
function $parcel$export(e, n, v, s) {
  Object.defineProperty(e, n, {get: v, set: s, enumerable: true, configurable: true});
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire4c48"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire4c48"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("eq1Fs", function(module, exports) {

$parcel$export(module.exports, "MOUSE", function () { return MOUSE; });
$parcel$export(module.exports, "TOUCH", function () { return TOUCH; });
$parcel$export(module.exports, "NormalBlending", function () { return NormalBlending; });
$parcel$export(module.exports, "LessDepth", function () { return LessDepth; });
$parcel$export(module.exports, "LinearFilter", function () { return LinearFilter; });
$parcel$export(module.exports, "EventDispatcher", function () { return EventDispatcher; });
$parcel$export(module.exports, "Vector2", function () { return Vector2; });
$parcel$export(module.exports, "Texture", function () { return Texture; });
$parcel$export(module.exports, "WebGLRenderTarget", function () { return WebGLRenderTarget; });
$parcel$export(module.exports, "Quaternion", function () { return Quaternion; });
$parcel$export(module.exports, "Vector3", function () { return Vector3; });
$parcel$export(module.exports, "Color", function () { return Color; });
$parcel$export(module.exports, "BufferAttribute", function () { return BufferAttribute; });
$parcel$export(module.exports, "BufferGeometry", function () { return BufferGeometry; });
$parcel$export(module.exports, "Mesh", function () { return Mesh; });
$parcel$export(module.exports, "ShaderMaterial", function () { return ShaderMaterial; });
$parcel$export(module.exports, "PerspectiveCamera", function () { return PerspectiveCamera; });
$parcel$export(module.exports, "ShaderChunk", function () { return ShaderChunk; });
$parcel$export(module.exports, "WebGLRenderer", function () { return WebGLRenderer; });
$parcel$export(module.exports, "Fog", function () { return Fog; });
$parcel$export(module.exports, "Scene", function () { return Scene; });
$parcel$export(module.exports, "LineBasicMaterial", function () { return LineBasicMaterial; });
$parcel$export(module.exports, "LineSegments", function () { return LineSegments; });
$parcel$export(module.exports, "Points", function () { return Points; });
$parcel$export(module.exports, "PointLight", function () { return PointLight; });
$parcel$export(module.exports, "OrthographicCamera", function () { return OrthographicCamera; });
$parcel$export(module.exports, "Spherical", function () { return Spherical; });
$parcel$export(module.exports, "AxesHelper", function () { return AxesHelper; });
// threejs.org/license
const REVISION = '125';
const MOUSE = {
    LEFT: 0,
    MIDDLE: 1,
    RIGHT: 2,
    ROTATE: 0,
    DOLLY: 1,
    PAN: 2
};
const TOUCH = {
    ROTATE: 0,
    PAN: 1,
    DOLLY_PAN: 2,
    DOLLY_ROTATE: 3
};
const CullFaceNone = 0;
const CullFaceBack = 1;
const CullFaceFront = 2;
const CullFaceFrontBack = 3;
const BasicShadowMap = 0;
const PCFShadowMap = 1;
const PCFSoftShadowMap = 2;
const VSMShadowMap = 3;
const FrontSide = 0;
const BackSide = 1;
const DoubleSide = 2;
const FlatShading = 1;
const SmoothShading = 2;
const NoBlending = 0;
const NormalBlending = 1;
const AdditiveBlending = 2;
const SubtractiveBlending = 3;
const MultiplyBlending = 4;
const CustomBlending = 5;
const AddEquation = 100;
const SubtractEquation = 101;
const ReverseSubtractEquation = 102;
const MinEquation = 103;
const MaxEquation = 104;
const ZeroFactor = 200;
const OneFactor = 201;
const SrcColorFactor = 202;
const OneMinusSrcColorFactor = 203;
const SrcAlphaFactor = 204;
const OneMinusSrcAlphaFactor = 205;
const DstAlphaFactor = 206;
const OneMinusDstAlphaFactor = 207;
const DstColorFactor = 208;
const OneMinusDstColorFactor = 209;
const SrcAlphaSaturateFactor = 210;
const NeverDepth = 0;
const AlwaysDepth = 1;
const LessDepth = 2;
const LessEqualDepth = 3;
const EqualDepth = 4;
const GreaterEqualDepth = 5;
const GreaterDepth = 6;
const NotEqualDepth = 7;
const MultiplyOperation = 0;
const MixOperation = 1;
const AddOperation = 2;
const NoToneMapping = 0;
const LinearToneMapping = 1;
const ReinhardToneMapping = 2;
const CineonToneMapping = 3;
const ACESFilmicToneMapping = 4;
const CustomToneMapping = 5;
const UVMapping = 300;
const CubeReflectionMapping = 301;
const CubeRefractionMapping = 302;
const EquirectangularReflectionMapping = 303;
const EquirectangularRefractionMapping = 304;
const CubeUVReflectionMapping = 306;
const CubeUVRefractionMapping = 307;
const RepeatWrapping = 1000;
const ClampToEdgeWrapping = 1001;
const MirroredRepeatWrapping = 1002;
const NearestFilter = 1003;
const NearestMipmapNearestFilter = 1004;
const NearestMipMapNearestFilter = 1004;
const NearestMipmapLinearFilter = 1005;
const NearestMipMapLinearFilter = 1005;
const LinearFilter = 1006;
const LinearMipmapNearestFilter = 1007;
const LinearMipMapNearestFilter = 1007;
const LinearMipmapLinearFilter = 1008;
const LinearMipMapLinearFilter = 1008;
const UnsignedByteType = 1009;
const ByteType = 1010;
const ShortType = 1011;
const UnsignedShortType = 1012;
const IntType = 1013;
const UnsignedIntType = 1014;
const FloatType = 1015;
const HalfFloatType = 1016;
const UnsignedShort4444Type = 1017;
const UnsignedShort5551Type = 1018;
const UnsignedShort565Type = 1019;
const UnsignedInt248Type = 1020;
const AlphaFormat = 1021;
const RGBFormat = 1022;
const RGBAFormat = 1023;
const LuminanceFormat = 1024;
const LuminanceAlphaFormat = 1025;
const RGBEFormat = RGBAFormat;
const DepthFormat = 1026;
const DepthStencilFormat = 1027;
const RedFormat = 1028;
const RedIntegerFormat = 1029;
const RGFormat = 1030;
const RGIntegerFormat = 1031;
const RGBIntegerFormat = 1032;
const RGBAIntegerFormat = 1033;
const RGB_S3TC_DXT1_Format = 33776;
const RGBA_S3TC_DXT1_Format = 33777;
const RGBA_S3TC_DXT3_Format = 33778;
const RGBA_S3TC_DXT5_Format = 33779;
const RGB_PVRTC_4BPPV1_Format = 35840;
const RGB_PVRTC_2BPPV1_Format = 35841;
const RGBA_PVRTC_4BPPV1_Format = 35842;
const RGBA_PVRTC_2BPPV1_Format = 35843;
const RGB_ETC1_Format = 36196;
const RGB_ETC2_Format = 37492;
const RGBA_ETC2_EAC_Format = 37496;
const RGBA_ASTC_4x4_Format = 37808;
const RGBA_ASTC_5x4_Format = 37809;
const RGBA_ASTC_5x5_Format = 37810;
const RGBA_ASTC_6x5_Format = 37811;
const RGBA_ASTC_6x6_Format = 37812;
const RGBA_ASTC_8x5_Format = 37813;
const RGBA_ASTC_8x6_Format = 37814;
const RGBA_ASTC_8x8_Format = 37815;
const RGBA_ASTC_10x5_Format = 37816;
const RGBA_ASTC_10x6_Format = 37817;
const RGBA_ASTC_10x8_Format = 37818;
const RGBA_ASTC_10x10_Format = 37819;
const RGBA_ASTC_12x10_Format = 37820;
const RGBA_ASTC_12x12_Format = 37821;
const RGBA_BPTC_Format = 36492;
const SRGB8_ALPHA8_ASTC_4x4_Format = 37840;
const SRGB8_ALPHA8_ASTC_5x4_Format = 37841;
const SRGB8_ALPHA8_ASTC_5x5_Format = 37842;
const SRGB8_ALPHA8_ASTC_6x5_Format = 37843;
const SRGB8_ALPHA8_ASTC_6x6_Format = 37844;
const SRGB8_ALPHA8_ASTC_8x5_Format = 37845;
const SRGB8_ALPHA8_ASTC_8x6_Format = 37846;
const SRGB8_ALPHA8_ASTC_8x8_Format = 37847;
const SRGB8_ALPHA8_ASTC_10x5_Format = 37848;
const SRGB8_ALPHA8_ASTC_10x6_Format = 37849;
const SRGB8_ALPHA8_ASTC_10x8_Format = 37850;
const SRGB8_ALPHA8_ASTC_10x10_Format = 37851;
const SRGB8_ALPHA8_ASTC_12x10_Format = 37852;
const SRGB8_ALPHA8_ASTC_12x12_Format = 37853;
const LoopOnce = 2200;
const LoopRepeat = 2201;
const LoopPingPong = 2202;
const InterpolateDiscrete = 2300;
const InterpolateLinear = 2301;
const InterpolateSmooth = 2302;
const ZeroCurvatureEnding = 2400;
const ZeroSlopeEnding = 2401;
const WrapAroundEnding = 2402;
const NormalAnimationBlendMode = 2500;
const AdditiveAnimationBlendMode = 2501;
const TrianglesDrawMode = 0;
const TriangleStripDrawMode = 1;
const TriangleFanDrawMode = 2;
const LinearEncoding = 3000;
const sRGBEncoding = 3001;
const GammaEncoding = 3007;
const RGBEEncoding = 3002;
const LogLuvEncoding = 3003;
const RGBM7Encoding = 3004;
const RGBM16Encoding = 3005;
const RGBDEncoding = 3006;
const BasicDepthPacking = 3200;
const RGBADepthPacking = 3201;
const TangentSpaceNormalMap = 0;
const ObjectSpaceNormalMap = 1;
const ZeroStencilOp = 0;
const KeepStencilOp = 7680;
const ReplaceStencilOp = 7681;
const IncrementStencilOp = 7682;
const DecrementStencilOp = 7683;
const IncrementWrapStencilOp = 34055;
const DecrementWrapStencilOp = 34056;
const InvertStencilOp = 5386;
const NeverStencilFunc = 512;
const LessStencilFunc = 513;
const EqualStencilFunc = 514;
const LessEqualStencilFunc = 515;
const GreaterStencilFunc = 516;
const NotEqualStencilFunc = 517;
const GreaterEqualStencilFunc = 518;
const AlwaysStencilFunc = 519;
const StaticDrawUsage = 35044;
const DynamicDrawUsage = 35048;
const StreamDrawUsage = 35040;
const StaticReadUsage = 35045;
const DynamicReadUsage = 35049;
const StreamReadUsage = 35041;
const StaticCopyUsage = 35046;
const DynamicCopyUsage = 35050;
const StreamCopyUsage = 35042;
const GLSL1 = '100';
const GLSL3 = '300 es';
/**
 * https://github.com/mrdoob/eventdispatcher.js/
 */ function EventDispatcher() {}
Object.assign(EventDispatcher.prototype, {
    addEventListener: function(type, listener) {
        if (this._listeners === undefined) this._listeners = {};
        const listeners = this._listeners;
        if (listeners[type] === undefined) listeners[type] = [];
        if (listeners[type].indexOf(listener) === -1) listeners[type].push(listener);
    },
    hasEventListener: function(type, listener) {
        if (this._listeners === undefined) return false;
        const listeners = this._listeners;
        return listeners[type] !== undefined && listeners[type].indexOf(listener) !== -1;
    },
    removeEventListener: function(type, listener) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[type];
        if (listenerArray !== undefined) {
            const index = listenerArray.indexOf(listener);
            if (index !== -1) listenerArray.splice(index, 1);
        }
    },
    dispatchEvent: function(event) {
        if (this._listeners === undefined) return;
        const listeners = this._listeners;
        const listenerArray = listeners[event.type];
        if (listenerArray !== undefined) {
            event.target = this;
            // Make a copy, in case listeners are removed while iterating.
            const array = listenerArray.slice(0);
            for(let i = 0, l = array.length; i < l; i++)array[i].call(this, event);
        }
    }
});
const _lut = [];
for(let i = 0; i < 256; i++)_lut[i] = (i < 16 ? '0' : '') + i.toString(16);
let _seed = 1234567;
const MathUtils = {
    DEG2RAD: Math.PI / 180,
    RAD2DEG: 180 / Math.PI,
    generateUUID: function() {
        // http://stackoverflow.com/questions/105034/how-to-create-a-guid-uuid-in-javascript/21963136#21963136
        const d0 = Math.random() * 0xffffffff | 0;
        const d1 = Math.random() * 0xffffffff | 0;
        const d2 = Math.random() * 0xffffffff | 0;
        const d3 = Math.random() * 0xffffffff | 0;
        const uuid = _lut[d0 & 0xff] + _lut[d0 >> 8 & 0xff] + _lut[d0 >> 16 & 0xff] + _lut[d0 >> 24 & 0xff] + '-' + _lut[d1 & 0xff] + _lut[d1 >> 8 & 0xff] + '-' + _lut[d1 >> 16 & 0x0f | 0x40] + _lut[d1 >> 24 & 0xff] + '-' + _lut[d2 & 0x3f | 0x80] + _lut[d2 >> 8 & 0xff] + '-' + _lut[d2 >> 16 & 0xff] + _lut[d2 >> 24 & 0xff] + _lut[d3 & 0xff] + _lut[d3 >> 8 & 0xff] + _lut[d3 >> 16 & 0xff] + _lut[d3 >> 24 & 0xff];
        // .toUpperCase() here flattens concatenated strings to save heap memory space.
        return uuid.toUpperCase();
    },
    clamp: function(value, min, max) {
        return Math.max(min, Math.min(max, value));
    },
    // compute euclidian modulo of m % n
    // https://en.wikipedia.org/wiki/Modulo_operation
    euclideanModulo: function(n, m) {
        return (n % m + m) % m;
    },
    // Linear mapping from range <a1, a2> to range <b1, b2>
    mapLinear: function(x, a1, a2, b1, b2) {
        return b1 + (x - a1) * (b2 - b1) / (a2 - a1);
    },
    // https://en.wikipedia.org/wiki/Linear_interpolation
    lerp: function(x, y, t) {
        return (1 - t) * x + t * y;
    },
    // http://www.rorydriscoll.com/2016/03/07/frame-rate-independent-damping-using-lerp/
    damp: function(x, y, lambda, dt) {
        return MathUtils.lerp(x, y, 1 - Math.exp(-lambda * dt));
    },
    // https://www.desmos.com/calculator/vcsjnyz7x4
    pingpong: function(x, length = 1) {
        return length - Math.abs(MathUtils.euclideanModulo(x, length * 2) - length);
    },
    // http://en.wikipedia.org/wiki/Smoothstep
    smoothstep: function(x, min, max) {
        if (x <= min) return 0;
        if (x >= max) return 1;
        x = (x - min) / (max - min);
        return x * x * (3 - 2 * x);
    },
    smootherstep: function(x, min, max) {
        if (x <= min) return 0;
        if (x >= max) return 1;
        x = (x - min) / (max - min);
        return x * x * x * (x * (x * 6 - 15) + 10);
    },
    // Random integer from <low, high> interval
    randInt: function(low, high) {
        return low + Math.floor(Math.random() * (high - low + 1));
    },
    // Random float from <low, high> interval
    randFloat: function(low, high) {
        return low + Math.random() * (high - low);
    },
    // Random float from <-range/2, range/2> interval
    randFloatSpread: function(range) {
        return range * (0.5 - Math.random());
    },
    // Deterministic pseudo-random float in the interval [ 0, 1 ]
    seededRandom: function(s) {
        if (s !== undefined) _seed = s % 2147483647;
        // Park-Miller algorithm
        _seed = _seed * 16807 % 2147483647;
        return (_seed - 1) / 2147483646;
    },
    degToRad: function(degrees) {
        return degrees * MathUtils.DEG2RAD;
    },
    radToDeg: function(radians) {
        return radians * MathUtils.RAD2DEG;
    },
    isPowerOfTwo: function(value) {
        return (value & value - 1) === 0 && value !== 0;
    },
    ceilPowerOfTwo: function(value) {
        return Math.pow(2, Math.ceil(Math.log(value) / Math.LN2));
    },
    floorPowerOfTwo: function(value) {
        return Math.pow(2, Math.floor(Math.log(value) / Math.LN2));
    },
    setQuaternionFromProperEuler: function(q, a, b, c, order) {
        // Intrinsic Proper Euler Angles - see https://en.wikipedia.org/wiki/Euler_angles
        // rotations are applied to the axes in the order specified by 'order'
        // rotation by angle 'a' is applied first, then by angle 'b', then by angle 'c'
        // angles are in radians
        const cos = Math.cos;
        const sin = Math.sin;
        const c2 = cos(b / 2);
        const s2 = sin(b / 2);
        const c13 = cos((a + c) / 2);
        const s13 = sin((a + c) / 2);
        const c1_3 = cos((a - c) / 2);
        const s1_3 = sin((a - c) / 2);
        const c3_1 = cos((c - a) / 2);
        const s3_1 = sin((c - a) / 2);
        switch(order){
            case 'XYX':
                q.set(c2 * s13, s2 * c1_3, s2 * s1_3, c2 * c13);
                break;
            case 'YZY':
                q.set(s2 * s1_3, c2 * s13, s2 * c1_3, c2 * c13);
                break;
            case 'ZXZ':
                q.set(s2 * c1_3, s2 * s1_3, c2 * s13, c2 * c13);
                break;
            case 'XZX':
                q.set(c2 * s13, s2 * s3_1, s2 * c3_1, c2 * c13);
                break;
            case 'YXY':
                q.set(s2 * c3_1, c2 * s13, s2 * s3_1, c2 * c13);
                break;
            case 'ZYZ':
                q.set(s2 * s3_1, s2 * c3_1, c2 * s13, c2 * c13);
                break;
            default:
                console.warn('THREE.MathUtils: .setQuaternionFromProperEuler() encountered an unknown order: ' + order);
        }
    }
};
class Vector2 {
    constructor(x = 0, y = 0){
        Object.defineProperty(this, 'isVector2', {
            value: true
        });
        this.x = x;
        this.y = y;
    }
    get width() {
        return this.x;
    }
    set width(value) {
        this.x = value;
    }
    get height() {
        return this.y;
    }
    set height(value) {
        this.y = value;
    }
    set(x, y) {
        this.x = x;
        this.y = y;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector2: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector2: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        return this;
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6];
        this.y = e[1] * x + e[4] * y + e[7];
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y;
    }
    cross(v) {
        return this.x * v.y - this.y * v.x;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    angle() {
        // computes the angle in radians with respect to the positive x-axis
        const angle = Math.atan2(-this.y, -this.x) + Math.PI;
        return angle;
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y;
        return dx * dx + dy * dy;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn('THREE.Vector2: offset has been removed from .fromBufferAttribute().');
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        return this;
    }
    rotateAround(center, angle) {
        const c = Math.cos(angle), s = Math.sin(angle);
        const x = this.x - center.x;
        const y = this.y - center.y;
        this.x = x * c - y * s + center.x;
        this.y = x * s + y * c + center.y;
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        return this;
    }
}
class Matrix3 {
    constructor(){
        Object.defineProperty(this, 'isMatrix3', {
            value: true
        });
        this.elements = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error('THREE.Matrix3: the constructor no longer reads arguments. use .set() instead.');
    }
    set(n11, n12, n13, n21, n22, n23, n31, n32, n33) {
        const te = this.elements;
        te[0] = n11;
        te[1] = n21;
        te[2] = n31;
        te[3] = n12;
        te[4] = n22;
        te[5] = n32;
        te[6] = n13;
        te[7] = n23;
        te[8] = n33;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 1, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new this.constructor().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrix3Column(this, 0);
        yAxis.setFromMatrix3Column(this, 1);
        zAxis.setFromMatrix3Column(this, 2);
        return this;
    }
    setFromMatrix4(m) {
        const me = m.elements;
        this.set(me[0], me[4], me[8], me[1], me[5], me[9], me[2], me[6], me[10]);
        return this;
    }
    multiply(m) {
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[3], a13 = ae[6];
        const a21 = ae[1], a22 = ae[4], a23 = ae[7];
        const a31 = ae[2], a32 = ae[5], a33 = ae[8];
        const b11 = be[0], b12 = be[3], b13 = be[6];
        const b21 = be[1], b22 = be[4], b23 = be[7];
        const b31 = be[2], b32 = be[5], b33 = be[8];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31;
        te[3] = a11 * b12 + a12 * b22 + a13 * b32;
        te[6] = a11 * b13 + a12 * b23 + a13 * b33;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31;
        te[4] = a21 * b12 + a22 * b22 + a23 * b32;
        te[7] = a21 * b13 + a22 * b23 + a23 * b33;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31;
        te[5] = a31 * b12 + a32 * b22 + a33 * b32;
        te[8] = a31 * b13 + a32 * b23 + a33 * b33;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[3] *= s;
        te[6] *= s;
        te[1] *= s;
        te[4] *= s;
        te[7] *= s;
        te[2] *= s;
        te[5] *= s;
        te[8] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const a = te[0], b = te[1], c = te[2], d = te[3], e = te[4], f = te[5], g = te[6], h = te[7], i = te[8];
        return a * e * i - a * f * h - b * d * i + b * f * g + c * d * h - c * e * g;
    }
    invert() {
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n12 = te[3], n22 = te[4], n32 = te[5], n13 = te[6], n23 = te[7], n33 = te[8], t11 = n33 * n22 - n32 * n23, t12 = n32 * n13 - n33 * n12, t13 = n23 * n12 - n22 * n13, det = n11 * t11 + n21 * t12 + n31 * t13;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n31 * n23 - n33 * n21) * detInv;
        te[2] = (n32 * n21 - n31 * n22) * detInv;
        te[3] = t12 * detInv;
        te[4] = (n33 * n11 - n31 * n13) * detInv;
        te[5] = (n31 * n12 - n32 * n11) * detInv;
        te[6] = t13 * detInv;
        te[7] = (n21 * n13 - n23 * n11) * detInv;
        te[8] = (n22 * n11 - n21 * n12) * detInv;
        return this;
    }
    transpose() {
        let tmp;
        const m = this.elements;
        tmp = m[1];
        m[1] = m[3];
        m[3] = tmp;
        tmp = m[2];
        m[2] = m[6];
        m[6] = tmp;
        tmp = m[5];
        m[5] = m[7];
        m[7] = tmp;
        return this;
    }
    getNormalMatrix(matrix4) {
        return this.setFromMatrix4(matrix4).copy(this).invert().transpose();
    }
    transposeIntoArray(r) {
        const m = this.elements;
        r[0] = m[0];
        r[1] = m[3];
        r[2] = m[6];
        r[3] = m[1];
        r[4] = m[4];
        r[5] = m[7];
        r[6] = m[2];
        r[7] = m[5];
        r[8] = m[8];
        return this;
    }
    setUvTransform(tx, ty, sx, sy, rotation, cx, cy) {
        const c = Math.cos(rotation);
        const s = Math.sin(rotation);
        this.set(sx * c, sx * s, -sx * (c * cx + s * cy) + cx + tx, -sy * s, sy * c, -sy * (-s * cx + c * cy) + cy + ty, 0, 0, 1);
        return this;
    }
    scale(sx, sy) {
        const te = this.elements;
        te[0] *= sx;
        te[3] *= sx;
        te[6] *= sx;
        te[1] *= sy;
        te[4] *= sy;
        te[7] *= sy;
        return this;
    }
    rotate(theta) {
        const c = Math.cos(theta);
        const s = Math.sin(theta);
        const te = this.elements;
        const a11 = te[0], a12 = te[3], a13 = te[6];
        const a21 = te[1], a22 = te[4], a23 = te[7];
        te[0] = c * a11 + s * a21;
        te[3] = c * a12 + s * a22;
        te[6] = c * a13 + s * a23;
        te[1] = -s * a11 + c * a21;
        te[4] = -s * a12 + c * a22;
        te[7] = -s * a13 + c * a23;
        return this;
    }
    translate(tx, ty) {
        const te = this.elements;
        te[0] += tx * te[2];
        te[3] += tx * te[5];
        te[6] += tx * te[8];
        te[1] += ty * te[2];
        te[4] += ty * te[5];
        te[7] += ty * te[8];
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 9; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 9; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        return array;
    }
}
let _canvas;
const ImageUtils = {
    getDataURL: function(image) {
        if (/^data:/i.test(image.src)) return image.src;
        if (typeof HTMLCanvasElement == 'undefined') return image.src;
        let canvas;
        if (image instanceof HTMLCanvasElement) canvas = image;
        else {
            if (_canvas === undefined) _canvas = document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
            _canvas.width = image.width;
            _canvas.height = image.height;
            const context = _canvas.getContext('2d');
            if (image instanceof ImageData) context.putImageData(image, 0, 0);
            else context.drawImage(image, 0, 0, image.width, image.height);
            canvas = _canvas;
        }
        if (canvas.width > 2048 || canvas.height > 2048) return canvas.toDataURL('image/jpeg', 0.6);
        else return canvas.toDataURL('image/png');
    }
};
let textureId = 0;
function Texture(image = Texture.DEFAULT_IMAGE, mapping = Texture.DEFAULT_MAPPING, wrapS = ClampToEdgeWrapping, wrapT = ClampToEdgeWrapping, magFilter = LinearFilter, minFilter = LinearMipmapLinearFilter, format = RGBAFormat, type = UnsignedByteType, anisotropy = 1, encoding = LinearEncoding) {
    Object.defineProperty(this, 'id', {
        value: textureId++
    });
    this.uuid = MathUtils.generateUUID();
    this.name = '';
    this.image = image;
    this.mipmaps = [];
    this.mapping = mapping;
    this.wrapS = wrapS;
    this.wrapT = wrapT;
    this.magFilter = magFilter;
    this.minFilter = minFilter;
    this.anisotropy = anisotropy;
    this.format = format;
    this.internalFormat = null;
    this.type = type;
    this.offset = new Vector2(0, 0);
    this.repeat = new Vector2(1, 1);
    this.center = new Vector2(0, 0);
    this.rotation = 0;
    this.matrixAutoUpdate = true;
    this.matrix = new Matrix3();
    this.generateMipmaps = true;
    this.premultiplyAlpha = false;
    this.flipY = true;
    this.unpackAlignment = 4; // valid values: 1, 2, 4, 8 (see http://www.khronos.org/opengles/sdk/docs/man/xhtml/glPixelStorei.xml)
    // Values of encoding !== THREE.LinearEncoding only supported on map, envMap and emissiveMap.
    //
    // Also changing the encoding after already used by a Material will not automatically make the Material
    // update. You need to explicitly call Material.needsUpdate to trigger it to recompile.
    this.encoding = encoding;
    this.version = 0;
    this.onUpdate = null;
}
Texture.DEFAULT_IMAGE = undefined;
Texture.DEFAULT_MAPPING = UVMapping;
Texture.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: Texture,
    isTexture: true,
    updateMatrix: function() {
        this.matrix.setUvTransform(this.offset.x, this.offset.y, this.repeat.x, this.repeat.y, this.rotation, this.center.x, this.center.y);
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    copy: function(source) {
        this.name = source.name;
        this.image = source.image;
        this.mipmaps = source.mipmaps.slice(0);
        this.mapping = source.mapping;
        this.wrapS = source.wrapS;
        this.wrapT = source.wrapT;
        this.magFilter = source.magFilter;
        this.minFilter = source.minFilter;
        this.anisotropy = source.anisotropy;
        this.format = source.format;
        this.internalFormat = source.internalFormat;
        this.type = source.type;
        this.offset.copy(source.offset);
        this.repeat.copy(source.repeat);
        this.center.copy(source.center);
        this.rotation = source.rotation;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrix.copy(source.matrix);
        this.generateMipmaps = source.generateMipmaps;
        this.premultiplyAlpha = source.premultiplyAlpha;
        this.flipY = source.flipY;
        this.unpackAlignment = source.unpackAlignment;
        this.encoding = source.encoding;
        return this;
    },
    toJSON: function(meta) {
        const isRootObject = meta === undefined || typeof meta === 'string';
        if (!isRootObject && meta.textures[this.uuid] !== undefined) return meta.textures[this.uuid];
        const output = {
            metadata: {
                version: 4.5,
                type: 'Texture',
                generator: 'Texture.toJSON'
            },
            uuid: this.uuid,
            name: this.name,
            mapping: this.mapping,
            repeat: [
                this.repeat.x,
                this.repeat.y
            ],
            offset: [
                this.offset.x,
                this.offset.y
            ],
            center: [
                this.center.x,
                this.center.y
            ],
            rotation: this.rotation,
            wrap: [
                this.wrapS,
                this.wrapT
            ],
            format: this.format,
            type: this.type,
            encoding: this.encoding,
            minFilter: this.minFilter,
            magFilter: this.magFilter,
            anisotropy: this.anisotropy,
            flipY: this.flipY,
            premultiplyAlpha: this.premultiplyAlpha,
            unpackAlignment: this.unpackAlignment
        };
        if (this.image !== undefined) {
            // TODO: Move to THREE.Image
            const image = this.image;
            if (image.uuid === undefined) image.uuid = MathUtils.generateUUID(); // UGH
            if (!isRootObject && meta.images[image.uuid] === undefined) {
                let url;
                if (Array.isArray(image)) {
                    // process array of images e.g. CubeTexture
                    url = [];
                    for(let i = 0, l = image.length; i < l; i++)// check cube texture with data textures
                    if (image[i].isDataTexture) url.push(serializeImage(image[i].image));
                    else url.push(serializeImage(image[i]));
                } else // process single image
                url = serializeImage(image);
                meta.images[image.uuid] = {
                    uuid: image.uuid,
                    url: url
                };
            }
            output.image = image.uuid;
        }
        if (!isRootObject) meta.textures[this.uuid] = output;
        return output;
    },
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    },
    transformUv: function(uv) {
        if (this.mapping !== UVMapping) return uv;
        uv.applyMatrix3(this.matrix);
        if (uv.x < 0 || uv.x > 1) switch(this.wrapS){
            case RepeatWrapping:
                uv.x = uv.x - Math.floor(uv.x);
                break;
            case ClampToEdgeWrapping:
                uv.x = uv.x < 0 ? 0 : 1;
                break;
            case MirroredRepeatWrapping:
                if (Math.abs(Math.floor(uv.x) % 2) === 1) uv.x = Math.ceil(uv.x) - uv.x;
                else uv.x = uv.x - Math.floor(uv.x);
                break;
        }
        if (uv.y < 0 || uv.y > 1) switch(this.wrapT){
            case RepeatWrapping:
                uv.y = uv.y - Math.floor(uv.y);
                break;
            case ClampToEdgeWrapping:
                uv.y = uv.y < 0 ? 0 : 1;
                break;
            case MirroredRepeatWrapping:
                if (Math.abs(Math.floor(uv.y) % 2) === 1) uv.y = Math.ceil(uv.y) - uv.y;
                else uv.y = uv.y - Math.floor(uv.y);
                break;
        }
        if (this.flipY) uv.y = 1 - uv.y;
        return uv;
    }
});
Object.defineProperty(Texture.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
function serializeImage(image) {
    if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) // default images
    return ImageUtils.getDataURL(image);
    else {
        if (image.data) // images of DataTexture
        return {
            data: Array.prototype.slice.call(image.data),
            width: image.width,
            height: image.height,
            type: image.data.constructor.name
        };
        else {
            console.warn('THREE.Texture: Unable to serialize Texture.');
            return {};
        }
    }
}
class Vector4 {
    constructor(x = 0, y = 0, z = 0, w = 1){
        Object.defineProperty(this, 'isVector4', {
            value: true
        });
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
    }
    get width() {
        return this.z;
    }
    set width(value) {
        this.z = value;
    }
    get height() {
        return this.w;
    }
    set height(value) {
        this.w = value;
    }
    set(x, y, z, w) {
        this.x = x;
        this.y = y;
        this.z = z;
        this.w = w;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        this.w = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setW(w) {
        this.w = w;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            case 3:
                this.w = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            case 3:
                return this.w;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z, this.w);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        this.w = v.w !== undefined ? v.w : 1;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector4: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        this.w += v.w;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        this.w += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        this.w = a.w + b.w;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        this.w += v.w * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector4: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        this.w -= v.w;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        this.w -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        this.w = a.w - b.w;
        return this;
    }
    multiply(v) {
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        this.w *= v.w;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        this.w *= scalar;
        return this;
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z, w = this.w;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z + e[12] * w;
        this.y = e[1] * x + e[5] * y + e[9] * z + e[13] * w;
        this.z = e[2] * x + e[6] * y + e[10] * z + e[14] * w;
        this.w = e[3] * x + e[7] * y + e[11] * z + e[15] * w;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    setAxisAngleFromQuaternion(q) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/quaternionToAngle/index.htm
        // q is assumed to be normalized
        this.w = 2 * Math.acos(q.w);
        const s = Math.sqrt(1 - q.w * q.w);
        if (s < 0.0001) {
            this.x = 1;
            this.y = 0;
            this.z = 0;
        } else {
            this.x = q.x / s;
            this.y = q.y / s;
            this.z = q.z / s;
        }
        return this;
    }
    setAxisAngleFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToAngle/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        let angle, x, y, z; // variables for result
        const epsilon = 0.01, epsilon2 = 0.1, te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10];
        if (Math.abs(m12 - m21) < epsilon && Math.abs(m13 - m31) < epsilon && Math.abs(m23 - m32) < epsilon) {
            // singularity found
            // first check for identity matrix which must have +1 for all terms
            // in leading diagonal and zero in other terms
            if (Math.abs(m12 + m21) < epsilon2 && Math.abs(m13 + m31) < epsilon2 && Math.abs(m23 + m32) < epsilon2 && Math.abs(m11 + m22 + m33 - 3) < epsilon2) {
                // this singularity is identity matrix so angle = 0
                this.set(1, 0, 0, 0);
                return this; // zero angle, arbitrary axis
            }
            // otherwise this singularity is angle = 180
            angle = Math.PI;
            const xx = (m11 + 1) / 2;
            const yy = (m22 + 1) / 2;
            const zz = (m33 + 1) / 2;
            const xy = (m12 + m21) / 4;
            const xz = (m13 + m31) / 4;
            const yz = (m23 + m32) / 4;
            if (xx > yy && xx > zz) {
                // m11 is the largest diagonal term
                if (xx < epsilon) {
                    x = 0;
                    y = 0.707106781;
                    z = 0.707106781;
                } else {
                    x = Math.sqrt(xx);
                    y = xy / x;
                    z = xz / x;
                }
            } else if (yy > zz) {
                // m22 is the largest diagonal term
                if (yy < epsilon) {
                    x = 0.707106781;
                    y = 0;
                    z = 0.707106781;
                } else {
                    y = Math.sqrt(yy);
                    x = xy / y;
                    z = yz / y;
                }
            } else // m33 is the largest diagonal term so base result on this
            if (zz < epsilon) {
                x = 0.707106781;
                y = 0.707106781;
                z = 0;
            } else {
                z = Math.sqrt(zz);
                x = xz / z;
                y = yz / z;
            }
            this.set(x, y, z, angle);
            return this; // return 180 deg rotation
        }
        // as we have reached here there are no singularities so we can handle normally
        let s = Math.sqrt((m32 - m23) * (m32 - m23) + (m13 - m31) * (m13 - m31) + (m21 - m12) * (m21 - m12)); // used to normalize
        if (Math.abs(s) < 0.001) s = 1;
        // prevent divide by zero, should not happen if matrix is orthogonal and should be
        // caught by singularity test above, but I've left it in just in case
        this.x = (m32 - m23) / s;
        this.y = (m13 - m31) / s;
        this.z = (m21 - m12) / s;
        this.w = Math.acos((m11 + m22 + m33 - 1) / 2);
        return this;
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        this.w = Math.min(this.w, v.w);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        this.w = Math.max(this.w, v.w);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        this.w = Math.max(min.w, Math.min(max.w, this.w));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        this.w = Math.max(minVal, Math.min(maxVal, this.w));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        this.w = Math.floor(this.w);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        this.w = Math.ceil(this.w);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        this.w = Math.round(this.w);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        this.w = this.w < 0 ? Math.ceil(this.w) : Math.floor(this.w);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        this.w = -this.w;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z + this.w * v.w;
    }
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z + this.w * this.w);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z) + Math.abs(this.w);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        this.w += (v.w - this.w) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        this.w = v1.w + (v2.w - v1.w) * alpha;
        return this;
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z && v.w === this.w;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        this.w = array[offset + 3];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        array[offset + 3] = this.w;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn('THREE.Vector4: offset has been removed from .fromBufferAttribute().');
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        this.w = attribute.getW(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        this.w = Math.random();
        return this;
    }
}
/*
 In options, we can specify:
 * Texture parameters for an auto-generated target texture
 * depthBuffer/stencilBuffer: Booleans to indicate if we should generate these buffers
*/ class WebGLRenderTarget extends EventDispatcher {
    constructor(width, height, options){
        super();
        Object.defineProperty(this, 'isWebGLRenderTarget', {
            value: true
        });
        this.width = width;
        this.height = height;
        this.scissor = new Vector4(0, 0, width, height);
        this.scissorTest = false;
        this.viewport = new Vector4(0, 0, width, height);
        options = options || {};
        this.texture = new Texture(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture.image = {};
        this.texture.image.width = width;
        this.texture.image.height = height;
        this.texture.generateMipmaps = options.generateMipmaps !== undefined ? options.generateMipmaps : false;
        this.texture.minFilter = options.minFilter !== undefined ? options.minFilter : LinearFilter;
        this.depthBuffer = options.depthBuffer !== undefined ? options.depthBuffer : true;
        this.stencilBuffer = options.stencilBuffer !== undefined ? options.stencilBuffer : false;
        this.depthTexture = options.depthTexture !== undefined ? options.depthTexture : null;
    }
    setSize(width, height) {
        if (this.width !== width || this.height !== height) {
            this.width = width;
            this.height = height;
            this.texture.image.width = width;
            this.texture.image.height = height;
            this.dispose();
        }
        this.viewport.set(0, 0, width, height);
        this.scissor.set(0, 0, width, height);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.width = source.width;
        this.height = source.height;
        this.viewport.copy(source.viewport);
        this.texture = source.texture.clone();
        this.depthBuffer = source.depthBuffer;
        this.stencilBuffer = source.stencilBuffer;
        this.depthTexture = source.depthTexture;
        return this;
    }
    dispose() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
}
class WebGLMultisampleRenderTarget extends WebGLRenderTarget {
    constructor(width, height, options){
        super(width, height, options);
        Object.defineProperty(this, 'isWebGLMultisampleRenderTarget', {
            value: true
        });
        this.samples = 4;
    }
    copy(source) {
        super.copy.call(this, source);
        this.samples = source.samples;
        return this;
    }
}
class Quaternion {
    constructor(x = 0, y = 0, z = 0, w = 1){
        Object.defineProperty(this, 'isQuaternion', {
            value: true
        });
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
    }
    static slerp(qa, qb, qm, t) {
        return qm.copy(qa).slerp(qb, t);
    }
    static slerpFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1, t) {
        // fuzz-free, array-based Quaternion SLERP operation
        let x0 = src0[srcOffset0 + 0], y0 = src0[srcOffset0 + 1], z0 = src0[srcOffset0 + 2], w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1 + 0], y1 = src1[srcOffset1 + 1], z1 = src1[srcOffset1 + 2], w1 = src1[srcOffset1 + 3];
        if (w0 !== w1 || x0 !== x1 || y0 !== y1 || z0 !== z1) {
            let s = 1 - t;
            const cos = x0 * x1 + y0 * y1 + z0 * z1 + w0 * w1, dir = cos >= 0 ? 1 : -1, sqrSin = 1 - cos * cos;
            // Skip the Slerp for tiny steps to avoid numeric problems:
            if (sqrSin > Number.EPSILON) {
                const sin = Math.sqrt(sqrSin), len = Math.atan2(sin, cos * dir);
                s = Math.sin(s * len) / sin;
                t = Math.sin(t * len) / sin;
            }
            const tDir = t * dir;
            x0 = x0 * s + x1 * tDir;
            y0 = y0 * s + y1 * tDir;
            z0 = z0 * s + z1 * tDir;
            w0 = w0 * s + w1 * tDir;
            // Normalize in case we just did a lerp:
            if (s === 1 - t) {
                const f = 1 / Math.sqrt(x0 * x0 + y0 * y0 + z0 * z0 + w0 * w0);
                x0 *= f;
                y0 *= f;
                z0 *= f;
                w0 *= f;
            }
        }
        dst[dstOffset] = x0;
        dst[dstOffset + 1] = y0;
        dst[dstOffset + 2] = z0;
        dst[dstOffset + 3] = w0;
    }
    static multiplyQuaternionsFlat(dst, dstOffset, src0, srcOffset0, src1, srcOffset1) {
        const x0 = src0[srcOffset0];
        const y0 = src0[srcOffset0 + 1];
        const z0 = src0[srcOffset0 + 2];
        const w0 = src0[srcOffset0 + 3];
        const x1 = src1[srcOffset1];
        const y1 = src1[srcOffset1 + 1];
        const z1 = src1[srcOffset1 + 2];
        const w1 = src1[srcOffset1 + 3];
        dst[dstOffset] = x0 * w1 + w0 * x1 + y0 * z1 - z0 * y1;
        dst[dstOffset + 1] = y0 * w1 + w0 * y1 + z0 * x1 - x0 * z1;
        dst[dstOffset + 2] = z0 * w1 + w0 * z1 + x0 * y1 - y0 * x1;
        dst[dstOffset + 3] = w0 * w1 - x0 * x1 - y0 * y1 - z0 * z1;
        return dst;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get w() {
        return this._w;
    }
    set w(value) {
        this._w = value;
        this._onChangeCallback();
    }
    set(x, y, z, w) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._w = w;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._w);
    }
    copy(quaternion) {
        this._x = quaternion.x;
        this._y = quaternion.y;
        this._z = quaternion.z;
        this._w = quaternion.w;
        this._onChangeCallback();
        return this;
    }
    setFromEuler(euler, update) {
        if (!(euler && euler.isEuler)) throw new Error('THREE.Quaternion: .setFromEuler() now expects an Euler rotation rather than a Vector3 and order.');
        const x = euler._x, y = euler._y, z = euler._z, order = euler._order;
        // http://www.mathworks.com/matlabcentral/fileexchange/
        // 	20696-function-to-convert-between-dcm-euler-angles-quaternions-and-euler-vectors/
        //	content/SpinCalc.m
        const cos = Math.cos;
        const sin = Math.sin;
        const c1 = cos(x / 2);
        const c2 = cos(y / 2);
        const c3 = cos(z / 2);
        const s1 = sin(x / 2);
        const s2 = sin(y / 2);
        const s3 = sin(z / 2);
        switch(order){
            case 'XYZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'YXZ':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'ZXY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'ZYX':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            case 'YZX':
                this._x = s1 * c2 * c3 + c1 * s2 * s3;
                this._y = c1 * s2 * c3 + s1 * c2 * s3;
                this._z = c1 * c2 * s3 - s1 * s2 * c3;
                this._w = c1 * c2 * c3 - s1 * s2 * s3;
                break;
            case 'XZY':
                this._x = s1 * c2 * c3 - c1 * s2 * s3;
                this._y = c1 * s2 * c3 - s1 * c2 * s3;
                this._z = c1 * c2 * s3 + s1 * s2 * c3;
                this._w = c1 * c2 * c3 + s1 * s2 * s3;
                break;
            default:
                console.warn('THREE.Quaternion: .setFromEuler() encountered an unknown order: ' + order);
        }
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromAxisAngle(axis, angle) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/angleToQuaternion/index.htm
        // assumes axis is normalized
        const halfAngle = angle / 2, s = Math.sin(halfAngle);
        this._x = axis.x * s;
        this._y = axis.y * s;
        this._z = axis.z * s;
        this._w = Math.cos(halfAngle);
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m) {
        // http://www.euclideanspace.com/maths/geometry/rotations/conversions/matrixToQuaternion/index.htm
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements, m11 = te[0], m12 = te[4], m13 = te[8], m21 = te[1], m22 = te[5], m23 = te[9], m31 = te[2], m32 = te[6], m33 = te[10], trace = m11 + m22 + m33;
        if (trace > 0) {
            const s = 0.5 / Math.sqrt(trace + 1.0);
            this._w = 0.25 / s;
            this._x = (m32 - m23) * s;
            this._y = (m13 - m31) * s;
            this._z = (m21 - m12) * s;
        } else if (m11 > m22 && m11 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m11 - m22 - m33);
            this._w = (m32 - m23) / s;
            this._x = 0.25 * s;
            this._y = (m12 + m21) / s;
            this._z = (m13 + m31) / s;
        } else if (m22 > m33) {
            const s = 2.0 * Math.sqrt(1.0 + m22 - m11 - m33);
            this._w = (m13 - m31) / s;
            this._x = (m12 + m21) / s;
            this._y = 0.25 * s;
            this._z = (m23 + m32) / s;
        } else {
            const s = 2.0 * Math.sqrt(1.0 + m33 - m11 - m22);
            this._w = (m21 - m12) / s;
            this._x = (m13 + m31) / s;
            this._y = (m23 + m32) / s;
            this._z = 0.25 * s;
        }
        this._onChangeCallback();
        return this;
    }
    setFromUnitVectors(vFrom, vTo) {
        // assumes direction vectors vFrom and vTo are normalized
        const EPS = 0.000001;
        let r = vFrom.dot(vTo) + 1;
        if (r < EPS) {
            r = 0;
            if (Math.abs(vFrom.x) > Math.abs(vFrom.z)) {
                this._x = -vFrom.y;
                this._y = vFrom.x;
                this._z = 0;
                this._w = r;
            } else {
                this._x = 0;
                this._y = -vFrom.z;
                this._z = vFrom.y;
                this._w = r;
            }
        } else {
            // crossVectors( vFrom, vTo ); // inlined to avoid cyclic dependency on Vector3
            this._x = vFrom.y * vTo.z - vFrom.z * vTo.y;
            this._y = vFrom.z * vTo.x - vFrom.x * vTo.z;
            this._z = vFrom.x * vTo.y - vFrom.y * vTo.x;
            this._w = r;
        }
        return this.normalize();
    }
    angleTo(q) {
        return 2 * Math.acos(Math.abs(MathUtils.clamp(this.dot(q), -1, 1)));
    }
    rotateTowards(q, step) {
        const angle = this.angleTo(q);
        if (angle === 0) return this;
        const t = Math.min(1, step / angle);
        this.slerp(q, t);
        return this;
    }
    identity() {
        return this.set(0, 0, 0, 1);
    }
    invert() {
        // quaternion is assumed to have unit length
        return this.conjugate();
    }
    conjugate() {
        this._x *= -1;
        this._y *= -1;
        this._z *= -1;
        this._onChangeCallback();
        return this;
    }
    dot(v) {
        return this._x * v._x + this._y * v._y + this._z * v._z + this._w * v._w;
    }
    lengthSq() {
        return this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w;
    }
    length() {
        return Math.sqrt(this._x * this._x + this._y * this._y + this._z * this._z + this._w * this._w);
    }
    normalize() {
        let l = this.length();
        if (l === 0) {
            this._x = 0;
            this._y = 0;
            this._z = 0;
            this._w = 1;
        } else {
            l = 1 / l;
            this._x = this._x * l;
            this._y = this._y * l;
            this._z = this._z * l;
            this._w = this._w * l;
        }
        this._onChangeCallback();
        return this;
    }
    multiply(q, p) {
        if (p !== undefined) {
            console.warn('THREE.Quaternion: .multiply() now only accepts one argument. Use .multiplyQuaternions( a, b ) instead.');
            return this.multiplyQuaternions(q, p);
        }
        return this.multiplyQuaternions(this, q);
    }
    premultiply(q) {
        return this.multiplyQuaternions(q, this);
    }
    multiplyQuaternions(a, b) {
        // from http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/code/index.htm
        const qax = a._x, qay = a._y, qaz = a._z, qaw = a._w;
        const qbx = b._x, qby = b._y, qbz = b._z, qbw = b._w;
        this._x = qax * qbw + qaw * qbx + qay * qbz - qaz * qby;
        this._y = qay * qbw + qaw * qby + qaz * qbx - qax * qbz;
        this._z = qaz * qbw + qaw * qbz + qax * qby - qay * qbx;
        this._w = qaw * qbw - qax * qbx - qay * qby - qaz * qbz;
        this._onChangeCallback();
        return this;
    }
    slerp(qb, t) {
        if (t === 0) return this;
        if (t === 1) return this.copy(qb);
        const x = this._x, y = this._y, z = this._z, w = this._w;
        // http://www.euclideanspace.com/maths/algebra/realNormedAlgebra/quaternions/slerp/
        let cosHalfTheta = w * qb._w + x * qb._x + y * qb._y + z * qb._z;
        if (cosHalfTheta < 0) {
            this._w = -qb._w;
            this._x = -qb._x;
            this._y = -qb._y;
            this._z = -qb._z;
            cosHalfTheta = -cosHalfTheta;
        } else this.copy(qb);
        if (cosHalfTheta >= 1.0) {
            this._w = w;
            this._x = x;
            this._y = y;
            this._z = z;
            return this;
        }
        const sqrSinHalfTheta = 1.0 - cosHalfTheta * cosHalfTheta;
        if (sqrSinHalfTheta <= Number.EPSILON) {
            const s = 1 - t;
            this._w = s * w + t * this._w;
            this._x = s * x + t * this._x;
            this._y = s * y + t * this._y;
            this._z = s * z + t * this._z;
            this.normalize();
            this._onChangeCallback();
            return this;
        }
        const sinHalfTheta = Math.sqrt(sqrSinHalfTheta);
        const halfTheta = Math.atan2(sinHalfTheta, cosHalfTheta);
        const ratioA = Math.sin((1 - t) * halfTheta) / sinHalfTheta, ratioB = Math.sin(t * halfTheta) / sinHalfTheta;
        this._w = w * ratioA + this._w * ratioB;
        this._x = x * ratioA + this._x * ratioB;
        this._y = y * ratioA + this._y * ratioB;
        this._z = z * ratioA + this._z * ratioB;
        this._onChangeCallback();
        return this;
    }
    equals(quaternion) {
        return quaternion._x === this._x && quaternion._y === this._y && quaternion._z === this._z && quaternion._w === this._w;
    }
    fromArray(array, offset = 0) {
        this._x = array[offset];
        this._y = array[offset + 1];
        this._z = array[offset + 2];
        this._w = array[offset + 3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._w;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this._x = attribute.getX(index);
        this._y = attribute.getY(index);
        this._z = attribute.getZ(index);
        this._w = attribute.getW(index);
        return this;
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
class Vector3 {
    constructor(x = 0, y = 0, z = 0){
        Object.defineProperty(this, 'isVector3', {
            value: true
        });
        this.x = x;
        this.y = y;
        this.z = z;
    }
    set(x, y, z) {
        if (z === undefined) z = this.z; // sprite.scale.set(x,y)
        this.x = x;
        this.y = y;
        this.z = z;
        return this;
    }
    setScalar(scalar) {
        this.x = scalar;
        this.y = scalar;
        this.z = scalar;
        return this;
    }
    setX(x) {
        this.x = x;
        return this;
    }
    setY(y) {
        this.y = y;
        return this;
    }
    setZ(z) {
        this.z = z;
        return this;
    }
    setComponent(index, value) {
        switch(index){
            case 0:
                this.x = value;
                break;
            case 1:
                this.y = value;
                break;
            case 2:
                this.z = value;
                break;
            default:
                throw new Error('index is out of range: ' + index);
        }
        return this;
    }
    getComponent(index) {
        switch(index){
            case 0:
                return this.x;
            case 1:
                return this.y;
            case 2:
                return this.z;
            default:
                throw new Error('index is out of range: ' + index);
        }
    }
    clone() {
        return new this.constructor(this.x, this.y, this.z);
    }
    copy(v) {
        this.x = v.x;
        this.y = v.y;
        this.z = v.z;
        return this;
    }
    add(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .add() now only accepts one argument. Use .addVectors( a, b ) instead.');
            return this.addVectors(v, w);
        }
        this.x += v.x;
        this.y += v.y;
        this.z += v.z;
        return this;
    }
    addScalar(s) {
        this.x += s;
        this.y += s;
        this.z += s;
        return this;
    }
    addVectors(a, b) {
        this.x = a.x + b.x;
        this.y = a.y + b.y;
        this.z = a.z + b.z;
        return this;
    }
    addScaledVector(v, s) {
        this.x += v.x * s;
        this.y += v.y * s;
        this.z += v.z * s;
        return this;
    }
    sub(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .sub() now only accepts one argument. Use .subVectors( a, b ) instead.');
            return this.subVectors(v, w);
        }
        this.x -= v.x;
        this.y -= v.y;
        this.z -= v.z;
        return this;
    }
    subScalar(s) {
        this.x -= s;
        this.y -= s;
        this.z -= s;
        return this;
    }
    subVectors(a, b) {
        this.x = a.x - b.x;
        this.y = a.y - b.y;
        this.z = a.z - b.z;
        return this;
    }
    multiply(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .multiply() now only accepts one argument. Use .multiplyVectors( a, b ) instead.');
            return this.multiplyVectors(v, w);
        }
        this.x *= v.x;
        this.y *= v.y;
        this.z *= v.z;
        return this;
    }
    multiplyScalar(scalar) {
        this.x *= scalar;
        this.y *= scalar;
        this.z *= scalar;
        return this;
    }
    multiplyVectors(a, b) {
        this.x = a.x * b.x;
        this.y = a.y * b.y;
        this.z = a.z * b.z;
        return this;
    }
    applyEuler(euler) {
        if (!(euler && euler.isEuler)) console.error('THREE.Vector3: .applyEuler() now expects an Euler rotation rather than a Vector3 and order.');
        return this.applyQuaternion(_quaternion.setFromEuler(euler));
    }
    applyAxisAngle(axis, angle) {
        return this.applyQuaternion(_quaternion.setFromAxisAngle(axis, angle));
    }
    applyMatrix3(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[3] * y + e[6] * z;
        this.y = e[1] * x + e[4] * y + e[7] * z;
        this.z = e[2] * x + e[5] * y + e[8] * z;
        return this;
    }
    applyNormalMatrix(m) {
        return this.applyMatrix3(m).normalize();
    }
    applyMatrix4(m) {
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        const w = 1 / (e[3] * x + e[7] * y + e[11] * z + e[15]);
        this.x = (e[0] * x + e[4] * y + e[8] * z + e[12]) * w;
        this.y = (e[1] * x + e[5] * y + e[9] * z + e[13]) * w;
        this.z = (e[2] * x + e[6] * y + e[10] * z + e[14]) * w;
        return this;
    }
    applyQuaternion(q) {
        const x = this.x, y = this.y, z = this.z;
        const qx = q.x, qy = q.y, qz = q.z, qw = q.w;
        // calculate quat * vector
        const ix = qw * x + qy * z - qz * y;
        const iy = qw * y + qz * x - qx * z;
        const iz = qw * z + qx * y - qy * x;
        const iw = -qx * x - qy * y - qz * z;
        // calculate result * inverse quat
        this.x = ix * qw + iw * -qx + iy * -qz - iz * -qy;
        this.y = iy * qw + iw * -qy + iz * -qx - ix * -qz;
        this.z = iz * qw + iw * -qz + ix * -qy - iy * -qx;
        return this;
    }
    project(camera) {
        return this.applyMatrix4(camera.matrixWorldInverse).applyMatrix4(camera.projectionMatrix);
    }
    unproject(camera) {
        return this.applyMatrix4(camera.projectionMatrixInverse).applyMatrix4(camera.matrixWorld);
    }
    transformDirection(m) {
        // input: THREE.Matrix4 affine matrix
        // vector interpreted as a direction
        const x = this.x, y = this.y, z = this.z;
        const e = m.elements;
        this.x = e[0] * x + e[4] * y + e[8] * z;
        this.y = e[1] * x + e[5] * y + e[9] * z;
        this.z = e[2] * x + e[6] * y + e[10] * z;
        return this.normalize();
    }
    divide(v) {
        this.x /= v.x;
        this.y /= v.y;
        this.z /= v.z;
        return this;
    }
    divideScalar(scalar) {
        return this.multiplyScalar(1 / scalar);
    }
    min(v) {
        this.x = Math.min(this.x, v.x);
        this.y = Math.min(this.y, v.y);
        this.z = Math.min(this.z, v.z);
        return this;
    }
    max(v) {
        this.x = Math.max(this.x, v.x);
        this.y = Math.max(this.y, v.y);
        this.z = Math.max(this.z, v.z);
        return this;
    }
    clamp(min, max) {
        // assumes min < max, componentwise
        this.x = Math.max(min.x, Math.min(max.x, this.x));
        this.y = Math.max(min.y, Math.min(max.y, this.y));
        this.z = Math.max(min.z, Math.min(max.z, this.z));
        return this;
    }
    clampScalar(minVal, maxVal) {
        this.x = Math.max(minVal, Math.min(maxVal, this.x));
        this.y = Math.max(minVal, Math.min(maxVal, this.y));
        this.z = Math.max(minVal, Math.min(maxVal, this.z));
        return this;
    }
    clampLength(min, max) {
        const length = this.length();
        return this.divideScalar(length || 1).multiplyScalar(Math.max(min, Math.min(max, length)));
    }
    floor() {
        this.x = Math.floor(this.x);
        this.y = Math.floor(this.y);
        this.z = Math.floor(this.z);
        return this;
    }
    ceil() {
        this.x = Math.ceil(this.x);
        this.y = Math.ceil(this.y);
        this.z = Math.ceil(this.z);
        return this;
    }
    round() {
        this.x = Math.round(this.x);
        this.y = Math.round(this.y);
        this.z = Math.round(this.z);
        return this;
    }
    roundToZero() {
        this.x = this.x < 0 ? Math.ceil(this.x) : Math.floor(this.x);
        this.y = this.y < 0 ? Math.ceil(this.y) : Math.floor(this.y);
        this.z = this.z < 0 ? Math.ceil(this.z) : Math.floor(this.z);
        return this;
    }
    negate() {
        this.x = -this.x;
        this.y = -this.y;
        this.z = -this.z;
        return this;
    }
    dot(v) {
        return this.x * v.x + this.y * v.y + this.z * v.z;
    }
    // TODO lengthSquared?
    lengthSq() {
        return this.x * this.x + this.y * this.y + this.z * this.z;
    }
    length() {
        return Math.sqrt(this.x * this.x + this.y * this.y + this.z * this.z);
    }
    manhattanLength() {
        return Math.abs(this.x) + Math.abs(this.y) + Math.abs(this.z);
    }
    normalize() {
        return this.divideScalar(this.length() || 1);
    }
    setLength(length) {
        return this.normalize().multiplyScalar(length);
    }
    lerp(v, alpha) {
        this.x += (v.x - this.x) * alpha;
        this.y += (v.y - this.y) * alpha;
        this.z += (v.z - this.z) * alpha;
        return this;
    }
    lerpVectors(v1, v2, alpha) {
        this.x = v1.x + (v2.x - v1.x) * alpha;
        this.y = v1.y + (v2.y - v1.y) * alpha;
        this.z = v1.z + (v2.z - v1.z) * alpha;
        return this;
    }
    cross(v, w) {
        if (w !== undefined) {
            console.warn('THREE.Vector3: .cross() now only accepts one argument. Use .crossVectors( a, b ) instead.');
            return this.crossVectors(v, w);
        }
        return this.crossVectors(this, v);
    }
    crossVectors(a, b) {
        const ax = a.x, ay = a.y, az = a.z;
        const bx = b.x, by = b.y, bz = b.z;
        this.x = ay * bz - az * by;
        this.y = az * bx - ax * bz;
        this.z = ax * by - ay * bx;
        return this;
    }
    projectOnVector(v) {
        const denominator = v.lengthSq();
        if (denominator === 0) return this.set(0, 0, 0);
        const scalar = v.dot(this) / denominator;
        return this.copy(v).multiplyScalar(scalar);
    }
    projectOnPlane(planeNormal) {
        _vector.copy(this).projectOnVector(planeNormal);
        return this.sub(_vector);
    }
    reflect(normal) {
        // reflect incident vector off plane orthogonal to normal
        // normal is assumed to have unit length
        return this.sub(_vector.copy(normal).multiplyScalar(2 * this.dot(normal)));
    }
    angleTo(v) {
        const denominator = Math.sqrt(this.lengthSq() * v.lengthSq());
        if (denominator === 0) return Math.PI / 2;
        const theta = this.dot(v) / denominator;
        // clamp, to handle numerical problems
        return Math.acos(MathUtils.clamp(theta, -1, 1));
    }
    distanceTo(v) {
        return Math.sqrt(this.distanceToSquared(v));
    }
    distanceToSquared(v) {
        const dx = this.x - v.x, dy = this.y - v.y, dz = this.z - v.z;
        return dx * dx + dy * dy + dz * dz;
    }
    manhattanDistanceTo(v) {
        return Math.abs(this.x - v.x) + Math.abs(this.y - v.y) + Math.abs(this.z - v.z);
    }
    setFromSpherical(s) {
        return this.setFromSphericalCoords(s.radius, s.phi, s.theta);
    }
    setFromSphericalCoords(radius, phi, theta) {
        const sinPhiRadius = Math.sin(phi) * radius;
        this.x = sinPhiRadius * Math.sin(theta);
        this.y = Math.cos(phi) * radius;
        this.z = sinPhiRadius * Math.cos(theta);
        return this;
    }
    setFromCylindrical(c) {
        return this.setFromCylindricalCoords(c.radius, c.theta, c.y);
    }
    setFromCylindricalCoords(radius, theta, y) {
        this.x = radius * Math.sin(theta);
        this.y = y;
        this.z = radius * Math.cos(theta);
        return this;
    }
    setFromMatrixPosition(m) {
        const e = m.elements;
        this.x = e[12];
        this.y = e[13];
        this.z = e[14];
        return this;
    }
    setFromMatrixScale(m) {
        const sx = this.setFromMatrixColumn(m, 0).length();
        const sy = this.setFromMatrixColumn(m, 1).length();
        const sz = this.setFromMatrixColumn(m, 2).length();
        this.x = sx;
        this.y = sy;
        this.z = sz;
        return this;
    }
    setFromMatrixColumn(m, index) {
        return this.fromArray(m.elements, index * 4);
    }
    setFromMatrix3Column(m, index) {
        return this.fromArray(m.elements, index * 3);
    }
    equals(v) {
        return v.x === this.x && v.y === this.y && v.z === this.z;
    }
    fromArray(array, offset = 0) {
        this.x = array[offset];
        this.y = array[offset + 1];
        this.z = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.x;
        array[offset + 1] = this.y;
        array[offset + 2] = this.z;
        return array;
    }
    fromBufferAttribute(attribute, index, offset) {
        if (offset !== undefined) console.warn('THREE.Vector3: offset has been removed from .fromBufferAttribute().');
        this.x = attribute.getX(index);
        this.y = attribute.getY(index);
        this.z = attribute.getZ(index);
        return this;
    }
    random() {
        this.x = Math.random();
        this.y = Math.random();
        this.z = Math.random();
        return this;
    }
}
const _vector = /*@__PURE__*/ new Vector3();
const _quaternion = /*@__PURE__*/ new Quaternion();
class Box3 {
    constructor(min, max){
        Object.defineProperty(this, 'isBox3', {
            value: true
        });
        this.min = min !== undefined ? min : new Vector3(Infinity, Infinity, Infinity);
        this.max = max !== undefined ? max : new Vector3(-Infinity, -Infinity, -Infinity);
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromArray(array) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = array.length; i < l; i += 3){
            const x = array[i];
            const y = array[i + 1];
            const z = array[i + 2];
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromBufferAttribute(attribute) {
        let minX = Infinity;
        let minY = Infinity;
        let minZ = Infinity;
        let maxX = -Infinity;
        let maxY = -Infinity;
        let maxZ = -Infinity;
        for(let i = 0, l = attribute.count; i < l; i++){
            const x = attribute.getX(i);
            const y = attribute.getY(i);
            const z = attribute.getZ(i);
            if (x < minX) minX = x;
            if (y < minY) minY = y;
            if (z < minZ) minZ = z;
            if (x > maxX) maxX = x;
            if (y > maxY) maxY = y;
            if (z > maxZ) maxZ = z;
        }
        this.min.set(minX, minY, minZ);
        this.max.set(maxX, maxY, maxZ);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = _vector$1.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    setFromObject(object) {
        this.makeEmpty();
        return this.expandByObject(object);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = this.min.z = Infinity;
        this.max.x = this.max.y = this.max.z = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y || this.max.z < this.min.z;
    }
    getCenter(target) {
        if (target === undefined) {
            console.warn('THREE.Box3: .getCenter() target is now required');
            target = new Vector3();
        }
        return this.isEmpty() ? target.set(0, 0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        if (target === undefined) {
            console.warn('THREE.Box3: .getSize() target is now required');
            target = new Vector3();
        }
        return this.isEmpty() ? target.set(0, 0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    expandByObject(object) {
        // Computes the world-axis-aligned bounding box of an object (including its children),
        // accounting for both the object's, and children's, world transforms
        object.updateWorldMatrix(false, false);
        const geometry = object.geometry;
        if (geometry !== undefined) {
            if (geometry.boundingBox === null) geometry.computeBoundingBox();
            _box.copy(geometry.boundingBox);
            _box.applyMatrix4(object.matrixWorld);
            this.union(_box);
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)this.expandByObject(children[i]);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y || point.z < this.min.z || point.z > this.max.z ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y && this.min.z <= box.min.z && box.max.z <= this.max.z;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        if (target === undefined) {
            console.warn('THREE.Box3: .getParameter() target is now required');
            target = new Vector3();
        }
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y), (point.z - this.min.z) / (this.max.z - this.min.z));
    }
    intersectsBox(box) {
        // using 6 splitting planes to rule out intersections.
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y || box.max.z < this.min.z || box.min.z > this.max.z ? false : true;
    }
    intersectsSphere(sphere) {
        // Find the point on the AABB closest to the sphere center.
        this.clampPoint(sphere.center, _vector$1);
        // If that point is inside the sphere, the AABB and sphere intersect.
        return _vector$1.distanceToSquared(sphere.center) <= sphere.radius * sphere.radius;
    }
    intersectsPlane(plane) {
        // We compute the minimum and maximum dot product values. If those values
        // are on the same side (back or front) of the plane, then there is no intersection.
        let min, max;
        if (plane.normal.x > 0) {
            min = plane.normal.x * this.min.x;
            max = plane.normal.x * this.max.x;
        } else {
            min = plane.normal.x * this.max.x;
            max = plane.normal.x * this.min.x;
        }
        if (plane.normal.y > 0) {
            min += plane.normal.y * this.min.y;
            max += plane.normal.y * this.max.y;
        } else {
            min += plane.normal.y * this.max.y;
            max += plane.normal.y * this.min.y;
        }
        if (plane.normal.z > 0) {
            min += plane.normal.z * this.min.z;
            max += plane.normal.z * this.max.z;
        } else {
            min += plane.normal.z * this.max.z;
            max += plane.normal.z * this.min.z;
        }
        return min <= -plane.constant && max >= -plane.constant;
    }
    intersectsTriangle(triangle) {
        if (this.isEmpty()) return false;
        // compute box center and extents
        this.getCenter(_center);
        _extents.subVectors(this.max, _center);
        // translate triangle to aabb origin
        _v0.subVectors(triangle.a, _center);
        _v1.subVectors(triangle.b, _center);
        _v2.subVectors(triangle.c, _center);
        // compute edge vectors for triangle
        _f0.subVectors(_v1, _v0);
        _f1.subVectors(_v2, _v1);
        _f2.subVectors(_v0, _v2);
        // test against axes that are given by cross product combinations of the edges of the triangle and the edges of the aabb
        // make an axis testing of each of the 3 sides of the aabb against each of the 3 sides of the triangle = 9 axis of separation
        // axis_ij = u_i x f_j (u0, u1, u2 = face normals of aabb = x,y,z axes vectors since aabb is axis aligned)
        let axes = [
            0,
            -_f0.z,
            _f0.y,
            0,
            -_f1.z,
            _f1.y,
            0,
            -_f2.z,
            _f2.y,
            _f0.z,
            0,
            -_f0.x,
            _f1.z,
            0,
            -_f1.x,
            _f2.z,
            0,
            -_f2.x,
            -_f0.y,
            _f0.x,
            0,
            -_f1.y,
            _f1.x,
            0,
            -_f2.y,
            _f2.x,
            0
        ];
        if (!satForAxes(axes, _v0, _v1, _v2, _extents)) return false;
        // test 3 face normals from the aabb
        axes = [
            1,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1
        ];
        if (!satForAxes(axes, _v0, _v1, _v2, _extents)) return false;
        // finally testing the face normal of the triangle
        // use already existing triangle edge vectors here
        _triangleNormal.crossVectors(_f0, _f1);
        axes = [
            _triangleNormal.x,
            _triangleNormal.y,
            _triangleNormal.z
        ];
        return satForAxes(axes, _v0, _v1, _v2, _extents);
    }
    clampPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Box3: .clampPoint() target is now required');
            target = new Vector3();
        }
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = _vector$1.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    getBoundingSphere(target) {
        if (target === undefined) console.error('THREE.Box3: .getBoundingSphere() target is now required');
        this.getCenter(target.center);
        target.radius = this.getSize(_vector$1).length() * 0.5;
        return target;
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        // ensure that if there is no overlap, the result is fully empty, not slightly empty with non-inf/+inf values that will cause subsequence intersects to erroneously return valid values.
        if (this.isEmpty()) this.makeEmpty();
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    applyMatrix4(matrix) {
        // transform of empty box is an empty box.
        if (this.isEmpty()) return this;
        // NOTE: I am using a binary pattern to specify all 2^3 combinations below
        _points[0].set(this.min.x, this.min.y, this.min.z).applyMatrix4(matrix); // 000
        _points[1].set(this.min.x, this.min.y, this.max.z).applyMatrix4(matrix); // 001
        _points[2].set(this.min.x, this.max.y, this.min.z).applyMatrix4(matrix); // 010
        _points[3].set(this.min.x, this.max.y, this.max.z).applyMatrix4(matrix); // 011
        _points[4].set(this.max.x, this.min.y, this.min.z).applyMatrix4(matrix); // 100
        _points[5].set(this.max.x, this.min.y, this.max.z).applyMatrix4(matrix); // 101
        _points[6].set(this.max.x, this.max.y, this.min.z).applyMatrix4(matrix); // 110
        _points[7].set(this.max.x, this.max.y, this.max.z).applyMatrix4(matrix); // 111
        this.setFromPoints(_points);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
function satForAxes(axes, v0, v1, v2, extents) {
    for(let i = 0, j = axes.length - 3; i <= j; i += 3){
        _testAxis.fromArray(axes, i);
        // project the aabb onto the seperating axis
        const r = extents.x * Math.abs(_testAxis.x) + extents.y * Math.abs(_testAxis.y) + extents.z * Math.abs(_testAxis.z);
        // project all 3 vertices of the triangle onto the seperating axis
        const p0 = v0.dot(_testAxis);
        const p1 = v1.dot(_testAxis);
        const p2 = v2.dot(_testAxis);
        // actual test, basically see if either of the most extreme of the triangle points intersects r
        if (Math.max(-Math.max(p0, p1, p2), Math.min(p0, p1, p2)) > r) // points of the projected triangle are outside the projected half-length of the aabb
        // the axis is seperating and we can exit
        return false;
    }
    return true;
}
const _points = [
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3(),
    /*@__PURE__*/ new Vector3()
];
const _vector$1 = /*@__PURE__*/ new Vector3();
const _box = /*@__PURE__*/ new Box3();
// triangle centered vertices
const _v0 = /*@__PURE__*/ new Vector3();
const _v1 = /*@__PURE__*/ new Vector3();
const _v2 = /*@__PURE__*/ new Vector3();
// triangle edge vectors
const _f0 = /*@__PURE__*/ new Vector3();
const _f1 = /*@__PURE__*/ new Vector3();
const _f2 = /*@__PURE__*/ new Vector3();
const _center = /*@__PURE__*/ new Vector3();
const _extents = /*@__PURE__*/ new Vector3();
const _triangleNormal = /*@__PURE__*/ new Vector3();
const _testAxis = /*@__PURE__*/ new Vector3();
const _box$1 = /*@__PURE__*/ new Box3();
class Sphere {
    constructor(center, radius){
        this.center = center !== undefined ? center : new Vector3();
        this.radius = radius !== undefined ? radius : -1;
    }
    set(center, radius) {
        this.center.copy(center);
        this.radius = radius;
        return this;
    }
    setFromPoints(points, optionalCenter) {
        const center = this.center;
        if (optionalCenter !== undefined) center.copy(optionalCenter);
        else _box$1.setFromPoints(points).getCenter(center);
        let maxRadiusSq = 0;
        for(let i = 0, il = points.length; i < il; i++)maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(points[i]));
        this.radius = Math.sqrt(maxRadiusSq);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(sphere) {
        this.center.copy(sphere.center);
        this.radius = sphere.radius;
        return this;
    }
    isEmpty() {
        return this.radius < 0;
    }
    makeEmpty() {
        this.center.set(0, 0, 0);
        this.radius = -1;
        return this;
    }
    containsPoint(point) {
        return point.distanceToSquared(this.center) <= this.radius * this.radius;
    }
    distanceToPoint(point) {
        return point.distanceTo(this.center) - this.radius;
    }
    intersectsSphere(sphere) {
        const radiusSum = this.radius + sphere.radius;
        return sphere.center.distanceToSquared(this.center) <= radiusSum * radiusSum;
    }
    intersectsBox(box) {
        return box.intersectsSphere(this);
    }
    intersectsPlane(plane) {
        return Math.abs(plane.distanceToPoint(this.center)) <= this.radius;
    }
    clampPoint(point, target) {
        const deltaLengthSq = this.center.distanceToSquared(point);
        if (target === undefined) {
            console.warn('THREE.Sphere: .clampPoint() target is now required');
            target = new Vector3();
        }
        target.copy(point);
        if (deltaLengthSq > this.radius * this.radius) {
            target.sub(this.center).normalize();
            target.multiplyScalar(this.radius).add(this.center);
        }
        return target;
    }
    getBoundingBox(target) {
        if (target === undefined) {
            console.warn('THREE.Sphere: .getBoundingBox() target is now required');
            target = new Box3();
        }
        if (this.isEmpty()) {
            // Empty sphere produces empty bounding box
            target.makeEmpty();
            return target;
        }
        target.set(this.center, this.center);
        target.expandByScalar(this.radius);
        return target;
    }
    applyMatrix4(matrix) {
        this.center.applyMatrix4(matrix);
        this.radius = this.radius * matrix.getMaxScaleOnAxis();
        return this;
    }
    translate(offset) {
        this.center.add(offset);
        return this;
    }
    equals(sphere) {
        return sphere.center.equals(this.center) && sphere.radius === this.radius;
    }
}
const _vector$2 = /*@__PURE__*/ new Vector3();
const _segCenter = /*@__PURE__*/ new Vector3();
const _segDir = /*@__PURE__*/ new Vector3();
const _diff = /*@__PURE__*/ new Vector3();
const _edge1 = /*@__PURE__*/ new Vector3();
const _edge2 = /*@__PURE__*/ new Vector3();
const _normal = /*@__PURE__*/ new Vector3();
class Ray {
    constructor(origin, direction){
        this.origin = origin !== undefined ? origin : new Vector3();
        this.direction = direction !== undefined ? direction : new Vector3(0, 0, -1);
    }
    set(origin, direction) {
        this.origin.copy(origin);
        this.direction.copy(direction);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(ray) {
        this.origin.copy(ray.origin);
        this.direction.copy(ray.direction);
        return this;
    }
    at(t, target) {
        if (target === undefined) {
            console.warn('THREE.Ray: .at() target is now required');
            target = new Vector3();
        }
        return target.copy(this.direction).multiplyScalar(t).add(this.origin);
    }
    lookAt(v) {
        this.direction.copy(v).sub(this.origin).normalize();
        return this;
    }
    recast(t) {
        this.origin.copy(this.at(t, _vector$2));
        return this;
    }
    closestPointToPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Ray: .closestPointToPoint() target is now required');
            target = new Vector3();
        }
        target.subVectors(point, this.origin);
        const directionDistance = target.dot(this.direction);
        if (directionDistance < 0) return target.copy(this.origin);
        return target.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
    }
    distanceToPoint(point) {
        return Math.sqrt(this.distanceSqToPoint(point));
    }
    distanceSqToPoint(point) {
        const directionDistance = _vector$2.subVectors(point, this.origin).dot(this.direction);
        // point behind the ray
        if (directionDistance < 0) return this.origin.distanceToSquared(point);
        _vector$2.copy(this.direction).multiplyScalar(directionDistance).add(this.origin);
        return _vector$2.distanceToSquared(point);
    }
    distanceSqToSegment(v0, v1, optionalPointOnRay, optionalPointOnSegment) {
        // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteDistRaySegment.h
        // It returns the min distance between the ray and the segment
        // defined by v0 and v1
        // It can also set two optional targets :
        // - The closest point on the ray
        // - The closest point on the segment
        _segCenter.copy(v0).add(v1).multiplyScalar(0.5);
        _segDir.copy(v1).sub(v0).normalize();
        _diff.copy(this.origin).sub(_segCenter);
        const segExtent = v0.distanceTo(v1) * 0.5;
        const a01 = -this.direction.dot(_segDir);
        const b0 = _diff.dot(this.direction);
        const b1 = -_diff.dot(_segDir);
        const c = _diff.lengthSq();
        const det = Math.abs(1 - a01 * a01);
        let s0, s1, sqrDist, extDet;
        if (det > 0) {
            // The ray and segment are not parallel.
            s0 = a01 * b1 - b0;
            s1 = a01 * b0 - b1;
            extDet = segExtent * det;
            if (s0 >= 0) {
                if (s1 >= -extDet) {
                    if (s1 <= extDet) {
                        // region 0
                        // Minimum at interior points of ray and segment.
                        const invDet = 1 / det;
                        s0 *= invDet;
                        s1 *= invDet;
                        sqrDist = s0 * (s0 + a01 * s1 + 2 * b0) + s1 * (a01 * s0 + s1 + 2 * b1) + c;
                    } else {
                        // region 1
                        s1 = segExtent;
                        s0 = Math.max(0, -(a01 * s1 + b0));
                        sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                    }
                } else {
                    // region 5
                    s1 = -segExtent;
                    s0 = Math.max(0, -(a01 * s1 + b0));
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            } else {
                if (s1 <= -extDet) {
                    // region 4
                    s0 = Math.max(0, -(-a01 * segExtent + b0));
                    s1 = s0 > 0 ? -segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                } else if (s1 <= extDet) {
                    // region 3
                    s0 = 0;
                    s1 = Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = s1 * (s1 + 2 * b1) + c;
                } else {
                    // region 2
                    s0 = Math.max(0, -(a01 * segExtent + b0));
                    s1 = s0 > 0 ? segExtent : Math.min(Math.max(-segExtent, -b1), segExtent);
                    sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
                }
            }
        } else {
            // Ray and segment are parallel.
            s1 = a01 > 0 ? -segExtent : segExtent;
            s0 = Math.max(0, -(a01 * s1 + b0));
            sqrDist = -s0 * s0 + s1 * (s1 + 2 * b1) + c;
        }
        if (optionalPointOnRay) optionalPointOnRay.copy(this.direction).multiplyScalar(s0).add(this.origin);
        if (optionalPointOnSegment) optionalPointOnSegment.copy(_segDir).multiplyScalar(s1).add(_segCenter);
        return sqrDist;
    }
    intersectSphere(sphere, target) {
        _vector$2.subVectors(sphere.center, this.origin);
        const tca = _vector$2.dot(this.direction);
        const d2 = _vector$2.dot(_vector$2) - tca * tca;
        const radius2 = sphere.radius * sphere.radius;
        if (d2 > radius2) return null;
        const thc = Math.sqrt(radius2 - d2);
        // t0 = first intersect point - entrance on front of sphere
        const t0 = tca - thc;
        // t1 = second intersect point - exit point on back of sphere
        const t1 = tca + thc;
        // test to see if both t0 and t1 are behind the ray - if so, return null
        if (t0 < 0 && t1 < 0) return null;
        // test to see if t0 is behind the ray:
        // if it is, the ray is inside the sphere, so return the second exit point scaled by t1,
        // in order to always return an intersect point that is in front of the ray.
        if (t0 < 0) return this.at(t1, target);
        // else t0 is in front of the ray, so return the first collision point scaled by t0
        return this.at(t0, target);
    }
    intersectsSphere(sphere) {
        return this.distanceSqToPoint(sphere.center) <= sphere.radius * sphere.radius;
    }
    distanceToPlane(plane) {
        const denominator = plane.normal.dot(this.direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (plane.distanceToPoint(this.origin) === 0) return 0;
            // Null is preferable to undefined since undefined means.... it is undefined
            return null;
        }
        const t = -(this.origin.dot(plane.normal) + plane.constant) / denominator;
        // Return if the ray never intersects the plane
        return t >= 0 ? t : null;
    }
    intersectPlane(plane, target) {
        const t = this.distanceToPlane(plane);
        if (t === null) return null;
        return this.at(t, target);
    }
    intersectsPlane(plane) {
        // check if the ray lies on the plane first
        const distToPoint = plane.distanceToPoint(this.origin);
        if (distToPoint === 0) return true;
        const denominator = plane.normal.dot(this.direction);
        if (denominator * distToPoint < 0) return true;
        // ray origin is behind the plane (and is pointing behind it)
        return false;
    }
    intersectBox(box, target) {
        let tmin, tmax, tymin, tymax, tzmin, tzmax;
        const invdirx = 1 / this.direction.x, invdiry = 1 / this.direction.y, invdirz = 1 / this.direction.z;
        const origin = this.origin;
        if (invdirx >= 0) {
            tmin = (box.min.x - origin.x) * invdirx;
            tmax = (box.max.x - origin.x) * invdirx;
        } else {
            tmin = (box.max.x - origin.x) * invdirx;
            tmax = (box.min.x - origin.x) * invdirx;
        }
        if (invdiry >= 0) {
            tymin = (box.min.y - origin.y) * invdiry;
            tymax = (box.max.y - origin.y) * invdiry;
        } else {
            tymin = (box.max.y - origin.y) * invdiry;
            tymax = (box.min.y - origin.y) * invdiry;
        }
        if (tmin > tymax || tymin > tmax) return null;
        // These lines also handle the case where tmin or tmax is NaN
        // (result of 0 * Infinity). x !== x returns true if x is NaN
        if (tymin > tmin || tmin !== tmin) tmin = tymin;
        if (tymax < tmax || tmax !== tmax) tmax = tymax;
        if (invdirz >= 0) {
            tzmin = (box.min.z - origin.z) * invdirz;
            tzmax = (box.max.z - origin.z) * invdirz;
        } else {
            tzmin = (box.max.z - origin.z) * invdirz;
            tzmax = (box.min.z - origin.z) * invdirz;
        }
        if (tmin > tzmax || tzmin > tmax) return null;
        if (tzmin > tmin || tmin !== tmin) tmin = tzmin;
        if (tzmax < tmax || tmax !== tmax) tmax = tzmax;
        //return point closest to the ray (positive side)
        if (tmax < 0) return null;
        return this.at(tmin >= 0 ? tmin : tmax, target);
    }
    intersectsBox(box) {
        return this.intersectBox(box, _vector$2) !== null;
    }
    intersectTriangle(a, b, c, backfaceCulling, target) {
        // Compute the offset origin, edges, and normal.
        // from http://www.geometrictools.com/GTEngine/Include/Mathematics/GteIntrRay3Triangle3.h
        _edge1.subVectors(b, a);
        _edge2.subVectors(c, a);
        _normal.crossVectors(_edge1, _edge2);
        // Solve Q + t*D = b1*E1 + b2*E2 (Q = kDiff, D = ray direction,
        // E1 = kEdge1, E2 = kEdge2, N = Cross(E1,E2)) by
        //   |Dot(D,N)|*b1 = sign(Dot(D,N))*Dot(D,Cross(Q,E2))
        //   |Dot(D,N)|*b2 = sign(Dot(D,N))*Dot(D,Cross(E1,Q))
        //   |Dot(D,N)|*t = -sign(Dot(D,N))*Dot(Q,N)
        let DdN = this.direction.dot(_normal);
        let sign;
        if (DdN > 0) {
            if (backfaceCulling) return null;
            sign = 1;
        } else if (DdN < 0) {
            sign = -1;
            DdN = -DdN;
        } else return null;
        _diff.subVectors(this.origin, a);
        const DdQxE2 = sign * this.direction.dot(_edge2.crossVectors(_diff, _edge2));
        // b1 < 0, no intersection
        if (DdQxE2 < 0) return null;
        const DdE1xQ = sign * this.direction.dot(_edge1.cross(_diff));
        // b2 < 0, no intersection
        if (DdE1xQ < 0) return null;
        // b1+b2 > 1, no intersection
        if (DdQxE2 + DdE1xQ > DdN) return null;
        // Line intersects triangle, check if ray does.
        const QdN = -sign * _diff.dot(_normal);
        // t < 0, no intersection
        if (QdN < 0) return null;
        // Ray intersects triangle.
        return this.at(QdN / DdN, target);
    }
    applyMatrix4(matrix4) {
        this.origin.applyMatrix4(matrix4);
        this.direction.transformDirection(matrix4);
        return this;
    }
    equals(ray) {
        return ray.origin.equals(this.origin) && ray.direction.equals(this.direction);
    }
}
class Matrix4 {
    constructor(){
        Object.defineProperty(this, 'isMatrix4', {
            value: true
        });
        this.elements = [
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            0,
            1
        ];
        if (arguments.length > 0) console.error('THREE.Matrix4: the constructor no longer reads arguments. use .set() instead.');
    }
    set(n11, n12, n13, n14, n21, n22, n23, n24, n31, n32, n33, n34, n41, n42, n43, n44) {
        const te = this.elements;
        te[0] = n11;
        te[4] = n12;
        te[8] = n13;
        te[12] = n14;
        te[1] = n21;
        te[5] = n22;
        te[9] = n23;
        te[13] = n24;
        te[2] = n31;
        te[6] = n32;
        te[10] = n33;
        te[14] = n34;
        te[3] = n41;
        te[7] = n42;
        te[11] = n43;
        te[15] = n44;
        return this;
    }
    identity() {
        this.set(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    clone() {
        return new Matrix4().fromArray(this.elements);
    }
    copy(m) {
        const te = this.elements;
        const me = m.elements;
        te[0] = me[0];
        te[1] = me[1];
        te[2] = me[2];
        te[3] = me[3];
        te[4] = me[4];
        te[5] = me[5];
        te[6] = me[6];
        te[7] = me[7];
        te[8] = me[8];
        te[9] = me[9];
        te[10] = me[10];
        te[11] = me[11];
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        te[15] = me[15];
        return this;
    }
    copyPosition(m) {
        const te = this.elements, me = m.elements;
        te[12] = me[12];
        te[13] = me[13];
        te[14] = me[14];
        return this;
    }
    setFromMatrix3(m) {
        const me = m.elements;
        this.set(me[0], me[3], me[6], 0, me[1], me[4], me[7], 0, me[2], me[5], me[8], 0, 0, 0, 0, 1);
        return this;
    }
    extractBasis(xAxis, yAxis, zAxis) {
        xAxis.setFromMatrixColumn(this, 0);
        yAxis.setFromMatrixColumn(this, 1);
        zAxis.setFromMatrixColumn(this, 2);
        return this;
    }
    makeBasis(xAxis, yAxis, zAxis) {
        this.set(xAxis.x, yAxis.x, zAxis.x, 0, xAxis.y, yAxis.y, zAxis.y, 0, xAxis.z, yAxis.z, zAxis.z, 0, 0, 0, 0, 1);
        return this;
    }
    extractRotation(m) {
        // this method does not support reflection matrices
        const te = this.elements;
        const me = m.elements;
        const scaleX = 1 / _v1$1.setFromMatrixColumn(m, 0).length();
        const scaleY = 1 / _v1$1.setFromMatrixColumn(m, 1).length();
        const scaleZ = 1 / _v1$1.setFromMatrixColumn(m, 2).length();
        te[0] = me[0] * scaleX;
        te[1] = me[1] * scaleX;
        te[2] = me[2] * scaleX;
        te[3] = 0;
        te[4] = me[4] * scaleY;
        te[5] = me[5] * scaleY;
        te[6] = me[6] * scaleY;
        te[7] = 0;
        te[8] = me[8] * scaleZ;
        te[9] = me[9] * scaleZ;
        te[10] = me[10] * scaleZ;
        te[11] = 0;
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromEuler(euler) {
        if (!(euler && euler.isEuler)) console.error('THREE.Matrix4: .makeRotationFromEuler() now expects a Euler rotation rather than a Vector3 and order.');
        const te = this.elements;
        const x = euler.x, y = euler.y, z = euler.z;
        const a = Math.cos(x), b = Math.sin(x);
        const c = Math.cos(y), d = Math.sin(y);
        const e = Math.cos(z), f = Math.sin(z);
        if (euler.order === 'XYZ') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = -c * f;
            te[8] = d;
            te[1] = af + be * d;
            te[5] = ae - bf * d;
            te[9] = -b * c;
            te[2] = bf - ae * d;
            te[6] = be + af * d;
            te[10] = a * c;
        } else if (euler.order === 'YXZ') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce + df * b;
            te[4] = de * b - cf;
            te[8] = a * d;
            te[1] = a * f;
            te[5] = a * e;
            te[9] = -b;
            te[2] = cf * b - de;
            te[6] = df + ce * b;
            te[10] = a * c;
        } else if (euler.order === 'ZXY') {
            const ce = c * e, cf = c * f, de = d * e, df = d * f;
            te[0] = ce - df * b;
            te[4] = -a * f;
            te[8] = de + cf * b;
            te[1] = cf + de * b;
            te[5] = a * e;
            te[9] = df - ce * b;
            te[2] = -a * d;
            te[6] = b;
            te[10] = a * c;
        } else if (euler.order === 'ZYX') {
            const ae = a * e, af = a * f, be = b * e, bf = b * f;
            te[0] = c * e;
            te[4] = be * d - af;
            te[8] = ae * d + bf;
            te[1] = c * f;
            te[5] = bf * d + ae;
            te[9] = af * d - be;
            te[2] = -d;
            te[6] = b * c;
            te[10] = a * c;
        } else if (euler.order === 'YZX') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = bd - ac * f;
            te[8] = bc * f + ad;
            te[1] = f;
            te[5] = a * e;
            te[9] = -b * e;
            te[2] = -d * e;
            te[6] = ad * f + bc;
            te[10] = ac - bd * f;
        } else if (euler.order === 'XZY') {
            const ac = a * c, ad = a * d, bc = b * c, bd = b * d;
            te[0] = c * e;
            te[4] = -f;
            te[8] = d * e;
            te[1] = ac * f + bd;
            te[5] = a * e;
            te[9] = ad * f - bc;
            te[2] = bc * f - ad;
            te[6] = b * e;
            te[10] = bd * f + ac;
        }
        // bottom row
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        // last column
        te[12] = 0;
        te[13] = 0;
        te[14] = 0;
        te[15] = 1;
        return this;
    }
    makeRotationFromQuaternion(q) {
        return this.compose(_zero, q, _one);
    }
    lookAt(eye, target, up) {
        const te = this.elements;
        _z.subVectors(eye, target);
        if (_z.lengthSq() === 0) // eye and target are in the same position
        _z.z = 1;
        _z.normalize();
        _x.crossVectors(up, _z);
        if (_x.lengthSq() === 0) {
            // up and z are parallel
            if (Math.abs(up.z) === 1) _z.x += 0.0001;
            else _z.z += 0.0001;
            _z.normalize();
            _x.crossVectors(up, _z);
        }
        _x.normalize();
        _y.crossVectors(_z, _x);
        te[0] = _x.x;
        te[4] = _y.x;
        te[8] = _z.x;
        te[1] = _x.y;
        te[5] = _y.y;
        te[9] = _z.y;
        te[2] = _x.z;
        te[6] = _y.z;
        te[10] = _z.z;
        return this;
    }
    multiply(m, n) {
        if (n !== undefined) {
            console.warn('THREE.Matrix4: .multiply() now only accepts one argument. Use .multiplyMatrices( a, b ) instead.');
            return this.multiplyMatrices(m, n);
        }
        return this.multiplyMatrices(this, m);
    }
    premultiply(m) {
        return this.multiplyMatrices(m, this);
    }
    multiplyMatrices(a, b) {
        const ae = a.elements;
        const be = b.elements;
        const te = this.elements;
        const a11 = ae[0], a12 = ae[4], a13 = ae[8], a14 = ae[12];
        const a21 = ae[1], a22 = ae[5], a23 = ae[9], a24 = ae[13];
        const a31 = ae[2], a32 = ae[6], a33 = ae[10], a34 = ae[14];
        const a41 = ae[3], a42 = ae[7], a43 = ae[11], a44 = ae[15];
        const b11 = be[0], b12 = be[4], b13 = be[8], b14 = be[12];
        const b21 = be[1], b22 = be[5], b23 = be[9], b24 = be[13];
        const b31 = be[2], b32 = be[6], b33 = be[10], b34 = be[14];
        const b41 = be[3], b42 = be[7], b43 = be[11], b44 = be[15];
        te[0] = a11 * b11 + a12 * b21 + a13 * b31 + a14 * b41;
        te[4] = a11 * b12 + a12 * b22 + a13 * b32 + a14 * b42;
        te[8] = a11 * b13 + a12 * b23 + a13 * b33 + a14 * b43;
        te[12] = a11 * b14 + a12 * b24 + a13 * b34 + a14 * b44;
        te[1] = a21 * b11 + a22 * b21 + a23 * b31 + a24 * b41;
        te[5] = a21 * b12 + a22 * b22 + a23 * b32 + a24 * b42;
        te[9] = a21 * b13 + a22 * b23 + a23 * b33 + a24 * b43;
        te[13] = a21 * b14 + a22 * b24 + a23 * b34 + a24 * b44;
        te[2] = a31 * b11 + a32 * b21 + a33 * b31 + a34 * b41;
        te[6] = a31 * b12 + a32 * b22 + a33 * b32 + a34 * b42;
        te[10] = a31 * b13 + a32 * b23 + a33 * b33 + a34 * b43;
        te[14] = a31 * b14 + a32 * b24 + a33 * b34 + a34 * b44;
        te[3] = a41 * b11 + a42 * b21 + a43 * b31 + a44 * b41;
        te[7] = a41 * b12 + a42 * b22 + a43 * b32 + a44 * b42;
        te[11] = a41 * b13 + a42 * b23 + a43 * b33 + a44 * b43;
        te[15] = a41 * b14 + a42 * b24 + a43 * b34 + a44 * b44;
        return this;
    }
    multiplyScalar(s) {
        const te = this.elements;
        te[0] *= s;
        te[4] *= s;
        te[8] *= s;
        te[12] *= s;
        te[1] *= s;
        te[5] *= s;
        te[9] *= s;
        te[13] *= s;
        te[2] *= s;
        te[6] *= s;
        te[10] *= s;
        te[14] *= s;
        te[3] *= s;
        te[7] *= s;
        te[11] *= s;
        te[15] *= s;
        return this;
    }
    determinant() {
        const te = this.elements;
        const n11 = te[0], n12 = te[4], n13 = te[8], n14 = te[12];
        const n21 = te[1], n22 = te[5], n23 = te[9], n24 = te[13];
        const n31 = te[2], n32 = te[6], n33 = te[10], n34 = te[14];
        const n41 = te[3], n42 = te[7], n43 = te[11], n44 = te[15];
        //TODO: make this more efficient
        //( based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm )
        return n41 * (+n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34) + n42 * (+n11 * n23 * n34 - n11 * n24 * n33 + n14 * n21 * n33 - n13 * n21 * n34 + n13 * n24 * n31 - n14 * n23 * n31) + n43 * (+n11 * n24 * n32 - n11 * n22 * n34 - n14 * n21 * n32 + n12 * n21 * n34 + n14 * n22 * n31 - n12 * n24 * n31) + n44 * (-n13 * n22 * n31 - n11 * n23 * n32 + n11 * n22 * n33 + n13 * n21 * n32 - n12 * n21 * n33 + n12 * n23 * n31);
    }
    transpose() {
        const te = this.elements;
        let tmp;
        tmp = te[1];
        te[1] = te[4];
        te[4] = tmp;
        tmp = te[2];
        te[2] = te[8];
        te[8] = tmp;
        tmp = te[6];
        te[6] = te[9];
        te[9] = tmp;
        tmp = te[3];
        te[3] = te[12];
        te[12] = tmp;
        tmp = te[7];
        te[7] = te[13];
        te[13] = tmp;
        tmp = te[11];
        te[11] = te[14];
        te[14] = tmp;
        return this;
    }
    setPosition(x, y, z) {
        const te = this.elements;
        if (x.isVector3) {
            te[12] = x.x;
            te[13] = x.y;
            te[14] = x.z;
        } else {
            te[12] = x;
            te[13] = y;
            te[14] = z;
        }
        return this;
    }
    invert() {
        // based on http://www.euclideanspace.com/maths/algebra/matrix/functions/inverse/fourD/index.htm
        const te = this.elements, n11 = te[0], n21 = te[1], n31 = te[2], n41 = te[3], n12 = te[4], n22 = te[5], n32 = te[6], n42 = te[7], n13 = te[8], n23 = te[9], n33 = te[10], n43 = te[11], n14 = te[12], n24 = te[13], n34 = te[14], n44 = te[15], t11 = n23 * n34 * n42 - n24 * n33 * n42 + n24 * n32 * n43 - n22 * n34 * n43 - n23 * n32 * n44 + n22 * n33 * n44, t12 = n14 * n33 * n42 - n13 * n34 * n42 - n14 * n32 * n43 + n12 * n34 * n43 + n13 * n32 * n44 - n12 * n33 * n44, t13 = n13 * n24 * n42 - n14 * n23 * n42 + n14 * n22 * n43 - n12 * n24 * n43 - n13 * n22 * n44 + n12 * n23 * n44, t14 = n14 * n23 * n32 - n13 * n24 * n32 - n14 * n22 * n33 + n12 * n24 * n33 + n13 * n22 * n34 - n12 * n23 * n34;
        const det = n11 * t11 + n21 * t12 + n31 * t13 + n41 * t14;
        if (det === 0) return this.set(0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0);
        const detInv = 1 / det;
        te[0] = t11 * detInv;
        te[1] = (n24 * n33 * n41 - n23 * n34 * n41 - n24 * n31 * n43 + n21 * n34 * n43 + n23 * n31 * n44 - n21 * n33 * n44) * detInv;
        te[2] = (n22 * n34 * n41 - n24 * n32 * n41 + n24 * n31 * n42 - n21 * n34 * n42 - n22 * n31 * n44 + n21 * n32 * n44) * detInv;
        te[3] = (n23 * n32 * n41 - n22 * n33 * n41 - n23 * n31 * n42 + n21 * n33 * n42 + n22 * n31 * n43 - n21 * n32 * n43) * detInv;
        te[4] = t12 * detInv;
        te[5] = (n13 * n34 * n41 - n14 * n33 * n41 + n14 * n31 * n43 - n11 * n34 * n43 - n13 * n31 * n44 + n11 * n33 * n44) * detInv;
        te[6] = (n14 * n32 * n41 - n12 * n34 * n41 - n14 * n31 * n42 + n11 * n34 * n42 + n12 * n31 * n44 - n11 * n32 * n44) * detInv;
        te[7] = (n12 * n33 * n41 - n13 * n32 * n41 + n13 * n31 * n42 - n11 * n33 * n42 - n12 * n31 * n43 + n11 * n32 * n43) * detInv;
        te[8] = t13 * detInv;
        te[9] = (n14 * n23 * n41 - n13 * n24 * n41 - n14 * n21 * n43 + n11 * n24 * n43 + n13 * n21 * n44 - n11 * n23 * n44) * detInv;
        te[10] = (n12 * n24 * n41 - n14 * n22 * n41 + n14 * n21 * n42 - n11 * n24 * n42 - n12 * n21 * n44 + n11 * n22 * n44) * detInv;
        te[11] = (n13 * n22 * n41 - n12 * n23 * n41 - n13 * n21 * n42 + n11 * n23 * n42 + n12 * n21 * n43 - n11 * n22 * n43) * detInv;
        te[12] = t14 * detInv;
        te[13] = (n13 * n24 * n31 - n14 * n23 * n31 + n14 * n21 * n33 - n11 * n24 * n33 - n13 * n21 * n34 + n11 * n23 * n34) * detInv;
        te[14] = (n14 * n22 * n31 - n12 * n24 * n31 - n14 * n21 * n32 + n11 * n24 * n32 + n12 * n21 * n34 - n11 * n22 * n34) * detInv;
        te[15] = (n12 * n23 * n31 - n13 * n22 * n31 + n13 * n21 * n32 - n11 * n23 * n32 - n12 * n21 * n33 + n11 * n22 * n33) * detInv;
        return this;
    }
    scale(v) {
        const te = this.elements;
        const x = v.x, y = v.y, z = v.z;
        te[0] *= x;
        te[4] *= y;
        te[8] *= z;
        te[1] *= x;
        te[5] *= y;
        te[9] *= z;
        te[2] *= x;
        te[6] *= y;
        te[10] *= z;
        te[3] *= x;
        te[7] *= y;
        te[11] *= z;
        return this;
    }
    getMaxScaleOnAxis() {
        const te = this.elements;
        const scaleXSq = te[0] * te[0] + te[1] * te[1] + te[2] * te[2];
        const scaleYSq = te[4] * te[4] + te[5] * te[5] + te[6] * te[6];
        const scaleZSq = te[8] * te[8] + te[9] * te[9] + te[10] * te[10];
        return Math.sqrt(Math.max(scaleXSq, scaleYSq, scaleZSq));
    }
    makeTranslation(x, y, z) {
        this.set(1, 0, 0, x, 0, 1, 0, y, 0, 0, 1, z, 0, 0, 0, 1);
        return this;
    }
    makeRotationX(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(1, 0, 0, 0, 0, c, -s, 0, 0, s, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationY(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, 0, s, 0, 0, 1, 0, 0, -s, 0, c, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationZ(theta) {
        const c = Math.cos(theta), s = Math.sin(theta);
        this.set(c, -s, 0, 0, s, c, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1);
        return this;
    }
    makeRotationAxis(axis, angle) {
        // Based on http://www.gamedev.net/reference/articles/article1199.asp
        const c = Math.cos(angle);
        const s = Math.sin(angle);
        const t = 1 - c;
        const x = axis.x, y = axis.y, z = axis.z;
        const tx = t * x, ty = t * y;
        this.set(tx * x + c, tx * y - s * z, tx * z + s * y, 0, tx * y + s * z, ty * y + c, ty * z - s * x, 0, tx * z - s * y, ty * z + s * x, t * z * z + c, 0, 0, 0, 0, 1);
        return this;
    }
    makeScale(x, y, z) {
        this.set(x, 0, 0, 0, 0, y, 0, 0, 0, 0, z, 0, 0, 0, 0, 1);
        return this;
    }
    makeShear(x, y, z) {
        this.set(1, y, z, 0, x, 1, z, 0, x, y, 1, 0, 0, 0, 0, 1);
        return this;
    }
    compose(position, quaternion, scale) {
        const te = this.elements;
        const x = quaternion._x, y = quaternion._y, z = quaternion._z, w = quaternion._w;
        const x2 = x + x, y2 = y + y, z2 = z + z;
        const xx = x * x2, xy = x * y2, xz = x * z2;
        const yy = y * y2, yz = y * z2, zz = z * z2;
        const wx = w * x2, wy = w * y2, wz = w * z2;
        const sx = scale.x, sy = scale.y, sz = scale.z;
        te[0] = (1 - (yy + zz)) * sx;
        te[1] = (xy + wz) * sx;
        te[2] = (xz - wy) * sx;
        te[3] = 0;
        te[4] = (xy - wz) * sy;
        te[5] = (1 - (xx + zz)) * sy;
        te[6] = (yz + wx) * sy;
        te[7] = 0;
        te[8] = (xz + wy) * sz;
        te[9] = (yz - wx) * sz;
        te[10] = (1 - (xx + yy)) * sz;
        te[11] = 0;
        te[12] = position.x;
        te[13] = position.y;
        te[14] = position.z;
        te[15] = 1;
        return this;
    }
    decompose(position, quaternion, scale) {
        const te = this.elements;
        let sx = _v1$1.set(te[0], te[1], te[2]).length();
        const sy = _v1$1.set(te[4], te[5], te[6]).length();
        const sz = _v1$1.set(te[8], te[9], te[10]).length();
        // if determine is negative, we need to invert one scale
        const det = this.determinant();
        if (det < 0) sx = -sx;
        position.x = te[12];
        position.y = te[13];
        position.z = te[14];
        // scale the rotation part
        _m1.copy(this);
        const invSX = 1 / sx;
        const invSY = 1 / sy;
        const invSZ = 1 / sz;
        _m1.elements[0] *= invSX;
        _m1.elements[1] *= invSX;
        _m1.elements[2] *= invSX;
        _m1.elements[4] *= invSY;
        _m1.elements[5] *= invSY;
        _m1.elements[6] *= invSY;
        _m1.elements[8] *= invSZ;
        _m1.elements[9] *= invSZ;
        _m1.elements[10] *= invSZ;
        quaternion.setFromRotationMatrix(_m1);
        scale.x = sx;
        scale.y = sy;
        scale.z = sz;
        return this;
    }
    makePerspective(left, right, top, bottom, near, far) {
        if (far === undefined) console.warn('THREE.Matrix4: .makePerspective() has been redefined and has a new signature. Please check the docs.');
        const te = this.elements;
        const x = 2 * near / (right - left);
        const y = 2 * near / (top - bottom);
        const a = (right + left) / (right - left);
        const b = (top + bottom) / (top - bottom);
        const c = -(far + near) / (far - near);
        const d = -2 * far * near / (far - near);
        te[0] = x;
        te[4] = 0;
        te[8] = a;
        te[12] = 0;
        te[1] = 0;
        te[5] = y;
        te[9] = b;
        te[13] = 0;
        te[2] = 0;
        te[6] = 0;
        te[10] = c;
        te[14] = d;
        te[3] = 0;
        te[7] = 0;
        te[11] = -1;
        te[15] = 0;
        return this;
    }
    makeOrthographic(left, right, top, bottom, near, far) {
        const te = this.elements;
        const w = 1.0 / (right - left);
        const h = 1.0 / (top - bottom);
        const p = 1.0 / (far - near);
        const x = (right + left) * w;
        const y = (top + bottom) * h;
        const z = (far + near) * p;
        te[0] = 2 * w;
        te[4] = 0;
        te[8] = 0;
        te[12] = -x;
        te[1] = 0;
        te[5] = 2 * h;
        te[9] = 0;
        te[13] = -y;
        te[2] = 0;
        te[6] = 0;
        te[10] = -2 * p;
        te[14] = -z;
        te[3] = 0;
        te[7] = 0;
        te[11] = 0;
        te[15] = 1;
        return this;
    }
    equals(matrix) {
        const te = this.elements;
        const me = matrix.elements;
        for(let i = 0; i < 16; i++){
            if (te[i] !== me[i]) return false;
        }
        return true;
    }
    fromArray(array, offset = 0) {
        for(let i = 0; i < 16; i++)this.elements[i] = array[i + offset];
        return this;
    }
    toArray(array = [], offset = 0) {
        const te = this.elements;
        array[offset] = te[0];
        array[offset + 1] = te[1];
        array[offset + 2] = te[2];
        array[offset + 3] = te[3];
        array[offset + 4] = te[4];
        array[offset + 5] = te[5];
        array[offset + 6] = te[6];
        array[offset + 7] = te[7];
        array[offset + 8] = te[8];
        array[offset + 9] = te[9];
        array[offset + 10] = te[10];
        array[offset + 11] = te[11];
        array[offset + 12] = te[12];
        array[offset + 13] = te[13];
        array[offset + 14] = te[14];
        array[offset + 15] = te[15];
        return array;
    }
}
const _v1$1 = /*@__PURE__*/ new Vector3();
const _m1 = /*@__PURE__*/ new Matrix4();
const _zero = /*@__PURE__*/ new Vector3(0, 0, 0);
const _one = /*@__PURE__*/ new Vector3(1, 1, 1);
const _x = /*@__PURE__*/ new Vector3();
const _y = /*@__PURE__*/ new Vector3();
const _z = /*@__PURE__*/ new Vector3();
class Euler {
    constructor(x = 0, y = 0, z = 0, order = Euler.DefaultOrder){
        Object.defineProperty(this, 'isEuler', {
            value: true
        });
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order;
    }
    get x() {
        return this._x;
    }
    set x(value) {
        this._x = value;
        this._onChangeCallback();
    }
    get y() {
        return this._y;
    }
    set y(value) {
        this._y = value;
        this._onChangeCallback();
    }
    get z() {
        return this._z;
    }
    set z(value) {
        this._z = value;
        this._onChangeCallback();
    }
    get order() {
        return this._order;
    }
    set order(value) {
        this._order = value;
        this._onChangeCallback();
    }
    set(x, y, z, order) {
        this._x = x;
        this._y = y;
        this._z = z;
        this._order = order || this._order;
        this._onChangeCallback();
        return this;
    }
    clone() {
        return new this.constructor(this._x, this._y, this._z, this._order);
    }
    copy(euler) {
        this._x = euler._x;
        this._y = euler._y;
        this._z = euler._z;
        this._order = euler._order;
        this._onChangeCallback();
        return this;
    }
    setFromRotationMatrix(m, order, update) {
        const clamp = MathUtils.clamp;
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        const te = m.elements;
        const m11 = te[0], m12 = te[4], m13 = te[8];
        const m21 = te[1], m22 = te[5], m23 = te[9];
        const m31 = te[2], m32 = te[6], m33 = te[10];
        order = order || this._order;
        switch(order){
            case 'XYZ':
                this._y = Math.asin(clamp(m13, -1, 1));
                if (Math.abs(m13) < 0.9999999) {
                    this._x = Math.atan2(-m23, m33);
                    this._z = Math.atan2(-m12, m11);
                } else {
                    this._x = Math.atan2(m32, m22);
                    this._z = 0;
                }
                break;
            case 'YXZ':
                this._x = Math.asin(-clamp(m23, -1, 1));
                if (Math.abs(m23) < 0.9999999) {
                    this._y = Math.atan2(m13, m33);
                    this._z = Math.atan2(m21, m22);
                } else {
                    this._y = Math.atan2(-m31, m11);
                    this._z = 0;
                }
                break;
            case 'ZXY':
                this._x = Math.asin(clamp(m32, -1, 1));
                if (Math.abs(m32) < 0.9999999) {
                    this._y = Math.atan2(-m31, m33);
                    this._z = Math.atan2(-m12, m22);
                } else {
                    this._y = 0;
                    this._z = Math.atan2(m21, m11);
                }
                break;
            case 'ZYX':
                this._y = Math.asin(-clamp(m31, -1, 1));
                if (Math.abs(m31) < 0.9999999) {
                    this._x = Math.atan2(m32, m33);
                    this._z = Math.atan2(m21, m11);
                } else {
                    this._x = 0;
                    this._z = Math.atan2(-m12, m22);
                }
                break;
            case 'YZX':
                this._z = Math.asin(clamp(m21, -1, 1));
                if (Math.abs(m21) < 0.9999999) {
                    this._x = Math.atan2(-m23, m22);
                    this._y = Math.atan2(-m31, m11);
                } else {
                    this._x = 0;
                    this._y = Math.atan2(m13, m33);
                }
                break;
            case 'XZY':
                this._z = Math.asin(-clamp(m12, -1, 1));
                if (Math.abs(m12) < 0.9999999) {
                    this._x = Math.atan2(m32, m22);
                    this._y = Math.atan2(m13, m11);
                } else {
                    this._x = Math.atan2(-m23, m33);
                    this._y = 0;
                }
                break;
            default:
                console.warn('THREE.Euler: .setFromRotationMatrix() encountered an unknown order: ' + order);
        }
        this._order = order;
        if (update !== false) this._onChangeCallback();
        return this;
    }
    setFromQuaternion(q, order, update) {
        _matrix.makeRotationFromQuaternion(q);
        return this.setFromRotationMatrix(_matrix, order, update);
    }
    setFromVector3(v, order) {
        return this.set(v.x, v.y, v.z, order || this._order);
    }
    reorder(newOrder) {
        // WARNING: this discards revolution information -bhouston
        _quaternion$1.setFromEuler(this);
        return this.setFromQuaternion(_quaternion$1, newOrder);
    }
    equals(euler) {
        return euler._x === this._x && euler._y === this._y && euler._z === this._z && euler._order === this._order;
    }
    fromArray(array) {
        this._x = array[0];
        this._y = array[1];
        this._z = array[2];
        if (array[3] !== undefined) this._order = array[3];
        this._onChangeCallback();
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this._x;
        array[offset + 1] = this._y;
        array[offset + 2] = this._z;
        array[offset + 3] = this._order;
        return array;
    }
    toVector3(optionalResult) {
        if (optionalResult) return optionalResult.set(this._x, this._y, this._z);
        else return new Vector3(this._x, this._y, this._z);
    }
    _onChange(callback) {
        this._onChangeCallback = callback;
        return this;
    }
    _onChangeCallback() {}
}
Euler.DefaultOrder = 'XYZ';
Euler.RotationOrders = [
    'XYZ',
    'YZX',
    'ZXY',
    'XZY',
    'YXZ',
    'ZYX'
];
const _matrix = /*@__PURE__*/ new Matrix4();
const _quaternion$1 = /*@__PURE__*/ new Quaternion();
class Layers {
    constructor(){
        this.mask = 1;
    }
    set(channel) {
        this.mask = 1 << channel | 0;
    }
    enable(channel) {
        this.mask |= 1 << channel | 0;
    }
    enableAll() {
        this.mask = -1;
    }
    toggle(channel) {
        this.mask ^= 1 << channel | 0;
    }
    disable(channel) {
        this.mask &= ~(1 << channel | 0);
    }
    disableAll() {
        this.mask = 0;
    }
    test(layers) {
        return (this.mask & layers.mask) !== 0;
    }
}
let _object3DId = 0;
const _v1$2 = new Vector3();
const _q1 = new Quaternion();
const _m1$1 = new Matrix4();
const _target = new Vector3();
const _position = new Vector3();
const _scale = new Vector3();
const _quaternion$2 = new Quaternion();
const _xAxis = new Vector3(1, 0, 0);
const _yAxis = new Vector3(0, 1, 0);
const _zAxis = new Vector3(0, 0, 1);
const _addedEvent = {
    type: 'added'
};
const _removedEvent = {
    type: 'removed'
};
function Object3D() {
    Object.defineProperty(this, 'id', {
        value: _object3DId++
    });
    this.uuid = MathUtils.generateUUID();
    this.name = '';
    this.type = 'Object3D';
    this.parent = null;
    this.children = [];
    this.up = Object3D.DefaultUp.clone();
    const position = new Vector3();
    const rotation = new Euler();
    const quaternion = new Quaternion();
    const scale = new Vector3(1, 1, 1);
    function onRotationChange() {
        quaternion.setFromEuler(rotation, false);
    }
    function onQuaternionChange() {
        rotation.setFromQuaternion(quaternion, undefined, false);
    }
    rotation._onChange(onRotationChange);
    quaternion._onChange(onQuaternionChange);
    Object.defineProperties(this, {
        position: {
            configurable: true,
            enumerable: true,
            value: position
        },
        rotation: {
            configurable: true,
            enumerable: true,
            value: rotation
        },
        quaternion: {
            configurable: true,
            enumerable: true,
            value: quaternion
        },
        scale: {
            configurable: true,
            enumerable: true,
            value: scale
        },
        modelViewMatrix: {
            value: new Matrix4()
        },
        normalMatrix: {
            value: new Matrix3()
        }
    });
    this.matrix = new Matrix4();
    this.matrixWorld = new Matrix4();
    this.matrixAutoUpdate = Object3D.DefaultMatrixAutoUpdate;
    this.matrixWorldNeedsUpdate = false;
    this.layers = new Layers();
    this.visible = true;
    this.castShadow = false;
    this.receiveShadow = false;
    this.frustumCulled = true;
    this.renderOrder = 0;
    this.animations = [];
    this.userData = {};
}
Object3D.DefaultUp = new Vector3(0, 1, 0);
Object3D.DefaultMatrixAutoUpdate = true;
Object3D.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: Object3D,
    isObject3D: true,
    onBeforeRender: function() {},
    onAfterRender: function() {},
    applyMatrix4: function(matrix) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        this.matrix.premultiply(matrix);
        this.matrix.decompose(this.position, this.quaternion, this.scale);
    },
    applyQuaternion: function(q) {
        this.quaternion.premultiply(q);
        return this;
    },
    setRotationFromAxisAngle: function(axis, angle) {
        // assumes axis is normalized
        this.quaternion.setFromAxisAngle(axis, angle);
    },
    setRotationFromEuler: function(euler) {
        this.quaternion.setFromEuler(euler, true);
    },
    setRotationFromMatrix: function(m) {
        // assumes the upper 3x3 of m is a pure rotation matrix (i.e, unscaled)
        this.quaternion.setFromRotationMatrix(m);
    },
    setRotationFromQuaternion: function(q) {
        // assumes q is normalized
        this.quaternion.copy(q);
    },
    rotateOnAxis: function(axis, angle) {
        // rotate object on axis in object space
        // axis is assumed to be normalized
        _q1.setFromAxisAngle(axis, angle);
        this.quaternion.multiply(_q1);
        return this;
    },
    rotateOnWorldAxis: function(axis, angle) {
        // rotate object on axis in world space
        // axis is assumed to be normalized
        // method assumes no rotated parent
        _q1.setFromAxisAngle(axis, angle);
        this.quaternion.premultiply(_q1);
        return this;
    },
    rotateX: function(angle) {
        return this.rotateOnAxis(_xAxis, angle);
    },
    rotateY: function(angle) {
        return this.rotateOnAxis(_yAxis, angle);
    },
    rotateZ: function(angle) {
        return this.rotateOnAxis(_zAxis, angle);
    },
    translateOnAxis: function(axis, distance) {
        // translate object by distance along axis in object space
        // axis is assumed to be normalized
        _v1$2.copy(axis).applyQuaternion(this.quaternion);
        this.position.add(_v1$2.multiplyScalar(distance));
        return this;
    },
    translateX: function(distance) {
        return this.translateOnAxis(_xAxis, distance);
    },
    translateY: function(distance) {
        return this.translateOnAxis(_yAxis, distance);
    },
    translateZ: function(distance) {
        return this.translateOnAxis(_zAxis, distance);
    },
    localToWorld: function(vector) {
        return vector.applyMatrix4(this.matrixWorld);
    },
    worldToLocal: function(vector) {
        return vector.applyMatrix4(_m1$1.copy(this.matrixWorld).invert());
    },
    lookAt: function(x, y, z) {
        // This method does not support objects having non-uniformly-scaled parent(s)
        if (x.isVector3) _target.copy(x);
        else _target.set(x, y, z);
        const parent = this.parent;
        this.updateWorldMatrix(true, false);
        _position.setFromMatrixPosition(this.matrixWorld);
        if (this.isCamera || this.isLight) _m1$1.lookAt(_position, _target, this.up);
        else _m1$1.lookAt(_target, _position, this.up);
        this.quaternion.setFromRotationMatrix(_m1$1);
        if (parent) {
            _m1$1.extractRotation(parent.matrixWorld);
            _q1.setFromRotationMatrix(_m1$1);
            this.quaternion.premultiply(_q1.invert());
        }
    },
    add: function(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.add(arguments[i]);
            return this;
        }
        if (object === this) {
            console.error('THREE.Object3D.add: object can\'t be added as a child of itself.', object);
            return this;
        }
        if (object && object.isObject3D) {
            if (object.parent !== null) object.parent.remove(object);
            object.parent = this;
            this.children.push(object);
            object.dispatchEvent(_addedEvent);
        } else console.error('THREE.Object3D.add: object not an instance of THREE.Object3D.', object);
        return this;
    },
    remove: function(object) {
        if (arguments.length > 1) {
            for(let i = 0; i < arguments.length; i++)this.remove(arguments[i]);
            return this;
        }
        const index = this.children.indexOf(object);
        if (index !== -1) {
            object.parent = null;
            this.children.splice(index, 1);
            object.dispatchEvent(_removedEvent);
        }
        return this;
    },
    clear: function() {
        for(let i = 0; i < this.children.length; i++){
            const object = this.children[i];
            object.parent = null;
            object.dispatchEvent(_removedEvent);
        }
        this.children.length = 0;
        return this;
    },
    attach: function(object) {
        // adds object as a child of this, while maintaining the object's world transform
        this.updateWorldMatrix(true, false);
        _m1$1.copy(this.matrixWorld).invert();
        if (object.parent !== null) {
            object.parent.updateWorldMatrix(true, false);
            _m1$1.multiply(object.parent.matrixWorld);
        }
        object.applyMatrix4(_m1$1);
        object.updateWorldMatrix(false, false);
        this.add(object);
        return this;
    },
    getObjectById: function(id) {
        return this.getObjectByProperty('id', id);
    },
    getObjectByName: function(name) {
        return this.getObjectByProperty('name', name);
    },
    getObjectByProperty: function(name, value) {
        if (this[name] === value) return this;
        for(let i = 0, l = this.children.length; i < l; i++){
            const child = this.children[i];
            const object = child.getObjectByProperty(name, value);
            if (object !== undefined) return object;
        }
        return undefined;
    },
    getWorldPosition: function(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldPosition() target is now required');
            target = new Vector3();
        }
        this.updateWorldMatrix(true, false);
        return target.setFromMatrixPosition(this.matrixWorld);
    },
    getWorldQuaternion: function(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldQuaternion() target is now required');
            target = new Quaternion();
        }
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose(_position, target, _scale);
        return target;
    },
    getWorldScale: function(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldScale() target is now required');
            target = new Vector3();
        }
        this.updateWorldMatrix(true, false);
        this.matrixWorld.decompose(_position, _quaternion$2, target);
        return target;
    },
    getWorldDirection: function(target) {
        if (target === undefined) {
            console.warn('THREE.Object3D: .getWorldDirection() target is now required');
            target = new Vector3();
        }
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(e[8], e[9], e[10]).normalize();
    },
    raycast: function() {},
    traverse: function(callback) {
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverse(callback);
    },
    traverseVisible: function(callback) {
        if (this.visible === false) return;
        callback(this);
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].traverseVisible(callback);
    },
    traverseAncestors: function(callback) {
        const parent = this.parent;
        if (parent !== null) {
            callback(parent);
            parent.traverseAncestors(callback);
        }
    },
    updateMatrix: function() {
        this.matrix.compose(this.position, this.quaternion, this.scale);
        this.matrixWorldNeedsUpdate = true;
    },
    updateMatrixWorld: function(force) {
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.matrixWorldNeedsUpdate || force) {
            if (this.parent === null) this.matrixWorld.copy(this.matrix);
            else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
            this.matrixWorldNeedsUpdate = false;
            force = true;
        }
        // update children
        const children = this.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(force);
    },
    updateWorldMatrix: function(updateParents, updateChildren) {
        const parent = this.parent;
        if (updateParents === true && parent !== null) parent.updateWorldMatrix(true, false);
        if (this.matrixAutoUpdate) this.updateMatrix();
        if (this.parent === null) this.matrixWorld.copy(this.matrix);
        else this.matrixWorld.multiplyMatrices(this.parent.matrixWorld, this.matrix);
        // update children
        if (updateChildren === true) {
            const children = this.children;
            for(let i = 0, l = children.length; i < l; i++)children[i].updateWorldMatrix(false, true);
        }
    },
    toJSON: function(meta) {
        // meta is a string when called from JSON.stringify
        const isRootObject = meta === undefined || typeof meta === 'string';
        const output = {};
        // meta is a hash used to collect geometries, materials.
        // not providing it implies that this is the root object
        // being serialized.
        if (isRootObject) {
            // initialize meta obj
            meta = {
                geometries: {},
                materials: {},
                textures: {},
                images: {},
                shapes: {},
                skeletons: {},
                animations: {}
            };
            output.metadata = {
                version: 4.5,
                type: 'Object',
                generator: 'Object3D.toJSON'
            };
        }
        // standard Object3D serialization
        const object = {};
        object.uuid = this.uuid;
        object.type = this.type;
        if (this.name !== '') object.name = this.name;
        if (this.castShadow === true) object.castShadow = true;
        if (this.receiveShadow === true) object.receiveShadow = true;
        if (this.visible === false) object.visible = false;
        if (this.frustumCulled === false) object.frustumCulled = false;
        if (this.renderOrder !== 0) object.renderOrder = this.renderOrder;
        if (JSON.stringify(this.userData) !== '{}') object.userData = this.userData;
        object.layers = this.layers.mask;
        object.matrix = this.matrix.toArray();
        if (this.matrixAutoUpdate === false) object.matrixAutoUpdate = false;
        // object specific properties
        if (this.isInstancedMesh) {
            object.type = 'InstancedMesh';
            object.count = this.count;
            object.instanceMatrix = this.instanceMatrix.toJSON();
        }
        //
        function serialize(library, element) {
            if (library[element.uuid] === undefined) library[element.uuid] = element.toJSON(meta);
            return element.uuid;
        }
        if (this.isMesh || this.isLine || this.isPoints) {
            object.geometry = serialize(meta.geometries, this.geometry);
            const parameters = this.geometry.parameters;
            if (parameters !== undefined && parameters.shapes !== undefined) {
                const shapes = parameters.shapes;
                if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
                    const shape = shapes[i];
                    serialize(meta.shapes, shape);
                }
                else serialize(meta.shapes, shapes);
            }
        }
        if (this.isSkinnedMesh) {
            object.bindMode = this.bindMode;
            object.bindMatrix = this.bindMatrix.toArray();
            if (this.skeleton !== undefined) {
                serialize(meta.skeletons, this.skeleton);
                object.skeleton = this.skeleton.uuid;
            }
        }
        if (this.material !== undefined) {
            if (Array.isArray(this.material)) {
                const uuids = [];
                for(let i = 0, l = this.material.length; i < l; i++)uuids.push(serialize(meta.materials, this.material[i]));
                object.material = uuids;
            } else object.material = serialize(meta.materials, this.material);
        }
        //
        if (this.children.length > 0) {
            object.children = [];
            for(let i = 0; i < this.children.length; i++)object.children.push(this.children[i].toJSON(meta).object);
        }
        //
        if (this.animations.length > 0) {
            object.animations = [];
            for(let i = 0; i < this.animations.length; i++){
                const animation = this.animations[i];
                object.animations.push(serialize(meta.animations, animation));
            }
        }
        if (isRootObject) {
            const geometries = extractFromCache(meta.geometries);
            const materials = extractFromCache(meta.materials);
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            const shapes = extractFromCache(meta.shapes);
            const skeletons = extractFromCache(meta.skeletons);
            const animations = extractFromCache(meta.animations);
            if (geometries.length > 0) output.geometries = geometries;
            if (materials.length > 0) output.materials = materials;
            if (textures.length > 0) output.textures = textures;
            if (images.length > 0) output.images = images;
            if (shapes.length > 0) output.shapes = shapes;
            if (skeletons.length > 0) output.skeletons = skeletons;
            if (animations.length > 0) output.animations = animations;
        }
        output.object = object;
        return output;
        // extract data from the cache hash
        // remove metadata on each item
        // and return as array
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
    },
    clone: function(recursive) {
        return new this.constructor().copy(this, recursive);
    },
    copy: function(source, recursive = true) {
        this.name = source.name;
        this.up.copy(source.up);
        this.position.copy(source.position);
        this.rotation.order = source.rotation.order;
        this.quaternion.copy(source.quaternion);
        this.scale.copy(source.scale);
        this.matrix.copy(source.matrix);
        this.matrixWorld.copy(source.matrixWorld);
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        this.matrixWorldNeedsUpdate = source.matrixWorldNeedsUpdate;
        this.layers.mask = source.layers.mask;
        this.visible = source.visible;
        this.castShadow = source.castShadow;
        this.receiveShadow = source.receiveShadow;
        this.frustumCulled = source.frustumCulled;
        this.renderOrder = source.renderOrder;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        if (recursive === true) for(let i = 0; i < source.children.length; i++){
            const child = source.children[i];
            this.add(child.clone());
        }
        return this;
    }
});
const _vector1 = /*@__PURE__*/ new Vector3();
const _vector2 = /*@__PURE__*/ new Vector3();
const _normalMatrix = /*@__PURE__*/ new Matrix3();
class Plane {
    constructor(normal, constant){
        Object.defineProperty(this, 'isPlane', {
            value: true
        });
        // normal is assumed to be normalized
        this.normal = normal !== undefined ? normal : new Vector3(1, 0, 0);
        this.constant = constant !== undefined ? constant : 0;
    }
    set(normal, constant) {
        this.normal.copy(normal);
        this.constant = constant;
        return this;
    }
    setComponents(x, y, z, w) {
        this.normal.set(x, y, z);
        this.constant = w;
        return this;
    }
    setFromNormalAndCoplanarPoint(normal, point) {
        this.normal.copy(normal);
        this.constant = -point.dot(this.normal);
        return this;
    }
    setFromCoplanarPoints(a, b, c) {
        const normal = _vector1.subVectors(c, b).cross(_vector2.subVectors(a, b)).normalize();
        // Q: should an error be thrown if normal is zero (e.g. degenerate plane)?
        this.setFromNormalAndCoplanarPoint(normal, a);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(plane) {
        this.normal.copy(plane.normal);
        this.constant = plane.constant;
        return this;
    }
    normalize() {
        // Note: will lead to a divide by zero if the plane is invalid.
        const inverseNormalLength = 1.0 / this.normal.length();
        this.normal.multiplyScalar(inverseNormalLength);
        this.constant *= inverseNormalLength;
        return this;
    }
    negate() {
        this.constant *= -1;
        this.normal.negate();
        return this;
    }
    distanceToPoint(point) {
        return this.normal.dot(point) + this.constant;
    }
    distanceToSphere(sphere) {
        return this.distanceToPoint(sphere.center) - sphere.radius;
    }
    projectPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Plane: .projectPoint() target is now required');
            target = new Vector3();
        }
        return target.copy(this.normal).multiplyScalar(-this.distanceToPoint(point)).add(point);
    }
    intersectLine(line, target) {
        if (target === undefined) {
            console.warn('THREE.Plane: .intersectLine() target is now required');
            target = new Vector3();
        }
        const direction = line.delta(_vector1);
        const denominator = this.normal.dot(direction);
        if (denominator === 0) {
            // line is coplanar, return origin
            if (this.distanceToPoint(line.start) === 0) return target.copy(line.start);
            // Unsure if this is the correct method to handle this case.
            return undefined;
        }
        const t = -(line.start.dot(this.normal) + this.constant) / denominator;
        if (t < 0 || t > 1) return undefined;
        return target.copy(direction).multiplyScalar(t).add(line.start);
    }
    intersectsLine(line) {
        // Note: this tests if a line intersects the plane, not whether it (or its end-points) are coplanar with it.
        const startSign = this.distanceToPoint(line.start);
        const endSign = this.distanceToPoint(line.end);
        return startSign < 0 && endSign > 0 || endSign < 0 && startSign > 0;
    }
    intersectsBox(box) {
        return box.intersectsPlane(this);
    }
    intersectsSphere(sphere) {
        return sphere.intersectsPlane(this);
    }
    coplanarPoint(target) {
        if (target === undefined) {
            console.warn('THREE.Plane: .coplanarPoint() target is now required');
            target = new Vector3();
        }
        return target.copy(this.normal).multiplyScalar(-this.constant);
    }
    applyMatrix4(matrix, optionalNormalMatrix) {
        const normalMatrix = optionalNormalMatrix || _normalMatrix.getNormalMatrix(matrix);
        const referencePoint = this.coplanarPoint(_vector1).applyMatrix4(matrix);
        const normal = this.normal.applyMatrix3(normalMatrix).normalize();
        this.constant = -referencePoint.dot(normal);
        return this;
    }
    translate(offset) {
        this.constant -= offset.dot(this.normal);
        return this;
    }
    equals(plane) {
        return plane.normal.equals(this.normal) && plane.constant === this.constant;
    }
}
const _v0$1 = /*@__PURE__*/ new Vector3();
const _v1$3 = /*@__PURE__*/ new Vector3();
const _v2$1 = /*@__PURE__*/ new Vector3();
const _v3 = /*@__PURE__*/ new Vector3();
const _vab = /*@__PURE__*/ new Vector3();
const _vac = /*@__PURE__*/ new Vector3();
const _vbc = /*@__PURE__*/ new Vector3();
const _vap = /*@__PURE__*/ new Vector3();
const _vbp = /*@__PURE__*/ new Vector3();
const _vcp = /*@__PURE__*/ new Vector3();
class Triangle {
    constructor(a, b, c){
        this.a = a !== undefined ? a : new Vector3();
        this.b = b !== undefined ? b : new Vector3();
        this.c = c !== undefined ? c : new Vector3();
    }
    static getNormal(a, b, c, target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .getNormal() target is now required');
            target = new Vector3();
        }
        target.subVectors(c, b);
        _v0$1.subVectors(a, b);
        target.cross(_v0$1);
        const targetLengthSq = target.lengthSq();
        if (targetLengthSq > 0) return target.multiplyScalar(1 / Math.sqrt(targetLengthSq));
        return target.set(0, 0, 0);
    }
    // static/instance method to calculate barycentric coordinates
    // based on: http://www.blackpawn.com/texts/pointinpoly/default.html
    static getBarycoord(point, a, b, c, target) {
        _v0$1.subVectors(c, a);
        _v1$3.subVectors(b, a);
        _v2$1.subVectors(point, a);
        const dot00 = _v0$1.dot(_v0$1);
        const dot01 = _v0$1.dot(_v1$3);
        const dot02 = _v0$1.dot(_v2$1);
        const dot11 = _v1$3.dot(_v1$3);
        const dot12 = _v1$3.dot(_v2$1);
        const denom = dot00 * dot11 - dot01 * dot01;
        if (target === undefined) {
            console.warn('THREE.Triangle: .getBarycoord() target is now required');
            target = new Vector3();
        }
        // collinear or singular triangle
        if (denom === 0) // arbitrary location outside of triangle?
        // not sure if this is the best idea, maybe should be returning undefined
        return target.set(-2, -1, -1);
        const invDenom = 1 / denom;
        const u = (dot11 * dot02 - dot01 * dot12) * invDenom;
        const v = (dot00 * dot12 - dot01 * dot02) * invDenom;
        // barycentric coordinates must always sum to 1
        return target.set(1 - u - v, v, u);
    }
    static containsPoint(point, a, b, c) {
        this.getBarycoord(point, a, b, c, _v3);
        return _v3.x >= 0 && _v3.y >= 0 && _v3.x + _v3.y <= 1;
    }
    static getUV(point, p1, p2, p3, uv1, uv2, uv3, target) {
        this.getBarycoord(point, p1, p2, p3, _v3);
        target.set(0, 0);
        target.addScaledVector(uv1, _v3.x);
        target.addScaledVector(uv2, _v3.y);
        target.addScaledVector(uv3, _v3.z);
        return target;
    }
    static isFrontFacing(a, b, c, direction) {
        _v0$1.subVectors(c, b);
        _v1$3.subVectors(a, b);
        // strictly front facing
        return _v0$1.cross(_v1$3).dot(direction) < 0 ? true : false;
    }
    set(a, b, c) {
        this.a.copy(a);
        this.b.copy(b);
        this.c.copy(c);
        return this;
    }
    setFromPointsAndIndices(points, i0, i1, i2) {
        this.a.copy(points[i0]);
        this.b.copy(points[i1]);
        this.c.copy(points[i2]);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(triangle) {
        this.a.copy(triangle.a);
        this.b.copy(triangle.b);
        this.c.copy(triangle.c);
        return this;
    }
    getArea() {
        _v0$1.subVectors(this.c, this.b);
        _v1$3.subVectors(this.a, this.b);
        return _v0$1.cross(_v1$3).length() * 0.5;
    }
    getMidpoint(target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .getMidpoint() target is now required');
            target = new Vector3();
        }
        return target.addVectors(this.a, this.b).add(this.c).multiplyScalar(1 / 3);
    }
    getNormal(target) {
        return Triangle.getNormal(this.a, this.b, this.c, target);
    }
    getPlane(target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .getPlane() target is now required');
            target = new Plane();
        }
        return target.setFromCoplanarPoints(this.a, this.b, this.c);
    }
    getBarycoord(point, target) {
        return Triangle.getBarycoord(point, this.a, this.b, this.c, target);
    }
    getUV(point, uv1, uv2, uv3, target) {
        return Triangle.getUV(point, this.a, this.b, this.c, uv1, uv2, uv3, target);
    }
    containsPoint(point) {
        return Triangle.containsPoint(point, this.a, this.b, this.c);
    }
    isFrontFacing(direction) {
        return Triangle.isFrontFacing(this.a, this.b, this.c, direction);
    }
    intersectsBox(box) {
        return box.intersectsTriangle(this);
    }
    closestPointToPoint(p, target) {
        if (target === undefined) {
            console.warn('THREE.Triangle: .closestPointToPoint() target is now required');
            target = new Vector3();
        }
        const a = this.a, b = this.b, c = this.c;
        let v, w;
        // algorithm thanks to Real-Time Collision Detection by Christer Ericson,
        // published by Morgan Kaufmann Publishers, (c) 2005 Elsevier Inc.,
        // under the accompanying license; see chapter 5.1.5 for detailed explanation.
        // basically, we're distinguishing which of the voronoi regions of the triangle
        // the point lies in with the minimum amount of redundant computation.
        _vab.subVectors(b, a);
        _vac.subVectors(c, a);
        _vap.subVectors(p, a);
        const d1 = _vab.dot(_vap);
        const d2 = _vac.dot(_vap);
        if (d1 <= 0 && d2 <= 0) // vertex region of A; barycentric coords (1, 0, 0)
        return target.copy(a);
        _vbp.subVectors(p, b);
        const d3 = _vab.dot(_vbp);
        const d4 = _vac.dot(_vbp);
        if (d3 >= 0 && d4 <= d3) // vertex region of B; barycentric coords (0, 1, 0)
        return target.copy(b);
        const vc = d1 * d4 - d3 * d2;
        if (vc <= 0 && d1 >= 0 && d3 <= 0) {
            v = d1 / (d1 - d3);
            // edge region of AB; barycentric coords (1-v, v, 0)
            return target.copy(a).addScaledVector(_vab, v);
        }
        _vcp.subVectors(p, c);
        const d5 = _vab.dot(_vcp);
        const d6 = _vac.dot(_vcp);
        if (d6 >= 0 && d5 <= d6) // vertex region of C; barycentric coords (0, 0, 1)
        return target.copy(c);
        const vb = d5 * d2 - d1 * d6;
        if (vb <= 0 && d2 >= 0 && d6 <= 0) {
            w = d2 / (d2 - d6);
            // edge region of AC; barycentric coords (1-w, 0, w)
            return target.copy(a).addScaledVector(_vac, w);
        }
        const va = d3 * d6 - d5 * d4;
        if (va <= 0 && d4 - d3 >= 0 && d5 - d6 >= 0) {
            _vbc.subVectors(c, b);
            w = (d4 - d3) / (d4 - d3 + (d5 - d6));
            // edge region of BC; barycentric coords (0, 1-w, w)
            return target.copy(b).addScaledVector(_vbc, w); // edge region of BC
        }
        // face region
        const denom = 1 / (va + vb + vc);
        // u = va * denom
        v = vb * denom;
        w = vc * denom;
        return target.copy(a).addScaledVector(_vab, v).addScaledVector(_vac, w);
    }
    equals(triangle) {
        return triangle.a.equals(this.a) && triangle.b.equals(this.b) && triangle.c.equals(this.c);
    }
}
const _colorKeywords = {
    'aliceblue': 0xF0F8FF,
    'antiquewhite': 0xFAEBD7,
    'aqua': 0x00FFFF,
    'aquamarine': 0x7FFFD4,
    'azure': 0xF0FFFF,
    'beige': 0xF5F5DC,
    'bisque': 0xFFE4C4,
    'black': 0x000000,
    'blanchedalmond': 0xFFEBCD,
    'blue': 0x0000FF,
    'blueviolet': 0x8A2BE2,
    'brown': 0xA52A2A,
    'burlywood': 0xDEB887,
    'cadetblue': 0x5F9EA0,
    'chartreuse': 0x7FFF00,
    'chocolate': 0xD2691E,
    'coral': 0xFF7F50,
    'cornflowerblue': 0x6495ED,
    'cornsilk': 0xFFF8DC,
    'crimson': 0xDC143C,
    'cyan': 0x00FFFF,
    'darkblue': 0x00008B,
    'darkcyan': 0x008B8B,
    'darkgoldenrod': 0xB8860B,
    'darkgray': 0xA9A9A9,
    'darkgreen': 0x006400,
    'darkgrey': 0xA9A9A9,
    'darkkhaki': 0xBDB76B,
    'darkmagenta': 0x8B008B,
    'darkolivegreen': 0x556B2F,
    'darkorange': 0xFF8C00,
    'darkorchid': 0x9932CC,
    'darkred': 0x8B0000,
    'darksalmon': 0xE9967A,
    'darkseagreen': 0x8FBC8F,
    'darkslateblue': 0x483D8B,
    'darkslategray': 0x2F4F4F,
    'darkslategrey': 0x2F4F4F,
    'darkturquoise': 0x00CED1,
    'darkviolet': 0x9400D3,
    'deeppink': 0xFF1493,
    'deepskyblue': 0x00BFFF,
    'dimgray': 0x696969,
    'dimgrey': 0x696969,
    'dodgerblue': 0x1E90FF,
    'firebrick': 0xB22222,
    'floralwhite': 0xFFFAF0,
    'forestgreen': 0x228B22,
    'fuchsia': 0xFF00FF,
    'gainsboro': 0xDCDCDC,
    'ghostwhite': 0xF8F8FF,
    'gold': 0xFFD700,
    'goldenrod': 0xDAA520,
    'gray': 0x808080,
    'green': 0x008000,
    'greenyellow': 0xADFF2F,
    'grey': 0x808080,
    'honeydew': 0xF0FFF0,
    'hotpink': 0xFF69B4,
    'indianred': 0xCD5C5C,
    'indigo': 0x4B0082,
    'ivory': 0xFFFFF0,
    'khaki': 0xF0E68C,
    'lavender': 0xE6E6FA,
    'lavenderblush': 0xFFF0F5,
    'lawngreen': 0x7CFC00,
    'lemonchiffon': 0xFFFACD,
    'lightblue': 0xADD8E6,
    'lightcoral': 0xF08080,
    'lightcyan': 0xE0FFFF,
    'lightgoldenrodyellow': 0xFAFAD2,
    'lightgray': 0xD3D3D3,
    'lightgreen': 0x90EE90,
    'lightgrey': 0xD3D3D3,
    'lightpink': 0xFFB6C1,
    'lightsalmon': 0xFFA07A,
    'lightseagreen': 0x20B2AA,
    'lightskyblue': 0x87CEFA,
    'lightslategray': 0x778899,
    'lightslategrey': 0x778899,
    'lightsteelblue': 0xB0C4DE,
    'lightyellow': 0xFFFFE0,
    'lime': 0x00FF00,
    'limegreen': 0x32CD32,
    'linen': 0xFAF0E6,
    'magenta': 0xFF00FF,
    'maroon': 0x800000,
    'mediumaquamarine': 0x66CDAA,
    'mediumblue': 0x0000CD,
    'mediumorchid': 0xBA55D3,
    'mediumpurple': 0x9370DB,
    'mediumseagreen': 0x3CB371,
    'mediumslateblue': 0x7B68EE,
    'mediumspringgreen': 0x00FA9A,
    'mediumturquoise': 0x48D1CC,
    'mediumvioletred': 0xC71585,
    'midnightblue': 0x191970,
    'mintcream': 0xF5FFFA,
    'mistyrose': 0xFFE4E1,
    'moccasin': 0xFFE4B5,
    'navajowhite': 0xFFDEAD,
    'navy': 0x000080,
    'oldlace': 0xFDF5E6,
    'olive': 0x808000,
    'olivedrab': 0x6B8E23,
    'orange': 0xFFA500,
    'orangered': 0xFF4500,
    'orchid': 0xDA70D6,
    'palegoldenrod': 0xEEE8AA,
    'palegreen': 0x98FB98,
    'paleturquoise': 0xAFEEEE,
    'palevioletred': 0xDB7093,
    'papayawhip': 0xFFEFD5,
    'peachpuff': 0xFFDAB9,
    'peru': 0xCD853F,
    'pink': 0xFFC0CB,
    'plum': 0xDDA0DD,
    'powderblue': 0xB0E0E6,
    'purple': 0x800080,
    'rebeccapurple': 0x663399,
    'red': 0xFF0000,
    'rosybrown': 0xBC8F8F,
    'royalblue': 0x4169E1,
    'saddlebrown': 0x8B4513,
    'salmon': 0xFA8072,
    'sandybrown': 0xF4A460,
    'seagreen': 0x2E8B57,
    'seashell': 0xFFF5EE,
    'sienna': 0xA0522D,
    'silver': 0xC0C0C0,
    'skyblue': 0x87CEEB,
    'slateblue': 0x6A5ACD,
    'slategray': 0x708090,
    'slategrey': 0x708090,
    'snow': 0xFFFAFA,
    'springgreen': 0x00FF7F,
    'steelblue': 0x4682B4,
    'tan': 0xD2B48C,
    'teal': 0x008080,
    'thistle': 0xD8BFD8,
    'tomato': 0xFF6347,
    'turquoise': 0x40E0D0,
    'violet': 0xEE82EE,
    'wheat': 0xF5DEB3,
    'white': 0xFFFFFF,
    'whitesmoke': 0xF5F5F5,
    'yellow': 0xFFFF00,
    'yellowgreen': 0x9ACD32
};
const _hslA = {
    h: 0,
    s: 0,
    l: 0
};
const _hslB = {
    h: 0,
    s: 0,
    l: 0
};
function hue2rgb(p, q, t) {
    if (t < 0) t += 1;
    if (t > 1) t -= 1;
    if (t < 1 / 6) return p + (q - p) * 6 * t;
    if (t < 0.5) return q;
    if (t < 2 / 3) return p + (q - p) * 6 * (2 / 3 - t);
    return p;
}
function SRGBToLinear(c) {
    return c < 0.04045 ? c * 0.0773993808 : Math.pow(c * 0.9478672986 + 0.0521327014, 2.4);
}
function LinearToSRGB(c) {
    return c < 0.0031308 ? c * 12.92 : 1.055 * Math.pow(c, 0.41666) - 0.055;
}
class Color {
    constructor(r, g, b){
        Object.defineProperty(this, 'isColor', {
            value: true
        });
        if (g === undefined && b === undefined) // r is THREE.Color, hex or string
        return this.set(r);
        return this.setRGB(r, g, b);
    }
    set(value) {
        if (value && value.isColor) this.copy(value);
        else if (typeof value === 'number') this.setHex(value);
        else if (typeof value === 'string') this.setStyle(value);
        return this;
    }
    setScalar(scalar) {
        this.r = scalar;
        this.g = scalar;
        this.b = scalar;
        return this;
    }
    setHex(hex) {
        hex = Math.floor(hex);
        this.r = (hex >> 16 & 255) / 255;
        this.g = (hex >> 8 & 255) / 255;
        this.b = (hex & 255) / 255;
        return this;
    }
    setRGB(r, g, b) {
        this.r = r;
        this.g = g;
        this.b = b;
        return this;
    }
    setHSL(h, s, l) {
        // h,s,l ranges are in 0.0 - 1.0
        h = MathUtils.euclideanModulo(h, 1);
        s = MathUtils.clamp(s, 0, 1);
        l = MathUtils.clamp(l, 0, 1);
        if (s === 0) this.r = this.g = this.b = l;
        else {
            const p = l <= 0.5 ? l * (1 + s) : l + s - l * s;
            const q = 2 * l - p;
            this.r = hue2rgb(q, p, h + 1 / 3);
            this.g = hue2rgb(q, p, h);
            this.b = hue2rgb(q, p, h - 1 / 3);
        }
        return this;
    }
    setStyle(style) {
        function handleAlpha(string) {
            if (string === undefined) return;
            if (parseFloat(string) < 1) console.warn('THREE.Color: Alpha component of ' + style + ' will be ignored.');
        }
        let m;
        if (m = /^((?:rgb|hsl)a?)\(([^\)]*)\)/.exec(style)) {
            // rgb / hsl
            let color;
            const name = m[1];
            const components = m[2];
            switch(name){
                case 'rgb':
                case 'rgba':
                    if (color = /^\s*(\d+)\s*,\s*(\d+)\s*,\s*(\d+)\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(255,0,0) rgba(255,0,0,0.5)
                        this.r = Math.min(255, parseInt(color[1], 10)) / 255;
                        this.g = Math.min(255, parseInt(color[2], 10)) / 255;
                        this.b = Math.min(255, parseInt(color[3], 10)) / 255;
                        handleAlpha(color[4]);
                        return this;
                    }
                    if (color = /^\s*(\d+)\%\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // rgb(100%,0%,0%) rgba(100%,0%,0%,0.5)
                        this.r = Math.min(100, parseInt(color[1], 10)) / 100;
                        this.g = Math.min(100, parseInt(color[2], 10)) / 100;
                        this.b = Math.min(100, parseInt(color[3], 10)) / 100;
                        handleAlpha(color[4]);
                        return this;
                    }
                    break;
                case 'hsl':
                case 'hsla':
                    if (color = /^\s*(\d*\.?\d+)\s*,\s*(\d+)\%\s*,\s*(\d+)\%\s*(?:,\s*(\d*\.?\d+)\s*)?$/.exec(components)) {
                        // hsl(120,50%,50%) hsla(120,50%,50%,0.5)
                        const h = parseFloat(color[1]) / 360;
                        const s = parseInt(color[2], 10) / 100;
                        const l = parseInt(color[3], 10) / 100;
                        handleAlpha(color[4]);
                        return this.setHSL(h, s, l);
                    }
                    break;
            }
        } else if (m = /^\#([A-Fa-f\d]+)$/.exec(style)) {
            // hex color
            const hex = m[1];
            const size = hex.length;
            if (size === 3) {
                // #ff0
                this.r = parseInt(hex.charAt(0) + hex.charAt(0), 16) / 255;
                this.g = parseInt(hex.charAt(1) + hex.charAt(1), 16) / 255;
                this.b = parseInt(hex.charAt(2) + hex.charAt(2), 16) / 255;
                return this;
            } else if (size === 6) {
                // #ff0000
                this.r = parseInt(hex.charAt(0) + hex.charAt(1), 16) / 255;
                this.g = parseInt(hex.charAt(2) + hex.charAt(3), 16) / 255;
                this.b = parseInt(hex.charAt(4) + hex.charAt(5), 16) / 255;
                return this;
            }
        }
        if (style && style.length > 0) return this.setColorName(style);
        return this;
    }
    setColorName(style) {
        // color keywords
        const hex = _colorKeywords[style];
        if (hex !== undefined) // red
        this.setHex(hex);
        else // unknown color
        console.warn('THREE.Color: Unknown color ' + style);
        return this;
    }
    clone() {
        return new this.constructor(this.r, this.g, this.b);
    }
    copy(color) {
        this.r = color.r;
        this.g = color.g;
        this.b = color.b;
        return this;
    }
    copyGammaToLinear(color, gammaFactor = 2.0) {
        this.r = Math.pow(color.r, gammaFactor);
        this.g = Math.pow(color.g, gammaFactor);
        this.b = Math.pow(color.b, gammaFactor);
        return this;
    }
    copyLinearToGamma(color, gammaFactor = 2.0) {
        const safeInverse = gammaFactor > 0 ? 1.0 / gammaFactor : 1.0;
        this.r = Math.pow(color.r, safeInverse);
        this.g = Math.pow(color.g, safeInverse);
        this.b = Math.pow(color.b, safeInverse);
        return this;
    }
    convertGammaToLinear(gammaFactor) {
        this.copyGammaToLinear(this, gammaFactor);
        return this;
    }
    convertLinearToGamma(gammaFactor) {
        this.copyLinearToGamma(this, gammaFactor);
        return this;
    }
    copySRGBToLinear(color) {
        this.r = SRGBToLinear(color.r);
        this.g = SRGBToLinear(color.g);
        this.b = SRGBToLinear(color.b);
        return this;
    }
    copyLinearToSRGB(color) {
        this.r = LinearToSRGB(color.r);
        this.g = LinearToSRGB(color.g);
        this.b = LinearToSRGB(color.b);
        return this;
    }
    convertSRGBToLinear() {
        this.copySRGBToLinear(this);
        return this;
    }
    convertLinearToSRGB() {
        this.copyLinearToSRGB(this);
        return this;
    }
    getHex() {
        return this.r * 255 << 16 ^ this.g * 255 << 8 ^ this.b * 255 << 0;
    }
    getHexString() {
        return ('000000' + this.getHex().toString(16)).slice(-6);
    }
    getHSL(target) {
        // h,s,l ranges are in 0.0 - 1.0
        if (target === undefined) {
            console.warn('THREE.Color: .getHSL() target is now required');
            target = {
                h: 0,
                s: 0,
                l: 0
            };
        }
        const r = this.r, g = this.g, b = this.b;
        const max = Math.max(r, g, b);
        const min = Math.min(r, g, b);
        let hue, saturation;
        const lightness = (min + max) / 2.0;
        if (min === max) {
            hue = 0;
            saturation = 0;
        } else {
            const delta = max - min;
            saturation = lightness <= 0.5 ? delta / (max + min) : delta / (2 - max - min);
            switch(max){
                case r:
                    hue = (g - b) / delta + (g < b ? 6 : 0);
                    break;
                case g:
                    hue = (b - r) / delta + 2;
                    break;
                case b:
                    hue = (r - g) / delta + 4;
                    break;
            }
            hue /= 6;
        }
        target.h = hue;
        target.s = saturation;
        target.l = lightness;
        return target;
    }
    getStyle() {
        return 'rgb(' + (this.r * 255 | 0) + ',' + (this.g * 255 | 0) + ',' + (this.b * 255 | 0) + ')';
    }
    offsetHSL(h, s, l) {
        this.getHSL(_hslA);
        _hslA.h += h;
        _hslA.s += s;
        _hslA.l += l;
        this.setHSL(_hslA.h, _hslA.s, _hslA.l);
        return this;
    }
    add(color) {
        this.r += color.r;
        this.g += color.g;
        this.b += color.b;
        return this;
    }
    addColors(color1, color2) {
        this.r = color1.r + color2.r;
        this.g = color1.g + color2.g;
        this.b = color1.b + color2.b;
        return this;
    }
    addScalar(s) {
        this.r += s;
        this.g += s;
        this.b += s;
        return this;
    }
    sub(color) {
        this.r = Math.max(0, this.r - color.r);
        this.g = Math.max(0, this.g - color.g);
        this.b = Math.max(0, this.b - color.b);
        return this;
    }
    multiply(color) {
        this.r *= color.r;
        this.g *= color.g;
        this.b *= color.b;
        return this;
    }
    multiplyScalar(s) {
        this.r *= s;
        this.g *= s;
        this.b *= s;
        return this;
    }
    lerp(color, alpha) {
        this.r += (color.r - this.r) * alpha;
        this.g += (color.g - this.g) * alpha;
        this.b += (color.b - this.b) * alpha;
        return this;
    }
    lerpColors(color1, color2, alpha) {
        this.r = color1.r + (color2.r - color1.r) * alpha;
        this.g = color1.g + (color2.g - color1.g) * alpha;
        this.b = color1.b + (color2.b - color1.b) * alpha;
        return this;
    }
    lerpHSL(color, alpha) {
        this.getHSL(_hslA);
        color.getHSL(_hslB);
        const h = MathUtils.lerp(_hslA.h, _hslB.h, alpha);
        const s = MathUtils.lerp(_hslA.s, _hslB.s, alpha);
        const l = MathUtils.lerp(_hslA.l, _hslB.l, alpha);
        this.setHSL(h, s, l);
        return this;
    }
    equals(c) {
        return c.r === this.r && c.g === this.g && c.b === this.b;
    }
    fromArray(array, offset = 0) {
        this.r = array[offset];
        this.g = array[offset + 1];
        this.b = array[offset + 2];
        return this;
    }
    toArray(array = [], offset = 0) {
        array[offset] = this.r;
        array[offset + 1] = this.g;
        array[offset + 2] = this.b;
        return array;
    }
    fromBufferAttribute(attribute, index) {
        this.r = attribute.getX(index);
        this.g = attribute.getY(index);
        this.b = attribute.getZ(index);
        if (attribute.normalized === true) {
            // assuming Uint8Array
            this.r /= 255;
            this.g /= 255;
            this.b /= 255;
        }
        return this;
    }
    toJSON() {
        return this.getHex();
    }
}
Color.NAMES = _colorKeywords;
Color.prototype.r = 1;
Color.prototype.g = 1;
Color.prototype.b = 1;
class Face3 {
    constructor(a, b, c, normal, color, materialIndex = 0){
        this.a = a;
        this.b = b;
        this.c = c;
        this.normal = normal && normal.isVector3 ? normal : new Vector3();
        this.vertexNormals = Array.isArray(normal) ? normal : [];
        this.color = color && color.isColor ? color : new Color();
        this.vertexColors = Array.isArray(color) ? color : [];
        this.materialIndex = materialIndex;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(source) {
        this.a = source.a;
        this.b = source.b;
        this.c = source.c;
        this.normal.copy(source.normal);
        this.color.copy(source.color);
        this.materialIndex = source.materialIndex;
        for(let i = 0, il = source.vertexNormals.length; i < il; i++)this.vertexNormals[i] = source.vertexNormals[i].clone();
        for(let i = 0, il = source.vertexColors.length; i < il; i++)this.vertexColors[i] = source.vertexColors[i].clone();
        return this;
    }
}
let materialId = 0;
function Material() {
    Object.defineProperty(this, 'id', {
        value: materialId++
    });
    this.uuid = MathUtils.generateUUID();
    this.name = '';
    this.type = 'Material';
    this.fog = true;
    this.blending = NormalBlending;
    this.side = FrontSide;
    this.flatShading = false;
    this.vertexColors = false;
    this.opacity = 1;
    this.transparent = false;
    this.blendSrc = SrcAlphaFactor;
    this.blendDst = OneMinusSrcAlphaFactor;
    this.blendEquation = AddEquation;
    this.blendSrcAlpha = null;
    this.blendDstAlpha = null;
    this.blendEquationAlpha = null;
    this.depthFunc = LessEqualDepth;
    this.depthTest = true;
    this.depthWrite = true;
    this.stencilWriteMask = 0xff;
    this.stencilFunc = AlwaysStencilFunc;
    this.stencilRef = 0;
    this.stencilFuncMask = 0xff;
    this.stencilFail = KeepStencilOp;
    this.stencilZFail = KeepStencilOp;
    this.stencilZPass = KeepStencilOp;
    this.stencilWrite = false;
    this.clippingPlanes = null;
    this.clipIntersection = false;
    this.clipShadows = false;
    this.shadowSide = null;
    this.colorWrite = true;
    this.precision = null; // override the renderer's default precision for this material
    this.polygonOffset = false;
    this.polygonOffsetFactor = 0;
    this.polygonOffsetUnits = 0;
    this.dithering = false;
    this.alphaTest = 0;
    this.premultipliedAlpha = false;
    this.visible = true;
    this.toneMapped = true;
    this.userData = {};
    this.version = 0;
}
Material.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: Material,
    isMaterial: true,
    onBeforeCompile: function() {},
    customProgramCacheKey: function() {
        return this.onBeforeCompile.toString();
    },
    setValues: function(values) {
        if (values === undefined) return;
        for(const key in values){
            const newValue = values[key];
            if (newValue === undefined) {
                console.warn('THREE.Material: \'' + key + '\' parameter is undefined.');
                continue;
            }
            // for backward compatability if shading is set in the constructor
            if (key === 'shading') {
                console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
                this.flatShading = newValue === FlatShading ? true : false;
                continue;
            }
            const currentValue = this[key];
            if (currentValue === undefined) {
                console.warn('THREE.' + this.type + ': \'' + key + '\' is not a property of this material.');
                continue;
            }
            if (currentValue && currentValue.isColor) currentValue.set(newValue);
            else if (currentValue && currentValue.isVector3 && newValue && newValue.isVector3) currentValue.copy(newValue);
            else this[key] = newValue;
        }
    },
    toJSON: function(meta) {
        const isRoot = meta === undefined || typeof meta === 'string';
        if (isRoot) meta = {
            textures: {},
            images: {}
        };
        const data = {
            metadata: {
                version: 4.5,
                type: 'Material',
                generator: 'Material.toJSON'
            }
        };
        // standard Material serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (this.color && this.color.isColor) data.color = this.color.getHex();
        if (this.roughness !== undefined) data.roughness = this.roughness;
        if (this.metalness !== undefined) data.metalness = this.metalness;
        if (this.sheen && this.sheen.isColor) data.sheen = this.sheen.getHex();
        if (this.emissive && this.emissive.isColor) data.emissive = this.emissive.getHex();
        if (this.emissiveIntensity && this.emissiveIntensity !== 1) data.emissiveIntensity = this.emissiveIntensity;
        if (this.specular && this.specular.isColor) data.specular = this.specular.getHex();
        if (this.shininess !== undefined) data.shininess = this.shininess;
        if (this.clearcoat !== undefined) data.clearcoat = this.clearcoat;
        if (this.clearcoatRoughness !== undefined) data.clearcoatRoughness = this.clearcoatRoughness;
        if (this.clearcoatMap && this.clearcoatMap.isTexture) data.clearcoatMap = this.clearcoatMap.toJSON(meta).uuid;
        if (this.clearcoatRoughnessMap && this.clearcoatRoughnessMap.isTexture) data.clearcoatRoughnessMap = this.clearcoatRoughnessMap.toJSON(meta).uuid;
        if (this.clearcoatNormalMap && this.clearcoatNormalMap.isTexture) {
            data.clearcoatNormalMap = this.clearcoatNormalMap.toJSON(meta).uuid;
            data.clearcoatNormalScale = this.clearcoatNormalScale.toArray();
        }
        if (this.map && this.map.isTexture) data.map = this.map.toJSON(meta).uuid;
        if (this.matcap && this.matcap.isTexture) data.matcap = this.matcap.toJSON(meta).uuid;
        if (this.alphaMap && this.alphaMap.isTexture) data.alphaMap = this.alphaMap.toJSON(meta).uuid;
        if (this.lightMap && this.lightMap.isTexture) data.lightMap = this.lightMap.toJSON(meta).uuid;
        if (this.aoMap && this.aoMap.isTexture) {
            data.aoMap = this.aoMap.toJSON(meta).uuid;
            data.aoMapIntensity = this.aoMapIntensity;
        }
        if (this.bumpMap && this.bumpMap.isTexture) {
            data.bumpMap = this.bumpMap.toJSON(meta).uuid;
            data.bumpScale = this.bumpScale;
        }
        if (this.normalMap && this.normalMap.isTexture) {
            data.normalMap = this.normalMap.toJSON(meta).uuid;
            data.normalMapType = this.normalMapType;
            data.normalScale = this.normalScale.toArray();
        }
        if (this.displacementMap && this.displacementMap.isTexture) {
            data.displacementMap = this.displacementMap.toJSON(meta).uuid;
            data.displacementScale = this.displacementScale;
            data.displacementBias = this.displacementBias;
        }
        if (this.roughnessMap && this.roughnessMap.isTexture) data.roughnessMap = this.roughnessMap.toJSON(meta).uuid;
        if (this.metalnessMap && this.metalnessMap.isTexture) data.metalnessMap = this.metalnessMap.toJSON(meta).uuid;
        if (this.emissiveMap && this.emissiveMap.isTexture) data.emissiveMap = this.emissiveMap.toJSON(meta).uuid;
        if (this.specularMap && this.specularMap.isTexture) data.specularMap = this.specularMap.toJSON(meta).uuid;
        if (this.envMap && this.envMap.isTexture) {
            data.envMap = this.envMap.toJSON(meta).uuid;
            data.reflectivity = this.reflectivity; // Scale behind envMap
            data.refractionRatio = this.refractionRatio;
            if (this.combine !== undefined) data.combine = this.combine;
            if (this.envMapIntensity !== undefined) data.envMapIntensity = this.envMapIntensity;
        }
        if (this.gradientMap && this.gradientMap.isTexture) data.gradientMap = this.gradientMap.toJSON(meta).uuid;
        if (this.size !== undefined) data.size = this.size;
        if (this.sizeAttenuation !== undefined) data.sizeAttenuation = this.sizeAttenuation;
        if (this.blending !== NormalBlending) data.blending = this.blending;
        if (this.flatShading === true) data.flatShading = this.flatShading;
        if (this.side !== FrontSide) data.side = this.side;
        if (this.vertexColors) data.vertexColors = true;
        if (this.opacity < 1) data.opacity = this.opacity;
        if (this.transparent === true) data.transparent = this.transparent;
        data.depthFunc = this.depthFunc;
        data.depthTest = this.depthTest;
        data.depthWrite = this.depthWrite;
        data.stencilWrite = this.stencilWrite;
        data.stencilWriteMask = this.stencilWriteMask;
        data.stencilFunc = this.stencilFunc;
        data.stencilRef = this.stencilRef;
        data.stencilFuncMask = this.stencilFuncMask;
        data.stencilFail = this.stencilFail;
        data.stencilZFail = this.stencilZFail;
        data.stencilZPass = this.stencilZPass;
        // rotation (SpriteMaterial)
        if (this.rotation && this.rotation !== 0) data.rotation = this.rotation;
        if (this.polygonOffset === true) data.polygonOffset = true;
        if (this.polygonOffsetFactor !== 0) data.polygonOffsetFactor = this.polygonOffsetFactor;
        if (this.polygonOffsetUnits !== 0) data.polygonOffsetUnits = this.polygonOffsetUnits;
        if (this.linewidth && this.linewidth !== 1) data.linewidth = this.linewidth;
        if (this.dashSize !== undefined) data.dashSize = this.dashSize;
        if (this.gapSize !== undefined) data.gapSize = this.gapSize;
        if (this.scale !== undefined) data.scale = this.scale;
        if (this.dithering === true) data.dithering = true;
        if (this.alphaTest > 0) data.alphaTest = this.alphaTest;
        if (this.premultipliedAlpha === true) data.premultipliedAlpha = this.premultipliedAlpha;
        if (this.wireframe === true) data.wireframe = this.wireframe;
        if (this.wireframeLinewidth > 1) data.wireframeLinewidth = this.wireframeLinewidth;
        if (this.wireframeLinecap !== 'round') data.wireframeLinecap = this.wireframeLinecap;
        if (this.wireframeLinejoin !== 'round') data.wireframeLinejoin = this.wireframeLinejoin;
        if (this.morphTargets === true) data.morphTargets = true;
        if (this.morphNormals === true) data.morphNormals = true;
        if (this.skinning === true) data.skinning = true;
        if (this.visible === false) data.visible = false;
        if (this.toneMapped === false) data.toneMapped = false;
        if (JSON.stringify(this.userData) !== '{}') data.userData = this.userData;
        // TODO: Copied from Object3D.toJSON
        function extractFromCache(cache) {
            const values = [];
            for(const key in cache){
                const data = cache[key];
                delete data.metadata;
                values.push(data);
            }
            return values;
        }
        if (isRoot) {
            const textures = extractFromCache(meta.textures);
            const images = extractFromCache(meta.images);
            if (textures.length > 0) data.textures = textures;
            if (images.length > 0) data.images = images;
        }
        return data;
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    copy: function(source) {
        this.name = source.name;
        this.fog = source.fog;
        this.blending = source.blending;
        this.side = source.side;
        this.flatShading = source.flatShading;
        this.vertexColors = source.vertexColors;
        this.opacity = source.opacity;
        this.transparent = source.transparent;
        this.blendSrc = source.blendSrc;
        this.blendDst = source.blendDst;
        this.blendEquation = source.blendEquation;
        this.blendSrcAlpha = source.blendSrcAlpha;
        this.blendDstAlpha = source.blendDstAlpha;
        this.blendEquationAlpha = source.blendEquationAlpha;
        this.depthFunc = source.depthFunc;
        this.depthTest = source.depthTest;
        this.depthWrite = source.depthWrite;
        this.stencilWriteMask = source.stencilWriteMask;
        this.stencilFunc = source.stencilFunc;
        this.stencilRef = source.stencilRef;
        this.stencilFuncMask = source.stencilFuncMask;
        this.stencilFail = source.stencilFail;
        this.stencilZFail = source.stencilZFail;
        this.stencilZPass = source.stencilZPass;
        this.stencilWrite = source.stencilWrite;
        const srcPlanes = source.clippingPlanes;
        let dstPlanes = null;
        if (srcPlanes !== null) {
            const n = srcPlanes.length;
            dstPlanes = new Array(n);
            for(let i = 0; i !== n; ++i)dstPlanes[i] = srcPlanes[i].clone();
        }
        this.clippingPlanes = dstPlanes;
        this.clipIntersection = source.clipIntersection;
        this.clipShadows = source.clipShadows;
        this.shadowSide = source.shadowSide;
        this.colorWrite = source.colorWrite;
        this.precision = source.precision;
        this.polygonOffset = source.polygonOffset;
        this.polygonOffsetFactor = source.polygonOffsetFactor;
        this.polygonOffsetUnits = source.polygonOffsetUnits;
        this.dithering = source.dithering;
        this.alphaTest = source.alphaTest;
        this.premultipliedAlpha = source.premultipliedAlpha;
        this.visible = source.visible;
        this.toneMapped = source.toneMapped;
        this.userData = JSON.parse(JSON.stringify(source.userData));
        return this;
    },
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
});
Object.defineProperty(Material.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  depthTest: <bool>,
 *  depthWrite: <bool>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>
 * }
 */ function MeshBasicMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshBasicMaterial';
    this.color = new Color(0xffffff); // emissive
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.setValues(parameters);
}
MeshBasicMaterial.prototype = Object.create(Material.prototype);
MeshBasicMaterial.prototype.constructor = MeshBasicMaterial;
MeshBasicMaterial.prototype.isMeshBasicMaterial = true;
MeshBasicMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    return this;
};
const _vector$3 = new Vector3();
const _vector2$1 = new Vector2();
function BufferAttribute(array, itemSize, normalized) {
    if (Array.isArray(array)) throw new TypeError('THREE.BufferAttribute: array should be a Typed Array.');
    this.name = '';
    this.array = array;
    this.itemSize = itemSize;
    this.count = array !== undefined ? array.length / itemSize : 0;
    this.normalized = normalized === true;
    this.usage = StaticDrawUsage;
    this.updateRange = {
        offset: 0,
        count: -1
    };
    this.version = 0;
}
Object.defineProperty(BufferAttribute.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
Object.assign(BufferAttribute.prototype, {
    isBufferAttribute: true,
    onUploadCallback: function() {},
    setUsage: function(value) {
        this.usage = value;
        return this;
    },
    copy: function(source) {
        this.name = source.name;
        this.array = new source.array.constructor(source.array);
        this.itemSize = source.itemSize;
        this.count = source.count;
        this.normalized = source.normalized;
        this.usage = source.usage;
        return this;
    },
    copyAt: function(index1, attribute, index2) {
        index1 *= this.itemSize;
        index2 *= attribute.itemSize;
        for(let i = 0, l = this.itemSize; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    },
    copyArray: function(array) {
        this.array.set(array);
        return this;
    },
    copyColorsArray: function(colors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = colors.length; i < l; i++){
            let color = colors[i];
            if (color === undefined) {
                console.warn('THREE.BufferAttribute.copyColorsArray(): color is undefined', i);
                color = new Color();
            }
            array[offset++] = color.r;
            array[offset++] = color.g;
            array[offset++] = color.b;
        }
        return this;
    },
    copyVector2sArray: function(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector2sArray(): vector is undefined', i);
                vector = new Vector2();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
        }
        return this;
    },
    copyVector3sArray: function(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector3sArray(): vector is undefined', i);
                vector = new Vector3();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
        }
        return this;
    },
    copyVector4sArray: function(vectors) {
        const array = this.array;
        let offset = 0;
        for(let i = 0, l = vectors.length; i < l; i++){
            let vector = vectors[i];
            if (vector === undefined) {
                console.warn('THREE.BufferAttribute.copyVector4sArray(): vector is undefined', i);
                vector = new Vector4();
            }
            array[offset++] = vector.x;
            array[offset++] = vector.y;
            array[offset++] = vector.z;
            array[offset++] = vector.w;
        }
        return this;
    },
    applyMatrix3: function(m) {
        if (this.itemSize === 2) for(let i = 0, l = this.count; i < l; i++){
            _vector2$1.fromBufferAttribute(this, i);
            _vector2$1.applyMatrix3(m);
            this.setXY(i, _vector2$1.x, _vector2$1.y);
        }
        else if (this.itemSize === 3) for(let i = 0, l = this.count; i < l; i++){
            _vector$3.fromBufferAttribute(this, i);
            _vector$3.applyMatrix3(m);
            this.setXYZ(i, _vector$3.x, _vector$3.y, _vector$3.z);
        }
        return this;
    },
    applyMatrix4: function(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$3.x = this.getX(i);
            _vector$3.y = this.getY(i);
            _vector$3.z = this.getZ(i);
            _vector$3.applyMatrix4(m);
            this.setXYZ(i, _vector$3.x, _vector$3.y, _vector$3.z);
        }
        return this;
    },
    applyNormalMatrix: function(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$3.x = this.getX(i);
            _vector$3.y = this.getY(i);
            _vector$3.z = this.getZ(i);
            _vector$3.applyNormalMatrix(m);
            this.setXYZ(i, _vector$3.x, _vector$3.y, _vector$3.z);
        }
        return this;
    },
    transformDirection: function(m) {
        for(let i = 0, l = this.count; i < l; i++){
            _vector$3.x = this.getX(i);
            _vector$3.y = this.getY(i);
            _vector$3.z = this.getZ(i);
            _vector$3.transformDirection(m);
            this.setXYZ(i, _vector$3.x, _vector$3.y, _vector$3.z);
        }
        return this;
    },
    set: function(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    },
    getX: function(index) {
        return this.array[index * this.itemSize];
    },
    setX: function(index, x) {
        this.array[index * this.itemSize] = x;
        return this;
    },
    getY: function(index) {
        return this.array[index * this.itemSize + 1];
    },
    setY: function(index, y) {
        this.array[index * this.itemSize + 1] = y;
        return this;
    },
    getZ: function(index) {
        return this.array[index * this.itemSize + 2];
    },
    setZ: function(index, z) {
        this.array[index * this.itemSize + 2] = z;
        return this;
    },
    getW: function(index) {
        return this.array[index * this.itemSize + 3];
    },
    setW: function(index, w) {
        this.array[index * this.itemSize + 3] = w;
        return this;
    },
    setXY: function(index, x, y) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        return this;
    },
    setXYZ: function(index, x, y, z) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        return this;
    },
    setXYZW: function(index, x, y, z, w) {
        index *= this.itemSize;
        this.array[index + 0] = x;
        this.array[index + 1] = y;
        this.array[index + 2] = z;
        this.array[index + 3] = w;
        return this;
    },
    onUpload: function(callback) {
        this.onUploadCallback = callback;
        return this;
    },
    clone: function() {
        return new this.constructor(this.array, this.itemSize).copy(this);
    },
    toJSON: function() {
        return {
            itemSize: this.itemSize,
            type: this.array.constructor.name,
            array: Array.prototype.slice.call(this.array),
            normalized: this.normalized
        };
    }
});
//
function Int8BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Int8Array(array), itemSize, normalized);
}
Int8BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Int8BufferAttribute.prototype.constructor = Int8BufferAttribute;
function Uint8BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint8Array(array), itemSize, normalized);
}
Uint8BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Uint8BufferAttribute.prototype.constructor = Uint8BufferAttribute;
function Uint8ClampedBufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint8ClampedArray(array), itemSize, normalized);
}
Uint8ClampedBufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Uint8ClampedBufferAttribute.prototype.constructor = Uint8ClampedBufferAttribute;
function Int16BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Int16Array(array), itemSize, normalized);
}
Int16BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Int16BufferAttribute.prototype.constructor = Int16BufferAttribute;
function Uint16BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint16Array(array), itemSize, normalized);
}
Uint16BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Uint16BufferAttribute.prototype.constructor = Uint16BufferAttribute;
function Int32BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Int32Array(array), itemSize, normalized);
}
Int32BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Int32BufferAttribute.prototype.constructor = Int32BufferAttribute;
function Uint32BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint32Array(array), itemSize, normalized);
}
Uint32BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Uint32BufferAttribute.prototype.constructor = Uint32BufferAttribute;
function Float16BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Uint16Array(array), itemSize, normalized);
}
Float16BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Float16BufferAttribute.prototype.constructor = Float16BufferAttribute;
Float16BufferAttribute.prototype.isFloat16BufferAttribute = true;
function Float32BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Float32Array(array), itemSize, normalized);
}
Float32BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Float32BufferAttribute.prototype.constructor = Float32BufferAttribute;
function Float64BufferAttribute(array, itemSize, normalized) {
    BufferAttribute.call(this, new Float64Array(array), itemSize, normalized);
}
Float64BufferAttribute.prototype = Object.create(BufferAttribute.prototype);
Float64BufferAttribute.prototype.constructor = Float64BufferAttribute;
function arrayMax(array) {
    if (array.length === 0) return -Infinity;
    let max = array[0];
    for(let i = 1, l = array.length; i < l; ++i)if (array[i] > max) max = array[i];
    return max;
}
const TYPED_ARRAYS = {
    Int8Array: Int8Array,
    Uint8Array: Uint8Array,
    // Workaround for IE11 pre KB2929437. See #11440
    Uint8ClampedArray: typeof Uint8ClampedArray !== 'undefined' ? Uint8ClampedArray : Uint8Array,
    Int16Array: Int16Array,
    Uint16Array: Uint16Array,
    Int32Array: Int32Array,
    Uint32Array: Uint32Array,
    Float32Array: Float32Array,
    Float64Array: Float64Array
};
function getTypedArray(type, buffer) {
    return new TYPED_ARRAYS[type](buffer);
}
let _id = 0;
const _m1$2 = new Matrix4();
const _obj = new Object3D();
const _offset = new Vector3();
const _box$2 = new Box3();
const _boxMorphTargets = new Box3();
const _vector$4 = new Vector3();
function BufferGeometry() {
    Object.defineProperty(this, 'id', {
        value: _id++
    });
    this.uuid = MathUtils.generateUUID();
    this.name = '';
    this.type = 'BufferGeometry';
    this.index = null;
    this.attributes = {};
    this.morphAttributes = {};
    this.morphTargetsRelative = false;
    this.groups = [];
    this.boundingBox = null;
    this.boundingSphere = null;
    this.drawRange = {
        start: 0,
        count: Infinity
    };
    this.userData = {};
}
BufferGeometry.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: BufferGeometry,
    isBufferGeometry: true,
    getIndex: function() {
        return this.index;
    },
    setIndex: function(index) {
        if (Array.isArray(index)) this.index = new (arrayMax(index) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute)(index, 1);
        else this.index = index;
        return this;
    },
    getAttribute: function(name) {
        return this.attributes[name];
    },
    setAttribute: function(name, attribute) {
        this.attributes[name] = attribute;
        return this;
    },
    deleteAttribute: function(name) {
        delete this.attributes[name];
        return this;
    },
    hasAttribute: function(name) {
        return this.attributes[name] !== undefined;
    },
    addGroup: function(start, count, materialIndex = 0) {
        this.groups.push({
            start: start,
            count: count,
            materialIndex: materialIndex
        });
    },
    clearGroups: function() {
        this.groups = [];
    },
    setDrawRange: function(start, count) {
        this.drawRange.start = start;
        this.drawRange.count = count;
    },
    applyMatrix4: function(matrix) {
        const position = this.attributes.position;
        if (position !== undefined) {
            position.applyMatrix4(matrix);
            position.needsUpdate = true;
        }
        const normal = this.attributes.normal;
        if (normal !== undefined) {
            const normalMatrix = new Matrix3().getNormalMatrix(matrix);
            normal.applyNormalMatrix(normalMatrix);
            normal.needsUpdate = true;
        }
        const tangent = this.attributes.tangent;
        if (tangent !== undefined) {
            tangent.transformDirection(matrix);
            tangent.needsUpdate = true;
        }
        if (this.boundingBox !== null) this.computeBoundingBox();
        if (this.boundingSphere !== null) this.computeBoundingSphere();
        return this;
    },
    rotateX: function(angle) {
        // rotate geometry around world x-axis
        _m1$2.makeRotationX(angle);
        this.applyMatrix4(_m1$2);
        return this;
    },
    rotateY: function(angle) {
        // rotate geometry around world y-axis
        _m1$2.makeRotationY(angle);
        this.applyMatrix4(_m1$2);
        return this;
    },
    rotateZ: function(angle) {
        // rotate geometry around world z-axis
        _m1$2.makeRotationZ(angle);
        this.applyMatrix4(_m1$2);
        return this;
    },
    translate: function(x, y, z) {
        // translate geometry
        _m1$2.makeTranslation(x, y, z);
        this.applyMatrix4(_m1$2);
        return this;
    },
    scale: function(x, y, z) {
        // scale geometry
        _m1$2.makeScale(x, y, z);
        this.applyMatrix4(_m1$2);
        return this;
    },
    lookAt: function(vector) {
        _obj.lookAt(vector);
        _obj.updateMatrix();
        this.applyMatrix4(_obj.matrix);
        return this;
    },
    center: function() {
        this.computeBoundingBox();
        this.boundingBox.getCenter(_offset).negate();
        this.translate(_offset.x, _offset.y, _offset.z);
        return this;
    },
    setFromPoints: function(points) {
        const position = [];
        for(let i = 0, l = points.length; i < l; i++){
            const point = points[i];
            position.push(point.x, point.y, point.z || 0);
        }
        this.setAttribute('position', new Float32BufferAttribute(position, 3));
        return this;
    },
    computeBoundingBox: function() {
        if (this.boundingBox === null) this.boundingBox = new Box3();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingBox(): GLBufferAttribute requires a manual bounding box. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingBox.set(new Vector3(-Infinity, -Infinity, -Infinity), new Vector3(Infinity, Infinity, Infinity));
            return;
        }
        if (position !== undefined) {
            this.boundingBox.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                _box$2.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    _vector$4.addVectors(this.boundingBox.min, _box$2.min);
                    this.boundingBox.expandByPoint(_vector$4);
                    _vector$4.addVectors(this.boundingBox.max, _box$2.max);
                    this.boundingBox.expandByPoint(_vector$4);
                } else {
                    this.boundingBox.expandByPoint(_box$2.min);
                    this.boundingBox.expandByPoint(_box$2.max);
                }
            }
        } else this.boundingBox.makeEmpty();
        if (isNaN(this.boundingBox.min.x) || isNaN(this.boundingBox.min.y) || isNaN(this.boundingBox.min.z)) console.error('THREE.BufferGeometry.computeBoundingBox(): Computed min/max have NaN values. The "position" attribute is likely to have NaN values.', this);
    },
    computeBoundingSphere: function() {
        if (this.boundingSphere === null) this.boundingSphere = new Sphere();
        const position = this.attributes.position;
        const morphAttributesPosition = this.morphAttributes.position;
        if (position && position.isGLBufferAttribute) {
            console.error('THREE.BufferGeometry.computeBoundingSphere(): GLBufferAttribute requires a manual bounding sphere. Alternatively set "mesh.frustumCulled" to "false".', this);
            this.boundingSphere.set(new Vector3(), Infinity);
            return;
        }
        if (position) {
            // first, find the center of the bounding sphere
            const center = this.boundingSphere.center;
            _box$2.setFromBufferAttribute(position);
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                _boxMorphTargets.setFromBufferAttribute(morphAttribute);
                if (this.morphTargetsRelative) {
                    _vector$4.addVectors(_box$2.min, _boxMorphTargets.min);
                    _box$2.expandByPoint(_vector$4);
                    _vector$4.addVectors(_box$2.max, _boxMorphTargets.max);
                    _box$2.expandByPoint(_vector$4);
                } else {
                    _box$2.expandByPoint(_boxMorphTargets.min);
                    _box$2.expandByPoint(_boxMorphTargets.max);
                }
            }
            _box$2.getCenter(center);
            // second, try to find a boundingSphere with a radius smaller than the
            // boundingSphere of the boundingBox: sqrt(3) smaller in the best case
            let maxRadiusSq = 0;
            for(let i = 0, il = position.count; i < il; i++){
                _vector$4.fromBufferAttribute(position, i);
                maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$4));
            }
            // process morph attributes if present
            if (morphAttributesPosition) for(let i = 0, il = morphAttributesPosition.length; i < il; i++){
                const morphAttribute = morphAttributesPosition[i];
                const morphTargetsRelative = this.morphTargetsRelative;
                for(let j = 0, jl = morphAttribute.count; j < jl; j++){
                    _vector$4.fromBufferAttribute(morphAttribute, j);
                    if (morphTargetsRelative) {
                        _offset.fromBufferAttribute(position, j);
                        _vector$4.add(_offset);
                    }
                    maxRadiusSq = Math.max(maxRadiusSq, center.distanceToSquared(_vector$4));
                }
            }
            this.boundingSphere.radius = Math.sqrt(maxRadiusSq);
            if (isNaN(this.boundingSphere.radius)) console.error('THREE.BufferGeometry.computeBoundingSphere(): Computed radius is NaN. The "position" attribute is likely to have NaN values.', this);
        }
    },
    computeFaceNormals: function() {
    // backwards compatibility
    },
    computeTangents: function() {
        const index = this.index;
        const attributes = this.attributes;
        // based on http://www.terathon.com/code/tangent.html
        // (per vertex tangents)
        if (index === null || attributes.position === undefined || attributes.normal === undefined || attributes.uv === undefined) {
            console.error('THREE.BufferGeometry: .computeTangents() failed. Missing required attributes (index, position, normal or uv)');
            return;
        }
        const indices = index.array;
        const positions = attributes.position.array;
        const normals = attributes.normal.array;
        const uvs = attributes.uv.array;
        const nVertices = positions.length / 3;
        if (attributes.tangent === undefined) this.setAttribute('tangent', new BufferAttribute(new Float32Array(4 * nVertices), 4));
        const tangents = attributes.tangent.array;
        const tan1 = [], tan2 = [];
        for(let i = 0; i < nVertices; i++){
            tan1[i] = new Vector3();
            tan2[i] = new Vector3();
        }
        const vA = new Vector3(), vB = new Vector3(), vC = new Vector3(), uvA = new Vector2(), uvB = new Vector2(), uvC = new Vector2(), sdir = new Vector3(), tdir = new Vector3();
        function handleTriangle(a, b, c) {
            vA.fromArray(positions, a * 3);
            vB.fromArray(positions, b * 3);
            vC.fromArray(positions, c * 3);
            uvA.fromArray(uvs, a * 2);
            uvB.fromArray(uvs, b * 2);
            uvC.fromArray(uvs, c * 2);
            vB.sub(vA);
            vC.sub(vA);
            uvB.sub(uvA);
            uvC.sub(uvA);
            const r = 1.0 / (uvB.x * uvC.y - uvC.x * uvB.y);
            // silently ignore degenerate uv triangles having coincident or colinear vertices
            if (!isFinite(r)) return;
            sdir.copy(vB).multiplyScalar(uvC.y).addScaledVector(vC, -uvB.y).multiplyScalar(r);
            tdir.copy(vC).multiplyScalar(uvB.x).addScaledVector(vB, -uvC.x).multiplyScalar(r);
            tan1[a].add(sdir);
            tan1[b].add(sdir);
            tan1[c].add(sdir);
            tan2[a].add(tdir);
            tan2[b].add(tdir);
            tan2[c].add(tdir);
        }
        let groups = this.groups;
        if (groups.length === 0) groups = [
            {
                start: 0,
                count: indices.length
            }
        ];
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3)handleTriangle(indices[j + 0], indices[j + 1], indices[j + 2]);
        }
        const tmp = new Vector3(), tmp2 = new Vector3();
        const n = new Vector3(), n2 = new Vector3();
        function handleVertex(v) {
            n.fromArray(normals, v * 3);
            n2.copy(n);
            const t = tan1[v];
            // Gram-Schmidt orthogonalize
            tmp.copy(t);
            tmp.sub(n.multiplyScalar(n.dot(t))).normalize();
            // Calculate handedness
            tmp2.crossVectors(n2, t);
            const test = tmp2.dot(tan2[v]);
            const w = test < 0.0 ? -1 : 1.0;
            tangents[v * 4] = tmp.x;
            tangents[v * 4 + 1] = tmp.y;
            tangents[v * 4 + 2] = tmp.z;
            tangents[v * 4 + 3] = w;
        }
        for(let i = 0, il = groups.length; i < il; ++i){
            const group = groups[i];
            const start = group.start;
            const count = group.count;
            for(let j = start, jl = start + count; j < jl; j += 3){
                handleVertex(indices[j + 0]);
                handleVertex(indices[j + 1]);
                handleVertex(indices[j + 2]);
            }
        }
    },
    computeVertexNormals: function() {
        const index = this.index;
        const positionAttribute = this.getAttribute('position');
        if (positionAttribute !== undefined) {
            let normalAttribute = this.getAttribute('normal');
            if (normalAttribute === undefined) {
                normalAttribute = new BufferAttribute(new Float32Array(positionAttribute.count * 3), 3);
                this.setAttribute('normal', normalAttribute);
            } else // reset existing normals to zero
            for(let i = 0, il = normalAttribute.count; i < il; i++)normalAttribute.setXYZ(i, 0, 0, 0);
            const pA = new Vector3(), pB = new Vector3(), pC = new Vector3();
            const nA = new Vector3(), nB = new Vector3(), nC = new Vector3();
            const cb = new Vector3(), ab = new Vector3();
            // indexed elements
            if (index) for(let i = 0, il = index.count; i < il; i += 3){
                const vA = index.getX(i + 0);
                const vB = index.getX(i + 1);
                const vC = index.getX(i + 2);
                pA.fromBufferAttribute(positionAttribute, vA);
                pB.fromBufferAttribute(positionAttribute, vB);
                pC.fromBufferAttribute(positionAttribute, vC);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                nA.fromBufferAttribute(normalAttribute, vA);
                nB.fromBufferAttribute(normalAttribute, vB);
                nC.fromBufferAttribute(normalAttribute, vC);
                nA.add(cb);
                nB.add(cb);
                nC.add(cb);
                normalAttribute.setXYZ(vA, nA.x, nA.y, nA.z);
                normalAttribute.setXYZ(vB, nB.x, nB.y, nB.z);
                normalAttribute.setXYZ(vC, nC.x, nC.y, nC.z);
            }
            else // non-indexed elements (unconnected triangle soup)
            for(let i = 0, il = positionAttribute.count; i < il; i += 3){
                pA.fromBufferAttribute(positionAttribute, i + 0);
                pB.fromBufferAttribute(positionAttribute, i + 1);
                pC.fromBufferAttribute(positionAttribute, i + 2);
                cb.subVectors(pC, pB);
                ab.subVectors(pA, pB);
                cb.cross(ab);
                normalAttribute.setXYZ(i + 0, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 1, cb.x, cb.y, cb.z);
                normalAttribute.setXYZ(i + 2, cb.x, cb.y, cb.z);
            }
            this.normalizeNormals();
            normalAttribute.needsUpdate = true;
        }
    },
    merge: function(geometry, offset) {
        if (!(geometry && geometry.isBufferGeometry)) {
            console.error('THREE.BufferGeometry.merge(): geometry not an instance of THREE.BufferGeometry.', geometry);
            return;
        }
        if (offset === undefined) {
            offset = 0;
            console.warn("THREE.BufferGeometry.merge(): Overwriting original geometry, starting at offset=0. Use BufferGeometryUtils.mergeBufferGeometries() for lossless merge.");
        }
        const attributes = this.attributes;
        for(const key in attributes){
            if (geometry.attributes[key] === undefined) continue;
            const attribute1 = attributes[key];
            const attributeArray1 = attribute1.array;
            const attribute2 = geometry.attributes[key];
            const attributeArray2 = attribute2.array;
            const attributeOffset = attribute2.itemSize * offset;
            const length = Math.min(attributeArray2.length, attributeArray1.length - attributeOffset);
            for(let i = 0, j = attributeOffset; i < length; i++, j++)attributeArray1[j] = attributeArray2[i];
        }
        return this;
    },
    normalizeNormals: function() {
        const normals = this.attributes.normal;
        for(let i = 0, il = normals.count; i < il; i++){
            _vector$4.fromBufferAttribute(normals, i);
            _vector$4.normalize();
            normals.setXYZ(i, _vector$4.x, _vector$4.y, _vector$4.z);
        }
    },
    toNonIndexed: function() {
        function convertBufferAttribute(attribute, indices) {
            const array = attribute.array;
            const itemSize = attribute.itemSize;
            const normalized = attribute.normalized;
            const array2 = new array.constructor(indices.length * itemSize);
            let index = 0, index2 = 0;
            for(let i = 0, l = indices.length; i < l; i++){
                index = indices[i] * itemSize;
                for(let j = 0; j < itemSize; j++)array2[index2++] = array[index++];
            }
            return new BufferAttribute(array2, itemSize, normalized);
        }
        //
        if (this.index === null) {
            console.warn('THREE.BufferGeometry.toNonIndexed(): BufferGeometry is already non-indexed.');
            return this;
        }
        const geometry2 = new BufferGeometry();
        const indices = this.index.array;
        const attributes = this.attributes;
        // attributes
        for(const name in attributes){
            const attribute = attributes[name];
            const newAttribute = convertBufferAttribute(attribute, indices);
            geometry2.setAttribute(name, newAttribute);
        }
        // morph attributes
        const morphAttributes = this.morphAttributes;
        for(const name in morphAttributes){
            const morphArray = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, il = morphAttribute.length; i < il; i++){
                const attribute = morphAttribute[i];
                const newAttribute = convertBufferAttribute(attribute, indices);
                morphArray.push(newAttribute);
            }
            geometry2.morphAttributes[name] = morphArray;
        }
        geometry2.morphTargetsRelative = this.morphTargetsRelative;
        // groups
        const groups = this.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            geometry2.addGroup(group.start, group.count, group.materialIndex);
        }
        return geometry2;
    },
    toJSON: function() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'BufferGeometry',
                generator: 'BufferGeometry.toJSON'
            }
        };
        // standard BufferGeometry serialization
        data.uuid = this.uuid;
        data.type = this.type;
        if (this.name !== '') data.name = this.name;
        if (Object.keys(this.userData).length > 0) data.userData = this.userData;
        if (this.parameters !== undefined) {
            const parameters = this.parameters;
            for(const key in parameters)if (parameters[key] !== undefined) data[key] = parameters[key];
            return data;
        }
        data.data = {
            attributes: {}
        };
        const index = this.index;
        if (index !== null) data.data.index = {
            type: index.array.constructor.name,
            array: Array.prototype.slice.call(index.array)
        };
        const attributes = this.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            const attributeData = attribute.toJSON(data.data);
            if (attribute.name !== '') attributeData.name = attribute.name;
            data.data.attributes[key] = attributeData;
        }
        const morphAttributes = {};
        let hasMorphAttributes = false;
        for(const key in this.morphAttributes){
            const attributeArray = this.morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                const attributeData = attribute.toJSON(data.data);
                if (attribute.name !== '') attributeData.name = attribute.name;
                array.push(attributeData);
            }
            if (array.length > 0) {
                morphAttributes[key] = array;
                hasMorphAttributes = true;
            }
        }
        if (hasMorphAttributes) {
            data.data.morphAttributes = morphAttributes;
            data.data.morphTargetsRelative = this.morphTargetsRelative;
        }
        const groups = this.groups;
        if (groups.length > 0) data.data.groups = JSON.parse(JSON.stringify(groups));
        const boundingSphere = this.boundingSphere;
        if (boundingSphere !== null) data.data.boundingSphere = {
            center: boundingSphere.center.toArray(),
            radius: boundingSphere.radius
        };
        return data;
    },
    clone: function() {
        /*
		 // Handle primitives

		 const parameters = this.parameters;

		 if ( parameters !== undefined ) {

		 const values = [];

		 for ( const key in parameters ) {

		 values.push( parameters[ key ] );

		 }

		 const geometry = Object.create( this.constructor.prototype );
		 this.constructor.apply( geometry, values );
		 return geometry;

		 }

		 return new this.constructor().copy( this );
		 */ return new BufferGeometry().copy(this);
    },
    copy: function(source) {
        // reset
        this.index = null;
        this.attributes = {};
        this.morphAttributes = {};
        this.groups = [];
        this.boundingBox = null;
        this.boundingSphere = null;
        // used for storing cloned, shared data
        const data = {};
        // name
        this.name = source.name;
        // index
        const index = source.index;
        if (index !== null) this.setIndex(index.clone(data));
        // attributes
        const attributes = source.attributes;
        for(const name in attributes){
            const attribute = attributes[name];
            this.setAttribute(name, attribute.clone(data));
        }
        // morph attributes
        const morphAttributes = source.morphAttributes;
        for(const name in morphAttributes){
            const array = [];
            const morphAttribute = morphAttributes[name]; // morphAttribute: array of Float32BufferAttributes
            for(let i = 0, l = morphAttribute.length; i < l; i++)array.push(morphAttribute[i].clone(data));
            this.morphAttributes[name] = array;
        }
        this.morphTargetsRelative = source.morphTargetsRelative;
        // groups
        const groups = source.groups;
        for(let i = 0, l = groups.length; i < l; i++){
            const group = groups[i];
            this.addGroup(group.start, group.count, group.materialIndex);
        }
        // bounding box
        const boundingBox = source.boundingBox;
        if (boundingBox !== null) this.boundingBox = boundingBox.clone();
        // bounding sphere
        const boundingSphere = source.boundingSphere;
        if (boundingSphere !== null) this.boundingSphere = boundingSphere.clone();
        // draw range
        this.drawRange.start = source.drawRange.start;
        this.drawRange.count = source.drawRange.count;
        // user data
        this.userData = source.userData;
        return this;
    },
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
});
const _inverseMatrix = new Matrix4();
const _ray = new Ray();
const _sphere = new Sphere();
const _vA = new Vector3();
const _vB = new Vector3();
const _vC = new Vector3();
const _tempA = new Vector3();
const _tempB = new Vector3();
const _tempC = new Vector3();
const _morphA = new Vector3();
const _morphB = new Vector3();
const _morphC = new Vector3();
const _uvA = new Vector2();
const _uvB = new Vector2();
const _uvC = new Vector2();
const _intersectionPoint = new Vector3();
const _intersectionPointWorld = new Vector3();
function Mesh(geometry = new BufferGeometry(), material = new MeshBasicMaterial()) {
    Object3D.call(this);
    this.type = 'Mesh';
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
}
Mesh.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Mesh,
    isMesh: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        if (source.morphTargetInfluences !== undefined) this.morphTargetInfluences = source.morphTargetInfluences.slice();
        if (source.morphTargetDictionary !== undefined) this.morphTargetDictionary = Object.assign({}, source.morphTargetDictionary);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    },
    updateMorphTargets: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Mesh.updateMorphTargets() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
    },
    raycast: function(raycaster, intersects) {
        const geometry = this.geometry;
        const material = this.material;
        const matrixWorld = this.matrixWorld;
        if (material === undefined) return;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere.copy(geometry.boundingSphere);
        _sphere.applyMatrix4(matrixWorld);
        if (raycaster.ray.intersectsSphere(_sphere) === false) return;
        //
        _inverseMatrix.copy(matrixWorld).invert();
        _ray.copy(raycaster.ray).applyMatrix4(_inverseMatrix);
        // Check boundingBox before continuing
        if (geometry.boundingBox !== null) {
            if (_ray.intersectsBox(geometry.boundingBox) === false) return;
        }
        let intersection;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const position = geometry.attributes.position;
            const morphPosition = geometry.morphAttributes.position;
            const morphTargetsRelative = geometry.morphTargetsRelative;
            const uv = geometry.attributes.uv;
            const uv2 = geometry.attributes.uv2;
            const groups = geometry.groups;
            const drawRange = geometry.drawRange;
            if (index !== null) {
                // indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = index.getX(j);
                        const b = index.getX(j + 1);
                        const c = index.getX(j + 2);
                        intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(index.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = index.getX(i);
                        const b = index.getX(i + 1);
                        const c = index.getX(i + 2);
                        intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            } else if (position !== undefined) {
                // non-indexed buffer geometry
                if (Array.isArray(material)) for(let i = 0, il = groups.length; i < il; i++){
                    const group = groups[i];
                    const groupMaterial = material[group.materialIndex];
                    const start = Math.max(group.start, drawRange.start);
                    const end = Math.min(group.start + group.count, drawRange.start + drawRange.count);
                    for(let j = start, jl = end; j < jl; j += 3){
                        const a = j;
                        const b = j + 1;
                        const c = j + 2;
                        intersection = checkBufferGeometryIntersection(this, groupMaterial, raycaster, _ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(j / 3); // triangle number in non-indexed buffer semantics
                            intersection.face.materialIndex = group.materialIndex;
                            intersects.push(intersection);
                        }
                    }
                }
                else {
                    const start = Math.max(0, drawRange.start);
                    const end = Math.min(position.count, drawRange.start + drawRange.count);
                    for(let i = start, il = end; i < il; i += 3){
                        const a = i;
                        const b = i + 1;
                        const c = i + 2;
                        intersection = checkBufferGeometryIntersection(this, material, raycaster, _ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c);
                        if (intersection) {
                            intersection.faceIndex = Math.floor(i / 3); // triangle number in non-indexed buffer semantics
                            intersects.push(intersection);
                        }
                    }
                }
            }
        } else if (geometry.isGeometry) console.error('THREE.Mesh.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
    }
});
function checkIntersection(object, material, raycaster, ray, pA, pB, pC, point) {
    let intersect;
    if (material.side === BackSide) intersect = ray.intersectTriangle(pC, pB, pA, true, point);
    else intersect = ray.intersectTriangle(pA, pB, pC, material.side !== DoubleSide, point);
    if (intersect === null) return null;
    _intersectionPointWorld.copy(point);
    _intersectionPointWorld.applyMatrix4(object.matrixWorld);
    const distance = raycaster.ray.origin.distanceTo(_intersectionPointWorld);
    if (distance < raycaster.near || distance > raycaster.far) return null;
    return {
        distance: distance,
        point: _intersectionPointWorld.clone(),
        object: object
    };
}
function checkBufferGeometryIntersection(object, material, raycaster, ray, position, morphPosition, morphTargetsRelative, uv, uv2, a, b, c) {
    _vA.fromBufferAttribute(position, a);
    _vB.fromBufferAttribute(position, b);
    _vC.fromBufferAttribute(position, c);
    const morphInfluences = object.morphTargetInfluences;
    if (material.morphTargets && morphPosition && morphInfluences) {
        _morphA.set(0, 0, 0);
        _morphB.set(0, 0, 0);
        _morphC.set(0, 0, 0);
        for(let i = 0, il = morphPosition.length; i < il; i++){
            const influence = morphInfluences[i];
            const morphAttribute = morphPosition[i];
            if (influence === 0) continue;
            _tempA.fromBufferAttribute(morphAttribute, a);
            _tempB.fromBufferAttribute(morphAttribute, b);
            _tempC.fromBufferAttribute(morphAttribute, c);
            if (morphTargetsRelative) {
                _morphA.addScaledVector(_tempA, influence);
                _morphB.addScaledVector(_tempB, influence);
                _morphC.addScaledVector(_tempC, influence);
            } else {
                _morphA.addScaledVector(_tempA.sub(_vA), influence);
                _morphB.addScaledVector(_tempB.sub(_vB), influence);
                _morphC.addScaledVector(_tempC.sub(_vC), influence);
            }
        }
        _vA.add(_morphA);
        _vB.add(_morphB);
        _vC.add(_morphC);
    }
    if (object.isSkinnedMesh) {
        object.boneTransform(a, _vA);
        object.boneTransform(b, _vB);
        object.boneTransform(c, _vC);
    }
    const intersection = checkIntersection(object, material, raycaster, ray, _vA, _vB, _vC, _intersectionPoint);
    if (intersection) {
        if (uv) {
            _uvA.fromBufferAttribute(uv, a);
            _uvB.fromBufferAttribute(uv, b);
            _uvC.fromBufferAttribute(uv, c);
            intersection.uv = Triangle.getUV(_intersectionPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2());
        }
        if (uv2) {
            _uvA.fromBufferAttribute(uv2, a);
            _uvB.fromBufferAttribute(uv2, b);
            _uvC.fromBufferAttribute(uv2, c);
            intersection.uv2 = Triangle.getUV(_intersectionPoint, _vA, _vB, _vC, _uvA, _uvB, _uvC, new Vector2());
        }
        const face = new Face3(a, b, c);
        Triangle.getNormal(_vA, _vB, _vC, face.normal);
        intersection.face = face;
    }
    return intersection;
}
class BoxGeometry extends BufferGeometry {
    constructor(width = 1, height = 1, depth = 1, widthSegments = 1, heightSegments = 1, depthSegments = 1){
        super();
        this.type = 'BoxGeometry';
        this.parameters = {
            width: width,
            height: height,
            depth: depth,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            depthSegments: depthSegments
        };
        const scope = this;
        // segments
        widthSegments = Math.floor(widthSegments);
        heightSegments = Math.floor(heightSegments);
        depthSegments = Math.floor(depthSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let numberOfVertices = 0;
        let groupStart = 0;
        // build each side of the box geometry
        buildPlane('z', 'y', 'x', -1, -1, depth, height, width, depthSegments, heightSegments, 0); // px
        buildPlane('z', 'y', 'x', 1, -1, depth, height, -width, depthSegments, heightSegments, 1); // nx
        buildPlane('x', 'z', 'y', 1, 1, width, depth, height, widthSegments, depthSegments, 2); // py
        buildPlane('x', 'z', 'y', 1, -1, width, depth, -height, widthSegments, depthSegments, 3); // ny
        buildPlane('x', 'y', 'z', 1, -1, width, height, depth, widthSegments, heightSegments, 4); // pz
        buildPlane('x', 'y', 'z', -1, -1, width, height, -depth, widthSegments, heightSegments, 5); // nz
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        function buildPlane(u, v, w, udir, vdir, width, height, depth, gridX, gridY, materialIndex) {
            const segmentWidth = width / gridX;
            const segmentHeight = height / gridY;
            const widthHalf = width / 2;
            const heightHalf = height / 2;
            const depthHalf = depth / 2;
            const gridX1 = gridX + 1;
            const gridY1 = gridY + 1;
            let vertexCounter = 0;
            let groupCount = 0;
            const vector = new Vector3();
            // generate vertices, normals and uvs
            for(let iy = 0; iy < gridY1; iy++){
                const y = iy * segmentHeight - heightHalf;
                for(let ix = 0; ix < gridX1; ix++){
                    const x = ix * segmentWidth - widthHalf;
                    // set values to correct vector component
                    vector[u] = x * udir;
                    vector[v] = y * vdir;
                    vector[w] = depthHalf;
                    // now apply vector to vertex buffer
                    vertices.push(vector.x, vector.y, vector.z);
                    // set values to correct vector component
                    vector[u] = 0;
                    vector[v] = 0;
                    vector[w] = depth > 0 ? 1 : -1;
                    // now apply vector to normal buffer
                    normals.push(vector.x, vector.y, vector.z);
                    // uvs
                    uvs.push(ix / gridX);
                    uvs.push(1 - iy / gridY);
                    // counters
                    vertexCounter += 1;
                }
            }
            // indices
            // 1. you need three indices to draw a single face
            // 2. a single segment consists of two faces
            // 3. so we need to generate six (2*3) indices per segment
            for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
                const a = numberOfVertices + ix + gridX1 * iy;
                const b = numberOfVertices + ix + gridX1 * (iy + 1);
                const c = numberOfVertices + (ix + 1) + gridX1 * (iy + 1);
                const d = numberOfVertices + (ix + 1) + gridX1 * iy;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // increase counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, materialIndex);
            // calculate new start value for groups
            groupStart += groupCount;
            // update total number of vertices
            numberOfVertices += vertexCounter;
        }
    }
}
/**
 * Uniform Utilities
 */ function cloneUniforms(src) {
    const dst = {};
    for(const u in src){
        dst[u] = {};
        for(const p in src[u]){
            const property = src[u][p];
            if (property && (property.isColor || property.isMatrix3 || property.isMatrix4 || property.isVector2 || property.isVector3 || property.isVector4 || property.isTexture)) dst[u][p] = property.clone();
            else if (Array.isArray(property)) dst[u][p] = property.slice();
            else dst[u][p] = property;
        }
    }
    return dst;
}
function mergeUniforms(uniforms) {
    const merged = {};
    for(let u = 0; u < uniforms.length; u++){
        const tmp = cloneUniforms(uniforms[u]);
        for(const p in tmp)merged[p] = tmp[p];
    }
    return merged;
}
// Legacy
const UniformsUtils = {
    clone: cloneUniforms,
    merge: mergeUniforms
};
var default_vertex = "void main() {\n\tgl_Position = projectionMatrix * modelViewMatrix * vec4( position, 1.0 );\n}";
var default_fragment = "void main() {\n\tgl_FragColor = vec4( 1.0, 0.0, 0.0, 1.0 );\n}";
/**
 * parameters = {
 *  defines: { "label" : "value" },
 *  uniforms: { "parameter1": { value: 1.0 }, "parameter2": { value2: 2 } },
 *
 *  fragmentShader: <string>,
 *  vertexShader: <string>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  lights: <bool>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function ShaderMaterial(parameters) {
    Material.call(this);
    this.type = 'ShaderMaterial';
    this.defines = {};
    this.uniforms = {};
    this.vertexShader = default_vertex;
    this.fragmentShader = default_fragment;
    this.linewidth = 1;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false; // set to use scene fog
    this.lights = false; // set to use scene lights
    this.clipping = false; // set to use user-defined clipping planes
    this.skinning = false; // set to use skinning attribute streams
    this.morphTargets = false; // set to use morph targets
    this.morphNormals = false; // set to use morph normals
    this.extensions = {
        derivatives: false,
        fragDepth: false,
        drawBuffers: false,
        shaderTextureLOD: false // set to use shader texture LOD
    };
    // When rendered geometry doesn't include these attributes but the material does,
    // use these default values in WebGL. This avoids errors when buffer data is missing.
    this.defaultAttributeValues = {
        'color': [
            1,
            1,
            1
        ],
        'uv': [
            0,
            0
        ],
        'uv2': [
            0,
            0
        ]
    };
    this.index0AttributeName = undefined;
    this.uniformsNeedUpdate = false;
    this.glslVersion = null;
    if (parameters !== undefined) {
        if (parameters.attributes !== undefined) console.error('THREE.ShaderMaterial: attributes should now be defined in THREE.BufferGeometry instead.');
        this.setValues(parameters);
    }
}
ShaderMaterial.prototype = Object.create(Material.prototype);
ShaderMaterial.prototype.constructor = ShaderMaterial;
ShaderMaterial.prototype.isShaderMaterial = true;
ShaderMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.fragmentShader = source.fragmentShader;
    this.vertexShader = source.vertexShader;
    this.uniforms = cloneUniforms(source.uniforms);
    this.defines = Object.assign({}, source.defines);
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.lights = source.lights;
    this.clipping = source.clipping;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    this.extensions = Object.assign({}, source.extensions);
    this.glslVersion = source.glslVersion;
    return this;
};
ShaderMaterial.prototype.toJSON = function(meta) {
    const data = Material.prototype.toJSON.call(this, meta);
    data.glslVersion = this.glslVersion;
    data.uniforms = {};
    for(const name in this.uniforms){
        const uniform = this.uniforms[name];
        const value = uniform.value;
        if (value && value.isTexture) data.uniforms[name] = {
            type: 't',
            value: value.toJSON(meta).uuid
        };
        else if (value && value.isColor) data.uniforms[name] = {
            type: 'c',
            value: value.getHex()
        };
        else if (value && value.isVector2) data.uniforms[name] = {
            type: 'v2',
            value: value.toArray()
        };
        else if (value && value.isVector3) data.uniforms[name] = {
            type: 'v3',
            value: value.toArray()
        };
        else if (value && value.isVector4) data.uniforms[name] = {
            type: 'v4',
            value: value.toArray()
        };
        else if (value && value.isMatrix3) data.uniforms[name] = {
            type: 'm3',
            value: value.toArray()
        };
        else if (value && value.isMatrix4) data.uniforms[name] = {
            type: 'm4',
            value: value.toArray()
        };
        else data.uniforms[name] = {
            value: value
        };
    }
    if (Object.keys(this.defines).length > 0) data.defines = this.defines;
    data.vertexShader = this.vertexShader;
    data.fragmentShader = this.fragmentShader;
    const extensions = {};
    for(const key in this.extensions)if (this.extensions[key] === true) extensions[key] = true;
    if (Object.keys(extensions).length > 0) data.extensions = extensions;
    return data;
};
function Camera() {
    Object3D.call(this);
    this.type = 'Camera';
    this.matrixWorldInverse = new Matrix4();
    this.projectionMatrix = new Matrix4();
    this.projectionMatrixInverse = new Matrix4();
}
Camera.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Camera,
    isCamera: true,
    copy: function(source, recursive) {
        Object3D.prototype.copy.call(this, source, recursive);
        this.matrixWorldInverse.copy(source.matrixWorldInverse);
        this.projectionMatrix.copy(source.projectionMatrix);
        this.projectionMatrixInverse.copy(source.projectionMatrixInverse);
        return this;
    },
    getWorldDirection: function(target) {
        if (target === undefined) {
            console.warn('THREE.Camera: .getWorldDirection() target is now required');
            target = new Vector3();
        }
        this.updateWorldMatrix(true, false);
        const e = this.matrixWorld.elements;
        return target.set(-e[8], -e[9], -e[10]).normalize();
    },
    updateMatrixWorld: function(force) {
        Object3D.prototype.updateMatrixWorld.call(this, force);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    },
    updateWorldMatrix: function(updateParents, updateChildren) {
        Object3D.prototype.updateWorldMatrix.call(this, updateParents, updateChildren);
        this.matrixWorldInverse.copy(this.matrixWorld).invert();
    },
    clone: function() {
        return new this.constructor().copy(this);
    }
});
function PerspectiveCamera(fov = 50, aspect = 1, near = 0.1, far = 2000) {
    Camera.call(this);
    this.type = 'PerspectiveCamera';
    this.fov = fov;
    this.zoom = 1;
    this.near = near;
    this.far = far;
    this.focus = 10;
    this.aspect = aspect;
    this.view = null;
    this.filmGauge = 35; // width of the film (default in millimeters)
    this.filmOffset = 0; // horizontal film offset (same unit as gauge)
    this.updateProjectionMatrix();
}
PerspectiveCamera.prototype = Object.assign(Object.create(Camera.prototype), {
    constructor: PerspectiveCamera,
    isPerspectiveCamera: true,
    copy: function(source, recursive) {
        Camera.prototype.copy.call(this, source, recursive);
        this.fov = source.fov;
        this.zoom = source.zoom;
        this.near = source.near;
        this.far = source.far;
        this.focus = source.focus;
        this.aspect = source.aspect;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        this.filmGauge = source.filmGauge;
        this.filmOffset = source.filmOffset;
        return this;
    },
    /**
	 * Sets the FOV by focal length in respect to the current .filmGauge.
	 *
	 * The default film gauge is 35, so that the focal length can be specified for
	 * a 35mm (full frame) camera.
	 *
	 * Values for focal length and film gauge must have the same unit.
	 */ setFocalLength: function(focalLength) {
        /** see {@link http://www.bobatkins.com/photography/technical/field_of_view.html} */ const vExtentSlope = 0.5 * this.getFilmHeight() / focalLength;
        this.fov = MathUtils.RAD2DEG * 2 * Math.atan(vExtentSlope);
        this.updateProjectionMatrix();
    },
    /**
	 * Calculates the focal length from the current .fov and .filmGauge.
	 */ getFocalLength: function() {
        const vExtentSlope = Math.tan(MathUtils.DEG2RAD * 0.5 * this.fov);
        return 0.5 * this.getFilmHeight() / vExtentSlope;
    },
    getEffectiveFOV: function() {
        return MathUtils.RAD2DEG * 2 * Math.atan(Math.tan(MathUtils.DEG2RAD * 0.5 * this.fov) / this.zoom);
    },
    getFilmWidth: function() {
        // film not completely covered in portrait format (aspect < 1)
        return this.filmGauge * Math.min(this.aspect, 1);
    },
    getFilmHeight: function() {
        // film not completely covered in landscape format (aspect > 1)
        return this.filmGauge / Math.max(this.aspect, 1);
    },
    /**
	 * Sets an offset in a larger frustum. This is useful for multi-window or
	 * multi-monitor/multi-machine setups.
	 *
	 * For example, if you have 3x2 monitors and each monitor is 1920x1080 and
	 * the monitors are in grid like this
	 *
	 *   +---+---+---+
	 *   | A | B | C |
	 *   +---+---+---+
	 *   | D | E | F |
	 *   +---+---+---+
	 *
	 * then for each monitor you would call it like this
	 *
	 *   const w = 1920;
	 *   const h = 1080;
	 *   const fullWidth = w * 3;
	 *   const fullHeight = h * 2;
	 *
	 *   --A--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 0, w, h );
	 *   --B--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 0, w, h );
	 *   --C--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 0, w, h );
	 *   --D--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 0, h * 1, w, h );
	 *   --E--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 1, h * 1, w, h );
	 *   --F--
	 *   camera.setViewOffset( fullWidth, fullHeight, w * 2, h * 1, w, h );
	 *
	 *   Note there is no reason monitors have to be the same size or in a grid.
	 */ setViewOffset: function(fullWidth, fullHeight, x, y, width, height) {
        this.aspect = fullWidth / fullHeight;
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    },
    clearViewOffset: function() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    },
    updateProjectionMatrix: function() {
        const near = this.near;
        let top = near * Math.tan(MathUtils.DEG2RAD * 0.5 * this.fov) / this.zoom;
        let height = 2 * top;
        let width = this.aspect * height;
        let left = -0.5 * width;
        const view = this.view;
        if (this.view !== null && this.view.enabled) {
            const fullWidth = view.fullWidth, fullHeight = view.fullHeight;
            left += view.offsetX * width / fullWidth;
            top -= view.offsetY * height / fullHeight;
            width *= view.width / fullWidth;
            height *= view.height / fullHeight;
        }
        const skew = this.filmOffset;
        if (skew !== 0) left += near * skew / this.getFilmWidth();
        this.projectionMatrix.makePerspective(left, left + width, top, top - height, near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    },
    toJSON: function(meta) {
        const data = Object3D.prototype.toJSON.call(this, meta);
        data.object.fov = this.fov;
        data.object.zoom = this.zoom;
        data.object.near = this.near;
        data.object.far = this.far;
        data.object.focus = this.focus;
        data.object.aspect = this.aspect;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        data.object.filmGauge = this.filmGauge;
        data.object.filmOffset = this.filmOffset;
        return data;
    }
});
const fov = 90, aspect = 1;
function CubeCamera(near, far, renderTarget) {
    Object3D.call(this);
    this.type = 'CubeCamera';
    if (renderTarget.isWebGLCubeRenderTarget !== true) {
        console.error('THREE.CubeCamera: The constructor now expects an instance of WebGLCubeRenderTarget as third parameter.');
        return;
    }
    this.renderTarget = renderTarget;
    const cameraPX = new PerspectiveCamera(fov, aspect, near, far);
    cameraPX.layers = this.layers;
    cameraPX.up.set(0, -1, 0);
    cameraPX.lookAt(new Vector3(1, 0, 0));
    this.add(cameraPX);
    const cameraNX = new PerspectiveCamera(fov, aspect, near, far);
    cameraNX.layers = this.layers;
    cameraNX.up.set(0, -1, 0);
    cameraNX.lookAt(new Vector3(-1, 0, 0));
    this.add(cameraNX);
    const cameraPY = new PerspectiveCamera(fov, aspect, near, far);
    cameraPY.layers = this.layers;
    cameraPY.up.set(0, 0, 1);
    cameraPY.lookAt(new Vector3(0, 1, 0));
    this.add(cameraPY);
    const cameraNY = new PerspectiveCamera(fov, aspect, near, far);
    cameraNY.layers = this.layers;
    cameraNY.up.set(0, 0, -1);
    cameraNY.lookAt(new Vector3(0, -1, 0));
    this.add(cameraNY);
    const cameraPZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraPZ.layers = this.layers;
    cameraPZ.up.set(0, -1, 0);
    cameraPZ.lookAt(new Vector3(0, 0, 1));
    this.add(cameraPZ);
    const cameraNZ = new PerspectiveCamera(fov, aspect, near, far);
    cameraNZ.layers = this.layers;
    cameraNZ.up.set(0, -1, 0);
    cameraNZ.lookAt(new Vector3(0, 0, -1));
    this.add(cameraNZ);
    this.update = function(renderer, scene) {
        if (this.parent === null) this.updateMatrixWorld();
        const currentXrEnabled = renderer.xr.enabled;
        const currentRenderTarget = renderer.getRenderTarget();
        renderer.xr.enabled = false;
        const generateMipmaps = renderTarget.texture.generateMipmaps;
        renderTarget.texture.generateMipmaps = false;
        renderer.setRenderTarget(renderTarget, 0);
        renderer.render(scene, cameraPX);
        renderer.setRenderTarget(renderTarget, 1);
        renderer.render(scene, cameraNX);
        renderer.setRenderTarget(renderTarget, 2);
        renderer.render(scene, cameraPY);
        renderer.setRenderTarget(renderTarget, 3);
        renderer.render(scene, cameraNY);
        renderer.setRenderTarget(renderTarget, 4);
        renderer.render(scene, cameraPZ);
        renderTarget.texture.generateMipmaps = generateMipmaps;
        renderer.setRenderTarget(renderTarget, 5);
        renderer.render(scene, cameraNZ);
        renderer.setRenderTarget(currentRenderTarget);
        renderer.xr.enabled = currentXrEnabled;
    };
}
CubeCamera.prototype = Object.create(Object3D.prototype);
CubeCamera.prototype.constructor = CubeCamera;
function CubeTexture(images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding) {
    images = images !== undefined ? images : [];
    mapping = mapping !== undefined ? mapping : CubeReflectionMapping;
    format = format !== undefined ? format : RGBFormat;
    Texture.call(this, images, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.flipY = false;
    // Why CubeTexture._needsFlipEnvMap is necessary:
    //
    // By convention -- likely based on the RenderMan spec from the 1990's -- cube maps are specified by WebGL (and three.js)
    // in a coordinate system in which positive-x is to the right when looking up the positive-z axis -- in other words,
    // in a left-handed coordinate system. By continuing this convention, preexisting cube maps continued to render correctly.
    // three.js uses a right-handed coordinate system. So environment maps used in three.js appear to have px and nx swapped
    // and the flag _needsFlipEnvMap controls this conversion. The flip is not required (and thus _needsFlipEnvMap is set to false)
    // when using WebGLCubeRenderTarget.texture as a cube texture.
    this._needsFlipEnvMap = true;
}
CubeTexture.prototype = Object.create(Texture.prototype);
CubeTexture.prototype.constructor = CubeTexture;
CubeTexture.prototype.isCubeTexture = true;
Object.defineProperty(CubeTexture.prototype, 'images', {
    get: function() {
        return this.image;
    },
    set: function(value) {
        this.image = value;
    }
});
class WebGLCubeRenderTarget extends WebGLRenderTarget {
    constructor(size, options, dummy){
        if (Number.isInteger(options)) {
            console.warn('THREE.WebGLCubeRenderTarget: constructor signature is now WebGLCubeRenderTarget( size, options )');
            options = dummy;
        }
        super(size, size, options);
        Object.defineProperty(this, 'isWebGLCubeRenderTarget', {
            value: true
        });
        options = options || {};
        this.texture = new CubeTexture(undefined, options.mapping, options.wrapS, options.wrapT, options.magFilter, options.minFilter, options.format, options.type, options.anisotropy, options.encoding);
        this.texture._needsFlipEnvMap = false;
    }
    fromEquirectangularTexture(renderer, texture) {
        this.texture.type = texture.type;
        this.texture.format = RGBAFormat; // see #18859
        this.texture.encoding = texture.encoding;
        this.texture.generateMipmaps = texture.generateMipmaps;
        this.texture.minFilter = texture.minFilter;
        this.texture.magFilter = texture.magFilter;
        const shader = {
            uniforms: {
                tEquirect: {
                    value: null
                }
            },
            vertexShader: /* glsl */ `

				varying vec3 vWorldDirection;

				vec3 transformDirection( in vec3 dir, in mat4 matrix ) {

					return normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );

				}

				void main() {

					vWorldDirection = transformDirection( position, modelMatrix );

					#include <begin_vertex>
					#include <project_vertex>

				}
			`,
            fragmentShader: /* glsl */ `

				uniform sampler2D tEquirect;

				varying vec3 vWorldDirection;

				#include <common>

				void main() {

					vec3 direction = normalize( vWorldDirection );

					vec2 sampleUV = equirectUv( direction );

					gl_FragColor = texture2D( tEquirect, sampleUV );

				}
			`
        };
        const geometry = new BoxGeometry(5, 5, 5);
        const material = new ShaderMaterial({
            name: 'CubemapFromEquirect',
            uniforms: cloneUniforms(shader.uniforms),
            vertexShader: shader.vertexShader,
            fragmentShader: shader.fragmentShader,
            side: BackSide,
            blending: NoBlending
        });
        material.uniforms.tEquirect.value = texture;
        const mesh = new Mesh(geometry, material);
        const currentMinFilter = texture.minFilter;
        // Avoid blurred poles
        if (texture.minFilter === LinearMipmapLinearFilter) texture.minFilter = LinearFilter;
        const camera = new CubeCamera(1, 10, this);
        camera.update(renderer, mesh);
        texture.minFilter = currentMinFilter;
        mesh.geometry.dispose();
        mesh.material.dispose();
        return this;
    }
    clear(renderer, color, depth, stencil) {
        const currentRenderTarget = renderer.getRenderTarget();
        for(let i = 0; i < 6; i++){
            renderer.setRenderTarget(this, i);
            renderer.clear(color, depth, stencil);
        }
        renderer.setRenderTarget(currentRenderTarget);
    }
}
function DataTexture(data, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    Texture.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = {
        data: data || null,
        width: width || 1,
        height: height || 1
    };
    this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
    this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
    this.generateMipmaps = false;
    this.flipY = false;
    this.unpackAlignment = 1;
    this.needsUpdate = true;
}
DataTexture.prototype = Object.create(Texture.prototype);
DataTexture.prototype.constructor = DataTexture;
DataTexture.prototype.isDataTexture = true;
const _sphere$1 = /*@__PURE__*/ new Sphere();
const _vector$5 = /*@__PURE__*/ new Vector3();
class Frustum {
    constructor(p0, p1, p2, p3, p4, p5){
        this.planes = [
            p0 !== undefined ? p0 : new Plane(),
            p1 !== undefined ? p1 : new Plane(),
            p2 !== undefined ? p2 : new Plane(),
            p3 !== undefined ? p3 : new Plane(),
            p4 !== undefined ? p4 : new Plane(),
            p5 !== undefined ? p5 : new Plane()
        ];
    }
    set(p0, p1, p2, p3, p4, p5) {
        const planes = this.planes;
        planes[0].copy(p0);
        planes[1].copy(p1);
        planes[2].copy(p2);
        planes[3].copy(p3);
        planes[4].copy(p4);
        planes[5].copy(p5);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(frustum) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++)planes[i].copy(frustum.planes[i]);
        return this;
    }
    setFromProjectionMatrix(m) {
        const planes = this.planes;
        const me = m.elements;
        const me0 = me[0], me1 = me[1], me2 = me[2], me3 = me[3];
        const me4 = me[4], me5 = me[5], me6 = me[6], me7 = me[7];
        const me8 = me[8], me9 = me[9], me10 = me[10], me11 = me[11];
        const me12 = me[12], me13 = me[13], me14 = me[14], me15 = me[15];
        planes[0].setComponents(me3 - me0, me7 - me4, me11 - me8, me15 - me12).normalize();
        planes[1].setComponents(me3 + me0, me7 + me4, me11 + me8, me15 + me12).normalize();
        planes[2].setComponents(me3 + me1, me7 + me5, me11 + me9, me15 + me13).normalize();
        planes[3].setComponents(me3 - me1, me7 - me5, me11 - me9, me15 - me13).normalize();
        planes[4].setComponents(me3 - me2, me7 - me6, me11 - me10, me15 - me14).normalize();
        planes[5].setComponents(me3 + me2, me7 + me6, me11 + me10, me15 + me14).normalize();
        return this;
    }
    intersectsObject(object) {
        const geometry = object.geometry;
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$1.copy(geometry.boundingSphere).applyMatrix4(object.matrixWorld);
        return this.intersectsSphere(_sphere$1);
    }
    intersectsSprite(sprite) {
        _sphere$1.center.set(0, 0, 0);
        _sphere$1.radius = 0.7071067811865476;
        _sphere$1.applyMatrix4(sprite.matrixWorld);
        return this.intersectsSphere(_sphere$1);
    }
    intersectsSphere(sphere) {
        const planes = this.planes;
        const center = sphere.center;
        const negRadius = -sphere.radius;
        for(let i = 0; i < 6; i++){
            const distance = planes[i].distanceToPoint(center);
            if (distance < negRadius) return false;
        }
        return true;
    }
    intersectsBox(box) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            const plane = planes[i];
            // corner at max distance
            _vector$5.x = plane.normal.x > 0 ? box.max.x : box.min.x;
            _vector$5.y = plane.normal.y > 0 ? box.max.y : box.min.y;
            _vector$5.z = plane.normal.z > 0 ? box.max.z : box.min.z;
            if (plane.distanceToPoint(_vector$5) < 0) return false;
        }
        return true;
    }
    containsPoint(point) {
        const planes = this.planes;
        for(let i = 0; i < 6; i++){
            if (planes[i].distanceToPoint(point) < 0) return false;
        }
        return true;
    }
}
function WebGLAnimation() {
    let context = null;
    let isAnimating = false;
    let animationLoop = null;
    let requestId = null;
    function onAnimationFrame(time, frame) {
        animationLoop(time, frame);
        requestId = context.requestAnimationFrame(onAnimationFrame);
    }
    return {
        start: function() {
            if (isAnimating === true) return;
            if (animationLoop === null) return;
            requestId = context.requestAnimationFrame(onAnimationFrame);
            isAnimating = true;
        },
        stop: function() {
            context.cancelAnimationFrame(requestId);
            isAnimating = false;
        },
        setAnimationLoop: function(callback) {
            animationLoop = callback;
        },
        setContext: function(value) {
            context = value;
        }
    };
}
function WebGLAttributes(gl, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    const buffers = new WeakMap();
    function createBuffer(attribute, bufferType) {
        const array = attribute.array;
        const usage = attribute.usage;
        const buffer = gl.createBuffer();
        gl.bindBuffer(bufferType, buffer);
        gl.bufferData(bufferType, array, usage);
        attribute.onUploadCallback();
        let type = 5126;
        if (array instanceof Float32Array) type = 5126;
        else if (array instanceof Float64Array) console.warn('THREE.WebGLAttributes: Unsupported data buffer format: Float64Array.');
        else if (array instanceof Uint16Array) {
            if (attribute.isFloat16BufferAttribute) {
                if (isWebGL2) type = 5131;
                else console.warn('THREE.WebGLAttributes: Usage of Float16BufferAttribute requires WebGL2.');
            } else type = 5123;
        } else if (array instanceof Int16Array) type = 5122;
        else if (array instanceof Uint32Array) type = 5125;
        else if (array instanceof Int32Array) type = 5124;
        else if (array instanceof Int8Array) type = 5120;
        else if (array instanceof Uint8Array) type = 5121;
        return {
            buffer: buffer,
            type: type,
            bytesPerElement: array.BYTES_PER_ELEMENT,
            version: attribute.version
        };
    }
    function updateBuffer(buffer, attribute, bufferType) {
        const array = attribute.array;
        const updateRange = attribute.updateRange;
        gl.bindBuffer(bufferType, buffer);
        if (updateRange.count === -1) // Not using update ranges
        gl.bufferSubData(bufferType, 0, array);
        else {
            if (isWebGL2) gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array, updateRange.offset, updateRange.count);
            else gl.bufferSubData(bufferType, updateRange.offset * array.BYTES_PER_ELEMENT, array.subarray(updateRange.offset, updateRange.offset + updateRange.count));
            updateRange.count = -1; // reset range
        }
    }
    //
    function get(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        return buffers.get(attribute);
    }
    function remove(attribute) {
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data) {
            gl.deleteBuffer(data.buffer);
            buffers.delete(attribute);
        }
    }
    function update(attribute, bufferType) {
        if (attribute.isGLBufferAttribute) {
            const cached = buffers.get(attribute);
            if (!cached || cached.version < attribute.version) buffers.set(attribute, {
                buffer: attribute.buffer,
                type: attribute.type,
                bytesPerElement: attribute.elementSize,
                version: attribute.version
            });
            return;
        }
        if (attribute.isInterleavedBufferAttribute) attribute = attribute.data;
        const data = buffers.get(attribute);
        if (data === undefined) buffers.set(attribute, createBuffer(attribute, bufferType));
        else if (data.version < attribute.version) {
            updateBuffer(data.buffer, attribute, bufferType);
            data.version = attribute.version;
        }
    }
    return {
        get: get,
        remove: remove,
        update: update
    };
}
class PlaneGeometry extends BufferGeometry {
    constructor(width = 1, height = 1, widthSegments = 1, heightSegments = 1){
        super();
        this.type = 'PlaneGeometry';
        this.parameters = {
            width: width,
            height: height,
            widthSegments: widthSegments,
            heightSegments: heightSegments
        };
        const width_half = width / 2;
        const height_half = height / 2;
        const gridX = Math.floor(widthSegments);
        const gridY = Math.floor(heightSegments);
        const gridX1 = gridX + 1;
        const gridY1 = gridY + 1;
        const segment_width = width / gridX;
        const segment_height = height / gridY;
        //
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        for(let iy = 0; iy < gridY1; iy++){
            const y = iy * segment_height - height_half;
            for(let ix = 0; ix < gridX1; ix++){
                const x = ix * segment_width - width_half;
                vertices.push(x, -y, 0);
                normals.push(0, 0, 1);
                uvs.push(ix / gridX);
                uvs.push(1 - iy / gridY);
            }
        }
        for(let iy = 0; iy < gridY; iy++)for(let ix = 0; ix < gridX; ix++){
            const a = ix + gridX1 * iy;
            const b = ix + gridX1 * (iy + 1);
            const c = ix + 1 + gridX1 * (iy + 1);
            const d = ix + 1 + gridX1 * iy;
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
var alphamap_fragment = "#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, vUv ).g;\n#endif";
var alphamap_pars_fragment = "#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var alphatest_fragment = "#ifdef ALPHATEST\n\tif ( diffuseColor.a < ALPHATEST ) discard;\n#endif";
var aomap_fragment = "#ifdef USE_AOMAP\n\tfloat ambientOcclusion = ( texture2D( aoMap, vUv2 ).r - 1.0 ) * aoMapIntensity + 1.0;\n\treflectedLight.indirectDiffuse *= ambientOcclusion;\n\t#if defined( USE_ENVMAP ) && defined( STANDARD )\n\t\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular *= computeSpecularOcclusion( dotNV, ambientOcclusion, material.specularRoughness );\n\t#endif\n#endif";
var aomap_pars_fragment = "#ifdef USE_AOMAP\n\tuniform sampler2D aoMap;\n\tuniform float aoMapIntensity;\n#endif";
var begin_vertex = "vec3 transformed = vec3( position );";
var beginnormal_vertex = "vec3 objectNormal = vec3( normal );\n#ifdef USE_TANGENT\n\tvec3 objectTangent = vec3( tangent.xyz );\n#endif";
var bsdfs = "vec2 integrateSpecularBRDF( const in float dotNV, const in float roughness ) {\n\tconst vec4 c0 = vec4( - 1, - 0.0275, - 0.572, 0.022 );\n\tconst vec4 c1 = vec4( 1, 0.0425, 1.04, - 0.04 );\n\tvec4 r = roughness * c0 + c1;\n\tfloat a004 = min( r.x * r.x, exp2( - 9.28 * dotNV ) ) * r.x + r.y;\n\treturn vec2( -1.04, 1.04 ) * a004 + r.zw;\n}\nfloat punctualLightIntensityToIrradianceFactor( const in float lightDistance, const in float cutoffDistance, const in float decayExponent ) {\n#if defined ( PHYSICALLY_CORRECT_LIGHTS )\n\tfloat distanceFalloff = 1.0 / max( pow( lightDistance, decayExponent ), 0.01 );\n\tif( cutoffDistance > 0.0 ) {\n\t\tdistanceFalloff *= pow2( saturate( 1.0 - pow4( lightDistance / cutoffDistance ) ) );\n\t}\n\treturn distanceFalloff;\n#else\n\tif( cutoffDistance > 0.0 && decayExponent > 0.0 ) {\n\t\treturn pow( saturate( -lightDistance / cutoffDistance + 1.0 ), decayExponent );\n\t}\n\treturn 1.0;\n#endif\n}\nvec3 BRDF_Diffuse_Lambert( const in vec3 diffuseColor ) {\n\treturn RECIPROCAL_PI * diffuseColor;\n}\nvec3 F_Schlick( const in vec3 specularColor, const in float dotLH ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotLH - 6.98316 ) * dotLH );\n\treturn ( 1.0 - specularColor ) * fresnel + specularColor;\n}\nvec3 F_Schlick_RoughnessDependent( const in vec3 F0, const in float dotNV, const in float roughness ) {\n\tfloat fresnel = exp2( ( -5.55473 * dotNV - 6.98316 ) * dotNV );\n\tvec3 Fr = max( vec3( 1.0 - roughness ), F0 ) - F0;\n\treturn Fr * fresnel + F0;\n}\nfloat G_GGX_Smith( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gl = dotNL + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\tfloat gv = dotNV + sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\treturn 1.0 / ( gl * gv );\n}\nfloat G_GGX_SmithCorrelated( const in float alpha, const in float dotNL, const in float dotNV ) {\n\tfloat a2 = pow2( alpha );\n\tfloat gv = dotNL * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNV ) );\n\tfloat gl = dotNV * sqrt( a2 + ( 1.0 - a2 ) * pow2( dotNL ) );\n\treturn 0.5 / max( gv + gl, EPSILON );\n}\nfloat D_GGX( const in float alpha, const in float dotNH ) {\n\tfloat a2 = pow2( alpha );\n\tfloat denom = pow2( dotNH ) * ( a2 - 1.0 ) + 1.0;\n\treturn RECIPROCAL_PI * a2 / pow2( denom );\n}\nvec3 BRDF_Specular_GGX( const in IncidentLight incidentLight, const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat alpha = pow2( roughness );\n\tvec3 halfDir = normalize( incidentLight.direction + viewDir );\n\tfloat dotNL = saturate( dot( normal, incidentLight.direction ) );\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tfloat dotNH = saturate( dot( normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_GGX_SmithCorrelated( alpha, dotNL, dotNV );\n\tfloat D = D_GGX( alpha, dotNH );\n\treturn F * ( G * D );\n}\nvec2 LTC_Uv( const in vec3 N, const in vec3 V, const in float roughness ) {\n\tconst float LUT_SIZE = 64.0;\n\tconst float LUT_SCALE = ( LUT_SIZE - 1.0 ) / LUT_SIZE;\n\tconst float LUT_BIAS = 0.5 / LUT_SIZE;\n\tfloat dotNV = saturate( dot( N, V ) );\n\tvec2 uv = vec2( roughness, sqrt( 1.0 - dotNV ) );\n\tuv = uv * LUT_SCALE + LUT_BIAS;\n\treturn uv;\n}\nfloat LTC_ClippedSphereFormFactor( const in vec3 f ) {\n\tfloat l = length( f );\n\treturn max( ( l * l + f.z ) / ( l + 1.0 ), 0.0 );\n}\nvec3 LTC_EdgeVectorFormFactor( const in vec3 v1, const in vec3 v2 ) {\n\tfloat x = dot( v1, v2 );\n\tfloat y = abs( x );\n\tfloat a = 0.8543985 + ( 0.4965155 + 0.0145206 * y ) * y;\n\tfloat b = 3.4175940 + ( 4.1616724 + y ) * y;\n\tfloat v = a / b;\n\tfloat theta_sintheta = ( x > 0.0 ) ? v : 0.5 * inversesqrt( max( 1.0 - x * x, 1e-7 ) ) - v;\n\treturn cross( v1, v2 ) * theta_sintheta;\n}\nvec3 LTC_Evaluate( const in vec3 N, const in vec3 V, const in vec3 P, const in mat3 mInv, const in vec3 rectCoords[ 4 ] ) {\n\tvec3 v1 = rectCoords[ 1 ] - rectCoords[ 0 ];\n\tvec3 v2 = rectCoords[ 3 ] - rectCoords[ 0 ];\n\tvec3 lightNormal = cross( v1, v2 );\n\tif( dot( lightNormal, P - rectCoords[ 0 ] ) < 0.0 ) return vec3( 0.0 );\n\tvec3 T1, T2;\n\tT1 = normalize( V - N * dot( V, N ) );\n\tT2 = - cross( N, T1 );\n\tmat3 mat = mInv * transposeMat3( mat3( T1, T2, N ) );\n\tvec3 coords[ 4 ];\n\tcoords[ 0 ] = mat * ( rectCoords[ 0 ] - P );\n\tcoords[ 1 ] = mat * ( rectCoords[ 1 ] - P );\n\tcoords[ 2 ] = mat * ( rectCoords[ 2 ] - P );\n\tcoords[ 3 ] = mat * ( rectCoords[ 3 ] - P );\n\tcoords[ 0 ] = normalize( coords[ 0 ] );\n\tcoords[ 1 ] = normalize( coords[ 1 ] );\n\tcoords[ 2 ] = normalize( coords[ 2 ] );\n\tcoords[ 3 ] = normalize( coords[ 3 ] );\n\tvec3 vectorFormFactor = vec3( 0.0 );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 0 ], coords[ 1 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 1 ], coords[ 2 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 2 ], coords[ 3 ] );\n\tvectorFormFactor += LTC_EdgeVectorFormFactor( coords[ 3 ], coords[ 0 ] );\n\tfloat result = LTC_ClippedSphereFormFactor( vectorFormFactor );\n\treturn vec3( result );\n}\nvec3 BRDF_Specular_GGX_Environment( const in vec3 viewDir, const in vec3 normal, const in vec3 specularColor, const in float roughness ) {\n\tfloat dotNV = saturate( dot( normal, viewDir ) );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\treturn specularColor * brdf.x + brdf.y;\n}\nvoid BRDF_Specular_Multiscattering_Environment( const in GeometricContext geometry, const in vec3 specularColor, const in float roughness, inout vec3 singleScatter, inout vec3 multiScatter ) {\n\tfloat dotNV = saturate( dot( geometry.normal, geometry.viewDir ) );\n\tvec3 F = F_Schlick_RoughnessDependent( specularColor, dotNV, roughness );\n\tvec2 brdf = integrateSpecularBRDF( dotNV, roughness );\n\tvec3 FssEss = F * brdf.x + brdf.y;\n\tfloat Ess = brdf.x + brdf.y;\n\tfloat Ems = 1.0 - Ess;\n\tvec3 Favg = specularColor + ( 1.0 - specularColor ) * 0.047619;\tvec3 Fms = FssEss * Favg / ( 1.0 - Ems * Favg );\n\tsingleScatter += FssEss;\n\tmultiScatter += Fms * Ems;\n}\nfloat G_BlinnPhong_Implicit( ) {\n\treturn 0.25;\n}\nfloat D_BlinnPhong( const in float shininess, const in float dotNH ) {\n\treturn RECIPROCAL_PI * ( shininess * 0.5 + 1.0 ) * pow( dotNH, shininess );\n}\nvec3 BRDF_Specular_BlinnPhong( const in IncidentLight incidentLight, const in GeometricContext geometry, const in vec3 specularColor, const in float shininess ) {\n\tvec3 halfDir = normalize( incidentLight.direction + geometry.viewDir );\n\tfloat dotNH = saturate( dot( geometry.normal, halfDir ) );\n\tfloat dotLH = saturate( dot( incidentLight.direction, halfDir ) );\n\tvec3 F = F_Schlick( specularColor, dotLH );\n\tfloat G = G_BlinnPhong_Implicit( );\n\tfloat D = D_BlinnPhong( shininess, dotNH );\n\treturn F * ( G * D );\n}\nfloat GGXRoughnessToBlinnExponent( const in float ggxRoughness ) {\n\treturn ( 2.0 / pow2( ggxRoughness + 0.0001 ) - 2.0 );\n}\nfloat BlinnExponentToGGXRoughness( const in float blinnExponent ) {\n\treturn sqrt( 2.0 / ( blinnExponent + 2.0 ) );\n}\n#if defined( USE_SHEEN )\nfloat D_Charlie(float roughness, float NoH) {\n\tfloat invAlpha = 1.0 / roughness;\n\tfloat cos2h = NoH * NoH;\n\tfloat sin2h = max(1.0 - cos2h, 0.0078125);\treturn (2.0 + invAlpha) * pow(sin2h, invAlpha * 0.5) / (2.0 * PI);\n}\nfloat V_Neubelt(float NoV, float NoL) {\n\treturn saturate(1.0 / (4.0 * (NoL + NoV - NoL * NoV)));\n}\nvec3 BRDF_Specular_Sheen( const in float roughness, const in vec3 L, const in GeometricContext geometry, vec3 specularColor ) {\n\tvec3 N = geometry.normal;\n\tvec3 V = geometry.viewDir;\n\tvec3 H = normalize( V + L );\n\tfloat dotNH = saturate( dot( N, H ) );\n\treturn specularColor * D_Charlie( roughness, dotNH ) * V_Neubelt( dot(N, V), dot(N, L) );\n}\n#endif";
var bumpmap_pars_fragment = "#ifdef USE_BUMPMAP\n\tuniform sampler2D bumpMap;\n\tuniform float bumpScale;\n\tvec2 dHdxy_fwd() {\n\t\tvec2 dSTdx = dFdx( vUv );\n\t\tvec2 dSTdy = dFdy( vUv );\n\t\tfloat Hll = bumpScale * texture2D( bumpMap, vUv ).x;\n\t\tfloat dBx = bumpScale * texture2D( bumpMap, vUv + dSTdx ).x - Hll;\n\t\tfloat dBy = bumpScale * texture2D( bumpMap, vUv + dSTdy ).x - Hll;\n\t\treturn vec2( dBx, dBy );\n\t}\n\tvec3 perturbNormalArb( vec3 surf_pos, vec3 surf_norm, vec2 dHdxy ) {\n\t\tvec3 vSigmaX = vec3( dFdx( surf_pos.x ), dFdx( surf_pos.y ), dFdx( surf_pos.z ) );\n\t\tvec3 vSigmaY = vec3( dFdy( surf_pos.x ), dFdy( surf_pos.y ), dFdy( surf_pos.z ) );\n\t\tvec3 vN = surf_norm;\n\t\tvec3 R1 = cross( vSigmaY, vN );\n\t\tvec3 R2 = cross( vN, vSigmaX );\n\t\tfloat fDet = dot( vSigmaX, R1 );\n\t\tfDet *= ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\tvec3 vGrad = sign( fDet ) * ( dHdxy.x * R1 + dHdxy.y * R2 );\n\t\treturn normalize( abs( fDet ) * surf_norm - vGrad );\n\t}\n#endif";
var clipping_planes_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvec4 plane;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < UNION_CLIPPING_PLANES; i ++ ) {\n\t\tplane = clippingPlanes[ i ];\n\t\tif ( dot( vClipPosition, plane.xyz ) > plane.w ) discard;\n\t}\n\t#pragma unroll_loop_end\n\t#if UNION_CLIPPING_PLANES < NUM_CLIPPING_PLANES\n\t\tbool clipped = true;\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = UNION_CLIPPING_PLANES; i < NUM_CLIPPING_PLANES; i ++ ) {\n\t\t\tplane = clippingPlanes[ i ];\n\t\t\tclipped = ( dot( vClipPosition, plane.xyz ) > plane.w ) && clipped;\n\t\t}\n\t\t#pragma unroll_loop_end\n\t\tif ( clipped ) discard;\n\t#endif\n#endif";
var clipping_planes_pars_fragment = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n\tuniform vec4 clippingPlanes[ NUM_CLIPPING_PLANES ];\n#endif";
var clipping_planes_pars_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvarying vec3 vClipPosition;\n#endif";
var clipping_planes_vertex = "#if NUM_CLIPPING_PLANES > 0\n\tvClipPosition = - mvPosition.xyz;\n#endif";
var color_fragment = "#ifdef USE_COLOR\n\tdiffuseColor.rgb *= vColor;\n#endif";
var color_pars_fragment = "#ifdef USE_COLOR\n\tvarying vec3 vColor;\n#endif";
var color_pars_vertex = "#if defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvarying vec3 vColor;\n#endif";
var color_vertex = "#if defined( USE_COLOR ) || defined( USE_INSTANCING_COLOR )\n\tvColor = vec3( 1.0 );\n#endif\n#ifdef USE_COLOR\n\tvColor.xyz *= color.xyz;\n#endif\n#ifdef USE_INSTANCING_COLOR\n\tvColor.xyz *= instanceColor.xyz;\n#endif";
var common = "#define PI 3.141592653589793\n#define PI2 6.283185307179586\n#define PI_HALF 1.5707963267948966\n#define RECIPROCAL_PI 0.3183098861837907\n#define RECIPROCAL_PI2 0.15915494309189535\n#define EPSILON 1e-6\n#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\n#define whiteComplement(a) ( 1.0 - saturate( a ) )\nfloat pow2( const in float x ) { return x*x; }\nfloat pow3( const in float x ) { return x*x*x; }\nfloat pow4( const in float x ) { float x2 = x*x; return x2*x2; }\nfloat average( const in vec3 color ) { return dot( color, vec3( 0.3333 ) ); }\nhighp float rand( const in vec2 uv ) {\n\tconst highp float a = 12.9898, b = 78.233, c = 43758.5453;\n\thighp float dt = dot( uv.xy, vec2( a,b ) ), sn = mod( dt, PI );\n\treturn fract(sin(sn) * c);\n}\n#ifdef HIGH_PRECISION\n\tfloat precisionSafeLength( vec3 v ) { return length( v ); }\n#else\n\tfloat max3( vec3 v ) { return max( max( v.x, v.y ), v.z ); }\n\tfloat precisionSafeLength( vec3 v ) {\n\t\tfloat maxComponent = max3( abs( v ) );\n\t\treturn length( v / maxComponent ) * maxComponent;\n\t}\n#endif\nstruct IncidentLight {\n\tvec3 color;\n\tvec3 direction;\n\tbool visible;\n};\nstruct ReflectedLight {\n\tvec3 directDiffuse;\n\tvec3 directSpecular;\n\tvec3 indirectDiffuse;\n\tvec3 indirectSpecular;\n};\nstruct GeometricContext {\n\tvec3 position;\n\tvec3 normal;\n\tvec3 viewDir;\n#ifdef CLEARCOAT\n\tvec3 clearcoatNormal;\n#endif\n};\nvec3 transformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( matrix * vec4( dir, 0.0 ) ).xyz );\n}\nvec3 inverseTransformDirection( in vec3 dir, in mat4 matrix ) {\n\treturn normalize( ( vec4( dir, 0.0 ) * matrix ).xyz );\n}\nvec3 projectOnPlane(in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\tfloat distance = dot( planeNormal, point - pointOnPlane );\n\treturn - distance * planeNormal + point;\n}\nfloat sideOfPlane( in vec3 point, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn sign( dot( point - pointOnPlane, planeNormal ) );\n}\nvec3 linePlaneIntersect( in vec3 pointOnLine, in vec3 lineDirection, in vec3 pointOnPlane, in vec3 planeNormal ) {\n\treturn lineDirection * ( dot( planeNormal, pointOnPlane - pointOnLine ) / dot( planeNormal, lineDirection ) ) + pointOnLine;\n}\nmat3 transposeMat3( const in mat3 m ) {\n\tmat3 tmp;\n\ttmp[ 0 ] = vec3( m[ 0 ].x, m[ 1 ].x, m[ 2 ].x );\n\ttmp[ 1 ] = vec3( m[ 0 ].y, m[ 1 ].y, m[ 2 ].y );\n\ttmp[ 2 ] = vec3( m[ 0 ].z, m[ 1 ].z, m[ 2 ].z );\n\treturn tmp;\n}\nfloat linearToRelativeLuminance( const in vec3 color ) {\n\tvec3 weights = vec3( 0.2126, 0.7152, 0.0722 );\n\treturn dot( weights, color.rgb );\n}\nbool isPerspectiveMatrix( mat4 m ) {\n\treturn m[ 2 ][ 3 ] == - 1.0;\n}\nvec2 equirectUv( in vec3 dir ) {\n\tfloat u = atan( dir.z, dir.x ) * RECIPROCAL_PI2 + 0.5;\n\tfloat v = asin( clamp( dir.y, - 1.0, 1.0 ) ) * RECIPROCAL_PI + 0.5;\n\treturn vec2( u, v );\n}";
var cube_uv_reflection_fragment = "#ifdef ENVMAP_TYPE_CUBE_UV\n\t#define cubeUV_maxMipLevel 8.0\n\t#define cubeUV_minMipLevel 4.0\n\t#define cubeUV_maxTileSize 256.0\n\t#define cubeUV_minTileSize 16.0\n\tfloat getFace( vec3 direction ) {\n\t\tvec3 absDirection = abs( direction );\n\t\tfloat face = - 1.0;\n\t\tif ( absDirection.x > absDirection.z ) {\n\t\t\tif ( absDirection.x > absDirection.y )\n\t\t\t\tface = direction.x > 0.0 ? 0.0 : 3.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t} else {\n\t\t\tif ( absDirection.z > absDirection.y )\n\t\t\t\tface = direction.z > 0.0 ? 2.0 : 5.0;\n\t\t\telse\n\t\t\t\tface = direction.y > 0.0 ? 1.0 : 4.0;\n\t\t}\n\t\treturn face;\n\t}\n\tvec2 getUV( vec3 direction, float face ) {\n\t\tvec2 uv;\n\t\tif ( face == 0.0 ) {\n\t\t\tuv = vec2( direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 1.0 ) {\n\t\t\tuv = vec2( - direction.x, - direction.z ) / abs( direction.y );\n\t\t} else if ( face == 2.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.y ) / abs( direction.z );\n\t\t} else if ( face == 3.0 ) {\n\t\t\tuv = vec2( - direction.z, direction.y ) / abs( direction.x );\n\t\t} else if ( face == 4.0 ) {\n\t\t\tuv = vec2( - direction.x, direction.z ) / abs( direction.y );\n\t\t} else {\n\t\t\tuv = vec2( direction.x, direction.y ) / abs( direction.z );\n\t\t}\n\t\treturn 0.5 * ( uv + 1.0 );\n\t}\n\tvec3 bilinearCubeUV( sampler2D envMap, vec3 direction, float mipInt ) {\n\t\tfloat face = getFace( direction );\n\t\tfloat filterInt = max( cubeUV_minMipLevel - mipInt, 0.0 );\n\t\tmipInt = max( mipInt, cubeUV_minMipLevel );\n\t\tfloat faceSize = exp2( mipInt );\n\t\tfloat texelSize = 1.0 / ( 3.0 * cubeUV_maxTileSize );\n\t\tvec2 uv = getUV( direction, face ) * ( faceSize - 1.0 );\n\t\tvec2 f = fract( uv );\n\t\tuv += 0.5 - f;\n\t\tif ( face > 2.0 ) {\n\t\t\tuv.y += faceSize;\n\t\t\tface -= 3.0;\n\t\t}\n\t\tuv.x += face * faceSize;\n\t\tif ( mipInt < cubeUV_maxMipLevel ) {\n\t\t\tuv.y += 2.0 * cubeUV_maxTileSize;\n\t\t}\n\t\tuv.y += filterInt * 2.0 * cubeUV_minTileSize;\n\t\tuv.x += 3.0 * max( 0.0, cubeUV_maxTileSize - 2.0 * faceSize );\n\t\tuv *= texelSize;\n\t\tvec3 tl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x += texelSize;\n\t\tvec3 tr = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.y += texelSize;\n\t\tvec3 br = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tuv.x -= texelSize;\n\t\tvec3 bl = envMapTexelToLinear( texture2D( envMap, uv ) ).rgb;\n\t\tvec3 tm = mix( tl, tr, f.x );\n\t\tvec3 bm = mix( bl, br, f.x );\n\t\treturn mix( tm, bm, f.y );\n\t}\n\t#define r0 1.0\n\t#define v0 0.339\n\t#define m0 - 2.0\n\t#define r1 0.8\n\t#define v1 0.276\n\t#define m1 - 1.0\n\t#define r4 0.4\n\t#define v4 0.046\n\t#define m4 2.0\n\t#define r5 0.305\n\t#define v5 0.016\n\t#define m5 3.0\n\t#define r6 0.21\n\t#define v6 0.0038\n\t#define m6 4.0\n\tfloat roughnessToMip( float roughness ) {\n\t\tfloat mip = 0.0;\n\t\tif ( roughness >= r1 ) {\n\t\t\tmip = ( r0 - roughness ) * ( m1 - m0 ) / ( r0 - r1 ) + m0;\n\t\t} else if ( roughness >= r4 ) {\n\t\t\tmip = ( r1 - roughness ) * ( m4 - m1 ) / ( r1 - r4 ) + m1;\n\t\t} else if ( roughness >= r5 ) {\n\t\t\tmip = ( r4 - roughness ) * ( m5 - m4 ) / ( r4 - r5 ) + m4;\n\t\t} else if ( roughness >= r6 ) {\n\t\t\tmip = ( r5 - roughness ) * ( m6 - m5 ) / ( r5 - r6 ) + m5;\n\t\t} else {\n\t\t\tmip = - 2.0 * log2( 1.16 * roughness );\t\t}\n\t\treturn mip;\n\t}\n\tvec4 textureCubeUV( sampler2D envMap, vec3 sampleDir, float roughness ) {\n\t\tfloat mip = clamp( roughnessToMip( roughness ), m0, cubeUV_maxMipLevel );\n\t\tfloat mipF = fract( mip );\n\t\tfloat mipInt = floor( mip );\n\t\tvec3 color0 = bilinearCubeUV( envMap, sampleDir, mipInt );\n\t\tif ( mipF == 0.0 ) {\n\t\t\treturn vec4( color0, 1.0 );\n\t\t} else {\n\t\t\tvec3 color1 = bilinearCubeUV( envMap, sampleDir, mipInt + 1.0 );\n\t\t\treturn vec4( mix( color0, color1, mipF ), 1.0 );\n\t\t}\n\t}\n#endif";
var defaultnormal_vertex = "vec3 transformedNormal = objectNormal;\n#ifdef USE_INSTANCING\n\tmat3 m = mat3( instanceMatrix );\n\ttransformedNormal /= vec3( dot( m[ 0 ], m[ 0 ] ), dot( m[ 1 ], m[ 1 ] ), dot( m[ 2 ], m[ 2 ] ) );\n\ttransformedNormal = m * transformedNormal;\n#endif\ntransformedNormal = normalMatrix * transformedNormal;\n#ifdef FLIP_SIDED\n\ttransformedNormal = - transformedNormal;\n#endif\n#ifdef USE_TANGENT\n\tvec3 transformedTangent = ( modelViewMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#ifdef FLIP_SIDED\n\t\ttransformedTangent = - transformedTangent;\n\t#endif\n#endif";
var displacementmap_pars_vertex = "#ifdef USE_DISPLACEMENTMAP\n\tuniform sampler2D displacementMap;\n\tuniform float displacementScale;\n\tuniform float displacementBias;\n#endif";
var displacementmap_vertex = "#ifdef USE_DISPLACEMENTMAP\n\ttransformed += normalize( objectNormal ) * ( texture2D( displacementMap, vUv ).x * displacementScale + displacementBias );\n#endif";
var emissivemap_fragment = "#ifdef USE_EMISSIVEMAP\n\tvec4 emissiveColor = texture2D( emissiveMap, vUv );\n\temissiveColor.rgb = emissiveMapTexelToLinear( emissiveColor ).rgb;\n\ttotalEmissiveRadiance *= emissiveColor.rgb;\n#endif";
var emissivemap_pars_fragment = "#ifdef USE_EMISSIVEMAP\n\tuniform sampler2D emissiveMap;\n#endif";
var encodings_fragment = "gl_FragColor = linearToOutputTexel( gl_FragColor );";
var encodings_pars_fragment = "\nvec4 LinearToLinear( in vec4 value ) {\n\treturn value;\n}\nvec4 GammaToLinear( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( gammaFactor ) ), value.a );\n}\nvec4 LinearToGamma( in vec4 value, in float gammaFactor ) {\n\treturn vec4( pow( value.rgb, vec3( 1.0 / gammaFactor ) ), value.a );\n}\nvec4 sRGBToLinear( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb * 0.9478672986 + vec3( 0.0521327014 ), vec3( 2.4 ) ), value.rgb * 0.0773993808, vec3( lessThanEqual( value.rgb, vec3( 0.04045 ) ) ) ), value.a );\n}\nvec4 LinearTosRGB( in vec4 value ) {\n\treturn vec4( mix( pow( value.rgb, vec3( 0.41666 ) ) * 1.055 - vec3( 0.055 ), value.rgb * 12.92, vec3( lessThanEqual( value.rgb, vec3( 0.0031308 ) ) ) ), value.a );\n}\nvec4 RGBEToLinear( in vec4 value ) {\n\treturn vec4( value.rgb * exp2( value.a * 255.0 - 128.0 ), 1.0 );\n}\nvec4 LinearToRGBE( in vec4 value ) {\n\tfloat maxComponent = max( max( value.r, value.g ), value.b );\n\tfloat fExp = clamp( ceil( log2( maxComponent ) ), -128.0, 127.0 );\n\treturn vec4( value.rgb / exp2( fExp ), ( fExp + 128.0 ) / 255.0 );\n}\nvec4 RGBMToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * value.a * maxRange, 1.0 );\n}\nvec4 LinearToRGBM( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat M = clamp( maxRGB / maxRange, 0.0, 1.0 );\n\tM = ceil( M * 255.0 ) / 255.0;\n\treturn vec4( value.rgb / ( M * maxRange ), M );\n}\nvec4 RGBDToLinear( in vec4 value, in float maxRange ) {\n\treturn vec4( value.rgb * ( ( maxRange / 255.0 ) / value.a ), 1.0 );\n}\nvec4 LinearToRGBD( in vec4 value, in float maxRange ) {\n\tfloat maxRGB = max( value.r, max( value.g, value.b ) );\n\tfloat D = max( maxRange / maxRGB, 1.0 );\n\tD = clamp( floor( D ) / 255.0, 0.0, 1.0 );\n\treturn vec4( value.rgb * ( D * ( 255.0 / maxRange ) ), D );\n}\nconst mat3 cLogLuvM = mat3( 0.2209, 0.3390, 0.4184, 0.1138, 0.6780, 0.7319, 0.0102, 0.1130, 0.2969 );\nvec4 LinearToLogLuv( in vec4 value ) {\n\tvec3 Xp_Y_XYZp = cLogLuvM * value.rgb;\n\tXp_Y_XYZp = max( Xp_Y_XYZp, vec3( 1e-6, 1e-6, 1e-6 ) );\n\tvec4 vResult;\n\tvResult.xy = Xp_Y_XYZp.xy / Xp_Y_XYZp.z;\n\tfloat Le = 2.0 * log2(Xp_Y_XYZp.y) + 127.0;\n\tvResult.w = fract( Le );\n\tvResult.z = ( Le - ( floor( vResult.w * 255.0 ) ) / 255.0 ) / 255.0;\n\treturn vResult;\n}\nconst mat3 cLogLuvInverseM = mat3( 6.0014, -2.7008, -1.7996, -1.3320, 3.1029, -5.7721, 0.3008, -1.0882, 5.6268 );\nvec4 LogLuvToLinear( in vec4 value ) {\n\tfloat Le = value.z * 255.0 + value.w;\n\tvec3 Xp_Y_XYZp;\n\tXp_Y_XYZp.y = exp2( ( Le - 127.0 ) / 2.0 );\n\tXp_Y_XYZp.z = Xp_Y_XYZp.y / value.y;\n\tXp_Y_XYZp.x = value.x * Xp_Y_XYZp.z;\n\tvec3 vRGB = cLogLuvInverseM * Xp_Y_XYZp.rgb;\n\treturn vec4( max( vRGB, 0.0 ), 1.0 );\n}";
var envmap_fragment = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvec3 cameraToFrag;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToFrag = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToFrag = normalize( vWorldPosition - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( normal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( cameraToFrag, worldNormal );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( cameraToFrag, worldNormal, refractionRatio );\n\t\t#endif\n\t#else\n\t\tvec3 reflectVec = vReflect;\n\t#endif\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tvec4 envColor = textureCube( envMap, vec3( flipEnvMap * reflectVec.x, reflectVec.yz ) );\n\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\tvec4 envColor = textureCubeUV( envMap, reflectVec, 0.0 );\n\t#else\n\t\tvec4 envColor = vec4( 0.0 );\n\t#endif\n\t#ifndef ENVMAP_TYPE_CUBE_UV\n\t\tenvColor = envMapTexelToLinear( envColor );\n\t#endif\n\t#ifdef ENVMAP_BLENDING_MULTIPLY\n\t\toutgoingLight = mix( outgoingLight, outgoingLight * envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_MIX )\n\t\toutgoingLight = mix( outgoingLight, envColor.xyz, specularStrength * reflectivity );\n\t#elif defined( ENVMAP_BLENDING_ADD )\n\t\toutgoingLight += envColor.xyz * specularStrength * reflectivity;\n\t#endif\n#endif";
var envmap_common_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float envMapIntensity;\n\tuniform float flipEnvMap;\n\tuniform int maxMipLevel;\n\t#ifdef ENVMAP_TYPE_CUBE\n\t\tuniform samplerCube envMap;\n\t#else\n\t\tuniform sampler2D envMap;\n\t#endif\n\t\n#endif";
var envmap_pars_fragment = "#ifdef USE_ENVMAP\n\tuniform float reflectivity;\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) || defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\tvarying vec3 vWorldPosition;\n\t\tuniform float refractionRatio;\n\t#else\n\t\tvarying vec3 vReflect;\n\t#endif\n#endif";
var envmap_pars_vertex = "#ifdef USE_ENVMAP\n\t#if defined( USE_BUMPMAP ) || defined( USE_NORMALMAP ) ||defined( PHONG )\n\t\t#define ENV_WORLDPOS\n\t#endif\n\t#ifdef ENV_WORLDPOS\n\t\t\n\t\tvarying vec3 vWorldPosition;\n\t#else\n\t\tvarying vec3 vReflect;\n\t\tuniform float refractionRatio;\n\t#endif\n#endif";
var envmap_vertex = "#ifdef USE_ENVMAP\n\t#ifdef ENV_WORLDPOS\n\t\tvWorldPosition = worldPosition.xyz;\n\t#else\n\t\tvec3 cameraToVertex;\n\t\tif ( isOrthographic ) {\n\t\t\tcameraToVertex = normalize( vec3( - viewMatrix[ 0 ][ 2 ], - viewMatrix[ 1 ][ 2 ], - viewMatrix[ 2 ][ 2 ] ) );\n\t\t} else {\n\t\t\tcameraToVertex = normalize( worldPosition.xyz - cameraPosition );\n\t\t}\n\t\tvec3 worldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvReflect = reflect( cameraToVertex, worldNormal );\n\t\t#else\n\t\t\tvReflect = refract( cameraToVertex, worldNormal, refractionRatio );\n\t\t#endif\n\t#endif\n#endif";
var fog_vertex = "#ifdef USE_FOG\n\tfogDepth = - mvPosition.z;\n#endif";
var fog_pars_vertex = "#ifdef USE_FOG\n\tvarying float fogDepth;\n#endif";
var fog_fragment = "#ifdef USE_FOG\n\t#ifdef FOG_EXP2\n\t\tfloat fogFactor = 1.0 - exp( - fogDensity * fogDensity * fogDepth * fogDepth );\n\t#else\n\t\tfloat fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n\t#endif\n\tgl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n#endif";
var fog_pars_fragment = "#ifdef USE_FOG\n\tuniform vec3 fogColor;\n\tvarying float fogDepth;\n\t#ifdef FOG_EXP2\n\t\tuniform float fogDensity;\n\t#else\n\t\tuniform float fogNear;\n\t\tuniform float fogFar;\n\t#endif\n#endif";
var gradientmap_pars_fragment = "#ifdef USE_GRADIENTMAP\n\tuniform sampler2D gradientMap;\n#endif\nvec3 getGradientIrradiance( vec3 normal, vec3 lightDirection ) {\n\tfloat dotNL = dot( normal, lightDirection );\n\tvec2 coord = vec2( dotNL * 0.5 + 0.5, 0.0 );\n\t#ifdef USE_GRADIENTMAP\n\t\treturn texture2D( gradientMap, coord ).rgb;\n\t#else\n\t\treturn ( coord.x < 0.7 ) ? vec3( 0.7 ) : vec3( 1.0 );\n\t#endif\n}";
var lightmap_fragment = "#ifdef USE_LIGHTMAP\n\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\treflectedLight.indirectDiffuse += PI * lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n#endif";
var lightmap_pars_fragment = "#ifdef USE_LIGHTMAP\n\tuniform sampler2D lightMap;\n\tuniform float lightMapIntensity;\n#endif";
var lights_lambert_vertex = "vec3 diffuse = vec3( 1.0 );\nGeometricContext geometry;\ngeometry.position = mvPosition.xyz;\ngeometry.normal = normalize( transformedNormal );\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( -mvPosition.xyz );\nGeometricContext backGeometry;\nbackGeometry.position = geometry.position;\nbackGeometry.normal = -geometry.normal;\nbackGeometry.viewDir = geometry.viewDir;\nvLightFront = vec3( 0.0 );\nvIndirectFront = vec3( 0.0 );\n#ifdef DOUBLE_SIDED\n\tvLightBack = vec3( 0.0 );\n\tvIndirectBack = vec3( 0.0 );\n#endif\nIncidentLight directLight;\nfloat dotNL;\nvec3 directLightColor_Diffuse;\nvIndirectFront += getAmbientLightIrradiance( ambientLightColor );\nvIndirectFront += getLightProbeIrradiance( lightProbe, geometry );\n#ifdef DOUBLE_SIDED\n\tvIndirectBack += getAmbientLightIrradiance( ambientLightColor );\n\tvIndirectBack += getLightProbeIrradiance( lightProbe, backGeometry );\n#endif\n#if NUM_POINT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tgetPointDirectLightIrradiance( pointLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tgetSpotDirectLightIrradiance( spotLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_DIR_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tgetDirectionalDirectLightIrradiance( directionalLights[ i ], geometry, directLight );\n\t\tdotNL = dot( geometry.normal, directLight.direction );\n\t\tdirectLightColor_Diffuse = PI * directLight.color;\n\t\tvLightFront += saturate( dotNL ) * directLightColor_Diffuse;\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvLightBack += saturate( -dotNL ) * directLightColor_Diffuse;\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\tvIndirectFront += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\tvIndirectBack += getHemisphereLightIrradiance( hemisphereLights[ i ], backGeometry );\n\t\t#endif\n\t}\n\t#pragma unroll_loop_end\n#endif";
var lights_pars_begin = "uniform bool receiveShadow;\nuniform vec3 ambientLightColor;\nuniform vec3 lightProbe[ 9 ];\nvec3 shGetIrradianceAt( in vec3 normal, in vec3 shCoefficients[ 9 ] ) {\n\tfloat x = normal.x, y = normal.y, z = normal.z;\n\tvec3 result = shCoefficients[ 0 ] * 0.886227;\n\tresult += shCoefficients[ 1 ] * 2.0 * 0.511664 * y;\n\tresult += shCoefficients[ 2 ] * 2.0 * 0.511664 * z;\n\tresult += shCoefficients[ 3 ] * 2.0 * 0.511664 * x;\n\tresult += shCoefficients[ 4 ] * 2.0 * 0.429043 * x * y;\n\tresult += shCoefficients[ 5 ] * 2.0 * 0.429043 * y * z;\n\tresult += shCoefficients[ 6 ] * ( 0.743125 * z * z - 0.247708 );\n\tresult += shCoefficients[ 7 ] * 2.0 * 0.429043 * x * z;\n\tresult += shCoefficients[ 8 ] * 0.429043 * ( x * x - y * y );\n\treturn result;\n}\nvec3 getLightProbeIrradiance( const in vec3 lightProbe[ 9 ], const in GeometricContext geometry ) {\n\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\tvec3 irradiance = shGetIrradianceAt( worldNormal, lightProbe );\n\treturn irradiance;\n}\nvec3 getAmbientLightIrradiance( const in vec3 ambientLightColor ) {\n\tvec3 irradiance = ambientLightColor;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treturn irradiance;\n}\n#if NUM_DIR_LIGHTS > 0\n\tstruct DirectionalLight {\n\t\tvec3 direction;\n\t\tvec3 color;\n\t};\n\tuniform DirectionalLight directionalLights[ NUM_DIR_LIGHTS ];\n\tvoid getDirectionalDirectLightIrradiance( const in DirectionalLight directionalLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tdirectLight.color = directionalLight.color;\n\t\tdirectLight.direction = directionalLight.direction;\n\t\tdirectLight.visible = true;\n\t}\n#endif\n#if NUM_POINT_LIGHTS > 0\n\tstruct PointLight {\n\t\tvec3 position;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t};\n\tuniform PointLight pointLights[ NUM_POINT_LIGHTS ];\n\tvoid getPointDirectLightIrradiance( const in PointLight pointLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = pointLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tdirectLight.color = pointLight.color;\n\t\tdirectLight.color *= punctualLightIntensityToIrradianceFactor( lightDistance, pointLight.distance, pointLight.decay );\n\t\tdirectLight.visible = ( directLight.color != vec3( 0.0 ) );\n\t}\n#endif\n#if NUM_SPOT_LIGHTS > 0\n\tstruct SpotLight {\n\t\tvec3 position;\n\t\tvec3 direction;\n\t\tvec3 color;\n\t\tfloat distance;\n\t\tfloat decay;\n\t\tfloat coneCos;\n\t\tfloat penumbraCos;\n\t};\n\tuniform SpotLight spotLights[ NUM_SPOT_LIGHTS ];\n\tvoid getSpotDirectLightIrradiance( const in SpotLight spotLight, const in GeometricContext geometry, out IncidentLight directLight ) {\n\t\tvec3 lVector = spotLight.position - geometry.position;\n\t\tdirectLight.direction = normalize( lVector );\n\t\tfloat lightDistance = length( lVector );\n\t\tfloat angleCos = dot( directLight.direction, spotLight.direction );\n\t\tif ( angleCos > spotLight.coneCos ) {\n\t\t\tfloat spotEffect = smoothstep( spotLight.coneCos, spotLight.penumbraCos, angleCos );\n\t\t\tdirectLight.color = spotLight.color;\n\t\t\tdirectLight.color *= spotEffect * punctualLightIntensityToIrradianceFactor( lightDistance, spotLight.distance, spotLight.decay );\n\t\t\tdirectLight.visible = true;\n\t\t} else {\n\t\t\tdirectLight.color = vec3( 0.0 );\n\t\t\tdirectLight.visible = false;\n\t\t}\n\t}\n#endif\n#if NUM_RECT_AREA_LIGHTS > 0\n\tstruct RectAreaLight {\n\t\tvec3 color;\n\t\tvec3 position;\n\t\tvec3 halfWidth;\n\t\tvec3 halfHeight;\n\t};\n\tuniform sampler2D ltc_1;\tuniform sampler2D ltc_2;\n\tuniform RectAreaLight rectAreaLights[ NUM_RECT_AREA_LIGHTS ];\n#endif\n#if NUM_HEMI_LIGHTS > 0\n\tstruct HemisphereLight {\n\t\tvec3 direction;\n\t\tvec3 skyColor;\n\t\tvec3 groundColor;\n\t};\n\tuniform HemisphereLight hemisphereLights[ NUM_HEMI_LIGHTS ];\n\tvec3 getHemisphereLightIrradiance( const in HemisphereLight hemiLight, const in GeometricContext geometry ) {\n\t\tfloat dotNL = dot( geometry.normal, hemiLight.direction );\n\t\tfloat hemiDiffuseWeight = 0.5 * dotNL + 0.5;\n\t\tvec3 irradiance = mix( hemiLight.groundColor, hemiLight.skyColor, hemiDiffuseWeight );\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tirradiance *= PI;\n\t\t#endif\n\t\treturn irradiance;\n\t}\n#endif";
var envmap_physical_pars_fragment = "#if defined( USE_ENVMAP )\n\t#ifdef ENVMAP_MODE_REFRACTION\n\t\tuniform float refractionRatio;\n\t#endif\n\tvec3 getLightProbeIndirectIrradiance( const in GeometricContext geometry, const in int maxMIPLevel ) {\n\t\tvec3 worldNormal = inverseTransformDirection( geometry.normal, viewMatrix );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryVec = vec3( flipEnvMap * worldNormal.x, worldNormal.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryVec, float( maxMIPLevel ) );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, worldNormal, 1.0 );\n\t\t#else\n\t\t\tvec4 envMapColor = vec4( 0.0 );\n\t\t#endif\n\t\treturn PI * envMapColor.rgb * envMapIntensity;\n\t}\n\tfloat getSpecularMIPLevel( const in float roughness, const in int maxMIPLevel ) {\n\t\tfloat maxMIPLevelScalar = float( maxMIPLevel );\n\t\tfloat sigma = PI * roughness * roughness / ( 1.0 + roughness );\n\t\tfloat desiredMIPLevel = maxMIPLevelScalar + log2( sigma );\n\t\treturn clamp( desiredMIPLevel, 0.0, maxMIPLevelScalar );\n\t}\n\tvec3 getLightProbeIndirectRadiance( const in vec3 viewDir, const in vec3 normal, const in float roughness, const in int maxMIPLevel ) {\n\t\t#ifdef ENVMAP_MODE_REFLECTION\n\t\t\tvec3 reflectVec = reflect( -viewDir, normal );\n\t\t\treflectVec = normalize( mix( reflectVec, normal, roughness * roughness) );\n\t\t#else\n\t\t\tvec3 reflectVec = refract( -viewDir, normal, refractionRatio );\n\t\t#endif\n\t\treflectVec = inverseTransformDirection( reflectVec, viewMatrix );\n\t\tfloat specularMIPLevel = getSpecularMIPLevel( roughness, maxMIPLevel );\n\t\t#ifdef ENVMAP_TYPE_CUBE\n\t\t\tvec3 queryReflectVec = vec3( flipEnvMap * reflectVec.x, reflectVec.yz );\n\t\t\t#ifdef TEXTURE_LOD_EXT\n\t\t\t\tvec4 envMapColor = textureCubeLodEXT( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#else\n\t\t\t\tvec4 envMapColor = textureCube( envMap, queryReflectVec, specularMIPLevel );\n\t\t\t#endif\n\t\t\tenvMapColor.rgb = envMapTexelToLinear( envMapColor ).rgb;\n\t\t#elif defined( ENVMAP_TYPE_CUBE_UV )\n\t\t\tvec4 envMapColor = textureCubeUV( envMap, reflectVec, roughness );\n\t\t#endif\n\t\treturn envMapColor.rgb * envMapIntensity;\n\t}\n#endif";
var lights_toon_fragment = "ToonMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;";
var lights_toon_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct ToonMaterial {\n\tvec3 diffuseColor;\n};\nvoid RE_Direct_Toon( const in IncidentLight directLight, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\tvec3 irradiance = getGradientIrradiance( geometry.normal, directLight.direction ) * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Toon( const in vec3 irradiance, const in GeometricContext geometry, const in ToonMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_Toon\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Toon\n#define Material_LightProbeLOD( material )\t(0)";
var lights_phong_fragment = "BlinnPhongMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb;\nmaterial.specularColor = specular;\nmaterial.specularShininess = shininess;\nmaterial.specularStrength = specularStrength;";
var lights_phong_pars_fragment = "varying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\nstruct BlinnPhongMaterial {\n\tvec3 diffuseColor;\n\tvec3 specularColor;\n\tfloat specularShininess;\n\tfloat specularStrength;\n};\nvoid RE_Direct_BlinnPhong( const in IncidentLight directLight, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\treflectedLight.directDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n\treflectedLight.directSpecular += irradiance * BRDF_Specular_BlinnPhong( directLight, geometry, material.specularColor, material.specularShininess ) * material.specularStrength;\n}\nvoid RE_IndirectDiffuse_BlinnPhong( const in vec3 irradiance, const in GeometricContext geometry, const in BlinnPhongMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\n#define RE_Direct\t\t\t\tRE_Direct_BlinnPhong\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_BlinnPhong\n#define Material_LightProbeLOD( material )\t(0)";
var lights_physical_fragment = "PhysicalMaterial material;\nmaterial.diffuseColor = diffuseColor.rgb * ( 1.0 - metalnessFactor );\nvec3 dxy = max( abs( dFdx( geometryNormal ) ), abs( dFdy( geometryNormal ) ) );\nfloat geometryRoughness = max( max( dxy.x, dxy.y ), dxy.z );\nmaterial.specularRoughness = max( roughnessFactor, 0.0525 );material.specularRoughness += geometryRoughness;\nmaterial.specularRoughness = min( material.specularRoughness, 1.0 );\n#ifdef REFLECTIVITY\n\tmaterial.specularColor = mix( vec3( MAXIMUM_SPECULAR_COEFFICIENT * pow2( reflectivity ) ), diffuseColor.rgb, metalnessFactor );\n#else\n\tmaterial.specularColor = mix( vec3( DEFAULT_SPECULAR_COEFFICIENT ), diffuseColor.rgb, metalnessFactor );\n#endif\n#ifdef CLEARCOAT\n\tmaterial.clearcoat = clearcoat;\n\tmaterial.clearcoatRoughness = clearcoatRoughness;\n\t#ifdef USE_CLEARCOATMAP\n\t\tmaterial.clearcoat *= texture2D( clearcoatMap, vUv ).x;\n\t#endif\n\t#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\t\tmaterial.clearcoatRoughness *= texture2D( clearcoatRoughnessMap, vUv ).y;\n\t#endif\n\tmaterial.clearcoat = saturate( material.clearcoat );\tmaterial.clearcoatRoughness = max( material.clearcoatRoughness, 0.0525 );\n\tmaterial.clearcoatRoughness += geometryRoughness;\n\tmaterial.clearcoatRoughness = min( material.clearcoatRoughness, 1.0 );\n#endif\n#ifdef USE_SHEEN\n\tmaterial.sheenColor = sheen;\n#endif";
var lights_physical_pars_fragment = "struct PhysicalMaterial {\n\tvec3 diffuseColor;\n\tfloat specularRoughness;\n\tvec3 specularColor;\n#ifdef CLEARCOAT\n\tfloat clearcoat;\n\tfloat clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tvec3 sheenColor;\n#endif\n};\n#define MAXIMUM_SPECULAR_COEFFICIENT 0.16\n#define DEFAULT_SPECULAR_COEFFICIENT 0.04\nfloat clearcoatDHRApprox( const in float roughness, const in float dotNL ) {\n\treturn DEFAULT_SPECULAR_COEFFICIENT + ( 1.0 - DEFAULT_SPECULAR_COEFFICIENT ) * ( pow( 1.0 - dotNL, 5.0 ) * pow( 1.0 - roughness, 2.0 ) );\n}\n#if NUM_RECT_AREA_LIGHTS > 0\n\tvoid RE_Direct_RectArea_Physical( const in RectAreaLight rectAreaLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\t\tvec3 normal = geometry.normal;\n\t\tvec3 viewDir = geometry.viewDir;\n\t\tvec3 position = geometry.position;\n\t\tvec3 lightPos = rectAreaLight.position;\n\t\tvec3 halfWidth = rectAreaLight.halfWidth;\n\t\tvec3 halfHeight = rectAreaLight.halfHeight;\n\t\tvec3 lightColor = rectAreaLight.color;\n\t\tfloat roughness = material.specularRoughness;\n\t\tvec3 rectCoords[ 4 ];\n\t\trectCoords[ 0 ] = lightPos + halfWidth - halfHeight;\t\trectCoords[ 1 ] = lightPos - halfWidth - halfHeight;\n\t\trectCoords[ 2 ] = lightPos - halfWidth + halfHeight;\n\t\trectCoords[ 3 ] = lightPos + halfWidth + halfHeight;\n\t\tvec2 uv = LTC_Uv( normal, viewDir, roughness );\n\t\tvec4 t1 = texture2D( ltc_1, uv );\n\t\tvec4 t2 = texture2D( ltc_2, uv );\n\t\tmat3 mInv = mat3(\n\t\t\tvec3( t1.x, 0, t1.y ),\n\t\t\tvec3(    0, 1,    0 ),\n\t\t\tvec3( t1.z, 0, t1.w )\n\t\t);\n\t\tvec3 fresnel = ( material.specularColor * t2.x + ( vec3( 1.0 ) - material.specularColor ) * t2.y );\n\t\treflectedLight.directSpecular += lightColor * fresnel * LTC_Evaluate( normal, viewDir, position, mInv, rectCoords );\n\t\treflectedLight.directDiffuse += lightColor * material.diffuseColor * LTC_Evaluate( normal, viewDir, position, mat3( 1.0 ), rectCoords );\n\t}\n#endif\nvoid RE_Direct_Physical( const in IncidentLight directLight, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\tfloat dotNL = saturate( dot( geometry.normal, directLight.direction ) );\n\tvec3 irradiance = dotNL * directLight.color;\n\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\tirradiance *= PI;\n\t#endif\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNL = saturate( dot( geometry.clearcoatNormal, directLight.direction ) );\n\t\tvec3 ccIrradiance = ccDotNL * directLight.color;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tccIrradiance *= PI;\n\t\t#endif\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t\treflectedLight.directSpecular += ccIrradiance * material.clearcoat * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\t#ifdef USE_SHEEN\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_Sheen(\n\t\t\tmaterial.specularRoughness,\n\t\t\tdirectLight.direction,\n\t\t\tgeometry,\n\t\t\tmaterial.sheenColor\n\t\t);\n\t#else\n\t\treflectedLight.directSpecular += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Specular_GGX( directLight, geometry.viewDir, geometry.normal, material.specularColor, material.specularRoughness);\n\t#endif\n\treflectedLight.directDiffuse += ( 1.0 - clearcoatDHR ) * irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectDiffuse_Physical( const in vec3 irradiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight ) {\n\treflectedLight.indirectDiffuse += irradiance * BRDF_Diffuse_Lambert( material.diffuseColor );\n}\nvoid RE_IndirectSpecular_Physical( const in vec3 radiance, const in vec3 irradiance, const in vec3 clearcoatRadiance, const in GeometricContext geometry, const in PhysicalMaterial material, inout ReflectedLight reflectedLight) {\n\t#ifdef CLEARCOAT\n\t\tfloat ccDotNV = saturate( dot( geometry.clearcoatNormal, geometry.viewDir ) );\n\t\treflectedLight.indirectSpecular += clearcoatRadiance * material.clearcoat * BRDF_Specular_GGX_Environment( geometry.viewDir, geometry.clearcoatNormal, vec3( DEFAULT_SPECULAR_COEFFICIENT ), material.clearcoatRoughness );\n\t\tfloat ccDotNL = ccDotNV;\n\t\tfloat clearcoatDHR = material.clearcoat * clearcoatDHRApprox( material.clearcoatRoughness, ccDotNL );\n\t#else\n\t\tfloat clearcoatDHR = 0.0;\n\t#endif\n\tfloat clearcoatInv = 1.0 - clearcoatDHR;\n\tvec3 singleScattering = vec3( 0.0 );\n\tvec3 multiScattering = vec3( 0.0 );\n\tvec3 cosineWeightedIrradiance = irradiance * RECIPROCAL_PI;\n\tBRDF_Specular_Multiscattering_Environment( geometry, material.specularColor, material.specularRoughness, singleScattering, multiScattering );\n\tvec3 diffuse = material.diffuseColor * ( 1.0 - ( singleScattering + multiScattering ) );\n\treflectedLight.indirectSpecular += clearcoatInv * radiance * singleScattering;\n\treflectedLight.indirectSpecular += multiScattering * cosineWeightedIrradiance;\n\treflectedLight.indirectDiffuse += diffuse * cosineWeightedIrradiance;\n}\n#define RE_Direct\t\t\t\tRE_Direct_Physical\n#define RE_Direct_RectArea\t\tRE_Direct_RectArea_Physical\n#define RE_IndirectDiffuse\t\tRE_IndirectDiffuse_Physical\n#define RE_IndirectSpecular\t\tRE_IndirectSpecular_Physical\nfloat computeSpecularOcclusion( const in float dotNV, const in float ambientOcclusion, const in float roughness ) {\n\treturn saturate( pow( dotNV + ambientOcclusion, exp2( - 16.0 * roughness - 1.0 ) ) - 1.0 + ambientOcclusion );\n}";
var lights_fragment_begin = "\nGeometricContext geometry;\ngeometry.position = - vViewPosition;\ngeometry.normal = normal;\ngeometry.viewDir = ( isOrthographic ) ? vec3( 0, 0, 1 ) : normalize( vViewPosition );\n#ifdef CLEARCOAT\n\tgeometry.clearcoatNormal = clearcoatNormal;\n#endif\nIncidentLight directLight;\n#if ( NUM_POINT_LIGHTS > 0 ) && defined( RE_Direct )\n\tPointLight pointLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHTS; i ++ ) {\n\t\tpointLight = pointLights[ i ];\n\t\tgetPointDirectLightIrradiance( pointLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_POINT_LIGHT_SHADOWS )\n\t\tpointLightShadow = pointLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getPointShadow( pointShadowMap[ i ], pointLightShadow.shadowMapSize, pointLightShadow.shadowBias, pointLightShadow.shadowRadius, vPointShadowCoord[ i ], pointLightShadow.shadowCameraNear, pointLightShadow.shadowCameraFar ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_SPOT_LIGHTS > 0 ) && defined( RE_Direct )\n\tSpotLight spotLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHTS; i ++ ) {\n\t\tspotLight = spotLights[ i ];\n\t\tgetSpotDirectLightIrradiance( spotLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_SPOT_LIGHT_SHADOWS )\n\t\tspotLightShadow = spotLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( spotShadowMap[ i ], spotLightShadow.shadowMapSize, spotLightShadow.shadowBias, spotLightShadow.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_DIR_LIGHTS > 0 ) && defined( RE_Direct )\n\tDirectionalLight directionalLight;\n\t#if defined( USE_SHADOWMAP ) && NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLightShadow;\n\t#endif\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHTS; i ++ ) {\n\t\tdirectionalLight = directionalLights[ i ];\n\t\tgetDirectionalDirectLightIrradiance( directionalLight, geometry, directLight );\n\t\t#if defined( USE_SHADOWMAP ) && ( UNROLLED_LOOP_INDEX < NUM_DIR_LIGHT_SHADOWS )\n\t\tdirectionalLightShadow = directionalLightShadows[ i ];\n\t\tdirectLight.color *= all( bvec2( directLight.visible, receiveShadow ) ) ? getShadow( directionalShadowMap[ i ], directionalLightShadow.shadowMapSize, directionalLightShadow.shadowBias, directionalLightShadow.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t\t#endif\n\t\tRE_Direct( directLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if ( NUM_RECT_AREA_LIGHTS > 0 ) && defined( RE_Direct_RectArea )\n\tRectAreaLight rectAreaLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_RECT_AREA_LIGHTS; i ++ ) {\n\t\trectAreaLight = rectAreaLights[ i ];\n\t\tRE_Direct_RectArea( rectAreaLight, geometry, material, reflectedLight );\n\t}\n\t#pragma unroll_loop_end\n#endif\n#if defined( RE_IndirectDiffuse )\n\tvec3 iblIrradiance = vec3( 0.0 );\n\tvec3 irradiance = getAmbientLightIrradiance( ambientLightColor );\n\tirradiance += getLightProbeIrradiance( lightProbe, geometry );\n\t#if ( NUM_HEMI_LIGHTS > 0 )\n\t\t#pragma unroll_loop_start\n\t\tfor ( int i = 0; i < NUM_HEMI_LIGHTS; i ++ ) {\n\t\t\tirradiance += getHemisphereLightIrradiance( hemisphereLights[ i ], geometry );\n\t\t}\n\t\t#pragma unroll_loop_end\n\t#endif\n#endif\n#if defined( RE_IndirectSpecular )\n\tvec3 radiance = vec3( 0.0 );\n\tvec3 clearcoatRadiance = vec3( 0.0 );\n#endif";
var lights_fragment_maps = "#if defined( RE_IndirectDiffuse )\n\t#ifdef USE_LIGHTMAP\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\tvec3 lightMapIrradiance = lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t\t#ifndef PHYSICALLY_CORRECT_LIGHTS\n\t\t\tlightMapIrradiance *= PI;\n\t\t#endif\n\t\tirradiance += lightMapIrradiance;\n\t#endif\n\t#if defined( USE_ENVMAP ) && defined( STANDARD ) && defined( ENVMAP_TYPE_CUBE_UV )\n\t\tiblIrradiance += getLightProbeIndirectIrradiance( geometry, maxMipLevel );\n\t#endif\n#endif\n#if defined( USE_ENVMAP ) && defined( RE_IndirectSpecular )\n\tradiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.normal, material.specularRoughness, maxMipLevel );\n\t#ifdef CLEARCOAT\n\t\tclearcoatRadiance += getLightProbeIndirectRadiance( geometry.viewDir, geometry.clearcoatNormal, material.clearcoatRoughness, maxMipLevel );\n\t#endif\n#endif";
var lights_fragment_end = "#if defined( RE_IndirectDiffuse )\n\tRE_IndirectDiffuse( irradiance, geometry, material, reflectedLight );\n#endif\n#if defined( RE_IndirectSpecular )\n\tRE_IndirectSpecular( radiance, iblIrradiance, clearcoatRadiance, geometry, material, reflectedLight );\n#endif";
var logdepthbuf_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tgl_FragDepthEXT = vIsPerspective == 0.0 ? gl_FragCoord.z : log2( vFragDepth ) * logDepthBufFC * 0.5;\n#endif";
var logdepthbuf_pars_fragment = "#if defined( USE_LOGDEPTHBUF ) && defined( USE_LOGDEPTHBUF_EXT )\n\tuniform float logDepthBufFC;\n\tvarying float vFragDepth;\n\tvarying float vIsPerspective;\n#endif";
var logdepthbuf_pars_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvarying float vFragDepth;\n\t\tvarying float vIsPerspective;\n\t#else\n\t\tuniform float logDepthBufFC;\n\t#endif\n#endif";
var logdepthbuf_vertex = "#ifdef USE_LOGDEPTHBUF\n\t#ifdef USE_LOGDEPTHBUF_EXT\n\t\tvFragDepth = 1.0 + gl_Position.w;\n\t\tvIsPerspective = float( isPerspectiveMatrix( projectionMatrix ) );\n\t#else\n\t\tif ( isPerspectiveMatrix( projectionMatrix ) ) {\n\t\t\tgl_Position.z = log2( max( EPSILON, gl_Position.w + 1.0 ) ) * logDepthBufFC - 1.0;\n\t\t\tgl_Position.z *= gl_Position.w;\n\t\t}\n\t#endif\n#endif";
var map_fragment = "#ifdef USE_MAP\n\tvec4 texelColor = texture2D( map, vUv );\n\ttexelColor = mapTexelToLinear( texelColor );\n\tdiffuseColor *= texelColor;\n#endif";
var map_pars_fragment = "#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif";
var map_particle_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tvec2 uv = ( uvTransform * vec3( gl_PointCoord.x, 1.0 - gl_PointCoord.y, 1 ) ).xy;\n#endif\n#ifdef USE_MAP\n\tvec4 mapTexel = texture2D( map, uv );\n\tdiffuseColor *= mapTexelToLinear( mapTexel );\n#endif\n#ifdef USE_ALPHAMAP\n\tdiffuseColor.a *= texture2D( alphaMap, uv ).g;\n#endif";
var map_particle_pars_fragment = "#if defined( USE_MAP ) || defined( USE_ALPHAMAP )\n\tuniform mat3 uvTransform;\n#endif\n#ifdef USE_MAP\n\tuniform sampler2D map;\n#endif\n#ifdef USE_ALPHAMAP\n\tuniform sampler2D alphaMap;\n#endif";
var metalnessmap_fragment = "float metalnessFactor = metalness;\n#ifdef USE_METALNESSMAP\n\tvec4 texelMetalness = texture2D( metalnessMap, vUv );\n\tmetalnessFactor *= texelMetalness.b;\n#endif";
var metalnessmap_pars_fragment = "#ifdef USE_METALNESSMAP\n\tuniform sampler2D metalnessMap;\n#endif";
var morphnormal_vertex = "#ifdef USE_MORPHNORMALS\n\tobjectNormal *= morphTargetBaseInfluence;\n\tobjectNormal += morphNormal0 * morphTargetInfluences[ 0 ];\n\tobjectNormal += morphNormal1 * morphTargetInfluences[ 1 ];\n\tobjectNormal += morphNormal2 * morphTargetInfluences[ 2 ];\n\tobjectNormal += morphNormal3 * morphTargetInfluences[ 3 ];\n#endif";
var morphtarget_pars_vertex = "#ifdef USE_MORPHTARGETS\n\tuniform float morphTargetBaseInfluence;\n\t#ifndef USE_MORPHNORMALS\n\t\tuniform float morphTargetInfluences[ 8 ];\n\t#else\n\t\tuniform float morphTargetInfluences[ 4 ];\n\t#endif\n#endif";
var morphtarget_vertex = "#ifdef USE_MORPHTARGETS\n\ttransformed *= morphTargetBaseInfluence;\n\ttransformed += morphTarget0 * morphTargetInfluences[ 0 ];\n\ttransformed += morphTarget1 * morphTargetInfluences[ 1 ];\n\ttransformed += morphTarget2 * morphTargetInfluences[ 2 ];\n\ttransformed += morphTarget3 * morphTargetInfluences[ 3 ];\n\t#ifndef USE_MORPHNORMALS\n\t\ttransformed += morphTarget4 * morphTargetInfluences[ 4 ];\n\t\ttransformed += morphTarget5 * morphTargetInfluences[ 5 ];\n\t\ttransformed += morphTarget6 * morphTargetInfluences[ 6 ];\n\t\ttransformed += morphTarget7 * morphTargetInfluences[ 7 ];\n\t#endif\n#endif";
var normal_fragment_begin = "#ifdef FLAT_SHADED\n\tvec3 fdx = vec3( dFdx( vViewPosition.x ), dFdx( vViewPosition.y ), dFdx( vViewPosition.z ) );\n\tvec3 fdy = vec3( dFdy( vViewPosition.x ), dFdy( vViewPosition.y ), dFdy( vViewPosition.z ) );\n\tvec3 normal = normalize( cross( fdx, fdy ) );\n#else\n\tvec3 normal = normalize( vNormal );\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n\t#ifdef USE_TANGENT\n\t\tvec3 tangent = normalize( vTangent );\n\t\tvec3 bitangent = normalize( vBitangent );\n\t\t#ifdef DOUBLE_SIDED\n\t\t\ttangent = tangent * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\t\tbitangent = bitangent * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\t#endif\n\t\t#if defined( TANGENTSPACE_NORMALMAP ) || defined( USE_CLEARCOAT_NORMALMAP )\n\t\t\tmat3 vTBN = mat3( tangent, bitangent, normal );\n\t\t#endif\n\t#endif\n#endif\nvec3 geometryNormal = normal;";
var normal_fragment_maps = "#ifdef OBJECTSPACE_NORMALMAP\n\tnormal = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\t#ifdef FLIP_SIDED\n\t\tnormal = - normal;\n\t#endif\n\t#ifdef DOUBLE_SIDED\n\t\tnormal = normal * ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t#endif\n\tnormal = normalize( normalMatrix * normal );\n#elif defined( TANGENTSPACE_NORMALMAP )\n\tvec3 mapN = texture2D( normalMap, vUv ).xyz * 2.0 - 1.0;\n\tmapN.xy *= normalScale;\n\t#ifdef USE_TANGENT\n\t\tnormal = normalize( vTBN * mapN );\n\t#else\n\t\tnormal = perturbNormal2Arb( -vViewPosition, normal, mapN );\n\t#endif\n#elif defined( USE_BUMPMAP )\n\tnormal = perturbNormalArb( -vViewPosition, normal, dHdxy_fwd() );\n#endif";
var normalmap_pars_fragment = "#ifdef USE_NORMALMAP\n\tuniform sampler2D normalMap;\n\tuniform vec2 normalScale;\n#endif\n#ifdef OBJECTSPACE_NORMALMAP\n\tuniform mat3 normalMatrix;\n#endif\n#if ! defined ( USE_TANGENT ) && ( defined ( TANGENTSPACE_NORMALMAP ) || defined ( USE_CLEARCOAT_NORMALMAP ) )\n\tvec3 perturbNormal2Arb( vec3 eye_pos, vec3 surf_norm, vec3 mapN ) {\n\t\tvec3 q0 = vec3( dFdx( eye_pos.x ), dFdx( eye_pos.y ), dFdx( eye_pos.z ) );\n\t\tvec3 q1 = vec3( dFdy( eye_pos.x ), dFdy( eye_pos.y ), dFdy( eye_pos.z ) );\n\t\tvec2 st0 = dFdx( vUv.st );\n\t\tvec2 st1 = dFdy( vUv.st );\n\t\tfloat scale = sign( st1.t * st0.s - st0.t * st1.s );\n\t\tvec3 S = normalize( ( q0 * st1.t - q1 * st0.t ) * scale );\n\t\tvec3 T = normalize( ( - q0 * st1.s + q1 * st0.s ) * scale );\n\t\tvec3 N = normalize( surf_norm );\n\t\tmat3 tsn = mat3( S, T, N );\n\t\tmapN.xy *= ( float( gl_FrontFacing ) * 2.0 - 1.0 );\n\t\treturn normalize( tsn * mapN );\n\t}\n#endif";
var clearcoat_normal_fragment_begin = "#ifdef CLEARCOAT\n\tvec3 clearcoatNormal = geometryNormal;\n#endif";
var clearcoat_normal_fragment_maps = "#ifdef USE_CLEARCOAT_NORMALMAP\n\tvec3 clearcoatMapN = texture2D( clearcoatNormalMap, vUv ).xyz * 2.0 - 1.0;\n\tclearcoatMapN.xy *= clearcoatNormalScale;\n\t#ifdef USE_TANGENT\n\t\tclearcoatNormal = normalize( vTBN * clearcoatMapN );\n\t#else\n\t\tclearcoatNormal = perturbNormal2Arb( - vViewPosition, clearcoatNormal, clearcoatMapN );\n\t#endif\n#endif";
var clearcoat_pars_fragment = "#ifdef USE_CLEARCOATMAP\n\tuniform sampler2D clearcoatMap;\n#endif\n#ifdef USE_CLEARCOAT_ROUGHNESSMAP\n\tuniform sampler2D clearcoatRoughnessMap;\n#endif\n#ifdef USE_CLEARCOAT_NORMALMAP\n\tuniform sampler2D clearcoatNormalMap;\n\tuniform vec2 clearcoatNormalScale;\n#endif";
var packing = "vec3 packNormalToRGB( const in vec3 normal ) {\n\treturn normalize( normal ) * 0.5 + 0.5;\n}\nvec3 unpackRGBToNormal( const in vec3 rgb ) {\n\treturn 2.0 * rgb.xyz - 1.0;\n}\nconst float PackUpscale = 256. / 255.;const float UnpackDownscale = 255. / 256.;\nconst vec3 PackFactors = vec3( 256. * 256. * 256., 256. * 256., 256. );\nconst vec4 UnpackFactors = UnpackDownscale / vec4( PackFactors, 1. );\nconst float ShiftRight8 = 1. / 256.;\nvec4 packDepthToRGBA( const in float v ) {\n\tvec4 r = vec4( fract( v * PackFactors ), v );\n\tr.yzw -= r.xyz * ShiftRight8;\treturn r * PackUpscale;\n}\nfloat unpackRGBAToDepth( const in vec4 v ) {\n\treturn dot( v, UnpackFactors );\n}\nvec4 pack2HalfToRGBA( vec2 v ) {\n\tvec4 r = vec4( v.x, fract( v.x * 255.0 ), v.y, fract( v.y * 255.0 ));\n\treturn vec4( r.x - r.y / 255.0, r.y, r.z - r.w / 255.0, r.w);\n}\nvec2 unpackRGBATo2Half( vec4 v ) {\n\treturn vec2( v.x + ( v.y / 255.0 ), v.z + ( v.w / 255.0 ) );\n}\nfloat viewZToOrthographicDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn ( viewZ + near ) / ( near - far );\n}\nfloat orthographicDepthToViewZ( const in float linearClipZ, const in float near, const in float far ) {\n\treturn linearClipZ * ( near - far ) - near;\n}\nfloat viewZToPerspectiveDepth( const in float viewZ, const in float near, const in float far ) {\n\treturn (( near + viewZ ) * far ) / (( far - near ) * viewZ );\n}\nfloat perspectiveDepthToViewZ( const in float invClipZ, const in float near, const in float far ) {\n\treturn ( near * far ) / ( ( far - near ) * invClipZ - far );\n}";
var premultiplied_alpha_fragment = "#ifdef PREMULTIPLIED_ALPHA\n\tgl_FragColor.rgb *= gl_FragColor.a;\n#endif";
var project_vertex = "vec4 mvPosition = vec4( transformed, 1.0 );\n#ifdef USE_INSTANCING\n\tmvPosition = instanceMatrix * mvPosition;\n#endif\nmvPosition = modelViewMatrix * mvPosition;\ngl_Position = projectionMatrix * mvPosition;";
var dithering_fragment = "#ifdef DITHERING\n\tgl_FragColor.rgb = dithering( gl_FragColor.rgb );\n#endif";
var dithering_pars_fragment = "#ifdef DITHERING\n\tvec3 dithering( vec3 color ) {\n\t\tfloat grid_position = rand( gl_FragCoord.xy );\n\t\tvec3 dither_shift_RGB = vec3( 0.25 / 255.0, -0.25 / 255.0, 0.25 / 255.0 );\n\t\tdither_shift_RGB = mix( 2.0 * dither_shift_RGB, -2.0 * dither_shift_RGB, grid_position );\n\t\treturn color + dither_shift_RGB;\n\t}\n#endif";
var roughnessmap_fragment = "float roughnessFactor = roughness;\n#ifdef USE_ROUGHNESSMAP\n\tvec4 texelRoughness = texture2D( roughnessMap, vUv );\n\troughnessFactor *= texelRoughness.g;\n#endif";
var roughnessmap_pars_fragment = "#ifdef USE_ROUGHNESSMAP\n\tuniform sampler2D roughnessMap;\n#endif";
var shadowmap_pars_fragment = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D directionalShadowMap[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D spotShadowMap[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform sampler2D pointShadowMap[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n\tfloat texture2DCompare( sampler2D depths, vec2 uv, float compare ) {\n\t\treturn step( compare, unpackRGBAToDepth( texture2D( depths, uv ) ) );\n\t}\n\tvec2 texture2DDistribution( sampler2D shadow, vec2 uv ) {\n\t\treturn unpackRGBATo2Half( texture2D( shadow, uv ) );\n\t}\n\tfloat VSMShadow (sampler2D shadow, vec2 uv, float compare ){\n\t\tfloat occlusion = 1.0;\n\t\tvec2 distribution = texture2DDistribution( shadow, uv );\n\t\tfloat hard_shadow = step( compare , distribution.x );\n\t\tif (hard_shadow != 1.0 ) {\n\t\t\tfloat distance = compare - distribution.x ;\n\t\t\tfloat variance = max( 0.00000, distribution.y * distribution.y );\n\t\t\tfloat softness_probability = variance / (variance + distance * distance );\t\t\tsoftness_probability = clamp( ( softness_probability - 0.3 ) / ( 0.95 - 0.3 ), 0.0, 1.0 );\t\t\tocclusion = clamp( max( hard_shadow, softness_probability ), 0.0, 1.0 );\n\t\t}\n\t\treturn occlusion;\n\t}\n\tfloat getShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord ) {\n\t\tfloat shadow = 1.0;\n\t\tshadowCoord.xyz /= shadowCoord.w;\n\t\tshadowCoord.z += shadowBias;\n\t\tbvec4 inFrustumVec = bvec4 ( shadowCoord.x >= 0.0, shadowCoord.x <= 1.0, shadowCoord.y >= 0.0, shadowCoord.y <= 1.0 );\n\t\tbool inFrustum = all( inFrustumVec );\n\t\tbvec2 frustumTestVec = bvec2( inFrustum, shadowCoord.z <= 1.0 );\n\t\tbool frustumTest = all( frustumTestVec );\n\t\tif ( frustumTest ) {\n\t\t#if defined( SHADOWMAP_TYPE_PCF )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx0 = - texelSize.x * shadowRadius;\n\t\t\tfloat dy0 = - texelSize.y * shadowRadius;\n\t\t\tfloat dx1 = + texelSize.x * shadowRadius;\n\t\t\tfloat dy1 = + texelSize.y * shadowRadius;\n\t\t\tfloat dx2 = dx0 / 2.0;\n\t\t\tfloat dy2 = dy0 / 2.0;\n\t\t\tfloat dx3 = dx1 / 2.0;\n\t\t\tfloat dy3 = dy1 / 2.0;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy2 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx2, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx3, dy3 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( 0.0, dy1 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, shadowCoord.xy + vec2( dx1, dy1 ), shadowCoord.z )\n\t\t\t) * ( 1.0 / 17.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_PCF_SOFT )\n\t\t\tvec2 texelSize = vec2( 1.0 ) / shadowMapSize;\n\t\t\tfloat dx = texelSize.x;\n\t\t\tfloat dy = texelSize.y;\n\t\t\tvec2 uv = shadowCoord.xy;\n\t\t\tvec2 f = fract( uv * shadowMapSize + 0.5 );\n\t\t\tuv -= f * texelSize;\n\t\t\tshadow = (\n\t\t\t\ttexture2DCompare( shadowMap, uv, shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( dx, 0.0 ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + vec2( 0.0, dy ), shadowCoord.z ) +\n\t\t\t\ttexture2DCompare( shadowMap, uv + texelSize, shadowCoord.z ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, 0.0 ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 0.0 ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( -dx, dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, dy ), shadowCoord.z ),\n\t\t\t\t\t f.x ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( 0.0, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( 0.0, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( texture2DCompare( shadowMap, uv + vec2( dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t texture2DCompare( shadowMap, uv + vec2( dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t f.y ) +\n\t\t\t\tmix( mix( texture2DCompare( shadowMap, uv + vec2( -dx, -dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, -dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t mix( texture2DCompare( shadowMap, uv + vec2( -dx, 2.0 * dy ), shadowCoord.z ), \n\t\t\t\t\t\t  texture2DCompare( shadowMap, uv + vec2( 2.0 * dx, 2.0 * dy ), shadowCoord.z ),\n\t\t\t\t\t\t  f.x ),\n\t\t\t\t\t f.y )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#elif defined( SHADOWMAP_TYPE_VSM )\n\t\t\tshadow = VSMShadow( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#else\n\t\t\tshadow = texture2DCompare( shadowMap, shadowCoord.xy, shadowCoord.z );\n\t\t#endif\n\t\t}\n\t\treturn shadow;\n\t}\n\tvec2 cubeToUV( vec3 v, float texelSizeY ) {\n\t\tvec3 absV = abs( v );\n\t\tfloat scaleToCube = 1.0 / max( absV.x, max( absV.y, absV.z ) );\n\t\tabsV *= scaleToCube;\n\t\tv *= scaleToCube * ( 1.0 - 2.0 * texelSizeY );\n\t\tvec2 planar = v.xy;\n\t\tfloat almostATexel = 1.5 * texelSizeY;\n\t\tfloat almostOne = 1.0 - almostATexel;\n\t\tif ( absV.z >= almostOne ) {\n\t\t\tif ( v.z > 0.0 )\n\t\t\t\tplanar.x = 4.0 - v.x;\n\t\t} else if ( absV.x >= almostOne ) {\n\t\t\tfloat signX = sign( v.x );\n\t\t\tplanar.x = v.z * signX + 2.0 * signX;\n\t\t} else if ( absV.y >= almostOne ) {\n\t\t\tfloat signY = sign( v.y );\n\t\t\tplanar.x = v.x + 2.0 * signY + 2.0;\n\t\t\tplanar.y = v.z * signY - 2.0;\n\t\t}\n\t\treturn vec2( 0.125, 0.25 ) * planar + vec2( 0.375, 0.75 );\n\t}\n\tfloat getPointShadow( sampler2D shadowMap, vec2 shadowMapSize, float shadowBias, float shadowRadius, vec4 shadowCoord, float shadowCameraNear, float shadowCameraFar ) {\n\t\tvec2 texelSize = vec2( 1.0 ) / ( shadowMapSize * vec2( 4.0, 2.0 ) );\n\t\tvec3 lightToPosition = shadowCoord.xyz;\n\t\tfloat dp = ( length( lightToPosition ) - shadowCameraNear ) / ( shadowCameraFar - shadowCameraNear );\t\tdp += shadowBias;\n\t\tvec3 bd3D = normalize( lightToPosition );\n\t\t#if defined( SHADOWMAP_TYPE_PCF ) || defined( SHADOWMAP_TYPE_PCF_SOFT ) || defined( SHADOWMAP_TYPE_VSM )\n\t\t\tvec2 offset = vec2( - 1, 1 ) * shadowRadius * texelSize.y;\n\t\t\treturn (\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yyx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxy, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.xxx, texelSize.y ), dp ) +\n\t\t\t\ttexture2DCompare( shadowMap, cubeToUV( bd3D + offset.yxx, texelSize.y ), dp )\n\t\t\t) * ( 1.0 / 9.0 );\n\t\t#else\n\t\t\treturn texture2DCompare( shadowMap, cubeToUV( bd3D, texelSize.y ), dp );\n\t\t#endif\n\t}\n#endif";
var shadowmap_pars_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t\tuniform mat4 directionalShadowMatrix[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tvarying vec4 vDirectionalShadowCoord[ NUM_DIR_LIGHT_SHADOWS ];\n\t\tstruct DirectionalLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform DirectionalLightShadow directionalLightShadows[ NUM_DIR_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 spotShadowMatrix[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vSpotShadowCoord[ NUM_SPOT_LIGHT_SHADOWS ];\n\t\tstruct SpotLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t};\n\t\tuniform SpotLightShadow spotLightShadows[ NUM_SPOT_LIGHT_SHADOWS ];\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t\tuniform mat4 pointShadowMatrix[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tvarying vec4 vPointShadowCoord[ NUM_POINT_LIGHT_SHADOWS ];\n\t\tstruct PointLightShadow {\n\t\t\tfloat shadowBias;\n\t\t\tfloat shadowNormalBias;\n\t\t\tfloat shadowRadius;\n\t\t\tvec2 shadowMapSize;\n\t\t\tfloat shadowCameraNear;\n\t\t\tfloat shadowCameraFar;\n\t\t};\n\t\tuniform PointLightShadow pointLightShadows[ NUM_POINT_LIGHT_SHADOWS ];\n\t#endif\n#endif";
var shadowmap_vertex = "#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0 || NUM_SPOT_LIGHT_SHADOWS > 0 || NUM_POINT_LIGHT_SHADOWS > 0\n\t\tvec3 shadowWorldNormal = inverseTransformDirection( transformedNormal, viewMatrix );\n\t\tvec4 shadowWorldPosition;\n\t#endif\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * directionalLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvDirectionalShadowCoord[ i ] = directionalShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * spotLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvSpotShadowCoord[ i ] = spotShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tshadowWorldPosition = worldPosition + vec4( shadowWorldNormal * pointLightShadows[ i ].shadowNormalBias, 0 );\n\t\tvPointShadowCoord[ i ] = pointShadowMatrix[ i ] * shadowWorldPosition;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n#endif";
var shadowmask_pars_fragment = "float getShadowMask() {\n\tfloat shadow = 1.0;\n\t#ifdef USE_SHADOWMAP\n\t#if NUM_DIR_LIGHT_SHADOWS > 0\n\tDirectionalLightShadow directionalLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_DIR_LIGHT_SHADOWS; i ++ ) {\n\t\tdirectionalLight = directionalLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( directionalShadowMap[ i ], directionalLight.shadowMapSize, directionalLight.shadowBias, directionalLight.shadowRadius, vDirectionalShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_SPOT_LIGHT_SHADOWS > 0\n\tSpotLightShadow spotLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_SPOT_LIGHT_SHADOWS; i ++ ) {\n\t\tspotLight = spotLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getShadow( spotShadowMap[ i ], spotLight.shadowMapSize, spotLight.shadowBias, spotLight.shadowRadius, vSpotShadowCoord[ i ] ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#if NUM_POINT_LIGHT_SHADOWS > 0\n\tPointLightShadow pointLight;\n\t#pragma unroll_loop_start\n\tfor ( int i = 0; i < NUM_POINT_LIGHT_SHADOWS; i ++ ) {\n\t\tpointLight = pointLightShadows[ i ];\n\t\tshadow *= receiveShadow ? getPointShadow( pointShadowMap[ i ], pointLight.shadowMapSize, pointLight.shadowBias, pointLight.shadowRadius, vPointShadowCoord[ i ], pointLight.shadowCameraNear, pointLight.shadowCameraFar ) : 1.0;\n\t}\n\t#pragma unroll_loop_end\n\t#endif\n\t#endif\n\treturn shadow;\n}";
var skinbase_vertex = "#ifdef USE_SKINNING\n\tmat4 boneMatX = getBoneMatrix( skinIndex.x );\n\tmat4 boneMatY = getBoneMatrix( skinIndex.y );\n\tmat4 boneMatZ = getBoneMatrix( skinIndex.z );\n\tmat4 boneMatW = getBoneMatrix( skinIndex.w );\n#endif";
var skinning_pars_vertex = "#ifdef USE_SKINNING\n\tuniform mat4 bindMatrix;\n\tuniform mat4 bindMatrixInverse;\n\t#ifdef BONE_TEXTURE\n\t\tuniform highp sampler2D boneTexture;\n\t\tuniform int boneTextureSize;\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tfloat j = i * 4.0;\n\t\t\tfloat x = mod( j, float( boneTextureSize ) );\n\t\t\tfloat y = floor( j / float( boneTextureSize ) );\n\t\t\tfloat dx = 1.0 / float( boneTextureSize );\n\t\t\tfloat dy = 1.0 / float( boneTextureSize );\n\t\t\ty = dy * ( y + 0.5 );\n\t\t\tvec4 v1 = texture2D( boneTexture, vec2( dx * ( x + 0.5 ), y ) );\n\t\t\tvec4 v2 = texture2D( boneTexture, vec2( dx * ( x + 1.5 ), y ) );\n\t\t\tvec4 v3 = texture2D( boneTexture, vec2( dx * ( x + 2.5 ), y ) );\n\t\t\tvec4 v4 = texture2D( boneTexture, vec2( dx * ( x + 3.5 ), y ) );\n\t\t\tmat4 bone = mat4( v1, v2, v3, v4 );\n\t\t\treturn bone;\n\t\t}\n\t#else\n\t\tuniform mat4 boneMatrices[ MAX_BONES ];\n\t\tmat4 getBoneMatrix( const in float i ) {\n\t\t\tmat4 bone = boneMatrices[ int(i) ];\n\t\t\treturn bone;\n\t\t}\n\t#endif\n#endif";
var skinning_vertex = "#ifdef USE_SKINNING\n\tvec4 skinVertex = bindMatrix * vec4( transformed, 1.0 );\n\tvec4 skinned = vec4( 0.0 );\n\tskinned += boneMatX * skinVertex * skinWeight.x;\n\tskinned += boneMatY * skinVertex * skinWeight.y;\n\tskinned += boneMatZ * skinVertex * skinWeight.z;\n\tskinned += boneMatW * skinVertex * skinWeight.w;\n\ttransformed = ( bindMatrixInverse * skinned ).xyz;\n#endif";
var skinnormal_vertex = "#ifdef USE_SKINNING\n\tmat4 skinMatrix = mat4( 0.0 );\n\tskinMatrix += skinWeight.x * boneMatX;\n\tskinMatrix += skinWeight.y * boneMatY;\n\tskinMatrix += skinWeight.z * boneMatZ;\n\tskinMatrix += skinWeight.w * boneMatW;\n\tskinMatrix = bindMatrixInverse * skinMatrix * bindMatrix;\n\tobjectNormal = vec4( skinMatrix * vec4( objectNormal, 0.0 ) ).xyz;\n\t#ifdef USE_TANGENT\n\t\tobjectTangent = vec4( skinMatrix * vec4( objectTangent, 0.0 ) ).xyz;\n\t#endif\n#endif";
var specularmap_fragment = "float specularStrength;\n#ifdef USE_SPECULARMAP\n\tvec4 texelSpecular = texture2D( specularMap, vUv );\n\tspecularStrength = texelSpecular.r;\n#else\n\tspecularStrength = 1.0;\n#endif";
var specularmap_pars_fragment = "#ifdef USE_SPECULARMAP\n\tuniform sampler2D specularMap;\n#endif";
var tonemapping_fragment = "#if defined( TONE_MAPPING )\n\tgl_FragColor.rgb = toneMapping( gl_FragColor.rgb );\n#endif";
var tonemapping_pars_fragment = "#ifndef saturate\n#define saturate(a) clamp( a, 0.0, 1.0 )\n#endif\nuniform float toneMappingExposure;\nvec3 LinearToneMapping( vec3 color ) {\n\treturn toneMappingExposure * color;\n}\nvec3 ReinhardToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\treturn saturate( color / ( vec3( 1.0 ) + color ) );\n}\nvec3 OptimizedCineonToneMapping( vec3 color ) {\n\tcolor *= toneMappingExposure;\n\tcolor = max( vec3( 0.0 ), color - 0.004 );\n\treturn pow( ( color * ( 6.2 * color + 0.5 ) ) / ( color * ( 6.2 * color + 1.7 ) + 0.06 ), vec3( 2.2 ) );\n}\nvec3 RRTAndODTFit( vec3 v ) {\n\tvec3 a = v * ( v + 0.0245786 ) - 0.000090537;\n\tvec3 b = v * ( 0.983729 * v + 0.4329510 ) + 0.238081;\n\treturn a / b;\n}\nvec3 ACESFilmicToneMapping( vec3 color ) {\n\tconst mat3 ACESInputMat = mat3(\n\t\tvec3( 0.59719, 0.07600, 0.02840 ),\t\tvec3( 0.35458, 0.90834, 0.13383 ),\n\t\tvec3( 0.04823, 0.01566, 0.83777 )\n\t);\n\tconst mat3 ACESOutputMat = mat3(\n\t\tvec3(  1.60475, -0.10208, -0.00327 ),\t\tvec3( -0.53108,  1.10813, -0.07276 ),\n\t\tvec3( -0.07367, -0.00605,  1.07602 )\n\t);\n\tcolor *= toneMappingExposure / 0.6;\n\tcolor = ACESInputMat * color;\n\tcolor = RRTAndODTFit( color );\n\tcolor = ACESOutputMat * color;\n\treturn saturate( color );\n}\nvec3 CustomToneMapping( vec3 color ) { return color; }";
var transmissionmap_fragment = "#ifdef USE_TRANSMISSIONMAP\n\ttotalTransmission *= texture2D( transmissionMap, vUv ).r;\n#endif";
var transmissionmap_pars_fragment = "#ifdef USE_TRANSMISSIONMAP\n\tuniform sampler2D transmissionMap;\n#endif";
var uv_pars_fragment = "#if ( defined( USE_UV ) && ! defined( UVS_VERTEX_ONLY ) )\n\tvarying vec2 vUv;\n#endif";
var uv_pars_vertex = "#ifdef USE_UV\n\t#ifdef UVS_VERTEX_ONLY\n\t\tvec2 vUv;\n\t#else\n\t\tvarying vec2 vUv;\n\t#endif\n\tuniform mat3 uvTransform;\n#endif";
var uv_vertex = "#ifdef USE_UV\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n#endif";
var uv2_pars_fragment = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvarying vec2 vUv2;\n#endif";
var uv2_pars_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tattribute vec2 uv2;\n\tvarying vec2 vUv2;\n\tuniform mat3 uv2Transform;\n#endif";
var uv2_vertex = "#if defined( USE_LIGHTMAP ) || defined( USE_AOMAP )\n\tvUv2 = ( uv2Transform * vec3( uv2, 1 ) ).xy;\n#endif";
var worldpos_vertex = "#if defined( USE_ENVMAP ) || defined( DISTANCE ) || defined ( USE_SHADOWMAP )\n\tvec4 worldPosition = vec4( transformed, 1.0 );\n\t#ifdef USE_INSTANCING\n\t\tworldPosition = instanceMatrix * worldPosition;\n\t#endif\n\tworldPosition = modelMatrix * worldPosition;\n#endif";
var background_frag = "uniform sampler2D t2D;\nvarying vec2 vUv;\nvoid main() {\n\tvec4 texColor = texture2D( t2D, vUv );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var background_vert = "varying vec2 vUv;\nuniform mat3 uvTransform;\nvoid main() {\n\tvUv = ( uvTransform * vec3( uv, 1 ) ).xy;\n\tgl_Position = vec4( position.xy, 1.0, 1.0 );\n}";
var cube_frag = "#include <envmap_common_pars_fragment>\nuniform float opacity;\nvarying vec3 vWorldDirection;\n#include <cube_uv_reflection_fragment>\nvoid main() {\n\tvec3 vReflect = vWorldDirection;\n\t#include <envmap_fragment>\n\tgl_FragColor = envColor;\n\tgl_FragColor.a *= opacity;\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var cube_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\tgl_Position.z = gl_Position.w;\n}";
var depth_frag = "#if DEPTH_PACKING == 3200\n\tuniform float opacity;\n#endif\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#if DEPTH_PACKING == 3200\n\t\tdiffuseColor.a = opacity;\n\t#endif\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <logdepthbuf_fragment>\n\tfloat fragCoordZ = 0.5 * vHighPrecisionZW[0] / vHighPrecisionZW[1] + 0.5;\n\t#if DEPTH_PACKING == 3200\n\t\tgl_FragColor = vec4( vec3( 1.0 - fragCoordZ ), opacity );\n\t#elif DEPTH_PACKING == 3201\n\t\tgl_FragColor = packDepthToRGBA( fragCoordZ );\n\t#endif\n}";
var depth_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvarying vec2 vHighPrecisionZW;\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvHighPrecisionZW = gl_Position.zw;\n}";
var distanceRGBA_frag = "#define DISTANCE\nuniform vec3 referencePosition;\nuniform float nearDistance;\nuniform float farDistance;\nvarying vec3 vWorldPosition;\n#include <common>\n#include <packing>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main () {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( 1.0 );\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\tfloat dist = length( vWorldPosition - referencePosition );\n\tdist = ( dist - nearDistance ) / ( farDistance - nearDistance );\n\tdist = saturate( dist );\n\tgl_FragColor = packDepthToRGBA( dist );\n}";
var distanceRGBA_vert = "#define DISTANCE\nvarying vec3 vWorldPosition;\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_DISPLACEMENTMAP\n\t\t#include <beginnormal_vertex>\n\t\t#include <morphnormal_vertex>\n\t\t#include <skinnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\tvWorldPosition = worldPosition.xyz;\n}";
var equirect_frag = "uniform sampler2D tEquirect;\nvarying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvec3 direction = normalize( vWorldDirection );\n\tvec2 sampleUV = equirectUv( direction );\n\tvec4 texColor = texture2D( tEquirect, sampleUV );\n\tgl_FragColor = mapTexelToLinear( texColor );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n}";
var equirect_vert = "varying vec3 vWorldDirection;\n#include <common>\nvoid main() {\n\tvWorldDirection = transformDirection( position, modelMatrix );\n\t#include <begin_vertex>\n\t#include <project_vertex>\n}";
var linedashed_frag = "uniform vec3 diffuse;\nuniform float opacity;\nuniform float dashSize;\nuniform float totalSize;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tif ( mod( vLineDistance, totalSize ) > dashSize ) {\n\t\tdiscard;\n\t}\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <color_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var linedashed_vert = "uniform float scale;\nattribute float lineDistance;\nvarying float vLineDistance;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\tvLineDistance = scale * lineDistance;\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
var meshbasic_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\t#ifdef USE_LIGHTMAP\n\t\n\t\tvec4 lightMapTexel= texture2D( lightMap, vUv2 );\n\t\treflectedLight.indirectDiffuse += lightMapTexelToLinear( lightMapTexel ).rgb * lightMapIntensity;\n\t#else\n\t\treflectedLight.indirectDiffuse += vec3( 1.0 );\n\t#endif\n\t#include <aomap_fragment>\n\treflectedLight.indirectDiffuse *= diffuseColor.rgb;\n\tvec3 outgoingLight = reflectedLight.indirectDiffuse;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshbasic_vert = "#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <skinbase_vertex>\n\t#ifdef USE_ENVMAP\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <worldpos_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <envmap_vertex>\n\t#include <fog_vertex>\n}";
var meshlambert_frag = "uniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <fog_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <emissivemap_fragment>\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.indirectDiffuse += ( gl_FrontFacing ) ? vIndirectFront : vIndirectBack;\n\t#else\n\t\treflectedLight.indirectDiffuse += vIndirectFront;\n\t#endif\n\t#include <lightmap_fragment>\n\treflectedLight.indirectDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb );\n\t#ifdef DOUBLE_SIDED\n\t\treflectedLight.directDiffuse = ( gl_FrontFacing ) ? vLightFront : vLightBack;\n\t#else\n\t\treflectedLight.directDiffuse = vLightFront;\n\t#endif\n\treflectedLight.directDiffuse *= BRDF_Diffuse_Lambert( diffuseColor.rgb ) * getShadowMask();\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshlambert_vert = "#define LAMBERT\nvarying vec3 vLightFront;\nvarying vec3 vIndirectFront;\n#ifdef DOUBLE_SIDED\n\tvarying vec3 vLightBack;\n\tvarying vec3 vIndirectBack;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <envmap_pars_vertex>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <lights_lambert_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var meshmatcap_frag = "#define MATCAP\nuniform vec3 diffuse;\nuniform float opacity;\nuniform sampler2D matcap;\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tvec3 viewDir = normalize( vViewPosition );\n\tvec3 x = normalize( vec3( viewDir.z, 0.0, - viewDir.x ) );\n\tvec3 y = cross( viewDir, x );\n\tvec2 uv = vec2( dot( x, normal ), dot( y, normal ) ) * 0.495 + 0.5;\n\t#ifdef USE_MATCAP\n\t\tvec4 matcapColor = texture2D( matcap, uv );\n\t\tmatcapColor = matcapTexelToLinear( matcapColor );\n\t#else\n\t\tvec4 matcapColor = vec4( 1.0 );\n\t#endif\n\tvec3 outgoingLight = diffuseColor.rgb * matcapColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshmatcap_vert = "#define MATCAP\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <color_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#ifndef FLAT_SHADED\n\t\tvNormal = normalize( transformedNormal );\n\t#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n\tvViewPosition = - mvPosition.xyz;\n}";
var meshtoon_frag = "#define TOON\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <gradientmap_pars_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_toon_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_toon_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + totalEmissiveRadiance;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshtoon_vert = "#define TOON\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var meshphong_frag = "#define PHONG\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform vec3 specular;\nuniform float shininess;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_pars_fragment>\n#include <cube_uv_reflection_fragment>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <lights_phong_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <specularmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <specularmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <lights_phong_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#include <envmap_fragment>\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshphong_vert = "#define PHONG\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <envmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <envmap_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var meshphysical_frag = "#define STANDARD\n#ifdef PHYSICAL\n\t#define REFLECTIVITY\n\t#define CLEARCOAT\n\t#define TRANSMISSION\n#endif\nuniform vec3 diffuse;\nuniform vec3 emissive;\nuniform float roughness;\nuniform float metalness;\nuniform float opacity;\n#ifdef TRANSMISSION\n\tuniform float transmission;\n#endif\n#ifdef REFLECTIVITY\n\tuniform float reflectivity;\n#endif\n#ifdef CLEARCOAT\n\tuniform float clearcoat;\n\tuniform float clearcoatRoughness;\n#endif\n#ifdef USE_SHEEN\n\tuniform vec3 sheen;\n#endif\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <packing>\n#include <dithering_pars_fragment>\n#include <color_pars_fragment>\n#include <uv_pars_fragment>\n#include <uv2_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <aomap_pars_fragment>\n#include <lightmap_pars_fragment>\n#include <emissivemap_pars_fragment>\n#include <transmissionmap_pars_fragment>\n#include <bsdfs>\n#include <cube_uv_reflection_fragment>\n#include <envmap_common_pars_fragment>\n#include <envmap_physical_pars_fragment>\n#include <fog_pars_fragment>\n#include <lights_pars_begin>\n#include <lights_physical_pars_fragment>\n#include <shadowmap_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <clearcoat_pars_fragment>\n#include <roughnessmap_pars_fragment>\n#include <metalnessmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\tReflectedLight reflectedLight = ReflectedLight( vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ), vec3( 0.0 ) );\n\tvec3 totalEmissiveRadiance = emissive;\n\t#ifdef TRANSMISSION\n\t\tfloat totalTransmission = transmission;\n\t#endif\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <color_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\t#include <roughnessmap_fragment>\n\t#include <metalnessmap_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\t#include <clearcoat_normal_fragment_begin>\n\t#include <clearcoat_normal_fragment_maps>\n\t#include <emissivemap_fragment>\n\t#include <transmissionmap_fragment>\n\t#include <lights_physical_fragment>\n\t#include <lights_fragment_begin>\n\t#include <lights_fragment_maps>\n\t#include <lights_fragment_end>\n\t#include <aomap_fragment>\n\tvec3 outgoingLight = reflectedLight.directDiffuse + reflectedLight.indirectDiffuse + reflectedLight.directSpecular + reflectedLight.indirectSpecular + totalEmissiveRadiance;\n\t#ifdef TRANSMISSION\n\t\tdiffuseColor.a *= mix( saturate( 1. - totalTransmission + linearToRelativeLuminance( reflectedLight.directSpecular + reflectedLight.indirectSpecular ) ), 1.0, metalness );\n\t#endif\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n\t#include <dithering_fragment>\n}";
var meshphysical_vert = "#define STANDARD\nvarying vec3 vViewPosition;\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <uv2_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <shadowmap_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <uv2_vertex>\n\t#include <color_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\tvViewPosition = - mvPosition.xyz;\n\t#include <worldpos_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var normal_frag = "#define NORMAL\nuniform float opacity;\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <packing>\n#include <uv_pars_fragment>\n#include <bumpmap_pars_fragment>\n#include <normalmap_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\t#include <logdepthbuf_fragment>\n\t#include <normal_fragment_begin>\n\t#include <normal_fragment_maps>\n\tgl_FragColor = vec4( packNormalToRGB( normal ), opacity );\n}";
var normal_vert = "#define NORMAL\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvarying vec3 vViewPosition;\n#endif\n#ifndef FLAT_SHADED\n\tvarying vec3 vNormal;\n\t#ifdef USE_TANGENT\n\t\tvarying vec3 vTangent;\n\t\tvarying vec3 vBitangent;\n\t#endif\n#endif\n#include <common>\n#include <uv_pars_vertex>\n#include <displacementmap_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <skinning_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n#ifndef FLAT_SHADED\n\tvNormal = normalize( transformedNormal );\n\t#ifdef USE_TANGENT\n\t\tvTangent = normalize( transformedTangent );\n\t\tvBitangent = normalize( cross( vNormal, vTangent ) * tangent.w );\n\t#endif\n#endif\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <skinning_vertex>\n\t#include <displacementmap_vertex>\n\t#include <project_vertex>\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n#if defined( FLAT_SHADED ) || defined( USE_BUMPMAP ) || defined( TANGENTSPACE_NORMALMAP )\n\tvViewPosition = - mvPosition.xyz;\n#endif\n}";
var points_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <color_pars_fragment>\n#include <map_particle_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_particle_fragment>\n\t#include <color_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n\t#include <premultiplied_alpha_fragment>\n}";
var points_vert = "uniform float size;\nuniform float scale;\n#include <common>\n#include <color_pars_vertex>\n#include <fog_pars_vertex>\n#include <morphtarget_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <color_vertex>\n\t#include <begin_vertex>\n\t#include <morphtarget_vertex>\n\t#include <project_vertex>\n\tgl_PointSize = size;\n\t#ifdef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) gl_PointSize *= ( scale / - mvPosition.z );\n\t#endif\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <worldpos_vertex>\n\t#include <fog_vertex>\n}";
var shadow_frag = "uniform vec3 color;\nuniform float opacity;\n#include <common>\n#include <packing>\n#include <fog_pars_fragment>\n#include <bsdfs>\n#include <lights_pars_begin>\n#include <shadowmap_pars_fragment>\n#include <shadowmask_pars_fragment>\nvoid main() {\n\tgl_FragColor = vec4( color, opacity * ( 1.0 - getShadowMask() ) );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var shadow_vert = "#include <common>\n#include <fog_pars_vertex>\n#include <shadowmap_pars_vertex>\nvoid main() {\n\t#include <begin_vertex>\n\t#include <project_vertex>\n\t#include <worldpos_vertex>\n\t#include <beginnormal_vertex>\n\t#include <morphnormal_vertex>\n\t#include <skinbase_vertex>\n\t#include <skinnormal_vertex>\n\t#include <defaultnormal_vertex>\n\t#include <shadowmap_vertex>\n\t#include <fog_vertex>\n}";
var sprite_frag = "uniform vec3 diffuse;\nuniform float opacity;\n#include <common>\n#include <uv_pars_fragment>\n#include <map_pars_fragment>\n#include <alphamap_pars_fragment>\n#include <fog_pars_fragment>\n#include <logdepthbuf_pars_fragment>\n#include <clipping_planes_pars_fragment>\nvoid main() {\n\t#include <clipping_planes_fragment>\n\tvec3 outgoingLight = vec3( 0.0 );\n\tvec4 diffuseColor = vec4( diffuse, opacity );\n\t#include <logdepthbuf_fragment>\n\t#include <map_fragment>\n\t#include <alphamap_fragment>\n\t#include <alphatest_fragment>\n\toutgoingLight = diffuseColor.rgb;\n\tgl_FragColor = vec4( outgoingLight, diffuseColor.a );\n\t#include <tonemapping_fragment>\n\t#include <encodings_fragment>\n\t#include <fog_fragment>\n}";
var sprite_vert = "uniform float rotation;\nuniform vec2 center;\n#include <common>\n#include <uv_pars_vertex>\n#include <fog_pars_vertex>\n#include <logdepthbuf_pars_vertex>\n#include <clipping_planes_pars_vertex>\nvoid main() {\n\t#include <uv_vertex>\n\tvec4 mvPosition = modelViewMatrix * vec4( 0.0, 0.0, 0.0, 1.0 );\n\tvec2 scale;\n\tscale.x = length( vec3( modelMatrix[ 0 ].x, modelMatrix[ 0 ].y, modelMatrix[ 0 ].z ) );\n\tscale.y = length( vec3( modelMatrix[ 1 ].x, modelMatrix[ 1 ].y, modelMatrix[ 1 ].z ) );\n\t#ifndef USE_SIZEATTENUATION\n\t\tbool isPerspective = isPerspectiveMatrix( projectionMatrix );\n\t\tif ( isPerspective ) scale *= - mvPosition.z;\n\t#endif\n\tvec2 alignedPosition = ( position.xy - ( center - vec2( 0.5 ) ) ) * scale;\n\tvec2 rotatedPosition;\n\trotatedPosition.x = cos( rotation ) * alignedPosition.x - sin( rotation ) * alignedPosition.y;\n\trotatedPosition.y = sin( rotation ) * alignedPosition.x + cos( rotation ) * alignedPosition.y;\n\tmvPosition.xy += rotatedPosition;\n\tgl_Position = projectionMatrix * mvPosition;\n\t#include <logdepthbuf_vertex>\n\t#include <clipping_planes_vertex>\n\t#include <fog_vertex>\n}";
const ShaderChunk = {
    alphamap_fragment: alphamap_fragment,
    alphamap_pars_fragment: alphamap_pars_fragment,
    alphatest_fragment: alphatest_fragment,
    aomap_fragment: aomap_fragment,
    aomap_pars_fragment: aomap_pars_fragment,
    begin_vertex: begin_vertex,
    beginnormal_vertex: beginnormal_vertex,
    bsdfs: bsdfs,
    bumpmap_pars_fragment: bumpmap_pars_fragment,
    clipping_planes_fragment: clipping_planes_fragment,
    clipping_planes_pars_fragment: clipping_planes_pars_fragment,
    clipping_planes_pars_vertex: clipping_planes_pars_vertex,
    clipping_planes_vertex: clipping_planes_vertex,
    color_fragment: color_fragment,
    color_pars_fragment: color_pars_fragment,
    color_pars_vertex: color_pars_vertex,
    color_vertex: color_vertex,
    common: common,
    cube_uv_reflection_fragment: cube_uv_reflection_fragment,
    defaultnormal_vertex: defaultnormal_vertex,
    displacementmap_pars_vertex: displacementmap_pars_vertex,
    displacementmap_vertex: displacementmap_vertex,
    emissivemap_fragment: emissivemap_fragment,
    emissivemap_pars_fragment: emissivemap_pars_fragment,
    encodings_fragment: encodings_fragment,
    encodings_pars_fragment: encodings_pars_fragment,
    envmap_fragment: envmap_fragment,
    envmap_common_pars_fragment: envmap_common_pars_fragment,
    envmap_pars_fragment: envmap_pars_fragment,
    envmap_pars_vertex: envmap_pars_vertex,
    envmap_physical_pars_fragment: envmap_physical_pars_fragment,
    envmap_vertex: envmap_vertex,
    fog_vertex: fog_vertex,
    fog_pars_vertex: fog_pars_vertex,
    fog_fragment: fog_fragment,
    fog_pars_fragment: fog_pars_fragment,
    gradientmap_pars_fragment: gradientmap_pars_fragment,
    lightmap_fragment: lightmap_fragment,
    lightmap_pars_fragment: lightmap_pars_fragment,
    lights_lambert_vertex: lights_lambert_vertex,
    lights_pars_begin: lights_pars_begin,
    lights_toon_fragment: lights_toon_fragment,
    lights_toon_pars_fragment: lights_toon_pars_fragment,
    lights_phong_fragment: lights_phong_fragment,
    lights_phong_pars_fragment: lights_phong_pars_fragment,
    lights_physical_fragment: lights_physical_fragment,
    lights_physical_pars_fragment: lights_physical_pars_fragment,
    lights_fragment_begin: lights_fragment_begin,
    lights_fragment_maps: lights_fragment_maps,
    lights_fragment_end: lights_fragment_end,
    logdepthbuf_fragment: logdepthbuf_fragment,
    logdepthbuf_pars_fragment: logdepthbuf_pars_fragment,
    logdepthbuf_pars_vertex: logdepthbuf_pars_vertex,
    logdepthbuf_vertex: logdepthbuf_vertex,
    map_fragment: map_fragment,
    map_pars_fragment: map_pars_fragment,
    map_particle_fragment: map_particle_fragment,
    map_particle_pars_fragment: map_particle_pars_fragment,
    metalnessmap_fragment: metalnessmap_fragment,
    metalnessmap_pars_fragment: metalnessmap_pars_fragment,
    morphnormal_vertex: morphnormal_vertex,
    morphtarget_pars_vertex: morphtarget_pars_vertex,
    morphtarget_vertex: morphtarget_vertex,
    normal_fragment_begin: normal_fragment_begin,
    normal_fragment_maps: normal_fragment_maps,
    normalmap_pars_fragment: normalmap_pars_fragment,
    clearcoat_normal_fragment_begin: clearcoat_normal_fragment_begin,
    clearcoat_normal_fragment_maps: clearcoat_normal_fragment_maps,
    clearcoat_pars_fragment: clearcoat_pars_fragment,
    packing: packing,
    premultiplied_alpha_fragment: premultiplied_alpha_fragment,
    project_vertex: project_vertex,
    dithering_fragment: dithering_fragment,
    dithering_pars_fragment: dithering_pars_fragment,
    roughnessmap_fragment: roughnessmap_fragment,
    roughnessmap_pars_fragment: roughnessmap_pars_fragment,
    shadowmap_pars_fragment: shadowmap_pars_fragment,
    shadowmap_pars_vertex: shadowmap_pars_vertex,
    shadowmap_vertex: shadowmap_vertex,
    shadowmask_pars_fragment: shadowmask_pars_fragment,
    skinbase_vertex: skinbase_vertex,
    skinning_pars_vertex: skinning_pars_vertex,
    skinning_vertex: skinning_vertex,
    skinnormal_vertex: skinnormal_vertex,
    specularmap_fragment: specularmap_fragment,
    specularmap_pars_fragment: specularmap_pars_fragment,
    tonemapping_fragment: tonemapping_fragment,
    tonemapping_pars_fragment: tonemapping_pars_fragment,
    transmissionmap_fragment: transmissionmap_fragment,
    transmissionmap_pars_fragment: transmissionmap_pars_fragment,
    uv_pars_fragment: uv_pars_fragment,
    uv_pars_vertex: uv_pars_vertex,
    uv_vertex: uv_vertex,
    uv2_pars_fragment: uv2_pars_fragment,
    uv2_pars_vertex: uv2_pars_vertex,
    uv2_vertex: uv2_vertex,
    worldpos_vertex: worldpos_vertex,
    background_frag: background_frag,
    background_vert: background_vert,
    cube_frag: cube_frag,
    cube_vert: cube_vert,
    depth_frag: depth_frag,
    depth_vert: depth_vert,
    distanceRGBA_frag: distanceRGBA_frag,
    distanceRGBA_vert: distanceRGBA_vert,
    equirect_frag: equirect_frag,
    equirect_vert: equirect_vert,
    linedashed_frag: linedashed_frag,
    linedashed_vert: linedashed_vert,
    meshbasic_frag: meshbasic_frag,
    meshbasic_vert: meshbasic_vert,
    meshlambert_frag: meshlambert_frag,
    meshlambert_vert: meshlambert_vert,
    meshmatcap_frag: meshmatcap_frag,
    meshmatcap_vert: meshmatcap_vert,
    meshtoon_frag: meshtoon_frag,
    meshtoon_vert: meshtoon_vert,
    meshphong_frag: meshphong_frag,
    meshphong_vert: meshphong_vert,
    meshphysical_frag: meshphysical_frag,
    meshphysical_vert: meshphysical_vert,
    normal_frag: normal_frag,
    normal_vert: normal_vert,
    points_frag: points_frag,
    points_vert: points_vert,
    shadow_frag: shadow_frag,
    shadow_vert: shadow_vert,
    sprite_frag: sprite_frag,
    sprite_vert: sprite_vert
};
/**
 * Uniforms library for shared webgl shaders
 */ const UniformsLib = {
    common: {
        diffuse: {
            value: new Color(0xeeeeee)
        },
        opacity: {
            value: 1.0
        },
        map: {
            value: null
        },
        uvTransform: {
            value: new Matrix3()
        },
        uv2Transform: {
            value: new Matrix3()
        },
        alphaMap: {
            value: null
        }
    },
    specularmap: {
        specularMap: {
            value: null
        }
    },
    envmap: {
        envMap: {
            value: null
        },
        flipEnvMap: {
            value: -1
        },
        reflectivity: {
            value: 1.0
        },
        refractionRatio: {
            value: 0.98
        },
        maxMipLevel: {
            value: 0
        }
    },
    aomap: {
        aoMap: {
            value: null
        },
        aoMapIntensity: {
            value: 1
        }
    },
    lightmap: {
        lightMap: {
            value: null
        },
        lightMapIntensity: {
            value: 1
        }
    },
    emissivemap: {
        emissiveMap: {
            value: null
        }
    },
    bumpmap: {
        bumpMap: {
            value: null
        },
        bumpScale: {
            value: 1
        }
    },
    normalmap: {
        normalMap: {
            value: null
        },
        normalScale: {
            value: new Vector2(1, 1)
        }
    },
    displacementmap: {
        displacementMap: {
            value: null
        },
        displacementScale: {
            value: 1
        },
        displacementBias: {
            value: 0
        }
    },
    roughnessmap: {
        roughnessMap: {
            value: null
        }
    },
    metalnessmap: {
        metalnessMap: {
            value: null
        }
    },
    gradientmap: {
        gradientMap: {
            value: null
        }
    },
    fog: {
        fogDensity: {
            value: 0.00025
        },
        fogNear: {
            value: 1
        },
        fogFar: {
            value: 2000
        },
        fogColor: {
            value: new Color(0xffffff)
        }
    },
    lights: {
        ambientLightColor: {
            value: []
        },
        lightProbe: {
            value: []
        },
        directionalLights: {
            value: [],
            properties: {
                direction: {},
                color: {}
            }
        },
        directionalLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        directionalShadowMap: {
            value: []
        },
        directionalShadowMatrix: {
            value: []
        },
        spotLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                direction: {},
                distance: {},
                coneCos: {},
                penumbraCos: {},
                decay: {}
            }
        },
        spotLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {}
            }
        },
        spotShadowMap: {
            value: []
        },
        spotShadowMatrix: {
            value: []
        },
        pointLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                decay: {},
                distance: {}
            }
        },
        pointLightShadows: {
            value: [],
            properties: {
                shadowBias: {},
                shadowNormalBias: {},
                shadowRadius: {},
                shadowMapSize: {},
                shadowCameraNear: {},
                shadowCameraFar: {}
            }
        },
        pointShadowMap: {
            value: []
        },
        pointShadowMatrix: {
            value: []
        },
        hemisphereLights: {
            value: [],
            properties: {
                direction: {},
                skyColor: {},
                groundColor: {}
            }
        },
        // TODO (abelnation): RectAreaLight BRDF data needs to be moved from example to main src
        rectAreaLights: {
            value: [],
            properties: {
                color: {},
                position: {},
                width: {},
                height: {}
            }
        },
        ltc_1: {
            value: null
        },
        ltc_2: {
            value: null
        }
    },
    points: {
        diffuse: {
            value: new Color(0xeeeeee)
        },
        opacity: {
            value: 1.0
        },
        size: {
            value: 1.0
        },
        scale: {
            value: 1.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new Matrix3()
        }
    },
    sprite: {
        diffuse: {
            value: new Color(0xeeeeee)
        },
        opacity: {
            value: 1.0
        },
        center: {
            value: new Vector2(0.5, 0.5)
        },
        rotation: {
            value: 0.0
        },
        map: {
            value: null
        },
        alphaMap: {
            value: null
        },
        uvTransform: {
            value: new Matrix3()
        }
    }
};
const ShaderLib = {
    basic: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.specularmap,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.meshbasic_vert,
        fragmentShader: ShaderChunk.meshbasic_frag
    },
    lambert: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.specularmap,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: new Color(0x000000)
                }
            }
        ]),
        vertexShader: ShaderChunk.meshlambert_vert,
        fragmentShader: ShaderChunk.meshlambert_frag
    },
    phong: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.specularmap,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: new Color(0x000000)
                },
                specular: {
                    value: new Color(0x111111)
                },
                shininess: {
                    value: 30
                }
            }
        ]),
        vertexShader: ShaderChunk.meshphong_vert,
        fragmentShader: ShaderChunk.meshphong_frag
    },
    standard: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.envmap,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.roughnessmap,
            UniformsLib.metalnessmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: new Color(0x000000)
                },
                roughness: {
                    value: 1.0
                },
                metalness: {
                    value: 0.0
                },
                envMapIntensity: {
                    value: 1
                } // temporary
            }
        ]),
        vertexShader: ShaderChunk.meshphysical_vert,
        fragmentShader: ShaderChunk.meshphysical_frag
    },
    toon: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.aomap,
            UniformsLib.lightmap,
            UniformsLib.emissivemap,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.gradientmap,
            UniformsLib.fog,
            UniformsLib.lights,
            {
                emissive: {
                    value: new Color(0x000000)
                }
            }
        ]),
        vertexShader: ShaderChunk.meshtoon_vert,
        fragmentShader: ShaderChunk.meshtoon_frag
    },
    matcap: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            UniformsLib.fog,
            {
                matcap: {
                    value: null
                }
            }
        ]),
        vertexShader: ShaderChunk.meshmatcap_vert,
        fragmentShader: ShaderChunk.meshmatcap_frag
    },
    points: {
        uniforms: mergeUniforms([
            UniformsLib.points,
            UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.points_vert,
        fragmentShader: ShaderChunk.points_frag
    },
    dashed: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.fog,
            {
                scale: {
                    value: 1
                },
                dashSize: {
                    value: 1
                },
                totalSize: {
                    value: 2
                }
            }
        ]),
        vertexShader: ShaderChunk.linedashed_vert,
        fragmentShader: ShaderChunk.linedashed_frag
    },
    depth: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.displacementmap
        ]),
        vertexShader: ShaderChunk.depth_vert,
        fragmentShader: ShaderChunk.depth_frag
    },
    normal: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.bumpmap,
            UniformsLib.normalmap,
            UniformsLib.displacementmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: ShaderChunk.normal_vert,
        fragmentShader: ShaderChunk.normal_frag
    },
    sprite: {
        uniforms: mergeUniforms([
            UniformsLib.sprite,
            UniformsLib.fog
        ]),
        vertexShader: ShaderChunk.sprite_vert,
        fragmentShader: ShaderChunk.sprite_frag
    },
    background: {
        uniforms: {
            uvTransform: {
                value: new Matrix3()
            },
            t2D: {
                value: null
            }
        },
        vertexShader: ShaderChunk.background_vert,
        fragmentShader: ShaderChunk.background_frag
    },
    /* -------------------------------------------------------------------------
	//	Cube map shader
	 ------------------------------------------------------------------------- */ cube: {
        uniforms: mergeUniforms([
            UniformsLib.envmap,
            {
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: ShaderChunk.cube_vert,
        fragmentShader: ShaderChunk.cube_frag
    },
    equirect: {
        uniforms: {
            tEquirect: {
                value: null
            }
        },
        vertexShader: ShaderChunk.equirect_vert,
        fragmentShader: ShaderChunk.equirect_frag
    },
    distanceRGBA: {
        uniforms: mergeUniforms([
            UniformsLib.common,
            UniformsLib.displacementmap,
            {
                referencePosition: {
                    value: new Vector3()
                },
                nearDistance: {
                    value: 1
                },
                farDistance: {
                    value: 1000
                }
            }
        ]),
        vertexShader: ShaderChunk.distanceRGBA_vert,
        fragmentShader: ShaderChunk.distanceRGBA_frag
    },
    shadow: {
        uniforms: mergeUniforms([
            UniformsLib.lights,
            UniformsLib.fog,
            {
                color: {
                    value: new Color(0x00000)
                },
                opacity: {
                    value: 1.0
                }
            }
        ]),
        vertexShader: ShaderChunk.shadow_vert,
        fragmentShader: ShaderChunk.shadow_frag
    }
};
ShaderLib.physical = {
    uniforms: mergeUniforms([
        ShaderLib.standard.uniforms,
        {
            clearcoat: {
                value: 0
            },
            clearcoatMap: {
                value: null
            },
            clearcoatRoughness: {
                value: 0
            },
            clearcoatRoughnessMap: {
                value: null
            },
            clearcoatNormalScale: {
                value: new Vector2(1, 1)
            },
            clearcoatNormalMap: {
                value: null
            },
            sheen: {
                value: new Color(0x000000)
            },
            transmission: {
                value: 0
            },
            transmissionMap: {
                value: null
            }
        }
    ]),
    vertexShader: ShaderChunk.meshphysical_vert,
    fragmentShader: ShaderChunk.meshphysical_frag
};
function WebGLBackground(renderer, cubemaps, state, objects, premultipliedAlpha) {
    const clearColor = new Color(0x000000);
    let clearAlpha = 0;
    let planeMesh;
    let boxMesh;
    let currentBackground = null;
    let currentBackgroundVersion = 0;
    let currentTonemapping = null;
    function render(renderList, scene, camera, forceClear) {
        let background = scene.isScene === true ? scene.background : null;
        if (background && background.isTexture) background = cubemaps.get(background);
        // Ignore background in AR
        // TODO: Reconsider this.
        const xr = renderer.xr;
        const session = xr.getSession && xr.getSession();
        if (session && session.environmentBlendMode === 'additive') background = null;
        if (background === null) setClear(clearColor, clearAlpha);
        else if (background && background.isColor) {
            setClear(background, 1);
            forceClear = true;
        }
        if (renderer.autoClear || forceClear) renderer.clear(renderer.autoClearColor, renderer.autoClearDepth, renderer.autoClearStencil);
        if (background && (background.isCubeTexture || background.isWebGLCubeRenderTarget || background.mapping === CubeUVReflectionMapping)) {
            if (boxMesh === undefined) {
                boxMesh = new Mesh(new BoxGeometry(1, 1, 1), new ShaderMaterial({
                    name: 'BackgroundCubeMaterial',
                    uniforms: cloneUniforms(ShaderLib.cube.uniforms),
                    vertexShader: ShaderLib.cube.vertexShader,
                    fragmentShader: ShaderLib.cube.fragmentShader,
                    side: BackSide,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                boxMesh.geometry.deleteAttribute('normal');
                boxMesh.geometry.deleteAttribute('uv');
                boxMesh.onBeforeRender = function(renderer, scene, camera) {
                    this.matrixWorld.copyPosition(camera.matrixWorld);
                };
                // enable code injection for non-built-in material
                Object.defineProperty(boxMesh.material, 'envMap', {
                    get: function() {
                        return this.uniforms.envMap.value;
                    }
                });
                objects.update(boxMesh);
            }
            if (background.isWebGLCubeRenderTarget) // TODO Deprecate
            background = background.texture;
            boxMesh.material.uniforms.envMap.value = background;
            boxMesh.material.uniforms.flipEnvMap.value = background.isCubeTexture && background._needsFlipEnvMap ? -1 : 1;
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                boxMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(boxMesh, boxMesh.geometry, boxMesh.material, 0, 0, null);
        } else if (background && background.isTexture) {
            if (planeMesh === undefined) {
                planeMesh = new Mesh(new PlaneGeometry(2, 2), new ShaderMaterial({
                    name: 'BackgroundMaterial',
                    uniforms: cloneUniforms(ShaderLib.background.uniforms),
                    vertexShader: ShaderLib.background.vertexShader,
                    fragmentShader: ShaderLib.background.fragmentShader,
                    side: FrontSide,
                    depthTest: false,
                    depthWrite: false,
                    fog: false
                }));
                planeMesh.geometry.deleteAttribute('normal');
                // enable code injection for non-built-in material
                Object.defineProperty(planeMesh.material, 'map', {
                    get: function() {
                        return this.uniforms.t2D.value;
                    }
                });
                objects.update(planeMesh);
            }
            planeMesh.material.uniforms.t2D.value = background;
            if (background.matrixAutoUpdate === true) background.updateMatrix();
            planeMesh.material.uniforms.uvTransform.value.copy(background.matrix);
            if (currentBackground !== background || currentBackgroundVersion !== background.version || currentTonemapping !== renderer.toneMapping) {
                planeMesh.material.needsUpdate = true;
                currentBackground = background;
                currentBackgroundVersion = background.version;
                currentTonemapping = renderer.toneMapping;
            }
            // push to the pre-sorted opaque render list
            renderList.unshift(planeMesh, planeMesh.geometry, planeMesh.material, 0, 0, null);
        }
    }
    function setClear(color, alpha) {
        state.buffers.color.setClear(color.r, color.g, color.b, alpha, premultipliedAlpha);
    }
    return {
        getClearColor: function() {
            return clearColor;
        },
        setClearColor: function(color, alpha = 1) {
            clearColor.set(color);
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        getClearAlpha: function() {
            return clearAlpha;
        },
        setClearAlpha: function(alpha) {
            clearAlpha = alpha;
            setClear(clearColor, clearAlpha);
        },
        render: render
    };
}
function WebGLBindingStates(gl, extensions, attributes, capabilities) {
    const maxVertexAttributes = gl.getParameter(34921);
    const extension = capabilities.isWebGL2 ? null : extensions.get('OES_vertex_array_object');
    const vaoAvailable = capabilities.isWebGL2 || extension !== null;
    const bindingStates = {};
    const defaultState = createBindingState(null);
    let currentState = defaultState;
    function setup(object, material, program, geometry, index) {
        let updateBuffers = false;
        if (vaoAvailable) {
            const state = getBindingState(geometry, program, material);
            if (currentState !== state) {
                currentState = state;
                bindVertexArrayObject(currentState.object);
            }
            updateBuffers = needsUpdate(geometry, index);
            if (updateBuffers) saveCache(geometry, index);
        } else {
            const wireframe = material.wireframe === true;
            if (currentState.geometry !== geometry.id || currentState.program !== program.id || currentState.wireframe !== wireframe) {
                currentState.geometry = geometry.id;
                currentState.program = program.id;
                currentState.wireframe = wireframe;
                updateBuffers = true;
            }
        }
        if (object.isInstancedMesh === true) updateBuffers = true;
        if (index !== null) attributes.update(index, 34963);
        if (updateBuffers) {
            setupVertexAttributes(object, material, program, geometry);
            if (index !== null) gl.bindBuffer(34963, attributes.get(index).buffer);
        }
    }
    function createVertexArrayObject() {
        if (capabilities.isWebGL2) return gl.createVertexArray();
        return extension.createVertexArrayOES();
    }
    function bindVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.bindVertexArray(vao);
        return extension.bindVertexArrayOES(vao);
    }
    function deleteVertexArrayObject(vao) {
        if (capabilities.isWebGL2) return gl.deleteVertexArray(vao);
        return extension.deleteVertexArrayOES(vao);
    }
    function getBindingState(geometry, program, material) {
        const wireframe = material.wireframe === true;
        let programMap = bindingStates[geometry.id];
        if (programMap === undefined) {
            programMap = {};
            bindingStates[geometry.id] = programMap;
        }
        let stateMap = programMap[program.id];
        if (stateMap === undefined) {
            stateMap = {};
            programMap[program.id] = stateMap;
        }
        let state = stateMap[wireframe];
        if (state === undefined) {
            state = createBindingState(createVertexArrayObject());
            stateMap[wireframe] = state;
        }
        return state;
    }
    function createBindingState(vao) {
        const newAttributes = [];
        const enabledAttributes = [];
        const attributeDivisors = [];
        for(let i = 0; i < maxVertexAttributes; i++){
            newAttributes[i] = 0;
            enabledAttributes[i] = 0;
            attributeDivisors[i] = 0;
        }
        return {
            // for backward compatibility on non-VAO support browser
            geometry: null,
            program: null,
            wireframe: false,
            newAttributes: newAttributes,
            enabledAttributes: enabledAttributes,
            attributeDivisors: attributeDivisors,
            object: vao,
            attributes: {},
            index: null
        };
    }
    function needsUpdate(geometry, index) {
        const cachedAttributes = currentState.attributes;
        const geometryAttributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in geometryAttributes){
            const cachedAttribute = cachedAttributes[key];
            const geometryAttribute = geometryAttributes[key];
            if (cachedAttribute === undefined) return true;
            if (cachedAttribute.attribute !== geometryAttribute) return true;
            if (cachedAttribute.data !== geometryAttribute.data) return true;
            attributesNum++;
        }
        if (currentState.attributesNum !== attributesNum) return true;
        if (currentState.index !== index) return true;
        return false;
    }
    function saveCache(geometry, index) {
        const cache = {};
        const attributes = geometry.attributes;
        let attributesNum = 0;
        for(const key in attributes){
            const attribute = attributes[key];
            const data = {};
            data.attribute = attribute;
            if (attribute.data) data.data = attribute.data;
            cache[key] = data;
            attributesNum++;
        }
        currentState.attributes = cache;
        currentState.attributesNum = attributesNum;
        currentState.index = index;
    }
    function initAttributes() {
        const newAttributes = currentState.newAttributes;
        for(let i = 0, il = newAttributes.length; i < il; i++)newAttributes[i] = 0;
    }
    function enableAttribute(attribute) {
        enableAttributeAndDivisor(attribute, 0);
    }
    function enableAttributeAndDivisor(attribute, meshPerAttribute) {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        const attributeDivisors = currentState.attributeDivisors;
        newAttributes[attribute] = 1;
        if (enabledAttributes[attribute] === 0) {
            gl.enableVertexAttribArray(attribute);
            enabledAttributes[attribute] = 1;
        }
        if (attributeDivisors[attribute] !== meshPerAttribute) {
            const extension = capabilities.isWebGL2 ? gl : extensions.get('ANGLE_instanced_arrays');
            extension[capabilities.isWebGL2 ? 'vertexAttribDivisor' : 'vertexAttribDivisorANGLE'](attribute, meshPerAttribute);
            attributeDivisors[attribute] = meshPerAttribute;
        }
    }
    function disableUnusedAttributes() {
        const newAttributes = currentState.newAttributes;
        const enabledAttributes = currentState.enabledAttributes;
        for(let i = 0, il = enabledAttributes.length; i < il; i++)if (enabledAttributes[i] !== newAttributes[i]) {
            gl.disableVertexAttribArray(i);
            enabledAttributes[i] = 0;
        }
    }
    function vertexAttribPointer(index, size, type, normalized, stride, offset) {
        if (capabilities.isWebGL2 === true && (type === 5124 || type === 5125)) gl.vertexAttribIPointer(index, size, type, stride, offset);
        else gl.vertexAttribPointer(index, size, type, normalized, stride, offset);
    }
    function setupVertexAttributes(object, material, program, geometry) {
        if (capabilities.isWebGL2 === false && (object.isInstancedMesh || geometry.isInstancedBufferGeometry)) {
            if (extensions.get('ANGLE_instanced_arrays') === null) return;
        }
        initAttributes();
        const geometryAttributes = geometry.attributes;
        const programAttributes = program.getAttributes();
        const materialDefaultAttributeValues = material.defaultAttributeValues;
        for(const name in programAttributes){
            const programAttribute = programAttributes[name];
            if (programAttribute >= 0) {
                const geometryAttribute = geometryAttributes[name];
                if (geometryAttribute !== undefined) {
                    const normalized = geometryAttribute.normalized;
                    const size = geometryAttribute.itemSize;
                    const attribute = attributes.get(geometryAttribute);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    const bytesPerElement = attribute.bytesPerElement;
                    if (geometryAttribute.isInterleavedBufferAttribute) {
                        const data = geometryAttribute.data;
                        const stride = data.stride;
                        const offset = geometryAttribute.offset;
                        if (data && data.isInstancedInterleavedBuffer) {
                            enableAttributeAndDivisor(programAttribute, data.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = data.meshPerAttribute * data.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, stride * bytesPerElement, offset * bytesPerElement);
                    } else {
                        if (geometryAttribute.isInstancedBufferAttribute) {
                            enableAttributeAndDivisor(programAttribute, geometryAttribute.meshPerAttribute);
                            if (geometry._maxInstanceCount === undefined) geometry._maxInstanceCount = geometryAttribute.meshPerAttribute * geometryAttribute.count;
                        } else enableAttribute(programAttribute);
                        gl.bindBuffer(34962, buffer);
                        vertexAttribPointer(programAttribute, size, type, normalized, 0, 0);
                    }
                } else if (name === 'instanceMatrix') {
                    const attribute = attributes.get(object.instanceMatrix);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    enableAttributeAndDivisor(programAttribute + 0, 1);
                    enableAttributeAndDivisor(programAttribute + 1, 1);
                    enableAttributeAndDivisor(programAttribute + 2, 1);
                    enableAttributeAndDivisor(programAttribute + 3, 1);
                    gl.bindBuffer(34962, buffer);
                    gl.vertexAttribPointer(programAttribute + 0, 4, type, false, 64, 0);
                    gl.vertexAttribPointer(programAttribute + 1, 4, type, false, 64, 16);
                    gl.vertexAttribPointer(programAttribute + 2, 4, type, false, 64, 32);
                    gl.vertexAttribPointer(programAttribute + 3, 4, type, false, 64, 48);
                } else if (name === 'instanceColor') {
                    const attribute = attributes.get(object.instanceColor);
                    // TODO Attribute may not be available on context restore
                    if (attribute === undefined) continue;
                    const buffer = attribute.buffer;
                    const type = attribute.type;
                    enableAttributeAndDivisor(programAttribute, 1);
                    gl.bindBuffer(34962, buffer);
                    gl.vertexAttribPointer(programAttribute, 3, type, false, 12, 0);
                } else if (materialDefaultAttributeValues !== undefined) {
                    const value = materialDefaultAttributeValues[name];
                    if (value !== undefined) switch(value.length){
                        case 2:
                            gl.vertexAttrib2fv(programAttribute, value);
                            break;
                        case 3:
                            gl.vertexAttrib3fv(programAttribute, value);
                            break;
                        case 4:
                            gl.vertexAttrib4fv(programAttribute, value);
                            break;
                        default:
                            gl.vertexAttrib1fv(programAttribute, value);
                    }
                }
            }
        }
        disableUnusedAttributes();
    }
    function dispose() {
        reset();
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            for(const programId in programMap){
                const stateMap = programMap[programId];
                for(const wireframe in stateMap){
                    deleteVertexArrayObject(stateMap[wireframe].object);
                    delete stateMap[wireframe];
                }
                delete programMap[programId];
            }
            delete bindingStates[geometryId];
        }
    }
    function releaseStatesOfGeometry(geometry) {
        if (bindingStates[geometry.id] === undefined) return;
        const programMap = bindingStates[geometry.id];
        for(const programId in programMap){
            const stateMap = programMap[programId];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[programId];
        }
        delete bindingStates[geometry.id];
    }
    function releaseStatesOfProgram(program) {
        for(const geometryId in bindingStates){
            const programMap = bindingStates[geometryId];
            if (programMap[program.id] === undefined) continue;
            const stateMap = programMap[program.id];
            for(const wireframe in stateMap){
                deleteVertexArrayObject(stateMap[wireframe].object);
                delete stateMap[wireframe];
            }
            delete programMap[program.id];
        }
    }
    function reset() {
        resetDefaultState();
        if (currentState === defaultState) return;
        currentState = defaultState;
        bindVertexArrayObject(currentState.object);
    }
    // for backward-compatilibity
    function resetDefaultState() {
        defaultState.geometry = null;
        defaultState.program = null;
        defaultState.wireframe = false;
    }
    return {
        setup: setup,
        reset: reset,
        resetDefaultState: resetDefaultState,
        dispose: dispose,
        releaseStatesOfGeometry: releaseStatesOfGeometry,
        releaseStatesOfProgram: releaseStatesOfProgram,
        initAttributes: initAttributes,
        enableAttribute: enableAttribute,
        disableUnusedAttributes: disableUnusedAttributes
    };
}
function WebGLBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    function render(start, count) {
        gl.drawArrays(mode, start, count);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawArraysInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawArraysInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, start, count, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.render = render;
    this.renderInstances = renderInstances;
}
function WebGLCapabilities(gl, extensions, parameters) {
    let maxAnisotropy;
    function getMaxAnisotropy() {
        if (maxAnisotropy !== undefined) return maxAnisotropy;
        const extension = extensions.get('EXT_texture_filter_anisotropic');
        if (extension !== null) maxAnisotropy = gl.getParameter(extension.MAX_TEXTURE_MAX_ANISOTROPY_EXT);
        else maxAnisotropy = 0;
        return maxAnisotropy;
    }
    function getMaxPrecision(precision) {
        if (precision === 'highp') {
            if (gl.getShaderPrecisionFormat(35633, 36338).precision > 0 && gl.getShaderPrecisionFormat(35632, 36338).precision > 0) return 'highp';
            precision = 'mediump';
        }
        if (precision === 'mediump') {
            if (gl.getShaderPrecisionFormat(35633, 36337).precision > 0 && gl.getShaderPrecisionFormat(35632, 36337).precision > 0) return 'mediump';
        }
        return 'lowp';
    }
    /* eslint-disable no-undef */ const isWebGL2 = typeof WebGL2RenderingContext !== 'undefined' && gl instanceof WebGL2RenderingContext || typeof WebGL2ComputeRenderingContext !== 'undefined' && gl instanceof WebGL2ComputeRenderingContext;
    /* eslint-enable no-undef */ let precision = parameters.precision !== undefined ? parameters.precision : 'highp';
    const maxPrecision = getMaxPrecision(precision);
    if (maxPrecision !== precision) {
        console.warn('THREE.WebGLRenderer:', precision, 'not supported, using', maxPrecision, 'instead.');
        precision = maxPrecision;
    }
    const logarithmicDepthBuffer = parameters.logarithmicDepthBuffer === true;
    const maxTextures = gl.getParameter(34930);
    const maxVertexTextures = gl.getParameter(35660);
    const maxTextureSize = gl.getParameter(3379);
    const maxCubemapSize = gl.getParameter(34076);
    const maxAttributes = gl.getParameter(34921);
    const maxVertexUniforms = gl.getParameter(36347);
    const maxVaryings = gl.getParameter(36348);
    const maxFragmentUniforms = gl.getParameter(36349);
    const vertexTextures = maxVertexTextures > 0;
    const floatFragmentTextures = isWebGL2 || !!extensions.get('OES_texture_float');
    const floatVertexTextures = vertexTextures && floatFragmentTextures;
    const maxSamples = isWebGL2 ? gl.getParameter(36183) : 0;
    return {
        isWebGL2: isWebGL2,
        getMaxAnisotropy: getMaxAnisotropy,
        getMaxPrecision: getMaxPrecision,
        precision: precision,
        logarithmicDepthBuffer: logarithmicDepthBuffer,
        maxTextures: maxTextures,
        maxVertexTextures: maxVertexTextures,
        maxTextureSize: maxTextureSize,
        maxCubemapSize: maxCubemapSize,
        maxAttributes: maxAttributes,
        maxVertexUniforms: maxVertexUniforms,
        maxVaryings: maxVaryings,
        maxFragmentUniforms: maxFragmentUniforms,
        vertexTextures: vertexTextures,
        floatFragmentTextures: floatFragmentTextures,
        floatVertexTextures: floatVertexTextures,
        maxSamples: maxSamples
    };
}
function WebGLClipping(properties) {
    const scope = this;
    let globalState = null, numGlobalPlanes = 0, localClippingEnabled = false, renderingShadows = false;
    const plane = new Plane(), viewNormalMatrix = new Matrix3(), uniform = {
        value: null,
        needsUpdate: false
    };
    this.uniform = uniform;
    this.numPlanes = 0;
    this.numIntersection = 0;
    this.init = function(planes, enableLocalClipping, camera) {
        const enabled = planes.length !== 0 || enableLocalClipping || // enable state of previous frame - the clipping code has to
        // run another frame in order to reset the state:
        numGlobalPlanes !== 0 || localClippingEnabled;
        localClippingEnabled = enableLocalClipping;
        globalState = projectPlanes(planes, camera, 0);
        numGlobalPlanes = planes.length;
        return enabled;
    };
    this.beginShadows = function() {
        renderingShadows = true;
        projectPlanes(null);
    };
    this.endShadows = function() {
        renderingShadows = false;
        resetGlobalState();
    };
    this.setState = function(material, camera, useCache) {
        const planes = material.clippingPlanes, clipIntersection = material.clipIntersection, clipShadows = material.clipShadows;
        const materialProperties = properties.get(material);
        if (!localClippingEnabled || planes === null || planes.length === 0 || renderingShadows && !clipShadows) {
            // there's no local clipping
            if (renderingShadows) // there's no global clipping
            projectPlanes(null);
            else resetGlobalState();
        } else {
            const nGlobal = renderingShadows ? 0 : numGlobalPlanes, lGlobal = nGlobal * 4;
            let dstArray = materialProperties.clippingState || null;
            uniform.value = dstArray; // ensure unique state
            dstArray = projectPlanes(planes, camera, lGlobal, useCache);
            for(let i = 0; i !== lGlobal; ++i)dstArray[i] = globalState[i];
            materialProperties.clippingState = dstArray;
            this.numIntersection = clipIntersection ? this.numPlanes : 0;
            this.numPlanes += nGlobal;
        }
    };
    function resetGlobalState() {
        if (uniform.value !== globalState) {
            uniform.value = globalState;
            uniform.needsUpdate = numGlobalPlanes > 0;
        }
        scope.numPlanes = numGlobalPlanes;
        scope.numIntersection = 0;
    }
    function projectPlanes(planes, camera, dstOffset, skipTransform) {
        const nPlanes = planes !== null ? planes.length : 0;
        let dstArray = null;
        if (nPlanes !== 0) {
            dstArray = uniform.value;
            if (skipTransform !== true || dstArray === null) {
                const flatSize = dstOffset + nPlanes * 4, viewMatrix = camera.matrixWorldInverse;
                viewNormalMatrix.getNormalMatrix(viewMatrix);
                if (dstArray === null || dstArray.length < flatSize) dstArray = new Float32Array(flatSize);
                for(let i = 0, i4 = dstOffset; i !== nPlanes; ++i, i4 += 4){
                    plane.copy(planes[i]).applyMatrix4(viewMatrix, viewNormalMatrix);
                    plane.normal.toArray(dstArray, i4);
                    dstArray[i4 + 3] = plane.constant;
                }
            }
            uniform.value = dstArray;
            uniform.needsUpdate = true;
        }
        scope.numPlanes = nPlanes;
        scope.numIntersection = 0;
        return dstArray;
    }
}
function WebGLCubeMaps(renderer) {
    let cubemaps = new WeakMap();
    function mapTextureMapping(texture, mapping) {
        if (mapping === EquirectangularReflectionMapping) texture.mapping = CubeReflectionMapping;
        else if (mapping === EquirectangularRefractionMapping) texture.mapping = CubeRefractionMapping;
        return texture;
    }
    function get(texture) {
        if (texture && texture.isTexture) {
            const mapping = texture.mapping;
            if (mapping === EquirectangularReflectionMapping || mapping === EquirectangularRefractionMapping) {
                if (cubemaps.has(texture)) {
                    const cubemap = cubemaps.get(texture).texture;
                    return mapTextureMapping(cubemap, texture.mapping);
                } else {
                    const image = texture.image;
                    if (image && image.height > 0) {
                        const currentRenderList = renderer.getRenderList();
                        const currentRenderTarget = renderer.getRenderTarget();
                        const renderTarget = new WebGLCubeRenderTarget(image.height / 2);
                        renderTarget.fromEquirectangularTexture(renderer, texture);
                        cubemaps.set(texture, renderTarget);
                        renderer.setRenderTarget(currentRenderTarget);
                        renderer.setRenderList(currentRenderList);
                        texture.addEventListener('dispose', onTextureDispose);
                        return mapTextureMapping(renderTarget.texture, texture.mapping);
                    } else // image not yet ready. try the conversion next frame
                    return null;
                }
            }
        }
        return texture;
    }
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        const cubemap = cubemaps.get(texture);
        if (cubemap !== undefined) {
            cubemaps.delete(texture);
            cubemap.dispose();
        }
    }
    function dispose() {
        cubemaps = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function WebGLExtensions(gl) {
    const extensions = {};
    function getExtension(name) {
        if (extensions[name] !== undefined) return extensions[name];
        let extension;
        switch(name){
            case 'WEBGL_depth_texture':
                extension = gl.getExtension('WEBGL_depth_texture') || gl.getExtension('MOZ_WEBGL_depth_texture') || gl.getExtension('WEBKIT_WEBGL_depth_texture');
                break;
            case 'EXT_texture_filter_anisotropic':
                extension = gl.getExtension('EXT_texture_filter_anisotropic') || gl.getExtension('MOZ_EXT_texture_filter_anisotropic') || gl.getExtension('WEBKIT_EXT_texture_filter_anisotropic');
                break;
            case 'WEBGL_compressed_texture_s3tc':
                extension = gl.getExtension('WEBGL_compressed_texture_s3tc') || gl.getExtension('MOZ_WEBGL_compressed_texture_s3tc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_s3tc');
                break;
            case 'WEBGL_compressed_texture_pvrtc':
                extension = gl.getExtension('WEBGL_compressed_texture_pvrtc') || gl.getExtension('WEBKIT_WEBGL_compressed_texture_pvrtc');
                break;
            default:
                extension = gl.getExtension(name);
        }
        extensions[name] = extension;
        return extension;
    }
    return {
        has: function(name) {
            return getExtension(name) !== null;
        },
        init: function(capabilities) {
            if (capabilities.isWebGL2) getExtension('EXT_color_buffer_float');
            else {
                getExtension('WEBGL_depth_texture');
                getExtension('OES_texture_float');
                getExtension('OES_texture_half_float');
                getExtension('OES_texture_half_float_linear');
                getExtension('OES_standard_derivatives');
                getExtension('OES_element_index_uint');
                getExtension('OES_vertex_array_object');
                getExtension('ANGLE_instanced_arrays');
            }
            getExtension('OES_texture_float_linear');
            getExtension('EXT_color_buffer_half_float');
        },
        get: function(name) {
            const extension = getExtension(name);
            if (extension === null) console.warn('THREE.WebGLRenderer: ' + name + ' extension not supported.');
            return extension;
        }
    };
}
function WebGLGeometries(gl, attributes, info, bindingStates) {
    const geometries = {};
    const wireframeAttributes = new WeakMap();
    function onGeometryDispose(event) {
        const geometry = event.target;
        if (geometry.index !== null) attributes.remove(geometry.index);
        for(const name in geometry.attributes)attributes.remove(geometry.attributes[name]);
        geometry.removeEventListener('dispose', onGeometryDispose);
        delete geometries[geometry.id];
        const attribute = wireframeAttributes.get(geometry);
        if (attribute) {
            attributes.remove(attribute);
            wireframeAttributes.delete(geometry);
        }
        bindingStates.releaseStatesOfGeometry(geometry);
        if (geometry.isInstancedBufferGeometry === true) delete geometry._maxInstanceCount;
        //
        info.memory.geometries--;
    }
    function get(object, geometry) {
        if (geometries[geometry.id] === true) return geometry;
        geometry.addEventListener('dispose', onGeometryDispose);
        geometries[geometry.id] = true;
        info.memory.geometries++;
        return geometry;
    }
    function update(geometry) {
        const geometryAttributes = geometry.attributes;
        // Updating index buffer in VAO now. See WebGLBindingStates.
        for(const name in geometryAttributes)attributes.update(geometryAttributes[name], 34962);
        // morph targets
        const morphAttributes = geometry.morphAttributes;
        for(const name in morphAttributes){
            const array = morphAttributes[name];
            for(let i = 0, l = array.length; i < l; i++)attributes.update(array[i], 34962);
        }
    }
    function updateWireframeAttribute(geometry) {
        const indices = [];
        const geometryIndex = geometry.index;
        const geometryPosition = geometry.attributes.position;
        let version = 0;
        if (geometryIndex !== null) {
            const array = geometryIndex.array;
            version = geometryIndex.version;
            for(let i = 0, l = array.length; i < l; i += 3){
                const a = array[i + 0];
                const b = array[i + 1];
                const c = array[i + 2];
                indices.push(a, b, b, c, c, a);
            }
        } else {
            const array = geometryPosition.array;
            version = geometryPosition.version;
            for(let i = 0, l = array.length / 3 - 1; i < l; i += 3){
                const a = i + 0;
                const b = i + 1;
                const c = i + 2;
                indices.push(a, b, b, c, c, a);
            }
        }
        const attribute = new (arrayMax(indices) > 65535 ? Uint32BufferAttribute : Uint16BufferAttribute)(indices, 1);
        attribute.version = version;
        // Updating index buffer in VAO now. See WebGLBindingStates
        //
        const previousAttribute = wireframeAttributes.get(geometry);
        if (previousAttribute) attributes.remove(previousAttribute);
        //
        wireframeAttributes.set(geometry, attribute);
    }
    function getWireframeAttribute(geometry) {
        const currentAttribute = wireframeAttributes.get(geometry);
        if (currentAttribute) {
            const geometryIndex = geometry.index;
            if (geometryIndex !== null) // if the attribute is obsolete, create a new one
            {
                if (currentAttribute.version < geometryIndex.version) updateWireframeAttribute(geometry);
            }
        } else updateWireframeAttribute(geometry);
        return wireframeAttributes.get(geometry);
    }
    return {
        get: get,
        update: update,
        getWireframeAttribute: getWireframeAttribute
    };
}
function WebGLIndexedBufferRenderer(gl, extensions, info, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    let mode;
    function setMode(value) {
        mode = value;
    }
    let type, bytesPerElement;
    function setIndex(value) {
        type = value.type;
        bytesPerElement = value.bytesPerElement;
    }
    function render(start, count) {
        gl.drawElements(mode, count, type, start * bytesPerElement);
        info.update(count, mode, 1);
    }
    function renderInstances(start, count, primcount) {
        if (primcount === 0) return;
        let extension, methodName;
        if (isWebGL2) {
            extension = gl;
            methodName = 'drawElementsInstanced';
        } else {
            extension = extensions.get('ANGLE_instanced_arrays');
            methodName = 'drawElementsInstancedANGLE';
            if (extension === null) {
                console.error('THREE.WebGLIndexedBufferRenderer: using THREE.InstancedBufferGeometry but hardware does not support extension ANGLE_instanced_arrays.');
                return;
            }
        }
        extension[methodName](mode, count, type, start * bytesPerElement, primcount);
        info.update(count, mode, primcount);
    }
    //
    this.setMode = setMode;
    this.setIndex = setIndex;
    this.render = render;
    this.renderInstances = renderInstances;
}
function WebGLInfo(gl) {
    const memory = {
        geometries: 0,
        textures: 0
    };
    const render = {
        frame: 0,
        calls: 0,
        triangles: 0,
        points: 0,
        lines: 0
    };
    function update(count, mode, instanceCount) {
        render.calls++;
        switch(mode){
            case 4:
                render.triangles += instanceCount * (count / 3);
                break;
            case 1:
                render.lines += instanceCount * (count / 2);
                break;
            case 3:
                render.lines += instanceCount * (count - 1);
                break;
            case 2:
                render.lines += instanceCount * count;
                break;
            case 0:
                render.points += instanceCount * count;
                break;
            default:
                console.error('THREE.WebGLInfo: Unknown draw mode:', mode);
                break;
        }
    }
    function reset() {
        render.frame++;
        render.calls = 0;
        render.triangles = 0;
        render.points = 0;
        render.lines = 0;
    }
    return {
        memory: memory,
        render: render,
        programs: null,
        autoReset: true,
        reset: reset,
        update: update
    };
}
function numericalSort(a, b) {
    return a[0] - b[0];
}
function absNumericalSort(a, b) {
    return Math.abs(b[1]) - Math.abs(a[1]);
}
function WebGLMorphtargets(gl) {
    const influencesList = {};
    const morphInfluences = new Float32Array(8);
    const workInfluences = [];
    for(let i = 0; i < 8; i++)workInfluences[i] = [
        i,
        0
    ];
    function update(object, geometry, material, program) {
        const objectInfluences = object.morphTargetInfluences;
        // When object doesn't have morph target influences defined, we treat it as a 0-length array
        // This is important to make sure we set up morphTargetBaseInfluence / morphTargetInfluences
        const length = objectInfluences === undefined ? 0 : objectInfluences.length;
        let influences = influencesList[geometry.id];
        if (influences === undefined) {
            // initialise list
            influences = [];
            for(let i = 0; i < length; i++)influences[i] = [
                i,
                0
            ];
            influencesList[geometry.id] = influences;
        }
        // Collect influences
        for(let i = 0; i < length; i++){
            const influence = influences[i];
            influence[0] = i;
            influence[1] = objectInfluences[i];
        }
        influences.sort(absNumericalSort);
        for(let i = 0; i < 8; i++)if (i < length && influences[i][1]) {
            workInfluences[i][0] = influences[i][0];
            workInfluences[i][1] = influences[i][1];
        } else {
            workInfluences[i][0] = Number.MAX_SAFE_INTEGER;
            workInfluences[i][1] = 0;
        }
        workInfluences.sort(numericalSort);
        const morphTargets = material.morphTargets && geometry.morphAttributes.position;
        const morphNormals = material.morphNormals && geometry.morphAttributes.normal;
        let morphInfluencesSum = 0;
        for(let i = 0; i < 8; i++){
            const influence = workInfluences[i];
            const index = influence[0];
            const value = influence[1];
            if (index !== Number.MAX_SAFE_INTEGER && value) {
                if (morphTargets && geometry.getAttribute('morphTarget' + i) !== morphTargets[index]) geometry.setAttribute('morphTarget' + i, morphTargets[index]);
                if (morphNormals && geometry.getAttribute('morphNormal' + i) !== morphNormals[index]) geometry.setAttribute('morphNormal' + i, morphNormals[index]);
                morphInfluences[i] = value;
                morphInfluencesSum += value;
            } else {
                if (morphTargets && geometry.hasAttribute('morphTarget' + i) === true) geometry.deleteAttribute('morphTarget' + i);
                if (morphNormals && geometry.hasAttribute('morphNormal' + i) === true) geometry.deleteAttribute('morphNormal' + i);
                morphInfluences[i] = 0;
            }
        }
        // GLSL shader uses formula baseinfluence * base + sum(target * influence)
        // This allows us to switch between absolute morphs and relative morphs without changing shader code
        // When baseinfluence = 1 - sum(influence), the above is equivalent to sum((target - base) * influence)
        const morphBaseInfluence = geometry.morphTargetsRelative ? 1 : 1 - morphInfluencesSum;
        program.getUniforms().setValue(gl, 'morphTargetBaseInfluence', morphBaseInfluence);
        program.getUniforms().setValue(gl, 'morphTargetInfluences', morphInfluences);
    }
    return {
        update: update
    };
}
function WebGLObjects(gl, geometries, attributes, info) {
    let updateMap = new WeakMap();
    function update(object) {
        const frame = info.render.frame;
        const geometry = object.geometry;
        const buffergeometry = geometries.get(object, geometry);
        // Update once per frame
        if (updateMap.get(buffergeometry) !== frame) {
            geometries.update(buffergeometry);
            updateMap.set(buffergeometry, frame);
        }
        if (object.isInstancedMesh) {
            if (object.hasEventListener('dispose', onInstancedMeshDispose) === false) object.addEventListener('dispose', onInstancedMeshDispose);
            attributes.update(object.instanceMatrix, 34962);
            if (object.instanceColor !== null) attributes.update(object.instanceColor, 34962);
        }
        return buffergeometry;
    }
    function dispose() {
        updateMap = new WeakMap();
    }
    function onInstancedMeshDispose(event) {
        const instancedMesh = event.target;
        instancedMesh.removeEventListener('dispose', onInstancedMeshDispose);
        attributes.remove(instancedMesh.instanceMatrix);
        if (instancedMesh.instanceColor !== null) attributes.remove(instancedMesh.instanceColor);
    }
    return {
        update: update,
        dispose: dispose
    };
}
function DataTexture2DArray(data = null, width = 1, height = 1, depth = 1) {
    Texture.call(this, null);
    this.image = {
        data: data,
        width: width,
        height: height,
        depth: depth
    };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.needsUpdate = true;
}
DataTexture2DArray.prototype = Object.create(Texture.prototype);
DataTexture2DArray.prototype.constructor = DataTexture2DArray;
DataTexture2DArray.prototype.isDataTexture2DArray = true;
function DataTexture3D(data = null, width = 1, height = 1, depth = 1) {
    // We're going to add .setXXX() methods for setting properties later.
    // Users can still set in DataTexture3D directly.
    //
    //	const texture = new THREE.DataTexture3D( data, width, height, depth );
    // 	texture.anisotropy = 16;
    //
    // See #14839
    Texture.call(this, null);
    this.image = {
        data: data,
        width: width,
        height: height,
        depth: depth
    };
    this.magFilter = NearestFilter;
    this.minFilter = NearestFilter;
    this.wrapR = ClampToEdgeWrapping;
    this.generateMipmaps = false;
    this.flipY = false;
    this.needsUpdate = true;
}
DataTexture3D.prototype = Object.create(Texture.prototype);
DataTexture3D.prototype.constructor = DataTexture3D;
DataTexture3D.prototype.isDataTexture3D = true;
/**
 * Uniforms of a program.
 * Those form a tree structure with a special top-level container for the root,
 * which you get by calling 'new WebGLUniforms( gl, program )'.
 *
 *
 * Properties of inner nodes including the top-level container:
 *
 * .seq - array of nested uniforms
 * .map - nested uniforms by name
 *
 *
 * Methods of all nodes except the top-level container:
 *
 * .setValue( gl, value, [textures] )
 *
 * 		uploads a uniform value(s)
 *  	the 'textures' parameter is needed for sampler uniforms
 *
 *
 * Static methods of the top-level container (textures factorizations):
 *
 * .upload( gl, seq, values, textures )
 *
 * 		sets uniforms in 'seq' to 'values[id].value'
 *
 * .seqWithValue( seq, values ) : filteredSeq
 *
 * 		filters 'seq' entries with corresponding entry in values
 *
 *
 * Methods of the top-level container (textures factorizations):
 *
 * .setValue( gl, name, value, textures )
 *
 * 		sets uniform with  name 'name' to 'value'
 *
 * .setOptional( gl, obj, prop )
 *
 * 		like .set for an optional property of the object
 *
 */ const emptyTexture = new Texture();
const emptyTexture2dArray = new DataTexture2DArray();
const emptyTexture3d = new DataTexture3D();
const emptyCubeTexture = new CubeTexture();
// --- Utilities ---
// Array Caches (provide typed arrays for temporary by size)
const arrayCacheF32 = [];
const arrayCacheI32 = [];
// Float32Array caches used for uploading Matrix uniforms
const mat4array = new Float32Array(16);
const mat3array = new Float32Array(9);
const mat2array = new Float32Array(4);
// Flattening for arrays of vectors and matrices
function flatten(array, nBlocks, blockSize) {
    const firstElem = array[0];
    if (firstElem <= 0 || firstElem > 0) return array;
    // unoptimized: ! isNaN( firstElem )
    // see http://jacksondunstan.com/articles/983
    const n = nBlocks * blockSize;
    let r = arrayCacheF32[n];
    if (r === undefined) {
        r = new Float32Array(n);
        arrayCacheF32[n] = r;
    }
    if (nBlocks !== 0) {
        firstElem.toArray(r, 0);
        for(let i = 1, offset = 0; i !== nBlocks; ++i){
            offset += blockSize;
            array[i].toArray(r, offset);
        }
    }
    return r;
}
function arraysEqual(a, b) {
    if (a.length !== b.length) return false;
    for(let i = 0, l = a.length; i < l; i++){
        if (a[i] !== b[i]) return false;
    }
    return true;
}
function copyArray(a, b) {
    for(let i = 0, l = b.length; i < l; i++)a[i] = b[i];
}
// Texture unit allocation
function allocTexUnits(textures, n) {
    let r = arrayCacheI32[n];
    if (r === undefined) {
        r = new Int32Array(n);
        arrayCacheI32[n] = r;
    }
    for(let i = 0; i !== n; ++i)r[i] = textures.allocateTextureUnit();
    return r;
}
// --- Setters ---
// Note: Defining these methods externally, because they come in a bunch
// and this way their names minify.
// Single scalar
function setValueV1f(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1f(this.addr, v);
    cache[0] = v;
}
// Single float vector (from flat array or THREE.VectorN)
function setValueV2f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y) {
            gl.uniform2f(this.addr, v.x, v.y);
            cache[0] = v.x;
            cache[1] = v.y;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform2fv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV3f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z) {
            gl.uniform3f(this.addr, v.x, v.y, v.z);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
        }
    } else if (v.r !== undefined) {
        if (cache[0] !== v.r || cache[1] !== v.g || cache[2] !== v.b) {
            gl.uniform3f(this.addr, v.r, v.g, v.b);
            cache[0] = v.r;
            cache[1] = v.g;
            cache[2] = v.b;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform3fv(this.addr, v);
        copyArray(cache, v);
    }
}
function setValueV4f(gl, v) {
    const cache = this.cache;
    if (v.x !== undefined) {
        if (cache[0] !== v.x || cache[1] !== v.y || cache[2] !== v.z || cache[3] !== v.w) {
            gl.uniform4f(this.addr, v.x, v.y, v.z, v.w);
            cache[0] = v.x;
            cache[1] = v.y;
            cache[2] = v.z;
            cache[3] = v.w;
        }
    } else {
        if (arraysEqual(cache, v)) return;
        gl.uniform4fv(this.addr, v);
        copyArray(cache, v);
    }
}
// Single matrix (from flat array or MatrixN)
function setValueM2(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if (arraysEqual(cache, v)) return;
        gl.uniformMatrix2fv(this.addr, false, v);
        copyArray(cache, v);
    } else {
        if (arraysEqual(cache, elements)) return;
        mat2array.set(elements);
        gl.uniformMatrix2fv(this.addr, false, mat2array);
        copyArray(cache, elements);
    }
}
function setValueM3(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if (arraysEqual(cache, v)) return;
        gl.uniformMatrix3fv(this.addr, false, v);
        copyArray(cache, v);
    } else {
        if (arraysEqual(cache, elements)) return;
        mat3array.set(elements);
        gl.uniformMatrix3fv(this.addr, false, mat3array);
        copyArray(cache, elements);
    }
}
function setValueM4(gl, v) {
    const cache = this.cache;
    const elements = v.elements;
    if (elements === undefined) {
        if (arraysEqual(cache, v)) return;
        gl.uniformMatrix4fv(this.addr, false, v);
        copyArray(cache, v);
    } else {
        if (arraysEqual(cache, elements)) return;
        mat4array.set(elements);
        gl.uniformMatrix4fv(this.addr, false, mat4array);
        copyArray(cache, elements);
    }
}
// Single texture (2D / Cube)
function setValueT1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTexture2D(v || emptyTexture, unit);
}
function setValueT2DArray1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture2DArray(v || emptyTexture2dArray, unit);
}
function setValueT3D1(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.setTexture3D(v || emptyTexture3d, unit);
}
function setValueT6(gl, v, textures) {
    const cache = this.cache;
    const unit = textures.allocateTextureUnit();
    if (cache[0] !== unit) {
        gl.uniform1i(this.addr, unit);
        cache[0] = unit;
    }
    textures.safeSetTextureCube(v || emptyCubeTexture, unit);
}
// Integer / Boolean vectors or arrays thereof (always flat arrays)
function setValueV1i(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1i(this.addr, v);
    cache[0] = v;
}
function setValueV2i(gl, v) {
    const cache = this.cache;
    if (arraysEqual(cache, v)) return;
    gl.uniform2iv(this.addr, v);
    copyArray(cache, v);
}
function setValueV3i(gl, v) {
    const cache = this.cache;
    if (arraysEqual(cache, v)) return;
    gl.uniform3iv(this.addr, v);
    copyArray(cache, v);
}
function setValueV4i(gl, v) {
    const cache = this.cache;
    if (arraysEqual(cache, v)) return;
    gl.uniform4iv(this.addr, v);
    copyArray(cache, v);
}
// uint
function setValueV1ui(gl, v) {
    const cache = this.cache;
    if (cache[0] === v) return;
    gl.uniform1ui(this.addr, v);
    cache[0] = v;
}
// Helper to pick the right setter for the singular case
function getSingularSetter(type) {
    switch(type){
        case 0x1406:
            return setValueV1f; // FLOAT
        case 0x8b50:
            return setValueV2f; // _VEC2
        case 0x8b51:
            return setValueV3f; // _VEC3
        case 0x8b52:
            return setValueV4f; // _VEC4
        case 0x8b5a:
            return setValueM2; // _MAT2
        case 0x8b5b:
            return setValueM3; // _MAT3
        case 0x8b5c:
            return setValueM4; // _MAT4
        case 0x1404:
        case 0x8b56:
            return setValueV1i; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return setValueV2i; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return setValueV3i; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return setValueV4i; // _VEC4
        case 0x1405:
            return setValueV1ui; // UINT
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return setValueT1;
        case 0x8b5f:
        case 0x8dcb:
        case 0x8dd3:
            return setValueT3D1;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return setValueT6;
        case 0x8dc1:
        case 0x8dcf:
        case 0x8dd7:
        case 0x8dc4:
            return setValueT2DArray1;
    }
}
// Array of scalars
function setValueV1fArray(gl, v) {
    gl.uniform1fv(this.addr, v);
}
// Integer / Boolean vectors or arrays thereof (always flat arrays)
function setValueV1iArray(gl, v) {
    gl.uniform1iv(this.addr, v);
}
function setValueV2iArray(gl, v) {
    gl.uniform2iv(this.addr, v);
}
function setValueV3iArray(gl, v) {
    gl.uniform3iv(this.addr, v);
}
function setValueV4iArray(gl, v) {
    gl.uniform4iv(this.addr, v);
}
// Array of vectors (flat or from THREE classes)
function setValueV2fArray(gl, v) {
    const data = flatten(v, this.size, 2);
    gl.uniform2fv(this.addr, data);
}
function setValueV3fArray(gl, v) {
    const data = flatten(v, this.size, 3);
    gl.uniform3fv(this.addr, data);
}
function setValueV4fArray(gl, v) {
    const data = flatten(v, this.size, 4);
    gl.uniform4fv(this.addr, data);
}
// Array of matrices (flat or from THREE clases)
function setValueM2Array(gl, v) {
    const data = flatten(v, this.size, 4);
    gl.uniformMatrix2fv(this.addr, false, data);
}
function setValueM3Array(gl, v) {
    const data = flatten(v, this.size, 9);
    gl.uniformMatrix3fv(this.addr, false, data);
}
function setValueM4Array(gl, v) {
    const data = flatten(v, this.size, 16);
    gl.uniformMatrix4fv(this.addr, false, data);
}
// Array of textures (2D / Cube)
function setValueT1Array(gl, v, textures) {
    const n = v.length;
    const units = allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTexture2D(v[i] || emptyTexture, units[i]);
}
function setValueT6Array(gl, v, textures) {
    const n = v.length;
    const units = allocTexUnits(textures, n);
    gl.uniform1iv(this.addr, units);
    for(let i = 0; i !== n; ++i)textures.safeSetTextureCube(v[i] || emptyCubeTexture, units[i]);
}
// Helper to pick the right setter for a pure (bottom-level) array
function getPureArraySetter(type) {
    switch(type){
        case 0x1406:
            return setValueV1fArray; // FLOAT
        case 0x8b50:
            return setValueV2fArray; // _VEC2
        case 0x8b51:
            return setValueV3fArray; // _VEC3
        case 0x8b52:
            return setValueV4fArray; // _VEC4
        case 0x8b5a:
            return setValueM2Array; // _MAT2
        case 0x8b5b:
            return setValueM3Array; // _MAT3
        case 0x8b5c:
            return setValueM4Array; // _MAT4
        case 0x1404:
        case 0x8b56:
            return setValueV1iArray; // INT, BOOL
        case 0x8b53:
        case 0x8b57:
            return setValueV2iArray; // _VEC2
        case 0x8b54:
        case 0x8b58:
            return setValueV3iArray; // _VEC3
        case 0x8b55:
        case 0x8b59:
            return setValueV4iArray; // _VEC4
        case 0x8b5e:
        case 0x8d66:
        case 0x8dca:
        case 0x8dd2:
        case 0x8b62:
            return setValueT1Array;
        case 0x8b60:
        case 0x8dcc:
        case 0x8dd4:
        case 0x8dc5:
            return setValueT6Array;
    }
}
// --- Uniform Classes ---
function SingleUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.setValue = getSingularSetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
function PureArrayUniform(id, activeInfo, addr) {
    this.id = id;
    this.addr = addr;
    this.cache = [];
    this.size = activeInfo.size;
    this.setValue = getPureArraySetter(activeInfo.type);
// this.path = activeInfo.name; // DEBUG
}
PureArrayUniform.prototype.updateCache = function(data) {
    const cache = this.cache;
    if (data instanceof Float32Array && cache.length !== data.length) this.cache = new Float32Array(data.length);
    copyArray(cache, data);
};
function StructuredUniform(id) {
    this.id = id;
    this.seq = [];
    this.map = {};
}
StructuredUniform.prototype.setValue = function(gl, value, textures) {
    const seq = this.seq;
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        u.setValue(gl, value[u.id], textures);
    }
};
// --- Top-level ---
// Parser - builds up the property tree from the path strings
const RePathPart = /(\w+)(\])?(\[|\.)?/g;
// extracts
// 	- the identifier (member name or array index)
//  - followed by an optional right bracket (found when array index)
//  - followed by an optional left bracket or dot (type of subscript)
//
// Note: These portions can be read in a non-overlapping fashion and
// allow straightforward parsing of the hierarchy that WebGL encodes
// in the uniform names.
function addUniform(container, uniformObject) {
    container.seq.push(uniformObject);
    container.map[uniformObject.id] = uniformObject;
}
function parseUniform(activeInfo, addr, container) {
    const path = activeInfo.name, pathLength = path.length;
    // reset RegExp object, because of the early exit of a previous run
    RePathPart.lastIndex = 0;
    while(true){
        const match = RePathPart.exec(path), matchEnd = RePathPart.lastIndex;
        let id = match[1];
        const idIsIndex = match[2] === ']', subscript = match[3];
        if (idIsIndex) id = id | 0; // convert to integer
        if (subscript === undefined || subscript === '[' && matchEnd + 2 === pathLength) {
            // bare name or "pure" bottom-level array "[0]" suffix
            addUniform(container, subscript === undefined ? new SingleUniform(id, activeInfo, addr) : new PureArrayUniform(id, activeInfo, addr));
            break;
        } else {
            // step into inner node / create it in case it doesn't exist
            const map = container.map;
            let next = map[id];
            if (next === undefined) {
                next = new StructuredUniform(id);
                addUniform(container, next);
            }
            container = next;
        }
    }
}
// Root Container
function WebGLUniforms(gl, program) {
    this.seq = [];
    this.map = {};
    const n = gl.getProgramParameter(program, 35718);
    for(let i = 0; i < n; ++i){
        const info = gl.getActiveUniform(program, i), addr = gl.getUniformLocation(program, info.name);
        parseUniform(info, addr, this);
    }
}
WebGLUniforms.prototype.setValue = function(gl, name, value, textures) {
    const u = this.map[name];
    if (u !== undefined) u.setValue(gl, value, textures);
};
WebGLUniforms.prototype.setOptional = function(gl, object, name) {
    const v = object[name];
    if (v !== undefined) this.setValue(gl, name, v);
};
// Static interface
WebGLUniforms.upload = function(gl, seq, values, textures) {
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i], v = values[u.id];
        if (v.needsUpdate !== false) // note: always updating when .needsUpdate is undefined
        u.setValue(gl, v.value, textures);
    }
};
WebGLUniforms.seqWithValue = function(seq, values) {
    const r = [];
    for(let i = 0, n = seq.length; i !== n; ++i){
        const u = seq[i];
        if (u.id in values) r.push(u);
    }
    return r;
};
function WebGLShader(gl, type, string) {
    const shader = gl.createShader(type);
    gl.shaderSource(shader, string);
    gl.compileShader(shader);
    return shader;
}
let programIdCount = 0;
function addLineNumbers(string) {
    const lines = string.split('\n');
    for(let i = 0; i < lines.length; i++)lines[i] = i + 1 + ': ' + lines[i];
    return lines.join('\n');
}
function getEncodingComponents(encoding) {
    switch(encoding){
        case LinearEncoding:
            return [
                'Linear',
                '( value )'
            ];
        case sRGBEncoding:
            return [
                'sRGB',
                '( value )'
            ];
        case RGBEEncoding:
            return [
                'RGBE',
                '( value )'
            ];
        case RGBM7Encoding:
            return [
                'RGBM',
                '( value, 7.0 )'
            ];
        case RGBM16Encoding:
            return [
                'RGBM',
                '( value, 16.0 )'
            ];
        case RGBDEncoding:
            return [
                'RGBD',
                '( value, 256.0 )'
            ];
        case GammaEncoding:
            return [
                'Gamma',
                '( value, float( GAMMA_FACTOR ) )'
            ];
        case LogLuvEncoding:
            return [
                'LogLuv',
                '( value )'
            ];
        default:
            console.warn('THREE.WebGLProgram: Unsupported encoding:', encoding);
            return [
                'Linear',
                '( value )'
            ];
    }
}
function getShaderErrors(gl, shader, type) {
    const status = gl.getShaderParameter(shader, 35713);
    const log = gl.getShaderInfoLog(shader).trim();
    if (status && log === '') return '';
    // --enable-privileged-webgl-extension
    // console.log( '**' + type + '**', gl.getExtension( 'WEBGL_debug_shaders' ).getTranslatedShaderSource( shader ) );
    const source = gl.getShaderSource(shader);
    return 'THREE.WebGLShader: gl.getShaderInfoLog() ' + type + '\n' + log + addLineNumbers(source);
}
function getTexelDecodingFunction(functionName, encoding) {
    const components = getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return ' + components[0] + 'ToLinear' + components[1] + '; }';
}
function getTexelEncodingFunction(functionName, encoding) {
    const components = getEncodingComponents(encoding);
    return 'vec4 ' + functionName + '( vec4 value ) { return LinearTo' + components[0] + components[1] + '; }';
}
function getToneMappingFunction(functionName, toneMapping) {
    let toneMappingName;
    switch(toneMapping){
        case LinearToneMapping:
            toneMappingName = 'Linear';
            break;
        case ReinhardToneMapping:
            toneMappingName = 'Reinhard';
            break;
        case CineonToneMapping:
            toneMappingName = 'OptimizedCineon';
            break;
        case ACESFilmicToneMapping:
            toneMappingName = 'ACESFilmic';
            break;
        case CustomToneMapping:
            toneMappingName = 'Custom';
            break;
        default:
            console.warn('THREE.WebGLProgram: Unsupported toneMapping:', toneMapping);
            toneMappingName = 'Linear';
    }
    return 'vec3 ' + functionName + '( vec3 color ) { return ' + toneMappingName + 'ToneMapping( color ); }';
}
function generateExtensions(parameters) {
    const chunks = [
        parameters.extensionDerivatives || parameters.envMapCubeUV || parameters.bumpMap || parameters.tangentSpaceNormalMap || parameters.clearcoatNormalMap || parameters.flatShading || parameters.shaderID === 'physical' ? '#extension GL_OES_standard_derivatives : enable' : '',
        (parameters.extensionFragDepth || parameters.logarithmicDepthBuffer) && parameters.rendererExtensionFragDepth ? '#extension GL_EXT_frag_depth : enable' : '',
        parameters.extensionDrawBuffers && parameters.rendererExtensionDrawBuffers ? '#extension GL_EXT_draw_buffers : require' : '',
        (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? '#extension GL_EXT_shader_texture_lod : enable' : ''
    ];
    return chunks.filter(filterEmptyLine).join('\n');
}
function generateDefines(defines) {
    const chunks = [];
    for(const name in defines){
        const value = defines[name];
        if (value === false) continue;
        chunks.push('#define ' + name + ' ' + value);
    }
    return chunks.join('\n');
}
function fetchAttributeLocations(gl, program) {
    const attributes = {};
    const n = gl.getProgramParameter(program, 35721);
    for(let i = 0; i < n; i++){
        const info = gl.getActiveAttrib(program, i);
        const name = info.name;
        // console.log( 'THREE.WebGLProgram: ACTIVE VERTEX ATTRIBUTE:', name, i );
        attributes[name] = gl.getAttribLocation(program, name);
    }
    return attributes;
}
function filterEmptyLine(string) {
    return string !== '';
}
function replaceLightNums(string, parameters) {
    return string.replace(/NUM_DIR_LIGHTS/g, parameters.numDirLights).replace(/NUM_SPOT_LIGHTS/g, parameters.numSpotLights).replace(/NUM_RECT_AREA_LIGHTS/g, parameters.numRectAreaLights).replace(/NUM_POINT_LIGHTS/g, parameters.numPointLights).replace(/NUM_HEMI_LIGHTS/g, parameters.numHemiLights).replace(/NUM_DIR_LIGHT_SHADOWS/g, parameters.numDirLightShadows).replace(/NUM_SPOT_LIGHT_SHADOWS/g, parameters.numSpotLightShadows).replace(/NUM_POINT_LIGHT_SHADOWS/g, parameters.numPointLightShadows);
}
function replaceClippingPlaneNums(string, parameters) {
    return string.replace(/NUM_CLIPPING_PLANES/g, parameters.numClippingPlanes).replace(/UNION_CLIPPING_PLANES/g, parameters.numClippingPlanes - parameters.numClipIntersection);
}
// Resolve Includes
const includePattern = /^[ \t]*#include +<([\w\d./]+)>/gm;
function resolveIncludes(string) {
    return string.replace(includePattern, includeReplacer);
}
function includeReplacer(match, include) {
    const string = ShaderChunk[include];
    if (string === undefined) throw new Error('Can not resolve #include <' + include + '>');
    return resolveIncludes(string);
}
// Unroll Loops
const deprecatedUnrollLoopPattern = /#pragma unroll_loop[\s]+?for \( int i \= (\d+)\; i < (\d+)\; i \+\+ \) \{([\s\S]+?)(?=\})\}/g;
const unrollLoopPattern = /#pragma unroll_loop_start\s+for\s*\(\s*int\s+i\s*=\s*(\d+)\s*;\s*i\s*<\s*(\d+)\s*;\s*i\s*\+\+\s*\)\s*{([\s\S]+?)}\s+#pragma unroll_loop_end/g;
function unrollLoops(string) {
    return string.replace(unrollLoopPattern, loopReplacer).replace(deprecatedUnrollLoopPattern, deprecatedLoopReplacer);
}
function deprecatedLoopReplacer(match, start, end, snippet) {
    console.warn('WebGLProgram: #pragma unroll_loop shader syntax is deprecated. Please use #pragma unroll_loop_start syntax instead.');
    return loopReplacer(match, start, end, snippet);
}
function loopReplacer(match, start, end, snippet) {
    let string = '';
    for(let i = parseInt(start); i < parseInt(end); i++)string += snippet.replace(/\[\s*i\s*\]/g, '[ ' + i + ' ]').replace(/UNROLLED_LOOP_INDEX/g, i);
    return string;
}
//
function generatePrecision(parameters) {
    let precisionstring = 'precision ' + parameters.precision + ' float;\nprecision ' + parameters.precision + ' int;';
    if (parameters.precision === 'highp') precisionstring += '\n#define HIGH_PRECISION';
    else if (parameters.precision === 'mediump') precisionstring += '\n#define MEDIUM_PRECISION';
    else if (parameters.precision === 'lowp') precisionstring += '\n#define LOW_PRECISION';
    return precisionstring;
}
function generateShadowMapTypeDefine(parameters) {
    let shadowMapTypeDefine = 'SHADOWMAP_TYPE_BASIC';
    if (parameters.shadowMapType === PCFShadowMap) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF';
    else if (parameters.shadowMapType === PCFSoftShadowMap) shadowMapTypeDefine = 'SHADOWMAP_TYPE_PCF_SOFT';
    else if (parameters.shadowMapType === VSMShadowMap) shadowMapTypeDefine = 'SHADOWMAP_TYPE_VSM';
    return shadowMapTypeDefine;
}
function generateEnvMapTypeDefine(parameters) {
    let envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
    if (parameters.envMap) switch(parameters.envMapMode){
        case CubeReflectionMapping:
        case CubeRefractionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE';
            break;
        case CubeUVReflectionMapping:
        case CubeUVRefractionMapping:
            envMapTypeDefine = 'ENVMAP_TYPE_CUBE_UV';
            break;
    }
    return envMapTypeDefine;
}
function generateEnvMapModeDefine(parameters) {
    let envMapModeDefine = 'ENVMAP_MODE_REFLECTION';
    if (parameters.envMap) switch(parameters.envMapMode){
        case CubeRefractionMapping:
        case CubeUVRefractionMapping:
            envMapModeDefine = 'ENVMAP_MODE_REFRACTION';
            break;
    }
    return envMapModeDefine;
}
function generateEnvMapBlendingDefine(parameters) {
    let envMapBlendingDefine = 'ENVMAP_BLENDING_NONE';
    if (parameters.envMap) switch(parameters.combine){
        case MultiplyOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MULTIPLY';
            break;
        case MixOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_MIX';
            break;
        case AddOperation:
            envMapBlendingDefine = 'ENVMAP_BLENDING_ADD';
            break;
    }
    return envMapBlendingDefine;
}
function WebGLProgram(renderer, cacheKey, parameters, bindingStates) {
    const gl = renderer.getContext();
    const defines = parameters.defines;
    let vertexShader = parameters.vertexShader;
    let fragmentShader = parameters.fragmentShader;
    const shadowMapTypeDefine = generateShadowMapTypeDefine(parameters);
    const envMapTypeDefine = generateEnvMapTypeDefine(parameters);
    const envMapModeDefine = generateEnvMapModeDefine(parameters);
    const envMapBlendingDefine = generateEnvMapBlendingDefine(parameters);
    const gammaFactorDefine = renderer.gammaFactor > 0 ? renderer.gammaFactor : 1.0;
    const customExtensions = parameters.isWebGL2 ? '' : generateExtensions(parameters);
    const customDefines = generateDefines(defines);
    const program = gl.createProgram();
    let prefixVertex, prefixFragment;
    let versionString = parameters.glslVersion ? '#version ' + parameters.glslVersion + '\n' : '';
    if (parameters.isRawShaderMaterial) {
        prefixVertex = [
            customDefines
        ].filter(filterEmptyLine).join('\n');
        if (prefixVertex.length > 0) prefixVertex += '\n';
        prefixFragment = [
            customExtensions,
            customDefines
        ].filter(filterEmptyLine).join('\n');
        if (prefixFragment.length > 0) prefixFragment += '\n';
    } else {
        prefixVertex = [
            generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.instancing ? '#define USE_INSTANCING' : '',
            parameters.instancingColor ? '#define USE_INSTANCING_COLOR' : '',
            parameters.supportsVertexTextures ? '#define VERTEX_TEXTURES' : '',
            '#define GAMMA_FACTOR ' + gammaFactorDefine,
            '#define MAX_BONES ' + parameters.maxBones,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.displacementMap && parameters.supportsVertexTextures ? '#define USE_DISPLACEMENTMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors ? '#define USE_COLOR' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.skinning ? '#define USE_SKINNING' : '',
            parameters.useVertexTexture ? '#define BONE_TEXTURE' : '',
            parameters.morphTargets ? '#define USE_MORPHTARGETS' : '',
            parameters.morphNormals && parameters.flatShading === false ? '#define USE_MORPHNORMALS' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.sizeAttenuation ? '#define USE_SIZEATTENUATION' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            'uniform mat4 modelMatrix;',
            'uniform mat4 modelViewMatrix;',
            'uniform mat4 projectionMatrix;',
            'uniform mat4 viewMatrix;',
            'uniform mat3 normalMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            '#ifdef USE_INSTANCING',
            '	attribute mat4 instanceMatrix;',
            '#endif',
            '#ifdef USE_INSTANCING_COLOR',
            '	attribute vec3 instanceColor;',
            '#endif',
            'attribute vec3 position;',
            'attribute vec3 normal;',
            'attribute vec2 uv;',
            '#ifdef USE_TANGENT',
            '	attribute vec4 tangent;',
            '#endif',
            '#ifdef USE_COLOR',
            '	attribute vec3 color;',
            '#endif',
            '#ifdef USE_MORPHTARGETS',
            '	attribute vec3 morphTarget0;',
            '	attribute vec3 morphTarget1;',
            '	attribute vec3 morphTarget2;',
            '	attribute vec3 morphTarget3;',
            '	#ifdef USE_MORPHNORMALS',
            '		attribute vec3 morphNormal0;',
            '		attribute vec3 morphNormal1;',
            '		attribute vec3 morphNormal2;',
            '		attribute vec3 morphNormal3;',
            '	#else',
            '		attribute vec3 morphTarget4;',
            '		attribute vec3 morphTarget5;',
            '		attribute vec3 morphTarget6;',
            '		attribute vec3 morphTarget7;',
            '	#endif',
            '#endif',
            '#ifdef USE_SKINNING',
            '	attribute vec4 skinIndex;',
            '	attribute vec4 skinWeight;',
            '#endif',
            '\n'
        ].filter(filterEmptyLine).join('\n');
        prefixFragment = [
            customExtensions,
            generatePrecision(parameters),
            '#define SHADER_NAME ' + parameters.shaderName,
            customDefines,
            parameters.alphaTest ? '#define ALPHATEST ' + parameters.alphaTest + (parameters.alphaTest % 1 ? '' : '.0') : '',
            '#define GAMMA_FACTOR ' + gammaFactorDefine,
            parameters.useFog && parameters.fog ? '#define USE_FOG' : '',
            parameters.useFog && parameters.fogExp2 ? '#define FOG_EXP2' : '',
            parameters.map ? '#define USE_MAP' : '',
            parameters.matcap ? '#define USE_MATCAP' : '',
            parameters.envMap ? '#define USE_ENVMAP' : '',
            parameters.envMap ? '#define ' + envMapTypeDefine : '',
            parameters.envMap ? '#define ' + envMapModeDefine : '',
            parameters.envMap ? '#define ' + envMapBlendingDefine : '',
            parameters.lightMap ? '#define USE_LIGHTMAP' : '',
            parameters.aoMap ? '#define USE_AOMAP' : '',
            parameters.emissiveMap ? '#define USE_EMISSIVEMAP' : '',
            parameters.bumpMap ? '#define USE_BUMPMAP' : '',
            parameters.normalMap ? '#define USE_NORMALMAP' : '',
            parameters.normalMap && parameters.objectSpaceNormalMap ? '#define OBJECTSPACE_NORMALMAP' : '',
            parameters.normalMap && parameters.tangentSpaceNormalMap ? '#define TANGENTSPACE_NORMALMAP' : '',
            parameters.clearcoatMap ? '#define USE_CLEARCOATMAP' : '',
            parameters.clearcoatRoughnessMap ? '#define USE_CLEARCOAT_ROUGHNESSMAP' : '',
            parameters.clearcoatNormalMap ? '#define USE_CLEARCOAT_NORMALMAP' : '',
            parameters.specularMap ? '#define USE_SPECULARMAP' : '',
            parameters.roughnessMap ? '#define USE_ROUGHNESSMAP' : '',
            parameters.metalnessMap ? '#define USE_METALNESSMAP' : '',
            parameters.alphaMap ? '#define USE_ALPHAMAP' : '',
            parameters.sheen ? '#define USE_SHEEN' : '',
            parameters.transmissionMap ? '#define USE_TRANSMISSIONMAP' : '',
            parameters.vertexTangents ? '#define USE_TANGENT' : '',
            parameters.vertexColors || parameters.instancingColor ? '#define USE_COLOR' : '',
            parameters.vertexUvs ? '#define USE_UV' : '',
            parameters.uvsVertexOnly ? '#define UVS_VERTEX_ONLY' : '',
            parameters.gradientMap ? '#define USE_GRADIENTMAP' : '',
            parameters.flatShading ? '#define FLAT_SHADED' : '',
            parameters.doubleSided ? '#define DOUBLE_SIDED' : '',
            parameters.flipSided ? '#define FLIP_SIDED' : '',
            parameters.shadowMapEnabled ? '#define USE_SHADOWMAP' : '',
            parameters.shadowMapEnabled ? '#define ' + shadowMapTypeDefine : '',
            parameters.premultipliedAlpha ? '#define PREMULTIPLIED_ALPHA' : '',
            parameters.physicallyCorrectLights ? '#define PHYSICALLY_CORRECT_LIGHTS' : '',
            parameters.logarithmicDepthBuffer ? '#define USE_LOGDEPTHBUF' : '',
            parameters.logarithmicDepthBuffer && parameters.rendererExtensionFragDepth ? '#define USE_LOGDEPTHBUF_EXT' : '',
            (parameters.extensionShaderTextureLOD || parameters.envMap) && parameters.rendererExtensionShaderTextureLod ? '#define TEXTURE_LOD_EXT' : '',
            'uniform mat4 viewMatrix;',
            'uniform vec3 cameraPosition;',
            'uniform bool isOrthographic;',
            parameters.toneMapping !== NoToneMapping ? '#define TONE_MAPPING' : '',
            parameters.toneMapping !== NoToneMapping ? ShaderChunk['tonemapping_pars_fragment'] : '',
            parameters.toneMapping !== NoToneMapping ? getToneMappingFunction('toneMapping', parameters.toneMapping) : '',
            parameters.dithering ? '#define DITHERING' : '',
            ShaderChunk['encodings_pars_fragment'],
            parameters.map ? getTexelDecodingFunction('mapTexelToLinear', parameters.mapEncoding) : '',
            parameters.matcap ? getTexelDecodingFunction('matcapTexelToLinear', parameters.matcapEncoding) : '',
            parameters.envMap ? getTexelDecodingFunction('envMapTexelToLinear', parameters.envMapEncoding) : '',
            parameters.emissiveMap ? getTexelDecodingFunction('emissiveMapTexelToLinear', parameters.emissiveMapEncoding) : '',
            parameters.lightMap ? getTexelDecodingFunction('lightMapTexelToLinear', parameters.lightMapEncoding) : '',
            getTexelEncodingFunction('linearToOutputTexel', parameters.outputEncoding),
            parameters.depthPacking ? '#define DEPTH_PACKING ' + parameters.depthPacking : '',
            '\n'
        ].filter(filterEmptyLine).join('\n');
    }
    vertexShader = resolveIncludes(vertexShader);
    vertexShader = replaceLightNums(vertexShader, parameters);
    vertexShader = replaceClippingPlaneNums(vertexShader, parameters);
    fragmentShader = resolveIncludes(fragmentShader);
    fragmentShader = replaceLightNums(fragmentShader, parameters);
    fragmentShader = replaceClippingPlaneNums(fragmentShader, parameters);
    vertexShader = unrollLoops(vertexShader);
    fragmentShader = unrollLoops(fragmentShader);
    if (parameters.isWebGL2 && parameters.isRawShaderMaterial !== true) {
        // GLSL 3.0 conversion for built-in materials and ShaderMaterial
        versionString = '#version 300 es\n';
        prefixVertex = [
            '#define attribute in',
            '#define varying out',
            '#define texture2D texture'
        ].join('\n') + '\n' + prefixVertex;
        prefixFragment = [
            '#define varying in',
            parameters.glslVersion === GLSL3 ? '' : 'out highp vec4 pc_fragColor;',
            parameters.glslVersion === GLSL3 ? '' : '#define gl_FragColor pc_fragColor',
            '#define gl_FragDepthEXT gl_FragDepth',
            '#define texture2D texture',
            '#define textureCube texture',
            '#define texture2DProj textureProj',
            '#define texture2DLodEXT textureLod',
            '#define texture2DProjLodEXT textureProjLod',
            '#define textureCubeLodEXT textureLod',
            '#define texture2DGradEXT textureGrad',
            '#define texture2DProjGradEXT textureProjGrad',
            '#define textureCubeGradEXT textureGrad'
        ].join('\n') + '\n' + prefixFragment;
    }
    const vertexGlsl = versionString + prefixVertex + vertexShader;
    const fragmentGlsl = versionString + prefixFragment + fragmentShader;
    // console.log( '*VERTEX*', vertexGlsl );
    // console.log( '*FRAGMENT*', fragmentGlsl );
    const glVertexShader = WebGLShader(gl, 35633, vertexGlsl);
    const glFragmentShader = WebGLShader(gl, 35632, fragmentGlsl);
    gl.attachShader(program, glVertexShader);
    gl.attachShader(program, glFragmentShader);
    // Force a particular attribute to index 0.
    if (parameters.index0AttributeName !== undefined) gl.bindAttribLocation(program, 0, parameters.index0AttributeName);
    else if (parameters.morphTargets === true) // programs with morphTargets displace position out of attribute 0
    gl.bindAttribLocation(program, 0, 'position');
    gl.linkProgram(program);
    // check for link errors
    if (renderer.debug.checkShaderErrors) {
        const programLog = gl.getProgramInfoLog(program).trim();
        const vertexLog = gl.getShaderInfoLog(glVertexShader).trim();
        const fragmentLog = gl.getShaderInfoLog(glFragmentShader).trim();
        let runnable = true;
        let haveDiagnostics = true;
        if (gl.getProgramParameter(program, 35714) === false) {
            runnable = false;
            const vertexErrors = getShaderErrors(gl, glVertexShader, 'vertex');
            const fragmentErrors = getShaderErrors(gl, glFragmentShader, 'fragment');
            console.error('THREE.WebGLProgram: shader error: ', gl.getError(), '35715', gl.getProgramParameter(program, 35715), 'gl.getProgramInfoLog', programLog, vertexErrors, fragmentErrors);
        } else if (programLog !== '') console.warn('THREE.WebGLProgram: gl.getProgramInfoLog()', programLog);
        else if (vertexLog === '' || fragmentLog === '') haveDiagnostics = false;
        if (haveDiagnostics) this.diagnostics = {
            runnable: runnable,
            programLog: programLog,
            vertexShader: {
                log: vertexLog,
                prefix: prefixVertex
            },
            fragmentShader: {
                log: fragmentLog,
                prefix: prefixFragment
            }
        };
    }
    // Clean up
    // Crashes in iOS9 and iOS10. #18402
    // gl.detachShader( program, glVertexShader );
    // gl.detachShader( program, glFragmentShader );
    gl.deleteShader(glVertexShader);
    gl.deleteShader(glFragmentShader);
    // set up caching for uniform locations
    let cachedUniforms;
    this.getUniforms = function() {
        if (cachedUniforms === undefined) cachedUniforms = new WebGLUniforms(gl, program);
        return cachedUniforms;
    };
    // set up caching for attribute locations
    let cachedAttributes;
    this.getAttributes = function() {
        if (cachedAttributes === undefined) cachedAttributes = fetchAttributeLocations(gl, program);
        return cachedAttributes;
    };
    // free resource
    this.destroy = function() {
        bindingStates.releaseStatesOfProgram(this);
        gl.deleteProgram(program);
        this.program = undefined;
    };
    //
    this.name = parameters.shaderName;
    this.id = programIdCount++;
    this.cacheKey = cacheKey;
    this.usedTimes = 1;
    this.program = program;
    this.vertexShader = glVertexShader;
    this.fragmentShader = glFragmentShader;
    return this;
}
function WebGLPrograms(renderer, cubemaps, extensions, capabilities, bindingStates, clipping) {
    const programs = [];
    const isWebGL2 = capabilities.isWebGL2;
    const logarithmicDepthBuffer = capabilities.logarithmicDepthBuffer;
    const floatVertexTextures = capabilities.floatVertexTextures;
    const maxVertexUniforms = capabilities.maxVertexUniforms;
    const vertexTextures = capabilities.vertexTextures;
    let precision = capabilities.precision;
    const shaderIDs = {
        MeshDepthMaterial: 'depth',
        MeshDistanceMaterial: 'distanceRGBA',
        MeshNormalMaterial: 'normal',
        MeshBasicMaterial: 'basic',
        MeshLambertMaterial: 'lambert',
        MeshPhongMaterial: 'phong',
        MeshToonMaterial: 'toon',
        MeshStandardMaterial: 'physical',
        MeshPhysicalMaterial: 'physical',
        MeshMatcapMaterial: 'matcap',
        LineBasicMaterial: 'basic',
        LineDashedMaterial: 'dashed',
        PointsMaterial: 'points',
        ShadowMaterial: 'shadow',
        SpriteMaterial: 'sprite'
    };
    const parameterNames = [
        'precision',
        'isWebGL2',
        'supportsVertexTextures',
        'outputEncoding',
        'instancing',
        'instancingColor',
        'map',
        'mapEncoding',
        'matcap',
        'matcapEncoding',
        'envMap',
        'envMapMode',
        'envMapEncoding',
        'envMapCubeUV',
        'lightMap',
        'lightMapEncoding',
        'aoMap',
        'emissiveMap',
        'emissiveMapEncoding',
        'bumpMap',
        'normalMap',
        'objectSpaceNormalMap',
        'tangentSpaceNormalMap',
        'clearcoatMap',
        'clearcoatRoughnessMap',
        'clearcoatNormalMap',
        'displacementMap',
        'specularMap',
        'roughnessMap',
        'metalnessMap',
        'gradientMap',
        'alphaMap',
        'combine',
        'vertexColors',
        'vertexTangents',
        'vertexUvs',
        'uvsVertexOnly',
        'fog',
        'useFog',
        'fogExp2',
        'flatShading',
        'sizeAttenuation',
        'logarithmicDepthBuffer',
        'skinning',
        'maxBones',
        'useVertexTexture',
        'morphTargets',
        'morphNormals',
        'maxMorphTargets',
        'maxMorphNormals',
        'premultipliedAlpha',
        'numDirLights',
        'numPointLights',
        'numSpotLights',
        'numHemiLights',
        'numRectAreaLights',
        'numDirLightShadows',
        'numPointLightShadows',
        'numSpotLightShadows',
        'shadowMapEnabled',
        'shadowMapType',
        'toneMapping',
        'physicallyCorrectLights',
        'alphaTest',
        'doubleSided',
        'flipSided',
        'numClippingPlanes',
        'numClipIntersection',
        'depthPacking',
        'dithering',
        'sheen',
        'transmissionMap'
    ];
    function getMaxBones(object) {
        const skeleton = object.skeleton;
        const bones = skeleton.bones;
        if (floatVertexTextures) return 1024;
        else {
            // default for when object is not specified
            // ( for example when prebuilding shader to be used with multiple objects )
            //
            //  - leave some extra space for other uniforms
            //  - limit here is ANGLE's 254 max uniform vectors
            //    (up to 54 should be safe)
            const nVertexUniforms = maxVertexUniforms;
            const nVertexMatrices = Math.floor((nVertexUniforms - 20) / 4);
            const maxBones = Math.min(nVertexMatrices, bones.length);
            if (maxBones < bones.length) {
                console.warn('THREE.WebGLRenderer: Skeleton has ' + bones.length + ' bones. This GPU supports ' + maxBones + '.');
                return 0;
            }
            return maxBones;
        }
    }
    function getTextureEncodingFromMap(map) {
        let encoding;
        if (map && map.isTexture) encoding = map.encoding;
        else if (map && map.isWebGLRenderTarget) {
            console.warn('THREE.WebGLPrograms.getTextureEncodingFromMap: don\'t use render targets as textures. Use their .texture property instead.');
            encoding = map.texture.encoding;
        } else encoding = LinearEncoding;
        return encoding;
    }
    function getParameters(material, lights, shadows, scene, object) {
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const envMap = cubemaps.get(material.envMap || environment);
        const shaderID = shaderIDs[material.type];
        // heuristics to create shader parameters according to lights in the scene
        // (not to blow over maxLights budget)
        const maxBones = object.isSkinnedMesh ? getMaxBones(object) : 0;
        if (material.precision !== null) {
            precision = capabilities.getMaxPrecision(material.precision);
            if (precision !== material.precision) console.warn('THREE.WebGLProgram.getParameters:', material.precision, 'not supported, using', precision, 'instead.');
        }
        let vertexShader, fragmentShader;
        if (shaderID) {
            const shader = ShaderLib[shaderID];
            vertexShader = shader.vertexShader;
            fragmentShader = shader.fragmentShader;
        } else {
            vertexShader = material.vertexShader;
            fragmentShader = material.fragmentShader;
        }
        const currentRenderTarget = renderer.getRenderTarget();
        const parameters = {
            isWebGL2: isWebGL2,
            shaderID: shaderID,
            shaderName: material.type,
            vertexShader: vertexShader,
            fragmentShader: fragmentShader,
            defines: material.defines,
            isRawShaderMaterial: material.isRawShaderMaterial === true,
            glslVersion: material.glslVersion,
            precision: precision,
            instancing: object.isInstancedMesh === true,
            instancingColor: object.isInstancedMesh === true && object.instanceColor !== null,
            supportsVertexTextures: vertexTextures,
            outputEncoding: currentRenderTarget !== null ? getTextureEncodingFromMap(currentRenderTarget.texture) : renderer.outputEncoding,
            map: !!material.map,
            mapEncoding: getTextureEncodingFromMap(material.map),
            matcap: !!material.matcap,
            matcapEncoding: getTextureEncodingFromMap(material.matcap),
            envMap: !!envMap,
            envMapMode: envMap && envMap.mapping,
            envMapEncoding: getTextureEncodingFromMap(envMap),
            envMapCubeUV: !!envMap && (envMap.mapping === CubeUVReflectionMapping || envMap.mapping === CubeUVRefractionMapping),
            lightMap: !!material.lightMap,
            lightMapEncoding: getTextureEncodingFromMap(material.lightMap),
            aoMap: !!material.aoMap,
            emissiveMap: !!material.emissiveMap,
            emissiveMapEncoding: getTextureEncodingFromMap(material.emissiveMap),
            bumpMap: !!material.bumpMap,
            normalMap: !!material.normalMap,
            objectSpaceNormalMap: material.normalMapType === ObjectSpaceNormalMap,
            tangentSpaceNormalMap: material.normalMapType === TangentSpaceNormalMap,
            clearcoatMap: !!material.clearcoatMap,
            clearcoatRoughnessMap: !!material.clearcoatRoughnessMap,
            clearcoatNormalMap: !!material.clearcoatNormalMap,
            displacementMap: !!material.displacementMap,
            roughnessMap: !!material.roughnessMap,
            metalnessMap: !!material.metalnessMap,
            specularMap: !!material.specularMap,
            alphaMap: !!material.alphaMap,
            gradientMap: !!material.gradientMap,
            sheen: !!material.sheen,
            transmissionMap: !!material.transmissionMap,
            combine: material.combine,
            vertexTangents: material.normalMap && material.vertexTangents,
            vertexColors: material.vertexColors,
            vertexUvs: !!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatMap || !!material.clearcoatRoughnessMap || !!material.clearcoatNormalMap || !!material.displacementMap || !!material.transmissionMap,
            uvsVertexOnly: !(!!material.map || !!material.bumpMap || !!material.normalMap || !!material.specularMap || !!material.alphaMap || !!material.emissiveMap || !!material.roughnessMap || !!material.metalnessMap || !!material.clearcoatNormalMap || !!material.transmissionMap) && !!material.displacementMap,
            fog: !!fog,
            useFog: material.fog,
            fogExp2: fog && fog.isFogExp2,
            flatShading: material.flatShading,
            sizeAttenuation: material.sizeAttenuation,
            logarithmicDepthBuffer: logarithmicDepthBuffer,
            skinning: material.skinning && maxBones > 0,
            maxBones: maxBones,
            useVertexTexture: floatVertexTextures,
            morphTargets: material.morphTargets,
            morphNormals: material.morphNormals,
            maxMorphTargets: renderer.maxMorphTargets,
            maxMorphNormals: renderer.maxMorphNormals,
            numDirLights: lights.directional.length,
            numPointLights: lights.point.length,
            numSpotLights: lights.spot.length,
            numRectAreaLights: lights.rectArea.length,
            numHemiLights: lights.hemi.length,
            numDirLightShadows: lights.directionalShadowMap.length,
            numPointLightShadows: lights.pointShadowMap.length,
            numSpotLightShadows: lights.spotShadowMap.length,
            numClippingPlanes: clipping.numPlanes,
            numClipIntersection: clipping.numIntersection,
            dithering: material.dithering,
            shadowMapEnabled: renderer.shadowMap.enabled && shadows.length > 0,
            shadowMapType: renderer.shadowMap.type,
            toneMapping: material.toneMapped ? renderer.toneMapping : NoToneMapping,
            physicallyCorrectLights: renderer.physicallyCorrectLights,
            premultipliedAlpha: material.premultipliedAlpha,
            alphaTest: material.alphaTest,
            doubleSided: material.side === DoubleSide,
            flipSided: material.side === BackSide,
            depthPacking: material.depthPacking !== undefined ? material.depthPacking : false,
            index0AttributeName: material.index0AttributeName,
            extensionDerivatives: material.extensions && material.extensions.derivatives,
            extensionFragDepth: material.extensions && material.extensions.fragDepth,
            extensionDrawBuffers: material.extensions && material.extensions.drawBuffers,
            extensionShaderTextureLOD: material.extensions && material.extensions.shaderTextureLOD,
            rendererExtensionFragDepth: isWebGL2 || extensions.has('EXT_frag_depth'),
            rendererExtensionDrawBuffers: isWebGL2 || extensions.has('WEBGL_draw_buffers'),
            rendererExtensionShaderTextureLod: isWebGL2 || extensions.has('EXT_shader_texture_lod'),
            customProgramCacheKey: material.customProgramCacheKey()
        };
        return parameters;
    }
    function getProgramCacheKey(parameters) {
        const array = [];
        if (parameters.shaderID) array.push(parameters.shaderID);
        else {
            array.push(parameters.fragmentShader);
            array.push(parameters.vertexShader);
        }
        if (parameters.defines !== undefined) for(const name in parameters.defines){
            array.push(name);
            array.push(parameters.defines[name]);
        }
        if (parameters.isRawShaderMaterial === false) {
            for(let i = 0; i < parameterNames.length; i++)array.push(parameters[parameterNames[i]]);
            array.push(renderer.outputEncoding);
            array.push(renderer.gammaFactor);
        }
        array.push(parameters.customProgramCacheKey);
        return array.join();
    }
    function getUniforms(material) {
        const shaderID = shaderIDs[material.type];
        let uniforms;
        if (shaderID) {
            const shader = ShaderLib[shaderID];
            uniforms = UniformsUtils.clone(shader.uniforms);
        } else uniforms = material.uniforms;
        return uniforms;
    }
    function acquireProgram(parameters, cacheKey) {
        let program;
        // Check if code has been already compiled
        for(let p = 0, pl = programs.length; p < pl; p++){
            const preexistingProgram = programs[p];
            if (preexistingProgram.cacheKey === cacheKey) {
                program = preexistingProgram;
                ++program.usedTimes;
                break;
            }
        }
        if (program === undefined) {
            program = new WebGLProgram(renderer, cacheKey, parameters, bindingStates);
            programs.push(program);
        }
        return program;
    }
    function releaseProgram(program) {
        if (--program.usedTimes === 0) {
            // Remove from unordered set
            const i = programs.indexOf(program);
            programs[i] = programs[programs.length - 1];
            programs.pop();
            // Free WebGL resources
            program.destroy();
        }
    }
    return {
        getParameters: getParameters,
        getProgramCacheKey: getProgramCacheKey,
        getUniforms: getUniforms,
        acquireProgram: acquireProgram,
        releaseProgram: releaseProgram,
        // Exposed for resource monitoring & error feedback via renderer.info:
        programs: programs
    };
}
function WebGLProperties() {
    let properties = new WeakMap();
    function get(object) {
        let map = properties.get(object);
        if (map === undefined) {
            map = {};
            properties.set(object, map);
        }
        return map;
    }
    function remove(object) {
        properties.delete(object);
    }
    function update(object, key, value) {
        properties.get(object)[key] = value;
    }
    function dispose() {
        properties = new WeakMap();
    }
    return {
        get: get,
        remove: remove,
        update: update,
        dispose: dispose
    };
}
function painterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.program !== b.program) return a.program.id - b.program.id;
    else if (a.material.id !== b.material.id) return a.material.id - b.material.id;
    else if (a.z !== b.z) return a.z - b.z;
    else return a.id - b.id;
}
function reversePainterSortStable(a, b) {
    if (a.groupOrder !== b.groupOrder) return a.groupOrder - b.groupOrder;
    else if (a.renderOrder !== b.renderOrder) return a.renderOrder - b.renderOrder;
    else if (a.z !== b.z) return b.z - a.z;
    else return a.id - b.id;
}
function WebGLRenderList(properties) {
    const renderItems = [];
    let renderItemsIndex = 0;
    const opaque = [];
    const transparent = [];
    const defaultProgram = {
        id: -1
    };
    function init() {
        renderItemsIndex = 0;
        opaque.length = 0;
        transparent.length = 0;
    }
    function getNextRenderItem(object, geometry, material, groupOrder, z, group) {
        let renderItem = renderItems[renderItemsIndex];
        const materialProperties = properties.get(material);
        if (renderItem === undefined) {
            renderItem = {
                id: object.id,
                object: object,
                geometry: geometry,
                material: material,
                program: materialProperties.program || defaultProgram,
                groupOrder: groupOrder,
                renderOrder: object.renderOrder,
                z: z,
                group: group
            };
            renderItems[renderItemsIndex] = renderItem;
        } else {
            renderItem.id = object.id;
            renderItem.object = object;
            renderItem.geometry = geometry;
            renderItem.material = material;
            renderItem.program = materialProperties.program || defaultProgram;
            renderItem.groupOrder = groupOrder;
            renderItem.renderOrder = object.renderOrder;
            renderItem.z = z;
            renderItem.group = group;
        }
        renderItemsIndex++;
        return renderItem;
    }
    function push(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        (material.transparent === true ? transparent : opaque).push(renderItem);
    }
    function unshift(object, geometry, material, groupOrder, z, group) {
        const renderItem = getNextRenderItem(object, geometry, material, groupOrder, z, group);
        (material.transparent === true ? transparent : opaque).unshift(renderItem);
    }
    function sort(customOpaqueSort, customTransparentSort) {
        if (opaque.length > 1) opaque.sort(customOpaqueSort || painterSortStable);
        if (transparent.length > 1) transparent.sort(customTransparentSort || reversePainterSortStable);
    }
    function finish() {
        // Clear references from inactive renderItems in the list
        for(let i = renderItemsIndex, il = renderItems.length; i < il; i++){
            const renderItem = renderItems[i];
            if (renderItem.id === null) break;
            renderItem.id = null;
            renderItem.object = null;
            renderItem.geometry = null;
            renderItem.material = null;
            renderItem.program = null;
            renderItem.group = null;
        }
    }
    return {
        opaque: opaque,
        transparent: transparent,
        init: init,
        push: push,
        unshift: unshift,
        finish: finish,
        sort: sort
    };
}
function WebGLRenderLists(properties) {
    let lists = new WeakMap();
    function get(scene, camera) {
        const cameras = lists.get(scene);
        let list;
        if (cameras === undefined) {
            list = new WebGLRenderList(properties);
            lists.set(scene, new WeakMap());
            lists.get(scene).set(camera, list);
        } else {
            list = cameras.get(camera);
            if (list === undefined) {
                list = new WebGLRenderList(properties);
                cameras.set(camera, list);
            }
        }
        return list;
    }
    function dispose() {
        lists = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
function UniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        direction: new Vector3(),
                        color: new Color()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        position: new Vector3(),
                        direction: new Vector3(),
                        color: new Color(),
                        distance: 0,
                        coneCos: 0,
                        penumbraCos: 0,
                        decay: 0
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        position: new Vector3(),
                        color: new Color(),
                        distance: 0,
                        decay: 0
                    };
                    break;
                case 'HemisphereLight':
                    uniforms = {
                        direction: new Vector3(),
                        skyColor: new Color(),
                        groundColor: new Color()
                    };
                    break;
                case 'RectAreaLight':
                    uniforms = {
                        color: new Color(),
                        position: new Vector3(),
                        halfWidth: new Vector3(),
                        halfHeight: new Vector3()
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
function ShadowUniformsCache() {
    const lights = {};
    return {
        get: function(light) {
            if (lights[light.id] !== undefined) return lights[light.id];
            let uniforms;
            switch(light.type){
                case 'DirectionalLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new Vector2()
                    };
                    break;
                case 'SpotLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new Vector2()
                    };
                    break;
                case 'PointLight':
                    uniforms = {
                        shadowBias: 0,
                        shadowNormalBias: 0,
                        shadowRadius: 1,
                        shadowMapSize: new Vector2(),
                        shadowCameraNear: 1,
                        shadowCameraFar: 1000
                    };
                    break;
            }
            lights[light.id] = uniforms;
            return uniforms;
        }
    };
}
let nextVersion = 0;
function shadowCastingLightsFirst(lightA, lightB) {
    return (lightB.castShadow ? 1 : 0) - (lightA.castShadow ? 1 : 0);
}
function WebGLLights(extensions, capabilities) {
    const cache = new UniformsCache();
    const shadowCache = ShadowUniformsCache();
    const state = {
        version: 0,
        hash: {
            directionalLength: -1,
            pointLength: -1,
            spotLength: -1,
            rectAreaLength: -1,
            hemiLength: -1,
            numDirectionalShadows: -1,
            numPointShadows: -1,
            numSpotShadows: -1
        },
        ambient: [
            0,
            0,
            0
        ],
        probe: [],
        directional: [],
        directionalShadow: [],
        directionalShadowMap: [],
        directionalShadowMatrix: [],
        spot: [],
        spotShadow: [],
        spotShadowMap: [],
        spotShadowMatrix: [],
        rectArea: [],
        rectAreaLTC1: null,
        rectAreaLTC2: null,
        point: [],
        pointShadow: [],
        pointShadowMap: [],
        pointShadowMatrix: [],
        hemi: []
    };
    for(let i = 0; i < 9; i++)state.probe.push(new Vector3());
    const vector3 = new Vector3();
    const matrix4 = new Matrix4();
    const matrix42 = new Matrix4();
    function setup(lights) {
        let r = 0, g = 0, b = 0;
        for(let i = 0; i < 9; i++)state.probe[i].set(0, 0, 0);
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        let numDirectionalShadows = 0;
        let numPointShadows = 0;
        let numSpotShadows = 0;
        lights.sort(shadowCastingLightsFirst);
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            const color = light.color;
            const intensity = light.intensity;
            const distance = light.distance;
            const shadowMap = light.shadow && light.shadow.map ? light.shadow.map.texture : null;
            if (light.isAmbientLight) {
                r += color.r * intensity;
                g += color.g * intensity;
                b += color.b * intensity;
            } else if (light.isLightProbe) for(let j = 0; j < 9; j++)state.probe[j].addScaledVector(light.sh.coefficients[j], intensity);
            else if (light.isDirectionalLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.directionalShadow[directionalLength] = shadowUniforms;
                    state.directionalShadowMap[directionalLength] = shadowMap;
                    state.directionalShadowMatrix[directionalLength] = light.shadow.matrix;
                    numDirectionalShadows++;
                }
                state.directional[directionalLength] = uniforms;
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = cache.get(light);
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.distance = distance;
                uniforms.coneCos = Math.cos(light.angle);
                uniforms.penumbraCos = Math.cos(light.angle * (1 - light.penumbra));
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    state.spotShadow[spotLength] = shadowUniforms;
                    state.spotShadowMap[spotLength] = shadowMap;
                    state.spotShadowMatrix[spotLength] = light.shadow.matrix;
                    numSpotShadows++;
                }
                state.spot[spotLength] = uniforms;
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = cache.get(light);
                // (a) intensity is the total visible light emitted
                //uniforms.color.copy( color ).multiplyScalar( intensity / ( light.width * light.height * Math.PI ) );
                // (b) intensity is the brightness of the light
                uniforms.color.copy(color).multiplyScalar(intensity);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                state.rectArea[rectAreaLength] = uniforms;
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = cache.get(light);
                uniforms.color.copy(light.color).multiplyScalar(light.intensity);
                uniforms.distance = light.distance;
                uniforms.decay = light.decay;
                if (light.castShadow) {
                    const shadow = light.shadow;
                    const shadowUniforms = shadowCache.get(light);
                    shadowUniforms.shadowBias = shadow.bias;
                    shadowUniforms.shadowNormalBias = shadow.normalBias;
                    shadowUniforms.shadowRadius = shadow.radius;
                    shadowUniforms.shadowMapSize = shadow.mapSize;
                    shadowUniforms.shadowCameraNear = shadow.camera.near;
                    shadowUniforms.shadowCameraFar = shadow.camera.far;
                    state.pointShadow[pointLength] = shadowUniforms;
                    state.pointShadowMap[pointLength] = shadowMap;
                    state.pointShadowMatrix[pointLength] = light.shadow.matrix;
                    numPointShadows++;
                }
                state.point[pointLength] = uniforms;
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = cache.get(light);
                uniforms.skyColor.copy(light.color).multiplyScalar(intensity);
                uniforms.groundColor.copy(light.groundColor).multiplyScalar(intensity);
                state.hemi[hemiLength] = uniforms;
                hemiLength++;
            }
        }
        if (rectAreaLength > 0) {
            if (capabilities.isWebGL2) {
                // WebGL 2
                state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
                state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
            } else {
                // WebGL 1
                if (extensions.has('OES_texture_float_linear') === true) {
                    state.rectAreaLTC1 = UniformsLib.LTC_FLOAT_1;
                    state.rectAreaLTC2 = UniformsLib.LTC_FLOAT_2;
                } else if (extensions.has('OES_texture_half_float_linear') === true) {
                    state.rectAreaLTC1 = UniformsLib.LTC_HALF_1;
                    state.rectAreaLTC2 = UniformsLib.LTC_HALF_2;
                } else console.error('THREE.WebGLRenderer: Unable to use RectAreaLight. Missing WebGL extensions.');
            }
        }
        state.ambient[0] = r;
        state.ambient[1] = g;
        state.ambient[2] = b;
        const hash = state.hash;
        if (hash.directionalLength !== directionalLength || hash.pointLength !== pointLength || hash.spotLength !== spotLength || hash.rectAreaLength !== rectAreaLength || hash.hemiLength !== hemiLength || hash.numDirectionalShadows !== numDirectionalShadows || hash.numPointShadows !== numPointShadows || hash.numSpotShadows !== numSpotShadows) {
            state.directional.length = directionalLength;
            state.spot.length = spotLength;
            state.rectArea.length = rectAreaLength;
            state.point.length = pointLength;
            state.hemi.length = hemiLength;
            state.directionalShadow.length = numDirectionalShadows;
            state.directionalShadowMap.length = numDirectionalShadows;
            state.pointShadow.length = numPointShadows;
            state.pointShadowMap.length = numPointShadows;
            state.spotShadow.length = numSpotShadows;
            state.spotShadowMap.length = numSpotShadows;
            state.directionalShadowMatrix.length = numDirectionalShadows;
            state.pointShadowMatrix.length = numPointShadows;
            state.spotShadowMatrix.length = numSpotShadows;
            hash.directionalLength = directionalLength;
            hash.pointLength = pointLength;
            hash.spotLength = spotLength;
            hash.rectAreaLength = rectAreaLength;
            hash.hemiLength = hemiLength;
            hash.numDirectionalShadows = numDirectionalShadows;
            hash.numPointShadows = numPointShadows;
            hash.numSpotShadows = numSpotShadows;
            state.version = nextVersion++;
        }
    }
    function setupView(lights, camera) {
        let directionalLength = 0;
        let pointLength = 0;
        let spotLength = 0;
        let rectAreaLength = 0;
        let hemiLength = 0;
        const viewMatrix = camera.matrixWorldInverse;
        for(let i = 0, l = lights.length; i < l; i++){
            const light = lights[i];
            if (light.isDirectionalLight) {
                const uniforms = state.directional[directionalLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                directionalLength++;
            } else if (light.isSpotLight) {
                const uniforms = state.spot[spotLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                vector3.setFromMatrixPosition(light.target.matrixWorld);
                uniforms.direction.sub(vector3);
                uniforms.direction.transformDirection(viewMatrix);
                spotLength++;
            } else if (light.isRectAreaLight) {
                const uniforms = state.rectArea[rectAreaLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                // extract local rotation of light to derive width/height half vectors
                matrix42.identity();
                matrix4.copy(light.matrixWorld);
                matrix4.premultiply(viewMatrix);
                matrix42.extractRotation(matrix4);
                uniforms.halfWidth.set(light.width * 0.5, 0.0, 0.0);
                uniforms.halfHeight.set(0.0, light.height * 0.5, 0.0);
                uniforms.halfWidth.applyMatrix4(matrix42);
                uniforms.halfHeight.applyMatrix4(matrix42);
                rectAreaLength++;
            } else if (light.isPointLight) {
                const uniforms = state.point[pointLength];
                uniforms.position.setFromMatrixPosition(light.matrixWorld);
                uniforms.position.applyMatrix4(viewMatrix);
                pointLength++;
            } else if (light.isHemisphereLight) {
                const uniforms = state.hemi[hemiLength];
                uniforms.direction.setFromMatrixPosition(light.matrixWorld);
                uniforms.direction.transformDirection(viewMatrix);
                uniforms.direction.normalize();
                hemiLength++;
            }
        }
    }
    return {
        setup: setup,
        setupView: setupView,
        state: state
    };
}
function WebGLRenderState(extensions, capabilities) {
    const lights = new WebGLLights(extensions, capabilities);
    const lightsArray = [];
    const shadowsArray = [];
    function init() {
        lightsArray.length = 0;
        shadowsArray.length = 0;
    }
    function pushLight(light) {
        lightsArray.push(light);
    }
    function pushShadow(shadowLight) {
        shadowsArray.push(shadowLight);
    }
    function setupLights() {
        lights.setup(lightsArray);
    }
    function setupLightsView(camera) {
        lights.setupView(lightsArray, camera);
    }
    const state = {
        lightsArray: lightsArray,
        shadowsArray: shadowsArray,
        lights: lights
    };
    return {
        init: init,
        state: state,
        setupLights: setupLights,
        setupLightsView: setupLightsView,
        pushLight: pushLight,
        pushShadow: pushShadow
    };
}
function WebGLRenderStates(extensions, capabilities) {
    let renderStates = new WeakMap();
    function get(scene, renderCallDepth = 0) {
        let renderState;
        if (renderStates.has(scene) === false) {
            renderState = new WebGLRenderState(extensions, capabilities);
            renderStates.set(scene, []);
            renderStates.get(scene).push(renderState);
        } else if (renderCallDepth >= renderStates.get(scene).length) {
            renderState = new WebGLRenderState(extensions, capabilities);
            renderStates.get(scene).push(renderState);
        } else renderState = renderStates.get(scene)[renderCallDepth];
        return renderState;
    }
    function dispose() {
        renderStates = new WeakMap();
    }
    return {
        get: get,
        dispose: dispose
    };
}
/**
 * parameters = {
 *
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 * }
 */ function MeshDepthMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshDepthMaterial';
    this.depthPacking = BasicDepthPacking;
    this.skinning = false;
    this.morphTargets = false;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.setValues(parameters);
}
MeshDepthMaterial.prototype = Object.create(Material.prototype);
MeshDepthMaterial.prototype.constructor = MeshDepthMaterial;
MeshDepthMaterial.prototype.isMeshDepthMaterial = true;
MeshDepthMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.depthPacking = source.depthPacking;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    return this;
};
/**
 * parameters = {
 *
 *  referencePosition: <float>,
 *  nearDistance: <float>,
 *  farDistance: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>
 *
 * }
 */ function MeshDistanceMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshDistanceMaterial';
    this.referencePosition = new Vector3();
    this.nearDistance = 1;
    this.farDistance = 1000;
    this.skinning = false;
    this.morphTargets = false;
    this.map = null;
    this.alphaMap = null;
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.fog = false;
    this.setValues(parameters);
}
MeshDistanceMaterial.prototype = Object.create(Material.prototype);
MeshDistanceMaterial.prototype.constructor = MeshDistanceMaterial;
MeshDistanceMaterial.prototype.isMeshDistanceMaterial = true;
MeshDistanceMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.referencePosition.copy(source.referencePosition);
    this.nearDistance = source.nearDistance;
    this.farDistance = source.farDistance;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    return this;
};
var vsm_frag = "uniform sampler2D shadow_pass;\nuniform vec2 resolution;\nuniform float radius;\n#include <packing>\nvoid main() {\n\tfloat mean = 0.0;\n\tfloat squared_mean = 0.0;\n\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy ) / resolution ) );\n\tfor ( float i = -1.0; i < 1.0 ; i += SAMPLE_RATE) {\n\t\t#ifdef HORIZONTAL_PASS\n\t\t\tvec2 distribution = unpackRGBATo2Half( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( i, 0.0 ) * radius ) / resolution ) );\n\t\t\tmean += distribution.x;\n\t\t\tsquared_mean += distribution.y * distribution.y + distribution.x * distribution.x;\n\t\t#else\n\t\t\tfloat depth = unpackRGBAToDepth( texture2D( shadow_pass, ( gl_FragCoord.xy + vec2( 0.0, i ) * radius ) / resolution ) );\n\t\t\tmean += depth;\n\t\t\tsquared_mean += depth * depth;\n\t\t#endif\n\t}\n\tmean = mean * HALF_SAMPLE_RATE;\n\tsquared_mean = squared_mean * HALF_SAMPLE_RATE;\n\tfloat std_dev = sqrt( squared_mean - mean * mean );\n\tgl_FragColor = pack2HalfToRGBA( vec2( mean, std_dev ) );\n}";
var vsm_vert = "void main() {\n\tgl_Position = vec4( position, 1.0 );\n}";
function WebGLShadowMap(_renderer, _objects, maxTextureSize) {
    let _frustum = new Frustum();
    const _shadowMapSize = new Vector2(), _viewportSize = new Vector2(), _viewport = new Vector4(), _depthMaterials = [], _distanceMaterials = [], _materialCache = {};
    const shadowSide = {
        0: BackSide,
        1: FrontSide,
        2: DoubleSide
    };
    const shadowMaterialVertical = new ShaderMaterial({
        defines: {
            SAMPLE_RATE: 0.25,
            HALF_SAMPLE_RATE: 0.125
        },
        uniforms: {
            shadow_pass: {
                value: null
            },
            resolution: {
                value: new Vector2()
            },
            radius: {
                value: 4.0
            }
        },
        vertexShader: vsm_vert,
        fragmentShader: vsm_frag
    });
    const shadowMaterialHorizontal = shadowMaterialVertical.clone();
    shadowMaterialHorizontal.defines.HORIZONTAL_PASS = 1;
    const fullScreenTri = new BufferGeometry();
    fullScreenTri.setAttribute('position', new BufferAttribute(new Float32Array([
        -1,
        -1,
        0.5,
        3,
        -1,
        0.5,
        -1,
        3,
        0.5
    ]), 3));
    const fullScreenMesh = new Mesh(fullScreenTri, shadowMaterialVertical);
    const scope = this;
    this.enabled = false;
    this.autoUpdate = true;
    this.needsUpdate = false;
    this.type = PCFShadowMap;
    this.render = function(lights, scene, camera) {
        if (scope.enabled === false) return;
        if (scope.autoUpdate === false && scope.needsUpdate === false) return;
        if (lights.length === 0) return;
        const currentRenderTarget = _renderer.getRenderTarget();
        const activeCubeFace = _renderer.getActiveCubeFace();
        const activeMipmapLevel = _renderer.getActiveMipmapLevel();
        const _state = _renderer.state;
        // Set GL state for depth map.
        _state.setBlending(NoBlending);
        _state.buffers.color.setClear(1, 1, 1, 1);
        _state.buffers.depth.setTest(true);
        _state.setScissorTest(false);
        // render depth map
        for(let i = 0, il = lights.length; i < il; i++){
            const light = lights[i];
            const shadow = light.shadow;
            if (shadow === undefined) {
                console.warn('THREE.WebGLShadowMap:', light, 'has no shadow.');
                continue;
            }
            if (shadow.autoUpdate === false && shadow.needsUpdate === false) continue;
            _shadowMapSize.copy(shadow.mapSize);
            const shadowFrameExtents = shadow.getFrameExtents();
            _shadowMapSize.multiply(shadowFrameExtents);
            _viewportSize.copy(shadow.mapSize);
            if (_shadowMapSize.x > maxTextureSize || _shadowMapSize.y > maxTextureSize) {
                if (_shadowMapSize.x > maxTextureSize) {
                    _viewportSize.x = Math.floor(maxTextureSize / shadowFrameExtents.x);
                    _shadowMapSize.x = _viewportSize.x * shadowFrameExtents.x;
                    shadow.mapSize.x = _viewportSize.x;
                }
                if (_shadowMapSize.y > maxTextureSize) {
                    _viewportSize.y = Math.floor(maxTextureSize / shadowFrameExtents.y);
                    _shadowMapSize.y = _viewportSize.y * shadowFrameExtents.y;
                    shadow.mapSize.y = _viewportSize.y;
                }
            }
            if (shadow.map === null && !shadow.isPointLightShadow && this.type === VSMShadowMap) {
                const pars = {
                    minFilter: LinearFilter,
                    magFilter: LinearFilter,
                    format: RGBAFormat
                };
                shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.mapPass = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.camera.updateProjectionMatrix();
            }
            if (shadow.map === null) {
                const pars = {
                    minFilter: NearestFilter,
                    magFilter: NearestFilter,
                    format: RGBAFormat
                };
                shadow.map = new WebGLRenderTarget(_shadowMapSize.x, _shadowMapSize.y, pars);
                shadow.map.texture.name = light.name + '.shadowMap';
                shadow.camera.updateProjectionMatrix();
            }
            _renderer.setRenderTarget(shadow.map);
            _renderer.clear();
            const viewportCount = shadow.getViewportCount();
            for(let vp = 0; vp < viewportCount; vp++){
                const viewport = shadow.getViewport(vp);
                _viewport.set(_viewportSize.x * viewport.x, _viewportSize.y * viewport.y, _viewportSize.x * viewport.z, _viewportSize.y * viewport.w);
                _state.viewport(_viewport);
                shadow.updateMatrices(light, vp);
                _frustum = shadow.getFrustum();
                renderObject(scene, camera, shadow.camera, light, this.type);
            }
            // do blur pass for VSM
            if (!shadow.isPointLightShadow && this.type === VSMShadowMap) VSMPass(shadow, camera);
            shadow.needsUpdate = false;
        }
        scope.needsUpdate = false;
        _renderer.setRenderTarget(currentRenderTarget, activeCubeFace, activeMipmapLevel);
    };
    function VSMPass(shadow, camera) {
        const geometry = _objects.update(fullScreenMesh);
        // vertical pass
        shadowMaterialVertical.uniforms.shadow_pass.value = shadow.map.texture;
        shadowMaterialVertical.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialVertical.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.mapPass);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialVertical, fullScreenMesh, null);
        // horizontal pass
        shadowMaterialHorizontal.uniforms.shadow_pass.value = shadow.mapPass.texture;
        shadowMaterialHorizontal.uniforms.resolution.value = shadow.mapSize;
        shadowMaterialHorizontal.uniforms.radius.value = shadow.radius;
        _renderer.setRenderTarget(shadow.map);
        _renderer.clear();
        _renderer.renderBufferDirect(camera, null, geometry, shadowMaterialHorizontal, fullScreenMesh, null);
    }
    function getDepthMaterialVariant(useMorphing, useSkinning, useInstancing) {
        const index = useMorphing << 0 | useSkinning << 1 | useInstancing << 2;
        let material = _depthMaterials[index];
        if (material === undefined) {
            material = new MeshDepthMaterial({
                depthPacking: RGBADepthPacking,
                morphTargets: useMorphing,
                skinning: useSkinning
            });
            _depthMaterials[index] = material;
        }
        return material;
    }
    function getDistanceMaterialVariant(useMorphing, useSkinning, useInstancing) {
        const index = useMorphing << 0 | useSkinning << 1 | useInstancing << 2;
        let material = _distanceMaterials[index];
        if (material === undefined) {
            material = new MeshDistanceMaterial({
                morphTargets: useMorphing,
                skinning: useSkinning
            });
            _distanceMaterials[index] = material;
        }
        return material;
    }
    function getDepthMaterial(object, geometry, material, light, shadowCameraNear, shadowCameraFar, type) {
        let result = null;
        let getMaterialVariant = getDepthMaterialVariant;
        let customMaterial = object.customDepthMaterial;
        if (light.isPointLight === true) {
            getMaterialVariant = getDistanceMaterialVariant;
            customMaterial = object.customDistanceMaterial;
        }
        if (customMaterial === undefined) {
            let useMorphing = false;
            if (material.morphTargets === true) useMorphing = geometry.morphAttributes && geometry.morphAttributes.position && geometry.morphAttributes.position.length > 0;
            let useSkinning = false;
            if (object.isSkinnedMesh === true) {
                if (material.skinning === true) useSkinning = true;
                else console.warn('THREE.WebGLShadowMap: THREE.SkinnedMesh with material.skinning set to false:', object);
            }
            const useInstancing = object.isInstancedMesh === true;
            result = getMaterialVariant(useMorphing, useSkinning, useInstancing);
        } else result = customMaterial;
        if (_renderer.localClippingEnabled && material.clipShadows === true && material.clippingPlanes.length !== 0) {
            // in this case we need a unique material instance reflecting the
            // appropriate state
            const keyA = result.uuid, keyB = material.uuid;
            let materialsForVariant = _materialCache[keyA];
            if (materialsForVariant === undefined) {
                materialsForVariant = {};
                _materialCache[keyA] = materialsForVariant;
            }
            let cachedMaterial = materialsForVariant[keyB];
            if (cachedMaterial === undefined) {
                cachedMaterial = result.clone();
                materialsForVariant[keyB] = cachedMaterial;
            }
            result = cachedMaterial;
        }
        result.visible = material.visible;
        result.wireframe = material.wireframe;
        if (type === VSMShadowMap) result.side = material.shadowSide !== null ? material.shadowSide : material.side;
        else result.side = material.shadowSide !== null ? material.shadowSide : shadowSide[material.side];
        result.clipShadows = material.clipShadows;
        result.clippingPlanes = material.clippingPlanes;
        result.clipIntersection = material.clipIntersection;
        result.wireframeLinewidth = material.wireframeLinewidth;
        result.linewidth = material.linewidth;
        if (light.isPointLight === true && result.isMeshDistanceMaterial === true) {
            result.referencePosition.setFromMatrixPosition(light.matrixWorld);
            result.nearDistance = shadowCameraNear;
            result.farDistance = shadowCameraFar;
        }
        return result;
    }
    function renderObject(object, camera, shadowCamera, light, type) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible && (object.isMesh || object.isLine || object.isPoints)) {
            if ((object.castShadow || object.receiveShadow && type === VSMShadowMap) && (!object.frustumCulled || _frustum.intersectsObject(object))) {
                object.modelViewMatrix.multiplyMatrices(shadowCamera.matrixWorldInverse, object.matrixWorld);
                const geometry = _objects.update(object);
                const material = object.material;
                if (Array.isArray(material)) {
                    const groups = geometry.groups;
                    for(let k = 0, kl = groups.length; k < kl; k++){
                        const group = groups[k];
                        const groupMaterial = material[group.materialIndex];
                        if (groupMaterial && groupMaterial.visible) {
                            const depthMaterial = getDepthMaterial(object, geometry, groupMaterial, light, shadowCamera.near, shadowCamera.far, type);
                            _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, group);
                        }
                    }
                } else if (material.visible) {
                    const depthMaterial = getDepthMaterial(object, geometry, material, light, shadowCamera.near, shadowCamera.far, type);
                    _renderer.renderBufferDirect(shadowCamera, null, geometry, depthMaterial, object, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)renderObject(children[i], camera, shadowCamera, light, type);
    }
}
function WebGLState(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function ColorBuffer() {
        let locked = false;
        const color = new Vector4();
        let currentColorMask = null;
        const currentColorClear = new Vector4(0, 0, 0, 0);
        return {
            setMask: function(colorMask) {
                if (currentColorMask !== colorMask && !locked) {
                    gl.colorMask(colorMask, colorMask, colorMask, colorMask);
                    currentColorMask = colorMask;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(r, g, b, a, premultipliedAlpha) {
                if (premultipliedAlpha === true) {
                    r *= a;
                    g *= a;
                    b *= a;
                }
                color.set(r, g, b, a);
                if (currentColorClear.equals(color) === false) {
                    gl.clearColor(r, g, b, a);
                    currentColorClear.copy(color);
                }
            },
            reset: function() {
                locked = false;
                currentColorMask = null;
                currentColorClear.set(-1, 0, 0, 0); // set to invalid state
            }
        };
    }
    function DepthBuffer() {
        let locked = false;
        let currentDepthMask = null;
        let currentDepthFunc = null;
        let currentDepthClear = null;
        return {
            setTest: function(depthTest) {
                if (depthTest) enable(2929);
                else disable(2929);
            },
            setMask: function(depthMask) {
                if (currentDepthMask !== depthMask && !locked) {
                    gl.depthMask(depthMask);
                    currentDepthMask = depthMask;
                }
            },
            setFunc: function(depthFunc) {
                if (currentDepthFunc !== depthFunc) {
                    if (depthFunc) switch(depthFunc){
                        case NeverDepth:
                            gl.depthFunc(512);
                            break;
                        case AlwaysDepth:
                            gl.depthFunc(519);
                            break;
                        case LessDepth:
                            gl.depthFunc(513);
                            break;
                        case LessEqualDepth:
                            gl.depthFunc(515);
                            break;
                        case EqualDepth:
                            gl.depthFunc(514);
                            break;
                        case GreaterEqualDepth:
                            gl.depthFunc(518);
                            break;
                        case GreaterDepth:
                            gl.depthFunc(516);
                            break;
                        case NotEqualDepth:
                            gl.depthFunc(517);
                            break;
                        default:
                            gl.depthFunc(515);
                    }
                    else gl.depthFunc(515);
                    currentDepthFunc = depthFunc;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(depth) {
                if (currentDepthClear !== depth) {
                    gl.clearDepth(depth);
                    currentDepthClear = depth;
                }
            },
            reset: function() {
                locked = false;
                currentDepthMask = null;
                currentDepthFunc = null;
                currentDepthClear = null;
            }
        };
    }
    function StencilBuffer() {
        let locked = false;
        let currentStencilMask = null;
        let currentStencilFunc = null;
        let currentStencilRef = null;
        let currentStencilFuncMask = null;
        let currentStencilFail = null;
        let currentStencilZFail = null;
        let currentStencilZPass = null;
        let currentStencilClear = null;
        return {
            setTest: function(stencilTest) {
                if (!locked) {
                    if (stencilTest) enable(2960);
                    else disable(2960);
                }
            },
            setMask: function(stencilMask) {
                if (currentStencilMask !== stencilMask && !locked) {
                    gl.stencilMask(stencilMask);
                    currentStencilMask = stencilMask;
                }
            },
            setFunc: function(stencilFunc, stencilRef, stencilMask) {
                if (currentStencilFunc !== stencilFunc || currentStencilRef !== stencilRef || currentStencilFuncMask !== stencilMask) {
                    gl.stencilFunc(stencilFunc, stencilRef, stencilMask);
                    currentStencilFunc = stencilFunc;
                    currentStencilRef = stencilRef;
                    currentStencilFuncMask = stencilMask;
                }
            },
            setOp: function(stencilFail, stencilZFail, stencilZPass) {
                if (currentStencilFail !== stencilFail || currentStencilZFail !== stencilZFail || currentStencilZPass !== stencilZPass) {
                    gl.stencilOp(stencilFail, stencilZFail, stencilZPass);
                    currentStencilFail = stencilFail;
                    currentStencilZFail = stencilZFail;
                    currentStencilZPass = stencilZPass;
                }
            },
            setLocked: function(lock) {
                locked = lock;
            },
            setClear: function(stencil) {
                if (currentStencilClear !== stencil) {
                    gl.clearStencil(stencil);
                    currentStencilClear = stencil;
                }
            },
            reset: function() {
                locked = false;
                currentStencilMask = null;
                currentStencilFunc = null;
                currentStencilRef = null;
                currentStencilFuncMask = null;
                currentStencilFail = null;
                currentStencilZFail = null;
                currentStencilZPass = null;
                currentStencilClear = null;
            }
        };
    }
    //
    const colorBuffer = new ColorBuffer();
    const depthBuffer = new DepthBuffer();
    const stencilBuffer = new StencilBuffer();
    let enabledCapabilities = {};
    let currentProgram = null;
    let currentBlendingEnabled = null;
    let currentBlending = null;
    let currentBlendEquation = null;
    let currentBlendSrc = null;
    let currentBlendDst = null;
    let currentBlendEquationAlpha = null;
    let currentBlendSrcAlpha = null;
    let currentBlendDstAlpha = null;
    let currentPremultipledAlpha = false;
    let currentFlipSided = null;
    let currentCullFace = null;
    let currentLineWidth = null;
    let currentPolygonOffsetFactor = null;
    let currentPolygonOffsetUnits = null;
    const maxTextures = gl.getParameter(35661);
    let lineWidthAvailable = false;
    let version = 0;
    const glVersion = gl.getParameter(7938);
    if (glVersion.indexOf('WebGL') !== -1) {
        version = parseFloat(/^WebGL (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 1.0;
    } else if (glVersion.indexOf('OpenGL ES') !== -1) {
        version = parseFloat(/^OpenGL ES (\d)/.exec(glVersion)[1]);
        lineWidthAvailable = version >= 2.0;
    }
    let currentTextureSlot = null;
    let currentBoundTextures = {};
    const currentScissor = new Vector4();
    const currentViewport = new Vector4();
    function createTexture(type, target, count) {
        const data = new Uint8Array(4); // 4 is required to match default unpack alignment of 4.
        const texture = gl.createTexture();
        gl.bindTexture(type, texture);
        gl.texParameteri(type, 10241, 9728);
        gl.texParameteri(type, 10240, 9728);
        for(let i = 0; i < count; i++)gl.texImage2D(target + i, 0, 6408, 1, 1, 0, 6408, 5121, data);
        return texture;
    }
    const emptyTextures = {};
    emptyTextures[3553] = createTexture(3553, 3553, 1);
    emptyTextures[34067] = createTexture(34067, 34069, 6);
    // init
    colorBuffer.setClear(0, 0, 0, 1);
    depthBuffer.setClear(1);
    stencilBuffer.setClear(0);
    enable(2929);
    depthBuffer.setFunc(LessEqualDepth);
    setFlipSided(false);
    setCullFace(CullFaceBack);
    enable(2884);
    setBlending(NoBlending);
    //
    function enable(id) {
        if (enabledCapabilities[id] !== true) {
            gl.enable(id);
            enabledCapabilities[id] = true;
        }
    }
    function disable(id) {
        if (enabledCapabilities[id] !== false) {
            gl.disable(id);
            enabledCapabilities[id] = false;
        }
    }
    function useProgram(program) {
        if (currentProgram !== program) {
            gl.useProgram(program);
            currentProgram = program;
            return true;
        }
        return false;
    }
    const equationToGL = {
        [AddEquation]: 32774,
        [SubtractEquation]: 32778,
        [ReverseSubtractEquation]: 32779
    };
    if (isWebGL2) {
        equationToGL[MinEquation] = 32775;
        equationToGL[MaxEquation] = 32776;
    } else {
        const extension = extensions.get('EXT_blend_minmax');
        if (extension !== null) {
            equationToGL[MinEquation] = extension.MIN_EXT;
            equationToGL[MaxEquation] = extension.MAX_EXT;
        }
    }
    const factorToGL = {
        [ZeroFactor]: 0,
        [OneFactor]: 1,
        [SrcColorFactor]: 768,
        [SrcAlphaFactor]: 770,
        [SrcAlphaSaturateFactor]: 776,
        [DstColorFactor]: 774,
        [DstAlphaFactor]: 772,
        [OneMinusSrcColorFactor]: 769,
        [OneMinusSrcAlphaFactor]: 771,
        [OneMinusDstColorFactor]: 775,
        [OneMinusDstAlphaFactor]: 773
    };
    function setBlending(blending, blendEquation, blendSrc, blendDst, blendEquationAlpha, blendSrcAlpha, blendDstAlpha, premultipliedAlpha) {
        if (blending === NoBlending) {
            if (currentBlendingEnabled) {
                disable(3042);
                currentBlendingEnabled = false;
            }
            return;
        }
        if (!currentBlendingEnabled) {
            enable(3042);
            currentBlendingEnabled = true;
        }
        if (blending !== CustomBlending) {
            if (blending !== currentBlending || premultipliedAlpha !== currentPremultipledAlpha) {
                if (currentBlendEquation !== AddEquation || currentBlendEquationAlpha !== AddEquation) {
                    gl.blendEquation(32774);
                    currentBlendEquation = AddEquation;
                    currentBlendEquationAlpha = AddEquation;
                }
                if (premultipliedAlpha) switch(blending){
                    case NormalBlending:
                        gl.blendFuncSeparate(1, 771, 1, 771);
                        break;
                    case AdditiveBlending:
                        gl.blendFunc(1, 1);
                        break;
                    case SubtractiveBlending:
                        gl.blendFuncSeparate(0, 0, 769, 771);
                        break;
                    case MultiplyBlending:
                        gl.blendFuncSeparate(0, 768, 0, 770);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                else switch(blending){
                    case NormalBlending:
                        gl.blendFuncSeparate(770, 771, 1, 771);
                        break;
                    case AdditiveBlending:
                        gl.blendFunc(770, 1);
                        break;
                    case SubtractiveBlending:
                        gl.blendFunc(0, 769);
                        break;
                    case MultiplyBlending:
                        gl.blendFunc(0, 768);
                        break;
                    default:
                        console.error('THREE.WebGLState: Invalid blending: ', blending);
                        break;
                }
                currentBlendSrc = null;
                currentBlendDst = null;
                currentBlendSrcAlpha = null;
                currentBlendDstAlpha = null;
                currentBlending = blending;
                currentPremultipledAlpha = premultipliedAlpha;
            }
            return;
        }
        // custom blending
        blendEquationAlpha = blendEquationAlpha || blendEquation;
        blendSrcAlpha = blendSrcAlpha || blendSrc;
        blendDstAlpha = blendDstAlpha || blendDst;
        if (blendEquation !== currentBlendEquation || blendEquationAlpha !== currentBlendEquationAlpha) {
            gl.blendEquationSeparate(equationToGL[blendEquation], equationToGL[blendEquationAlpha]);
            currentBlendEquation = blendEquation;
            currentBlendEquationAlpha = blendEquationAlpha;
        }
        if (blendSrc !== currentBlendSrc || blendDst !== currentBlendDst || blendSrcAlpha !== currentBlendSrcAlpha || blendDstAlpha !== currentBlendDstAlpha) {
            gl.blendFuncSeparate(factorToGL[blendSrc], factorToGL[blendDst], factorToGL[blendSrcAlpha], factorToGL[blendDstAlpha]);
            currentBlendSrc = blendSrc;
            currentBlendDst = blendDst;
            currentBlendSrcAlpha = blendSrcAlpha;
            currentBlendDstAlpha = blendDstAlpha;
        }
        currentBlending = blending;
        currentPremultipledAlpha = null;
    }
    function setMaterial(material, frontFaceCW) {
        material.side === DoubleSide ? disable(2884) : enable(2884);
        let flipSided = material.side === BackSide;
        if (frontFaceCW) flipSided = !flipSided;
        setFlipSided(flipSided);
        material.blending === NormalBlending && material.transparent === false ? setBlending(NoBlending) : setBlending(material.blending, material.blendEquation, material.blendSrc, material.blendDst, material.blendEquationAlpha, material.blendSrcAlpha, material.blendDstAlpha, material.premultipliedAlpha);
        depthBuffer.setFunc(material.depthFunc);
        depthBuffer.setTest(material.depthTest);
        depthBuffer.setMask(material.depthWrite);
        colorBuffer.setMask(material.colorWrite);
        const stencilWrite = material.stencilWrite;
        stencilBuffer.setTest(stencilWrite);
        if (stencilWrite) {
            stencilBuffer.setMask(material.stencilWriteMask);
            stencilBuffer.setFunc(material.stencilFunc, material.stencilRef, material.stencilFuncMask);
            stencilBuffer.setOp(material.stencilFail, material.stencilZFail, material.stencilZPass);
        }
        setPolygonOffset(material.polygonOffset, material.polygonOffsetFactor, material.polygonOffsetUnits);
    }
    //
    function setFlipSided(flipSided) {
        if (currentFlipSided !== flipSided) {
            if (flipSided) gl.frontFace(2304);
            else gl.frontFace(2305);
            currentFlipSided = flipSided;
        }
    }
    function setCullFace(cullFace) {
        if (cullFace !== CullFaceNone) {
            enable(2884);
            if (cullFace !== currentCullFace) {
                if (cullFace === CullFaceBack) gl.cullFace(1029);
                else if (cullFace === CullFaceFront) gl.cullFace(1028);
                else gl.cullFace(1032);
            }
        } else disable(2884);
        currentCullFace = cullFace;
    }
    function setLineWidth(width) {
        if (width !== currentLineWidth) {
            if (lineWidthAvailable) gl.lineWidth(width);
            currentLineWidth = width;
        }
    }
    function setPolygonOffset(polygonOffset, factor, units) {
        if (polygonOffset) {
            enable(32823);
            if (currentPolygonOffsetFactor !== factor || currentPolygonOffsetUnits !== units) {
                gl.polygonOffset(factor, units);
                currentPolygonOffsetFactor = factor;
                currentPolygonOffsetUnits = units;
            }
        } else disable(32823);
    }
    function setScissorTest(scissorTest) {
        if (scissorTest) enable(3089);
        else disable(3089);
    }
    // texture
    function activeTexture(webglSlot) {
        if (webglSlot === undefined) webglSlot = 33984 + maxTextures - 1;
        if (currentTextureSlot !== webglSlot) {
            gl.activeTexture(webglSlot);
            currentTextureSlot = webglSlot;
        }
    }
    function bindTexture(webglType, webglTexture) {
        if (currentTextureSlot === null) activeTexture();
        let boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture === undefined) {
            boundTexture = {
                type: undefined,
                texture: undefined
            };
            currentBoundTextures[currentTextureSlot] = boundTexture;
        }
        if (boundTexture.type !== webglType || boundTexture.texture !== webglTexture) {
            gl.bindTexture(webglType, webglTexture || emptyTextures[webglType]);
            boundTexture.type = webglType;
            boundTexture.texture = webglTexture;
        }
    }
    function unbindTexture() {
        const boundTexture = currentBoundTextures[currentTextureSlot];
        if (boundTexture !== undefined && boundTexture.type !== undefined) {
            gl.bindTexture(boundTexture.type, null);
            boundTexture.type = undefined;
            boundTexture.texture = undefined;
        }
    }
    function compressedTexImage2D() {
        try {
            gl.compressedTexImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage2D() {
        try {
            gl.texImage2D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    function texImage3D() {
        try {
            gl.texImage3D.apply(gl, arguments);
        } catch (error) {
            console.error('THREE.WebGLState:', error);
        }
    }
    //
    function scissor(scissor) {
        if (currentScissor.equals(scissor) === false) {
            gl.scissor(scissor.x, scissor.y, scissor.z, scissor.w);
            currentScissor.copy(scissor);
        }
    }
    function viewport(viewport) {
        if (currentViewport.equals(viewport) === false) {
            gl.viewport(viewport.x, viewport.y, viewport.z, viewport.w);
            currentViewport.copy(viewport);
        }
    }
    //
    function reset() {
        enabledCapabilities = {};
        currentTextureSlot = null;
        currentBoundTextures = {};
        currentProgram = null;
        currentBlendingEnabled = null;
        currentBlending = null;
        currentBlendEquation = null;
        currentBlendSrc = null;
        currentBlendDst = null;
        currentBlendEquationAlpha = null;
        currentBlendSrcAlpha = null;
        currentBlendDstAlpha = null;
        currentPremultipledAlpha = false;
        currentFlipSided = null;
        currentCullFace = null;
        currentLineWidth = null;
        currentPolygonOffsetFactor = null;
        currentPolygonOffsetUnits = null;
        colorBuffer.reset();
        depthBuffer.reset();
        stencilBuffer.reset();
    }
    return {
        buffers: {
            color: colorBuffer,
            depth: depthBuffer,
            stencil: stencilBuffer
        },
        enable: enable,
        disable: disable,
        useProgram: useProgram,
        setBlending: setBlending,
        setMaterial: setMaterial,
        setFlipSided: setFlipSided,
        setCullFace: setCullFace,
        setLineWidth: setLineWidth,
        setPolygonOffset: setPolygonOffset,
        setScissorTest: setScissorTest,
        activeTexture: activeTexture,
        bindTexture: bindTexture,
        unbindTexture: unbindTexture,
        compressedTexImage2D: compressedTexImage2D,
        texImage2D: texImage2D,
        texImage3D: texImage3D,
        scissor: scissor,
        viewport: viewport,
        reset: reset
    };
}
function WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info) {
    const isWebGL2 = capabilities.isWebGL2;
    const maxTextures = capabilities.maxTextures;
    const maxCubemapSize = capabilities.maxCubemapSize;
    const maxTextureSize = capabilities.maxTextureSize;
    const maxSamples = capabilities.maxSamples;
    const _videoTextures = new WeakMap();
    let _canvas;
    // cordova iOS (as of 5.0) still uses UIWebView, which provides OffscreenCanvas,
    // also OffscreenCanvas.getContext("webgl"), but not OffscreenCanvas.getContext("2d")!
    // Some implementations may only implement OffscreenCanvas partially (e.g. lacking 2d).
    let useOffscreenCanvas = false;
    try {
        useOffscreenCanvas = typeof OffscreenCanvas !== 'undefined' && new OffscreenCanvas(1, 1).getContext('2d') !== null;
    } catch (err) {
    // Ignore any errors
    }
    function createCanvas(width, height) {
        // Use OffscreenCanvas when available. Specially needed in web workers
        return useOffscreenCanvas ? new OffscreenCanvas(width, height) : document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
    }
    function resizeImage(image, needsPowerOfTwo, needsNewCanvas, maxSize) {
        let scale = 1;
        // handle case if texture exceeds max size
        if (image.width > maxSize || image.height > maxSize) scale = maxSize / Math.max(image.width, image.height);
        // only perform resize if necessary
        if (scale < 1 || needsPowerOfTwo === true) {
            // only perform resize for certain image types
            if (typeof HTMLImageElement !== 'undefined' && image instanceof HTMLImageElement || typeof HTMLCanvasElement !== 'undefined' && image instanceof HTMLCanvasElement || typeof ImageBitmap !== 'undefined' && image instanceof ImageBitmap) {
                const floor = needsPowerOfTwo ? MathUtils.floorPowerOfTwo : Math.floor;
                const width = floor(scale * image.width);
                const height = floor(scale * image.height);
                if (_canvas === undefined) _canvas = createCanvas(width, height);
                // cube textures can't reuse the same canvas
                const canvas = needsNewCanvas ? createCanvas(width, height) : _canvas;
                canvas.width = width;
                canvas.height = height;
                const context = canvas.getContext('2d');
                context.drawImage(image, 0, 0, width, height);
                console.warn('THREE.WebGLRenderer: Texture has been resized from (' + image.width + 'x' + image.height + ') to (' + width + 'x' + height + ').');
                return canvas;
            } else {
                if ('data' in image) console.warn('THREE.WebGLRenderer: Image in DataTexture is too big (' + image.width + 'x' + image.height + ').');
                return image;
            }
        }
        return image;
    }
    function isPowerOfTwo(image) {
        return MathUtils.isPowerOfTwo(image.width) && MathUtils.isPowerOfTwo(image.height);
    }
    function textureNeedsPowerOfTwo(texture) {
        if (isWebGL2) return false;
        return texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping || texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
    }
    function textureNeedsGenerateMipmaps(texture, supportsMips) {
        return texture.generateMipmaps && supportsMips && texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter;
    }
    function generateMipmap(target, texture, width, height) {
        _gl.generateMipmap(target);
        const textureProperties = properties.get(texture);
        // Note: Math.log( x ) * Math.LOG2E used instead of Math.log2( x ) which is not supported by IE11
        textureProperties.__maxMipLevel = Math.log(Math.max(width, height)) * Math.LOG2E;
    }
    function getInternalFormat(internalFormatName, glFormat, glType) {
        if (isWebGL2 === false) return glFormat;
        if (internalFormatName !== null) {
            if (_gl[internalFormatName] !== undefined) return _gl[internalFormatName];
            console.warn('THREE.WebGLRenderer: Attempt to use non-existing WebGL internal format \'' + internalFormatName + '\'');
        }
        let internalFormat = glFormat;
        if (glFormat === 6403) {
            if (glType === 5126) internalFormat = 33326;
            if (glType === 5131) internalFormat = 33325;
            if (glType === 5121) internalFormat = 33321;
        }
        if (glFormat === 6407) {
            if (glType === 5126) internalFormat = 34837;
            if (glType === 5131) internalFormat = 34843;
            if (glType === 5121) internalFormat = 32849;
        }
        if (glFormat === 6408) {
            if (glType === 5126) internalFormat = 34836;
            if (glType === 5131) internalFormat = 34842;
            if (glType === 5121) internalFormat = 32856;
        }
        if (internalFormat === 33325 || internalFormat === 33326 || internalFormat === 34842 || internalFormat === 34836) extensions.get('EXT_color_buffer_float');
        return internalFormat;
    }
    // Fallback filters for non-power-of-2 textures
    function filterFallback(f) {
        if (f === NearestFilter || f === NearestMipmapNearestFilter || f === NearestMipmapLinearFilter) return 9728;
        return 9729;
    }
    //
    function onTextureDispose(event) {
        const texture = event.target;
        texture.removeEventListener('dispose', onTextureDispose);
        deallocateTexture(texture);
        if (texture.isVideoTexture) _videoTextures.delete(texture);
        info.memory.textures--;
    }
    function onRenderTargetDispose(event) {
        const renderTarget = event.target;
        renderTarget.removeEventListener('dispose', onRenderTargetDispose);
        deallocateRenderTarget(renderTarget);
        info.memory.textures--;
    }
    //
    function deallocateTexture(texture) {
        const textureProperties = properties.get(texture);
        if (textureProperties.__webglInit === undefined) return;
        _gl.deleteTexture(textureProperties.__webglTexture);
        properties.remove(texture);
    }
    function deallocateRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(renderTarget.texture);
        if (!renderTarget) return;
        if (textureProperties.__webglTexture !== undefined) _gl.deleteTexture(textureProperties.__webglTexture);
        if (renderTarget.depthTexture) renderTarget.depthTexture.dispose();
        if (renderTarget.isWebGLCubeRenderTarget) for(let i = 0; i < 6; i++){
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer[i]);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer[i]);
        }
        else {
            _gl.deleteFramebuffer(renderTargetProperties.__webglFramebuffer);
            if (renderTargetProperties.__webglDepthbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthbuffer);
            if (renderTargetProperties.__webglMultisampledFramebuffer) _gl.deleteFramebuffer(renderTargetProperties.__webglMultisampledFramebuffer);
            if (renderTargetProperties.__webglColorRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglColorRenderbuffer);
            if (renderTargetProperties.__webglDepthRenderbuffer) _gl.deleteRenderbuffer(renderTargetProperties.__webglDepthRenderbuffer);
        }
        properties.remove(renderTarget.texture);
        properties.remove(renderTarget);
    }
    //
    let textureUnits = 0;
    function resetTextureUnits() {
        textureUnits = 0;
    }
    function allocateTextureUnit() {
        const textureUnit = textureUnits;
        if (textureUnit >= maxTextures) console.warn('THREE.WebGLTextures: Trying to use ' + textureUnit + ' texture units while this GPU supports only ' + maxTextures);
        textureUnits += 1;
        return textureUnit;
    }
    //
    function setTexture2D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.isVideoTexture) updateVideoTexture(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            const image = texture.image;
            if (image === undefined) console.warn('THREE.WebGLRenderer: Texture marked for update but image is undefined');
            else if (image.complete === false) console.warn('THREE.WebGLRenderer: Texture marked for update but image is incomplete');
            else {
                uploadTexture(textureProperties, texture, slot);
                return;
            }
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(3553, textureProperties.__webglTexture);
    }
    function setTexture2DArray(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(35866, textureProperties.__webglTexture);
    }
    function setTexture3D(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(32879, textureProperties.__webglTexture);
    }
    function setTextureCube(texture, slot) {
        const textureProperties = properties.get(texture);
        if (texture.version > 0 && textureProperties.__version !== texture.version) {
            uploadCubeTexture(textureProperties, texture, slot);
            return;
        }
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
    }
    const wrappingToGL = {
        [RepeatWrapping]: 10497,
        [ClampToEdgeWrapping]: 33071,
        [MirroredRepeatWrapping]: 33648
    };
    const filterToGL = {
        [NearestFilter]: 9728,
        [NearestMipmapNearestFilter]: 9984,
        [NearestMipmapLinearFilter]: 9986,
        [LinearFilter]: 9729,
        [LinearMipmapNearestFilter]: 9985,
        [LinearMipmapLinearFilter]: 9987
    };
    function setTextureParameters(textureType, texture, supportsMips) {
        if (supportsMips) {
            _gl.texParameteri(textureType, 10242, wrappingToGL[texture.wrapS]);
            _gl.texParameteri(textureType, 10243, wrappingToGL[texture.wrapT]);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, wrappingToGL[texture.wrapR]);
            _gl.texParameteri(textureType, 10240, filterToGL[texture.magFilter]);
            _gl.texParameteri(textureType, 10241, filterToGL[texture.minFilter]);
        } else {
            _gl.texParameteri(textureType, 10242, 33071);
            _gl.texParameteri(textureType, 10243, 33071);
            if (textureType === 32879 || textureType === 35866) _gl.texParameteri(textureType, 32882, 33071);
            if (texture.wrapS !== ClampToEdgeWrapping || texture.wrapT !== ClampToEdgeWrapping) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.wrapS and Texture.wrapT should be set to THREE.ClampToEdgeWrapping.');
            _gl.texParameteri(textureType, 10240, filterFallback(texture.magFilter));
            _gl.texParameteri(textureType, 10241, filterFallback(texture.minFilter));
            if (texture.minFilter !== NearestFilter && texture.minFilter !== LinearFilter) console.warn('THREE.WebGLRenderer: Texture is not power of two. Texture.minFilter should be set to THREE.NearestFilter or THREE.LinearFilter.');
        }
        const extension = extensions.get('EXT_texture_filter_anisotropic');
        if (extension) {
            if (texture.type === FloatType && extensions.get('OES_texture_float_linear') === null) return;
            if (texture.type === HalfFloatType && (isWebGL2 || extensions.get('OES_texture_half_float_linear')) === null) return;
            if (texture.anisotropy > 1 || properties.get(texture).__currentAnisotropy) {
                _gl.texParameterf(textureType, extension.TEXTURE_MAX_ANISOTROPY_EXT, Math.min(texture.anisotropy, capabilities.getMaxAnisotropy()));
                properties.get(texture).__currentAnisotropy = texture.anisotropy;
            }
        }
    }
    function initTexture(textureProperties, texture) {
        if (textureProperties.__webglInit === undefined) {
            textureProperties.__webglInit = true;
            texture.addEventListener('dispose', onTextureDispose);
            textureProperties.__webglTexture = _gl.createTexture();
            info.memory.textures++;
        }
    }
    function uploadTexture(textureProperties, texture, slot) {
        let textureType = 3553;
        if (texture.isDataTexture2DArray) textureType = 35866;
        if (texture.isDataTexture3D) textureType = 32879;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(textureType, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        const needsPowerOfTwo = textureNeedsPowerOfTwo(texture) && isPowerOfTwo(texture.image) === false;
        const image = resizeImage(texture.image, needsPowerOfTwo, false, maxTextureSize);
        const supportsMips = isPowerOfTwo(image) || isWebGL2, glFormat = utils.convert(texture.format);
        let glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(textureType, texture, supportsMips);
        let mipmap;
        const mipmaps = texture.mipmaps;
        if (texture.isDepthTexture) {
            // populate depth texture with dummy data
            glInternalFormat = 6402;
            if (isWebGL2) {
                if (texture.type === FloatType) glInternalFormat = 36012;
                else if (texture.type === UnsignedIntType) glInternalFormat = 33190;
                else if (texture.type === UnsignedInt248Type) glInternalFormat = 35056;
                else glInternalFormat = 33189; // WebGL2 requires sized internalformat for glTexImage2D
            } else if (texture.type === FloatType) console.error('WebGLRenderer: Floating point depth texture requires WebGL2.');
            // validation checks for WebGL 1
            if (texture.format === DepthFormat && glInternalFormat === 6402) // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
            // DEPTH_COMPONENT and type is not UNSIGNED_SHORT or UNSIGNED_INT
            // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
            {
                if (texture.type !== UnsignedShortType && texture.type !== UnsignedIntType) {
                    console.warn('THREE.WebGLRenderer: Use UnsignedShortType or UnsignedIntType for DepthFormat DepthTexture.');
                    texture.type = UnsignedShortType;
                    glType = utils.convert(texture.type);
                }
            }
            if (texture.format === DepthStencilFormat && glInternalFormat === 6402) {
                // Depth stencil textures need the DEPTH_STENCIL internal format
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                glInternalFormat = 34041;
                // The error INVALID_OPERATION is generated by texImage2D if format and internalformat are
                // DEPTH_STENCIL and type is not UNSIGNED_INT_24_8_WEBGL.
                // (https://www.khronos.org/registry/webgl/extensions/WEBGL_depth_texture/)
                if (texture.type !== UnsignedInt248Type) {
                    console.warn('THREE.WebGLRenderer: Use UnsignedInt248Type for DepthStencilFormat DepthTexture.');
                    texture.type = UnsignedInt248Type;
                    glType = utils.convert(texture.type);
                }
            }
            //
            state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, null);
        } else if (texture.isDataTexture) {
            // use manually created mipmaps if available
            // if there are no manual mipmaps
            // set 0 level mipmap and then use GL to generate other mipmap levels
            if (mipmaps.length > 0 && supportsMips) {
                for(let i = 0, il = mipmaps.length; i < il; i++){
                    mipmap = mipmaps[i];
                    state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
                texture.generateMipmaps = false;
                textureProperties.__maxMipLevel = mipmaps.length - 1;
            } else {
                state.texImage2D(3553, 0, glInternalFormat, image.width, image.height, 0, glFormat, glType, image.data);
                textureProperties.__maxMipLevel = 0;
            }
        } else if (texture.isCompressedTexture) {
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                if (texture.format !== RGBAFormat && texture.format !== RGBFormat) {
                    if (glFormat !== null) state.compressedTexImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                    else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .uploadTexture()');
                } else state.texImage2D(3553, i, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else if (texture.isDataTexture2DArray) {
            state.texImage3D(35866, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else if (texture.isDataTexture3D) {
            state.texImage3D(32879, 0, glInternalFormat, image.width, image.height, image.depth, 0, glFormat, glType, image.data);
            textureProperties.__maxMipLevel = 0;
        } else // regular Texture (image, video, canvas)
        // use manually created mipmaps if available
        // if there are no manual mipmaps
        // set 0 level mipmap and then use GL to generate other mipmap levels
        if (mipmaps.length > 0 && supportsMips) {
            for(let i = 0, il = mipmaps.length; i < il; i++){
                mipmap = mipmaps[i];
                state.texImage2D(3553, i, glInternalFormat, glFormat, glType, mipmap);
            }
            texture.generateMipmaps = false;
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            state.texImage2D(3553, 0, glInternalFormat, glFormat, glType, image);
            textureProperties.__maxMipLevel = 0;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) generateMipmap(textureType, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    function uploadCubeTexture(textureProperties, texture, slot) {
        if (texture.image.length !== 6) return;
        initTexture(textureProperties, texture);
        state.activeTexture(33984 + slot);
        state.bindTexture(34067, textureProperties.__webglTexture);
        _gl.pixelStorei(37440, texture.flipY);
        _gl.pixelStorei(37441, texture.premultiplyAlpha);
        _gl.pixelStorei(3317, texture.unpackAlignment);
        const isCompressed = texture && (texture.isCompressedTexture || texture.image[0].isCompressedTexture);
        const isDataTexture = texture.image[0] && texture.image[0].isDataTexture;
        const cubeImage = [];
        for(let i = 0; i < 6; i++)if (!isCompressed && !isDataTexture) cubeImage[i] = resizeImage(texture.image[i], false, true, maxCubemapSize);
        else cubeImage[i] = isDataTexture ? texture.image[i].image : texture.image[i];
        const image = cubeImage[0], supportsMips = isPowerOfTwo(image) || isWebGL2, glFormat = utils.convert(texture.format), glType = utils.convert(texture.type), glInternalFormat = getInternalFormat(texture.internalFormat, glFormat, glType);
        setTextureParameters(34067, texture, supportsMips);
        let mipmaps;
        if (isCompressed) {
            for(let i = 0; i < 6; i++){
                mipmaps = cubeImage[i].mipmaps;
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    if (texture.format !== RGBAFormat && texture.format !== RGBFormat) {
                        if (glFormat !== null) state.compressedTexImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, mipmap.data);
                        else console.warn('THREE.WebGLRenderer: Attempt to load unsupported compressed texture format in .setTextureCube()');
                    } else state.texImage2D(34069 + i, j, glInternalFormat, mipmap.width, mipmap.height, 0, glFormat, glType, mipmap.data);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length - 1;
        } else {
            mipmaps = texture.mipmaps;
            for(let i = 0; i < 6; i++)if (isDataTexture) {
                state.texImage2D(34069 + i, 0, glInternalFormat, cubeImage[i].width, cubeImage[i].height, 0, glFormat, glType, cubeImage[i].data);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    const mipmapImage = mipmap.image[i].image;
                    state.texImage2D(34069 + i, j + 1, glInternalFormat, mipmapImage.width, mipmapImage.height, 0, glFormat, glType, mipmapImage.data);
                }
            } else {
                state.texImage2D(34069 + i, 0, glInternalFormat, glFormat, glType, cubeImage[i]);
                for(let j = 0; j < mipmaps.length; j++){
                    const mipmap = mipmaps[j];
                    state.texImage2D(34069 + i, j + 1, glInternalFormat, glFormat, glType, mipmap.image[i]);
                }
            }
            textureProperties.__maxMipLevel = mipmaps.length;
        }
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) // We assume images for cube map have the same size.
        generateMipmap(34067, texture, image.width, image.height);
        textureProperties.__version = texture.version;
        if (texture.onUpdate) texture.onUpdate(texture);
    }
    // Render targets
    // Setup storage for target texture and bind it to correct framebuffer
    function setupFrameBufferTexture(framebuffer, renderTarget, attachment, textureTarget) {
        const glFormat = utils.convert(renderTarget.texture.format);
        const glType = utils.convert(renderTarget.texture.type);
        const glInternalFormat = getInternalFormat(renderTarget.texture.internalFormat, glFormat, glType);
        state.texImage2D(textureTarget, 0, glInternalFormat, renderTarget.width, renderTarget.height, 0, glFormat, glType, null);
        _gl.bindFramebuffer(36160, framebuffer);
        _gl.framebufferTexture2D(36160, attachment, textureTarget, properties.get(renderTarget.texture).__webglTexture, 0);
        _gl.bindFramebuffer(36160, null);
    }
    // Setup storage for internal depth/stencil buffers and bind to correct framebuffer
    function setupRenderBufferStorage(renderbuffer, renderTarget, isMultisample) {
        _gl.bindRenderbuffer(36161, renderbuffer);
        if (renderTarget.depthBuffer && !renderTarget.stencilBuffer) {
            let glInternalFormat = 33189;
            if (isMultisample) {
                const depthTexture = renderTarget.depthTexture;
                if (depthTexture && depthTexture.isDepthTexture) {
                    if (depthTexture.type === FloatType) glInternalFormat = 36012;
                    else if (depthTexture.type === UnsignedIntType) glInternalFormat = 33190;
                }
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 36096, 36161, renderbuffer);
        } else if (renderTarget.depthBuffer && renderTarget.stencilBuffer) {
            if (isMultisample) {
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, 35056, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, 34041, renderTarget.width, renderTarget.height);
            _gl.framebufferRenderbuffer(36160, 33306, 36161, renderbuffer);
        } else {
            const glFormat = utils.convert(renderTarget.texture.format);
            const glType = utils.convert(renderTarget.texture.type);
            const glInternalFormat = getInternalFormat(renderTarget.texture.internalFormat, glFormat, glType);
            if (isMultisample) {
                const samples = getRenderTargetSamples(renderTarget);
                _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
            } else _gl.renderbufferStorage(36161, glInternalFormat, renderTarget.width, renderTarget.height);
        }
        _gl.bindRenderbuffer(36161, null);
    }
    // Setup resources for a Depth Texture for a FBO (needs an extension)
    function setupDepthTexture(framebuffer, renderTarget) {
        const isCube = renderTarget && renderTarget.isWebGLCubeRenderTarget;
        if (isCube) throw new Error('Depth Texture with cube render targets is not supported');
        _gl.bindFramebuffer(36160, framebuffer);
        if (!(renderTarget.depthTexture && renderTarget.depthTexture.isDepthTexture)) throw new Error('renderTarget.depthTexture must be an instance of THREE.DepthTexture');
        // upload an empty depth texture with framebuffer size
        if (!properties.get(renderTarget.depthTexture).__webglTexture || renderTarget.depthTexture.image.width !== renderTarget.width || renderTarget.depthTexture.image.height !== renderTarget.height) {
            renderTarget.depthTexture.image.width = renderTarget.width;
            renderTarget.depthTexture.image.height = renderTarget.height;
            renderTarget.depthTexture.needsUpdate = true;
        }
        setTexture2D(renderTarget.depthTexture, 0);
        const webglDepthTexture = properties.get(renderTarget.depthTexture).__webglTexture;
        if (renderTarget.depthTexture.format === DepthFormat) _gl.framebufferTexture2D(36160, 36096, 3553, webglDepthTexture, 0);
        else if (renderTarget.depthTexture.format === DepthStencilFormat) _gl.framebufferTexture2D(36160, 33306, 3553, webglDepthTexture, 0);
        else throw new Error('Unknown depthTexture format');
    }
    // Setup GL resources for a non-texture depth buffer
    function setupDepthRenderbuffer(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        if (renderTarget.depthTexture) {
            if (isCube) throw new Error('target.depthTexture not supported in Cube render targets');
            setupDepthTexture(renderTargetProperties.__webglFramebuffer, renderTarget);
        } else if (isCube) {
            renderTargetProperties.__webglDepthbuffer = [];
            for(let i = 0; i < 6; i++){
                _gl.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer[i]);
                renderTargetProperties.__webglDepthbuffer[i] = _gl.createRenderbuffer();
                setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer[i], renderTarget, false);
            }
        } else {
            _gl.bindFramebuffer(36160, renderTargetProperties.__webglFramebuffer);
            renderTargetProperties.__webglDepthbuffer = _gl.createRenderbuffer();
            setupRenderBufferStorage(renderTargetProperties.__webglDepthbuffer, renderTarget, false);
        }
        _gl.bindFramebuffer(36160, null);
    }
    // Set up GL resources for the render target
    function setupRenderTarget(renderTarget) {
        const renderTargetProperties = properties.get(renderTarget);
        const textureProperties = properties.get(renderTarget.texture);
        renderTarget.addEventListener('dispose', onRenderTargetDispose);
        textureProperties.__webglTexture = _gl.createTexture();
        info.memory.textures++;
        const isCube = renderTarget.isWebGLCubeRenderTarget === true;
        const isMultisample = renderTarget.isWebGLMultisampleRenderTarget === true;
        const supportsMips = isPowerOfTwo(renderTarget) || isWebGL2;
        // Handles WebGL2 RGBFormat fallback - #18858
        if (isWebGL2 && renderTarget.texture.format === RGBFormat && (renderTarget.texture.type === FloatType || renderTarget.texture.type === HalfFloatType)) {
            renderTarget.texture.format = RGBAFormat;
            console.warn('THREE.WebGLRenderer: Rendering to textures with RGB format is not supported. Using RGBA format instead.');
        }
        // Setup framebuffer
        if (isCube) {
            renderTargetProperties.__webglFramebuffer = [];
            for(let i = 0; i < 6; i++)renderTargetProperties.__webglFramebuffer[i] = _gl.createFramebuffer();
        } else {
            renderTargetProperties.__webglFramebuffer = _gl.createFramebuffer();
            if (isMultisample) {
                if (isWebGL2) {
                    renderTargetProperties.__webglMultisampledFramebuffer = _gl.createFramebuffer();
                    renderTargetProperties.__webglColorRenderbuffer = _gl.createRenderbuffer();
                    _gl.bindRenderbuffer(36161, renderTargetProperties.__webglColorRenderbuffer);
                    const glFormat = utils.convert(renderTarget.texture.format);
                    const glType = utils.convert(renderTarget.texture.type);
                    const glInternalFormat = getInternalFormat(renderTarget.texture.internalFormat, glFormat, glType);
                    const samples = getRenderTargetSamples(renderTarget);
                    _gl.renderbufferStorageMultisample(36161, samples, glInternalFormat, renderTarget.width, renderTarget.height);
                    _gl.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer);
                    _gl.framebufferRenderbuffer(36160, 36064, 36161, renderTargetProperties.__webglColorRenderbuffer);
                    _gl.bindRenderbuffer(36161, null);
                    if (renderTarget.depthBuffer) {
                        renderTargetProperties.__webglDepthRenderbuffer = _gl.createRenderbuffer();
                        setupRenderBufferStorage(renderTargetProperties.__webglDepthRenderbuffer, renderTarget, true);
                    }
                    _gl.bindFramebuffer(36160, null);
                } else console.warn('THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.');
            }
        }
        // Setup color buffer
        if (isCube) {
            state.bindTexture(34067, textureProperties.__webglTexture);
            setTextureParameters(34067, renderTarget.texture, supportsMips);
            for(let i = 0; i < 6; i++)setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer[i], renderTarget, 36064, 34069 + i);
            if (textureNeedsGenerateMipmaps(renderTarget.texture, supportsMips)) generateMipmap(34067, renderTarget.texture, renderTarget.width, renderTarget.height);
            state.bindTexture(34067, null);
        } else {
            state.bindTexture(3553, textureProperties.__webglTexture);
            setTextureParameters(3553, renderTarget.texture, supportsMips);
            setupFrameBufferTexture(renderTargetProperties.__webglFramebuffer, renderTarget, 36064, 3553);
            if (textureNeedsGenerateMipmaps(renderTarget.texture, supportsMips)) generateMipmap(3553, renderTarget.texture, renderTarget.width, renderTarget.height);
            state.bindTexture(3553, null);
        }
        // Setup depth and stencil buffers
        if (renderTarget.depthBuffer) setupDepthRenderbuffer(renderTarget);
    }
    function updateRenderTargetMipmap(renderTarget) {
        const texture = renderTarget.texture;
        const supportsMips = isPowerOfTwo(renderTarget) || isWebGL2;
        if (textureNeedsGenerateMipmaps(texture, supportsMips)) {
            const target = renderTarget.isWebGLCubeRenderTarget ? 34067 : 3553;
            const webglTexture = properties.get(texture).__webglTexture;
            state.bindTexture(target, webglTexture);
            generateMipmap(target, texture, renderTarget.width, renderTarget.height);
            state.bindTexture(target, null);
        }
    }
    function updateMultisampleRenderTarget(renderTarget) {
        if (renderTarget.isWebGLMultisampleRenderTarget) {
            if (isWebGL2) {
                const renderTargetProperties = properties.get(renderTarget);
                _gl.bindFramebuffer(36008, renderTargetProperties.__webglMultisampledFramebuffer);
                _gl.bindFramebuffer(36009, renderTargetProperties.__webglFramebuffer);
                const width = renderTarget.width;
                const height = renderTarget.height;
                let mask = 16384;
                if (renderTarget.depthBuffer) mask |= 256;
                if (renderTarget.stencilBuffer) mask |= 1024;
                _gl.blitFramebuffer(0, 0, width, height, 0, 0, width, height, mask, 9728);
                _gl.bindFramebuffer(36160, renderTargetProperties.__webglMultisampledFramebuffer); // see #18905
            } else console.warn('THREE.WebGLRenderer: WebGLMultisampleRenderTarget can only be used with WebGL2.');
        }
    }
    function getRenderTargetSamples(renderTarget) {
        return isWebGL2 && renderTarget.isWebGLMultisampleRenderTarget ? Math.min(maxSamples, renderTarget.samples) : 0;
    }
    function updateVideoTexture(texture) {
        const frame = info.render.frame;
        // Check the last frame we updated the VideoTexture
        if (_videoTextures.get(texture) !== frame) {
            _videoTextures.set(texture, frame);
            texture.update();
        }
    }
    // backwards compatibility
    let warnedTexture2D = false;
    let warnedTextureCube = false;
    function safeSetTexture2D(texture, slot) {
        if (texture && texture.isWebGLRenderTarget) {
            if (warnedTexture2D === false) {
                console.warn('THREE.WebGLTextures.safeSetTexture2D: don\'t use render targets as textures. Use their .texture property instead.');
                warnedTexture2D = true;
            }
            texture = texture.texture;
        }
        setTexture2D(texture, slot);
    }
    function safeSetTextureCube(texture, slot) {
        if (texture && texture.isWebGLCubeRenderTarget) {
            if (warnedTextureCube === false) {
                console.warn('THREE.WebGLTextures.safeSetTextureCube: don\'t use cube render targets as textures. Use their .texture property instead.');
                warnedTextureCube = true;
            }
            texture = texture.texture;
        }
        setTextureCube(texture, slot);
    }
    //
    this.allocateTextureUnit = allocateTextureUnit;
    this.resetTextureUnits = resetTextureUnits;
    this.setTexture2D = setTexture2D;
    this.setTexture2DArray = setTexture2DArray;
    this.setTexture3D = setTexture3D;
    this.setTextureCube = setTextureCube;
    this.setupRenderTarget = setupRenderTarget;
    this.updateRenderTargetMipmap = updateRenderTargetMipmap;
    this.updateMultisampleRenderTarget = updateMultisampleRenderTarget;
    this.safeSetTexture2D = safeSetTexture2D;
    this.safeSetTextureCube = safeSetTextureCube;
}
function WebGLUtils(gl, extensions, capabilities) {
    const isWebGL2 = capabilities.isWebGL2;
    function convert(p) {
        let extension;
        if (p === UnsignedByteType) return 5121;
        if (p === UnsignedShort4444Type) return 32819;
        if (p === UnsignedShort5551Type) return 32820;
        if (p === UnsignedShort565Type) return 33635;
        if (p === ByteType) return 5120;
        if (p === ShortType) return 5122;
        if (p === UnsignedShortType) return 5123;
        if (p === IntType) return 5124;
        if (p === UnsignedIntType) return 5125;
        if (p === FloatType) return 5126;
        if (p === HalfFloatType) {
            if (isWebGL2) return 5131;
            extension = extensions.get('OES_texture_half_float');
            if (extension !== null) return extension.HALF_FLOAT_OES;
            else return null;
        }
        if (p === AlphaFormat) return 6406;
        if (p === RGBFormat) return 6407;
        if (p === RGBAFormat) return 6408;
        if (p === LuminanceFormat) return 6409;
        if (p === LuminanceAlphaFormat) return 6410;
        if (p === DepthFormat) return 6402;
        if (p === DepthStencilFormat) return 34041;
        if (p === RedFormat) return 6403;
        // WebGL2 formats.
        if (p === RedIntegerFormat) return 36244;
        if (p === RGFormat) return 33319;
        if (p === RGIntegerFormat) return 33320;
        if (p === RGBIntegerFormat) return 36248;
        if (p === RGBAIntegerFormat) return 36249;
        if (p === RGB_S3TC_DXT1_Format || p === RGBA_S3TC_DXT1_Format || p === RGBA_S3TC_DXT3_Format || p === RGBA_S3TC_DXT5_Format) {
            extension = extensions.get('WEBGL_compressed_texture_s3tc');
            if (extension !== null) {
                if (p === RGB_S3TC_DXT1_Format) return extension.COMPRESSED_RGB_S3TC_DXT1_EXT;
                if (p === RGBA_S3TC_DXT1_Format) return extension.COMPRESSED_RGBA_S3TC_DXT1_EXT;
                if (p === RGBA_S3TC_DXT3_Format) return extension.COMPRESSED_RGBA_S3TC_DXT3_EXT;
                if (p === RGBA_S3TC_DXT5_Format) return extension.COMPRESSED_RGBA_S3TC_DXT5_EXT;
            } else return null;
        }
        if (p === RGB_PVRTC_4BPPV1_Format || p === RGB_PVRTC_2BPPV1_Format || p === RGBA_PVRTC_4BPPV1_Format || p === RGBA_PVRTC_2BPPV1_Format) {
            extension = extensions.get('WEBGL_compressed_texture_pvrtc');
            if (extension !== null) {
                if (p === RGB_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_4BPPV1_IMG;
                if (p === RGB_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGB_PVRTC_2BPPV1_IMG;
                if (p === RGBA_PVRTC_4BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_4BPPV1_IMG;
                if (p === RGBA_PVRTC_2BPPV1_Format) return extension.COMPRESSED_RGBA_PVRTC_2BPPV1_IMG;
            } else return null;
        }
        if (p === RGB_ETC1_Format) {
            extension = extensions.get('WEBGL_compressed_texture_etc1');
            if (extension !== null) return extension.COMPRESSED_RGB_ETC1_WEBGL;
            else return null;
        }
        if (p === RGB_ETC2_Format || p === RGBA_ETC2_EAC_Format) {
            extension = extensions.get('WEBGL_compressed_texture_etc');
            if (extension !== null) {
                if (p === RGB_ETC2_Format) return extension.COMPRESSED_RGB8_ETC2;
                if (p === RGBA_ETC2_EAC_Format) return extension.COMPRESSED_RGBA8_ETC2_EAC;
            }
        }
        if (p === RGBA_ASTC_4x4_Format || p === RGBA_ASTC_5x4_Format || p === RGBA_ASTC_5x5_Format || p === RGBA_ASTC_6x5_Format || p === RGBA_ASTC_6x6_Format || p === RGBA_ASTC_8x5_Format || p === RGBA_ASTC_8x6_Format || p === RGBA_ASTC_8x8_Format || p === RGBA_ASTC_10x5_Format || p === RGBA_ASTC_10x6_Format || p === RGBA_ASTC_10x8_Format || p === RGBA_ASTC_10x10_Format || p === RGBA_ASTC_12x10_Format || p === RGBA_ASTC_12x12_Format || p === SRGB8_ALPHA8_ASTC_4x4_Format || p === SRGB8_ALPHA8_ASTC_5x4_Format || p === SRGB8_ALPHA8_ASTC_5x5_Format || p === SRGB8_ALPHA8_ASTC_6x5_Format || p === SRGB8_ALPHA8_ASTC_6x6_Format || p === SRGB8_ALPHA8_ASTC_8x5_Format || p === SRGB8_ALPHA8_ASTC_8x6_Format || p === SRGB8_ALPHA8_ASTC_8x8_Format || p === SRGB8_ALPHA8_ASTC_10x5_Format || p === SRGB8_ALPHA8_ASTC_10x6_Format || p === SRGB8_ALPHA8_ASTC_10x8_Format || p === SRGB8_ALPHA8_ASTC_10x10_Format || p === SRGB8_ALPHA8_ASTC_12x10_Format || p === SRGB8_ALPHA8_ASTC_12x12_Format) {
            extension = extensions.get('WEBGL_compressed_texture_astc');
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === RGBA_BPTC_Format) {
            extension = extensions.get('EXT_texture_compression_bptc');
            if (extension !== null) // TODO Complete?
            return p;
            else return null;
        }
        if (p === UnsignedInt248Type) {
            if (isWebGL2) return 34042;
            extension = extensions.get('WEBGL_depth_texture');
            if (extension !== null) return extension.UNSIGNED_INT_24_8_WEBGL;
            else return null;
        }
    }
    return {
        convert: convert
    };
}
function ArrayCamera(array = []) {
    PerspectiveCamera.call(this);
    this.cameras = array;
}
ArrayCamera.prototype = Object.assign(Object.create(PerspectiveCamera.prototype), {
    constructor: ArrayCamera,
    isArrayCamera: true
});
function Group() {
    Object3D.call(this);
    this.type = 'Group';
}
Group.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Group,
    isGroup: true
});
function WebXRController() {
    this._targetRay = null;
    this._grip = null;
    this._hand = null;
}
Object.assign(WebXRController.prototype, {
    constructor: WebXRController,
    getHandSpace: function() {
        if (this._hand === null) {
            this._hand = new Group();
            this._hand.matrixAutoUpdate = false;
            this._hand.visible = false;
            this._hand.joints = {};
            this._hand.inputState = {
                pinching: false
            };
        }
        return this._hand;
    },
    getTargetRaySpace: function() {
        if (this._targetRay === null) {
            this._targetRay = new Group();
            this._targetRay.matrixAutoUpdate = false;
            this._targetRay.visible = false;
        }
        return this._targetRay;
    },
    getGripSpace: function() {
        if (this._grip === null) {
            this._grip = new Group();
            this._grip.matrixAutoUpdate = false;
            this._grip.visible = false;
        }
        return this._grip;
    },
    dispatchEvent: function(event) {
        if (this._targetRay !== null) this._targetRay.dispatchEvent(event);
        if (this._grip !== null) this._grip.dispatchEvent(event);
        if (this._hand !== null) this._hand.dispatchEvent(event);
        return this;
    },
    disconnect: function(inputSource) {
        this.dispatchEvent({
            type: 'disconnected',
            data: inputSource
        });
        if (this._targetRay !== null) this._targetRay.visible = false;
        if (this._grip !== null) this._grip.visible = false;
        if (this._hand !== null) this._hand.visible = false;
        return this;
    },
    update: function(inputSource, frame, referenceSpace) {
        let inputPose = null;
        let gripPose = null;
        let handPose = null;
        const targetRay = this._targetRay;
        const grip = this._grip;
        const hand = this._hand;
        if (inputSource && frame.session.visibilityState !== 'visible-blurred') {
            if (hand && inputSource.hand) {
                handPose = true;
                for (const inputjoint of inputSource.hand.values()){
                    // Update the joints groups with the XRJoint poses
                    const jointPose = frame.getJointPose(inputjoint, referenceSpace);
                    if (hand.joints[inputjoint.jointName] === undefined) {
                        // The transform of this joint will be updated with the joint pose on each frame
                        const joint = new Group();
                        joint.matrixAutoUpdate = false;
                        joint.visible = false;
                        hand.joints[inputjoint.jointName] = joint;
                        // ??
                        hand.add(joint);
                    }
                    const joint = hand.joints[inputjoint.jointName];
                    if (jointPose !== null) {
                        joint.matrix.fromArray(jointPose.transform.matrix);
                        joint.matrix.decompose(joint.position, joint.rotation, joint.scale);
                        joint.jointRadius = jointPose.radius;
                    }
                    joint.visible = jointPose !== null;
                }
                // Custom events
                // Check pinchz
                const indexTip = hand.joints['index-finger-tip'];
                const thumbTip = hand.joints['thumb-tip'];
                const distance = indexTip.position.distanceTo(thumbTip.position);
                const distanceToPinch = 0.02;
                const threshold = 0.005;
                if (hand.inputState.pinching && distance > distanceToPinch + threshold) {
                    hand.inputState.pinching = false;
                    this.dispatchEvent({
                        type: 'pinchend',
                        handedness: inputSource.handedness,
                        target: this
                    });
                } else if (!hand.inputState.pinching && distance <= distanceToPinch - threshold) {
                    hand.inputState.pinching = true;
                    this.dispatchEvent({
                        type: 'pinchstart',
                        handedness: inputSource.handedness,
                        target: this
                    });
                }
            } else {
                if (targetRay !== null) {
                    inputPose = frame.getPose(inputSource.targetRaySpace, referenceSpace);
                    if (inputPose !== null) {
                        targetRay.matrix.fromArray(inputPose.transform.matrix);
                        targetRay.matrix.decompose(targetRay.position, targetRay.rotation, targetRay.scale);
                    }
                }
                if (grip !== null && inputSource.gripSpace) {
                    gripPose = frame.getPose(inputSource.gripSpace, referenceSpace);
                    if (gripPose !== null) {
                        grip.matrix.fromArray(gripPose.transform.matrix);
                        grip.matrix.decompose(grip.position, grip.rotation, grip.scale);
                    }
                }
            }
        }
        if (targetRay !== null) targetRay.visible = inputPose !== null;
        if (grip !== null) grip.visible = gripPose !== null;
        if (hand !== null) hand.visible = handPose !== null;
        return this;
    }
});
function WebXRManager(renderer, gl) {
    const scope = this;
    let session = null;
    let framebufferScaleFactor = 1.0;
    let referenceSpace = null;
    let referenceSpaceType = 'local-floor';
    let pose = null;
    const controllers = [];
    const inputSourcesMap = new Map();
    //
    const cameraL = new PerspectiveCamera();
    cameraL.layers.enable(1);
    cameraL.viewport = new Vector4();
    const cameraR = new PerspectiveCamera();
    cameraR.layers.enable(2);
    cameraR.viewport = new Vector4();
    const cameras = [
        cameraL,
        cameraR
    ];
    const cameraVR = new ArrayCamera();
    cameraVR.layers.enable(1);
    cameraVR.layers.enable(2);
    let _currentDepthNear = null;
    let _currentDepthFar = null;
    //
    this.enabled = false;
    this.isPresenting = false;
    this.getController = function(index) {
        let controller = controllers[index];
        if (controller === undefined) {
            controller = new WebXRController();
            controllers[index] = controller;
        }
        return controller.getTargetRaySpace();
    };
    this.getControllerGrip = function(index) {
        let controller = controllers[index];
        if (controller === undefined) {
            controller = new WebXRController();
            controllers[index] = controller;
        }
        return controller.getGripSpace();
    };
    this.getHand = function(index) {
        let controller = controllers[index];
        if (controller === undefined) {
            controller = new WebXRController();
            controllers[index] = controller;
        }
        return controller.getHandSpace();
    };
    //
    function onSessionEvent(event) {
        const controller = inputSourcesMap.get(event.inputSource);
        if (controller) controller.dispatchEvent({
            type: event.type,
            data: event.inputSource
        });
    }
    function onSessionEnd() {
        inputSourcesMap.forEach(function(controller, inputSource) {
            controller.disconnect(inputSource);
        });
        inputSourcesMap.clear();
        _currentDepthNear = null;
        _currentDepthFar = null;
        //
        renderer.setFramebuffer(null);
        renderer.setRenderTarget(renderer.getRenderTarget()); // Hack #15830
        animation.stop();
        scope.isPresenting = false;
        scope.dispatchEvent({
            type: 'sessionend'
        });
    }
    this.setFramebufferScaleFactor = function(value) {
        framebufferScaleFactor = value;
        if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change framebuffer scale while presenting.');
    };
    this.setReferenceSpaceType = function(value) {
        referenceSpaceType = value;
        if (scope.isPresenting === true) console.warn('THREE.WebXRManager: Cannot change reference space type while presenting.');
    };
    this.getReferenceSpace = function() {
        return referenceSpace;
    };
    this.getSession = function() {
        return session;
    };
    this.setSession = async function(value) {
        session = value;
        if (session !== null) {
            session.addEventListener('select', onSessionEvent);
            session.addEventListener('selectstart', onSessionEvent);
            session.addEventListener('selectend', onSessionEvent);
            session.addEventListener('squeeze', onSessionEvent);
            session.addEventListener('squeezestart', onSessionEvent);
            session.addEventListener('squeezeend', onSessionEvent);
            session.addEventListener('end', onSessionEnd);
            session.addEventListener('inputsourceschange', onInputSourcesChange);
            const attributes = gl.getContextAttributes();
            if (attributes.xrCompatible !== true) await gl.makeXRCompatible();
            const layerInit = {
                antialias: attributes.antialias,
                alpha: attributes.alpha,
                depth: attributes.depth,
                stencil: attributes.stencil,
                framebufferScaleFactor: framebufferScaleFactor
            };
            // eslint-disable-next-line no-undef
            const baseLayer = new XRWebGLLayer(session, gl, layerInit);
            session.updateRenderState({
                baseLayer: baseLayer
            });
            referenceSpace = await session.requestReferenceSpace(referenceSpaceType);
            animation.setContext(session);
            animation.start();
            scope.isPresenting = true;
            scope.dispatchEvent({
                type: 'sessionstart'
            });
        }
    };
    function onInputSourcesChange(event) {
        const inputSources = session.inputSources;
        // Assign inputSources to available controllers
        for(let i = 0; i < controllers.length; i++)inputSourcesMap.set(inputSources[i], controllers[i]);
        // Notify disconnected
        for(let i = 0; i < event.removed.length; i++){
            const inputSource = event.removed[i];
            const controller = inputSourcesMap.get(inputSource);
            if (controller) {
                controller.dispatchEvent({
                    type: 'disconnected',
                    data: inputSource
                });
                inputSourcesMap.delete(inputSource);
            }
        }
        // Notify connected
        for(let i = 0; i < event.added.length; i++){
            const inputSource = event.added[i];
            const controller = inputSourcesMap.get(inputSource);
            if (controller) controller.dispatchEvent({
                type: 'connected',
                data: inputSource
            });
        }
    }
    //
    const cameraLPos = new Vector3();
    const cameraRPos = new Vector3();
    /**
	 * Assumes 2 cameras that are parallel and share an X-axis, and that
	 * the cameras' projection and world matrices have already been set.
	 * And that near and far planes are identical for both cameras.
	 * Visualization of this technique: https://computergraphics.stackexchange.com/a/4765
	 */ function setProjectionFromUnion(camera, cameraL, cameraR) {
        cameraLPos.setFromMatrixPosition(cameraL.matrixWorld);
        cameraRPos.setFromMatrixPosition(cameraR.matrixWorld);
        const ipd = cameraLPos.distanceTo(cameraRPos);
        const projL = cameraL.projectionMatrix.elements;
        const projR = cameraR.projectionMatrix.elements;
        // VR systems will have identical far and near planes, and
        // most likely identical top and bottom frustum extents.
        // Use the left camera for these values.
        const near = projL[14] / (projL[10] - 1);
        const far = projL[14] / (projL[10] + 1);
        const topFov = (projL[9] + 1) / projL[5];
        const bottomFov = (projL[9] - 1) / projL[5];
        const leftFov = (projL[8] - 1) / projL[0];
        const rightFov = (projR[8] + 1) / projR[0];
        const left = near * leftFov;
        const right = near * rightFov;
        // Calculate the new camera's position offset from the
        // left camera. xOffset should be roughly half `ipd`.
        const zOffset = ipd / (-leftFov + rightFov);
        const xOffset = zOffset * -leftFov;
        // TODO: Better way to apply this offset?
        cameraL.matrixWorld.decompose(camera.position, camera.quaternion, camera.scale);
        camera.translateX(xOffset);
        camera.translateZ(zOffset);
        camera.matrixWorld.compose(camera.position, camera.quaternion, camera.scale);
        camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
        // Find the union of the frustum values of the cameras and scale
        // the values so that the near plane's position does not change in world space,
        // although must now be relative to the new union camera.
        const near2 = near + zOffset;
        const far2 = far + zOffset;
        const left2 = left - xOffset;
        const right2 = right + (ipd - xOffset);
        const top2 = topFov * far / far2 * near2;
        const bottom2 = bottomFov * far / far2 * near2;
        camera.projectionMatrix.makePerspective(left2, right2, top2, bottom2, near2, far2);
    }
    function updateCamera(camera, parent) {
        if (parent === null) camera.matrixWorld.copy(camera.matrix);
        else camera.matrixWorld.multiplyMatrices(parent.matrixWorld, camera.matrix);
        camera.matrixWorldInverse.copy(camera.matrixWorld).invert();
    }
    this.getCamera = function(camera) {
        cameraVR.near = cameraR.near = cameraL.near = camera.near;
        cameraVR.far = cameraR.far = cameraL.far = camera.far;
        if (_currentDepthNear !== cameraVR.near || _currentDepthFar !== cameraVR.far) {
            // Note that the new renderState won't apply until the next frame. See #18320
            session.updateRenderState({
                depthNear: cameraVR.near,
                depthFar: cameraVR.far
            });
            _currentDepthNear = cameraVR.near;
            _currentDepthFar = cameraVR.far;
        }
        const parent = camera.parent;
        const cameras = cameraVR.cameras;
        updateCamera(cameraVR, parent);
        for(let i = 0; i < cameras.length; i++)updateCamera(cameras[i], parent);
        // update camera and its children
        camera.matrixWorld.copy(cameraVR.matrixWorld);
        camera.matrix.copy(cameraVR.matrix);
        camera.matrix.decompose(camera.position, camera.quaternion, camera.scale);
        const children = camera.children;
        for(let i = 0, l = children.length; i < l; i++)children[i].updateMatrixWorld(true);
        // update projection matrix for proper view frustum culling
        if (cameras.length === 2) setProjectionFromUnion(cameraVR, cameraL, cameraR);
        else // assume single camera setup (AR)
        cameraVR.projectionMatrix.copy(cameraL.projectionMatrix);
        return cameraVR;
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time, frame) {
        pose = frame.getViewerPose(referenceSpace);
        if (pose !== null) {
            const views = pose.views;
            const baseLayer = session.renderState.baseLayer;
            renderer.setFramebuffer(baseLayer.framebuffer);
            let cameraVRNeedsUpdate = false;
            // check if it's necessary to rebuild cameraVR's camera list
            if (views.length !== cameraVR.cameras.length) {
                cameraVR.cameras.length = 0;
                cameraVRNeedsUpdate = true;
            }
            for(let i = 0; i < views.length; i++){
                const view = views[i];
                const viewport = baseLayer.getViewport(view);
                const camera = cameras[i];
                camera.matrix.fromArray(view.transform.matrix);
                camera.projectionMatrix.fromArray(view.projectionMatrix);
                camera.viewport.set(viewport.x, viewport.y, viewport.width, viewport.height);
                if (i === 0) cameraVR.matrix.copy(camera.matrix);
                if (cameraVRNeedsUpdate === true) cameraVR.cameras.push(camera);
            }
        }
        //
        const inputSources = session.inputSources;
        for(let i = 0; i < controllers.length; i++){
            const controller = controllers[i];
            const inputSource = inputSources[i];
            controller.update(inputSource, frame, referenceSpace);
        }
        if (onAnimationFrameCallback) onAnimationFrameCallback(time, frame);
    }
    const animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
    };
    this.dispose = function() {};
}
Object.assign(WebXRManager.prototype, EventDispatcher.prototype);
function WebGLMaterials(properties) {
    function refreshFogUniforms(uniforms, fog) {
        uniforms.fogColor.value.copy(fog.color);
        if (fog.isFog) {
            uniforms.fogNear.value = fog.near;
            uniforms.fogFar.value = fog.far;
        } else if (fog.isFogExp2) uniforms.fogDensity.value = fog.density;
    }
    function refreshMaterialUniforms(uniforms, material, pixelRatio, height) {
        if (material.isMeshBasicMaterial) refreshUniformsCommon(uniforms, material);
        else if (material.isMeshLambertMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsLambert(uniforms, material);
        } else if (material.isMeshToonMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsToon(uniforms, material);
        } else if (material.isMeshPhongMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsPhong(uniforms, material);
        } else if (material.isMeshStandardMaterial) {
            refreshUniformsCommon(uniforms, material);
            if (material.isMeshPhysicalMaterial) refreshUniformsPhysical(uniforms, material);
            else refreshUniformsStandard(uniforms, material);
        } else if (material.isMeshMatcapMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsMatcap(uniforms, material);
        } else if (material.isMeshDepthMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDepth(uniforms, material);
        } else if (material.isMeshDistanceMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsDistance(uniforms, material);
        } else if (material.isMeshNormalMaterial) {
            refreshUniformsCommon(uniforms, material);
            refreshUniformsNormal(uniforms, material);
        } else if (material.isLineBasicMaterial) {
            refreshUniformsLine(uniforms, material);
            if (material.isLineDashedMaterial) refreshUniformsDash(uniforms, material);
        } else if (material.isPointsMaterial) refreshUniformsPoints(uniforms, material, pixelRatio, height);
        else if (material.isSpriteMaterial) refreshUniformsSprites(uniforms, material);
        else if (material.isShadowMaterial) {
            uniforms.color.value.copy(material.color);
            uniforms.opacity.value = material.opacity;
        } else if (material.isShaderMaterial) material.uniformsNeedUpdate = false; // #15581
    }
    function refreshUniformsCommon(uniforms, material) {
        uniforms.opacity.value = material.opacity;
        if (material.color) uniforms.diffuse.value.copy(material.color);
        if (material.emissive) uniforms.emissive.value.copy(material.emissive).multiplyScalar(material.emissiveIntensity);
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        if (material.specularMap) uniforms.specularMap.value = material.specularMap;
        const envMap = properties.get(material).envMap;
        if (envMap) {
            uniforms.envMap.value = envMap;
            uniforms.flipEnvMap.value = envMap.isCubeTexture && envMap._needsFlipEnvMap ? -1 : 1;
            uniforms.reflectivity.value = material.reflectivity;
            uniforms.refractionRatio.value = material.refractionRatio;
            const maxMipLevel = properties.get(envMap).__maxMipLevel;
            if (maxMipLevel !== undefined) uniforms.maxMipLevel.value = maxMipLevel;
        }
        if (material.lightMap) {
            uniforms.lightMap.value = material.lightMap;
            uniforms.lightMapIntensity.value = material.lightMapIntensity;
        }
        if (material.aoMap) {
            uniforms.aoMap.value = material.aoMap;
            uniforms.aoMapIntensity.value = material.aoMapIntensity;
        }
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. specular map
        // 3. displacementMap map
        // 4. normal map
        // 5. bump map
        // 6. roughnessMap map
        // 7. metalnessMap map
        // 8. alphaMap map
        // 9. emissiveMap map
        // 10. clearcoat map
        // 11. clearcoat normal map
        // 12. clearcoat roughnessMap map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.specularMap) uvScaleMap = material.specularMap;
        else if (material.displacementMap) uvScaleMap = material.displacementMap;
        else if (material.normalMap) uvScaleMap = material.normalMap;
        else if (material.bumpMap) uvScaleMap = material.bumpMap;
        else if (material.roughnessMap) uvScaleMap = material.roughnessMap;
        else if (material.metalnessMap) uvScaleMap = material.metalnessMap;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        else if (material.emissiveMap) uvScaleMap = material.emissiveMap;
        else if (material.clearcoatMap) uvScaleMap = material.clearcoatMap;
        else if (material.clearcoatNormalMap) uvScaleMap = material.clearcoatNormalMap;
        else if (material.clearcoatRoughnessMap) uvScaleMap = material.clearcoatRoughnessMap;
        if (uvScaleMap !== undefined) {
            // backwards compatibility
            if (uvScaleMap.isWebGLRenderTarget) uvScaleMap = uvScaleMap.texture;
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
        // uv repeat and offset setting priorities for uv2
        // 1. ao map
        // 2. light map
        let uv2ScaleMap;
        if (material.aoMap) uv2ScaleMap = material.aoMap;
        else if (material.lightMap) uv2ScaleMap = material.lightMap;
        if (uv2ScaleMap !== undefined) {
            // backwards compatibility
            if (uv2ScaleMap.isWebGLRenderTarget) uv2ScaleMap = uv2ScaleMap.texture;
            if (uv2ScaleMap.matrixAutoUpdate === true) uv2ScaleMap.updateMatrix();
            uniforms.uv2Transform.value.copy(uv2ScaleMap.matrix);
        }
    }
    function refreshUniformsLine(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
    }
    function refreshUniformsDash(uniforms, material) {
        uniforms.dashSize.value = material.dashSize;
        uniforms.totalSize.value = material.dashSize + material.gapSize;
        uniforms.scale.value = material.scale;
    }
    function refreshUniformsPoints(uniforms, material, pixelRatio, height) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.size.value = material.size * pixelRatio;
        uniforms.scale.value = height * 0.5;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsSprites(uniforms, material) {
        uniforms.diffuse.value.copy(material.color);
        uniforms.opacity.value = material.opacity;
        uniforms.rotation.value = material.rotation;
        if (material.map) uniforms.map.value = material.map;
        if (material.alphaMap) uniforms.alphaMap.value = material.alphaMap;
        // uv repeat and offset setting priorities
        // 1. color map
        // 2. alpha map
        let uvScaleMap;
        if (material.map) uvScaleMap = material.map;
        else if (material.alphaMap) uvScaleMap = material.alphaMap;
        if (uvScaleMap !== undefined) {
            if (uvScaleMap.matrixAutoUpdate === true) uvScaleMap.updateMatrix();
            uniforms.uvTransform.value.copy(uvScaleMap.matrix);
        }
    }
    function refreshUniformsLambert(uniforms, material) {
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
    }
    function refreshUniformsPhong(uniforms, material) {
        uniforms.specular.value.copy(material.specular);
        uniforms.shininess.value = Math.max(material.shininess, 1e-4); // to prevent pow( 0.0, 0.0 )
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsToon(uniforms, material) {
        if (material.gradientMap) uniforms.gradientMap.value = material.gradientMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsStandard(uniforms, material) {
        uniforms.roughness.value = material.roughness;
        uniforms.metalness.value = material.metalness;
        if (material.roughnessMap) uniforms.roughnessMap.value = material.roughnessMap;
        if (material.metalnessMap) uniforms.metalnessMap.value = material.metalnessMap;
        if (material.emissiveMap) uniforms.emissiveMap.value = material.emissiveMap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        const envMap = properties.get(material).envMap;
        if (envMap) //uniforms.envMap.value = material.envMap; // part of uniforms common
        uniforms.envMapIntensity.value = material.envMapIntensity;
    }
    function refreshUniformsPhysical(uniforms, material) {
        refreshUniformsStandard(uniforms, material);
        uniforms.reflectivity.value = material.reflectivity; // also part of uniforms common
        uniforms.clearcoat.value = material.clearcoat;
        uniforms.clearcoatRoughness.value = material.clearcoatRoughness;
        if (material.sheen) uniforms.sheen.value.copy(material.sheen);
        if (material.clearcoatMap) uniforms.clearcoatMap.value = material.clearcoatMap;
        if (material.clearcoatRoughnessMap) uniforms.clearcoatRoughnessMap.value = material.clearcoatRoughnessMap;
        if (material.clearcoatNormalMap) {
            uniforms.clearcoatNormalScale.value.copy(material.clearcoatNormalScale);
            uniforms.clearcoatNormalMap.value = material.clearcoatNormalMap;
            if (material.side === BackSide) uniforms.clearcoatNormalScale.value.negate();
        }
        uniforms.transmission.value = material.transmission;
        if (material.transmissionMap) uniforms.transmissionMap.value = material.transmissionMap;
    }
    function refreshUniformsMatcap(uniforms, material) {
        if (material.matcap) uniforms.matcap.value = material.matcap;
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDepth(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    function refreshUniformsDistance(uniforms, material) {
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
        uniforms.referencePosition.value.copy(material.referencePosition);
        uniforms.nearDistance.value = material.nearDistance;
        uniforms.farDistance.value = material.farDistance;
    }
    function refreshUniformsNormal(uniforms, material) {
        if (material.bumpMap) {
            uniforms.bumpMap.value = material.bumpMap;
            uniforms.bumpScale.value = material.bumpScale;
            if (material.side === BackSide) uniforms.bumpScale.value *= -1;
        }
        if (material.normalMap) {
            uniforms.normalMap.value = material.normalMap;
            uniforms.normalScale.value.copy(material.normalScale);
            if (material.side === BackSide) uniforms.normalScale.value.negate();
        }
        if (material.displacementMap) {
            uniforms.displacementMap.value = material.displacementMap;
            uniforms.displacementScale.value = material.displacementScale;
            uniforms.displacementBias.value = material.displacementBias;
        }
    }
    return {
        refreshFogUniforms: refreshFogUniforms,
        refreshMaterialUniforms: refreshMaterialUniforms
    };
}
function createCanvasElement() {
    const canvas = document.createElementNS('http://www.w3.org/1999/xhtml', 'canvas');
    canvas.style.display = 'block';
    return canvas;
}
function WebGLRenderer(parameters) {
    parameters = parameters || {};
    const _canvas = parameters.canvas !== undefined ? parameters.canvas : createCanvasElement(), _context = parameters.context !== undefined ? parameters.context : null, _alpha = parameters.alpha !== undefined ? parameters.alpha : false, _depth = parameters.depth !== undefined ? parameters.depth : true, _stencil = parameters.stencil !== undefined ? parameters.stencil : true, _antialias = parameters.antialias !== undefined ? parameters.antialias : false, _premultipliedAlpha = parameters.premultipliedAlpha !== undefined ? parameters.premultipliedAlpha : true, _preserveDrawingBuffer = parameters.preserveDrawingBuffer !== undefined ? parameters.preserveDrawingBuffer : false, _powerPreference = parameters.powerPreference !== undefined ? parameters.powerPreference : 'default', _failIfMajorPerformanceCaveat = parameters.failIfMajorPerformanceCaveat !== undefined ? parameters.failIfMajorPerformanceCaveat : false;
    let currentRenderList = null;
    let currentRenderState = null;
    // render() can be called from within a callback triggered by another render.
    // We track this so that the nested render call gets its state isolated from the parent render call.
    const renderStateStack = [];
    // public properties
    this.domElement = _canvas;
    // Debug configuration container
    this.debug = {
        /**
		 * Enables error checking and reporting when shader programs are being compiled
		 * @type {boolean}
		 */ checkShaderErrors: true
    };
    // clearing
    this.autoClear = true;
    this.autoClearColor = true;
    this.autoClearDepth = true;
    this.autoClearStencil = true;
    // scene graph
    this.sortObjects = true;
    // user-defined clipping
    this.clippingPlanes = [];
    this.localClippingEnabled = false;
    // physically based shading
    this.gammaFactor = 2.0; // for backwards compatibility
    this.outputEncoding = LinearEncoding;
    // physical lights
    this.physicallyCorrectLights = false;
    // tone mapping
    this.toneMapping = NoToneMapping;
    this.toneMappingExposure = 1.0;
    // morphs
    this.maxMorphTargets = 8;
    this.maxMorphNormals = 4;
    // internal properties
    const _this = this;
    let _isContextLost = false;
    // internal state cache
    let _framebuffer = null;
    let _currentActiveCubeFace = 0;
    let _currentActiveMipmapLevel = 0;
    let _currentRenderTarget = null;
    let _currentFramebuffer = null;
    let _currentMaterialId = -1;
    let _currentCamera = null;
    const _currentViewport = new Vector4();
    const _currentScissor = new Vector4();
    let _currentScissorTest = null;
    //
    let _width = _canvas.width;
    let _height = _canvas.height;
    let _pixelRatio = 1;
    let _opaqueSort = null;
    let _transparentSort = null;
    const _viewport = new Vector4(0, 0, _width, _height);
    const _scissor = new Vector4(0, 0, _width, _height);
    let _scissorTest = false;
    // frustum
    const _frustum = new Frustum();
    // clipping
    let _clippingEnabled = false;
    let _localClippingEnabled = false;
    // camera matrices cache
    const _projScreenMatrix = new Matrix4();
    const _vector3 = new Vector3();
    const _emptyScene = {
        background: null,
        fog: null,
        environment: null,
        overrideMaterial: null,
        isScene: true
    };
    function getTargetPixelRatio() {
        return _currentRenderTarget === null ? _pixelRatio : 1;
    }
    // initialize
    let _gl = _context;
    function getContext(contextNames, contextAttributes) {
        for(let i = 0; i < contextNames.length; i++){
            const contextName = contextNames[i];
            const context = _canvas.getContext(contextName, contextAttributes);
            if (context !== null) return context;
        }
        return null;
    }
    try {
        const contextAttributes = {
            alpha: _alpha,
            depth: _depth,
            stencil: _stencil,
            antialias: _antialias,
            premultipliedAlpha: _premultipliedAlpha,
            preserveDrawingBuffer: _preserveDrawingBuffer,
            powerPreference: _powerPreference,
            failIfMajorPerformanceCaveat: _failIfMajorPerformanceCaveat
        };
        // event listeners must be registered before WebGL context is created, see #12753
        _canvas.addEventListener('webglcontextlost', onContextLost, false);
        _canvas.addEventListener('webglcontextrestored', onContextRestore, false);
        if (_gl === null) {
            const contextNames = [
                'webgl2',
                'webgl',
                'experimental-webgl'
            ];
            if (_this.isWebGL1Renderer === true) contextNames.shift();
            _gl = getContext(contextNames, contextAttributes);
            if (_gl === null) {
                if (getContext(contextNames)) throw new Error('Error creating WebGL context with your selected attributes.');
                else throw new Error('Error creating WebGL context.');
            }
        }
        // Some experimental-webgl implementations do not have getShaderPrecisionFormat
        if (_gl.getShaderPrecisionFormat === undefined) _gl.getShaderPrecisionFormat = function() {
            return {
                'rangeMin': 1,
                'rangeMax': 1,
                'precision': 1
            };
        };
    } catch (error) {
        console.error('THREE.WebGLRenderer: ' + error.message);
        throw error;
    }
    let extensions, capabilities, state, info;
    let properties, textures, cubemaps, attributes, geometries, objects;
    let programCache, materials, renderLists, renderStates, clipping;
    let background, morphtargets, bufferRenderer, indexedBufferRenderer;
    let utils, bindingStates;
    function initGLContext() {
        extensions = new WebGLExtensions(_gl);
        capabilities = new WebGLCapabilities(_gl, extensions, parameters);
        extensions.init(capabilities);
        utils = new WebGLUtils(_gl, extensions, capabilities);
        state = new WebGLState(_gl, extensions, capabilities);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
        info = new WebGLInfo(_gl);
        properties = new WebGLProperties();
        textures = new WebGLTextures(_gl, extensions, state, properties, capabilities, utils, info);
        cubemaps = new WebGLCubeMaps(_this);
        attributes = new WebGLAttributes(_gl, capabilities);
        bindingStates = new WebGLBindingStates(_gl, extensions, attributes, capabilities);
        geometries = new WebGLGeometries(_gl, attributes, info, bindingStates);
        objects = new WebGLObjects(_gl, geometries, attributes, info);
        morphtargets = new WebGLMorphtargets(_gl);
        clipping = new WebGLClipping(properties);
        programCache = new WebGLPrograms(_this, cubemaps, extensions, capabilities, bindingStates, clipping);
        materials = new WebGLMaterials(properties);
        renderLists = new WebGLRenderLists(properties);
        renderStates = new WebGLRenderStates(extensions, capabilities);
        background = new WebGLBackground(_this, cubemaps, state, objects, _premultipliedAlpha);
        bufferRenderer = new WebGLBufferRenderer(_gl, extensions, info, capabilities);
        indexedBufferRenderer = new WebGLIndexedBufferRenderer(_gl, extensions, info, capabilities);
        info.programs = programCache.programs;
        _this.capabilities = capabilities;
        _this.extensions = extensions;
        _this.properties = properties;
        _this.renderLists = renderLists;
        _this.state = state;
        _this.info = info;
    }
    initGLContext();
    // xr
    const xr = new WebXRManager(_this, _gl);
    this.xr = xr;
    // shadow map
    const shadowMap = new WebGLShadowMap(_this, objects, capabilities.maxTextureSize);
    this.shadowMap = shadowMap;
    // API
    this.getContext = function() {
        return _gl;
    };
    this.getContextAttributes = function() {
        return _gl.getContextAttributes();
    };
    this.forceContextLoss = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.loseContext();
    };
    this.forceContextRestore = function() {
        const extension = extensions.get('WEBGL_lose_context');
        if (extension) extension.restoreContext();
    };
    this.getPixelRatio = function() {
        return _pixelRatio;
    };
    this.setPixelRatio = function(value) {
        if (value === undefined) return;
        _pixelRatio = value;
        this.setSize(_width, _height, false);
    };
    this.getSize = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getsize() now requires a Vector2 as an argument');
            target = new Vector2();
        }
        return target.set(_width, _height);
    };
    this.setSize = function(width, height, updateStyle) {
        if (xr.isPresenting) {
            console.warn('THREE.WebGLRenderer: Can\'t change size while VR device is presenting.');
            return;
        }
        _width = width;
        _height = height;
        _canvas.width = Math.floor(width * _pixelRatio);
        _canvas.height = Math.floor(height * _pixelRatio);
        if (updateStyle !== false) {
            _canvas.style.width = width + 'px';
            _canvas.style.height = height + 'px';
        }
        this.setViewport(0, 0, width, height);
    };
    this.getDrawingBufferSize = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getdrawingBufferSize() now requires a Vector2 as an argument');
            target = new Vector2();
        }
        return target.set(_width * _pixelRatio, _height * _pixelRatio).floor();
    };
    this.setDrawingBufferSize = function(width, height, pixelRatio) {
        _width = width;
        _height = height;
        _pixelRatio = pixelRatio;
        _canvas.width = Math.floor(width * pixelRatio);
        _canvas.height = Math.floor(height * pixelRatio);
        this.setViewport(0, 0, width, height);
    };
    this.getCurrentViewport = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getCurrentViewport() now requires a Vector4 as an argument');
            target = new Vector4();
        }
        return target.copy(_currentViewport);
    };
    this.getViewport = function(target) {
        return target.copy(_viewport);
    };
    this.setViewport = function(x, y, width, height) {
        if (x.isVector4) _viewport.set(x.x, x.y, x.z, x.w);
        else _viewport.set(x, y, width, height);
        state.viewport(_currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissor = function(target) {
        return target.copy(_scissor);
    };
    this.setScissor = function(x, y, width, height) {
        if (x.isVector4) _scissor.set(x.x, x.y, x.z, x.w);
        else _scissor.set(x, y, width, height);
        state.scissor(_currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor());
    };
    this.getScissorTest = function() {
        return _scissorTest;
    };
    this.setScissorTest = function(boolean) {
        state.setScissorTest(_scissorTest = boolean);
    };
    this.setOpaqueSort = function(method) {
        _opaqueSort = method;
    };
    this.setTransparentSort = function(method) {
        _transparentSort = method;
    };
    // Clearing
    this.getClearColor = function(target) {
        if (target === undefined) {
            console.warn('WebGLRenderer: .getClearColor() now requires a Color as an argument');
            target = new Color();
        }
        return target.copy(background.getClearColor());
    };
    this.setClearColor = function() {
        background.setClearColor.apply(background, arguments);
    };
    this.getClearAlpha = function() {
        return background.getClearAlpha();
    };
    this.setClearAlpha = function() {
        background.setClearAlpha.apply(background, arguments);
    };
    this.clear = function(color, depth, stencil) {
        let bits = 0;
        if (color === undefined || color) bits |= 16384;
        if (depth === undefined || depth) bits |= 256;
        if (stencil === undefined || stencil) bits |= 1024;
        _gl.clear(bits);
    };
    this.clearColor = function() {
        this.clear(true, false, false);
    };
    this.clearDepth = function() {
        this.clear(false, true, false);
    };
    this.clearStencil = function() {
        this.clear(false, false, true);
    };
    //
    this.dispose = function() {
        _canvas.removeEventListener('webglcontextlost', onContextLost, false);
        _canvas.removeEventListener('webglcontextrestored', onContextRestore, false);
        renderLists.dispose();
        renderStates.dispose();
        properties.dispose();
        cubemaps.dispose();
        objects.dispose();
        bindingStates.dispose();
        xr.dispose();
        animation.stop();
    };
    // Events
    function onContextLost(event) {
        event.preventDefault();
        console.log('THREE.WebGLRenderer: Context Lost.');
        _isContextLost = true;
    }
    function onContextRestore() {
        console.log('THREE.WebGLRenderer: Context Restored.');
        _isContextLost = false;
        initGLContext();
    }
    function onMaterialDispose(event) {
        const material = event.target;
        material.removeEventListener('dispose', onMaterialDispose);
        deallocateMaterial(material);
    }
    // Buffer deallocation
    function deallocateMaterial(material) {
        releaseMaterialProgramReference(material);
        properties.remove(material);
    }
    function releaseMaterialProgramReference(material) {
        const programInfo = properties.get(material).program;
        if (programInfo !== undefined) programCache.releaseProgram(programInfo);
    }
    // Buffer rendering
    function renderObjectImmediate(object, program) {
        object.render(function(object) {
            _this.renderBufferImmediate(object, program);
        });
    }
    this.renderBufferImmediate = function(object, program) {
        bindingStates.initAttributes();
        const buffers = properties.get(object);
        if (object.hasPositions && !buffers.position) buffers.position = _gl.createBuffer();
        if (object.hasNormals && !buffers.normal) buffers.normal = _gl.createBuffer();
        if (object.hasUvs && !buffers.uv) buffers.uv = _gl.createBuffer();
        if (object.hasColors && !buffers.color) buffers.color = _gl.createBuffer();
        const programAttributes = program.getAttributes();
        if (object.hasPositions) {
            _gl.bindBuffer(34962, buffers.position);
            _gl.bufferData(34962, object.positionArray, 35048);
            bindingStates.enableAttribute(programAttributes.position);
            _gl.vertexAttribPointer(programAttributes.position, 3, 5126, false, 0, 0);
        }
        if (object.hasNormals) {
            _gl.bindBuffer(34962, buffers.normal);
            _gl.bufferData(34962, object.normalArray, 35048);
            bindingStates.enableAttribute(programAttributes.normal);
            _gl.vertexAttribPointer(programAttributes.normal, 3, 5126, false, 0, 0);
        }
        if (object.hasUvs) {
            _gl.bindBuffer(34962, buffers.uv);
            _gl.bufferData(34962, object.uvArray, 35048);
            bindingStates.enableAttribute(programAttributes.uv);
            _gl.vertexAttribPointer(programAttributes.uv, 2, 5126, false, 0, 0);
        }
        if (object.hasColors) {
            _gl.bindBuffer(34962, buffers.color);
            _gl.bufferData(34962, object.colorArray, 35048);
            bindingStates.enableAttribute(programAttributes.color);
            _gl.vertexAttribPointer(programAttributes.color, 3, 5126, false, 0, 0);
        }
        bindingStates.disableUnusedAttributes();
        _gl.drawArrays(4, 0, object.count);
        object.count = 0;
    };
    this.renderBufferDirect = function(camera, scene, geometry, material, object, group) {
        if (scene === null) scene = _emptyScene; // renderBufferDirect second parameter used to be fog (could be null)
        const frontFaceCW = object.isMesh && object.matrixWorld.determinant() < 0;
        const program = setProgram(camera, scene, material, object);
        state.setMaterial(material, frontFaceCW);
        //
        let index = geometry.index;
        const position = geometry.attributes.position;
        //
        if (index === null) {
            if (position === undefined || position.count === 0) return;
        } else if (index.count === 0) return;
        //
        let rangeFactor = 1;
        if (material.wireframe === true) {
            index = geometries.getWireframeAttribute(geometry);
            rangeFactor = 2;
        }
        if (material.morphTargets || material.morphNormals) morphtargets.update(object, geometry, material, program);
        bindingStates.setup(object, material, program, geometry, index);
        let attribute;
        let renderer = bufferRenderer;
        if (index !== null) {
            attribute = attributes.get(index);
            renderer = indexedBufferRenderer;
            renderer.setIndex(attribute);
        }
        //
        const dataCount = index !== null ? index.count : position.count;
        const rangeStart = geometry.drawRange.start * rangeFactor;
        const rangeCount = geometry.drawRange.count * rangeFactor;
        const groupStart = group !== null ? group.start * rangeFactor : 0;
        const groupCount = group !== null ? group.count * rangeFactor : Infinity;
        const drawStart = Math.max(rangeStart, groupStart);
        const drawEnd = Math.min(dataCount, rangeStart + rangeCount, groupStart + groupCount) - 1;
        const drawCount = Math.max(0, drawEnd - drawStart + 1);
        if (drawCount === 0) return;
        //
        if (object.isMesh) {
            if (material.wireframe === true) {
                state.setLineWidth(material.wireframeLinewidth * getTargetPixelRatio());
                renderer.setMode(1);
            } else renderer.setMode(4);
        } else if (object.isLine) {
            let lineWidth = material.linewidth;
            if (lineWidth === undefined) lineWidth = 1; // Not using Line*Material
            state.setLineWidth(lineWidth * getTargetPixelRatio());
            if (object.isLineSegments) renderer.setMode(1);
            else if (object.isLineLoop) renderer.setMode(2);
            else renderer.setMode(3);
        } else if (object.isPoints) renderer.setMode(0);
        else if (object.isSprite) renderer.setMode(4);
        if (object.isInstancedMesh) renderer.renderInstances(drawStart, drawCount, object.count);
        else if (geometry.isInstancedBufferGeometry) {
            const instanceCount = Math.min(geometry.instanceCount, geometry._maxInstanceCount);
            renderer.renderInstances(drawStart, drawCount, instanceCount);
        } else renderer.render(drawStart, drawCount);
    };
    // Compile
    this.compile = function(scene, camera) {
        currentRenderState = renderStates.get(scene);
        currentRenderState.init();
        scene.traverseVisible(function(object) {
            if (object.isLight && object.layers.test(camera.layers)) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            }
        });
        currentRenderState.setupLights();
        const compiled = new WeakMap();
        scene.traverse(function(object) {
            const material = object.material;
            if (material) {
                if (Array.isArray(material)) for(let i = 0; i < material.length; i++){
                    const material2 = material[i];
                    if (compiled.has(material2) === false) {
                        initMaterial(material2, scene, object);
                        compiled.set(material2);
                    }
                }
                else if (compiled.has(material) === false) {
                    initMaterial(material, scene, object);
                    compiled.set(material);
                }
            }
        });
    };
    // Animation Loop
    let onAnimationFrameCallback = null;
    function onAnimationFrame(time) {
        if (xr.isPresenting) return;
        if (onAnimationFrameCallback) onAnimationFrameCallback(time);
    }
    const animation = new WebGLAnimation();
    animation.setAnimationLoop(onAnimationFrame);
    if (typeof window !== 'undefined') animation.setContext(window);
    this.setAnimationLoop = function(callback) {
        onAnimationFrameCallback = callback;
        xr.setAnimationLoop(callback);
        callback === null ? animation.stop() : animation.start();
    };
    // Rendering
    this.render = function(scene, camera) {
        let renderTarget, forceClear;
        if (arguments[2] !== undefined) {
            console.warn('THREE.WebGLRenderer.render(): the renderTarget argument has been removed. Use .setRenderTarget() instead.');
            renderTarget = arguments[2];
        }
        if (arguments[3] !== undefined) {
            console.warn('THREE.WebGLRenderer.render(): the forceClear argument has been removed. Use .clear() instead.');
            forceClear = arguments[3];
        }
        if (camera !== undefined && camera.isCamera !== true) {
            console.error('THREE.WebGLRenderer.render: camera is not an instance of THREE.Camera.');
            return;
        }
        if (_isContextLost === true) return;
        // reset caching for this frame
        bindingStates.resetDefaultState();
        _currentMaterialId = -1;
        _currentCamera = null;
        // update scene graph
        if (scene.autoUpdate === true) scene.updateMatrixWorld();
        // update camera matrices and frustum
        if (camera.parent === null) camera.updateMatrixWorld();
        if (xr.enabled === true && xr.isPresenting === true) camera = xr.getCamera(camera);
        //
        if (scene.isScene === true) scene.onBeforeRender(_this, scene, camera, renderTarget || _currentRenderTarget);
        currentRenderState = renderStates.get(scene, renderStateStack.length);
        currentRenderState.init();
        renderStateStack.push(currentRenderState);
        _projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        _frustum.setFromProjectionMatrix(_projScreenMatrix);
        _localClippingEnabled = this.localClippingEnabled;
        _clippingEnabled = clipping.init(this.clippingPlanes, _localClippingEnabled, camera);
        currentRenderList = renderLists.get(scene, camera);
        currentRenderList.init();
        projectObject(scene, camera, 0, _this.sortObjects);
        currentRenderList.finish();
        if (_this.sortObjects === true) currentRenderList.sort(_opaqueSort, _transparentSort);
        //
        if (_clippingEnabled === true) clipping.beginShadows();
        const shadowsArray = currentRenderState.state.shadowsArray;
        shadowMap.render(shadowsArray, scene, camera);
        currentRenderState.setupLights();
        currentRenderState.setupLightsView(camera);
        if (_clippingEnabled === true) clipping.endShadows();
        //
        if (this.info.autoReset === true) this.info.reset();
        if (renderTarget !== undefined) this.setRenderTarget(renderTarget);
        //
        background.render(currentRenderList, scene, camera, forceClear);
        // render scene
        const opaqueObjects = currentRenderList.opaque;
        const transparentObjects = currentRenderList.transparent;
        if (opaqueObjects.length > 0) renderObjects(opaqueObjects, scene, camera);
        if (transparentObjects.length > 0) renderObjects(transparentObjects, scene, camera);
        //
        if (scene.isScene === true) scene.onAfterRender(_this, scene, camera);
        //
        if (_currentRenderTarget !== null) {
            // Generate mipmap if we're using any kind of mipmap filtering
            textures.updateRenderTargetMipmap(_currentRenderTarget);
            // resolve multisample renderbuffers to a single-sample texture if necessary
            textures.updateMultisampleRenderTarget(_currentRenderTarget);
        }
        // Ensure depth buffer writing is enabled so it can be cleared on next render
        state.buffers.depth.setTest(true);
        state.buffers.depth.setMask(true);
        state.buffers.color.setMask(true);
        state.setPolygonOffset(false);
        // _gl.finish();
        renderStateStack.pop();
        if (renderStateStack.length > 0) currentRenderState = renderStateStack[renderStateStack.length - 1];
        else currentRenderState = null;
        currentRenderList = null;
    };
    function projectObject(object, camera, groupOrder, sortObjects) {
        if (object.visible === false) return;
        const visible = object.layers.test(camera.layers);
        if (visible) {
            if (object.isGroup) groupOrder = object.renderOrder;
            else if (object.isLOD) {
                if (object.autoUpdate === true) object.update(camera);
            } else if (object.isLight) {
                currentRenderState.pushLight(object);
                if (object.castShadow) currentRenderState.pushShadow(object);
            } else if (object.isSprite) {
                if (!object.frustumCulled || _frustum.intersectsSprite(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            } else if (object.isImmediateRenderObject) {
                if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                currentRenderList.push(object, null, object.material, groupOrder, _vector3.z, null);
            } else if (object.isMesh || object.isLine || object.isPoints) {
                if (object.isSkinnedMesh) // update skeleton only once in a frame
                {
                    if (object.skeleton.frame !== info.render.frame) {
                        object.skeleton.update();
                        object.skeleton.frame = info.render.frame;
                    }
                }
                if (!object.frustumCulled || _frustum.intersectsObject(object)) {
                    if (sortObjects) _vector3.setFromMatrixPosition(object.matrixWorld).applyMatrix4(_projScreenMatrix);
                    const geometry = objects.update(object);
                    const material = object.material;
                    if (Array.isArray(material)) {
                        const groups = geometry.groups;
                        for(let i = 0, l = groups.length; i < l; i++){
                            const group = groups[i];
                            const groupMaterial = material[group.materialIndex];
                            if (groupMaterial && groupMaterial.visible) currentRenderList.push(object, geometry, groupMaterial, groupOrder, _vector3.z, group);
                        }
                    } else if (material.visible) currentRenderList.push(object, geometry, material, groupOrder, _vector3.z, null);
                }
            }
        }
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)projectObject(children[i], camera, groupOrder, sortObjects);
    }
    function renderObjects(renderList, scene, camera) {
        const overrideMaterial = scene.isScene === true ? scene.overrideMaterial : null;
        for(let i = 0, l = renderList.length; i < l; i++){
            const renderItem = renderList[i];
            const object = renderItem.object;
            const geometry = renderItem.geometry;
            const material = overrideMaterial === null ? renderItem.material : overrideMaterial;
            const group = renderItem.group;
            if (camera.isArrayCamera) {
                const cameras = camera.cameras;
                for(let j = 0, jl = cameras.length; j < jl; j++){
                    const camera2 = cameras[j];
                    if (object.layers.test(camera2.layers)) {
                        state.viewport(_currentViewport.copy(camera2.viewport));
                        currentRenderState.setupLightsView(camera2);
                        renderObject(object, scene, camera2, geometry, material, group);
                    }
                }
            } else renderObject(object, scene, camera, geometry, material, group);
        }
    }
    function renderObject(object, scene, camera, geometry, material, group) {
        object.onBeforeRender(_this, scene, camera, geometry, material, group);
        object.modelViewMatrix.multiplyMatrices(camera.matrixWorldInverse, object.matrixWorld);
        object.normalMatrix.getNormalMatrix(object.modelViewMatrix);
        if (object.isImmediateRenderObject) {
            const program = setProgram(camera, scene, material, object);
            state.setMaterial(material);
            bindingStates.reset();
            renderObjectImmediate(object, program);
        } else _this.renderBufferDirect(camera, scene, geometry, material, object, group);
        object.onAfterRender(_this, scene, camera, geometry, material, group);
    }
    function initMaterial(material, scene, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        const shadowsArray = currentRenderState.state.shadowsArray;
        const lightsStateVersion = lights.state.version;
        const parameters = programCache.getParameters(material, lights.state, shadowsArray, scene, object);
        const programCacheKey = programCache.getProgramCacheKey(parameters);
        let program = materialProperties.program;
        let programChange = true;
        // always update environment and fog - changing these trigger an initMaterial call, but it's possible that the program doesn't change
        materialProperties.environment = material.isMeshStandardMaterial ? scene.environment : null;
        materialProperties.fog = scene.fog;
        materialProperties.envMap = cubemaps.get(material.envMap || materialProperties.environment);
        if (program === undefined) // new material
        material.addEventListener('dispose', onMaterialDispose);
        else if (program.cacheKey !== programCacheKey) // changed glsl or parameters
        releaseMaterialProgramReference(material);
        else if (materialProperties.lightsStateVersion !== lightsStateVersion) programChange = false;
        else if (parameters.shaderID !== undefined) // same glsl and uniform list
        return;
        else // only rebuild uniform list
        programChange = false;
        if (programChange) {
            parameters.uniforms = programCache.getUniforms(material);
            material.onBeforeCompile(parameters, _this);
            program = programCache.acquireProgram(parameters, programCacheKey);
            materialProperties.program = program;
            materialProperties.uniforms = parameters.uniforms;
            materialProperties.outputEncoding = parameters.outputEncoding;
        }
        const uniforms = materialProperties.uniforms;
        if (!material.isShaderMaterial && !material.isRawShaderMaterial || material.clipping === true) {
            materialProperties.numClippingPlanes = clipping.numPlanes;
            materialProperties.numIntersection = clipping.numIntersection;
            uniforms.clippingPlanes = clipping.uniform;
        }
        // store the light setup it was created for
        materialProperties.needsLights = materialNeedsLights(material);
        materialProperties.lightsStateVersion = lightsStateVersion;
        if (materialProperties.needsLights) {
            // wire up the material to this renderer's lighting state
            uniforms.ambientLightColor.value = lights.state.ambient;
            uniforms.lightProbe.value = lights.state.probe;
            uniforms.directionalLights.value = lights.state.directional;
            uniforms.directionalLightShadows.value = lights.state.directionalShadow;
            uniforms.spotLights.value = lights.state.spot;
            uniforms.spotLightShadows.value = lights.state.spotShadow;
            uniforms.rectAreaLights.value = lights.state.rectArea;
            uniforms.ltc_1.value = lights.state.rectAreaLTC1;
            uniforms.ltc_2.value = lights.state.rectAreaLTC2;
            uniforms.pointLights.value = lights.state.point;
            uniforms.pointLightShadows.value = lights.state.pointShadow;
            uniforms.hemisphereLights.value = lights.state.hemi;
            uniforms.directionalShadowMap.value = lights.state.directionalShadowMap;
            uniforms.directionalShadowMatrix.value = lights.state.directionalShadowMatrix;
            uniforms.spotShadowMap.value = lights.state.spotShadowMap;
            uniforms.spotShadowMatrix.value = lights.state.spotShadowMatrix;
            uniforms.pointShadowMap.value = lights.state.pointShadowMap;
            uniforms.pointShadowMatrix.value = lights.state.pointShadowMatrix;
        // TODO (abelnation): add area lights shadow info to uniforms
        }
        const progUniforms = materialProperties.program.getUniforms();
        const uniformsList = WebGLUniforms.seqWithValue(progUniforms.seq, uniforms);
        materialProperties.uniformsList = uniformsList;
    }
    function setProgram(camera, scene, material, object) {
        if (scene.isScene !== true) scene = _emptyScene; // scene could be a Mesh, Line, Points, ...
        textures.resetTextureUnits();
        const fog = scene.fog;
        const environment = material.isMeshStandardMaterial ? scene.environment : null;
        const encoding = _currentRenderTarget === null ? _this.outputEncoding : _currentRenderTarget.texture.encoding;
        const envMap = cubemaps.get(material.envMap || environment);
        const materialProperties = properties.get(material);
        const lights = currentRenderState.state.lights;
        if (_clippingEnabled === true) {
            if (_localClippingEnabled === true || camera !== _currentCamera) {
                const useCache = camera === _currentCamera && material.id === _currentMaterialId;
                // we might want to call this function with some ClippingGroup
                // object instead of the material, once it becomes feasible
                // (#8465, #8379)
                clipping.setState(material, camera, useCache);
            }
        }
        if (material.version === materialProperties.__version) {
            if (material.fog && materialProperties.fog !== fog) initMaterial(material, scene, object);
            else if (materialProperties.environment !== environment) initMaterial(material, scene, object);
            else if (materialProperties.needsLights && materialProperties.lightsStateVersion !== lights.state.version) initMaterial(material, scene, object);
            else if (materialProperties.numClippingPlanes !== undefined && (materialProperties.numClippingPlanes !== clipping.numPlanes || materialProperties.numIntersection !== clipping.numIntersection)) initMaterial(material, scene, object);
            else if (materialProperties.outputEncoding !== encoding) initMaterial(material, scene, object);
            else if (materialProperties.envMap !== envMap) initMaterial(material, scene, object);
        } else {
            initMaterial(material, scene, object);
            materialProperties.__version = material.version;
        }
        let refreshProgram = false;
        let refreshMaterial = false;
        let refreshLights = false;
        const program = materialProperties.program, p_uniforms = program.getUniforms(), m_uniforms = materialProperties.uniforms;
        if (state.useProgram(program.program)) {
            refreshProgram = true;
            refreshMaterial = true;
            refreshLights = true;
        }
        if (material.id !== _currentMaterialId) {
            _currentMaterialId = material.id;
            refreshMaterial = true;
        }
        if (refreshProgram || _currentCamera !== camera) {
            p_uniforms.setValue(_gl, 'projectionMatrix', camera.projectionMatrix);
            if (capabilities.logarithmicDepthBuffer) p_uniforms.setValue(_gl, 'logDepthBufFC', 2.0 / (Math.log(camera.far + 1.0) / Math.LN2));
            if (_currentCamera !== camera) {
                _currentCamera = camera;
                // lighting uniforms depend on the camera so enforce an update
                // now, in case this material supports lights - or later, when
                // the next material that does gets activated:
                refreshMaterial = true; // set to true on material change
                refreshLights = true; // remains set until update done
            }
            // load material specific uniforms
            // (shader material also gets them for the sake of genericity)
            if (material.isShaderMaterial || material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshStandardMaterial || material.envMap) {
                const uCamPos = p_uniforms.map.cameraPosition;
                if (uCamPos !== undefined) uCamPos.setValue(_gl, _vector3.setFromMatrixPosition(camera.matrixWorld));
            }
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial) p_uniforms.setValue(_gl, 'isOrthographic', camera.isOrthographicCamera === true);
            if (material.isMeshPhongMaterial || material.isMeshToonMaterial || material.isMeshLambertMaterial || material.isMeshBasicMaterial || material.isMeshStandardMaterial || material.isShaderMaterial || material.isShadowMaterial || material.skinning) p_uniforms.setValue(_gl, 'viewMatrix', camera.matrixWorldInverse);
        }
        // skinning uniforms must be set even if material didn't change
        // auto-setting of texture unit for bone texture must go before other textures
        // otherwise textures used for skinning can take over texture units reserved for other material textures
        if (material.skinning) {
            p_uniforms.setOptional(_gl, object, 'bindMatrix');
            p_uniforms.setOptional(_gl, object, 'bindMatrixInverse');
            const skeleton = object.skeleton;
            if (skeleton) {
                const bones = skeleton.bones;
                if (capabilities.floatVertexTextures) {
                    if (skeleton.boneTexture === null) {
                        // layout (1 matrix = 4 pixels)
                        //      RGBA RGBA RGBA RGBA (=> column1, column2, column3, column4)
                        //  with  8x8  pixel texture max   16 bones * 4 pixels =  (8 * 8)
                        //       16x16 pixel texture max   64 bones * 4 pixels = (16 * 16)
                        //       32x32 pixel texture max  256 bones * 4 pixels = (32 * 32)
                        //       64x64 pixel texture max 1024 bones * 4 pixels = (64 * 64)
                        let size = Math.sqrt(bones.length * 4); // 4 pixels needed for 1 matrix
                        size = MathUtils.ceilPowerOfTwo(size);
                        size = Math.max(size, 4);
                        const boneMatrices = new Float32Array(size * size * 4); // 4 floats per RGBA pixel
                        boneMatrices.set(skeleton.boneMatrices); // copy current values
                        const boneTexture = new DataTexture(boneMatrices, size, size, RGBAFormat, FloatType);
                        skeleton.boneMatrices = boneMatrices;
                        skeleton.boneTexture = boneTexture;
                        skeleton.boneTextureSize = size;
                    }
                    p_uniforms.setValue(_gl, 'boneTexture', skeleton.boneTexture, textures);
                    p_uniforms.setValue(_gl, 'boneTextureSize', skeleton.boneTextureSize);
                } else p_uniforms.setOptional(_gl, skeleton, 'boneMatrices');
            }
        }
        if (refreshMaterial || materialProperties.receiveShadow !== object.receiveShadow) {
            materialProperties.receiveShadow = object.receiveShadow;
            p_uniforms.setValue(_gl, 'receiveShadow', object.receiveShadow);
        }
        if (refreshMaterial) {
            p_uniforms.setValue(_gl, 'toneMappingExposure', _this.toneMappingExposure);
            if (materialProperties.needsLights) // the current material requires lighting info
            // note: all lighting uniforms are always set correctly
            // they simply reference the renderer's state for their
            // values
            //
            // use the current material's .needsUpdate flags to set
            // the GL state when required
            markUniformsLightsNeedsUpdate(m_uniforms, refreshLights);
            // refresh uniforms common to several materials
            if (fog && material.fog) materials.refreshFogUniforms(m_uniforms, fog);
            materials.refreshMaterialUniforms(m_uniforms, material, _pixelRatio, _height);
            WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
        }
        if (material.isShaderMaterial && material.uniformsNeedUpdate === true) {
            WebGLUniforms.upload(_gl, materialProperties.uniformsList, m_uniforms, textures);
            material.uniformsNeedUpdate = false;
        }
        if (material.isSpriteMaterial) p_uniforms.setValue(_gl, 'center', object.center);
        // common matrices
        p_uniforms.setValue(_gl, 'modelViewMatrix', object.modelViewMatrix);
        p_uniforms.setValue(_gl, 'normalMatrix', object.normalMatrix);
        p_uniforms.setValue(_gl, 'modelMatrix', object.matrixWorld);
        return program;
    }
    // If uniforms are marked as clean, they don't need to be loaded to the GPU.
    function markUniformsLightsNeedsUpdate(uniforms, value) {
        uniforms.ambientLightColor.needsUpdate = value;
        uniforms.lightProbe.needsUpdate = value;
        uniforms.directionalLights.needsUpdate = value;
        uniforms.directionalLightShadows.needsUpdate = value;
        uniforms.pointLights.needsUpdate = value;
        uniforms.pointLightShadows.needsUpdate = value;
        uniforms.spotLights.needsUpdate = value;
        uniforms.spotLightShadows.needsUpdate = value;
        uniforms.rectAreaLights.needsUpdate = value;
        uniforms.hemisphereLights.needsUpdate = value;
    }
    function materialNeedsLights(material) {
        return material.isMeshLambertMaterial || material.isMeshToonMaterial || material.isMeshPhongMaterial || material.isMeshStandardMaterial || material.isShadowMaterial || material.isShaderMaterial && material.lights === true;
    }
    //
    this.setFramebuffer = function(value) {
        if (_framebuffer !== value && _currentRenderTarget === null) _gl.bindFramebuffer(36160, value);
        _framebuffer = value;
    };
    this.getActiveCubeFace = function() {
        return _currentActiveCubeFace;
    };
    this.getActiveMipmapLevel = function() {
        return _currentActiveMipmapLevel;
    };
    this.getRenderList = function() {
        return currentRenderList;
    };
    this.setRenderList = function(renderList) {
        currentRenderList = renderList;
    };
    this.getRenderTarget = function() {
        return _currentRenderTarget;
    };
    this.setRenderTarget = function(renderTarget, activeCubeFace = 0, activeMipmapLevel = 0) {
        _currentRenderTarget = renderTarget;
        _currentActiveCubeFace = activeCubeFace;
        _currentActiveMipmapLevel = activeMipmapLevel;
        if (renderTarget && properties.get(renderTarget).__webglFramebuffer === undefined) textures.setupRenderTarget(renderTarget);
        let framebuffer = _framebuffer;
        let isCube = false;
        if (renderTarget) {
            const __webglFramebuffer = properties.get(renderTarget).__webglFramebuffer;
            if (renderTarget.isWebGLCubeRenderTarget) {
                framebuffer = __webglFramebuffer[activeCubeFace];
                isCube = true;
            } else if (renderTarget.isWebGLMultisampleRenderTarget) framebuffer = properties.get(renderTarget).__webglMultisampledFramebuffer;
            else framebuffer = __webglFramebuffer;
            _currentViewport.copy(renderTarget.viewport);
            _currentScissor.copy(renderTarget.scissor);
            _currentScissorTest = renderTarget.scissorTest;
        } else {
            _currentViewport.copy(_viewport).multiplyScalar(_pixelRatio).floor();
            _currentScissor.copy(_scissor).multiplyScalar(_pixelRatio).floor();
            _currentScissorTest = _scissorTest;
        }
        if (_currentFramebuffer !== framebuffer) {
            _gl.bindFramebuffer(36160, framebuffer);
            _currentFramebuffer = framebuffer;
        }
        state.viewport(_currentViewport);
        state.scissor(_currentScissor);
        state.setScissorTest(_currentScissorTest);
        if (isCube) {
            const textureProperties = properties.get(renderTarget.texture);
            _gl.framebufferTexture2D(36160, 36064, 34069 + activeCubeFace, textureProperties.__webglTexture, activeMipmapLevel);
        }
    };
    this.readRenderTargetPixels = function(renderTarget, x, y, width, height, buffer, activeCubeFaceIndex) {
        if (!(renderTarget && renderTarget.isWebGLRenderTarget)) {
            console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not THREE.WebGLRenderTarget.');
            return;
        }
        let framebuffer = properties.get(renderTarget).__webglFramebuffer;
        if (renderTarget.isWebGLCubeRenderTarget && activeCubeFaceIndex !== undefined) framebuffer = framebuffer[activeCubeFaceIndex];
        if (framebuffer) {
            let restore = false;
            if (framebuffer !== _currentFramebuffer) {
                _gl.bindFramebuffer(36160, framebuffer);
                restore = true;
            }
            try {
                const texture = renderTarget.texture;
                const textureFormat = texture.format;
                const textureType = texture.type;
                if (textureFormat !== RGBAFormat && utils.convert(textureFormat) !== _gl.getParameter(35739)) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in RGBA or implementation defined format.');
                    return;
                }
                const halfFloatSupportedByExt = textureType === HalfFloatType && (extensions.has('EXT_color_buffer_half_float') || capabilities.isWebGL2 && extensions.has('EXT_color_buffer_float'));
                if (textureType !== UnsignedByteType && utils.convert(textureType) !== _gl.getParameter(35738) && // IE11, Edge and Chrome Mac < 52 (#9513)
                !(textureType === FloatType && (capabilities.isWebGL2 || extensions.has('OES_texture_float') || extensions.has('WEBGL_color_buffer_float'))) && // Chrome Mac >= 52 and Firefox
                !halfFloatSupportedByExt) {
                    console.error('THREE.WebGLRenderer.readRenderTargetPixels: renderTarget is not in UnsignedByteType or implementation defined type.');
                    return;
                }
                if (_gl.checkFramebufferStatus(36160) === 36053) // the following if statement ensures valid read requests (no out-of-bounds pixels, see #8604)
                {
                    if (x >= 0 && x <= renderTarget.width - width && y >= 0 && y <= renderTarget.height - height) _gl.readPixels(x, y, width, height, utils.convert(textureFormat), utils.convert(textureType), buffer);
                } else console.error('THREE.WebGLRenderer.readRenderTargetPixels: readPixels from renderTarget failed. Framebuffer not complete.');
            } finally{
                if (restore) _gl.bindFramebuffer(36160, _currentFramebuffer);
            }
        }
    };
    this.copyFramebufferToTexture = function(position, texture, level = 0) {
        const levelScale = Math.pow(2, -level);
        const width = Math.floor(texture.image.width * levelScale);
        const height = Math.floor(texture.image.height * levelScale);
        const glFormat = utils.convert(texture.format);
        textures.setTexture2D(texture, 0);
        _gl.copyTexImage2D(3553, level, glFormat, position.x, position.y, width, height, 0);
        state.unbindTexture();
    };
    this.copyTextureToTexture = function(position, srcTexture, dstTexture, level = 0) {
        const width = srcTexture.image.width;
        const height = srcTexture.image.height;
        const glFormat = utils.convert(dstTexture.format);
        const glType = utils.convert(dstTexture.type);
        textures.setTexture2D(dstTexture, 0);
        // As another texture upload may have changed pixelStorei
        // parameters, make sure they are correct for the dstTexture
        _gl.pixelStorei(37440, dstTexture.flipY);
        _gl.pixelStorei(37441, dstTexture.premultiplyAlpha);
        _gl.pixelStorei(3317, dstTexture.unpackAlignment);
        if (srcTexture.isDataTexture) _gl.texSubImage2D(3553, level, position.x, position.y, width, height, glFormat, glType, srcTexture.image.data);
        else if (srcTexture.isCompressedTexture) _gl.compressedTexSubImage2D(3553, level, position.x, position.y, srcTexture.mipmaps[0].width, srcTexture.mipmaps[0].height, glFormat, srcTexture.mipmaps[0].data);
        else _gl.texSubImage2D(3553, level, position.x, position.y, glFormat, glType, srcTexture.image);
        // Generate mipmaps only when copying level 0
        if (level === 0 && dstTexture.generateMipmaps) _gl.generateMipmap(3553);
        state.unbindTexture();
    };
    this.initTexture = function(texture) {
        textures.setTexture2D(texture, 0);
        state.unbindTexture();
    };
    this.resetState = function() {
        state.reset();
        bindingStates.reset();
    };
    if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
        detail: this
    })); // eslint-disable-line no-undef
}
function WebGL1Renderer(parameters) {
    WebGLRenderer.call(this, parameters);
}
WebGL1Renderer.prototype = Object.assign(Object.create(WebGLRenderer.prototype), {
    constructor: WebGL1Renderer,
    isWebGL1Renderer: true
});
class FogExp2 {
    constructor(color, density){
        Object.defineProperty(this, 'isFogExp2', {
            value: true
        });
        this.name = '';
        this.color = new Color(color);
        this.density = density !== undefined ? density : 0.00025;
    }
    clone() {
        return new FogExp2(this.color, this.density);
    }
    toJSON() {
        return {
            type: 'FogExp2',
            color: this.color.getHex(),
            density: this.density
        };
    }
}
class Fog {
    constructor(color, near, far){
        Object.defineProperty(this, 'isFog', {
            value: true
        });
        this.name = '';
        this.color = new Color(color);
        this.near = near !== undefined ? near : 1;
        this.far = far !== undefined ? far : 1000;
    }
    clone() {
        return new Fog(this.color, this.near, this.far);
    }
    toJSON() {
        return {
            type: 'Fog',
            color: this.color.getHex(),
            near: this.near,
            far: this.far
        };
    }
}
class Scene extends Object3D {
    constructor(){
        super();
        Object.defineProperty(this, 'isScene', {
            value: true
        });
        this.type = 'Scene';
        this.background = null;
        this.environment = null;
        this.fog = null;
        this.overrideMaterial = null;
        this.autoUpdate = true; // checked by the renderer
        if (typeof __THREE_DEVTOOLS__ !== 'undefined') __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('observe', {
            detail: this
        })); // eslint-disable-line no-undef
    }
    copy(source, recursive) {
        super.copy(source, recursive);
        if (source.background !== null) this.background = source.background.clone();
        if (source.environment !== null) this.environment = source.environment.clone();
        if (source.fog !== null) this.fog = source.fog.clone();
        if (source.overrideMaterial !== null) this.overrideMaterial = source.overrideMaterial.clone();
        this.autoUpdate = source.autoUpdate;
        this.matrixAutoUpdate = source.matrixAutoUpdate;
        return this;
    }
    toJSON(meta) {
        const data = super.toJSON(meta);
        if (this.background !== null) data.object.background = this.background.toJSON(meta);
        if (this.environment !== null) data.object.environment = this.environment.toJSON(meta);
        if (this.fog !== null) data.object.fog = this.fog.toJSON();
        return data;
    }
}
function InterleavedBuffer(array, stride) {
    this.array = array;
    this.stride = stride;
    this.count = array !== undefined ? array.length / stride : 0;
    this.usage = StaticDrawUsage;
    this.updateRange = {
        offset: 0,
        count: -1
    };
    this.version = 0;
    this.uuid = MathUtils.generateUUID();
}
Object.defineProperty(InterleavedBuffer.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
Object.assign(InterleavedBuffer.prototype, {
    isInterleavedBuffer: true,
    onUploadCallback: function() {},
    setUsage: function(value) {
        this.usage = value;
        return this;
    },
    copy: function(source) {
        this.array = new source.array.constructor(source.array);
        this.count = source.count;
        this.stride = source.stride;
        this.usage = source.usage;
        return this;
    },
    copyAt: function(index1, attribute, index2) {
        index1 *= this.stride;
        index2 *= attribute.stride;
        for(let i = 0, l = this.stride; i < l; i++)this.array[index1 + i] = attribute.array[index2 + i];
        return this;
    },
    set: function(value, offset = 0) {
        this.array.set(value, offset);
        return this;
    },
    clone: function(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = MathUtils.generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = this.array.slice(0).buffer;
        const array = new this.array.constructor(data.arrayBuffers[this.array.buffer._uuid]);
        const ib = new InterleavedBuffer(array, this.stride);
        ib.setUsage(this.usage);
        return ib;
    },
    onUpload: function(callback) {
        this.onUploadCallback = callback;
        return this;
    },
    toJSON: function(data) {
        if (data.arrayBuffers === undefined) data.arrayBuffers = {};
        // generate UUID for array buffer if necessary
        if (this.array.buffer._uuid === undefined) this.array.buffer._uuid = MathUtils.generateUUID();
        if (data.arrayBuffers[this.array.buffer._uuid] === undefined) data.arrayBuffers[this.array.buffer._uuid] = Array.prototype.slice.call(new Uint32Array(this.array.buffer));
        //
        return {
            uuid: this.uuid,
            buffer: this.array.buffer._uuid,
            type: this.array.constructor.name,
            stride: this.stride
        };
    }
});
const _vector$6 = new Vector3();
function InterleavedBufferAttribute(interleavedBuffer, itemSize, offset, normalized) {
    this.name = '';
    this.data = interleavedBuffer;
    this.itemSize = itemSize;
    this.offset = offset;
    this.normalized = normalized === true;
}
Object.defineProperties(InterleavedBufferAttribute.prototype, {
    count: {
        get: function() {
            return this.data.count;
        }
    },
    array: {
        get: function() {
            return this.data.array;
        }
    },
    needsUpdate: {
        set: function(value) {
            this.data.needsUpdate = value;
        }
    }
});
Object.assign(InterleavedBufferAttribute.prototype, {
    isInterleavedBufferAttribute: true,
    applyMatrix4: function(m) {
        for(let i = 0, l = this.data.count; i < l; i++){
            _vector$6.x = this.getX(i);
            _vector$6.y = this.getY(i);
            _vector$6.z = this.getZ(i);
            _vector$6.applyMatrix4(m);
            this.setXYZ(i, _vector$6.x, _vector$6.y, _vector$6.z);
        }
        return this;
    },
    setX: function(index, x) {
        this.data.array[index * this.data.stride + this.offset] = x;
        return this;
    },
    setY: function(index, y) {
        this.data.array[index * this.data.stride + this.offset + 1] = y;
        return this;
    },
    setZ: function(index, z) {
        this.data.array[index * this.data.stride + this.offset + 2] = z;
        return this;
    },
    setW: function(index, w) {
        this.data.array[index * this.data.stride + this.offset + 3] = w;
        return this;
    },
    getX: function(index) {
        return this.data.array[index * this.data.stride + this.offset];
    },
    getY: function(index) {
        return this.data.array[index * this.data.stride + this.offset + 1];
    },
    getZ: function(index) {
        return this.data.array[index * this.data.stride + this.offset + 2];
    },
    getW: function(index) {
        return this.data.array[index * this.data.stride + this.offset + 3];
    },
    setXY: function(index, x, y) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        return this;
    },
    setXYZ: function(index, x, y, z) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        return this;
    },
    setXYZW: function(index, x, y, z, w) {
        index = index * this.data.stride + this.offset;
        this.data.array[index + 0] = x;
        this.data.array[index + 1] = y;
        this.data.array[index + 2] = z;
        this.data.array[index + 3] = w;
        return this;
    },
    clone: function(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.clone(): Cloning an interlaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            return new BufferAttribute(new this.array.constructor(array), this.itemSize, this.normalized);
        } else {
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.clone(data);
            return new InterleavedBufferAttribute(data.interleavedBuffers[this.data.uuid], this.itemSize, this.offset, this.normalized);
        }
    },
    toJSON: function(data) {
        if (data === undefined) {
            console.log('THREE.InterleavedBufferAttribute.toJSON(): Serializing an interlaved buffer attribute will deinterleave buffer data.');
            const array = [];
            for(let i = 0; i < this.count; i++){
                const index = i * this.data.stride + this.offset;
                for(let j = 0; j < this.itemSize; j++)array.push(this.data.array[index + j]);
            }
            // deinterleave data and save it as an ordinary buffer attribute for now
            return {
                itemSize: this.itemSize,
                type: this.array.constructor.name,
                array: array,
                normalized: this.normalized
            };
        } else {
            // save as true interlaved attribtue
            if (data.interleavedBuffers === undefined) data.interleavedBuffers = {};
            if (data.interleavedBuffers[this.data.uuid] === undefined) data.interleavedBuffers[this.data.uuid] = this.data.toJSON(data);
            return {
                isInterleavedBufferAttribute: true,
                itemSize: this.itemSize,
                data: this.data.uuid,
                offset: this.offset,
                normalized: this.normalized
            };
        }
    }
});
/**
 * parameters = {
 *  color: <hex>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *  rotation: <float>,
 *  sizeAttenuation: <bool>
 * }
 */ function SpriteMaterial(parameters) {
    Material.call(this);
    this.type = 'SpriteMaterial';
    this.color = new Color(0xffffff);
    this.map = null;
    this.alphaMap = null;
    this.rotation = 0;
    this.sizeAttenuation = true;
    this.transparent = true;
    this.setValues(parameters);
}
SpriteMaterial.prototype = Object.create(Material.prototype);
SpriteMaterial.prototype.constructor = SpriteMaterial;
SpriteMaterial.prototype.isSpriteMaterial = true;
SpriteMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.rotation = source.rotation;
    this.sizeAttenuation = source.sizeAttenuation;
    return this;
};
let _geometry;
const _intersectPoint = new Vector3();
const _worldScale = new Vector3();
const _mvPosition = new Vector3();
const _alignedPosition = new Vector2();
const _rotatedPosition = new Vector2();
const _viewWorldMatrix = new Matrix4();
const _vA$1 = new Vector3();
const _vB$1 = new Vector3();
const _vC$1 = new Vector3();
const _uvA$1 = new Vector2();
const _uvB$1 = new Vector2();
const _uvC$1 = new Vector2();
function Sprite(material) {
    Object3D.call(this);
    this.type = 'Sprite';
    if (_geometry === undefined) {
        _geometry = new BufferGeometry();
        const float32Array = new Float32Array([
            -0.5,
            -0.5,
            0,
            0,
            0,
            0.5,
            -0.5,
            0,
            1,
            0,
            0.5,
            0.5,
            0,
            1,
            1,
            -0.5,
            0.5,
            0,
            0,
            1
        ]);
        const interleavedBuffer = new InterleavedBuffer(float32Array, 5);
        _geometry.setIndex([
            0,
            1,
            2,
            0,
            2,
            3
        ]);
        _geometry.setAttribute('position', new InterleavedBufferAttribute(interleavedBuffer, 3, 0, false));
        _geometry.setAttribute('uv', new InterleavedBufferAttribute(interleavedBuffer, 2, 3, false));
    }
    this.geometry = _geometry;
    this.material = material !== undefined ? material : new SpriteMaterial();
    this.center = new Vector2(0.5, 0.5);
}
Sprite.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Sprite,
    isSprite: true,
    raycast: function(raycaster, intersects) {
        if (raycaster.camera === null) console.error('THREE.Sprite: "Raycaster.camera" needs to be set in order to raycast against sprites.');
        _worldScale.setFromMatrixScale(this.matrixWorld);
        _viewWorldMatrix.copy(raycaster.camera.matrixWorld);
        this.modelViewMatrix.multiplyMatrices(raycaster.camera.matrixWorldInverse, this.matrixWorld);
        _mvPosition.setFromMatrixPosition(this.modelViewMatrix);
        if (raycaster.camera.isPerspectiveCamera && this.material.sizeAttenuation === false) _worldScale.multiplyScalar(-_mvPosition.z);
        const rotation = this.material.rotation;
        let sin, cos;
        if (rotation !== 0) {
            cos = Math.cos(rotation);
            sin = Math.sin(rotation);
        }
        const center = this.center;
        transformVertex(_vA$1.set(-0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        transformVertex(_vB$1.set(0.5, -0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        transformVertex(_vC$1.set(0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
        _uvA$1.set(0, 0);
        _uvB$1.set(1, 0);
        _uvC$1.set(1, 1);
        // check first triangle
        let intersect = raycaster.ray.intersectTriangle(_vA$1, _vB$1, _vC$1, false, _intersectPoint);
        if (intersect === null) {
            // check second triangle
            transformVertex(_vB$1.set(-0.5, 0.5, 0), _mvPosition, center, _worldScale, sin, cos);
            _uvB$1.set(0, 1);
            intersect = raycaster.ray.intersectTriangle(_vA$1, _vC$1, _vB$1, false, _intersectPoint);
            if (intersect === null) return;
        }
        const distance = raycaster.ray.origin.distanceTo(_intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            point: _intersectPoint.clone(),
            uv: Triangle.getUV(_intersectPoint, _vA$1, _vB$1, _vC$1, _uvA$1, _uvB$1, _uvC$1, new Vector2()),
            face: null,
            object: this
        });
    },
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        if (source.center !== undefined) this.center.copy(source.center);
        this.material = source.material;
        return this;
    }
});
function transformVertex(vertexPosition, mvPosition, center, scale, sin, cos) {
    // compute position in camera space
    _alignedPosition.subVectors(vertexPosition, center).addScalar(0.5).multiply(scale);
    // to check if rotation is not zero
    if (sin !== undefined) {
        _rotatedPosition.x = cos * _alignedPosition.x - sin * _alignedPosition.y;
        _rotatedPosition.y = sin * _alignedPosition.x + cos * _alignedPosition.y;
    } else _rotatedPosition.copy(_alignedPosition);
    vertexPosition.copy(mvPosition);
    vertexPosition.x += _rotatedPosition.x;
    vertexPosition.y += _rotatedPosition.y;
    // transform to world space
    vertexPosition.applyMatrix4(_viewWorldMatrix);
}
const _v1$4 = new Vector3();
const _v2$2 = new Vector3();
function LOD() {
    Object3D.call(this);
    this._currentLevel = 0;
    this.type = 'LOD';
    Object.defineProperties(this, {
        levels: {
            enumerable: true,
            value: []
        }
    });
    this.autoUpdate = true;
}
LOD.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: LOD,
    isLOD: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source, false);
        const levels = source.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            this.addLevel(level.object.clone(), level.distance);
        }
        this.autoUpdate = source.autoUpdate;
        return this;
    },
    addLevel: function(object, distance = 0) {
        distance = Math.abs(distance);
        const levels = this.levels;
        let l;
        for(l = 0; l < levels.length; l++){
            if (distance < levels[l].distance) break;
        }
        levels.splice(l, 0, {
            distance: distance,
            object: object
        });
        this.add(object);
        return this;
    },
    getCurrentLevel: function() {
        return this._currentLevel;
    },
    getObjectForDistance: function(distance) {
        const levels = this.levels;
        if (levels.length > 0) {
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance < levels[i].distance) break;
            }
            return levels[i - 1].object;
        }
        return null;
    },
    raycast: function(raycaster, intersects) {
        const levels = this.levels;
        if (levels.length > 0) {
            _v1$4.setFromMatrixPosition(this.matrixWorld);
            const distance = raycaster.ray.origin.distanceTo(_v1$4);
            this.getObjectForDistance(distance).raycast(raycaster, intersects);
        }
    },
    update: function(camera) {
        const levels = this.levels;
        if (levels.length > 1) {
            _v1$4.setFromMatrixPosition(camera.matrixWorld);
            _v2$2.setFromMatrixPosition(this.matrixWorld);
            const distance = _v1$4.distanceTo(_v2$2) / camera.zoom;
            levels[0].object.visible = true;
            let i, l;
            for(i = 1, l = levels.length; i < l; i++){
                if (distance >= levels[i].distance) {
                    levels[i - 1].object.visible = false;
                    levels[i].object.visible = true;
                } else break;
            }
            this._currentLevel = i - 1;
            for(; i < l; i++)levels[i].object.visible = false;
        }
    },
    toJSON: function(meta) {
        const data = Object3D.prototype.toJSON.call(this, meta);
        if (this.autoUpdate === false) data.object.autoUpdate = false;
        data.object.levels = [];
        const levels = this.levels;
        for(let i = 0, l = levels.length; i < l; i++){
            const level = levels[i];
            data.object.levels.push({
                object: level.object.uuid,
                distance: level.distance
            });
        }
        return data;
    }
});
const _basePosition = new Vector3();
const _skinIndex = new Vector4();
const _skinWeight = new Vector4();
const _vector$7 = new Vector3();
const _matrix$1 = new Matrix4();
function SkinnedMesh(geometry, material) {
    if (geometry && geometry.isGeometry) console.error('THREE.SkinnedMesh no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
    Mesh.call(this, geometry, material);
    this.type = 'SkinnedMesh';
    this.bindMode = 'attached';
    this.bindMatrix = new Matrix4();
    this.bindMatrixInverse = new Matrix4();
}
SkinnedMesh.prototype = Object.assign(Object.create(Mesh.prototype), {
    constructor: SkinnedMesh,
    isSkinnedMesh: true,
    copy: function(source) {
        Mesh.prototype.copy.call(this, source);
        this.bindMode = source.bindMode;
        this.bindMatrix.copy(source.bindMatrix);
        this.bindMatrixInverse.copy(source.bindMatrixInverse);
        this.skeleton = source.skeleton;
        return this;
    },
    bind: function(skeleton, bindMatrix) {
        this.skeleton = skeleton;
        if (bindMatrix === undefined) {
            this.updateMatrixWorld(true);
            this.skeleton.calculateInverses();
            bindMatrix = this.matrixWorld;
        }
        this.bindMatrix.copy(bindMatrix);
        this.bindMatrixInverse.copy(bindMatrix).invert();
    },
    pose: function() {
        this.skeleton.pose();
    },
    normalizeSkinWeights: function() {
        const vector = new Vector4();
        const skinWeight = this.geometry.attributes.skinWeight;
        for(let i = 0, l = skinWeight.count; i < l; i++){
            vector.x = skinWeight.getX(i);
            vector.y = skinWeight.getY(i);
            vector.z = skinWeight.getZ(i);
            vector.w = skinWeight.getW(i);
            const scale = 1.0 / vector.manhattanLength();
            if (scale !== Infinity) vector.multiplyScalar(scale);
            else vector.set(1, 0, 0, 0); // do something reasonable
            skinWeight.setXYZW(i, vector.x, vector.y, vector.z, vector.w);
        }
    },
    updateMatrixWorld: function(force) {
        Mesh.prototype.updateMatrixWorld.call(this, force);
        if (this.bindMode === 'attached') this.bindMatrixInverse.copy(this.matrixWorld).invert();
        else if (this.bindMode === 'detached') this.bindMatrixInverse.copy(this.bindMatrix).invert();
        else console.warn('THREE.SkinnedMesh: Unrecognized bindMode: ' + this.bindMode);
    },
    boneTransform: function(index, target) {
        const skeleton = this.skeleton;
        const geometry = this.geometry;
        _skinIndex.fromBufferAttribute(geometry.attributes.skinIndex, index);
        _skinWeight.fromBufferAttribute(geometry.attributes.skinWeight, index);
        _basePosition.fromBufferAttribute(geometry.attributes.position, index).applyMatrix4(this.bindMatrix);
        target.set(0, 0, 0);
        for(let i = 0; i < 4; i++){
            const weight = _skinWeight.getComponent(i);
            if (weight !== 0) {
                const boneIndex = _skinIndex.getComponent(i);
                _matrix$1.multiplyMatrices(skeleton.bones[boneIndex].matrixWorld, skeleton.boneInverses[boneIndex]);
                target.addScaledVector(_vector$7.copy(_basePosition).applyMatrix4(_matrix$1), weight);
            }
        }
        return target.applyMatrix4(this.bindMatrixInverse);
    }
});
function Bone() {
    Object3D.call(this);
    this.type = 'Bone';
}
Bone.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Bone,
    isBone: true
});
const _offsetMatrix = new Matrix4();
const _identityMatrix = new Matrix4();
function Skeleton(bones = [], boneInverses = []) {
    this.uuid = MathUtils.generateUUID();
    this.bones = bones.slice(0);
    this.boneInverses = boneInverses;
    this.boneMatrices = null;
    this.boneTexture = null;
    this.boneTextureSize = 0;
    this.frame = -1;
    this.init();
}
Object.assign(Skeleton.prototype, {
    init: function() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        this.boneMatrices = new Float32Array(bones.length * 16);
        // calculate inverse bone matrices if necessary
        if (boneInverses.length === 0) this.calculateInverses();
        else // handle special case
        if (bones.length !== boneInverses.length) {
            console.warn('THREE.Skeleton: Number of inverse bone matrices does not match amount of bones.');
            this.boneInverses = [];
            for(let i = 0, il = this.bones.length; i < il; i++)this.boneInverses.push(new Matrix4());
        }
    },
    calculateInverses: function() {
        this.boneInverses.length = 0;
        for(let i = 0, il = this.bones.length; i < il; i++){
            const inverse = new Matrix4();
            if (this.bones[i]) inverse.copy(this.bones[i].matrixWorld).invert();
            this.boneInverses.push(inverse);
        }
    },
    pose: function() {
        // recover the bind-time world matrices
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) bone.matrixWorld.copy(this.boneInverses[i]).invert();
        }
        // compute the local matrices, positions, rotations and scales
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone) {
                if (bone.parent && bone.parent.isBone) {
                    bone.matrix.copy(bone.parent.matrixWorld).invert();
                    bone.matrix.multiply(bone.matrixWorld);
                } else bone.matrix.copy(bone.matrixWorld);
                bone.matrix.decompose(bone.position, bone.quaternion, bone.scale);
            }
        }
    },
    update: function() {
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        const boneMatrices = this.boneMatrices;
        const boneTexture = this.boneTexture;
        // flatten bone matrices to array
        for(let i = 0, il = bones.length; i < il; i++){
            // compute the offset between the current and the original transform
            const matrix = bones[i] ? bones[i].matrixWorld : _identityMatrix;
            _offsetMatrix.multiplyMatrices(matrix, boneInverses[i]);
            _offsetMatrix.toArray(boneMatrices, i * 16);
        }
        if (boneTexture !== null) boneTexture.needsUpdate = true;
    },
    clone: function() {
        return new Skeleton(this.bones, this.boneInverses);
    },
    getBoneByName: function(name) {
        for(let i = 0, il = this.bones.length; i < il; i++){
            const bone = this.bones[i];
            if (bone.name === name) return bone;
        }
        return undefined;
    },
    dispose: function() {
        if (this.boneTexture !== null) {
            this.boneTexture.dispose();
            this.boneTexture = null;
        }
    },
    fromJSON: function(json, bones) {
        this.uuid = json.uuid;
        for(let i = 0, l = json.bones.length; i < l; i++){
            const uuid = json.bones[i];
            let bone = bones[uuid];
            if (bone === undefined) {
                console.warn('THREE.Skeleton: No bone found with UUID:', uuid);
                bone = new Bone();
            }
            this.bones.push(bone);
            this.boneInverses.push(new Matrix4().fromArray(json.boneInverses[i]));
        }
        this.init();
        return this;
    },
    toJSON: function() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Skeleton',
                generator: 'Skeleton.toJSON'
            },
            bones: [],
            boneInverses: []
        };
        data.uuid = this.uuid;
        const bones = this.bones;
        const boneInverses = this.boneInverses;
        for(let i = 0, l = bones.length; i < l; i++){
            const bone = bones[i];
            data.bones.push(bone.uuid);
            const boneInverse = boneInverses[i];
            data.boneInverses.push(boneInverse.toArray());
        }
        return data;
    }
});
const _instanceLocalMatrix = new Matrix4();
const _instanceWorldMatrix = new Matrix4();
const _instanceIntersects = [];
const _mesh = new Mesh();
function InstancedMesh(geometry, material, count) {
    Mesh.call(this, geometry, material);
    this.instanceMatrix = new BufferAttribute(new Float32Array(count * 16), 16);
    this.instanceColor = null;
    this.count = count;
    this.frustumCulled = false;
}
InstancedMesh.prototype = Object.assign(Object.create(Mesh.prototype), {
    constructor: InstancedMesh,
    isInstancedMesh: true,
    copy: function(source) {
        Mesh.prototype.copy.call(this, source);
        this.instanceMatrix.copy(source.instanceMatrix);
        if (source.instanceColor !== null) this.instanceColor = source.instanceColor.clone();
        this.count = source.count;
        return this;
    },
    getColorAt: function(index, color) {
        color.fromArray(this.instanceColor.array, index * 3);
    },
    getMatrixAt: function(index, matrix) {
        matrix.fromArray(this.instanceMatrix.array, index * 16);
    },
    raycast: function(raycaster, intersects) {
        const matrixWorld = this.matrixWorld;
        const raycastTimes = this.count;
        _mesh.geometry = this.geometry;
        _mesh.material = this.material;
        if (_mesh.material === undefined) return;
        for(let instanceId = 0; instanceId < raycastTimes; instanceId++){
            // calculate the world matrix for each instance
            this.getMatrixAt(instanceId, _instanceLocalMatrix);
            _instanceWorldMatrix.multiplyMatrices(matrixWorld, _instanceLocalMatrix);
            // the mesh represents this single instance
            _mesh.matrixWorld = _instanceWorldMatrix;
            _mesh.raycast(raycaster, _instanceIntersects);
            // process the result of raycast
            for(let i = 0, l = _instanceIntersects.length; i < l; i++){
                const intersect = _instanceIntersects[i];
                intersect.instanceId = instanceId;
                intersect.object = this;
                intersects.push(intersect);
            }
            _instanceIntersects.length = 0;
        }
    },
    setColorAt: function(index, color) {
        if (this.instanceColor === null) this.instanceColor = new BufferAttribute(new Float32Array(this.count * 3), 3);
        color.toArray(this.instanceColor.array, index * 3);
    },
    setMatrixAt: function(index, matrix) {
        matrix.toArray(this.instanceMatrix.array, index * 16);
    },
    updateMorphTargets: function() {},
    dispose: function() {
        this.dispatchEvent({
            type: 'dispose'
        });
    }
});
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *  linecap: "round",
 *  linejoin: "round"
 * }
 */ function LineBasicMaterial(parameters) {
    Material.call(this);
    this.type = 'LineBasicMaterial';
    this.color = new Color(0xffffff);
    this.linewidth = 1;
    this.linecap = 'round';
    this.linejoin = 'round';
    this.morphTargets = false;
    this.setValues(parameters);
}
LineBasicMaterial.prototype = Object.create(Material.prototype);
LineBasicMaterial.prototype.constructor = LineBasicMaterial;
LineBasicMaterial.prototype.isLineBasicMaterial = true;
LineBasicMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.linewidth = source.linewidth;
    this.linecap = source.linecap;
    this.linejoin = source.linejoin;
    this.morphTargets = source.morphTargets;
    return this;
};
const _start = new Vector3();
const _end = new Vector3();
const _inverseMatrix$1 = new Matrix4();
const _ray$1 = new Ray();
const _sphere$2 = new Sphere();
function Line(geometry = new BufferGeometry(), material = new LineBasicMaterial()) {
    Object3D.call(this);
    this.type = 'Line';
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
}
Line.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Line,
    isLine: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    },
    computeLineDistances: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [
                    0
                ];
                for(let i = 1, l = positionAttribute.count; i < l; i++){
                    _start.fromBufferAttribute(positionAttribute, i - 1);
                    _end.fromBufferAttribute(positionAttribute, i);
                    lineDistances[i] = lineDistances[i - 1];
                    lineDistances[i] += _start.distanceTo(_end);
                }
                geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
            } else console.warn('THREE.Line.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        } else if (geometry.isGeometry) console.error('THREE.Line.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
        return this;
    },
    raycast: function(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Line.threshold;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$2.copy(geometry.boundingSphere);
        _sphere$2.applyMatrix4(matrixWorld);
        _sphere$2.radius += threshold;
        if (raycaster.ray.intersectsSphere(_sphere$2) === false) return;
        //
        _inverseMatrix$1.copy(matrixWorld).invert();
        _ray$1.copy(raycaster.ray).applyMatrix4(_inverseMatrix$1);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        const vStart = new Vector3();
        const vEnd = new Vector3();
        const interSegment = new Vector3();
        const interRay = new Vector3();
        const step = this.isLineSegments ? 2 : 1;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const indices = index.array;
                for(let i = 0, l = indices.length - 1; i < l; i += step){
                    const a = indices[i];
                    const b = indices[i + 1];
                    vStart.fromBufferAttribute(positionAttribute, a);
                    vEnd.fromBufferAttribute(positionAttribute, b);
                    const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                    if (distSq > localThresholdSq) continue;
                    interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                    const distance = raycaster.ray.origin.distanceTo(interRay);
                    if (distance < raycaster.near || distance > raycaster.far) continue;
                    intersects.push({
                        distance: distance,
                        // What do we want? intersection point on the ray or on the segment??
                        // point: raycaster.ray.at( distance ),
                        point: interSegment.clone().applyMatrix4(this.matrixWorld),
                        index: i,
                        face: null,
                        faceIndex: null,
                        object: this
                    });
                }
            } else for(let i = 0, l = positionAttribute.count - 1; i < l; i += step){
                vStart.fromBufferAttribute(positionAttribute, i);
                vEnd.fromBufferAttribute(positionAttribute, i + 1);
                const distSq = _ray$1.distanceSqToSegment(vStart, vEnd, interRay, interSegment);
                if (distSq > localThresholdSq) continue;
                interRay.applyMatrix4(this.matrixWorld); //Move back to world space for distance calculation
                const distance = raycaster.ray.origin.distanceTo(interRay);
                if (distance < raycaster.near || distance > raycaster.far) continue;
                intersects.push({
                    distance: distance,
                    // What do we want? intersection point on the ray or on the segment??
                    // point: raycaster.ray.at( distance ),
                    point: interSegment.clone().applyMatrix4(this.matrixWorld),
                    index: i,
                    face: null,
                    faceIndex: null,
                    object: this
                });
            }
        } else if (geometry.isGeometry) console.error('THREE.Line.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
    },
    updateMorphTargets: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Line.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
    }
});
const _start$1 = new Vector3();
const _end$1 = new Vector3();
function LineSegments(geometry, material) {
    Line.call(this, geometry, material);
    this.type = 'LineSegments';
}
LineSegments.prototype = Object.assign(Object.create(Line.prototype), {
    constructor: LineSegments,
    isLineSegments: true,
    computeLineDistances: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            // we assume non-indexed geometry
            if (geometry.index === null) {
                const positionAttribute = geometry.attributes.position;
                const lineDistances = [];
                for(let i = 0, l = positionAttribute.count; i < l; i += 2){
                    _start$1.fromBufferAttribute(positionAttribute, i);
                    _end$1.fromBufferAttribute(positionAttribute, i + 1);
                    lineDistances[i] = i === 0 ? 0 : lineDistances[i - 1];
                    lineDistances[i + 1] = lineDistances[i] + _start$1.distanceTo(_end$1);
                }
                geometry.setAttribute('lineDistance', new Float32BufferAttribute(lineDistances, 1));
            } else console.warn('THREE.LineSegments.computeLineDistances(): Computation only possible with non-indexed BufferGeometry.');
        } else if (geometry.isGeometry) console.error('THREE.LineSegments.computeLineDistances() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
        return this;
    }
});
function LineLoop(geometry, material) {
    Line.call(this, geometry, material);
    this.type = 'LineLoop';
}
LineLoop.prototype = Object.assign(Object.create(Line.prototype), {
    constructor: LineLoop,
    isLineLoop: true
});
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *  map: new THREE.Texture( <Image> ),
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  size: <float>,
 *  sizeAttenuation: <bool>
 *
 *  morphTargets: <bool>
 * }
 */ function PointsMaterial(parameters) {
    Material.call(this);
    this.type = 'PointsMaterial';
    this.color = new Color(0xffffff);
    this.map = null;
    this.alphaMap = null;
    this.size = 1;
    this.sizeAttenuation = true;
    this.morphTargets = false;
    this.setValues(parameters);
}
PointsMaterial.prototype = Object.create(Material.prototype);
PointsMaterial.prototype.constructor = PointsMaterial;
PointsMaterial.prototype.isPointsMaterial = true;
PointsMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.alphaMap = source.alphaMap;
    this.size = source.size;
    this.sizeAttenuation = source.sizeAttenuation;
    this.morphTargets = source.morphTargets;
    return this;
};
const _inverseMatrix$2 = new Matrix4();
const _ray$2 = new Ray();
const _sphere$3 = new Sphere();
const _position$1 = new Vector3();
function Points(geometry = new BufferGeometry(), material = new PointsMaterial()) {
    Object3D.call(this);
    this.type = 'Points';
    this.geometry = geometry;
    this.material = material;
    this.updateMorphTargets();
}
Points.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Points,
    isPoints: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        this.material = source.material;
        this.geometry = source.geometry;
        return this;
    },
    raycast: function(raycaster, intersects) {
        const geometry = this.geometry;
        const matrixWorld = this.matrixWorld;
        const threshold = raycaster.params.Points.threshold;
        // Checking boundingSphere distance to ray
        if (geometry.boundingSphere === null) geometry.computeBoundingSphere();
        _sphere$3.copy(geometry.boundingSphere);
        _sphere$3.applyMatrix4(matrixWorld);
        _sphere$3.radius += threshold;
        if (raycaster.ray.intersectsSphere(_sphere$3) === false) return;
        //
        _inverseMatrix$2.copy(matrixWorld).invert();
        _ray$2.copy(raycaster.ray).applyMatrix4(_inverseMatrix$2);
        const localThreshold = threshold / ((this.scale.x + this.scale.y + this.scale.z) / 3);
        const localThresholdSq = localThreshold * localThreshold;
        if (geometry.isBufferGeometry) {
            const index = geometry.index;
            const attributes = geometry.attributes;
            const positionAttribute = attributes.position;
            if (index !== null) {
                const indices = index.array;
                for(let i = 0, il = indices.length; i < il; i++){
                    const a = indices[i];
                    _position$1.fromBufferAttribute(positionAttribute, a);
                    testPoint(_position$1, a, localThresholdSq, matrixWorld, raycaster, intersects, this);
                }
            } else for(let i = 0, l = positionAttribute.count; i < l; i++){
                _position$1.fromBufferAttribute(positionAttribute, i);
                testPoint(_position$1, i, localThresholdSq, matrixWorld, raycaster, intersects, this);
            }
        } else console.error('THREE.Points.raycast() no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
    },
    updateMorphTargets: function() {
        const geometry = this.geometry;
        if (geometry.isBufferGeometry) {
            const morphAttributes = geometry.morphAttributes;
            const keys = Object.keys(morphAttributes);
            if (keys.length > 0) {
                const morphAttribute = morphAttributes[keys[0]];
                if (morphAttribute !== undefined) {
                    this.morphTargetInfluences = [];
                    this.morphTargetDictionary = {};
                    for(let m = 0, ml = morphAttribute.length; m < ml; m++){
                        const name = morphAttribute[m].name || String(m);
                        this.morphTargetInfluences.push(0);
                        this.morphTargetDictionary[name] = m;
                    }
                }
            }
        } else {
            const morphTargets = geometry.morphTargets;
            if (morphTargets !== undefined && morphTargets.length > 0) console.error('THREE.Points.updateMorphTargets() does not support THREE.Geometry. Use THREE.BufferGeometry instead.');
        }
    }
});
function testPoint(point, index, localThresholdSq, matrixWorld, raycaster, intersects, object) {
    const rayPointDistanceSq = _ray$2.distanceSqToPoint(point);
    if (rayPointDistanceSq < localThresholdSq) {
        const intersectPoint = new Vector3();
        _ray$2.closestPointToPoint(point, intersectPoint);
        intersectPoint.applyMatrix4(matrixWorld);
        const distance = raycaster.ray.origin.distanceTo(intersectPoint);
        if (distance < raycaster.near || distance > raycaster.far) return;
        intersects.push({
            distance: distance,
            distanceToRay: Math.sqrt(rayPointDistanceSq),
            point: intersectPoint,
            index: index,
            face: null,
            object: object
        });
    }
}
function VideoTexture(video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    Texture.call(this, video, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.format = format !== undefined ? format : RGBFormat;
    this.minFilter = minFilter !== undefined ? minFilter : LinearFilter;
    this.magFilter = magFilter !== undefined ? magFilter : LinearFilter;
    this.generateMipmaps = false;
    const scope = this;
    function updateVideo() {
        scope.needsUpdate = true;
        video.requestVideoFrameCallback(updateVideo);
    }
    if ('requestVideoFrameCallback' in video) video.requestVideoFrameCallback(updateVideo);
}
VideoTexture.prototype = Object.assign(Object.create(Texture.prototype), {
    constructor: VideoTexture,
    clone: function() {
        return new this.constructor(this.image).copy(this);
    },
    isVideoTexture: true,
    update: function() {
        const video = this.image;
        const hasVideoFrameCallback = 'requestVideoFrameCallback' in video;
        if (hasVideoFrameCallback === false && video.readyState >= video.HAVE_CURRENT_DATA) this.needsUpdate = true;
    }
});
function CompressedTexture(mipmaps, width, height, format, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, encoding) {
    Texture.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy, encoding);
    this.image = {
        width: width,
        height: height
    };
    this.mipmaps = mipmaps;
    // no flipping for cube textures
    // (also flipping doesn't work for compressed textures )
    this.flipY = false;
    // can't generate mipmaps for compressed textures
    // mips must be embedded in DDS files
    this.generateMipmaps = false;
}
CompressedTexture.prototype = Object.create(Texture.prototype);
CompressedTexture.prototype.constructor = CompressedTexture;
CompressedTexture.prototype.isCompressedTexture = true;
function CanvasTexture(canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy) {
    Texture.call(this, canvas, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.needsUpdate = true;
}
CanvasTexture.prototype = Object.create(Texture.prototype);
CanvasTexture.prototype.constructor = CanvasTexture;
CanvasTexture.prototype.isCanvasTexture = true;
function DepthTexture(width, height, type, mapping, wrapS, wrapT, magFilter, minFilter, anisotropy, format) {
    format = format !== undefined ? format : DepthFormat;
    if (format !== DepthFormat && format !== DepthStencilFormat) throw new Error('DepthTexture format must be either THREE.DepthFormat or THREE.DepthStencilFormat');
    if (type === undefined && format === DepthFormat) type = UnsignedShortType;
    if (type === undefined && format === DepthStencilFormat) type = UnsignedInt248Type;
    Texture.call(this, null, mapping, wrapS, wrapT, magFilter, minFilter, format, type, anisotropy);
    this.image = {
        width: width,
        height: height
    };
    this.magFilter = magFilter !== undefined ? magFilter : NearestFilter;
    this.minFilter = minFilter !== undefined ? minFilter : NearestFilter;
    this.flipY = false;
    this.generateMipmaps = false;
}
DepthTexture.prototype = Object.create(Texture.prototype);
DepthTexture.prototype.constructor = DepthTexture;
DepthTexture.prototype.isDepthTexture = true;
class CircleGeometry extends BufferGeometry {
    constructor(radius = 1, segments = 8, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CircleGeometry';
        this.parameters = {
            radius: radius,
            segments: segments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        segments = Math.max(3, segments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new Vector3();
        const uv = new Vector2();
        // center point
        vertices.push(0, 0, 0);
        normals.push(0, 0, 1);
        uvs.push(0.5, 0.5);
        for(let s = 0, i = 3; s <= segments; s++, i += 3){
            const segment = thetaStart + s / segments * thetaLength;
            // vertex
            vertex.x = radius * Math.cos(segment);
            vertex.y = radius * Math.sin(segment);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            normals.push(0, 0, 1);
            // uvs
            uv.x = (vertices[i] / radius + 1) / 2;
            uv.y = (vertices[i + 1] / radius + 1) / 2;
            uvs.push(uv.x, uv.y);
        }
        // indices
        for(let i = 1; i <= segments; i++)indices.push(i, i + 1, 0);
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
class CylinderGeometry extends BufferGeometry {
    constructor(radiusTop = 1, radiusBottom = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'CylinderGeometry';
        this.parameters = {
            radiusTop: radiusTop,
            radiusBottom: radiusBottom,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        const scope = this;
        radialSegments = Math.floor(radialSegments);
        heightSegments = Math.floor(heightSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let index = 0;
        const indexArray = [];
        const halfHeight = height / 2;
        let groupStart = 0;
        // generate geometry
        generateTorso();
        if (openEnded === false) {
            if (radiusTop > 0) generateCap(true);
            if (radiusBottom > 0) generateCap(false);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        function generateTorso() {
            const normal = new Vector3();
            const vertex = new Vector3();
            let groupCount = 0;
            // this will be used to calculate the normal
            const slope = (radiusBottom - radiusTop) / height;
            // generate vertices, normals and uvs
            for(let y = 0; y <= heightSegments; y++){
                const indexRow = [];
                const v = y / heightSegments;
                // calculate the radius of the current row
                const radius = v * (radiusBottom - radiusTop) + radiusTop;
                for(let x = 0; x <= radialSegments; x++){
                    const u = x / radialSegments;
                    const theta = u * thetaLength + thetaStart;
                    const sinTheta = Math.sin(theta);
                    const cosTheta = Math.cos(theta);
                    // vertex
                    vertex.x = radius * sinTheta;
                    vertex.y = -v * height + halfHeight;
                    vertex.z = radius * cosTheta;
                    vertices.push(vertex.x, vertex.y, vertex.z);
                    // normal
                    normal.set(sinTheta, slope, cosTheta).normalize();
                    normals.push(normal.x, normal.y, normal.z);
                    // uv
                    uvs.push(u, 1 - v);
                    // save index of vertex in respective row
                    indexRow.push(index++);
                }
                // now save vertices of the row in our index array
                indexArray.push(indexRow);
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++)for(let y = 0; y < heightSegments; y++){
                // we use the index array to access the correct indices
                const a = indexArray[y][x];
                const b = indexArray[y + 1][x];
                const c = indexArray[y + 1][x + 1];
                const d = indexArray[y][x + 1];
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
                // update group counter
                groupCount += 6;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, 0);
            // calculate new start value for groups
            groupStart += groupCount;
        }
        function generateCap(top) {
            // save the index of the first center vertex
            const centerIndexStart = index;
            const uv = new Vector2();
            const vertex = new Vector3();
            let groupCount = 0;
            const radius = top === true ? radiusTop : radiusBottom;
            const sign = top === true ? 1 : -1;
            // first we generate the center vertex data of the cap.
            // because the geometry needs one set of uvs per face,
            // we must generate a center vertex per face/segment
            for(let x = 1; x <= radialSegments; x++){
                // vertex
                vertices.push(0, halfHeight * sign, 0);
                // normal
                normals.push(0, sign, 0);
                // uv
                uvs.push(0.5, 0.5);
                // increase index
                index++;
            }
            // save the index of the last center vertex
            const centerIndexEnd = index;
            // now we generate the surrounding vertices, normals and uvs
            for(let x = 0; x <= radialSegments; x++){
                const u = x / radialSegments;
                const theta = u * thetaLength + thetaStart;
                const cosTheta = Math.cos(theta);
                const sinTheta = Math.sin(theta);
                // vertex
                vertex.x = radius * sinTheta;
                vertex.y = halfHeight * sign;
                vertex.z = radius * cosTheta;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, sign, 0);
                // uv
                uv.x = cosTheta * 0.5 + 0.5;
                uv.y = sinTheta * 0.5 * sign + 0.5;
                uvs.push(uv.x, uv.y);
                // increase index
                index++;
            }
            // generate indices
            for(let x = 0; x < radialSegments; x++){
                const c = centerIndexStart + x;
                const i = centerIndexEnd + x;
                if (top === true) // face top
                indices.push(i, i + 1, c);
                else // face bottom
                indices.push(i + 1, i, c);
                groupCount += 3;
            }
            // add a group to the geometry. this will ensure multi material support
            scope.addGroup(groupStart, groupCount, top === true ? 1 : 2);
            // calculate new start value for groups
            groupStart += groupCount;
        }
    }
}
class ConeGeometry extends CylinderGeometry {
    constructor(radius = 1, height = 1, radialSegments = 8, heightSegments = 1, openEnded = false, thetaStart = 0, thetaLength = Math.PI * 2){
        super(0, radius, height, radialSegments, heightSegments, openEnded, thetaStart, thetaLength);
        this.type = 'ConeGeometry';
        this.parameters = {
            radius: radius,
            height: height,
            radialSegments: radialSegments,
            heightSegments: heightSegments,
            openEnded: openEnded,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
    }
}
class PolyhedronGeometry extends BufferGeometry {
    constructor(vertices, indices, radius = 1, detail = 0){
        super();
        this.type = 'PolyhedronGeometry';
        this.parameters = {
            vertices: vertices,
            indices: indices,
            radius: radius,
            detail: detail
        };
        // default buffer data
        const vertexBuffer = [];
        const uvBuffer = [];
        // the subdivision creates the vertex buffer data
        subdivide(detail);
        // all vertices should lie on a conceptual sphere with a given radius
        applyRadius(radius);
        // finally, create the uv data
        generateUVs();
        // build non-indexed geometry
        this.setAttribute('position', new Float32BufferAttribute(vertexBuffer, 3));
        this.setAttribute('normal', new Float32BufferAttribute(vertexBuffer.slice(), 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvBuffer, 2));
        if (detail === 0) this.computeVertexNormals(); // flat normals
        else this.normalizeNormals(); // smooth normals
        // helper functions
        function subdivide(detail) {
            const a = new Vector3();
            const b = new Vector3();
            const c = new Vector3();
            // iterate over all faces and apply a subdivison with the given detail value
            for(let i = 0; i < indices.length; i += 3){
                // get the vertices of the face
                getVertexByIndex(indices[i + 0], a);
                getVertexByIndex(indices[i + 1], b);
                getVertexByIndex(indices[i + 2], c);
                // perform subdivision
                subdivideFace(a, b, c, detail);
            }
        }
        function subdivideFace(a, b, c, detail) {
            const cols = detail + 1;
            // we use this multidimensional array as a data structure for creating the subdivision
            const v = [];
            // construct all of the vertices for this subdivision
            for(let i = 0; i <= cols; i++){
                v[i] = [];
                const aj = a.clone().lerp(c, i / cols);
                const bj = b.clone().lerp(c, i / cols);
                const rows = cols - i;
                for(let j = 0; j <= rows; j++)if (j === 0 && i === cols) v[i][j] = aj;
                else v[i][j] = aj.clone().lerp(bj, j / rows);
            }
            // construct all of the faces
            for(let i = 0; i < cols; i++)for(let j = 0; j < 2 * (cols - i) - 1; j++){
                const k = Math.floor(j / 2);
                if (j % 2 === 0) {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k]);
                    pushVertex(v[i][k]);
                } else {
                    pushVertex(v[i][k + 1]);
                    pushVertex(v[i + 1][k + 1]);
                    pushVertex(v[i + 1][k]);
                }
            }
        }
        function applyRadius(radius) {
            const vertex = new Vector3();
            // iterate over the entire buffer and apply the radius to each vertex
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                vertex.normalize().multiplyScalar(radius);
                vertexBuffer[i + 0] = vertex.x;
                vertexBuffer[i + 1] = vertex.y;
                vertexBuffer[i + 2] = vertex.z;
            }
        }
        function generateUVs() {
            const vertex = new Vector3();
            for(let i = 0; i < vertexBuffer.length; i += 3){
                vertex.x = vertexBuffer[i + 0];
                vertex.y = vertexBuffer[i + 1];
                vertex.z = vertexBuffer[i + 2];
                const u = azimuth(vertex) / 2 / Math.PI + 0.5;
                const v = inclination(vertex) / Math.PI + 0.5;
                uvBuffer.push(u, 1 - v);
            }
            correctUVs();
            correctSeam();
        }
        function correctSeam() {
            // handle case when face straddles the seam, see #3269
            for(let i = 0; i < uvBuffer.length; i += 6){
                // uv data of a single face
                const x0 = uvBuffer[i + 0];
                const x1 = uvBuffer[i + 2];
                const x2 = uvBuffer[i + 4];
                const max = Math.max(x0, x1, x2);
                const min = Math.min(x0, x1, x2);
                // 0.9 is somewhat arbitrary
                if (max > 0.9 && min < 0.1) {
                    if (x0 < 0.2) uvBuffer[i + 0] += 1;
                    if (x1 < 0.2) uvBuffer[i + 2] += 1;
                    if (x2 < 0.2) uvBuffer[i + 4] += 1;
                }
            }
        }
        function pushVertex(vertex) {
            vertexBuffer.push(vertex.x, vertex.y, vertex.z);
        }
        function getVertexByIndex(index, vertex) {
            const stride = index * 3;
            vertex.x = vertices[stride + 0];
            vertex.y = vertices[stride + 1];
            vertex.z = vertices[stride + 2];
        }
        function correctUVs() {
            const a = new Vector3();
            const b = new Vector3();
            const c = new Vector3();
            const centroid = new Vector3();
            const uvA = new Vector2();
            const uvB = new Vector2();
            const uvC = new Vector2();
            for(let i = 0, j = 0; i < vertexBuffer.length; i += 9, j += 6){
                a.set(vertexBuffer[i + 0], vertexBuffer[i + 1], vertexBuffer[i + 2]);
                b.set(vertexBuffer[i + 3], vertexBuffer[i + 4], vertexBuffer[i + 5]);
                c.set(vertexBuffer[i + 6], vertexBuffer[i + 7], vertexBuffer[i + 8]);
                uvA.set(uvBuffer[j + 0], uvBuffer[j + 1]);
                uvB.set(uvBuffer[j + 2], uvBuffer[j + 3]);
                uvC.set(uvBuffer[j + 4], uvBuffer[j + 5]);
                centroid.copy(a).add(b).add(c).divideScalar(3);
                const azi = azimuth(centroid);
                correctUV(uvA, j + 0, a, azi);
                correctUV(uvB, j + 2, b, azi);
                correctUV(uvC, j + 4, c, azi);
            }
        }
        function correctUV(uv, stride, vector, azimuth) {
            if (azimuth < 0 && uv.x === 1) uvBuffer[stride] = uv.x - 1;
            if (vector.x === 0 && vector.z === 0) uvBuffer[stride] = azimuth / 2 / Math.PI + 0.5;
        }
        // Angle around the Y axis, counter-clockwise when looking from above.
        function azimuth(vector) {
            return Math.atan2(vector.z, -vector.x);
        }
        // Angle above the XZ plane.
        function inclination(vector) {
            return Math.atan2(-vector.y, Math.sqrt(vector.x * vector.x + vector.z * vector.z));
        }
    }
}
class DodecahedronGeometry extends PolyhedronGeometry {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const r = 1 / t;
        const vertices = [
            // (±1, ±1, ±1)
            -1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            1,
            1,
            1,
            // (0, ±1/φ, ±φ)
            0,
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            // (±1/φ, ±φ, 0)
            -r,
            -t,
            0,
            -r,
            t,
            0,
            r,
            -t,
            0,
            r,
            t,
            0,
            // (±φ, 0, ±1/φ)
            -t,
            0,
            -r,
            t,
            0,
            -r,
            -t,
            0,
            r,
            t,
            0,
            r
        ];
        const indices = [
            3,
            11,
            7,
            3,
            7,
            15,
            3,
            15,
            13,
            7,
            19,
            17,
            7,
            17,
            6,
            7,
            6,
            15,
            17,
            4,
            8,
            17,
            8,
            10,
            17,
            10,
            6,
            8,
            0,
            16,
            8,
            16,
            2,
            8,
            2,
            10,
            0,
            12,
            1,
            0,
            1,
            18,
            0,
            18,
            16,
            6,
            10,
            2,
            6,
            2,
            13,
            6,
            13,
            15,
            2,
            16,
            18,
            2,
            18,
            3,
            2,
            3,
            13,
            18,
            1,
            9,
            18,
            9,
            11,
            18,
            11,
            3,
            4,
            14,
            12,
            4,
            12,
            0,
            4,
            0,
            8,
            11,
            9,
            5,
            11,
            5,
            19,
            11,
            19,
            7,
            19,
            5,
            14,
            19,
            14,
            4,
            19,
            4,
            17,
            1,
            12,
            14,
            1,
            14,
            5,
            1,
            5,
            9
        ];
        super(vertices, indices, radius, detail);
        this.type = 'DodecahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
const _v0$2 = new Vector3();
const _v1$5 = new Vector3();
const _normal$1 = new Vector3();
const _triangle = new Triangle();
class EdgesGeometry extends BufferGeometry {
    constructor(geometry, thresholdAngle){
        super();
        this.type = 'EdgesGeometry';
        this.parameters = {
            thresholdAngle: thresholdAngle
        };
        thresholdAngle = thresholdAngle !== undefined ? thresholdAngle : 1;
        if (geometry.isGeometry === true) {
            console.error('THREE.EdgesGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
            return;
        }
        const precisionPoints = 4;
        const precision = Math.pow(10, precisionPoints);
        const thresholdDot = Math.cos(MathUtils.DEG2RAD * thresholdAngle);
        const indexAttr = geometry.getIndex();
        const positionAttr = geometry.getAttribute('position');
        const indexCount = indexAttr ? indexAttr.count : positionAttr.count;
        const indexArr = [
            0,
            0,
            0
        ];
        const vertKeys = [
            'a',
            'b',
            'c'
        ];
        const hashes = new Array(3);
        const edgeData = {};
        const vertices = [];
        for(let i = 0; i < indexCount; i += 3){
            if (indexAttr) {
                indexArr[0] = indexAttr.getX(i);
                indexArr[1] = indexAttr.getX(i + 1);
                indexArr[2] = indexAttr.getX(i + 2);
            } else {
                indexArr[0] = i;
                indexArr[1] = i + 1;
                indexArr[2] = i + 2;
            }
            const { a, b, c } = _triangle;
            a.fromBufferAttribute(positionAttr, indexArr[0]);
            b.fromBufferAttribute(positionAttr, indexArr[1]);
            c.fromBufferAttribute(positionAttr, indexArr[2]);
            _triangle.getNormal(_normal$1);
            // create hashes for the edge from the vertices
            hashes[0] = `${Math.round(a.x * precision)},${Math.round(a.y * precision)},${Math.round(a.z * precision)}`;
            hashes[1] = `${Math.round(b.x * precision)},${Math.round(b.y * precision)},${Math.round(b.z * precision)}`;
            hashes[2] = `${Math.round(c.x * precision)},${Math.round(c.y * precision)},${Math.round(c.z * precision)}`;
            // skip degenerate triangles
            if (hashes[0] === hashes[1] || hashes[1] === hashes[2] || hashes[2] === hashes[0]) continue;
            // iterate over every edge
            for(let j = 0; j < 3; j++){
                // get the first and next vertex making up the edge
                const jNext = (j + 1) % 3;
                const vecHash0 = hashes[j];
                const vecHash1 = hashes[jNext];
                const v0 = _triangle[vertKeys[j]];
                const v1 = _triangle[vertKeys[jNext]];
                const hash = `${vecHash0}_${vecHash1}`;
                const reverseHash = `${vecHash1}_${vecHash0}`;
                if (reverseHash in edgeData && edgeData[reverseHash]) {
                    // if we found a sibling edge add it into the vertex array if
                    // it meets the angle threshold and delete the edge from the map.
                    if (_normal$1.dot(edgeData[reverseHash].normal) <= thresholdDot) {
                        vertices.push(v0.x, v0.y, v0.z);
                        vertices.push(v1.x, v1.y, v1.z);
                    }
                    edgeData[reverseHash] = null;
                } else if (!(hash in edgeData)) // if we've already got an edge here then skip adding a new one
                edgeData[hash] = {
                    index0: indexArr[j],
                    index1: indexArr[jNext],
                    normal: _normal$1.clone()
                };
            }
        }
        // iterate over all remaining, unmatched edges and add them to the vertex array
        for(const key in edgeData)if (edgeData[key]) {
            const { index0, index1 } = edgeData[key];
            _v0$2.fromBufferAttribute(positionAttr, index0);
            _v1$5.fromBufferAttribute(positionAttr, index1);
            vertices.push(_v0$2.x, _v0$2.y, _v0$2.z);
            vertices.push(_v1$5.x, _v1$5.y, _v1$5.z);
        }
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    }
}
/**
 * Port from https://github.com/mapbox/earcut (v2.2.2)
 */ const Earcut = {
    triangulate: function(data, holeIndices, dim) {
        dim = dim || 2;
        const hasHoles = holeIndices && holeIndices.length;
        const outerLen = hasHoles ? holeIndices[0] * dim : data.length;
        let outerNode = linkedList(data, 0, outerLen, dim, true);
        const triangles = [];
        if (!outerNode || outerNode.next === outerNode.prev) return triangles;
        let minX, minY, maxX, maxY, x, y, invSize;
        if (hasHoles) outerNode = eliminateHoles(data, holeIndices, outerNode, dim);
        // if the shape is not too simple, we'll use z-order curve hash later; calculate polygon bbox
        if (data.length > 80 * dim) {
            minX = maxX = data[0];
            minY = maxY = data[1];
            for(let i = dim; i < outerLen; i += dim){
                x = data[i];
                y = data[i + 1];
                if (x < minX) minX = x;
                if (y < minY) minY = y;
                if (x > maxX) maxX = x;
                if (y > maxY) maxY = y;
            }
            // minX, minY and invSize are later used to transform coords into integers for z-order calculation
            invSize = Math.max(maxX - minX, maxY - minY);
            invSize = invSize !== 0 ? 1 / invSize : 0;
        }
        earcutLinked(outerNode, triangles, dim, minX, minY, invSize);
        return triangles;
    }
};
// create a circular doubly linked list from polygon points in the specified winding order
function linkedList(data, start, end, dim, clockwise) {
    let i, last;
    if (clockwise === signedArea(data, start, end, dim) > 0) for(i = start; i < end; i += dim)last = insertNode(i, data[i], data[i + 1], last);
    else for(i = end - dim; i >= start; i -= dim)last = insertNode(i, data[i], data[i + 1], last);
    if (last && equals(last, last.next)) {
        removeNode(last);
        last = last.next;
    }
    return last;
}
// eliminate colinear or duplicate points
function filterPoints(start, end) {
    if (!start) return start;
    if (!end) end = start;
    let p = start, again;
    do {
        again = false;
        if (!p.steiner && (equals(p, p.next) || area(p.prev, p, p.next) === 0)) {
            removeNode(p);
            p = end = p.prev;
            if (p === p.next) break;
            again = true;
        } else p = p.next;
    }while (again || p !== end);
    return end;
}
// main ear slicing loop which triangulates a polygon (given as a linked list)
function earcutLinked(ear, triangles, dim, minX, minY, invSize, pass) {
    if (!ear) return;
    // interlink polygon nodes in z-order
    if (!pass && invSize) indexCurve(ear, minX, minY, invSize);
    let stop = ear, prev, next;
    // iterate through ears, slicing them one by one
    while(ear.prev !== ear.next){
        prev = ear.prev;
        next = ear.next;
        if (invSize ? isEarHashed(ear, minX, minY, invSize) : isEar(ear)) {
            // cut off the triangle
            triangles.push(prev.i / dim);
            triangles.push(ear.i / dim);
            triangles.push(next.i / dim);
            removeNode(ear);
            // skipping the next vertex leads to less sliver triangles
            ear = next.next;
            stop = next.next;
            continue;
        }
        ear = next;
        // if we looped through the whole remaining polygon and can't find any more ears
        if (ear === stop) {
            // try filtering points and slicing again
            if (!pass) earcutLinked(filterPoints(ear), triangles, dim, minX, minY, invSize, 1);
            else if (pass === 1) {
                ear = cureLocalIntersections(filterPoints(ear), triangles, dim);
                earcutLinked(ear, triangles, dim, minX, minY, invSize, 2);
            // as a last resort, try splitting the remaining polygon into two
            } else if (pass === 2) splitEarcut(ear, triangles, dim, minX, minY, invSize);
            break;
        }
    }
}
// check whether a polygon node forms a valid ear with adjacent nodes
function isEar(ear) {
    const a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // now make sure we don't have other points inside the potential ear
    let p = ear.next.next;
    while(p !== ear.prev){
        if (pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.next;
    }
    return true;
}
function isEarHashed(ear, minX, minY, invSize) {
    const a = ear.prev, b = ear, c = ear.next;
    if (area(a, b, c) >= 0) return false; // reflex, can't be an ear
    // triangle bbox; min & max are calculated like this for speed
    const minTX = a.x < b.x ? a.x < c.x ? a.x : c.x : b.x < c.x ? b.x : c.x, minTY = a.y < b.y ? a.y < c.y ? a.y : c.y : b.y < c.y ? b.y : c.y, maxTX = a.x > b.x ? a.x > c.x ? a.x : c.x : b.x > c.x ? b.x : c.x, maxTY = a.y > b.y ? a.y > c.y ? a.y : c.y : b.y > c.y ? b.y : c.y;
    // z-order range for the current triangle bbox;
    const minZ = zOrder(minTX, minTY, minX, minY, invSize), maxZ = zOrder(maxTX, maxTY, minX, minY, invSize);
    let p = ear.prevZ, n = ear.nextZ;
    // look for points inside the triangle in both directions
    while(p && p.z >= minZ && n && n.z <= maxZ){
        if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
        if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    // look for remaining points in decreasing z-order
    while(p && p.z >= minZ){
        if (p !== ear.prev && p !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, p.x, p.y) && area(p.prev, p, p.next) >= 0) return false;
        p = p.prevZ;
    }
    // look for remaining points in increasing z-order
    while(n && n.z <= maxZ){
        if (n !== ear.prev && n !== ear.next && pointInTriangle(a.x, a.y, b.x, b.y, c.x, c.y, n.x, n.y) && area(n.prev, n, n.next) >= 0) return false;
        n = n.nextZ;
    }
    return true;
}
// go through all polygon nodes and cure small local self-intersections
function cureLocalIntersections(start, triangles, dim) {
    let p = start;
    do {
        const a = p.prev, b = p.next.next;
        if (!equals(a, b) && intersects(a, p, p.next, b) && locallyInside(a, b) && locallyInside(b, a)) {
            triangles.push(a.i / dim);
            triangles.push(p.i / dim);
            triangles.push(b.i / dim);
            // remove two nodes involved
            removeNode(p);
            removeNode(p.next);
            p = start = b;
        }
        p = p.next;
    }while (p !== start);
    return filterPoints(p);
}
// try splitting polygon into two and triangulate them independently
function splitEarcut(start, triangles, dim, minX, minY, invSize) {
    // look for a valid diagonal that divides the polygon into two
    let a = start;
    do {
        let b = a.next.next;
        while(b !== a.prev){
            if (a.i !== b.i && isValidDiagonal(a, b)) {
                // split the polygon in two by the diagonal
                let c = splitPolygon(a, b);
                // filter colinear points around the cuts
                a = filterPoints(a, a.next);
                c = filterPoints(c, c.next);
                // run earcut on each half
                earcutLinked(a, triangles, dim, minX, minY, invSize);
                earcutLinked(c, triangles, dim, minX, minY, invSize);
                return;
            }
            b = b.next;
        }
        a = a.next;
    }while (a !== start);
}
// link every hole into the outer loop, producing a single-ring polygon without holes
function eliminateHoles(data, holeIndices, outerNode, dim) {
    const queue = [];
    let i, len, start, end, list;
    for(i = 0, len = holeIndices.length; i < len; i++){
        start = holeIndices[i] * dim;
        end = i < len - 1 ? holeIndices[i + 1] * dim : data.length;
        list = linkedList(data, start, end, dim, false);
        if (list === list.next) list.steiner = true;
        queue.push(getLeftmost(list));
    }
    queue.sort(compareX);
    // process holes from left to right
    for(i = 0; i < queue.length; i++){
        eliminateHole(queue[i], outerNode);
        outerNode = filterPoints(outerNode, outerNode.next);
    }
    return outerNode;
}
function compareX(a, b) {
    return a.x - b.x;
}
// find a bridge between vertices that connects hole with an outer ring and and link it
function eliminateHole(hole, outerNode) {
    outerNode = findHoleBridge(hole, outerNode);
    if (outerNode) {
        const b = splitPolygon(outerNode, hole);
        // filter collinear points around the cuts
        filterPoints(outerNode, outerNode.next);
        filterPoints(b, b.next);
    }
}
// David Eberly's algorithm for finding a bridge between hole and outer polygon
function findHoleBridge(hole, outerNode) {
    let p = outerNode;
    const hx = hole.x;
    const hy = hole.y;
    let qx = -Infinity, m;
    // find a segment intersected by a ray from the hole's leftmost point to the left;
    // segment's endpoint with lesser x will be potential connection point
    do {
        if (hy <= p.y && hy >= p.next.y && p.next.y !== p.y) {
            const x = p.x + (hy - p.y) * (p.next.x - p.x) / (p.next.y - p.y);
            if (x <= hx && x > qx) {
                qx = x;
                if (x === hx) {
                    if (hy === p.y) return p;
                    if (hy === p.next.y) return p.next;
                }
                m = p.x < p.next.x ? p : p.next;
            }
        }
        p = p.next;
    }while (p !== outerNode);
    if (!m) return null;
    if (hx === qx) return m; // hole touches outer segment; pick leftmost endpoint
    // look for points inside the triangle of hole point, segment intersection and endpoint;
    // if there are no points found, we have a valid connection;
    // otherwise choose the point of the minimum angle with the ray as connection point
    const stop = m, mx = m.x, my = m.y;
    let tanMin = Infinity, tan;
    p = m;
    do {
        if (hx >= p.x && p.x >= mx && hx !== p.x && pointInTriangle(hy < my ? hx : qx, hy, mx, my, hy < my ? qx : hx, hy, p.x, p.y)) {
            tan = Math.abs(hy - p.y) / (hx - p.x); // tangential
            if (locallyInside(p, hole) && (tan < tanMin || tan === tanMin && (p.x > m.x || p.x === m.x && sectorContainsSector(m, p)))) {
                m = p;
                tanMin = tan;
            }
        }
        p = p.next;
    }while (p !== stop);
    return m;
}
// whether sector in vertex m contains sector in vertex p in the same coordinates
function sectorContainsSector(m, p) {
    return area(m.prev, m, p.prev) < 0 && area(p.next, m, m.next) < 0;
}
// interlink polygon nodes in z-order
function indexCurve(start, minX, minY, invSize) {
    let p = start;
    do {
        if (p.z === null) p.z = zOrder(p.x, p.y, minX, minY, invSize);
        p.prevZ = p.prev;
        p.nextZ = p.next;
        p = p.next;
    }while (p !== start);
    p.prevZ.nextZ = null;
    p.prevZ = null;
    sortLinked(p);
}
// Simon Tatham's linked list merge sort algorithm
// http://www.chiark.greenend.org.uk/~sgtatham/algorithms/listsort.html
function sortLinked(list) {
    let i, p, q, e, tail, numMerges, pSize, qSize, inSize = 1;
    do {
        p = list;
        list = null;
        tail = null;
        numMerges = 0;
        while(p){
            numMerges++;
            q = p;
            pSize = 0;
            for(i = 0; i < inSize; i++){
                pSize++;
                q = q.nextZ;
                if (!q) break;
            }
            qSize = inSize;
            while(pSize > 0 || qSize > 0 && q){
                if (pSize !== 0 && (qSize === 0 || !q || p.z <= q.z)) {
                    e = p;
                    p = p.nextZ;
                    pSize--;
                } else {
                    e = q;
                    q = q.nextZ;
                    qSize--;
                }
                if (tail) tail.nextZ = e;
                else list = e;
                e.prevZ = tail;
                tail = e;
            }
            p = q;
        }
        tail.nextZ = null;
        inSize *= 2;
    }while (numMerges > 1);
    return list;
}
// z-order of a point given coords and inverse of the longer side of data bbox
function zOrder(x, y, minX, minY, invSize) {
    // coords are transformed into non-negative 15-bit integer range
    x = 32767 * (x - minX) * invSize;
    y = 32767 * (y - minY) * invSize;
    x = (x | x << 8) & 0x00FF00FF;
    x = (x | x << 4) & 0x0F0F0F0F;
    x = (x | x << 2) & 0x33333333;
    x = (x | x << 1) & 0x55555555;
    y = (y | y << 8) & 0x00FF00FF;
    y = (y | y << 4) & 0x0F0F0F0F;
    y = (y | y << 2) & 0x33333333;
    y = (y | y << 1) & 0x55555555;
    return x | y << 1;
}
// find the leftmost node of a polygon ring
function getLeftmost(start) {
    let p = start, leftmost = start;
    do {
        if (p.x < leftmost.x || p.x === leftmost.x && p.y < leftmost.y) leftmost = p;
        p = p.next;
    }while (p !== start);
    return leftmost;
}
// check if a point lies within a convex triangle
function pointInTriangle(ax, ay, bx, by, cx, cy, px, py) {
    return (cx - px) * (ay - py) - (ax - px) * (cy - py) >= 0 && (ax - px) * (by - py) - (bx - px) * (ay - py) >= 0 && (bx - px) * (cy - py) - (cx - px) * (by - py) >= 0;
}
// check if a diagonal between two polygon nodes is valid (lies in polygon interior)
function isValidDiagonal(a, b) {
    return a.next.i !== b.i && a.prev.i !== b.i && !intersectsPolygon(a, b) && // dones't intersect other edges
    (locallyInside(a, b) && locallyInside(b, a) && middleInside(a, b) && // locally visible
    (area(a.prev, a, b.prev) || area(a, b.prev, b)) || // does not create opposite-facing sectors
    equals(a, b) && area(a.prev, a, a.next) > 0 && area(b.prev, b, b.next) > 0); // special zero-length case
}
// signed area of a triangle
function area(p, q, r) {
    return (q.y - p.y) * (r.x - q.x) - (q.x - p.x) * (r.y - q.y);
}
// check if two points are equal
function equals(p1, p2) {
    return p1.x === p2.x && p1.y === p2.y;
}
// check if two segments intersect
function intersects(p1, q1, p2, q2) {
    const o1 = sign(area(p1, q1, p2));
    const o2 = sign(area(p1, q1, q2));
    const o3 = sign(area(p2, q2, p1));
    const o4 = sign(area(p2, q2, q1));
    if (o1 !== o2 && o3 !== o4) return true; // general case
    if (o1 === 0 && onSegment(p1, p2, q1)) return true; // p1, q1 and p2 are collinear and p2 lies on p1q1
    if (o2 === 0 && onSegment(p1, q2, q1)) return true; // p1, q1 and q2 are collinear and q2 lies on p1q1
    if (o3 === 0 && onSegment(p2, p1, q2)) return true; // p2, q2 and p1 are collinear and p1 lies on p2q2
    if (o4 === 0 && onSegment(p2, q1, q2)) return true; // p2, q2 and q1 are collinear and q1 lies on p2q2
    return false;
}
// for collinear points p, q, r, check if point q lies on segment pr
function onSegment(p, q, r) {
    return q.x <= Math.max(p.x, r.x) && q.x >= Math.min(p.x, r.x) && q.y <= Math.max(p.y, r.y) && q.y >= Math.min(p.y, r.y);
}
function sign(num) {
    return num > 0 ? 1 : num < 0 ? -1 : 0;
}
// check if a polygon diagonal intersects any polygon segments
function intersectsPolygon(a, b) {
    let p = a;
    do {
        if (p.i !== a.i && p.next.i !== a.i && p.i !== b.i && p.next.i !== b.i && intersects(p, p.next, a, b)) return true;
        p = p.next;
    }while (p !== a);
    return false;
}
// check if a polygon diagonal is locally inside the polygon
function locallyInside(a, b) {
    return area(a.prev, a, a.next) < 0 ? area(a, b, a.next) >= 0 && area(a, a.prev, b) >= 0 : area(a, b, a.prev) < 0 || area(a, a.next, b) < 0;
}
// check if the middle point of a polygon diagonal is inside the polygon
function middleInside(a, b) {
    let p = a, inside = false;
    const px = (a.x + b.x) / 2, py = (a.y + b.y) / 2;
    do {
        if (p.y > py !== p.next.y > py && p.next.y !== p.y && px < (p.next.x - p.x) * (py - p.y) / (p.next.y - p.y) + p.x) inside = !inside;
        p = p.next;
    }while (p !== a);
    return inside;
}
// link two polygon vertices with a bridge; if the vertices belong to the same ring, it splits polygon into two;
// if one belongs to the outer ring and another to a hole, it merges it into a single ring
function splitPolygon(a, b) {
    const a2 = new Node(a.i, a.x, a.y), b2 = new Node(b.i, b.x, b.y), an = a.next, bp = b.prev;
    a.next = b;
    b.prev = a;
    a2.next = an;
    an.prev = a2;
    b2.next = a2;
    a2.prev = b2;
    bp.next = b2;
    b2.prev = bp;
    return b2;
}
// create a node and optionally link it with previous one (in a circular doubly linked list)
function insertNode(i, x, y, last) {
    const p = new Node(i, x, y);
    if (!last) {
        p.prev = p;
        p.next = p;
    } else {
        p.next = last.next;
        p.prev = last;
        last.next.prev = p;
        last.next = p;
    }
    return p;
}
function removeNode(p) {
    p.next.prev = p.prev;
    p.prev.next = p.next;
    if (p.prevZ) p.prevZ.nextZ = p.nextZ;
    if (p.nextZ) p.nextZ.prevZ = p.prevZ;
}
function Node(i, x, y) {
    // vertex index in coordinates array
    this.i = i;
    // vertex coordinates
    this.x = x;
    this.y = y;
    // previous and next vertex nodes in a polygon ring
    this.prev = null;
    this.next = null;
    // z-order curve value
    this.z = null;
    // previous and next nodes in z-order
    this.prevZ = null;
    this.nextZ = null;
    // indicates whether this is a steiner point
    this.steiner = false;
}
function signedArea(data, start, end, dim) {
    let sum = 0;
    for(let i = start, j = end - dim; i < end; i += dim){
        sum += (data[j] - data[i]) * (data[i + 1] + data[j + 1]);
        j = i;
    }
    return sum;
}
const ShapeUtils = {
    // calculate area of the contour polygon
    area: function(contour) {
        const n = contour.length;
        let a = 0.0;
        for(let p = n - 1, q = 0; q < n; p = q++)a += contour[p].x * contour[q].y - contour[q].x * contour[p].y;
        return a * 0.5;
    },
    isClockWise: function(pts) {
        return ShapeUtils.area(pts) < 0;
    },
    triangulateShape: function(contour, holes) {
        const vertices = []; // flat array of vertices like [ x0,y0, x1,y1, x2,y2, ... ]
        const holeIndices = []; // array of hole indices
        const faces = []; // final array of vertex indices like [ [ a,b,d ], [ b,c,d ] ]
        removeDupEndPts(contour);
        addContour(vertices, contour);
        //
        let holeIndex = contour.length;
        holes.forEach(removeDupEndPts);
        for(let i = 0; i < holes.length; i++){
            holeIndices.push(holeIndex);
            holeIndex += holes[i].length;
            addContour(vertices, holes[i]);
        }
        //
        const triangles = Earcut.triangulate(vertices, holeIndices);
        //
        for(let i = 0; i < triangles.length; i += 3)faces.push(triangles.slice(i, i + 3));
        return faces;
    }
};
function removeDupEndPts(points) {
    const l = points.length;
    if (l > 2 && points[l - 1].equals(points[0])) points.pop();
}
function addContour(vertices, contour) {
    for(let i = 0; i < contour.length; i++){
        vertices.push(contour[i].x);
        vertices.push(contour[i].y);
    }
}
/**
 * Creates extruded geometry from a path shape.
 *
 * parameters = {
 *
 *  curveSegments: <int>, // number of points on the curves
 *  steps: <int>, // number of points for z-side extrusions / used for subdividing segments of extrude spline too
 *  depth: <float>, // Depth to extrude the shape
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into the original shape bevel goes
 *  bevelSize: <float>, // how far from shape outline (including bevelOffset) is bevel
 *  bevelOffset: <float>, // how far from shape outline does bevel start
 *  bevelSegments: <int>, // number of bevel layers
 *
 *  extrudePath: <THREE.Curve> // curve to extrude shape along
 *
 *  UVGenerator: <Object> // object that provides UV generator functions
 *
 * }
 */ class ExtrudeGeometry extends BufferGeometry {
    constructor(shapes, options){
        super();
        this.type = 'ExtrudeGeometry';
        this.parameters = {
            shapes: shapes,
            options: options
        };
        shapes = Array.isArray(shapes) ? shapes : [
            shapes
        ];
        const scope = this;
        const verticesArray = [];
        const uvArray = [];
        for(let i = 0, l = shapes.length; i < l; i++){
            const shape = shapes[i];
            addShape(shape);
        }
        // build geometry
        this.setAttribute('position', new Float32BufferAttribute(verticesArray, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvArray, 2));
        this.computeVertexNormals();
        // functions
        function addShape(shape) {
            const placeholder = [];
            // options
            const curveSegments = options.curveSegments !== undefined ? options.curveSegments : 12;
            const steps = options.steps !== undefined ? options.steps : 1;
            let depth = options.depth !== undefined ? options.depth : 100;
            let bevelEnabled = options.bevelEnabled !== undefined ? options.bevelEnabled : true;
            let bevelThickness = options.bevelThickness !== undefined ? options.bevelThickness : 6;
            let bevelSize = options.bevelSize !== undefined ? options.bevelSize : bevelThickness - 2;
            let bevelOffset = options.bevelOffset !== undefined ? options.bevelOffset : 0;
            let bevelSegments = options.bevelSegments !== undefined ? options.bevelSegments : 3;
            const extrudePath = options.extrudePath;
            const uvgen = options.UVGenerator !== undefined ? options.UVGenerator : WorldUVGenerator;
            // deprecated options
            if (options.amount !== undefined) {
                console.warn('THREE.ExtrudeBufferGeometry: amount has been renamed to depth.');
                depth = options.amount;
            }
            //
            let extrudePts, extrudeByPath = false;
            let splineTube, binormal, normal, position2;
            if (extrudePath) {
                extrudePts = extrudePath.getSpacedPoints(steps);
                extrudeByPath = true;
                bevelEnabled = false; // bevels not supported for path extrusion
                // SETUP TNB variables
                // TODO1 - have a .isClosed in spline?
                splineTube = extrudePath.computeFrenetFrames(steps, false);
                // console.log(splineTube, 'splineTube', splineTube.normals.length, 'steps', steps, 'extrudePts', extrudePts.length);
                binormal = new Vector3();
                normal = new Vector3();
                position2 = new Vector3();
            }
            // Safeguards if bevels are not enabled
            if (!bevelEnabled) {
                bevelSegments = 0;
                bevelThickness = 0;
                bevelSize = 0;
                bevelOffset = 0;
            }
            // Variables initialization
            const shapePoints = shape.extractPoints(curveSegments);
            let vertices = shapePoints.shape;
            const holes = shapePoints.holes;
            const reverse = !ShapeUtils.isClockWise(vertices);
            if (reverse) {
                vertices = vertices.reverse();
                // Maybe we should also check if holes are in the opposite direction, just to be safe ...
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    if (ShapeUtils.isClockWise(ahole)) holes[h] = ahole.reverse();
                }
            }
            const faces = ShapeUtils.triangulateShape(vertices, holes);
            /* Vertices */ const contour = vertices; // vertices has all points but contour has only points of circumference
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                vertices = vertices.concat(ahole);
            }
            function scalePt2(pt, vec, size) {
                if (!vec) console.error('THREE.ExtrudeGeometry: vec does not exist');
                return vec.clone().multiplyScalar(size).add(pt);
            }
            const vlen = vertices.length, flen = faces.length;
            // Find directions for point movement
            function getBevelVec(inPt, inPrev, inNext) {
                // computes for inPt the corresponding point inPt' on a new contour
                //   shifted by 1 unit (length of normalized vector) to the left
                // if we walk along contour clockwise, this new contour is outside the old one
                //
                // inPt' is the intersection of the two lines parallel to the two
                //  adjacent edges of inPt at a distance of 1 unit on the left side.
                let v_trans_x, v_trans_y, shrink_by; // resulting translation vector for inPt
                // good reading for geometry algorithms (here: line-line intersection)
                // http://geomalgorithms.com/a05-_intersect-1.html
                const v_prev_x = inPt.x - inPrev.x, v_prev_y = inPt.y - inPrev.y;
                const v_next_x = inNext.x - inPt.x, v_next_y = inNext.y - inPt.y;
                const v_prev_lensq = v_prev_x * v_prev_x + v_prev_y * v_prev_y;
                // check for collinear edges
                const collinear0 = v_prev_x * v_next_y - v_prev_y * v_next_x;
                if (Math.abs(collinear0) > Number.EPSILON) {
                    // not collinear
                    // length of vectors for normalizing
                    const v_prev_len = Math.sqrt(v_prev_lensq);
                    const v_next_len = Math.sqrt(v_next_x * v_next_x + v_next_y * v_next_y);
                    // shift adjacent points by unit vectors to the left
                    const ptPrevShift_x = inPrev.x - v_prev_y / v_prev_len;
                    const ptPrevShift_y = inPrev.y + v_prev_x / v_prev_len;
                    const ptNextShift_x = inNext.x - v_next_y / v_next_len;
                    const ptNextShift_y = inNext.y + v_next_x / v_next_len;
                    // scaling factor for v_prev to intersection point
                    const sf = ((ptNextShift_x - ptPrevShift_x) * v_next_y - (ptNextShift_y - ptPrevShift_y) * v_next_x) / (v_prev_x * v_next_y - v_prev_y * v_next_x);
                    // vector from inPt to intersection point
                    v_trans_x = ptPrevShift_x + v_prev_x * sf - inPt.x;
                    v_trans_y = ptPrevShift_y + v_prev_y * sf - inPt.y;
                    // Don't normalize!, otherwise sharp corners become ugly
                    //  but prevent crazy spikes
                    const v_trans_lensq = v_trans_x * v_trans_x + v_trans_y * v_trans_y;
                    if (v_trans_lensq <= 2) return new Vector2(v_trans_x, v_trans_y);
                    else shrink_by = Math.sqrt(v_trans_lensq / 2);
                } else {
                    // handle special case of collinear edges
                    let direction_eq = false; // assumes: opposite
                    if (v_prev_x > Number.EPSILON) {
                        if (v_next_x > Number.EPSILON) direction_eq = true;
                    } else {
                        if (v_prev_x < -Number.EPSILON) {
                            if (v_next_x < -Number.EPSILON) direction_eq = true;
                        } else if (Math.sign(v_prev_y) === Math.sign(v_next_y)) direction_eq = true;
                    }
                    if (direction_eq) {
                        // console.log("Warning: lines are a straight sequence");
                        v_trans_x = -v_prev_y;
                        v_trans_y = v_prev_x;
                        shrink_by = Math.sqrt(v_prev_lensq);
                    } else {
                        // console.log("Warning: lines are a straight spike");
                        v_trans_x = v_prev_x;
                        v_trans_y = v_prev_y;
                        shrink_by = Math.sqrt(v_prev_lensq / 2);
                    }
                }
                return new Vector2(v_trans_x / shrink_by, v_trans_y / shrink_by);
            }
            const contourMovements = [];
            for(let i = 0, il = contour.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                if (j === il) j = 0;
                if (k === il) k = 0;
                //  (j)---(i)---(k)
                // console.log('i,j,k', i, j , k)
                contourMovements[i] = getBevelVec(contour[i], contour[j], contour[k]);
            }
            const holesMovements = [];
            let oneHoleMovements, verticesMovements = contourMovements.concat();
            for(let h = 0, hl = holes.length; h < hl; h++){
                const ahole = holes[h];
                oneHoleMovements = [];
                for(let i = 0, il = ahole.length, j = il - 1, k = i + 1; i < il; i++, j++, k++){
                    if (j === il) j = 0;
                    if (k === il) k = 0;
                    //  (j)---(i)---(k)
                    oneHoleMovements[i] = getBevelVec(ahole[i], ahole[j], ahole[k]);
                }
                holesMovements.push(oneHoleMovements);
                verticesMovements = verticesMovements.concat(oneHoleMovements);
            }
            // Loop bevelSegments, 1 for the front, 1 for the back
            for(let b = 0; b < bevelSegments; b++){
                //for ( b = bevelSegments; b > 0; b -- ) {
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, -z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        v(vert.x, vert.y, -z);
                    }
                }
            }
            const bs = bevelSize + bevelOffset;
            // Back facing vertices
            for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, 0);
                else {
                    // v( vert.x, vert.y + extrudePts[ 0 ].y, extrudePts[ 0 ].x );
                    normal.copy(splineTube.normals[0]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[0]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[0]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add stepped vertices...
            // Including front facing vertices
            for(let s = 1; s <= steps; s++)for(let i = 0; i < vlen; i++){
                const vert = bevelEnabled ? scalePt2(vertices[i], verticesMovements[i], bs) : vertices[i];
                if (!extrudeByPath) v(vert.x, vert.y, depth / steps * s);
                else {
                    // v( vert.x, vert.y + extrudePts[ s - 1 ].y, extrudePts[ s - 1 ].x );
                    normal.copy(splineTube.normals[s]).multiplyScalar(vert.x);
                    binormal.copy(splineTube.binormals[s]).multiplyScalar(vert.y);
                    position2.copy(extrudePts[s]).add(normal).add(binormal);
                    v(position2.x, position2.y, position2.z);
                }
            }
            // Add bevel segments planes
            //for ( b = 1; b <= bevelSegments; b ++ ) {
            for(let b = bevelSegments - 1; b >= 0; b--){
                const t = b / bevelSegments;
                const z = bevelThickness * Math.cos(t * Math.PI / 2);
                const bs = bevelSize * Math.sin(t * Math.PI / 2) + bevelOffset;
                // contract shape
                for(let i = 0, il = contour.length; i < il; i++){
                    const vert = scalePt2(contour[i], contourMovements[i], bs);
                    v(vert.x, vert.y, depth + z);
                }
                // expand holes
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    oneHoleMovements = holesMovements[h];
                    for(let i = 0, il = ahole.length; i < il; i++){
                        const vert = scalePt2(ahole[i], oneHoleMovements[i], bs);
                        if (!extrudeByPath) v(vert.x, vert.y, depth + z);
                        else v(vert.x, vert.y + extrudePts[steps - 1].y, extrudePts[steps - 1].x + z);
                    }
                }
            }
            /* Faces */ // Top and bottom faces
            buildLidFaces();
            // Sides faces
            buildSideFaces();
            /////  Internal functions
            function buildLidFaces() {
                const start = verticesArray.length / 3;
                if (bevelEnabled) {
                    let layer = 0; // steps + 1
                    let offset = vlen * layer;
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2] + offset, face[1] + offset, face[0] + offset);
                    }
                    layer = steps + bevelSegments * 2;
                    offset = vlen * layer;
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + offset, face[1] + offset, face[2] + offset);
                    }
                } else {
                    // Bottom faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[2], face[1], face[0]);
                    }
                    // Top faces
                    for(let i = 0; i < flen; i++){
                        const face = faces[i];
                        f3(face[0] + vlen * steps, face[1] + vlen * steps, face[2] + vlen * steps);
                    }
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 0);
            }
            // Create faces for the z-sides of the shape
            function buildSideFaces() {
                const start = verticesArray.length / 3;
                let layeroffset = 0;
                sidewalls(contour, layeroffset);
                layeroffset += contour.length;
                for(let h = 0, hl = holes.length; h < hl; h++){
                    const ahole = holes[h];
                    sidewalls(ahole, layeroffset);
                    //, true
                    layeroffset += ahole.length;
                }
                scope.addGroup(start, verticesArray.length / 3 - start, 1);
            }
            function sidewalls(contour, layeroffset) {
                let i = contour.length;
                while(--i >= 0){
                    const j = i;
                    let k = i - 1;
                    if (k < 0) k = contour.length - 1;
                    //console.log('b', i,j, i-1, k,vertices.length);
                    for(let s = 0, sl = steps + bevelSegments * 2; s < sl; s++){
                        const slen1 = vlen * s;
                        const slen2 = vlen * (s + 1);
                        const a = layeroffset + j + slen1, b = layeroffset + k + slen1, c = layeroffset + k + slen2, d = layeroffset + j + slen2;
                        f4(a, b, c, d);
                    }
                }
            }
            function v(x, y, z) {
                placeholder.push(x);
                placeholder.push(y);
                placeholder.push(z);
            }
            function f3(a, b, c) {
                addVertex(a);
                addVertex(b);
                addVertex(c);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateTopUV(scope, verticesArray, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[2]);
            }
            function f4(a, b, c, d) {
                addVertex(a);
                addVertex(b);
                addVertex(d);
                addVertex(b);
                addVertex(c);
                addVertex(d);
                const nextIndex = verticesArray.length / 3;
                const uvs = uvgen.generateSideWallUV(scope, verticesArray, nextIndex - 6, nextIndex - 3, nextIndex - 2, nextIndex - 1);
                addUV(uvs[0]);
                addUV(uvs[1]);
                addUV(uvs[3]);
                addUV(uvs[1]);
                addUV(uvs[2]);
                addUV(uvs[3]);
            }
            function addVertex(index) {
                verticesArray.push(placeholder[index * 3 + 0]);
                verticesArray.push(placeholder[index * 3 + 1]);
                verticesArray.push(placeholder[index * 3 + 2]);
            }
            function addUV(vector2) {
                uvArray.push(vector2.x);
                uvArray.push(vector2.y);
            }
        }
    }
    toJSON() {
        const data = BufferGeometry.prototype.toJSON.call(this);
        const shapes = this.parameters.shapes;
        const options = this.parameters.options;
        return toJSON(shapes, options, data);
    }
}
const WorldUVGenerator = {
    generateTopUV: function(geometry, vertices, indexA, indexB, indexC) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        return [
            new Vector2(a_x, a_y),
            new Vector2(b_x, b_y),
            new Vector2(c_x, c_y)
        ];
    },
    generateSideWallUV: function(geometry, vertices, indexA, indexB, indexC, indexD) {
        const a_x = vertices[indexA * 3];
        const a_y = vertices[indexA * 3 + 1];
        const a_z = vertices[indexA * 3 + 2];
        const b_x = vertices[indexB * 3];
        const b_y = vertices[indexB * 3 + 1];
        const b_z = vertices[indexB * 3 + 2];
        const c_x = vertices[indexC * 3];
        const c_y = vertices[indexC * 3 + 1];
        const c_z = vertices[indexC * 3 + 2];
        const d_x = vertices[indexD * 3];
        const d_y = vertices[indexD * 3 + 1];
        const d_z = vertices[indexD * 3 + 2];
        if (Math.abs(a_y - b_y) < 0.01) return [
            new Vector2(a_x, 1 - a_z),
            new Vector2(b_x, 1 - b_z),
            new Vector2(c_x, 1 - c_z),
            new Vector2(d_x, 1 - d_z)
        ];
        else return [
            new Vector2(a_y, 1 - a_z),
            new Vector2(b_y, 1 - b_z),
            new Vector2(c_y, 1 - c_z),
            new Vector2(d_y, 1 - d_z)
        ];
    }
};
function toJSON(shapes, options, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    if (options.extrudePath !== undefined) data.options.extrudePath = options.extrudePath.toJSON();
    return data;
}
class IcosahedronGeometry extends PolyhedronGeometry {
    constructor(radius = 1, detail = 0){
        const t = (1 + Math.sqrt(5)) / 2;
        const vertices = [
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            0,
            0,
            -1,
            t,
            0,
            1,
            t,
            0,
            -1,
            -t,
            0,
            1,
            -t,
            t,
            0,
            -1,
            t,
            0,
            1,
            -t,
            0,
            -1,
            -t,
            0,
            1
        ];
        const indices = [
            0,
            11,
            5,
            0,
            5,
            1,
            0,
            1,
            7,
            0,
            7,
            10,
            0,
            10,
            11,
            1,
            5,
            9,
            5,
            11,
            4,
            11,
            10,
            2,
            10,
            7,
            6,
            7,
            1,
            8,
            3,
            9,
            4,
            3,
            4,
            2,
            3,
            2,
            6,
            3,
            6,
            8,
            3,
            8,
            9,
            4,
            9,
            5,
            2,
            4,
            11,
            6,
            2,
            10,
            8,
            6,
            7,
            9,
            8,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'IcosahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
class LatheGeometry extends BufferGeometry {
    constructor(points, segments = 12, phiStart = 0, phiLength = Math.PI * 2){
        super();
        this.type = 'LatheGeometry';
        this.parameters = {
            points: points,
            segments: segments,
            phiStart: phiStart,
            phiLength: phiLength
        };
        segments = Math.floor(segments);
        // clamp phiLength so it's in range of [ 0, 2PI ]
        phiLength = MathUtils.clamp(phiLength, 0, Math.PI * 2);
        // buffers
        const indices = [];
        const vertices = [];
        const uvs = [];
        // helper variables
        const inverseSegments = 1.0 / segments;
        const vertex = new Vector3();
        const uv = new Vector2();
        // generate vertices and uvs
        for(let i = 0; i <= segments; i++){
            const phi = phiStart + i * inverseSegments * phiLength;
            const sin = Math.sin(phi);
            const cos = Math.cos(phi);
            for(let j = 0; j <= points.length - 1; j++){
                // vertex
                vertex.x = points[j].x * sin;
                vertex.y = points[j].y;
                vertex.z = points[j].x * cos;
                vertices.push(vertex.x, vertex.y, vertex.z);
                // uv
                uv.x = i / segments;
                uv.y = j / (points.length - 1);
                uvs.push(uv.x, uv.y);
            }
        }
        // indices
        for(let i = 0; i < segments; i++)for(let j = 0; j < points.length - 1; j++){
            const base = j + i * points.length;
            const a = base;
            const b = base + points.length;
            const c = base + points.length + 1;
            const d = base + 1;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // generate normals
        this.computeVertexNormals();
        // if the geometry is closed, we need to average the normals along the seam.
        // because the corresponding vertices are identical (but still have different UVs).
        if (phiLength === Math.PI * 2) {
            const normals = this.attributes.normal.array;
            const n1 = new Vector3();
            const n2 = new Vector3();
            const n = new Vector3();
            // this is the buffer offset for the last line of vertices
            const base = segments * points.length * 3;
            for(let i = 0, j = 0; i < points.length; i++, j += 3){
                // select the normal of the vertex in the first line
                n1.x = normals[j + 0];
                n1.y = normals[j + 1];
                n1.z = normals[j + 2];
                // select the normal of the vertex in the last line
                n2.x = normals[base + j + 0];
                n2.y = normals[base + j + 1];
                n2.z = normals[base + j + 2];
                // average normals
                n.addVectors(n1, n2).normalize();
                // assign the new values to both normals
                normals[j + 0] = normals[base + j + 0] = n.x;
                normals[j + 1] = normals[base + j + 1] = n.y;
                normals[j + 2] = normals[base + j + 2] = n.z;
            }
        }
    }
}
class OctahedronGeometry extends PolyhedronGeometry {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1,
            0,
            0,
            0,
            1,
            0,
            0,
            -1
        ];
        const indices = [
            0,
            2,
            4,
            0,
            4,
            3,
            0,
            3,
            5,
            0,
            5,
            2,
            1,
            2,
            5,
            1,
            5,
            3,
            1,
            3,
            4,
            1,
            4,
            2
        ];
        super(vertices, indices, radius, detail);
        this.type = 'OctahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
/**
 * Parametric Surfaces Geometry
 * based on the brilliant article by @prideout https://prideout.net/blog/old/blog/index.html@p=44.html
 */ function ParametricGeometry(func, slices, stacks) {
    BufferGeometry.call(this);
    this.type = 'ParametricGeometry';
    this.parameters = {
        func: func,
        slices: slices,
        stacks: stacks
    };
    // buffers
    const indices = [];
    const vertices = [];
    const normals = [];
    const uvs = [];
    const EPS = 0.00001;
    const normal = new Vector3();
    const p0 = new Vector3(), p1 = new Vector3();
    const pu = new Vector3(), pv = new Vector3();
    if (func.length < 3) console.error('THREE.ParametricGeometry: Function must now modify a Vector3 as third parameter.');
    // generate vertices, normals and uvs
    const sliceCount = slices + 1;
    for(let i = 0; i <= stacks; i++){
        const v = i / stacks;
        for(let j = 0; j <= slices; j++){
            const u = j / slices;
            // vertex
            func(u, v, p0);
            vertices.push(p0.x, p0.y, p0.z);
            // normal
            // approximate tangent vectors via finite differences
            if (u - EPS >= 0) {
                func(u - EPS, v, p1);
                pu.subVectors(p0, p1);
            } else {
                func(u + EPS, v, p1);
                pu.subVectors(p1, p0);
            }
            if (v - EPS >= 0) {
                func(u, v - EPS, p1);
                pv.subVectors(p0, p1);
            } else {
                func(u, v + EPS, p1);
                pv.subVectors(p1, p0);
            }
            // cross product of tangent vectors returns surface normal
            normal.crossVectors(pu, pv).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(u, v);
        }
    }
    // generate indices
    for(let i = 0; i < stacks; i++)for(let j = 0; j < slices; j++){
        const a = i * sliceCount + j;
        const b = i * sliceCount + j + 1;
        const c = (i + 1) * sliceCount + j + 1;
        const d = (i + 1) * sliceCount + j;
        // faces one and two
        indices.push(a, b, d);
        indices.push(b, c, d);
    }
    // build geometry
    this.setIndex(indices);
    this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
    this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
}
ParametricGeometry.prototype = Object.create(BufferGeometry.prototype);
ParametricGeometry.prototype.constructor = ParametricGeometry;
class RingGeometry extends BufferGeometry {
    constructor(innerRadius = 0.5, outerRadius = 1, thetaSegments = 8, phiSegments = 1, thetaStart = 0, thetaLength = Math.PI * 2){
        super();
        this.type = 'RingGeometry';
        this.parameters = {
            innerRadius: innerRadius,
            outerRadius: outerRadius,
            thetaSegments: thetaSegments,
            phiSegments: phiSegments,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        thetaSegments = Math.max(3, thetaSegments);
        phiSegments = Math.max(1, phiSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // some helper variables
        let radius = innerRadius;
        const radiusStep = (outerRadius - innerRadius) / phiSegments;
        const vertex = new Vector3();
        const uv = new Vector2();
        // generate vertices, normals and uvs
        for(let j = 0; j <= phiSegments; j++){
            for(let i = 0; i <= thetaSegments; i++){
                // values are generate from the inside of the ring to the outside
                const segment = thetaStart + i / thetaSegments * thetaLength;
                // vertex
                vertex.x = radius * Math.cos(segment);
                vertex.y = radius * Math.sin(segment);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normals.push(0, 0, 1);
                // uv
                uv.x = (vertex.x / outerRadius + 1) / 2;
                uv.y = (vertex.y / outerRadius + 1) / 2;
                uvs.push(uv.x, uv.y);
            }
            // increase the radius for next row of vertices
            radius += radiusStep;
        }
        // indices
        for(let j = 0; j < phiSegments; j++){
            const thetaSegmentLevel = j * (thetaSegments + 1);
            for(let i = 0; i < thetaSegments; i++){
                const segment = i + thetaSegmentLevel;
                const a = segment;
                const b = segment + thetaSegments + 1;
                const c = segment + thetaSegments + 2;
                const d = segment + 1;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
class ShapeGeometry extends BufferGeometry {
    constructor(shapes, curveSegments = 12){
        super();
        this.type = 'ShapeGeometry';
        this.parameters = {
            shapes: shapes,
            curveSegments: curveSegments
        };
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        let groupStart = 0;
        let groupCount = 0;
        // allow single and array values for "shapes" parameter
        if (Array.isArray(shapes) === false) addShape(shapes);
        else for(let i = 0; i < shapes.length; i++){
            addShape(shapes[i]);
            this.addGroup(groupStart, groupCount, i); // enables MultiMaterial support
            groupStart += groupCount;
            groupCount = 0;
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // helper functions
        function addShape(shape) {
            const indexOffset = vertices.length / 3;
            const points = shape.extractPoints(curveSegments);
            let shapeVertices = points.shape;
            const shapeHoles = points.holes;
            // check direction of vertices
            if (ShapeUtils.isClockWise(shapeVertices) === false) shapeVertices = shapeVertices.reverse();
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                if (ShapeUtils.isClockWise(shapeHole) === true) shapeHoles[i] = shapeHole.reverse();
            }
            const faces = ShapeUtils.triangulateShape(shapeVertices, shapeHoles);
            // join vertices of inner and outer paths to a single array
            for(let i = 0, l = shapeHoles.length; i < l; i++){
                const shapeHole = shapeHoles[i];
                shapeVertices = shapeVertices.concat(shapeHole);
            }
            // vertices, normals, uvs
            for(let i = 0, l = shapeVertices.length; i < l; i++){
                const vertex = shapeVertices[i];
                vertices.push(vertex.x, vertex.y, 0);
                normals.push(0, 0, 1);
                uvs.push(vertex.x, vertex.y); // world uvs
            }
            // incides
            for(let i = 0, l = faces.length; i < l; i++){
                const face = faces[i];
                const a = face[0] + indexOffset;
                const b = face[1] + indexOffset;
                const c = face[2] + indexOffset;
                indices.push(a, b, c);
                groupCount += 3;
            }
        }
    }
    toJSON() {
        const data = BufferGeometry.prototype.toJSON.call(this);
        const shapes = this.parameters.shapes;
        return toJSON$1(shapes, data);
    }
}
function toJSON$1(shapes, data) {
    data.shapes = [];
    if (Array.isArray(shapes)) for(let i = 0, l = shapes.length; i < l; i++){
        const shape = shapes[i];
        data.shapes.push(shape.uuid);
    }
    else data.shapes.push(shapes.uuid);
    return data;
}
class SphereGeometry extends BufferGeometry {
    constructor(radius = 1, widthSegments = 8, heightSegments = 6, phiStart = 0, phiLength = Math.PI * 2, thetaStart = 0, thetaLength = Math.PI){
        super();
        this.type = 'SphereGeometry';
        this.parameters = {
            radius: radius,
            widthSegments: widthSegments,
            heightSegments: heightSegments,
            phiStart: phiStart,
            phiLength: phiLength,
            thetaStart: thetaStart,
            thetaLength: thetaLength
        };
        widthSegments = Math.max(3, Math.floor(widthSegments));
        heightSegments = Math.max(2, Math.floor(heightSegments));
        const thetaEnd = Math.min(thetaStart + thetaLength, Math.PI);
        let index = 0;
        const grid = [];
        const vertex = new Vector3();
        const normal = new Vector3();
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // generate vertices, normals and uvs
        for(let iy = 0; iy <= heightSegments; iy++){
            const verticesRow = [];
            const v = iy / heightSegments;
            // special case for the poles
            let uOffset = 0;
            if (iy == 0 && thetaStart == 0) uOffset = 0.5 / widthSegments;
            else if (iy == heightSegments && thetaEnd == Math.PI) uOffset = -0.5 / widthSegments;
            for(let ix = 0; ix <= widthSegments; ix++){
                const u = ix / widthSegments;
                // vertex
                vertex.x = -radius * Math.cos(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertex.y = radius * Math.cos(thetaStart + v * thetaLength);
                vertex.z = radius * Math.sin(phiStart + u * phiLength) * Math.sin(thetaStart + v * thetaLength);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal
                normal.copy(vertex).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(u + uOffset, 1 - v);
                verticesRow.push(index++);
            }
            grid.push(verticesRow);
        }
        // indices
        for(let iy = 0; iy < heightSegments; iy++)for(let ix = 0; ix < widthSegments; ix++){
            const a = grid[iy][ix + 1];
            const b = grid[iy][ix];
            const c = grid[iy + 1][ix];
            const d = grid[iy + 1][ix + 1];
            if (iy !== 0 || thetaStart > 0) indices.push(a, b, d);
            if (iy !== heightSegments - 1 || thetaEnd < Math.PI) indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
class TetrahedronGeometry extends PolyhedronGeometry {
    constructor(radius = 1, detail = 0){
        const vertices = [
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            1,
            -1,
            1,
            -1,
            -1
        ];
        const indices = [
            2,
            1,
            0,
            0,
            3,
            2,
            1,
            3,
            0,
            2,
            3,
            1
        ];
        super(vertices, indices, radius, detail);
        this.type = 'TetrahedronGeometry';
        this.parameters = {
            radius: radius,
            detail: detail
        };
    }
}
/**
 * Text = 3D Text
 *
 * parameters = {
 *  font: <THREE.Font>, // font
 *
 *  size: <float>, // size of the text
 *  height: <float>, // thickness to extrude text
 *  curveSegments: <int>, // number of points on the curves
 *
 *  bevelEnabled: <bool>, // turn on bevel
 *  bevelThickness: <float>, // how deep into text bevel goes
 *  bevelSize: <float>, // how far from text outline (including bevelOffset) is bevel
 *  bevelOffset: <float> // how far from text outline does bevel start
 * }
 */ class TextGeometry extends ExtrudeGeometry {
    constructor(text, parameters = {}){
        const font = parameters.font;
        if (!(font && font.isFont)) {
            console.error('THREE.TextGeometry: font parameter is not an instance of THREE.Font.');
            return new BufferGeometry();
        }
        const shapes = font.generateShapes(text, parameters.size);
        // translate parameters to ExtrudeGeometry API
        parameters.depth = parameters.height !== undefined ? parameters.height : 50;
        // defaults
        if (parameters.bevelThickness === undefined) parameters.bevelThickness = 10;
        if (parameters.bevelSize === undefined) parameters.bevelSize = 8;
        if (parameters.bevelEnabled === undefined) parameters.bevelEnabled = false;
        super(shapes, parameters);
        this.type = 'TextGeometry';
    }
}
class TorusGeometry extends BufferGeometry {
    constructor(radius = 1, tube = 0.4, radialSegments = 8, tubularSegments = 6, arc = Math.PI * 2){
        super();
        this.type = 'TorusGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            radialSegments: radialSegments,
            tubularSegments: tubularSegments,
            arc: arc
        };
        radialSegments = Math.floor(radialSegments);
        tubularSegments = Math.floor(tubularSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const center = new Vector3();
        const vertex = new Vector3();
        const normal = new Vector3();
        // generate vertices, normals and uvs
        for(let j = 0; j <= radialSegments; j++)for(let i = 0; i <= tubularSegments; i++){
            const u = i / tubularSegments * arc;
            const v = j / radialSegments * Math.PI * 2;
            // vertex
            vertex.x = (radius + tube * Math.cos(v)) * Math.cos(u);
            vertex.y = (radius + tube * Math.cos(v)) * Math.sin(u);
            vertex.z = tube * Math.sin(v);
            vertices.push(vertex.x, vertex.y, vertex.z);
            // normal
            center.x = radius * Math.cos(u);
            center.y = radius * Math.sin(u);
            normal.subVectors(vertex, center).normalize();
            normals.push(normal.x, normal.y, normal.z);
            // uv
            uvs.push(i / tubularSegments);
            uvs.push(j / radialSegments);
        }
        // generate indices
        for(let j = 1; j <= radialSegments; j++)for(let i = 1; i <= tubularSegments; i++){
            // indices
            const a = (tubularSegments + 1) * j + i - 1;
            const b = (tubularSegments + 1) * (j - 1) + i - 1;
            const c = (tubularSegments + 1) * (j - 1) + i;
            const d = (tubularSegments + 1) * j + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
    }
}
class TorusKnotGeometry extends BufferGeometry {
    constructor(radius = 1, tube = 0.4, tubularSegments = 64, radialSegments = 8, p = 2, q = 3){
        super();
        this.type = 'TorusKnotGeometry';
        this.parameters = {
            radius: radius,
            tube: tube,
            tubularSegments: tubularSegments,
            radialSegments: radialSegments,
            p: p,
            q: q
        };
        tubularSegments = Math.floor(tubularSegments);
        radialSegments = Math.floor(radialSegments);
        // buffers
        const indices = [];
        const vertices = [];
        const normals = [];
        const uvs = [];
        // helper variables
        const vertex = new Vector3();
        const normal = new Vector3();
        const P1 = new Vector3();
        const P2 = new Vector3();
        const B = new Vector3();
        const T = new Vector3();
        const N = new Vector3();
        // generate vertices, normals and uvs
        for(let i = 0; i <= tubularSegments; ++i){
            // the radian "u" is used to calculate the position on the torus curve of the current tubular segement
            const u = i / tubularSegments * p * Math.PI * 2;
            // now we calculate two points. P1 is our current position on the curve, P2 is a little farther ahead.
            // these points are used to create a special "coordinate space", which is necessary to calculate the correct vertex positions
            calculatePositionOnCurve(u, p, q, radius, P1);
            calculatePositionOnCurve(u + 0.01, p, q, radius, P2);
            // calculate orthonormal basis
            T.subVectors(P2, P1);
            N.addVectors(P2, P1);
            B.crossVectors(T, N);
            N.crossVectors(B, T);
            // normalize B, N. T can be ignored, we don't use it
            B.normalize();
            N.normalize();
            for(let j = 0; j <= radialSegments; ++j){
                // now calculate the vertices. they are nothing more than an extrusion of the torus curve.
                // because we extrude a shape in the xy-plane, there is no need to calculate a z-value.
                const v = j / radialSegments * Math.PI * 2;
                const cx = -tube * Math.cos(v);
                const cy = tube * Math.sin(v);
                // now calculate the final vertex position.
                // first we orient the extrusion with our basis vectos, then we add it to the current position on the curve
                vertex.x = P1.x + (cx * N.x + cy * B.x);
                vertex.y = P1.y + (cx * N.y + cy * B.y);
                vertex.z = P1.z + (cx * N.z + cy * B.z);
                vertices.push(vertex.x, vertex.y, vertex.z);
                // normal (P1 is always the center/origin of the extrusion, thus we can use it to calculate the normal)
                normal.subVectors(vertex, P1).normalize();
                normals.push(normal.x, normal.y, normal.z);
                // uv
                uvs.push(i / tubularSegments);
                uvs.push(j / radialSegments);
            }
        }
        // generate indices
        for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
            // indices
            const a = (radialSegments + 1) * (j - 1) + (i - 1);
            const b = (radialSegments + 1) * j + (i - 1);
            const c = (radialSegments + 1) * j + i;
            const d = (radialSegments + 1) * (j - 1) + i;
            // faces
            indices.push(a, b, d);
            indices.push(b, c, d);
        }
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // this function calculates the current position on the torus curve
        function calculatePositionOnCurve(u, p, q, radius, position) {
            const cu = Math.cos(u);
            const su = Math.sin(u);
            const quOverP = q / p * u;
            const cs = Math.cos(quOverP);
            position.x = radius * (2 + cs) * 0.5 * cu;
            position.y = radius * (2 + cs) * su * 0.5;
            position.z = radius * Math.sin(quOverP) * 0.5;
        }
    }
}
class TubeGeometry extends BufferGeometry {
    constructor(path, tubularSegments = 64, radius = 1, radialSegments = 8, closed = false){
        super();
        this.type = 'TubeGeometry';
        this.parameters = {
            path: path,
            tubularSegments: tubularSegments,
            radius: radius,
            radialSegments: radialSegments,
            closed: closed
        };
        const frames = path.computeFrenetFrames(tubularSegments, closed);
        // expose internals
        this.tangents = frames.tangents;
        this.normals = frames.normals;
        this.binormals = frames.binormals;
        // helper variables
        const vertex = new Vector3();
        const normal = new Vector3();
        const uv = new Vector2();
        let P = new Vector3();
        // buffer
        const vertices = [];
        const normals = [];
        const uvs = [];
        const indices = [];
        // create buffer data
        generateBufferData();
        // build geometry
        this.setIndex(indices);
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        this.setAttribute('normal', new Float32BufferAttribute(normals, 3));
        this.setAttribute('uv', new Float32BufferAttribute(uvs, 2));
        // functions
        function generateBufferData() {
            for(let i = 0; i < tubularSegments; i++)generateSegment(i);
            // if the geometry is not closed, generate the last row of vertices and normals
            // at the regular position on the given path
            //
            // if the geometry is closed, duplicate the first row of vertices and normals (uvs will differ)
            generateSegment(closed === false ? tubularSegments : 0);
            // uvs are generated in a separate function.
            // this makes it easy compute correct values for closed geometries
            generateUVs();
            // finally create faces
            generateIndices();
        }
        function generateSegment(i) {
            // we use getPointAt to sample evenly distributed points from the given path
            P = path.getPointAt(i / tubularSegments, P);
            // retrieve corresponding normal and binormal
            const N = frames.normals[i];
            const B = frames.binormals[i];
            // generate normals and vertices for the current segment
            for(let j = 0; j <= radialSegments; j++){
                const v = j / radialSegments * Math.PI * 2;
                const sin = Math.sin(v);
                const cos = -Math.cos(v);
                // normal
                normal.x = cos * N.x + sin * B.x;
                normal.y = cos * N.y + sin * B.y;
                normal.z = cos * N.z + sin * B.z;
                normal.normalize();
                normals.push(normal.x, normal.y, normal.z);
                // vertex
                vertex.x = P.x + radius * normal.x;
                vertex.y = P.y + radius * normal.y;
                vertex.z = P.z + radius * normal.z;
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        function generateIndices() {
            for(let j = 1; j <= tubularSegments; j++)for(let i = 1; i <= radialSegments; i++){
                const a = (radialSegments + 1) * (j - 1) + (i - 1);
                const b = (radialSegments + 1) * j + (i - 1);
                const c = (radialSegments + 1) * j + i;
                const d = (radialSegments + 1) * (j - 1) + i;
                // faces
                indices.push(a, b, d);
                indices.push(b, c, d);
            }
        }
        function generateUVs() {
            for(let i = 0; i <= tubularSegments; i++)for(let j = 0; j <= radialSegments; j++){
                uv.x = i / tubularSegments;
                uv.y = j / radialSegments;
                uvs.push(uv.x, uv.y);
            }
        }
    }
    toJSON() {
        const data = BufferGeometry.prototype.toJSON.call(this);
        data.path = this.parameters.path.toJSON();
        return data;
    }
}
class WireframeGeometry extends BufferGeometry {
    constructor(geometry){
        super();
        this.type = 'WireframeGeometry';
        if (geometry.isGeometry === true) {
            console.error('THREE.WireframeGeometry no longer supports THREE.Geometry. Use THREE.BufferGeometry instead.');
            return;
        }
        // buffer
        const vertices = [];
        // helper variables
        const edge = [
            0,
            0
        ], edges = {};
        const vertex = new Vector3();
        if (geometry.index !== null) {
            // indexed BufferGeometry
            const position = geometry.attributes.position;
            const indices = geometry.index;
            let groups = geometry.groups;
            if (groups.length === 0) groups = [
                {
                    start: 0,
                    count: indices.count,
                    materialIndex: 0
                }
            ];
            // create a data structure that contains all eges without duplicates
            for(let o = 0, ol = groups.length; o < ol; ++o){
                const group = groups[o];
                const start = group.start;
                const count = group.count;
                for(let i = start, l = start + count; i < l; i += 3)for(let j = 0; j < 3; j++){
                    const edge1 = indices.getX(i + j);
                    const edge2 = indices.getX(i + (j + 1) % 3);
                    edge[0] = Math.min(edge1, edge2); // sorting prevents duplicates
                    edge[1] = Math.max(edge1, edge2);
                    const key = edge[0] + ',' + edge[1];
                    if (edges[key] === undefined) edges[key] = {
                        index1: edge[0],
                        index2: edge[1]
                    };
                }
            }
            // generate vertices
            for(const key in edges){
                const e = edges[key];
                vertex.fromBufferAttribute(position, e.index1);
                vertices.push(vertex.x, vertex.y, vertex.z);
                vertex.fromBufferAttribute(position, e.index2);
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        } else {
            // non-indexed BufferGeometry
            const position = geometry.attributes.position;
            for(let i = 0, l = position.count / 3; i < l; i++)for(let j = 0; j < 3; j++){
                // three edges per triangle, an edge is represented as (index1, index2)
                // e.g. the first triangle has the following edges: (0,1),(1,2),(2,0)
                const index1 = 3 * i + j;
                vertex.fromBufferAttribute(position, index1);
                vertices.push(vertex.x, vertex.y, vertex.z);
                const index2 = 3 * i + (j + 1) % 3;
                vertex.fromBufferAttribute(position, index2);
                vertices.push(vertex.x, vertex.y, vertex.z);
            }
        }
        // build geometry
        this.setAttribute('position', new Float32BufferAttribute(vertices, 3));
    }
}
var Geometries = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    BoxGeometry: BoxGeometry,
    BoxBufferGeometry: BoxGeometry,
    CircleGeometry: CircleGeometry,
    CircleBufferGeometry: CircleGeometry,
    ConeGeometry: ConeGeometry,
    ConeBufferGeometry: ConeGeometry,
    CylinderGeometry: CylinderGeometry,
    CylinderBufferGeometry: CylinderGeometry,
    DodecahedronGeometry: DodecahedronGeometry,
    DodecahedronBufferGeometry: DodecahedronGeometry,
    EdgesGeometry: EdgesGeometry,
    ExtrudeGeometry: ExtrudeGeometry,
    ExtrudeBufferGeometry: ExtrudeGeometry,
    IcosahedronGeometry: IcosahedronGeometry,
    IcosahedronBufferGeometry: IcosahedronGeometry,
    LatheGeometry: LatheGeometry,
    LatheBufferGeometry: LatheGeometry,
    OctahedronGeometry: OctahedronGeometry,
    OctahedronBufferGeometry: OctahedronGeometry,
    ParametricGeometry: ParametricGeometry,
    ParametricBufferGeometry: ParametricGeometry,
    PlaneGeometry: PlaneGeometry,
    PlaneBufferGeometry: PlaneGeometry,
    PolyhedronGeometry: PolyhedronGeometry,
    PolyhedronBufferGeometry: PolyhedronGeometry,
    RingGeometry: RingGeometry,
    RingBufferGeometry: RingGeometry,
    ShapeGeometry: ShapeGeometry,
    ShapeBufferGeometry: ShapeGeometry,
    SphereGeometry: SphereGeometry,
    SphereBufferGeometry: SphereGeometry,
    TetrahedronGeometry: TetrahedronGeometry,
    TetrahedronBufferGeometry: TetrahedronGeometry,
    TextGeometry: TextGeometry,
    TextBufferGeometry: TextGeometry,
    TorusGeometry: TorusGeometry,
    TorusBufferGeometry: TorusGeometry,
    TorusKnotGeometry: TorusKnotGeometry,
    TorusKnotBufferGeometry: TorusKnotGeometry,
    TubeGeometry: TubeGeometry,
    TubeBufferGeometry: TubeGeometry,
    WireframeGeometry: WireframeGeometry
});
/**
 * parameters = {
 *  color: <THREE.Color>
 * }
 */ function ShadowMaterial(parameters) {
    Material.call(this);
    this.type = 'ShadowMaterial';
    this.color = new Color(0x000000);
    this.transparent = true;
    this.setValues(parameters);
}
ShadowMaterial.prototype = Object.create(Material.prototype);
ShadowMaterial.prototype.constructor = ShadowMaterial;
ShadowMaterial.prototype.isShadowMaterial = true;
ShadowMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    return this;
};
function RawShaderMaterial(parameters) {
    ShaderMaterial.call(this, parameters);
    this.type = 'RawShaderMaterial';
}
RawShaderMaterial.prototype = Object.create(ShaderMaterial.prototype);
RawShaderMaterial.prototype.constructor = RawShaderMaterial;
RawShaderMaterial.prototype.isRawShaderMaterial = true;
/**
 * parameters = {
 *  color: <hex>,
 *  roughness: <float>,
 *  metalness: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  roughnessMap: new THREE.Texture( <Image> ),
 *
 *  metalnessMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  envMapIntensity: <float>
 *
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshStandardMaterial(parameters) {
    Material.call(this);
    this.defines = {
        'STANDARD': ''
    };
    this.type = 'MeshStandardMaterial';
    this.color = new Color(0xffffff); // diffuse
    this.roughness = 1.0;
    this.metalness = 0.0;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.emissive = new Color(0x000000);
    this.emissiveIntensity = 1.0;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.roughnessMap = null;
    this.metalnessMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.envMapIntensity = 1.0;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.vertexTangents = false;
    this.setValues(parameters);
}
MeshStandardMaterial.prototype = Object.create(Material.prototype);
MeshStandardMaterial.prototype.constructor = MeshStandardMaterial;
MeshStandardMaterial.prototype.isMeshStandardMaterial = true;
MeshStandardMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.defines = {
        'STANDARD': ''
    };
    this.color.copy(source.color);
    this.roughness = source.roughness;
    this.metalness = source.metalness;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.roughnessMap = source.roughnessMap;
    this.metalnessMap = source.metalnessMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.envMapIntensity = source.envMapIntensity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    this.vertexTangents = source.vertexTangents;
    return this;
};
/**
 * parameters = {
 *  clearcoat: <float>,
 *  clearcoatMap: new THREE.Texture( <Image> ),
 *  clearcoatRoughness: <float>,
 *  clearcoatRoughnessMap: new THREE.Texture( <Image> ),
 *  clearcoatNormalScale: <Vector2>,
 *  clearcoatNormalMap: new THREE.Texture( <Image> ),
 *
 *  reflectivity: <float>,
 *  ior: <float>,
 *
 *  sheen: <Color>,
 *
 *  transmission: <float>,
 *  transmissionMap: new THREE.Texture( <Image> )
 * }
 */ function MeshPhysicalMaterial(parameters) {
    MeshStandardMaterial.call(this);
    this.defines = {
        'STANDARD': '',
        'PHYSICAL': ''
    };
    this.type = 'MeshPhysicalMaterial';
    this.clearcoat = 0.0;
    this.clearcoatMap = null;
    this.clearcoatRoughness = 0.0;
    this.clearcoatRoughnessMap = null;
    this.clearcoatNormalScale = new Vector2(1, 1);
    this.clearcoatNormalMap = null;
    this.reflectivity = 0.5; // maps to F0 = 0.04
    Object.defineProperty(this, 'ior', {
        get: function() {
            return (1 + 0.4 * this.reflectivity) / (1 - 0.4 * this.reflectivity);
        },
        set: function(ior) {
            this.reflectivity = MathUtils.clamp(2.5 * (ior - 1) / (ior + 1), 0, 1);
        }
    });
    this.sheen = null; // null will disable sheen bsdf
    this.transmission = 0.0;
    this.transmissionMap = null;
    this.setValues(parameters);
}
MeshPhysicalMaterial.prototype = Object.create(MeshStandardMaterial.prototype);
MeshPhysicalMaterial.prototype.constructor = MeshPhysicalMaterial;
MeshPhysicalMaterial.prototype.isMeshPhysicalMaterial = true;
MeshPhysicalMaterial.prototype.copy = function(source) {
    MeshStandardMaterial.prototype.copy.call(this, source);
    this.defines = {
        'STANDARD': '',
        'PHYSICAL': ''
    };
    this.clearcoat = source.clearcoat;
    this.clearcoatMap = source.clearcoatMap;
    this.clearcoatRoughness = source.clearcoatRoughness;
    this.clearcoatRoughnessMap = source.clearcoatRoughnessMap;
    this.clearcoatNormalMap = source.clearcoatNormalMap;
    this.clearcoatNormalScale.copy(source.clearcoatNormalScale);
    this.reflectivity = source.reflectivity;
    if (source.sheen) this.sheen = (this.sheen || new Color()).copy(source.sheen);
    else this.sheen = null;
    this.transmission = source.transmission;
    this.transmissionMap = source.transmissionMap;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *  specular: <hex>,
 *  shininess: <float>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.MultiplyOperation,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshPhongMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshPhongMaterial';
    this.color = new Color(0xffffff); // diffuse
    this.specular = new Color(0x111111);
    this.shininess = 30;
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.emissive = new Color(0x000000);
    this.emissiveIntensity = 1.0;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshPhongMaterial.prototype = Object.create(Material.prototype);
MeshPhongMaterial.prototype.constructor = MeshPhongMaterial;
MeshPhongMaterial.prototype.isMeshPhongMaterial = true;
MeshPhongMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.specular.copy(source.specular);
    this.shininess = source.shininess;
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *
 *  map: new THREE.Texture( <Image> ),
 *  gradientMap: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshToonMaterial(parameters) {
    Material.call(this);
    this.defines = {
        'TOON': ''
    };
    this.type = 'MeshToonMaterial';
    this.color = new Color(0xffffff);
    this.map = null;
    this.gradientMap = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.emissive = new Color(0x000000);
    this.emissiveIntensity = 1.0;
    this.emissiveMap = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshToonMaterial.prototype = Object.create(Material.prototype);
MeshToonMaterial.prototype.constructor = MeshToonMaterial;
MeshToonMaterial.prototype.isMeshToonMaterial = true;
MeshToonMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.gradientMap = source.gradientMap;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  opacity: <float>,
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshNormalMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshNormalMaterial';
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.fog = false;
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshNormalMaterial.prototype = Object.create(Material.prototype);
MeshNormalMaterial.prototype.constructor = MeshNormalMaterial;
MeshNormalMaterial.prototype.isMeshNormalMaterial = true;
MeshNormalMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  lightMap: new THREE.Texture( <Image> ),
 *  lightMapIntensity: <float>
 *
 *  aoMap: new THREE.Texture( <Image> ),
 *  aoMapIntensity: <float>
 *
 *  emissive: <hex>,
 *  emissiveIntensity: <float>
 *  emissiveMap: new THREE.Texture( <Image> ),
 *
 *  specularMap: new THREE.Texture( <Image> ),
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  envMap: new THREE.CubeTexture( [posx, negx, posy, negy, posz, negz] ),
 *  combine: THREE.Multiply,
 *  reflectivity: <float>,
 *  refractionRatio: <float>,
 *
 *  wireframe: <boolean>,
 *  wireframeLinewidth: <float>,
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshLambertMaterial(parameters) {
    Material.call(this);
    this.type = 'MeshLambertMaterial';
    this.color = new Color(0xffffff); // diffuse
    this.map = null;
    this.lightMap = null;
    this.lightMapIntensity = 1.0;
    this.aoMap = null;
    this.aoMapIntensity = 1.0;
    this.emissive = new Color(0x000000);
    this.emissiveIntensity = 1.0;
    this.emissiveMap = null;
    this.specularMap = null;
    this.alphaMap = null;
    this.envMap = null;
    this.combine = MultiplyOperation;
    this.reflectivity = 1;
    this.refractionRatio = 0.98;
    this.wireframe = false;
    this.wireframeLinewidth = 1;
    this.wireframeLinecap = 'round';
    this.wireframeLinejoin = 'round';
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshLambertMaterial.prototype = Object.create(Material.prototype);
MeshLambertMaterial.prototype.constructor = MeshLambertMaterial;
MeshLambertMaterial.prototype.isMeshLambertMaterial = true;
MeshLambertMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.color.copy(source.color);
    this.map = source.map;
    this.lightMap = source.lightMap;
    this.lightMapIntensity = source.lightMapIntensity;
    this.aoMap = source.aoMap;
    this.aoMapIntensity = source.aoMapIntensity;
    this.emissive.copy(source.emissive);
    this.emissiveMap = source.emissiveMap;
    this.emissiveIntensity = source.emissiveIntensity;
    this.specularMap = source.specularMap;
    this.alphaMap = source.alphaMap;
    this.envMap = source.envMap;
    this.combine = source.combine;
    this.reflectivity = source.reflectivity;
    this.refractionRatio = source.refractionRatio;
    this.wireframe = source.wireframe;
    this.wireframeLinewidth = source.wireframeLinewidth;
    this.wireframeLinecap = source.wireframeLinecap;
    this.wireframeLinejoin = source.wireframeLinejoin;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  matcap: new THREE.Texture( <Image> ),
 *
 *  map: new THREE.Texture( <Image> ),
 *
 *  bumpMap: new THREE.Texture( <Image> ),
 *  bumpScale: <float>,
 *
 *  normalMap: new THREE.Texture( <Image> ),
 *  normalMapType: THREE.TangentSpaceNormalMap,
 *  normalScale: <Vector2>,
 *
 *  displacementMap: new THREE.Texture( <Image> ),
 *  displacementScale: <float>,
 *  displacementBias: <float>,
 *
 *  alphaMap: new THREE.Texture( <Image> ),
 *
 *  skinning: <bool>,
 *  morphTargets: <bool>,
 *  morphNormals: <bool>
 * }
 */ function MeshMatcapMaterial(parameters) {
    Material.call(this);
    this.defines = {
        'MATCAP': ''
    };
    this.type = 'MeshMatcapMaterial';
    this.color = new Color(0xffffff); // diffuse
    this.matcap = null;
    this.map = null;
    this.bumpMap = null;
    this.bumpScale = 1;
    this.normalMap = null;
    this.normalMapType = TangentSpaceNormalMap;
    this.normalScale = new Vector2(1, 1);
    this.displacementMap = null;
    this.displacementScale = 1;
    this.displacementBias = 0;
    this.alphaMap = null;
    this.skinning = false;
    this.morphTargets = false;
    this.morphNormals = false;
    this.setValues(parameters);
}
MeshMatcapMaterial.prototype = Object.create(Material.prototype);
MeshMatcapMaterial.prototype.constructor = MeshMatcapMaterial;
MeshMatcapMaterial.prototype.isMeshMatcapMaterial = true;
MeshMatcapMaterial.prototype.copy = function(source) {
    Material.prototype.copy.call(this, source);
    this.defines = {
        'MATCAP': ''
    };
    this.color.copy(source.color);
    this.matcap = source.matcap;
    this.map = source.map;
    this.bumpMap = source.bumpMap;
    this.bumpScale = source.bumpScale;
    this.normalMap = source.normalMap;
    this.normalMapType = source.normalMapType;
    this.normalScale.copy(source.normalScale);
    this.displacementMap = source.displacementMap;
    this.displacementScale = source.displacementScale;
    this.displacementBias = source.displacementBias;
    this.alphaMap = source.alphaMap;
    this.skinning = source.skinning;
    this.morphTargets = source.morphTargets;
    this.morphNormals = source.morphNormals;
    return this;
};
/**
 * parameters = {
 *  color: <hex>,
 *  opacity: <float>,
 *
 *  linewidth: <float>,
 *
 *  scale: <float>,
 *  dashSize: <float>,
 *  gapSize: <float>
 * }
 */ function LineDashedMaterial(parameters) {
    LineBasicMaterial.call(this);
    this.type = 'LineDashedMaterial';
    this.scale = 1;
    this.dashSize = 3;
    this.gapSize = 1;
    this.setValues(parameters);
}
LineDashedMaterial.prototype = Object.create(LineBasicMaterial.prototype);
LineDashedMaterial.prototype.constructor = LineDashedMaterial;
LineDashedMaterial.prototype.isLineDashedMaterial = true;
LineDashedMaterial.prototype.copy = function(source) {
    LineBasicMaterial.prototype.copy.call(this, source);
    this.scale = source.scale;
    this.dashSize = source.dashSize;
    this.gapSize = source.gapSize;
    return this;
};
var Materials = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ShadowMaterial: ShadowMaterial,
    SpriteMaterial: SpriteMaterial,
    RawShaderMaterial: RawShaderMaterial,
    ShaderMaterial: ShaderMaterial,
    PointsMaterial: PointsMaterial,
    MeshPhysicalMaterial: MeshPhysicalMaterial,
    MeshStandardMaterial: MeshStandardMaterial,
    MeshPhongMaterial: MeshPhongMaterial,
    MeshToonMaterial: MeshToonMaterial,
    MeshNormalMaterial: MeshNormalMaterial,
    MeshLambertMaterial: MeshLambertMaterial,
    MeshDepthMaterial: MeshDepthMaterial,
    MeshDistanceMaterial: MeshDistanceMaterial,
    MeshBasicMaterial: MeshBasicMaterial,
    MeshMatcapMaterial: MeshMatcapMaterial,
    LineDashedMaterial: LineDashedMaterial,
    LineBasicMaterial: LineBasicMaterial,
    Material: Material
});
const AnimationUtils = {
    // same as Array.prototype.slice, but also works on typed arrays
    arraySlice: function(array, from, to) {
        if (AnimationUtils.isTypedArray(array)) // in ios9 array.subarray(from, undefined) will return empty array
        // but array.subarray(from) or array.subarray(from, len) is correct
        return new array.constructor(array.subarray(from, to !== undefined ? to : array.length));
        return array.slice(from, to);
    },
    // converts an array to a specific type
    convertArray: function(array, type, forceClone) {
        if (!array || // let 'undefined' and 'null' pass
        !forceClone && array.constructor === type) return array;
        if (typeof type.BYTES_PER_ELEMENT === 'number') return new type(array); // create typed array
        return Array.prototype.slice.call(array); // create Array
    },
    isTypedArray: function(object) {
        return ArrayBuffer.isView(object) && !(object instanceof DataView);
    },
    // returns an array by which times and values can be sorted
    getKeyframeOrder: function(times) {
        function compareTime(i, j) {
            return times[i] - times[j];
        }
        const n = times.length;
        const result = new Array(n);
        for(let i = 0; i !== n; ++i)result[i] = i;
        result.sort(compareTime);
        return result;
    },
    // uses the array previously returned by 'getKeyframeOrder' to sort data
    sortedArray: function(values, stride, order) {
        const nValues = values.length;
        const result = new values.constructor(nValues);
        for(let i = 0, dstOffset = 0; dstOffset !== nValues; ++i){
            const srcOffset = order[i] * stride;
            for(let j = 0; j !== stride; ++j)result[dstOffset++] = values[srcOffset + j];
        }
        return result;
    },
    // function for parsing AOS keyframe formats
    flattenJSON: function(jsonKeys, times, values, valuePropertyName) {
        let i = 1, key = jsonKeys[0];
        while(key !== undefined && key[valuePropertyName] === undefined)key = jsonKeys[i++];
        if (key === undefined) return; // no data
        let value = key[valuePropertyName];
        if (value === undefined) return; // no data
        if (Array.isArray(value)) do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push.apply(values, value); // push all elements
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else if (value.toArray !== undefined) // ...assume THREE.Math-ish
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                value.toArray(values, values.length);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
        else // otherwise push as-is
        do {
            value = key[valuePropertyName];
            if (value !== undefined) {
                times.push(key.time);
                values.push(value);
            }
            key = jsonKeys[i++];
        }while (key !== undefined);
    },
    subclip: function(sourceClip, name, startFrame, endFrame, fps = 30) {
        const clip = sourceClip.clone();
        clip.name = name;
        const tracks = [];
        for(let i = 0; i < clip.tracks.length; ++i){
            const track = clip.tracks[i];
            const valueSize = track.getValueSize();
            const times = [];
            const values = [];
            for(let j = 0; j < track.times.length; ++j){
                const frame = track.times[j] * fps;
                if (frame < startFrame || frame >= endFrame) continue;
                times.push(track.times[j]);
                for(let k = 0; k < valueSize; ++k)values.push(track.values[j * valueSize + k]);
            }
            if (times.length === 0) continue;
            track.times = AnimationUtils.convertArray(times, track.times.constructor);
            track.values = AnimationUtils.convertArray(values, track.values.constructor);
            tracks.push(track);
        }
        clip.tracks = tracks;
        // find minimum .times value across all tracks in the trimmed clip
        let minStartTime = Infinity;
        for(let i = 0; i < clip.tracks.length; ++i)if (minStartTime > clip.tracks[i].times[0]) minStartTime = clip.tracks[i].times[0];
        // shift all tracks such that clip begins at t=0
        for(let i = 0; i < clip.tracks.length; ++i)clip.tracks[i].shift(-1 * minStartTime);
        clip.resetDuration();
        return clip;
    },
    makeClipAdditive: function(targetClip, referenceFrame = 0, referenceClip = targetClip, fps = 30) {
        if (fps <= 0) fps = 30;
        const numTracks = referenceClip.tracks.length;
        const referenceTime = referenceFrame / fps;
        // Make each track's values relative to the values at the reference frame
        for(let i = 0; i < numTracks; ++i){
            const referenceTrack = referenceClip.tracks[i];
            const referenceTrackType = referenceTrack.ValueTypeName;
            // Skip this track if it's non-numeric
            if (referenceTrackType === 'bool' || referenceTrackType === 'string') continue;
            // Find the track in the target clip whose name and type matches the reference track
            const targetTrack = targetClip.tracks.find(function(track) {
                return track.name === referenceTrack.name && track.ValueTypeName === referenceTrackType;
            });
            if (targetTrack === undefined) continue;
            let referenceOffset = 0;
            const referenceValueSize = referenceTrack.getValueSize();
            if (referenceTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) referenceOffset = referenceValueSize / 3;
            let targetOffset = 0;
            const targetValueSize = targetTrack.getValueSize();
            if (targetTrack.createInterpolant.isInterpolantFactoryMethodGLTFCubicSpline) targetOffset = targetValueSize / 3;
            const lastIndex = referenceTrack.times.length - 1;
            let referenceValue;
            // Find the value to subtract out of the track
            if (referenceTime <= referenceTrack.times[0]) {
                // Reference frame is earlier than the first keyframe, so just use the first keyframe
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else if (referenceTime >= referenceTrack.times[lastIndex]) {
                // Reference frame is after the last keyframe, so just use the last keyframe
                const startIndex = lastIndex * referenceValueSize + referenceOffset;
                const endIndex = startIndex + referenceValueSize - referenceOffset;
                referenceValue = AnimationUtils.arraySlice(referenceTrack.values, startIndex, endIndex);
            } else {
                // Interpolate to the reference value
                const interpolant = referenceTrack.createInterpolant();
                const startIndex = referenceOffset;
                const endIndex = referenceValueSize - referenceOffset;
                interpolant.evaluate(referenceTime);
                referenceValue = AnimationUtils.arraySlice(interpolant.resultBuffer, startIndex, endIndex);
            }
            // Conjugate the quaternion
            if (referenceTrackType === 'quaternion') {
                const referenceQuat = new Quaternion().fromArray(referenceValue).normalize().conjugate();
                referenceQuat.toArray(referenceValue);
            }
            // Subtract the reference value from all of the track values
            const numTimes = targetTrack.times.length;
            for(let j = 0; j < numTimes; ++j){
                const valueStart = j * targetValueSize + targetOffset;
                if (referenceTrackType === 'quaternion') // Multiply the conjugate for quaternion track types
                Quaternion.multiplyQuaternionsFlat(targetTrack.values, valueStart, referenceValue, 0, targetTrack.values, valueStart);
                else {
                    const valueEnd = targetValueSize - targetOffset * 2;
                    // Subtract each value for all other numeric track types
                    for(let k = 0; k < valueEnd; ++k)targetTrack.values[valueStart + k] -= referenceValue[k];
                }
            }
        }
        targetClip.blendMode = AdditiveAnimationBlendMode;
        return targetClip;
    }
};
/**
 * Abstract base class of interpolants over parametric samples.
 *
 * The parameter domain is one dimensional, typically the time or a path
 * along a curve defined by the data.
 *
 * The sample values can have any dimensionality and derived classes may
 * apply special interpretations to the data.
 *
 * This class provides the interval seek in a Template Method, deferring
 * the actual interpolation to derived classes.
 *
 * Time complexity is O(1) for linear access crossing at most two points
 * and O(log N) for random access, where N is the number of positions.
 *
 * References:
 *
 * 		http://www.oodesign.com/template-method-pattern.html
 *
 */ function Interpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    this.parameterPositions = parameterPositions;
    this._cachedIndex = 0;
    this.resultBuffer = resultBuffer !== undefined ? resultBuffer : new sampleValues.constructor(sampleSize);
    this.sampleValues = sampleValues;
    this.valueSize = sampleSize;
}
Object.assign(Interpolant.prototype, {
    evaluate: function(t) {
        const pp = this.parameterPositions;
        let i1 = this._cachedIndex, t1 = pp[i1], t0 = pp[i1 - 1];
        validate_interval: {
            seek: {
                let right;
                linear_scan: {
                    //- See http://jsperf.com/comparison-to-undefined/3
                    //- slower code:
                    //-
                    //- 				if ( t >= t1 || t1 === undefined ) {
                    forward_scan: if (!(t < t1)) {
                        for(let giveUpAt = i1 + 2;;){
                            if (t1 === undefined) {
                                if (t < t0) break forward_scan;
                                // after end
                                i1 = pp.length;
                                this._cachedIndex = i1;
                                return this.afterEnd_(i1 - 1, t, t0);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t0 = t1;
                            t1 = pp[++i1];
                            if (t < t1) break seek;
                        }
                        // prepare binary search on the right side of the index
                        right = pp.length;
                        break linear_scan;
                    }
                    //- slower code:
                    //-					if ( t < t0 || t0 === undefined ) {
                    if (!(t >= t0)) {
                        // looping?
                        const t1global = pp[1];
                        if (t < t1global) {
                            i1 = 2; // + 1, using the scan for the details
                            t0 = t1global;
                        }
                        // linear reverse scan
                        for(let giveUpAt = i1 - 2;;){
                            if (t0 === undefined) {
                                // before start
                                this._cachedIndex = 0;
                                return this.beforeStart_(0, t, t1);
                            }
                            if (i1 === giveUpAt) break; // this loop
                            t1 = t0;
                            t0 = pp[--i1 - 1];
                            if (t >= t0) break seek;
                        }
                        // prepare binary search on the left side of the index
                        right = i1;
                        i1 = 0;
                        break linear_scan;
                    }
                    break validate_interval;
                } // linear scan
                // binary search
                while(i1 < right){
                    const mid = i1 + right >>> 1;
                    if (t < pp[mid]) right = mid;
                    else i1 = mid + 1;
                }
                t1 = pp[i1];
                t0 = pp[i1 - 1];
                // check boundary cases, again
                if (t0 === undefined) {
                    this._cachedIndex = 0;
                    return this.beforeStart_(0, t, t1);
                }
                if (t1 === undefined) {
                    i1 = pp.length;
                    this._cachedIndex = i1;
                    return this.afterEnd_(i1 - 1, t0, t);
                }
            } // seek
            this._cachedIndex = i1;
            this.intervalChanged_(i1, t0, t1);
        } // validate_interval
        return this.interpolate_(i1, t0, t, t1);
    },
    settings: null,
    // Note: The indirection allows central control of many interpolants.
    // --- Protected interface
    DefaultSettings_: {},
    getSettings_: function() {
        return this.settings || this.DefaultSettings_;
    },
    copySampleValue_: function(index) {
        // copies a sample value to the result buffer
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset = index * stride;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset + i];
        return result;
    },
    // Template methods for derived classes:
    interpolate_: function() {
        throw new Error('call to abstract method');
    // implementations shall return this.resultBuffer
    },
    intervalChanged_: function() {
    // empty
    }
});
// DECLARE ALIAS AFTER assign prototype
Object.assign(Interpolant.prototype, {
    //( 0, t, t0 ), returns this.resultBuffer
    beforeStart_: Interpolant.prototype.copySampleValue_,
    //( N-1, tN-1, t ), returns this.resultBuffer
    afterEnd_: Interpolant.prototype.copySampleValue_
});
/**
 * Fast and simple cubic spline interpolant.
 *
 * It was derived from a Hermitian construction setting the first derivative
 * at each sample position to the linear slope between neighboring positions
 * over their parameter interval.
 */ function CubicInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    Interpolant.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
    this._weightPrev = -0;
    this._offsetPrev = -0;
    this._weightNext = -0;
    this._offsetNext = -0;
}
CubicInterpolant.prototype = Object.assign(Object.create(Interpolant.prototype), {
    constructor: CubicInterpolant,
    DefaultSettings_: {
        endingStart: ZeroCurvatureEnding,
        endingEnd: ZeroCurvatureEnding
    },
    intervalChanged_: function(i1, t0, t1) {
        const pp = this.parameterPositions;
        let iPrev = i1 - 2, iNext = i1 + 1, tPrev = pp[iPrev], tNext = pp[iNext];
        if (tPrev === undefined) switch(this.getSettings_().endingStart){
            case ZeroSlopeEnding:
                // f'(t0) = 0
                iPrev = i1;
                tPrev = 2 * t0 - t1;
                break;
            case WrapAroundEnding:
                // use the other end of the curve
                iPrev = pp.length - 2;
                tPrev = t0 + pp[iPrev] - pp[iPrev + 1];
                break;
            default:
                // f''(t0) = 0 a.k.a. Natural Spline
                iPrev = i1;
                tPrev = t1;
        }
        if (tNext === undefined) switch(this.getSettings_().endingEnd){
            case ZeroSlopeEnding:
                // f'(tN) = 0
                iNext = i1;
                tNext = 2 * t1 - t0;
                break;
            case WrapAroundEnding:
                // use the other end of the curve
                iNext = 1;
                tNext = t1 + pp[1] - pp[0];
                break;
            default:
                // f''(tN) = 0, a.k.a. Natural Spline
                iNext = i1 - 1;
                tNext = t0;
        }
        const halfDt = (t1 - t0) * 0.5, stride = this.valueSize;
        this._weightPrev = halfDt / (t0 - tPrev);
        this._weightNext = halfDt / (tNext - t1);
        this._offsetPrev = iPrev * stride;
        this._offsetNext = iNext * stride;
    },
    interpolate_: function(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, o1 = i1 * stride, o0 = o1 - stride, oP = this._offsetPrev, oN = this._offsetNext, wP = this._weightPrev, wN = this._weightNext, p = (t - t0) / (t1 - t0), pp = p * p, ppp = pp * p;
        // evaluate polynomials
        const sP = -wP * ppp + 2 * wP * pp - wP * p;
        const s0 = (1 + wP) * ppp + (-1.5 - 2 * wP) * pp + (-0.5 + wP) * p + 1;
        const s1 = (-1 - wN) * ppp + (1.5 + wN) * pp + 0.5 * p;
        const sN = wN * ppp - wN * pp;
        // combine data linearly
        for(let i = 0; i !== stride; ++i)result[i] = sP * values[oP + i] + s0 * values[o0 + i] + s1 * values[o1 + i] + sN * values[oN + i];
        return result;
    }
});
function LinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    Interpolant.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
}
LinearInterpolant.prototype = Object.assign(Object.create(Interpolant.prototype), {
    constructor: LinearInterpolant,
    interpolate_: function(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, offset1 = i1 * stride, offset0 = offset1 - stride, weight1 = (t - t0) / (t1 - t0), weight0 = 1 - weight1;
        for(let i = 0; i !== stride; ++i)result[i] = values[offset0 + i] * weight0 + values[offset1 + i] * weight1;
        return result;
    }
});
/**
 *
 * Interpolant that evaluates to the sample value at the position preceeding
 * the parameter.
 */ function DiscreteInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    Interpolant.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
}
DiscreteInterpolant.prototype = Object.assign(Object.create(Interpolant.prototype), {
    constructor: DiscreteInterpolant,
    interpolate_: function(i1 /*, t0, t, t1 */ ) {
        return this.copySampleValue_(i1 - 1);
    }
});
function KeyframeTrack(name, times, values, interpolation) {
    if (name === undefined) throw new Error('THREE.KeyframeTrack: track name is undefined');
    if (times === undefined || times.length === 0) throw new Error('THREE.KeyframeTrack: no keyframes in track named ' + name);
    this.name = name;
    this.times = AnimationUtils.convertArray(times, this.TimeBufferType);
    this.values = AnimationUtils.convertArray(values, this.ValueBufferType);
    this.setInterpolation(interpolation || this.DefaultInterpolation);
}
// Static methods
Object.assign(KeyframeTrack, {
    // Serialization (in static context, because of constructor invocation
    // and automatic invocation of .toJSON):
    toJSON: function(track) {
        const trackType = track.constructor;
        let json;
        // derived classes can define a static toJSON method
        if (trackType.toJSON !== undefined) json = trackType.toJSON(track);
        else {
            // by default, we assume the data can be serialized as-is
            json = {
                'name': track.name,
                'times': AnimationUtils.convertArray(track.times, Array),
                'values': AnimationUtils.convertArray(track.values, Array)
            };
            const interpolation = track.getInterpolation();
            if (interpolation !== track.DefaultInterpolation) json.interpolation = interpolation;
        }
        json.type = track.ValueTypeName; // mandatory
        return json;
    }
});
Object.assign(KeyframeTrack.prototype, {
    constructor: KeyframeTrack,
    TimeBufferType: Float32Array,
    ValueBufferType: Float32Array,
    DefaultInterpolation: InterpolateLinear,
    InterpolantFactoryMethodDiscrete: function(result) {
        return new DiscreteInterpolant(this.times, this.values, this.getValueSize(), result);
    },
    InterpolantFactoryMethodLinear: function(result) {
        return new LinearInterpolant(this.times, this.values, this.getValueSize(), result);
    },
    InterpolantFactoryMethodSmooth: function(result) {
        return new CubicInterpolant(this.times, this.values, this.getValueSize(), result);
    },
    setInterpolation: function(interpolation) {
        let factoryMethod;
        switch(interpolation){
            case InterpolateDiscrete:
                factoryMethod = this.InterpolantFactoryMethodDiscrete;
                break;
            case InterpolateLinear:
                factoryMethod = this.InterpolantFactoryMethodLinear;
                break;
            case InterpolateSmooth:
                factoryMethod = this.InterpolantFactoryMethodSmooth;
                break;
        }
        if (factoryMethod === undefined) {
            const message = 'unsupported interpolation for ' + this.ValueTypeName + ' keyframe track named ' + this.name;
            if (this.createInterpolant === undefined) {
                // fall back to default, unless the default itself is messed up
                if (interpolation !== this.DefaultInterpolation) this.setInterpolation(this.DefaultInterpolation);
                else throw new Error(message); // fatal, in this case
            }
            console.warn('THREE.KeyframeTrack:', message);
            return this;
        }
        this.createInterpolant = factoryMethod;
        return this;
    },
    getInterpolation: function() {
        switch(this.createInterpolant){
            case this.InterpolantFactoryMethodDiscrete:
                return InterpolateDiscrete;
            case this.InterpolantFactoryMethodLinear:
                return InterpolateLinear;
            case this.InterpolantFactoryMethodSmooth:
                return InterpolateSmooth;
        }
    },
    getValueSize: function() {
        return this.values.length / this.times.length;
    },
    // move all keyframes either forwards or backwards in time
    shift: function(timeOffset) {
        if (timeOffset !== 0.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] += timeOffset;
        }
        return this;
    },
    // scale all keyframe times by a factor (useful for frame <-> seconds conversions)
    scale: function(timeScale) {
        if (timeScale !== 1.0) {
            const times = this.times;
            for(let i = 0, n = times.length; i !== n; ++i)times[i] *= timeScale;
        }
        return this;
    },
    // removes keyframes before and after animation without changing any values within the range [startTime, endTime].
    // IMPORTANT: We do not shift around keys to the start of the track time, because for interpolated keys this will change their values
    trim: function(startTime, endTime) {
        const times = this.times, nKeys = times.length;
        let from = 0, to = nKeys - 1;
        while(from !== nKeys && times[from] < startTime)++from;
        while(to !== -1 && times[to] > endTime)--to;
        ++to; // inclusive -> exclusive bound
        if (from !== 0 || to !== nKeys) {
            // empty tracks are forbidden, so keep at least one keyframe
            if (from >= to) {
                to = Math.max(to, 1);
                from = to - 1;
            }
            const stride = this.getValueSize();
            this.times = AnimationUtils.arraySlice(times, from, to);
            this.values = AnimationUtils.arraySlice(this.values, from * stride, to * stride);
        }
        return this;
    },
    // ensure we do not get a GarbageInGarbageOut situation, make sure tracks are at least minimally viable
    validate: function() {
        let valid = true;
        const valueSize = this.getValueSize();
        if (valueSize - Math.floor(valueSize) !== 0) {
            console.error('THREE.KeyframeTrack: Invalid value size in track.', this);
            valid = false;
        }
        const times = this.times, values = this.values, nKeys = times.length;
        if (nKeys === 0) {
            console.error('THREE.KeyframeTrack: Track is empty.', this);
            valid = false;
        }
        let prevTime = null;
        for(let i = 0; i !== nKeys; i++){
            const currTime = times[i];
            if (typeof currTime === 'number' && isNaN(currTime)) {
                console.error('THREE.KeyframeTrack: Time is not a valid number.', this, i, currTime);
                valid = false;
                break;
            }
            if (prevTime !== null && prevTime > currTime) {
                console.error('THREE.KeyframeTrack: Out of order keys.', this, i, currTime, prevTime);
                valid = false;
                break;
            }
            prevTime = currTime;
        }
        if (values !== undefined) {
            if (AnimationUtils.isTypedArray(values)) for(let i = 0, n = values.length; i !== n; ++i){
                const value = values[i];
                if (isNaN(value)) {
                    console.error('THREE.KeyframeTrack: Value is not a valid number.', this, i, value);
                    valid = false;
                    break;
                }
            }
        }
        return valid;
    },
    // removes equivalent sequential keys as common in morph target sequences
    // (0,0,0,0,1,1,1,0,0,0,0,0,0,0) --> (0,0,1,1,0,0)
    optimize: function() {
        // times or values may be shared with other tracks, so overwriting is unsafe
        const times = AnimationUtils.arraySlice(this.times), values = AnimationUtils.arraySlice(this.values), stride = this.getValueSize(), smoothInterpolation = this.getInterpolation() === InterpolateSmooth, lastIndex = times.length - 1;
        let writeIndex = 1;
        for(let i = 1; i < lastIndex; ++i){
            let keep = false;
            const time = times[i];
            const timeNext = times[i + 1];
            // remove adjacent keyframes scheduled at the same time
            if (time !== timeNext && (i !== 1 || time !== times[0])) {
                if (!smoothInterpolation) {
                    // remove unnecessary keyframes same as their neighbors
                    const offset = i * stride, offsetP = offset - stride, offsetN = offset + stride;
                    for(let j = 0; j !== stride; ++j){
                        const value = values[offset + j];
                        if (value !== values[offsetP + j] || value !== values[offsetN + j]) {
                            keep = true;
                            break;
                        }
                    }
                } else keep = true;
            }
            // in-place compaction
            if (keep) {
                if (i !== writeIndex) {
                    times[writeIndex] = times[i];
                    const readOffset = i * stride, writeOffset = writeIndex * stride;
                    for(let j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
                }
                ++writeIndex;
            }
        }
        // flush last keyframe (compaction looks ahead)
        if (lastIndex > 0) {
            times[writeIndex] = times[lastIndex];
            for(let readOffset = lastIndex * stride, writeOffset = writeIndex * stride, j = 0; j !== stride; ++j)values[writeOffset + j] = values[readOffset + j];
            ++writeIndex;
        }
        if (writeIndex !== times.length) {
            this.times = AnimationUtils.arraySlice(times, 0, writeIndex);
            this.values = AnimationUtils.arraySlice(values, 0, writeIndex * stride);
        } else {
            this.times = times;
            this.values = values;
        }
        return this;
    },
    clone: function() {
        const times = AnimationUtils.arraySlice(this.times, 0);
        const values = AnimationUtils.arraySlice(this.values, 0);
        const TypedKeyframeTrack = this.constructor;
        const track = new TypedKeyframeTrack(this.name, times, values);
        // Interpolant argument to constructor is not saved, so copy the factory method directly.
        track.createInterpolant = this.createInterpolant;
        return track;
    }
});
/**
 * A Track of Boolean keyframe values.
 */ function BooleanKeyframeTrack(name, times, values) {
    KeyframeTrack.call(this, name, times, values);
}
BooleanKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: BooleanKeyframeTrack,
    ValueTypeName: 'bool',
    ValueBufferType: Array,
    DefaultInterpolation: InterpolateDiscrete,
    InterpolantFactoryMethodLinear: undefined,
    InterpolantFactoryMethodSmooth: undefined
});
/**
 * A Track of keyframe values that represent color.
 */ function ColorKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
ColorKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: ColorKeyframeTrack,
    ValueTypeName: 'color'
});
/**
 * A Track of numeric keyframe values.
 */ function NumberKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
NumberKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: NumberKeyframeTrack,
    ValueTypeName: 'number'
});
/**
 * Spherical linear unit quaternion interpolant.
 */ function QuaternionLinearInterpolant(parameterPositions, sampleValues, sampleSize, resultBuffer) {
    Interpolant.call(this, parameterPositions, sampleValues, sampleSize, resultBuffer);
}
QuaternionLinearInterpolant.prototype = Object.assign(Object.create(Interpolant.prototype), {
    constructor: QuaternionLinearInterpolant,
    interpolate_: function(i1, t0, t, t1) {
        const result = this.resultBuffer, values = this.sampleValues, stride = this.valueSize, alpha = (t - t0) / (t1 - t0);
        let offset = i1 * stride;
        for(let end = offset + stride; offset !== end; offset += 4)Quaternion.slerpFlat(result, 0, values, offset - stride, values, offset, alpha);
        return result;
    }
});
/**
 * A Track of quaternion keyframe values.
 */ function QuaternionKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
QuaternionKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: QuaternionKeyframeTrack,
    ValueTypeName: 'quaternion',
    // ValueBufferType is inherited
    DefaultInterpolation: InterpolateLinear,
    InterpolantFactoryMethodLinear: function(result) {
        return new QuaternionLinearInterpolant(this.times, this.values, this.getValueSize(), result);
    },
    InterpolantFactoryMethodSmooth: undefined // not yet implemented
});
/**
 * A Track that interpolates Strings
 */ function StringKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
StringKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: StringKeyframeTrack,
    ValueTypeName: 'string',
    ValueBufferType: Array,
    DefaultInterpolation: InterpolateDiscrete,
    InterpolantFactoryMethodLinear: undefined,
    InterpolantFactoryMethodSmooth: undefined
});
/**
 * A Track of vectored keyframe values.
 */ function VectorKeyframeTrack(name, times, values, interpolation) {
    KeyframeTrack.call(this, name, times, values, interpolation);
}
VectorKeyframeTrack.prototype = Object.assign(Object.create(KeyframeTrack.prototype), {
    constructor: VectorKeyframeTrack,
    ValueTypeName: 'vector'
});
function AnimationClip(name, duration = -1, tracks, blendMode = NormalAnimationBlendMode) {
    this.name = name;
    this.tracks = tracks;
    this.duration = duration;
    this.blendMode = blendMode;
    this.uuid = MathUtils.generateUUID();
    // this means it should figure out its duration by scanning the tracks
    if (this.duration < 0) this.resetDuration();
}
function getTrackTypeForValueTypeName(typeName) {
    switch(typeName.toLowerCase()){
        case 'scalar':
        case 'double':
        case 'float':
        case 'number':
        case 'integer':
            return NumberKeyframeTrack;
        case 'vector':
        case 'vector2':
        case 'vector3':
        case 'vector4':
            return VectorKeyframeTrack;
        case 'color':
            return ColorKeyframeTrack;
        case 'quaternion':
            return QuaternionKeyframeTrack;
        case 'bool':
        case 'boolean':
            return BooleanKeyframeTrack;
        case 'string':
            return StringKeyframeTrack;
    }
    throw new Error('THREE.KeyframeTrack: Unsupported typeName: ' + typeName);
}
function parseKeyframeTrack(json) {
    if (json.type === undefined) throw new Error('THREE.KeyframeTrack: track type undefined, can not parse');
    const trackType = getTrackTypeForValueTypeName(json.type);
    if (json.times === undefined) {
        const times = [], values = [];
        AnimationUtils.flattenJSON(json.keys, times, values, 'value');
        json.times = times;
        json.values = values;
    }
    // derived classes can define a static parse method
    if (trackType.parse !== undefined) return trackType.parse(json);
    else // by default, we assume a constructor compatible with the base
    return new trackType(json.name, json.times, json.values, json.interpolation);
}
Object.assign(AnimationClip, {
    parse: function(json) {
        const tracks = [], jsonTracks = json.tracks, frameTime = 1.0 / (json.fps || 1.0);
        for(let i = 0, n = jsonTracks.length; i !== n; ++i)tracks.push(parseKeyframeTrack(jsonTracks[i]).scale(frameTime));
        const clip = new AnimationClip(json.name, json.duration, tracks, json.blendMode);
        clip.uuid = json.uuid;
        return clip;
    },
    toJSON: function(clip) {
        const tracks = [], clipTracks = clip.tracks;
        const json = {
            'name': clip.name,
            'duration': clip.duration,
            'tracks': tracks,
            'uuid': clip.uuid,
            'blendMode': clip.blendMode
        };
        for(let i = 0, n = clipTracks.length; i !== n; ++i)tracks.push(KeyframeTrack.toJSON(clipTracks[i]));
        return json;
    },
    CreateFromMorphTargetSequence: function(name, morphTargetSequence, fps, noLoop) {
        const numMorphTargets = morphTargetSequence.length;
        const tracks = [];
        for(let i = 0; i < numMorphTargets; i++){
            let times = [];
            let values = [];
            times.push((i + numMorphTargets - 1) % numMorphTargets, i, (i + 1) % numMorphTargets);
            values.push(0, 1, 0);
            const order = AnimationUtils.getKeyframeOrder(times);
            times = AnimationUtils.sortedArray(times, 1, order);
            values = AnimationUtils.sortedArray(values, 1, order);
            // if there is a key at the first frame, duplicate it as the
            // last frame as well for perfect loop.
            if (!noLoop && times[0] === 0) {
                times.push(numMorphTargets);
                values.push(values[0]);
            }
            tracks.push(new NumberKeyframeTrack('.morphTargetInfluences[' + morphTargetSequence[i].name + ']', times, values).scale(1.0 / fps));
        }
        return new AnimationClip(name, -1, tracks);
    },
    findByName: function(objectOrClipArray, name) {
        let clipArray = objectOrClipArray;
        if (!Array.isArray(objectOrClipArray)) {
            const o = objectOrClipArray;
            clipArray = o.geometry && o.geometry.animations || o.animations;
        }
        for(let i = 0; i < clipArray.length; i++){
            if (clipArray[i].name === name) return clipArray[i];
        }
        return null;
    },
    CreateClipsFromMorphTargetSequences: function(morphTargets, fps, noLoop) {
        const animationToMorphTargets = {};
        // tested with https://regex101.com/ on trick sequences
        // such flamingo_flyA_003, flamingo_run1_003, crdeath0059
        const pattern = /^([\w-]*?)([\d]+)$/;
        // sort morph target names into animation groups based
        // patterns like Walk_001, Walk_002, Run_001, Run_002
        for(let i = 0, il = morphTargets.length; i < il; i++){
            const morphTarget = morphTargets[i];
            const parts = morphTarget.name.match(pattern);
            if (parts && parts.length > 1) {
                const name = parts[1];
                let animationMorphTargets = animationToMorphTargets[name];
                if (!animationMorphTargets) animationToMorphTargets[name] = animationMorphTargets = [];
                animationMorphTargets.push(morphTarget);
            }
        }
        const clips = [];
        for(const name in animationToMorphTargets)clips.push(AnimationClip.CreateFromMorphTargetSequence(name, animationToMorphTargets[name], fps, noLoop));
        return clips;
    },
    // parse the animation.hierarchy format
    parseAnimation: function(animation, bones) {
        if (!animation) {
            console.error('THREE.AnimationClip: No animation in JSONLoader data.');
            return null;
        }
        const addNonemptyTrack = function(trackType, trackName, animationKeys, propertyName, destTracks) {
            // only return track if there are actually keys.
            if (animationKeys.length !== 0) {
                const times = [];
                const values = [];
                AnimationUtils.flattenJSON(animationKeys, times, values, propertyName);
                // empty keys are filtered out, so check again
                if (times.length !== 0) destTracks.push(new trackType(trackName, times, values));
            }
        };
        const tracks = [];
        const clipName = animation.name || 'default';
        const fps = animation.fps || 30;
        const blendMode = animation.blendMode;
        // automatic length determination in AnimationClip.
        let duration = animation.length || -1;
        const hierarchyTracks = animation.hierarchy || [];
        for(let h = 0; h < hierarchyTracks.length; h++){
            const animationKeys = hierarchyTracks[h].keys;
            // skip empty tracks
            if (!animationKeys || animationKeys.length === 0) continue;
            // process morph targets
            if (animationKeys[0].morphTargets) {
                // figure out all morph targets used in this track
                const morphTargetNames = {};
                let k;
                for(k = 0; k < animationKeys.length; k++){
                    if (animationKeys[k].morphTargets) for(let m = 0; m < animationKeys[k].morphTargets.length; m++)morphTargetNames[animationKeys[k].morphTargets[m]] = -1;
                }
                // create a track for each morph target with all zero
                // morphTargetInfluences except for the keys in which
                // the morphTarget is named.
                for(const morphTargetName in morphTargetNames){
                    const times = [];
                    const values = [];
                    for(let m = 0; m !== animationKeys[k].morphTargets.length; ++m){
                        const animationKey = animationKeys[k];
                        times.push(animationKey.time);
                        values.push(animationKey.morphTarget === morphTargetName ? 1 : 0);
                    }
                    tracks.push(new NumberKeyframeTrack('.morphTargetInfluence[' + morphTargetName + ']', times, values));
                }
                duration = morphTargetNames.length * (fps || 1.0);
            } else {
                // ...assume skeletal animation
                const boneName = '.bones[' + bones[h].name + ']';
                addNonemptyTrack(VectorKeyframeTrack, boneName + '.position', animationKeys, 'pos', tracks);
                addNonemptyTrack(QuaternionKeyframeTrack, boneName + '.quaternion', animationKeys, 'rot', tracks);
                addNonemptyTrack(VectorKeyframeTrack, boneName + '.scale', animationKeys, 'scl', tracks);
            }
        }
        if (tracks.length === 0) return null;
        const clip = new AnimationClip(clipName, duration, tracks, blendMode);
        return clip;
    }
});
Object.assign(AnimationClip.prototype, {
    resetDuration: function() {
        const tracks = this.tracks;
        let duration = 0;
        for(let i = 0, n = tracks.length; i !== n; ++i){
            const track = this.tracks[i];
            duration = Math.max(duration, track.times[track.times.length - 1]);
        }
        this.duration = duration;
        return this;
    },
    trim: function() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].trim(0, this.duration);
        return this;
    },
    validate: function() {
        let valid = true;
        for(let i = 0; i < this.tracks.length; i++)valid = valid && this.tracks[i].validate();
        return valid;
    },
    optimize: function() {
        for(let i = 0; i < this.tracks.length; i++)this.tracks[i].optimize();
        return this;
    },
    clone: function() {
        const tracks = [];
        for(let i = 0; i < this.tracks.length; i++)tracks.push(this.tracks[i].clone());
        return new AnimationClip(this.name, this.duration, tracks, this.blendMode);
    },
    toJSON: function() {
        return AnimationClip.toJSON(this);
    }
});
const Cache = {
    enabled: false,
    files: {},
    add: function(key, file) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Adding key:', key );
        this.files[key] = file;
    },
    get: function(key) {
        if (this.enabled === false) return;
        // console.log( 'THREE.Cache', 'Checking key:', key );
        return this.files[key];
    },
    remove: function(key) {
        delete this.files[key];
    },
    clear: function() {
        this.files = {};
    }
};
function LoadingManager(onLoad, onProgress, onError) {
    const scope = this;
    let isLoading = false;
    let itemsLoaded = 0;
    let itemsTotal = 0;
    let urlModifier = undefined;
    const handlers = [];
    // Refer to #5689 for the reason why we don't set .onStart
    // in the constructor
    this.onStart = undefined;
    this.onLoad = onLoad;
    this.onProgress = onProgress;
    this.onError = onError;
    this.itemStart = function(url) {
        itemsTotal++;
        if (isLoading === false) {
            if (scope.onStart !== undefined) scope.onStart(url, itemsLoaded, itemsTotal);
        }
        isLoading = true;
    };
    this.itemEnd = function(url) {
        itemsLoaded++;
        if (scope.onProgress !== undefined) scope.onProgress(url, itemsLoaded, itemsTotal);
        if (itemsLoaded === itemsTotal) {
            isLoading = false;
            if (scope.onLoad !== undefined) scope.onLoad();
        }
    };
    this.itemError = function(url) {
        if (scope.onError !== undefined) scope.onError(url);
    };
    this.resolveURL = function(url) {
        if (urlModifier) return urlModifier(url);
        return url;
    };
    this.setURLModifier = function(transform) {
        urlModifier = transform;
        return this;
    };
    this.addHandler = function(regex, loader) {
        handlers.push(regex, loader);
        return this;
    };
    this.removeHandler = function(regex) {
        const index = handlers.indexOf(regex);
        if (index !== -1) handlers.splice(index, 2);
        return this;
    };
    this.getHandler = function(file) {
        for(let i = 0, l = handlers.length; i < l; i += 2){
            const regex = handlers[i];
            const loader = handlers[i + 1];
            if (regex.global) regex.lastIndex = 0; // see #17920
            if (regex.test(file)) return loader;
        }
        return null;
    };
}
const DefaultLoadingManager = new LoadingManager();
function Loader(manager) {
    this.manager = manager !== undefined ? manager : DefaultLoadingManager;
    this.crossOrigin = 'anonymous';
    this.withCredentials = false;
    this.path = '';
    this.resourcePath = '';
    this.requestHeader = {};
}
Object.assign(Loader.prototype, {
    load: function() {},
    loadAsync: function(url, onProgress) {
        const scope = this;
        return new Promise(function(resolve, reject) {
            scope.load(url, resolve, onProgress, reject);
        });
    },
    parse: function() {},
    setCrossOrigin: function(crossOrigin) {
        this.crossOrigin = crossOrigin;
        return this;
    },
    setWithCredentials: function(value) {
        this.withCredentials = value;
        return this;
    },
    setPath: function(path) {
        this.path = path;
        return this;
    },
    setResourcePath: function(resourcePath) {
        this.resourcePath = resourcePath;
        return this;
    },
    setRequestHeader: function(requestHeader) {
        this.requestHeader = requestHeader;
        return this;
    }
});
const loading = {};
function FileLoader(manager) {
    Loader.call(this, manager);
}
FileLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: FileLoader,
    load: function(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = Cache.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        // Check if request is duplicate
        if (loading[url] !== undefined) {
            loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            return;
        }
        // Check for data: URI
        const dataUriRegex = /^data:(.*?)(;base64)?,(.*)$/;
        const dataUriRegexResult = url.match(dataUriRegex);
        let request;
        // Safari can not handle Data URIs through XMLHttpRequest so process manually
        if (dataUriRegexResult) {
            const mimeType = dataUriRegexResult[1];
            const isBase64 = !!dataUriRegexResult[2];
            let data = dataUriRegexResult[3];
            data = decodeURIComponent(data);
            if (isBase64) data = atob(data);
            try {
                let response;
                const responseType = (this.responseType || '').toLowerCase();
                switch(responseType){
                    case 'arraybuffer':
                    case 'blob':
                        const view = new Uint8Array(data.length);
                        for(let i = 0; i < data.length; i++)view[i] = data.charCodeAt(i);
                        if (responseType === 'blob') response = new Blob([
                            view.buffer
                        ], {
                            type: mimeType
                        });
                        else response = view.buffer;
                        break;
                    case 'document':
                        const parser = new DOMParser();
                        response = parser.parseFromString(data, mimeType);
                        break;
                    case 'json':
                        response = JSON.parse(data);
                        break;
                    default:
                        response = data;
                        break;
                }
                // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                setTimeout(function() {
                    if (onLoad) onLoad(response);
                    scope.manager.itemEnd(url);
                }, 0);
            } catch (error) {
                // Wait for next browser tick like standard XMLHttpRequest event dispatching does
                setTimeout(function() {
                    if (onError) onError(error);
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }, 0);
            }
        } else {
            // Initialise array for duplicate requests
            loading[url] = [];
            loading[url].push({
                onLoad: onLoad,
                onProgress: onProgress,
                onError: onError
            });
            request = new XMLHttpRequest();
            request.open('GET', url, true);
            request.addEventListener('load', function(event) {
                const response = this.response;
                const callbacks = loading[url];
                delete loading[url];
                if (this.status === 200 || this.status === 0) {
                    // Some browsers return HTTP Status 0 when using non-http protocol
                    // e.g. 'file://' or 'data://'. Handle as success.
                    if (this.status === 0) console.warn('THREE.FileLoader: HTTP Status 0 received.');
                    // Add to cache only on HTTP success, so that we do not cache
                    // error response bodies as proper responses to requests.
                    Cache.add(url, response);
                    for(let i = 0, il = callbacks.length; i < il; i++){
                        const callback = callbacks[i];
                        if (callback.onLoad) callback.onLoad(response);
                    }
                    scope.manager.itemEnd(url);
                } else {
                    for(let i = 0, il = callbacks.length; i < il; i++){
                        const callback = callbacks[i];
                        if (callback.onError) callback.onError(event);
                    }
                    scope.manager.itemError(url);
                    scope.manager.itemEnd(url);
                }
            }, false);
            request.addEventListener('progress', function(event) {
                const callbacks = loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onProgress) callback.onProgress(event);
                }
            }, false);
            request.addEventListener('error', function(event) {
                const callbacks = loading[url];
                delete loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onError) callback.onError(event);
                }
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            }, false);
            request.addEventListener('abort', function(event) {
                const callbacks = loading[url];
                delete loading[url];
                for(let i = 0, il = callbacks.length; i < il; i++){
                    const callback = callbacks[i];
                    if (callback.onError) callback.onError(event);
                }
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            }, false);
            if (this.responseType !== undefined) request.responseType = this.responseType;
            if (this.withCredentials !== undefined) request.withCredentials = this.withCredentials;
            if (request.overrideMimeType) request.overrideMimeType(this.mimeType !== undefined ? this.mimeType : 'text/plain');
            for(const header in this.requestHeader)request.setRequestHeader(header, this.requestHeader[header]);
            request.send(null);
        }
        scope.manager.itemStart(url);
        return request;
    },
    setResponseType: function(value) {
        this.responseType = value;
        return this;
    },
    setMimeType: function(value) {
        this.mimeType = value;
        return this;
    }
});
function AnimationLoader(manager) {
    Loader.call(this, manager);
}
AnimationLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: AnimationLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    },
    parse: function(json) {
        const animations = [];
        for(let i = 0; i < json.length; i++){
            const clip = AnimationClip.parse(json[i]);
            animations.push(clip);
        }
        return animations;
    }
});
/**
 * Abstract Base class to block based textures loader (dds, pvr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ function CompressedTextureLoader(manager) {
    Loader.call(this, manager);
}
CompressedTextureLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: CompressedTextureLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const images = [];
        const texture = new CompressedTexture();
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(url[i], function(buffer) {
                const texDatas = scope.parse(buffer, true);
                images[i] = {
                    width: texDatas.width,
                    height: texDatas.height,
                    format: texDatas.format,
                    mipmaps: texDatas.mipmaps
                };
                loaded += 1;
                if (loaded === 6) {
                    if (texDatas.mipmapCount === 1) texture.minFilter = LinearFilter;
                    texture.image = images;
                    texture.format = texDatas.format;
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, onProgress, onError);
        }
        if (Array.isArray(url)) for(let i = 0, il = url.length; i < il; ++i)loadTexture(i);
        else // compressed cubemap texture stored in a single DDS file
        loader.load(url, function(buffer) {
            const texDatas = scope.parse(buffer, true);
            if (texDatas.isCubemap) {
                const faces = texDatas.mipmaps.length / texDatas.mipmapCount;
                for(let f = 0; f < faces; f++){
                    images[f] = {
                        mipmaps: []
                    };
                    for(let i = 0; i < texDatas.mipmapCount; i++){
                        images[f].mipmaps.push(texDatas.mipmaps[f * texDatas.mipmapCount + i]);
                        images[f].format = texDatas.format;
                        images[f].width = texDatas.width;
                        images[f].height = texDatas.height;
                    }
                }
                texture.image = images;
            } else {
                texture.image.width = texDatas.width;
                texture.image.height = texDatas.height;
                texture.mipmaps = texDatas.mipmaps;
            }
            if (texDatas.mipmapCount === 1) texture.minFilter = LinearFilter;
            texture.format = texDatas.format;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
});
function ImageLoader(manager) {
    Loader.call(this, manager);
}
ImageLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: ImageLoader,
    load: function(url, onLoad, onProgress, onError) {
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = Cache.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const image = document.createElementNS('http://www.w3.org/1999/xhtml', 'img');
        function onImageLoad() {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
            Cache.add(url, this);
            if (onLoad) onLoad(this);
            scope.manager.itemEnd(url);
        }
        function onImageError(event) {
            image.removeEventListener('load', onImageLoad, false);
            image.removeEventListener('error', onImageError, false);
            if (onError) onError(event);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        }
        image.addEventListener('load', onImageLoad, false);
        image.addEventListener('error', onImageError, false);
        if (url.substr(0, 5) !== 'data:') {
            if (this.crossOrigin !== undefined) image.crossOrigin = this.crossOrigin;
        }
        scope.manager.itemStart(url);
        image.src = url;
        return image;
    }
});
function CubeTextureLoader(manager) {
    Loader.call(this, manager);
}
CubeTextureLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: CubeTextureLoader,
    load: function(urls, onLoad, onProgress, onError) {
        const texture = new CubeTexture();
        const loader = new ImageLoader(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        let loaded = 0;
        function loadTexture(i) {
            loader.load(urls[i], function(image) {
                texture.images[i] = image;
                loaded++;
                if (loaded === 6) {
                    texture.needsUpdate = true;
                    if (onLoad) onLoad(texture);
                }
            }, undefined, onError);
        }
        for(let i = 0; i < urls.length; ++i)loadTexture(i);
        return texture;
    }
});
/**
 * Abstract Base class to load generic binary textures formats (rgbe, hdr, ...)
 *
 * Sub classes have to implement the parse() method which will be used in load().
 */ function DataTextureLoader(manager) {
    Loader.call(this, manager);
}
DataTextureLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: DataTextureLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const texture = new DataTexture();
        const loader = new FileLoader(this.manager);
        loader.setResponseType('arraybuffer');
        loader.setRequestHeader(this.requestHeader);
        loader.setPath(this.path);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            const texData = scope.parse(buffer);
            if (!texData) return;
            if (texData.image !== undefined) texture.image = texData.image;
            else if (texData.data !== undefined) {
                texture.image.width = texData.width;
                texture.image.height = texData.height;
                texture.image.data = texData.data;
            }
            texture.wrapS = texData.wrapS !== undefined ? texData.wrapS : ClampToEdgeWrapping;
            texture.wrapT = texData.wrapT !== undefined ? texData.wrapT : ClampToEdgeWrapping;
            texture.magFilter = texData.magFilter !== undefined ? texData.magFilter : LinearFilter;
            texture.minFilter = texData.minFilter !== undefined ? texData.minFilter : LinearFilter;
            texture.anisotropy = texData.anisotropy !== undefined ? texData.anisotropy : 1;
            if (texData.encoding !== undefined) texture.encoding = texData.encoding;
            if (texData.flipY !== undefined) texture.flipY = texData.flipY;
            if (texData.format !== undefined) texture.format = texData.format;
            if (texData.type !== undefined) texture.type = texData.type;
            if (texData.mipmaps !== undefined) {
                texture.mipmaps = texData.mipmaps;
                texture.minFilter = LinearMipmapLinearFilter; // presumably...
            }
            if (texData.mipmapCount === 1) texture.minFilter = LinearFilter;
            texture.needsUpdate = true;
            if (onLoad) onLoad(texture, texData);
        }, onProgress, onError);
        return texture;
    }
});
function TextureLoader(manager) {
    Loader.call(this, manager);
}
TextureLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: TextureLoader,
    load: function(url, onLoad, onProgress, onError) {
        const texture = new Texture();
        const loader = new ImageLoader(this.manager);
        loader.setCrossOrigin(this.crossOrigin);
        loader.setPath(this.path);
        loader.load(url, function(image) {
            texture.image = image;
            // JPEGs can't have an alpha channel, so memory can be saved by storing them as RGB.
            const isJPEG = url.search(/\.jpe?g($|\?)/i) > 0 || url.search(/^data\:image\/jpeg/) === 0;
            texture.format = isJPEG ? RGBFormat : RGBAFormat;
            texture.needsUpdate = true;
            if (onLoad !== undefined) onLoad(texture);
        }, onProgress, onError);
        return texture;
    }
});
/**
 * Extensible curve object.
 *
 * Some common of curve methods:
 * .getPoint( t, optionalTarget ), .getTangent( t, optionalTarget )
 * .getPointAt( u, optionalTarget ), .getTangentAt( u, optionalTarget )
 * .getPoints(), .getSpacedPoints()
 * .getLength()
 * .updateArcLengths()
 *
 * This following curves inherit from THREE.Curve:
 *
 * -- 2D curves --
 * THREE.ArcCurve
 * THREE.CubicBezierCurve
 * THREE.EllipseCurve
 * THREE.LineCurve
 * THREE.QuadraticBezierCurve
 * THREE.SplineCurve
 *
 * -- 3D curves --
 * THREE.CatmullRomCurve3
 * THREE.CubicBezierCurve3
 * THREE.LineCurve3
 * THREE.QuadraticBezierCurve3
 *
 * A series of curves can be represented as a THREE.CurvePath.
 *
 **/ function Curve() {
    this.type = 'Curve';
    this.arcLengthDivisions = 200;
}
Object.assign(Curve.prototype, {
    // Virtual base class method to overwrite and implement in subclasses
    //	- t [0 .. 1]
    getPoint: function() {
        console.warn('THREE.Curve: .getPoint() not implemented.');
        return null;
    },
    // Get point at relative position in curve according to arc length
    // - u [0 .. 1]
    getPointAt: function(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getPoint(t, optionalTarget);
    },
    // Get sequence of points using getPoint( t )
    getPoints: function(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPoint(d / divisions));
        return points;
    },
    // Get sequence of points using getPointAt( u )
    getSpacedPoints: function(divisions = 5) {
        const points = [];
        for(let d = 0; d <= divisions; d++)points.push(this.getPointAt(d / divisions));
        return points;
    },
    // Get total curve arc length
    getLength: function() {
        const lengths = this.getLengths();
        return lengths[lengths.length - 1];
    },
    // Get list of cumulative segment lengths
    getLengths: function(divisions) {
        if (divisions === undefined) divisions = this.arcLengthDivisions;
        if (this.cacheArcLengths && this.cacheArcLengths.length === divisions + 1 && !this.needsUpdate) return this.cacheArcLengths;
        this.needsUpdate = false;
        const cache = [];
        let current, last = this.getPoint(0);
        let sum = 0;
        cache.push(0);
        for(let p = 1; p <= divisions; p++){
            current = this.getPoint(p / divisions);
            sum += current.distanceTo(last);
            cache.push(sum);
            last = current;
        }
        this.cacheArcLengths = cache;
        return cache; // { sums: cache, sum: sum }; Sum is in the last element.
    },
    updateArcLengths: function() {
        this.needsUpdate = true;
        this.getLengths();
    },
    // Given u ( 0 .. 1 ), get a t to find p. This gives you points which are equidistant
    getUtoTmapping: function(u, distance) {
        const arcLengths = this.getLengths();
        let i = 0;
        const il = arcLengths.length;
        let targetArcLength; // The targeted u distance value to get
        if (distance) targetArcLength = distance;
        else targetArcLength = u * arcLengths[il - 1];
        // binary search for the index with largest value smaller than target u distance
        let low = 0, high = il - 1, comparison;
        while(low <= high){
            i = Math.floor(low + (high - low) / 2); // less likely to overflow, though probably not issue here, JS doesn't really have integers, all numbers are floats
            comparison = arcLengths[i] - targetArcLength;
            if (comparison < 0) low = i + 1;
            else if (comparison > 0) high = i - 1;
            else {
                high = i;
                break;
            // DONE
            }
        }
        i = high;
        if (arcLengths[i] === targetArcLength) return i / (il - 1);
        // we could get finer grain at lengths, or use simple interpolation between two points
        const lengthBefore = arcLengths[i];
        const lengthAfter = arcLengths[i + 1];
        const segmentLength = lengthAfter - lengthBefore;
        // determine where we are between the 'before' and 'after' points
        const segmentFraction = (targetArcLength - lengthBefore) / segmentLength;
        // add that fractional amount to t
        const t = (i + segmentFraction) / (il - 1);
        return t;
    },
    // Returns a unit vector tangent at t
    // In case any sub curve does not implement its tangent derivation,
    // 2 points a small delta apart will be used to find its gradient
    // which seems to give a reasonable approximation
    getTangent: function(t, optionalTarget) {
        const delta = 0.0001;
        let t1 = t - delta;
        let t2 = t + delta;
        // Capping in case of danger
        if (t1 < 0) t1 = 0;
        if (t2 > 1) t2 = 1;
        const pt1 = this.getPoint(t1);
        const pt2 = this.getPoint(t2);
        const tangent = optionalTarget || (pt1.isVector2 ? new Vector2() : new Vector3());
        tangent.copy(pt2).sub(pt1).normalize();
        return tangent;
    },
    getTangentAt: function(u, optionalTarget) {
        const t = this.getUtoTmapping(u);
        return this.getTangent(t, optionalTarget);
    },
    computeFrenetFrames: function(segments, closed) {
        // see http://www.cs.indiana.edu/pub/techreports/TR425.pdf
        const normal = new Vector3();
        const tangents = [];
        const normals = [];
        const binormals = [];
        const vec = new Vector3();
        const mat = new Matrix4();
        // compute the tangent vectors for each segment on the curve
        for(let i = 0; i <= segments; i++){
            const u = i / segments;
            tangents[i] = this.getTangentAt(u, new Vector3());
            tangents[i].normalize();
        }
        // select an initial normal vector perpendicular to the first tangent vector,
        // and in the direction of the minimum tangent xyz component
        normals[0] = new Vector3();
        binormals[0] = new Vector3();
        let min = Number.MAX_VALUE;
        const tx = Math.abs(tangents[0].x);
        const ty = Math.abs(tangents[0].y);
        const tz = Math.abs(tangents[0].z);
        if (tx <= min) {
            min = tx;
            normal.set(1, 0, 0);
        }
        if (ty <= min) {
            min = ty;
            normal.set(0, 1, 0);
        }
        if (tz <= min) normal.set(0, 0, 1);
        vec.crossVectors(tangents[0], normal).normalize();
        normals[0].crossVectors(tangents[0], vec);
        binormals[0].crossVectors(tangents[0], normals[0]);
        // compute the slowly-varying normal and binormal vectors for each segment on the curve
        for(let i = 1; i <= segments; i++){
            normals[i] = normals[i - 1].clone();
            binormals[i] = binormals[i - 1].clone();
            vec.crossVectors(tangents[i - 1], tangents[i]);
            if (vec.length() > Number.EPSILON) {
                vec.normalize();
                const theta = Math.acos(MathUtils.clamp(tangents[i - 1].dot(tangents[i]), -1, 1)); // clamp for floating pt errors
                normals[i].applyMatrix4(mat.makeRotationAxis(vec, theta));
            }
            binormals[i].crossVectors(tangents[i], normals[i]);
        }
        // if the curve is closed, postprocess the vectors so the first and last normal vectors are the same
        if (closed === true) {
            let theta = Math.acos(MathUtils.clamp(normals[0].dot(normals[segments]), -1, 1));
            theta /= segments;
            if (tangents[0].dot(vec.crossVectors(normals[0], normals[segments])) > 0) theta = -theta;
            for(let i = 1; i <= segments; i++){
                // twist a little...
                normals[i].applyMatrix4(mat.makeRotationAxis(tangents[i], theta * i));
                binormals[i].crossVectors(tangents[i], normals[i]);
            }
        }
        return {
            tangents: tangents,
            normals: normals,
            binormals: binormals
        };
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    copy: function(source) {
        this.arcLengthDivisions = source.arcLengthDivisions;
        return this;
    },
    toJSON: function() {
        const data = {
            metadata: {
                version: 4.5,
                type: 'Curve',
                generator: 'Curve.toJSON'
            }
        };
        data.arcLengthDivisions = this.arcLengthDivisions;
        data.type = this.type;
        return data;
    },
    fromJSON: function(json) {
        this.arcLengthDivisions = json.arcLengthDivisions;
        return this;
    }
});
function EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
    Curve.call(this);
    this.type = 'EllipseCurve';
    this.aX = aX || 0;
    this.aY = aY || 0;
    this.xRadius = xRadius || 1;
    this.yRadius = yRadius || 1;
    this.aStartAngle = aStartAngle || 0;
    this.aEndAngle = aEndAngle || 2 * Math.PI;
    this.aClockwise = aClockwise || false;
    this.aRotation = aRotation || 0;
}
EllipseCurve.prototype = Object.create(Curve.prototype);
EllipseCurve.prototype.constructor = EllipseCurve;
EllipseCurve.prototype.isEllipseCurve = true;
EllipseCurve.prototype.getPoint = function(t, optionalTarget) {
    const point = optionalTarget || new Vector2();
    const twoPi = Math.PI * 2;
    let deltaAngle = this.aEndAngle - this.aStartAngle;
    const samePoints = Math.abs(deltaAngle) < Number.EPSILON;
    // ensures that deltaAngle is 0 .. 2 PI
    while(deltaAngle < 0)deltaAngle += twoPi;
    while(deltaAngle > twoPi)deltaAngle -= twoPi;
    if (deltaAngle < Number.EPSILON) {
        if (samePoints) deltaAngle = 0;
        else deltaAngle = twoPi;
    }
    if (this.aClockwise === true && !samePoints) {
        if (deltaAngle === twoPi) deltaAngle = -twoPi;
        else deltaAngle = deltaAngle - twoPi;
    }
    const angle = this.aStartAngle + t * deltaAngle;
    let x = this.aX + this.xRadius * Math.cos(angle);
    let y = this.aY + this.yRadius * Math.sin(angle);
    if (this.aRotation !== 0) {
        const cos = Math.cos(this.aRotation);
        const sin = Math.sin(this.aRotation);
        const tx = x - this.aX;
        const ty = y - this.aY;
        // Rotate the point about the center of the ellipse.
        x = tx * cos - ty * sin + this.aX;
        y = tx * sin + ty * cos + this.aY;
    }
    return point.set(x, y);
};
EllipseCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.aX = source.aX;
    this.aY = source.aY;
    this.xRadius = source.xRadius;
    this.yRadius = source.yRadius;
    this.aStartAngle = source.aStartAngle;
    this.aEndAngle = source.aEndAngle;
    this.aClockwise = source.aClockwise;
    this.aRotation = source.aRotation;
    return this;
};
EllipseCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.aX = this.aX;
    data.aY = this.aY;
    data.xRadius = this.xRadius;
    data.yRadius = this.yRadius;
    data.aStartAngle = this.aStartAngle;
    data.aEndAngle = this.aEndAngle;
    data.aClockwise = this.aClockwise;
    data.aRotation = this.aRotation;
    return data;
};
EllipseCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.aX = json.aX;
    this.aY = json.aY;
    this.xRadius = json.xRadius;
    this.yRadius = json.yRadius;
    this.aStartAngle = json.aStartAngle;
    this.aEndAngle = json.aEndAngle;
    this.aClockwise = json.aClockwise;
    this.aRotation = json.aRotation;
    return this;
};
function ArcCurve(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
    EllipseCurve.call(this, aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
    this.type = 'ArcCurve';
}
ArcCurve.prototype = Object.create(EllipseCurve.prototype);
ArcCurve.prototype.constructor = ArcCurve;
ArcCurve.prototype.isArcCurve = true;
/**
 * Centripetal CatmullRom Curve - which is useful for avoiding
 * cusps and self-intersections in non-uniform catmull rom curves.
 * http://www.cemyuksel.com/research/catmullrom_param/catmullrom.pdf
 *
 * curve.type accepts centripetal(default), chordal and catmullrom
 * curve.tension is used for catmullrom which defaults to 0.5
 */ /*
Based on an optimized c++ solution in
 - http://stackoverflow.com/questions/9489736/catmull-rom-curve-with-no-cusps-and-no-self-intersections/
 - http://ideone.com/NoEbVM

This CubicPoly class could be used for reusing some variables and calculations,
but for three.js curve use, it could be possible inlined and flatten into a single function call
which can be placed in CurveUtils.
*/ function CubicPoly() {
    let c0 = 0, c1 = 0, c2 = 0, c3 = 0;
    /*
	 * Compute coefficients for a cubic polynomial
	 *   p(s) = c0 + c1*s + c2*s^2 + c3*s^3
	 * such that
	 *   p(0) = x0, p(1) = x1
	 *  and
	 *   p'(0) = t0, p'(1) = t1.
	 */ function init(x0, x1, t0, t1) {
        c0 = x0;
        c1 = t0;
        c2 = -3 * x0 + 3 * x1 - 2 * t0 - t1;
        c3 = 2 * x0 - 2 * x1 + t0 + t1;
    }
    return {
        initCatmullRom: function(x0, x1, x2, x3, tension) {
            init(x1, x2, tension * (x2 - x0), tension * (x3 - x1));
        },
        initNonuniformCatmullRom: function(x0, x1, x2, x3, dt0, dt1, dt2) {
            // compute tangents when parameterized in [t1,t2]
            let t1 = (x1 - x0) / dt0 - (x2 - x0) / (dt0 + dt1) + (x2 - x1) / dt1;
            let t2 = (x2 - x1) / dt1 - (x3 - x1) / (dt1 + dt2) + (x3 - x2) / dt2;
            // rescale tangents for parametrization in [0,1]
            t1 *= dt1;
            t2 *= dt1;
            init(x1, x2, t1, t2);
        },
        calc: function(t) {
            const t2 = t * t;
            const t3 = t2 * t;
            return c0 + c1 * t + c2 * t2 + c3 * t3;
        }
    };
}
//
const tmp = new Vector3();
const px = new CubicPoly(), py = new CubicPoly(), pz = new CubicPoly();
function CatmullRomCurve3(points = [], closed = false, curveType = 'centripetal', tension = 0.5) {
    Curve.call(this);
    this.type = 'CatmullRomCurve3';
    this.points = points;
    this.closed = closed;
    this.curveType = curveType;
    this.tension = tension;
}
CatmullRomCurve3.prototype = Object.create(Curve.prototype);
CatmullRomCurve3.prototype.constructor = CatmullRomCurve3;
CatmullRomCurve3.prototype.isCatmullRomCurve3 = true;
CatmullRomCurve3.prototype.getPoint = function(t, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    const points = this.points;
    const l = points.length;
    const p = (l - (this.closed ? 0 : 1)) * t;
    let intPoint = Math.floor(p);
    let weight = p - intPoint;
    if (this.closed) intPoint += intPoint > 0 ? 0 : (Math.floor(Math.abs(intPoint) / l) + 1) * l;
    else if (weight === 0 && intPoint === l - 1) {
        intPoint = l - 2;
        weight = 1;
    }
    let p0, p3; // 4 points (p1 & p2 defined below)
    if (this.closed || intPoint > 0) p0 = points[(intPoint - 1) % l];
    else {
        // extrapolate first point
        tmp.subVectors(points[0], points[1]).add(points[0]);
        p0 = tmp;
    }
    const p1 = points[intPoint % l];
    const p2 = points[(intPoint + 1) % l];
    if (this.closed || intPoint + 2 < l) p3 = points[(intPoint + 2) % l];
    else {
        // extrapolate last point
        tmp.subVectors(points[l - 1], points[l - 2]).add(points[l - 1]);
        p3 = tmp;
    }
    if (this.curveType === 'centripetal' || this.curveType === 'chordal') {
        // init Centripetal / Chordal Catmull-Rom
        const pow = this.curveType === 'chordal' ? 0.5 : 0.25;
        let dt0 = Math.pow(p0.distanceToSquared(p1), pow);
        let dt1 = Math.pow(p1.distanceToSquared(p2), pow);
        let dt2 = Math.pow(p2.distanceToSquared(p3), pow);
        // safety check for repeated points
        if (dt1 < 1e-4) dt1 = 1.0;
        if (dt0 < 1e-4) dt0 = dt1;
        if (dt2 < 1e-4) dt2 = dt1;
        px.initNonuniformCatmullRom(p0.x, p1.x, p2.x, p3.x, dt0, dt1, dt2);
        py.initNonuniformCatmullRom(p0.y, p1.y, p2.y, p3.y, dt0, dt1, dt2);
        pz.initNonuniformCatmullRom(p0.z, p1.z, p2.z, p3.z, dt0, dt1, dt2);
    } else if (this.curveType === 'catmullrom') {
        px.initCatmullRom(p0.x, p1.x, p2.x, p3.x, this.tension);
        py.initCatmullRom(p0.y, p1.y, p2.y, p3.y, this.tension);
        pz.initCatmullRom(p0.z, p1.z, p2.z, p3.z, this.tension);
    }
    point.set(px.calc(weight), py.calc(weight), pz.calc(weight));
    return point;
};
CatmullRomCurve3.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.points = [];
    for(let i = 0, l = source.points.length; i < l; i++){
        const point = source.points[i];
        this.points.push(point.clone());
    }
    this.closed = source.closed;
    this.curveType = source.curveType;
    this.tension = source.tension;
    return this;
};
CatmullRomCurve3.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.points = [];
    for(let i = 0, l = this.points.length; i < l; i++){
        const point = this.points[i];
        data.points.push(point.toArray());
    }
    data.closed = this.closed;
    data.curveType = this.curveType;
    data.tension = this.tension;
    return data;
};
CatmullRomCurve3.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.points = [];
    for(let i = 0, l = json.points.length; i < l; i++){
        const point = json.points[i];
        this.points.push(new Vector3().fromArray(point));
    }
    this.closed = json.closed;
    this.curveType = json.curveType;
    this.tension = json.tension;
    return this;
};
/**
 * Bezier Curves formulas obtained from
 * http://en.wikipedia.org/wiki/Bézier_curve
 */ function CatmullRom(t, p0, p1, p2, p3) {
    const v0 = (p2 - p0) * 0.5;
    const v1 = (p3 - p1) * 0.5;
    const t2 = t * t;
    const t3 = t * t2;
    return (2 * p1 - 2 * p2 + v0 + v1) * t3 + (-3 * p1 + 3 * p2 - 2 * v0 - v1) * t2 + v0 * t + p1;
}
//
function QuadraticBezierP0(t, p) {
    const k = 1 - t;
    return k * k * p;
}
function QuadraticBezierP1(t, p) {
    return 2 * (1 - t) * t * p;
}
function QuadraticBezierP2(t, p) {
    return t * t * p;
}
function QuadraticBezier(t, p0, p1, p2) {
    return QuadraticBezierP0(t, p0) + QuadraticBezierP1(t, p1) + QuadraticBezierP2(t, p2);
}
//
function CubicBezierP0(t, p) {
    const k = 1 - t;
    return k * k * k * p;
}
function CubicBezierP1(t, p) {
    const k = 1 - t;
    return 3 * k * k * t * p;
}
function CubicBezierP2(t, p) {
    return 3 * (1 - t) * t * t * p;
}
function CubicBezierP3(t, p) {
    return t * t * t * p;
}
function CubicBezier(t, p0, p1, p2, p3) {
    return CubicBezierP0(t, p0) + CubicBezierP1(t, p1) + CubicBezierP2(t, p2) + CubicBezierP3(t, p3);
}
function CubicBezierCurve(v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2(), v3 = new Vector2()) {
    Curve.call(this);
    this.type = 'CubicBezierCurve';
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
}
CubicBezierCurve.prototype = Object.create(Curve.prototype);
CubicBezierCurve.prototype.constructor = CubicBezierCurve;
CubicBezierCurve.prototype.isCubicBezierCurve = true;
CubicBezierCurve.prototype.getPoint = function(t, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y));
    return point;
};
CubicBezierCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
};
CubicBezierCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
};
CubicBezierCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
};
function CubicBezierCurve3(v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3(), v3 = new Vector3()) {
    Curve.call(this);
    this.type = 'CubicBezierCurve3';
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
    this.v3 = v3;
}
CubicBezierCurve3.prototype = Object.create(Curve.prototype);
CubicBezierCurve3.prototype.constructor = CubicBezierCurve3;
CubicBezierCurve3.prototype.isCubicBezierCurve3 = true;
CubicBezierCurve3.prototype.getPoint = function(t, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2, v3 = this.v3;
    point.set(CubicBezier(t, v0.x, v1.x, v2.x, v3.x), CubicBezier(t, v0.y, v1.y, v2.y, v3.y), CubicBezier(t, v0.z, v1.z, v2.z, v3.z));
    return point;
};
CubicBezierCurve3.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    this.v3.copy(source.v3);
    return this;
};
CubicBezierCurve3.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    data.v3 = this.v3.toArray();
    return data;
};
CubicBezierCurve3.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    this.v3.fromArray(json.v3);
    return this;
};
function LineCurve(v1 = new Vector2(), v2 = new Vector2()) {
    Curve.call(this);
    this.type = 'LineCurve';
    this.v1 = v1;
    this.v2 = v2;
}
LineCurve.prototype = Object.create(Curve.prototype);
LineCurve.prototype.constructor = LineCurve;
LineCurve.prototype.isLineCurve = true;
LineCurve.prototype.getPoint = function(t, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    if (t === 1) point.copy(this.v2);
    else {
        point.copy(this.v2).sub(this.v1);
        point.multiplyScalar(t).add(this.v1);
    }
    return point;
};
// Line curve is linear, so we can overwrite default getPointAt
LineCurve.prototype.getPointAt = function(u, optionalTarget) {
    return this.getPoint(u, optionalTarget);
};
LineCurve.prototype.getTangent = function(t, optionalTarget) {
    const tangent = optionalTarget || new Vector2();
    tangent.copy(this.v2).sub(this.v1).normalize();
    return tangent;
};
LineCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
};
LineCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
};
LineCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
};
function LineCurve3(v1 = new Vector3(), v2 = new Vector3()) {
    Curve.call(this);
    this.type = 'LineCurve3';
    this.v1 = v1;
    this.v2 = v2;
}
LineCurve3.prototype = Object.create(Curve.prototype);
LineCurve3.prototype.constructor = LineCurve3;
LineCurve3.prototype.isLineCurve3 = true;
LineCurve3.prototype.getPoint = function(t, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    if (t === 1) point.copy(this.v2);
    else {
        point.copy(this.v2).sub(this.v1);
        point.multiplyScalar(t).add(this.v1);
    }
    return point;
};
// Line curve is linear, so we can overwrite default getPointAt
LineCurve3.prototype.getPointAt = function(u, optionalTarget) {
    return this.getPoint(u, optionalTarget);
};
LineCurve3.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
};
LineCurve3.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
};
LineCurve3.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
};
function QuadraticBezierCurve(v0 = new Vector2(), v1 = new Vector2(), v2 = new Vector2()) {
    Curve.call(this);
    this.type = 'QuadraticBezierCurve';
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
}
QuadraticBezierCurve.prototype = Object.create(Curve.prototype);
QuadraticBezierCurve.prototype.constructor = QuadraticBezierCurve;
QuadraticBezierCurve.prototype.isQuadraticBezierCurve = true;
QuadraticBezierCurve.prototype.getPoint = function(t, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y));
    return point;
};
QuadraticBezierCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
};
QuadraticBezierCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
};
QuadraticBezierCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
};
function QuadraticBezierCurve3(v0 = new Vector3(), v1 = new Vector3(), v2 = new Vector3()) {
    Curve.call(this);
    this.type = 'QuadraticBezierCurve3';
    this.v0 = v0;
    this.v1 = v1;
    this.v2 = v2;
}
QuadraticBezierCurve3.prototype = Object.create(Curve.prototype);
QuadraticBezierCurve3.prototype.constructor = QuadraticBezierCurve3;
QuadraticBezierCurve3.prototype.isQuadraticBezierCurve3 = true;
QuadraticBezierCurve3.prototype.getPoint = function(t, optionalTarget = new Vector3()) {
    const point = optionalTarget;
    const v0 = this.v0, v1 = this.v1, v2 = this.v2;
    point.set(QuadraticBezier(t, v0.x, v1.x, v2.x), QuadraticBezier(t, v0.y, v1.y, v2.y), QuadraticBezier(t, v0.z, v1.z, v2.z));
    return point;
};
QuadraticBezierCurve3.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.v0.copy(source.v0);
    this.v1.copy(source.v1);
    this.v2.copy(source.v2);
    return this;
};
QuadraticBezierCurve3.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.v0 = this.v0.toArray();
    data.v1 = this.v1.toArray();
    data.v2 = this.v2.toArray();
    return data;
};
QuadraticBezierCurve3.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.v0.fromArray(json.v0);
    this.v1.fromArray(json.v1);
    this.v2.fromArray(json.v2);
    return this;
};
function SplineCurve(points = []) {
    Curve.call(this);
    this.type = 'SplineCurve';
    this.points = points;
}
SplineCurve.prototype = Object.create(Curve.prototype);
SplineCurve.prototype.constructor = SplineCurve;
SplineCurve.prototype.isSplineCurve = true;
SplineCurve.prototype.getPoint = function(t, optionalTarget = new Vector2()) {
    const point = optionalTarget;
    const points = this.points;
    const p = (points.length - 1) * t;
    const intPoint = Math.floor(p);
    const weight = p - intPoint;
    const p0 = points[intPoint === 0 ? intPoint : intPoint - 1];
    const p1 = points[intPoint];
    const p2 = points[intPoint > points.length - 2 ? points.length - 1 : intPoint + 1];
    const p3 = points[intPoint > points.length - 3 ? points.length - 1 : intPoint + 2];
    point.set(CatmullRom(weight, p0.x, p1.x, p2.x, p3.x), CatmullRom(weight, p0.y, p1.y, p2.y, p3.y));
    return point;
};
SplineCurve.prototype.copy = function(source) {
    Curve.prototype.copy.call(this, source);
    this.points = [];
    for(let i = 0, l = source.points.length; i < l; i++){
        const point = source.points[i];
        this.points.push(point.clone());
    }
    return this;
};
SplineCurve.prototype.toJSON = function() {
    const data = Curve.prototype.toJSON.call(this);
    data.points = [];
    for(let i = 0, l = this.points.length; i < l; i++){
        const point = this.points[i];
        data.points.push(point.toArray());
    }
    return data;
};
SplineCurve.prototype.fromJSON = function(json) {
    Curve.prototype.fromJSON.call(this, json);
    this.points = [];
    for(let i = 0, l = json.points.length; i < l; i++){
        const point = json.points[i];
        this.points.push(new Vector2().fromArray(point));
    }
    return this;
};
var Curves = /*#__PURE__*/ Object.freeze({
    __proto__: null,
    ArcCurve: ArcCurve,
    CatmullRomCurve3: CatmullRomCurve3,
    CubicBezierCurve: CubicBezierCurve,
    CubicBezierCurve3: CubicBezierCurve3,
    EllipseCurve: EllipseCurve,
    LineCurve: LineCurve,
    LineCurve3: LineCurve3,
    QuadraticBezierCurve: QuadraticBezierCurve,
    QuadraticBezierCurve3: QuadraticBezierCurve3,
    SplineCurve: SplineCurve
});
/**************************************************************
 *	Curved Path - a curve path is simply a array of connected
 *  curves, but retains the api of a curve
 **************************************************************/ function CurvePath() {
    Curve.call(this);
    this.type = 'CurvePath';
    this.curves = [];
    this.autoClose = false; // Automatically closes the path
}
CurvePath.prototype = Object.assign(Object.create(Curve.prototype), {
    constructor: CurvePath,
    add: function(curve) {
        this.curves.push(curve);
    },
    closePath: function() {
        // Add a line curve if start and end of lines are not connected
        const startPoint = this.curves[0].getPoint(0);
        const endPoint = this.curves[this.curves.length - 1].getPoint(1);
        if (!startPoint.equals(endPoint)) this.curves.push(new LineCurve(endPoint, startPoint));
    },
    // To get accurate point with reference to
    // entire path distance at time t,
    // following has to be done:
    // 1. Length of each sub path have to be known
    // 2. Locate and identify type of curve
    // 3. Get t for the curve
    // 4. Return curve.getPointAt(t')
    getPoint: function(t) {
        const d = t * this.getLength();
        const curveLengths = this.getCurveLengths();
        let i = 0;
        // To think about boundaries points.
        while(i < curveLengths.length){
            if (curveLengths[i] >= d) {
                const diff = curveLengths[i] - d;
                const curve = this.curves[i];
                const segmentLength = curve.getLength();
                const u = segmentLength === 0 ? 0 : 1 - diff / segmentLength;
                return curve.getPointAt(u);
            }
            i++;
        }
        return null;
    // loop where sum != 0, sum > d , sum+1 <d
    },
    // We cannot use the default THREE.Curve getPoint() with getLength() because in
    // THREE.Curve, getLength() depends on getPoint() but in THREE.CurvePath
    // getPoint() depends on getLength
    getLength: function() {
        const lens = this.getCurveLengths();
        return lens[lens.length - 1];
    },
    // cacheLengths must be recalculated.
    updateArcLengths: function() {
        this.needsUpdate = true;
        this.cacheLengths = null;
        this.getCurveLengths();
    },
    // Compute lengths and cache them
    // We cannot overwrite getLengths() because UtoT mapping uses it.
    getCurveLengths: function() {
        // We use cache values if curves and cache array are same length
        if (this.cacheLengths && this.cacheLengths.length === this.curves.length) return this.cacheLengths;
        // Get length of sub-curve
        // Push sums into cached array
        const lengths = [];
        let sums = 0;
        for(let i = 0, l = this.curves.length; i < l; i++){
            sums += this.curves[i].getLength();
            lengths.push(sums);
        }
        this.cacheLengths = lengths;
        return lengths;
    },
    getSpacedPoints: function(divisions = 40) {
        const points = [];
        for(let i = 0; i <= divisions; i++)points.push(this.getPoint(i / divisions));
        if (this.autoClose) points.push(points[0]);
        return points;
    },
    getPoints: function(divisions = 12) {
        const points = [];
        let last;
        for(let i = 0, curves = this.curves; i < curves.length; i++){
            const curve = curves[i];
            const resolution = curve && curve.isEllipseCurve ? divisions * 2 : curve && (curve.isLineCurve || curve.isLineCurve3) ? 1 : curve && curve.isSplineCurve ? divisions * curve.points.length : divisions;
            const pts = curve.getPoints(resolution);
            for(let j = 0; j < pts.length; j++){
                const point = pts[j];
                if (last && last.equals(point)) continue; // ensures no consecutive points are duplicates
                points.push(point);
                last = point;
            }
        }
        if (this.autoClose && points.length > 1 && !points[points.length - 1].equals(points[0])) points.push(points[0]);
        return points;
    },
    copy: function(source) {
        Curve.prototype.copy.call(this, source);
        this.curves = [];
        for(let i = 0, l = source.curves.length; i < l; i++){
            const curve = source.curves[i];
            this.curves.push(curve.clone());
        }
        this.autoClose = source.autoClose;
        return this;
    },
    toJSON: function() {
        const data = Curve.prototype.toJSON.call(this);
        data.autoClose = this.autoClose;
        data.curves = [];
        for(let i = 0, l = this.curves.length; i < l; i++){
            const curve = this.curves[i];
            data.curves.push(curve.toJSON());
        }
        return data;
    },
    fromJSON: function(json) {
        Curve.prototype.fromJSON.call(this, json);
        this.autoClose = json.autoClose;
        this.curves = [];
        for(let i = 0, l = json.curves.length; i < l; i++){
            const curve = json.curves[i];
            this.curves.push(new Curves[curve.type]().fromJSON(curve));
        }
        return this;
    }
});
function Path(points) {
    CurvePath.call(this);
    this.type = 'Path';
    this.currentPoint = new Vector2();
    if (points) this.setFromPoints(points);
}
Path.prototype = Object.assign(Object.create(CurvePath.prototype), {
    constructor: Path,
    setFromPoints: function(points) {
        this.moveTo(points[0].x, points[0].y);
        for(let i = 1, l = points.length; i < l; i++)this.lineTo(points[i].x, points[i].y);
        return this;
    },
    moveTo: function(x, y) {
        this.currentPoint.set(x, y); // TODO consider referencing vectors instead of copying?
        return this;
    },
    lineTo: function(x, y) {
        const curve = new LineCurve(this.currentPoint.clone(), new Vector2(x, y));
        this.curves.push(curve);
        this.currentPoint.set(x, y);
        return this;
    },
    quadraticCurveTo: function(aCPx, aCPy, aX, aY) {
        const curve = new QuadraticBezierCurve(this.currentPoint.clone(), new Vector2(aCPx, aCPy), new Vector2(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    },
    bezierCurveTo: function(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        const curve = new CubicBezierCurve(this.currentPoint.clone(), new Vector2(aCP1x, aCP1y), new Vector2(aCP2x, aCP2y), new Vector2(aX, aY));
        this.curves.push(curve);
        this.currentPoint.set(aX, aY);
        return this;
    },
    splineThru: function(pts /*Array of Vector*/ ) {
        const npts = [
            this.currentPoint.clone()
        ].concat(pts);
        const curve = new SplineCurve(npts);
        this.curves.push(curve);
        this.currentPoint.copy(pts[pts.length - 1]);
        return this;
    },
    arc: function(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absarc(aX + x0, aY + y0, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    },
    absarc: function(aX, aY, aRadius, aStartAngle, aEndAngle, aClockwise) {
        this.absellipse(aX, aY, aRadius, aRadius, aStartAngle, aEndAngle, aClockwise);
        return this;
    },
    ellipse: function(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const x0 = this.currentPoint.x;
        const y0 = this.currentPoint.y;
        this.absellipse(aX + x0, aY + y0, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        return this;
    },
    absellipse: function(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation) {
        const curve = new EllipseCurve(aX, aY, xRadius, yRadius, aStartAngle, aEndAngle, aClockwise, aRotation);
        if (this.curves.length > 0) {
            // if a previous curve is present, attempt to join
            const firstPoint = curve.getPoint(0);
            if (!firstPoint.equals(this.currentPoint)) this.lineTo(firstPoint.x, firstPoint.y);
        }
        this.curves.push(curve);
        const lastPoint = curve.getPoint(1);
        this.currentPoint.copy(lastPoint);
        return this;
    },
    copy: function(source) {
        CurvePath.prototype.copy.call(this, source);
        this.currentPoint.copy(source.currentPoint);
        return this;
    },
    toJSON: function() {
        const data = CurvePath.prototype.toJSON.call(this);
        data.currentPoint = this.currentPoint.toArray();
        return data;
    },
    fromJSON: function(json) {
        CurvePath.prototype.fromJSON.call(this, json);
        this.currentPoint.fromArray(json.currentPoint);
        return this;
    }
});
function Shape(points) {
    Path.call(this, points);
    this.uuid = MathUtils.generateUUID();
    this.type = 'Shape';
    this.holes = [];
}
Shape.prototype = Object.assign(Object.create(Path.prototype), {
    constructor: Shape,
    getPointsHoles: function(divisions) {
        const holesPts = [];
        for(let i = 0, l = this.holes.length; i < l; i++)holesPts[i] = this.holes[i].getPoints(divisions);
        return holesPts;
    },
    // get points of shape and holes (keypoints based on segments parameter)
    extractPoints: function(divisions) {
        return {
            shape: this.getPoints(divisions),
            holes: this.getPointsHoles(divisions)
        };
    },
    copy: function(source) {
        Path.prototype.copy.call(this, source);
        this.holes = [];
        for(let i = 0, l = source.holes.length; i < l; i++){
            const hole = source.holes[i];
            this.holes.push(hole.clone());
        }
        return this;
    },
    toJSON: function() {
        const data = Path.prototype.toJSON.call(this);
        data.uuid = this.uuid;
        data.holes = [];
        for(let i = 0, l = this.holes.length; i < l; i++){
            const hole = this.holes[i];
            data.holes.push(hole.toJSON());
        }
        return data;
    },
    fromJSON: function(json) {
        Path.prototype.fromJSON.call(this, json);
        this.uuid = json.uuid;
        this.holes = [];
        for(let i = 0, l = json.holes.length; i < l; i++){
            const hole = json.holes[i];
            this.holes.push(new Path().fromJSON(hole));
        }
        return this;
    }
});
function Light(color, intensity = 1) {
    Object3D.call(this);
    this.type = 'Light';
    this.color = new Color(color);
    this.intensity = intensity;
}
Light.prototype = Object.assign(Object.create(Object3D.prototype), {
    constructor: Light,
    isLight: true,
    copy: function(source) {
        Object3D.prototype.copy.call(this, source);
        this.color.copy(source.color);
        this.intensity = source.intensity;
        return this;
    },
    toJSON: function(meta) {
        const data = Object3D.prototype.toJSON.call(this, meta);
        data.object.color = this.color.getHex();
        data.object.intensity = this.intensity;
        if (this.groundColor !== undefined) data.object.groundColor = this.groundColor.getHex();
        if (this.distance !== undefined) data.object.distance = this.distance;
        if (this.angle !== undefined) data.object.angle = this.angle;
        if (this.decay !== undefined) data.object.decay = this.decay;
        if (this.penumbra !== undefined) data.object.penumbra = this.penumbra;
        if (this.shadow !== undefined) data.object.shadow = this.shadow.toJSON();
        return data;
    }
});
function HemisphereLight(skyColor, groundColor, intensity) {
    Light.call(this, skyColor, intensity);
    this.type = 'HemisphereLight';
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.groundColor = new Color(groundColor);
}
HemisphereLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: HemisphereLight,
    isHemisphereLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.groundColor.copy(source.groundColor);
        return this;
    }
});
function LightShadow(camera) {
    this.camera = camera;
    this.bias = 0;
    this.normalBias = 0;
    this.radius = 1;
    this.mapSize = new Vector2(512, 512);
    this.map = null;
    this.mapPass = null;
    this.matrix = new Matrix4();
    this.autoUpdate = true;
    this.needsUpdate = false;
    this._frustum = new Frustum();
    this._frameExtents = new Vector2(1, 1);
    this._viewportCount = 1;
    this._viewports = [
        new Vector4(0, 0, 1, 1)
    ];
}
Object.assign(LightShadow.prototype, {
    _projScreenMatrix: new Matrix4(),
    _lightPositionWorld: new Vector3(),
    _lookTarget: new Vector3(),
    getViewportCount: function() {
        return this._viewportCount;
    },
    getFrustum: function() {
        return this._frustum;
    },
    updateMatrices: function(light) {
        const shadowCamera = this.camera, shadowMatrix = this.matrix, projScreenMatrix = this._projScreenMatrix, lookTarget = this._lookTarget, lightPositionWorld = this._lightPositionWorld;
        lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        shadowCamera.position.copy(lightPositionWorld);
        lookTarget.setFromMatrixPosition(light.target.matrixWorld);
        shadowCamera.lookAt(lookTarget);
        shadowCamera.updateMatrixWorld();
        projScreenMatrix.multiplyMatrices(shadowCamera.projectionMatrix, shadowCamera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix(projScreenMatrix);
        shadowMatrix.set(0.5, 0.0, 0.0, 0.5, 0.0, 0.5, 0.0, 0.5, 0.0, 0.0, 0.5, 0.5, 0.0, 0.0, 0.0, 1.0);
        shadowMatrix.multiply(shadowCamera.projectionMatrix);
        shadowMatrix.multiply(shadowCamera.matrixWorldInverse);
    },
    getViewport: function(viewportIndex) {
        return this._viewports[viewportIndex];
    },
    getFrameExtents: function() {
        return this._frameExtents;
    },
    copy: function(source) {
        this.camera = source.camera.clone();
        this.bias = source.bias;
        this.radius = source.radius;
        this.mapSize.copy(source.mapSize);
        return this;
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    toJSON: function() {
        const object = {};
        if (this.bias !== 0) object.bias = this.bias;
        if (this.normalBias !== 0) object.normalBias = this.normalBias;
        if (this.radius !== 1) object.radius = this.radius;
        if (this.mapSize.x !== 512 || this.mapSize.y !== 512) object.mapSize = this.mapSize.toArray();
        object.camera = this.camera.toJSON(false).object;
        delete object.camera.matrix;
        return object;
    }
});
function SpotLightShadow() {
    LightShadow.call(this, new PerspectiveCamera(50, 1, 0.5, 500));
    this.focus = 1;
}
SpotLightShadow.prototype = Object.assign(Object.create(LightShadow.prototype), {
    constructor: SpotLightShadow,
    isSpotLightShadow: true,
    updateMatrices: function(light) {
        const camera = this.camera;
        const fov = MathUtils.RAD2DEG * 2 * light.angle * this.focus;
        const aspect = this.mapSize.width / this.mapSize.height;
        const far = light.distance || camera.far;
        if (fov !== camera.fov || aspect !== camera.aspect || far !== camera.far) {
            camera.fov = fov;
            camera.aspect = aspect;
            camera.far = far;
            camera.updateProjectionMatrix();
        }
        LightShadow.prototype.updateMatrices.call(this, light);
    }
});
function SpotLight(color, intensity, distance, angle, penumbra, decay) {
    Light.call(this, color, intensity);
    this.type = 'SpotLight';
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D();
    Object.defineProperty(this, 'power', {
        get: function() {
            // intensity = power per solid angle.
            // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
            return this.intensity * Math.PI;
        },
        set: function(power) {
            // intensity = power per solid angle.
            // ref: equation (17) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
            this.intensity = power / Math.PI;
        }
    });
    this.distance = distance !== undefined ? distance : 0;
    this.angle = angle !== undefined ? angle : Math.PI / 3;
    this.penumbra = penumbra !== undefined ? penumbra : 0;
    this.decay = decay !== undefined ? decay : 1; // for physically correct lights, should be 2.
    this.shadow = new SpotLightShadow();
}
SpotLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: SpotLight,
    isSpotLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.distance = source.distance;
        this.angle = source.angle;
        this.penumbra = source.penumbra;
        this.decay = source.decay;
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
});
function PointLightShadow() {
    LightShadow.call(this, new PerspectiveCamera(90, 1, 0.5, 500));
    this._frameExtents = new Vector2(4, 2);
    this._viewportCount = 6;
    this._viewports = [
        // These viewports map a cube-map onto a 2D texture with the
        // following orientation:
        //
        //  xzXZ
        //   y Y
        //
        // X - Positive x direction
        // x - Negative x direction
        // Y - Positive y direction
        // y - Negative y direction
        // Z - Positive z direction
        // z - Negative z direction
        // positive X
        new Vector4(2, 1, 1, 1),
        // negative X
        new Vector4(0, 1, 1, 1),
        // positive Z
        new Vector4(3, 1, 1, 1),
        // negative Z
        new Vector4(1, 1, 1, 1),
        // positive Y
        new Vector4(3, 0, 1, 1),
        // negative Y
        new Vector4(1, 0, 1, 1)
    ];
    this._cubeDirections = [
        new Vector3(1, 0, 0),
        new Vector3(-1, 0, 0),
        new Vector3(0, 0, 1),
        new Vector3(0, 0, -1),
        new Vector3(0, 1, 0),
        new Vector3(0, -1, 0)
    ];
    this._cubeUps = [
        new Vector3(0, 1, 0),
        new Vector3(0, 1, 0),
        new Vector3(0, 1, 0),
        new Vector3(0, 1, 0),
        new Vector3(0, 0, 1),
        new Vector3(0, 0, -1)
    ];
}
PointLightShadow.prototype = Object.assign(Object.create(LightShadow.prototype), {
    constructor: PointLightShadow,
    isPointLightShadow: true,
    updateMatrices: function(light, viewportIndex = 0) {
        const camera = this.camera, shadowMatrix = this.matrix, lightPositionWorld = this._lightPositionWorld, lookTarget = this._lookTarget, projScreenMatrix = this._projScreenMatrix;
        lightPositionWorld.setFromMatrixPosition(light.matrixWorld);
        camera.position.copy(lightPositionWorld);
        lookTarget.copy(camera.position);
        lookTarget.add(this._cubeDirections[viewportIndex]);
        camera.up.copy(this._cubeUps[viewportIndex]);
        camera.lookAt(lookTarget);
        camera.updateMatrixWorld();
        shadowMatrix.makeTranslation(-lightPositionWorld.x, -lightPositionWorld.y, -lightPositionWorld.z);
        projScreenMatrix.multiplyMatrices(camera.projectionMatrix, camera.matrixWorldInverse);
        this._frustum.setFromProjectionMatrix(projScreenMatrix);
    }
});
function PointLight(color, intensity, distance, decay) {
    Light.call(this, color, intensity);
    this.type = 'PointLight';
    Object.defineProperty(this, 'power', {
        get: function() {
            // intensity = power per solid angle.
            // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
            return this.intensity * 4 * Math.PI;
        },
        set: function(power) {
            // intensity = power per solid angle.
            // ref: equation (15) from https://seblagarde.files.wordpress.com/2015/07/course_notes_moving_frostbite_to_pbr_v32.pdf
            this.intensity = power / (4 * Math.PI);
        }
    });
    this.distance = distance !== undefined ? distance : 0;
    this.decay = decay !== undefined ? decay : 1; // for physically correct lights, should be 2.
    this.shadow = new PointLightShadow();
}
PointLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: PointLight,
    isPointLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.distance = source.distance;
        this.decay = source.decay;
        this.shadow = source.shadow.clone();
        return this;
    }
});
function OrthographicCamera(left = -1, right = 1, top = 1, bottom = -1, near = 0.1, far = 2000) {
    Camera.call(this);
    this.type = 'OrthographicCamera';
    this.zoom = 1;
    this.view = null;
    this.left = left;
    this.right = right;
    this.top = top;
    this.bottom = bottom;
    this.near = near;
    this.far = far;
    this.updateProjectionMatrix();
}
OrthographicCamera.prototype = Object.assign(Object.create(Camera.prototype), {
    constructor: OrthographicCamera,
    isOrthographicCamera: true,
    copy: function(source, recursive) {
        Camera.prototype.copy.call(this, source, recursive);
        this.left = source.left;
        this.right = source.right;
        this.top = source.top;
        this.bottom = source.bottom;
        this.near = source.near;
        this.far = source.far;
        this.zoom = source.zoom;
        this.view = source.view === null ? null : Object.assign({}, source.view);
        return this;
    },
    setViewOffset: function(fullWidth, fullHeight, x, y, width, height) {
        if (this.view === null) this.view = {
            enabled: true,
            fullWidth: 1,
            fullHeight: 1,
            offsetX: 0,
            offsetY: 0,
            width: 1,
            height: 1
        };
        this.view.enabled = true;
        this.view.fullWidth = fullWidth;
        this.view.fullHeight = fullHeight;
        this.view.offsetX = x;
        this.view.offsetY = y;
        this.view.width = width;
        this.view.height = height;
        this.updateProjectionMatrix();
    },
    clearViewOffset: function() {
        if (this.view !== null) this.view.enabled = false;
        this.updateProjectionMatrix();
    },
    updateProjectionMatrix: function() {
        const dx = (this.right - this.left) / (2 * this.zoom);
        const dy = (this.top - this.bottom) / (2 * this.zoom);
        const cx = (this.right + this.left) / 2;
        const cy = (this.top + this.bottom) / 2;
        let left = cx - dx;
        let right = cx + dx;
        let top = cy + dy;
        let bottom = cy - dy;
        if (this.view !== null && this.view.enabled) {
            const scaleW = (this.right - this.left) / this.view.fullWidth / this.zoom;
            const scaleH = (this.top - this.bottom) / this.view.fullHeight / this.zoom;
            left += scaleW * this.view.offsetX;
            right = left + scaleW * this.view.width;
            top -= scaleH * this.view.offsetY;
            bottom = top - scaleH * this.view.height;
        }
        this.projectionMatrix.makeOrthographic(left, right, top, bottom, this.near, this.far);
        this.projectionMatrixInverse.copy(this.projectionMatrix).invert();
    },
    toJSON: function(meta) {
        const data = Object3D.prototype.toJSON.call(this, meta);
        data.object.zoom = this.zoom;
        data.object.left = this.left;
        data.object.right = this.right;
        data.object.top = this.top;
        data.object.bottom = this.bottom;
        data.object.near = this.near;
        data.object.far = this.far;
        if (this.view !== null) data.object.view = Object.assign({}, this.view);
        return data;
    }
});
function DirectionalLightShadow() {
    LightShadow.call(this, new OrthographicCamera(-5, 5, 5, -5, 0.5, 500));
}
DirectionalLightShadow.prototype = Object.assign(Object.create(LightShadow.prototype), {
    constructor: DirectionalLightShadow,
    isDirectionalLightShadow: true,
    updateMatrices: function(light) {
        LightShadow.prototype.updateMatrices.call(this, light);
    }
});
function DirectionalLight(color, intensity) {
    Light.call(this, color, intensity);
    this.type = 'DirectionalLight';
    this.position.copy(Object3D.DefaultUp);
    this.updateMatrix();
    this.target = new Object3D();
    this.shadow = new DirectionalLightShadow();
}
DirectionalLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: DirectionalLight,
    isDirectionalLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.target = source.target.clone();
        this.shadow = source.shadow.clone();
        return this;
    }
});
function AmbientLight(color, intensity) {
    Light.call(this, color, intensity);
    this.type = 'AmbientLight';
}
AmbientLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: AmbientLight,
    isAmbientLight: true
});
function RectAreaLight(color, intensity, width, height) {
    Light.call(this, color, intensity);
    this.type = 'RectAreaLight';
    this.width = width !== undefined ? width : 10;
    this.height = height !== undefined ? height : 10;
}
RectAreaLight.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: RectAreaLight,
    isRectAreaLight: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.width = source.width;
        this.height = source.height;
        return this;
    },
    toJSON: function(meta) {
        const data = Light.prototype.toJSON.call(this, meta);
        data.object.width = this.width;
        data.object.height = this.height;
        return data;
    }
});
/**
 * Primary reference:
 *   https://graphics.stanford.edu/papers/envmap/envmap.pdf
 *
 * Secondary reference:
 *   https://www.ppsloan.org/publications/StupidSH36.pdf
 */ // 3-band SH defined by 9 coefficients
class SphericalHarmonics3 {
    constructor(){
        Object.defineProperty(this, 'isSphericalHarmonics3', {
            value: true
        });
        this.coefficients = [];
        for(let i = 0; i < 9; i++)this.coefficients.push(new Vector3());
    }
    set(coefficients) {
        for(let i = 0; i < 9; i++)this.coefficients[i].copy(coefficients[i]);
        return this;
    }
    zero() {
        for(let i = 0; i < 9; i++)this.coefficients[i].set(0, 0, 0);
        return this;
    }
    // get the radiance in the direction of the normal
    // target is a Vector3
    getAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.282095);
        // band 1
        target.addScaledVector(coeff[1], 0.488603 * y);
        target.addScaledVector(coeff[2], 0.488603 * z);
        target.addScaledVector(coeff[3], 0.488603 * x);
        // band 2
        target.addScaledVector(coeff[4], 1.092548 * (x * y));
        target.addScaledVector(coeff[5], 1.092548 * (y * z));
        target.addScaledVector(coeff[6], 0.315392 * (3.0 * z * z - 1.0));
        target.addScaledVector(coeff[7], 1.092548 * (x * z));
        target.addScaledVector(coeff[8], 0.546274 * (x * x - y * y));
        return target;
    }
    // get the irradiance (radiance convolved with cosine lobe) in the direction of the normal
    // target is a Vector3
    // https://graphics.stanford.edu/papers/envmap/envmap.pdf
    getIrradianceAt(normal, target) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        const coeff = this.coefficients;
        // band 0
        target.copy(coeff[0]).multiplyScalar(0.886227); // π * 0.282095
        // band 1
        target.addScaledVector(coeff[1], 1.023328 * y); // ( 2 * π / 3 ) * 0.488603
        target.addScaledVector(coeff[2], 1.023328 * z);
        target.addScaledVector(coeff[3], 1.023328 * x);
        // band 2
        target.addScaledVector(coeff[4], 0.858086 * x * y); // ( π / 4 ) * 1.092548
        target.addScaledVector(coeff[5], 0.858086 * y * z);
        target.addScaledVector(coeff[6], 0.743125 * z * z - 0.247708); // ( π / 4 ) * 0.315392 * 3
        target.addScaledVector(coeff[7], 0.858086 * x * z);
        target.addScaledVector(coeff[8], 0.429043 * (x * x - y * y)); // ( π / 4 ) * 0.546274
        return target;
    }
    add(sh) {
        for(let i = 0; i < 9; i++)this.coefficients[i].add(sh.coefficients[i]);
        return this;
    }
    addScaledSH(sh, s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].addScaledVector(sh.coefficients[i], s);
        return this;
    }
    scale(s) {
        for(let i = 0; i < 9; i++)this.coefficients[i].multiplyScalar(s);
        return this;
    }
    lerp(sh, alpha) {
        for(let i = 0; i < 9; i++)this.coefficients[i].lerp(sh.coefficients[i], alpha);
        return this;
    }
    equals(sh) {
        for(let i = 0; i < 9; i++){
            if (!this.coefficients[i].equals(sh.coefficients[i])) return false;
        }
        return true;
    }
    copy(sh) {
        return this.set(sh.coefficients);
    }
    clone() {
        return new this.constructor().copy(this);
    }
    fromArray(array, offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].fromArray(array, offset + i * 3);
        return this;
    }
    toArray(array = [], offset = 0) {
        const coefficients = this.coefficients;
        for(let i = 0; i < 9; i++)coefficients[i].toArray(array, offset + i * 3);
        return array;
    }
    // evaluate the basis functions
    // shBasis is an Array[ 9 ]
    static getBasisAt(normal, shBasis) {
        // normal is assumed to be unit length
        const x = normal.x, y = normal.y, z = normal.z;
        // band 0
        shBasis[0] = 0.282095;
        // band 1
        shBasis[1] = 0.488603 * y;
        shBasis[2] = 0.488603 * z;
        shBasis[3] = 0.488603 * x;
        // band 2
        shBasis[4] = 1.092548 * x * y;
        shBasis[5] = 1.092548 * y * z;
        shBasis[6] = 0.315392 * (3 * z * z - 1);
        shBasis[7] = 1.092548 * x * z;
        shBasis[8] = 0.546274 * (x * x - y * y);
    }
}
function LightProbe(sh, intensity) {
    Light.call(this, undefined, intensity);
    this.type = 'LightProbe';
    this.sh = sh !== undefined ? sh : new SphericalHarmonics3();
}
LightProbe.prototype = Object.assign(Object.create(Light.prototype), {
    constructor: LightProbe,
    isLightProbe: true,
    copy: function(source) {
        Light.prototype.copy.call(this, source);
        this.sh.copy(source.sh);
        return this;
    },
    fromJSON: function(json) {
        this.intensity = json.intensity; // TODO: Move this bit to Light.fromJSON();
        this.sh.fromArray(json.sh);
        return this;
    },
    toJSON: function(meta) {
        const data = Light.prototype.toJSON.call(this, meta);
        data.object.sh = this.sh.toArray();
        return data;
    }
});
function MaterialLoader(manager) {
    Loader.call(this, manager);
    this.textures = {};
}
MaterialLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: MaterialLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    },
    parse: function(json) {
        const textures = this.textures;
        function getTexture(name) {
            if (textures[name] === undefined) console.warn('THREE.MaterialLoader: Undefined texture', name);
            return textures[name];
        }
        const material = new Materials[json.type]();
        if (json.uuid !== undefined) material.uuid = json.uuid;
        if (json.name !== undefined) material.name = json.name;
        if (json.color !== undefined && material.color !== undefined) material.color.setHex(json.color);
        if (json.roughness !== undefined) material.roughness = json.roughness;
        if (json.metalness !== undefined) material.metalness = json.metalness;
        if (json.sheen !== undefined) material.sheen = new Color().setHex(json.sheen);
        if (json.emissive !== undefined && material.emissive !== undefined) material.emissive.setHex(json.emissive);
        if (json.specular !== undefined && material.specular !== undefined) material.specular.setHex(json.specular);
        if (json.shininess !== undefined) material.shininess = json.shininess;
        if (json.clearcoat !== undefined) material.clearcoat = json.clearcoat;
        if (json.clearcoatRoughness !== undefined) material.clearcoatRoughness = json.clearcoatRoughness;
        if (json.fog !== undefined) material.fog = json.fog;
        if (json.flatShading !== undefined) material.flatShading = json.flatShading;
        if (json.blending !== undefined) material.blending = json.blending;
        if (json.combine !== undefined) material.combine = json.combine;
        if (json.side !== undefined) material.side = json.side;
        if (json.opacity !== undefined) material.opacity = json.opacity;
        if (json.transparent !== undefined) material.transparent = json.transparent;
        if (json.alphaTest !== undefined) material.alphaTest = json.alphaTest;
        if (json.depthTest !== undefined) material.depthTest = json.depthTest;
        if (json.depthWrite !== undefined) material.depthWrite = json.depthWrite;
        if (json.colorWrite !== undefined) material.colorWrite = json.colorWrite;
        if (json.stencilWrite !== undefined) material.stencilWrite = json.stencilWrite;
        if (json.stencilWriteMask !== undefined) material.stencilWriteMask = json.stencilWriteMask;
        if (json.stencilFunc !== undefined) material.stencilFunc = json.stencilFunc;
        if (json.stencilRef !== undefined) material.stencilRef = json.stencilRef;
        if (json.stencilFuncMask !== undefined) material.stencilFuncMask = json.stencilFuncMask;
        if (json.stencilFail !== undefined) material.stencilFail = json.stencilFail;
        if (json.stencilZFail !== undefined) material.stencilZFail = json.stencilZFail;
        if (json.stencilZPass !== undefined) material.stencilZPass = json.stencilZPass;
        if (json.wireframe !== undefined) material.wireframe = json.wireframe;
        if (json.wireframeLinewidth !== undefined) material.wireframeLinewidth = json.wireframeLinewidth;
        if (json.wireframeLinecap !== undefined) material.wireframeLinecap = json.wireframeLinecap;
        if (json.wireframeLinejoin !== undefined) material.wireframeLinejoin = json.wireframeLinejoin;
        if (json.rotation !== undefined) material.rotation = json.rotation;
        if (json.linewidth !== 1) material.linewidth = json.linewidth;
        if (json.dashSize !== undefined) material.dashSize = json.dashSize;
        if (json.gapSize !== undefined) material.gapSize = json.gapSize;
        if (json.scale !== undefined) material.scale = json.scale;
        if (json.polygonOffset !== undefined) material.polygonOffset = json.polygonOffset;
        if (json.polygonOffsetFactor !== undefined) material.polygonOffsetFactor = json.polygonOffsetFactor;
        if (json.polygonOffsetUnits !== undefined) material.polygonOffsetUnits = json.polygonOffsetUnits;
        if (json.skinning !== undefined) material.skinning = json.skinning;
        if (json.morphTargets !== undefined) material.morphTargets = json.morphTargets;
        if (json.morphNormals !== undefined) material.morphNormals = json.morphNormals;
        if (json.dithering !== undefined) material.dithering = json.dithering;
        if (json.vertexTangents !== undefined) material.vertexTangents = json.vertexTangents;
        if (json.visible !== undefined) material.visible = json.visible;
        if (json.toneMapped !== undefined) material.toneMapped = json.toneMapped;
        if (json.userData !== undefined) material.userData = json.userData;
        if (json.vertexColors !== undefined) {
            if (typeof json.vertexColors === 'number') material.vertexColors = json.vertexColors > 0 ? true : false;
            else material.vertexColors = json.vertexColors;
        }
        // Shader Material
        if (json.uniforms !== undefined) for(const name in json.uniforms){
            const uniform = json.uniforms[name];
            material.uniforms[name] = {};
            switch(uniform.type){
                case 't':
                    material.uniforms[name].value = getTexture(uniform.value);
                    break;
                case 'c':
                    material.uniforms[name].value = new Color().setHex(uniform.value);
                    break;
                case 'v2':
                    material.uniforms[name].value = new Vector2().fromArray(uniform.value);
                    break;
                case 'v3':
                    material.uniforms[name].value = new Vector3().fromArray(uniform.value);
                    break;
                case 'v4':
                    material.uniforms[name].value = new Vector4().fromArray(uniform.value);
                    break;
                case 'm3':
                    material.uniforms[name].value = new Matrix3().fromArray(uniform.value);
                    break;
                case 'm4':
                    material.uniforms[name].value = new Matrix4().fromArray(uniform.value);
                    break;
                default:
                    material.uniforms[name].value = uniform.value;
            }
        }
        if (json.defines !== undefined) material.defines = json.defines;
        if (json.vertexShader !== undefined) material.vertexShader = json.vertexShader;
        if (json.fragmentShader !== undefined) material.fragmentShader = json.fragmentShader;
        if (json.extensions !== undefined) for(const key in json.extensions)material.extensions[key] = json.extensions[key];
        // Deprecated
        if (json.shading !== undefined) material.flatShading = json.shading === 1; // THREE.FlatShading
        // for PointsMaterial
        if (json.size !== undefined) material.size = json.size;
        if (json.sizeAttenuation !== undefined) material.sizeAttenuation = json.sizeAttenuation;
        // maps
        if (json.map !== undefined) material.map = getTexture(json.map);
        if (json.matcap !== undefined) material.matcap = getTexture(json.matcap);
        if (json.alphaMap !== undefined) material.alphaMap = getTexture(json.alphaMap);
        if (json.bumpMap !== undefined) material.bumpMap = getTexture(json.bumpMap);
        if (json.bumpScale !== undefined) material.bumpScale = json.bumpScale;
        if (json.normalMap !== undefined) material.normalMap = getTexture(json.normalMap);
        if (json.normalMapType !== undefined) material.normalMapType = json.normalMapType;
        if (json.normalScale !== undefined) {
            let normalScale = json.normalScale;
            if (Array.isArray(normalScale) === false) // Blender exporter used to export a scalar. See #7459
            normalScale = [
                normalScale,
                normalScale
            ];
            material.normalScale = new Vector2().fromArray(normalScale);
        }
        if (json.displacementMap !== undefined) material.displacementMap = getTexture(json.displacementMap);
        if (json.displacementScale !== undefined) material.displacementScale = json.displacementScale;
        if (json.displacementBias !== undefined) material.displacementBias = json.displacementBias;
        if (json.roughnessMap !== undefined) material.roughnessMap = getTexture(json.roughnessMap);
        if (json.metalnessMap !== undefined) material.metalnessMap = getTexture(json.metalnessMap);
        if (json.emissiveMap !== undefined) material.emissiveMap = getTexture(json.emissiveMap);
        if (json.emissiveIntensity !== undefined) material.emissiveIntensity = json.emissiveIntensity;
        if (json.specularMap !== undefined) material.specularMap = getTexture(json.specularMap);
        if (json.envMap !== undefined) material.envMap = getTexture(json.envMap);
        if (json.envMapIntensity !== undefined) material.envMapIntensity = json.envMapIntensity;
        if (json.reflectivity !== undefined) material.reflectivity = json.reflectivity;
        if (json.refractionRatio !== undefined) material.refractionRatio = json.refractionRatio;
        if (json.lightMap !== undefined) material.lightMap = getTexture(json.lightMap);
        if (json.lightMapIntensity !== undefined) material.lightMapIntensity = json.lightMapIntensity;
        if (json.aoMap !== undefined) material.aoMap = getTexture(json.aoMap);
        if (json.aoMapIntensity !== undefined) material.aoMapIntensity = json.aoMapIntensity;
        if (json.gradientMap !== undefined) material.gradientMap = getTexture(json.gradientMap);
        if (json.clearcoatMap !== undefined) material.clearcoatMap = getTexture(json.clearcoatMap);
        if (json.clearcoatRoughnessMap !== undefined) material.clearcoatRoughnessMap = getTexture(json.clearcoatRoughnessMap);
        if (json.clearcoatNormalMap !== undefined) material.clearcoatNormalMap = getTexture(json.clearcoatNormalMap);
        if (json.clearcoatNormalScale !== undefined) material.clearcoatNormalScale = new Vector2().fromArray(json.clearcoatNormalScale);
        if (json.transmission !== undefined) material.transmission = json.transmission;
        if (json.transmissionMap !== undefined) material.transmissionMap = getTexture(json.transmissionMap);
        return material;
    },
    setTextures: function(value) {
        this.textures = value;
        return this;
    }
});
const LoaderUtils = {
    decodeText: function(array) {
        if (typeof TextDecoder !== 'undefined') return new TextDecoder().decode(array);
        // Avoid the String.fromCharCode.apply(null, array) shortcut, which
        // throws a "maximum call stack size exceeded" error for large arrays.
        let s = '';
        for(let i = 0, il = array.length; i < il; i++)// Implicitly assumes little-endian.
        s += String.fromCharCode(array[i]);
        try {
            // merges multi-byte utf-8 characters.
            return decodeURIComponent(escape(s));
        } catch (e) {
            return s;
        }
    },
    extractUrlBase: function(url) {
        const index = url.lastIndexOf('/');
        if (index === -1) return './';
        return url.substr(0, index + 1);
    }
};
function InstancedBufferGeometry() {
    BufferGeometry.call(this);
    this.type = 'InstancedBufferGeometry';
    this.instanceCount = Infinity;
}
InstancedBufferGeometry.prototype = Object.assign(Object.create(BufferGeometry.prototype), {
    constructor: InstancedBufferGeometry,
    isInstancedBufferGeometry: true,
    copy: function(source) {
        BufferGeometry.prototype.copy.call(this, source);
        this.instanceCount = source.instanceCount;
        return this;
    },
    clone: function() {
        return new this.constructor().copy(this);
    },
    toJSON: function() {
        const data = BufferGeometry.prototype.toJSON.call(this);
        data.instanceCount = this.instanceCount;
        data.isInstancedBufferGeometry = true;
        return data;
    }
});
function InstancedBufferAttribute(array, itemSize, normalized, meshPerAttribute) {
    if (typeof normalized === 'number') {
        meshPerAttribute = normalized;
        normalized = false;
        console.error('THREE.InstancedBufferAttribute: The constructor now expects normalized as the third argument.');
    }
    BufferAttribute.call(this, array, itemSize, normalized);
    this.meshPerAttribute = meshPerAttribute || 1;
}
InstancedBufferAttribute.prototype = Object.assign(Object.create(BufferAttribute.prototype), {
    constructor: InstancedBufferAttribute,
    isInstancedBufferAttribute: true,
    copy: function(source) {
        BufferAttribute.prototype.copy.call(this, source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    },
    toJSON: function() {
        const data = BufferAttribute.prototype.toJSON.call(this);
        data.meshPerAttribute = this.meshPerAttribute;
        data.isInstancedBufferAttribute = true;
        return data;
    }
});
function BufferGeometryLoader(manager) {
    Loader.call(this, manager);
}
BufferGeometryLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: BufferGeometryLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            try {
                onLoad(scope.parse(JSON.parse(text)));
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    },
    parse: function(json) {
        const interleavedBufferMap = {};
        const arrayBufferMap = {};
        function getInterleavedBuffer(json, uuid) {
            if (interleavedBufferMap[uuid] !== undefined) return interleavedBufferMap[uuid];
            const interleavedBuffers = json.interleavedBuffers;
            const interleavedBuffer = interleavedBuffers[uuid];
            const buffer = getArrayBuffer(json, interleavedBuffer.buffer);
            const array = getTypedArray(interleavedBuffer.type, buffer);
            const ib = new InterleavedBuffer(array, interleavedBuffer.stride);
            ib.uuid = interleavedBuffer.uuid;
            interleavedBufferMap[uuid] = ib;
            return ib;
        }
        function getArrayBuffer(json, uuid) {
            if (arrayBufferMap[uuid] !== undefined) return arrayBufferMap[uuid];
            const arrayBuffers = json.arrayBuffers;
            const arrayBuffer = arrayBuffers[uuid];
            const ab = new Uint32Array(arrayBuffer).buffer;
            arrayBufferMap[uuid] = ab;
            return ab;
        }
        const geometry = json.isInstancedBufferGeometry ? new InstancedBufferGeometry() : new BufferGeometry();
        const index = json.data.index;
        if (index !== undefined) {
            const typedArray = getTypedArray(index.type, index.array);
            geometry.setIndex(new BufferAttribute(typedArray, 1));
        }
        const attributes = json.data.attributes;
        for(const key in attributes){
            const attribute = attributes[key];
            let bufferAttribute;
            if (attribute.isInterleavedBufferAttribute) {
                const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
            } else {
                const typedArray = getTypedArray(attribute.type, attribute.array);
                const bufferAttributeConstr = attribute.isInstancedBufferAttribute ? InstancedBufferAttribute : BufferAttribute;
                bufferAttribute = new bufferAttributeConstr(typedArray, attribute.itemSize, attribute.normalized);
            }
            if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
            geometry.setAttribute(key, bufferAttribute);
        }
        const morphAttributes = json.data.morphAttributes;
        if (morphAttributes) for(const key in morphAttributes){
            const attributeArray = morphAttributes[key];
            const array = [];
            for(let i = 0, il = attributeArray.length; i < il; i++){
                const attribute = attributeArray[i];
                let bufferAttribute;
                if (attribute.isInterleavedBufferAttribute) {
                    const interleavedBuffer = getInterleavedBuffer(json.data, attribute.data);
                    bufferAttribute = new InterleavedBufferAttribute(interleavedBuffer, attribute.itemSize, attribute.offset, attribute.normalized);
                } else {
                    const typedArray = getTypedArray(attribute.type, attribute.array);
                    bufferAttribute = new BufferAttribute(typedArray, attribute.itemSize, attribute.normalized);
                }
                if (attribute.name !== undefined) bufferAttribute.name = attribute.name;
                array.push(bufferAttribute);
            }
            geometry.morphAttributes[key] = array;
        }
        const morphTargetsRelative = json.data.morphTargetsRelative;
        if (morphTargetsRelative) geometry.morphTargetsRelative = true;
        const groups = json.data.groups || json.data.drawcalls || json.data.offsets;
        if (groups !== undefined) for(let i = 0, n = groups.length; i !== n; ++i){
            const group = groups[i];
            geometry.addGroup(group.start, group.count, group.materialIndex);
        }
        const boundingSphere = json.data.boundingSphere;
        if (boundingSphere !== undefined) {
            const center = new Vector3();
            if (boundingSphere.center !== undefined) center.fromArray(boundingSphere.center);
            geometry.boundingSphere = new Sphere(center, boundingSphere.radius);
        }
        if (json.name) geometry.name = json.name;
        if (json.userData) geometry.userData = json.userData;
        return geometry;
    }
});
class ObjectLoader extends Loader {
    constructor(manager){
        super(manager);
    }
    load(url, onLoad, onProgress, onError) {
        const scope = this;
        const path = this.path === '' ? LoaderUtils.extractUrlBase(url) : this.path;
        this.resourcePath = this.resourcePath || path;
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(this.withCredentials);
        loader.load(url, function(text) {
            let json = null;
            try {
                json = JSON.parse(text);
            } catch (error) {
                if (onError !== undefined) onError(error);
                console.error('THREE:ObjectLoader: Can\'t parse ' + url + '.', error.message);
                return;
            }
            const metadata = json.metadata;
            if (metadata === undefined || metadata.type === undefined || metadata.type.toLowerCase() === 'geometry') {
                console.error('THREE.ObjectLoader: Can\'t load ' + url);
                return;
            }
            scope.parse(json, onLoad);
        }, onProgress, onError);
    }
    parse(json, onLoad) {
        const animations = this.parseAnimations(json.animations);
        const shapes = this.parseShapes(json.shapes);
        const geometries = this.parseGeometries(json.geometries, shapes);
        const images = this.parseImages(json.images, function() {
            if (onLoad !== undefined) onLoad(object);
        });
        const textures = this.parseTextures(json.textures, images);
        const materials = this.parseMaterials(json.materials, textures);
        const object = this.parseObject(json.object, geometries, materials, animations);
        const skeletons = this.parseSkeletons(json.skeletons, object);
        this.bindSkeletons(object, skeletons);
        //
        if (onLoad !== undefined) {
            let hasImages = false;
            for(const uuid in images)if (images[uuid] instanceof HTMLImageElement) {
                hasImages = true;
                break;
            }
            if (hasImages === false) onLoad(object);
        }
        return object;
    }
    parseShapes(json) {
        const shapes = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const shape = new Shape().fromJSON(json[i]);
            shapes[shape.uuid] = shape;
        }
        return shapes;
    }
    parseSkeletons(json, object) {
        const skeletons = {};
        const bones = {};
        // generate bone lookup table
        object.traverse(function(child) {
            if (child.isBone) bones[child.uuid] = child;
        });
        // create skeletons
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const skeleton = new Skeleton().fromJSON(json[i], bones);
            skeletons[skeleton.uuid] = skeleton;
        }
        return skeletons;
    }
    parseGeometries(json, shapes) {
        const geometries = {};
        let geometryShapes;
        if (json !== undefined) {
            const bufferGeometryLoader = new BufferGeometryLoader();
            for(let i = 0, l = json.length; i < l; i++){
                let geometry;
                const data = json[i];
                switch(data.type){
                    case 'PlaneGeometry':
                    case 'PlaneBufferGeometry':
                        geometry = new Geometries[data.type](data.width, data.height, data.widthSegments, data.heightSegments);
                        break;
                    case 'BoxGeometry':
                    case 'BoxBufferGeometry':
                        geometry = new Geometries[data.type](data.width, data.height, data.depth, data.widthSegments, data.heightSegments, data.depthSegments);
                        break;
                    case 'CircleGeometry':
                    case 'CircleBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.segments, data.thetaStart, data.thetaLength);
                        break;
                    case 'CylinderGeometry':
                    case 'CylinderBufferGeometry':
                        geometry = new Geometries[data.type](data.radiusTop, data.radiusBottom, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
                        break;
                    case 'ConeGeometry':
                    case 'ConeBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.height, data.radialSegments, data.heightSegments, data.openEnded, data.thetaStart, data.thetaLength);
                        break;
                    case 'SphereGeometry':
                    case 'SphereBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.widthSegments, data.heightSegments, data.phiStart, data.phiLength, data.thetaStart, data.thetaLength);
                        break;
                    case 'DodecahedronGeometry':
                    case 'DodecahedronBufferGeometry':
                    case 'IcosahedronGeometry':
                    case 'IcosahedronBufferGeometry':
                    case 'OctahedronGeometry':
                    case 'OctahedronBufferGeometry':
                    case 'TetrahedronGeometry':
                    case 'TetrahedronBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.detail);
                        break;
                    case 'RingGeometry':
                    case 'RingBufferGeometry':
                        geometry = new Geometries[data.type](data.innerRadius, data.outerRadius, data.thetaSegments, data.phiSegments, data.thetaStart, data.thetaLength);
                        break;
                    case 'TorusGeometry':
                    case 'TorusBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.tube, data.radialSegments, data.tubularSegments, data.arc);
                        break;
                    case 'TorusKnotGeometry':
                    case 'TorusKnotBufferGeometry':
                        geometry = new Geometries[data.type](data.radius, data.tube, data.tubularSegments, data.radialSegments, data.p, data.q);
                        break;
                    case 'TubeGeometry':
                    case 'TubeBufferGeometry':
                        // This only works for built-in curves (e.g. CatmullRomCurve3).
                        // User defined curves or instances of CurvePath will not be deserialized.
                        geometry = new Geometries[data.type](new Curves[data.path.type]().fromJSON(data.path), data.tubularSegments, data.radius, data.radialSegments, data.closed);
                        break;
                    case 'LatheGeometry':
                    case 'LatheBufferGeometry':
                        geometry = new Geometries[data.type](data.points, data.segments, data.phiStart, data.phiLength);
                        break;
                    case 'PolyhedronGeometry':
                    case 'PolyhedronBufferGeometry':
                        geometry = new Geometries[data.type](data.vertices, data.indices, data.radius, data.details);
                        break;
                    case 'ShapeGeometry':
                    case 'ShapeBufferGeometry':
                        geometryShapes = [];
                        for(let j = 0, jl = data.shapes.length; j < jl; j++){
                            const shape = shapes[data.shapes[j]];
                            geometryShapes.push(shape);
                        }
                        geometry = new Geometries[data.type](geometryShapes, data.curveSegments);
                        break;
                    case 'ExtrudeGeometry':
                    case 'ExtrudeBufferGeometry':
                        geometryShapes = [];
                        for(let j = 0, jl = data.shapes.length; j < jl; j++){
                            const shape = shapes[data.shapes[j]];
                            geometryShapes.push(shape);
                        }
                        const extrudePath = data.options.extrudePath;
                        if (extrudePath !== undefined) data.options.extrudePath = new Curves[extrudePath.type]().fromJSON(extrudePath);
                        geometry = new Geometries[data.type](geometryShapes, data.options);
                        break;
                    case 'BufferGeometry':
                    case 'InstancedBufferGeometry':
                        geometry = bufferGeometryLoader.parse(data);
                        break;
                    case 'Geometry':
                        console.error('THREE.ObjectLoader: Loading "Geometry" is not supported anymore.');
                        break;
                    default:
                        console.warn('THREE.ObjectLoader: Unsupported geometry type "' + data.type + '"');
                        continue;
                }
                geometry.uuid = data.uuid;
                if (data.name !== undefined) geometry.name = data.name;
                if (geometry.isBufferGeometry === true && data.userData !== undefined) geometry.userData = data.userData;
                geometries[data.uuid] = geometry;
            }
        }
        return geometries;
    }
    parseMaterials(json, textures) {
        const cache = {}; // MultiMaterial
        const materials = {};
        if (json !== undefined) {
            const loader = new MaterialLoader();
            loader.setTextures(textures);
            for(let i = 0, l = json.length; i < l; i++){
                const data = json[i];
                if (data.type === 'MultiMaterial') {
                    // Deprecated
                    const array = [];
                    for(let j = 0; j < data.materials.length; j++){
                        const material = data.materials[j];
                        if (cache[material.uuid] === undefined) cache[material.uuid] = loader.parse(material);
                        array.push(cache[material.uuid]);
                    }
                    materials[data.uuid] = array;
                } else {
                    if (cache[data.uuid] === undefined) cache[data.uuid] = loader.parse(data);
                    materials[data.uuid] = cache[data.uuid];
                }
            }
        }
        return materials;
    }
    parseAnimations(json) {
        const animations = {};
        if (json !== undefined) for(let i = 0; i < json.length; i++){
            const data = json[i];
            const clip = AnimationClip.parse(data);
            animations[clip.uuid] = clip;
        }
        return animations;
    }
    parseImages(json, onLoad) {
        const scope = this;
        const images = {};
        let loader;
        function loadImage(url) {
            scope.manager.itemStart(url);
            return loader.load(url, function() {
                scope.manager.itemEnd(url);
            }, undefined, function() {
                scope.manager.itemError(url);
                scope.manager.itemEnd(url);
            });
        }
        function deserializeImage(image) {
            if (typeof image === 'string') {
                const url = image;
                const path = /^(\/\/)|([a-z]+:(\/\/)?)/i.test(url) ? url : scope.resourcePath + url;
                return loadImage(path);
            } else {
                if (image.data) return {
                    data: getTypedArray(image.type, image.data),
                    width: image.width,
                    height: image.height
                };
                else return null;
            }
        }
        if (json !== undefined && json.length > 0) {
            const manager = new LoadingManager(onLoad);
            loader = new ImageLoader(manager);
            loader.setCrossOrigin(this.crossOrigin);
            for(let i = 0, il = json.length; i < il; i++){
                const image = json[i];
                const url = image.url;
                if (Array.isArray(url)) {
                    // load array of images e.g CubeTexture
                    images[image.uuid] = [];
                    for(let j = 0, jl = url.length; j < jl; j++){
                        const currentUrl = url[j];
                        const deserializedImage = deserializeImage(currentUrl);
                        if (deserializedImage !== null) {
                            if (deserializedImage instanceof HTMLImageElement) images[image.uuid].push(deserializedImage);
                            else // special case: handle array of data textures for cube textures
                            images[image.uuid].push(new DataTexture(deserializedImage.data, deserializedImage.width, deserializedImage.height));
                        }
                    }
                } else {
                    // load single image
                    const deserializedImage = deserializeImage(image.url);
                    if (deserializedImage !== null) images[image.uuid] = deserializedImage;
                }
            }
        }
        return images;
    }
    parseTextures(json, images) {
        function parseConstant(value, type) {
            if (typeof value === 'number') return value;
            console.warn('THREE.ObjectLoader.parseTexture: Constant should be in numeric form.', value);
            return type[value];
        }
        const textures = {};
        if (json !== undefined) for(let i = 0, l = json.length; i < l; i++){
            const data = json[i];
            if (data.image === undefined) console.warn('THREE.ObjectLoader: No "image" specified for', data.uuid);
            if (images[data.image] === undefined) console.warn('THREE.ObjectLoader: Undefined image', data.image);
            let texture;
            const image = images[data.image];
            if (Array.isArray(image)) {
                texture = new CubeTexture(image);
                if (image.length === 6) texture.needsUpdate = true;
            } else {
                if (image && image.data) texture = new DataTexture(image.data, image.width, image.height);
                else texture = new Texture(image);
                if (image) texture.needsUpdate = true; // textures can have undefined image data
            }
            texture.uuid = data.uuid;
            if (data.name !== undefined) texture.name = data.name;
            if (data.mapping !== undefined) texture.mapping = parseConstant(data.mapping, TEXTURE_MAPPING);
            if (data.offset !== undefined) texture.offset.fromArray(data.offset);
            if (data.repeat !== undefined) texture.repeat.fromArray(data.repeat);
            if (data.center !== undefined) texture.center.fromArray(data.center);
            if (data.rotation !== undefined) texture.rotation = data.rotation;
            if (data.wrap !== undefined) {
                texture.wrapS = parseConstant(data.wrap[0], TEXTURE_WRAPPING);
                texture.wrapT = parseConstant(data.wrap[1], TEXTURE_WRAPPING);
            }
            if (data.format !== undefined) texture.format = data.format;
            if (data.type !== undefined) texture.type = data.type;
            if (data.encoding !== undefined) texture.encoding = data.encoding;
            if (data.minFilter !== undefined) texture.minFilter = parseConstant(data.minFilter, TEXTURE_FILTER);
            if (data.magFilter !== undefined) texture.magFilter = parseConstant(data.magFilter, TEXTURE_FILTER);
            if (data.anisotropy !== undefined) texture.anisotropy = data.anisotropy;
            if (data.flipY !== undefined) texture.flipY = data.flipY;
            if (data.premultiplyAlpha !== undefined) texture.premultiplyAlpha = data.premultiplyAlpha;
            if (data.unpackAlignment !== undefined) texture.unpackAlignment = data.unpackAlignment;
            textures[data.uuid] = texture;
        }
        return textures;
    }
    parseObject(data, geometries, materials, animations) {
        let object;
        function getGeometry(name) {
            if (geometries[name] === undefined) console.warn('THREE.ObjectLoader: Undefined geometry', name);
            return geometries[name];
        }
        function getMaterial(name) {
            if (name === undefined) return undefined;
            if (Array.isArray(name)) {
                const array = [];
                for(let i = 0, l = name.length; i < l; i++){
                    const uuid = name[i];
                    if (materials[uuid] === undefined) console.warn('THREE.ObjectLoader: Undefined material', uuid);
                    array.push(materials[uuid]);
                }
                return array;
            }
            if (materials[name] === undefined) console.warn('THREE.ObjectLoader: Undefined material', name);
            return materials[name];
        }
        let geometry, material;
        switch(data.type){
            case 'Scene':
                object = new Scene();
                if (data.background !== undefined) {
                    if (Number.isInteger(data.background)) object.background = new Color(data.background);
                }
                if (data.fog !== undefined) {
                    if (data.fog.type === 'Fog') object.fog = new Fog(data.fog.color, data.fog.near, data.fog.far);
                    else if (data.fog.type === 'FogExp2') object.fog = new FogExp2(data.fog.color, data.fog.density);
                }
                break;
            case 'PerspectiveCamera':
                object = new PerspectiveCamera(data.fov, data.aspect, data.near, data.far);
                if (data.focus !== undefined) object.focus = data.focus;
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.filmGauge !== undefined) object.filmGauge = data.filmGauge;
                if (data.filmOffset !== undefined) object.filmOffset = data.filmOffset;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'OrthographicCamera':
                object = new OrthographicCamera(data.left, data.right, data.top, data.bottom, data.near, data.far);
                if (data.zoom !== undefined) object.zoom = data.zoom;
                if (data.view !== undefined) object.view = Object.assign({}, data.view);
                break;
            case 'AmbientLight':
                object = new AmbientLight(data.color, data.intensity);
                break;
            case 'DirectionalLight':
                object = new DirectionalLight(data.color, data.intensity);
                break;
            case 'PointLight':
                object = new PointLight(data.color, data.intensity, data.distance, data.decay);
                break;
            case 'RectAreaLight':
                object = new RectAreaLight(data.color, data.intensity, data.width, data.height);
                break;
            case 'SpotLight':
                object = new SpotLight(data.color, data.intensity, data.distance, data.angle, data.penumbra, data.decay);
                break;
            case 'HemisphereLight':
                object = new HemisphereLight(data.color, data.groundColor, data.intensity);
                break;
            case 'LightProbe':
                object = new LightProbe().fromJSON(data);
                break;
            case 'SkinnedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new SkinnedMesh(geometry, material);
                if (data.bindMode !== undefined) object.bindMode = data.bindMode;
                if (data.bindMatrix !== undefined) object.bindMatrix.fromArray(data.bindMatrix);
                if (data.skeleton !== undefined) object.skeleton = data.skeleton;
                break;
            case 'Mesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                object = new Mesh(geometry, material);
                break;
            case 'InstancedMesh':
                geometry = getGeometry(data.geometry);
                material = getMaterial(data.material);
                const count = data.count;
                const instanceMatrix = data.instanceMatrix;
                object = new InstancedMesh(geometry, material, count);
                object.instanceMatrix = new BufferAttribute(new Float32Array(instanceMatrix.array), 16);
                break;
            case 'LOD':
                object = new LOD();
                break;
            case 'Line':
                object = new Line(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineLoop':
                object = new LineLoop(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'LineSegments':
                object = new LineSegments(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'PointCloud':
            case 'Points':
                object = new Points(getGeometry(data.geometry), getMaterial(data.material));
                break;
            case 'Sprite':
                object = new Sprite(getMaterial(data.material));
                break;
            case 'Group':
                object = new Group();
                break;
            case 'Bone':
                object = new Bone();
                break;
            default:
                object = new Object3D();
        }
        object.uuid = data.uuid;
        if (data.name !== undefined) object.name = data.name;
        if (data.matrix !== undefined) {
            object.matrix.fromArray(data.matrix);
            if (data.matrixAutoUpdate !== undefined) object.matrixAutoUpdate = data.matrixAutoUpdate;
            if (object.matrixAutoUpdate) object.matrix.decompose(object.position, object.quaternion, object.scale);
        } else {
            if (data.position !== undefined) object.position.fromArray(data.position);
            if (data.rotation !== undefined) object.rotation.fromArray(data.rotation);
            if (data.quaternion !== undefined) object.quaternion.fromArray(data.quaternion);
            if (data.scale !== undefined) object.scale.fromArray(data.scale);
        }
        if (data.castShadow !== undefined) object.castShadow = data.castShadow;
        if (data.receiveShadow !== undefined) object.receiveShadow = data.receiveShadow;
        if (data.shadow) {
            if (data.shadow.bias !== undefined) object.shadow.bias = data.shadow.bias;
            if (data.shadow.normalBias !== undefined) object.shadow.normalBias = data.shadow.normalBias;
            if (data.shadow.radius !== undefined) object.shadow.radius = data.shadow.radius;
            if (data.shadow.mapSize !== undefined) object.shadow.mapSize.fromArray(data.shadow.mapSize);
            if (data.shadow.camera !== undefined) object.shadow.camera = this.parseObject(data.shadow.camera);
        }
        if (data.visible !== undefined) object.visible = data.visible;
        if (data.frustumCulled !== undefined) object.frustumCulled = data.frustumCulled;
        if (data.renderOrder !== undefined) object.renderOrder = data.renderOrder;
        if (data.userData !== undefined) object.userData = data.userData;
        if (data.layers !== undefined) object.layers.mask = data.layers;
        if (data.children !== undefined) {
            const children = data.children;
            for(let i = 0; i < children.length; i++)object.add(this.parseObject(children[i], geometries, materials, animations));
        }
        if (data.animations !== undefined) {
            const objectAnimations = data.animations;
            for(let i = 0; i < objectAnimations.length; i++){
                const uuid = objectAnimations[i];
                object.animations.push(animations[uuid]);
            }
        }
        if (data.type === 'LOD') {
            if (data.autoUpdate !== undefined) object.autoUpdate = data.autoUpdate;
            const levels = data.levels;
            for(let l = 0; l < levels.length; l++){
                const level = levels[l];
                const child = object.getObjectByProperty('uuid', level.object);
                if (child !== undefined) object.addLevel(child, level.distance);
            }
        }
        return object;
    }
    bindSkeletons(object, skeletons) {
        if (Object.keys(skeletons).length === 0) return;
        object.traverse(function(child) {
            if (child.isSkinnedMesh === true && child.skeleton !== undefined) {
                const skeleton = skeletons[child.skeleton];
                if (skeleton === undefined) console.warn('THREE.ObjectLoader: No skeleton found with UUID:', child.skeleton);
                else child.bind(skeleton, child.bindMatrix);
            }
        });
    }
    /* DEPRECATED */ setTexturePath(value) {
        console.warn('THREE.ObjectLoader: .setTexturePath() has been renamed to .setResourcePath().');
        return this.setResourcePath(value);
    }
}
const TEXTURE_MAPPING = {
    UVMapping: UVMapping,
    CubeReflectionMapping: CubeReflectionMapping,
    CubeRefractionMapping: CubeRefractionMapping,
    EquirectangularReflectionMapping: EquirectangularReflectionMapping,
    EquirectangularRefractionMapping: EquirectangularRefractionMapping,
    CubeUVReflectionMapping: CubeUVReflectionMapping,
    CubeUVRefractionMapping: CubeUVRefractionMapping
};
const TEXTURE_WRAPPING = {
    RepeatWrapping: RepeatWrapping,
    ClampToEdgeWrapping: ClampToEdgeWrapping,
    MirroredRepeatWrapping: MirroredRepeatWrapping
};
const TEXTURE_FILTER = {
    NearestFilter: NearestFilter,
    NearestMipmapNearestFilter: NearestMipmapNearestFilter,
    NearestMipmapLinearFilter: NearestMipmapLinearFilter,
    LinearFilter: LinearFilter,
    LinearMipmapNearestFilter: LinearMipmapNearestFilter,
    LinearMipmapLinearFilter: LinearMipmapLinearFilter
};
function ImageBitmapLoader(manager) {
    if (typeof createImageBitmap === 'undefined') console.warn('THREE.ImageBitmapLoader: createImageBitmap() not supported.');
    if (typeof fetch === 'undefined') console.warn('THREE.ImageBitmapLoader: fetch() not supported.');
    Loader.call(this, manager);
    this.options = {
        premultiplyAlpha: 'none'
    };
}
ImageBitmapLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: ImageBitmapLoader,
    isImageBitmapLoader: true,
    setOptions: function setOptions(options) {
        this.options = options;
        return this;
    },
    load: function(url, onLoad, onProgress, onError) {
        if (url === undefined) url = '';
        if (this.path !== undefined) url = this.path + url;
        url = this.manager.resolveURL(url);
        const scope = this;
        const cached = Cache.get(url);
        if (cached !== undefined) {
            scope.manager.itemStart(url);
            setTimeout(function() {
                if (onLoad) onLoad(cached);
                scope.manager.itemEnd(url);
            }, 0);
            return cached;
        }
        const fetchOptions = {};
        fetchOptions.credentials = this.crossOrigin === 'anonymous' ? 'same-origin' : 'include';
        fetch(url, fetchOptions).then(function(res) {
            return res.blob();
        }).then(function(blob) {
            return createImageBitmap(blob, scope.options);
        }).then(function(imageBitmap) {
            Cache.add(url, imageBitmap);
            if (onLoad) onLoad(imageBitmap);
            scope.manager.itemEnd(url);
        }).catch(function(e) {
            if (onError) onError(e);
            scope.manager.itemError(url);
            scope.manager.itemEnd(url);
        });
        scope.manager.itemStart(url);
    }
});
function ShapePath() {
    this.type = 'ShapePath';
    this.color = new Color();
    this.subPaths = [];
    this.currentPath = null;
}
Object.assign(ShapePath.prototype, {
    moveTo: function(x, y) {
        this.currentPath = new Path();
        this.subPaths.push(this.currentPath);
        this.currentPath.moveTo(x, y);
        return this;
    },
    lineTo: function(x, y) {
        this.currentPath.lineTo(x, y);
        return this;
    },
    quadraticCurveTo: function(aCPx, aCPy, aX, aY) {
        this.currentPath.quadraticCurveTo(aCPx, aCPy, aX, aY);
        return this;
    },
    bezierCurveTo: function(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY) {
        this.currentPath.bezierCurveTo(aCP1x, aCP1y, aCP2x, aCP2y, aX, aY);
        return this;
    },
    splineThru: function(pts) {
        this.currentPath.splineThru(pts);
        return this;
    },
    toShapes: function(isCCW, noHoles) {
        function toShapesNoHoles(inSubpaths) {
            const shapes = [];
            for(let i = 0, l = inSubpaths.length; i < l; i++){
                const tmpPath = inSubpaths[i];
                const tmpShape = new Shape();
                tmpShape.curves = tmpPath.curves;
                shapes.push(tmpShape);
            }
            return shapes;
        }
        function isPointInsidePolygon(inPt, inPolygon) {
            const polyLen = inPolygon.length;
            // inPt on polygon contour => immediate success    or
            // toggling of inside/outside at every single! intersection point of an edge
            //  with the horizontal line through inPt, left of inPt
            //  not counting lowerY endpoints of edges and whole edges on that line
            let inside = false;
            for(let p = polyLen - 1, q = 0; q < polyLen; p = q++){
                let edgeLowPt = inPolygon[p];
                let edgeHighPt = inPolygon[q];
                let edgeDx = edgeHighPt.x - edgeLowPt.x;
                let edgeDy = edgeHighPt.y - edgeLowPt.y;
                if (Math.abs(edgeDy) > Number.EPSILON) {
                    // not parallel
                    if (edgeDy < 0) {
                        edgeLowPt = inPolygon[q];
                        edgeDx = -edgeDx;
                        edgeHighPt = inPolygon[p];
                        edgeDy = -edgeDy;
                    }
                    if (inPt.y < edgeLowPt.y || inPt.y > edgeHighPt.y) continue;
                    if (inPt.y === edgeLowPt.y) {
                        if (inPt.x === edgeLowPt.x) return true; // inPt is on contour ?
                    // continue;				// no intersection or edgeLowPt => doesn't count !!!
                    } else {
                        const perpEdge = edgeDy * (inPt.x - edgeLowPt.x) - edgeDx * (inPt.y - edgeLowPt.y);
                        if (perpEdge === 0) return true; // inPt is on contour ?
                        if (perpEdge < 0) continue;
                        inside = !inside; // true intersection left of inPt
                    }
                } else {
                    // parallel or collinear
                    if (inPt.y !== edgeLowPt.y) continue; // parallel
                    // edge lies on the same horizontal line as inPt
                    if (edgeHighPt.x <= inPt.x && inPt.x <= edgeLowPt.x || edgeLowPt.x <= inPt.x && inPt.x <= edgeHighPt.x) return true; // inPt: Point on contour !
                // continue;
                }
            }
            return inside;
        }
        const isClockWise = ShapeUtils.isClockWise;
        const subPaths = this.subPaths;
        if (subPaths.length === 0) return [];
        if (noHoles === true) return toShapesNoHoles(subPaths);
        let solid, tmpPath, tmpShape;
        const shapes = [];
        if (subPaths.length === 1) {
            tmpPath = subPaths[0];
            tmpShape = new Shape();
            tmpShape.curves = tmpPath.curves;
            shapes.push(tmpShape);
            return shapes;
        }
        let holesFirst = !isClockWise(subPaths[0].getPoints());
        holesFirst = isCCW ? !holesFirst : holesFirst;
        // console.log("Holes first", holesFirst);
        const betterShapeHoles = [];
        const newShapes = [];
        let newShapeHoles = [];
        let mainIdx = 0;
        let tmpPoints;
        newShapes[mainIdx] = undefined;
        newShapeHoles[mainIdx] = [];
        for(let i = 0, l = subPaths.length; i < l; i++){
            tmpPath = subPaths[i];
            tmpPoints = tmpPath.getPoints();
            solid = isClockWise(tmpPoints);
            solid = isCCW ? !solid : solid;
            if (solid) {
                if (!holesFirst && newShapes[mainIdx]) mainIdx++;
                newShapes[mainIdx] = {
                    s: new Shape(),
                    p: tmpPoints
                };
                newShapes[mainIdx].s.curves = tmpPath.curves;
                if (holesFirst) mainIdx++;
                newShapeHoles[mainIdx] = [];
            //console.log('cw', i);
            } else newShapeHoles[mainIdx].push({
                h: tmpPath,
                p: tmpPoints[0]
            });
        }
        // only Holes? -> probably all Shapes with wrong orientation
        if (!newShapes[0]) return toShapesNoHoles(subPaths);
        if (newShapes.length > 1) {
            let ambiguous = false;
            const toChange = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++)betterShapeHoles[sIdx] = [];
            for(let sIdx = 0, sLen = newShapes.length; sIdx < sLen; sIdx++){
                const sho = newShapeHoles[sIdx];
                for(let hIdx = 0; hIdx < sho.length; hIdx++){
                    const ho = sho[hIdx];
                    let hole_unassigned = true;
                    for(let s2Idx = 0; s2Idx < newShapes.length; s2Idx++)if (isPointInsidePolygon(ho.p, newShapes[s2Idx].p)) {
                        if (sIdx !== s2Idx) toChange.push({
                            froms: sIdx,
                            tos: s2Idx,
                            hole: hIdx
                        });
                        if (hole_unassigned) {
                            hole_unassigned = false;
                            betterShapeHoles[s2Idx].push(ho);
                        } else ambiguous = true;
                    }
                    if (hole_unassigned) betterShapeHoles[sIdx].push(ho);
                }
            }
            // console.log("ambiguous: ", ambiguous);
            if (toChange.length > 0) // console.log("to change: ", toChange);
            {
                if (!ambiguous) newShapeHoles = betterShapeHoles;
            }
        }
        let tmpHoles;
        for(let i = 0, il = newShapes.length; i < il; i++){
            tmpShape = newShapes[i].s;
            shapes.push(tmpShape);
            tmpHoles = newShapeHoles[i];
            for(let j = 0, jl = tmpHoles.length; j < jl; j++)tmpShape.holes.push(tmpHoles[j].h);
        }
        //console.log("shape", shapes);
        return shapes;
    }
});
class Font {
    constructor(data){
        Object.defineProperty(this, 'isFont', {
            value: true
        });
        this.type = 'Font';
        this.data = data;
    }
    generateShapes(text, size = 100) {
        const shapes = [];
        const paths = createPaths(text, size, this.data);
        for(let p = 0, pl = paths.length; p < pl; p++)Array.prototype.push.apply(shapes, paths[p].toShapes());
        return shapes;
    }
}
function createPaths(text, size, data) {
    const chars = Array.from ? Array.from(text) : String(text).split(''); // workaround for IE11, see #13988
    const scale = size / data.resolution;
    const line_height = (data.boundingBox.yMax - data.boundingBox.yMin + data.underlineThickness) * scale;
    const paths = [];
    let offsetX = 0, offsetY = 0;
    for(let i = 0; i < chars.length; i++){
        const char = chars[i];
        if (char === '\n') {
            offsetX = 0;
            offsetY -= line_height;
        } else {
            const ret = createPath(char, scale, offsetX, offsetY, data);
            offsetX += ret.offsetX;
            paths.push(ret.path);
        }
    }
    return paths;
}
function createPath(char, scale, offsetX, offsetY, data) {
    const glyph = data.glyphs[char] || data.glyphs['?'];
    if (!glyph) {
        console.error('THREE.Font: character "' + char + '" does not exists in font family ' + data.familyName + '.');
        return;
    }
    const path = new ShapePath();
    let x, y, cpx, cpy, cpx1, cpy1, cpx2, cpy2;
    if (glyph.o) {
        const outline = glyph._cachedOutline || (glyph._cachedOutline = glyph.o.split(' '));
        for(let i = 0, l = outline.length; i < l;){
            const action = outline[i++];
            switch(action){
                case 'm':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.moveTo(x, y);
                    break;
                case 'l':
                    x = outline[i++] * scale + offsetX;
                    y = outline[i++] * scale + offsetY;
                    path.lineTo(x, y);
                    break;
                case 'q':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    path.quadraticCurveTo(cpx1, cpy1, cpx, cpy);
                    break;
                case 'b':
                    cpx = outline[i++] * scale + offsetX;
                    cpy = outline[i++] * scale + offsetY;
                    cpx1 = outline[i++] * scale + offsetX;
                    cpy1 = outline[i++] * scale + offsetY;
                    cpx2 = outline[i++] * scale + offsetX;
                    cpy2 = outline[i++] * scale + offsetY;
                    path.bezierCurveTo(cpx1, cpy1, cpx2, cpy2, cpx, cpy);
                    break;
            }
        }
    }
    return {
        offsetX: glyph.ha * scale,
        path: path
    };
}
function FontLoader(manager) {
    Loader.call(this, manager);
}
FontLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: FontLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(this.manager);
        loader.setPath(this.path);
        loader.setRequestHeader(this.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(text) {
            let json;
            try {
                json = JSON.parse(text);
            } catch (e) {
                console.warn('THREE.FontLoader: typeface.js support is being deprecated. Use typeface.json instead.');
                json = JSON.parse(text.substring(65, text.length - 2));
            }
            const font = scope.parse(json);
            if (onLoad) onLoad(font);
        }, onProgress, onError);
    },
    parse: function(json) {
        return new Font(json);
    }
});
let _context;
const AudioContext = {
    getContext: function() {
        if (_context === undefined) _context = new (window.AudioContext || window.webkitAudioContext)();
        return _context;
    },
    setContext: function(value) {
        _context = value;
    }
};
function AudioLoader(manager) {
    Loader.call(this, manager);
}
AudioLoader.prototype = Object.assign(Object.create(Loader.prototype), {
    constructor: AudioLoader,
    load: function(url, onLoad, onProgress, onError) {
        const scope = this;
        const loader = new FileLoader(scope.manager);
        loader.setResponseType('arraybuffer');
        loader.setPath(scope.path);
        loader.setRequestHeader(scope.requestHeader);
        loader.setWithCredentials(scope.withCredentials);
        loader.load(url, function(buffer) {
            try {
                // Create a copy of the buffer. The `decodeAudioData` method
                // detaches the buffer when complete, preventing reuse.
                const bufferCopy = buffer.slice(0);
                const context = AudioContext.getContext();
                context.decodeAudioData(bufferCopy, function(audioBuffer) {
                    onLoad(audioBuffer);
                });
            } catch (e) {
                if (onError) onError(e);
                else console.error(e);
                scope.manager.itemError(url);
            }
        }, onProgress, onError);
    }
});
function HemisphereLightProbe(skyColor, groundColor, intensity) {
    LightProbe.call(this, undefined, intensity);
    const color1 = new Color().set(skyColor);
    const color2 = new Color().set(groundColor);
    const sky = new Vector3(color1.r, color1.g, color1.b);
    const ground = new Vector3(color2.r, color2.g, color2.b);
    // without extra factor of PI in the shader, should = 1 / Math.sqrt( Math.PI );
    const c0 = Math.sqrt(Math.PI);
    const c1 = c0 * Math.sqrt(0.75);
    this.sh.coefficients[0].copy(sky).add(ground).multiplyScalar(c0);
    this.sh.coefficients[1].copy(sky).sub(ground).multiplyScalar(c1);
}
HemisphereLightProbe.prototype = Object.assign(Object.create(LightProbe.prototype), {
    constructor: HemisphereLightProbe,
    isHemisphereLightProbe: true,
    copy: function(source) {
        LightProbe.prototype.copy.call(this, source);
        return this;
    },
    toJSON: function(meta) {
        const data = LightProbe.prototype.toJSON.call(this, meta);
        // data.sh = this.sh.toArray(); // todo
        return data;
    }
});
function AmbientLightProbe(color, intensity) {
    LightProbe.call(this, undefined, intensity);
    const color1 = new Color().set(color);
    // without extra factor of PI in the shader, would be 2 / Math.sqrt( Math.PI );
    this.sh.coefficients[0].set(color1.r, color1.g, color1.b).multiplyScalar(2 * Math.sqrt(Math.PI));
}
AmbientLightProbe.prototype = Object.assign(Object.create(LightProbe.prototype), {
    constructor: AmbientLightProbe,
    isAmbientLightProbe: true,
    copy: function(source) {
        LightProbe.prototype.copy.call(this, source);
        return this;
    },
    toJSON: function(meta) {
        const data = LightProbe.prototype.toJSON.call(this, meta);
        // data.sh = this.sh.toArray(); // todo
        return data;
    }
});
const _eyeRight = new Matrix4();
const _eyeLeft = new Matrix4();
function StereoCamera() {
    this.type = 'StereoCamera';
    this.aspect = 1;
    this.eyeSep = 0.064;
    this.cameraL = new PerspectiveCamera();
    this.cameraL.layers.enable(1);
    this.cameraL.matrixAutoUpdate = false;
    this.cameraR = new PerspectiveCamera();
    this.cameraR.layers.enable(2);
    this.cameraR.matrixAutoUpdate = false;
    this._cache = {
        focus: null,
        fov: null,
        aspect: null,
        near: null,
        far: null,
        zoom: null,
        eyeSep: null
    };
}
Object.assign(StereoCamera.prototype, {
    update: function(camera) {
        const cache = this._cache;
        const needsUpdate = cache.focus !== camera.focus || cache.fov !== camera.fov || cache.aspect !== camera.aspect * this.aspect || cache.near !== camera.near || cache.far !== camera.far || cache.zoom !== camera.zoom || cache.eyeSep !== this.eyeSep;
        if (needsUpdate) {
            cache.focus = camera.focus;
            cache.fov = camera.fov;
            cache.aspect = camera.aspect * this.aspect;
            cache.near = camera.near;
            cache.far = camera.far;
            cache.zoom = camera.zoom;
            cache.eyeSep = this.eyeSep;
            // Off-axis stereoscopic effect based on
            // http://paulbourke.net/stereographics/stereorender/
            const projectionMatrix = camera.projectionMatrix.clone();
            const eyeSepHalf = cache.eyeSep / 2;
            const eyeSepOnProjection = eyeSepHalf * cache.near / cache.focus;
            const ymax = cache.near * Math.tan(MathUtils.DEG2RAD * cache.fov * 0.5) / cache.zoom;
            let xmin, xmax;
            // translate xOffset
            _eyeLeft.elements[12] = -eyeSepHalf;
            _eyeRight.elements[12] = eyeSepHalf;
            // for left eye
            xmin = -ymax * cache.aspect + eyeSepOnProjection;
            xmax = ymax * cache.aspect + eyeSepOnProjection;
            projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraL.projectionMatrix.copy(projectionMatrix);
            // for right eye
            xmin = -ymax * cache.aspect - eyeSepOnProjection;
            xmax = ymax * cache.aspect - eyeSepOnProjection;
            projectionMatrix.elements[0] = 2 * cache.near / (xmax - xmin);
            projectionMatrix.elements[8] = (xmax + xmin) / (xmax - xmin);
            this.cameraR.projectionMatrix.copy(projectionMatrix);
        }
        this.cameraL.matrixWorld.copy(camera.matrixWorld).multiply(_eyeLeft);
        this.cameraR.matrixWorld.copy(camera.matrixWorld).multiply(_eyeRight);
    }
});
class Clock {
    constructor(autoStart){
        this.autoStart = autoStart !== undefined ? autoStart : true;
        this.startTime = 0;
        this.oldTime = 0;
        this.elapsedTime = 0;
        this.running = false;
    }
    start() {
        this.startTime = now();
        this.oldTime = this.startTime;
        this.elapsedTime = 0;
        this.running = true;
    }
    stop() {
        this.getElapsedTime();
        this.running = false;
        this.autoStart = false;
    }
    getElapsedTime() {
        this.getDelta();
        return this.elapsedTime;
    }
    getDelta() {
        let diff = 0;
        if (this.autoStart && !this.running) {
            this.start();
            return 0;
        }
        if (this.running) {
            const newTime = now();
            diff = (newTime - this.oldTime) / 1000;
            this.oldTime = newTime;
            this.elapsedTime += diff;
        }
        return diff;
    }
}
function now() {
    return (typeof performance === 'undefined' ? Date : performance).now(); // see #10732
}
const _position$2 = /*@__PURE__*/ new Vector3();
const _quaternion$3 = /*@__PURE__*/ new Quaternion();
const _scale$1 = /*@__PURE__*/ new Vector3();
const _orientation = /*@__PURE__*/ new Vector3();
class AudioListener extends Object3D {
    constructor(){
        super();
        this.type = 'AudioListener';
        this.context = AudioContext.getContext();
        this.gain = this.context.createGain();
        this.gain.connect(this.context.destination);
        this.filter = null;
        this.timeDelta = 0;
        // private
        this._clock = new Clock();
    }
    getInput() {
        return this.gain;
    }
    removeFilter() {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
            this.gain.connect(this.context.destination);
            this.filter = null;
        }
        return this;
    }
    getFilter() {
        return this.filter;
    }
    setFilter(value) {
        if (this.filter !== null) {
            this.gain.disconnect(this.filter);
            this.filter.disconnect(this.context.destination);
        } else this.gain.disconnect(this.context.destination);
        this.filter = value;
        this.gain.connect(this.filter);
        this.filter.connect(this.context.destination);
        return this;
    }
    getMasterVolume() {
        return this.gain.gain.value;
    }
    setMasterVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        const listener = this.context.listener;
        const up = this.up;
        this.timeDelta = this._clock.getDelta();
        this.matrixWorld.decompose(_position$2, _quaternion$3, _scale$1);
        _orientation.set(0, 0, -1).applyQuaternion(_quaternion$3);
        if (listener.positionX) {
            // code path for Chrome (see #14393)
            const endTime = this.context.currentTime + this.timeDelta;
            listener.positionX.linearRampToValueAtTime(_position$2.x, endTime);
            listener.positionY.linearRampToValueAtTime(_position$2.y, endTime);
            listener.positionZ.linearRampToValueAtTime(_position$2.z, endTime);
            listener.forwardX.linearRampToValueAtTime(_orientation.x, endTime);
            listener.forwardY.linearRampToValueAtTime(_orientation.y, endTime);
            listener.forwardZ.linearRampToValueAtTime(_orientation.z, endTime);
            listener.upX.linearRampToValueAtTime(up.x, endTime);
            listener.upY.linearRampToValueAtTime(up.y, endTime);
            listener.upZ.linearRampToValueAtTime(up.z, endTime);
        } else {
            listener.setPosition(_position$2.x, _position$2.y, _position$2.z);
            listener.setOrientation(_orientation.x, _orientation.y, _orientation.z, up.x, up.y, up.z);
        }
    }
}
class Audio extends Object3D {
    constructor(listener){
        super();
        this.type = 'Audio';
        this.listener = listener;
        this.context = listener.context;
        this.gain = this.context.createGain();
        this.gain.connect(listener.getInput());
        this.autoplay = false;
        this.buffer = null;
        this.detune = 0;
        this.loop = false;
        this.loopStart = 0;
        this.loopEnd = 0;
        this.offset = 0;
        this.duration = undefined;
        this.playbackRate = 1;
        this.isPlaying = false;
        this.hasPlaybackControl = true;
        this.source = null;
        this.sourceType = 'empty';
        this._startedAt = 0;
        this._progress = 0;
        this._connected = false;
        this.filters = [];
    }
    getOutput() {
        return this.gain;
    }
    setNodeSource(audioNode) {
        this.hasPlaybackControl = false;
        this.sourceType = 'audioNode';
        this.source = audioNode;
        this.connect();
        return this;
    }
    setMediaElementSource(mediaElement) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaNode';
        this.source = this.context.createMediaElementSource(mediaElement);
        this.connect();
        return this;
    }
    setMediaStreamSource(mediaStream) {
        this.hasPlaybackControl = false;
        this.sourceType = 'mediaStreamNode';
        this.source = this.context.createMediaStreamSource(mediaStream);
        this.connect();
        return this;
    }
    setBuffer(audioBuffer) {
        this.buffer = audioBuffer;
        this.sourceType = 'buffer';
        if (this.autoplay) this.play();
        return this;
    }
    play(delay = 0) {
        if (this.isPlaying === true) {
            console.warn('THREE.Audio: Audio is already playing.');
            return;
        }
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._startedAt = this.context.currentTime + delay;
        const source = this.context.createBufferSource();
        source.buffer = this.buffer;
        source.loop = this.loop;
        source.loopStart = this.loopStart;
        source.loopEnd = this.loopEnd;
        source.onended = this.onEnded.bind(this);
        source.start(this._startedAt, this._progress + this.offset, this.duration);
        this.isPlaying = true;
        this.source = source;
        this.setDetune(this.detune);
        this.setPlaybackRate(this.playbackRate);
        return this.connect();
    }
    pause() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        if (this.isPlaying === true) {
            // update current progress
            this._progress += Math.max(this.context.currentTime - this._startedAt, 0) * this.playbackRate;
            if (this.loop === true) // ensure _progress does not exceed duration with looped audios
            this._progress = this._progress % (this.duration || this.buffer.duration);
            this.source.stop();
            this.source.onended = null;
            this.isPlaying = false;
        }
        return this;
    }
    stop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this._progress = 0;
        this.source.stop();
        this.source.onended = null;
        this.isPlaying = false;
        return this;
    }
    connect() {
        if (this.filters.length > 0) {
            this.source.connect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].connect(this.filters[i]);
            this.filters[this.filters.length - 1].connect(this.getOutput());
        } else this.source.connect(this.getOutput());
        this._connected = true;
        return this;
    }
    disconnect() {
        if (this.filters.length > 0) {
            this.source.disconnect(this.filters[0]);
            for(let i = 1, l = this.filters.length; i < l; i++)this.filters[i - 1].disconnect(this.filters[i]);
            this.filters[this.filters.length - 1].disconnect(this.getOutput());
        } else this.source.disconnect(this.getOutput());
        this._connected = false;
        return this;
    }
    getFilters() {
        return this.filters;
    }
    setFilters(value) {
        if (!value) value = [];
        if (this._connected === true) {
            this.disconnect();
            this.filters = value.slice();
            this.connect();
        } else this.filters = value.slice();
        return this;
    }
    setDetune(value) {
        this.detune = value;
        if (this.source.detune === undefined) return; // only set detune when available
        if (this.isPlaying === true) this.source.detune.setTargetAtTime(this.detune, this.context.currentTime, 0.01);
        return this;
    }
    getDetune() {
        return this.detune;
    }
    getFilter() {
        return this.getFilters()[0];
    }
    setFilter(filter) {
        return this.setFilters(filter ? [
            filter
        ] : []);
    }
    setPlaybackRate(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.playbackRate = value;
        if (this.isPlaying === true) this.source.playbackRate.setTargetAtTime(this.playbackRate, this.context.currentTime, 0.01);
        return this;
    }
    getPlaybackRate() {
        return this.playbackRate;
    }
    onEnded() {
        this.isPlaying = false;
    }
    getLoop() {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return false;
        }
        return this.loop;
    }
    setLoop(value) {
        if (this.hasPlaybackControl === false) {
            console.warn('THREE.Audio: this Audio has no playback control.');
            return;
        }
        this.loop = value;
        if (this.isPlaying === true) this.source.loop = this.loop;
        return this;
    }
    setLoopStart(value) {
        this.loopStart = value;
        return this;
    }
    setLoopEnd(value) {
        this.loopEnd = value;
        return this;
    }
    getVolume() {
        return this.gain.gain.value;
    }
    setVolume(value) {
        this.gain.gain.setTargetAtTime(value, this.context.currentTime, 0.01);
        return this;
    }
}
const _position$3 = /*@__PURE__*/ new Vector3();
const _quaternion$4 = /*@__PURE__*/ new Quaternion();
const _scale$2 = /*@__PURE__*/ new Vector3();
const _orientation$1 = /*@__PURE__*/ new Vector3();
class PositionalAudio extends Audio {
    constructor(listener){
        super(listener);
        this.panner = this.context.createPanner();
        this.panner.panningModel = 'HRTF';
        this.panner.connect(this.gain);
    }
    getOutput() {
        return this.panner;
    }
    getRefDistance() {
        return this.panner.refDistance;
    }
    setRefDistance(value) {
        this.panner.refDistance = value;
        return this;
    }
    getRolloffFactor() {
        return this.panner.rolloffFactor;
    }
    setRolloffFactor(value) {
        this.panner.rolloffFactor = value;
        return this;
    }
    getDistanceModel() {
        return this.panner.distanceModel;
    }
    setDistanceModel(value) {
        this.panner.distanceModel = value;
        return this;
    }
    getMaxDistance() {
        return this.panner.maxDistance;
    }
    setMaxDistance(value) {
        this.panner.maxDistance = value;
        return this;
    }
    setDirectionalCone(coneInnerAngle, coneOuterAngle, coneOuterGain) {
        this.panner.coneInnerAngle = coneInnerAngle;
        this.panner.coneOuterAngle = coneOuterAngle;
        this.panner.coneOuterGain = coneOuterGain;
        return this;
    }
    updateMatrixWorld(force) {
        super.updateMatrixWorld(force);
        if (this.hasPlaybackControl === true && this.isPlaying === false) return;
        this.matrixWorld.decompose(_position$3, _quaternion$4, _scale$2);
        _orientation$1.set(0, 0, 1).applyQuaternion(_quaternion$4);
        const panner = this.panner;
        if (panner.positionX) {
            // code path for Chrome and Firefox (see #14393)
            const endTime = this.context.currentTime + this.listener.timeDelta;
            panner.positionX.linearRampToValueAtTime(_position$3.x, endTime);
            panner.positionY.linearRampToValueAtTime(_position$3.y, endTime);
            panner.positionZ.linearRampToValueAtTime(_position$3.z, endTime);
            panner.orientationX.linearRampToValueAtTime(_orientation$1.x, endTime);
            panner.orientationY.linearRampToValueAtTime(_orientation$1.y, endTime);
            panner.orientationZ.linearRampToValueAtTime(_orientation$1.z, endTime);
        } else {
            panner.setPosition(_position$3.x, _position$3.y, _position$3.z);
            panner.setOrientation(_orientation$1.x, _orientation$1.y, _orientation$1.z);
        }
    }
}
class AudioAnalyser {
    constructor(audio, fftSize = 2048){
        this.analyser = audio.context.createAnalyser();
        this.analyser.fftSize = fftSize;
        this.data = new Uint8Array(this.analyser.frequencyBinCount);
        audio.getOutput().connect(this.analyser);
    }
    getFrequencyData() {
        this.analyser.getByteFrequencyData(this.data);
        return this.data;
    }
    getAverageFrequency() {
        let value = 0;
        const data = this.getFrequencyData();
        for(let i = 0; i < data.length; i++)value += data[i];
        return value / data.length;
    }
}
function PropertyMixer(binding, typeName, valueSize) {
    this.binding = binding;
    this.valueSize = valueSize;
    let mixFunction, mixFunctionAdditive, setIdentity;
    // buffer layout: [ incoming | accu0 | accu1 | orig | addAccu | (optional work) ]
    //
    // interpolators can use .buffer as their .result
    // the data then goes to 'incoming'
    //
    // 'accu0' and 'accu1' are used frame-interleaved for
    // the cumulative result and are compared to detect
    // changes
    //
    // 'orig' stores the original state of the property
    //
    // 'add' is used for additive cumulative results
    //
    // 'work' is optional and is only present for quaternion types. It is used
    // to store intermediate quaternion multiplication results
    switch(typeName){
        case 'quaternion':
            mixFunction = this._slerp;
            mixFunctionAdditive = this._slerpAdditive;
            setIdentity = this._setAdditiveIdentityQuaternion;
            this.buffer = new Float64Array(valueSize * 6);
            this._workIndex = 5;
            break;
        case 'string':
        case 'bool':
            mixFunction = this._select;
            // Use the regular mix function and for additive on these types,
            // additive is not relevant for non-numeric types
            mixFunctionAdditive = this._select;
            setIdentity = this._setAdditiveIdentityOther;
            this.buffer = new Array(valueSize * 5);
            break;
        default:
            mixFunction = this._lerp;
            mixFunctionAdditive = this._lerpAdditive;
            setIdentity = this._setAdditiveIdentityNumeric;
            this.buffer = new Float64Array(valueSize * 5);
    }
    this._mixBufferRegion = mixFunction;
    this._mixBufferRegionAdditive = mixFunctionAdditive;
    this._setIdentity = setIdentity;
    this._origIndex = 3;
    this._addIndex = 4;
    this.cumulativeWeight = 0;
    this.cumulativeWeightAdditive = 0;
    this.useCount = 0;
    this.referenceCount = 0;
}
Object.assign(PropertyMixer.prototype, {
    // accumulate data in the 'incoming' region into 'accu<i>'
    accumulate: function(accuIndex, weight) {
        // note: happily accumulating nothing when weight = 0, the caller knows
        // the weight and shouldn't have made the call in the first place
        const buffer = this.buffer, stride = this.valueSize, offset = accuIndex * stride + stride;
        let currentWeight = this.cumulativeWeight;
        if (currentWeight === 0) {
            // accuN := incoming * weight
            for(let i = 0; i !== stride; ++i)buffer[offset + i] = buffer[i];
            currentWeight = weight;
        } else {
            // accuN := accuN + incoming * weight
            currentWeight += weight;
            const mix = weight / currentWeight;
            this._mixBufferRegion(buffer, offset, 0, mix, stride);
        }
        this.cumulativeWeight = currentWeight;
    },
    // accumulate data in the 'incoming' region into 'add'
    accumulateAdditive: function(weight) {
        const buffer = this.buffer, stride = this.valueSize, offset = stride * this._addIndex;
        if (this.cumulativeWeightAdditive === 0) // add = identity
        this._setIdentity();
        // add := add + incoming * weight
        this._mixBufferRegionAdditive(buffer, offset, 0, weight, stride);
        this.cumulativeWeightAdditive += weight;
    },
    // apply the state of 'accu<i>' to the binding when accus differ
    apply: function(accuIndex) {
        const stride = this.valueSize, buffer = this.buffer, offset = accuIndex * stride + stride, weight = this.cumulativeWeight, weightAdditive = this.cumulativeWeightAdditive, binding = this.binding;
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
        if (weight < 1) {
            // accuN := accuN + original * ( 1 - cumulativeWeight )
            const originalValueOffset = stride * this._origIndex;
            this._mixBufferRegion(buffer, offset, originalValueOffset, 1 - weight, stride);
        }
        if (weightAdditive > 0) // accuN := accuN + additive accuN
        this._mixBufferRegionAdditive(buffer, offset, this._addIndex * stride, 1, stride);
        for(let i = stride, e = stride + stride; i !== e; ++i)if (buffer[i] !== buffer[i + stride]) {
            // value has changed -> update scene graph
            binding.setValue(buffer, offset);
            break;
        }
    },
    // remember the state of the bound property and copy it to both accus
    saveOriginalState: function() {
        const binding = this.binding;
        const buffer = this.buffer, stride = this.valueSize, originalValueOffset = stride * this._origIndex;
        binding.getValue(buffer, originalValueOffset);
        // accu[0..1] := orig -- initially detect changes against the original
        for(let i = stride, e = originalValueOffset; i !== e; ++i)buffer[i] = buffer[originalValueOffset + i % stride];
        // Add to identity for additive
        this._setIdentity();
        this.cumulativeWeight = 0;
        this.cumulativeWeightAdditive = 0;
    },
    // apply the state previously taken via 'saveOriginalState' to the binding
    restoreOriginalState: function() {
        const originalValueOffset = this.valueSize * 3;
        this.binding.setValue(this.buffer, originalValueOffset);
    },
    _setAdditiveIdentityNumeric: function() {
        const startIndex = this._addIndex * this.valueSize;
        const endIndex = startIndex + this.valueSize;
        for(let i = startIndex; i < endIndex; i++)this.buffer[i] = 0;
    },
    _setAdditiveIdentityQuaternion: function() {
        this._setAdditiveIdentityNumeric();
        this.buffer[this._addIndex * this.valueSize + 3] = 1;
    },
    _setAdditiveIdentityOther: function() {
        const startIndex = this._origIndex * this.valueSize;
        const targetIndex = this._addIndex * this.valueSize;
        for(let i = 0; i < this.valueSize; i++)this.buffer[targetIndex + i] = this.buffer[startIndex + i];
    },
    // mix functions
    _select: function(buffer, dstOffset, srcOffset, t, stride) {
        if (t >= 0.5) for(let i = 0; i !== stride; ++i)buffer[dstOffset + i] = buffer[srcOffset + i];
    },
    _slerp: function(buffer, dstOffset, srcOffset, t) {
        Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, srcOffset, t);
    },
    _slerpAdditive: function(buffer, dstOffset, srcOffset, t, stride) {
        const workOffset = this._workIndex * stride;
        // Store result in intermediate buffer offset
        Quaternion.multiplyQuaternionsFlat(buffer, workOffset, buffer, dstOffset, buffer, srcOffset);
        // Slerp to the intermediate result
        Quaternion.slerpFlat(buffer, dstOffset, buffer, dstOffset, buffer, workOffset, t);
    },
    _lerp: function(buffer, dstOffset, srcOffset, t, stride) {
        const s = 1 - t;
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] * s + buffer[srcOffset + i] * t;
        }
    },
    _lerpAdditive: function(buffer, dstOffset, srcOffset, t, stride) {
        for(let i = 0; i !== stride; ++i){
            const j = dstOffset + i;
            buffer[j] = buffer[j] + buffer[srcOffset + i] * t;
        }
    }
});
// Characters [].:/ are reserved for track binding syntax.
const _RESERVED_CHARS_RE = '\\[\\]\\.:\\/';
const _reservedRe = new RegExp('[' + _RESERVED_CHARS_RE + ']', 'g');
// Attempts to allow node names from any language. ES5's `\w` regexp matches
// only latin characters, and the unicode \p{L} is not yet supported. So
// instead, we exclude reserved characters and match everything else.
const _wordChar = '[^' + _RESERVED_CHARS_RE + ']';
const _wordCharOrDot = '[^' + _RESERVED_CHARS_RE.replace('\\.', '') + ']';
// Parent directories, delimited by '/' or ':'. Currently unused, but must
// be matched to parse the rest of the track name.
const _directoryRe = /((?:WC+[\/:])*)/.source.replace('WC', _wordChar);
// Target node. May contain word characters (a-zA-Z0-9_) and '.' or '-'.
const _nodeRe = /(WCOD+)?/.source.replace('WCOD', _wordCharOrDot);
// Object on target node, and accessor. May not contain reserved
// characters. Accessor may contain any character except closing bracket.
const _objectRe = /(?:\.(WC+)(?:\[(.+)\])?)?/.source.replace('WC', _wordChar);
// Property and accessor. May not contain reserved characters. Accessor may
// contain any non-bracket characters.
const _propertyRe = /\.(WC+)(?:\[(.+)\])?/.source.replace('WC', _wordChar);
const _trackRe = new RegExp("^" + _directoryRe + _nodeRe + _objectRe + _propertyRe + '$');
const _supportedObjectNames = [
    'material',
    'materials',
    'bones'
];
function Composite(targetGroup, path, optionalParsedPath) {
    const parsedPath = optionalParsedPath || PropertyBinding.parseTrackName(path);
    this._targetGroup = targetGroup;
    this._bindings = targetGroup.subscribe_(path, parsedPath);
}
Object.assign(Composite.prototype, {
    getValue: function(array, offset) {
        this.bind(); // bind all binding
        const firstValidIndex = this._targetGroup.nCachedObjects_, binding = this._bindings[firstValidIndex];
        // and only call .getValue on the first
        if (binding !== undefined) binding.getValue(array, offset);
    },
    setValue: function(array, offset) {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].setValue(array, offset);
    },
    bind: function() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].bind();
    },
    unbind: function() {
        const bindings = this._bindings;
        for(let i = this._targetGroup.nCachedObjects_, n = bindings.length; i !== n; ++i)bindings[i].unbind();
    }
});
function PropertyBinding(rootNode, path, parsedPath) {
    this.path = path;
    this.parsedPath = parsedPath || PropertyBinding.parseTrackName(path);
    this.node = PropertyBinding.findNode(rootNode, this.parsedPath.nodeName) || rootNode;
    this.rootNode = rootNode;
}
Object.assign(PropertyBinding, {
    Composite: Composite,
    create: function(root, path, parsedPath) {
        if (!(root && root.isAnimationObjectGroup)) return new PropertyBinding(root, path, parsedPath);
        else return new PropertyBinding.Composite(root, path, parsedPath);
    },
    /**
	 * Replaces spaces with underscores and removes unsupported characters from
	 * node names, to ensure compatibility with parseTrackName().
	 *
	 * @param {string} name Node name to be sanitized.
	 * @return {string}
	 */ sanitizeNodeName: function(name) {
        return name.replace(/\s/g, '_').replace(_reservedRe, '');
    },
    parseTrackName: function(trackName) {
        const matches = _trackRe.exec(trackName);
        if (!matches) throw new Error('PropertyBinding: Cannot parse trackName: ' + trackName);
        const results = {
            // directoryName: matches[ 1 ], // (tschw) currently unused
            nodeName: matches[2],
            objectName: matches[3],
            objectIndex: matches[4],
            propertyName: matches[5],
            propertyIndex: matches[6]
        };
        const lastDot = results.nodeName && results.nodeName.lastIndexOf('.');
        if (lastDot !== undefined && lastDot !== -1) {
            const objectName = results.nodeName.substring(lastDot + 1);
            // Object names must be checked against an allowlist. Otherwise, there
            // is no way to parse 'foo.bar.baz': 'baz' must be a property, but
            // 'bar' could be the objectName, or part of a nodeName (which can
            // include '.' characters).
            if (_supportedObjectNames.indexOf(objectName) !== -1) {
                results.nodeName = results.nodeName.substring(0, lastDot);
                results.objectName = objectName;
            }
        }
        if (results.propertyName === null || results.propertyName.length === 0) throw new Error('PropertyBinding: can not parse propertyName from trackName: ' + trackName);
        return results;
    },
    findNode: function(root, nodeName) {
        if (!nodeName || nodeName === '' || nodeName === '.' || nodeName === -1 || nodeName === root.name || nodeName === root.uuid) return root;
        // search into skeleton bones.
        if (root.skeleton) {
            const bone = root.skeleton.getBoneByName(nodeName);
            if (bone !== undefined) return bone;
        }
        // search into node subtree.
        if (root.children) {
            const searchNodeSubtree = function(children) {
                for(let i = 0; i < children.length; i++){
                    const childNode = children[i];
                    if (childNode.name === nodeName || childNode.uuid === nodeName) return childNode;
                    const result = searchNodeSubtree(childNode.children);
                    if (result) return result;
                }
                return null;
            };
            const subTreeNode = searchNodeSubtree(root.children);
            if (subTreeNode) return subTreeNode;
        }
        return null;
    }
});
Object.assign(PropertyBinding.prototype, {
    // these are used to "bind" a nonexistent property
    _getValue_unavailable: function() {},
    _setValue_unavailable: function() {},
    BindingType: {
        Direct: 0,
        EntireArray: 1,
        ArrayElement: 2,
        HasFromToArray: 3
    },
    Versioning: {
        None: 0,
        NeedsUpdate: 1,
        MatrixWorldNeedsUpdate: 2
    },
    GetterByBindingType: [
        function getValue_direct(buffer, offset) {
            buffer[offset] = this.node[this.propertyName];
        },
        function getValue_array(buffer, offset) {
            const source = this.resolvedProperty;
            for(let i = 0, n = source.length; i !== n; ++i)buffer[offset++] = source[i];
        },
        function getValue_arrayElement(buffer, offset) {
            buffer[offset] = this.resolvedProperty[this.propertyIndex];
        },
        function getValue_toArray(buffer, offset) {
            this.resolvedProperty.toArray(buffer, offset);
        }
    ],
    SetterByBindingTypeAndVersioning: [
        [
            // Direct
            function setValue_direct(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
            },
            function setValue_direct_setNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.needsUpdate = true;
            },
            function setValue_direct_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.targetObject[this.propertyName] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        ],
        [
            // EntireArray
            function setValue_array(buffer, offset) {
                const dest = this.resolvedProperty;
                for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
            },
            function setValue_array_setNeedsUpdate(buffer, offset) {
                const dest = this.resolvedProperty;
                for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.needsUpdate = true;
            },
            function setValue_array_setMatrixWorldNeedsUpdate(buffer, offset) {
                const dest = this.resolvedProperty;
                for(let i = 0, n = dest.length; i !== n; ++i)dest[i] = buffer[offset++];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        ],
        [
            // ArrayElement
            function setValue_arrayElement(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
            },
            function setValue_arrayElement_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.needsUpdate = true;
            },
            function setValue_arrayElement_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty[this.propertyIndex] = buffer[offset];
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        ],
        [
            // HasToFromArray
            function setValue_fromArray(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
            },
            function setValue_fromArray_setNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.needsUpdate = true;
            },
            function setValue_fromArray_setMatrixWorldNeedsUpdate(buffer, offset) {
                this.resolvedProperty.fromArray(buffer, offset);
                this.targetObject.matrixWorldNeedsUpdate = true;
            }
        ]
    ],
    getValue: function getValue_unbound(targetArray, offset) {
        this.bind();
        this.getValue(targetArray, offset);
    // Note: This class uses a State pattern on a per-method basis:
    // 'bind' sets 'this.getValue' / 'setValue' and shadows the
    // prototype version of these methods with one that represents
    // the bound state. When the property is not found, the methods
    // become no-ops.
    },
    setValue: function getValue_unbound(sourceArray, offset) {
        this.bind();
        this.setValue(sourceArray, offset);
    },
    // create getter / setter pair for a property in the scene graph
    bind: function() {
        let targetObject = this.node;
        const parsedPath = this.parsedPath;
        const objectName = parsedPath.objectName;
        const propertyName = parsedPath.propertyName;
        let propertyIndex = parsedPath.propertyIndex;
        if (!targetObject) {
            targetObject = PropertyBinding.findNode(this.rootNode, parsedPath.nodeName) || this.rootNode;
            this.node = targetObject;
        }
        // set fail state so we can just 'return' on error
        this.getValue = this._getValue_unavailable;
        this.setValue = this._setValue_unavailable;
        // ensure there is a value node
        if (!targetObject) {
            console.error('THREE.PropertyBinding: Trying to update node for track: ' + this.path + ' but it wasn\'t found.');
            return;
        }
        if (objectName) {
            let objectIndex = parsedPath.objectIndex;
            // special cases were we need to reach deeper into the hierarchy to get the face materials....
            switch(objectName){
                case 'materials':
                    if (!targetObject.material) {
                        console.error('THREE.PropertyBinding: Can not bind to material as node does not have a material.', this);
                        return;
                    }
                    if (!targetObject.material.materials) {
                        console.error('THREE.PropertyBinding: Can not bind to material.materials as node.material does not have a materials array.', this);
                        return;
                    }
                    targetObject = targetObject.material.materials;
                    break;
                case 'bones':
                    if (!targetObject.skeleton) {
                        console.error('THREE.PropertyBinding: Can not bind to bones as node does not have a skeleton.', this);
                        return;
                    }
                    // potential future optimization: skip this if propertyIndex is already an integer
                    // and convert the integer string to a true integer.
                    targetObject = targetObject.skeleton.bones;
                    // support resolving morphTarget names into indices.
                    for(let i = 0; i < targetObject.length; i++)if (targetObject[i].name === objectIndex) {
                        objectIndex = i;
                        break;
                    }
                    break;
                default:
                    if (targetObject[objectName] === undefined) {
                        console.error('THREE.PropertyBinding: Can not bind to objectName of node undefined.', this);
                        return;
                    }
                    targetObject = targetObject[objectName];
            }
            if (objectIndex !== undefined) {
                if (targetObject[objectIndex] === undefined) {
                    console.error('THREE.PropertyBinding: Trying to bind to objectIndex of objectName, but is undefined.', this, targetObject);
                    return;
                }
                targetObject = targetObject[objectIndex];
            }
        }
        // resolve property
        const nodeProperty = targetObject[propertyName];
        if (nodeProperty === undefined) {
            const nodeName = parsedPath.nodeName;
            console.error('THREE.PropertyBinding: Trying to update property for track: ' + nodeName + '.' + propertyName + ' but it wasn\'t found.', targetObject);
            return;
        }
        // determine versioning scheme
        let versioning = this.Versioning.None;
        this.targetObject = targetObject;
        if (targetObject.needsUpdate !== undefined) versioning = this.Versioning.NeedsUpdate;
        else if (targetObject.matrixWorldNeedsUpdate !== undefined) versioning = this.Versioning.MatrixWorldNeedsUpdate;
        // determine how the property gets bound
        let bindingType = this.BindingType.Direct;
        if (propertyIndex !== undefined) {
            // access a sub element of the property array (only primitives are supported right now)
            if (propertyName === 'morphTargetInfluences') {
                // potential optimization, skip this if propertyIndex is already an integer, and convert the integer string to a true integer.
                // support resolving morphTarget names into indices.
                if (!targetObject.geometry) {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.', this);
                    return;
                }
                if (targetObject.geometry.isBufferGeometry) {
                    if (!targetObject.geometry.morphAttributes) {
                        console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences because node does not have a geometry.morphAttributes.', this);
                        return;
                    }
                    if (targetObject.morphTargetDictionary[propertyIndex] !== undefined) propertyIndex = targetObject.morphTargetDictionary[propertyIndex];
                } else {
                    console.error('THREE.PropertyBinding: Can not bind to morphTargetInfluences on THREE.Geometry. Use THREE.BufferGeometry instead.', this);
                    return;
                }
            }
            bindingType = this.BindingType.ArrayElement;
            this.resolvedProperty = nodeProperty;
            this.propertyIndex = propertyIndex;
        } else if (nodeProperty.fromArray !== undefined && nodeProperty.toArray !== undefined) {
            // must use copy for Object3D.Euler/Quaternion
            bindingType = this.BindingType.HasFromToArray;
            this.resolvedProperty = nodeProperty;
        } else if (Array.isArray(nodeProperty)) {
            bindingType = this.BindingType.EntireArray;
            this.resolvedProperty = nodeProperty;
        } else this.propertyName = propertyName;
        // select getter / setter
        this.getValue = this.GetterByBindingType[bindingType];
        this.setValue = this.SetterByBindingTypeAndVersioning[bindingType][versioning];
    },
    unbind: function() {
        this.node = null;
        // back to the prototype version of getValue / setValue
        // note: avoiding to mutate the shape of 'this' via 'delete'
        this.getValue = this._getValue_unbound;
        this.setValue = this._setValue_unbound;
    }
});
// DECLARE ALIAS AFTER assign prototype
Object.assign(PropertyBinding.prototype, {
    // initial state of these methods that calls 'bind'
    _getValue_unbound: PropertyBinding.prototype.getValue,
    _setValue_unbound: PropertyBinding.prototype.setValue
});
/**
 *
 * A group of objects that receives a shared animation state.
 *
 * Usage:
 *
 *  - Add objects you would otherwise pass as 'root' to the
 *    constructor or the .clipAction method of AnimationMixer.
 *
 *  - Instead pass this object as 'root'.
 *
 *  - You can also add and remove objects later when the mixer
 *    is running.
 *
 * Note:
 *
 *    Objects of this class appear as one object to the mixer,
 *    so cache control of the individual objects must be done
 *    on the group.
 *
 * Limitation:
 *
 *  - The animated properties must be compatible among the
 *    all objects in the group.
 *
 *  - A single property can either be controlled through a
 *    target group or directly, but not both.
 */ function AnimationObjectGroup() {
    this.uuid = MathUtils.generateUUID();
    // cached objects followed by the active ones
    this._objects = Array.prototype.slice.call(arguments);
    this.nCachedObjects_ = 0; // threshold
    // note: read by PropertyBinding.Composite
    const indices = {};
    this._indicesByUUID = indices; // for bookkeeping
    for(let i = 0, n = arguments.length; i !== n; ++i)indices[arguments[i].uuid] = i;
    this._paths = []; // inside: string
    this._parsedPaths = []; // inside: { we don't care, here }
    this._bindings = []; // inside: Array< PropertyBinding >
    this._bindingsIndicesByPath = {}; // inside: indices in these arrays
    const scope = this;
    this.stats = {
        objects: {
            get total () {
                return scope._objects.length;
            },
            get inUse () {
                return this.total - scope.nCachedObjects_;
            }
        },
        get bindingsPerObject () {
            return scope._bindings.length;
        }
    };
}
Object.assign(AnimationObjectGroup.prototype, {
    isAnimationObjectGroup: true,
    add: function() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, nBindings = bindings.length;
        let knownObject = undefined, nObjects = objects.length, nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid;
            let index = indicesByUUID[uuid];
            if (index === undefined) {
                // unknown object -> add it to the ACTIVE region
                index = nObjects++;
                indicesByUUID[uuid] = index;
                objects.push(object);
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j)bindings[j].push(new PropertyBinding(object, paths[j], parsedPaths[j]));
            } else if (index < nCachedObjects) {
                knownObject = objects[index];
                // move existing object to the ACTIVE region
                const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex];
                indicesByUUID[lastCachedObject.uuid] = index;
                objects[index] = lastCachedObject;
                indicesByUUID[uuid] = firstActiveIndex;
                objects[firstActiveIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex];
                    let binding = bindingsForPath[index];
                    bindingsForPath[index] = lastCached;
                    if (binding === undefined) // since we do not bother to create new bindings
                    // for objects that are cached, the binding may
                    // or may not exist
                    binding = new PropertyBinding(object, paths[j], parsedPaths[j]);
                    bindingsForPath[firstActiveIndex] = binding;
                }
            } else if (objects[index] !== knownObject) console.error("THREE.AnimationObjectGroup: Different objects with the same UUID detected. Clean the caches or recreate your infrastructure when reloading scenes.");
             // else the object is already where we want it to be
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    },
    remove: function() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined && index >= nCachedObjects) {
                // move existing object into the CACHED region
                const lastCachedIndex = nCachedObjects++, firstActiveObject = objects[lastCachedIndex];
                indicesByUUID[firstActiveObject.uuid] = index;
                objects[index] = firstActiveObject;
                indicesByUUID[uuid] = lastCachedIndex;
                objects[lastCachedIndex] = object;
                // accounting is done, now do the same for all bindings
                for(let j = 0, m = nBindings; j !== m; ++j){
                    const bindingsForPath = bindings[j], firstActive = bindingsForPath[lastCachedIndex], binding = bindingsForPath[index];
                    bindingsForPath[index] = firstActive;
                    bindingsForPath[lastCachedIndex] = binding;
                }
            }
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    },
    // remove & forget
    uncache: function() {
        const objects = this._objects, indicesByUUID = this._indicesByUUID, bindings = this._bindings, nBindings = bindings.length;
        let nCachedObjects = this.nCachedObjects_, nObjects = objects.length;
        for(let i = 0, n = arguments.length; i !== n; ++i){
            const object = arguments[i], uuid = object.uuid, index = indicesByUUID[uuid];
            if (index !== undefined) {
                delete indicesByUUID[uuid];
                if (index < nCachedObjects) {
                    // object is cached, shrink the CACHED region
                    const firstActiveIndex = --nCachedObjects, lastCachedObject = objects[firstActiveIndex], lastIndex = --nObjects, lastObject = objects[lastIndex];
                    // last cached object takes this object's place
                    indicesByUUID[lastCachedObject.uuid] = index;
                    objects[index] = lastCachedObject;
                    // last object goes to the activated slot and pop
                    indicesByUUID[lastObject.uuid] = firstActiveIndex;
                    objects[firstActiveIndex] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j], lastCached = bindingsForPath[firstActiveIndex], last = bindingsForPath[lastIndex];
                        bindingsForPath[index] = lastCached;
                        bindingsForPath[firstActiveIndex] = last;
                        bindingsForPath.pop();
                    }
                } else {
                    // object is active, just swap with the last and pop
                    const lastIndex = --nObjects, lastObject = objects[lastIndex];
                    if (lastIndex > 0) indicesByUUID[lastObject.uuid] = index;
                    objects[index] = lastObject;
                    objects.pop();
                    // accounting is done, now do the same for all bindings
                    for(let j = 0, m = nBindings; j !== m; ++j){
                        const bindingsForPath = bindings[j];
                        bindingsForPath[index] = bindingsForPath[lastIndex];
                        bindingsForPath.pop();
                    }
                } // cached or active
            } // if object is known
        } // for arguments
        this.nCachedObjects_ = nCachedObjects;
    },
    // Internal interface used by befriended PropertyBinding.Composite:
    subscribe_: function(path, parsedPath) {
        // returns an array of bindings for the given path that is changed
        // according to the contained objects in the group
        const indicesByPath = this._bindingsIndicesByPath;
        let index = indicesByPath[path];
        const bindings = this._bindings;
        if (index !== undefined) return bindings[index];
        const paths = this._paths, parsedPaths = this._parsedPaths, objects = this._objects, nObjects = objects.length, nCachedObjects = this.nCachedObjects_, bindingsForPath = new Array(nObjects);
        index = bindings.length;
        indicesByPath[path] = index;
        paths.push(path);
        parsedPaths.push(parsedPath);
        bindings.push(bindingsForPath);
        for(let i = nCachedObjects, n = objects.length; i !== n; ++i){
            const object = objects[i];
            bindingsForPath[i] = new PropertyBinding(object, path, parsedPath);
        }
        return bindingsForPath;
    },
    unsubscribe_: function(path) {
        // tells the group to forget about a property path and no longer
        // update the array previously obtained with 'subscribe_'
        const indicesByPath = this._bindingsIndicesByPath, index = indicesByPath[path];
        if (index !== undefined) {
            const paths = this._paths, parsedPaths = this._parsedPaths, bindings = this._bindings, lastBindingsIndex = bindings.length - 1, lastBindings = bindings[lastBindingsIndex], lastBindingsPath = path[lastBindingsIndex];
            indicesByPath[lastBindingsPath] = index;
            bindings[index] = lastBindings;
            bindings.pop();
            parsedPaths[index] = parsedPaths[lastBindingsIndex];
            parsedPaths.pop();
            paths[index] = paths[lastBindingsIndex];
            paths.pop();
        }
    }
});
class AnimationAction {
    constructor(mixer, clip, localRoot = null, blendMode = clip.blendMode){
        this._mixer = mixer;
        this._clip = clip;
        this._localRoot = localRoot;
        this.blendMode = blendMode;
        const tracks = clip.tracks, nTracks = tracks.length, interpolants = new Array(nTracks);
        const interpolantSettings = {
            endingStart: ZeroCurvatureEnding,
            endingEnd: ZeroCurvatureEnding
        };
        for(let i = 0; i !== nTracks; ++i){
            const interpolant = tracks[i].createInterpolant(null);
            interpolants[i] = interpolant;
            interpolant.settings = interpolantSettings;
        }
        this._interpolantSettings = interpolantSettings;
        this._interpolants = interpolants; // bound by the mixer
        // inside: PropertyMixer (managed by the mixer)
        this._propertyBindings = new Array(nTracks);
        this._cacheIndex = null; // for the memory manager
        this._byClipCacheIndex = null; // for the memory manager
        this._timeScaleInterpolant = null;
        this._weightInterpolant = null;
        this.loop = LoopRepeat;
        this._loopCount = -1;
        // global mixer time when the action is to be started
        // it's set back to 'null' upon start of the action
        this._startTime = null;
        // scaled local time of the action
        // gets clamped or wrapped to 0..clip.duration according to loop
        this.time = 0;
        this.timeScale = 1;
        this._effectiveTimeScale = 1;
        this.weight = 1;
        this._effectiveWeight = 1;
        this.repetitions = Infinity; // no. of repetitions when looping
        this.paused = false; // true -> zero effective time scale
        this.enabled = true; // false -> zero effective weight
        this.clampWhenFinished = false; // keep feeding the last frame?
        this.zeroSlopeAtStart = true; // for smooth interpolation w/o separate
        this.zeroSlopeAtEnd = true; // clips for start, loop and end
    }
    // State & Scheduling
    play() {
        this._mixer._activateAction(this);
        return this;
    }
    stop() {
        this._mixer._deactivateAction(this);
        return this.reset();
    }
    reset() {
        this.paused = false;
        this.enabled = true;
        this.time = 0; // restart clip
        this._loopCount = -1; // forget previous loops
        this._startTime = null; // forget scheduling
        return this.stopFading().stopWarping();
    }
    isRunning() {
        return this.enabled && !this.paused && this.timeScale !== 0 && this._startTime === null && this._mixer._isActiveAction(this);
    }
    // return true when play has been called
    isScheduled() {
        return this._mixer._isActiveAction(this);
    }
    startAt(time) {
        this._startTime = time;
        return this;
    }
    setLoop(mode, repetitions) {
        this.loop = mode;
        this.repetitions = repetitions;
        return this;
    }
    // Weight
    // set the weight stopping any scheduled fading
    // although .enabled = false yields an effective weight of zero, this
    // method does *not* change .enabled, because it would be confusing
    setEffectiveWeight(weight) {
        this.weight = weight;
        // note: same logic as when updated at runtime
        this._effectiveWeight = this.enabled ? weight : 0;
        return this.stopFading();
    }
    // return the weight considering fading and .enabled
    getEffectiveWeight() {
        return this._effectiveWeight;
    }
    fadeIn(duration) {
        return this._scheduleFading(duration, 0, 1);
    }
    fadeOut(duration) {
        return this._scheduleFading(duration, 1, 0);
    }
    crossFadeFrom(fadeOutAction, duration, warp) {
        fadeOutAction.fadeOut(duration);
        this.fadeIn(duration);
        if (warp) {
            const fadeInDuration = this._clip.duration, fadeOutDuration = fadeOutAction._clip.duration, startEndRatio = fadeOutDuration / fadeInDuration, endStartRatio = fadeInDuration / fadeOutDuration;
            fadeOutAction.warp(1.0, startEndRatio, duration);
            this.warp(endStartRatio, 1.0, duration);
        }
        return this;
    }
    crossFadeTo(fadeInAction, duration, warp) {
        return fadeInAction.crossFadeFrom(this, duration, warp);
    }
    stopFading() {
        const weightInterpolant = this._weightInterpolant;
        if (weightInterpolant !== null) {
            this._weightInterpolant = null;
            this._mixer._takeBackControlInterpolant(weightInterpolant);
        }
        return this;
    }
    // Time Scale Control
    // set the time scale stopping any scheduled warping
    // although .paused = true yields an effective time scale of zero, this
    // method does *not* change .paused, because it would be confusing
    setEffectiveTimeScale(timeScale) {
        this.timeScale = timeScale;
        this._effectiveTimeScale = this.paused ? 0 : timeScale;
        return this.stopWarping();
    }
    // return the time scale considering warping and .paused
    getEffectiveTimeScale() {
        return this._effectiveTimeScale;
    }
    setDuration(duration) {
        this.timeScale = this._clip.duration / duration;
        return this.stopWarping();
    }
    syncWith(action) {
        this.time = action.time;
        this.timeScale = action.timeScale;
        return this.stopWarping();
    }
    halt(duration) {
        return this.warp(this._effectiveTimeScale, 0, duration);
    }
    warp(startTimeScale, endTimeScale, duration) {
        const mixer = this._mixer, now = mixer.time, timeScale = this.timeScale;
        let interpolant = this._timeScaleInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._timeScaleInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        times[1] = now + duration;
        values[0] = startTimeScale / timeScale;
        values[1] = endTimeScale / timeScale;
        return this;
    }
    stopWarping() {
        const timeScaleInterpolant = this._timeScaleInterpolant;
        if (timeScaleInterpolant !== null) {
            this._timeScaleInterpolant = null;
            this._mixer._takeBackControlInterpolant(timeScaleInterpolant);
        }
        return this;
    }
    // Object Accessors
    getMixer() {
        return this._mixer;
    }
    getClip() {
        return this._clip;
    }
    getRoot() {
        return this._localRoot || this._mixer._root;
    }
    // Interna
    _update(time, deltaTime, timeDirection, accuIndex) {
        // called by the mixer
        if (!this.enabled) {
            // call ._updateWeight() to update ._effectiveWeight
            this._updateWeight(time);
            return;
        }
        const startTime = this._startTime;
        if (startTime !== null) {
            // check for scheduled start of action
            const timeRunning = (time - startTime) * timeDirection;
            if (timeRunning < 0 || timeDirection === 0) return; // yet to come / don't decide when delta = 0
            // start
            this._startTime = null; // unschedule
            deltaTime = timeDirection * timeRunning;
        }
        // apply time scale and advance time
        deltaTime *= this._updateTimeScale(time);
        const clipTime = this._updateTime(deltaTime);
        // note: _updateTime may disable the action resulting in
        // an effective weight of 0
        const weight = this._updateWeight(time);
        if (weight > 0) {
            const interpolants = this._interpolants;
            const propertyMixers = this._propertyBindings;
            switch(this.blendMode){
                case AdditiveAnimationBlendMode:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulateAdditive(weight);
                    }
                    break;
                case NormalAnimationBlendMode:
                default:
                    for(let j = 0, m = interpolants.length; j !== m; ++j){
                        interpolants[j].evaluate(clipTime);
                        propertyMixers[j].accumulate(accuIndex, weight);
                    }
            }
        }
    }
    _updateWeight(time) {
        let weight = 0;
        if (this.enabled) {
            weight = this.weight;
            const interpolant = this._weightInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                weight *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopFading();
                    if (interpolantValue === 0) // faded out, disable
                    this.enabled = false;
                }
            }
        }
        this._effectiveWeight = weight;
        return weight;
    }
    _updateTimeScale(time) {
        let timeScale = 0;
        if (!this.paused) {
            timeScale = this.timeScale;
            const interpolant = this._timeScaleInterpolant;
            if (interpolant !== null) {
                const interpolantValue = interpolant.evaluate(time)[0];
                timeScale *= interpolantValue;
                if (time > interpolant.parameterPositions[1]) {
                    this.stopWarping();
                    if (timeScale === 0) // motion has halted, pause
                    this.paused = true;
                    else // warp done - apply final time scale
                    this.timeScale = timeScale;
                }
            }
        }
        this._effectiveTimeScale = timeScale;
        return timeScale;
    }
    _updateTime(deltaTime) {
        const duration = this._clip.duration;
        const loop = this.loop;
        let time = this.time + deltaTime;
        let loopCount = this._loopCount;
        const pingPong = loop === LoopPingPong;
        if (deltaTime === 0) {
            if (loopCount === -1) return time;
            return pingPong && (loopCount & 1) === 1 ? duration - time : time;
        }
        if (loop === LoopOnce) {
            if (loopCount === -1) {
                // just started
                this._loopCount = 0;
                this._setEndings(true, true, false);
            }
            handle_stop: {
                if (time >= duration) time = duration;
                else if (time < 0) time = 0;
                else {
                    this.time = time;
                    break handle_stop;
                }
                if (this.clampWhenFinished) this.paused = true;
                else this.enabled = false;
                this.time = time;
                this._mixer.dispatchEvent({
                    type: 'finished',
                    action: this,
                    direction: deltaTime < 0 ? -1 : 1
                });
            }
        } else {
            if (loopCount === -1) {
                // just started
                if (deltaTime >= 0) {
                    loopCount = 0;
                    this._setEndings(true, this.repetitions === 0, pingPong);
                } else // when looping in reverse direction, the initial
                // transition through zero counts as a repetition,
                // so leave loopCount at -1
                this._setEndings(this.repetitions === 0, true, pingPong);
            }
            if (time >= duration || time < 0) {
                // wrap around
                const loopDelta = Math.floor(time / duration); // signed
                time -= duration * loopDelta;
                loopCount += Math.abs(loopDelta);
                const pending = this.repetitions - loopCount;
                if (pending <= 0) {
                    // have to stop (switch state, clamp time, fire event)
                    if (this.clampWhenFinished) this.paused = true;
                    else this.enabled = false;
                    time = deltaTime > 0 ? duration : 0;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'finished',
                        action: this,
                        direction: deltaTime > 0 ? 1 : -1
                    });
                } else {
                    // keep running
                    if (pending === 1) {
                        // entering the last round
                        const atStart = deltaTime < 0;
                        this._setEndings(atStart, !atStart, pingPong);
                    } else this._setEndings(false, false, pingPong);
                    this._loopCount = loopCount;
                    this.time = time;
                    this._mixer.dispatchEvent({
                        type: 'loop',
                        action: this,
                        loopDelta: loopDelta
                    });
                }
            } else this.time = time;
            if (pingPong && (loopCount & 1) === 1) // invert time for the "pong round"
            return duration - time;
        }
        return time;
    }
    _setEndings(atStart, atEnd, pingPong) {
        const settings = this._interpolantSettings;
        if (pingPong) {
            settings.endingStart = ZeroSlopeEnding;
            settings.endingEnd = ZeroSlopeEnding;
        } else {
            // assuming for LoopOnce atStart == atEnd == true
            if (atStart) settings.endingStart = this.zeroSlopeAtStart ? ZeroSlopeEnding : ZeroCurvatureEnding;
            else settings.endingStart = WrapAroundEnding;
            if (atEnd) settings.endingEnd = this.zeroSlopeAtEnd ? ZeroSlopeEnding : ZeroCurvatureEnding;
            else settings.endingEnd = WrapAroundEnding;
        }
    }
    _scheduleFading(duration, weightNow, weightThen) {
        const mixer = this._mixer, now = mixer.time;
        let interpolant = this._weightInterpolant;
        if (interpolant === null) {
            interpolant = mixer._lendControlInterpolant();
            this._weightInterpolant = interpolant;
        }
        const times = interpolant.parameterPositions, values = interpolant.sampleValues;
        times[0] = now;
        values[0] = weightNow;
        times[1] = now + duration;
        values[1] = weightThen;
        return this;
    }
}
function AnimationMixer(root) {
    this._root = root;
    this._initMemoryManager();
    this._accuIndex = 0;
    this.time = 0;
    this.timeScale = 1.0;
}
AnimationMixer.prototype = Object.assign(Object.create(EventDispatcher.prototype), {
    constructor: AnimationMixer,
    _bindAction: function(action, prototypeAction) {
        const root = action._localRoot || this._root, tracks = action._clip.tracks, nTracks = tracks.length, bindings = action._propertyBindings, interpolants = action._interpolants, rootUuid = root.uuid, bindingsByRoot = this._bindingsByRootAndName;
        let bindingsByName = bindingsByRoot[rootUuid];
        if (bindingsByName === undefined) {
            bindingsByName = {};
            bindingsByRoot[rootUuid] = bindingsByName;
        }
        for(let i = 0; i !== nTracks; ++i){
            const track = tracks[i], trackName = track.name;
            let binding = bindingsByName[trackName];
            if (binding !== undefined) bindings[i] = binding;
            else {
                binding = bindings[i];
                if (binding !== undefined) {
                    // existing binding, make sure the cache knows
                    if (binding._cacheIndex === null) {
                        ++binding.referenceCount;
                        this._addInactiveBinding(binding, rootUuid, trackName);
                    }
                    continue;
                }
                const path = prototypeAction && prototypeAction._propertyBindings[i].binding.parsedPath;
                binding = new PropertyMixer(PropertyBinding.create(root, trackName, path), track.ValueTypeName, track.getValueSize());
                ++binding.referenceCount;
                this._addInactiveBinding(binding, rootUuid, trackName);
                bindings[i] = binding;
            }
            interpolants[i].resultBuffer = binding.buffer;
        }
    },
    _activateAction: function(action) {
        if (!this._isActiveAction(action)) {
            if (action._cacheIndex === null) {
                // this action has been forgotten by the cache, but the user
                // appears to be still using it -> rebind
                const rootUuid = (action._localRoot || this._root).uuid, clipUuid = action._clip.uuid, actionsForClip = this._actionsByClip[clipUuid];
                this._bindAction(action, actionsForClip && actionsForClip.knownActions[0]);
                this._addInactiveAction(action, clipUuid, rootUuid);
            }
            const bindings = action._propertyBindings;
            // increment reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (binding.useCount++ === 0) {
                    this._lendBinding(binding);
                    binding.saveOriginalState();
                }
            }
            this._lendAction(action);
        }
    },
    _deactivateAction: function(action) {
        if (this._isActiveAction(action)) {
            const bindings = action._propertyBindings;
            // decrement reference counts / sort out state
            for(let i = 0, n = bindings.length; i !== n; ++i){
                const binding = bindings[i];
                if (--binding.useCount === 0) {
                    binding.restoreOriginalState();
                    this._takeBackBinding(binding);
                }
            }
            this._takeBackAction(action);
        }
    },
    // Memory manager
    _initMemoryManager: function() {
        this._actions = []; // 'nActiveActions' followed by inactive ones
        this._nActiveActions = 0;
        this._actionsByClip = {};
        // inside:
        // {
        // 	knownActions: Array< AnimationAction > - used as prototypes
        // 	actionByRoot: AnimationAction - lookup
        // }
        this._bindings = []; // 'nActiveBindings' followed by inactive ones
        this._nActiveBindings = 0;
        this._bindingsByRootAndName = {}; // inside: Map< name, PropertyMixer >
        this._controlInterpolants = []; // same game as above
        this._nActiveControlInterpolants = 0;
        const scope = this;
        this.stats = {
            actions: {
                get total () {
                    return scope._actions.length;
                },
                get inUse () {
                    return scope._nActiveActions;
                }
            },
            bindings: {
                get total () {
                    return scope._bindings.length;
                },
                get inUse () {
                    return scope._nActiveBindings;
                }
            },
            controlInterpolants: {
                get total () {
                    return scope._controlInterpolants.length;
                },
                get inUse () {
                    return scope._nActiveControlInterpolants;
                }
            }
        };
    },
    // Memory management for AnimationAction objects
    _isActiveAction: function(action) {
        const index = action._cacheIndex;
        return index !== null && index < this._nActiveActions;
    },
    _addInactiveAction: function(action, clipUuid, rootUuid) {
        const actions = this._actions, actionsByClip = this._actionsByClip;
        let actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip === undefined) {
            actionsForClip = {
                knownActions: [
                    action
                ],
                actionByRoot: {}
            };
            action._byClipCacheIndex = 0;
            actionsByClip[clipUuid] = actionsForClip;
        } else {
            const knownActions = actionsForClip.knownActions;
            action._byClipCacheIndex = knownActions.length;
            knownActions.push(action);
        }
        action._cacheIndex = actions.length;
        actions.push(action);
        actionsForClip.actionByRoot[rootUuid] = action;
    },
    _removeInactiveAction: function(action) {
        const actions = this._actions, lastInactiveAction = actions[actions.length - 1], cacheIndex = action._cacheIndex;
        lastInactiveAction._cacheIndex = cacheIndex;
        actions[cacheIndex] = lastInactiveAction;
        actions.pop();
        action._cacheIndex = null;
        const clipUuid = action._clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid], knownActionsForClip = actionsForClip.knownActions, lastKnownAction = knownActionsForClip[knownActionsForClip.length - 1], byClipCacheIndex = action._byClipCacheIndex;
        lastKnownAction._byClipCacheIndex = byClipCacheIndex;
        knownActionsForClip[byClipCacheIndex] = lastKnownAction;
        knownActionsForClip.pop();
        action._byClipCacheIndex = null;
        const actionByRoot = actionsForClip.actionByRoot, rootUuid = (action._localRoot || this._root).uuid;
        delete actionByRoot[rootUuid];
        if (knownActionsForClip.length === 0) delete actionsByClip[clipUuid];
        this._removeInactiveBindingsForAction(action);
    },
    _removeInactiveBindingsForAction: function(action) {
        const bindings = action._propertyBindings;
        for(let i = 0, n = bindings.length; i !== n; ++i){
            const binding = bindings[i];
            if (--binding.referenceCount === 0) this._removeInactiveBinding(binding);
        }
    },
    _lendAction: function(action) {
        // [ active actions |  inactive actions  ]
        // [  active actions >| inactive actions ]
        //                 s        a
        //                  <-swap->
        //                 a        s
        const actions = this._actions, prevIndex = action._cacheIndex, lastActiveIndex = this._nActiveActions++, firstInactiveAction = actions[lastActiveIndex];
        action._cacheIndex = lastActiveIndex;
        actions[lastActiveIndex] = action;
        firstInactiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = firstInactiveAction;
    },
    _takeBackAction: function(action) {
        // [  active actions  | inactive actions ]
        // [ active actions |< inactive actions  ]
        //        a        s
        //         <-swap->
        //        s        a
        const actions = this._actions, prevIndex = action._cacheIndex, firstInactiveIndex = --this._nActiveActions, lastActiveAction = actions[firstInactiveIndex];
        action._cacheIndex = firstInactiveIndex;
        actions[firstInactiveIndex] = action;
        lastActiveAction._cacheIndex = prevIndex;
        actions[prevIndex] = lastActiveAction;
    },
    // Memory management for PropertyMixer objects
    _addInactiveBinding: function(binding, rootUuid, trackName) {
        const bindingsByRoot = this._bindingsByRootAndName, bindings = this._bindings;
        let bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName === undefined) {
            bindingByName = {};
            bindingsByRoot[rootUuid] = bindingByName;
        }
        bindingByName[trackName] = binding;
        binding._cacheIndex = bindings.length;
        bindings.push(binding);
    },
    _removeInactiveBinding: function(binding) {
        const bindings = this._bindings, propBinding = binding.binding, rootUuid = propBinding.rootNode.uuid, trackName = propBinding.path, bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid], lastInactiveBinding = bindings[bindings.length - 1], cacheIndex = binding._cacheIndex;
        lastInactiveBinding._cacheIndex = cacheIndex;
        bindings[cacheIndex] = lastInactiveBinding;
        bindings.pop();
        delete bindingByName[trackName];
        if (Object.keys(bindingByName).length === 0) delete bindingsByRoot[rootUuid];
    },
    _lendBinding: function(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, lastActiveIndex = this._nActiveBindings++, firstInactiveBinding = bindings[lastActiveIndex];
        binding._cacheIndex = lastActiveIndex;
        bindings[lastActiveIndex] = binding;
        firstInactiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = firstInactiveBinding;
    },
    _takeBackBinding: function(binding) {
        const bindings = this._bindings, prevIndex = binding._cacheIndex, firstInactiveIndex = --this._nActiveBindings, lastActiveBinding = bindings[firstInactiveIndex];
        binding._cacheIndex = firstInactiveIndex;
        bindings[firstInactiveIndex] = binding;
        lastActiveBinding._cacheIndex = prevIndex;
        bindings[prevIndex] = lastActiveBinding;
    },
    // Memory management of Interpolants for weight and time scale
    _lendControlInterpolant: function() {
        const interpolants = this._controlInterpolants, lastActiveIndex = this._nActiveControlInterpolants++;
        let interpolant = interpolants[lastActiveIndex];
        if (interpolant === undefined) {
            interpolant = new LinearInterpolant(new Float32Array(2), new Float32Array(2), 1, this._controlInterpolantsResultBuffer);
            interpolant.__cacheIndex = lastActiveIndex;
            interpolants[lastActiveIndex] = interpolant;
        }
        return interpolant;
    },
    _takeBackControlInterpolant: function(interpolant) {
        const interpolants = this._controlInterpolants, prevIndex = interpolant.__cacheIndex, firstInactiveIndex = --this._nActiveControlInterpolants, lastActiveInterpolant = interpolants[firstInactiveIndex];
        interpolant.__cacheIndex = firstInactiveIndex;
        interpolants[firstInactiveIndex] = interpolant;
        lastActiveInterpolant.__cacheIndex = prevIndex;
        interpolants[prevIndex] = lastActiveInterpolant;
    },
    _controlInterpolantsResultBuffer: new Float32Array(1),
    // return an action for a clip optionally using a custom root target
    // object (this method allocates a lot of dynamic memory in case a
    // previously unknown clip/root combination is specified)
    clipAction: function(clip, optionalRoot, blendMode) {
        const root = optionalRoot || this._root, rootUuid = root.uuid;
        let clipObject = typeof clip === 'string' ? AnimationClip.findByName(root, clip) : clip;
        const clipUuid = clipObject !== null ? clipObject.uuid : clip;
        const actionsForClip = this._actionsByClip[clipUuid];
        let prototypeAction = null;
        if (blendMode === undefined) {
            if (clipObject !== null) blendMode = clipObject.blendMode;
            else blendMode = NormalAnimationBlendMode;
        }
        if (actionsForClip !== undefined) {
            const existingAction = actionsForClip.actionByRoot[rootUuid];
            if (existingAction !== undefined && existingAction.blendMode === blendMode) return existingAction;
            // we know the clip, so we don't have to parse all
            // the bindings again but can just copy
            prototypeAction = actionsForClip.knownActions[0];
            // also, take the clip from the prototype action
            if (clipObject === null) clipObject = prototypeAction._clip;
        }
        // clip must be known when specified via string
        if (clipObject === null) return null;
        // allocate all resources required to run it
        const newAction = new AnimationAction(this, clipObject, optionalRoot, blendMode);
        this._bindAction(newAction, prototypeAction);
        // and make the action known to the memory manager
        this._addInactiveAction(newAction, clipUuid, rootUuid);
        return newAction;
    },
    // get an existing action
    existingAction: function(clip, optionalRoot) {
        const root = optionalRoot || this._root, rootUuid = root.uuid, clipObject = typeof clip === 'string' ? AnimationClip.findByName(root, clip) : clip, clipUuid = clipObject ? clipObject.uuid : clip, actionsForClip = this._actionsByClip[clipUuid];
        if (actionsForClip !== undefined) return actionsForClip.actionByRoot[rootUuid] || null;
        return null;
    },
    // deactivates all previously scheduled actions
    stopAllAction: function() {
        const actions = this._actions, nActions = this._nActiveActions;
        for(let i = nActions - 1; i >= 0; --i)actions[i].stop();
        return this;
    },
    // advance the time and update apply the animation
    update: function(deltaTime) {
        deltaTime *= this.timeScale;
        const actions = this._actions, nActions = this._nActiveActions, time = this.time += deltaTime, timeDirection = Math.sign(deltaTime), accuIndex = this._accuIndex ^= 1;
        // run active actions
        for(let i = 0; i !== nActions; ++i){
            const action = actions[i];
            action._update(time, deltaTime, timeDirection, accuIndex);
        }
        // update scene graph
        const bindings = this._bindings, nBindings = this._nActiveBindings;
        for(let i = 0; i !== nBindings; ++i)bindings[i].apply(accuIndex);
        return this;
    },
    // Allows you to seek to a specific time in an animation.
    setTime: function(timeInSeconds) {
        this.time = 0; // Zero out time attribute for AnimationMixer object;
        for(let i = 0; i < this._actions.length; i++)this._actions[i].time = 0; // Zero out time attribute for all associated AnimationAction objects.
        return this.update(timeInSeconds); // Update used to set exact time. Returns "this" AnimationMixer object.
    },
    // return this mixer's root target object
    getRoot: function() {
        return this._root;
    },
    // free all resources specific to a particular clip
    uncacheClip: function(clip) {
        const actions = this._actions, clipUuid = clip.uuid, actionsByClip = this._actionsByClip, actionsForClip = actionsByClip[clipUuid];
        if (actionsForClip !== undefined) {
            // note: just calling _removeInactiveAction would mess up the
            // iteration state and also require updating the state we can
            // just throw away
            const actionsToRemove = actionsForClip.knownActions;
            for(let i = 0, n = actionsToRemove.length; i !== n; ++i){
                const action = actionsToRemove[i];
                this._deactivateAction(action);
                const cacheIndex = action._cacheIndex, lastInactiveAction = actions[actions.length - 1];
                action._cacheIndex = null;
                action._byClipCacheIndex = null;
                lastInactiveAction._cacheIndex = cacheIndex;
                actions[cacheIndex] = lastInactiveAction;
                actions.pop();
                this._removeInactiveBindingsForAction(action);
            }
            delete actionsByClip[clipUuid];
        }
    },
    // free all resources specific to a particular root target object
    uncacheRoot: function(root) {
        const rootUuid = root.uuid, actionsByClip = this._actionsByClip;
        for(const clipUuid in actionsByClip){
            const actionByRoot = actionsByClip[clipUuid].actionByRoot, action = actionByRoot[rootUuid];
            if (action !== undefined) {
                this._deactivateAction(action);
                this._removeInactiveAction(action);
            }
        }
        const bindingsByRoot = this._bindingsByRootAndName, bindingByName = bindingsByRoot[rootUuid];
        if (bindingByName !== undefined) for(const trackName in bindingByName){
            const binding = bindingByName[trackName];
            binding.restoreOriginalState();
            this._removeInactiveBinding(binding);
        }
    },
    // remove a targeted clip from the cache
    uncacheAction: function(clip, optionalRoot) {
        const action = this.existingAction(clip, optionalRoot);
        if (action !== null) {
            this._deactivateAction(action);
            this._removeInactiveAction(action);
        }
    }
});
class Uniform {
    constructor(value){
        if (typeof value === 'string') {
            console.warn('THREE.Uniform: Type parameter is no longer needed.');
            value = arguments[1];
        }
        this.value = value;
    }
    clone() {
        return new Uniform(this.value.clone === undefined ? this.value : this.value.clone());
    }
}
function InstancedInterleavedBuffer(array, stride, meshPerAttribute) {
    InterleavedBuffer.call(this, array, stride);
    this.meshPerAttribute = meshPerAttribute || 1;
}
InstancedInterleavedBuffer.prototype = Object.assign(Object.create(InterleavedBuffer.prototype), {
    constructor: InstancedInterleavedBuffer,
    isInstancedInterleavedBuffer: true,
    copy: function(source) {
        InterleavedBuffer.prototype.copy.call(this, source);
        this.meshPerAttribute = source.meshPerAttribute;
        return this;
    },
    clone: function(data) {
        const ib = InterleavedBuffer.prototype.clone.call(this, data);
        ib.meshPerAttribute = this.meshPerAttribute;
        return ib;
    },
    toJSON: function(data) {
        const json = InterleavedBuffer.prototype.toJSON.call(this, data);
        json.isInstancedInterleavedBuffer = true;
        json.meshPerAttribute = this.meshPerAttribute;
        return json;
    }
});
function GLBufferAttribute(buffer, type, itemSize, elementSize, count) {
    this.buffer = buffer;
    this.type = type;
    this.itemSize = itemSize;
    this.elementSize = elementSize;
    this.count = count;
    this.version = 0;
}
Object.defineProperty(GLBufferAttribute.prototype, 'needsUpdate', {
    set: function(value) {
        if (value === true) this.version++;
    }
});
Object.assign(GLBufferAttribute.prototype, {
    isGLBufferAttribute: true,
    setBuffer: function(buffer) {
        this.buffer = buffer;
        return this;
    },
    setType: function(type, elementSize) {
        this.type = type;
        this.elementSize = elementSize;
        return this;
    },
    setItemSize: function(itemSize) {
        this.itemSize = itemSize;
        return this;
    },
    setCount: function(count) {
        this.count = count;
        return this;
    }
});
function Raycaster(origin, direction, near, far) {
    this.ray = new Ray(origin, direction);
    // direction is assumed to be normalized (for accurate distance calculations)
    this.near = near || 0;
    this.far = far || Infinity;
    this.camera = null;
    this.layers = new Layers();
    this.params = {
        Mesh: {},
        Line: {
            threshold: 1
        },
        LOD: {},
        Points: {
            threshold: 1
        },
        Sprite: {}
    };
    Object.defineProperties(this.params, {
        PointCloud: {
            get: function() {
                console.warn('THREE.Raycaster: params.PointCloud has been renamed to params.Points.');
                return this.Points;
            }
        }
    });
}
function ascSort(a, b) {
    return a.distance - b.distance;
}
function intersectObject(object, raycaster, intersects, recursive) {
    if (object.layers.test(raycaster.layers)) object.raycast(raycaster, intersects);
    if (recursive === true) {
        const children = object.children;
        for(let i = 0, l = children.length; i < l; i++)intersectObject(children[i], raycaster, intersects, true);
    }
}
Object.assign(Raycaster.prototype, {
    set: function(origin, direction) {
        // direction is assumed to be normalized (for accurate distance calculations)
        this.ray.set(origin, direction);
    },
    setFromCamera: function(coords, camera) {
        if (camera && camera.isPerspectiveCamera) {
            this.ray.origin.setFromMatrixPosition(camera.matrixWorld);
            this.ray.direction.set(coords.x, coords.y, 0.5).unproject(camera).sub(this.ray.origin).normalize();
            this.camera = camera;
        } else if (camera && camera.isOrthographicCamera) {
            this.ray.origin.set(coords.x, coords.y, (camera.near + camera.far) / (camera.near - camera.far)).unproject(camera); // set origin in plane of camera
            this.ray.direction.set(0, 0, -1).transformDirection(camera.matrixWorld);
            this.camera = camera;
        } else console.error('THREE.Raycaster: Unsupported camera type: ' + camera.type);
    },
    intersectObject: function(object, recursive, optionalTarget) {
        const intersects = optionalTarget || [];
        intersectObject(object, this, intersects, recursive);
        intersects.sort(ascSort);
        return intersects;
    },
    intersectObjects: function(objects, recursive, optionalTarget) {
        const intersects = optionalTarget || [];
        if (Array.isArray(objects) === false) {
            console.warn('THREE.Raycaster.intersectObjects: objects is not an Array.');
            return intersects;
        }
        for(let i = 0, l = objects.length; i < l; i++)intersectObject(objects[i], this, intersects, recursive);
        intersects.sort(ascSort);
        return intersects;
    }
});
/**
 * Ref: https://en.wikipedia.org/wiki/Spherical_coordinate_system
 *
 * The polar angle (phi) is measured from the positive y-axis. The positive y-axis is up.
 * The azimuthal angle (theta) is measured from the positive z-axis.
 */ class Spherical {
    constructor(radius = 1, phi = 0, theta = 0){
        this.radius = radius;
        this.phi = phi; // polar angle
        this.theta = theta; // azimuthal angle
        return this;
    }
    set(radius, phi, theta) {
        this.radius = radius;
        this.phi = phi;
        this.theta = theta;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(other) {
        this.radius = other.radius;
        this.phi = other.phi;
        this.theta = other.theta;
        return this;
    }
    // restrict phi to be betwee EPS and PI-EPS
    makeSafe() {
        const EPS = 0.000001;
        this.phi = Math.max(EPS, Math.min(Math.PI - EPS, this.phi));
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + y * y + z * z);
        if (this.radius === 0) {
            this.theta = 0;
            this.phi = 0;
        } else {
            this.theta = Math.atan2(x, z);
            this.phi = Math.acos(MathUtils.clamp(y / this.radius, -1, 1));
        }
        return this;
    }
}
/**
 * Ref: https://en.wikipedia.org/wiki/Cylindrical_coordinate_system
 */ class Cylindrical {
    constructor(radius, theta, y){
        this.radius = radius !== undefined ? radius : 1.0; // distance from the origin to a point in the x-z plane
        this.theta = theta !== undefined ? theta : 0; // counterclockwise angle in the x-z plane measured in radians from the positive z-axis
        this.y = y !== undefined ? y : 0; // height above the x-z plane
        return this;
    }
    set(radius, theta, y) {
        this.radius = radius;
        this.theta = theta;
        this.y = y;
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(other) {
        this.radius = other.radius;
        this.theta = other.theta;
        this.y = other.y;
        return this;
    }
    setFromVector3(v) {
        return this.setFromCartesianCoords(v.x, v.y, v.z);
    }
    setFromCartesianCoords(x, y, z) {
        this.radius = Math.sqrt(x * x + z * z);
        this.theta = Math.atan2(x, z);
        this.y = y;
        return this;
    }
}
const _vector$8 = /*@__PURE__*/ new Vector2();
class Box2 {
    constructor(min, max){
        Object.defineProperty(this, 'isBox2', {
            value: true
        });
        this.min = min !== undefined ? min : new Vector2(Infinity, Infinity);
        this.max = max !== undefined ? max : new Vector2(-Infinity, -Infinity);
    }
    set(min, max) {
        this.min.copy(min);
        this.max.copy(max);
        return this;
    }
    setFromPoints(points) {
        this.makeEmpty();
        for(let i = 0, il = points.length; i < il; i++)this.expandByPoint(points[i]);
        return this;
    }
    setFromCenterAndSize(center, size) {
        const halfSize = _vector$8.copy(size).multiplyScalar(0.5);
        this.min.copy(center).sub(halfSize);
        this.max.copy(center).add(halfSize);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(box) {
        this.min.copy(box.min);
        this.max.copy(box.max);
        return this;
    }
    makeEmpty() {
        this.min.x = this.min.y = Infinity;
        this.max.x = this.max.y = -Infinity;
        return this;
    }
    isEmpty() {
        // this is a more robust check for empty than ( volume <= 0 ) because volume can get positive with two negative axes
        return this.max.x < this.min.x || this.max.y < this.min.y;
    }
    getCenter(target) {
        if (target === undefined) {
            console.warn('THREE.Box2: .getCenter() target is now required');
            target = new Vector2();
        }
        return this.isEmpty() ? target.set(0, 0) : target.addVectors(this.min, this.max).multiplyScalar(0.5);
    }
    getSize(target) {
        if (target === undefined) {
            console.warn('THREE.Box2: .getSize() target is now required');
            target = new Vector2();
        }
        return this.isEmpty() ? target.set(0, 0) : target.subVectors(this.max, this.min);
    }
    expandByPoint(point) {
        this.min.min(point);
        this.max.max(point);
        return this;
    }
    expandByVector(vector) {
        this.min.sub(vector);
        this.max.add(vector);
        return this;
    }
    expandByScalar(scalar) {
        this.min.addScalar(-scalar);
        this.max.addScalar(scalar);
        return this;
    }
    containsPoint(point) {
        return point.x < this.min.x || point.x > this.max.x || point.y < this.min.y || point.y > this.max.y ? false : true;
    }
    containsBox(box) {
        return this.min.x <= box.min.x && box.max.x <= this.max.x && this.min.y <= box.min.y && box.max.y <= this.max.y;
    }
    getParameter(point, target) {
        // This can potentially have a divide by zero if the box
        // has a size dimension of 0.
        if (target === undefined) {
            console.warn('THREE.Box2: .getParameter() target is now required');
            target = new Vector2();
        }
        return target.set((point.x - this.min.x) / (this.max.x - this.min.x), (point.y - this.min.y) / (this.max.y - this.min.y));
    }
    intersectsBox(box) {
        // using 4 splitting planes to rule out intersections
        return box.max.x < this.min.x || box.min.x > this.max.x || box.max.y < this.min.y || box.min.y > this.max.y ? false : true;
    }
    clampPoint(point, target) {
        if (target === undefined) {
            console.warn('THREE.Box2: .clampPoint() target is now required');
            target = new Vector2();
        }
        return target.copy(point).clamp(this.min, this.max);
    }
    distanceToPoint(point) {
        const clampedPoint = _vector$8.copy(point).clamp(this.min, this.max);
        return clampedPoint.sub(point).length();
    }
    intersect(box) {
        this.min.max(box.min);
        this.max.min(box.max);
        return this;
    }
    union(box) {
        this.min.min(box.min);
        this.max.max(box.max);
        return this;
    }
    translate(offset) {
        this.min.add(offset);
        this.max.add(offset);
        return this;
    }
    equals(box) {
        return box.min.equals(this.min) && box.max.equals(this.max);
    }
}
const _startP = /*@__PURE__*/ new Vector3();
const _startEnd = /*@__PURE__*/ new Vector3();
class Line3 {
    constructor(start, end){
        this.start = start !== undefined ? start : new Vector3();
        this.end = end !== undefined ? end : new Vector3();
    }
    set(start, end) {
        this.start.copy(start);
        this.end.copy(end);
        return this;
    }
    clone() {
        return new this.constructor().copy(this);
    }
    copy(line) {
        this.start.copy(line.start);
        this.end.copy(line.end);
        return this;
    }
    getCenter(target) {
        if (target === undefined) {
            console.warn('THREE.Line3: .getCenter() target is now required');
            target = new Vector3();
        }
        return target.addVectors(this.start, this.end).multiplyScalar(0.5);
    }
    delta(target) {
        if (target === undefined) {
            console.warn('THREE.Line3: .delta() target is now required');
            target = new Vector3();
        }
        return target.subVectors(this.end, this.start);
    }
    distanceSq() {
        return this.start.distanceToSquared(this.end);
    }
    distance() {
        return this.start.distanceTo(this.end);
    }
    at(t, target) {
        if (target === undefined) {
            console.warn('THREE.Line3: .at() target is now required');
            target = new Vector3();
        }
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    closestPointToPointParameter(point, clampToLine) {
        _startP.subVectors(point, this.start);
        _startEnd.subVectors(this.end, this.start);
        const startEnd2 = _startEnd.dot(_startEnd);
        const startEnd_startP = _startEnd.dot(_startP);
        let t = startEnd_startP / startEnd2;
        if (clampToLine) t = MathUtils.clamp(t, 0, 1);
        return t;
    }
    closestPointToPoint(point, clampToLine, target) {
        const t = this.closestPointToPointParameter(point, clampToLine);
        if (target === undefined) {
            console.warn('THREE.Line3: .closestPointToPoint() target is now required');
            target = new Vector3();
        }
        return this.delta(target).multiplyScalar(t).add(this.start);
    }
    applyMatrix4(matrix) {
        this.start.applyMatrix4(matrix);
        this.end.applyMatrix4(matrix);
        return this;
    }
    equals(line) {
        return line.start.equals(this.start) && line.end.equals(this.end);
    }
}
function ImmediateRenderObject(material) {
    Object3D.call(this);
    this.material = material;
    this.render = function() {};
    this.hasPositions = false;
    this.hasNormals = false;
    this.hasColors = false;
    this.hasUvs = false;
    this.positionArray = null;
    this.normalArray = null;
    this.colorArray = null;
    this.uvArray = null;
    this.count = 0;
}
ImmediateRenderObject.prototype = Object.create(Object3D.prototype);
ImmediateRenderObject.prototype.constructor = ImmediateRenderObject;
ImmediateRenderObject.prototype.isImmediateRenderObject = true;
const _vector$9 = /*@__PURE__*/ new Vector3();
class SpotLightHelper extends Object3D {
    constructor(light, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new BufferGeometry();
        const positions = [
            0,
            0,
            0,
            0,
            0,
            1,
            0,
            0,
            0,
            1,
            0,
            1,
            0,
            0,
            0,
            -1,
            0,
            1,
            0,
            0,
            0,
            0,
            1,
            1,
            0,
            0,
            0,
            0,
            -1,
            1
        ];
        for(let i = 0, j = 1, l = 32; i < l; i++, j++){
            const p1 = i / l * Math.PI * 2;
            const p2 = j / l * Math.PI * 2;
            positions.push(Math.cos(p1), Math.sin(p1), 1, Math.cos(p2), Math.sin(p2), 1);
        }
        geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
        const material = new LineBasicMaterial({
            fog: false,
            toneMapped: false
        });
        this.cone = new LineSegments(geometry, material);
        this.add(this.cone);
        this.update();
    }
    dispose() {
        this.cone.geometry.dispose();
        this.cone.material.dispose();
    }
    update() {
        this.light.updateMatrixWorld();
        const coneLength = this.light.distance ? this.light.distance : 1000;
        const coneWidth = coneLength * Math.tan(this.light.angle);
        this.cone.scale.set(coneWidth, coneWidth, coneLength);
        _vector$9.setFromMatrixPosition(this.light.target.matrixWorld);
        this.cone.lookAt(_vector$9);
        if (this.color !== undefined) this.cone.material.color.set(this.color);
        else this.cone.material.color.copy(this.light.color);
    }
}
const _vector$a = /*@__PURE__*/ new Vector3();
const _boneMatrix = /*@__PURE__*/ new Matrix4();
const _matrixWorldInv = /*@__PURE__*/ new Matrix4();
class SkeletonHelper extends LineSegments {
    constructor(object){
        const bones = getBoneList(object);
        const geometry = new BufferGeometry();
        const vertices = [];
        const colors = [];
        const color1 = new Color(0, 0, 1);
        const color2 = new Color(0, 1, 0);
        for(let i = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                vertices.push(0, 0, 0);
                vertices.push(0, 0, 0);
                colors.push(color1.r, color1.g, color1.b);
                colors.push(color2.r, color2.g, color2.b);
            }
        }
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            depthTest: false,
            depthWrite: false,
            toneMapped: false,
            transparent: true
        });
        super(geometry, material);
        this.type = 'SkeletonHelper';
        this.isSkeletonHelper = true;
        this.root = object;
        this.bones = bones;
        this.matrix = object.matrixWorld;
        this.matrixAutoUpdate = false;
    }
    updateMatrixWorld(force) {
        const bones = this.bones;
        const geometry = this.geometry;
        const position = geometry.getAttribute('position');
        _matrixWorldInv.copy(this.root.matrixWorld).invert();
        for(let i = 0, j = 0; i < bones.length; i++){
            const bone = bones[i];
            if (bone.parent && bone.parent.isBone) {
                _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.matrixWorld);
                _vector$a.setFromMatrixPosition(_boneMatrix);
                position.setXYZ(j, _vector$a.x, _vector$a.y, _vector$a.z);
                _boneMatrix.multiplyMatrices(_matrixWorldInv, bone.parent.matrixWorld);
                _vector$a.setFromMatrixPosition(_boneMatrix);
                position.setXYZ(j + 1, _vector$a.x, _vector$a.y, _vector$a.z);
                j += 2;
            }
        }
        geometry.getAttribute('position').needsUpdate = true;
        super.updateMatrixWorld(force);
    }
}
function getBoneList(object) {
    const boneList = [];
    if (object && object.isBone) boneList.push(object);
    for(let i = 0; i < object.children.length; i++)boneList.push.apply(boneList, getBoneList(object.children[i]));
    return boneList;
}
class PointLightHelper extends Mesh {
    constructor(light, sphereSize, color){
        const geometry = new SphereGeometry(sphereSize, 4, 2);
        const material = new MeshBasicMaterial({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        super(geometry, material);
        this.light = light;
        this.light.updateMatrixWorld();
        this.color = color;
        this.type = 'PointLightHelper';
        this.matrix = this.light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.update();
    /*
	// TODO: delete this comment?
	const distanceGeometry = new THREE.IcosahedronBufferGeometry( 1, 2 );
	const distanceMaterial = new THREE.MeshBasicMaterial( { color: hexColor, fog: false, wireframe: true, opacity: 0.1, transparent: true } );

	this.lightSphere = new THREE.Mesh( bulbGeometry, bulbMaterial );
	this.lightDistance = new THREE.Mesh( distanceGeometry, distanceMaterial );

	const d = light.distance;

	if ( d === 0.0 ) {

		this.lightDistance.visible = false;

	} else {

		this.lightDistance.scale.set( d, d, d );

	}

	this.add( this.lightDistance );
	*/ }
    dispose() {
        this.geometry.dispose();
        this.material.dispose();
    }
    update() {
        if (this.color !== undefined) this.material.color.set(this.color);
        else this.material.color.copy(this.light.color);
    /*
		const d = this.light.distance;

		if ( d === 0.0 ) {

			this.lightDistance.visible = false;

		} else {

			this.lightDistance.visible = true;
			this.lightDistance.scale.set( d, d, d );

		}
		*/ }
}
const _vector$b = /*@__PURE__*/ new Vector3();
const _color1 = /*@__PURE__*/ new Color();
const _color2 = /*@__PURE__*/ new Color();
class HemisphereLightHelper extends Object3D {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        const geometry = new OctahedronGeometry(size);
        geometry.rotateY(Math.PI * 0.5);
        this.material = new MeshBasicMaterial({
            wireframe: true,
            fog: false,
            toneMapped: false
        });
        if (this.color === undefined) this.material.vertexColors = true;
        const position = geometry.getAttribute('position');
        const colors = new Float32Array(position.count * 3);
        geometry.setAttribute('color', new BufferAttribute(colors, 3));
        this.add(new Mesh(geometry, this.material));
        this.update();
    }
    dispose() {
        this.children[0].geometry.dispose();
        this.children[0].material.dispose();
    }
    update() {
        const mesh = this.children[0];
        if (this.color !== undefined) this.material.color.set(this.color);
        else {
            const colors = mesh.geometry.getAttribute('color');
            _color1.copy(this.light.color);
            _color2.copy(this.light.groundColor);
            for(let i = 0, l = colors.count; i < l; i++){
                const color = i < l / 2 ? _color1 : _color2;
                colors.setXYZ(i, color.r, color.g, color.b);
            }
            colors.needsUpdate = true;
        }
        mesh.lookAt(_vector$b.setFromMatrixPosition(this.light.matrixWorld).negate());
    }
}
class GridHelper extends LineSegments {
    constructor(size = 10, divisions = 10, color1 = 0x444444, color2 = 0x888888){
        color1 = new Color(color1);
        color2 = new Color(color2);
        const center = divisions / 2;
        const step = size / divisions;
        const halfSize = size / 2;
        const vertices = [], colors = [];
        for(let i = 0, j = 0, k = -halfSize; i <= divisions; i++, k += step){
            vertices.push(-halfSize, 0, k, halfSize, 0, k);
            vertices.push(k, 0, -halfSize, k, 0, halfSize);
            const color = i === center ? color1 : color2;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
            color.toArray(colors, j);
            j += 3;
        }
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'GridHelper';
    }
}
class PolarGridHelper extends LineSegments {
    constructor(radius = 10, radials = 16, circles = 8, divisions = 64, color1 = 0x444444, color2 = 0x888888){
        color1 = new Color(color1);
        color2 = new Color(color2);
        const vertices = [];
        const colors = [];
        // create the radials
        for(let i = 0; i <= radials; i++){
            const v = i / radials * (Math.PI * 2);
            const x = Math.sin(v) * radius;
            const z = Math.cos(v) * radius;
            vertices.push(0, 0, 0);
            vertices.push(x, 0, z);
            const color = i & 1 ? color1 : color2;
            colors.push(color.r, color.g, color.b);
            colors.push(color.r, color.g, color.b);
        }
        // create the circles
        for(let i = 0; i <= circles; i++){
            const color = i & 1 ? color1 : color2;
            const r = radius - radius / circles * i;
            for(let j = 0; j < divisions; j++){
                // first vertex
                let v = j / divisions * (Math.PI * 2);
                let x = Math.sin(v) * r;
                let z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
                // second vertex
                v = (j + 1) / divisions * (Math.PI * 2);
                x = Math.sin(v) * r;
                z = Math.cos(v) * r;
                vertices.push(x, 0, z);
                colors.push(color.r, color.g, color.b);
            }
        }
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'PolarGridHelper';
    }
}
const _v1$6 = /*@__PURE__*/ new Vector3();
const _v2$3 = /*@__PURE__*/ new Vector3();
const _v3$1 = /*@__PURE__*/ new Vector3();
class DirectionalLightHelper extends Object3D {
    constructor(light, size, color){
        super();
        this.light = light;
        this.light.updateMatrixWorld();
        this.matrix = light.matrixWorld;
        this.matrixAutoUpdate = false;
        this.color = color;
        if (size === undefined) size = 1;
        let geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute([
            -size,
            size,
            0,
            size,
            size,
            0,
            size,
            -size,
            0,
            -size,
            -size,
            0,
            -size,
            size,
            0
        ], 3));
        const material = new LineBasicMaterial({
            fog: false,
            toneMapped: false
        });
        this.lightPlane = new Line(geometry, material);
        this.add(this.lightPlane);
        geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute([
            0,
            0,
            0,
            0,
            0,
            1
        ], 3));
        this.targetLine = new Line(geometry, material);
        this.add(this.targetLine);
        this.update();
    }
    dispose() {
        this.lightPlane.geometry.dispose();
        this.lightPlane.material.dispose();
        this.targetLine.geometry.dispose();
        this.targetLine.material.dispose();
    }
    update() {
        _v1$6.setFromMatrixPosition(this.light.matrixWorld);
        _v2$3.setFromMatrixPosition(this.light.target.matrixWorld);
        _v3$1.subVectors(_v2$3, _v1$6);
        this.lightPlane.lookAt(_v2$3);
        if (this.color !== undefined) {
            this.lightPlane.material.color.set(this.color);
            this.targetLine.material.color.set(this.color);
        } else {
            this.lightPlane.material.color.copy(this.light.color);
            this.targetLine.material.color.copy(this.light.color);
        }
        this.targetLine.lookAt(_v2$3);
        this.targetLine.scale.z = _v3$1.length();
    }
}
const _vector$c = /*@__PURE__*/ new Vector3();
const _camera = /*@__PURE__*/ new Camera();
/**
 *	- shows frustum, line of sight and up of the camera
 *	- suitable for fast updates
 * 	- based on frustum visualization in lightgl.js shadowmap example
 *		http://evanw.github.com/lightgl.js/tests/shadowmap.html
 */ class CameraHelper extends LineSegments {
    constructor(camera){
        const geometry = new BufferGeometry();
        const material = new LineBasicMaterial({
            color: 0xffffff,
            vertexColors: true,
            toneMapped: false
        });
        const vertices = [];
        const colors = [];
        const pointMap = {};
        // colors
        const colorFrustum = new Color(0xffaa00);
        const colorCone = new Color(0xff0000);
        const colorUp = new Color(0x00aaff);
        const colorTarget = new Color(0xffffff);
        const colorCross = new Color(0x333333);
        // near
        addLine('n1', 'n2', colorFrustum);
        addLine('n2', 'n4', colorFrustum);
        addLine('n4', 'n3', colorFrustum);
        addLine('n3', 'n1', colorFrustum);
        // far
        addLine('f1', 'f2', colorFrustum);
        addLine('f2', 'f4', colorFrustum);
        addLine('f4', 'f3', colorFrustum);
        addLine('f3', 'f1', colorFrustum);
        // sides
        addLine('n1', 'f1', colorFrustum);
        addLine('n2', 'f2', colorFrustum);
        addLine('n3', 'f3', colorFrustum);
        addLine('n4', 'f4', colorFrustum);
        // cone
        addLine('p', 'n1', colorCone);
        addLine('p', 'n2', colorCone);
        addLine('p', 'n3', colorCone);
        addLine('p', 'n4', colorCone);
        // up
        addLine('u1', 'u2', colorUp);
        addLine('u2', 'u3', colorUp);
        addLine('u3', 'u1', colorUp);
        // target
        addLine('c', 't', colorTarget);
        addLine('p', 'c', colorCross);
        // cross
        addLine('cn1', 'cn2', colorCross);
        addLine('cn3', 'cn4', colorCross);
        addLine('cf1', 'cf2', colorCross);
        addLine('cf3', 'cf4', colorCross);
        function addLine(a, b, color) {
            addPoint(a, color);
            addPoint(b, color);
        }
        function addPoint(id, color) {
            vertices.push(0, 0, 0);
            colors.push(color.r, color.g, color.b);
            if (pointMap[id] === undefined) pointMap[id] = [];
            pointMap[id].push(vertices.length / 3 - 1);
        }
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        super(geometry, material);
        this.type = 'CameraHelper';
        this.camera = camera;
        if (this.camera.updateProjectionMatrix) this.camera.updateProjectionMatrix();
        this.matrix = camera.matrixWorld;
        this.matrixAutoUpdate = false;
        this.pointMap = pointMap;
        this.update();
    }
    update() {
        const geometry = this.geometry;
        const pointMap = this.pointMap;
        const w = 1, h = 1;
        // we need just camera projection matrix inverse
        // world matrix must be identity
        _camera.projectionMatrixInverse.copy(this.camera.projectionMatrixInverse);
        // center / target
        setPoint('c', pointMap, geometry, _camera, 0, 0, -1);
        setPoint('t', pointMap, geometry, _camera, 0, 0, 1);
        // near
        setPoint('n1', pointMap, geometry, _camera, -w, -h, -1);
        setPoint('n2', pointMap, geometry, _camera, w, -h, -1);
        setPoint('n3', pointMap, geometry, _camera, -w, h, -1);
        setPoint('n4', pointMap, geometry, _camera, w, h, -1);
        // far
        setPoint('f1', pointMap, geometry, _camera, -w, -h, 1);
        setPoint('f2', pointMap, geometry, _camera, w, -h, 1);
        setPoint('f3', pointMap, geometry, _camera, -w, h, 1);
        setPoint('f4', pointMap, geometry, _camera, w, h, 1);
        // up
        setPoint('u1', pointMap, geometry, _camera, w * 0.7, h * 1.1, -1);
        setPoint('u2', pointMap, geometry, _camera, -w * 0.7, h * 1.1, -1);
        setPoint('u3', pointMap, geometry, _camera, 0, h * 2, -1);
        // cross
        setPoint('cf1', pointMap, geometry, _camera, -w, 0, 1);
        setPoint('cf2', pointMap, geometry, _camera, w, 0, 1);
        setPoint('cf3', pointMap, geometry, _camera, 0, -h, 1);
        setPoint('cf4', pointMap, geometry, _camera, 0, h, 1);
        setPoint('cn1', pointMap, geometry, _camera, -w, 0, -1);
        setPoint('cn2', pointMap, geometry, _camera, w, 0, -1);
        setPoint('cn3', pointMap, geometry, _camera, 0, -h, -1);
        setPoint('cn4', pointMap, geometry, _camera, 0, h, -1);
        geometry.getAttribute('position').needsUpdate = true;
    }
}
function setPoint(point, pointMap, geometry, camera, x, y, z) {
    _vector$c.set(x, y, z).unproject(camera);
    const points = pointMap[point];
    if (points !== undefined) {
        const position = geometry.getAttribute('position');
        for(let i = 0, l = points.length; i < l; i++)position.setXYZ(points[i], _vector$c.x, _vector$c.y, _vector$c.z);
    }
}
const _box$3 = /*@__PURE__*/ new Box3();
class BoxHelper extends LineSegments {
    constructor(object, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = new Float32Array(24);
        const geometry = new BufferGeometry();
        geometry.setIndex(new BufferAttribute(indices, 1));
        geometry.setAttribute('position', new BufferAttribute(positions, 3));
        super(geometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.object = object;
        this.type = 'BoxHelper';
        this.matrixAutoUpdate = false;
        this.update();
    }
    update(object) {
        if (object !== undefined) console.warn('THREE.BoxHelper: .update() has no longer arguments.');
        if (this.object !== undefined) _box$3.setFromObject(this.object);
        if (_box$3.isEmpty()) return;
        const min = _box$3.min;
        const max = _box$3.max;
        /*
			5____4
		1/___0/|
		| 6__|_7
		2/___3/

		0: max.x, max.y, max.z
		1: min.x, max.y, max.z
		2: min.x, min.y, max.z
		3: max.x, min.y, max.z
		4: max.x, max.y, min.z
		5: min.x, max.y, min.z
		6: min.x, min.y, min.z
		7: max.x, min.y, min.z
		*/ const position = this.geometry.attributes.position;
        const array = position.array;
        array[0] = max.x;
        array[1] = max.y;
        array[2] = max.z;
        array[3] = min.x;
        array[4] = max.y;
        array[5] = max.z;
        array[6] = min.x;
        array[7] = min.y;
        array[8] = max.z;
        array[9] = max.x;
        array[10] = min.y;
        array[11] = max.z;
        array[12] = max.x;
        array[13] = max.y;
        array[14] = min.z;
        array[15] = min.x;
        array[16] = max.y;
        array[17] = min.z;
        array[18] = min.x;
        array[19] = min.y;
        array[20] = min.z;
        array[21] = max.x;
        array[22] = min.y;
        array[23] = min.z;
        position.needsUpdate = true;
        this.geometry.computeBoundingSphere();
    }
    setFromObject(object) {
        this.object = object;
        this.update();
        return this;
    }
    copy(source) {
        LineSegments.prototype.copy.call(this, source);
        this.object = source.object;
        return this;
    }
}
class Box3Helper extends LineSegments {
    constructor(box, color = 0xffff00){
        const indices = new Uint16Array([
            0,
            1,
            1,
            2,
            2,
            3,
            3,
            0,
            4,
            5,
            5,
            6,
            6,
            7,
            7,
            4,
            0,
            4,
            1,
            5,
            2,
            6,
            3,
            7
        ]);
        const positions = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            -1,
            -1,
            -1,
            -1,
            1,
            -1,
            -1
        ];
        const geometry = new BufferGeometry();
        geometry.setIndex(new BufferAttribute(indices, 1));
        geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
        super(geometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.box = box;
        this.type = 'Box3Helper';
        this.geometry.computeBoundingSphere();
    }
    updateMatrixWorld(force) {
        const box = this.box;
        if (box.isEmpty()) return;
        box.getCenter(this.position);
        box.getSize(this.scale);
        this.scale.multiplyScalar(0.5);
        super.updateMatrixWorld(force);
    }
}
class PlaneHelper extends Line {
    constructor(plane, size = 1, hex = 0xffff00){
        const color = hex;
        const positions = [
            1,
            -1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1,
            1,
            1,
            1,
            0,
            0,
            1,
            0,
            0,
            0
        ];
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(positions, 3));
        geometry.computeBoundingSphere();
        super(geometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.type = 'PlaneHelper';
        this.plane = plane;
        this.size = size;
        const positions2 = [
            1,
            1,
            1,
            -1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            1,
            1,
            -1,
            -1,
            1,
            1,
            -1,
            1
        ];
        const geometry2 = new BufferGeometry();
        geometry2.setAttribute('position', new Float32BufferAttribute(positions2, 3));
        geometry2.computeBoundingSphere();
        this.add(new Mesh(geometry2, new MeshBasicMaterial({
            color: color,
            opacity: 0.2,
            transparent: true,
            depthWrite: false,
            toneMapped: false
        })));
    }
    updateMatrixWorld(force) {
        let scale = -this.plane.constant;
        if (Math.abs(scale) < 1e-8) scale = 1e-8; // sign does not matter
        this.scale.set(0.5 * this.size, 0.5 * this.size, scale);
        this.children[0].material.side = scale < 0 ? BackSide : FrontSide; // renderer flips side when determinant < 0; flipping not wanted here
        this.lookAt(this.plane.normal);
        super.updateMatrixWorld(force);
    }
}
const _axis = /*@__PURE__*/ new Vector3();
let _lineGeometry, _coneGeometry;
class ArrowHelper extends Object3D {
    constructor(dir, origin, length, color, headLength, headWidth){
        super();
        // dir is assumed to be normalized
        this.type = 'ArrowHelper';
        if (dir === undefined) dir = new Vector3(0, 0, 1);
        if (origin === undefined) origin = new Vector3(0, 0, 0);
        if (length === undefined) length = 1;
        if (color === undefined) color = 0xffff00;
        if (headLength === undefined) headLength = 0.2 * length;
        if (headWidth === undefined) headWidth = 0.2 * headLength;
        if (_lineGeometry === undefined) {
            _lineGeometry = new BufferGeometry();
            _lineGeometry.setAttribute('position', new Float32BufferAttribute([
                0,
                0,
                0,
                0,
                1,
                0
            ], 3));
            _coneGeometry = new CylinderGeometry(0, 0.5, 1, 5, 1);
            _coneGeometry.translate(0, -0.5, 0);
        }
        this.position.copy(origin);
        this.line = new Line(_lineGeometry, new LineBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.line.matrixAutoUpdate = false;
        this.add(this.line);
        this.cone = new Mesh(_coneGeometry, new MeshBasicMaterial({
            color: color,
            toneMapped: false
        }));
        this.cone.matrixAutoUpdate = false;
        this.add(this.cone);
        this.setDirection(dir);
        this.setLength(length, headLength, headWidth);
    }
    setDirection(dir) {
        // dir is assumed to be normalized
        if (dir.y > 0.99999) this.quaternion.set(0, 0, 0, 1);
        else if (dir.y < -0.99999) this.quaternion.set(1, 0, 0, 0);
        else {
            _axis.set(dir.z, 0, -dir.x).normalize();
            const radians = Math.acos(dir.y);
            this.quaternion.setFromAxisAngle(_axis, radians);
        }
    }
    setLength(length, headLength, headWidth) {
        if (headLength === undefined) headLength = 0.2 * length;
        if (headWidth === undefined) headWidth = 0.2 * headLength;
        this.line.scale.set(1, Math.max(0.0001, length - headLength), 1); // see #17458
        this.line.updateMatrix();
        this.cone.scale.set(headWidth, headLength, headWidth);
        this.cone.position.y = length;
        this.cone.updateMatrix();
    }
    setColor(color) {
        this.line.material.color.set(color);
        this.cone.material.color.set(color);
    }
    copy(source) {
        super.copy(source, false);
        this.line.copy(source.line);
        this.cone.copy(source.cone);
        return this;
    }
}
class AxesHelper extends LineSegments {
    constructor(size = 1){
        const vertices = [
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size,
            0,
            0,
            0,
            0,
            0,
            0,
            size
        ];
        const colors = [
            1,
            0,
            0,
            1,
            0.6,
            0,
            0,
            1,
            0,
            0.6,
            1,
            0,
            0,
            0,
            1,
            0,
            0.6,
            1
        ];
        const geometry = new BufferGeometry();
        geometry.setAttribute('position', new Float32BufferAttribute(vertices, 3));
        geometry.setAttribute('color', new Float32BufferAttribute(colors, 3));
        const material = new LineBasicMaterial({
            vertexColors: true,
            toneMapped: false
        });
        super(geometry, material);
        this.type = 'AxesHelper';
    }
}
const _floatView = new Float32Array(1);
const _int32View = new Int32Array(_floatView.buffer);
const DataUtils = {
    // Converts float32 to float16 (stored as uint16 value).
    toHalfFloat: function(val) {
        // Source: http://gamedev.stackexchange.com/questions/17326/conversion-of-a-number-from-single-precision-floating-point-representation-to-a/17410#17410
        /* This method is faster than the OpenEXR implementation (very often
		* used, eg. in Ogre), with the additional benefit of rounding, inspired
		* by James Tursa?s half-precision code. */ _floatView[0] = val;
        const x = _int32View[0];
        let bits = x >> 16 & 0x8000; /* Get the sign */ 
        let m = x >> 12 & 0x07ff; /* Keep one extra bit for rounding */ 
        const e = x >> 23 & 0xff; /* Using int is faster here */ 
        /* If zero, or denormal, or exponent underflows too much for a denormal
			* half, return signed zero. */ if (e < 103) return bits;
        /* If NaN, return NaN. If Inf or exponent overflow, return Inf. */ if (e > 142) {
            bits |= 0x7c00;
            /* If exponent was 0xff and one mantissa bit was set, it means NaN,
						* not Inf, so make sure we set one mantissa bit too. */ bits |= (e == 255 ? 0 : 1) && x & 0x007fffff;
            return bits;
        }
        /* If exponent underflows but not too much, return a denormal */ if (e < 113) {
            m |= 0x0800;
            /* Extra rounding may overflow and set mantissa to 0 and exponent
				* to 1, which is OK. */ bits |= (m >> 114 - e) + (m >> 113 - e & 1);
            return bits;
        }
        bits |= e - 112 << 10 | m >> 1;
        /* Extra rounding. An overflow will set mantissa to 0 and increment
			* the exponent, which is OK. */ bits += m & 1;
        return bits;
    }
};
const LOD_MIN = 4;
const LOD_MAX = 8;
const SIZE_MAX = Math.pow(2, LOD_MAX);
// The standard deviations (radians) associated with the extra mips. These are
// chosen to approximate a Trowbridge-Reitz distribution function times the
// geometric shadowing function. These sigma values squared must match the
// variance #defines in cube_uv_reflection_fragment.glsl.js.
const EXTRA_LOD_SIGMA = [
    0.125,
    0.215,
    0.35,
    0.446,
    0.526,
    0.582
];
const TOTAL_LODS = LOD_MAX - LOD_MIN + 1 + EXTRA_LOD_SIGMA.length;
// The maximum length of the blur for loop. Smaller sigmas will use fewer
// samples and exit early, but not recompile the shader.
const MAX_SAMPLES = 20;
const ENCODINGS = {
    [LinearEncoding]: 0,
    [sRGBEncoding]: 1,
    [RGBEEncoding]: 2,
    [RGBM7Encoding]: 3,
    [RGBM16Encoding]: 4,
    [RGBDEncoding]: 5,
    [GammaEncoding]: 6
};
const backgroundMaterial = new MeshBasicMaterial({
    side: BackSide,
    depthWrite: false,
    depthTest: false
});
const backgroundBox = new Mesh(new BoxGeometry(), backgroundMaterial);
const _flatCamera = /*@__PURE__*/ new OrthographicCamera();
const { _lodPlanes, _sizeLods, _sigmas } = /*@__PURE__*/ _createPlanes();
const _clearColor = /*@__PURE__*/ new Color();
let _oldTarget = null;
// Golden Ratio
const PHI = (1 + Math.sqrt(5)) / 2;
const INV_PHI = 1 / PHI;
// Vertices of a dodecahedron (except the opposites, which represent the
// same axis), used as axis directions evenly spread on a sphere.
const _axisDirections = [
    /*@__PURE__*/ new Vector3(1, 1, 1),
    /*@__PURE__*/ new Vector3(-1, 1, 1),
    /*@__PURE__*/ new Vector3(1, 1, -1),
    /*@__PURE__*/ new Vector3(-1, 1, -1),
    /*@__PURE__*/ new Vector3(0, PHI, INV_PHI),
    /*@__PURE__*/ new Vector3(0, PHI, -INV_PHI),
    /*@__PURE__*/ new Vector3(INV_PHI, 0, PHI),
    /*@__PURE__*/ new Vector3(-INV_PHI, 0, PHI),
    /*@__PURE__*/ new Vector3(PHI, INV_PHI, 0),
    /*@__PURE__*/ new Vector3(-PHI, INV_PHI, 0)
];
/**
 * This class generates a Prefiltered, Mipmapped Radiance Environment Map
 * (PMREM) from a cubeMap environment texture. This allows different levels of
 * blur to be quickly accessed based on material roughness. It is packed into a
 * special CubeUV format that allows us to perform custom interpolation so that
 * we can support nonlinear formats such as RGBE. Unlike a traditional mipmap
 * chain, it only goes down to the LOD_MIN level (above), and then creates extra
 * even more filtered 'mips' at the same LOD_MIN resolution, associated with
 * higher roughness levels. In this way we maintain resolution to smoothly
 * interpolate diffuse lighting while limiting sampling computation.
 */ function convertLinearToRGBE(color) {
    const maxComponent = Math.max(color.r, color.g, color.b);
    const fExp = Math.min(Math.max(Math.ceil(Math.log2(maxComponent)), -128), 127.0);
    color.multiplyScalar(Math.pow(2.0, -fExp));
    const alpha = (fExp + 128.0) / 255.0;
    return alpha;
}
class PMREMGenerator {
    constructor(renderer){
        this._renderer = renderer;
        this._pingPongRenderTarget = null;
        this._blurMaterial = _getBlurShader(MAX_SAMPLES);
        this._equirectShader = null;
        this._cubemapShader = null;
        this._compileMaterial(this._blurMaterial);
    }
    /**
	 * Generates a PMREM from a supplied Scene, which can be faster than using an
	 * image if networking bandwidth is low. Optional sigma specifies a blur radius
	 * in radians to be applied to the scene before PMREM generation. Optional near
	 * and far planes ensure the scene is rendered in its entirety (the cubeCamera
	 * is placed at the origin).
	 */ fromScene(scene, sigma = 0, near = 0.1, far = 100) {
        _oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets();
        this._sceneToCubeUV(scene, near, far, cubeUVRenderTarget);
        if (sigma > 0) this._blur(cubeUVRenderTarget, 0, 0, sigma);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    /**
	 * Generates a PMREM from an equirectangular texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input image size is 1k (1024 x 512),
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromEquirectangular(equirectangular) {
        return this._fromTexture(equirectangular);
    }
    /**
	 * Generates a PMREM from an cubemap texture, which can be either LDR
	 * (RGBFormat) or HDR (RGBEFormat). The ideal input cube size is 256 x 256,
	 * as this matches best with the 256 x 256 cubemap output.
	 */ fromCubemap(cubemap) {
        return this._fromTexture(cubemap);
    }
    /**
	 * Pre-compiles the cubemap shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileCubemapShader() {
        if (this._cubemapShader === null) {
            this._cubemapShader = _getCubemapShader();
            this._compileMaterial(this._cubemapShader);
        }
    }
    /**
	 * Pre-compiles the equirectangular shader. You can get faster start-up by invoking this method during
	 * your texture's network fetch for increased concurrency.
	 */ compileEquirectangularShader() {
        if (this._equirectShader === null) {
            this._equirectShader = _getEquirectShader();
            this._compileMaterial(this._equirectShader);
        }
    }
    /**
	 * Disposes of the PMREMGenerator's internal memory. Note that PMREMGenerator is a static class,
	 * so you should not need more than one PMREMGenerator object. If you do, calling dispose() on
	 * one of them will cause any others to also become unusable.
	 */ dispose() {
        this._blurMaterial.dispose();
        if (this._cubemapShader !== null) this._cubemapShader.dispose();
        if (this._equirectShader !== null) this._equirectShader.dispose();
        for(let i = 0; i < _lodPlanes.length; i++)_lodPlanes[i].dispose();
    }
    // private interface
    _cleanup(outputTarget) {
        this._pingPongRenderTarget.dispose();
        this._renderer.setRenderTarget(_oldTarget);
        outputTarget.scissorTest = false;
        _setViewport(outputTarget, 0, 0, outputTarget.width, outputTarget.height);
    }
    _fromTexture(texture) {
        _oldTarget = this._renderer.getRenderTarget();
        const cubeUVRenderTarget = this._allocateTargets(texture);
        this._textureToCubeUV(texture, cubeUVRenderTarget);
        this._applyPMREM(cubeUVRenderTarget);
        this._cleanup(cubeUVRenderTarget);
        return cubeUVRenderTarget;
    }
    _allocateTargets(texture) {
        const params = {
            magFilter: NearestFilter,
            minFilter: NearestFilter,
            generateMipmaps: false,
            type: UnsignedByteType,
            format: RGBEFormat,
            encoding: _isLDR(texture) ? texture.encoding : RGBEEncoding,
            depthBuffer: false
        };
        const cubeUVRenderTarget = _createRenderTarget(params);
        cubeUVRenderTarget.depthBuffer = texture ? false : true;
        this._pingPongRenderTarget = _createRenderTarget(params);
        return cubeUVRenderTarget;
    }
    _compileMaterial(material) {
        const tmpMesh = new Mesh(_lodPlanes[0], material);
        this._renderer.compile(tmpMesh, _flatCamera);
    }
    _sceneToCubeUV(scene, near, far, cubeUVRenderTarget) {
        const fov = 90;
        const aspect = 1;
        const cubeCamera = new PerspectiveCamera(fov, aspect, near, far);
        const upSign = [
            1,
            -1,
            1,
            1,
            1,
            1
        ];
        const forwardSign = [
            1,
            1,
            1,
            -1,
            -1,
            -1
        ];
        const renderer = this._renderer;
        const originalAutoClear = renderer.autoClear;
        const outputEncoding = renderer.outputEncoding;
        const toneMapping = renderer.toneMapping;
        renderer.getClearColor(_clearColor);
        renderer.toneMapping = NoToneMapping;
        renderer.outputEncoding = LinearEncoding;
        renderer.autoClear = false;
        let useSolidColor = false;
        const background = scene.background;
        if (background) {
            if (background.isColor) {
                backgroundMaterial.color.copy(background).convertSRGBToLinear();
                scene.background = null;
                const alpha = convertLinearToRGBE(backgroundMaterial.color);
                backgroundMaterial.opacity = alpha;
                useSolidColor = true;
            }
        } else {
            backgroundMaterial.color.copy(_clearColor).convertSRGBToLinear();
            const alpha = convertLinearToRGBE(backgroundMaterial.color);
            backgroundMaterial.opacity = alpha;
            useSolidColor = true;
        }
        for(let i = 0; i < 6; i++){
            const col = i % 3;
            if (col == 0) {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(forwardSign[i], 0, 0);
            } else if (col == 1) {
                cubeCamera.up.set(0, 0, upSign[i]);
                cubeCamera.lookAt(0, forwardSign[i], 0);
            } else {
                cubeCamera.up.set(0, upSign[i], 0);
                cubeCamera.lookAt(0, 0, forwardSign[i]);
            }
            _setViewport(cubeUVRenderTarget, col * SIZE_MAX, i > 2 ? SIZE_MAX : 0, SIZE_MAX, SIZE_MAX);
            renderer.setRenderTarget(cubeUVRenderTarget);
            if (useSolidColor) renderer.render(backgroundBox, cubeCamera);
            renderer.render(scene, cubeCamera);
        }
        renderer.toneMapping = toneMapping;
        renderer.outputEncoding = outputEncoding;
        renderer.autoClear = originalAutoClear;
    }
    _textureToCubeUV(texture, cubeUVRenderTarget) {
        const renderer = this._renderer;
        if (texture.isCubeTexture) {
            if (this._cubemapShader == null) this._cubemapShader = _getCubemapShader();
        } else if (this._equirectShader == null) this._equirectShader = _getEquirectShader();
        const material = texture.isCubeTexture ? this._cubemapShader : this._equirectShader;
        const mesh = new Mesh(_lodPlanes[0], material);
        const uniforms = material.uniforms;
        uniforms['envMap'].value = texture;
        if (!texture.isCubeTexture) uniforms['texelSize'].value.set(1.0 / texture.image.width, 1.0 / texture.image.height);
        uniforms['inputEncoding'].value = ENCODINGS[texture.encoding];
        uniforms['outputEncoding'].value = ENCODINGS[cubeUVRenderTarget.texture.encoding];
        _setViewport(cubeUVRenderTarget, 0, 0, 3 * SIZE_MAX, 2 * SIZE_MAX);
        renderer.setRenderTarget(cubeUVRenderTarget);
        renderer.render(mesh, _flatCamera);
    }
    _applyPMREM(cubeUVRenderTarget) {
        const renderer = this._renderer;
        const autoClear = renderer.autoClear;
        renderer.autoClear = false;
        for(let i = 1; i < TOTAL_LODS; i++){
            const sigma = Math.sqrt(_sigmas[i] * _sigmas[i] - _sigmas[i - 1] * _sigmas[i - 1]);
            const poleAxis = _axisDirections[(i - 1) % _axisDirections.length];
            this._blur(cubeUVRenderTarget, i - 1, i, sigma, poleAxis);
        }
        renderer.autoClear = autoClear;
    }
    /**
	 * This is a two-pass Gaussian blur for a cubemap. Normally this is done
	 * vertically and horizontally, but this breaks down on a cube. Here we apply
	 * the blur latitudinally (around the poles), and then longitudinally (towards
	 * the poles) to approximate the orthogonally-separable blur. It is least
	 * accurate at the poles, but still does a decent job.
	 */ _blur(cubeUVRenderTarget, lodIn, lodOut, sigma, poleAxis) {
        const pingPongRenderTarget = this._pingPongRenderTarget;
        this._halfBlur(cubeUVRenderTarget, pingPongRenderTarget, lodIn, lodOut, sigma, 'latitudinal', poleAxis);
        this._halfBlur(pingPongRenderTarget, cubeUVRenderTarget, lodOut, lodOut, sigma, 'longitudinal', poleAxis);
    }
    _halfBlur(targetIn, targetOut, lodIn, lodOut, sigmaRadians, direction, poleAxis) {
        const renderer = this._renderer;
        const blurMaterial = this._blurMaterial;
        if (direction !== 'latitudinal' && direction !== 'longitudinal') console.error('blur direction must be either latitudinal or longitudinal!');
        // Number of standard deviations at which to cut off the discrete approximation.
        const STANDARD_DEVIATIONS = 3;
        const blurMesh = new Mesh(_lodPlanes[lodOut], blurMaterial);
        const blurUniforms = blurMaterial.uniforms;
        const pixels = _sizeLods[lodIn] - 1;
        const radiansPerPixel = isFinite(sigmaRadians) ? Math.PI / (2 * pixels) : 2 * Math.PI / (2 * MAX_SAMPLES - 1);
        const sigmaPixels = sigmaRadians / radiansPerPixel;
        const samples = isFinite(sigmaRadians) ? 1 + Math.floor(STANDARD_DEVIATIONS * sigmaPixels) : MAX_SAMPLES;
        if (samples > MAX_SAMPLES) console.warn(`sigmaRadians, ${sigmaRadians}, is too large and will clip, as it requested ${samples} samples when the maximum is set to ${MAX_SAMPLES}`);
        const weights = [];
        let sum = 0;
        for(let i = 0; i < MAX_SAMPLES; ++i){
            const x = i / sigmaPixels;
            const weight = Math.exp(-x * x / 2);
            weights.push(weight);
            if (i == 0) sum += weight;
            else if (i < samples) sum += 2 * weight;
        }
        for(let i = 0; i < weights.length; i++)weights[i] = weights[i] / sum;
        blurUniforms['envMap'].value = targetIn.texture;
        blurUniforms['samples'].value = samples;
        blurUniforms['weights'].value = weights;
        blurUniforms['latitudinal'].value = direction === 'latitudinal';
        if (poleAxis) blurUniforms['poleAxis'].value = poleAxis;
        blurUniforms['dTheta'].value = radiansPerPixel;
        blurUniforms['mipInt'].value = LOD_MAX - lodIn;
        blurUniforms['inputEncoding'].value = ENCODINGS[targetIn.texture.encoding];
        blurUniforms['outputEncoding'].value = ENCODINGS[targetIn.texture.encoding];
        const outputSize = _sizeLods[lodOut];
        const x = 3 * Math.max(0, SIZE_MAX - 2 * outputSize);
        const y = (lodOut === 0 ? 0 : 2 * SIZE_MAX) + 2 * outputSize * (lodOut > LOD_MAX - LOD_MIN ? lodOut - LOD_MAX + LOD_MIN : 0);
        _setViewport(targetOut, x, y, 3 * outputSize, 2 * outputSize);
        renderer.setRenderTarget(targetOut);
        renderer.render(blurMesh, _flatCamera);
    }
}
function _isLDR(texture) {
    if (texture === undefined || texture.type !== UnsignedByteType) return false;
    return texture.encoding === LinearEncoding || texture.encoding === sRGBEncoding || texture.encoding === GammaEncoding;
}
function _createPlanes() {
    const _lodPlanes = [];
    const _sizeLods = [];
    const _sigmas = [];
    let lod = LOD_MAX;
    for(let i = 0; i < TOTAL_LODS; i++){
        const sizeLod = Math.pow(2, lod);
        _sizeLods.push(sizeLod);
        let sigma = 1.0 / sizeLod;
        if (i > LOD_MAX - LOD_MIN) sigma = EXTRA_LOD_SIGMA[i - LOD_MAX + LOD_MIN - 1];
        else if (i == 0) sigma = 0;
        _sigmas.push(sigma);
        const texelSize = 1.0 / (sizeLod - 1);
        const min = -texelSize / 2;
        const max = 1 + texelSize / 2;
        const uv1 = [
            min,
            min,
            max,
            min,
            max,
            max,
            min,
            min,
            max,
            max,
            min,
            max
        ];
        const cubeFaces = 6;
        const vertices = 6;
        const positionSize = 3;
        const uvSize = 2;
        const faceIndexSize = 1;
        const position = new Float32Array(positionSize * vertices * cubeFaces);
        const uv = new Float32Array(uvSize * vertices * cubeFaces);
        const faceIndex = new Float32Array(faceIndexSize * vertices * cubeFaces);
        for(let face = 0; face < cubeFaces; face++){
            const x = face % 3 * 2 / 3 - 1;
            const y = face > 2 ? 0 : -1;
            const coordinates = [
                x,
                y,
                0,
                x + 2 / 3,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y,
                0,
                x + 2 / 3,
                y + 1,
                0,
                x,
                y + 1,
                0
            ];
            position.set(coordinates, positionSize * vertices * face);
            uv.set(uv1, uvSize * vertices * face);
            const fill = [
                face,
                face,
                face,
                face,
                face,
                face
            ];
            faceIndex.set(fill, faceIndexSize * vertices * face);
        }
        const planes = new BufferGeometry();
        planes.setAttribute('position', new BufferAttribute(position, positionSize));
        planes.setAttribute('uv', new BufferAttribute(uv, uvSize));
        planes.setAttribute('faceIndex', new BufferAttribute(faceIndex, faceIndexSize));
        _lodPlanes.push(planes);
        if (lod > LOD_MIN) lod--;
    }
    return {
        _lodPlanes: _lodPlanes,
        _sizeLods: _sizeLods,
        _sigmas: _sigmas
    };
}
function _createRenderTarget(params) {
    const cubeUVRenderTarget = new WebGLRenderTarget(3 * SIZE_MAX, 3 * SIZE_MAX, params);
    cubeUVRenderTarget.texture.mapping = CubeUVReflectionMapping;
    cubeUVRenderTarget.texture.name = 'PMREM.cubeUv';
    cubeUVRenderTarget.scissorTest = true;
    return cubeUVRenderTarget;
}
function _setViewport(target, x, y, width, height) {
    target.viewport.set(x, y, width, height);
    target.scissor.set(x, y, width, height);
}
function _getBlurShader(maxSamples) {
    const weights = new Float32Array(maxSamples);
    const poleAxis = new Vector3(0, 1, 0);
    const shaderMaterial = new RawShaderMaterial({
        name: 'SphericalGaussianBlur',
        defines: {
            'n': maxSamples
        },
        uniforms: {
            'envMap': {
                value: null
            },
            'samples': {
                value: 1
            },
            'weights': {
                value: weights
            },
            'latitudinal': {
                value: false
            },
            'dTheta': {
                value: 0
            },
            'mipInt': {
                value: 0
            },
            'poleAxis': {
                value: poleAxis
            },
            'inputEncoding': {
                value: ENCODINGS[LinearEncoding]
            },
            'outputEncoding': {
                value: ENCODINGS[LinearEncoding]
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform int samples;
			uniform float weights[ n ];
			uniform bool latitudinal;
			uniform float dTheta;
			uniform float mipInt;
			uniform vec3 poleAxis;

			${_getEncodings()}

			#define ENVMAP_TYPE_CUBE_UV
			#include <cube_uv_reflection_fragment>

			vec3 getSample( float theta, vec3 axis ) {

				float cosTheta = cos( theta );
				// Rodrigues' axis-angle rotation
				vec3 sampleDirection = vOutputDirection * cosTheta
					+ cross( axis, vOutputDirection ) * sin( theta )
					+ axis * dot( axis, vOutputDirection ) * ( 1.0 - cosTheta );

				return bilinearCubeUV( envMap, sampleDirection, mipInt );

			}

			void main() {

				vec3 axis = latitudinal ? poleAxis : cross( poleAxis, vOutputDirection );

				if ( all( equal( axis, vec3( 0.0 ) ) ) ) {

					axis = vec3( vOutputDirection.z, 0.0, - vOutputDirection.x );

				}

				axis = normalize( axis );

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb += weights[ 0 ] * getSample( 0.0, axis );

				for ( int i = 1; i < n; i++ ) {

					if ( i >= samples ) {

						break;

					}

					float theta = dTheta * float( i );
					gl_FragColor.rgb += weights[ i ] * getSample( -1.0 * theta, axis );
					gl_FragColor.rgb += weights[ i ] * getSample( theta, axis );

				}

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: NoBlending,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function _getEquirectShader() {
    const texelSize = new Vector2(1, 1);
    const shaderMaterial = new RawShaderMaterial({
        name: 'EquirectangularToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'texelSize': {
                value: texelSize
            },
            'inputEncoding': {
                value: ENCODINGS[LinearEncoding]
            },
            'outputEncoding': {
                value: ENCODINGS[LinearEncoding]
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform sampler2D envMap;
			uniform vec2 texelSize;

			${_getEncodings()}

			#include <common>

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );

				vec3 outputDirection = normalize( vOutputDirection );
				vec2 uv = equirectUv( outputDirection );

				vec2 f = fract( uv / texelSize - 0.5 );
				uv -= f * texelSize;
				vec3 tl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x += texelSize.x;
				vec3 tr = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.y += texelSize.y;
				vec3 br = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;
				uv.x -= texelSize.x;
				vec3 bl = envMapTexelToLinear( texture2D ( envMap, uv ) ).rgb;

				vec3 tm = mix( tl, tr, f.x );
				vec3 bm = mix( bl, br, f.x );
				gl_FragColor.rgb = mix( tm, bm, f.y );

				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: NoBlending,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function _getCubemapShader() {
    const shaderMaterial = new RawShaderMaterial({
        name: 'CubemapToCubeUV',
        uniforms: {
            'envMap': {
                value: null
            },
            'inputEncoding': {
                value: ENCODINGS[LinearEncoding]
            },
            'outputEncoding': {
                value: ENCODINGS[LinearEncoding]
            }
        },
        vertexShader: _getCommonVertexShader(),
        fragmentShader: /* glsl */ `

			precision mediump float;
			precision mediump int;

			varying vec3 vOutputDirection;

			uniform samplerCube envMap;

			${_getEncodings()}

			void main() {

				gl_FragColor = vec4( 0.0, 0.0, 0.0, 1.0 );
				gl_FragColor.rgb = envMapTexelToLinear( textureCube( envMap, vec3( - vOutputDirection.x, vOutputDirection.yz ) ) ).rgb;
				gl_FragColor = linearToOutputTexel( gl_FragColor );

			}
		`,
        blending: NoBlending,
        depthTest: false,
        depthWrite: false
    });
    return shaderMaterial;
}
function _getCommonVertexShader() {
    return /* glsl */ `

		precision mediump float;
		precision mediump int;

		attribute vec3 position;
		attribute vec2 uv;
		attribute float faceIndex;

		varying vec3 vOutputDirection;

		// RH coordinate system; PMREM face-indexing convention
		vec3 getDirection( vec2 uv, float face ) {

			uv = 2.0 * uv - 1.0;

			vec3 direction = vec3( uv, 1.0 );

			if ( face == 0.0 ) {

				direction = direction.zyx; // ( 1, v, u ) pos x

			} else if ( face == 1.0 ) {

				direction = direction.xzy;
				direction.xz *= -1.0; // ( -u, 1, -v ) pos y

			} else if ( face == 2.0 ) {

				direction.x *= -1.0; // ( -u, v, 1 ) pos z

			} else if ( face == 3.0 ) {

				direction = direction.zyx;
				direction.xz *= -1.0; // ( -1, v, -u ) neg x

			} else if ( face == 4.0 ) {

				direction = direction.xzy;
				direction.xy *= -1.0; // ( -u, -1, v ) neg y

			} else if ( face == 5.0 ) {

				direction.z *= -1.0; // ( u, v, -1 ) neg z

			}

			return direction;

		}

		void main() {

			vOutputDirection = getDirection( uv, faceIndex );
			gl_Position = vec4( position, 1.0 );

		}
	`;
}
function _getEncodings() {
    return /* glsl */ `

		uniform int inputEncoding;
		uniform int outputEncoding;

		#include <encodings_pars_fragment>

		vec4 inputTexelToLinear( vec4 value ) {

			if ( inputEncoding == 0 ) {

				return value;

			} else if ( inputEncoding == 1 ) {

				return sRGBToLinear( value );

			} else if ( inputEncoding == 2 ) {

				return RGBEToLinear( value );

			} else if ( inputEncoding == 3 ) {

				return RGBMToLinear( value, 7.0 );

			} else if ( inputEncoding == 4 ) {

				return RGBMToLinear( value, 16.0 );

			} else if ( inputEncoding == 5 ) {

				return RGBDToLinear( value, 256.0 );

			} else {

				return GammaToLinear( value, 2.2 );

			}

		}

		vec4 linearToOutputTexel( vec4 value ) {

			if ( outputEncoding == 0 ) {

				return value;

			} else if ( outputEncoding == 1 ) {

				return LinearTosRGB( value );

			} else if ( outputEncoding == 2 ) {

				return LinearToRGBE( value );

			} else if ( outputEncoding == 3 ) {

				return LinearToRGBM( value, 7.0 );

			} else if ( outputEncoding == 4 ) {

				return LinearToRGBM( value, 16.0 );

			} else if ( outputEncoding == 5 ) {

				return LinearToRGBD( value, 256.0 );

			} else {

				return LinearToGamma( value, 2.2 );

			}

		}

		vec4 envMapTexelToLinear( vec4 color ) {

			return inputTexelToLinear( color );

		}
	`;
}
function Face4(a, b, c, d, normal, color, materialIndex) {
    console.warn('THREE.Face4 has been removed. A THREE.Face3 will be created instead.');
    return new Face3(a, b, c, normal, color, materialIndex);
}
const LineStrip = 0;
const LinePieces = 1;
const NoColors = 0;
const FaceColors = 1;
const VertexColors = 2;
function MeshFaceMaterial(materials) {
    console.warn('THREE.MeshFaceMaterial has been removed. Use an Array instead.');
    return materials;
}
function MultiMaterial(materials = []) {
    console.warn('THREE.MultiMaterial has been removed. Use an Array instead.');
    materials.isMultiMaterial = true;
    materials.materials = materials;
    materials.clone = function() {
        return materials.slice();
    };
    return materials;
}
function PointCloud(geometry, material) {
    console.warn('THREE.PointCloud has been renamed to THREE.Points.');
    return new Points(geometry, material);
}
function Particle(material) {
    console.warn('THREE.Particle has been renamed to THREE.Sprite.');
    return new Sprite(material);
}
function ParticleSystem(geometry, material) {
    console.warn('THREE.ParticleSystem has been renamed to THREE.Points.');
    return new Points(geometry, material);
}
function PointCloudMaterial(parameters) {
    console.warn('THREE.PointCloudMaterial has been renamed to THREE.PointsMaterial.');
    return new PointsMaterial(parameters);
}
function ParticleBasicMaterial(parameters) {
    console.warn('THREE.ParticleBasicMaterial has been renamed to THREE.PointsMaterial.');
    return new PointsMaterial(parameters);
}
function ParticleSystemMaterial(parameters) {
    console.warn('THREE.ParticleSystemMaterial has been renamed to THREE.PointsMaterial.');
    return new PointsMaterial(parameters);
}
function Vertex(x, y, z) {
    console.warn('THREE.Vertex has been removed. Use THREE.Vector3 instead.');
    return new Vector3(x, y, z);
}
//
function DynamicBufferAttribute(array, itemSize) {
    console.warn('THREE.DynamicBufferAttribute has been removed. Use new THREE.BufferAttribute().setUsage( THREE.DynamicDrawUsage ) instead.');
    return new BufferAttribute(array, itemSize).setUsage(DynamicDrawUsage);
}
function Int8Attribute(array, itemSize) {
    console.warn('THREE.Int8Attribute has been removed. Use new THREE.Int8BufferAttribute() instead.');
    return new Int8BufferAttribute(array, itemSize);
}
function Uint8Attribute(array, itemSize) {
    console.warn('THREE.Uint8Attribute has been removed. Use new THREE.Uint8BufferAttribute() instead.');
    return new Uint8BufferAttribute(array, itemSize);
}
function Uint8ClampedAttribute(array, itemSize) {
    console.warn('THREE.Uint8ClampedAttribute has been removed. Use new THREE.Uint8ClampedBufferAttribute() instead.');
    return new Uint8ClampedBufferAttribute(array, itemSize);
}
function Int16Attribute(array, itemSize) {
    console.warn('THREE.Int16Attribute has been removed. Use new THREE.Int16BufferAttribute() instead.');
    return new Int16BufferAttribute(array, itemSize);
}
function Uint16Attribute(array, itemSize) {
    console.warn('THREE.Uint16Attribute has been removed. Use new THREE.Uint16BufferAttribute() instead.');
    return new Uint16BufferAttribute(array, itemSize);
}
function Int32Attribute(array, itemSize) {
    console.warn('THREE.Int32Attribute has been removed. Use new THREE.Int32BufferAttribute() instead.');
    return new Int32BufferAttribute(array, itemSize);
}
function Uint32Attribute(array, itemSize) {
    console.warn('THREE.Uint32Attribute has been removed. Use new THREE.Uint32BufferAttribute() instead.');
    return new Uint32BufferAttribute(array, itemSize);
}
function Float32Attribute(array, itemSize) {
    console.warn('THREE.Float32Attribute has been removed. Use new THREE.Float32BufferAttribute() instead.');
    return new Float32BufferAttribute(array, itemSize);
}
function Float64Attribute(array, itemSize) {
    console.warn('THREE.Float64Attribute has been removed. Use new THREE.Float64BufferAttribute() instead.');
    return new Float64BufferAttribute(array, itemSize);
}
//
Curve.create = function(construct, getPoint) {
    console.log('THREE.Curve.create() has been deprecated');
    construct.prototype = Object.create(Curve.prototype);
    construct.prototype.constructor = construct;
    construct.prototype.getPoint = getPoint;
    return construct;
};
//
Object.assign(Path.prototype, {
    fromPoints: function(points) {
        console.warn('THREE.Path: .fromPoints() has been renamed to .setFromPoints().');
        return this.setFromPoints(points);
    }
});
//
function ClosedSplineCurve3(points) {
    console.warn('THREE.ClosedSplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.');
    CatmullRomCurve3.call(this, points);
    this.type = 'catmullrom';
    this.closed = true;
}
ClosedSplineCurve3.prototype = Object.create(CatmullRomCurve3.prototype);
//
function SplineCurve3(points) {
    console.warn('THREE.SplineCurve3 has been deprecated. Use THREE.CatmullRomCurve3 instead.');
    CatmullRomCurve3.call(this, points);
    this.type = 'catmullrom';
}
SplineCurve3.prototype = Object.create(CatmullRomCurve3.prototype);
//
function Spline(points) {
    console.warn('THREE.Spline has been removed. Use THREE.CatmullRomCurve3 instead.');
    CatmullRomCurve3.call(this, points);
    this.type = 'catmullrom';
}
Spline.prototype = Object.create(CatmullRomCurve3.prototype);
Object.assign(Spline.prototype, {
    initFromArray: function() {
        console.error('THREE.Spline: .initFromArray() has been removed.');
    },
    getControlPointsArray: function() {
        console.error('THREE.Spline: .getControlPointsArray() has been removed.');
    },
    reparametrizeByArcLength: function() {
        console.error('THREE.Spline: .reparametrizeByArcLength() has been removed.');
    }
});
//
function AxisHelper(size) {
    console.warn('THREE.AxisHelper has been renamed to THREE.AxesHelper.');
    return new AxesHelper(size);
}
function BoundingBoxHelper(object, color) {
    console.warn('THREE.BoundingBoxHelper has been deprecated. Creating a THREE.BoxHelper instead.');
    return new BoxHelper(object, color);
}
function EdgesHelper(object, hex) {
    console.warn('THREE.EdgesHelper has been removed. Use THREE.EdgesGeometry instead.');
    return new LineSegments(new EdgesGeometry(object.geometry), new LineBasicMaterial({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
GridHelper.prototype.setColors = function() {
    console.error('THREE.GridHelper: setColors() has been deprecated, pass them in the constructor instead.');
};
SkeletonHelper.prototype.update = function() {
    console.error('THREE.SkeletonHelper: update() no longer needs to be called.');
};
function WireframeHelper(object, hex) {
    console.warn('THREE.WireframeHelper has been removed. Use THREE.WireframeGeometry instead.');
    return new LineSegments(new WireframeGeometry(object.geometry), new LineBasicMaterial({
        color: hex !== undefined ? hex : 0xffffff
    }));
}
//
Object.assign(Loader.prototype, {
    extractUrlBase: function(url) {
        console.warn('THREE.Loader: .extractUrlBase() has been deprecated. Use THREE.LoaderUtils.extractUrlBase() instead.');
        return LoaderUtils.extractUrlBase(url);
    }
});
Loader.Handlers = {
    add: function() {
        console.error('THREE.Loader: Handlers.add() has been removed. Use LoadingManager.addHandler() instead.');
    },
    get: function() {
        console.error('THREE.Loader: Handlers.get() has been removed. Use LoadingManager.getHandler() instead.');
    }
};
function XHRLoader(manager) {
    console.warn('THREE.XHRLoader has been renamed to THREE.FileLoader.');
    return new FileLoader(manager);
}
function BinaryTextureLoader(manager) {
    console.warn('THREE.BinaryTextureLoader has been renamed to THREE.DataTextureLoader.');
    return new DataTextureLoader(manager);
}
//
Object.assign(Box2.prototype, {
    center: function(optionalTarget) {
        console.warn('THREE.Box2: .center() has been renamed to .getCenter().');
        return this.getCenter(optionalTarget);
    },
    empty: function() {
        console.warn('THREE.Box2: .empty() has been renamed to .isEmpty().');
        return this.isEmpty();
    },
    isIntersectionBox: function(box) {
        console.warn('THREE.Box2: .isIntersectionBox() has been renamed to .intersectsBox().');
        return this.intersectsBox(box);
    },
    size: function(optionalTarget) {
        console.warn('THREE.Box2: .size() has been renamed to .getSize().');
        return this.getSize(optionalTarget);
    }
});
Object.assign(Box3.prototype, {
    center: function(optionalTarget) {
        console.warn('THREE.Box3: .center() has been renamed to .getCenter().');
        return this.getCenter(optionalTarget);
    },
    empty: function() {
        console.warn('THREE.Box3: .empty() has been renamed to .isEmpty().');
        return this.isEmpty();
    },
    isIntersectionBox: function(box) {
        console.warn('THREE.Box3: .isIntersectionBox() has been renamed to .intersectsBox().');
        return this.intersectsBox(box);
    },
    isIntersectionSphere: function(sphere) {
        console.warn('THREE.Box3: .isIntersectionSphere() has been renamed to .intersectsSphere().');
        return this.intersectsSphere(sphere);
    },
    size: function(optionalTarget) {
        console.warn('THREE.Box3: .size() has been renamed to .getSize().');
        return this.getSize(optionalTarget);
    }
});
Object.assign(Sphere.prototype, {
    empty: function() {
        console.warn('THREE.Sphere: .empty() has been renamed to .isEmpty().');
        return this.isEmpty();
    }
});
Frustum.prototype.setFromMatrix = function(m) {
    console.warn('THREE.Frustum: .setFromMatrix() has been renamed to .setFromProjectionMatrix().');
    return this.setFromProjectionMatrix(m);
};
Line3.prototype.center = function(optionalTarget) {
    console.warn('THREE.Line3: .center() has been renamed to .getCenter().');
    return this.getCenter(optionalTarget);
};
Object.assign(MathUtils, {
    random16: function() {
        console.warn('THREE.Math: .random16() has been deprecated. Use Math.random() instead.');
        return Math.random();
    },
    nearestPowerOfTwo: function(value) {
        console.warn('THREE.Math: .nearestPowerOfTwo() has been renamed to .floorPowerOfTwo().');
        return MathUtils.floorPowerOfTwo(value);
    },
    nextPowerOfTwo: function(value) {
        console.warn('THREE.Math: .nextPowerOfTwo() has been renamed to .ceilPowerOfTwo().');
        return MathUtils.ceilPowerOfTwo(value);
    }
});
Object.assign(Matrix3.prototype, {
    flattenToArrayOffset: function(array, offset) {
        console.warn('THREE.Matrix3: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
        return this.toArray(array, offset);
    },
    multiplyVector3: function(vector) {
        console.warn('THREE.Matrix3: .multiplyVector3() has been removed. Use vector.applyMatrix3( matrix ) instead.');
        return vector.applyMatrix3(this);
    },
    multiplyVector3Array: function() {
        console.error('THREE.Matrix3: .multiplyVector3Array() has been removed.');
    },
    applyToBufferAttribute: function(attribute) {
        console.warn('THREE.Matrix3: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix3( matrix ) instead.');
        return attribute.applyMatrix3(this);
    },
    applyToVector3Array: function() {
        console.error('THREE.Matrix3: .applyToVector3Array() has been removed.');
    },
    getInverse: function(matrix) {
        console.warn('THREE.Matrix3: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
        return this.copy(matrix).invert();
    }
});
Object.assign(Matrix4.prototype, {
    extractPosition: function(m) {
        console.warn('THREE.Matrix4: .extractPosition() has been renamed to .copyPosition().');
        return this.copyPosition(m);
    },
    flattenToArrayOffset: function(array, offset) {
        console.warn('THREE.Matrix4: .flattenToArrayOffset() has been deprecated. Use .toArray() instead.');
        return this.toArray(array, offset);
    },
    getPosition: function() {
        console.warn('THREE.Matrix4: .getPosition() has been removed. Use Vector3.setFromMatrixPosition( matrix ) instead.');
        return new Vector3().setFromMatrixColumn(this, 3);
    },
    setRotationFromQuaternion: function(q) {
        console.warn('THREE.Matrix4: .setRotationFromQuaternion() has been renamed to .makeRotationFromQuaternion().');
        return this.makeRotationFromQuaternion(q);
    },
    multiplyToArray: function() {
        console.warn('THREE.Matrix4: .multiplyToArray() has been removed.');
    },
    multiplyVector3: function(vector) {
        console.warn('THREE.Matrix4: .multiplyVector3() has been removed. Use vector.applyMatrix4( matrix ) instead.');
        return vector.applyMatrix4(this);
    },
    multiplyVector4: function(vector) {
        console.warn('THREE.Matrix4: .multiplyVector4() has been removed. Use vector.applyMatrix4( matrix ) instead.');
        return vector.applyMatrix4(this);
    },
    multiplyVector3Array: function() {
        console.error('THREE.Matrix4: .multiplyVector3Array() has been removed.');
    },
    rotateAxis: function(v) {
        console.warn('THREE.Matrix4: .rotateAxis() has been removed. Use Vector3.transformDirection( matrix ) instead.');
        v.transformDirection(this);
    },
    crossVector: function(vector) {
        console.warn('THREE.Matrix4: .crossVector() has been removed. Use vector.applyMatrix4( matrix ) instead.');
        return vector.applyMatrix4(this);
    },
    translate: function() {
        console.error('THREE.Matrix4: .translate() has been removed.');
    },
    rotateX: function() {
        console.error('THREE.Matrix4: .rotateX() has been removed.');
    },
    rotateY: function() {
        console.error('THREE.Matrix4: .rotateY() has been removed.');
    },
    rotateZ: function() {
        console.error('THREE.Matrix4: .rotateZ() has been removed.');
    },
    rotateByAxis: function() {
        console.error('THREE.Matrix4: .rotateByAxis() has been removed.');
    },
    applyToBufferAttribute: function(attribute) {
        console.warn('THREE.Matrix4: .applyToBufferAttribute() has been removed. Use attribute.applyMatrix4( matrix ) instead.');
        return attribute.applyMatrix4(this);
    },
    applyToVector3Array: function() {
        console.error('THREE.Matrix4: .applyToVector3Array() has been removed.');
    },
    makeFrustum: function(left, right, bottom, top, near, far) {
        console.warn('THREE.Matrix4: .makeFrustum() has been removed. Use .makePerspective( left, right, top, bottom, near, far ) instead.');
        return this.makePerspective(left, right, top, bottom, near, far);
    },
    getInverse: function(matrix) {
        console.warn('THREE.Matrix4: .getInverse() has been removed. Use matrixInv.copy( matrix ).invert(); instead.');
        return this.copy(matrix).invert();
    }
});
Plane.prototype.isIntersectionLine = function(line) {
    console.warn('THREE.Plane: .isIntersectionLine() has been renamed to .intersectsLine().');
    return this.intersectsLine(line);
};
Object.assign(Quaternion.prototype, {
    multiplyVector3: function(vector) {
        console.warn('THREE.Quaternion: .multiplyVector3() has been removed. Use is now vector.applyQuaternion( quaternion ) instead.');
        return vector.applyQuaternion(this);
    },
    inverse: function() {
        console.warn('THREE.Quaternion: .inverse() has been renamed to invert().');
        return this.invert();
    }
});
Object.assign(Ray.prototype, {
    isIntersectionBox: function(box) {
        console.warn('THREE.Ray: .isIntersectionBox() has been renamed to .intersectsBox().');
        return this.intersectsBox(box);
    },
    isIntersectionPlane: function(plane) {
        console.warn('THREE.Ray: .isIntersectionPlane() has been renamed to .intersectsPlane().');
        return this.intersectsPlane(plane);
    },
    isIntersectionSphere: function(sphere) {
        console.warn('THREE.Ray: .isIntersectionSphere() has been renamed to .intersectsSphere().');
        return this.intersectsSphere(sphere);
    }
});
Object.assign(Triangle.prototype, {
    area: function() {
        console.warn('THREE.Triangle: .area() has been renamed to .getArea().');
        return this.getArea();
    },
    barycoordFromPoint: function(point, target) {
        console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
        return this.getBarycoord(point, target);
    },
    midpoint: function(target) {
        console.warn('THREE.Triangle: .midpoint() has been renamed to .getMidpoint().');
        return this.getMidpoint(target);
    },
    normal: function(target) {
        console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
        return this.getNormal(target);
    },
    plane: function(target) {
        console.warn('THREE.Triangle: .plane() has been renamed to .getPlane().');
        return this.getPlane(target);
    }
});
Object.assign(Triangle, {
    barycoordFromPoint: function(point, a, b, c, target) {
        console.warn('THREE.Triangle: .barycoordFromPoint() has been renamed to .getBarycoord().');
        return Triangle.getBarycoord(point, a, b, c, target);
    },
    normal: function(a, b, c, target) {
        console.warn('THREE.Triangle: .normal() has been renamed to .getNormal().');
        return Triangle.getNormal(a, b, c, target);
    }
});
Object.assign(Shape.prototype, {
    extractAllPoints: function(divisions) {
        console.warn('THREE.Shape: .extractAllPoints() has been removed. Use .extractPoints() instead.');
        return this.extractPoints(divisions);
    },
    extrude: function(options) {
        console.warn('THREE.Shape: .extrude() has been removed. Use ExtrudeGeometry() instead.');
        return new ExtrudeGeometry(this, options);
    },
    makeGeometry: function(options) {
        console.warn('THREE.Shape: .makeGeometry() has been removed. Use ShapeGeometry() instead.');
        return new ShapeGeometry(this, options);
    }
});
Object.assign(Vector2.prototype, {
    fromAttribute: function(attribute, index, offset) {
        console.warn('THREE.Vector2: .fromAttribute() has been renamed to .fromBufferAttribute().');
        return this.fromBufferAttribute(attribute, index, offset);
    },
    distanceToManhattan: function(v) {
        console.warn('THREE.Vector2: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
        return this.manhattanDistanceTo(v);
    },
    lengthManhattan: function() {
        console.warn('THREE.Vector2: .lengthManhattan() has been renamed to .manhattanLength().');
        return this.manhattanLength();
    }
});
Object.assign(Vector3.prototype, {
    setEulerFromRotationMatrix: function() {
        console.error('THREE.Vector3: .setEulerFromRotationMatrix() has been removed. Use Euler.setFromRotationMatrix() instead.');
    },
    setEulerFromQuaternion: function() {
        console.error('THREE.Vector3: .setEulerFromQuaternion() has been removed. Use Euler.setFromQuaternion() instead.');
    },
    getPositionFromMatrix: function(m) {
        console.warn('THREE.Vector3: .getPositionFromMatrix() has been renamed to .setFromMatrixPosition().');
        return this.setFromMatrixPosition(m);
    },
    getScaleFromMatrix: function(m) {
        console.warn('THREE.Vector3: .getScaleFromMatrix() has been renamed to .setFromMatrixScale().');
        return this.setFromMatrixScale(m);
    },
    getColumnFromMatrix: function(index, matrix) {
        console.warn('THREE.Vector3: .getColumnFromMatrix() has been renamed to .setFromMatrixColumn().');
        return this.setFromMatrixColumn(matrix, index);
    },
    applyProjection: function(m) {
        console.warn('THREE.Vector3: .applyProjection() has been removed. Use .applyMatrix4( m ) instead.');
        return this.applyMatrix4(m);
    },
    fromAttribute: function(attribute, index, offset) {
        console.warn('THREE.Vector3: .fromAttribute() has been renamed to .fromBufferAttribute().');
        return this.fromBufferAttribute(attribute, index, offset);
    },
    distanceToManhattan: function(v) {
        console.warn('THREE.Vector3: .distanceToManhattan() has been renamed to .manhattanDistanceTo().');
        return this.manhattanDistanceTo(v);
    },
    lengthManhattan: function() {
        console.warn('THREE.Vector3: .lengthManhattan() has been renamed to .manhattanLength().');
        return this.manhattanLength();
    }
});
Object.assign(Vector4.prototype, {
    fromAttribute: function(attribute, index, offset) {
        console.warn('THREE.Vector4: .fromAttribute() has been renamed to .fromBufferAttribute().');
        return this.fromBufferAttribute(attribute, index, offset);
    },
    lengthManhattan: function() {
        console.warn('THREE.Vector4: .lengthManhattan() has been renamed to .manhattanLength().');
        return this.manhattanLength();
    }
});
//
Object.assign(Object3D.prototype, {
    getChildByName: function(name) {
        console.warn('THREE.Object3D: .getChildByName() has been renamed to .getObjectByName().');
        return this.getObjectByName(name);
    },
    renderDepth: function() {
        console.warn('THREE.Object3D: .renderDepth has been removed. Use .renderOrder, instead.');
    },
    translate: function(distance, axis) {
        console.warn('THREE.Object3D: .translate() has been removed. Use .translateOnAxis( axis, distance ) instead.');
        return this.translateOnAxis(axis, distance);
    },
    getWorldRotation: function() {
        console.error('THREE.Object3D: .getWorldRotation() has been removed. Use THREE.Object3D.getWorldQuaternion( target ) instead.');
    },
    applyMatrix: function(matrix) {
        console.warn('THREE.Object3D: .applyMatrix() has been renamed to .applyMatrix4().');
        return this.applyMatrix4(matrix);
    }
});
Object.defineProperties(Object3D.prototype, {
    eulerOrder: {
        get: function() {
            console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
            return this.rotation.order;
        },
        set: function(value) {
            console.warn('THREE.Object3D: .eulerOrder is now .rotation.order.');
            this.rotation.order = value;
        }
    },
    useQuaternion: {
        get: function() {
            console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
        },
        set: function() {
            console.warn('THREE.Object3D: .useQuaternion has been removed. The library now uses quaternions by default.');
        }
    }
});
Object.assign(Mesh.prototype, {
    setDrawMode: function() {
        console.error('THREE.Mesh: .setDrawMode() has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
    }
});
Object.defineProperties(Mesh.prototype, {
    drawMode: {
        get: function() {
            console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode.');
            return TrianglesDrawMode;
        },
        set: function() {
            console.error('THREE.Mesh: .drawMode has been removed. The renderer now always assumes THREE.TrianglesDrawMode. Transform your geometry via BufferGeometryUtils.toTrianglesDrawMode() if necessary.');
        }
    }
});
Object.defineProperties(LOD.prototype, {
    objects: {
        get: function() {
            console.warn('THREE.LOD: .objects has been renamed to .levels.');
            return this.levels;
        }
    }
});
Object.defineProperty(Skeleton.prototype, 'useVertexTexture', {
    get: function() {
        console.warn('THREE.Skeleton: useVertexTexture has been removed.');
    },
    set: function() {
        console.warn('THREE.Skeleton: useVertexTexture has been removed.');
    }
});
SkinnedMesh.prototype.initBones = function() {
    console.error('THREE.SkinnedMesh: initBones() has been removed.');
};
Object.defineProperty(Curve.prototype, '__arcLengthDivisions', {
    get: function() {
        console.warn('THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.');
        return this.arcLengthDivisions;
    },
    set: function(value) {
        console.warn('THREE.Curve: .__arcLengthDivisions is now .arcLengthDivisions.');
        this.arcLengthDivisions = value;
    }
});
//
PerspectiveCamera.prototype.setLens = function(focalLength, filmGauge) {
    console.warn("THREE.PerspectiveCamera.setLens is deprecated. Use .setFocalLength and .filmGauge for a photographic setup.");
    if (filmGauge !== undefined) this.filmGauge = filmGauge;
    this.setFocalLength(focalLength);
};
//
Object.defineProperties(Light.prototype, {
    onlyShadow: {
        set: function() {
            console.warn('THREE.Light: .onlyShadow has been removed.');
        }
    },
    shadowCameraFov: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraFov is now .shadow.camera.fov.');
            this.shadow.camera.fov = value;
        }
    },
    shadowCameraLeft: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraLeft is now .shadow.camera.left.');
            this.shadow.camera.left = value;
        }
    },
    shadowCameraRight: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraRight is now .shadow.camera.right.');
            this.shadow.camera.right = value;
        }
    },
    shadowCameraTop: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraTop is now .shadow.camera.top.');
            this.shadow.camera.top = value;
        }
    },
    shadowCameraBottom: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraBottom is now .shadow.camera.bottom.');
            this.shadow.camera.bottom = value;
        }
    },
    shadowCameraNear: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraNear is now .shadow.camera.near.');
            this.shadow.camera.near = value;
        }
    },
    shadowCameraFar: {
        set: function(value) {
            console.warn('THREE.Light: .shadowCameraFar is now .shadow.camera.far.');
            this.shadow.camera.far = value;
        }
    },
    shadowCameraVisible: {
        set: function() {
            console.warn('THREE.Light: .shadowCameraVisible has been removed. Use new THREE.CameraHelper( light.shadow.camera ) instead.');
        }
    },
    shadowBias: {
        set: function(value) {
            console.warn('THREE.Light: .shadowBias is now .shadow.bias.');
            this.shadow.bias = value;
        }
    },
    shadowDarkness: {
        set: function() {
            console.warn('THREE.Light: .shadowDarkness has been removed.');
        }
    },
    shadowMapWidth: {
        set: function(value) {
            console.warn('THREE.Light: .shadowMapWidth is now .shadow.mapSize.width.');
            this.shadow.mapSize.width = value;
        }
    },
    shadowMapHeight: {
        set: function(value) {
            console.warn('THREE.Light: .shadowMapHeight is now .shadow.mapSize.height.');
            this.shadow.mapSize.height = value;
        }
    }
});
//
Object.defineProperties(BufferAttribute.prototype, {
    length: {
        get: function() {
            console.warn('THREE.BufferAttribute: .length has been deprecated. Use .count instead.');
            return this.array.length;
        }
    },
    dynamic: {
        get: function() {
            console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
            return this.usage === DynamicDrawUsage;
        },
        set: function() {
            console.warn('THREE.BufferAttribute: .dynamic has been deprecated. Use .usage instead.');
            this.setUsage(DynamicDrawUsage);
        }
    }
});
Object.assign(BufferAttribute.prototype, {
    setDynamic: function(value) {
        console.warn('THREE.BufferAttribute: .setDynamic() has been deprecated. Use .setUsage() instead.');
        this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
        return this;
    },
    copyIndicesArray: function() {
        console.error('THREE.BufferAttribute: .copyIndicesArray() has been removed.');
    },
    setArray: function() {
        console.error('THREE.BufferAttribute: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers');
    }
});
Object.assign(BufferGeometry.prototype, {
    addIndex: function(index) {
        console.warn('THREE.BufferGeometry: .addIndex() has been renamed to .setIndex().');
        this.setIndex(index);
    },
    addAttribute: function(name, attribute) {
        console.warn('THREE.BufferGeometry: .addAttribute() has been renamed to .setAttribute().');
        if (!(attribute && attribute.isBufferAttribute) && !(attribute && attribute.isInterleavedBufferAttribute)) {
            console.warn('THREE.BufferGeometry: .addAttribute() now expects ( name, attribute ).');
            return this.setAttribute(name, new BufferAttribute(arguments[1], arguments[2]));
        }
        if (name === 'index') {
            console.warn('THREE.BufferGeometry.addAttribute: Use .setIndex() for index attribute.');
            this.setIndex(attribute);
            return this;
        }
        return this.setAttribute(name, attribute);
    },
    addDrawCall: function(start, count, indexOffset) {
        if (indexOffset !== undefined) console.warn('THREE.BufferGeometry: .addDrawCall() no longer supports indexOffset.');
        console.warn('THREE.BufferGeometry: .addDrawCall() is now .addGroup().');
        this.addGroup(start, count);
    },
    clearDrawCalls: function() {
        console.warn('THREE.BufferGeometry: .clearDrawCalls() is now .clearGroups().');
        this.clearGroups();
    },
    computeOffsets: function() {
        console.warn('THREE.BufferGeometry: .computeOffsets() has been removed.');
    },
    removeAttribute: function(name) {
        console.warn('THREE.BufferGeometry: .removeAttribute() has been renamed to .deleteAttribute().');
        return this.deleteAttribute(name);
    },
    applyMatrix: function(matrix) {
        console.warn('THREE.BufferGeometry: .applyMatrix() has been renamed to .applyMatrix4().');
        return this.applyMatrix4(matrix);
    }
});
Object.defineProperties(BufferGeometry.prototype, {
    drawcalls: {
        get: function() {
            console.error('THREE.BufferGeometry: .drawcalls has been renamed to .groups.');
            return this.groups;
        }
    },
    offsets: {
        get: function() {
            console.warn('THREE.BufferGeometry: .offsets has been renamed to .groups.');
            return this.groups;
        }
    }
});
Object.defineProperties(InstancedBufferGeometry.prototype, {
    maxInstancedCount: {
        get: function() {
            console.warn('THREE.InstancedBufferGeometry: .maxInstancedCount has been renamed to .instanceCount.');
            return this.instanceCount;
        },
        set: function(value) {
            console.warn('THREE.InstancedBufferGeometry: .maxInstancedCount has been renamed to .instanceCount.');
            this.instanceCount = value;
        }
    }
});
Object.defineProperties(Raycaster.prototype, {
    linePrecision: {
        get: function() {
            console.warn('THREE.Raycaster: .linePrecision has been deprecated. Use .params.Line.threshold instead.');
            return this.params.Line.threshold;
        },
        set: function(value) {
            console.warn('THREE.Raycaster: .linePrecision has been deprecated. Use .params.Line.threshold instead.');
            this.params.Line.threshold = value;
        }
    }
});
Object.defineProperties(InterleavedBuffer.prototype, {
    dynamic: {
        get: function() {
            console.warn('THREE.InterleavedBuffer: .length has been deprecated. Use .usage instead.');
            return this.usage === DynamicDrawUsage;
        },
        set: function(value) {
            console.warn('THREE.InterleavedBuffer: .length has been deprecated. Use .usage instead.');
            this.setUsage(value);
        }
    }
});
Object.assign(InterleavedBuffer.prototype, {
    setDynamic: function(value) {
        console.warn('THREE.InterleavedBuffer: .setDynamic() has been deprecated. Use .setUsage() instead.');
        this.setUsage(value === true ? DynamicDrawUsage : StaticDrawUsage);
        return this;
    },
    setArray: function() {
        console.error('THREE.InterleavedBuffer: .setArray has been removed. Use BufferGeometry .setAttribute to replace/resize attribute buffers');
    }
});
//
Object.assign(ExtrudeGeometry.prototype, {
    getArrays: function() {
        console.error('THREE.ExtrudeGeometry: .getArrays() has been removed.');
    },
    addShapeList: function() {
        console.error('THREE.ExtrudeGeometry: .addShapeList() has been removed.');
    },
    addShape: function() {
        console.error('THREE.ExtrudeGeometry: .addShape() has been removed.');
    }
});
//
Object.assign(Scene.prototype, {
    dispose: function() {
        console.error('THREE.Scene: .dispose() has been removed.');
    }
});
//
Object.defineProperties(Uniform.prototype, {
    dynamic: {
        set: function() {
            console.warn('THREE.Uniform: .dynamic has been removed. Use object.onBeforeRender() instead.');
        }
    },
    onUpdate: {
        value: function() {
            console.warn('THREE.Uniform: .onUpdate() has been removed. Use object.onBeforeRender() instead.');
            return this;
        }
    }
});
//
Object.defineProperties(Material.prototype, {
    wrapAround: {
        get: function() {
            console.warn('THREE.Material: .wrapAround has been removed.');
        },
        set: function() {
            console.warn('THREE.Material: .wrapAround has been removed.');
        }
    },
    overdraw: {
        get: function() {
            console.warn('THREE.Material: .overdraw has been removed.');
        },
        set: function() {
            console.warn('THREE.Material: .overdraw has been removed.');
        }
    },
    wrapRGB: {
        get: function() {
            console.warn('THREE.Material: .wrapRGB has been removed.');
            return new Color();
        }
    },
    shading: {
        get: function() {
            console.error('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
        },
        set: function(value) {
            console.warn('THREE.' + this.type + ': .shading has been removed. Use the boolean .flatShading instead.');
            this.flatShading = value === FlatShading;
        }
    },
    stencilMask: {
        get: function() {
            console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
            return this.stencilFuncMask;
        },
        set: function(value) {
            console.warn('THREE.' + this.type + ': .stencilMask has been removed. Use .stencilFuncMask instead.');
            this.stencilFuncMask = value;
        }
    }
});
Object.defineProperties(MeshPhongMaterial.prototype, {
    metal: {
        get: function() {
            console.warn('THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead.');
            return false;
        },
        set: function() {
            console.warn('THREE.MeshPhongMaterial: .metal has been removed. Use THREE.MeshStandardMaterial instead');
        }
    }
});
Object.defineProperties(MeshPhysicalMaterial.prototype, {
    transparency: {
        get: function() {
            console.warn('THREE.MeshPhysicalMaterial: .transparency has been renamed to .transmission.');
            return this.transmission;
        },
        set: function(value) {
            console.warn('THREE.MeshPhysicalMaterial: .transparency has been renamed to .transmission.');
            this.transmission = value;
        }
    }
});
Object.defineProperties(ShaderMaterial.prototype, {
    derivatives: {
        get: function() {
            console.warn('THREE.ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
            return this.extensions.derivatives;
        },
        set: function(value) {
            console.warn('THREE. ShaderMaterial: .derivatives has been moved to .extensions.derivatives.');
            this.extensions.derivatives = value;
        }
    }
});
//
Object.assign(WebGLRenderer.prototype, {
    clearTarget: function(renderTarget, color, depth, stencil) {
        console.warn('THREE.WebGLRenderer: .clearTarget() has been deprecated. Use .setRenderTarget() and .clear() instead.');
        this.setRenderTarget(renderTarget);
        this.clear(color, depth, stencil);
    },
    animate: function(callback) {
        console.warn('THREE.WebGLRenderer: .animate() is now .setAnimationLoop().');
        this.setAnimationLoop(callback);
    },
    getCurrentRenderTarget: function() {
        console.warn('THREE.WebGLRenderer: .getCurrentRenderTarget() is now .getRenderTarget().');
        return this.getRenderTarget();
    },
    getMaxAnisotropy: function() {
        console.warn('THREE.WebGLRenderer: .getMaxAnisotropy() is now .capabilities.getMaxAnisotropy().');
        return this.capabilities.getMaxAnisotropy();
    },
    getPrecision: function() {
        console.warn('THREE.WebGLRenderer: .getPrecision() is now .capabilities.precision.');
        return this.capabilities.precision;
    },
    resetGLState: function() {
        console.warn('THREE.WebGLRenderer: .resetGLState() is now .state.reset().');
        return this.state.reset();
    },
    supportsFloatTextures: function() {
        console.warn('THREE.WebGLRenderer: .supportsFloatTextures() is now .extensions.get( \'OES_texture_float\' ).');
        return this.extensions.get('OES_texture_float');
    },
    supportsHalfFloatTextures: function() {
        console.warn('THREE.WebGLRenderer: .supportsHalfFloatTextures() is now .extensions.get( \'OES_texture_half_float\' ).');
        return this.extensions.get('OES_texture_half_float');
    },
    supportsStandardDerivatives: function() {
        console.warn('THREE.WebGLRenderer: .supportsStandardDerivatives() is now .extensions.get( \'OES_standard_derivatives\' ).');
        return this.extensions.get('OES_standard_derivatives');
    },
    supportsCompressedTextureS3TC: function() {
        console.warn('THREE.WebGLRenderer: .supportsCompressedTextureS3TC() is now .extensions.get( \'WEBGL_compressed_texture_s3tc\' ).');
        return this.extensions.get('WEBGL_compressed_texture_s3tc');
    },
    supportsCompressedTexturePVRTC: function() {
        console.warn('THREE.WebGLRenderer: .supportsCompressedTexturePVRTC() is now .extensions.get( \'WEBGL_compressed_texture_pvrtc\' ).');
        return this.extensions.get('WEBGL_compressed_texture_pvrtc');
    },
    supportsBlendMinMax: function() {
        console.warn('THREE.WebGLRenderer: .supportsBlendMinMax() is now .extensions.get( \'EXT_blend_minmax\' ).');
        return this.extensions.get('EXT_blend_minmax');
    },
    supportsVertexTextures: function() {
        console.warn('THREE.WebGLRenderer: .supportsVertexTextures() is now .capabilities.vertexTextures.');
        return this.capabilities.vertexTextures;
    },
    supportsInstancedArrays: function() {
        console.warn('THREE.WebGLRenderer: .supportsInstancedArrays() is now .extensions.get( \'ANGLE_instanced_arrays\' ).');
        return this.extensions.get('ANGLE_instanced_arrays');
    },
    enableScissorTest: function(boolean) {
        console.warn('THREE.WebGLRenderer: .enableScissorTest() is now .setScissorTest().');
        this.setScissorTest(boolean);
    },
    initMaterial: function() {
        console.warn('THREE.WebGLRenderer: .initMaterial() has been removed.');
    },
    addPrePlugin: function() {
        console.warn('THREE.WebGLRenderer: .addPrePlugin() has been removed.');
    },
    addPostPlugin: function() {
        console.warn('THREE.WebGLRenderer: .addPostPlugin() has been removed.');
    },
    updateShadowMap: function() {
        console.warn('THREE.WebGLRenderer: .updateShadowMap() has been removed.');
    },
    setFaceCulling: function() {
        console.warn('THREE.WebGLRenderer: .setFaceCulling() has been removed.');
    },
    allocTextureUnit: function() {
        console.warn('THREE.WebGLRenderer: .allocTextureUnit() has been removed.');
    },
    setTexture: function() {
        console.warn('THREE.WebGLRenderer: .setTexture() has been removed.');
    },
    setTexture2D: function() {
        console.warn('THREE.WebGLRenderer: .setTexture2D() has been removed.');
    },
    setTextureCube: function() {
        console.warn('THREE.WebGLRenderer: .setTextureCube() has been removed.');
    },
    getActiveMipMapLevel: function() {
        console.warn('THREE.WebGLRenderer: .getActiveMipMapLevel() is now .getActiveMipmapLevel().');
        return this.getActiveMipmapLevel();
    }
});
Object.defineProperties(WebGLRenderer.prototype, {
    shadowMapEnabled: {
        get: function() {
            return this.shadowMap.enabled;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderer: .shadowMapEnabled is now .shadowMap.enabled.');
            this.shadowMap.enabled = value;
        }
    },
    shadowMapType: {
        get: function() {
            return this.shadowMap.type;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderer: .shadowMapType is now .shadowMap.type.');
            this.shadowMap.type = value;
        }
    },
    shadowMapCullFace: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMapCullFace has been removed. Set Material.shadowSide instead.');
        }
    },
    context: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .context has been removed. Use .getContext() instead.');
            return this.getContext();
        }
    },
    vr: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .vr has been renamed to .xr');
            return this.xr;
        }
    },
    gammaInput: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
            return false;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .gammaInput has been removed. Set the encoding for textures via Texture.encoding instead.');
        }
    },
    gammaOutput: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
            return false;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderer: .gammaOutput has been removed. Set WebGLRenderer.outputEncoding instead.');
            this.outputEncoding = value === true ? sRGBEncoding : LinearEncoding;
        }
    },
    toneMappingWhitePoint: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
            return 1.0;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .toneMappingWhitePoint has been removed.');
        }
    }
});
Object.defineProperties(WebGLShadowMap.prototype, {
    cullFace: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.cullFace has been removed. Set Material.shadowSide instead.');
        }
    },
    renderReverseSided: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderReverseSided has been removed. Set Material.shadowSide instead.');
        }
    },
    renderSingleSided: {
        get: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
            return undefined;
        },
        set: function() {
            console.warn('THREE.WebGLRenderer: .shadowMap.renderSingleSided has been removed. Set Material.shadowSide instead.');
        }
    }
});
function WebGLRenderTargetCube(width, height, options) {
    console.warn('THREE.WebGLRenderTargetCube( width, height, options ) is now WebGLCubeRenderTarget( size, options ).');
    return new WebGLCubeRenderTarget(width, options);
}
//
Object.defineProperties(WebGLRenderTarget.prototype, {
    wrapS: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
            return this.texture.wrapS;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .wrapS is now .texture.wrapS.');
            this.texture.wrapS = value;
        }
    },
    wrapT: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
            return this.texture.wrapT;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .wrapT is now .texture.wrapT.');
            this.texture.wrapT = value;
        }
    },
    magFilter: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
            return this.texture.magFilter;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .magFilter is now .texture.magFilter.');
            this.texture.magFilter = value;
        }
    },
    minFilter: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
            return this.texture.minFilter;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .minFilter is now .texture.minFilter.');
            this.texture.minFilter = value;
        }
    },
    anisotropy: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
            return this.texture.anisotropy;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .anisotropy is now .texture.anisotropy.');
            this.texture.anisotropy = value;
        }
    },
    offset: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
            return this.texture.offset;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .offset is now .texture.offset.');
            this.texture.offset = value;
        }
    },
    repeat: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
            return this.texture.repeat;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .repeat is now .texture.repeat.');
            this.texture.repeat = value;
        }
    },
    format: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
            return this.texture.format;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .format is now .texture.format.');
            this.texture.format = value;
        }
    },
    type: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
            return this.texture.type;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .type is now .texture.type.');
            this.texture.type = value;
        }
    },
    generateMipmaps: {
        get: function() {
            console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
            return this.texture.generateMipmaps;
        },
        set: function(value) {
            console.warn('THREE.WebGLRenderTarget: .generateMipmaps is now .texture.generateMipmaps.');
            this.texture.generateMipmaps = value;
        }
    }
});
//
Object.defineProperties(Audio.prototype, {
    load: {
        value: function(file) {
            console.warn('THREE.Audio: .load has been deprecated. Use THREE.AudioLoader instead.');
            const scope = this;
            const audioLoader = new AudioLoader();
            audioLoader.load(file, function(buffer) {
                scope.setBuffer(buffer);
            });
            return this;
        }
    },
    startTime: {
        set: function() {
            console.warn('THREE.Audio: .startTime is now .play( delay ).');
        }
    }
});
AudioAnalyser.prototype.getData = function() {
    console.warn('THREE.AudioAnalyser: .getData() is now .getFrequencyData().');
    return this.getFrequencyData();
};
//
CubeCamera.prototype.updateCubeMap = function(renderer, scene) {
    console.warn('THREE.CubeCamera: .updateCubeMap() is now .update().');
    return this.update(renderer, scene);
};
CubeCamera.prototype.clear = function(renderer, color, depth, stencil) {
    console.warn('THREE.CubeCamera: .clear() is now .renderTarget.clear().');
    return this.renderTarget.clear(renderer, color, depth, stencil);
};
//
const GeometryUtils = {
    merge: function(geometry1, geometry2, materialIndexOffset) {
        console.warn('THREE.GeometryUtils: .merge() has been moved to Geometry. Use geometry.merge( geometry2, matrix, materialIndexOffset ) instead.');
        let matrix;
        if (geometry2.isMesh) {
            geometry2.matrixAutoUpdate && geometry2.updateMatrix();
            matrix = geometry2.matrix;
            geometry2 = geometry2.geometry;
        }
        geometry1.merge(geometry2, matrix, materialIndexOffset);
    },
    center: function(geometry) {
        console.warn('THREE.GeometryUtils: .center() has been moved to Geometry. Use geometry.center() instead.');
        return geometry.center();
    }
};
ImageUtils.crossOrigin = undefined;
ImageUtils.loadTexture = function(url, mapping, onLoad, onError) {
    console.warn('THREE.ImageUtils.loadTexture has been deprecated. Use THREE.TextureLoader() instead.');
    const loader = new TextureLoader();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(url, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
ImageUtils.loadTextureCube = function(urls, mapping, onLoad, onError) {
    console.warn('THREE.ImageUtils.loadTextureCube has been deprecated. Use THREE.CubeTextureLoader() instead.');
    const loader = new CubeTextureLoader();
    loader.setCrossOrigin(this.crossOrigin);
    const texture = loader.load(urls, onLoad, undefined, onError);
    if (mapping) texture.mapping = mapping;
    return texture;
};
ImageUtils.loadCompressedTexture = function() {
    console.error('THREE.ImageUtils.loadCompressedTexture has been removed. Use THREE.DDSLoader instead.');
};
ImageUtils.loadCompressedTextureCube = function() {
    console.error('THREE.ImageUtils.loadCompressedTextureCube has been removed. Use THREE.DDSLoader instead.');
};
//
function CanvasRenderer() {
    console.error('THREE.CanvasRenderer has been removed');
}
//
function JSONLoader() {
    console.error('THREE.JSONLoader has been removed.');
}
//
const SceneUtils = {
    createMultiMaterialObject: function() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    },
    detach: function() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    },
    attach: function() {
        console.error('THREE.SceneUtils has been moved to /examples/jsm/utils/SceneUtils.js');
    }
};
//
function LensFlare() {
    console.error('THREE.LensFlare has been moved to /examples/jsm/objects/Lensflare.js');
}
if (typeof __THREE_DEVTOOLS__ !== 'undefined') /* eslint-disable no-undef */ __THREE_DEVTOOLS__.dispatchEvent(new CustomEvent('register', {
    detail: {
        revision: REVISION
    }
}));
if (typeof window !== 'undefined') {
    if (window.__THREE__) console.warn('WARNING: Multiple instances of Three.js being imported.');
    else window.__THREE__ = REVISION;
}

});

var $a2acea4f3420f1d8$var$t = "undefined" != typeof self ? self : {};
function $a2acea4f3420f1d8$var$e(e, r) {
    t: {
        for(var n = [
            "CLOSURE_FLAGS"
        ], i = $a2acea4f3420f1d8$var$t, s = 0; s < n.length; s++)if (null == (i = i[n[s]])) {
            n = null;
            break t;
        }
        n = i;
    }
    return null != (e = n && n[e]) ? e : r;
}
function $a2acea4f3420f1d8$var$r(e, r) {
    e = e.split(".");
    for(var n, i = $a2acea4f3420f1d8$var$t; e.length && (n = e.shift());)e.length || void 0 === r ? i = i[n] && i[n] !== Object.prototype[n] ? i[n] : i[n] = {} : i[n] = r;
}
function $a2acea4f3420f1d8$var$n() {
    throw Error("Invalid UTF8");
}
function $a2acea4f3420f1d8$var$i(t, e) {
    return e = String.fromCharCode.apply(null, e), null == t ? e : t + e;
}
var $a2acea4f3420f1d8$var$s, $a2acea4f3420f1d8$var$o, $a2acea4f3420f1d8$var$a = void 0, $a2acea4f3420f1d8$var$h = "undefined" != typeof TextDecoder, $a2acea4f3420f1d8$var$u = "undefined" != typeof TextEncoder;
function $a2acea4f3420f1d8$var$c(t) {
    if ($a2acea4f3420f1d8$var$u) t = ($a2acea4f3420f1d8$var$o ||= new TextEncoder).encode(t);
    else {
        let r = 0, n = new Uint8Array(3 * t.length);
        for(let i = 0; i < t.length; i++){
            var e = t.charCodeAt(i);
            if (e < 128) n[r++] = e;
            else {
                if (e < 2048) n[r++] = e >> 6 | 192;
                else {
                    if (e >= 55296 && e <= 57343) {
                        if (e <= 56319 && i < t.length) {
                            let s = t.charCodeAt(++i);
                            if (s >= 56320 && s <= 57343) {
                                e = 1024 * (e - 55296) + s - 56320 + 65536, n[r++] = e >> 18 | 240, n[r++] = e >> 12 & 63 | 128, n[r++] = e >> 6 & 63 | 128, n[r++] = 63 & e | 128;
                                continue;
                            }
                            i--;
                        }
                        e = 65533;
                    }
                    n[r++] = e >> 12 | 224, n[r++] = e >> 6 & 63 | 128;
                }
                n[r++] = 63 & e | 128;
            }
        }
        t = r === n.length ? n : n.subarray(0, r);
    }
    return t;
}
function $a2acea4f3420f1d8$var$l(e) {
    $a2acea4f3420f1d8$var$t.setTimeout(()=>{
        throw e;
    }, 0);
}
var $a2acea4f3420f1d8$var$d = $a2acea4f3420f1d8$var$e(610401301, !1), $a2acea4f3420f1d8$var$f = $a2acea4f3420f1d8$var$e(748402147, !0);
function $a2acea4f3420f1d8$var$p() {
    var e = $a2acea4f3420f1d8$var$t.navigator;
    return e && (e = e.userAgent) ? e : "";
}
var $a2acea4f3420f1d8$var$g, $a2acea4f3420f1d8$var$m = $a2acea4f3420f1d8$var$t.navigator;
function $a2acea4f3420f1d8$var$v(t) {
    return $a2acea4f3420f1d8$var$v[" "](t), t;
}
$a2acea4f3420f1d8$var$g = $a2acea4f3420f1d8$var$m && $a2acea4f3420f1d8$var$m.userAgentData || null, $a2acea4f3420f1d8$var$v[" "] = function() {};
var $a2acea4f3420f1d8$var$_ = {}, $a2acea4f3420f1d8$var$y = null;
function $a2acea4f3420f1d8$var$E(t) {
    var e = t.length, r = 3 * e / 4;
    r % 3 ? r = Math.floor(r) : -1 != "=.".indexOf(t[e - 1]) && (r = -1 != "=.".indexOf(t[e - 2]) ? r - 2 : r - 1);
    var n = new Uint8Array(r), i = 0;
    return function(t, e) {
        function r(e) {
            for(; n < t.length;){
                let e = t.charAt(n++), r = $a2acea4f3420f1d8$var$y[e];
                if (null != r) return r;
                if (!/^[\s\xa0]*$/.test(e)) throw Error("Unknown base64 encoding at char: " + e);
            }
            return e;
        }
        $a2acea4f3420f1d8$var$A();
        for(var n = 0;;){
            let t = r(-1), n = r(0), i = r(64), s = r(64);
            if (64 === s && -1 === t) break;
            e(t << 2 | n >> 4), 64 != i && (e(n << 4 & 240 | i >> 2), 64 != s && e(i << 6 & 192 | s));
        }
    }(t, function(t) {
        n[i++] = t;
    }), i !== r ? n.subarray(0, i) : n;
}
function $a2acea4f3420f1d8$var$A() {
    if (!$a2acea4f3420f1d8$var$y) {
        $a2acea4f3420f1d8$var$y = {};
        var t = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789".split(""), e = [
            "+/=",
            "+/",
            "-_=",
            "-_.",
            "-_"
        ];
        for(let r = 0; r < 5; r++){
            let n = t.concat(e[r].split(""));
            $a2acea4f3420f1d8$var$_[r] = n;
            for(let t = 0; t < n.length; t++){
                let e = n[t];
                void 0 === $a2acea4f3420f1d8$var$y[e] && ($a2acea4f3420f1d8$var$y[e] = t);
            }
        }
    }
}
var $a2acea4f3420f1d8$var$w = "undefined" != typeof Uint8Array, $a2acea4f3420f1d8$var$b = !(!($a2acea4f3420f1d8$var$d && $a2acea4f3420f1d8$var$g && $a2acea4f3420f1d8$var$g.brands.length > 0) && (-1 != $a2acea4f3420f1d8$var$p().indexOf("Trident") || -1 != $a2acea4f3420f1d8$var$p().indexOf("MSIE"))) && "function" == typeof btoa, $a2acea4f3420f1d8$var$T = /[-_.]/g, $a2acea4f3420f1d8$var$k = {
    "-": "+",
    _: "/",
    ".": "="
};
function $a2acea4f3420f1d8$var$S(t) {
    return $a2acea4f3420f1d8$var$k[t] || "";
}
function $a2acea4f3420f1d8$var$L(t) {
    if (!$a2acea4f3420f1d8$var$b) return $a2acea4f3420f1d8$var$E(t);
    t = $a2acea4f3420f1d8$var$T.test(t) ? t.replace($a2acea4f3420f1d8$var$T, $a2acea4f3420f1d8$var$S) : t, t = atob(t);
    var e = new Uint8Array(t.length);
    for(let r = 0; r < t.length; r++)e[r] = t.charCodeAt(r);
    return e;
}
function $a2acea4f3420f1d8$var$x(t) {
    return $a2acea4f3420f1d8$var$w && null != t && t instanceof Uint8Array;
}
var $a2acea4f3420f1d8$var$R = {};
function $a2acea4f3420f1d8$var$I() {
    return $a2acea4f3420f1d8$var$C ||= new $a2acea4f3420f1d8$var$N(null, $a2acea4f3420f1d8$var$R);
}
function $a2acea4f3420f1d8$var$F(t) {
    $a2acea4f3420f1d8$var$M($a2acea4f3420f1d8$var$R);
    var e = t.g;
    return null == (e = null == e || $a2acea4f3420f1d8$var$x(e) ? e : "string" == typeof e ? $a2acea4f3420f1d8$var$L(e) : null) ? e : t.g = e;
}
var $a2acea4f3420f1d8$var$C, $a2acea4f3420f1d8$var$N = class {
    h() {
        return new Uint8Array($a2acea4f3420f1d8$var$F(this) || 0);
    }
    constructor(t, e){
        if ($a2acea4f3420f1d8$var$M(e), this.g = t, null != t && 0 === t.length) throw Error("ByteString should be constructed with non-empty values");
    }
};
function $a2acea4f3420f1d8$var$M(t) {
    if (t !== $a2acea4f3420f1d8$var$R) throw Error("illegal external caller");
}
function $a2acea4f3420f1d8$var$O(t, e) {
    t.__closure__error__context__984382 || (t.__closure__error__context__984382 = {}), t.__closure__error__context__984382.severity = e;
}
var $a2acea4f3420f1d8$var$D = void 0;
function $a2acea4f3420f1d8$var$P(t) {
    return $a2acea4f3420f1d8$var$O(t = Error(t), "warning"), t;
}
function $a2acea4f3420f1d8$var$$(t, e) {
    if (null != t) {
        var r = $a2acea4f3420f1d8$var$D ??= {}, n = r[t] || 0;
        n >= e || (r[t] = n + 1, $a2acea4f3420f1d8$var$O(t = Error(), "incident"), $a2acea4f3420f1d8$var$l(t));
    }
}
function $a2acea4f3420f1d8$var$U() {
    return "function" == typeof BigInt;
}
var $a2acea4f3420f1d8$var$B = "function" == typeof Symbol && "symbol" == typeof Symbol();
function $a2acea4f3420f1d8$var$G(t, e, r = !1) {
    return "function" == typeof Symbol && "symbol" == typeof Symbol() ? r && Symbol.for && t ? Symbol.for(t) : null != t ? Symbol(t) : Symbol() : e;
}
var $a2acea4f3420f1d8$var$j, $a2acea4f3420f1d8$var$V = $a2acea4f3420f1d8$var$G("jas", void 0, !0), $a2acea4f3420f1d8$var$H = $a2acea4f3420f1d8$var$G(void 0, "0di"), $a2acea4f3420f1d8$var$K = $a2acea4f3420f1d8$var$G(void 0, "1oa"), $a2acea4f3420f1d8$var$X = $a2acea4f3420f1d8$var$G(void 0, Symbol()), $a2acea4f3420f1d8$var$W = $a2acea4f3420f1d8$var$G(void 0, "0ub"), $a2acea4f3420f1d8$var$z = $a2acea4f3420f1d8$var$G(void 0, "0ubs"), $a2acea4f3420f1d8$var$Y = $a2acea4f3420f1d8$var$G(void 0, "0ubsb"), $a2acea4f3420f1d8$var$q = $a2acea4f3420f1d8$var$G(void 0, "0actk"), $a2acea4f3420f1d8$var$J = $a2acea4f3420f1d8$var$G("m_m", "kb", !0), $a2acea4f3420f1d8$var$Z = $a2acea4f3420f1d8$var$G(), $a2acea4f3420f1d8$var$Q = {
    Va: {
        value: 0,
        configurable: !0,
        writable: !0,
        enumerable: !1
    }
}, $a2acea4f3420f1d8$var$tt = Object.defineProperties, $a2acea4f3420f1d8$var$et = $a2acea4f3420f1d8$var$B ? $a2acea4f3420f1d8$var$V : "Va", $a2acea4f3420f1d8$var$rt = [];
function $a2acea4f3420f1d8$var$nt(t, e) {
    $a2acea4f3420f1d8$var$B || $a2acea4f3420f1d8$var$et in t || $a2acea4f3420f1d8$var$tt(t, $a2acea4f3420f1d8$var$Q), t[$a2acea4f3420f1d8$var$et] |= e;
}
function $a2acea4f3420f1d8$var$it(t, e) {
    $a2acea4f3420f1d8$var$B || $a2acea4f3420f1d8$var$et in t || $a2acea4f3420f1d8$var$tt(t, $a2acea4f3420f1d8$var$Q), t[$a2acea4f3420f1d8$var$et] = e;
}
function $a2acea4f3420f1d8$var$st(t) {
    return $a2acea4f3420f1d8$var$nt(t, 34), t;
}
function $a2acea4f3420f1d8$var$ot(t) {
    return $a2acea4f3420f1d8$var$nt(t, 8192), t;
}
$a2acea4f3420f1d8$var$it($a2acea4f3420f1d8$var$rt, 7), $a2acea4f3420f1d8$var$j = Object.freeze($a2acea4f3420f1d8$var$rt);
var $a2acea4f3420f1d8$var$at = {};
function $a2acea4f3420f1d8$var$ht(t, e) {
    return void 0 === e ? t.h !== $a2acea4f3420f1d8$var$ut && !!(2 & t.A[$a2acea4f3420f1d8$var$et]) : !!(2 & e) && t.h !== $a2acea4f3420f1d8$var$ut;
}
var $a2acea4f3420f1d8$var$ut = {};
function $a2acea4f3420f1d8$var$ct(t, e) {
    if (null != t) {
        if ("string" == typeof t) t = t ? new $a2acea4f3420f1d8$var$N(t, $a2acea4f3420f1d8$var$R) : $a2acea4f3420f1d8$var$I();
        else if (t.constructor !== $a2acea4f3420f1d8$var$N) {
            if ($a2acea4f3420f1d8$var$x(t)) t = t.length ? new $a2acea4f3420f1d8$var$N(new Uint8Array(t), $a2acea4f3420f1d8$var$R) : $a2acea4f3420f1d8$var$I();
            else {
                if (!e) throw Error();
                t = void 0;
            }
        }
    }
    return t;
}
class $a2acea4f3420f1d8$var$lt {
    constructor(t, e, r){
        this.g = t, this.h = e, this.j = r;
    }
    next() {
        var t = this.g.next();
        return t.done || (t.value = this.h.call(this.j, t.value)), t;
    }
    [Symbol.iterator]() {
        return this;
    }
}
var $a2acea4f3420f1d8$var$dt = Object.freeze({});
function $a2acea4f3420f1d8$var$ft(t, e, r) {
    var n, i = 128 & e ? 0 : -1, s = t.length;
    (n = !!s) && (n = null != (n = t[s - 1]) && "object" == typeof n && n.constructor === Object);
    var o = s + (n ? -1 : 0);
    for(e = 128 & e ? 1 : 0; e < o; e++)r(e - i, t[e]);
    if (n) {
        t = t[s - 1];
        for(let e in t)!isNaN(e) && r(+e, t[e]);
    }
}
var $a2acea4f3420f1d8$var$pt = {};
function $a2acea4f3420f1d8$var$gt(t) {
    return 128 & t ? $a2acea4f3420f1d8$var$pt : void 0;
}
function $a2acea4f3420f1d8$var$mt(t) {
    return t.ib = !0, t;
}
var $a2acea4f3420f1d8$var$vt = $a2acea4f3420f1d8$var$mt((t)=>"number" == typeof t), $a2acea4f3420f1d8$var$_t = $a2acea4f3420f1d8$var$mt((t)=>"string" == typeof t), $a2acea4f3420f1d8$var$yt = $a2acea4f3420f1d8$var$mt((t)=>"boolean" == typeof t), $a2acea4f3420f1d8$var$Et = "function" == typeof $a2acea4f3420f1d8$var$t.BigInt && "bigint" == typeof $a2acea4f3420f1d8$var$t.BigInt(0);
function $a2acea4f3420f1d8$var$At(t) {
    var e = t;
    if ($a2acea4f3420f1d8$var$_t(e)) {
        if (!/^\s*(?:-?[1-9]\d*|0)?\s*$/.test(e)) throw Error(String(e));
    } else if ($a2acea4f3420f1d8$var$vt(e) && !Number.isSafeInteger(e)) throw Error(String(e));
    return $a2acea4f3420f1d8$var$Et ? BigInt(t) : t = $a2acea4f3420f1d8$var$yt(t) ? t ? "1" : "0" : $a2acea4f3420f1d8$var$_t(t) ? t.trim() || "0" : String(t);
}
var $a2acea4f3420f1d8$var$wt = $a2acea4f3420f1d8$var$mt((t)=>$a2acea4f3420f1d8$var$Et ? t >= $a2acea4f3420f1d8$var$Tt && t <= $a2acea4f3420f1d8$var$St : "-" === t[0] ? $a2acea4f3420f1d8$var$Lt(t, $a2acea4f3420f1d8$var$bt) : $a2acea4f3420f1d8$var$Lt(t, $a2acea4f3420f1d8$var$kt)), $a2acea4f3420f1d8$var$bt = Number.MIN_SAFE_INTEGER.toString(), $a2acea4f3420f1d8$var$Tt = $a2acea4f3420f1d8$var$Et ? BigInt(Number.MIN_SAFE_INTEGER) : void 0, $a2acea4f3420f1d8$var$kt = Number.MAX_SAFE_INTEGER.toString(), $a2acea4f3420f1d8$var$St = $a2acea4f3420f1d8$var$Et ? BigInt(Number.MAX_SAFE_INTEGER) : void 0;
function $a2acea4f3420f1d8$var$Lt(t, e) {
    if (t.length > e.length) return !1;
    if (t.length < e.length || t === e) return !0;
    for(let r = 0; r < t.length; r++){
        let n = t[r], i = e[r];
        if (n > i) return !1;
        if (n < i) return !0;
    }
}
var $a2acea4f3420f1d8$var$xt, $a2acea4f3420f1d8$var$Rt = "function" == typeof Uint8Array.prototype.slice, $a2acea4f3420f1d8$var$It = 0, $a2acea4f3420f1d8$var$Ft = 0;
function $a2acea4f3420f1d8$var$Ct(t) {
    var e = t >>> 0;
    $a2acea4f3420f1d8$var$It = e, $a2acea4f3420f1d8$var$Ft = (t - e) / 4294967296 >>> 0;
}
function $a2acea4f3420f1d8$var$Nt(t) {
    if (t < 0) {
        $a2acea4f3420f1d8$var$Ct(-t);
        let [e, r] = $a2acea4f3420f1d8$var$jt($a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft);
        $a2acea4f3420f1d8$var$It = e >>> 0, $a2acea4f3420f1d8$var$Ft = r >>> 0;
    } else $a2acea4f3420f1d8$var$Ct(t);
}
function $a2acea4f3420f1d8$var$Mt(t) {
    var e = $a2acea4f3420f1d8$var$xt ||= new DataView(new ArrayBuffer(8));
    e.setFloat32(0, +t, !0), $a2acea4f3420f1d8$var$Ft = 0, $a2acea4f3420f1d8$var$It = e.getUint32(0, !0);
}
function $a2acea4f3420f1d8$var$Ot(t, e) {
    var r = 4294967296 * e + (t >>> 0);
    return Number.isSafeInteger(r) ? r : $a2acea4f3420f1d8$var$$t(t, e);
}
function $a2acea4f3420f1d8$var$Dt(t, e) {
    return $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$U() ? BigInt.asUintN(64, (BigInt(e >>> 0) << BigInt(32)) + BigInt(t >>> 0)) : $a2acea4f3420f1d8$var$$t(t, e));
}
function $a2acea4f3420f1d8$var$Pt(t, e) {
    return $a2acea4f3420f1d8$var$U() ? $a2acea4f3420f1d8$var$At(BigInt.asIntN(64, (BigInt.asUintN(32, BigInt(e)) << BigInt(32)) + BigInt.asUintN(32, BigInt(t)))) : $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$Bt(t, e));
}
function $a2acea4f3420f1d8$var$$t(t, e) {
    if (t >>>= 0, (e >>>= 0) <= 2097151) var r = "" + (4294967296 * e + t);
    else $a2acea4f3420f1d8$var$U() ? r = "" + (BigInt(e) << BigInt(32) | BigInt(t)) : (t = (16777215 & t) + 6777216 * (r = 16777215 & (t >>> 24 | e << 8)) + 6710656 * (e = e >> 16 & 65535), r += 8147497 * e, e *= 2, t >= 1e7 && (r += t / 1e7 >>> 0, t %= 1e7), r >= 1e7 && (e += r / 1e7 >>> 0, r %= 1e7), r = e + $a2acea4f3420f1d8$var$Ut(r) + $a2acea4f3420f1d8$var$Ut(t));
    return r;
}
function $a2acea4f3420f1d8$var$Ut(t) {
    return t = String(t), "0000000".slice(t.length) + t;
}
function $a2acea4f3420f1d8$var$Bt(t, e) {
    if (2147483648 & e) {
        if ($a2acea4f3420f1d8$var$U()) t = "" + (BigInt(0 | e) << BigInt(32) | BigInt(t >>> 0));
        else {
            let [r, n] = $a2acea4f3420f1d8$var$jt(t, e);
            t = "-" + $a2acea4f3420f1d8$var$$t(r, n);
        }
    } else t = $a2acea4f3420f1d8$var$$t(t, e);
    return t;
}
function $a2acea4f3420f1d8$var$Gt(t) {
    if (t.length < 16) $a2acea4f3420f1d8$var$Nt(Number(t));
    else if ($a2acea4f3420f1d8$var$U()) t = BigInt(t), $a2acea4f3420f1d8$var$It = Number(t & BigInt(4294967295)) >>> 0, $a2acea4f3420f1d8$var$Ft = Number(t >> BigInt(32) & BigInt(4294967295));
    else {
        let e = +("-" === t[0]);
        $a2acea4f3420f1d8$var$Ft = $a2acea4f3420f1d8$var$It = 0;
        let r = t.length;
        for(let n = e, i = (r - e) % 6 + e; i <= r; n = i, i += 6){
            let e = Number(t.slice(n, i));
            $a2acea4f3420f1d8$var$Ft *= 1e6, ($a2acea4f3420f1d8$var$It = 1e6 * $a2acea4f3420f1d8$var$It + e) >= 4294967296 && ($a2acea4f3420f1d8$var$Ft += Math.trunc($a2acea4f3420f1d8$var$It / 4294967296), $a2acea4f3420f1d8$var$Ft >>>= 0, $a2acea4f3420f1d8$var$It >>>= 0);
        }
        if (e) {
            let [t, e] = $a2acea4f3420f1d8$var$jt($a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft);
            $a2acea4f3420f1d8$var$It = t, $a2acea4f3420f1d8$var$Ft = e;
        }
    }
}
function $a2acea4f3420f1d8$var$jt(t, e) {
    return e = ~e, t ? t = 1 + ~t : e += 1, [
        t,
        e
    ];
}
function $a2acea4f3420f1d8$var$Vt(t) {
    return Array.prototype.slice.call(t);
}
var $a2acea4f3420f1d8$var$Ht = "function" == typeof BigInt ? BigInt.asIntN : void 0, $a2acea4f3420f1d8$var$Kt = "function" == typeof BigInt ? BigInt.asUintN : void 0, $a2acea4f3420f1d8$var$Xt = Number.isSafeInteger, $a2acea4f3420f1d8$var$Wt = Number.isFinite, $a2acea4f3420f1d8$var$zt = Math.trunc, $a2acea4f3420f1d8$var$Yt = $a2acea4f3420f1d8$var$At(0);
function $a2acea4f3420f1d8$var$qt(t) {
    if ("number" != typeof t) throw Error(`Value of float/double field must be a number, found ${typeof t}: ${t}`);
    return t;
}
function $a2acea4f3420f1d8$var$Jt(t) {
    return null == t || "number" == typeof t ? t : "NaN" === t || "Infinity" === t || "-Infinity" === t ? Number(t) : void 0;
}
function $a2acea4f3420f1d8$var$Zt(t) {
    if ("boolean" != typeof t) {
        var e = typeof t;
        throw Error(`Expected boolean but got ${"object" != e ? e : t ? Array.isArray(t) ? "array" : e : "null"}: ${t}`);
    }
    return t;
}
var $a2acea4f3420f1d8$var$Qt = /^-?([1-9][0-9]*|0)(\.[0-9]+)?$/;
function $a2acea4f3420f1d8$var$te(t) {
    switch(typeof t){
        case "bigint":
            return !0;
        case "number":
            return $a2acea4f3420f1d8$var$Wt(t);
        case "string":
            return $a2acea4f3420f1d8$var$Qt.test(t);
        default:
            return !1;
    }
}
function $a2acea4f3420f1d8$var$ee(t) {
    if (null != t) {
        if (!$a2acea4f3420f1d8$var$Wt(t)) throw $a2acea4f3420f1d8$var$P("enum");
        t |= 0;
    }
    return t;
}
function $a2acea4f3420f1d8$var$re(t) {
    if (null == t) return t;
    if ("string" == typeof t && t) t = +t;
    else if ("number" != typeof t) return;
    return $a2acea4f3420f1d8$var$Wt(t) ? 0 | t : void 0;
}
function $a2acea4f3420f1d8$var$ne(t) {
    if (null == t) return t;
    if ("string" == typeof t && t) t = +t;
    else if ("number" != typeof t) return;
    return $a2acea4f3420f1d8$var$Wt(t) ? t >>> 0 : void 0;
}
function $a2acea4f3420f1d8$var$ie(t, e) {
    if (e ??= 1024, !$a2acea4f3420f1d8$var$te(t)) throw $a2acea4f3420f1d8$var$P("int64");
    var r = typeof t;
    switch(e){
        case 512:
            switch(r){
                case "string":
                    return $a2acea4f3420f1d8$var$ce(t);
                case "bigint":
                    return String($a2acea4f3420f1d8$var$Ht(64, t));
                default:
                    return $a2acea4f3420f1d8$var$ue(t);
            }
        case 1024:
            switch(r){
                case "string":
                    return $a2acea4f3420f1d8$var$le(t);
                case "bigint":
                    return $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$Ht(64, t));
                default:
                    return $a2acea4f3420f1d8$var$de(t);
            }
        case 0:
            switch(r){
                case "string":
                    return $a2acea4f3420f1d8$var$ce(t);
                case "bigint":
                    return $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$Ht(64, t));
                default:
                    return $a2acea4f3420f1d8$var$ae(t);
            }
        default:
            return function(t, e = `unexpected value ${t}!`) {
                throw Error(e);
            }(e, "Unknown format requested type for int64");
    }
}
function $a2acea4f3420f1d8$var$se(t) {
    var e = t.length;
    return ("-" === t[0] ? e < 20 || 20 === e && t <= "-9223372036854775808" : e < 19 || 19 === e && t <= "9223372036854775807") ? t : ($a2acea4f3420f1d8$var$Gt(t), $a2acea4f3420f1d8$var$Bt($a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft));
}
function $a2acea4f3420f1d8$var$oe(t) {
    if ("-" === t[0]) var e = !1;
    else e = (e = t.length) < 20 || 20 === e && t <= "18446744073709551615";
    return e ? t : ($a2acea4f3420f1d8$var$Gt(t), $a2acea4f3420f1d8$var$$t($a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft));
}
function $a2acea4f3420f1d8$var$ae(t) {
    if (t = $a2acea4f3420f1d8$var$zt(t), !$a2acea4f3420f1d8$var$Xt(t)) {
        $a2acea4f3420f1d8$var$Nt(t);
        var e = $a2acea4f3420f1d8$var$It, r = $a2acea4f3420f1d8$var$Ft;
        (t = 2147483648 & r) && (r = ~r >>> 0, 0 == (e = 1 + ~e >>> 0) && (r = r + 1 >>> 0)), t = "number" == typeof (e = $a2acea4f3420f1d8$var$Ot(e, r)) ? t ? -e : e : t ? "-" + e : e;
    }
    return t;
}
function $a2acea4f3420f1d8$var$he(t) {
    return (t = $a2acea4f3420f1d8$var$zt(t)) >= 0 && $a2acea4f3420f1d8$var$Xt(t) || ($a2acea4f3420f1d8$var$Nt(t), t = $a2acea4f3420f1d8$var$Ot($a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft)), t;
}
function $a2acea4f3420f1d8$var$ue(t) {
    return t = $a2acea4f3420f1d8$var$zt(t), $a2acea4f3420f1d8$var$Xt(t) ? t = String(t) : ($a2acea4f3420f1d8$var$Nt(t), t = $a2acea4f3420f1d8$var$Bt($a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft)), t;
}
function $a2acea4f3420f1d8$var$ce(t) {
    var e = $a2acea4f3420f1d8$var$zt(Number(t));
    return $a2acea4f3420f1d8$var$Xt(e) ? String(e) : (-1 !== (e = t.indexOf(".")) && (t = t.substring(0, e)), $a2acea4f3420f1d8$var$se(t));
}
function $a2acea4f3420f1d8$var$le(t) {
    var e = $a2acea4f3420f1d8$var$zt(Number(t));
    return $a2acea4f3420f1d8$var$Xt(e) ? $a2acea4f3420f1d8$var$At(e) : (-1 !== (e = t.indexOf(".")) && (t = t.substring(0, e)), $a2acea4f3420f1d8$var$U() ? $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$Ht(64, BigInt(t))) : $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$se(t)));
}
function $a2acea4f3420f1d8$var$de(t) {
    return $a2acea4f3420f1d8$var$Xt(t) ? $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$ae(t)) : $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$ue(t));
}
function $a2acea4f3420f1d8$var$fe(t) {
    var e = typeof t;
    return null == t ? t : "bigint" === e ? $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$Ht(64, t)) : $a2acea4f3420f1d8$var$te(t) ? "string" === e ? $a2acea4f3420f1d8$var$le(t) : $a2acea4f3420f1d8$var$de(t) : void 0;
}
function $a2acea4f3420f1d8$var$pe(t) {
    if (null == t) return t;
    var e = typeof t;
    if ("bigint" === e) return String($a2acea4f3420f1d8$var$Ht(64, t));
    if ($a2acea4f3420f1d8$var$te(t)) {
        if ("string" === e) return $a2acea4f3420f1d8$var$ce(t);
        if ("number" === e) return $a2acea4f3420f1d8$var$ae(t);
    }
}
function $a2acea4f3420f1d8$var$ge(t) {
    if (null == t || "string" == typeof t || t instanceof $a2acea4f3420f1d8$var$N) return t;
}
function $a2acea4f3420f1d8$var$me(t) {
    if ("string" != typeof t) throw Error();
    return t;
}
function $a2acea4f3420f1d8$var$ve(t) {
    if (null != t && "string" != typeof t) throw Error();
    return t;
}
function $a2acea4f3420f1d8$var$_e(t) {
    return null == t || "string" == typeof t ? t : void 0;
}
function $a2acea4f3420f1d8$var$ye(t, e, r, n) {
    return null != t && t[$a2acea4f3420f1d8$var$J] === $a2acea4f3420f1d8$var$at ? t : Array.isArray(t) ? ((n = (r = 0 | t[$a2acea4f3420f1d8$var$et]) | 32 & n | 2 & n) !== r && $a2acea4f3420f1d8$var$it(t, n), new e(t)) : (r ? 2 & n ? ((t = e[$a2acea4f3420f1d8$var$H]) || ($a2acea4f3420f1d8$var$st((t = new e).A), t = e[$a2acea4f3420f1d8$var$H] = t), e = t) : e = new e : e = void 0, e);
}
function $a2acea4f3420f1d8$var$Ee(t, e, r) {
    return null == (t = e ? $a2acea4f3420f1d8$var$ie(t, 1024) : $a2acea4f3420f1d8$var$fe(t)) ? r ? $a2acea4f3420f1d8$var$Yt : void 0 : t;
}
function $a2acea4f3420f1d8$var$Ae(t) {
    return t;
}
var $a2acea4f3420f1d8$var$we = {}, $a2acea4f3420f1d8$var$be = function() {
    try {
        return $a2acea4f3420f1d8$var$v(new class extends Map {
            constructor(){
                super();
            }
        }), !1;
    } catch  {
        return !0;
    }
}();
class $a2acea4f3420f1d8$var$Te {
    constructor(){
        this.g = new Map;
    }
    get(t) {
        return this.g.get(t);
    }
    set(t, e) {
        return this.g.set(t, e), this.size = this.g.size, this;
    }
    delete(t) {
        return t = this.g.delete(t), this.size = this.g.size, t;
    }
    clear() {
        this.g.clear(), this.size = this.g.size;
    }
    has(t) {
        return this.g.has(t);
    }
    entries() {
        return this.g.entries();
    }
    keys() {
        return this.g.keys();
    }
    values() {
        return this.g.values();
    }
    forEach(t, e) {
        return this.g.forEach(t, e);
    }
    [Symbol.iterator]() {
        return this.entries();
    }
}
var $a2acea4f3420f1d8$var$ke = $a2acea4f3420f1d8$var$be ? (Object.setPrototypeOf($a2acea4f3420f1d8$var$Te.prototype, Map.prototype), Object.defineProperties($a2acea4f3420f1d8$var$Te.prototype, {
    size: {
        value: 0,
        configurable: !0,
        enumerable: !0,
        writable: !0
    }
}), $a2acea4f3420f1d8$var$Te) : class extends Map {
    constructor(){
        super();
    }
};
function $a2acea4f3420f1d8$var$Se(t) {
    return t;
}
function $a2acea4f3420f1d8$var$Le(t) {
    if (2 & t.M) throw Error("Cannot mutate an immutable Map");
}
var $a2acea4f3420f1d8$var$xe, $a2acea4f3420f1d8$var$Re = class extends $a2acea4f3420f1d8$var$ke {
    constructor(t, e, r = $a2acea4f3420f1d8$var$Se, n = $a2acea4f3420f1d8$var$Se){
        super(), this.M = 0 | t[$a2acea4f3420f1d8$var$et], this.N = e, this.ba = r, this.na = this.N ? $a2acea4f3420f1d8$var$Ie : n;
        for(let i = 0; i < t.length; i++){
            let s = t[i], o = r(s[0], !1, !0), a = s[1];
            e ? void 0 === a && (a = null) : a = n(s[1], !1, !0, void 0, void 0, this.M), super.set(o, a);
        }
    }
    ea(t) {
        return $a2acea4f3420f1d8$var$ot(Array.from(super.entries(), t));
    }
    clear() {
        $a2acea4f3420f1d8$var$Le(this), super.clear();
    }
    delete(t) {
        return $a2acea4f3420f1d8$var$Le(this), super.delete(this.ba(t, !0, !1));
    }
    entries() {
        if (this.N) {
            var t = super.keys();
            t = new $a2acea4f3420f1d8$var$lt(t, $a2acea4f3420f1d8$var$Fe, this);
        } else t = super.entries();
        return t;
    }
    values() {
        if (this.N) {
            var t = super.keys();
            t = new $a2acea4f3420f1d8$var$lt(t, $a2acea4f3420f1d8$var$Re.prototype.get, this);
        } else t = super.values();
        return t;
    }
    forEach(t, e) {
        this.N ? super.forEach((r, n, i)=>{
            t.call(e, i.get(n), n, i);
        }) : super.forEach(t, e);
    }
    set(t, e) {
        return $a2acea4f3420f1d8$var$Le(this), null == (t = this.ba(t, !0, !1)) ? this : null == e ? (super.delete(t), this) : super.set(t, this.na(e, !0, !0, this.N, !1, this.M));
    }
    gb(t) {
        var e = this.ba(t[0], !1, !0);
        t = t[1], t = this.N ? void 0 === t ? null : t : this.na(t, !1, !0, void 0, !1, this.M), super.set(e, t);
    }
    has(t) {
        return super.has(this.ba(t, !1, !1));
    }
    get(t) {
        t = this.ba(t, !1, !1);
        var e = super.get(t);
        if (void 0 !== e) {
            var r = this.N;
            return r ? ((r = this.na(e, !1, !0, r, this.Fa, this.M)) !== e && super.set(t, r), r) : e;
        }
    }
    [Symbol.iterator]() {
        return this.entries();
    }
};
function $a2acea4f3420f1d8$var$Ie(t, e, r, n, i, s) {
    return t = $a2acea4f3420f1d8$var$ye(t, n, r, s), i && (t = $a2acea4f3420f1d8$var$Ze(t)), t;
}
function $a2acea4f3420f1d8$var$Fe(t) {
    return [
        t,
        this.get(t)
    ];
}
function $a2acea4f3420f1d8$var$Ce() {
    return $a2acea4f3420f1d8$var$xe ||= new $a2acea4f3420f1d8$var$Re($a2acea4f3420f1d8$var$st([]), void 0, void 0, void 0, $a2acea4f3420f1d8$var$we);
}
function $a2acea4f3420f1d8$var$Ne(t) {
    return $a2acea4f3420f1d8$var$X ? t[$a2acea4f3420f1d8$var$X] : void 0;
}
function $a2acea4f3420f1d8$var$Me(t, e) {
    for(let r in t)!isNaN(r) && e(t, +r, t[r]);
}
$a2acea4f3420f1d8$var$Re.prototype.toJSON = void 0;
var $a2acea4f3420f1d8$var$Oe, $a2acea4f3420f1d8$var$De, $a2acea4f3420f1d8$var$Pe, $a2acea4f3420f1d8$var$$e = class {
}, $a2acea4f3420f1d8$var$Ue = {
    cb: !0
};
function $a2acea4f3420f1d8$var$Be(t, e) {
    e < 100 || $a2acea4f3420f1d8$var$$($a2acea4f3420f1d8$var$z, 1);
}
function $a2acea4f3420f1d8$var$Ge(t, e, r, n) {
    var i = void 0 !== n;
    n = !!n;
    var s, o = $a2acea4f3420f1d8$var$X;
    !i && $a2acea4f3420f1d8$var$B && o && (s = t[o]) && $a2acea4f3420f1d8$var$Me(s, $a2acea4f3420f1d8$var$Be), o = [];
    var a = t.length;
    s = 4294967295;
    var h = !1, u = !!(64 & e), c = u ? 128 & e ? 0 : -1 : void 0;
    if (!(1 & e)) {
        var l = a && t[a - 1];
        null != l && "object" == typeof l && l.constructor === Object ? s = --a : l = void 0, !u || 128 & e || i || (h = !0, s = ($a2acea4f3420f1d8$var$Oe ?? $a2acea4f3420f1d8$var$Ae)(s - c, c, t, l, void 0) + c);
    }
    e = void 0;
    for(var d = 0; d < a; d++){
        let i = t[d];
        if (null != i && null != (i = r(i, n))) {
            if (u && d >= s) {
                let t = d - c;
                (e ??= {})[t] = i;
            } else o[d] = i;
        }
    }
    if (l) for(let t in l){
        if (null == (a = l[t]) || null == (a = r(a, n))) continue;
        let i;
        d = +t, u && !Number.isNaN(d) && (i = d + c) < s ? o[i] = a : (e ??= {})[t] = a;
    }
    return e && (h ? o.push(e) : o[s] = e), i && $a2acea4f3420f1d8$var$X && (t = $a2acea4f3420f1d8$var$Ne(t)) && t instanceof $a2acea4f3420f1d8$var$$e && (o[$a2acea4f3420f1d8$var$X] = function(t) {
        var e = new $a2acea4f3420f1d8$var$$e;
        return $a2acea4f3420f1d8$var$Me(t, (t, r, n)=>{
            e[r] = $a2acea4f3420f1d8$var$Vt(n);
        }), e.ka = t.ka, e;
    }(t)), o;
}
function $a2acea4f3420f1d8$var$je(t) {
    return t[0] = $a2acea4f3420f1d8$var$Ve(t[0]), t[1] = $a2acea4f3420f1d8$var$Ve(t[1]), t;
}
function $a2acea4f3420f1d8$var$Ve(t) {
    switch(typeof t){
        case "number":
            return Number.isFinite(t) ? t : "" + t;
        case "bigint":
            return $a2acea4f3420f1d8$var$wt(t) ? Number(t) : "" + t;
        case "boolean":
            return t ? 1 : 0;
        case "object":
            if (Array.isArray(t)) {
                var e = 0 | t[$a2acea4f3420f1d8$var$et];
                return 0 === t.length && 1 & e ? void 0 : $a2acea4f3420f1d8$var$Ge(t, e, $a2acea4f3420f1d8$var$Ve);
            }
            if (null != t && t[$a2acea4f3420f1d8$var$J] === $a2acea4f3420f1d8$var$at) return $a2acea4f3420f1d8$var$He(t);
            if (t instanceof $a2acea4f3420f1d8$var$N) {
                if (null == (e = t.g)) t = "";
                else if ("string" == typeof e) t = e;
                else {
                    if ($a2acea4f3420f1d8$var$b) {
                        for(var r = "", n = 0, i = e.length - 10240; n < i;)r += String.fromCharCode.apply(null, e.subarray(n, n += 10240));
                        r += String.fromCharCode.apply(null, n ? e.subarray(n) : e), e = btoa(r);
                    } else {
                        void 0 === r && (r = 0), $a2acea4f3420f1d8$var$A(), r = $a2acea4f3420f1d8$var$_[r], n = Array(Math.floor(e.length / 3)), i = r[64] || "";
                        let t = 0, u = 0;
                        for(; t < e.length - 2; t += 3){
                            var s = e[t], o = e[t + 1], a = e[t + 2], h = r[s >> 2];
                            s = r[(3 & s) << 4 | o >> 4], o = r[(15 & o) << 2 | a >> 6], a = r[63 & a], n[u++] = h + s + o + a;
                        }
                        switch(h = 0, a = i, e.length - t){
                            case 2:
                                a = r[(15 & (h = e[t + 1])) << 2] || i;
                            case 1:
                                e = e[t], n[u] = r[e >> 2] + r[(3 & e) << 4 | h >> 4] + a + i;
                        }
                        e = n.join("");
                    }
                    t = t.g = e;
                }
                return t;
            }
            return t instanceof $a2acea4f3420f1d8$var$Re ? t = 0 !== t.size ? t.ea($a2acea4f3420f1d8$var$je) : void 0 : void 0;
    }
    return t;
}
function $a2acea4f3420f1d8$var$He(t) {
    return $a2acea4f3420f1d8$var$Ge(t = t.A, 0 | t[$a2acea4f3420f1d8$var$et], $a2acea4f3420f1d8$var$Ve);
}
function $a2acea4f3420f1d8$var$Ke(t, e) {
    return $a2acea4f3420f1d8$var$Xe(t, e[0], e[1]);
}
function $a2acea4f3420f1d8$var$Xe(t, e, r, n = 0) {
    if (null == t) {
        var i = 32;
        r ? (t = [
            r
        ], i |= 128) : t = [], e && (i = -16760833 & i | (1023 & e) << 14);
    } else {
        if (!Array.isArray(t)) throw Error("narr");
        if (i = 0 | t[$a2acea4f3420f1d8$var$et], $a2acea4f3420f1d8$var$f && 1 & i) throw Error("rfarr");
        if (2048 & i && !(2 & i) && function() {
            if ($a2acea4f3420f1d8$var$f) throw Error("carr");
            $a2acea4f3420f1d8$var$$($a2acea4f3420f1d8$var$q, 5);
        }(), 256 & i) throw Error("farr");
        if (64 & i) return (i | n) !== i && $a2acea4f3420f1d8$var$it(t, i | n), t;
        if (r && (i |= 128, r !== t[0])) throw Error("mid");
        t: {
            i |= 64;
            var s = (r = t).length;
            if (s) {
                var o = s - 1;
                let t = r[o];
                if (null != t && "object" == typeof t && t.constructor === Object) {
                    if ((o -= e = 128 & i ? 0 : -1) >= 1024) throw Error("pvtlmt");
                    for(var a in t)(s = +a) < o && (r[s + e] = t[a], delete t[a]);
                    i = -16760833 & i | (1023 & o) << 14;
                    break t;
                }
            }
            if (e) {
                if ((a = Math.max(e, s - (128 & i ? 0 : -1))) > 1024) throw Error("spvt");
                i = -16760833 & i | (1023 & a) << 14;
            }
        }
    }
    return $a2acea4f3420f1d8$var$it(t, 64 | i | n), t;
}
function $a2acea4f3420f1d8$var$We(t, e) {
    if ("object" != typeof t) return t;
    if (Array.isArray(t)) {
        var r = 0 | t[$a2acea4f3420f1d8$var$et];
        return 0 === t.length && 1 & r ? void 0 : $a2acea4f3420f1d8$var$ze(t, r, e);
    }
    if (null != t && t[$a2acea4f3420f1d8$var$J] === $a2acea4f3420f1d8$var$at) return $a2acea4f3420f1d8$var$qe(t);
    if (t instanceof $a2acea4f3420f1d8$var$Re) {
        if (2 & (e = t.M)) return t;
        if (!t.size) return;
        if (r = $a2acea4f3420f1d8$var$st(t.ea()), t.N) for(t = 0; t < r.length; t++){
            let n = r[t], i = n[1];
            i = null == i || "object" != typeof i ? void 0 : null != i && i[$a2acea4f3420f1d8$var$J] === $a2acea4f3420f1d8$var$at ? $a2acea4f3420f1d8$var$qe(i) : Array.isArray(i) ? $a2acea4f3420f1d8$var$ze(i, 0 | i[$a2acea4f3420f1d8$var$et], !!(32 & e)) : void 0, n[1] = i;
        }
        return r;
    }
    return t instanceof $a2acea4f3420f1d8$var$N ? t : void 0;
}
function $a2acea4f3420f1d8$var$ze(t, e, r) {
    return 2 & e || (!r || 4096 & e || 16 & e ? t = $a2acea4f3420f1d8$var$Je(t, e, !1, r && !(16 & e)) : ($a2acea4f3420f1d8$var$nt(t, 34), 4 & e && Object.freeze(t))), t;
}
function $a2acea4f3420f1d8$var$Ye(t, e, r) {
    return t = new t.constructor(e), r && (t.h = $a2acea4f3420f1d8$var$ut), t.m = $a2acea4f3420f1d8$var$ut, t;
}
function $a2acea4f3420f1d8$var$qe(t) {
    var e = t.A, r = 0 | e[$a2acea4f3420f1d8$var$et];
    return $a2acea4f3420f1d8$var$ht(t, r) ? t : $a2acea4f3420f1d8$var$rr(t, e, r) ? $a2acea4f3420f1d8$var$Ye(t, e) : $a2acea4f3420f1d8$var$Je(e, r);
}
function $a2acea4f3420f1d8$var$Je(t, e, r, n) {
    return n ??= !!(34 & e), t = $a2acea4f3420f1d8$var$Ge(t, e, $a2acea4f3420f1d8$var$We, n), n = 32, r && (n |= 2), $a2acea4f3420f1d8$var$it(t, e = 16769217 & e | n), t;
}
function $a2acea4f3420f1d8$var$Ze(t) {
    var e = t.A, r = 0 | e[$a2acea4f3420f1d8$var$et];
    return $a2acea4f3420f1d8$var$ht(t, r) ? $a2acea4f3420f1d8$var$rr(t, e, r) ? $a2acea4f3420f1d8$var$Ye(t, e, !0) : new t.constructor($a2acea4f3420f1d8$var$Je(e, r, !1)) : t;
}
function $a2acea4f3420f1d8$var$Qe(t) {
    if (t.h !== $a2acea4f3420f1d8$var$ut) return !1;
    var e = t.A;
    return $a2acea4f3420f1d8$var$nt(e = $a2acea4f3420f1d8$var$Je(e, 0 | e[$a2acea4f3420f1d8$var$et]), 2048), t.A = e, t.h = void 0, t.m = void 0, !0;
}
function $a2acea4f3420f1d8$var$tr(t) {
    if (!$a2acea4f3420f1d8$var$Qe(t) && $a2acea4f3420f1d8$var$ht(t, 0 | t.A[$a2acea4f3420f1d8$var$et])) throw Error();
}
function $a2acea4f3420f1d8$var$er(t, e) {
    void 0 === e && (e = 0 | t[$a2acea4f3420f1d8$var$et]), 32 & e && !(4096 & e) && $a2acea4f3420f1d8$var$it(t, 4096 | e);
}
function $a2acea4f3420f1d8$var$rr(t, e, r) {
    return !!(2 & r) || !(!(32 & r) || 4096 & r) && ($a2acea4f3420f1d8$var$it(e, 2 | r), t.h = $a2acea4f3420f1d8$var$ut, !0);
}
var $a2acea4f3420f1d8$var$nr = $a2acea4f3420f1d8$var$At(0), $a2acea4f3420f1d8$var$ir = {};
function $a2acea4f3420f1d8$var$sr(t, e, r, n) {
    if (null !== (e = $a2acea4f3420f1d8$var$or(t.A, e, void 0, n)) || r && t.m !== $a2acea4f3420f1d8$var$ut) return e;
}
function $a2acea4f3420f1d8$var$or(t, e, r, n) {
    if (-1 === e) return null;
    var i = e + (r ? 0 : -1), s = t.length - 1;
    if (!(s < 1 + (r ? 0 : -1))) {
        if (i >= s) {
            var o = t[s];
            if (null != o && "object" == typeof o && o.constructor === Object) {
                r = o[e];
                var a = !0;
            } else {
                if (i !== s) return;
                r = o;
            }
        } else r = t[i];
        if (n && null != r) {
            if (null == (n = n(r))) return n;
            if (!Object.is(n, r)) return a ? o[e] = n : t[i] = n, n;
        }
        return r;
    }
}
function $a2acea4f3420f1d8$var$ar(t, e, r, n) {
    $a2acea4f3420f1d8$var$tr(t);
    var i = t.A;
    return $a2acea4f3420f1d8$var$hr(i, 0 | i[$a2acea4f3420f1d8$var$et], e, r, n), t;
}
function $a2acea4f3420f1d8$var$hr(t, e, r, n, i) {
    var s = r + (i ? 0 : -1), o = t.length - 1;
    if (o >= 1 + (i ? 0 : -1) && s >= o) {
        let i = t[o];
        if (null != i && "object" == typeof i && i.constructor === Object) return i[r] = n, e;
    }
    return s <= o ? (t[s] = n, e) : (void 0 !== n && (r >= (o = (e ??= 0 | t[$a2acea4f3420f1d8$var$et]) >> 14 & 1023 || 536870912) ? null != n && (t[o + (i ? 0 : -1)] = {
        [r]: n
    }) : t[s] = n), e);
}
function $a2acea4f3420f1d8$var$ur(t, e, r, n) {
    var i = t.A;
    return void 0 !== $a2acea4f3420f1d8$var$kr(i, 0 | i[$a2acea4f3420f1d8$var$et], e, t = $a2acea4f3420f1d8$var$Er(t, n) === r ? r : -1);
}
function $a2acea4f3420f1d8$var$cr() {
    return void 0 === $a2acea4f3420f1d8$var$dt ? 2 : 4;
}
function $a2acea4f3420f1d8$var$lr(t, e, r, n, i) {
    var s = t.A, o = 0 | s[$a2acea4f3420f1d8$var$et];
    n = $a2acea4f3420f1d8$var$ht(t, o) ? 1 : n, i = !!i || 3 === n, 2 === n && $a2acea4f3420f1d8$var$Qe(t) && (o = 0 | (s = t.A)[$a2acea4f3420f1d8$var$et]);
    var a = (t = $a2acea4f3420f1d8$var$fr(s, e)) === $a2acea4f3420f1d8$var$j ? 7 : 0 | t[$a2acea4f3420f1d8$var$et], h = $a2acea4f3420f1d8$var$pr(a, o), u = !(4 & h);
    if (u) {
        4 & h && (t = $a2acea4f3420f1d8$var$Vt(t), a = 0, h = $a2acea4f3420f1d8$var$Nr(h, o), o = $a2acea4f3420f1d8$var$hr(s, o, e, t));
        let n = 0, i = 0;
        for(; n < t.length; n++){
            let e = r(t[n]);
            null != e && (t[i++] = e);
        }
        i < n && (t.length = i), r = -513 & h | 4, h = r &= -1025, h &= -4097;
    }
    return h !== a && ($a2acea4f3420f1d8$var$it(t, h), 2 & h && Object.freeze(t)), $a2acea4f3420f1d8$var$dr(t, h, s, o, e, n, u, i);
}
function $a2acea4f3420f1d8$var$dr(t, e, r, n, i, s, o, a) {
    var h = e;
    return 1 === s || 4 === s && (2 & e || !(16 & e) && 32 & n) ? $a2acea4f3420f1d8$var$gr(e) || ((e |= !t.length || o && !(4096 & e) || 32 & n && !(4096 & e || 16 & e) ? 2 : 256) !== h && $a2acea4f3420f1d8$var$it(t, e), Object.freeze(t)) : (2 === s && $a2acea4f3420f1d8$var$gr(e) && (t = $a2acea4f3420f1d8$var$Vt(t), h = 0, e = $a2acea4f3420f1d8$var$Nr(e, n), n = $a2acea4f3420f1d8$var$hr(r, n, i, t)), $a2acea4f3420f1d8$var$gr(e) || (a || (e |= 16), e !== h && $a2acea4f3420f1d8$var$it(t, e))), 2 & e || !(4096 & e || 16 & e) || $a2acea4f3420f1d8$var$er(r, n), t;
}
function $a2acea4f3420f1d8$var$fr(t, e, r) {
    return t = $a2acea4f3420f1d8$var$or(t, e, r), Array.isArray(t) ? t : $a2acea4f3420f1d8$var$j;
}
function $a2acea4f3420f1d8$var$pr(t, e) {
    return 2 & e && (t |= 2), 1 | t;
}
function $a2acea4f3420f1d8$var$gr(t) {
    return !!(2 & t) && !!(4 & t) || !!(256 & t);
}
function $a2acea4f3420f1d8$var$mr(t) {
    return $a2acea4f3420f1d8$var$ct(t, !0);
}
function $a2acea4f3420f1d8$var$vr(t) {
    t = $a2acea4f3420f1d8$var$Vt(t);
    for(let e = 0; e < t.length; e++){
        let r = t[e] = $a2acea4f3420f1d8$var$Vt(t[e]);
        Array.isArray(r[1]) && (r[1] = $a2acea4f3420f1d8$var$st(r[1]));
    }
    return $a2acea4f3420f1d8$var$ot(t);
}
function $a2acea4f3420f1d8$var$_r(t, e, r, n) {
    $a2acea4f3420f1d8$var$tr(t), $a2acea4f3420f1d8$var$hr(t = t.A, 0 | t[$a2acea4f3420f1d8$var$et], e, ("0" === n ? 0 === Number(r) : r === n) ? void 0 : r);
}
function $a2acea4f3420f1d8$var$yr(t, e, r) {
    if (2 & e) throw Error();
    var n = $a2acea4f3420f1d8$var$gt(e), i = $a2acea4f3420f1d8$var$fr(t, r, n), s = i === $a2acea4f3420f1d8$var$j ? 7 : 0 | i[$a2acea4f3420f1d8$var$et], o = $a2acea4f3420f1d8$var$pr(s, e);
    return (2 & o || $a2acea4f3420f1d8$var$gr(o) || 16 & o) && (o === s || $a2acea4f3420f1d8$var$gr(o) || $a2acea4f3420f1d8$var$it(i, o), i = $a2acea4f3420f1d8$var$Vt(i), s = 0, o = $a2acea4f3420f1d8$var$Nr(o, e), $a2acea4f3420f1d8$var$hr(t, e, r, i, n)), (o &= -13) !== s && $a2acea4f3420f1d8$var$it(i, o), i;
}
function $a2acea4f3420f1d8$var$Er(t, e) {
    return $a2acea4f3420f1d8$var$br($a2acea4f3420f1d8$var$Ar(t = t.A), t, void 0, e);
}
function $a2acea4f3420f1d8$var$Ar(t) {
    if ($a2acea4f3420f1d8$var$B) return t[$a2acea4f3420f1d8$var$K] ?? (t[$a2acea4f3420f1d8$var$K] = new Map);
    if ($a2acea4f3420f1d8$var$K in t) return t[$a2acea4f3420f1d8$var$K];
    var e = new Map;
    return Object.defineProperty(t, $a2acea4f3420f1d8$var$K, {
        value: e
    }), e;
}
function $a2acea4f3420f1d8$var$wr(t, e, r, n, i) {
    var s = $a2acea4f3420f1d8$var$Ar(t), o = $a2acea4f3420f1d8$var$br(s, t, e, r, i);
    return o !== n && (o && (e = $a2acea4f3420f1d8$var$hr(t, e, o, void 0, i)), s.set(r, n)), e;
}
function $a2acea4f3420f1d8$var$br(t, e, r, n, i) {
    var s = t.get(n);
    if (null != s) return s;
    s = 0;
    for(let t = 0; t < n.length; t++){
        let o = n[t];
        null != $a2acea4f3420f1d8$var$or(e, o, i) && (0 !== s && (r = $a2acea4f3420f1d8$var$hr(e, r, s, void 0, i)), s = o);
    }
    return t.set(n, s), s;
}
function $a2acea4f3420f1d8$var$Tr(t, e, r) {
    var n = 0 | t[$a2acea4f3420f1d8$var$et], i = $a2acea4f3420f1d8$var$gt(n), s = $a2acea4f3420f1d8$var$or(t, r, i);
    if (null != s && s[$a2acea4f3420f1d8$var$J] === $a2acea4f3420f1d8$var$at) {
        if (!$a2acea4f3420f1d8$var$ht(s)) return $a2acea4f3420f1d8$var$Qe(s), s.A;
        var o = s.A;
    } else Array.isArray(s) && (o = s);
    if (o) {
        let t = 0 | o[$a2acea4f3420f1d8$var$et];
        2 & t && (o = $a2acea4f3420f1d8$var$Je(o, t));
    }
    return (o = $a2acea4f3420f1d8$var$Ke(o, e)) !== s && $a2acea4f3420f1d8$var$hr(t, n, r, o, i), o;
}
function $a2acea4f3420f1d8$var$kr(t, e, r, n, i) {
    var s = !1;
    if (null != (n = $a2acea4f3420f1d8$var$or(t, n, i, (t)=>{
        var n = $a2acea4f3420f1d8$var$ye(t, r, !1, e);
        return s = n !== t && null != n, n;
    }))) return s && !$a2acea4f3420f1d8$var$ht(n) && $a2acea4f3420f1d8$var$er(t, e), n;
}
function $a2acea4f3420f1d8$var$Sr(t, e, r, n) {
    var i = t.A, s = 0 | i[$a2acea4f3420f1d8$var$et];
    if (null == (e = $a2acea4f3420f1d8$var$kr(i, s, e, r, n))) return e;
    if (!$a2acea4f3420f1d8$var$ht(t, s = 0 | i[$a2acea4f3420f1d8$var$et])) {
        let o = $a2acea4f3420f1d8$var$Ze(e);
        o !== e && ($a2acea4f3420f1d8$var$Qe(t) && (s = 0 | (i = t.A)[$a2acea4f3420f1d8$var$et]), $a2acea4f3420f1d8$var$er(i, s = $a2acea4f3420f1d8$var$hr(i, s, r, e = o, n)));
    }
    return e;
}
function $a2acea4f3420f1d8$var$Lr(t, e, r, n, i, s, o, a) {
    var h = $a2acea4f3420f1d8$var$ht(t, r);
    s = h ? 1 : s, o = !!o || 3 === s, h = a && !h, (2 === s || h) && $a2acea4f3420f1d8$var$Qe(t) && (r = 0 | (e = t.A)[$a2acea4f3420f1d8$var$et]);
    var u = (t = $a2acea4f3420f1d8$var$fr(e, i)) === $a2acea4f3420f1d8$var$j ? 7 : 0 | t[$a2acea4f3420f1d8$var$et], c = $a2acea4f3420f1d8$var$pr(u, r);
    if (a = !(4 & c)) {
        var l = t, d = r;
        let e = !!(2 & c);
        e && (d |= 2);
        let i = !e, s = !0, o = 0, a = 0;
        for(; o < l.length; o++){
            let t = $a2acea4f3420f1d8$var$ye(l[o], n, !1, d);
            if (t instanceof n) {
                if (!e) {
                    let e = $a2acea4f3420f1d8$var$ht(t);
                    i &&= !e, s &&= e;
                }
                l[a++] = t;
            }
        }
        a < o && (l.length = a), c |= 4, c = s ? -4097 & c : 4096 | c, c = i ? 8 | c : -9 & c;
    }
    if (c !== u && ($a2acea4f3420f1d8$var$it(t, c), 2 & c && Object.freeze(t)), h && !(8 & c || !t.length && (1 === s || 4 === s && (2 & c || !(16 & c) && 32 & r)))) {
        for($a2acea4f3420f1d8$var$gr(c) && (t = $a2acea4f3420f1d8$var$Vt(t), c = $a2acea4f3420f1d8$var$Nr(c, r), r = $a2acea4f3420f1d8$var$hr(e, r, i, t)), n = t, h = c, u = 0; u < n.length; u++)(l = n[u]) !== (c = $a2acea4f3420f1d8$var$Ze(l)) && (n[u] = c);
        h |= 8, $a2acea4f3420f1d8$var$it(t, c = h = n.length ? 4096 | h : -4097 & h);
    }
    return $a2acea4f3420f1d8$var$dr(t, c, e, r, i, s, a, o);
}
function $a2acea4f3420f1d8$var$xr(t, e, r) {
    var n = t.A;
    return $a2acea4f3420f1d8$var$Lr(t, n, 0 | n[$a2acea4f3420f1d8$var$et], e, r, $a2acea4f3420f1d8$var$cr(), !1, !0);
}
function $a2acea4f3420f1d8$var$Rr(t) {
    return null == t && (t = void 0), t;
}
function $a2acea4f3420f1d8$var$Ir(t, e, r, n, i) {
    return $a2acea4f3420f1d8$var$ar(t, r, n = $a2acea4f3420f1d8$var$Rr(n), i), n && !$a2acea4f3420f1d8$var$ht(n) && $a2acea4f3420f1d8$var$er(t.A), t;
}
function $a2acea4f3420f1d8$var$Fr(t, e, r, n) {
    t: {
        var i = n = $a2acea4f3420f1d8$var$Rr(n);
        $a2acea4f3420f1d8$var$tr(t);
        let s = t.A, o = 0 | s[$a2acea4f3420f1d8$var$et];
        if (null == i) {
            let t = $a2acea4f3420f1d8$var$Ar(s);
            if ($a2acea4f3420f1d8$var$br(t, s, o, r) !== e) break t;
            t.set(r, 0);
        } else o = $a2acea4f3420f1d8$var$wr(s, o, r, e);
        $a2acea4f3420f1d8$var$hr(s, o, e, i);
    }
    return n && !$a2acea4f3420f1d8$var$ht(n) && $a2acea4f3420f1d8$var$er(t.A), t;
}
function $a2acea4f3420f1d8$var$Cr(t, e, r) {
    $a2acea4f3420f1d8$var$tr(t);
    var n = t.A, i = 0 | n[$a2acea4f3420f1d8$var$et];
    if (null == r) return $a2acea4f3420f1d8$var$hr(n, i, e), t;
    var s = r === $a2acea4f3420f1d8$var$j ? 7 : 0 | r[$a2acea4f3420f1d8$var$et], o = s, a = $a2acea4f3420f1d8$var$gr(s), h = a || Object.isFrozen(r), u = !0, c = !0;
    for(let t = 0; t < r.length; t++){
        var l = r[t];
        a || (l = $a2acea4f3420f1d8$var$ht(l), u &&= !l, c &&= l);
    }
    return a || (s = u ? 13 : 5, s = c ? -4097 & s : 4096 | s), h && s === o || (r = $a2acea4f3420f1d8$var$Vt(r), o = 0, s = $a2acea4f3420f1d8$var$Nr(s, i)), s !== o && $a2acea4f3420f1d8$var$it(r, s), i = $a2acea4f3420f1d8$var$hr(n, i, e, r), 2 & s || !(4096 & s || 16 & s) || $a2acea4f3420f1d8$var$er(n, i), t;
}
function $a2acea4f3420f1d8$var$Nr(t, e) {
    return -273 & (2 & e ? 2 | t : -3 & t);
}
function $a2acea4f3420f1d8$var$Mr(t, e, r, n) {
    var i = n;
    $a2acea4f3420f1d8$var$tr(t), t = $a2acea4f3420f1d8$var$Lr(t, n = t.A, 0 | n[$a2acea4f3420f1d8$var$et], r, e, 2, !0), i = null != i ? i : new r, t.push(i), e = r = t === $a2acea4f3420f1d8$var$j ? 7 : 0 | t[$a2acea4f3420f1d8$var$et], (i = $a2acea4f3420f1d8$var$ht(i)) ? (r &= -9, 1 === t.length && (r &= -4097)) : r |= 4096, r !== e && $a2acea4f3420f1d8$var$it(t, r), i || $a2acea4f3420f1d8$var$er(n);
}
function $a2acea4f3420f1d8$var$Or(t, e, r) {
    return $a2acea4f3420f1d8$var$re($a2acea4f3420f1d8$var$sr(t, e, r));
}
function $a2acea4f3420f1d8$var$Dr(t, e) {
    return $a2acea4f3420f1d8$var$sr(t, e, void 0, $a2acea4f3420f1d8$var$Jt) ?? 0;
}
function $a2acea4f3420f1d8$var$Pr(t, e, r) {
    return $a2acea4f3420f1d8$var$Sr(t, e, r = $a2acea4f3420f1d8$var$Er(t, $a2acea4f3420f1d8$var$Uo) === r ? r : -1, void 0);
}
function $a2acea4f3420f1d8$var$$r(t, e) {
    $a2acea4f3420f1d8$var$_r(t, 3, null == e ? e : $a2acea4f3420f1d8$var$Zt(e), !1);
}
function $a2acea4f3420f1d8$var$Ur(t, e, r) {
    if (null != r) {
        if ("number" != typeof r) throw $a2acea4f3420f1d8$var$P("int32");
        if (!$a2acea4f3420f1d8$var$Wt(r)) throw $a2acea4f3420f1d8$var$P("int32");
        r |= 0;
    }
    $a2acea4f3420f1d8$var$ar(t, e, r);
}
function $a2acea4f3420f1d8$var$Br(t, e, r) {
    return $a2acea4f3420f1d8$var$ar(t, e, null == r ? r : $a2acea4f3420f1d8$var$ie(r));
}
function $a2acea4f3420f1d8$var$Gr(t, e, r) {
    return $a2acea4f3420f1d8$var$ar(t, e, null == r ? r : function(t) {
        if (!$a2acea4f3420f1d8$var$te(t)) throw $a2acea4f3420f1d8$var$P("uint64");
        switch(typeof t){
            case "string":
                var e = $a2acea4f3420f1d8$var$zt(Number(t));
                return $a2acea4f3420f1d8$var$Xt(e) && e >= 0 ? t = $a2acea4f3420f1d8$var$At(e) : (-1 !== (e = t.indexOf(".")) && (t = t.substring(0, e)), t = $a2acea4f3420f1d8$var$U() ? $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$Kt(64, BigInt(t))) : $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$oe(t))), t;
            case "bigint":
                return $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$Kt(64, t));
            default:
                return $a2acea4f3420f1d8$var$Xt(t) ? t = $a2acea4f3420f1d8$var$At($a2acea4f3420f1d8$var$he(t)) : ((t = $a2acea4f3420f1d8$var$zt(t)) >= 0 && $a2acea4f3420f1d8$var$Xt(t) ? t = String(t) : ($a2acea4f3420f1d8$var$Nt(t), t = $a2acea4f3420f1d8$var$$t($a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft)), t = $a2acea4f3420f1d8$var$At(t)), t;
        }
    }(r));
}
function $a2acea4f3420f1d8$var$jr(t, e, r) {
    $a2acea4f3420f1d8$var$ar(t, e, null == r ? r : $a2acea4f3420f1d8$var$qt(r));
}
function $a2acea4f3420f1d8$var$Vr(t, e, r) {
    $a2acea4f3420f1d8$var$_r(t, e, null == r ? r : $a2acea4f3420f1d8$var$qt(r), 0);
}
function $a2acea4f3420f1d8$var$Hr(t, e, r) {
    $a2acea4f3420f1d8$var$_r(t, e, $a2acea4f3420f1d8$var$ve(r), "");
}
function $a2acea4f3420f1d8$var$Kr(t, e, r) {
    {
        $a2acea4f3420f1d8$var$tr(t);
        let o = t.A, a = 0 | o[$a2acea4f3420f1d8$var$et];
        if (null == r) $a2acea4f3420f1d8$var$hr(o, a, e);
        else {
            var n = t = r === $a2acea4f3420f1d8$var$j ? 7 : 0 | r[$a2acea4f3420f1d8$var$et], i = $a2acea4f3420f1d8$var$gr(t), s = i || Object.isFrozen(r);
            for(i || (t = 0), s || (r = $a2acea4f3420f1d8$var$Vt(r), n = 0, t = $a2acea4f3420f1d8$var$Nr(t, a), s = !1), t |= 5, t |= (4 & t ? 512 & t ? 512 : 1024 & t ? 1024 : 0 : void 0) ?? 1024, i = 0; i < r.length; i++){
                let e = r[i], o = $a2acea4f3420f1d8$var$me(e);
                Object.is(e, o) || (s && (r = $a2acea4f3420f1d8$var$Vt(r), n = 0, t = $a2acea4f3420f1d8$var$Nr(t, a), s = !1), r[i] = o);
            }
            t !== n && (s && (r = $a2acea4f3420f1d8$var$Vt(r), t = $a2acea4f3420f1d8$var$Nr(t, a)), $a2acea4f3420f1d8$var$it(r, t)), $a2acea4f3420f1d8$var$hr(o, a, e, r);
        }
    }
}
function $a2acea4f3420f1d8$var$Xr(t, e, r) {
    $a2acea4f3420f1d8$var$tr(t), $a2acea4f3420f1d8$var$lr(t, e, $a2acea4f3420f1d8$var$_e, 2, !0).push($a2acea4f3420f1d8$var$me(r));
}
var $a2acea4f3420f1d8$var$Wr = class {
    constructor(t, e, r){
        if (this.buffer = t, r && !e) throw Error();
        this.g = e;
    }
};
function $a2acea4f3420f1d8$var$zr(t, e) {
    if ("string" == typeof t) return new $a2acea4f3420f1d8$var$Wr($a2acea4f3420f1d8$var$L(t), e);
    if (Array.isArray(t)) return new $a2acea4f3420f1d8$var$Wr(new Uint8Array(t), e);
    if (t.constructor === Uint8Array) return new $a2acea4f3420f1d8$var$Wr(t, !1);
    if (t.constructor === ArrayBuffer) return t = new Uint8Array(t), new $a2acea4f3420f1d8$var$Wr(t, !1);
    if (t.constructor === $a2acea4f3420f1d8$var$N) return e = $a2acea4f3420f1d8$var$F(t) || new Uint8Array(0), new $a2acea4f3420f1d8$var$Wr(e, !0, t);
    if (t instanceof Uint8Array) return t = t.constructor === Uint8Array ? t : new Uint8Array(t.buffer, t.byteOffset, t.byteLength), new $a2acea4f3420f1d8$var$Wr(t, !1);
    throw Error();
}
function $a2acea4f3420f1d8$var$Yr(t, e) {
    var r = 0, n = 0, i = 0, s = t.h, o = t.g;
    do {
        var a = s[o++];
        r |= (127 & a) << i, i += 7;
    }while (i < 32 && 128 & a);
    if (i > 32) for(n |= (127 & a) >> 4, i = 3; i < 32 && 128 & a; i += 7)n |= (127 & (a = s[o++])) << i;
    if ($a2acea4f3420f1d8$var$nn(t, o), !(128 & a)) return e(r >>> 0, n >>> 0);
    throw Error();
}
function $a2acea4f3420f1d8$var$qr(t) {
    for(var e = 0, r = t.g, n = r + 10, i = t.h; r < n;){
        let n = i[r++];
        if (e |= n, !(128 & n)) return $a2acea4f3420f1d8$var$nn(t, r), !!(127 & e);
    }
    throw Error();
}
function $a2acea4f3420f1d8$var$Jr(t) {
    var e = t.h, r = t.g, n = e[r++], i = 127 & n;
    if (128 & n && (i |= (127 & (n = e[r++])) << 7, 128 & n && (i |= (127 & (n = e[r++])) << 14, 128 & n && (i |= (127 & (n = e[r++])) << 21, 128 & n && (i |= (n = e[r++]) << 28, 128 & n && 128 & e[r++] && 128 & e[r++] && 128 & e[r++] && 128 & e[r++] && 128 & e[r++]))))) throw Error();
    return $a2acea4f3420f1d8$var$nn(t, r), i;
}
function $a2acea4f3420f1d8$var$Zr(t) {
    return $a2acea4f3420f1d8$var$Jr(t) >>> 0;
}
function $a2acea4f3420f1d8$var$Qr(t) {
    return $a2acea4f3420f1d8$var$Yr(t, $a2acea4f3420f1d8$var$Pt);
}
function $a2acea4f3420f1d8$var$tn(t) {
    var e = t.h, r = t.g, n = e[r], i = e[r + 1], s = e[r + 2];
    return e = e[r + 3], $a2acea4f3420f1d8$var$nn(t, t.g + 4), (n | i << 8 | s << 16 | e << 24) >>> 0;
}
function $a2acea4f3420f1d8$var$en(t) {
    var e = $a2acea4f3420f1d8$var$tn(t);
    t = 2 * (e >> 31) + 1;
    var r = e >>> 23 & 255;
    return e &= 8388607, 255 == r ? e ? NaN : t * (1 / 0) : 0 == r ? 1401298464324817e-60 * t * e : t * Math.pow(2, r - 150) * (e + 8388608);
}
function $a2acea4f3420f1d8$var$rn(t) {
    return $a2acea4f3420f1d8$var$Jr(t);
}
function $a2acea4f3420f1d8$var$nn(t, e) {
    if (t.g = e, e > t.j) throw Error();
}
function $a2acea4f3420f1d8$var$sn(t, e) {
    if (e < 0) throw Error();
    var r = t.g;
    if ((e = r + e) > t.j) throw Error();
    return t.g = e, r;
}
function $a2acea4f3420f1d8$var$on(t, e) {
    if (0 == e) return $a2acea4f3420f1d8$var$I();
    var r = $a2acea4f3420f1d8$var$sn(t, e);
    return t.fa && t.o ? r = t.h.subarray(r, r + e) : (t = t.h, r = r === (e = r + e) ? new Uint8Array(0) : $a2acea4f3420f1d8$var$Rt ? t.slice(r, e) : new Uint8Array(t.subarray(r, e))), 0 == r.length ? $a2acea4f3420f1d8$var$I() : new $a2acea4f3420f1d8$var$N(r, $a2acea4f3420f1d8$var$R);
}
var $a2acea4f3420f1d8$var$an = class {
    constructor(t, e, r, n){
        this.h = null, this.o = !1, this.g = this.j = this.m = 0, this.init(t, e, r, n);
    }
    init(t, e, r, { fa: n = !1, ma: i = !1 } = {}) {
        this.fa = n, this.ma = i, t && (t = $a2acea4f3420f1d8$var$zr(t, this.ma), this.h = t.buffer, this.o = t.g, this.m = e || 0, this.j = void 0 !== r ? this.m + r : this.h.length, this.g = this.m);
    }
    clear() {
        this.h = null, this.o = !1, this.g = this.j = this.m = 0, this.fa = !1;
    }
}, $a2acea4f3420f1d8$var$hn = [], $a2acea4f3420f1d8$var$un = 0;
function $a2acea4f3420f1d8$var$cn(t, e, r, n) {
    if ($a2acea4f3420f1d8$var$En.length) {
        let i = $a2acea4f3420f1d8$var$En.pop();
        return i.v(n), i.g.init(t, e, r, n), i;
    }
    return new $a2acea4f3420f1d8$var$yn(t, e, r, n);
}
function $a2acea4f3420f1d8$var$ln(t) {
    t.g.clear(), t.j = -1, t.h = -1, $a2acea4f3420f1d8$var$En.length < 100 && $a2acea4f3420f1d8$var$En.push(t);
}
function $a2acea4f3420f1d8$var$dn(t) {
    var e = t.g;
    if (e.g == e.j) return !1;
    t.m = t.g.g;
    var r = $a2acea4f3420f1d8$var$Zr(t.g);
    if (e = r >>> 3, !((r &= 7) >= 0 && r <= 5)) throw Error();
    if (e < 1) throw Error();
    return t.j = e, t.h = r, !0;
}
function $a2acea4f3420f1d8$var$fn(t) {
    try {
        switch(t.h){
            case 0:
                0 != t.h ? $a2acea4f3420f1d8$var$fn(t) : $a2acea4f3420f1d8$var$qr(t.g);
                break;
            case 1:
                var e = t.g;
                $a2acea4f3420f1d8$var$nn(e, e.g + 8);
                break;
            case 2:
                if (2 != t.h) $a2acea4f3420f1d8$var$fn(t);
                else {
                    var r = $a2acea4f3420f1d8$var$Zr(t.g), n = t.g;
                    $a2acea4f3420f1d8$var$nn(n, n.g + r);
                }
                break;
            case 5:
                var i = t.g;
                $a2acea4f3420f1d8$var$nn(i, i.g + 4);
                break;
            case 3:
                $a2acea4f3420f1d8$var$pn();
                let s = t.j;
                try {
                    for(;;){
                        if (!$a2acea4f3420f1d8$var$dn(t)) throw Error();
                        if (4 == t.h) {
                            if (t.j != s) throw Error();
                            break;
                        }
                        $a2acea4f3420f1d8$var$fn(t);
                    }
                } catch (t) {
                    if (t instanceof RangeError) throw new SyntaxError;
                    throw t;
                } finally{
                    $a2acea4f3420f1d8$var$un > 0 && $a2acea4f3420f1d8$var$un--;
                }
                break;
            default:
                throw Error();
        }
    } catch (t) {
        if (t instanceof RangeError) throw new SyntaxError;
        throw t;
    }
}
function $a2acea4f3420f1d8$var$pn() {
    if ($a2acea4f3420f1d8$var$un >= 100) throw new SyntaxError;
    $a2acea4f3420f1d8$var$un++;
}
function $a2acea4f3420f1d8$var$gn(t, e, r) {
    var n = t.g.j, i = $a2acea4f3420f1d8$var$Zr(t.g), s = (i = t.g.g + i) - n;
    if (s <= 0 && (t.g.j = i, r(e, t, void 0, void 0, void 0), s = i - t.g.g), s) throw Error();
    return t.g.g = i, t.g.j = n, e;
}
function $a2acea4f3420f1d8$var$mn(t) {
    var e = $a2acea4f3420f1d8$var$Zr(t.g), r = $a2acea4f3420f1d8$var$sn(t = t.g, e);
    if (t = t.h, $a2acea4f3420f1d8$var$h) {
        var o, u = t;
        (o = $a2acea4f3420f1d8$var$s) || (o = $a2acea4f3420f1d8$var$s = new TextDecoder("utf-8", {
            fatal: !0
        })), e = r + e, u = 0 === r && e === u.length ? u : u.subarray(r, e);
        try {
            var c = o.decode(u);
        } catch (t) {
            if (void 0 === $a2acea4f3420f1d8$var$a) {
                try {
                    o.decode(new Uint8Array([
                        128
                    ]));
                } catch (t) {}
                try {
                    o.decode(new Uint8Array([
                        97
                    ])), $a2acea4f3420f1d8$var$a = !0;
                } catch (t) {
                    $a2acea4f3420f1d8$var$a = !1;
                }
            }
            throw !$a2acea4f3420f1d8$var$a && ($a2acea4f3420f1d8$var$s = void 0), t;
        }
    } else {
        e = (c = r) + e, r = [];
        let s, a = null;
        for(; c < e;){
            var l = t[c++];
            l < 128 ? r.push(l) : l < 224 ? c >= e ? $a2acea4f3420f1d8$var$n() : (s = t[c++], l < 194 || 128 != (192 & s) ? (c--, $a2acea4f3420f1d8$var$n()) : r.push((31 & l) << 6 | 63 & s)) : l < 240 ? c >= e - 1 ? $a2acea4f3420f1d8$var$n() : (s = t[c++], 128 != (192 & s) || 224 === l && s < 160 || 237 === l && s >= 160 || 128 != (192 & (o = t[c++])) ? (c--, $a2acea4f3420f1d8$var$n()) : r.push((15 & l) << 12 | (63 & s) << 6 | 63 & o)) : l <= 244 ? c >= e - 2 ? $a2acea4f3420f1d8$var$n() : (s = t[c++], 128 != (192 & s) || s - 144 + (l << 28) >> 30 || 128 != (192 & (o = t[c++])) || 128 != (192 & (u = t[c++])) ? (c--, $a2acea4f3420f1d8$var$n()) : (l = (7 & l) << 18 | (63 & s) << 12 | (63 & o) << 6 | 63 & u, l -= 65536, r.push(55296 + (l >> 10 & 1023), 56320 + (1023 & l)))) : $a2acea4f3420f1d8$var$n(), r.length >= 8192 && (a = $a2acea4f3420f1d8$var$i(a, r), r.length = 0);
        }
        c = $a2acea4f3420f1d8$var$i(a, r);
    }
    return c;
}
function $a2acea4f3420f1d8$var$vn(t) {
    var e = $a2acea4f3420f1d8$var$Zr(t.g);
    return $a2acea4f3420f1d8$var$on(t.g, e);
}
function $a2acea4f3420f1d8$var$_n(t, e, r) {
    var n = $a2acea4f3420f1d8$var$Zr(t.g);
    for(n = t.g.g + n; t.g.g < n;)r.push(e(t.g));
}
var $a2acea4f3420f1d8$var$yn = class {
    constructor(t, e, r, n){
        if ($a2acea4f3420f1d8$var$hn.length) {
            let i = $a2acea4f3420f1d8$var$hn.pop();
            i.init(t, e, r, n), t = i;
        } else t = new $a2acea4f3420f1d8$var$an(t, e, r, n);
        this.g = t, this.m = this.g.g, this.h = this.j = -1, this.v(n);
    }
    v({ ra: t = !1 } = {}) {
        this.ra = t;
    }
}, $a2acea4f3420f1d8$var$En = [];
function $a2acea4f3420f1d8$var$An(t) {
    return new $a2acea4f3420f1d8$var$Tn(4294967295 & t, Math.floor(t / 4294967296));
}
function $a2acea4f3420f1d8$var$wn(t) {
    return t ? /^\d+$/.test(t) ? ($a2acea4f3420f1d8$var$Gt(t), new $a2acea4f3420f1d8$var$Tn($a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft)) : null : $a2acea4f3420f1d8$var$bn ||= new $a2acea4f3420f1d8$var$Tn(0, 0);
}
var $a2acea4f3420f1d8$var$bn, $a2acea4f3420f1d8$var$Tn = class {
    constructor(t, e){
        this.h = t >>> 0, this.g = e >>> 0;
    }
};
function $a2acea4f3420f1d8$var$kn(t) {
    return new $a2acea4f3420f1d8$var$On(4294967295 & t, Math.floor(t / 4294967296));
}
function $a2acea4f3420f1d8$var$Sn(t) {
    return t ? /^-?\d+$/.test(t) ? ($a2acea4f3420f1d8$var$Gt(t), new $a2acea4f3420f1d8$var$On($a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft)) : null : $a2acea4f3420f1d8$var$Ln ||= new $a2acea4f3420f1d8$var$On(0, 0);
}
var $a2acea4f3420f1d8$var$Ln, $a2acea4f3420f1d8$var$xn, $a2acea4f3420f1d8$var$Rn, $a2acea4f3420f1d8$var$In, $a2acea4f3420f1d8$var$Fn, $a2acea4f3420f1d8$var$Cn, $a2acea4f3420f1d8$var$Nn, $a2acea4f3420f1d8$var$Mn, $a2acea4f3420f1d8$var$On = class {
    constructor(t, e){
        this.h = t >>> 0, this.g = e >>> 0;
    }
};
function $a2acea4f3420f1d8$var$Dn(t, e, r) {
    return "undefined" != typeof BigInt64Array ? ($a2acea4f3420f1d8$var$Nn || ($a2acea4f3420f1d8$var$Nn = new BigInt64Array(1), $a2acea4f3420f1d8$var$Mn = new Uint32Array($a2acea4f3420f1d8$var$Nn.buffer), $a2acea4f3420f1d8$var$Nn[0] = BigInt(1), $a2acea4f3420f1d8$var$Cn = 1 === $a2acea4f3420f1d8$var$Mn[0]), $a2acea4f3420f1d8$var$Nn[0] = t, new e($a2acea4f3420f1d8$var$Mn[t = $a2acea4f3420f1d8$var$Cn ? 0 : 1], $a2acea4f3420f1d8$var$Mn[1 - t])) : ($a2acea4f3420f1d8$var$Fn || ($a2acea4f3420f1d8$var$xn = BigInt(Number.MIN_SAFE_INTEGER), $a2acea4f3420f1d8$var$Rn = BigInt(Number.MAX_SAFE_INTEGER), $a2acea4f3420f1d8$var$In = BigInt(4294967295), $a2acea4f3420f1d8$var$Fn = BigInt(32)), t >= $a2acea4f3420f1d8$var$xn && t <= $a2acea4f3420f1d8$var$Rn ? r(Number(t)) : (t = BigInt.asUintN(64, t), new e(Number(t & $a2acea4f3420f1d8$var$In), Number(t >> $a2acea4f3420f1d8$var$Fn))));
}
function $a2acea4f3420f1d8$var$Pn(t, e, r) {
    for(; r > 0 || e > 127;)t.g.push(127 & e | 128), e = (e >>> 7 | r << 25) >>> 0, r >>>= 7;
    t.g.push(e);
}
function $a2acea4f3420f1d8$var$$n(t, e) {
    for(; e > 127;)t.g.push(127 & e | 128), e >>>= 7;
    t.g.push(e);
}
function $a2acea4f3420f1d8$var$Un(t, e) {
    if (e >= 0) $a2acea4f3420f1d8$var$$n(t, e);
    else {
        for(let r = 0; r < 9; r++)t.g.push(127 & e | 128), e >>= 7;
        t.g.push(1);
    }
}
function $a2acea4f3420f1d8$var$Bn(t, e) {
    $a2acea4f3420f1d8$var$Gt(e), function(t) {
        var e = $a2acea4f3420f1d8$var$Ft >> 31;
        t($a2acea4f3420f1d8$var$It << 1 ^ e, ($a2acea4f3420f1d8$var$Ft << 1 | $a2acea4f3420f1d8$var$It >>> 31) ^ e);
    }((e, r)=>{
        $a2acea4f3420f1d8$var$Pn(t, e >>> 0, r >>> 0);
    });
}
function $a2acea4f3420f1d8$var$Gn(t, e) {
    t.g.push(e >>> 0 & 255), t.g.push(e >>> 8 & 255), t.g.push(e >>> 16 & 255), t.g.push(e >>> 24 & 255);
}
var $a2acea4f3420f1d8$var$jn = class {
    constructor(){
        this.g = [];
    }
    length() {
        return this.g.length;
    }
    end() {
        var t = this.g;
        return this.g = [], t;
    }
};
function $a2acea4f3420f1d8$var$Vn(t, e) {
    0 !== e.length && (t.j.push(e), t.h += e.length);
}
function $a2acea4f3420f1d8$var$Hn(t, e, r) {
    $a2acea4f3420f1d8$var$$n(t.g, 8 * e + r);
}
function $a2acea4f3420f1d8$var$Kn(t, e) {
    return $a2acea4f3420f1d8$var$Hn(t, e, 2), e = t.g.end(), $a2acea4f3420f1d8$var$Vn(t, e), e.push(t.h), e;
}
function $a2acea4f3420f1d8$var$Xn(t, e) {
    var r = e.pop();
    for(r = t.h + t.g.length() - r; r > 127;)e.push(127 & r | 128), r >>>= 7, t.h++;
    e.push(r), t.h++;
}
function $a2acea4f3420f1d8$var$Wn(t, e, r) {
    if (null != r) switch($a2acea4f3420f1d8$var$Hn(t, e, 0), typeof r){
        case "number":
            t = t.g, $a2acea4f3420f1d8$var$Nt(r), $a2acea4f3420f1d8$var$Pn(t, $a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft);
            break;
        case "bigint":
            r = $a2acea4f3420f1d8$var$Dn(r, $a2acea4f3420f1d8$var$On, $a2acea4f3420f1d8$var$kn), $a2acea4f3420f1d8$var$Pn(t.g, r.h, r.g);
            break;
        default:
            r = $a2acea4f3420f1d8$var$Sn(r), $a2acea4f3420f1d8$var$Pn(t.g, r.h, r.g);
    }
}
function $a2acea4f3420f1d8$var$zn(t, e, r) {
    $a2acea4f3420f1d8$var$Hn(t, e, 2), $a2acea4f3420f1d8$var$$n(t.g, r.length), $a2acea4f3420f1d8$var$Vn(t, t.g.end()), $a2acea4f3420f1d8$var$Vn(t, r);
}
function $a2acea4f3420f1d8$var$Yn(t, e, r, n) {
    null != r && (e = $a2acea4f3420f1d8$var$Kn(t, e), n(r, t), $a2acea4f3420f1d8$var$Xn(t, e));
}
var $a2acea4f3420f1d8$var$qn = class {
    constructor(){
        this.j = [], this.h = 0, this.g = new $a2acea4f3420f1d8$var$jn;
    }
};
function $a2acea4f3420f1d8$var$Jn(t) {
    if ("string" == typeof t) $a2acea4f3420f1d8$var$Sn(t);
}
function $a2acea4f3420f1d8$var$Zn() {
    var t = class {
        constructor(){
            throw Error();
        }
    };
    return Object.setPrototypeOf(t, t.prototype), t;
}
var $a2acea4f3420f1d8$var$Qn = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$ti = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$ei = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$ri = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$ni = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$ii = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$si = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$oi = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$ai = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$hi = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$ui = $a2acea4f3420f1d8$var$Zn(), $a2acea4f3420f1d8$var$ci = $a2acea4f3420f1d8$var$Zn();
function $a2acea4f3420f1d8$var$li(t, e, r) {
    var n = t.A;
    $a2acea4f3420f1d8$var$X && $a2acea4f3420f1d8$var$X in n && (n = n[$a2acea4f3420f1d8$var$X]) && delete n[e.g], e.h ? e.o(t, e.h, e.g, r, e.j) : e.o(t, e.g, r, e.j);
}
var $a2acea4f3420f1d8$var$di = class {
    constructor(t, e){
        this.A = $a2acea4f3420f1d8$var$Xe(t, e, void 0, 2048);
    }
    toJSON() {
        return $a2acea4f3420f1d8$var$He(this);
    }
    o() {
        var t = $a2acea4f3420f1d8$var$Ca, e = this.A, r = t.g, n = $a2acea4f3420f1d8$var$X;
        if ($a2acea4f3420f1d8$var$B && n && null != e[n]?.[r] && $a2acea4f3420f1d8$var$$($a2acea4f3420f1d8$var$W, 3), e = t.g, $a2acea4f3420f1d8$var$Z && $a2acea4f3420f1d8$var$X && void 0 === $a2acea4f3420f1d8$var$Z && (n = (r = this.A)[$a2acea4f3420f1d8$var$X]) && (n = n.ka)) try {
            n(r, e, $a2acea4f3420f1d8$var$Ue);
        } catch (t) {
            $a2acea4f3420f1d8$var$l(t);
        }
        return t.h ? t.m(this, t.h, t.g, t.j) : t.m(this, t.g, t.defaultValue, t.j);
    }
    clone() {
        var t = this.A, e = 0 | t[$a2acea4f3420f1d8$var$et];
        return $a2acea4f3420f1d8$var$rr(this, t, e) ? $a2acea4f3420f1d8$var$Ye(this, t, !0) : new this.constructor($a2acea4f3420f1d8$var$Je(t, e, !1));
    }
};
$a2acea4f3420f1d8$var$di.prototype[$a2acea4f3420f1d8$var$J] = $a2acea4f3420f1d8$var$at, $a2acea4f3420f1d8$var$di.prototype.toString = function() {
    return this.A.toString();
};
var $a2acea4f3420f1d8$var$fi = class {
    constructor(t, e, r){
        this.g = t, this.h = e, t = $a2acea4f3420f1d8$var$Qn, this.j = !!t && r === t || !1;
    }
};
function $a2acea4f3420f1d8$var$pi(t, e) {
    return new $a2acea4f3420f1d8$var$fi(t, e, $a2acea4f3420f1d8$var$Qn);
}
function $a2acea4f3420f1d8$var$gi(t, e, r, n, i) {
    $a2acea4f3420f1d8$var$Yn(t, r, $a2acea4f3420f1d8$var$Li(e, n), i);
}
var $a2acea4f3420f1d8$var$mi, $a2acea4f3420f1d8$var$vi, $a2acea4f3420f1d8$var$_i = $a2acea4f3420f1d8$var$pi(function(t, e, r, n, i) {
    return 2 === t.h && ($a2acea4f3420f1d8$var$gn(t, $a2acea4f3420f1d8$var$Tr(e, n, r), i), !0);
}, $a2acea4f3420f1d8$var$gi), $a2acea4f3420f1d8$var$yi = $a2acea4f3420f1d8$var$pi(function(t, e, r, n, i) {
    return 2 === t.h && ($a2acea4f3420f1d8$var$gn(t, $a2acea4f3420f1d8$var$Tr(e, n, r), i), !0);
}, $a2acea4f3420f1d8$var$gi), $a2acea4f3420f1d8$var$Ei = Symbol(), $a2acea4f3420f1d8$var$Ai = Symbol(), $a2acea4f3420f1d8$var$wi = Symbol(), $a2acea4f3420f1d8$var$bi = Symbol(), $a2acea4f3420f1d8$var$Ti = Symbol();
function $a2acea4f3420f1d8$var$ki(t, e, r, n) {
    var i = n[t];
    if (i) return i;
    (i = {}).Ea = n, i.ca = function(t) {
        switch(typeof t){
            case "boolean":
                return $a2acea4f3420f1d8$var$De ||= [
                    0,
                    void 0,
                    !0
                ];
            case "number":
                return t > 0 ? void 0 : 0 === t ? $a2acea4f3420f1d8$var$Pe ||= [
                    0,
                    void 0
                ] : [
                    -t,
                    void 0
                ];
            case "string":
                return [
                    0,
                    t
                ];
            case "object":
                return t;
        }
    }(n[0]);
    var s = n[1], o = 1;
    s && s.constructor === Object && (i.ia = s, "function" == typeof (s = n[++o]) && (i.wa = !0, $a2acea4f3420f1d8$var$mi ??= s, $a2acea4f3420f1d8$var$vi ??= n[o + 1], s = n[o += 2]));
    for(var a = {}; s && Array.isArray(s) && s.length && "number" == typeof s[0] && s[0] > 0;){
        for(var h = 0; h < s.length; h++)a[s[h]] = s;
        s = n[++o];
    }
    for(h = 1; void 0 !== s;){
        let t;
        "number" == typeof s && (h += s, s = n[++o]);
        var u = void 0;
        if (s instanceof $a2acea4f3420f1d8$var$fi ? t = s : (t = $a2acea4f3420f1d8$var$_i, o--), t?.j) {
            s = n[++o], u = n;
            var c = o;
            "function" == typeof s && (s = s(), u[c] = s), u = s;
        }
        for(c = h + 1, "number" == typeof (s = n[++o]) && s < 0 && (c -= s, s = n[++o]); h < c; h++){
            let n = a[h];
            u ? r(i, h, t, u, n) : e(i, h, t, n);
        }
    }
    return n[t] = i;
}
function $a2acea4f3420f1d8$var$Si(t) {
    return Array.isArray(t) ? t[0] instanceof $a2acea4f3420f1d8$var$fi ? t : [
        $a2acea4f3420f1d8$var$yi,
        t
    ] : [
        t,
        void 0
    ];
}
function $a2acea4f3420f1d8$var$Li(t, e) {
    return t instanceof $a2acea4f3420f1d8$var$di ? t.A : Array.isArray(t) ? $a2acea4f3420f1d8$var$Ke(t, e) : void 0;
}
function $a2acea4f3420f1d8$var$xi(t, e, r, n) {
    var i = r.g;
    t[e] = n ? (t, e, r)=>i(t, e, r, n) : i;
}
function $a2acea4f3420f1d8$var$Ri(t, e, r, n, i) {
    var s, o, a = r.g;
    t[e] = (t, e, r)=>a(t, e, r, o ||= $a2acea4f3420f1d8$var$ki($a2acea4f3420f1d8$var$Ai, $a2acea4f3420f1d8$var$xi, $a2acea4f3420f1d8$var$Ri, n).ca, s ||= $a2acea4f3420f1d8$var$Ii(n), i);
}
function $a2acea4f3420f1d8$var$Ii(t) {
    var e = t[$a2acea4f3420f1d8$var$wi];
    if (null != e) return e;
    var r = $a2acea4f3420f1d8$var$ki($a2acea4f3420f1d8$var$Ai, $a2acea4f3420f1d8$var$xi, $a2acea4f3420f1d8$var$Ri, t);
    return e = r.wa ? (t, e)=>$a2acea4f3420f1d8$var$mi(t, e, r) : (t, e)=>{
        t: {
            $a2acea4f3420f1d8$var$pn();
            try {
                for(; $a2acea4f3420f1d8$var$dn(e) && 4 != e.h;){
                    let h = e.j, u = r[h];
                    if (null == u) {
                        let t = r.ia;
                        if (t) {
                            let e = t[h];
                            if (e) {
                                let t = $a2acea4f3420f1d8$var$Ci(e);
                                null != t && (u = r[h] = t);
                            }
                        }
                    }
                    if (null == u || !u(e, t, h)) {
                        var n = e;
                        let r = n.m;
                        if ($a2acea4f3420f1d8$var$fn(n), n.ra) var i = void 0;
                        else {
                            let t = n.g.g - r;
                            n.g.g = r, i = $a2acea4f3420f1d8$var$on(n.g, t);
                        }
                        n = void 0;
                        var s = t, o = h, a = i;
                        a && ((n = s[$a2acea4f3420f1d8$var$X] ?? (s[$a2acea4f3420f1d8$var$X] = new $a2acea4f3420f1d8$var$$e))[o] ?? (n[o] = [])).push(a);
                    }
                }
                let u = $a2acea4f3420f1d8$var$Ne(t);
                u && (u.ka = r.Ea[$a2acea4f3420f1d8$var$Ti]);
                var h = !0;
                break t;
            } catch (t) {
                if (t instanceof RangeError) throw new SyntaxError;
                throw t;
            } finally{
                $a2acea4f3420f1d8$var$un > 0 && $a2acea4f3420f1d8$var$un--;
            }
            h = void 0;
        }
        return h;
    }, t[$a2acea4f3420f1d8$var$wi] = e, t[$a2acea4f3420f1d8$var$Ti] = $a2acea4f3420f1d8$var$Fi.bind(t), e;
}
function $a2acea4f3420f1d8$var$Fi(t, e, r, n) {
    var i = this[$a2acea4f3420f1d8$var$Ai], s = this[$a2acea4f3420f1d8$var$wi], o = $a2acea4f3420f1d8$var$Ke(void 0, i.ca), a = $a2acea4f3420f1d8$var$Ne(t);
    if (a) {
        var h = !1, u = i.ia;
        if (u) {
            if (i = (e, r, i)=>{
                if (0 !== i.length) {
                    if (u[r]) for (let t of i){
                        e = $a2acea4f3420f1d8$var$cn(t);
                        try {
                            h = !0, s(o, e);
                        } finally{
                            $a2acea4f3420f1d8$var$ln(e);
                        }
                    }
                    else n?.(t, r, i);
                }
            }, null == e) $a2acea4f3420f1d8$var$Me(a, i);
            else if (null != a) {
                let t = a[e];
                t && i(a, e, t);
            }
            if (h) {
                let n = 0 | t[$a2acea4f3420f1d8$var$et];
                if (2 & n && 2048 & n && !r?.cb) throw Error();
                let i = $a2acea4f3420f1d8$var$gt(n), s = (e, s)=>{
                    if (null != $a2acea4f3420f1d8$var$or(t, e, i)) {
                        if (1 === r?.lb) return;
                        throw Error();
                    }
                    null != s && (n = $a2acea4f3420f1d8$var$hr(t, n, e, s, i)), delete a[e];
                };
                null == e ? $a2acea4f3420f1d8$var$ft(o, 0 | o[$a2acea4f3420f1d8$var$et], (t, e)=>{
                    s(t, e);
                }) : s(e, $a2acea4f3420f1d8$var$or(o, e, i));
            }
        }
    }
}
function $a2acea4f3420f1d8$var$Ci(t) {
    var e = (t = $a2acea4f3420f1d8$var$Si(t))[0].g;
    if (t = t[1]) {
        let r = $a2acea4f3420f1d8$var$Ii(t), n = $a2acea4f3420f1d8$var$ki($a2acea4f3420f1d8$var$Ai, $a2acea4f3420f1d8$var$xi, $a2acea4f3420f1d8$var$Ri, t).ca;
        return (t, i, s)=>e(t, i, s, n, r);
    }
    return e;
}
function $a2acea4f3420f1d8$var$Ni(t, e, r) {
    t[e] = r.h;
}
function $a2acea4f3420f1d8$var$Mi(t, e, r, n) {
    var i, s, o = r.h;
    t[e] = (t, e, r)=>o(t, e, r, s ||= $a2acea4f3420f1d8$var$ki($a2acea4f3420f1d8$var$Ei, $a2acea4f3420f1d8$var$Ni, $a2acea4f3420f1d8$var$Mi, n).ca, i ||= $a2acea4f3420f1d8$var$Oi(n));
}
function $a2acea4f3420f1d8$var$Oi(t) {
    var e = t[$a2acea4f3420f1d8$var$bi];
    if (!e) {
        let r = $a2acea4f3420f1d8$var$ki($a2acea4f3420f1d8$var$Ei, $a2acea4f3420f1d8$var$Ni, $a2acea4f3420f1d8$var$Mi, t);
        e = (t, e)=>$a2acea4f3420f1d8$var$Di(t, e, r), t[$a2acea4f3420f1d8$var$bi] = e;
    }
    return e;
}
function $a2acea4f3420f1d8$var$Di(t, e, r) {
    $a2acea4f3420f1d8$var$ft(t, 0 | t[$a2acea4f3420f1d8$var$et], (t, n)=>{
        if (null != n) {
            var i = function(t, e) {
                var r = t[e];
                if (r) return r;
                if ((r = t.ia) && (r = r[e])) {
                    var n = (r = $a2acea4f3420f1d8$var$Si(r))[0].h;
                    if (r = r[1]) {
                        let e = $a2acea4f3420f1d8$var$Oi(r), i = $a2acea4f3420f1d8$var$ki($a2acea4f3420f1d8$var$Ei, $a2acea4f3420f1d8$var$Ni, $a2acea4f3420f1d8$var$Mi, r).ca;
                        r = t.wa ? $a2acea4f3420f1d8$var$vi(i, e) : (t, r, s)=>n(t, r, s, i, e);
                    } else r = n;
                    return t[e] = r;
                }
            }(r, t);
            i ? i(e, n, t) : t < 500 || $a2acea4f3420f1d8$var$$($a2acea4f3420f1d8$var$Y, 3);
        }
    }), (t = $a2acea4f3420f1d8$var$Ne(t)) && $a2acea4f3420f1d8$var$Me(t, (t, r, n)=>{
        for($a2acea4f3420f1d8$var$Vn(e, e.g.end()), t = 0; t < n.length; t++)$a2acea4f3420f1d8$var$Vn(e, $a2acea4f3420f1d8$var$F(n[t]) || new Uint8Array(0));
    });
}
var $a2acea4f3420f1d8$var$Pi = $a2acea4f3420f1d8$var$At(0);
function $a2acea4f3420f1d8$var$$i(t, e, r) {
    if (Array.isArray(e)) {
        var n = 0 | e[$a2acea4f3420f1d8$var$et];
        if (4 & n) return e;
        for(var i = 0, s = 0; i < e.length; i++){
            let r = t(e[i]);
            null != r && (e[s++] = r);
        }
        return s < i && (e.length = s), t = 1 | n, r && (t = -1537 & t | 4), t !== n && $a2acea4f3420f1d8$var$it(e, t), r && 2 & t && Object.freeze(e), e;
    }
}
var $a2acea4f3420f1d8$var$Ui = (t, e)=>{
    var r = new $a2acea4f3420f1d8$var$qn;
    $a2acea4f3420f1d8$var$Di(t.A, r, $a2acea4f3420f1d8$var$ki($a2acea4f3420f1d8$var$Ei, $a2acea4f3420f1d8$var$Ni, $a2acea4f3420f1d8$var$Mi, e)), $a2acea4f3420f1d8$var$Vn(r, r.g.end()), t = new Uint8Array(r.h);
    var n = (e = r.j).length, i = 0;
    for(let r = 0; r < n; r++){
        let n = e[r];
        t.set(n, i), i += n.length;
    }
    return r.j = [
        t
    ], t;
};
function $a2acea4f3420f1d8$var$Bi(t, e, r) {
    return new $a2acea4f3420f1d8$var$fi(t, e, r);
}
function $a2acea4f3420f1d8$var$Gi(t, e, r) {
    return new $a2acea4f3420f1d8$var$fi(t, e, r);
}
function $a2acea4f3420f1d8$var$ji(t, e, r) {
    $a2acea4f3420f1d8$var$hr(t, 0 | t[$a2acea4f3420f1d8$var$et], e, r, $a2acea4f3420f1d8$var$gt(0 | t[$a2acea4f3420f1d8$var$et]));
}
var $a2acea4f3420f1d8$var$Vi = $a2acea4f3420f1d8$var$pi(function(t, e, r, n, i) {
    if (2 !== t.h) return !1;
    if (t = $a2acea4f3420f1d8$var$Vt(t = $a2acea4f3420f1d8$var$gn(t, $a2acea4f3420f1d8$var$Ke([
        void 0,
        void 0
    ], n), i)), i = $a2acea4f3420f1d8$var$gt(n = 0 | e[$a2acea4f3420f1d8$var$et]), 2 & n) throw Error();
    var s = $a2acea4f3420f1d8$var$or(e, r, i);
    if (s instanceof $a2acea4f3420f1d8$var$Re) 2 & s.M ? ((s = s.ea()).push(t), $a2acea4f3420f1d8$var$hr(e, n, r, s, i)) : s.gb(t);
    else if (Array.isArray(s)) {
        var o = 0 | s[$a2acea4f3420f1d8$var$et];
        8192 & o || $a2acea4f3420f1d8$var$it(s, o |= 8192), 2 & o && $a2acea4f3420f1d8$var$hr(e, n, r, s = $a2acea4f3420f1d8$var$vr(s), i), s.push(t);
    } else $a2acea4f3420f1d8$var$hr(e, n, r, $a2acea4f3420f1d8$var$ot([
        t
    ]), i);
    return !0;
}, function(t, e, r, n, i) {
    if (e instanceof $a2acea4f3420f1d8$var$Re) e.forEach((e, s)=>{
        $a2acea4f3420f1d8$var$Yn(t, r, $a2acea4f3420f1d8$var$Ke([
            s,
            e
        ], n), i);
    });
    else if (Array.isArray(e)) {
        for(let s = 0; s < e.length; s++){
            let o = e[s];
            Array.isArray(o) && $a2acea4f3420f1d8$var$Yn(t, r, $a2acea4f3420f1d8$var$Ke(o, n), i);
        }
        $a2acea4f3420f1d8$var$ot(e);
    }
});
function $a2acea4f3420f1d8$var$Hi(t, e, r) {
    null != (e = $a2acea4f3420f1d8$var$Jt(e)) && ($a2acea4f3420f1d8$var$Hn(t, r, 5), t = t.g, $a2acea4f3420f1d8$var$Mt(e), $a2acea4f3420f1d8$var$Gn(t, $a2acea4f3420f1d8$var$It));
}
function $a2acea4f3420f1d8$var$Ki(t, e, r) {
    null != (e = $a2acea4f3420f1d8$var$pe(e)) && ($a2acea4f3420f1d8$var$Jn(e), $a2acea4f3420f1d8$var$Wn(t, r, e));
}
function $a2acea4f3420f1d8$var$Xi(t, e, r) {
    null != (e = $a2acea4f3420f1d8$var$re(e)) && null != e && ($a2acea4f3420f1d8$var$Hn(t, r, 0), $a2acea4f3420f1d8$var$Un(t.g, e));
}
function $a2acea4f3420f1d8$var$Wi(t, e, r) {
    null != (e = null == e || "boolean" == typeof e ? e : "number" == typeof e ? !!e : void 0) && ($a2acea4f3420f1d8$var$Hn(t, r, 0), t.g.g.push(e ? 1 : 0));
}
function $a2acea4f3420f1d8$var$zi(t, e, r) {
    null != (e = $a2acea4f3420f1d8$var$_e(e)) && $a2acea4f3420f1d8$var$zn(t, r, $a2acea4f3420f1d8$var$c(e));
}
function $a2acea4f3420f1d8$var$Yi(t, e, r, n, i) {
    $a2acea4f3420f1d8$var$Yn(t, r, $a2acea4f3420f1d8$var$Li(e, n), i);
}
function $a2acea4f3420f1d8$var$qi(t, e, r) {
    null != (e = $a2acea4f3420f1d8$var$ge(e)) && $a2acea4f3420f1d8$var$zn(t, r, $a2acea4f3420f1d8$var$zr(e, !0).buffer);
}
function $a2acea4f3420f1d8$var$Ji(t, e, r) {
    null != (e = $a2acea4f3420f1d8$var$ne(e)) && null != e && ($a2acea4f3420f1d8$var$Hn(t, r, 0), $a2acea4f3420f1d8$var$$n(t.g, e));
}
function $a2acea4f3420f1d8$var$Zi(t, e, r) {
    null != (e = $a2acea4f3420f1d8$var$re(e)) && (e = parseInt(e, 10), $a2acea4f3420f1d8$var$Hn(t, r, 0), $a2acea4f3420f1d8$var$Un(t.g, e));
}
function $a2acea4f3420f1d8$var$Qi(t, e, r) {
    return (5 === t.h || 2 === t.h) && (e = $a2acea4f3420f1d8$var$yr(e, 0 | e[$a2acea4f3420f1d8$var$et], r), 2 == t.h ? $a2acea4f3420f1d8$var$_n(t, $a2acea4f3420f1d8$var$en, e) : e.push($a2acea4f3420f1d8$var$en(t.g)), !0);
}
function $a2acea4f3420f1d8$var$ts(t, e, r) {
    return 0 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, $a2acea4f3420f1d8$var$Qr(t.g)), !0);
}
function $a2acea4f3420f1d8$var$es(t, e, r) {
    return (0 === t.h || 2 === t.h) && (e = $a2acea4f3420f1d8$var$yr(e, 0 | e[$a2acea4f3420f1d8$var$et], r), 2 == t.h ? $a2acea4f3420f1d8$var$_n(t, $a2acea4f3420f1d8$var$Jr, e) : e.push($a2acea4f3420f1d8$var$Jr(t.g)), !0);
}
function $a2acea4f3420f1d8$var$rs(t, e, r) {
    return 2 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, (t = $a2acea4f3420f1d8$var$vn(t)) === $a2acea4f3420f1d8$var$I() ? void 0 : t), !0);
}
var $a2acea4f3420f1d8$var$ns = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    if (1 !== t.h) return !1;
    var n = t.g;
    t = $a2acea4f3420f1d8$var$tn(n);
    var i = $a2acea4f3420f1d8$var$tn(n);
    n = 2 * (i >> 31) + 1;
    var s = i >>> 20 & 2047;
    return t = 4294967296 * (1048575 & i) + t, $a2acea4f3420f1d8$var$ji(e, r, 2047 == s ? t ? NaN : n * (1 / 0) : 0 == s ? 5e-324 * n * t : n * Math.pow(2, s - 1075) * (t + 4503599627370496)), !0;
}, function(t, e, r) {
    null != (e = $a2acea4f3420f1d8$var$Jt(e)) && ($a2acea4f3420f1d8$var$Hn(t, r, 1), t = t.g, (r = $a2acea4f3420f1d8$var$xt ||= new DataView(new ArrayBuffer(8))).setFloat64(0, +e, !0), $a2acea4f3420f1d8$var$It = r.getUint32(0, !0), $a2acea4f3420f1d8$var$Ft = r.getUint32(4, !0), $a2acea4f3420f1d8$var$Gn(t, $a2acea4f3420f1d8$var$It), $a2acea4f3420f1d8$var$Gn(t, $a2acea4f3420f1d8$var$Ft));
}, $a2acea4f3420f1d8$var$hi), $a2acea4f3420f1d8$var$is = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 5 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, $a2acea4f3420f1d8$var$en(t.g)), !0);
}, $a2acea4f3420f1d8$var$Hi, $a2acea4f3420f1d8$var$ai), $a2acea4f3420f1d8$var$ss = $a2acea4f3420f1d8$var$Gi($a2acea4f3420f1d8$var$Qi, function(t, e, r) {
    if (null != (e = $a2acea4f3420f1d8$var$$i($a2acea4f3420f1d8$var$Jt, e, !0))) for(let o = 0; o < e.length; o++){
        var n = t, i = r, s = e[o];
        null != s && ($a2acea4f3420f1d8$var$Hn(n, i, 5), n = n.g, $a2acea4f3420f1d8$var$Mt(s), $a2acea4f3420f1d8$var$Gn(n, $a2acea4f3420f1d8$var$It));
    }
}, $a2acea4f3420f1d8$var$ai), $a2acea4f3420f1d8$var$os = $a2acea4f3420f1d8$var$Gi($a2acea4f3420f1d8$var$Qi, function(t, e, r) {
    if (null != (e = $a2acea4f3420f1d8$var$$i($a2acea4f3420f1d8$var$Jt, e, !0)) && e.length) {
        $a2acea4f3420f1d8$var$Hn(t, r, 2), $a2acea4f3420f1d8$var$$n(t.g, 4 * e.length);
        for(let n = 0; n < e.length; n++)r = t.g, $a2acea4f3420f1d8$var$Mt(e[n]), $a2acea4f3420f1d8$var$Gn(r, $a2acea4f3420f1d8$var$It);
    }
}, $a2acea4f3420f1d8$var$ai), $a2acea4f3420f1d8$var$as = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 5 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, 0 === (t = $a2acea4f3420f1d8$var$en(t.g)) ? void 0 : t), !0);
}, $a2acea4f3420f1d8$var$Hi, $a2acea4f3420f1d8$var$ai), $a2acea4f3420f1d8$var$hs = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return $a2acea4f3420f1d8$var$ts(t, e, r);
}, $a2acea4f3420f1d8$var$Ki, $a2acea4f3420f1d8$var$ii), $a2acea4f3420f1d8$var$us = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return $a2acea4f3420f1d8$var$ts(t, e, r);
}, $a2acea4f3420f1d8$var$Ki, $a2acea4f3420f1d8$var$ii), $a2acea4f3420f1d8$var$cs = $a2acea4f3420f1d8$var$Gi(function(t, e, r) {
    return 0 !== t.h && 2 !== t.h ? t = !1 : (e = $a2acea4f3420f1d8$var$yr(e, 0 | e[$a2acea4f3420f1d8$var$et], r), 2 == t.h ? $a2acea4f3420f1d8$var$_n(t, $a2acea4f3420f1d8$var$Qr, e) : e.push($a2acea4f3420f1d8$var$Qr(t.g)), t = !0), t;
}, function(t, e, r) {
    if (null != (e = $a2acea4f3420f1d8$var$$i($a2acea4f3420f1d8$var$pe, e, !1))) for(let n = 0; n < e.length; n++)$a2acea4f3420f1d8$var$Wn(t, r, e[n]);
}, $a2acea4f3420f1d8$var$ii), $a2acea4f3420f1d8$var$ls = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 !== t.h ? e = !1 : ($a2acea4f3420f1d8$var$ji(e, r, (t = $a2acea4f3420f1d8$var$Qr(t.g)) === $a2acea4f3420f1d8$var$Pi ? void 0 : t), e = !0), e;
}, $a2acea4f3420f1d8$var$Ki, $a2acea4f3420f1d8$var$ii), $a2acea4f3420f1d8$var$ds = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 !== t.h ? t = !1 : ($a2acea4f3420f1d8$var$ji(e, r, $a2acea4f3420f1d8$var$Yr(t.g, $a2acea4f3420f1d8$var$Dt)), t = !0), t;
}, function(t, e, r) {
    if (e = function(t) {
        if (null == t) return t;
        var e = typeof t;
        if ("bigint" === e) return String($a2acea4f3420f1d8$var$Kt(64, t));
        if ($a2acea4f3420f1d8$var$te(t)) {
            if ("string" === e) return e = $a2acea4f3420f1d8$var$zt(Number(t)), $a2acea4f3420f1d8$var$Xt(e) && e >= 0 ? t = String(e) : (-1 !== (e = t.indexOf(".")) && (t = t.substring(0, e)), t = $a2acea4f3420f1d8$var$oe(t)), t;
            if ("number" === e) return $a2acea4f3420f1d8$var$he(t);
        }
    }(e), null != e) {
        if ("string" == typeof e) $a2acea4f3420f1d8$var$wn(e);
        if (null != e) switch($a2acea4f3420f1d8$var$Hn(t, r, 0), typeof e){
            case "number":
                t = t.g, $a2acea4f3420f1d8$var$Nt(e), $a2acea4f3420f1d8$var$Pn(t, $a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft);
                break;
            case "bigint":
                r = $a2acea4f3420f1d8$var$Dn(e, $a2acea4f3420f1d8$var$Tn, $a2acea4f3420f1d8$var$An), $a2acea4f3420f1d8$var$Pn(t.g, r.h, r.g);
                break;
            default:
                r = $a2acea4f3420f1d8$var$wn(e), $a2acea4f3420f1d8$var$Pn(t.g, r.h, r.g);
        }
    }
}, $a2acea4f3420f1d8$var$si), $a2acea4f3420f1d8$var$fs = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, $a2acea4f3420f1d8$var$Jr(t.g)), !0);
}, $a2acea4f3420f1d8$var$Xi, $a2acea4f3420f1d8$var$ri), $a2acea4f3420f1d8$var$ps = $a2acea4f3420f1d8$var$Gi($a2acea4f3420f1d8$var$es, function(t, e, r) {
    if (null != (e = $a2acea4f3420f1d8$var$$i($a2acea4f3420f1d8$var$re, e, !0))) for(let o = 0; o < e.length; o++){
        var n = t, i = r, s = e[o];
        null != s && ($a2acea4f3420f1d8$var$Hn(n, i, 0), $a2acea4f3420f1d8$var$Un(n.g, s));
    }
}, $a2acea4f3420f1d8$var$ri), $a2acea4f3420f1d8$var$gs = $a2acea4f3420f1d8$var$Gi($a2acea4f3420f1d8$var$es, function(t, e, r) {
    if (null != (e = $a2acea4f3420f1d8$var$$i($a2acea4f3420f1d8$var$re, e, !0)) && e.length) {
        r = $a2acea4f3420f1d8$var$Kn(t, r);
        for(let r = 0; r < e.length; r++)$a2acea4f3420f1d8$var$Un(t.g, e[r]);
        $a2acea4f3420f1d8$var$Xn(t, r);
    }
}, $a2acea4f3420f1d8$var$ri), $a2acea4f3420f1d8$var$ms = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, 0 === (t = $a2acea4f3420f1d8$var$Jr(t.g)) ? void 0 : t), !0);
}, $a2acea4f3420f1d8$var$Xi, $a2acea4f3420f1d8$var$ri), $a2acea4f3420f1d8$var$vs = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, $a2acea4f3420f1d8$var$qr(t.g)), !0);
}, $a2acea4f3420f1d8$var$Wi, $a2acea4f3420f1d8$var$ti), $a2acea4f3420f1d8$var$_s = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, !1 === (t = $a2acea4f3420f1d8$var$qr(t.g)) ? void 0 : t), !0);
}, $a2acea4f3420f1d8$var$Wi, $a2acea4f3420f1d8$var$ti), $a2acea4f3420f1d8$var$ys = $a2acea4f3420f1d8$var$Gi(function(t, e, r) {
    return 2 === t.h && (t = $a2acea4f3420f1d8$var$mn(t), $a2acea4f3420f1d8$var$yr(e, 0 | e[$a2acea4f3420f1d8$var$et], r).push(t), !0);
}, function(t, e, r) {
    if (null != (e = $a2acea4f3420f1d8$var$$i($a2acea4f3420f1d8$var$_e, e, !0))) for(let o = 0; o < e.length; o++){
        var n = t, i = r, s = e[o];
        null != s && $a2acea4f3420f1d8$var$zn(n, i, $a2acea4f3420f1d8$var$c(s));
    }
}, $a2acea4f3420f1d8$var$ei), $a2acea4f3420f1d8$var$Es = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 2 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, "" === (t = $a2acea4f3420f1d8$var$mn(t)) ? void 0 : t), !0);
}, $a2acea4f3420f1d8$var$zi, $a2acea4f3420f1d8$var$ei), $a2acea4f3420f1d8$var$As = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 2 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, $a2acea4f3420f1d8$var$mn(t)), !0);
}, $a2acea4f3420f1d8$var$zi, $a2acea4f3420f1d8$var$ei), $a2acea4f3420f1d8$var$ws = function(t, e, r = $a2acea4f3420f1d8$var$Qn) {
    return new $a2acea4f3420f1d8$var$fi(t, e, r);
}(function(t, e, r, n, i) {
    return 2 === t.h && (n = $a2acea4f3420f1d8$var$Ke(void 0, n), $a2acea4f3420f1d8$var$yr(e, 0 | e[$a2acea4f3420f1d8$var$et], r).push(n), $a2acea4f3420f1d8$var$gn(t, n, i), !0);
}, function(t, e, r, n, i) {
    if (Array.isArray(e)) {
        for(let s = 0; s < e.length; s++)$a2acea4f3420f1d8$var$Yi(t, e[s], r, n, i);
        1 & (t = 0 | e[$a2acea4f3420f1d8$var$et]) || $a2acea4f3420f1d8$var$it(e, 1 | t);
    }
}), $a2acea4f3420f1d8$var$bs = $a2acea4f3420f1d8$var$pi(function(t, e, r, n, i, s) {
    if (2 !== t.h) return !1;
    var o = 0 | e[$a2acea4f3420f1d8$var$et];
    return $a2acea4f3420f1d8$var$wr(e, o, s, r, $a2acea4f3420f1d8$var$gt(o)), $a2acea4f3420f1d8$var$gn(t, e = $a2acea4f3420f1d8$var$Tr(e, n, r), i), !0;
}, $a2acea4f3420f1d8$var$Yi), $a2acea4f3420f1d8$var$Ts = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 2 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, $a2acea4f3420f1d8$var$vn(t)), !0);
}, $a2acea4f3420f1d8$var$qi, $a2acea4f3420f1d8$var$ui), $a2acea4f3420f1d8$var$ks = $a2acea4f3420f1d8$var$Gi(function(t, e, r) {
    return 2 === t.h && (t = $a2acea4f3420f1d8$var$vn(t), $a2acea4f3420f1d8$var$yr(e, 0 | e[$a2acea4f3420f1d8$var$et], r).push(t), !0);
}, function(t, e, r) {
    if (null != (e = $a2acea4f3420f1d8$var$$i($a2acea4f3420f1d8$var$ge, e, !1))) for(let o = 0; o < e.length; o++){
        var n = t, i = r, s = e[o];
        null != s && $a2acea4f3420f1d8$var$zn(n, i, $a2acea4f3420f1d8$var$zr(s, !0).buffer);
    }
}, $a2acea4f3420f1d8$var$ui), $a2acea4f3420f1d8$var$Ss = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, $a2acea4f3420f1d8$var$Zr(t.g)), !0);
}, $a2acea4f3420f1d8$var$Ji, $a2acea4f3420f1d8$var$ni), $a2acea4f3420f1d8$var$Ls = $a2acea4f3420f1d8$var$Gi(function(t, e, r) {
    return (0 === t.h || 2 === t.h) && (e = $a2acea4f3420f1d8$var$yr(e, 0 | e[$a2acea4f3420f1d8$var$et], r), 2 == t.h ? $a2acea4f3420f1d8$var$_n(t, $a2acea4f3420f1d8$var$Zr, e) : e.push($a2acea4f3420f1d8$var$Zr(t.g)), !0);
}, function(t, e, r) {
    if (null != (e = $a2acea4f3420f1d8$var$$i($a2acea4f3420f1d8$var$ne, e, !0))) for(let o = 0; o < e.length; o++){
        var n = t, i = r, s = e[o];
        null != s && ($a2acea4f3420f1d8$var$Hn(n, i, 0), $a2acea4f3420f1d8$var$$n(n.g, s));
    }
}, $a2acea4f3420f1d8$var$ni), $a2acea4f3420f1d8$var$xs = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, 0 === (t = $a2acea4f3420f1d8$var$Zr(t.g)) ? void 0 : t), !0);
}, $a2acea4f3420f1d8$var$Ji, $a2acea4f3420f1d8$var$ni), $a2acea4f3420f1d8$var$Rs = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, $a2acea4f3420f1d8$var$Jr(t.g)), !0);
}, $a2acea4f3420f1d8$var$Zi, $a2acea4f3420f1d8$var$ci), $a2acea4f3420f1d8$var$Is = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 === t.h && ($a2acea4f3420f1d8$var$ji(e, r, 0 === (t = $a2acea4f3420f1d8$var$Jr(t.g)) ? void 0 : t), !0);
}, $a2acea4f3420f1d8$var$Zi, $a2acea4f3420f1d8$var$ci), $a2acea4f3420f1d8$var$Fs = $a2acea4f3420f1d8$var$Bi(function(t, e, r) {
    return 0 !== t.h ? t = !1 : ($a2acea4f3420f1d8$var$ji(e, r, function(t) {
        return $a2acea4f3420f1d8$var$Yr(t, (t, e)=>{
            var r = -(1 & t);
            return $a2acea4f3420f1d8$var$Pt(t = (t >>> 1 | e << 31) ^ r, e >>> 1 ^ r);
        });
    }(t.g)), t = !0), t;
}, function(t, e, r) {
    if (null != (e = $a2acea4f3420f1d8$var$pe(e)) && ($a2acea4f3420f1d8$var$Jn(e), null != e)) switch($a2acea4f3420f1d8$var$Hn(t, r, 0), typeof e){
        case "number":
            t = t.g, e = (r = e) < 0, $a2acea4f3420f1d8$var$Ct(r = 2 * Math.abs(r)), r = $a2acea4f3420f1d8$var$It;
            let n = $a2acea4f3420f1d8$var$Ft;
            e && (0 == r ? 0 == n ? n = r = 4294967295 : (n--, r = 4294967295) : r--), $a2acea4f3420f1d8$var$Pn(t, $a2acea4f3420f1d8$var$It = r, $a2acea4f3420f1d8$var$Ft = n);
            break;
        case "bigint":
            t = t.g, e = e << BigInt(1) ^ e >> BigInt(63), $a2acea4f3420f1d8$var$It = Number(BigInt.asUintN(32, e)), $a2acea4f3420f1d8$var$Ft = Number(BigInt.asUintN(32, e >> BigInt(32))), $a2acea4f3420f1d8$var$Pn(t, $a2acea4f3420f1d8$var$It, $a2acea4f3420f1d8$var$Ft);
            break;
        default:
            $a2acea4f3420f1d8$var$Bn(t.g, e);
    }
}, $a2acea4f3420f1d8$var$oi);
class $a2acea4f3420f1d8$var$Cs {
    constructor(t, e){
        var r = $a2acea4f3420f1d8$var$no;
        this.g = t, this.h = e, this.m = $a2acea4f3420f1d8$var$Sr, this.o = $a2acea4f3420f1d8$var$Ir, this.defaultValue = void 0, this.j = null != r.jb ? $a2acea4f3420f1d8$var$pt : void 0;
    }
    register() {
        $a2acea4f3420f1d8$var$v(this);
    }
}
function $a2acea4f3420f1d8$var$Ns(t, e) {
    return new $a2acea4f3420f1d8$var$Cs(t, e);
}
function $a2acea4f3420f1d8$var$Ms(t, e) {
    return (r, n)=>{
        t: {
            let s = {
                ma: !0
            };
            n && Object.assign(s, n), r = $a2acea4f3420f1d8$var$cn(r, void 0, void 0, s);
            try {
                let n = new t, s = n.A;
                $a2acea4f3420f1d8$var$Ii(e)(s, r);
                var i = n;
                break t;
            } catch (t) {
                if (t instanceof RangeError) throw new SyntaxError;
                throw t;
            } finally{
                $a2acea4f3420f1d8$var$ln(r);
            }
            i = void 0;
        }
        return i;
    };
}
function $a2acea4f3420f1d8$var$Os(t) {
    return (e)=>$a2acea4f3420f1d8$var$Ui(e, t);
}
function $a2acea4f3420f1d8$var$Ds(t) {
    return function() {
        return $a2acea4f3420f1d8$var$Ui(this, t);
    };
}
var $a2acea4f3420f1d8$var$Ps = [
    0,
    $a2acea4f3420f1d8$var$Ts,
    $a2acea4f3420f1d8$var$ks,
    $a2acea4f3420f1d8$var$vs,
    $a2acea4f3420f1d8$var$As
], $a2acea4f3420f1d8$var$$s = [
    0,
    $a2acea4f3420f1d8$var$Es,
    [
        0,
        $a2acea4f3420f1d8$var$Is,
        [
            0,
            $a2acea4f3420f1d8$var$ls,
            $a2acea4f3420f1d8$var$ms
        ],
        $a2acea4f3420f1d8$var$Is,
        -1,
        [
            0,
            $a2acea4f3420f1d8$var$Rs
        ],
        $a2acea4f3420f1d8$var$Is,
        -1
    ],
    $a2acea4f3420f1d8$var$Bi($a2acea4f3420f1d8$var$rs, $a2acea4f3420f1d8$var$qi, $a2acea4f3420f1d8$var$ui)
];
var $a2acea4f3420f1d8$var$Us, $a2acea4f3420f1d8$var$Bs = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Gs = [
    0,
    $a2acea4f3420f1d8$var$Es,
    $a2acea4f3420f1d8$var$Bi($a2acea4f3420f1d8$var$rs, function(t, e, r) {
        if (null != e) {
            if (e instanceof $a2acea4f3420f1d8$var$di) {
                let n = e.mb;
                return void (n ? (e = n(e), null != e && $a2acea4f3420f1d8$var$zn(t, r, $a2acea4f3420f1d8$var$zr(e, !0).buffer)) : $a2acea4f3420f1d8$var$$($a2acea4f3420f1d8$var$Y, 3));
            }
            if (Array.isArray(e)) return void $a2acea4f3420f1d8$var$$($a2acea4f3420f1d8$var$Y, 3);
        }
        $a2acea4f3420f1d8$var$qi(t, e, r);
    }, $a2acea4f3420f1d8$var$ui)
], $a2acea4f3420f1d8$var$js = [
    0,
    1,
    [
        0,
        12,
        $a2acea4f3420f1d8$var$fs,
        10,
        $a2acea4f3420f1d8$var$vs
    ],
    [
        0,
        7,
        [
            0,
            $a2acea4f3420f1d8$var$fs,
            -1
        ]
    ]
], $a2acea4f3420f1d8$var$Vs = globalThis.trustedTypes;
var $a2acea4f3420f1d8$var$Hs = class {
    constructor(t){
        this.g = t;
    }
    toString() {
        return this.g + "";
    }
};
function $a2acea4f3420f1d8$var$Ks(t) {
    var e;
    return void 0 === $a2acea4f3420f1d8$var$Us && ($a2acea4f3420f1d8$var$Us = function() {
        var t = null;
        if (!$a2acea4f3420f1d8$var$Vs) return t;
        try {
            let e = (t)=>t;
            t = $a2acea4f3420f1d8$var$Vs.createPolicy("goog#html", {
                createHTML: e,
                createScript: e,
                createScriptURL: e
            });
        } catch (t) {}
        return t;
    }()), t = (e = $a2acea4f3420f1d8$var$Us) ? e.createScriptURL(t) : t, new $a2acea4f3420f1d8$var$Hs(t);
}
function $a2acea4f3420f1d8$var$Xs(t, ...e) {
    if (0 === e.length) return $a2acea4f3420f1d8$var$Ks(t[0]);
    var r = t[0];
    for(let n = 0; n < e.length; n++)r += encodeURIComponent(e[n]) + t[n + 1];
    return $a2acea4f3420f1d8$var$Ks(r);
}
var $a2acea4f3420f1d8$var$Ws = [
    0,
    $a2acea4f3420f1d8$var$fs,
    $a2acea4f3420f1d8$var$Rs,
    $a2acea4f3420f1d8$var$vs,
    -1,
    $a2acea4f3420f1d8$var$gs,
    $a2acea4f3420f1d8$var$Rs,
    -1,
    $a2acea4f3420f1d8$var$vs,
    -1
], $a2acea4f3420f1d8$var$zs = [
    0,
    $a2acea4f3420f1d8$var$Rs,
    -1,
    $a2acea4f3420f1d8$var$vs
], $a2acea4f3420f1d8$var$Ys = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$qs = [
    0,
    $a2acea4f3420f1d8$var$vs,
    $a2acea4f3420f1d8$var$As,
    $a2acea4f3420f1d8$var$vs,
    $a2acea4f3420f1d8$var$Rs,
    -1,
    $a2acea4f3420f1d8$var$Gi(function(t, e, r) {
        return (0 === t.h || 2 === t.h) && (e = $a2acea4f3420f1d8$var$yr(e, 0 | e[$a2acea4f3420f1d8$var$et], r), 2 == t.h ? $a2acea4f3420f1d8$var$_n(t, $a2acea4f3420f1d8$var$rn, e) : e.push($a2acea4f3420f1d8$var$Jr(t.g)), !0);
    }, function(t, e, r) {
        if (null != (e = $a2acea4f3420f1d8$var$$i($a2acea4f3420f1d8$var$re, e, !0)) && e.length) {
            r = $a2acea4f3420f1d8$var$Kn(t, r);
            for(let r = 0; r < e.length; r++)$a2acea4f3420f1d8$var$Un(t.g, e[r]);
            $a2acea4f3420f1d8$var$Xn(t, r);
        }
    }, $a2acea4f3420f1d8$var$ci),
    $a2acea4f3420f1d8$var$As,
    -1,
    [
        0,
        $a2acea4f3420f1d8$var$vs,
        -1
    ],
    $a2acea4f3420f1d8$var$Rs,
    $a2acea4f3420f1d8$var$vs,
    -1,
    $a2acea4f3420f1d8$var$zs
], $a2acea4f3420f1d8$var$Js = [
    0,
    3,
    $a2acea4f3420f1d8$var$vs,
    -1,
    2,
    [
        0,
        [
            2
        ],
        $a2acea4f3420f1d8$var$fs,
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$Ss
        ]
    ],
    [
        0,
        $a2acea4f3420f1d8$var$Rs,
        $a2acea4f3420f1d8$var$vs,
        $a2acea4f3420f1d8$var$Rs,
        $a2acea4f3420f1d8$var$vs,
        $a2acea4f3420f1d8$var$Rs,
        4,
        [
            0,
            $a2acea4f3420f1d8$var$vs,
            $a2acea4f3420f1d8$var$As,
            -1,
            $a2acea4f3420f1d8$var$vs
        ]
    ],
    [
        0,
        [
            3,
            4
        ],
        $a2acea4f3420f1d8$var$As,
        -1,
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$fs
        ],
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$Rs,
            -1
        ]
    ],
    [
        0
    ]
], $a2acea4f3420f1d8$var$Zs = [
    0,
    $a2acea4f3420f1d8$var$As,
    -2
], $a2acea4f3420f1d8$var$Qs = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$to = [
    0
], $a2acea4f3420f1d8$var$eo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$ro = [
    0,
    $a2acea4f3420f1d8$var$fs,
    $a2acea4f3420f1d8$var$vs,
    1,
    $a2acea4f3420f1d8$var$vs,
    -4
], $a2acea4f3420f1d8$var$no = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t, 2);
    }
}, $a2acea4f3420f1d8$var$io = {};
$a2acea4f3420f1d8$var$io[336783863] = [
    0,
    $a2acea4f3420f1d8$var$As,
    $a2acea4f3420f1d8$var$vs,
    -1,
    $a2acea4f3420f1d8$var$fs,
    [
        0,
        [
            1,
            2,
            3,
            4,
            5,
            6,
            7,
            8,
            9
        ],
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$to,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$qs,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$Zs,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$ro,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$Ws,
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -2
        ],
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            $a2acea4f3420f1d8$var$Rs
        ],
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$Js,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$zs
    ],
    [
        0,
        $a2acea4f3420f1d8$var$As
    ],
    $a2acea4f3420f1d8$var$vs,
    [
        0,
        [
            1,
            3
        ],
        [
            2,
            4
        ],
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$gs
        ],
        -1,
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$ys
        ],
        -1,
        $a2acea4f3420f1d8$var$ws,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -1
        ]
    ],
    $a2acea4f3420f1d8$var$As
];
var $a2acea4f3420f1d8$var$so = [
    0,
    $a2acea4f3420f1d8$var$ls,
    -1,
    $a2acea4f3420f1d8$var$_s,
    -3,
    $a2acea4f3420f1d8$var$ls,
    $a2acea4f3420f1d8$var$gs,
    $a2acea4f3420f1d8$var$Es,
    $a2acea4f3420f1d8$var$ms,
    $a2acea4f3420f1d8$var$ls,
    -1,
    $a2acea4f3420f1d8$var$_s,
    $a2acea4f3420f1d8$var$ms,
    $a2acea4f3420f1d8$var$_s,
    -2,
    $a2acea4f3420f1d8$var$Es
];
function $a2acea4f3420f1d8$var$oo(t, e) {
    $a2acea4f3420f1d8$var$Xr(t, 3, e);
}
function $a2acea4f3420f1d8$var$ao(t, e) {
    $a2acea4f3420f1d8$var$Xr(t, 4, e);
}
var $a2acea4f3420f1d8$var$ho = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t, 500);
    }
    v(t) {
        return $a2acea4f3420f1d8$var$Ir(this, 0, 7, t);
    }
}, $a2acea4f3420f1d8$var$uo = [
    -1,
    {}
], $a2acea4f3420f1d8$var$co = [
    0,
    $a2acea4f3420f1d8$var$As,
    1,
    $a2acea4f3420f1d8$var$uo
], $a2acea4f3420f1d8$var$lo = [
    0,
    $a2acea4f3420f1d8$var$As,
    $a2acea4f3420f1d8$var$ys,
    $a2acea4f3420f1d8$var$uo
];
function $a2acea4f3420f1d8$var$fo(t, e) {
    $a2acea4f3420f1d8$var$Mr(t, 1, $a2acea4f3420f1d8$var$ho, e);
}
function $a2acea4f3420f1d8$var$po(t, e) {
    $a2acea4f3420f1d8$var$Xr(t, 10, e);
}
function $a2acea4f3420f1d8$var$go(t, e) {
    $a2acea4f3420f1d8$var$Xr(t, 15, e);
}
var $a2acea4f3420f1d8$var$mo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t, 500);
    }
    v(t) {
        return $a2acea4f3420f1d8$var$Ir(this, 0, 1001, t);
    }
}, $a2acea4f3420f1d8$var$vo = [
    -500,
    $a2acea4f3420f1d8$var$ws,
    [
        -500,
        $a2acea4f3420f1d8$var$Es,
        -1,
        $a2acea4f3420f1d8$var$ys,
        -3,
        [
            -2,
            $a2acea4f3420f1d8$var$io,
            $a2acea4f3420f1d8$var$vs
        ],
        $a2acea4f3420f1d8$var$ws,
        $a2acea4f3420f1d8$var$Gs,
        $a2acea4f3420f1d8$var$ms,
        -1,
        $a2acea4f3420f1d8$var$co,
        $a2acea4f3420f1d8$var$lo,
        $a2acea4f3420f1d8$var$ws,
        [
            0,
            $a2acea4f3420f1d8$var$Es,
            $a2acea4f3420f1d8$var$_s
        ],
        $a2acea4f3420f1d8$var$Es,
        $a2acea4f3420f1d8$var$so,
        $a2acea4f3420f1d8$var$ms,
        $a2acea4f3420f1d8$var$ys,
        987,
        $a2acea4f3420f1d8$var$ys
    ],
    4,
    $a2acea4f3420f1d8$var$ws,
    [
        -500,
        $a2acea4f3420f1d8$var$As,
        -1,
        [
            -1,
            {}
        ],
        998,
        $a2acea4f3420f1d8$var$As
    ],
    $a2acea4f3420f1d8$var$ws,
    [
        -500,
        $a2acea4f3420f1d8$var$As,
        $a2acea4f3420f1d8$var$ys,
        -1,
        [
            -2,
            {},
            $a2acea4f3420f1d8$var$vs
        ],
        997,
        $a2acea4f3420f1d8$var$ys,
        -1
    ],
    $a2acea4f3420f1d8$var$ms,
    $a2acea4f3420f1d8$var$ws,
    [
        -500,
        $a2acea4f3420f1d8$var$As,
        $a2acea4f3420f1d8$var$ys,
        $a2acea4f3420f1d8$var$uo,
        998,
        $a2acea4f3420f1d8$var$ys
    ],
    $a2acea4f3420f1d8$var$ys,
    $a2acea4f3420f1d8$var$ms,
    $a2acea4f3420f1d8$var$co,
    $a2acea4f3420f1d8$var$lo,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        $a2acea4f3420f1d8$var$Es,
        -1,
        $a2acea4f3420f1d8$var$uo
    ],
    $a2acea4f3420f1d8$var$ys,
    -2,
    $a2acea4f3420f1d8$var$so,
    $a2acea4f3420f1d8$var$Es,
    -1,
    $a2acea4f3420f1d8$var$_s,
    [
        0,
        $a2acea4f3420f1d8$var$_s,
        $a2acea4f3420f1d8$var$xs
    ],
    978,
    $a2acea4f3420f1d8$var$uo,
    $a2acea4f3420f1d8$var$ws,
    $a2acea4f3420f1d8$var$Gs
];
$a2acea4f3420f1d8$var$mo.prototype.g = $a2acea4f3420f1d8$var$Ds($a2acea4f3420f1d8$var$vo);
var $a2acea4f3420f1d8$var$_o = $a2acea4f3420f1d8$var$Ms($a2acea4f3420f1d8$var$mo, $a2acea4f3420f1d8$var$vo), $a2acea4f3420f1d8$var$yo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Eo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
    g() {
        return $a2acea4f3420f1d8$var$xr(this, $a2acea4f3420f1d8$var$yo, 1);
    }
}, $a2acea4f3420f1d8$var$Ao = [
    0,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        $a2acea4f3420f1d8$var$fs,
        $a2acea4f3420f1d8$var$is,
        $a2acea4f3420f1d8$var$As,
        -1
    ]
], $a2acea4f3420f1d8$var$wo = $a2acea4f3420f1d8$var$Ms($a2acea4f3420f1d8$var$Eo, $a2acea4f3420f1d8$var$Ao), $a2acea4f3420f1d8$var$bo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$To = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$ko = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
    j() {
        return $a2acea4f3420f1d8$var$Sr(this, $a2acea4f3420f1d8$var$bo, 2);
    }
    g() {
        return $a2acea4f3420f1d8$var$xr(this, $a2acea4f3420f1d8$var$To, 5);
    }
}, $a2acea4f3420f1d8$var$So = $a2acea4f3420f1d8$var$Ms(class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, [
    0,
    $a2acea4f3420f1d8$var$ys,
    $a2acea4f3420f1d8$var$gs,
    $a2acea4f3420f1d8$var$os,
    [
        0,
        $a2acea4f3420f1d8$var$Rs,
        [
            0,
            $a2acea4f3420f1d8$var$fs,
            -3
        ],
        [
            0,
            $a2acea4f3420f1d8$var$is,
            -3
        ],
        [
            0,
            $a2acea4f3420f1d8$var$fs,
            -1,
            [
                0,
                $a2acea4f3420f1d8$var$ws,
                [
                    0,
                    $a2acea4f3420f1d8$var$fs,
                    -2
                ]
            ]
        ],
        $a2acea4f3420f1d8$var$ws,
        [
            0,
            $a2acea4f3420f1d8$var$is,
            -1,
            $a2acea4f3420f1d8$var$As,
            $a2acea4f3420f1d8$var$is
        ]
    ],
    $a2acea4f3420f1d8$var$As,
    -1,
    $a2acea4f3420f1d8$var$us,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        $a2acea4f3420f1d8$var$fs,
        $a2acea4f3420f1d8$var$is
    ],
    $a2acea4f3420f1d8$var$ys,
    $a2acea4f3420f1d8$var$us
]), $a2acea4f3420f1d8$var$Lo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$xo = $a2acea4f3420f1d8$var$Ms(class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, [
    0,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        $a2acea4f3420f1d8$var$is,
        -4
    ]
]), $a2acea4f3420f1d8$var$Ro = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Io = $a2acea4f3420f1d8$var$Ms(class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, [
    0,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        $a2acea4f3420f1d8$var$is,
        -4
    ]
]), $a2acea4f3420f1d8$var$Fo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Co = [
    0,
    $a2acea4f3420f1d8$var$fs,
    -1,
    $a2acea4f3420f1d8$var$os,
    $a2acea4f3420f1d8$var$Rs
], $a2acea4f3420f1d8$var$No = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
};
$a2acea4f3420f1d8$var$No.prototype.g = $a2acea4f3420f1d8$var$Ds([
    0,
    $a2acea4f3420f1d8$var$is,
    -4,
    $a2acea4f3420f1d8$var$us
]);
var $a2acea4f3420f1d8$var$Mo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Oo = $a2acea4f3420f1d8$var$Ms(class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, [
    0,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        1,
        $a2acea4f3420f1d8$var$fs,
        $a2acea4f3420f1d8$var$As,
        $a2acea4f3420f1d8$var$Ao
    ],
    $a2acea4f3420f1d8$var$us
]), $a2acea4f3420f1d8$var$Do = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Po = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
    g() {
        var t = $a2acea4f3420f1d8$var$sr(this, 1, void 0, $a2acea4f3420f1d8$var$mr);
        return null == t ? $a2acea4f3420f1d8$var$I() : t;
    }
}, $a2acea4f3420f1d8$var$$o = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Uo = [
    1,
    2
], $a2acea4f3420f1d8$var$Bo = $a2acea4f3420f1d8$var$Ms(class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, [
    0,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        $a2acea4f3420f1d8$var$Uo,
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$os
        ],
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$Ts
        ],
        $a2acea4f3420f1d8$var$fs,
        $a2acea4f3420f1d8$var$As
    ],
    $a2acea4f3420f1d8$var$us
]), $a2acea4f3420f1d8$var$Go = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$jo = [
    0,
    $a2acea4f3420f1d8$var$As,
    $a2acea4f3420f1d8$var$fs,
    $a2acea4f3420f1d8$var$is,
    $a2acea4f3420f1d8$var$ys,
    -1
], $a2acea4f3420f1d8$var$Vo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Ho = [
    0,
    $a2acea4f3420f1d8$var$vs,
    -1
], $a2acea4f3420f1d8$var$Ko = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
    g() {
        return $a2acea4f3420f1d8$var$ur(this, $a2acea4f3420f1d8$var$Ys, 2, $a2acea4f3420f1d8$var$Xo);
    }
}, $a2acea4f3420f1d8$var$Xo = [
    1,
    2,
    3,
    4,
    5,
    6
], $a2acea4f3420f1d8$var$Wo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
    g() {
        return null != $a2acea4f3420f1d8$var$sr(this, 1, void 0, $a2acea4f3420f1d8$var$mr);
    }
    j() {
        return null != $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(this, 2));
    }
}, $a2acea4f3420f1d8$var$zo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Yo = [
    0,
    $a2acea4f3420f1d8$var$Ts,
    $a2acea4f3420f1d8$var$As,
    [
        0,
        $a2acea4f3420f1d8$var$fs,
        $a2acea4f3420f1d8$var$us,
        -1
    ],
    [
        0,
        $a2acea4f3420f1d8$var$ds,
        $a2acea4f3420f1d8$var$us
    ]
], $a2acea4f3420f1d8$var$qo = [
    0,
    $a2acea4f3420f1d8$var$Yo,
    $a2acea4f3420f1d8$var$vs,
    [
        0,
        $a2acea4f3420f1d8$var$Xo,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$ro,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$qs,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$Ws,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$to,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$Zs,
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$Js
    ],
    $a2acea4f3420f1d8$var$Rs
], $a2acea4f3420f1d8$var$Jo = $a2acea4f3420f1d8$var$Os($a2acea4f3420f1d8$var$qo), $a2acea4f3420f1d8$var$Zo = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Qo = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$is,
    -1,
    $a2acea4f3420f1d8$var$fs
], $a2acea4f3420f1d8$var$ta = $a2acea4f3420f1d8$var$Ns(502141897, $a2acea4f3420f1d8$var$Zo);
$a2acea4f3420f1d8$var$io[502141897] = $a2acea4f3420f1d8$var$Qo;
var $a2acea4f3420f1d8$var$ea = $a2acea4f3420f1d8$var$Ms(class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, [
    0,
    [
        0,
        $a2acea4f3420f1d8$var$Rs,
        -1,
        $a2acea4f3420f1d8$var$ss,
        $a2acea4f3420f1d8$var$Ls
    ],
    $a2acea4f3420f1d8$var$Co
]), $a2acea4f3420f1d8$var$ra = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$na = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$ia = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$is,
    [
        0,
        $a2acea4f3420f1d8$var$qo
    ],
    $a2acea4f3420f1d8$var$vs
], $a2acea4f3420f1d8$var$sa = $a2acea4f3420f1d8$var$Ns(508968150, $a2acea4f3420f1d8$var$na);
$a2acea4f3420f1d8$var$io[508968150] = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$Qo,
    $a2acea4f3420f1d8$var$ia,
    $a2acea4f3420f1d8$var$is,
    [
        0,
        [
            0,
            $a2acea4f3420f1d8$var$Yo
        ]
    ]
], $a2acea4f3420f1d8$var$io[508968149] = $a2acea4f3420f1d8$var$ia;
var $a2acea4f3420f1d8$var$oa = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
    j() {
        return $a2acea4f3420f1d8$var$Sr(this, $a2acea4f3420f1d8$var$Go, 2);
    }
    g() {
        $a2acea4f3420f1d8$var$ar(this, 2);
    }
}, $a2acea4f3420f1d8$var$aa = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$jo
];
$a2acea4f3420f1d8$var$io[478825465] = $a2acea4f3420f1d8$var$aa;
var $a2acea4f3420f1d8$var$ha = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$ua = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$ca = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$la = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$da = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$fa = [
    0,
    $a2acea4f3420f1d8$var$qo,
    [
        0,
        $a2acea4f3420f1d8$var$qo
    ],
    $a2acea4f3420f1d8$var$aa,
    -1
], $a2acea4f3420f1d8$var$pa = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$is,
    $a2acea4f3420f1d8$var$fs
], $a2acea4f3420f1d8$var$ga = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$is
], $a2acea4f3420f1d8$var$ma = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$pa,
    $a2acea4f3420f1d8$var$ga,
    $a2acea4f3420f1d8$var$is
], $a2acea4f3420f1d8$var$va = $a2acea4f3420f1d8$var$Ns(479097054, $a2acea4f3420f1d8$var$da);
$a2acea4f3420f1d8$var$io[479097054] = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$ma,
    $a2acea4f3420f1d8$var$fa
], $a2acea4f3420f1d8$var$io[463370452] = $a2acea4f3420f1d8$var$fa, $a2acea4f3420f1d8$var$io[464864288] = $a2acea4f3420f1d8$var$pa;
var $a2acea4f3420f1d8$var$_a = $a2acea4f3420f1d8$var$Ns(462713202, $a2acea4f3420f1d8$var$la);
$a2acea4f3420f1d8$var$io[462713202] = $a2acea4f3420f1d8$var$ma, $a2acea4f3420f1d8$var$io[474472470] = $a2acea4f3420f1d8$var$ga;
var $a2acea4f3420f1d8$var$ya = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Ea = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Aa = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$wa = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$ba = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$is,
    -1,
    $a2acea4f3420f1d8$var$fs
], $a2acea4f3420f1d8$var$Ta = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$is,
    $a2acea4f3420f1d8$var$vs
];
$a2acea4f3420f1d8$var$wa.prototype.g = $a2acea4f3420f1d8$var$Ds([
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$ga,
    [
        0,
        $a2acea4f3420f1d8$var$qo
    ],
    $a2acea4f3420f1d8$var$Qo,
    $a2acea4f3420f1d8$var$ia,
    $a2acea4f3420f1d8$var$ba,
    $a2acea4f3420f1d8$var$Ta
]);
var $a2acea4f3420f1d8$var$ka = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Sa = $a2acea4f3420f1d8$var$Ns(456383383, $a2acea4f3420f1d8$var$ka);
$a2acea4f3420f1d8$var$io[456383383] = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$jo
];
var $a2acea4f3420f1d8$var$La = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$xa = $a2acea4f3420f1d8$var$Ns(476348187, $a2acea4f3420f1d8$var$La);
$a2acea4f3420f1d8$var$io[476348187] = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$Ho
];
var $a2acea4f3420f1d8$var$Ra = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Ia = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Fa = [
    0,
    $a2acea4f3420f1d8$var$Rs,
    -1
], $a2acea4f3420f1d8$var$Ca = $a2acea4f3420f1d8$var$Ns(458105876, class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
    g() {
        var t = this.A, e = 0 | t[$a2acea4f3420f1d8$var$et], r = $a2acea4f3420f1d8$var$ht(this, e);
        return t = function(t, e, r, n) {
            var i = $a2acea4f3420f1d8$var$Ia;
            !n && $a2acea4f3420f1d8$var$Qe(t) && (r = 0 | (e = t.A)[$a2acea4f3420f1d8$var$et]);
            var s = $a2acea4f3420f1d8$var$or(e, 2);
            if (t = !1, null == s) {
                if (n) return $a2acea4f3420f1d8$var$Ce();
                s = [];
            } else if (s.constructor === $a2acea4f3420f1d8$var$Re) {
                if (!(2 & s.M) || n) return s;
                s = s.ea();
            } else Array.isArray(s) ? t = !!(2 & s[$a2acea4f3420f1d8$var$et]) : s = [];
            if (n) {
                if (!s.length) return $a2acea4f3420f1d8$var$Ce();
                t || (t = !0, $a2acea4f3420f1d8$var$st(s));
            } else t && (t = !1, $a2acea4f3420f1d8$var$ot(s), s = $a2acea4f3420f1d8$var$vr(s));
            return !t && 32 & r && $a2acea4f3420f1d8$var$nt(s, 32), r = $a2acea4f3420f1d8$var$hr(e, r, 2, n = new $a2acea4f3420f1d8$var$Re(s, i, $a2acea4f3420f1d8$var$Ee, void 0)), t || $a2acea4f3420f1d8$var$er(e, r), n;
        }(this, t, e, r), !r && $a2acea4f3420f1d8$var$Ia && (t.Fa = !0), t;
    }
});
$a2acea4f3420f1d8$var$io[458105876] = [
    0,
    $a2acea4f3420f1d8$var$Fa,
    $a2acea4f3420f1d8$var$Vi,
    [
        !0,
        $a2acea4f3420f1d8$var$us,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -1,
            $a2acea4f3420f1d8$var$ys
        ]
    ],
    [
        0,
        $a2acea4f3420f1d8$var$gs,
        $a2acea4f3420f1d8$var$vs,
        $a2acea4f3420f1d8$var$Rs
    ],
    $a2acea4f3420f1d8$var$vs
];
var $a2acea4f3420f1d8$var$Na = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Ma = $a2acea4f3420f1d8$var$Ns(458105758, $a2acea4f3420f1d8$var$Na);
$a2acea4f3420f1d8$var$io[458105758] = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$As,
    $a2acea4f3420f1d8$var$Fa
];
var $a2acea4f3420f1d8$var$Oa = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Da = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Pa = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$$a = $a2acea4f3420f1d8$var$Os([
    0,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        $a2acea4f3420f1d8$var$Is,
        $a2acea4f3420f1d8$var$ws,
        [
            0,
            $a2acea4f3420f1d8$var$as,
            -1
        ],
        $a2acea4f3420f1d8$var$_s
    ]
]), $a2acea4f3420f1d8$var$Ua = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Ba = [
    0,
    $a2acea4f3420f1d8$var$as,
    -1,
    $a2acea4f3420f1d8$var$_s
], $a2acea4f3420f1d8$var$Ga = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$ja = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Va = [
    1,
    2
];
$a2acea4f3420f1d8$var$ja.prototype.g = $a2acea4f3420f1d8$var$Ds([
    0,
    $a2acea4f3420f1d8$var$Va,
    $a2acea4f3420f1d8$var$bs,
    $a2acea4f3420f1d8$var$Ba,
    $a2acea4f3420f1d8$var$bs,
    [
        0,
        $a2acea4f3420f1d8$var$ws,
        $a2acea4f3420f1d8$var$Ba
    ]
]);
var $a2acea4f3420f1d8$var$Ha = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Ka = $a2acea4f3420f1d8$var$Ns(443442058, $a2acea4f3420f1d8$var$Ha);
$a2acea4f3420f1d8$var$io[443442058] = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$As,
    $a2acea4f3420f1d8$var$fs,
    $a2acea4f3420f1d8$var$is,
    $a2acea4f3420f1d8$var$ys,
    -1,
    $a2acea4f3420f1d8$var$vs,
    $a2acea4f3420f1d8$var$is
], $a2acea4f3420f1d8$var$io[514774813] = $a2acea4f3420f1d8$var$ba;
var $a2acea4f3420f1d8$var$Xa = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$Wa = $a2acea4f3420f1d8$var$Ns(516587230, $a2acea4f3420f1d8$var$Xa);
function $a2acea4f3420f1d8$var$za(t, e) {
    return e = e ? e.clone() : new $a2acea4f3420f1d8$var$Go, void 0 !== t.displayNamesLocale ? $a2acea4f3420f1d8$var$ar(e, 1, $a2acea4f3420f1d8$var$ve(t.displayNamesLocale)) : void 0 === t.displayNamesLocale && $a2acea4f3420f1d8$var$ar(e, 1), void 0 !== t.maxResults ? $a2acea4f3420f1d8$var$Ur(e, 2, t.maxResults) : "maxResults" in t && $a2acea4f3420f1d8$var$ar(e, 2), void 0 !== t.scoreThreshold ? $a2acea4f3420f1d8$var$jr(e, 3, t.scoreThreshold) : "scoreThreshold" in t && $a2acea4f3420f1d8$var$ar(e, 3), void 0 !== t.categoryAllowlist ? $a2acea4f3420f1d8$var$Kr(e, 4, t.categoryAllowlist) : "categoryAllowlist" in t && $a2acea4f3420f1d8$var$ar(e, 4), void 0 !== t.categoryDenylist ? $a2acea4f3420f1d8$var$Kr(e, 5, t.categoryDenylist) : "categoryDenylist" in t && $a2acea4f3420f1d8$var$ar(e, 5), e;
}
function $a2acea4f3420f1d8$var$Ya(t) {
    var e = Number(t);
    return Number.isSafeInteger(e) ? e : String(t);
}
function $a2acea4f3420f1d8$var$qa(t, e = -1, r = "") {
    return {
        categories: t.map((t)=>({
                index: $a2acea4f3420f1d8$var$Or(t, 1) ?? 0 ?? -1,
                score: $a2acea4f3420f1d8$var$Dr(t, 2) ?? 0,
                categoryName: $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(t, 3)) ?? "" ?? "",
                displayName: $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(t, 4)) ?? "" ?? ""
            })),
        headIndex: e,
        headName: r
    };
}
function $a2acea4f3420f1d8$var$Ja(t) {
    var e = {
        classifications: $a2acea4f3420f1d8$var$xr(t, $a2acea4f3420f1d8$var$Mo, 1).map((t)=>$a2acea4f3420f1d8$var$qa($a2acea4f3420f1d8$var$Sr(t, $a2acea4f3420f1d8$var$Eo, 4)?.g() ?? [], $a2acea4f3420f1d8$var$Or(t, 2) ?? 0, $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(t, 3)) ?? ""))
    };
    return null != function(t) {
        return null == t ? t : "bigint" == typeof t ? ($a2acea4f3420f1d8$var$wt(t) ? t = Number(t) : (t = $a2acea4f3420f1d8$var$Ht(64, t), t = $a2acea4f3420f1d8$var$wt(t) ? Number(t) : String(t)), t) : $a2acea4f3420f1d8$var$te(t) ? "number" == typeof t ? $a2acea4f3420f1d8$var$ae(t) : $a2acea4f3420f1d8$var$ce(t) : void 0;
    }($a2acea4f3420f1d8$var$sr(t, 2, void 0, $a2acea4f3420f1d8$var$fe)) && (e.timestampMs = $a2acea4f3420f1d8$var$Ya($a2acea4f3420f1d8$var$sr(t, 2, void 0, $a2acea4f3420f1d8$var$fe) ?? $a2acea4f3420f1d8$var$nr)), e;
}
function $a2acea4f3420f1d8$var$Za(t) {
    var e = $a2acea4f3420f1d8$var$lr(t, 3, $a2acea4f3420f1d8$var$Jt, $a2acea4f3420f1d8$var$cr()), r = $a2acea4f3420f1d8$var$lr(t, 2, $a2acea4f3420f1d8$var$re, $a2acea4f3420f1d8$var$cr()), n = $a2acea4f3420f1d8$var$lr(t, 1, $a2acea4f3420f1d8$var$_e, $a2acea4f3420f1d8$var$cr()), i = $a2acea4f3420f1d8$var$lr(t, 9, $a2acea4f3420f1d8$var$_e, $a2acea4f3420f1d8$var$cr()), s = {
        categories: [],
        keypoints: []
    };
    for(let t = 0; t < e.length; t++)s.categories.push({
        score: e[t],
        index: r[t] ?? -1,
        categoryName: n[t] ?? "",
        displayName: i[t] ?? ""
    });
    if ((e = $a2acea4f3420f1d8$var$Sr(t, $a2acea4f3420f1d8$var$ko, 4)?.j()) && (s.boundingBox = {
        originX: $a2acea4f3420f1d8$var$Or(e, 1, $a2acea4f3420f1d8$var$ir) ?? 0,
        originY: $a2acea4f3420f1d8$var$Or(e, 2, $a2acea4f3420f1d8$var$ir) ?? 0,
        width: $a2acea4f3420f1d8$var$Or(e, 3, $a2acea4f3420f1d8$var$ir) ?? 0,
        height: $a2acea4f3420f1d8$var$Or(e, 4, $a2acea4f3420f1d8$var$ir) ?? 0,
        angle: 0
    }), $a2acea4f3420f1d8$var$Sr(t, $a2acea4f3420f1d8$var$ko, 4)?.g().length) for (let e of $a2acea4f3420f1d8$var$Sr(t, $a2acea4f3420f1d8$var$ko, 4).g())s.keypoints.push({
        x: $a2acea4f3420f1d8$var$sr(e, 1, $a2acea4f3420f1d8$var$ir, $a2acea4f3420f1d8$var$Jt) ?? 0,
        y: $a2acea4f3420f1d8$var$sr(e, 2, $a2acea4f3420f1d8$var$ir, $a2acea4f3420f1d8$var$Jt) ?? 0,
        score: $a2acea4f3420f1d8$var$sr(e, 4, $a2acea4f3420f1d8$var$ir, $a2acea4f3420f1d8$var$Jt) ?? 0,
        label: $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(e, 3, $a2acea4f3420f1d8$var$ir)) ?? ""
    });
    return s;
}
function $a2acea4f3420f1d8$var$Qa(t) {
    var e = [];
    for (let r of $a2acea4f3420f1d8$var$xr(t, $a2acea4f3420f1d8$var$Ro, 1))e.push({
        x: $a2acea4f3420f1d8$var$Dr(r, 1) ?? 0,
        y: $a2acea4f3420f1d8$var$Dr(r, 2) ?? 0,
        z: $a2acea4f3420f1d8$var$Dr(r, 3) ?? 0,
        visibility: $a2acea4f3420f1d8$var$Dr(r, 4) ?? 0
    });
    return e;
}
function $a2acea4f3420f1d8$var$th(t) {
    var e = [];
    for (let r of $a2acea4f3420f1d8$var$xr(t, $a2acea4f3420f1d8$var$Lo, 1))e.push({
        x: $a2acea4f3420f1d8$var$Dr(r, 1) ?? 0,
        y: $a2acea4f3420f1d8$var$Dr(r, 2) ?? 0,
        z: $a2acea4f3420f1d8$var$Dr(r, 3) ?? 0,
        visibility: $a2acea4f3420f1d8$var$Dr(r, 4) ?? 0
    });
    return e;
}
function $a2acea4f3420f1d8$var$eh(t) {
    return Array.from(t, (t)=>t > 127 ? t - 256 : t);
}
function $a2acea4f3420f1d8$var$rh(t, e) {
    if (t.length !== e.length) throw Error(`Cannot compute cosine similarity between embeddings of different sizes (${t.length} vs. ${e.length}).`);
    var r = 0, n = 0, i = 0;
    for(let s = 0; s < t.length; s++)r += t[s] * e[s], n += t[s] * t[s], i += e[s] * e[s];
    if (n <= 0 || i <= 0) throw Error("Cannot compute cosine similarity on embedding with 0 norm.");
    return r / Math.sqrt(n * i);
}
$a2acea4f3420f1d8$var$io[516587230] = [
    0,
    $a2acea4f3420f1d8$var$qo,
    $a2acea4f3420f1d8$var$ba,
    $a2acea4f3420f1d8$var$Ta,
    $a2acea4f3420f1d8$var$is
], $a2acea4f3420f1d8$var$io[518928384] = $a2acea4f3420f1d8$var$Ta;
var $a2acea4f3420f1d8$var$nh, $a2acea4f3420f1d8$var$ih = new Uint8Array([
    0,
    97,
    115,
    109,
    1,
    0,
    0,
    0,
    1,
    5,
    1,
    96,
    0,
    1,
    123,
    3,
    2,
    1,
    0,
    10,
    10,
    1,
    8,
    0,
    65,
    0,
    253,
    15,
    253,
    98,
    11
]);
async function $a2acea4f3420f1d8$var$sh(t) {
    if (t) return !0;
    if (void 0 === $a2acea4f3420f1d8$var$nh) try {
        await WebAssembly.instantiate($a2acea4f3420f1d8$var$ih), $a2acea4f3420f1d8$var$nh = !0;
    } catch  {
        $a2acea4f3420f1d8$var$nh = !1;
    }
    return $a2acea4f3420f1d8$var$nh;
}
async function $a2acea4f3420f1d8$var$oh(t, e, r) {
    return {
        wasmLoaderPath: `${e}/${t}_${r = `wasm${r ? "_module" : ""}${await $a2acea4f3420f1d8$var$sh(r) ? "" : "_nosimd"}_internal`}.js`,
        wasmBinaryPath: `${e}/${t}_${r}.wasm`
    };
}
var $a2acea4f3420f1d8$export$f97946dfe503e8d3 = class {
};
function $a2acea4f3420f1d8$var$hh(t) {
    return $a2acea4f3420f1d8$var$ar(new $a2acea4f3420f1d8$var$uh, 1, $a2acea4f3420f1d8$var$ee(t));
}
$a2acea4f3420f1d8$export$f97946dfe503e8d3.forVisionTasks = function(t, e = !1) {
    return $a2acea4f3420f1d8$var$oh("vision", t ?? $a2acea4f3420f1d8$var$Xs``, e);
}, $a2acea4f3420f1d8$export$f97946dfe503e8d3.forTextTasks = function(t, e = !1) {
    return $a2acea4f3420f1d8$var$oh("text", t ?? $a2acea4f3420f1d8$var$Xs``, e);
}, $a2acea4f3420f1d8$export$f97946dfe503e8d3.forGenAiTasks = function(t, e = !1) {
    return $a2acea4f3420f1d8$var$oh("genai", t ?? $a2acea4f3420f1d8$var$Xs``, e);
}, $a2acea4f3420f1d8$export$f97946dfe503e8d3.forAudioTasks = function(t, e = !1) {
    return $a2acea4f3420f1d8$var$oh("audio", t ?? $a2acea4f3420f1d8$var$Xs``, e);
}, $a2acea4f3420f1d8$export$f97946dfe503e8d3.isSimdSupported = function(t = !1) {
    return $a2acea4f3420f1d8$var$sh(t);
};
var $a2acea4f3420f1d8$var$uh = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$ch = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$lh = [
    0,
    $a2acea4f3420f1d8$var$Rs,
    2,
    $a2acea4f3420f1d8$var$ds,
    -2,
    $a2acea4f3420f1d8$var$us,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        $a2acea4f3420f1d8$var$Rs,
        $a2acea4f3420f1d8$var$us
    ]
], $a2acea4f3420f1d8$var$dh = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$fh = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
};
function $a2acea4f3420f1d8$var$ph(t, e) {
    return $a2acea4f3420f1d8$var$ar(t, 1, $a2acea4f3420f1d8$var$ee(e));
}
function $a2acea4f3420f1d8$var$gh(t, e) {
    return $a2acea4f3420f1d8$var$ar(t, 2, $a2acea4f3420f1d8$var$ee(e));
}
var $a2acea4f3420f1d8$var$mh = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$vh = [
    3,
    4,
    5,
    6,
    7
], $a2acea4f3420f1d8$var$_h = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
}, $a2acea4f3420f1d8$var$yh = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t);
    }
};
$a2acea4f3420f1d8$var$yh.prototype.g = $a2acea4f3420f1d8$var$Ds([
    0,
    [
        0,
        $a2acea4f3420f1d8$var$Rs,
        $a2acea4f3420f1d8$var$As,
        -3,
        $a2acea4f3420f1d8$var$Rs
    ],
    [
        0,
        $a2acea4f3420f1d8$var$vh,
        $a2acea4f3420f1d8$var$Rs,
        -1,
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            $a2acea4f3420f1d8$var$ds
        ],
        $a2acea4f3420f1d8$var$bs,
        $a2acea4f3420f1d8$var$lh,
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            1,
            $a2acea4f3420f1d8$var$lh
        ],
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$Rs
        ],
        $a2acea4f3420f1d8$var$bs,
        [
            0,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            $a2acea4f3420f1d8$var$ds
        ]
    ]
]);
var $a2acea4f3420f1d8$var$Eh = class {
    constructor(){
        this.g = "undefined" != typeof AbortController;
    }
    async send(t, e, r) {
        var n = this.g ? new AbortController : void 0, i = n && t.la > 0 ? setTimeout(()=>{
            n.abort();
        }, t.la) : void 0;
        try {
            let i = await fetch(t.url, {
                method: t.bb,
                headers: {
                    ...t.ab
                },
                ...t.body && {
                    body: t.body
                },
                ...t.withCredentials && {
                    credentials: "include"
                },
                signal: t.la && n ? n.signal : null
            });
            200 === i.status ? e?.(await i.text()) : r?.(i.status);
        } catch (t) {
            if ("AbortError" === t?.name) r?.(408);
            else r?.(400);
        } finally{
            clearTimeout(i);
        }
    }
}, $a2acea4f3420f1d8$var$Ah = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t, 37);
    }
}, $a2acea4f3420f1d8$var$wh = [
    -4,
    {},
    $a2acea4f3420f1d8$var$js,
    $a2acea4f3420f1d8$var$Rs,
    $a2acea4f3420f1d8$var$$s
], $a2acea4f3420f1d8$var$bh = [
    0,
    $a2acea4f3420f1d8$var$As,
    $a2acea4f3420f1d8$var$Rs,
    1,
    $a2acea4f3420f1d8$var$As,
    -1,
    $a2acea4f3420f1d8$var$Rs,
    1,
    $a2acea4f3420f1d8$var$Rs,
    1,
    $a2acea4f3420f1d8$var$us
], $a2acea4f3420f1d8$var$Th = [
    0,
    $a2acea4f3420f1d8$var$Rs,
    $a2acea4f3420f1d8$var$As,
    -2
], $a2acea4f3420f1d8$var$kh = [
    0,
    $a2acea4f3420f1d8$var$As,
    $a2acea4f3420f1d8$var$Rs
], $a2acea4f3420f1d8$var$Sh = [
    0,
    $a2acea4f3420f1d8$var$As,
    $a2acea4f3420f1d8$var$Rs
], $a2acea4f3420f1d8$var$Lh = [
    0,
    $a2acea4f3420f1d8$var$vs,
    -3
], $a2acea4f3420f1d8$var$xh = [
    0,
    $a2acea4f3420f1d8$var$Rs,
    $a2acea4f3420f1d8$var$As,
    -1,
    $a2acea4f3420f1d8$var$us,
    $a2acea4f3420f1d8$var$fs,
    -1,
    $a2acea4f3420f1d8$var$As,
    -5,
    $a2acea4f3420f1d8$var$ws,
    [
        0,
        $a2acea4f3420f1d8$var$As,
        -4
    ],
    -1,
    $a2acea4f3420f1d8$var$vs,
    [
        0,
        $a2acea4f3420f1d8$var$vs,
        -3
    ],
    $a2acea4f3420f1d8$var$Rs
];
var $a2acea4f3420f1d8$var$Rh = class extends $a2acea4f3420f1d8$var$di {
    constructor(t){
        super(t, 19);
    }
}, $a2acea4f3420f1d8$var$Ih = $a2acea4f3420f1d8$var$Os([
    -19,
    {},
    [
        0,
        $a2acea4f3420f1d8$var$Rs,
        1,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -6,
            $a2acea4f3420f1d8$var$us,
            $a2acea4f3420f1d8$var$fs,
            $a2acea4f3420f1d8$var$As,
            -1,
            $a2acea4f3420f1d8$var$us
        ],
        1,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            1,
            $a2acea4f3420f1d8$var$As,
            -5
        ],
        $a2acea4f3420f1d8$var$As,
        -1,
        [
            0,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            -8
        ],
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -3
        ],
        [
            0,
            $a2acea4f3420f1d8$var$As,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            -2
        ],
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -1,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            -1,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            -1,
            [
                0,
                $a2acea4f3420f1d8$var$ws,
                [
                    0,
                    $a2acea4f3420f1d8$var$As,
                    -1
                ],
                $a2acea4f3420f1d8$var$vs,
                $a2acea4f3420f1d8$var$As,
                -5
            ],
            [
                0,
                $a2acea4f3420f1d8$var$Rs,
                $a2acea4f3420f1d8$var$vs,
                $a2acea4f3420f1d8$var$fs,
                -2
            ]
        ],
        $a2acea4f3420f1d8$var$us,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -3,
            $a2acea4f3420f1d8$var$us,
            $a2acea4f3420f1d8$var$fs,
            $a2acea4f3420f1d8$var$As,
            -1
        ],
        [
            0,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            -1
        ],
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -9
        ],
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -6,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            1,
            $a2acea4f3420f1d8$var$As,
            $a2acea4f3420f1d8$var$vs,
            $a2acea4f3420f1d8$var$Rs,
            -1,
            $a2acea4f3420f1d8$var$vs,
            $a2acea4f3420f1d8$var$As,
            -2,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            $a2acea4f3420f1d8$var$fs,
            -1
        ],
        1,
        [
            0,
            $a2acea4f3420f1d8$var$Rs
        ],
        1,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -4
        ],
        1,
        $a2acea4f3420f1d8$var$bh,
        [
            0,
            [
                1,
                2,
                3,
                4,
                5,
                6
            ],
            $a2acea4f3420f1d8$var$bs,
            $a2acea4f3420f1d8$var$bh,
            $a2acea4f3420f1d8$var$bs,
            $a2acea4f3420f1d8$var$kh,
            $a2acea4f3420f1d8$var$bs,
            $a2acea4f3420f1d8$var$Sh,
            $a2acea4f3420f1d8$var$bs,
            [
                0,
                $a2acea4f3420f1d8$var$Rs
            ],
            $a2acea4f3420f1d8$var$bs,
            $a2acea4f3420f1d8$var$xh,
            $a2acea4f3420f1d8$var$bs,
            $a2acea4f3420f1d8$var$Th
        ],
        $a2acea4f3420f1d8$var$kh,
        $a2acea4f3420f1d8$var$Sh,
        $a2acea4f3420f1d8$var$xh,
        [
            0,
            [
                0,
                $a2acea4f3420f1d8$var$Rs,
                $a2acea4f3420f1d8$var$As,
                -1,
                $a2acea4f3420f1d8$var$us,
                $a2acea4f3420f1d8$var$fs,
                -1,
                $a2acea4f3420f1d8$var$As,
                -4,
                $a2acea4f3420f1d8$var$ws,
                [
                    0,
                    $a2acea4f3420f1d8$var$As,
                    -4
                ],
                -1,
                1,
                $a2acea4f3420f1d8$var$Lh
            ],
            [
                0,
                $a2acea4f3420f1d8$var$Rs,
                $a2acea4f3420f1d8$var$As,
                -1,
                $a2acea4f3420f1d8$var$us,
                $a2acea4f3420f1d8$var$fs,
                -1,
                $a2acea4f3420f1d8$var$As,
                -4,
                $a2acea4f3420f1d8$var$Lh
            ]
        ],
        $a2acea4f3420f1d8$var$Th,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            [
                0,
                $a2acea4f3420f1d8$var$fs,
                -3,
                $a2acea4f3420f1d8$var$Rs
            ],
            $a2acea4f3420f1d8$var$Rs,
            -2,
            [
                0,
                $a2acea4f3420f1d8$var$fs,
                -1
            ],
            $a2acea4f3420f1d8$var$vs
        ],
        4,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            -1,
            $a2acea4f3420f1d8$var$us,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$As,
            -1,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$fs,
            -1
        ]
    ],
    $a2acea4f3420f1d8$var$Rs,
    $a2acea4f3420f1d8$var$ws,
    [
        -37,
        {},
        $a2acea4f3420f1d8$var$hs,
        $a2acea4f3420f1d8$var$As,
        $a2acea4f3420f1d8$var$ws,
        [
            0,
            $a2acea4f3420f1d8$var$As,
            -1
        ],
        $a2acea4f3420f1d8$var$Ts,
        1,
        $a2acea4f3420f1d8$var$Ts,
        [
            0,
            $a2acea4f3420f1d8$var$ys,
            -1,
            $a2acea4f3420f1d8$var$ps,
            $a2acea4f3420f1d8$var$cs,
            -1
        ],
        $a2acea4f3420f1d8$var$As,
        [
            0,
            $a2acea4f3420f1d8$var$fs,
            $a2acea4f3420f1d8$var$As,
            -1
        ],
        $a2acea4f3420f1d8$var$vs,
        $a2acea4f3420f1d8$var$fs,
        $a2acea4f3420f1d8$var$us,
        $a2acea4f3420f1d8$var$As,
        -1,
        $a2acea4f3420f1d8$var$Fs,
        $a2acea4f3420f1d8$var$Ps,
        $a2acea4f3420f1d8$var$hs,
        $a2acea4f3420f1d8$var$Ts,
        $a2acea4f3420f1d8$var$Rs,
        $a2acea4f3420f1d8$var$ps,
        $a2acea4f3420f1d8$var$us,
        -1,
        [
            0,
            $a2acea4f3420f1d8$var$Rs,
            -1
        ],
        $a2acea4f3420f1d8$var$As,
        $a2acea4f3420f1d8$var$vs,
        $a2acea4f3420f1d8$var$As,
        $a2acea4f3420f1d8$var$gs,
        $a2acea4f3420f1d8$var$As,
        -1,
        $a2acea4f3420f1d8$var$ns,
        1,
        $a2acea4f3420f1d8$var$ns,
        $a2acea4f3420f1d8$var$wh,
        $a2acea4f3420f1d8$var$vs,
        [
            0,
            $a2acea4f3420f1d8$var$Rs,
            [
                0,
                $a2acea4f3420f1d8$var$is,
                $a2acea4f3420f1d8$var$fs,
                -2
            ],
            [
                0,
                $a2acea4f3420f1d8$var$is
            ]
        ],
        [
            0,
            $a2acea4f3420f1d8$var$Rs,
            $a2acea4f3420f1d8$var$us
        ]
    ],
    $a2acea4f3420f1d8$var$hs,
    $a2acea4f3420f1d8$var$ks,
    $a2acea4f3420f1d8$var$As,
    -1,
    $a2acea4f3420f1d8$var$hs,
    $a2acea4f3420f1d8$var$Rs,
    -1,
    [
        0,
        $a2acea4f3420f1d8$var$vs,
        -1,
        $a2acea4f3420f1d8$var$Rs,
        $a2acea4f3420f1d8$var$vs
    ],
    [
        0,
        $a2acea4f3420f1d8$var$us,
        -1,
        $a2acea4f3420f1d8$var$As
    ],
    [
        0,
        $a2acea4f3420f1d8$var$hs,
        $a2acea4f3420f1d8$var$vs,
        $a2acea4f3420f1d8$var$us
    ],
    $a2acea4f3420f1d8$var$us,
    1,
    $a2acea4f3420f1d8$var$Ss,
    1,
    $a2acea4f3420f1d8$var$wh
]), $a2acea4f3420f1d8$var$Fh = class {
    constructor(t){
        this.h = [], this.m = new $a2acea4f3420f1d8$var$Eh, this.j = t ?? "", this.g = setInterval(()=>{
            this.flush();
        }, 6e4);
    }
    close() {
        void 0 !== this.g && (clearInterval(this.g), this.g = void 0), this.flush();
    }
    flush(t, e) {
        if (this.error) e?.("net-send-failed");
        else if (0 === this.h.length) t?.();
        else {
            var r = this.h;
            this.h = [], r = function(t) {
                var e = new $a2acea4f3420f1d8$var$Rh;
                return $a2acea4f3420f1d8$var$Cr(e = $a2acea4f3420f1d8$var$ar(e, 2, $a2acea4f3420f1d8$var$ee(1786)), 3, t);
            }(r), r = $a2acea4f3420f1d8$var$Ih(r), this.m.send({
                url: "https://odml.pa.googleapis.com/v1/log",
                bb: "POST",
                la: 1e4,
                body: r,
                hb: 2,
                ab: {
                    "Content-Type": "application/x-protobuf",
                    "x-goog-api-key": this.j
                },
                withCredentials: !1
            }, ()=>{
                t?.();
            }, (t)=>{
                this.error = Error(`Logging failed with HTTP error: ${t}`), this.h = [], void 0 !== this.g && (clearInterval(this.g), this.g = void 0), e?.("net-send-failed", t);
            });
        }
    }
};
class $a2acea4f3420f1d8$var$Ch {
    constructor(){
        this.aa = this.U = this.X = this.R = this.V = this.T = this.P = 0;
    }
}
function $a2acea4f3420f1d8$var$Nh(t, e) {
    var r = new $a2acea4f3420f1d8$var$yh;
    r = $a2acea4f3420f1d8$var$Ir(r, 0, 1, t.B), r = $a2acea4f3420f1d8$var$Ir(r, 0, 2, e), e = $a2acea4f3420f1d8$var$ar(e = new $a2acea4f3420f1d8$var$Ah, 6, $a2acea4f3420f1d8$var$ct(r = r.g(), !1)), (t = t.l).error || t.h.push(e);
}
function $a2acea4f3420f1d8$var$Mh(t, e) {
    var r = {
        P: e.P - t.j.P,
        T: e.T - t.j.T,
        V: e.V - t.j.V,
        R: e.R - t.j.R,
        X: e.X - t.j.X,
        U: e.U,
        aa: e.aa
    }, n = $a2acea4f3420f1d8$var$gh($a2acea4f3420f1d8$var$ph(new $a2acea4f3420f1d8$var$mh, t.C), 1);
    r = $a2acea4f3420f1d8$var$Oh(t, r), $a2acea4f3420f1d8$var$Nh(t, n = $a2acea4f3420f1d8$var$Fr(n, 4, $a2acea4f3420f1d8$var$vh, r)), t.j = e;
}
function $a2acea4f3420f1d8$var$Oh(t, e) {
    var r = new $a2acea4f3420f1d8$var$ch;
    return t = $a2acea4f3420f1d8$var$Gr(t = $a2acea4f3420f1d8$var$Br(t = $a2acea4f3420f1d8$var$ar(r, 1, $a2acea4f3420f1d8$var$ee(t.D)), 7, e.R), 5, e.U), t = $a2acea4f3420f1d8$var$Gr(t, 6, e.aa), e.V > 0 && $a2acea4f3420f1d8$var$Gr(t, 4, e.X / e.V), 0 !== e.P && (r = $a2acea4f3420f1d8$var$Br(r = $a2acea4f3420f1d8$var$hh(3), 2, e.P), $a2acea4f3420f1d8$var$Mr(t, 8, $a2acea4f3420f1d8$var$uh, r)), 0 !== e.T && (e = $a2acea4f3420f1d8$var$Br(r = $a2acea4f3420f1d8$var$hh(4), 2, e.T), $a2acea4f3420f1d8$var$Mr(t, 8, $a2acea4f3420f1d8$var$uh, e)), t;
}
var $a2acea4f3420f1d8$var$Dh = class {
    constructor(t, e, r){
        this.u = performance.now(), this.m = performance.now(), this.h = new Map, this.o = 0, this.g = new $a2acea4f3420f1d8$var$Ch, this.j = new $a2acea4f3420f1d8$var$Ch, this.l = new $a2acea4f3420f1d8$var$Fh(r), this.C = function(t) {
            switch(t){
                case "AudioClassifier":
                    return 4;
                case "AudioEmbedder":
                    return 5;
                case "TextClassifier":
                    return 6;
                case "TextEmbedder":
                    return 7;
                case "GestureRecognizer":
                    return 8;
                case "HandDetector":
                    return 9;
                case "HandLandmarker":
                    return 10;
                case "ImageClassifier":
                    return 11;
                case "ImageEmbedder":
                    return 12;
                case "ImageSegmenter":
                    return 13;
                case "ObjectDetector":
                    return 14;
                case "FaceDetector":
                    return 15;
                case "FaceLandmarker":
                    return 16;
                case "InteractiveSegmenter":
                case "InteractiveSegmenterLegacy":
                    return 18;
                case "HolisticLandmarker":
                    return 20;
                case "LlmInference":
                    return 21;
                case "LanguageDetector":
                    return 22;
                case "PoseLandmarker":
                    return 23;
                default:
                    return 0;
            }
        }(t), this.D = function(t) {
            switch(t){
                case "IMAGE":
                    return 11;
                case "VIDEO":
                    return 12;
                case "LIVE_STREAM":
                    return 13;
                case "AUDIO_CLIPS":
                    return 14;
                case "AUDIO_STREAM":
                    return 15;
                default:
                    return 10;
            }
        }(e), t = new $a2acea4f3420f1d8$var$_h, "undefined" == typeof window ? e = 0 : (e = navigator.userAgent, e = /Android/i.test(e) ? 1 : /iPhone|iPad|iPod/i.test(e) ? 2 : /Windows/i.test(e) ? 5 : /Macintosh/i.test(e) ? 4 : /Linux/i.test(e) ? 3 : 0), t = $a2acea4f3420f1d8$var$ar(t, 1, $a2acea4f3420f1d8$var$ee(e)), t = $a2acea4f3420f1d8$var$ar(t, 2, $a2acea4f3420f1d8$var$ve("")), t = $a2acea4f3420f1d8$var$ar(t, 3, $a2acea4f3420f1d8$var$ve("")), t = $a2acea4f3420f1d8$var$ar(t, 4, $a2acea4f3420f1d8$var$ve("1.0.1")), t = $a2acea4f3420f1d8$var$ar(t, 5, $a2acea4f3420f1d8$var$ve("")), this.B = $a2acea4f3420f1d8$var$ar(t, 6, $a2acea4f3420f1d8$var$ee(4));
    }
    ya() {
        var t = new $a2acea4f3420f1d8$var$fh;
        t = $a2acea4f3420f1d8$var$Gr(t = $a2acea4f3420f1d8$var$ar(t, 1, $a2acea4f3420f1d8$var$ee(this.D)), 3, performance.now() - this.u), $a2acea4f3420f1d8$var$Nh(this, t = $a2acea4f3420f1d8$var$Fr($a2acea4f3420f1d8$var$gh($a2acea4f3420f1d8$var$ph(new $a2acea4f3420f1d8$var$mh, this.C), 0), 3, $a2acea4f3420f1d8$var$vh, t)), this.m = performance.now();
    }
    za(t) {
        var e = this.h.get(t);
        if (void 0 !== e && (this.h.delete(t), t = performance.now() - e, ++this.g.V, this.g.X += t, this.g.U = Math.max(this.g.U, t), this.o = Math.max(this.o, t), performance.now() > this.m + 3e4)) {
            for (let [r, n] of this.h.entries())t = r, n < e && (this.g.R++, this.h.delete(t));
            e = {
                ...this.g,
                aa: performance.now() - this.m
            }, this.g.U = 0, this.m = performance.now(), $a2acea4f3420f1d8$var$Mh(this, e);
        }
    }
    xa() {
        var t = {
            ...this.g,
            R: this.g.R + this.h.size,
            U: this.o,
            aa: performance.now() - this.u
        };
        $a2acea4f3420f1d8$var$Mh(this, t);
        var e = new $a2acea4f3420f1d8$var$dh;
        e = $a2acea4f3420f1d8$var$Ir(e, 0, 2, t = $a2acea4f3420f1d8$var$Oh(this, t)), $a2acea4f3420f1d8$var$Nh(this, e = $a2acea4f3420f1d8$var$Fr(t = $a2acea4f3420f1d8$var$gh($a2acea4f3420f1d8$var$ph(new $a2acea4f3420f1d8$var$mh, this.C), 2), 5, $a2acea4f3420f1d8$var$vh, e));
    }
    close() {
        var t = this.l;
        "function" == typeof t.close ? t.close() : t.flush();
    }
};
function $a2acea4f3420f1d8$var$Ph() {
    var t = navigator;
    return "undefined" != typeof OffscreenCanvas && (!function(t = navigator) {
        return (t = t.userAgent).includes("Safari") && !t.includes("Chrome");
    }(t) || !!((t = t.userAgent.match(/Version\/([\d]+).*Safari/)) && t.length >= 1 && Number(t[1]) >= 17));
}
async function $a2acea4f3420f1d8$var$$h(t) {
    if ("function" != typeof importScripts) {
        let e = document.createElement("script");
        return e.src = t.toString(), e.crossOrigin = "anonymous", new Promise((t, r)=>{
            e.addEventListener("load", ()=>{
                t();
            }, !1), e.addEventListener("error", (t)=>{
                r(t);
            }, !1), document.body.appendChild(e);
        });
    }
    try {
        importScripts(t.toString());
    } catch (e) {
        if (!(e instanceof TypeError)) throw e;
        {
            let e = self.import;
            e ? await e(t.toString()) : await import(t.toString());
        }
    }
}
function $a2acea4f3420f1d8$var$Uh(t) {
    return void 0 !== t.videoWidth ? [
        t.videoWidth,
        t.videoHeight
    ] : void 0 !== t.naturalWidth ? [
        t.naturalWidth,
        t.naturalHeight
    ] : void 0 !== t.displayWidth ? [
        t.displayWidth,
        t.displayHeight
    ] : [
        t.width,
        t.height
    ];
}
function $a2acea4f3420f1d8$var$Bh(t, e, r) {
    t.m || console.error("No wasm multistream support detected: ensure dependency inclusion of :gl_graph_runner_internal_multi_input target"), r(e = t.i.stringToNewUTF8(e)), t.i._free(e);
}
function $a2acea4f3420f1d8$var$Gh(t, e, r) {
    if (!t.i.canvas) throw Error("No OpenGL canvas configured.");
    if (r ? t.i._bindTextureToStream(r) : t.i._bindTextureToCanvas(), !(r = t.i.canvas.getContext("webgl2") || t.i.canvas.getContext("webgl"))) throw Error("Failed to obtain WebGL context from the provided canvas. `getContext()` should only be invoked with `webgl` or `webgl2`.");
    t.i.gpuOriginForWebTexturesIsBottomLeft && r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, !0), r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, r.RGBA, r.UNSIGNED_BYTE, e), t.i.gpuOriginForWebTexturesIsBottomLeft && r.pixelStorei(r.UNPACK_FLIP_Y_WEBGL, !1);
    var [n, i] = $a2acea4f3420f1d8$var$Uh(e);
    return !t.j || n === t.i.canvas.width && i === t.i.canvas.height || (t.i.canvas.width = n, t.i.canvas.height = i), [
        n,
        i
    ];
}
function $a2acea4f3420f1d8$var$jh(t, e, r) {
    t.m || console.error("No wasm multistream support detected: ensure dependency inclusion of :gl_graph_runner_internal_multi_input target");
    var n = new Uint32Array(e.length);
    for(let r = 0; r < e.length; r++)n[r] = t.i.stringToNewUTF8(e[r]);
    e = t.i._malloc(4 * n.length), t.i.HEAPU32.set(n, e >> 2), r(e);
    for (let e of n)t.i._free(e);
    t.i._free(e);
}
function $a2acea4f3420f1d8$var$Vh(t, e, r) {
    t.i.simpleListeners = t.i.simpleListeners || {}, t.i.simpleListeners[e] = r;
}
function $a2acea4f3420f1d8$var$Hh(t, e, r) {
    var n = [];
    t.i.simpleListeners = t.i.simpleListeners || {}, t.i.simpleListeners[e] = (t, e, i)=>{
        e ? (r(n, i), n = []) : n.push(t);
    };
}
var $a2acea4f3420f1d8$var$Kh = class {
    constructor(t, e){
        this.j = !0, this.i = t, this.g = null, this.h = 0, this.m = "function" == typeof this.i._addIntToInputStream, void 0 !== e ? this.i.canvas = e : $a2acea4f3420f1d8$var$Ph() ? this.i.canvas = new OffscreenCanvas(1, 1) : (console.warn("OffscreenCanvas not supported and GraphRunner constructor glCanvas parameter is undefined. Creating backup canvas."), this.i.canvas = document.createElement("canvas"));
    }
    async initializeGraph(t) {
        var e = await (await fetch(t)).arrayBuffer();
        t = !(t.endsWith(".pbtxt") || t.endsWith(".textproto")), this.setGraph(new Uint8Array(e), t);
    }
    setGraphFromString(t) {
        this.setGraph((new TextEncoder).encode(t), !1);
    }
    setGraph(t, e) {
        var r = t.length, n = this.i._malloc(r);
        this.i.HEAPU8.set(t, n), e ? this.i._changeBinaryGraph(r, n) : this.i._changeTextGraph(r, n), this.i._free(n);
    }
    configureAudio(t, e, r, n, i) {
        this.i._configureAudio || console.warn('Attempting to use configureAudio without support for input audio. Is build dep ":gl_graph_runner_audio" missing?'), $a2acea4f3420f1d8$var$Bh(this, n || "input_audio", (n)=>{
            $a2acea4f3420f1d8$var$Bh(this, i = i || "audio_header", (i)=>{
                this.i._configureAudio(n, i, t, e ?? 0, r);
            });
        });
    }
    setAutoResizeCanvas(t) {
        this.j = t;
    }
    setAutoRenderToScreen(t) {
        this.i._setAutoRenderToScreen(t);
    }
    setGpuBufferVerticalFlip(t) {
        this.i.gpuOriginForWebTexturesIsBottomLeft = t;
    }
    ja(t) {
        $a2acea4f3420f1d8$var$Vh(this, "__graph_config__", (e)=>{
            t(e);
        }), $a2acea4f3420f1d8$var$Bh(this, "__graph_config__", (t)=>{
            this.i._getGraphConfig(t, void 0);
        }), delete this.i.simpleListeners.__graph_config__;
    }
    attachErrorListener(t) {
        this.i.errorListener = t;
    }
    attachEmptyPacketListener(t, e) {
        this.i.emptyPacketListeners = this.i.emptyPacketListeners || {}, this.i.emptyPacketListeners[t] = e;
    }
    addAudioToStream(t, e, r) {
        this.addAudioToStreamWithShape(t, 0, 0, e, r);
    }
    addAudioToStreamWithShape(t, e, r, n, i) {
        var s = 4 * t.length;
        this.h !== s && (this.g && this.i._free(this.g), this.g = this.i._malloc(s), this.h = s), this.i.HEAPF32.set(t, this.g / 4), $a2acea4f3420f1d8$var$Bh(this, n, (t)=>{
            this.i._addAudioToInputStream(this.g, e, r, t, i);
        });
    }
    addGpuBufferToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var [n, i] = $a2acea4f3420f1d8$var$Gh(this, t, e);
            this.i._addBoundTextureToStream(e, n, i, r);
        });
    }
    addBoolToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addBoolToInputStream(t, e, r);
        });
    }
    addDoubleToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addDoubleToInputStream(t, e, r);
        });
    }
    addFloatToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addFloatToInputStream(t, e, r);
        });
    }
    addIntToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addIntToInputStream(t, e, r);
        });
    }
    addUintToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addUintToInputStream(t, e, r);
        });
    }
    addStringToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
                this.i._addStringToInputStream(t, e, r);
            });
        });
    }
    addStringRecordToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            $a2acea4f3420f1d8$var$jh(this, Object.keys(t), (n)=>{
                $a2acea4f3420f1d8$var$jh(this, Object.values(t), (i)=>{
                    this.i._addFlatHashMapToInputStream(n, i, Object.keys(t).length, e, r);
                });
            });
        });
    }
    addProtoToStream(t, e, r, n) {
        $a2acea4f3420f1d8$var$Bh(this, r, (r)=>{
            $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
                var i = this.i._malloc(t.length);
                this.i.HEAPU8.set(t, i), this.i._addProtoToInputStream(i, t.length, e, r, n), this.i._free(i);
            });
        });
    }
    addEmptyPacketToStream(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._addEmptyPacketToInputStream(t, e);
        });
    }
    addBoolVectorToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var n = this.i._allocateBoolVector(t.length);
            if (!n) throw Error("Unable to allocate new bool vector on heap.");
            for (let e of t)this.i._addBoolVectorEntry(n, e);
            this.i._addBoolVectorToInputStream(n, e, r);
        });
    }
    addDoubleVectorToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var n = this.i._allocateDoubleVector(t.length);
            if (!n) throw Error("Unable to allocate new double vector on heap.");
            for (let e of t)this.i._addDoubleVectorEntry(n, e);
            this.i._addDoubleVectorToInputStream(n, e, r);
        });
    }
    addFloatVectorToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var n = this.i._allocateFloatVector(t.length);
            if (!n) throw Error("Unable to allocate new float vector on heap.");
            for (let e of t)this.i._addFloatVectorEntry(n, e);
            this.i._addFloatVectorToInputStream(n, e, r);
        });
    }
    addIntVectorToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var n = this.i._allocateIntVector(t.length);
            if (!n) throw Error("Unable to allocate new int vector on heap.");
            for (let e of t)this.i._addIntVectorEntry(n, e);
            this.i._addIntVectorToInputStream(n, e, r);
        });
    }
    addUintVectorToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var n = this.i._allocateUintVector(t.length);
            if (!n) throw Error("Unable to allocate new unsigned int vector on heap.");
            for (let e of t)this.i._addUintVectorEntry(n, e);
            this.i._addUintVectorToInputStream(n, e, r);
        });
    }
    addStringVectorToStream(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var n = this.i._allocateStringVector(t.length);
            if (!n) throw Error("Unable to allocate new string vector on heap.");
            for (let e of t)$a2acea4f3420f1d8$var$Bh(this, e, (t)=>{
                this.i._addStringVectorEntry(n, t);
            });
            this.i._addStringVectorToInputStream(n, e, r);
        });
    }
    addBoolToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addBoolToInputSidePacket(t, e);
        });
    }
    addDoubleToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addDoubleToInputSidePacket(t, e);
        });
    }
    addFloatToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addFloatToInputSidePacket(t, e);
        });
    }
    addIntToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addIntToInputSidePacket(t, e);
        });
    }
    addUintToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            this.i._addUintToInputSidePacket(t, e);
        });
    }
    addStringToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
                this.i._addStringToInputSidePacket(t, e);
            });
        });
    }
    addProtoToInputSidePacket(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, r, (r)=>{
            $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
                var n = this.i._malloc(t.length);
                this.i.HEAPU8.set(t, n), this.i._addProtoToInputSidePacket(n, t.length, e, r), this.i._free(n);
            });
        });
    }
    addBoolVectorToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var r = this.i._allocateBoolVector(t.length);
            if (!r) throw Error("Unable to allocate new bool vector on heap.");
            for (let e of t)this.i._addBoolVectorEntry(r, e);
            this.i._addBoolVectorToInputSidePacket(r, e);
        });
    }
    addDoubleVectorToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var r = this.i._allocateDoubleVector(t.length);
            if (!r) throw Error("Unable to allocate new double vector on heap.");
            for (let e of t)this.i._addDoubleVectorEntry(r, e);
            this.i._addDoubleVectorToInputSidePacket(r, e);
        });
    }
    addFloatVectorToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var r = this.i._allocateFloatVector(t.length);
            if (!r) throw Error("Unable to allocate new float vector on heap.");
            for (let e of t)this.i._addFloatVectorEntry(r, e);
            this.i._addFloatVectorToInputSidePacket(r, e);
        });
    }
    addIntVectorToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var r = this.i._allocateIntVector(t.length);
            if (!r) throw Error("Unable to allocate new int vector on heap.");
            for (let e of t)this.i._addIntVectorEntry(r, e);
            this.i._addIntVectorToInputSidePacket(r, e);
        });
    }
    addUintVectorToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var r = this.i._allocateUintVector(t.length);
            if (!r) throw Error("Unable to allocate new unsigned int vector on heap.");
            for (let e of t)this.i._addUintVectorEntry(r, e);
            this.i._addUintVectorToInputSidePacket(r, e);
        });
    }
    addStringVectorToInputSidePacket(t, e) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var r = this.i._allocateStringVector(t.length);
            if (!r) throw Error("Unable to allocate new string vector on heap.");
            for (let e of t)$a2acea4f3420f1d8$var$Bh(this, e, (t)=>{
                this.i._addStringVectorEntry(r, t);
            });
            this.i._addStringVectorToInputSidePacket(r, e);
        });
    }
    attachBoolListener(t, e) {
        $a2acea4f3420f1d8$var$Vh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachBoolListener(t);
        });
    }
    attachBoolVectorListener(t, e) {
        $a2acea4f3420f1d8$var$Hh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachBoolVectorListener(t);
        });
    }
    attachIntListener(t, e) {
        $a2acea4f3420f1d8$var$Vh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachIntListener(t);
        });
    }
    attachIntVectorListener(t, e) {
        $a2acea4f3420f1d8$var$Hh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachIntVectorListener(t);
        });
    }
    attachUintListener(t, e) {
        $a2acea4f3420f1d8$var$Vh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachUintListener(t);
        });
    }
    attachUintVectorListener(t, e) {
        $a2acea4f3420f1d8$var$Hh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachUintVectorListener(t);
        });
    }
    attachDoubleListener(t, e) {
        $a2acea4f3420f1d8$var$Vh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachDoubleListener(t);
        });
    }
    attachDoubleVectorListener(t, e) {
        $a2acea4f3420f1d8$var$Hh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachDoubleVectorListener(t);
        });
    }
    attachFloatListener(t, e) {
        $a2acea4f3420f1d8$var$Vh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachFloatListener(t);
        });
    }
    attachFloatVectorListener(t, e) {
        $a2acea4f3420f1d8$var$Hh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachFloatVectorListener(t);
        });
    }
    attachStringListener(t, e) {
        $a2acea4f3420f1d8$var$Vh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachStringListener(t);
        });
    }
    attachStringVectorListener(t, e) {
        $a2acea4f3420f1d8$var$Hh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachStringVectorListener(t);
        });
    }
    attachProtoListener(t, e, r) {
        $a2acea4f3420f1d8$var$Vh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachProtoListener(t, r || !1);
        });
    }
    attachProtoVectorListener(t, e, r) {
        $a2acea4f3420f1d8$var$Hh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachProtoVectorListener(t, r || !1);
        });
    }
    attachAudioListener(t, e, r) {
        this.i._attachAudioListener || console.warn('Attempting to use attachAudioListener without support for output audio. Is build dep ":gl_graph_runner_audio_out" missing?'), $a2acea4f3420f1d8$var$Vh(this, t, (t, r)=>{
            t = new Float32Array(t.buffer, t.byteOffset, t.length / 4), e(t, r);
        }), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.i._attachAudioListener(t, r || !1);
        });
    }
    finishProcessing() {
        this.i._waitUntilIdle();
    }
    closeGraph() {
        this.i._closeGraph(), this.i.simpleListeners = void 0, this.i.emptyPacketListeners = void 0;
    }
};
function $a2acea4f3420f1d8$var$Xh(t) {
    return class extends t {
        get pa() {
            return this.i;
        }
        Sa() {
            if ("function" == typeof this.pa._mediapipeLoggerGetEncodedApiKey) {
                let t = this.pa._mediapipeLoggerGetEncodedApiKey();
                return this.pa._decodeBase64(t);
            }
        }
    };
}
function $a2acea4f3420f1d8$var$Wh(t) {
    return class extends t {
        Za() {
            this.i._registerModelResourcesGraphService();
        }
    };
}
var $a2acea4f3420f1d8$var$zh = $a2acea4f3420f1d8$var$Xh($a2acea4f3420f1d8$var$Wh($a2acea4f3420f1d8$var$Kh)), $a2acea4f3420f1d8$var$Yh = class extends $a2acea4f3420f1d8$var$zh {
};
async function $a2acea4f3420f1d8$var$qh(t, e, r, n) {
    return t = await (async (t, e, r, n, i)=>{
        if (e && await $a2acea4f3420f1d8$var$$h(e), !self.ModuleFactory) throw Error("ModuleFactory not set.");
        if (r && (await $a2acea4f3420f1d8$var$$h(r), !self.ModuleFactory)) throw Error("ModuleFactory not set.");
        return self.Module && i && ((e = self.Module).locateFile = i.locateFile, i.mainScriptUrlOrBlob && (e.mainScriptUrlOrBlob = i.mainScriptUrlOrBlob)), i = await self.ModuleFactory(self.Module || i), self.ModuleFactory = self.Module = void 0, new t(i, n);
    })(t, r.wasmLoaderPath, r.assetLoaderPath, e, {
        locateFile: (t)=>t.endsWith(".wasm") ? r.wasmBinaryPath.toString() : r.assetBinaryPath && t.endsWith(".data") ? r.assetBinaryPath.toString() : t
    }), function(t, e) {
        e = e.runningMode ?? "";
        var r = t.g.Sa();
        t.m = new $a2acea4f3420f1d8$var$Dh(t.C(), e, r);
    }(t, n), await t.v(n), t;
}
async function $a2acea4f3420f1d8$var$Jh(t, e, r, n) {
    return $a2acea4f3420f1d8$var$qh(t, e, r, n);
}
function $a2acea4f3420f1d8$var$Zh(t, e) {
    var r = $a2acea4f3420f1d8$var$Sr(t.baseOptions, $a2acea4f3420f1d8$var$Wo, 1) || new $a2acea4f3420f1d8$var$Wo;
    "string" == typeof e ? ($a2acea4f3420f1d8$var$ar(r, 2, $a2acea4f3420f1d8$var$ve(e)), $a2acea4f3420f1d8$var$ar(r, 1)) : e instanceof Uint8Array && ($a2acea4f3420f1d8$var$ar(r, 1, $a2acea4f3420f1d8$var$ct(e, !1)), $a2acea4f3420f1d8$var$ar(r, 2)), $a2acea4f3420f1d8$var$Ir(t.baseOptions, 0, 1, r);
}
function $a2acea4f3420f1d8$var$Qh(t) {
    try {
        let e = t.K.length;
        if (1 === e) throw Error(t.K[0].message);
        if (e > 1) throw Error("Encountered multiple errors: " + t.K.map((t)=>t.message).join(", "));
    } finally{
        t.K = [];
    }
}
function $a2acea4f3420f1d8$var$tu(t, e) {
    t.I = Math.max(t.I, e);
}
function $a2acea4f3420f1d8$var$eu(t, e) {
    t.D = new $a2acea4f3420f1d8$var$ho, $a2acea4f3420f1d8$var$Hr(t.D, 2, "PassThroughCalculator"), $a2acea4f3420f1d8$var$oo(t.D, "free_memory"), $a2acea4f3420f1d8$var$ao(t.D, "free_memory_unused_out"), $a2acea4f3420f1d8$var$po(e, "free_memory"), $a2acea4f3420f1d8$var$fo(e, t.D);
}
function $a2acea4f3420f1d8$var$ru(t, e) {
    $a2acea4f3420f1d8$var$oo(t.D, e), $a2acea4f3420f1d8$var$ao(t.D, e + "_unused_out");
}
function $a2acea4f3420f1d8$var$nu(t) {
    t.g.addBoolToStream(!0, "free_memory", t.I);
}
var $a2acea4f3420f1d8$export$61e9fc2d6edc635c = class {
    constructor(t){
        this.g = t, this.K = [], this.I = 0, this.g.setAutoRenderToScreen(!1);
    }
    j(t, e = !0) {
        if (e) {
            let e = t.baseOptions || {};
            if (t.baseOptions?.modelAssetBuffer && t.baseOptions?.modelAssetPath) throw Error("Cannot set both baseOptions.modelAssetPath and baseOptions.modelAssetBuffer");
            if (!($a2acea4f3420f1d8$var$Sr(this.baseOptions, $a2acea4f3420f1d8$var$Wo, 1)?.g() || $a2acea4f3420f1d8$var$Sr(this.baseOptions, $a2acea4f3420f1d8$var$Wo, 1)?.j() || t.baseOptions?.modelAssetBuffer || t.baseOptions?.modelAssetPath)) throw Error("Either baseOptions.modelAssetPath or baseOptions.modelAssetBuffer must be set");
            if (function(t, e) {
                var r = $a2acea4f3420f1d8$var$Sr(t.baseOptions, $a2acea4f3420f1d8$var$Ko, 3);
                if (!r) {
                    var n = r = new $a2acea4f3420f1d8$var$Ko, i = new $a2acea4f3420f1d8$var$Qs;
                    $a2acea4f3420f1d8$var$Fr(n, 4, $a2acea4f3420f1d8$var$Xo, i);
                }
                "delegate" in e && ("GPU" === e.delegate ? (e = r, n = new $a2acea4f3420f1d8$var$Ys, $a2acea4f3420f1d8$var$Fr(e, 2, $a2acea4f3420f1d8$var$Xo, n)) : (e = r, n = new $a2acea4f3420f1d8$var$Qs, $a2acea4f3420f1d8$var$Fr(e, 4, $a2acea4f3420f1d8$var$Xo, n))), $a2acea4f3420f1d8$var$Ir(t.baseOptions, 0, 3, r);
            }(this, e), e.modelAssetPath) return fetch(e.modelAssetPath.toString()).then((t)=>{
                if (t.ok) return t.arrayBuffer();
                throw Error(`Failed to fetch model: ${e.modelAssetPath} (${t.status})`);
            }).then((t)=>{
                try {
                    this.g.i.FS_unlink("/model.dat");
                } catch  {}
                this.g.i.FS_createDataFile("/", "model.dat", new Uint8Array(t), !0, !1, !1), $a2acea4f3420f1d8$var$Zh(this, "/model.dat"), this.o(), this.L();
            });
            if (e.modelAssetBuffer instanceof Uint8Array) $a2acea4f3420f1d8$var$Zh(this, e.modelAssetBuffer);
            else if (e.modelAssetBuffer) return (async function(t) {
                for(var e = [], r = 0;;){
                    let { done: n, value: i } = await t.read();
                    if (n) break;
                    e.push(i), r += i.length;
                }
                if (0 === e.length) return new Uint8Array(0);
                if (1 === e.length) return e[0];
                t = new Uint8Array(r), r = 0;
                for (let n of e)t.set(n, r), r += n.length;
                return t;
            })(e.modelAssetBuffer).then((t)=>{
                $a2acea4f3420f1d8$var$Zh(this, t), this.o(), this.L();
            });
        }
        return this.o(), this.L(), Promise.resolve();
    }
    L() {}
    ja() {
        var t;
        if (this.g.ja((e)=>{
            t = $a2acea4f3420f1d8$var$_o(e);
        }), !t) throw Error("Failed to retrieve CalculatorGraphConfig");
        return t;
    }
    setGraph(t, e) {
        this.g.attachErrorListener((t, e)=>{
            this.K.push(Error(e));
        }), this.g.Za(), this.g.setGraph(t, e), this.m?.ya(), this.D = void 0, $a2acea4f3420f1d8$var$Qh(this);
    }
    finishProcessing(t) {
        this.g.finishProcessing(), $a2acea4f3420f1d8$var$Qh(this), this.m && void 0 !== t && this.m.za(t);
    }
    close() {
        this.D = void 0, this.m?.xa(), this.m?.close(), this.g.closeGraph();
    }
};
function $a2acea4f3420f1d8$var$su(t, e) {
    if (!t) throw Error(`Unable to obtain required WebGL resource: ${e}`);
    return t;
}
$a2acea4f3420f1d8$export$61e9fc2d6edc635c.prototype.close = $a2acea4f3420f1d8$export$61e9fc2d6edc635c.prototype.close;
class $a2acea4f3420f1d8$var$ou {
    constructor(t, e, r, n){
        this.g = t, this.h = e, this.m = r, this.j = n;
    }
    bind() {
        this.g.bindVertexArray(this.h);
    }
    close() {
        this.g.deleteVertexArray(this.h), this.g.deleteBuffer(this.m), this.g.deleteBuffer(this.j);
    }
}
function $a2acea4f3420f1d8$var$au(t, e, r) {
    var n = t.g;
    if (r = $a2acea4f3420f1d8$var$su(n.createShader(r), "Failed to create WebGL shader"), n.shaderSource(r, e), n.compileShader(r), !n.getShaderParameter(r, n.COMPILE_STATUS)) throw Error(`Could not compile WebGL shader: ${n.getShaderInfoLog(r)}`);
    return n.attachShader(t.h, r), r;
}
function $a2acea4f3420f1d8$var$hu(t, e) {
    var r = t.g, n = $a2acea4f3420f1d8$var$su(r.createVertexArray(), "Failed to create vertex array");
    r.bindVertexArray(n);
    var i = $a2acea4f3420f1d8$var$su(r.createBuffer(), "Failed to create buffer");
    r.bindBuffer(r.ARRAY_BUFFER, i), r.enableVertexAttribArray(t.F), r.vertexAttribPointer(t.F, 2, r.FLOAT, !1, 0, 0), r.bufferData(r.ARRAY_BUFFER, new Float32Array([
        -1,
        -1,
        -1,
        1,
        1,
        1,
        1,
        -1
    ]), r.STATIC_DRAW);
    var s = $a2acea4f3420f1d8$var$su(r.createBuffer(), "Failed to create buffer");
    return r.bindBuffer(r.ARRAY_BUFFER, s), r.enableVertexAttribArray(t.K), r.vertexAttribPointer(t.K, 2, r.FLOAT, !1, 0, 0), r.bufferData(r.ARRAY_BUFFER, new Float32Array(e ? [
        0,
        1,
        0,
        0,
        1,
        0,
        1,
        1
    ] : [
        0,
        0,
        0,
        1,
        1,
        1,
        1,
        0
    ]), r.STATIC_DRAW), r.bindBuffer(r.ARRAY_BUFFER, null), r.bindVertexArray(null), new $a2acea4f3420f1d8$var$ou(r, n, i, s);
}
function $a2acea4f3420f1d8$var$uu(t, e) {
    if (t.g) {
        if (e !== t.g) throw Error("Cannot change GL context once initialized");
    } else t.g = e;
}
function $a2acea4f3420f1d8$var$cu(t, e, r, n) {
    return $a2acea4f3420f1d8$var$uu(t, e), t.h || (t.m(), t.I()), r ? (t.l || (t.l = $a2acea4f3420f1d8$var$hu(t, !0)), r = t.l) : (t.D || (t.D = $a2acea4f3420f1d8$var$hu(t, !1)), r = t.D), e.useProgram(t.h), r.bind(), t.j(), t = n(), r.g.bindVertexArray(null), t;
}
function $a2acea4f3420f1d8$var$lu(t, e, r) {
    return $a2acea4f3420f1d8$var$uu(t, e), t = $a2acea4f3420f1d8$var$su(e.createTexture(), "Failed to create texture"), e.bindTexture(e.TEXTURE_2D, t), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_S, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_WRAP_T, e.CLAMP_TO_EDGE), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MIN_FILTER, r ?? e.LINEAR), e.texParameteri(e.TEXTURE_2D, e.TEXTURE_MAG_FILTER, r ?? e.LINEAR), e.bindTexture(e.TEXTURE_2D, null), t;
}
function $a2acea4f3420f1d8$var$du(t, e, r) {
    $a2acea4f3420f1d8$var$uu(t, e), t.C || (t.C = $a2acea4f3420f1d8$var$su(e.createFramebuffer(), "Failed to create framebuffe.")), e.bindFramebuffer(e.FRAMEBUFFER, t.C), e.framebufferTexture2D(e.FRAMEBUFFER, e.COLOR_ATTACHMENT0, e.TEXTURE_2D, r, 0);
}
function $a2acea4f3420f1d8$var$fu(t) {
    t.g?.bindFramebuffer(t.g.FRAMEBUFFER, null);
}
var $a2acea4f3420f1d8$var$pu = class {
    B() {
        return "\n  precision mediump float;\n  varying vec2 vTex;\n  uniform sampler2D inputTexture;\n  void main() {\n    gl_FragColor = texture2D(inputTexture, vTex);\n  }\n ";
    }
    m() {
        var t = this.g;
        if (this.h = $a2acea4f3420f1d8$var$su(t.createProgram(), "Failed to create WebGL program"), this.da = $a2acea4f3420f1d8$var$au(this, "\n  attribute vec2 aVertex;\n  attribute vec2 aTex;\n  varying vec2 vTex;\n  void main(void) {\n    gl_Position = vec4(aVertex, 0.0, 1.0);\n    vTex = aTex;\n  }", t.VERTEX_SHADER), this.Z = $a2acea4f3420f1d8$var$au(this, this.B(), t.FRAGMENT_SHADER), t.linkProgram(this.h), !t.getProgramParameter(this.h, t.LINK_STATUS)) throw Error(`Error during program linking: ${t.getProgramInfoLog(this.h)}`);
        this.F = t.getAttribLocation(this.h, "aVertex"), this.K = t.getAttribLocation(this.h, "aTex");
    }
    I() {}
    j() {}
    close() {
        if (this.h) {
            let t = this.g;
            t.deleteProgram(this.h), t.deleteShader(this.da), t.deleteShader(this.Z);
        }
        this.C && this.g.deleteFramebuffer(this.C), this.D && this.D.close(), this.l && this.l.close();
    }
};
var $a2acea4f3420f1d8$var$gu = class extends $a2acea4f3420f1d8$var$pu {
    B() {
        return "\n  precision mediump float;\n  uniform sampler2D backgroundTexture;\n  uniform sampler2D maskTexture;\n  uniform sampler2D colorMappingTexture;\n  varying vec2 vTex;\n  void main() {\n    vec4 backgroundColor = texture2D(backgroundTexture, vTex);\n    float category = texture2D(maskTexture, vTex).r;\n    vec4 categoryColor = texture2D(colorMappingTexture, vec2(category, 0.0));\n    gl_FragColor = mix(backgroundColor, categoryColor, categoryColor.a);\n  }\n ";
    }
    I() {
        var t = this.g;
        t.activeTexture(t.TEXTURE1), this.u = $a2acea4f3420f1d8$var$lu(this, t, t.LINEAR), t.activeTexture(t.TEXTURE2), this.o = $a2acea4f3420f1d8$var$lu(this, t, t.NEAREST);
    }
    m() {
        super.m();
        var t = this.g;
        this.O = $a2acea4f3420f1d8$var$su(t.getUniformLocation(this.h, "backgroundTexture"), "Uniform location"), this.Y = $a2acea4f3420f1d8$var$su(t.getUniformLocation(this.h, "colorMappingTexture"), "Uniform location"), this.L = $a2acea4f3420f1d8$var$su(t.getUniformLocation(this.h, "maskTexture"), "Uniform location");
    }
    j() {
        super.j();
        var t = this.g;
        t.uniform1i(this.L, 0), t.uniform1i(this.O, 1), t.uniform1i(this.Y, 2);
    }
    close() {
        this.u && this.g.deleteTexture(this.u), this.o && this.g.deleteTexture(this.o), super.close();
    }
}, $a2acea4f3420f1d8$var$mu = class extends $a2acea4f3420f1d8$var$pu {
    B() {
        return "\n  precision mediump float;\n  uniform sampler2D maskTexture;\n  uniform sampler2D defaultTexture;\n  uniform sampler2D overlayTexture;\n  varying vec2 vTex;\n  void main() {\n    float confidence = texture2D(maskTexture, vTex).r;\n    vec4 defaultColor = texture2D(defaultTexture, vTex);\n    vec4 overlayColor = texture2D(overlayTexture, vTex);\n    // Apply the alpha from the overlay and merge in the default color\n    overlayColor = mix(defaultColor, overlayColor, overlayColor.a);\n    gl_FragColor = mix(defaultColor, overlayColor, confidence);\n  }\n ";
    }
    I() {
        var t = this.g;
        t.activeTexture(t.TEXTURE1), this.o = $a2acea4f3420f1d8$var$lu(this, t), t.activeTexture(t.TEXTURE2), this.u = $a2acea4f3420f1d8$var$lu(this, t);
    }
    m() {
        super.m();
        var t = this.g;
        this.L = $a2acea4f3420f1d8$var$su(t.getUniformLocation(this.h, "defaultTexture"), "Uniform location"), this.O = $a2acea4f3420f1d8$var$su(t.getUniformLocation(this.h, "overlayTexture"), "Uniform location"), this.J = $a2acea4f3420f1d8$var$su(t.getUniformLocation(this.h, "maskTexture"), "Uniform location");
    }
    j() {
        super.j();
        var t = this.g;
        t.uniform1i(this.J, 0), t.uniform1i(this.L, 1), t.uniform1i(this.O, 2);
    }
    close() {
        this.o && this.g.deleteTexture(this.o), this.u && this.g.deleteTexture(this.u), super.close();
    }
};
function $a2acea4f3420f1d8$var$vu(t, e) {
    switch(e){
        case 0:
            return t.g.find((t)=>t instanceof Uint8Array);
        case 1:
            return t.g.find((t)=>t instanceof Float32Array);
        case 2:
            return t.g.find((t)=>"undefined" != typeof WebGLTexture && t instanceof WebGLTexture);
        default:
            throw Error(`Type is not supported: ${e}`);
    }
}
function $a2acea4f3420f1d8$var$_u(t) {
    var e = $a2acea4f3420f1d8$var$vu(t, 1);
    if (!e) {
        if (e = $a2acea4f3420f1d8$var$vu(t, 0)) e = new Float32Array(e).map((t)=>t / 255);
        else {
            e = new Float32Array(t.width * t.height);
            let n = $a2acea4f3420f1d8$var$Eu(t);
            var r = $a2acea4f3420f1d8$var$wu(t);
            if ($a2acea4f3420f1d8$var$du(r, n, $a2acea4f3420f1d8$var$yu(t)), "iPad Simulator;iPhone Simulator;iPod Simulator;iPad;iPhone;iPod".split(";").includes(navigator.platform) || navigator.userAgent.includes("Mac") && "document" in self && "ontouchend" in self.document) {
                r = new Float32Array(t.width * t.height * 4), n.readPixels(0, 0, t.width, t.height, n.RGBA, n.FLOAT, r);
                for(let t = 0, n = 0; t < e.length; ++t, n += 4)e[t] = r[n];
            } else n.readPixels(0, 0, t.width, t.height, n.RED, n.FLOAT, e);
        }
        t.g.push(e);
    }
    return e;
}
function $a2acea4f3420f1d8$var$yu(t) {
    var e = $a2acea4f3420f1d8$var$vu(t, 2);
    if (!e) {
        let r = $a2acea4f3420f1d8$var$Eu(t);
        e = $a2acea4f3420f1d8$var$bu(t);
        let n = $a2acea4f3420f1d8$var$_u(t), i = $a2acea4f3420f1d8$var$Au(t);
        r.texImage2D(r.TEXTURE_2D, 0, i, t.width, t.height, 0, r.RED, r.FLOAT, n), $a2acea4f3420f1d8$var$Tu(t);
    }
    return e;
}
function $a2acea4f3420f1d8$var$Eu(t) {
    if (!t.canvas) throw Error("Conversion to different image formats require that a canvas is passed when initializing the image.");
    return t.h || (t.h = $a2acea4f3420f1d8$var$su(t.canvas.getContext("webgl2"), "You cannot use a canvas that is already bound to a different type of rendering context.")), t.h;
}
function $a2acea4f3420f1d8$var$Au(t) {
    if (t = $a2acea4f3420f1d8$var$Eu(t), !$a2acea4f3420f1d8$var$ku) {
        if (t.getExtension("EXT_color_buffer_float") && t.getExtension("OES_texture_float_linear") && t.getExtension("EXT_float_blend")) $a2acea4f3420f1d8$var$ku = t.R32F;
        else {
            if (!t.getExtension("EXT_color_buffer_half_float")) throw Error("GPU does not fully support 4-channel float32 or float16 formats");
            $a2acea4f3420f1d8$var$ku = t.R16F;
        }
    }
    return $a2acea4f3420f1d8$var$ku;
}
function $a2acea4f3420f1d8$var$wu(t) {
    return t.j || (t.j = new $a2acea4f3420f1d8$var$pu), t.j;
}
function $a2acea4f3420f1d8$var$bu(t) {
    var e = $a2acea4f3420f1d8$var$Eu(t);
    e.viewport(0, 0, t.width, t.height), e.activeTexture(e.TEXTURE0);
    var r = $a2acea4f3420f1d8$var$vu(t, 2);
    return r || (r = $a2acea4f3420f1d8$var$lu($a2acea4f3420f1d8$var$wu(t), e, t.m ? e.LINEAR : e.NEAREST), t.g.push(r), t.o = !0), e.bindTexture(e.TEXTURE_2D, r), r;
}
function $a2acea4f3420f1d8$var$Tu(t) {
    t.h.bindTexture(t.h.TEXTURE_2D, null);
}
var $a2acea4f3420f1d8$var$ku, $a2acea4f3420f1d8$export$e68fd2753c6d17ef = class {
    constructor(t, e, r, n, i, s, o){
        this.g = t, this.m = e, this.o = r, this.canvas = n, this.j = i, this.width = s, this.height = o, this.o && 0 === --$a2acea4f3420f1d8$var$Lu && console.error("You seem to be creating MPMask instances without invoking .close(). This leaks resources.");
    }
    Ua() {
        return !!$a2acea4f3420f1d8$var$vu(this, 0);
    }
    ua() {
        return !!$a2acea4f3420f1d8$var$vu(this, 1);
    }
    W() {
        return !!$a2acea4f3420f1d8$var$vu(this, 2);
    }
    ta() {
        var t, e;
        return (e = $a2acea4f3420f1d8$var$vu(t = this, 0)) || (e = $a2acea4f3420f1d8$var$_u(t), e = new Uint8Array(e.map((t)=>Math.round(255 * t))), t.g.push(e)), e;
    }
    sa() {
        return $a2acea4f3420f1d8$var$_u(this);
    }
    S() {
        return $a2acea4f3420f1d8$var$yu(this);
    }
    clone() {
        var t = [];
        for (let e of this.g){
            let r;
            if (e instanceof Uint8Array) r = new Uint8Array(e);
            else if (e instanceof Float32Array) r = new Float32Array(e);
            else {
                if (!(e instanceof WebGLTexture)) throw Error(`Type is not supported: ${e}`);
                {
                    let t = $a2acea4f3420f1d8$var$Eu(this), e = $a2acea4f3420f1d8$var$wu(this);
                    t.activeTexture(t.TEXTURE1), r = $a2acea4f3420f1d8$var$lu(e, t, this.m ? t.LINEAR : t.NEAREST), t.bindTexture(t.TEXTURE_2D, r);
                    let n = $a2acea4f3420f1d8$var$Au(this);
                    t.texImage2D(t.TEXTURE_2D, 0, n, this.width, this.height, 0, t.RED, t.FLOAT, null), t.bindTexture(t.TEXTURE_2D, null), $a2acea4f3420f1d8$var$du(e, t, r), $a2acea4f3420f1d8$var$cu(e, t, !1, ()=>{
                        $a2acea4f3420f1d8$var$bu(this), t.clearColor(0, 0, 0, 0), t.clear(t.COLOR_BUFFER_BIT), t.drawArrays(t.TRIANGLE_FAN, 0, 4), $a2acea4f3420f1d8$var$Tu(this);
                    }), $a2acea4f3420f1d8$var$fu(e), $a2acea4f3420f1d8$var$Tu(this);
                }
            }
            t.push(r);
        }
        return new $a2acea4f3420f1d8$export$e68fd2753c6d17ef(t, this.m, this.W(), this.canvas, this.j, this.width, this.height);
    }
    close() {
        this.o && $a2acea4f3420f1d8$var$Eu(this).deleteTexture($a2acea4f3420f1d8$var$vu(this, 2)), $a2acea4f3420f1d8$var$Lu = -1;
    }
};
$a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.close = $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.close, $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.clone = $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.clone, $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.getAsWebGLTexture = $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.S, $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.getAsFloat32Array = $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.sa, $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.getAsUint8Array = $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.ta, $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.hasWebGLTexture = $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.W, $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.hasFloat32Array = $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.ua, $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.hasUint8Array = $a2acea4f3420f1d8$export$e68fd2753c6d17ef.prototype.Ua;
var $a2acea4f3420f1d8$var$Lu = 250, $a2acea4f3420f1d8$var$xu = {
    color: "white",
    lineWidth: 4,
    radius: 6
};
function $a2acea4f3420f1d8$var$Ru(t) {
    return {
        ...$a2acea4f3420f1d8$var$xu,
        fillColor: (t = t || {}).color,
        ...t
    };
}
function $a2acea4f3420f1d8$var$Iu(t, e) {
    return t instanceof Function ? t(e) : t;
}
function $a2acea4f3420f1d8$var$Fu(t, e, r) {
    return Math.max(Math.min(e, r), Math.min(Math.max(e, r), t));
}
function $a2acea4f3420f1d8$var$Cu(t) {
    if (!t.j) throw Error("CPU rendering requested but CanvasRenderingContext2D not provided.");
    return t.j;
}
function $a2acea4f3420f1d8$var$Nu(t) {
    if (!t.o) throw Error("GPU rendering requested but WebGL2RenderingContext not provided.");
    return t.o;
}
function $a2acea4f3420f1d8$var$Mu(t, e, r) {
    if (e.W()) r(e.S());
    else {
        let n = e.ua() ? e.sa() : e.ta();
        t.m = t.m ?? new $a2acea4f3420f1d8$var$pu;
        let i = $a2acea4f3420f1d8$var$Nu(t);
        r((t = new $a2acea4f3420f1d8$export$e68fd2753c6d17ef([
            n
        ], e.m, !1, i.canvas, t.m, e.width, e.height)).S()), t.close();
    }
}
function $a2acea4f3420f1d8$var$Ou(t, e, r, n) {
    var i = function(t) {
        return t.g || (t.g = new $a2acea4f3420f1d8$var$gu), t.g;
    }(t), s = $a2acea4f3420f1d8$var$Nu(t), o = Array.isArray(r) ? new ImageData(new Uint8ClampedArray(r), 1, 1) : r;
    $a2acea4f3420f1d8$var$cu(i, s, !0, ()=>{
        !function(t, e, r, n) {
            var i = t.g;
            if (i.activeTexture(i.TEXTURE0), i.bindTexture(i.TEXTURE_2D, e), i.activeTexture(i.TEXTURE1), i.bindTexture(i.TEXTURE_2D, t.u), i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, i.RGBA, i.UNSIGNED_BYTE, r), t.J && function(t, e) {
                if (t !== e) return !1;
                t = t.entries(), e = e.entries();
                for (let [r, n] of t){
                    t = r;
                    let i = n, s = e.next();
                    if (s.done) return !1;
                    let [o, a] = s.value;
                    if (t !== o || i[0] !== a[0] || i[1] !== a[1] || i[2] !== a[2] || i[3] !== a[3]) return !1;
                }
                return !!e.next().done;
            }(t.J, n)) i.activeTexture(i.TEXTURE2), i.bindTexture(i.TEXTURE_2D, t.o);
            else {
                t.J = n;
                let e = Array(1024).fill(0);
                n.forEach((t, r)=>{
                    if (4 !== t.length) throw Error(`Color at index ${r} is not a four-channel value.`);
                    e[4 * r] = t[0], e[4 * r + 1] = t[1], e[4 * r + 2] = t[2], e[4 * r + 3] = t[3];
                }), i.activeTexture(i.TEXTURE2), i.bindTexture(i.TEXTURE_2D, t.o), i.texImage2D(i.TEXTURE_2D, 0, i.RGBA, 256, 1, 0, i.RGBA, i.UNSIGNED_BYTE, new Uint8Array(e));
            }
        }(i, e, o, n), s.clearColor(0, 0, 0, 0), s.clear(s.COLOR_BUFFER_BIT), s.drawArrays(s.TRIANGLE_FAN, 0, 4);
        var t = i.g;
        t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, null), t.activeTexture(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, null), t.activeTexture(t.TEXTURE2), t.bindTexture(t.TEXTURE_2D, null);
    });
}
function $a2acea4f3420f1d8$var$Du(t, e, r, n) {
    var i = $a2acea4f3420f1d8$var$Nu(t), s = function(t) {
        return t.h || (t.h = new $a2acea4f3420f1d8$var$mu), t.h;
    }(t), o = Array.isArray(r) ? new ImageData(new Uint8ClampedArray(r), 1, 1) : r, a = Array.isArray(n) ? new ImageData(new Uint8ClampedArray(n), 1, 1) : n;
    $a2acea4f3420f1d8$var$cu(s, i, !0, ()=>{
        var t = s.g;
        t.activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, e), t.activeTexture(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, s.o), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, o), t.activeTexture(t.TEXTURE2), t.bindTexture(t.TEXTURE_2D, s.u), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, t.RGBA, t.UNSIGNED_BYTE, a), i.clearColor(0, 0, 0, 0), i.clear(i.COLOR_BUFFER_BIT), i.drawArrays(i.TRIANGLE_FAN, 0, 4), i.bindTexture(i.TEXTURE_2D, null), (t = s.g).activeTexture(t.TEXTURE0), t.bindTexture(t.TEXTURE_2D, null), t.activeTexture(t.TEXTURE1), t.bindTexture(t.TEXTURE_2D, null), t.activeTexture(t.TEXTURE2), t.bindTexture(t.TEXTURE_2D, null);
    });
}
var $a2acea4f3420f1d8$export$94ffe84d90dbe8de = class {
    constructor(t, e){
        "undefined" != typeof CanvasRenderingContext2D && t instanceof CanvasRenderingContext2D || t instanceof OffscreenCanvasRenderingContext2D ? (this.j = t, this.o = e) : this.o = t;
    }
    Ma(t, e) {
        if (t) {
            var r = $a2acea4f3420f1d8$var$Cu(this);
            e = $a2acea4f3420f1d8$var$Ru(e), r.save();
            var n = r.canvas, i = 0;
            for (let s of t)r.fillStyle = $a2acea4f3420f1d8$var$Iu(e.fillColor, {
                index: i,
                from: s
            }), r.strokeStyle = $a2acea4f3420f1d8$var$Iu(e.color, {
                index: i,
                from: s
            }), r.lineWidth = $a2acea4f3420f1d8$var$Iu(e.lineWidth, {
                index: i,
                from: s
            }), (t = new Path2D).arc(s.x * n.width, s.y * n.height, $a2acea4f3420f1d8$var$Iu(e.radius, {
                index: i,
                from: s
            }), 0, 2 * Math.PI), r.fill(t), r.stroke(t), ++i;
            r.restore();
        }
    }
    La(t, e, r) {
        if (t && e) {
            var n = $a2acea4f3420f1d8$var$Cu(this);
            r = $a2acea4f3420f1d8$var$Ru(r), n.save();
            var i = n.canvas, s = 0;
            for (let o of e){
                n.beginPath(), e = t[o.start];
                let a = t[o.end];
                e && a && (n.strokeStyle = $a2acea4f3420f1d8$var$Iu(r.color, {
                    index: s,
                    from: e,
                    to: a
                }), n.lineWidth = $a2acea4f3420f1d8$var$Iu(r.lineWidth, {
                    index: s,
                    from: e,
                    to: a
                }), n.moveTo(e.x * i.width, e.y * i.height), n.lineTo(a.x * i.width, a.y * i.height)), ++s, n.stroke();
            }
            n.restore();
        }
    }
    Ia(t, e) {
        var r = $a2acea4f3420f1d8$var$Cu(this);
        e = $a2acea4f3420f1d8$var$Ru(e), r.save(), r.beginPath(), r.lineWidth = $a2acea4f3420f1d8$var$Iu(e.lineWidth, {}), r.strokeStyle = $a2acea4f3420f1d8$var$Iu(e.color, {}), r.fillStyle = $a2acea4f3420f1d8$var$Iu(e.fillColor, {}), r.moveTo(t.originX, t.originY), r.lineTo(t.originX + t.width, t.originY), r.lineTo(t.originX + t.width, t.originY + t.height), r.lineTo(t.originX, t.originY + t.height), r.lineTo(t.originX, t.originY), r.stroke(), r.fill(), r.restore();
    }
    Ja(t, e, r = [
        0,
        0,
        0,
        255
    ]) {
        this.j ? function(t, e, r, n) {
            var i = $a2acea4f3420f1d8$var$Nu(t);
            $a2acea4f3420f1d8$var$Mu(t, e, (e)=>{
                $a2acea4f3420f1d8$var$Ou(t, e, r, n), (e = $a2acea4f3420f1d8$var$Cu(t)).drawImage(i.canvas, 0, 0, e.canvas.width, e.canvas.height);
            });
        }(this, t, r, e) : $a2acea4f3420f1d8$var$Ou(this, t.S(), r, e);
    }
    Ka(t, e, r) {
        this.j ? function(t, e, r, n) {
            var i = $a2acea4f3420f1d8$var$Nu(t);
            $a2acea4f3420f1d8$var$Mu(t, e, (e)=>{
                $a2acea4f3420f1d8$var$Du(t, e, r, n), (e = $a2acea4f3420f1d8$var$Cu(t)).drawImage(i.canvas, 0, 0, e.canvas.width, e.canvas.height);
            });
        }(this, t, e, r) : $a2acea4f3420f1d8$var$Du(this, t.S(), e, r);
    }
    close() {
        this.g?.close(), this.g = void 0, this.h?.close(), this.h = void 0, this.m?.close(), this.m = void 0;
    }
};
function $a2acea4f3420f1d8$var$$u(t, e) {
    switch(e){
        case 0:
            return t.g.find((t)=>t instanceof ImageData);
        case 1:
            return t.g.find((t)=>"undefined" != typeof ImageBitmap && t instanceof ImageBitmap);
        case 2:
            return t.g.find((t)=>"undefined" != typeof WebGLTexture && t instanceof WebGLTexture);
        default:
            throw Error(`Type is not supported: ${e}`);
    }
}
function $a2acea4f3420f1d8$var$Uu(t) {
    var e = $a2acea4f3420f1d8$var$$u(t, 0);
    if (!e) {
        e = $a2acea4f3420f1d8$var$Gu(t);
        let r = $a2acea4f3420f1d8$var$ju(t), n = new Uint8Array(t.width * t.height * 4);
        $a2acea4f3420f1d8$var$du(r, e, $a2acea4f3420f1d8$var$Bu(t)), e.readPixels(0, 0, t.width, t.height, e.RGBA, e.UNSIGNED_BYTE, n), $a2acea4f3420f1d8$var$fu(r), e = new ImageData(new Uint8ClampedArray(n.buffer), t.width, t.height), t.g.push(e);
    }
    return e;
}
function $a2acea4f3420f1d8$var$Bu(t) {
    var e = $a2acea4f3420f1d8$var$$u(t, 2);
    if (!e) {
        let r = $a2acea4f3420f1d8$var$Gu(t);
        e = $a2acea4f3420f1d8$var$Vu(t);
        let n = $a2acea4f3420f1d8$var$$u(t, 1) || $a2acea4f3420f1d8$var$Uu(t);
        r.texImage2D(r.TEXTURE_2D, 0, r.RGBA, r.RGBA, r.UNSIGNED_BYTE, n), $a2acea4f3420f1d8$var$Hu(t);
    }
    return e;
}
function $a2acea4f3420f1d8$var$Gu(t) {
    if (!t.canvas) throw Error("Conversion to different image formats require that a canvas is passed when initializing the image.");
    return t.h || (t.h = $a2acea4f3420f1d8$var$su(t.canvas.getContext("webgl2"), "You cannot use a canvas that is already bound to a different type of rendering context.")), t.h;
}
function $a2acea4f3420f1d8$var$ju(t) {
    return t.j || (t.j = new $a2acea4f3420f1d8$var$pu), t.j;
}
function $a2acea4f3420f1d8$var$Vu(t) {
    var e = $a2acea4f3420f1d8$var$Gu(t);
    e.viewport(0, 0, t.width, t.height), e.activeTexture(e.TEXTURE0);
    var r = $a2acea4f3420f1d8$var$$u(t, 2);
    return r || (r = $a2acea4f3420f1d8$var$lu($a2acea4f3420f1d8$var$ju(t), e), t.g.push(r), t.m = !0), e.bindTexture(e.TEXTURE_2D, r), r;
}
function $a2acea4f3420f1d8$var$Hu(t) {
    t.h.bindTexture(t.h.TEXTURE_2D, null);
}
function $a2acea4f3420f1d8$var$Ku(t) {
    var e = $a2acea4f3420f1d8$var$Gu(t);
    return $a2acea4f3420f1d8$var$cu($a2acea4f3420f1d8$var$ju(t), e, !0, ()=>(function(t, e) {
            var r = t.canvas;
            if (r.width === t.width && r.height === t.height) return e();
            var n = r.width, i = r.height;
            return r.width = t.width, r.height = t.height, t = e(), r.width = n, r.height = i, t;
        })(t, ()=>{
            if (e.bindFramebuffer(e.FRAMEBUFFER, null), e.clearColor(0, 0, 0, 0), e.clear(e.COLOR_BUFFER_BIT), e.drawArrays(e.TRIANGLE_FAN, 0, 4), !(t.canvas instanceof OffscreenCanvas)) throw Error("Conversion to ImageBitmap requires that the MediaPipe Tasks is initialized with an OffscreenCanvas");
            return t.canvas.transferToImageBitmap();
        }));
}
$a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.close = $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.close, $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.drawConfidenceMask = $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.Ka, $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.drawCategoryMask = $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.Ja, $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.drawBoundingBox = $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.Ia, $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.drawConnectors = $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.La, $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.drawLandmarks = $a2acea4f3420f1d8$export$94ffe84d90dbe8de.prototype.Ma, $a2acea4f3420f1d8$export$94ffe84d90dbe8de.lerp = function(t, e, r, n, i) {
    return $a2acea4f3420f1d8$var$Fu(n * (1 - (t - e) / (r - e)) + i * (1 - (r - t) / (r - e)), n, i);
}, $a2acea4f3420f1d8$export$94ffe84d90dbe8de.clamp = $a2acea4f3420f1d8$var$Fu;
var $a2acea4f3420f1d8$export$7c9479202f61c045 = class {
    constructor(t, e, r, n, i, s, o){
        this.g = t, this.o = e, this.m = r, this.canvas = n, this.j = i, this.width = s, this.height = o, (this.o || this.m) && 0 === --$a2acea4f3420f1d8$var$Wu && console.error("You seem to be creating MPImage instances without invoking .close(). This leaks resources.");
    }
    Ta() {
        return !!$a2acea4f3420f1d8$var$$u(this, 0);
    }
    va() {
        return !!$a2acea4f3420f1d8$var$$u(this, 1);
    }
    W() {
        return !!$a2acea4f3420f1d8$var$$u(this, 2);
    }
    Qa() {
        return $a2acea4f3420f1d8$var$Uu(this);
    }
    Pa() {
        var t = $a2acea4f3420f1d8$var$$u(this, 1);
        return t || ($a2acea4f3420f1d8$var$Bu(this), $a2acea4f3420f1d8$var$Vu(this), t = $a2acea4f3420f1d8$var$Ku(this), $a2acea4f3420f1d8$var$Hu(this), this.g.push(t), this.o = !0), t;
    }
    S() {
        return $a2acea4f3420f1d8$var$Bu(this);
    }
    clone() {
        var t = [];
        for (let e of this.g){
            let r;
            if (e instanceof ImageData) r = new ImageData(e.data, this.width, this.height);
            else if (e instanceof WebGLTexture) {
                let t = $a2acea4f3420f1d8$var$Gu(this), e = $a2acea4f3420f1d8$var$ju(this);
                t.activeTexture(t.TEXTURE1), r = $a2acea4f3420f1d8$var$lu(e, t), t.bindTexture(t.TEXTURE_2D, r), t.texImage2D(t.TEXTURE_2D, 0, t.RGBA, this.width, this.height, 0, t.RGBA, t.UNSIGNED_BYTE, null), t.bindTexture(t.TEXTURE_2D, null), $a2acea4f3420f1d8$var$du(e, t, r), $a2acea4f3420f1d8$var$cu(e, t, !1, ()=>{
                    $a2acea4f3420f1d8$var$Vu(this), t.clearColor(0, 0, 0, 0), t.clear(t.COLOR_BUFFER_BIT), t.drawArrays(t.TRIANGLE_FAN, 0, 4), $a2acea4f3420f1d8$var$Hu(this);
                }), $a2acea4f3420f1d8$var$fu(e), $a2acea4f3420f1d8$var$Hu(this);
            } else {
                if (!(e instanceof ImageBitmap)) throw Error(`Type is not supported: ${e}`);
                $a2acea4f3420f1d8$var$Bu(this), $a2acea4f3420f1d8$var$Vu(this), r = $a2acea4f3420f1d8$var$Ku(this), $a2acea4f3420f1d8$var$Hu(this);
            }
            t.push(r);
        }
        return new $a2acea4f3420f1d8$export$7c9479202f61c045(t, this.va(), this.W(), this.canvas, this.j, this.width, this.height);
    }
    close() {
        this.o && $a2acea4f3420f1d8$var$$u(this, 1).close(), this.m && $a2acea4f3420f1d8$var$Gu(this).deleteTexture($a2acea4f3420f1d8$var$$u(this, 2)), $a2acea4f3420f1d8$var$Wu = -1;
    }
};
$a2acea4f3420f1d8$export$7c9479202f61c045.prototype.close = $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.close, $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.clone = $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.clone, $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.getAsWebGLTexture = $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.S, $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.getAsImageBitmap = $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.Pa, $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.getAsImageData = $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.Qa, $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.hasWebGLTexture = $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.W, $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.hasImageBitmap = $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.va, $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.hasImageData = $a2acea4f3420f1d8$export$7c9479202f61c045.prototype.Ta;
var $a2acea4f3420f1d8$var$Wu = 250;
function $a2acea4f3420f1d8$var$zu(...t) {
    return t.map(([t, e])=>({
            start: t,
            end: e
        }));
}
var $a2acea4f3420f1d8$var$Yu, $a2acea4f3420f1d8$var$qu = $a2acea4f3420f1d8$var$Wh(($a2acea4f3420f1d8$var$Yu = $a2acea4f3420f1d8$var$Xh($a2acea4f3420f1d8$var$Kh), class extends $a2acea4f3420f1d8$var$Yu {
    get oa() {
        return this.i;
    }
    Da(t, e, r) {
        $a2acea4f3420f1d8$var$Bh(this, e, (e)=>{
            var [n, i] = $a2acea4f3420f1d8$var$Gh(this, t, e);
            this.oa._addBoundTextureAsImageToStream(e, n, i, r);
        });
    }
    ga(t, e) {
        $a2acea4f3420f1d8$var$Vh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.oa._attachImageListener(t);
        });
    }
    ha(t, e) {
        $a2acea4f3420f1d8$var$Hh(this, t, e), $a2acea4f3420f1d8$var$Bh(this, t, (t)=>{
            this.oa._attachImageVectorListener(t);
        });
    }
})), $a2acea4f3420f1d8$var$Ju = class extends $a2acea4f3420f1d8$var$qu {
};
async function $a2acea4f3420f1d8$var$Zu(t, e, r) {
    return $a2acea4f3420f1d8$var$Jh(t, r.canvas ?? ($a2acea4f3420f1d8$var$Ph() ? void 0 : document.createElement("canvas")), e, r);
}
function $a2acea4f3420f1d8$var$Qu(t, e, r, n) {
    if (t.m && void 0 !== n) {
        if ($a2acea4f3420f1d8$var$Sr(t.baseOptions, $a2acea4f3420f1d8$var$Ko, 3)?.g()) {
            var i = t.m;
            ++i.g.T, i.h.set(n, performance.now());
        } else ++(i = t.m).g.P, i.h.set(n, performance.now());
    }
    if (t.qa) {
        if (i = new $a2acea4f3420f1d8$var$No, r?.regionOfInterest) {
            if (!t.Ca) throw Error("This task doesn't support region-of-interest.");
            var s = r.regionOfInterest;
            if (s.left >= s.right || s.top >= s.bottom) throw Error("Expected RectF with left < right and top < bottom.");
            if (s.left < 0 || s.top < 0 || s.right > 1 || s.bottom > 1) throw Error("Expected RectF values to be in [0,1].");
            $a2acea4f3420f1d8$var$jr(i, 1, (s.left + s.right) / 2), $a2acea4f3420f1d8$var$jr(i, 2, (s.top + s.bottom) / 2), $a2acea4f3420f1d8$var$jr(i, 4, s.right - s.left), $a2acea4f3420f1d8$var$jr(i, 3, s.bottom - s.top);
        } else $a2acea4f3420f1d8$var$jr(i, 1, .5), $a2acea4f3420f1d8$var$jr(i, 2, .5), $a2acea4f3420f1d8$var$jr(i, 4, 1), $a2acea4f3420f1d8$var$jr(i, 3, 1);
        if (r?.rotationDegrees) {
            if (r?.rotationDegrees % 90 != 0) throw Error("Expected rotation to be a multiple of 90\xb0.");
            if ($a2acea4f3420f1d8$var$jr(i, 5, -Math.PI * r.rotationDegrees / 180), r?.rotationDegrees % 180 != 0) {
                let [t, n] = $a2acea4f3420f1d8$var$Uh(e);
                r = $a2acea4f3420f1d8$var$Dr(i, 3) * n / t, s = $a2acea4f3420f1d8$var$Dr(i, 4) * t / n, $a2acea4f3420f1d8$var$jr(i, 4, r), $a2acea4f3420f1d8$var$jr(i, 3, s);
            }
        }
        t.g.addProtoToStream(i.g(), "mediapipe.NormalizedRect", t.qa, n);
    }
    t.g.Da(e, t.Ba, n ?? performance.now()), t.finishProcessing(n);
}
function $a2acea4f3420f1d8$var$tc(t, e, r) {
    if (t.J) throw Error("Task is not initialized with image mode. 'runningMode' must be set to 'IMAGE'.");
    $a2acea4f3420f1d8$var$Qu(t, e, r, t.I + 1);
}
function $a2acea4f3420f1d8$var$ec(t, e, r, n) {
    if (!t.J) throw Error("Task is not initialized with video mode. 'runningMode' must be set to 'VIDEO'.");
    $a2acea4f3420f1d8$var$Qu(t, e, r, n);
}
function $a2acea4f3420f1d8$var$rc(t, e, r, n) {
    var i = e.data, s = e.width, o = s * (e = e.height);
    if ((i instanceof Uint8Array || i instanceof Float32Array) && i.length !== o) throw Error("Unsupported channel count: " + i.length / o);
    return t = new $a2acea4f3420f1d8$export$e68fd2753c6d17ef([
        i
    ], r, !1, t.g.i.canvas, t.da, s, e), n ? t.clone() : t;
}
var $a2acea4f3420f1d8$export$6371bff908d1a094 = class extends $a2acea4f3420f1d8$export$61e9fc2d6edc635c {
    constructor(t, e, r, n){
        super(t), this.g = t, this.Ba = e, this.qa = r, this.Ca = n, this.da = new $a2acea4f3420f1d8$var$pu, this.J = !1;
    }
    j(t, e = !0) {
        if ("runningMode" in t) {
            var r = this.J = !!t.runningMode && "IMAGE" !== t.runningMode;
            $a2acea4f3420f1d8$var$ar(this.baseOptions, 2, null == r ? r : $a2acea4f3420f1d8$var$Zt(r));
        }
        if (void 0 !== t.canvas && this.g.i.canvas !== t.canvas) throw Error("You must create a new task to reset the canvas.");
        return super.j(t, e);
    }
    close() {
        this.da.close(), super.close();
    }
};
$a2acea4f3420f1d8$export$6371bff908d1a094.prototype.close = $a2acea4f3420f1d8$export$6371bff908d1a094.prototype.close;
var $a2acea4f3420f1d8$export$6de3c7136b240002 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "image_in", "norm_rect_in", !1), this.l = {
            detections: []
        }, $a2acea4f3420f1d8$var$Ir(t = this.h = new $a2acea4f3420f1d8$var$Zo, 0, 1, e = new $a2acea4f3420f1d8$var$zo), $a2acea4f3420f1d8$var$jr(this.h, 2, .5), $a2acea4f3420f1d8$var$jr(this.h, 3, .3);
    }
    C() {
        return "FaceDetector";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.h, 0, 1, t);
    }
    v(t) {
        return "minDetectionConfidence" in t && $a2acea4f3420f1d8$var$jr(this.h, 2, t.minDetectionConfidence ?? .5), "minSuppressionThreshold" in t && $a2acea4f3420f1d8$var$jr(this.h, 3, t.minSuppressionThreshold ?? .3), this.j(t);
    }
    G(t, e) {
        return this.l = {
            detections: []
        }, $a2acea4f3420f1d8$var$tc(this, t, e), this.l;
    }
    H(t, e, r) {
        return this.l = {
            detections: []
        }, $a2acea4f3420f1d8$var$ec(this, t, r, e), this.l;
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "image_in"), $a2acea4f3420f1d8$var$po(t, "norm_rect_in"), $a2acea4f3420f1d8$var$go(t, "detections");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$ta, this.h);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.face_detector.FaceDetectorGraph"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:image_in"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect_in"), $a2acea4f3420f1d8$var$ao(r, "DETECTIONS:detections"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), this.g.attachProtoVectorListener("detections", (t, e)=>{
            for (let e of t)t = $a2acea4f3420f1d8$var$So(e), this.l.detections.push($a2acea4f3420f1d8$var$Za(t));
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("detections", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$6de3c7136b240002.prototype.detectForVideo = $a2acea4f3420f1d8$export$6de3c7136b240002.prototype.H, $a2acea4f3420f1d8$export$6de3c7136b240002.prototype.detect = $a2acea4f3420f1d8$export$6de3c7136b240002.prototype.G, $a2acea4f3420f1d8$export$6de3c7136b240002.prototype.setOptions = $a2acea4f3420f1d8$export$6de3c7136b240002.prototype.v, $a2acea4f3420f1d8$export$6de3c7136b240002.createFromModelPath = async function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$6de3c7136b240002, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$6de3c7136b240002.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$6de3c7136b240002, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$6de3c7136b240002.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$6de3c7136b240002, t, e);
};
var $a2acea4f3420f1d8$var$sc = $a2acea4f3420f1d8$var$zu([
    61,
    146
], [
    146,
    91
], [
    91,
    181
], [
    181,
    84
], [
    84,
    17
], [
    17,
    314
], [
    314,
    405
], [
    405,
    321
], [
    321,
    375
], [
    375,
    291
], [
    61,
    185
], [
    185,
    40
], [
    40,
    39
], [
    39,
    37
], [
    37,
    0
], [
    0,
    267
], [
    267,
    269
], [
    269,
    270
], [
    270,
    409
], [
    409,
    291
], [
    78,
    95
], [
    95,
    88
], [
    88,
    178
], [
    178,
    87
], [
    87,
    14
], [
    14,
    317
], [
    317,
    402
], [
    402,
    318
], [
    318,
    324
], [
    324,
    308
], [
    78,
    191
], [
    191,
    80
], [
    80,
    81
], [
    81,
    82
], [
    82,
    13
], [
    13,
    312
], [
    312,
    311
], [
    311,
    310
], [
    310,
    415
], [
    415,
    308
]), $a2acea4f3420f1d8$var$oc = $a2acea4f3420f1d8$var$zu([
    263,
    249
], [
    249,
    390
], [
    390,
    373
], [
    373,
    374
], [
    374,
    380
], [
    380,
    381
], [
    381,
    382
], [
    382,
    362
], [
    263,
    466
], [
    466,
    388
], [
    388,
    387
], [
    387,
    386
], [
    386,
    385
], [
    385,
    384
], [
    384,
    398
], [
    398,
    362
]), $a2acea4f3420f1d8$var$ac = $a2acea4f3420f1d8$var$zu([
    276,
    283
], [
    283,
    282
], [
    282,
    295
], [
    295,
    285
], [
    300,
    293
], [
    293,
    334
], [
    334,
    296
], [
    296,
    336
]), $a2acea4f3420f1d8$var$hc = $a2acea4f3420f1d8$var$zu([
    474,
    475
], [
    475,
    476
], [
    476,
    477
], [
    477,
    474
]), $a2acea4f3420f1d8$var$uc = $a2acea4f3420f1d8$var$zu([
    33,
    7
], [
    7,
    163
], [
    163,
    144
], [
    144,
    145
], [
    145,
    153
], [
    153,
    154
], [
    154,
    155
], [
    155,
    133
], [
    33,
    246
], [
    246,
    161
], [
    161,
    160
], [
    160,
    159
], [
    159,
    158
], [
    158,
    157
], [
    157,
    173
], [
    173,
    133
]), $a2acea4f3420f1d8$var$cc = $a2acea4f3420f1d8$var$zu([
    46,
    53
], [
    53,
    52
], [
    52,
    65
], [
    65,
    55
], [
    70,
    63
], [
    63,
    105
], [
    105,
    66
], [
    66,
    107
]), $a2acea4f3420f1d8$var$lc = $a2acea4f3420f1d8$var$zu([
    469,
    470
], [
    470,
    471
], [
    471,
    472
], [
    472,
    469
]), $a2acea4f3420f1d8$var$dc = $a2acea4f3420f1d8$var$zu([
    10,
    338
], [
    338,
    297
], [
    297,
    332
], [
    332,
    284
], [
    284,
    251
], [
    251,
    389
], [
    389,
    356
], [
    356,
    454
], [
    454,
    323
], [
    323,
    361
], [
    361,
    288
], [
    288,
    397
], [
    397,
    365
], [
    365,
    379
], [
    379,
    378
], [
    378,
    400
], [
    400,
    377
], [
    377,
    152
], [
    152,
    148
], [
    148,
    176
], [
    176,
    149
], [
    149,
    150
], [
    150,
    136
], [
    136,
    172
], [
    172,
    58
], [
    58,
    132
], [
    132,
    93
], [
    93,
    234
], [
    234,
    127
], [
    127,
    162
], [
    162,
    21
], [
    21,
    54
], [
    54,
    103
], [
    103,
    67
], [
    67,
    109
], [
    109,
    10
]), $a2acea4f3420f1d8$var$fc = [
    ...$a2acea4f3420f1d8$var$sc,
    ...$a2acea4f3420f1d8$var$oc,
    ...$a2acea4f3420f1d8$var$ac,
    ...$a2acea4f3420f1d8$var$uc,
    ...$a2acea4f3420f1d8$var$cc,
    ...$a2acea4f3420f1d8$var$dc
], $a2acea4f3420f1d8$var$pc = $a2acea4f3420f1d8$var$zu([
    127,
    34
], [
    34,
    139
], [
    139,
    127
], [
    11,
    0
], [
    0,
    37
], [
    37,
    11
], [
    232,
    231
], [
    231,
    120
], [
    120,
    232
], [
    72,
    37
], [
    37,
    39
], [
    39,
    72
], [
    128,
    121
], [
    121,
    47
], [
    47,
    128
], [
    232,
    121
], [
    121,
    128
], [
    128,
    232
], [
    104,
    69
], [
    69,
    67
], [
    67,
    104
], [
    175,
    171
], [
    171,
    148
], [
    148,
    175
], [
    118,
    50
], [
    50,
    101
], [
    101,
    118
], [
    73,
    39
], [
    39,
    40
], [
    40,
    73
], [
    9,
    151
], [
    151,
    108
], [
    108,
    9
], [
    48,
    115
], [
    115,
    131
], [
    131,
    48
], [
    194,
    204
], [
    204,
    211
], [
    211,
    194
], [
    74,
    40
], [
    40,
    185
], [
    185,
    74
], [
    80,
    42
], [
    42,
    183
], [
    183,
    80
], [
    40,
    92
], [
    92,
    186
], [
    186,
    40
], [
    230,
    229
], [
    229,
    118
], [
    118,
    230
], [
    202,
    212
], [
    212,
    214
], [
    214,
    202
], [
    83,
    18
], [
    18,
    17
], [
    17,
    83
], [
    76,
    61
], [
    61,
    146
], [
    146,
    76
], [
    160,
    29
], [
    29,
    30
], [
    30,
    160
], [
    56,
    157
], [
    157,
    173
], [
    173,
    56
], [
    106,
    204
], [
    204,
    194
], [
    194,
    106
], [
    135,
    214
], [
    214,
    192
], [
    192,
    135
], [
    203,
    165
], [
    165,
    98
], [
    98,
    203
], [
    21,
    71
], [
    71,
    68
], [
    68,
    21
], [
    51,
    45
], [
    45,
    4
], [
    4,
    51
], [
    144,
    24
], [
    24,
    23
], [
    23,
    144
], [
    77,
    146
], [
    146,
    91
], [
    91,
    77
], [
    205,
    50
], [
    50,
    187
], [
    187,
    205
], [
    201,
    200
], [
    200,
    18
], [
    18,
    201
], [
    91,
    106
], [
    106,
    182
], [
    182,
    91
], [
    90,
    91
], [
    91,
    181
], [
    181,
    90
], [
    85,
    84
], [
    84,
    17
], [
    17,
    85
], [
    206,
    203
], [
    203,
    36
], [
    36,
    206
], [
    148,
    171
], [
    171,
    140
], [
    140,
    148
], [
    92,
    40
], [
    40,
    39
], [
    39,
    92
], [
    193,
    189
], [
    189,
    244
], [
    244,
    193
], [
    159,
    158
], [
    158,
    28
], [
    28,
    159
], [
    247,
    246
], [
    246,
    161
], [
    161,
    247
], [
    236,
    3
], [
    3,
    196
], [
    196,
    236
], [
    54,
    68
], [
    68,
    104
], [
    104,
    54
], [
    193,
    168
], [
    168,
    8
], [
    8,
    193
], [
    117,
    228
], [
    228,
    31
], [
    31,
    117
], [
    189,
    193
], [
    193,
    55
], [
    55,
    189
], [
    98,
    97
], [
    97,
    99
], [
    99,
    98
], [
    126,
    47
], [
    47,
    100
], [
    100,
    126
], [
    166,
    79
], [
    79,
    218
], [
    218,
    166
], [
    155,
    154
], [
    154,
    26
], [
    26,
    155
], [
    209,
    49
], [
    49,
    131
], [
    131,
    209
], [
    135,
    136
], [
    136,
    150
], [
    150,
    135
], [
    47,
    126
], [
    126,
    217
], [
    217,
    47
], [
    223,
    52
], [
    52,
    53
], [
    53,
    223
], [
    45,
    51
], [
    51,
    134
], [
    134,
    45
], [
    211,
    170
], [
    170,
    140
], [
    140,
    211
], [
    67,
    69
], [
    69,
    108
], [
    108,
    67
], [
    43,
    106
], [
    106,
    91
], [
    91,
    43
], [
    230,
    119
], [
    119,
    120
], [
    120,
    230
], [
    226,
    130
], [
    130,
    247
], [
    247,
    226
], [
    63,
    53
], [
    53,
    52
], [
    52,
    63
], [
    238,
    20
], [
    20,
    242
], [
    242,
    238
], [
    46,
    70
], [
    70,
    156
], [
    156,
    46
], [
    78,
    62
], [
    62,
    96
], [
    96,
    78
], [
    46,
    53
], [
    53,
    63
], [
    63,
    46
], [
    143,
    34
], [
    34,
    227
], [
    227,
    143
], [
    123,
    117
], [
    117,
    111
], [
    111,
    123
], [
    44,
    125
], [
    125,
    19
], [
    19,
    44
], [
    236,
    134
], [
    134,
    51
], [
    51,
    236
], [
    216,
    206
], [
    206,
    205
], [
    205,
    216
], [
    154,
    153
], [
    153,
    22
], [
    22,
    154
], [
    39,
    37
], [
    37,
    167
], [
    167,
    39
], [
    200,
    201
], [
    201,
    208
], [
    208,
    200
], [
    36,
    142
], [
    142,
    100
], [
    100,
    36
], [
    57,
    212
], [
    212,
    202
], [
    202,
    57
], [
    20,
    60
], [
    60,
    99
], [
    99,
    20
], [
    28,
    158
], [
    158,
    157
], [
    157,
    28
], [
    35,
    226
], [
    226,
    113
], [
    113,
    35
], [
    160,
    159
], [
    159,
    27
], [
    27,
    160
], [
    204,
    202
], [
    202,
    210
], [
    210,
    204
], [
    113,
    225
], [
    225,
    46
], [
    46,
    113
], [
    43,
    202
], [
    202,
    204
], [
    204,
    43
], [
    62,
    76
], [
    76,
    77
], [
    77,
    62
], [
    137,
    123
], [
    123,
    116
], [
    116,
    137
], [
    41,
    38
], [
    38,
    72
], [
    72,
    41
], [
    203,
    129
], [
    129,
    142
], [
    142,
    203
], [
    64,
    98
], [
    98,
    240
], [
    240,
    64
], [
    49,
    102
], [
    102,
    64
], [
    64,
    49
], [
    41,
    73
], [
    73,
    74
], [
    74,
    41
], [
    212,
    216
], [
    216,
    207
], [
    207,
    212
], [
    42,
    74
], [
    74,
    184
], [
    184,
    42
], [
    169,
    170
], [
    170,
    211
], [
    211,
    169
], [
    170,
    149
], [
    149,
    176
], [
    176,
    170
], [
    105,
    66
], [
    66,
    69
], [
    69,
    105
], [
    122,
    6
], [
    6,
    168
], [
    168,
    122
], [
    123,
    147
], [
    147,
    187
], [
    187,
    123
], [
    96,
    77
], [
    77,
    90
], [
    90,
    96
], [
    65,
    55
], [
    55,
    107
], [
    107,
    65
], [
    89,
    90
], [
    90,
    180
], [
    180,
    89
], [
    101,
    100
], [
    100,
    120
], [
    120,
    101
], [
    63,
    105
], [
    105,
    104
], [
    104,
    63
], [
    93,
    137
], [
    137,
    227
], [
    227,
    93
], [
    15,
    86
], [
    86,
    85
], [
    85,
    15
], [
    129,
    102
], [
    102,
    49
], [
    49,
    129
], [
    14,
    87
], [
    87,
    86
], [
    86,
    14
], [
    55,
    8
], [
    8,
    9
], [
    9,
    55
], [
    100,
    47
], [
    47,
    121
], [
    121,
    100
], [
    145,
    23
], [
    23,
    22
], [
    22,
    145
], [
    88,
    89
], [
    89,
    179
], [
    179,
    88
], [
    6,
    122
], [
    122,
    196
], [
    196,
    6
], [
    88,
    95
], [
    95,
    96
], [
    96,
    88
], [
    138,
    172
], [
    172,
    136
], [
    136,
    138
], [
    215,
    58
], [
    58,
    172
], [
    172,
    215
], [
    115,
    48
], [
    48,
    219
], [
    219,
    115
], [
    42,
    80
], [
    80,
    81
], [
    81,
    42
], [
    195,
    3
], [
    3,
    51
], [
    51,
    195
], [
    43,
    146
], [
    146,
    61
], [
    61,
    43
], [
    171,
    175
], [
    175,
    199
], [
    199,
    171
], [
    81,
    82
], [
    82,
    38
], [
    38,
    81
], [
    53,
    46
], [
    46,
    225
], [
    225,
    53
], [
    144,
    163
], [
    163,
    110
], [
    110,
    144
], [
    52,
    65
], [
    65,
    66
], [
    66,
    52
], [
    229,
    228
], [
    228,
    117
], [
    117,
    229
], [
    34,
    127
], [
    127,
    234
], [
    234,
    34
], [
    107,
    108
], [
    108,
    69
], [
    69,
    107
], [
    109,
    108
], [
    108,
    151
], [
    151,
    109
], [
    48,
    64
], [
    64,
    235
], [
    235,
    48
], [
    62,
    78
], [
    78,
    191
], [
    191,
    62
], [
    129,
    209
], [
    209,
    126
], [
    126,
    129
], [
    111,
    35
], [
    35,
    143
], [
    143,
    111
], [
    117,
    123
], [
    123,
    50
], [
    50,
    117
], [
    222,
    65
], [
    65,
    52
], [
    52,
    222
], [
    19,
    125
], [
    125,
    141
], [
    141,
    19
], [
    221,
    55
], [
    55,
    65
], [
    65,
    221
], [
    3,
    195
], [
    195,
    197
], [
    197,
    3
], [
    25,
    7
], [
    7,
    33
], [
    33,
    25
], [
    220,
    237
], [
    237,
    44
], [
    44,
    220
], [
    70,
    71
], [
    71,
    139
], [
    139,
    70
], [
    122,
    193
], [
    193,
    245
], [
    245,
    122
], [
    247,
    130
], [
    130,
    33
], [
    33,
    247
], [
    71,
    21
], [
    21,
    162
], [
    162,
    71
], [
    170,
    169
], [
    169,
    150
], [
    150,
    170
], [
    188,
    174
], [
    174,
    196
], [
    196,
    188
], [
    216,
    186
], [
    186,
    92
], [
    92,
    216
], [
    2,
    97
], [
    97,
    167
], [
    167,
    2
], [
    141,
    125
], [
    125,
    241
], [
    241,
    141
], [
    164,
    167
], [
    167,
    37
], [
    37,
    164
], [
    72,
    38
], [
    38,
    12
], [
    12,
    72
], [
    38,
    82
], [
    82,
    13
], [
    13,
    38
], [
    63,
    68
], [
    68,
    71
], [
    71,
    63
], [
    226,
    35
], [
    35,
    111
], [
    111,
    226
], [
    101,
    50
], [
    50,
    205
], [
    205,
    101
], [
    206,
    92
], [
    92,
    165
], [
    165,
    206
], [
    209,
    198
], [
    198,
    217
], [
    217,
    209
], [
    165,
    167
], [
    167,
    97
], [
    97,
    165
], [
    220,
    115
], [
    115,
    218
], [
    218,
    220
], [
    133,
    112
], [
    112,
    243
], [
    243,
    133
], [
    239,
    238
], [
    238,
    241
], [
    241,
    239
], [
    214,
    135
], [
    135,
    169
], [
    169,
    214
], [
    190,
    173
], [
    173,
    133
], [
    133,
    190
], [
    171,
    208
], [
    208,
    32
], [
    32,
    171
], [
    125,
    44
], [
    44,
    237
], [
    237,
    125
], [
    86,
    87
], [
    87,
    178
], [
    178,
    86
], [
    85,
    86
], [
    86,
    179
], [
    179,
    85
], [
    84,
    85
], [
    85,
    180
], [
    180,
    84
], [
    83,
    84
], [
    84,
    181
], [
    181,
    83
], [
    201,
    83
], [
    83,
    182
], [
    182,
    201
], [
    137,
    93
], [
    93,
    132
], [
    132,
    137
], [
    76,
    62
], [
    62,
    183
], [
    183,
    76
], [
    61,
    76
], [
    76,
    184
], [
    184,
    61
], [
    57,
    61
], [
    61,
    185
], [
    185,
    57
], [
    212,
    57
], [
    57,
    186
], [
    186,
    212
], [
    214,
    207
], [
    207,
    187
], [
    187,
    214
], [
    34,
    143
], [
    143,
    156
], [
    156,
    34
], [
    79,
    239
], [
    239,
    237
], [
    237,
    79
], [
    123,
    137
], [
    137,
    177
], [
    177,
    123
], [
    44,
    1
], [
    1,
    4
], [
    4,
    44
], [
    201,
    194
], [
    194,
    32
], [
    32,
    201
], [
    64,
    102
], [
    102,
    129
], [
    129,
    64
], [
    213,
    215
], [
    215,
    138
], [
    138,
    213
], [
    59,
    166
], [
    166,
    219
], [
    219,
    59
], [
    242,
    99
], [
    99,
    97
], [
    97,
    242
], [
    2,
    94
], [
    94,
    141
], [
    141,
    2
], [
    75,
    59
], [
    59,
    235
], [
    235,
    75
], [
    24,
    110
], [
    110,
    228
], [
    228,
    24
], [
    25,
    130
], [
    130,
    226
], [
    226,
    25
], [
    23,
    24
], [
    24,
    229
], [
    229,
    23
], [
    22,
    23
], [
    23,
    230
], [
    230,
    22
], [
    26,
    22
], [
    22,
    231
], [
    231,
    26
], [
    112,
    26
], [
    26,
    232
], [
    232,
    112
], [
    189,
    190
], [
    190,
    243
], [
    243,
    189
], [
    221,
    56
], [
    56,
    190
], [
    190,
    221
], [
    28,
    56
], [
    56,
    221
], [
    221,
    28
], [
    27,
    28
], [
    28,
    222
], [
    222,
    27
], [
    29,
    27
], [
    27,
    223
], [
    223,
    29
], [
    30,
    29
], [
    29,
    224
], [
    224,
    30
], [
    247,
    30
], [
    30,
    225
], [
    225,
    247
], [
    238,
    79
], [
    79,
    20
], [
    20,
    238
], [
    166,
    59
], [
    59,
    75
], [
    75,
    166
], [
    60,
    75
], [
    75,
    240
], [
    240,
    60
], [
    147,
    177
], [
    177,
    215
], [
    215,
    147
], [
    20,
    79
], [
    79,
    166
], [
    166,
    20
], [
    187,
    147
], [
    147,
    213
], [
    213,
    187
], [
    112,
    233
], [
    233,
    244
], [
    244,
    112
], [
    233,
    128
], [
    128,
    245
], [
    245,
    233
], [
    128,
    114
], [
    114,
    188
], [
    188,
    128
], [
    114,
    217
], [
    217,
    174
], [
    174,
    114
], [
    131,
    115
], [
    115,
    220
], [
    220,
    131
], [
    217,
    198
], [
    198,
    236
], [
    236,
    217
], [
    198,
    131
], [
    131,
    134
], [
    134,
    198
], [
    177,
    132
], [
    132,
    58
], [
    58,
    177
], [
    143,
    35
], [
    35,
    124
], [
    124,
    143
], [
    110,
    163
], [
    163,
    7
], [
    7,
    110
], [
    228,
    110
], [
    110,
    25
], [
    25,
    228
], [
    356,
    389
], [
    389,
    368
], [
    368,
    356
], [
    11,
    302
], [
    302,
    267
], [
    267,
    11
], [
    452,
    350
], [
    350,
    349
], [
    349,
    452
], [
    302,
    303
], [
    303,
    269
], [
    269,
    302
], [
    357,
    343
], [
    343,
    277
], [
    277,
    357
], [
    452,
    453
], [
    453,
    357
], [
    357,
    452
], [
    333,
    332
], [
    332,
    297
], [
    297,
    333
], [
    175,
    152
], [
    152,
    377
], [
    377,
    175
], [
    347,
    348
], [
    348,
    330
], [
    330,
    347
], [
    303,
    304
], [
    304,
    270
], [
    270,
    303
], [
    9,
    336
], [
    336,
    337
], [
    337,
    9
], [
    278,
    279
], [
    279,
    360
], [
    360,
    278
], [
    418,
    262
], [
    262,
    431
], [
    431,
    418
], [
    304,
    408
], [
    408,
    409
], [
    409,
    304
], [
    310,
    415
], [
    415,
    407
], [
    407,
    310
], [
    270,
    409
], [
    409,
    410
], [
    410,
    270
], [
    450,
    348
], [
    348,
    347
], [
    347,
    450
], [
    422,
    430
], [
    430,
    434
], [
    434,
    422
], [
    313,
    314
], [
    314,
    17
], [
    17,
    313
], [
    306,
    307
], [
    307,
    375
], [
    375,
    306
], [
    387,
    388
], [
    388,
    260
], [
    260,
    387
], [
    286,
    414
], [
    414,
    398
], [
    398,
    286
], [
    335,
    406
], [
    406,
    418
], [
    418,
    335
], [
    364,
    367
], [
    367,
    416
], [
    416,
    364
], [
    423,
    358
], [
    358,
    327
], [
    327,
    423
], [
    251,
    284
], [
    284,
    298
], [
    298,
    251
], [
    281,
    5
], [
    5,
    4
], [
    4,
    281
], [
    373,
    374
], [
    374,
    253
], [
    253,
    373
], [
    307,
    320
], [
    320,
    321
], [
    321,
    307
], [
    425,
    427
], [
    427,
    411
], [
    411,
    425
], [
    421,
    313
], [
    313,
    18
], [
    18,
    421
], [
    321,
    405
], [
    405,
    406
], [
    406,
    321
], [
    320,
    404
], [
    404,
    405
], [
    405,
    320
], [
    315,
    16
], [
    16,
    17
], [
    17,
    315
], [
    426,
    425
], [
    425,
    266
], [
    266,
    426
], [
    377,
    400
], [
    400,
    369
], [
    369,
    377
], [
    322,
    391
], [
    391,
    269
], [
    269,
    322
], [
    417,
    465
], [
    465,
    464
], [
    464,
    417
], [
    386,
    257
], [
    257,
    258
], [
    258,
    386
], [
    466,
    260
], [
    260,
    388
], [
    388,
    466
], [
    456,
    399
], [
    399,
    419
], [
    419,
    456
], [
    284,
    332
], [
    332,
    333
], [
    333,
    284
], [
    417,
    285
], [
    285,
    8
], [
    8,
    417
], [
    346,
    340
], [
    340,
    261
], [
    261,
    346
], [
    413,
    441
], [
    441,
    285
], [
    285,
    413
], [
    327,
    460
], [
    460,
    328
], [
    328,
    327
], [
    355,
    371
], [
    371,
    329
], [
    329,
    355
], [
    392,
    439
], [
    439,
    438
], [
    438,
    392
], [
    382,
    341
], [
    341,
    256
], [
    256,
    382
], [
    429,
    420
], [
    420,
    360
], [
    360,
    429
], [
    364,
    394
], [
    394,
    379
], [
    379,
    364
], [
    277,
    343
], [
    343,
    437
], [
    437,
    277
], [
    443,
    444
], [
    444,
    283
], [
    283,
    443
], [
    275,
    440
], [
    440,
    363
], [
    363,
    275
], [
    431,
    262
], [
    262,
    369
], [
    369,
    431
], [
    297,
    338
], [
    338,
    337
], [
    337,
    297
], [
    273,
    375
], [
    375,
    321
], [
    321,
    273
], [
    450,
    451
], [
    451,
    349
], [
    349,
    450
], [
    446,
    342
], [
    342,
    467
], [
    467,
    446
], [
    293,
    334
], [
    334,
    282
], [
    282,
    293
], [
    458,
    461
], [
    461,
    462
], [
    462,
    458
], [
    276,
    353
], [
    353,
    383
], [
    383,
    276
], [
    308,
    324
], [
    324,
    325
], [
    325,
    308
], [
    276,
    300
], [
    300,
    293
], [
    293,
    276
], [
    372,
    345
], [
    345,
    447
], [
    447,
    372
], [
    352,
    345
], [
    345,
    340
], [
    340,
    352
], [
    274,
    1
], [
    1,
    19
], [
    19,
    274
], [
    456,
    248
], [
    248,
    281
], [
    281,
    456
], [
    436,
    427
], [
    427,
    425
], [
    425,
    436
], [
    381,
    256
], [
    256,
    252
], [
    252,
    381
], [
    269,
    391
], [
    391,
    393
], [
    393,
    269
], [
    200,
    199
], [
    199,
    428
], [
    428,
    200
], [
    266,
    330
], [
    330,
    329
], [
    329,
    266
], [
    287,
    273
], [
    273,
    422
], [
    422,
    287
], [
    250,
    462
], [
    462,
    328
], [
    328,
    250
], [
    258,
    286
], [
    286,
    384
], [
    384,
    258
], [
    265,
    353
], [
    353,
    342
], [
    342,
    265
], [
    387,
    259
], [
    259,
    257
], [
    257,
    387
], [
    424,
    431
], [
    431,
    430
], [
    430,
    424
], [
    342,
    353
], [
    353,
    276
], [
    276,
    342
], [
    273,
    335
], [
    335,
    424
], [
    424,
    273
], [
    292,
    325
], [
    325,
    307
], [
    307,
    292
], [
    366,
    447
], [
    447,
    345
], [
    345,
    366
], [
    271,
    303
], [
    303,
    302
], [
    302,
    271
], [
    423,
    266
], [
    266,
    371
], [
    371,
    423
], [
    294,
    455
], [
    455,
    460
], [
    460,
    294
], [
    279,
    278
], [
    278,
    294
], [
    294,
    279
], [
    271,
    272
], [
    272,
    304
], [
    304,
    271
], [
    432,
    434
], [
    434,
    427
], [
    427,
    432
], [
    272,
    407
], [
    407,
    408
], [
    408,
    272
], [
    394,
    430
], [
    430,
    431
], [
    431,
    394
], [
    395,
    369
], [
    369,
    400
], [
    400,
    395
], [
    334,
    333
], [
    333,
    299
], [
    299,
    334
], [
    351,
    417
], [
    417,
    168
], [
    168,
    351
], [
    352,
    280
], [
    280,
    411
], [
    411,
    352
], [
    325,
    319
], [
    319,
    320
], [
    320,
    325
], [
    295,
    296
], [
    296,
    336
], [
    336,
    295
], [
    319,
    403
], [
    403,
    404
], [
    404,
    319
], [
    330,
    348
], [
    348,
    349
], [
    349,
    330
], [
    293,
    298
], [
    298,
    333
], [
    333,
    293
], [
    323,
    454
], [
    454,
    447
], [
    447,
    323
], [
    15,
    16
], [
    16,
    315
], [
    315,
    15
], [
    358,
    429
], [
    429,
    279
], [
    279,
    358
], [
    14,
    15
], [
    15,
    316
], [
    316,
    14
], [
    285,
    336
], [
    336,
    9
], [
    9,
    285
], [
    329,
    349
], [
    349,
    350
], [
    350,
    329
], [
    374,
    380
], [
    380,
    252
], [
    252,
    374
], [
    318,
    402
], [
    402,
    403
], [
    403,
    318
], [
    6,
    197
], [
    197,
    419
], [
    419,
    6
], [
    318,
    319
], [
    319,
    325
], [
    325,
    318
], [
    367,
    364
], [
    364,
    365
], [
    365,
    367
], [
    435,
    367
], [
    367,
    397
], [
    397,
    435
], [
    344,
    438
], [
    438,
    439
], [
    439,
    344
], [
    272,
    271
], [
    271,
    311
], [
    311,
    272
], [
    195,
    5
], [
    5,
    281
], [
    281,
    195
], [
    273,
    287
], [
    287,
    291
], [
    291,
    273
], [
    396,
    428
], [
    428,
    199
], [
    199,
    396
], [
    311,
    271
], [
    271,
    268
], [
    268,
    311
], [
    283,
    444
], [
    444,
    445
], [
    445,
    283
], [
    373,
    254
], [
    254,
    339
], [
    339,
    373
], [
    282,
    334
], [
    334,
    296
], [
    296,
    282
], [
    449,
    347
], [
    347,
    346
], [
    346,
    449
], [
    264,
    447
], [
    447,
    454
], [
    454,
    264
], [
    336,
    296
], [
    296,
    299
], [
    299,
    336
], [
    338,
    10
], [
    10,
    151
], [
    151,
    338
], [
    278,
    439
], [
    439,
    455
], [
    455,
    278
], [
    292,
    407
], [
    407,
    415
], [
    415,
    292
], [
    358,
    371
], [
    371,
    355
], [
    355,
    358
], [
    340,
    345
], [
    345,
    372
], [
    372,
    340
], [
    346,
    347
], [
    347,
    280
], [
    280,
    346
], [
    442,
    443
], [
    443,
    282
], [
    282,
    442
], [
    19,
    94
], [
    94,
    370
], [
    370,
    19
], [
    441,
    442
], [
    442,
    295
], [
    295,
    441
], [
    248,
    419
], [
    419,
    197
], [
    197,
    248
], [
    263,
    255
], [
    255,
    359
], [
    359,
    263
], [
    440,
    275
], [
    275,
    274
], [
    274,
    440
], [
    300,
    383
], [
    383,
    368
], [
    368,
    300
], [
    351,
    412
], [
    412,
    465
], [
    465,
    351
], [
    263,
    467
], [
    467,
    466
], [
    466,
    263
], [
    301,
    368
], [
    368,
    389
], [
    389,
    301
], [
    395,
    378
], [
    378,
    379
], [
    379,
    395
], [
    412,
    351
], [
    351,
    419
], [
    419,
    412
], [
    436,
    426
], [
    426,
    322
], [
    322,
    436
], [
    2,
    164
], [
    164,
    393
], [
    393,
    2
], [
    370,
    462
], [
    462,
    461
], [
    461,
    370
], [
    164,
    0
], [
    0,
    267
], [
    267,
    164
], [
    302,
    11
], [
    11,
    12
], [
    12,
    302
], [
    268,
    12
], [
    12,
    13
], [
    13,
    268
], [
    293,
    300
], [
    300,
    301
], [
    301,
    293
], [
    446,
    261
], [
    261,
    340
], [
    340,
    446
], [
    330,
    266
], [
    266,
    425
], [
    425,
    330
], [
    426,
    423
], [
    423,
    391
], [
    391,
    426
], [
    429,
    355
], [
    355,
    437
], [
    437,
    429
], [
    391,
    327
], [
    327,
    326
], [
    326,
    391
], [
    440,
    457
], [
    457,
    438
], [
    438,
    440
], [
    341,
    382
], [
    382,
    362
], [
    362,
    341
], [
    459,
    457
], [
    457,
    461
], [
    461,
    459
], [
    434,
    430
], [
    430,
    394
], [
    394,
    434
], [
    414,
    463
], [
    463,
    362
], [
    362,
    414
], [
    396,
    369
], [
    369,
    262
], [
    262,
    396
], [
    354,
    461
], [
    461,
    457
], [
    457,
    354
], [
    316,
    403
], [
    403,
    402
], [
    402,
    316
], [
    315,
    404
], [
    404,
    403
], [
    403,
    315
], [
    314,
    405
], [
    405,
    404
], [
    404,
    314
], [
    313,
    406
], [
    406,
    405
], [
    405,
    313
], [
    421,
    418
], [
    418,
    406
], [
    406,
    421
], [
    366,
    401
], [
    401,
    361
], [
    361,
    366
], [
    306,
    408
], [
    408,
    407
], [
    407,
    306
], [
    291,
    409
], [
    409,
    408
], [
    408,
    291
], [
    287,
    410
], [
    410,
    409
], [
    409,
    287
], [
    432,
    436
], [
    436,
    410
], [
    410,
    432
], [
    434,
    416
], [
    416,
    411
], [
    411,
    434
], [
    264,
    368
], [
    368,
    383
], [
    383,
    264
], [
    309,
    438
], [
    438,
    457
], [
    457,
    309
], [
    352,
    376
], [
    376,
    401
], [
    401,
    352
], [
    274,
    275
], [
    275,
    4
], [
    4,
    274
], [
    421,
    428
], [
    428,
    262
], [
    262,
    421
], [
    294,
    327
], [
    327,
    358
], [
    358,
    294
], [
    433,
    416
], [
    416,
    367
], [
    367,
    433
], [
    289,
    455
], [
    455,
    439
], [
    439,
    289
], [
    462,
    370
], [
    370,
    326
], [
    326,
    462
], [
    2,
    326
], [
    326,
    370
], [
    370,
    2
], [
    305,
    460
], [
    460,
    455
], [
    455,
    305
], [
    254,
    449
], [
    449,
    448
], [
    448,
    254
], [
    255,
    261
], [
    261,
    446
], [
    446,
    255
], [
    253,
    450
], [
    450,
    449
], [
    449,
    253
], [
    252,
    451
], [
    451,
    450
], [
    450,
    252
], [
    256,
    452
], [
    452,
    451
], [
    451,
    256
], [
    341,
    453
], [
    453,
    452
], [
    452,
    341
], [
    413,
    464
], [
    464,
    463
], [
    463,
    413
], [
    441,
    413
], [
    413,
    414
], [
    414,
    441
], [
    258,
    442
], [
    442,
    441
], [
    441,
    258
], [
    257,
    443
], [
    443,
    442
], [
    442,
    257
], [
    259,
    444
], [
    444,
    443
], [
    443,
    259
], [
    260,
    445
], [
    445,
    444
], [
    444,
    260
], [
    467,
    342
], [
    342,
    445
], [
    445,
    467
], [
    459,
    458
], [
    458,
    250
], [
    250,
    459
], [
    289,
    392
], [
    392,
    290
], [
    290,
    289
], [
    290,
    328
], [
    328,
    460
], [
    460,
    290
], [
    376,
    433
], [
    433,
    435
], [
    435,
    376
], [
    250,
    290
], [
    290,
    392
], [
    392,
    250
], [
    411,
    416
], [
    416,
    433
], [
    433,
    411
], [
    341,
    463
], [
    463,
    464
], [
    464,
    341
], [
    453,
    464
], [
    464,
    465
], [
    465,
    453
], [
    357,
    465
], [
    465,
    412
], [
    412,
    357
], [
    343,
    412
], [
    412,
    399
], [
    399,
    343
], [
    360,
    363
], [
    363,
    440
], [
    440,
    360
], [
    437,
    399
], [
    399,
    456
], [
    456,
    437
], [
    420,
    456
], [
    456,
    363
], [
    363,
    420
], [
    401,
    435
], [
    435,
    288
], [
    288,
    401
], [
    372,
    383
], [
    383,
    353
], [
    353,
    372
], [
    339,
    255
], [
    255,
    249
], [
    249,
    339
], [
    448,
    261
], [
    261,
    255
], [
    255,
    448
], [
    133,
    243
], [
    243,
    190
], [
    190,
    133
], [
    133,
    155
], [
    155,
    112
], [
    112,
    133
], [
    33,
    246
], [
    246,
    247
], [
    247,
    33
], [
    33,
    130
], [
    130,
    25
], [
    25,
    33
], [
    398,
    384
], [
    384,
    286
], [
    286,
    398
], [
    362,
    398
], [
    398,
    414
], [
    414,
    362
], [
    362,
    463
], [
    463,
    341
], [
    341,
    362
], [
    263,
    359
], [
    359,
    467
], [
    467,
    263
], [
    263,
    249
], [
    249,
    255
], [
    255,
    263
], [
    466,
    467
], [
    467,
    260
], [
    260,
    466
], [
    75,
    60
], [
    60,
    166
], [
    166,
    75
], [
    238,
    239
], [
    239,
    79
], [
    79,
    238
], [
    162,
    127
], [
    127,
    139
], [
    139,
    162
], [
    72,
    11
], [
    11,
    37
], [
    37,
    72
], [
    121,
    232
], [
    232,
    120
], [
    120,
    121
], [
    73,
    72
], [
    72,
    39
], [
    39,
    73
], [
    114,
    128
], [
    128,
    47
], [
    47,
    114
], [
    233,
    232
], [
    232,
    128
], [
    128,
    233
], [
    103,
    104
], [
    104,
    67
], [
    67,
    103
], [
    152,
    175
], [
    175,
    148
], [
    148,
    152
], [
    119,
    118
], [
    118,
    101
], [
    101,
    119
], [
    74,
    73
], [
    73,
    40
], [
    40,
    74
], [
    107,
    9
], [
    9,
    108
], [
    108,
    107
], [
    49,
    48
], [
    48,
    131
], [
    131,
    49
], [
    32,
    194
], [
    194,
    211
], [
    211,
    32
], [
    184,
    74
], [
    74,
    185
], [
    185,
    184
], [
    191,
    80
], [
    80,
    183
], [
    183,
    191
], [
    185,
    40
], [
    40,
    186
], [
    186,
    185
], [
    119,
    230
], [
    230,
    118
], [
    118,
    119
], [
    210,
    202
], [
    202,
    214
], [
    214,
    210
], [
    84,
    83
], [
    83,
    17
], [
    17,
    84
], [
    77,
    76
], [
    76,
    146
], [
    146,
    77
], [
    161,
    160
], [
    160,
    30
], [
    30,
    161
], [
    190,
    56
], [
    56,
    173
], [
    173,
    190
], [
    182,
    106
], [
    106,
    194
], [
    194,
    182
], [
    138,
    135
], [
    135,
    192
], [
    192,
    138
], [
    129,
    203
], [
    203,
    98
], [
    98,
    129
], [
    54,
    21
], [
    21,
    68
], [
    68,
    54
], [
    5,
    51
], [
    51,
    4
], [
    4,
    5
], [
    145,
    144
], [
    144,
    23
], [
    23,
    145
], [
    90,
    77
], [
    77,
    91
], [
    91,
    90
], [
    207,
    205
], [
    205,
    187
], [
    187,
    207
], [
    83,
    201
], [
    201,
    18
], [
    18,
    83
], [
    181,
    91
], [
    91,
    182
], [
    182,
    181
], [
    180,
    90
], [
    90,
    181
], [
    181,
    180
], [
    16,
    85
], [
    85,
    17
], [
    17,
    16
], [
    205,
    206
], [
    206,
    36
], [
    36,
    205
], [
    176,
    148
], [
    148,
    140
], [
    140,
    176
], [
    165,
    92
], [
    92,
    39
], [
    39,
    165
], [
    245,
    193
], [
    193,
    244
], [
    244,
    245
], [
    27,
    159
], [
    159,
    28
], [
    28,
    27
], [
    30,
    247
], [
    247,
    161
], [
    161,
    30
], [
    174,
    236
], [
    236,
    196
], [
    196,
    174
], [
    103,
    54
], [
    54,
    104
], [
    104,
    103
], [
    55,
    193
], [
    193,
    8
], [
    8,
    55
], [
    111,
    117
], [
    117,
    31
], [
    31,
    111
], [
    221,
    189
], [
    189,
    55
], [
    55,
    221
], [
    240,
    98
], [
    98,
    99
], [
    99,
    240
], [
    142,
    126
], [
    126,
    100
], [
    100,
    142
], [
    219,
    166
], [
    166,
    218
], [
    218,
    219
], [
    112,
    155
], [
    155,
    26
], [
    26,
    112
], [
    198,
    209
], [
    209,
    131
], [
    131,
    198
], [
    169,
    135
], [
    135,
    150
], [
    150,
    169
], [
    114,
    47
], [
    47,
    217
], [
    217,
    114
], [
    224,
    223
], [
    223,
    53
], [
    53,
    224
], [
    220,
    45
], [
    45,
    134
], [
    134,
    220
], [
    32,
    211
], [
    211,
    140
], [
    140,
    32
], [
    109,
    67
], [
    67,
    108
], [
    108,
    109
], [
    146,
    43
], [
    43,
    91
], [
    91,
    146
], [
    231,
    230
], [
    230,
    120
], [
    120,
    231
], [
    113,
    226
], [
    226,
    247
], [
    247,
    113
], [
    105,
    63
], [
    63,
    52
], [
    52,
    105
], [
    241,
    238
], [
    238,
    242
], [
    242,
    241
], [
    124,
    46
], [
    46,
    156
], [
    156,
    124
], [
    95,
    78
], [
    78,
    96
], [
    96,
    95
], [
    70,
    46
], [
    46,
    63
], [
    63,
    70
], [
    116,
    143
], [
    143,
    227
], [
    227,
    116
], [
    116,
    123
], [
    123,
    111
], [
    111,
    116
], [
    1,
    44
], [
    44,
    19
], [
    19,
    1
], [
    3,
    236
], [
    236,
    51
], [
    51,
    3
], [
    207,
    216
], [
    216,
    205
], [
    205,
    207
], [
    26,
    154
], [
    154,
    22
], [
    22,
    26
], [
    165,
    39
], [
    39,
    167
], [
    167,
    165
], [
    199,
    200
], [
    200,
    208
], [
    208,
    199
], [
    101,
    36
], [
    36,
    100
], [
    100,
    101
], [
    43,
    57
], [
    57,
    202
], [
    202,
    43
], [
    242,
    20
], [
    20,
    99
], [
    99,
    242
], [
    56,
    28
], [
    28,
    157
], [
    157,
    56
], [
    124,
    35
], [
    35,
    113
], [
    113,
    124
], [
    29,
    160
], [
    160,
    27
], [
    27,
    29
], [
    211,
    204
], [
    204,
    210
], [
    210,
    211
], [
    124,
    113
], [
    113,
    46
], [
    46,
    124
], [
    106,
    43
], [
    43,
    204
], [
    204,
    106
], [
    96,
    62
], [
    62,
    77
], [
    77,
    96
], [
    227,
    137
], [
    137,
    116
], [
    116,
    227
], [
    73,
    41
], [
    41,
    72
], [
    72,
    73
], [
    36,
    203
], [
    203,
    142
], [
    142,
    36
], [
    235,
    64
], [
    64,
    240
], [
    240,
    235
], [
    48,
    49
], [
    49,
    64
], [
    64,
    48
], [
    42,
    41
], [
    41,
    74
], [
    74,
    42
], [
    214,
    212
], [
    212,
    207
], [
    207,
    214
], [
    183,
    42
], [
    42,
    184
], [
    184,
    183
], [
    210,
    169
], [
    169,
    211
], [
    211,
    210
], [
    140,
    170
], [
    170,
    176
], [
    176,
    140
], [
    104,
    105
], [
    105,
    69
], [
    69,
    104
], [
    193,
    122
], [
    122,
    168
], [
    168,
    193
], [
    50,
    123
], [
    123,
    187
], [
    187,
    50
], [
    89,
    96
], [
    96,
    90
], [
    90,
    89
], [
    66,
    65
], [
    65,
    107
], [
    107,
    66
], [
    179,
    89
], [
    89,
    180
], [
    180,
    179
], [
    119,
    101
], [
    101,
    120
], [
    120,
    119
], [
    68,
    63
], [
    63,
    104
], [
    104,
    68
], [
    234,
    93
], [
    93,
    227
], [
    227,
    234
], [
    16,
    15
], [
    15,
    85
], [
    85,
    16
], [
    209,
    129
], [
    129,
    49
], [
    49,
    209
], [
    15,
    14
], [
    14,
    86
], [
    86,
    15
], [
    107,
    55
], [
    55,
    9
], [
    9,
    107
], [
    120,
    100
], [
    100,
    121
], [
    121,
    120
], [
    153,
    145
], [
    145,
    22
], [
    22,
    153
], [
    178,
    88
], [
    88,
    179
], [
    179,
    178
], [
    197,
    6
], [
    6,
    196
], [
    196,
    197
], [
    89,
    88
], [
    88,
    96
], [
    96,
    89
], [
    135,
    138
], [
    138,
    136
], [
    136,
    135
], [
    138,
    215
], [
    215,
    172
], [
    172,
    138
], [
    218,
    115
], [
    115,
    219
], [
    219,
    218
], [
    41,
    42
], [
    42,
    81
], [
    81,
    41
], [
    5,
    195
], [
    195,
    51
], [
    51,
    5
], [
    57,
    43
], [
    43,
    61
], [
    61,
    57
], [
    208,
    171
], [
    171,
    199
], [
    199,
    208
], [
    41,
    81
], [
    81,
    38
], [
    38,
    41
], [
    224,
    53
], [
    53,
    225
], [
    225,
    224
], [
    24,
    144
], [
    144,
    110
], [
    110,
    24
], [
    105,
    52
], [
    52,
    66
], [
    66,
    105
], [
    118,
    229
], [
    229,
    117
], [
    117,
    118
], [
    227,
    34
], [
    34,
    234
], [
    234,
    227
], [
    66,
    107
], [
    107,
    69
], [
    69,
    66
], [
    10,
    109
], [
    109,
    151
], [
    151,
    10
], [
    219,
    48
], [
    48,
    235
], [
    235,
    219
], [
    183,
    62
], [
    62,
    191
], [
    191,
    183
], [
    142,
    129
], [
    129,
    126
], [
    126,
    142
], [
    116,
    111
], [
    111,
    143
], [
    143,
    116
], [
    118,
    117
], [
    117,
    50
], [
    50,
    118
], [
    223,
    222
], [
    222,
    52
], [
    52,
    223
], [
    94,
    19
], [
    19,
    141
], [
    141,
    94
], [
    222,
    221
], [
    221,
    65
], [
    65,
    222
], [
    196,
    3
], [
    3,
    197
], [
    197,
    196
], [
    45,
    220
], [
    220,
    44
], [
    44,
    45
], [
    156,
    70
], [
    70,
    139
], [
    139,
    156
], [
    188,
    122
], [
    122,
    245
], [
    245,
    188
], [
    139,
    71
], [
    71,
    162
], [
    162,
    139
], [
    149,
    170
], [
    170,
    150
], [
    150,
    149
], [
    122,
    188
], [
    188,
    196
], [
    196,
    122
], [
    206,
    216
], [
    216,
    92
], [
    92,
    206
], [
    164,
    2
], [
    2,
    167
], [
    167,
    164
], [
    242,
    141
], [
    141,
    241
], [
    241,
    242
], [
    0,
    164
], [
    164,
    37
], [
    37,
    0
], [
    11,
    72
], [
    72,
    12
], [
    12,
    11
], [
    12,
    38
], [
    38,
    13
], [
    13,
    12
], [
    70,
    63
], [
    63,
    71
], [
    71,
    70
], [
    31,
    226
], [
    226,
    111
], [
    111,
    31
], [
    36,
    101
], [
    101,
    205
], [
    205,
    36
], [
    203,
    206
], [
    206,
    165
], [
    165,
    203
], [
    126,
    209
], [
    209,
    217
], [
    217,
    126
], [
    98,
    165
], [
    165,
    97
], [
    97,
    98
], [
    237,
    220
], [
    220,
    218
], [
    218,
    237
], [
    237,
    239
], [
    239,
    241
], [
    241,
    237
], [
    210,
    214
], [
    214,
    169
], [
    169,
    210
], [
    140,
    171
], [
    171,
    32
], [
    32,
    140
], [
    241,
    125
], [
    125,
    237
], [
    237,
    241
], [
    179,
    86
], [
    86,
    178
], [
    178,
    179
], [
    180,
    85
], [
    85,
    179
], [
    179,
    180
], [
    181,
    84
], [
    84,
    180
], [
    180,
    181
], [
    182,
    83
], [
    83,
    181
], [
    181,
    182
], [
    194,
    201
], [
    201,
    182
], [
    182,
    194
], [
    177,
    137
], [
    137,
    132
], [
    132,
    177
], [
    184,
    76
], [
    76,
    183
], [
    183,
    184
], [
    185,
    61
], [
    61,
    184
], [
    184,
    185
], [
    186,
    57
], [
    57,
    185
], [
    185,
    186
], [
    216,
    212
], [
    212,
    186
], [
    186,
    216
], [
    192,
    214
], [
    214,
    187
], [
    187,
    192
], [
    139,
    34
], [
    34,
    156
], [
    156,
    139
], [
    218,
    79
], [
    79,
    237
], [
    237,
    218
], [
    147,
    123
], [
    123,
    177
], [
    177,
    147
], [
    45,
    44
], [
    44,
    4
], [
    4,
    45
], [
    208,
    201
], [
    201,
    32
], [
    32,
    208
], [
    98,
    64
], [
    64,
    129
], [
    129,
    98
], [
    192,
    213
], [
    213,
    138
], [
    138,
    192
], [
    235,
    59
], [
    59,
    219
], [
    219,
    235
], [
    141,
    242
], [
    242,
    97
], [
    97,
    141
], [
    97,
    2
], [
    2,
    141
], [
    141,
    97
], [
    240,
    75
], [
    75,
    235
], [
    235,
    240
], [
    229,
    24
], [
    24,
    228
], [
    228,
    229
], [
    31,
    25
], [
    25,
    226
], [
    226,
    31
], [
    230,
    23
], [
    23,
    229
], [
    229,
    230
], [
    231,
    22
], [
    22,
    230
], [
    230,
    231
], [
    232,
    26
], [
    26,
    231
], [
    231,
    232
], [
    233,
    112
], [
    112,
    232
], [
    232,
    233
], [
    244,
    189
], [
    189,
    243
], [
    243,
    244
], [
    189,
    221
], [
    221,
    190
], [
    190,
    189
], [
    222,
    28
], [
    28,
    221
], [
    221,
    222
], [
    223,
    27
], [
    27,
    222
], [
    222,
    223
], [
    224,
    29
], [
    29,
    223
], [
    223,
    224
], [
    225,
    30
], [
    30,
    224
], [
    224,
    225
], [
    113,
    247
], [
    247,
    225
], [
    225,
    113
], [
    99,
    60
], [
    60,
    240
], [
    240,
    99
], [
    213,
    147
], [
    147,
    215
], [
    215,
    213
], [
    60,
    20
], [
    20,
    166
], [
    166,
    60
], [
    192,
    187
], [
    187,
    213
], [
    213,
    192
], [
    243,
    112
], [
    112,
    244
], [
    244,
    243
], [
    244,
    233
], [
    233,
    245
], [
    245,
    244
], [
    245,
    128
], [
    128,
    188
], [
    188,
    245
], [
    188,
    114
], [
    114,
    174
], [
    174,
    188
], [
    134,
    131
], [
    131,
    220
], [
    220,
    134
], [
    174,
    217
], [
    217,
    236
], [
    236,
    174
], [
    236,
    198
], [
    198,
    134
], [
    134,
    236
], [
    215,
    177
], [
    177,
    58
], [
    58,
    215
], [
    156,
    143
], [
    143,
    124
], [
    124,
    156
], [
    25,
    110
], [
    110,
    7
], [
    7,
    25
], [
    31,
    228
], [
    228,
    25
], [
    25,
    31
], [
    264,
    356
], [
    356,
    368
], [
    368,
    264
], [
    0,
    11
], [
    11,
    267
], [
    267,
    0
], [
    451,
    452
], [
    452,
    349
], [
    349,
    451
], [
    267,
    302
], [
    302,
    269
], [
    269,
    267
], [
    350,
    357
], [
    357,
    277
], [
    277,
    350
], [
    350,
    452
], [
    452,
    357
], [
    357,
    350
], [
    299,
    333
], [
    333,
    297
], [
    297,
    299
], [
    396,
    175
], [
    175,
    377
], [
    377,
    396
], [
    280,
    347
], [
    347,
    330
], [
    330,
    280
], [
    269,
    303
], [
    303,
    270
], [
    270,
    269
], [
    151,
    9
], [
    9,
    337
], [
    337,
    151
], [
    344,
    278
], [
    278,
    360
], [
    360,
    344
], [
    424,
    418
], [
    418,
    431
], [
    431,
    424
], [
    270,
    304
], [
    304,
    409
], [
    409,
    270
], [
    272,
    310
], [
    310,
    407
], [
    407,
    272
], [
    322,
    270
], [
    270,
    410
], [
    410,
    322
], [
    449,
    450
], [
    450,
    347
], [
    347,
    449
], [
    432,
    422
], [
    422,
    434
], [
    434,
    432
], [
    18,
    313
], [
    313,
    17
], [
    17,
    18
], [
    291,
    306
], [
    306,
    375
], [
    375,
    291
], [
    259,
    387
], [
    387,
    260
], [
    260,
    259
], [
    424,
    335
], [
    335,
    418
], [
    418,
    424
], [
    434,
    364
], [
    364,
    416
], [
    416,
    434
], [
    391,
    423
], [
    423,
    327
], [
    327,
    391
], [
    301,
    251
], [
    251,
    298
], [
    298,
    301
], [
    275,
    281
], [
    281,
    4
], [
    4,
    275
], [
    254,
    373
], [
    373,
    253
], [
    253,
    254
], [
    375,
    307
], [
    307,
    321
], [
    321,
    375
], [
    280,
    425
], [
    425,
    411
], [
    411,
    280
], [
    200,
    421
], [
    421,
    18
], [
    18,
    200
], [
    335,
    321
], [
    321,
    406
], [
    406,
    335
], [
    321,
    320
], [
    320,
    405
], [
    405,
    321
], [
    314,
    315
], [
    315,
    17
], [
    17,
    314
], [
    423,
    426
], [
    426,
    266
], [
    266,
    423
], [
    396,
    377
], [
    377,
    369
], [
    369,
    396
], [
    270,
    322
], [
    322,
    269
], [
    269,
    270
], [
    413,
    417
], [
    417,
    464
], [
    464,
    413
], [
    385,
    386
], [
    386,
    258
], [
    258,
    385
], [
    248,
    456
], [
    456,
    419
], [
    419,
    248
], [
    298,
    284
], [
    284,
    333
], [
    333,
    298
], [
    168,
    417
], [
    417,
    8
], [
    8,
    168
], [
    448,
    346
], [
    346,
    261
], [
    261,
    448
], [
    417,
    413
], [
    413,
    285
], [
    285,
    417
], [
    326,
    327
], [
    327,
    328
], [
    328,
    326
], [
    277,
    355
], [
    355,
    329
], [
    329,
    277
], [
    309,
    392
], [
    392,
    438
], [
    438,
    309
], [
    381,
    382
], [
    382,
    256
], [
    256,
    381
], [
    279,
    429
], [
    429,
    360
], [
    360,
    279
], [
    365,
    364
], [
    364,
    379
], [
    379,
    365
], [
    355,
    277
], [
    277,
    437
], [
    437,
    355
], [
    282,
    443
], [
    443,
    283
], [
    283,
    282
], [
    281,
    275
], [
    275,
    363
], [
    363,
    281
], [
    395,
    431
], [
    431,
    369
], [
    369,
    395
], [
    299,
    297
], [
    297,
    337
], [
    337,
    299
], [
    335,
    273
], [
    273,
    321
], [
    321,
    335
], [
    348,
    450
], [
    450,
    349
], [
    349,
    348
], [
    359,
    446
], [
    446,
    467
], [
    467,
    359
], [
    283,
    293
], [
    293,
    282
], [
    282,
    283
], [
    250,
    458
], [
    458,
    462
], [
    462,
    250
], [
    300,
    276
], [
    276,
    383
], [
    383,
    300
], [
    292,
    308
], [
    308,
    325
], [
    325,
    292
], [
    283,
    276
], [
    276,
    293
], [
    293,
    283
], [
    264,
    372
], [
    372,
    447
], [
    447,
    264
], [
    346,
    352
], [
    352,
    340
], [
    340,
    346
], [
    354,
    274
], [
    274,
    19
], [
    19,
    354
], [
    363,
    456
], [
    456,
    281
], [
    281,
    363
], [
    426,
    436
], [
    436,
    425
], [
    425,
    426
], [
    380,
    381
], [
    381,
    252
], [
    252,
    380
], [
    267,
    269
], [
    269,
    393
], [
    393,
    267
], [
    421,
    200
], [
    200,
    428
], [
    428,
    421
], [
    371,
    266
], [
    266,
    329
], [
    329,
    371
], [
    432,
    287
], [
    287,
    422
], [
    422,
    432
], [
    290,
    250
], [
    250,
    328
], [
    328,
    290
], [
    385,
    258
], [
    258,
    384
], [
    384,
    385
], [
    446,
    265
], [
    265,
    342
], [
    342,
    446
], [
    386,
    387
], [
    387,
    257
], [
    257,
    386
], [
    422,
    424
], [
    424,
    430
], [
    430,
    422
], [
    445,
    342
], [
    342,
    276
], [
    276,
    445
], [
    422,
    273
], [
    273,
    424
], [
    424,
    422
], [
    306,
    292
], [
    292,
    307
], [
    307,
    306
], [
    352,
    366
], [
    366,
    345
], [
    345,
    352
], [
    268,
    271
], [
    271,
    302
], [
    302,
    268
], [
    358,
    423
], [
    423,
    371
], [
    371,
    358
], [
    327,
    294
], [
    294,
    460
], [
    460,
    327
], [
    331,
    279
], [
    279,
    294
], [
    294,
    331
], [
    303,
    271
], [
    271,
    304
], [
    304,
    303
], [
    436,
    432
], [
    432,
    427
], [
    427,
    436
], [
    304,
    272
], [
    272,
    408
], [
    408,
    304
], [
    395,
    394
], [
    394,
    431
], [
    431,
    395
], [
    378,
    395
], [
    395,
    400
], [
    400,
    378
], [
    296,
    334
], [
    334,
    299
], [
    299,
    296
], [
    6,
    351
], [
    351,
    168
], [
    168,
    6
], [
    376,
    352
], [
    352,
    411
], [
    411,
    376
], [
    307,
    325
], [
    325,
    320
], [
    320,
    307
], [
    285,
    295
], [
    295,
    336
], [
    336,
    285
], [
    320,
    319
], [
    319,
    404
], [
    404,
    320
], [
    329,
    330
], [
    330,
    349
], [
    349,
    329
], [
    334,
    293
], [
    293,
    333
], [
    333,
    334
], [
    366,
    323
], [
    323,
    447
], [
    447,
    366
], [
    316,
    15
], [
    15,
    315
], [
    315,
    316
], [
    331,
    358
], [
    358,
    279
], [
    279,
    331
], [
    317,
    14
], [
    14,
    316
], [
    316,
    317
], [
    8,
    285
], [
    285,
    9
], [
    9,
    8
], [
    277,
    329
], [
    329,
    350
], [
    350,
    277
], [
    253,
    374
], [
    374,
    252
], [
    252,
    253
], [
    319,
    318
], [
    318,
    403
], [
    403,
    319
], [
    351,
    6
], [
    6,
    419
], [
    419,
    351
], [
    324,
    318
], [
    318,
    325
], [
    325,
    324
], [
    397,
    367
], [
    367,
    365
], [
    365,
    397
], [
    288,
    435
], [
    435,
    397
], [
    397,
    288
], [
    278,
    344
], [
    344,
    439
], [
    439,
    278
], [
    310,
    272
], [
    272,
    311
], [
    311,
    310
], [
    248,
    195
], [
    195,
    281
], [
    281,
    248
], [
    375,
    273
], [
    273,
    291
], [
    291,
    375
], [
    175,
    396
], [
    396,
    199
], [
    199,
    175
], [
    312,
    311
], [
    311,
    268
], [
    268,
    312
], [
    276,
    283
], [
    283,
    445
], [
    445,
    276
], [
    390,
    373
], [
    373,
    339
], [
    339,
    390
], [
    295,
    282
], [
    282,
    296
], [
    296,
    295
], [
    448,
    449
], [
    449,
    346
], [
    346,
    448
], [
    356,
    264
], [
    264,
    454
], [
    454,
    356
], [
    337,
    336
], [
    336,
    299
], [
    299,
    337
], [
    337,
    338
], [
    338,
    151
], [
    151,
    337
], [
    294,
    278
], [
    278,
    455
], [
    455,
    294
], [
    308,
    292
], [
    292,
    415
], [
    415,
    308
], [
    429,
    358
], [
    358,
    355
], [
    355,
    429
], [
    265,
    340
], [
    340,
    372
], [
    372,
    265
], [
    352,
    346
], [
    346,
    280
], [
    280,
    352
], [
    295,
    442
], [
    442,
    282
], [
    282,
    295
], [
    354,
    19
], [
    19,
    370
], [
    370,
    354
], [
    285,
    441
], [
    441,
    295
], [
    295,
    285
], [
    195,
    248
], [
    248,
    197
], [
    197,
    195
], [
    457,
    440
], [
    440,
    274
], [
    274,
    457
], [
    301,
    300
], [
    300,
    368
], [
    368,
    301
], [
    417,
    351
], [
    351,
    465
], [
    465,
    417
], [
    251,
    301
], [
    301,
    389
], [
    389,
    251
], [
    394,
    395
], [
    395,
    379
], [
    379,
    394
], [
    399,
    412
], [
    412,
    419
], [
    419,
    399
], [
    410,
    436
], [
    436,
    322
], [
    322,
    410
], [
    326,
    2
], [
    2,
    393
], [
    393,
    326
], [
    354,
    370
], [
    370,
    461
], [
    461,
    354
], [
    393,
    164
], [
    164,
    267
], [
    267,
    393
], [
    268,
    302
], [
    302,
    12
], [
    12,
    268
], [
    312,
    268
], [
    268,
    13
], [
    13,
    312
], [
    298,
    293
], [
    293,
    301
], [
    301,
    298
], [
    265,
    446
], [
    446,
    340
], [
    340,
    265
], [
    280,
    330
], [
    330,
    425
], [
    425,
    280
], [
    322,
    426
], [
    426,
    391
], [
    391,
    322
], [
    420,
    429
], [
    429,
    437
], [
    437,
    420
], [
    393,
    391
], [
    391,
    326
], [
    326,
    393
], [
    344,
    440
], [
    440,
    438
], [
    438,
    344
], [
    458,
    459
], [
    459,
    461
], [
    461,
    458
], [
    364,
    434
], [
    434,
    394
], [
    394,
    364
], [
    428,
    396
], [
    396,
    262
], [
    262,
    428
], [
    274,
    354
], [
    354,
    457
], [
    457,
    274
], [
    317,
    316
], [
    316,
    402
], [
    402,
    317
], [
    316,
    315
], [
    315,
    403
], [
    403,
    316
], [
    315,
    314
], [
    314,
    404
], [
    404,
    315
], [
    314,
    313
], [
    313,
    405
], [
    405,
    314
], [
    313,
    421
], [
    421,
    406
], [
    406,
    313
], [
    323,
    366
], [
    366,
    361
], [
    361,
    323
], [
    292,
    306
], [
    306,
    407
], [
    407,
    292
], [
    306,
    291
], [
    291,
    408
], [
    408,
    306
], [
    291,
    287
], [
    287,
    409
], [
    409,
    291
], [
    287,
    432
], [
    432,
    410
], [
    410,
    287
], [
    427,
    434
], [
    434,
    411
], [
    411,
    427
], [
    372,
    264
], [
    264,
    383
], [
    383,
    372
], [
    459,
    309
], [
    309,
    457
], [
    457,
    459
], [
    366,
    352
], [
    352,
    401
], [
    401,
    366
], [
    1,
    274
], [
    274,
    4
], [
    4,
    1
], [
    418,
    421
], [
    421,
    262
], [
    262,
    418
], [
    331,
    294
], [
    294,
    358
], [
    358,
    331
], [
    435,
    433
], [
    433,
    367
], [
    367,
    435
], [
    392,
    289
], [
    289,
    439
], [
    439,
    392
], [
    328,
    462
], [
    462,
    326
], [
    326,
    328
], [
    94,
    2
], [
    2,
    370
], [
    370,
    94
], [
    289,
    305
], [
    305,
    455
], [
    455,
    289
], [
    339,
    254
], [
    254,
    448
], [
    448,
    339
], [
    359,
    255
], [
    255,
    446
], [
    446,
    359
], [
    254,
    253
], [
    253,
    449
], [
    449,
    254
], [
    253,
    252
], [
    252,
    450
], [
    450,
    253
], [
    252,
    256
], [
    256,
    451
], [
    451,
    252
], [
    256,
    341
], [
    341,
    452
], [
    452,
    256
], [
    414,
    413
], [
    413,
    463
], [
    463,
    414
], [
    286,
    441
], [
    441,
    414
], [
    414,
    286
], [
    286,
    258
], [
    258,
    441
], [
    441,
    286
], [
    258,
    257
], [
    257,
    442
], [
    442,
    258
], [
    257,
    259
], [
    259,
    443
], [
    443,
    257
], [
    259,
    260
], [
    260,
    444
], [
    444,
    259
], [
    260,
    467
], [
    467,
    445
], [
    445,
    260
], [
    309,
    459
], [
    459,
    250
], [
    250,
    309
], [
    305,
    289
], [
    289,
    290
], [
    290,
    305
], [
    305,
    290
], [
    290,
    460
], [
    460,
    305
], [
    401,
    376
], [
    376,
    435
], [
    435,
    401
], [
    309,
    250
], [
    250,
    392
], [
    392,
    309
], [
    376,
    411
], [
    411,
    433
], [
    433,
    376
], [
    453,
    341
], [
    341,
    464
], [
    464,
    453
], [
    357,
    453
], [
    453,
    465
], [
    465,
    357
], [
    343,
    357
], [
    357,
    412
], [
    412,
    343
], [
    437,
    343
], [
    343,
    399
], [
    399,
    437
], [
    344,
    360
], [
    360,
    440
], [
    440,
    344
], [
    420,
    437
], [
    437,
    456
], [
    456,
    420
], [
    360,
    420
], [
    420,
    363
], [
    363,
    360
], [
    361,
    401
], [
    401,
    288
], [
    288,
    361
], [
    265,
    372
], [
    372,
    353
], [
    353,
    265
], [
    390,
    339
], [
    339,
    249
], [
    249,
    390
], [
    339,
    448
], [
    448,
    255
], [
    255,
    339
]);
function $a2acea4f3420f1d8$var$gc(t) {
    t.l = {
        faceLandmarks: [],
        faceBlendshapes: [],
        facialTransformationMatrixes: []
    };
}
var $a2acea4f3420f1d8$export$9a141f0109a4ba18 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "image_in", "norm_rect", !1), this.l = {
            faceLandmarks: [],
            faceBlendshapes: [],
            facialTransformationMatrixes: []
        }, this.outputFacialTransformationMatrixes = this.outputFaceBlendshapes = !1, $a2acea4f3420f1d8$var$Ir(t = this.h = new $a2acea4f3420f1d8$var$na, 0, 1, e = new $a2acea4f3420f1d8$var$zo), this.B = new $a2acea4f3420f1d8$var$ra, $a2acea4f3420f1d8$var$Ir(this.h, 0, 3, this.B), this.u = new $a2acea4f3420f1d8$var$Zo, $a2acea4f3420f1d8$var$Ir(this.h, 0, 2, this.u), $a2acea4f3420f1d8$var$Ur(this.u, 4, 1), $a2acea4f3420f1d8$var$jr(this.u, 2, .5), $a2acea4f3420f1d8$var$jr(this.B, 2, .5), $a2acea4f3420f1d8$var$jr(this.h, 4, .5);
    }
    C() {
        return "FaceLandmarker";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.h, 0, 1, t);
    }
    v(t) {
        return "numFaces" in t && $a2acea4f3420f1d8$var$Ur(this.u, 4, t.numFaces ?? 1), "minFaceDetectionConfidence" in t && $a2acea4f3420f1d8$var$jr(this.u, 2, t.minFaceDetectionConfidence ?? .5), "minTrackingConfidence" in t && $a2acea4f3420f1d8$var$jr(this.h, 4, t.minTrackingConfidence ?? .5), "minFacePresenceConfidence" in t && $a2acea4f3420f1d8$var$jr(this.B, 2, t.minFacePresenceConfidence ?? .5), "outputFaceBlendshapes" in t && (this.outputFaceBlendshapes = !!t.outputFaceBlendshapes), "outputFacialTransformationMatrixes" in t && (this.outputFacialTransformationMatrixes = !!t.outputFacialTransformationMatrixes), this.j(t);
    }
    G(t, e) {
        return $a2acea4f3420f1d8$var$gc(this), $a2acea4f3420f1d8$var$tc(this, t, e), this.l;
    }
    H(t, e, r) {
        return $a2acea4f3420f1d8$var$gc(this), $a2acea4f3420f1d8$var$ec(this, t, r, e), this.l;
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "image_in"), $a2acea4f3420f1d8$var$po(t, "norm_rect"), $a2acea4f3420f1d8$var$go(t, "face_landmarks");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$sa, this.h);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.face_landmarker.FaceLandmarkerGraph"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:image_in"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect"), $a2acea4f3420f1d8$var$ao(r, "NORM_LANDMARKS:face_landmarks"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), this.g.attachProtoVectorListener("face_landmarks", (t, e)=>{
            for (let e of t)t = $a2acea4f3420f1d8$var$Io(e), this.l.faceLandmarks.push($a2acea4f3420f1d8$var$Qa(t));
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("face_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.outputFaceBlendshapes && ($a2acea4f3420f1d8$var$go(t, "blendshapes"), $a2acea4f3420f1d8$var$ao(r, "BLENDSHAPES:blendshapes"), this.g.attachProtoVectorListener("blendshapes", (t, e)=>{
            if (this.outputFaceBlendshapes) for (let e of t)t = $a2acea4f3420f1d8$var$wo(e), this.l.faceBlendshapes.push($a2acea4f3420f1d8$var$qa(t.g() ?? []));
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("blendshapes", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        })), this.outputFacialTransformationMatrixes && ($a2acea4f3420f1d8$var$go(t, "face_geometry"), $a2acea4f3420f1d8$var$ao(r, "FACE_GEOMETRY:face_geometry"), this.g.attachProtoVectorListener("face_geometry", (t, e)=>{
            if (this.outputFacialTransformationMatrixes) for (let e of t)(t = $a2acea4f3420f1d8$var$Sr(t = $a2acea4f3420f1d8$var$ea(e), $a2acea4f3420f1d8$var$Fo, 2)) && this.l.facialTransformationMatrixes.push({
                rows: $a2acea4f3420f1d8$var$Or(t, 1) ?? 0 ?? 0,
                columns: $a2acea4f3420f1d8$var$Or(t, 2) ?? 0 ?? 0,
                data: $a2acea4f3420f1d8$var$lr(t, 3, $a2acea4f3420f1d8$var$Jt, $a2acea4f3420f1d8$var$cr()).slice() ?? []
            });
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("face_geometry", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        })), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$9a141f0109a4ba18.prototype.detectForVideo = $a2acea4f3420f1d8$export$9a141f0109a4ba18.prototype.H, $a2acea4f3420f1d8$export$9a141f0109a4ba18.prototype.detect = $a2acea4f3420f1d8$export$9a141f0109a4ba18.prototype.G, $a2acea4f3420f1d8$export$9a141f0109a4ba18.prototype.setOptions = $a2acea4f3420f1d8$export$9a141f0109a4ba18.prototype.v, $a2acea4f3420f1d8$export$9a141f0109a4ba18.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$9a141f0109a4ba18, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$9a141f0109a4ba18.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$9a141f0109a4ba18, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$9a141f0109a4ba18.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$9a141f0109a4ba18, t, e);
}, $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_LIPS = $a2acea4f3420f1d8$var$sc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_LIPS", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_LIPS), $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_EYE = $a2acea4f3420f1d8$var$oc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_LEFT_EYE", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_EYE), $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_EYEBROW = $a2acea4f3420f1d8$var$ac, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_LEFT_EYEBROW", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_EYEBROW), $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_IRIS = $a2acea4f3420f1d8$var$hc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_LEFT_IRIS", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_LEFT_IRIS), $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_EYE = $a2acea4f3420f1d8$var$uc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_RIGHT_EYE", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_EYE), $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_EYEBROW = $a2acea4f3420f1d8$var$cc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_RIGHT_EYEBROW", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_EYEBROW), $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_IRIS = $a2acea4f3420f1d8$var$lc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_RIGHT_IRIS", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_RIGHT_IRIS), $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_FACE_OVAL = $a2acea4f3420f1d8$var$dc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_FACE_OVAL", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_FACE_OVAL), $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_CONTOURS = $a2acea4f3420f1d8$var$fc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_CONTOURS", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_CONTOURS), $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_TESSELATION = $a2acea4f3420f1d8$var$pc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$face_landmarker$face_landmarker.FaceLandmarker.FACE_LANDMARKS_TESSELATION", $a2acea4f3420f1d8$export$9a141f0109a4ba18.FACE_LANDMARKS_TESSELATION);
var $a2acea4f3420f1d8$var$vc = $a2acea4f3420f1d8$var$zu([
    0,
    1
], [
    1,
    2
], [
    2,
    3
], [
    3,
    4
], [
    0,
    5
], [
    5,
    6
], [
    6,
    7
], [
    7,
    8
], [
    5,
    9
], [
    9,
    10
], [
    10,
    11
], [
    11,
    12
], [
    9,
    13
], [
    13,
    14
], [
    14,
    15
], [
    15,
    16
], [
    13,
    17
], [
    0,
    17
], [
    17,
    18
], [
    18,
    19
], [
    19,
    20
]);
function $a2acea4f3420f1d8$var$_c(t) {
    t.gestures = [], t.landmarks = [], t.worldLandmarks = [], t.handedness = [];
}
function $a2acea4f3420f1d8$var$yc(t) {
    return 0 === t.gestures.length ? {
        gestures: [],
        landmarks: [],
        worldLandmarks: [],
        handedness: [],
        handednesses: []
    } : {
        gestures: t.gestures,
        landmarks: t.landmarks,
        worldLandmarks: t.worldLandmarks,
        handedness: t.handedness,
        handednesses: t.handedness
    };
}
function $a2acea4f3420f1d8$var$Ec(t, e = !0) {
    var r = [];
    for (let i of t){
        var n = $a2acea4f3420f1d8$var$wo(i);
        t = [];
        for (let r of n.g())n = e && null != $a2acea4f3420f1d8$var$Or(r, 1) ? $a2acea4f3420f1d8$var$Or(r, 1) ?? 0 : -1, t.push({
            score: $a2acea4f3420f1d8$var$Dr(r, 2) ?? 0,
            index: n,
            categoryName: $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(r, 3)) ?? "" ?? "",
            displayName: $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(r, 4)) ?? "" ?? ""
        });
        r.push(t);
    }
    return r;
}
var $a2acea4f3420f1d8$export$e1bdb836a8013647 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "image_in", "norm_rect", !1), this.gestures = [], this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $a2acea4f3420f1d8$var$Ir(t = this.l = new $a2acea4f3420f1d8$var$da, 0, 1, e = new $a2acea4f3420f1d8$var$zo), this.u = new $a2acea4f3420f1d8$var$la, $a2acea4f3420f1d8$var$Ir(this.l, 0, 2, this.u), this.F = new $a2acea4f3420f1d8$var$ca, $a2acea4f3420f1d8$var$Ir(this.u, 0, 3, this.F), this.B = new $a2acea4f3420f1d8$var$ua, $a2acea4f3420f1d8$var$Ir(this.u, 0, 2, this.B), this.h = new $a2acea4f3420f1d8$var$ha, $a2acea4f3420f1d8$var$Ir(this.l, 0, 3, this.h), $a2acea4f3420f1d8$var$jr(this.B, 2, .5), $a2acea4f3420f1d8$var$jr(this.u, 4, .5), $a2acea4f3420f1d8$var$jr(this.F, 2, .5);
    }
    C() {
        return "GestureRecognizer";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.l, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.l, 0, 1, t);
    }
    v(t) {
        if ($a2acea4f3420f1d8$var$Ur(this.B, 3, t.numHands ?? 1), "minHandDetectionConfidence" in t && $a2acea4f3420f1d8$var$jr(this.B, 2, t.minHandDetectionConfidence ?? .5), "minTrackingConfidence" in t && $a2acea4f3420f1d8$var$jr(this.u, 4, t.minTrackingConfidence ?? .5), "minHandPresenceConfidence" in t && $a2acea4f3420f1d8$var$jr(this.F, 2, t.minHandPresenceConfidence ?? .5), t.cannedGesturesClassifierOptions) {
            var e = new $a2acea4f3420f1d8$var$oa, r = e, n = $a2acea4f3420f1d8$var$za(t.cannedGesturesClassifierOptions, $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$oa, 3)?.j());
            $a2acea4f3420f1d8$var$Ir(r, 0, 2, n), $a2acea4f3420f1d8$var$Ir(this.h, 0, 3, e);
        } else void 0 === t.cannedGesturesClassifierOptions && $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$oa, 3)?.g();
        return t.customGesturesClassifierOptions ? ($a2acea4f3420f1d8$var$Ir(r = e = new $a2acea4f3420f1d8$var$oa, 0, 2, n = $a2acea4f3420f1d8$var$za(t.customGesturesClassifierOptions, $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$oa, 4)?.j())), $a2acea4f3420f1d8$var$Ir(this.h, 0, 4, e)) : void 0 === t.customGesturesClassifierOptions && $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$oa, 4)?.g(), this.j(t);
    }
    Xa(t, e) {
        return $a2acea4f3420f1d8$var$_c(this), $a2acea4f3420f1d8$var$tc(this, t, e), $a2acea4f3420f1d8$var$yc(this);
    }
    Ya(t, e, r) {
        return $a2acea4f3420f1d8$var$_c(this), $a2acea4f3420f1d8$var$ec(this, t, r, e), $a2acea4f3420f1d8$var$yc(this);
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "image_in"), $a2acea4f3420f1d8$var$po(t, "norm_rect"), $a2acea4f3420f1d8$var$go(t, "hand_gestures"), $a2acea4f3420f1d8$var$go(t, "hand_landmarks"), $a2acea4f3420f1d8$var$go(t, "world_hand_landmarks"), $a2acea4f3420f1d8$var$go(t, "handedness");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$va, this.l);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.gesture_recognizer.GestureRecognizerGraph"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:image_in"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect"), $a2acea4f3420f1d8$var$ao(r, "HAND_GESTURES:hand_gestures"), $a2acea4f3420f1d8$var$ao(r, "LANDMARKS:hand_landmarks"), $a2acea4f3420f1d8$var$ao(r, "WORLD_LANDMARKS:world_hand_landmarks"), $a2acea4f3420f1d8$var$ao(r, "HANDEDNESS:handedness"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), this.g.attachProtoVectorListener("hand_landmarks", (t, e)=>{
            for (let e of t){
                t = $a2acea4f3420f1d8$var$Io(e);
                let r = [];
                for (let e of $a2acea4f3420f1d8$var$xr(t, $a2acea4f3420f1d8$var$Ro, 1))r.push({
                    x: $a2acea4f3420f1d8$var$Dr(e, 1) ?? 0,
                    y: $a2acea4f3420f1d8$var$Dr(e, 2) ?? 0,
                    z: $a2acea4f3420f1d8$var$Dr(e, 3) ?? 0,
                    visibility: $a2acea4f3420f1d8$var$Dr(e, 4) ?? 0
                });
                this.landmarks.push(r);
            }
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("hand_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoVectorListener("world_hand_landmarks", (t, e)=>{
            for (let e of t){
                t = $a2acea4f3420f1d8$var$xo(e);
                let r = [];
                for (let e of $a2acea4f3420f1d8$var$xr(t, $a2acea4f3420f1d8$var$Lo, 1))r.push({
                    x: $a2acea4f3420f1d8$var$Dr(e, 1) ?? 0,
                    y: $a2acea4f3420f1d8$var$Dr(e, 2) ?? 0,
                    z: $a2acea4f3420f1d8$var$Dr(e, 3) ?? 0,
                    visibility: $a2acea4f3420f1d8$var$Dr(e, 4) ?? 0
                });
                this.worldLandmarks.push(r);
            }
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("world_hand_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoVectorListener("hand_gestures", (t, e)=>{
            this.gestures.push(...$a2acea4f3420f1d8$var$Ec(t, !1)), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("hand_gestures", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoVectorListener("handedness", (t, e)=>{
            this.handedness.push(...$a2acea4f3420f1d8$var$Ec(t)), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("handedness", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
function $a2acea4f3420f1d8$var$wc(t) {
    return {
        landmarks: t.landmarks,
        worldLandmarks: t.worldLandmarks,
        handednesses: t.handedness,
        handedness: t.handedness
    };
}
$a2acea4f3420f1d8$export$e1bdb836a8013647.prototype.recognizeForVideo = $a2acea4f3420f1d8$export$e1bdb836a8013647.prototype.Ya, $a2acea4f3420f1d8$export$e1bdb836a8013647.prototype.recognize = $a2acea4f3420f1d8$export$e1bdb836a8013647.prototype.Xa, $a2acea4f3420f1d8$export$e1bdb836a8013647.prototype.setOptions = $a2acea4f3420f1d8$export$e1bdb836a8013647.prototype.v, $a2acea4f3420f1d8$export$e1bdb836a8013647.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$e1bdb836a8013647, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$e1bdb836a8013647.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$e1bdb836a8013647, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$e1bdb836a8013647.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$e1bdb836a8013647, t, e);
}, $a2acea4f3420f1d8$export$e1bdb836a8013647.HAND_CONNECTIONS = $a2acea4f3420f1d8$var$vc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$gesture_recognizer$gesture_recognizer.GestureRecognizer.HAND_CONNECTIONS", $a2acea4f3420f1d8$export$e1bdb836a8013647.HAND_CONNECTIONS);
var $a2acea4f3420f1d8$export$d2c56c12d54a59a1 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "image_in", "norm_rect", !1), this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $a2acea4f3420f1d8$var$Ir(t = this.h = new $a2acea4f3420f1d8$var$la, 0, 1, e = new $a2acea4f3420f1d8$var$zo), this.u = new $a2acea4f3420f1d8$var$ca, $a2acea4f3420f1d8$var$Ir(this.h, 0, 3, this.u), this.l = new $a2acea4f3420f1d8$var$ua, $a2acea4f3420f1d8$var$Ir(this.h, 0, 2, this.l), $a2acea4f3420f1d8$var$Ur(this.l, 3, 1), $a2acea4f3420f1d8$var$jr(this.l, 2, .5), $a2acea4f3420f1d8$var$jr(this.u, 2, .5), $a2acea4f3420f1d8$var$jr(this.h, 4, .5);
    }
    C() {
        return "HandLandmarker";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.h, 0, 1, t);
    }
    v(t) {
        return "numHands" in t && $a2acea4f3420f1d8$var$Ur(this.l, 3, t.numHands ?? 1), "minHandDetectionConfidence" in t && $a2acea4f3420f1d8$var$jr(this.l, 2, t.minHandDetectionConfidence ?? .5), "minTrackingConfidence" in t && $a2acea4f3420f1d8$var$jr(this.h, 4, t.minTrackingConfidence ?? .5), "minHandPresenceConfidence" in t && $a2acea4f3420f1d8$var$jr(this.u, 2, t.minHandPresenceConfidence ?? .5), this.j(t);
    }
    G(t, e) {
        return this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $a2acea4f3420f1d8$var$tc(this, t, e), $a2acea4f3420f1d8$var$wc(this);
    }
    H(t, e, r) {
        return this.landmarks = [], this.worldLandmarks = [], this.handedness = [], $a2acea4f3420f1d8$var$ec(this, t, r, e), $a2acea4f3420f1d8$var$wc(this);
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "image_in"), $a2acea4f3420f1d8$var$po(t, "norm_rect"), $a2acea4f3420f1d8$var$go(t, "hand_landmarks"), $a2acea4f3420f1d8$var$go(t, "world_hand_landmarks"), $a2acea4f3420f1d8$var$go(t, "handedness");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$_a, this.h);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.hand_landmarker.HandLandmarkerGraph"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:image_in"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect"), $a2acea4f3420f1d8$var$ao(r, "LANDMARKS:hand_landmarks"), $a2acea4f3420f1d8$var$ao(r, "WORLD_LANDMARKS:world_hand_landmarks"), $a2acea4f3420f1d8$var$ao(r, "HANDEDNESS:handedness"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), this.g.attachProtoVectorListener("hand_landmarks", (t, e)=>{
            for (let e of t)t = $a2acea4f3420f1d8$var$Io(e), this.landmarks.push($a2acea4f3420f1d8$var$Qa(t));
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("hand_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoVectorListener("world_hand_landmarks", (t, e)=>{
            for (let e of t)t = $a2acea4f3420f1d8$var$xo(e), this.worldLandmarks.push($a2acea4f3420f1d8$var$th(t));
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("world_hand_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoVectorListener("handedness", (t, e)=>{
            var r = this.handedness, n = r.push, i = [];
            for (let e of t){
                t = $a2acea4f3420f1d8$var$wo(e);
                let r = [];
                for (let e of t.g())r.push({
                    score: $a2acea4f3420f1d8$var$Dr(e, 2) ?? 0,
                    index: $a2acea4f3420f1d8$var$Or(e, 1) ?? 0 ?? -1,
                    categoryName: $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(e, 3)) ?? "" ?? "",
                    displayName: $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(e, 4)) ?? "" ?? ""
                });
                i.push(r);
            }
            n.call(r, ...i), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("handedness", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$d2c56c12d54a59a1.prototype.detectForVideo = $a2acea4f3420f1d8$export$d2c56c12d54a59a1.prototype.H, $a2acea4f3420f1d8$export$d2c56c12d54a59a1.prototype.detect = $a2acea4f3420f1d8$export$d2c56c12d54a59a1.prototype.G, $a2acea4f3420f1d8$export$d2c56c12d54a59a1.prototype.setOptions = $a2acea4f3420f1d8$export$d2c56c12d54a59a1.prototype.v, $a2acea4f3420f1d8$export$d2c56c12d54a59a1.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$d2c56c12d54a59a1, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$d2c56c12d54a59a1.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$d2c56c12d54a59a1, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$d2c56c12d54a59a1.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$d2c56c12d54a59a1, t, e);
}, $a2acea4f3420f1d8$export$d2c56c12d54a59a1.HAND_CONNECTIONS = $a2acea4f3420f1d8$var$vc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$hand_landmarker$hand_landmarker.HandLandmarker.HAND_CONNECTIONS", $a2acea4f3420f1d8$export$d2c56c12d54a59a1.HAND_CONNECTIONS);
var $a2acea4f3420f1d8$var$Tc = $a2acea4f3420f1d8$var$zu([
    0,
    1
], [
    1,
    2
], [
    2,
    3
], [
    3,
    7
], [
    0,
    4
], [
    4,
    5
], [
    5,
    6
], [
    6,
    8
], [
    9,
    10
], [
    11,
    12
], [
    11,
    13
], [
    13,
    15
], [
    15,
    17
], [
    15,
    19
], [
    15,
    21
], [
    17,
    19
], [
    12,
    14
], [
    14,
    16
], [
    16,
    18
], [
    16,
    20
], [
    16,
    22
], [
    18,
    20
], [
    11,
    23
], [
    12,
    24
], [
    23,
    24
], [
    23,
    25
], [
    24,
    26
], [
    25,
    27
], [
    26,
    28
], [
    27,
    29
], [
    28,
    30
], [
    29,
    31
], [
    30,
    32
], [
    27,
    31
], [
    28,
    32
]);
function $a2acea4f3420f1d8$var$kc(t) {
    t.h = {
        faceLandmarks: [],
        faceBlendshapes: [],
        poseLandmarks: [],
        poseWorldLandmarks: [],
        poseSegmentationMasks: [],
        leftHandLandmarks: [],
        leftHandWorldLandmarks: [],
        rightHandLandmarks: [],
        rightHandWorldLandmarks: []
    };
}
function $a2acea4f3420f1d8$var$Sc(t) {
    try {
        if (!t.F) return t.h;
        t.F(t.h);
    } finally{
        $a2acea4f3420f1d8$var$nu(t);
    }
}
function $a2acea4f3420f1d8$var$Lc(t, e) {
    t = $a2acea4f3420f1d8$var$Io(t), e.push($a2acea4f3420f1d8$var$Qa(t));
}
var $a2acea4f3420f1d8$export$6911d649b097b693 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "input_frames_image", null, !1), this.h = {
            faceLandmarks: [],
            faceBlendshapes: [],
            poseLandmarks: [],
            poseWorldLandmarks: [],
            poseSegmentationMasks: [],
            leftHandLandmarks: [],
            leftHandWorldLandmarks: [],
            rightHandLandmarks: [],
            rightHandWorldLandmarks: []
        }, this.outputPoseSegmentationMasks = this.outputFaceBlendshapes = !1, $a2acea4f3420f1d8$var$Ir(t = this.l = new $a2acea4f3420f1d8$var$wa, 0, 1, e = new $a2acea4f3420f1d8$var$zo), this.Y = new $a2acea4f3420f1d8$var$ca, $a2acea4f3420f1d8$var$Ir(this.l, 0, 2, this.Y), this.Aa = new $a2acea4f3420f1d8$var$ya, $a2acea4f3420f1d8$var$Ir(this.l, 0, 3, this.Aa), this.u = new $a2acea4f3420f1d8$var$Zo, $a2acea4f3420f1d8$var$Ir(this.l, 0, 4, this.u), this.O = new $a2acea4f3420f1d8$var$ra, $a2acea4f3420f1d8$var$Ir(this.l, 0, 5, this.O), this.B = new $a2acea4f3420f1d8$var$Ea, $a2acea4f3420f1d8$var$Ir(this.l, 0, 6, this.B), this.Z = new $a2acea4f3420f1d8$var$Aa, $a2acea4f3420f1d8$var$Ir(this.l, 0, 7, this.Z), $a2acea4f3420f1d8$var$jr(this.u, 2, .5), $a2acea4f3420f1d8$var$jr(this.u, 3, .3), $a2acea4f3420f1d8$var$jr(this.O, 2, .5), $a2acea4f3420f1d8$var$jr(this.B, 2, .5), $a2acea4f3420f1d8$var$jr(this.B, 3, .3), $a2acea4f3420f1d8$var$jr(this.Z, 2, .5), $a2acea4f3420f1d8$var$jr(this.Y, 2, .5);
    }
    C() {
        return "HolisticLandmarker";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.l, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.l, 0, 1, t);
    }
    v(t) {
        return "minFaceDetectionConfidence" in t && $a2acea4f3420f1d8$var$jr(this.u, 2, t.minFaceDetectionConfidence ?? .5), "minFaceSuppressionThreshold" in t && $a2acea4f3420f1d8$var$jr(this.u, 3, t.minFaceSuppressionThreshold ?? .3), "minFacePresenceConfidence" in t && $a2acea4f3420f1d8$var$jr(this.O, 2, t.minFacePresenceConfidence ?? .5), "outputFaceBlendshapes" in t && (this.outputFaceBlendshapes = !!t.outputFaceBlendshapes), "minPoseDetectionConfidence" in t && $a2acea4f3420f1d8$var$jr(this.B, 2, t.minPoseDetectionConfidence ?? .5), "minPoseSuppressionThreshold" in t && $a2acea4f3420f1d8$var$jr(this.B, 3, t.minPoseSuppressionThreshold ?? .3), "minPosePresenceConfidence" in t && $a2acea4f3420f1d8$var$jr(this.Z, 2, t.minPosePresenceConfidence ?? .5), "outputPoseSegmentationMasks" in t && (this.outputPoseSegmentationMasks = !!t.outputPoseSegmentationMasks), "minHandLandmarksConfidence" in t && $a2acea4f3420f1d8$var$jr(this.Y, 2, t.minHandLandmarksConfidence ?? .5), this.j(t);
    }
    G(t, e, r) {
        var n = "function" != typeof e ? e : {};
        return this.F = "function" == typeof e ? e : r, $a2acea4f3420f1d8$var$kc(this), $a2acea4f3420f1d8$var$tc(this, t, n), $a2acea4f3420f1d8$var$Sc(this);
    }
    H(t, e, r, n) {
        var i = "function" != typeof r ? r : {};
        return this.F = "function" == typeof r ? r : n, $a2acea4f3420f1d8$var$kc(this), $a2acea4f3420f1d8$var$ec(this, t, i, e), $a2acea4f3420f1d8$var$Sc(this);
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "input_frames_image"), $a2acea4f3420f1d8$var$go(t, "pose_landmarks"), $a2acea4f3420f1d8$var$go(t, "pose_world_landmarks"), $a2acea4f3420f1d8$var$go(t, "face_landmarks"), $a2acea4f3420f1d8$var$go(t, "left_hand_landmarks"), $a2acea4f3420f1d8$var$go(t, "left_hand_world_landmarks"), $a2acea4f3420f1d8$var$go(t, "right_hand_landmarks"), $a2acea4f3420f1d8$var$go(t, "right_hand_world_landmarks");
        var e = new $a2acea4f3420f1d8$var$no, r = new $a2acea4f3420f1d8$var$Bs;
        $a2acea4f3420f1d8$var$Hr(r, 1, "type.googleapis.com/mediapipe.tasks.vision.holistic_landmarker.proto.HolisticLandmarkerGraphOptions"), function(t, e) {
            if (null != e) {
                if (Array.isArray(e)) $a2acea4f3420f1d8$var$ar(t, 2, $a2acea4f3420f1d8$var$Ge(e, 0, $a2acea4f3420f1d8$var$Ve));
                else {
                    if (!("string" == typeof e || e instanceof $a2acea4f3420f1d8$var$N || $a2acea4f3420f1d8$var$x(e))) throw Error("invalid value in Any.value field: " + e + " expected a ByteString, a base64 encoded string, a Uint8Array or a jspb array");
                    $a2acea4f3420f1d8$var$_r(t, 2, $a2acea4f3420f1d8$var$ct(e, !1), $a2acea4f3420f1d8$var$I());
                }
            }
        }(r, this.l.g());
        var n = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(n, 2, "mediapipe.tasks.vision.holistic_landmarker.HolisticLandmarkerGraph"), $a2acea4f3420f1d8$var$Mr(n, 8, $a2acea4f3420f1d8$var$Bs, r), $a2acea4f3420f1d8$var$oo(n, "IMAGE:input_frames_image"), $a2acea4f3420f1d8$var$ao(n, "POSE_LANDMARKS:pose_landmarks"), $a2acea4f3420f1d8$var$ao(n, "POSE_WORLD_LANDMARKS:pose_world_landmarks"), $a2acea4f3420f1d8$var$ao(n, "FACE_LANDMARKS:face_landmarks"), $a2acea4f3420f1d8$var$ao(n, "LEFT_HAND_LANDMARKS:left_hand_landmarks"), $a2acea4f3420f1d8$var$ao(n, "LEFT_HAND_WORLD_LANDMARKS:left_hand_world_landmarks"), $a2acea4f3420f1d8$var$ao(n, "RIGHT_HAND_LANDMARKS:right_hand_landmarks"), $a2acea4f3420f1d8$var$ao(n, "RIGHT_HAND_WORLD_LANDMARKS:right_hand_world_landmarks"), n.v(e), $a2acea4f3420f1d8$var$fo(t, n), $a2acea4f3420f1d8$var$eu(this, t), this.g.attachProtoListener("pose_landmarks", (t, e)=>{
            $a2acea4f3420f1d8$var$Lc(t, this.h.poseLandmarks), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("pose_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoListener("pose_world_landmarks", (t, e)=>{
            var r = this.h.poseWorldLandmarks;
            t = $a2acea4f3420f1d8$var$xo(t), r.push($a2acea4f3420f1d8$var$th(t)), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("pose_world_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.outputPoseSegmentationMasks && ($a2acea4f3420f1d8$var$ao(n, "POSE_SEGMENTATION_MASK:pose_segmentation_mask"), $a2acea4f3420f1d8$var$ru(this, "pose_segmentation_mask"), this.g.ga("pose_segmentation_mask", (t, e)=>{
            this.h.poseSegmentationMasks = [
                $a2acea4f3420f1d8$var$rc(this, t, !0, !this.F)
            ], $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("pose_segmentation_mask", (t)=>{
            this.h.poseSegmentationMasks = [], $a2acea4f3420f1d8$var$tu(this, t);
        })), this.g.attachProtoListener("face_landmarks", (t, e)=>{
            $a2acea4f3420f1d8$var$Lc(t, this.h.faceLandmarks), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("face_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.outputFaceBlendshapes && ($a2acea4f3420f1d8$var$go(t, "extra_blendshapes"), $a2acea4f3420f1d8$var$ao(n, "FACE_BLENDSHAPES:extra_blendshapes"), this.g.attachProtoListener("extra_blendshapes", (t, e)=>{
            var r = this.h.faceBlendshapes;
            this.outputFaceBlendshapes && (t = $a2acea4f3420f1d8$var$wo(t), r.push($a2acea4f3420f1d8$var$qa(t.g() ?? []))), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("extra_blendshapes", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        })), this.g.attachProtoListener("left_hand_landmarks", (t, e)=>{
            $a2acea4f3420f1d8$var$Lc(t, this.h.leftHandLandmarks), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("left_hand_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoListener("left_hand_world_landmarks", (t, e)=>{
            var r = this.h.leftHandWorldLandmarks;
            t = $a2acea4f3420f1d8$var$xo(t), r.push($a2acea4f3420f1d8$var$th(t)), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("left_hand_world_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoListener("right_hand_landmarks", (t, e)=>{
            $a2acea4f3420f1d8$var$Lc(t, this.h.rightHandLandmarks), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("right_hand_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoListener("right_hand_world_landmarks", (t, e)=>{
            var r = this.h.rightHandWorldLandmarks;
            t = $a2acea4f3420f1d8$var$xo(t), r.push($a2acea4f3420f1d8$var$th(t)), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("right_hand_world_landmarks", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$6911d649b097b693.prototype.detectForVideo = $a2acea4f3420f1d8$export$6911d649b097b693.prototype.H, $a2acea4f3420f1d8$export$6911d649b097b693.prototype.detect = $a2acea4f3420f1d8$export$6911d649b097b693.prototype.G, $a2acea4f3420f1d8$export$6911d649b097b693.prototype.setOptions = $a2acea4f3420f1d8$export$6911d649b097b693.prototype.v, $a2acea4f3420f1d8$export$6911d649b097b693.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$6911d649b097b693, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$6911d649b097b693.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$6911d649b097b693, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$6911d649b097b693.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$6911d649b097b693, t, e);
}, $a2acea4f3420f1d8$export$6911d649b097b693.HAND_CONNECTIONS = $a2acea4f3420f1d8$var$vc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.HAND_CONNECTIONS", $a2acea4f3420f1d8$export$6911d649b097b693.HAND_CONNECTIONS), $a2acea4f3420f1d8$export$6911d649b097b693.POSE_CONNECTIONS = $a2acea4f3420f1d8$var$Tc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.POSE_CONNECTIONS", $a2acea4f3420f1d8$export$6911d649b097b693.POSE_CONNECTIONS), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_LIPS = $a2acea4f3420f1d8$var$sc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_LIPS", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_LIPS), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_LEFT_EYE = $a2acea4f3420f1d8$var$oc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_LEFT_EYE", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_LEFT_EYE), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_LEFT_EYEBROW = $a2acea4f3420f1d8$var$ac, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_LEFT_EYEBROW", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_LEFT_EYEBROW), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_LEFT_IRIS = $a2acea4f3420f1d8$var$hc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_LEFT_IRIS", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_LEFT_IRIS), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_RIGHT_EYE = $a2acea4f3420f1d8$var$uc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_RIGHT_EYE", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_RIGHT_EYE), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_RIGHT_EYEBROW = $a2acea4f3420f1d8$var$cc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_RIGHT_EYEBROW", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_RIGHT_EYEBROW), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_RIGHT_IRIS = $a2acea4f3420f1d8$var$lc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_RIGHT_IRIS", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_RIGHT_IRIS), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_FACE_OVAL = $a2acea4f3420f1d8$var$dc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_FACE_OVAL", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_FACE_OVAL), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_CONTOURS = $a2acea4f3420f1d8$var$fc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_CONTOURS", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_CONTOURS), $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_TESSELATION = $a2acea4f3420f1d8$var$pc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$holistic_landmarker$holistic_landmarker.HolisticLandmarker.FACE_LANDMARKS_TESSELATION", $a2acea4f3420f1d8$export$6911d649b097b693.FACE_LANDMARKS_TESSELATION);
var $a2acea4f3420f1d8$export$af0b5c7f41d90214 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "input_image", "norm_rect", !0), this.l = {
            classifications: []
        }, $a2acea4f3420f1d8$var$Ir(t = this.h = new $a2acea4f3420f1d8$var$ka, 0, 1, e = new $a2acea4f3420f1d8$var$zo);
    }
    C() {
        return "ImageClassifier";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.h, 0, 1, t);
    }
    v(t) {
        return $a2acea4f3420f1d8$var$Ir(this.h, 0, 2, $a2acea4f3420f1d8$var$za(t, $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$Go, 2))), this.j(t);
    }
    Ga(t, e) {
        return this.l = {
            classifications: []
        }, $a2acea4f3420f1d8$var$tc(this, t, e), this.l;
    }
    Ha(t, e, r) {
        return this.l = {
            classifications: []
        }, $a2acea4f3420f1d8$var$ec(this, t, r, e), this.l;
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "input_image"), $a2acea4f3420f1d8$var$po(t, "norm_rect"), $a2acea4f3420f1d8$var$go(t, "classifications");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$Sa, this.h);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.image_classifier.ImageClassifierGraph"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:input_image"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect"), $a2acea4f3420f1d8$var$ao(r, "CLASSIFICATIONS:classifications"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), this.g.attachProtoListener("classifications", (t, e)=>{
            this.l = $a2acea4f3420f1d8$var$Ja($a2acea4f3420f1d8$var$Oo(t)), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("classifications", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$af0b5c7f41d90214.prototype.classifyForVideo = $a2acea4f3420f1d8$export$af0b5c7f41d90214.prototype.Ha, $a2acea4f3420f1d8$export$af0b5c7f41d90214.prototype.classify = $a2acea4f3420f1d8$export$af0b5c7f41d90214.prototype.Ga, $a2acea4f3420f1d8$export$af0b5c7f41d90214.prototype.setOptions = $a2acea4f3420f1d8$export$af0b5c7f41d90214.prototype.v, $a2acea4f3420f1d8$export$af0b5c7f41d90214.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$af0b5c7f41d90214, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$af0b5c7f41d90214.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$af0b5c7f41d90214, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$af0b5c7f41d90214.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$af0b5c7f41d90214, t, e);
};
var $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "image_in", "norm_rect", !0), this.h = new $a2acea4f3420f1d8$var$La, this.embeddings = {
            embeddings: []
        }, $a2acea4f3420f1d8$var$Ir(t = this.h, 0, 1, e = new $a2acea4f3420f1d8$var$zo);
    }
    C() {
        return "ImageEmbedder";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.h, 0, 1, t);
    }
    v(t) {
        var e = this.h, r = $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$Vo, 2);
        if (r = r ? r.clone() : new $a2acea4f3420f1d8$var$Vo, void 0 !== t.l2Normalize) {
            var n = t.l2Normalize;
            $a2acea4f3420f1d8$var$ar(r, 1, null == n ? n : $a2acea4f3420f1d8$var$Zt(n));
        } else "l2Normalize" in t && $a2acea4f3420f1d8$var$ar(r, 1);
        return void 0 !== t.quantize ? $a2acea4f3420f1d8$var$ar(r, 2, null == (n = t.quantize) ? n : $a2acea4f3420f1d8$var$Zt(n)) : "quantize" in t && $a2acea4f3420f1d8$var$ar(r, 2), $a2acea4f3420f1d8$var$Ir(e, 0, 2, r), this.j(t);
    }
    Na(t, e) {
        return $a2acea4f3420f1d8$var$tc(this, t, e), this.embeddings;
    }
    Oa(t, e, r) {
        return $a2acea4f3420f1d8$var$ec(this, t, r, e), this.embeddings;
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "image_in"), $a2acea4f3420f1d8$var$po(t, "norm_rect"), $a2acea4f3420f1d8$var$go(t, "embeddings_out");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$xa, this.h);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.image_embedder.ImageEmbedderGraph"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:image_in"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect"), $a2acea4f3420f1d8$var$ao(r, "EMBEDDINGS:embeddings_out"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), this.g.attachProtoListener("embeddings_out", (t, e)=>{
            t = $a2acea4f3420f1d8$var$Bo(t), this.embeddings = function(t) {
                return {
                    embeddings: $a2acea4f3420f1d8$var$xr(t, $a2acea4f3420f1d8$var$$o, 1).map((t)=>{
                        var e = {
                            headIndex: $a2acea4f3420f1d8$var$Or(t, 3) ?? 0 ?? -1,
                            headName: $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(t, 4)) ?? "" ?? ""
                        };
                        if ($a2acea4f3420f1d8$var$ur(t, $a2acea4f3420f1d8$var$Do, 1, $a2acea4f3420f1d8$var$Uo)) t = $a2acea4f3420f1d8$var$lr(t = $a2acea4f3420f1d8$var$Pr(t, $a2acea4f3420f1d8$var$Do, 1), 1, $a2acea4f3420f1d8$var$Jt, $a2acea4f3420f1d8$var$cr()), e.floatEmbedding = t.slice();
                        else {
                            let r = new Uint8Array(0);
                            e.quantizedEmbedding = $a2acea4f3420f1d8$var$Pr(t, $a2acea4f3420f1d8$var$Po, 2)?.g()?.h() ?? r;
                        }
                        return e;
                    }),
                    timestampMs: $a2acea4f3420f1d8$var$Ya($a2acea4f3420f1d8$var$sr(t, 2, void 0, $a2acea4f3420f1d8$var$fe) ?? $a2acea4f3420f1d8$var$nr)
                };
            }(t), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("embeddings_out", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.cosineSimilarity = function(t, e) {
    if (t.floatEmbedding && e.floatEmbedding) t = $a2acea4f3420f1d8$var$rh(t.floatEmbedding, e.floatEmbedding);
    else {
        if (!t.quantizedEmbedding || !e.quantizedEmbedding) throw Error("Cannot compute cosine similarity between quantized and float embeddings.");
        t = $a2acea4f3420f1d8$var$rh($a2acea4f3420f1d8$var$eh(t.quantizedEmbedding), $a2acea4f3420f1d8$var$eh(e.quantizedEmbedding));
    }
    return t;
}, $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.prototype.embedForVideo = $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.prototype.Oa, $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.prototype.embed = $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.prototype.Na, $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.prototype.setOptions = $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.prototype.v, $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$7bd9ab1a59f5f8a2, t, e);
};
var $a2acea4f3420f1d8$export$23c2ae92dccdcffe = class {
    constructor(t, e, r){
        this.confidenceMasks = t, this.categoryMask = e, this.qualityScores = r;
    }
    close() {
        this.confidenceMasks?.forEach((t)=>{
            t.close();
        }), this.categoryMask?.close();
    }
};
function $a2acea4f3420f1d8$var$Cc(t) {
    var e = (function(t) {
        return $a2acea4f3420f1d8$var$xr(t, $a2acea4f3420f1d8$var$ho, 1);
    })(t.ja()).filter((t)=>($a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(t, 1)) ?? "").includes("mediapipe.tasks.TensorsToSegmentationCalculator"));
    if (t.u = [], e.length > 1) throw Error("The graph has more than one mediapipe.tasks.TensorsToSegmentationCalculator.");
    1 === e.length && ($a2acea4f3420f1d8$var$Sr(e[0], $a2acea4f3420f1d8$var$no, 7)?.o()?.g() ?? new Map).forEach((e, r)=>{
        t.u[Number(r)] = $a2acea4f3420f1d8$var$_e($a2acea4f3420f1d8$var$sr(e, 1)) ?? "";
    });
}
function $a2acea4f3420f1d8$var$Nc(t) {
    t.categoryMask = void 0, t.confidenceMasks = void 0, t.qualityScores = void 0;
}
function $a2acea4f3420f1d8$var$Mc(t) {
    try {
        let e = new $a2acea4f3420f1d8$export$23c2ae92dccdcffe(t.confidenceMasks, t.categoryMask, t.qualityScores);
        if (!t.l) return e;
        t.l(e);
    } finally{
        $a2acea4f3420f1d8$var$nu(t);
    }
}
$a2acea4f3420f1d8$export$23c2ae92dccdcffe.prototype.close = $a2acea4f3420f1d8$export$23c2ae92dccdcffe.prototype.close;
var $a2acea4f3420f1d8$export$a6aab52785405573 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "image_in", "norm_rect", !1), this.u = [], this.outputCategoryMask = !1, this.outputConfidenceMasks = !0, this.h = new $a2acea4f3420f1d8$var$Na, this.B = new $a2acea4f3420f1d8$var$Ra, $a2acea4f3420f1d8$var$Ir(this.h, 0, 3, this.B), $a2acea4f3420f1d8$var$Ir(t = this.h, 0, 1, e = new $a2acea4f3420f1d8$var$zo);
    }
    C() {
        return "ImageSegmenter";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.h, 0, 1, t);
    }
    v(t) {
        return void 0 !== t.displayNamesLocale ? $a2acea4f3420f1d8$var$ar(this.h, 2, $a2acea4f3420f1d8$var$ve(t.displayNamesLocale)) : "displayNamesLocale" in t && $a2acea4f3420f1d8$var$ar(this.h, 2), "outputCategoryMask" in t && (this.outputCategoryMask = t.outputCategoryMask ?? !1), "outputConfidenceMasks" in t && (this.outputConfidenceMasks = t.outputConfidenceMasks ?? !0), super.j(t);
    }
    L() {
        $a2acea4f3420f1d8$var$Cc(this);
    }
    segment(t, e, r) {
        var n = "function" != typeof e ? e : {};
        return this.l = "function" == typeof e ? e : r, $a2acea4f3420f1d8$var$Nc(this), $a2acea4f3420f1d8$var$tc(this, t, n), $a2acea4f3420f1d8$var$Mc(this);
    }
    eb(t, e, r, n) {
        var i = "function" != typeof r ? r : {};
        return this.l = "function" == typeof r ? r : n, $a2acea4f3420f1d8$var$Nc(this), $a2acea4f3420f1d8$var$ec(this, t, i, e), $a2acea4f3420f1d8$var$Mc(this);
    }
    Ra() {
        return this.u;
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "image_in"), $a2acea4f3420f1d8$var$po(t, "norm_rect");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$Ma, this.h);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.image_segmenter.ImageSegmenterGraph"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:image_in"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), $a2acea4f3420f1d8$var$eu(this, t), this.outputConfidenceMasks && ($a2acea4f3420f1d8$var$go(t, "confidence_masks"), $a2acea4f3420f1d8$var$ao(r, "CONFIDENCE_MASKS:confidence_masks"), $a2acea4f3420f1d8$var$ru(this, "confidence_masks"), this.g.ha("confidence_masks", (t, e)=>{
            this.confidenceMasks = t.map((t)=>$a2acea4f3420f1d8$var$rc(this, t, !0, !this.l)), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("confidence_masks", (t)=>{
            this.confidenceMasks = [], $a2acea4f3420f1d8$var$tu(this, t);
        })), this.outputCategoryMask && ($a2acea4f3420f1d8$var$go(t, "category_mask"), $a2acea4f3420f1d8$var$ao(r, "CATEGORY_MASK:category_mask"), $a2acea4f3420f1d8$var$ru(this, "category_mask"), this.g.ga("category_mask", (t, e)=>{
            this.categoryMask = $a2acea4f3420f1d8$var$rc(this, t, !1, !this.l), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("category_mask", (t)=>{
            this.categoryMask = void 0, $a2acea4f3420f1d8$var$tu(this, t);
        })), $a2acea4f3420f1d8$var$go(t, "quality_scores"), $a2acea4f3420f1d8$var$ao(r, "QUALITY_SCORES:quality_scores"), this.g.attachFloatVectorListener("quality_scores", (t, e)=>{
            this.qualityScores = t, $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("quality_scores", (t)=>{
            this.categoryMask = void 0, $a2acea4f3420f1d8$var$tu(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$a6aab52785405573.prototype.getLabels = $a2acea4f3420f1d8$export$a6aab52785405573.prototype.Ra, $a2acea4f3420f1d8$export$a6aab52785405573.prototype.segmentForVideo = $a2acea4f3420f1d8$export$a6aab52785405573.prototype.eb, $a2acea4f3420f1d8$export$a6aab52785405573.prototype.segment = $a2acea4f3420f1d8$export$a6aab52785405573.prototype.segment, $a2acea4f3420f1d8$export$a6aab52785405573.prototype.setOptions = $a2acea4f3420f1d8$export$a6aab52785405573.prototype.v, $a2acea4f3420f1d8$export$a6aab52785405573.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$a6aab52785405573, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$a6aab52785405573.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$a6aab52785405573, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$a6aab52785405573.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$a6aab52785405573, t, e);
};
var $a2acea4f3420f1d8$var$Dc = {
    0: 0,
    1: 1,
    2: 2,
    3: 3
};
function $a2acea4f3420f1d8$var$Pc() {
    return $a2acea4f3420f1d8$var$Ph() ? void 0 : document.createElement("canvas");
}
var $a2acea4f3420f1d8$export$1911ac08eb46d346 = class extends $a2acea4f3420f1d8$export$61e9fc2d6edc635c {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Yh(t, e)), this.u = new $a2acea4f3420f1d8$var$pu, this.delegate = "CPU", this.h = 0, this.baseOptions = new $a2acea4f3420f1d8$var$zo, this.B = this.l = 0;
    }
    C() {
        return "InteractiveSegmenter";
    }
    get i() {
        return this.g.i;
    }
    v(t) {
        return this.delegate = t.baseOptions?.delegate ?? "CPU", super.j(t);
    }
    fb(t) {
        if (0 === this.h) throw Error("Segmenter is not initialized.");
        var e;
        if (0 !== this.l && (this.i._free(this.l), this.l = 0), !(e = "undefined" != typeof ImageData && t instanceof ImageData)) {
            if ("object" != typeof t || null === t) e = !1;
            else {
                e = t.data;
                var r = t.width, n = t.height;
                e = Number.isInteger(r) && r > 0 && Number.isInteger(n) && n > 0 && (e instanceof Uint8ClampedArray || e instanceof Uint8Array);
            }
        }
        if (e) e = t.width, r = t.height, t = t.data;
        else {
            if ([e, r] = $a2acea4f3420f1d8$var$Uh(t), "undefined" != typeof OffscreenCanvas) n = new OffscreenCanvas(e, r);
            else {
                if ("undefined" == typeof document) throw Error("Canvas is not supported in this environment.");
                n = document.createElement("canvas");
            }
            if (n.width = e, n.height = r, !(n = n.getContext("2d"))) throw Error("Canvas 2D context is not supported in this environment.");
            n.drawImage(t, 0, 0), t = n.getImageData(0, 0, e, r).data;
        }
        if (!t) throw Error("Unsupported image source or failed to extract image pixels.");
        n = function({ Wa: t, width: e, height: r }) {
            if (e <= 0 || r <= 0) throw Error(`Invalid image dimensions: ${e}x${r}. Dimensions must be positive.`);
            if (t % (e * r) !== 0) throw Error(`Invalid image dimensions or pixel data length. Pixel data length ${t} is not a multiple of the number of pixels (${e * r}).`);
            if (4 !== (t /= e * r) && 3 !== t && 1 !== t) throw Error(`Invalid image dimensions or pixel data length. Calculated channels: ${t}. Expected 1, 3, or 4.`);
            return t;
        }({
            Wa: t.length,
            width: e,
            height: r
        });
        var i = this.i._malloc(t.length);
        if (this.i.HEAPU8.set(t, i), this.l = i, !this.i._interactive_segmenter_set_image(this.h, i, e, r, n)) throw Error("Failed to set image on native engine.");
    }
    segment(t) {
        if (0 === this.h) throw Error("Segmenter is not initialized.");
        var e = function(t) {
            t = t.map(({ isCompleted: t, brushMode: e, point: r })=>{
                e = $a2acea4f3420f1d8$var$Dc[e] ?? 0, r = r.map(({ x: t, y: e })=>{
                    var r = new $a2acea4f3420f1d8$var$Oa;
                    return $a2acea4f3420f1d8$var$Vr(r, 1, t), $a2acea4f3420f1d8$var$Vr(r, 2, e), r;
                });
                var n = new $a2acea4f3420f1d8$var$Da;
                return $a2acea4f3420f1d8$var$$r(n, t), $a2acea4f3420f1d8$var$_r(n, 1, $a2acea4f3420f1d8$var$ee(e), 0), $a2acea4f3420f1d8$var$Cr(n, 2, r), n;
            });
            var e = new $a2acea4f3420f1d8$var$Pa;
            return $a2acea4f3420f1d8$var$Cr(e, 1, t), $a2acea4f3420f1d8$var$$a(e);
        }(t);
        t = this.i._malloc(e.length), this.i.HEAPU8.set(e, t);
        var r = this.i._malloc(12), n = r + 4, i = r + 8, s = 0, o = this.B++;
        try {
            if (this.m) {
                if ("GPU" === this.delegate) {
                    var a = this.m;
                    ++a.g.T, a.h.set(o, performance.now());
                } else {
                    var h = this.m;
                    ++h.g.P, h.h.set(o, performance.now());
                }
            }
            if (0 === (s = this.i._interactive_segmenter_segment(this.h, t, e.length, r, n, i))) throw Error("Segmentation failed.");
            this.m?.za(o);
            let c = this.i.HEAPU32[r / 4], l = this.i.HEAPU32[n / 4], d = new Float32Array(this.i.HEAPU8.buffer, s, this.i.HEAPU32[i / 4] / 4);
            var u = new Float32Array(d);
            if (a = c * l, (u instanceof Uint8Array || u instanceof Float32Array) && u.length !== a) throw Error("Unsupported channel count: " + u.length / a);
            return new $a2acea4f3420f1d8$export$e68fd2753c6d17ef([
                u
            ], !0, !1, this.g.i.canvas ?? void 0, this.u, c, l);
        } finally{
            0 !== t && this.i._free(t), 0 !== r && this.i._free(r), 0 !== s && this.i._free(s);
        }
    }
    o() {
        0 !== this.h && (this.m?.xa(), this.i._interactive_segmenter_close(this.h), this.h = 0), 0 !== this.l && (this.i._free(this.l), this.l = 0);
        var t = new $a2acea4f3420f1d8$var$Ko;
        if ("GPU" === this.delegate) {
            var e = new $a2acea4f3420f1d8$var$Ys;
            $a2acea4f3420f1d8$var$Fr(t, 2, $a2acea4f3420f1d8$var$Xo, e);
        } else $a2acea4f3420f1d8$var$Ur(e = new $a2acea4f3420f1d8$var$eo, 1, 4), $a2acea4f3420f1d8$var$Fr(t, 1, $a2acea4f3420f1d8$var$Xo, e);
        if ($a2acea4f3420f1d8$var$Ir(this.baseOptions, 0, 3, t), t = $a2acea4f3420f1d8$var$Jo(this.baseOptions), e = this.i._malloc(t.length), this.i.HEAPU8.set(t, e), this.h = this.i._interactive_segmenter_create(e, t.length), this.i._free(e), 0 === this.h) throw Error("Failed to create native InteractiveSegmenter engine.");
        this.m?.ya();
    }
    close() {
        0 !== this.h && (this.i._interactive_segmenter_close(this.h), this.h = 0), 0 !== this.l && (this.i._free(this.l), this.l = 0), this.u.close(), super.close();
    }
};
$a2acea4f3420f1d8$export$1911ac08eb46d346.prototype.close = $a2acea4f3420f1d8$export$1911ac08eb46d346.prototype.close, $a2acea4f3420f1d8$export$1911ac08eb46d346.prototype.segment = $a2acea4f3420f1d8$export$1911ac08eb46d346.prototype.segment, $a2acea4f3420f1d8$export$1911ac08eb46d346.prototype.setImage = $a2acea4f3420f1d8$export$1911ac08eb46d346.prototype.fb, $a2acea4f3420f1d8$export$1911ac08eb46d346.prototype.setOptions = $a2acea4f3420f1d8$export$1911ac08eb46d346.prototype.v, $a2acea4f3420f1d8$export$1911ac08eb46d346.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Jh($a2acea4f3420f1d8$export$1911ac08eb46d346, $a2acea4f3420f1d8$var$Pc(), t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$1911ac08eb46d346.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Jh($a2acea4f3420f1d8$export$1911ac08eb46d346, $a2acea4f3420f1d8$var$Pc(), t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$1911ac08eb46d346.createFromOptions = function(t, e) {
    var r = e.canvas ?? $a2acea4f3420f1d8$var$Pc();
    return $a2acea4f3420f1d8$var$Jh($a2acea4f3420f1d8$export$1911ac08eb46d346, r, t, e);
};
var $a2acea4f3420f1d8$export$206ec43bd4c99895 = class {
    constructor(t, e, r){
        this.confidenceMasks = t, this.categoryMask = e, this.qualityScores = r;
    }
    close() {
        this.confidenceMasks?.forEach((t)=>{
            t.close();
        }), this.categoryMask?.close();
    }
};
$a2acea4f3420f1d8$export$206ec43bd4c99895.prototype.close = $a2acea4f3420f1d8$export$206ec43bd4c99895.prototype.close;
var $a2acea4f3420f1d8$export$bdd1bc4a5794d516 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "image_in", "norm_rect_in", !1), this.outputCategoryMask = !1, this.outputConfidenceMasks = !0, this.h = new $a2acea4f3420f1d8$var$Na, this.u = new $a2acea4f3420f1d8$var$Ra, $a2acea4f3420f1d8$var$Ir(this.h, 0, 3, this.u), $a2acea4f3420f1d8$var$Ir(t = this.h, 0, 1, e = new $a2acea4f3420f1d8$var$zo);
    }
    C() {
        return "InteractiveSegmenterLegacy";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.h, 0, 1, t);
    }
    v(t) {
        return "outputCategoryMask" in t && (this.outputCategoryMask = t.outputCategoryMask ?? !1), "outputConfidenceMasks" in t && (this.outputConfidenceMasks = t.outputConfidenceMasks ?? !0), super.j(t);
    }
    segment(t, e, r, n) {
        var i = "function" != typeof r ? r : {};
        if (this.l = "function" == typeof r ? r : n, this.qualityScores = this.categoryMask = this.confidenceMasks = void 0, r = this.I + 1, n = new $a2acea4f3420f1d8$var$ja, e.keypoint && e.scribble) throw Error("Cannot provide both keypoint and scribble.");
        if (e.keypoint) {
            var s = new $a2acea4f3420f1d8$var$Ua;
            $a2acea4f3420f1d8$var$$r(s, !0), $a2acea4f3420f1d8$var$Vr(s, 1, e.keypoint.x), $a2acea4f3420f1d8$var$Vr(s, 2, e.keypoint.y), $a2acea4f3420f1d8$var$Fr(n, 1, $a2acea4f3420f1d8$var$Va, s);
        } else {
            if (!e.scribble) throw Error("Must provide either a keypoint or a scribble.");
            {
                let t = new $a2acea4f3420f1d8$var$Ga;
                for (s of e.scribble)$a2acea4f3420f1d8$var$$r(e = new $a2acea4f3420f1d8$var$Ua, !0), $a2acea4f3420f1d8$var$Vr(e, 1, s.x), $a2acea4f3420f1d8$var$Vr(e, 2, s.y), $a2acea4f3420f1d8$var$Mr(t, 1, $a2acea4f3420f1d8$var$Ua, e);
                $a2acea4f3420f1d8$var$Fr(n, 2, $a2acea4f3420f1d8$var$Va, t);
            }
        }
        this.g.addProtoToStream(n.g(), "mediapipe.tasks.vision.interactive_segmenter_legacy.proto.RegionOfInterest", "roi_in", r), $a2acea4f3420f1d8$var$tc(this, t, i);
        t: {
            try {
                let t = new $a2acea4f3420f1d8$export$206ec43bd4c99895(this.confidenceMasks, this.categoryMask, this.qualityScores);
                if (!this.l) {
                    var o = t;
                    break t;
                }
                this.l(t);
            } finally{
                $a2acea4f3420f1d8$var$nu(this);
            }
            o = void 0;
        }
        return o;
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "image_in"), $a2acea4f3420f1d8$var$po(t, "roi_in"), $a2acea4f3420f1d8$var$po(t, "norm_rect_in");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$Ma, this.h);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.interactive_segmenter_legacy.InteractiveSegmenterGraphV2"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:image_in"), $a2acea4f3420f1d8$var$oo(r, "ROI:roi_in"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect_in"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), $a2acea4f3420f1d8$var$eu(this, t), this.outputConfidenceMasks && ($a2acea4f3420f1d8$var$go(t, "confidence_masks"), $a2acea4f3420f1d8$var$ao(r, "CONFIDENCE_MASKS:confidence_masks"), $a2acea4f3420f1d8$var$ru(this, "confidence_masks"), this.g.ha("confidence_masks", (t, e)=>{
            this.confidenceMasks = t.map((t)=>$a2acea4f3420f1d8$var$rc(this, t, !0, !this.l)), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("confidence_masks", (t)=>{
            this.confidenceMasks = [], $a2acea4f3420f1d8$var$tu(this, t);
        })), this.outputCategoryMask && ($a2acea4f3420f1d8$var$go(t, "category_mask"), $a2acea4f3420f1d8$var$ao(r, "CATEGORY_MASK:category_mask"), $a2acea4f3420f1d8$var$ru(this, "category_mask"), this.g.ga("category_mask", (t, e)=>{
            this.categoryMask = $a2acea4f3420f1d8$var$rc(this, t, !1, !this.l), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("category_mask", (t)=>{
            this.categoryMask = void 0, $a2acea4f3420f1d8$var$tu(this, t);
        })), $a2acea4f3420f1d8$var$go(t, "quality_scores"), $a2acea4f3420f1d8$var$ao(r, "QUALITY_SCORES:quality_scores"), this.g.attachFloatVectorListener("quality_scores", (t, e)=>{
            this.qualityScores = t, $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("quality_scores", (t)=>{
            this.categoryMask = void 0, $a2acea4f3420f1d8$var$tu(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$bdd1bc4a5794d516.prototype.segment = $a2acea4f3420f1d8$export$bdd1bc4a5794d516.prototype.segment, $a2acea4f3420f1d8$export$bdd1bc4a5794d516.prototype.setOptions = $a2acea4f3420f1d8$export$bdd1bc4a5794d516.prototype.v, $a2acea4f3420f1d8$export$bdd1bc4a5794d516.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$bdd1bc4a5794d516, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$bdd1bc4a5794d516.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$bdd1bc4a5794d516, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$bdd1bc4a5794d516.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$bdd1bc4a5794d516, t, e);
};
var $a2acea4f3420f1d8$export$f03f381c3c95b342 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "input_frame_gpu", "norm_rect", !1), this.l = {
            detections: []
        }, $a2acea4f3420f1d8$var$Ir(t = this.h = new $a2acea4f3420f1d8$var$Ha, 0, 1, e = new $a2acea4f3420f1d8$var$zo);
    }
    C() {
        return "ObjectDetector";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.h, 0, 1, t);
    }
    v(t) {
        return void 0 !== t.displayNamesLocale ? $a2acea4f3420f1d8$var$ar(this.h, 2, $a2acea4f3420f1d8$var$ve(t.displayNamesLocale)) : "displayNamesLocale" in t && $a2acea4f3420f1d8$var$ar(this.h, 2), void 0 !== t.maxResults ? $a2acea4f3420f1d8$var$Ur(this.h, 3, t.maxResults) : "maxResults" in t && $a2acea4f3420f1d8$var$ar(this.h, 3), void 0 !== t.scoreThreshold ? $a2acea4f3420f1d8$var$jr(this.h, 4, t.scoreThreshold) : "scoreThreshold" in t && $a2acea4f3420f1d8$var$ar(this.h, 4), void 0 !== t.categoryAllowlist ? $a2acea4f3420f1d8$var$Kr(this.h, 5, t.categoryAllowlist) : "categoryAllowlist" in t && $a2acea4f3420f1d8$var$ar(this.h, 5), void 0 !== t.categoryDenylist ? $a2acea4f3420f1d8$var$Kr(this.h, 6, t.categoryDenylist) : "categoryDenylist" in t && $a2acea4f3420f1d8$var$ar(this.h, 6), this.j(t);
    }
    G(t, e) {
        return this.l = {
            detections: []
        }, $a2acea4f3420f1d8$var$tc(this, t, e), this.l;
    }
    H(t, e, r) {
        return this.l = {
            detections: []
        }, $a2acea4f3420f1d8$var$ec(this, t, r, e), this.l;
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "input_frame_gpu"), $a2acea4f3420f1d8$var$po(t, "norm_rect"), $a2acea4f3420f1d8$var$go(t, "detections");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$Ka, this.h);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.ObjectDetectorGraph"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:input_frame_gpu"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect"), $a2acea4f3420f1d8$var$ao(r, "DETECTIONS:detections"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), this.g.attachProtoVectorListener("detections", (t, e)=>{
            for (let e of t)t = $a2acea4f3420f1d8$var$So(e), this.l.detections.push($a2acea4f3420f1d8$var$Za(t));
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("detections", (t)=>{
            $a2acea4f3420f1d8$var$tu(this, t);
        }), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$f03f381c3c95b342.prototype.detectForVideo = $a2acea4f3420f1d8$export$f03f381c3c95b342.prototype.H, $a2acea4f3420f1d8$export$f03f381c3c95b342.prototype.detect = $a2acea4f3420f1d8$export$f03f381c3c95b342.prototype.G, $a2acea4f3420f1d8$export$f03f381c3c95b342.prototype.setOptions = $a2acea4f3420f1d8$export$f03f381c3c95b342.prototype.v, $a2acea4f3420f1d8$export$f03f381c3c95b342.createFromModelPath = async function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$f03f381c3c95b342, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$f03f381c3c95b342.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$f03f381c3c95b342, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$f03f381c3c95b342.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$f03f381c3c95b342, t, e);
};
var $a2acea4f3420f1d8$var$jc = class {
    constructor(t, e, r){
        this.landmarks = t, this.worldLandmarks = e, this.segmentationMasks = r;
    }
    close() {
        this.segmentationMasks?.forEach((t)=>{
            t.close();
        });
    }
};
function $a2acea4f3420f1d8$var$Vc(t) {
    t.landmarks = [], t.worldLandmarks = [], t.segmentationMasks = void 0;
}
function $a2acea4f3420f1d8$var$Hc(t) {
    try {
        let e = new $a2acea4f3420f1d8$var$jc(t.landmarks, t.worldLandmarks, t.segmentationMasks);
        if (!t.u) return e;
        t.u(e);
    } finally{
        $a2acea4f3420f1d8$var$nu(t);
    }
}
$a2acea4f3420f1d8$var$jc.prototype.close = $a2acea4f3420f1d8$var$jc.prototype.close;
var $a2acea4f3420f1d8$export$fe95e48202120e29 = class extends $a2acea4f3420f1d8$export$6371bff908d1a094 {
    constructor(t, e){
        super(new $a2acea4f3420f1d8$var$Ju(t, e), "image_in", "norm_rect", !1), this.landmarks = [], this.worldLandmarks = [], this.outputSegmentationMasks = !1, $a2acea4f3420f1d8$var$Ir(t = this.h = new $a2acea4f3420f1d8$var$Xa, 0, 1, e = new $a2acea4f3420f1d8$var$zo), this.B = new $a2acea4f3420f1d8$var$Aa, $a2acea4f3420f1d8$var$Ir(this.h, 0, 3, this.B), this.l = new $a2acea4f3420f1d8$var$Ea, $a2acea4f3420f1d8$var$Ir(this.h, 0, 2, this.l), $a2acea4f3420f1d8$var$Ur(this.l, 4, 1), $a2acea4f3420f1d8$var$jr(this.l, 2, .5), $a2acea4f3420f1d8$var$jr(this.B, 2, .5), $a2acea4f3420f1d8$var$jr(this.h, 4, .5);
    }
    C() {
        return "PoseLandmarker";
    }
    get baseOptions() {
        return $a2acea4f3420f1d8$var$Sr(this.h, $a2acea4f3420f1d8$var$zo, 1);
    }
    set baseOptions(t) {
        $a2acea4f3420f1d8$var$Ir(this.h, 0, 1, t);
    }
    v(t) {
        return "numPoses" in t && $a2acea4f3420f1d8$var$Ur(this.l, 4, t.numPoses ?? 1), "minPoseDetectionConfidence" in t && $a2acea4f3420f1d8$var$jr(this.l, 2, t.minPoseDetectionConfidence ?? .5), "minTrackingConfidence" in t && $a2acea4f3420f1d8$var$jr(this.h, 4, t.minTrackingConfidence ?? .5), "minPosePresenceConfidence" in t && $a2acea4f3420f1d8$var$jr(this.B, 2, t.minPosePresenceConfidence ?? .5), "outputSegmentationMasks" in t && (this.outputSegmentationMasks = t.outputSegmentationMasks ?? !1), this.j(t);
    }
    G(t, e, r) {
        var n = "function" != typeof e ? e : {};
        return this.u = "function" == typeof e ? e : r, $a2acea4f3420f1d8$var$Vc(this), $a2acea4f3420f1d8$var$tc(this, t, n), $a2acea4f3420f1d8$var$Hc(this);
    }
    H(t, e, r, n) {
        var i = "function" != typeof r ? r : {};
        return this.u = "function" == typeof r ? r : n, $a2acea4f3420f1d8$var$Vc(this), $a2acea4f3420f1d8$var$ec(this, t, i, e), $a2acea4f3420f1d8$var$Hc(this);
    }
    o() {
        var t = new $a2acea4f3420f1d8$var$mo;
        $a2acea4f3420f1d8$var$po(t, "image_in"), $a2acea4f3420f1d8$var$po(t, "norm_rect"), $a2acea4f3420f1d8$var$go(t, "normalized_landmarks"), $a2acea4f3420f1d8$var$go(t, "world_landmarks"), $a2acea4f3420f1d8$var$go(t, "segmentation_masks");
        var e = new $a2acea4f3420f1d8$var$no;
        $a2acea4f3420f1d8$var$li(e, $a2acea4f3420f1d8$var$Wa, this.h);
        var r = new $a2acea4f3420f1d8$var$ho;
        $a2acea4f3420f1d8$var$Hr(r, 2, "mediapipe.tasks.vision.pose_landmarker.PoseLandmarkerGraph"), $a2acea4f3420f1d8$var$oo(r, "IMAGE:image_in"), $a2acea4f3420f1d8$var$oo(r, "NORM_RECT:norm_rect"), $a2acea4f3420f1d8$var$ao(r, "NORM_LANDMARKS:normalized_landmarks"), $a2acea4f3420f1d8$var$ao(r, "WORLD_LANDMARKS:world_landmarks"), r.v(e), $a2acea4f3420f1d8$var$fo(t, r), $a2acea4f3420f1d8$var$eu(this, t), this.g.attachProtoVectorListener("normalized_landmarks", (t, e)=>{
            this.landmarks = [];
            for (let e of t)t = $a2acea4f3420f1d8$var$Io(e), this.landmarks.push($a2acea4f3420f1d8$var$Qa(t));
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("normalized_landmarks", (t)=>{
            this.landmarks = [], $a2acea4f3420f1d8$var$tu(this, t);
        }), this.g.attachProtoVectorListener("world_landmarks", (t, e)=>{
            this.worldLandmarks = [];
            for (let e of t)t = $a2acea4f3420f1d8$var$xo(e), this.worldLandmarks.push($a2acea4f3420f1d8$var$th(t));
            $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("world_landmarks", (t)=>{
            this.worldLandmarks = [], $a2acea4f3420f1d8$var$tu(this, t);
        }), this.outputSegmentationMasks && ($a2acea4f3420f1d8$var$ao(r, "SEGMENTATION_MASK:segmentation_masks"), $a2acea4f3420f1d8$var$ru(this, "segmentation_masks"), this.g.ha("segmentation_masks", (t, e)=>{
            this.segmentationMasks = t.map((t)=>$a2acea4f3420f1d8$var$rc(this, t, !0, !this.u)), $a2acea4f3420f1d8$var$tu(this, e);
        }), this.g.attachEmptyPacketListener("segmentation_masks", (t)=>{
            this.segmentationMasks = [], $a2acea4f3420f1d8$var$tu(this, t);
        })), t = t.g(), this.setGraph(new Uint8Array(t), !0);
    }
};
$a2acea4f3420f1d8$export$fe95e48202120e29.prototype.detectForVideo = $a2acea4f3420f1d8$export$fe95e48202120e29.prototype.H, $a2acea4f3420f1d8$export$fe95e48202120e29.prototype.detect = $a2acea4f3420f1d8$export$fe95e48202120e29.prototype.G, $a2acea4f3420f1d8$export$fe95e48202120e29.prototype.setOptions = $a2acea4f3420f1d8$export$fe95e48202120e29.prototype.v, $a2acea4f3420f1d8$export$fe95e48202120e29.createFromModelPath = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$fe95e48202120e29, t, {
        baseOptions: {
            modelAssetPath: e
        }
    });
}, $a2acea4f3420f1d8$export$fe95e48202120e29.createFromModelBuffer = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$fe95e48202120e29, t, {
        baseOptions: {
            modelAssetBuffer: e
        }
    });
}, $a2acea4f3420f1d8$export$fe95e48202120e29.createFromOptions = function(t, e) {
    return $a2acea4f3420f1d8$var$Zu($a2acea4f3420f1d8$export$fe95e48202120e29, t, e);
}, $a2acea4f3420f1d8$export$fe95e48202120e29.POSE_CONNECTIONS = $a2acea4f3420f1d8$var$Tc, $a2acea4f3420f1d8$var$r("module$exports$google3$third_party$mediapipe$tasks$web$vision$pose_landmarker$pose_landmarker.PoseLandmarker.POSE_CONNECTIONS", $a2acea4f3420f1d8$export$fe95e48202120e29.POSE_CONNECTIONS);
 //# sourceMappingURL=vision_bundle_mjs.js.map


/**
 * @license
 * Copyright 2021 Google LLC. All Rights Reserved.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 */ /**
 * Configuration and the BlazePose 33-landmark topology.
 *
 * The landmark names and their ordering are defined by MediaPipe's pose
 * landmarker model; see
 * https://ai.google.dev/edge/mediapipe/solutions/vision/pose_landmarker
 */ const $4765f54d936bfe63$export$fa5c98d8c8e603f1 = 2;
const $4765f54d936bfe63$export$63f2df7bd7371262 = 4;
const $4765f54d936bfe63$export$b9792696e3661529 = {
    "1280 X 720": {
        width: 1280,
        height: 720
    },
    "640 X 480": {
        width: 640,
        height: 480
    },
    "640 X 360": {
        width: 640,
        height: 360
    },
    "360 X 270": {
        width: 360,
        height: 270
    }
};
const $4765f54d936bfe63$export$46af0713ef1f3295 = "/wasm";
const $4765f54d936bfe63$export$66d3b9df51b4fadf = {
    lite: "/models/pose_landmarker_lite.task",
    full: "/models/pose_landmarker_full.task",
    heavy: "/models/pose_landmarker_heavy.task"
};
const $4765f54d936bfe63$export$63b4527a2777036f = {
    camera: {
        targetFPS: 60,
        sizeOption: "640 X 480",
        /**
     * On a phone the camera is asked for 360x270 regardless of the option
     * above, which is what the vendored demo did and what every recording so
     * far was captured at. It is cheap per frame, and for an angle at the hip
     * or the knee it is plenty. It is NOT plenty for the head: the face
     * landmarks the head angle is built from are a handful of pixels across at
     * that size. `?camsize=` overrides it, so the cost in frame rate can be
     * measured on the phone it would run on rather than guessed at here.
     */ mobileSizeOption: "360 X 270"
    },
    /**
   * "camera" for the live view, "file" to analyse a recording instead. Reviewing
   * a file is easier than reading numbers off a live 60fps overlay, and it is
   * the only way to run this pipeline where there is no camera.
   */ sourceKind: "camera",
    model: "full",
    landmarker: {
        numPoses: 1,
        minPoseDetectionConfidence: 0.5,
        minPosePresenceConfidence: 0.5,
        minTrackingConfidence: 0.5,
        outputSegmentationMasks: false
    },
    /** Landmarks below this visibility are not drawn. */ visibilityThreshold: 0.5,
    render3D: false,
    /**
   * Metrics are computed for one declared camera view at a time. Each metric
   * names the views it is valid in (see metrics/definitions.js); the view set
   * here decides which of them are computed and shown.
   */ metrics: {
        enabled: true,
        view: "side",
        /** Armed by ?record=1: starts recording at the first detected pose. */ autoRecord: false,
        /**
     * ?capture=1 shows the recording bar instead of the drill bar. Capturing a
     * fixture is an errand for whoever is tuning the detector; the drill bar is
     * what the athlete came for.
     */ capture: false,
        /**
     * Tones on each rep and through the countdown. ?sound=0 silences them.
     * On by default: filmed side-on the athlete is at ninety degrees to the
     * phone, so a sound is the only feedback that does not cost them a turn of
     * the head mid-rep.
     */ sound: true,
        /**
     * ?soundcheck=1 turns Start into a speaker test that plays the good and
     * fault sounds back to back. A diagnostic, not part of the drill: the only
     * other way to hear the fault sound is to perform a bad rep on purpose.
     */ soundcheck: false,
        /**
     * Seconds of countdown before recording actually starts, so the phone can
     * be set down and the athlete can walk into frame. 0 starts immediately.
     */ countdownSeconds: 5,
        /** Rolling span the metrics are computed over, in milliseconds. */ windowMs: 3000,
        /** Frames retained. At 60fps this is ten seconds, comfortably over windowMs. */ bufferFrames: 600,
        /**
     * Which drill to score, by its id in exercises/index.js. Null shows the
     * exercise menu first, which is the normal way in; `?exercise=arm_swing`
     * goes straight to that drill, which is how a recording is reviewed and how
     * the pipeline is driven headlessly.
     */ exercise: null
    },
    /**
   * Thresholds for the posture criteria scored on each rep. See
   * docs/arm-swing-posture.md: every number here is measured off one athlete's
   * ten reps read by one person, not a coaching standard, which is exactly why
   * they are settings and are overridable by URL parameter.
   */ posture: {
        enabled: true,
        /** Heel lift that counts as on the toes, in foot lengths. Flat is ~0.3. */ tiptoeMin: 0.7,
        /** Knee must bend at least to this angle. Measured reps reach ~104. */ kneeFlexMax: 150,
        /** Trunk tilt range allowed per rep. The stand-in for core engagement. */ trunkRockMax: 20,
        /** How far ahead of the knee the head or chest may sit, in centimetres. */ aheadOfKneeMax: 10,
        /**
     * The athlete's own neutral head pitch, in degrees from square to the
     * trunk. This is anatomy, not form: the ear-to-nose line is not exactly
     * perpendicular to the spine on anyone. The default is the figure measured
     * on the reference recording, so the criterion is usable out of the box;
     * a still capture with the neck deliberately neutral pins it per athlete.
     */ neckOffset: 18,
        /** Allowed deviation from neckOffset. */ neckTolerance: 15,
        /** Leg landmarks below this are the model guessing, so the frame is refused. */ /**
     * How far the up/down speed ratio has to sit from 1.0 before the readout
     * calls either direction faster. Inside the band it says "Even".
     *
     * 0.10 because that is the measurement's own resolution: the ratio has a
     * standard deviation of about 0.09 between reps of the reference take, so a
     * smaller band would report a difference the method cannot see. The ratio
     * stopped being a pass/fail criterion on 2026-10-03 — it is reported and
     * never judged — so this only decides what the row says, never a verdict.
     */ tempoEvenBand: 0.1,
        /**
     * Degrees per second over a whole rep, below which the swing is too slow.
     *
     * The one threshold here that is not a judgement call. On the reference take
     * the eight reps performed at pace run 186 to 225 degrees/second and the two
     * that exist only because the athlete was walking in or had paused come out
     * at 74 and 95, with nothing in between. Any value from 120 to 180 separates
     * them identically; 150 is the middle of that gap, 24% below the slowest real
     * rep and 58% above the fastest false one.
     */ swingSpeedMin: 150,
        minVisibility: 0.5,
        /** A longer gap between frames breaks rep accumulation rather than bridging it. */ maxGapMs: 250,
        /*
     * Squat thresholds. Unlike every number above, these are NOT measured: they
     * are the movement's own anatomy plus judgement, which is why the squat
     * jump declares `calibrated: false` and why the receipt prints that.
     * Calibrating them means the protocol in fixtures/README.md, the same one
     * the swing went through. The two COUNTING thresholds below are the
     * exception: those were measured, in docs/squat-jump.md.
     *
     * The two counting thresholds sit far apart on purpose. The knee angle
     * wanders a degree or two at the bottom of the movement — the noise floor
     * across this app is 1-3 degrees — and a counter watching one line would
     * score every wobble across it as another rep.
     */ /**
     * Knee angle the counter-movement has to pass below for a rep to start.
     *
     * Shallow on purpose, and this is the subtle one. A jump taken with almost
     * no counter-movement is a fault the athlete should be told about, and at
     * 120 it was not a fault at all — it was a rep that never started, so it
     * vanished from the count instead of failing. Worse, it made
     * `jumpDepthMax` unreachable: a rep could only exist if the knee had
     * already passed 120, which is under the 125 the criterion asks for, so
     * depth passed by construction on every rep that could be scored. At 140
     * the shallow ones count and fail, which is what the athlete can act on.
     * Measured: the fault take goes from 9 reps to 17, five of them failing
     * depth at 126-139 degrees, and the good take still reads 11.
     */ jumpKneeDown: 140,
        /**
     * And return above to close it. Deliberately NOT near a locked 180: on the
     * reference take the athlete came back to only 154-162 degrees between
     * jumps at a 1.5s cadence, so 160 merged five of the ten gaps and counted 6
     * reps against 11 performed. 155 already loses one. See docs/squat-jump.md.
     *
     * The 10 degrees between this and `jumpKneeDown` is the gap that stops the
     * wobble at either end counting twice, and it is as wide as the two
     * measurements allow: the line below cannot rise without missing a shallow
     * jump, and this one cannot without missing a real one.
     */ jumpKneeUp: 150,
        /**
     * How long after `jumpKneeUp` the rep keeps collecting, so that the flight
     * is inside the window the criteria read. On the reference take the body
     * finished extending 350ms after the crossing and nothing changed past
     * 400ms. The cap is also what closes the last rep of a set, where the
     * athlete stands with the knee above `jumpKneeUp` and the signal never
     * comes back down. Milliseconds.
     */ jumpFlightMs: 400,
        /** Deepest knee angle that counts as having loaded the jump. */ jumpDepthMax: 125,
        /**
     * Knee angle the legs have to reach in the air. A straight leg reads near
     * 180; the reference take reached 154-167, so this passes it with little
     * room, which is deliberate — the drill is a stand-in for a hurdle jump and
     * straighter legs are the point.
     */ jumpLegsMin: 150,
        /**
     * Hip angle — shoulder-hip-knee — the body line has to open to in the air.
     *
     * This is the one that measures "trunk and legs not extended", the fault
     * the athlete named first, and the knee does not: on his fault take the
     * knee reached 150-171, as straight as his good set, while the hip piked to
     * 141-155 against 163-178 clean. 158 keeps 5 degrees under the good set's
     * worst rep and still fails 10 of the 17 bad ones; a line at 160 would
     * catch 14 but sit 3 degrees off a correct rep, which is inside what this
     * measurement can resolve.
     */ jumpHipsMin: 158,
        /**
     * Where the airborne phase of a jump starts and ends, as a share of foot
     * length of ankle extension. The criteria that judge the shape in the air
     * have to be read while the athlete IS in the air: the rep window runs past
     * the landing, and a knee read anywhere in it mostly reports someone
     * standing up. A flat foot measures around 0.3 because the heel landmark
     * sits above the toes anatomically, so 0.4 is the first value clear of one.
     *
     * Swept against both takes: at 0.5 the good set's weakest rep reads 151
     * against a 150 threshold, which is inside the noise floor. At 0.4 it reads
     * 154 and the deliberately-bent-leg take reads 125-171. See
     * docs/squat-jump.md.
     */ jumpAirToes: 0.4,
        /**
     * And how much of it there has to be for the movement to be a jump at all.
     *
     * This is the one the athlete will want to move. The counter watches the
     * knee, and a knee bending on the floor traces the same curve as a knee
     * bending to jump, so settling between reps — stepping back into position,
     * shaking out a leg — was counted as an attempt and told it was a bad one.
     * Asking for flight is what separates the two, and it is what makes resting
     * mid-set free: a set is the reps performed in it, not the time between
     * them, and this drill is heavy enough that people stop in the middle.
     *
     * 100ms against the good take's shortest airborne phase of 266ms, so there
     * is 2.7x of margin on a real jump. It is also what the criteria need to
     * read the shape at all: two frames of air is not a body to judge.
     * Overridable as `?jumpairminms=`.
     */ jumpAirMinMs: 100,
        /**
     * Trunk away from vertical at its most upright in the air. The reference
     * take reached 0.8-7.1 degrees, so this is clear of it by a wide margin and
     * is there to catch a jump taken folded rather than to grade a good one.
     */ jumpTrunkMax: 15,
        /**
     * How far the arm has to swing BACK between the bottom of the load and the
     * air, in degrees. The arms go forward and down into the load and back and
     * up through the jump, which is the opposite way to the body and is the
     * athlete's own instruction.
     *
     * Measured: 145-172 degrees of travel across the good take's eleven reps,
     * against -99 to 144 on the take where the arms were left out of it. 110
     * sits under the good set's weakest rep by 7 degrees. Travel rather than a
     * finishing position, since where the arm ends up also depends on how the
     * athlete carries it at rest.
     */ jumpArmSwingMin: 110,
        /*
     * V-sit thresholds, on the hip angle: shoulder-hip-knee, 180 lying flat and
     * closing as the body folds. **Measured**, off the take of 2026-10-13, in
     * which the athlete performed four labelled blocks of five reps in one
     * recording: clean, deliberately shallow, deliberately bent knees, and
     * lying leg raises with the back kept on the floor. Every number below was
     * moved by it. See docs/v-sit.md for the tables.
     */ /** Hip angle the fold has to pass below for a rep to be under way. */ vSitHipDown: 120,
        /**
     * And return above to close it. Coming back down is half the rep and this
     * is where that is enforced — a bounced rep that never unfolds is not
     * counted at all. **Measured, and lowered from 160**: with knees bent the
     * hip reads lower lying flat than it does with straight legs, so one rep of
     * the bent-knee block never returned above 160 and was swallowed into its
     * neighbour. 19 reps for 20 performed, which is the disappearing rep this
     * file predicted before the take existed. The take counts 20 of 20 at
     * anything from 145 to 155 and adds no rep at any of them.
     */ vSitHipUp: 150,
        /**
     * Tightest hip angle that counts as a full fold. **Measured, from 95**: the
     * clean block folds to 61-65 and the deliberately shallow block to 96-117,
     * so 95 sat 1 degree off the fault and 30 off the clean. 85 is between them
     * with 20 degrees of margin on the clean side, where a false failure costs
     * more, and 11 on the fault side.
     */ vSitFoldMax: 85,
        /**
     * Knee angle wanted while folded; below this the legs are tucked.
     * **Measured, from 150**: the bent-knee block reads 90-98 and the clean
     * block 149-170, the knee softening across the block as the athlete tires.
     * 150 failed the last clean rep by one degree, which is inside the noise
     * floor. 145 fails none of them and still catches every bent rep by 47.
     */ vSitKneeMin: 145,
        /**
     * Degrees the trunk has to come off the floor within the rep, measured as
     * the rise in trunk elevation from the flattest frame of the rep to the
     * most upright one.
     *
     * **The hip angle alone cannot ask for this.** Shoulder-hip-knee closes
     * just as well when the legs come up to a trunk that never moved, so a lying
     * leg raise scored a clean V-sit — which is what the athlete reported.
     * Counting still runs off the hip, because that is what says an attempt
     * happened; this is the criterion that says it was the movement claimed.
     *
     * A rise rather than an absolute angle, because the floor is not a landmark:
     * what makes the number mean "off the floor" is that it is read against the
     * same rep's own flattest frame, so a phone propped at a tilt cannot shift
     * it.
     *
     * **Measured, from 20.** The leg raises read 1-3 degrees and every rep of
     * every other block reads 13 or more, so 20 was failing real reps: a shallow
     * fold and a tired bent-knee rep both raise the trunk less, and they were
     * being told to lift their chest when the fault was elsewhere. 8 sits
     * between the two populations with 5 degrees either side, and the clean
     * block is nowhere near it at 34-43.
     */ vSitTrunkRise: 8,
        /**
     * Wall handstand. **Mostly still unmeasured.** One take exists
     * (`fixtures/wall_handstand/`) and it answered the question that mattered
     * most — MediaPipe does track an inverted body, cleanly — so these are no
     * longer angles written down against nothing. But one take of one athlete
     * calibrates one number: the head, which that take broke on purpose, and the
     * knee, which it showed failing a straight leg. Every other number here is
     * still a diver's line written down, and the drill still ships
     * `calibrated: false`. See `docs/wall-handstand.md`.
     */ /** Trunk lean off vertical, in degrees, above which the body counts as
     *  inverted. 180 is fully upside down; this sits well clear of the kick-up
     *  so that going up and coming down are not part of the hold. */ handstandInvertMin: 140,
        /** Shoulder-hip-ankle, the line through the whole body. 180 is a plank. */ handstandLineMin: 165,
        /** Knee angle wanted in the hold. **Measured twice, in both directions.**
     *  170 was wrong and failed a straight leg every time, since a real straight
     *  leg upside down reads 166-170, so it went to 160 — which then passed
     *  three quarters of a knee bent on purpose. The third take settled it with
     *  the fault and the correction inside one hold: the bent stretch reads a
     *  median of 154 (min 130, p90 166) and the straight stretches of the same
     *  hold read 164-176 with a p10 of 166. 163 sits 3 degrees under that p10
     *  and 9 above the fault's median, fails no frame of a labelled clean
     *  stretch, and catches 86% of the fault against 76% at 160. The margin on
     *  the clean side is 1 degree against the single worst clean frame, which is
     *  inside the noise floor: this is the number to revisit first if a straight
     *  leg ever reads as bent. The kick-up frames read 45-124.
     *  See docs/wall-handstand.md. */ handstandKneeMin: 163,
        /** Elbow angle wanted in the hold. */ handstandElbowMin: 160,
        /** Wrist-shoulder-hip: the shoulder stacked over the hand. */ handstandShoulderMin: 155,
        /* No toe threshold. The ankle angle does not track the foot: the athlete
     * flexed his feet deliberately and corrected them within one hold and the
     * best split anywhere in it separates the halves by 3.2 degrees, in the
     * wrong direction. The row reports and never judges, the way the squat
     * jump's row on the same joint does. See docs/wall-handstand.md. */ /** Shorter than this upside down was a kick-up and a fall, not a hold. */ handstandMinHoldMs: 2000,
        /** How long a change in the posture has to persist before it is announced.
     *  It is a sound in the athlete's ear, so a flicker at the threshold must
     *  not be one; see exercises/hold.js. */ handstandSettleMs: 400,
        /** Metres of lean between hands and feet below which the wall is not
     *  called. A handstand leans the way the wall is, but only just. */ handstandLeanMin: 0.04,
        /** Metres the hands may sit out from the wall. The feet are ON the wall, so
     *  the horizontal gap between the wrist and the ankle IS that distance. */ handstandWallMax: 0.3,
        /** Degrees the ear may sit past the line of the arm, out behind it.
     *  **Measured**, and the one threshold on this drill with a fault take
     *  behind it: on the reference recording a clean hold reads -8 to -28 and
     *  never above +2, and the deliberately broken stretches read +10 to +47
     *  with a 10th percentile of +10. The margin is 8 degrees on the clean side
     *  of this and 2 on the fault side; see docs/wall-handstand.md. */ handstandHeadMax: 8,
        /** And the other side of it. **Measured**, on the take that answered the
     *  question Alfre asked after watching the drill pass a head held much too
     *  far forward: the criterion was one-sided, so only the head thrown back
     *  could ever fail it. In the same hold he broke it both ways — forward
     *  reads -56 to -63, back reads +35 to +47 — with clean stretches either
     *  side of each reading -4 to -45. This bound sits 4.6 degrees under the
     *  worst clean frame of that take and 6.1 above the nearest fault frame.
     *  A head is out of line in two directions and the threshold has to be too;
     *  see docs/wall-handstand.md. */ handstandHeadMin: -50,
        /** Metres of nose-to-ear offset below which the facing is not called, and
     *  the head criterion reports unjudged rather than guessing. The sign of
     *  the facing is what turns "one side of the arm" into "the chest side", so
     *  a facing read wrong inverts the criterion. On the reference take it never
     *  fell below 4.7cm across 2777 frames and never changed sign. */ handstandFacingMin: 0.02
    },
    smoothing: {
        enabled: true,
        /**
     * Tuned against a 60fps jitter/ramp sweep. beta is the lag/jitter dial:
     * raising it tracks fast motion more tightly at a small jitter cost.
     *   beta 0.0 -> lag 0.28   beta 1.0 -> lag 0.10
     *   beta 0.5 -> lag 0.15   beta 1.5 -> lag 0.08  (jitter is flat across all)
     * Sport motion wants low lag, so this sits high.
     */ normalized: {
            minCutoff: 1.0,
            beta: 1.5,
            dCutoff: 1.0
        },
        /** World landmarks are in metres, so speeds are ~3x larger; beta scales down. */ world: {
            minCutoff: 1.0,
            beta: 0.5,
            dCutoff: 1.0
        }
    }
};
const $4765f54d936bfe63$export$8519f787e6064507 = [
    "nose",
    "left_eye_inner",
    "left_eye",
    "left_eye_outer",
    "right_eye_inner",
    "right_eye",
    "right_eye_outer",
    "left_ear",
    "right_ear",
    "mouth_left",
    "mouth_right",
    "left_shoulder",
    "right_shoulder",
    "left_elbow",
    "right_elbow",
    "left_wrist",
    "right_wrist",
    "left_pinky",
    "right_pinky",
    "left_index",
    "right_index",
    "left_thumb",
    "right_thumb",
    "left_hip",
    "right_hip",
    "left_knee",
    "right_knee",
    "left_ankle",
    "right_ankle",
    "left_heel",
    "right_heel",
    "left_foot_index",
    "right_foot_index"
];
const $4765f54d936bfe63$export$93e1ca20ea9c5749 = Object.fromEntries($4765f54d936bfe63$export$8519f787e6064507.map((name, i)=>[
        name.toUpperCase(),
        i
    ]));
const $4765f54d936bfe63$export$17f063499ab4f36b = {
    left: $4765f54d936bfe63$var$indicesOnSide("left"),
    right: $4765f54d936bfe63$var$indicesOnSide("right"),
    middle: $4765f54d936bfe63$export$8519f787e6064507.map((_, i)=>i).filter((i)=>$4765f54d936bfe63$var$side($4765f54d936bfe63$export$8519f787e6064507[i]) == null)
};
function $4765f54d936bfe63$var$side(name) {
    const parts = name.split("_");
    if (parts.includes("left")) return "left";
    if (parts.includes("right")) return "right";
    return null;
}
function $4765f54d936bfe63$var$indicesOnSide(wanted) {
    return $4765f54d936bfe63$export$8519f787e6064507.map((name, i)=>$4765f54d936bfe63$var$side(name) === wanted ? i : -1).filter((i)=>i >= 0);
}


/**
 * How long to wait for the camera stream to produce frames before giving up.
 * A hang here used to leave a blank page forever; failing loudly is better.
 */ const $99e47839c965209f$var$STREAM_READY_TIMEOUT_MS = 15000;
/**
 * Resolves once the video is actually producing frames, i.e. once it reports
 * real dimensions.
 *
 * `loadedmetadata` alone is not a safe signal. iOS Safari does not report
 * metadata for a MediaStream until playback has actually started, and in some
 * builds the event does not arrive at all even though frames are flowing, so
 * this listens to several events AND polls the dimensions, whichever comes
 * first. Rejects rather than hanging, so the failure is visible.
 */ function $99e47839c965209f$var$waitForFrames(video, timeoutMs) {
    const hasFrames = ()=>video.videoWidth > 0 && video.videoHeight > 0;
    if (hasFrames()) return Promise.resolve();
    return new Promise((resolve, reject)=>{
        const events = [
            "loadedmetadata",
            "loadeddata",
            "canplay",
            "playing"
        ];
        let done = false;
        const cleanup = ()=>{
            clearInterval(poll);
            clearTimeout(deadline);
            for (const name of events)video.removeEventListener(name, check);
        };
        const check = ()=>{
            if (done || !hasFrames()) return;
            done = true;
            cleanup();
            resolve();
        };
        const poll = setInterval(check, 100);
        const deadline = setTimeout(()=>{
            if (done) return;
            done = true;
            cleanup();
            reject(new Error(`Camera stream produced no frames within ${timeoutMs / 1000}s. ` + "On iOS this usually means the video element was not allowed to " + "play inline."));
        }, timeoutMs);
        for (const name of events)video.addEventListener(name, check);
        check();
    });
}
function $99e47839c965209f$export$86c1a3f9ab33da5c() {
    return /iPhone|iPad|iPod/i.test(navigator.userAgent);
}
function $99e47839c965209f$export$a11b0059900ceec8() {
    return /Android/i.test(navigator.userAgent);
}
function $99e47839c965209f$export$d0a8044dce8ff2fc() {
    return $99e47839c965209f$export$a11b0059900ceec8() || $99e47839c965209f$export$86c1a3f9ab33da5c();
}
class $99e47839c965209f$export$79f141de891a5fed {
    constructor(){
        this.video = document.getElementById("video");
    }
    /**
   * Initiate a Camera instance and wait for the camera stream to be ready.
   * @param cameraParam From app `STATE.camera`.
   */ static async setup(cameraParam) {
        if (!navigator.mediaDevices || !navigator.mediaDevices.getUserMedia) throw new Error("Browser API navigator.mediaDevices.getUserMedia not available");
        const { targetFPS: targetFPS, sizeOption: sizeOption, mobileSizeOption: mobileSizeOption } = cameraParam;
        const $size = $4765f54d936bfe63$export$b9792696e3661529[sizeOption];
        // A phone gets its own, smaller option: see STATE.camera in params.js for
        // what that costs and why it is overridable.
        const $mobile = $4765f54d936bfe63$export$b9792696e3661529[mobileSizeOption] || $4765f54d936bfe63$export$b9792696e3661529["360 X 270"];
        const videoConfig = {
            audio: false,
            video: {
                facingMode: "user",
                // Only setting the video to a specified size for large screen, on
                // mobile devices accept the default size.
                width: $99e47839c965209f$export$d0a8044dce8ff2fc() ? $mobile.width : $size.width,
                height: $99e47839c965209f$export$d0a8044dce8ff2fc() ? $mobile.height : $size.height,
                frameRate: {
                    ideal: targetFPS
                }
            }
        };
        const stream = await navigator.mediaDevices.getUserMedia(videoConfig);
        const camera = new $99e47839c965209f$export$79f141de891a5fed();
        camera.video.srcObject = stream;
        // iOS Safari refuses to start an inline video that is not muted. Set these
        // on the element as well as in the markup, so the guarantee does not depend
        // on the attributes surviving.
        camera.video.muted = true;
        camera.video.playsInline = true;
        camera.video.setAttribute("playsinline", "");
        camera.video.setAttribute("muted", "");
        // play() must come BEFORE waiting for readiness. iOS does not report
        // metadata for a MediaStream until playback has started, so waiting first
        // and playing afterwards deadlocks: the wait is for an event that only
        // playing can produce. Rejection is left to the readiness timeout, which
        // gives a far more useful message than a bare AbortError.
        const playing = camera.video.play();
        if (playing && typeof playing.catch === "function") playing.catch(()=>{});
        await $99e47839c965209f$var$waitForFrames(camera.video, $99e47839c965209f$var$STREAM_READY_TIMEOUT_MS);
        const videoWidth = camera.video.videoWidth;
        const videoHeight = camera.video.videoHeight;
        // Must set below two lines, otherwise video element doesn't show.
        camera.video.width = videoWidth;
        camera.video.height = videoHeight;
        // Aspect ratio rather than fixed pixels: the wrapper is width-driven so the
        // view scales to the screen, and CSS derives the height. Assigning to
        // .style.aspectRatio also avoids clobbering any other inline style, which
        // `element.style = "..."` would.
        const canvasContainer = document.querySelector(".canvas-wrapper");
        canvasContainer.style.aspectRatio = `${videoWidth} / ${videoHeight}`;
        return camera;
    }
}


/**
 * One Euro filter — Casiez, Roussel & Vogel (CHI 2012),
 * "1e Filter: A Simple Speed-based Low-pass Filter for Noisy Input in
 * Interactive Systems". https://gery.casiez.net/1euro/
 *
 * An adaptive low-pass filter: it smooths hard when a signal is nearly still
 * (killing jitter) and barely at all when it moves fast (killing lag). That
 * tradeoff is exactly what sport motion needs — a held plank position should
 * not shimmer, and a sprinting wrist should not lag behind the video.
 */ /** Exponential smoothing with an externally supplied alpha. */ class $a75a0c604ecdd6ea$var$LowPassFilter {
    constructor(){
        this.hasLastValue = false;
        this.lastValue = 0;
    }
    filter(value, alpha) {
        const result = this.hasLastValue ? alpha * value + (1 - alpha) * this.lastValue : value;
        this.lastValue = result;
        this.hasLastValue = true;
        return result;
    }
    reset() {
        this.hasLastValue = false;
        this.lastValue = 0;
    }
}
class $a75a0c604ecdd6ea$export$b03ffd491b0af50f {
    /**
   * @param minCutoff Cutoff in Hz at zero speed. Lower = smoother when still.
   * @param beta Speed coefficient. Higher = less lag on fast motion.
   * @param dCutoff Cutoff in Hz for the speed estimate itself.
   */ constructor({ minCutoff: minCutoff = 1.0, beta: beta = 0.5, dCutoff: dCutoff = 1.0 } = {}){
        this.minCutoff = minCutoff;
        this.beta = beta;
        this.dCutoff = dCutoff;
        this.valueFilter = new $a75a0c604ecdd6ea$var$LowPassFilter();
        this.speedFilter = new $a75a0c604ecdd6ea$var$LowPassFilter();
        this.lastValue = 0;
        this.lastTimestamp = null;
    }
    /**
   * @param value Raw sample.
   * @param timestamp Sample time in milliseconds, monotonically increasing.
   */ filter(value, timestamp) {
        // First sample, or a non-advancing clock: nothing to differentiate against.
        if (this.lastTimestamp == null || timestamp <= this.lastTimestamp) {
            this.lastTimestamp = timestamp;
            this.lastValue = value;
            this.speedFilter.reset();
            return this.valueFilter.filter(value, 1.0);
        }
        const rate = 1000 / (timestamp - this.lastTimestamp);
        const speed = (value - this.lastValue) * rate;
        const smoothedSpeed = this.speedFilter.filter(speed, $a75a0c604ecdd6ea$var$alpha(this.dCutoff, rate));
        // The adaptive step: cutoff rises with speed, so fast motion passes through.
        const cutoff = this.minCutoff + this.beta * Math.abs(smoothedSpeed);
        this.lastTimestamp = timestamp;
        this.lastValue = value;
        return this.valueFilter.filter(value, $a75a0c604ecdd6ea$var$alpha(cutoff, rate));
    }
    reset() {
        this.valueFilter.reset();
        this.speedFilter.reset();
        this.lastValue = 0;
        this.lastTimestamp = null;
    }
}
function $a75a0c604ecdd6ea$var$alpha(cutoff, rate) {
    const tau = 1 / (2 * Math.PI * cutoff);
    const te = 1 / rate;
    return 1 / (1 + tau / te);
}
class $a75a0c604ecdd6ea$export$b49a7690c1441d8a {
    constructor(config){
        this.config = config;
        this.filters = new Map();
    }
    /**
   * Drop all state — call when tracking is lost, so the next acquisition does
   * not get dragged toward wherever the athlete was standing before.
   */ reset() {
        this.filters.clear();
    }
    /**
   * @param landmarks A single pose's landmark array.
   * @param timestamp Frame time in milliseconds.
   * @return A new array of smoothed landmarks; input is not mutated.
   */ smooth(landmarks, timestamp) {
        return landmarks.map((landmark, i)=>({
                ...landmark,
                x: this.filterAxis(i, "x", landmark.x, timestamp),
                y: this.filterAxis(i, "y", landmark.y, timestamp),
                z: this.filterAxis(i, "z", landmark.z, timestamp)
            }));
    }
    filterAxis(index, axis, value, timestamp) {
        if (value == null) return value;
        const key = `${index}:${axis}`;
        let filter = this.filters.get(key);
        if (filter == null) {
            filter = new $a75a0c604ecdd6ea$export$b03ffd491b0af50f(this.config);
            this.filters.set(key, filter);
        }
        return filter.filter(value, timestamp);
    }
}


/**
 * @license
 * Copyright 2023 Google LLC.
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 * https://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 * =============================================================================
 *
 * Adapted from the tfjs-models pose-detection demo renderer to draw MediaPipe
 * PoseLandmarker output (33 landmarks, normalized 2D + metric 3D) instead of
 * MoveNet's 17 pixel-space keypoints.
 */ 
var $abd2d8e70de93536$exports = {};
"use strict";
Object.defineProperty($abd2d8e70de93536$exports, "__esModule", {
    value: true
});
var $7aca01f07175d0d8$exports = {};
"use strict";
var $7aca01f07175d0d8$var$__read = $7aca01f07175d0d8$exports && $7aca01f07175d0d8$exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $7aca01f07175d0d8$var$__spread = $7aca01f07175d0d8$exports && $7aca01f07175d0d8$exports.__spread || function() {
    for(var ar = [], i = 0; i < arguments.length; i++)ar = ar.concat($7aca01f07175d0d8$var$__read(arguments[i]));
    return ar;
};
var $7aca01f07175d0d8$var$__values = $7aca01f07175d0d8$exports && $7aca01f07175d0d8$exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty($7aca01f07175d0d8$exports, "__esModule", {
    value: true
});
var $31a6dfd76139c96e$exports = {};
"use strict";
var $31a6dfd76139c96e$var$__assign = $31a6dfd76139c96e$exports && $31a6dfd76139c96e$exports.__assign || function() {
    $31a6dfd76139c96e$var$__assign = Object.assign || function(t) {
        for(var s, i = 1, n = arguments.length; i < n; i++){
            s = arguments[i];
            for(var p in s)if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
        }
        return t;
    };
    return $31a6dfd76139c96e$var$__assign.apply(this, arguments);
};
var $31a6dfd76139c96e$var$__read = $31a6dfd76139c96e$exports && $31a6dfd76139c96e$exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
var $31a6dfd76139c96e$var$__values = $31a6dfd76139c96e$exports && $31a6dfd76139c96e$exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty($31a6dfd76139c96e$exports, "__esModule", {
    value: true
});

var $eq1Fs = parcelRequire("eq1Fs");

var $eq1Fs = parcelRequire("eq1Fs");
// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
//
//    Orbit - left mouse / touch: one-finger move
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - right mouse, or left mouse + ctrl/meta/shiftKey, or arrow keys / touch: two-finger move
var $ac97ba1014cae2cd$export$8ff7788029dfdf52 = function(object, domElement) {
    if (domElement === undefined) console.warn('THREE.OrbitControls: The second parameter "domElement" is now mandatory.');
    if (domElement === document) console.error('THREE.OrbitControls: "document" should not be used as the target "domElement". Please use "renderer.domElement" instead.');
    this.object = object;
    this.domElement = domElement;
    // Set to false to disable this control
    this.enabled = true;
    // "target" sets the location of focus, where the object orbits around
    this.target = new (0, $eq1Fs.Vector3)();
    // How far you can dolly in and out ( PerspectiveCamera only )
    this.minDistance = 0;
    this.maxDistance = Infinity;
    // How far you can zoom in and out ( OrthographicCamera only )
    this.minZoom = 0;
    this.maxZoom = Infinity;
    // How far you can orbit vertically, upper and lower limits.
    // Range is 0 to Math.PI radians.
    this.minPolarAngle = 0; // radians
    this.maxPolarAngle = Math.PI; // radians
    // How far you can orbit horizontally, upper and lower limits.
    // If set, the interval [ min, max ] must be a sub-interval of [ - 2 PI, 2 PI ], with ( max - min < 2 PI )
    this.minAzimuthAngle = -Infinity; // radians
    this.maxAzimuthAngle = Infinity; // radians
    // Set to true to enable damping (inertia)
    // If damping is enabled, you must call controls.update() in your animation loop
    this.enableDamping = false;
    this.dampingFactor = 0.05;
    // This option actually enables dollying in and out; left as "zoom" for backwards compatibility.
    // Set to false to disable zooming
    this.enableZoom = true;
    this.zoomSpeed = 1.0;
    // Set to false to disable rotating
    this.enableRotate = true;
    this.rotateSpeed = 1.0;
    // Set to false to disable panning
    this.enablePan = true;
    this.panSpeed = 1.0;
    this.screenSpacePanning = true; // if false, pan orthogonal to world-space direction camera.up
    this.keyPanSpeed = 7.0; // pixels moved per arrow key push
    // Set to true to automatically rotate around the target
    // If auto-rotate is enabled, you must call controls.update() in your animation loop
    this.autoRotate = false;
    this.autoRotateSpeed = 2.0; // 30 seconds per round when fps is 60
    // The four arrow keys
    this.keys = {
        LEFT: 37,
        UP: 38,
        RIGHT: 39,
        BOTTOM: 40
    };
    // Mouse buttons
    this.mouseButtons = {
        LEFT: (0, $eq1Fs.MOUSE).ROTATE,
        MIDDLE: (0, $eq1Fs.MOUSE).DOLLY,
        RIGHT: (0, $eq1Fs.MOUSE).PAN
    };
    // Touch fingers
    this.touches = {
        ONE: (0, $eq1Fs.TOUCH).ROTATE,
        TWO: (0, $eq1Fs.TOUCH).DOLLY_PAN
    };
    // for reset
    this.target0 = this.target.clone();
    this.position0 = this.object.position.clone();
    this.zoom0 = this.object.zoom;
    // the target DOM element for key events
    this._domElementKeyEvents = null;
    //
    // public methods
    //
    this.getPolarAngle = function() {
        return spherical.phi;
    };
    this.getAzimuthalAngle = function() {
        return spherical.theta;
    };
    this.listenToKeyEvents = function(domElement) {
        domElement.addEventListener('keydown', onKeyDown);
        this._domElementKeyEvents = domElement;
    };
    this.saveState = function() {
        scope.target0.copy(scope.target);
        scope.position0.copy(scope.object.position);
        scope.zoom0 = scope.object.zoom;
    };
    this.reset = function() {
        scope.target.copy(scope.target0);
        scope.object.position.copy(scope.position0);
        scope.object.zoom = scope.zoom0;
        scope.object.updateProjectionMatrix();
        scope.dispatchEvent(changeEvent);
        scope.update();
        state = STATE.NONE;
    };
    // this method is exposed, but perhaps it would be better if we can make it private...
    this.update = function() {
        var offset = new (0, $eq1Fs.Vector3)();
        // so camera.up is the orbit axis
        var quat = new (0, $eq1Fs.Quaternion)().setFromUnitVectors(object.up, new (0, $eq1Fs.Vector3)(0, 1, 0));
        var quatInverse = quat.clone().invert();
        var lastPosition = new (0, $eq1Fs.Vector3)();
        var lastQuaternion = new (0, $eq1Fs.Quaternion)();
        var twoPI = 2 * Math.PI;
        return function update() {
            var position = scope.object.position;
            offset.copy(position).sub(scope.target);
            // rotate offset to "y-axis-is-up" space
            offset.applyQuaternion(quat);
            // angle from z-axis around y-axis
            spherical.setFromVector3(offset);
            if (scope.autoRotate && state === STATE.NONE) rotateLeft(getAutoRotationAngle());
            if (scope.enableDamping) {
                spherical.theta += sphericalDelta.theta * scope.dampingFactor;
                spherical.phi += sphericalDelta.phi * scope.dampingFactor;
            } else {
                spherical.theta += sphericalDelta.theta;
                spherical.phi += sphericalDelta.phi;
            }
            // restrict theta to be between desired limits
            var min = scope.minAzimuthAngle;
            var max = scope.maxAzimuthAngle;
            if (isFinite(min) && isFinite(max)) {
                if (min < -Math.PI) min += twoPI;
                else if (min > Math.PI) min -= twoPI;
                if (max < -Math.PI) max += twoPI;
                else if (max > Math.PI) max -= twoPI;
                if (min <= max) spherical.theta = Math.max(min, Math.min(max, spherical.theta));
                else spherical.theta = spherical.theta > (min + max) / 2 ? Math.max(min, spherical.theta) : Math.min(max, spherical.theta);
            }
            // restrict phi to be between desired limits
            spherical.phi = Math.max(scope.minPolarAngle, Math.min(scope.maxPolarAngle, spherical.phi));
            spherical.makeSafe();
            spherical.radius *= scale;
            // restrict radius to be between desired limits
            spherical.radius = Math.max(scope.minDistance, Math.min(scope.maxDistance, spherical.radius));
            // move target to panned location
            if (scope.enableDamping === true) scope.target.addScaledVector(panOffset, scope.dampingFactor);
            else scope.target.add(panOffset);
            offset.setFromSpherical(spherical);
            // rotate offset back to "camera-up-vector-is-up" space
            offset.applyQuaternion(quatInverse);
            position.copy(scope.target).add(offset);
            scope.object.lookAt(scope.target);
            if (scope.enableDamping === true) {
                sphericalDelta.theta *= 1 - scope.dampingFactor;
                sphericalDelta.phi *= 1 - scope.dampingFactor;
                panOffset.multiplyScalar(1 - scope.dampingFactor);
            } else {
                sphericalDelta.set(0, 0, 0);
                panOffset.set(0, 0, 0);
            }
            scale = 1;
            // update condition is:
            // min(camera displacement, camera rotation in radians)^2 > EPS
            // using small-angle approximation cos(x/2) = 1 - x^2 / 8
            if (zoomChanged || lastPosition.distanceToSquared(scope.object.position) > EPS || 8 * (1 - lastQuaternion.dot(scope.object.quaternion)) > EPS) {
                scope.dispatchEvent(changeEvent);
                lastPosition.copy(scope.object.position);
                lastQuaternion.copy(scope.object.quaternion);
                zoomChanged = false;
                return true;
            }
            return false;
        };
    }();
    this.dispose = function() {
        scope.domElement.removeEventListener('contextmenu', onContextMenu);
        scope.domElement.removeEventListener('pointerdown', onPointerDown);
        scope.domElement.removeEventListener('wheel', onMouseWheel);
        scope.domElement.removeEventListener('touchstart', onTouchStart);
        scope.domElement.removeEventListener('touchend', onTouchEnd);
        scope.domElement.removeEventListener('touchmove', onTouchMove);
        scope.domElement.ownerDocument.removeEventListener('pointermove', onPointerMove);
        scope.domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
        if (scope._domElementKeyEvents !== null) scope._domElementKeyEvents.removeEventListener('keydown', onKeyDown);
    //scope.dispatchEvent( { type: 'dispose' } ); // should this be added here?
    };
    //
    // internals
    //
    var scope = this;
    var changeEvent = {
        type: 'change'
    };
    var startEvent = {
        type: 'start'
    };
    var endEvent = {
        type: 'end'
    };
    var STATE = {
        NONE: -1,
        ROTATE: 0,
        DOLLY: 1,
        PAN: 2,
        TOUCH_ROTATE: 3,
        TOUCH_PAN: 4,
        TOUCH_DOLLY_PAN: 5,
        TOUCH_DOLLY_ROTATE: 6
    };
    var state = STATE.NONE;
    var EPS = 0.000001;
    // current position in spherical coordinates
    var spherical = new (0, $eq1Fs.Spherical)();
    var sphericalDelta = new (0, $eq1Fs.Spherical)();
    var scale = 1;
    var panOffset = new (0, $eq1Fs.Vector3)();
    var zoomChanged = false;
    var rotateStart = new (0, $eq1Fs.Vector2)();
    var rotateEnd = new (0, $eq1Fs.Vector2)();
    var rotateDelta = new (0, $eq1Fs.Vector2)();
    var panStart = new (0, $eq1Fs.Vector2)();
    var panEnd = new (0, $eq1Fs.Vector2)();
    var panDelta = new (0, $eq1Fs.Vector2)();
    var dollyStart = new (0, $eq1Fs.Vector2)();
    var dollyEnd = new (0, $eq1Fs.Vector2)();
    var dollyDelta = new (0, $eq1Fs.Vector2)();
    function getAutoRotationAngle() {
        return 2 * Math.PI / 60 / 60 * scope.autoRotateSpeed;
    }
    function getZoomScale() {
        return Math.pow(0.95, scope.zoomSpeed);
    }
    function rotateLeft(angle) {
        sphericalDelta.theta -= angle;
    }
    function rotateUp(angle) {
        sphericalDelta.phi -= angle;
    }
    var panLeft = function() {
        var v = new (0, $eq1Fs.Vector3)();
        return function panLeft(distance, objectMatrix) {
            v.setFromMatrixColumn(objectMatrix, 0); // get X column of objectMatrix
            v.multiplyScalar(-distance);
            panOffset.add(v);
        };
    }();
    var panUp = function() {
        var v = new (0, $eq1Fs.Vector3)();
        return function panUp(distance, objectMatrix) {
            if (scope.screenSpacePanning === true) v.setFromMatrixColumn(objectMatrix, 1);
            else {
                v.setFromMatrixColumn(objectMatrix, 0);
                v.crossVectors(scope.object.up, v);
            }
            v.multiplyScalar(distance);
            panOffset.add(v);
        };
    }();
    // deltaX and deltaY are in pixels; right and down are positive
    var pan = function() {
        var offset = new (0, $eq1Fs.Vector3)();
        return function pan(deltaX, deltaY) {
            var element = scope.domElement;
            if (scope.object.isPerspectiveCamera) {
                // perspective
                var position = scope.object.position;
                offset.copy(position).sub(scope.target);
                var targetDistance = offset.length();
                // half of the fov is center to top of screen
                targetDistance *= Math.tan(scope.object.fov / 2 * Math.PI / 180.0);
                // we use only clientHeight here so aspect ratio does not distort speed
                panLeft(2 * deltaX * targetDistance / element.clientHeight, scope.object.matrix);
                panUp(2 * deltaY * targetDistance / element.clientHeight, scope.object.matrix);
            } else if (scope.object.isOrthographicCamera) {
                // orthographic
                panLeft(deltaX * (scope.object.right - scope.object.left) / scope.object.zoom / element.clientWidth, scope.object.matrix);
                panUp(deltaY * (scope.object.top - scope.object.bottom) / scope.object.zoom / element.clientHeight, scope.object.matrix);
            } else {
                // camera neither orthographic nor perspective
                console.warn('WARNING: OrbitControls.js encountered an unknown camera type - pan disabled.');
                scope.enablePan = false;
            }
        };
    }();
    function dollyOut(dollyScale) {
        if (scope.object.isPerspectiveCamera) scale /= dollyScale;
        else if (scope.object.isOrthographicCamera) {
            scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom * dollyScale));
            scope.object.updateProjectionMatrix();
            zoomChanged = true;
        } else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            scope.enableZoom = false;
        }
    }
    function dollyIn(dollyScale) {
        if (scope.object.isPerspectiveCamera) scale *= dollyScale;
        else if (scope.object.isOrthographicCamera) {
            scope.object.zoom = Math.max(scope.minZoom, Math.min(scope.maxZoom, scope.object.zoom / dollyScale));
            scope.object.updateProjectionMatrix();
            zoomChanged = true;
        } else {
            console.warn('WARNING: OrbitControls.js encountered an unknown camera type - dolly/zoom disabled.');
            scope.enableZoom = false;
        }
    }
    //
    // event callbacks - update the object state
    //
    function handleMouseDownRotate(event) {
        rotateStart.set(event.clientX, event.clientY);
    }
    function handleMouseDownDolly(event) {
        dollyStart.set(event.clientX, event.clientY);
    }
    function handleMouseDownPan(event) {
        panStart.set(event.clientX, event.clientY);
    }
    function handleMouseMoveRotate(event) {
        rotateEnd.set(event.clientX, event.clientY);
        rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
        var element = scope.domElement;
        rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
        rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
        rotateStart.copy(rotateEnd);
        scope.update();
    }
    function handleMouseMoveDolly(event) {
        dollyEnd.set(event.clientX, event.clientY);
        dollyDelta.subVectors(dollyEnd, dollyStart);
        if (dollyDelta.y > 0) dollyOut(getZoomScale());
        else if (dollyDelta.y < 0) dollyIn(getZoomScale());
        dollyStart.copy(dollyEnd);
        scope.update();
    }
    function handleMouseMovePan(event) {
        panEnd.set(event.clientX, event.clientY);
        panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
        pan(panDelta.x, panDelta.y);
        panStart.copy(panEnd);
        scope.update();
    }
    function handleMouseUp() {
    // no-op
    }
    function handleMouseWheel(event) {
        if (event.deltaY < 0) dollyIn(getZoomScale());
        else if (event.deltaY > 0) dollyOut(getZoomScale());
        scope.update();
    }
    function handleKeyDown(event) {
        var needsUpdate = false;
        switch(event.keyCode){
            case scope.keys.UP:
                pan(0, scope.keyPanSpeed);
                needsUpdate = true;
                break;
            case scope.keys.BOTTOM:
                pan(0, -scope.keyPanSpeed);
                needsUpdate = true;
                break;
            case scope.keys.LEFT:
                pan(scope.keyPanSpeed, 0);
                needsUpdate = true;
                break;
            case scope.keys.RIGHT:
                pan(-scope.keyPanSpeed, 0);
                needsUpdate = true;
                break;
        }
        if (needsUpdate) {
            // prevent the browser from scrolling on cursor keys
            event.preventDefault();
            scope.update();
        }
    }
    function handleTouchStartRotate(event) {
        if (event.touches.length == 1) rotateStart.set(event.touches[0].pageX, event.touches[0].pageY);
        else {
            var x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
            var y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
            rotateStart.set(x, y);
        }
    }
    function handleTouchStartPan(event) {
        if (event.touches.length == 1) panStart.set(event.touches[0].pageX, event.touches[0].pageY);
        else {
            var x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
            var y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
            panStart.set(x, y);
        }
    }
    function handleTouchStartDolly(event) {
        var dx = event.touches[0].pageX - event.touches[1].pageX;
        var dy = event.touches[0].pageY - event.touches[1].pageY;
        var distance = Math.sqrt(dx * dx + dy * dy);
        dollyStart.set(0, distance);
    }
    function handleTouchStartDollyPan(event) {
        if (scope.enableZoom) handleTouchStartDolly(event);
        if (scope.enablePan) handleTouchStartPan(event);
    }
    function handleTouchStartDollyRotate(event) {
        if (scope.enableZoom) handleTouchStartDolly(event);
        if (scope.enableRotate) handleTouchStartRotate(event);
    }
    function handleTouchMoveRotate(event) {
        if (event.touches.length == 1) rotateEnd.set(event.touches[0].pageX, event.touches[0].pageY);
        else {
            var x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
            var y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
            rotateEnd.set(x, y);
        }
        rotateDelta.subVectors(rotateEnd, rotateStart).multiplyScalar(scope.rotateSpeed);
        var element = scope.domElement;
        rotateLeft(2 * Math.PI * rotateDelta.x / element.clientHeight); // yes, height
        rotateUp(2 * Math.PI * rotateDelta.y / element.clientHeight);
        rotateStart.copy(rotateEnd);
    }
    function handleTouchMovePan(event) {
        if (event.touches.length == 1) panEnd.set(event.touches[0].pageX, event.touches[0].pageY);
        else {
            var x = 0.5 * (event.touches[0].pageX + event.touches[1].pageX);
            var y = 0.5 * (event.touches[0].pageY + event.touches[1].pageY);
            panEnd.set(x, y);
        }
        panDelta.subVectors(panEnd, panStart).multiplyScalar(scope.panSpeed);
        pan(panDelta.x, panDelta.y);
        panStart.copy(panEnd);
    }
    function handleTouchMoveDolly(event) {
        var dx = event.touches[0].pageX - event.touches[1].pageX;
        var dy = event.touches[0].pageY - event.touches[1].pageY;
        var distance = Math.sqrt(dx * dx + dy * dy);
        dollyEnd.set(0, distance);
        dollyDelta.set(0, Math.pow(dollyEnd.y / dollyStart.y, scope.zoomSpeed));
        dollyOut(dollyDelta.y);
        dollyStart.copy(dollyEnd);
    }
    function handleTouchMoveDollyPan(event) {
        if (scope.enableZoom) handleTouchMoveDolly(event);
        if (scope.enablePan) handleTouchMovePan(event);
    }
    function handleTouchMoveDollyRotate(event) {
        if (scope.enableZoom) handleTouchMoveDolly(event);
        if (scope.enableRotate) handleTouchMoveRotate(event);
    }
    function handleTouchEnd() {
    // no-op
    }
    //
    // event handlers - FSM: listen for events and reset state
    //
    function onPointerDown(event) {
        if (scope.enabled === false) return;
        switch(event.pointerType){
            case 'mouse':
            case 'pen':
                onMouseDown(event);
                break;
        }
    }
    function onPointerMove(event) {
        if (scope.enabled === false) return;
        switch(event.pointerType){
            case 'mouse':
            case 'pen':
                onMouseMove(event);
                break;
        }
    }
    function onPointerUp(event) {
        switch(event.pointerType){
            case 'mouse':
            case 'pen':
                onMouseUp(event);
                break;
        }
    }
    function onMouseDown(event) {
        // Prevent the browser from scrolling.
        event.preventDefault();
        // Manually set the focus since calling preventDefault above
        // prevents the browser from setting it automatically.
        scope.domElement.focus ? scope.domElement.focus() : window.focus();
        var mouseAction;
        switch(event.button){
            case 0:
                mouseAction = scope.mouseButtons.LEFT;
                break;
            case 1:
                mouseAction = scope.mouseButtons.MIDDLE;
                break;
            case 2:
                mouseAction = scope.mouseButtons.RIGHT;
                break;
            default:
                mouseAction = -1;
        }
        switch(mouseAction){
            case (0, $eq1Fs.MOUSE).DOLLY:
                if (scope.enableZoom === false) return;
                handleMouseDownDolly(event);
                state = STATE.DOLLY;
                break;
            case (0, $eq1Fs.MOUSE).ROTATE:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (scope.enablePan === false) return;
                    handleMouseDownPan(event);
                    state = STATE.PAN;
                } else {
                    if (scope.enableRotate === false) return;
                    handleMouseDownRotate(event);
                    state = STATE.ROTATE;
                }
                break;
            case (0, $eq1Fs.MOUSE).PAN:
                if (event.ctrlKey || event.metaKey || event.shiftKey) {
                    if (scope.enableRotate === false) return;
                    handleMouseDownRotate(event);
                    state = STATE.ROTATE;
                } else {
                    if (scope.enablePan === false) return;
                    handleMouseDownPan(event);
                    state = STATE.PAN;
                }
                break;
            default:
                state = STATE.NONE;
        }
        if (state !== STATE.NONE) {
            scope.domElement.ownerDocument.addEventListener('pointermove', onPointerMove);
            scope.domElement.ownerDocument.addEventListener('pointerup', onPointerUp);
            scope.dispatchEvent(startEvent);
        }
    }
    function onMouseMove(event) {
        if (scope.enabled === false) return;
        event.preventDefault();
        switch(state){
            case STATE.ROTATE:
                if (scope.enableRotate === false) return;
                handleMouseMoveRotate(event);
                break;
            case STATE.DOLLY:
                if (scope.enableZoom === false) return;
                handleMouseMoveDolly(event);
                break;
            case STATE.PAN:
                if (scope.enablePan === false) return;
                handleMouseMovePan(event);
                break;
        }
    }
    function onMouseUp(event) {
        scope.domElement.ownerDocument.removeEventListener('pointermove', onPointerMove);
        scope.domElement.ownerDocument.removeEventListener('pointerup', onPointerUp);
        if (scope.enabled === false) return;
        handleMouseUp(event);
        scope.dispatchEvent(endEvent);
        state = STATE.NONE;
    }
    function onMouseWheel(event) {
        if (scope.enabled === false || scope.enableZoom === false || state !== STATE.NONE && state !== STATE.ROTATE) return;
        event.preventDefault();
        event.stopPropagation();
        scope.dispatchEvent(startEvent);
        handleMouseWheel(event);
        scope.dispatchEvent(endEvent);
    }
    function onKeyDown(event) {
        if (scope.enabled === false || scope.enablePan === false) return;
        handleKeyDown(event);
    }
    function onTouchStart(event) {
        if (scope.enabled === false) return;
        event.preventDefault(); // prevent scrolling
        switch(event.touches.length){
            case 1:
                switch(scope.touches.ONE){
                    case (0, $eq1Fs.TOUCH).ROTATE:
                        if (scope.enableRotate === false) return;
                        handleTouchStartRotate(event);
                        state = STATE.TOUCH_ROTATE;
                        break;
                    case (0, $eq1Fs.TOUCH).PAN:
                        if (scope.enablePan === false) return;
                        handleTouchStartPan(event);
                        state = STATE.TOUCH_PAN;
                        break;
                    default:
                        state = STATE.NONE;
                }
                break;
            case 2:
                switch(scope.touches.TWO){
                    case (0, $eq1Fs.TOUCH).DOLLY_PAN:
                        if (scope.enableZoom === false && scope.enablePan === false) return;
                        handleTouchStartDollyPan(event);
                        state = STATE.TOUCH_DOLLY_PAN;
                        break;
                    case (0, $eq1Fs.TOUCH).DOLLY_ROTATE:
                        if (scope.enableZoom === false && scope.enableRotate === false) return;
                        handleTouchStartDollyRotate(event);
                        state = STATE.TOUCH_DOLLY_ROTATE;
                        break;
                    default:
                        state = STATE.NONE;
                }
                break;
            default:
                state = STATE.NONE;
        }
        if (state !== STATE.NONE) scope.dispatchEvent(startEvent);
    }
    function onTouchMove(event) {
        if (scope.enabled === false) return;
        event.preventDefault(); // prevent scrolling
        event.stopPropagation();
        switch(state){
            case STATE.TOUCH_ROTATE:
                if (scope.enableRotate === false) return;
                handleTouchMoveRotate(event);
                scope.update();
                break;
            case STATE.TOUCH_PAN:
                if (scope.enablePan === false) return;
                handleTouchMovePan(event);
                scope.update();
                break;
            case STATE.TOUCH_DOLLY_PAN:
                if (scope.enableZoom === false && scope.enablePan === false) return;
                handleTouchMoveDollyPan(event);
                scope.update();
                break;
            case STATE.TOUCH_DOLLY_ROTATE:
                if (scope.enableZoom === false && scope.enableRotate === false) return;
                handleTouchMoveDollyRotate(event);
                scope.update();
                break;
            default:
                state = STATE.NONE;
        }
    }
    function onTouchEnd(event) {
        if (scope.enabled === false) return;
        handleTouchEnd(event);
        scope.dispatchEvent(endEvent);
        state = STATE.NONE;
    }
    function onContextMenu(event) {
        if (scope.enabled === false) return;
        event.preventDefault();
    }
    //
    scope.domElement.addEventListener('contextmenu', onContextMenu);
    scope.domElement.addEventListener('pointerdown', onPointerDown);
    scope.domElement.addEventListener('wheel', onMouseWheel);
    scope.domElement.addEventListener('touchstart', onTouchStart);
    scope.domElement.addEventListener('touchend', onTouchEnd);
    scope.domElement.addEventListener('touchmove', onTouchMove);
    // force an update at start
    this.update();
};
$ac97ba1014cae2cd$export$8ff7788029dfdf52.prototype = Object.create((0, $eq1Fs.EventDispatcher).prototype);
$ac97ba1014cae2cd$export$8ff7788029dfdf52.prototype.constructor = $ac97ba1014cae2cd$export$8ff7788029dfdf52;
// This set of controls performs orbiting, dollying (zooming), and panning.
// Unlike TrackballControls, it maintains the "up" direction object.up (+Y by default).
// This is very similar to OrbitControls, another set of touch behavior
//
//    Orbit - right mouse, or left mouse + ctrl/meta/shiftKey / touch: two-finger rotate
//    Zoom - middle mouse, or mousewheel / touch: two-finger spread or squish
//    Pan - left mouse, or arrow keys / touch: one-finger move
var $ac97ba1014cae2cd$export$7628ccdac312035f = function(object, domElement) {
    $ac97ba1014cae2cd$export$8ff7788029dfdf52.call(this, object, domElement);
    this.screenSpacePanning = false; // pan orthogonal to world-space direction camera.up
    this.mouseButtons.LEFT = (0, $eq1Fs.MOUSE).PAN;
    this.mouseButtons.RIGHT = (0, $eq1Fs.MOUSE).ROTATE;
    this.touches.ONE = (0, $eq1Fs.TOUCH).PAN;
    this.touches.TWO = (0, $eq1Fs.TOUCH).DOLLY_ROTATE;
};
$ac97ba1014cae2cd$export$7628ccdac312035f.prototype = Object.create((0, $eq1Fs.EventDispatcher).prototype);
$ac97ba1014cae2cd$export$7628ccdac312035f.prototype.constructor = $ac97ba1014cae2cd$export$7628ccdac312035f;


var $480c19973a73a2be$exports = {};
"use strict";
Object.defineProperty($480c19973a73a2be$exports, "__esModule", {
    value: true
});
var $480c19973a73a2be$var$LabelRenderParams = function() {
    function LabelRenderParams(pointIndices, labelStrings, scaleFactors, useSceneOpacityFlags, defaultFontSize, fillColors, strokeColors) {
        this.pointIndices = pointIndices;
        this.labelStrings = labelStrings;
        this.scaleFactors = scaleFactors;
        this.useSceneOpacityFlags = useSceneOpacityFlags;
        this.defaultFontSize = defaultFontSize;
        this.fillColors = fillColors;
        this.strokeColors = strokeColors;
    }
    return LabelRenderParams;
}();
$480c19973a73a2be$exports.LabelRenderParams = $480c19973a73a2be$var$LabelRenderParams;
var $480c19973a73a2be$var$CameraType;
(function(CameraType) {
    CameraType[CameraType["Perspective"] = 0] = "Perspective";
    CameraType[CameraType["Orthographic"] = 1] = "Orthographic";
})($480c19973a73a2be$var$CameraType = $480c19973a73a2be$exports.CameraType || ($480c19973a73a2be$exports.CameraType = {}));
var $480c19973a73a2be$var$RenderContext = function() {
    function RenderContext(camera, cameraType, cameraTarget, screenWidth, screenHeight, nearestCameraSpacePointZ, farthestCameraSpacePointZ, backgroundColor, pointColors, pointScaleFactors, labels, polylineColors, polylineOpacities, polylineWidths) {
        this.camera = camera;
        this.cameraType = cameraType;
        this.cameraTarget = cameraTarget;
        this.screenWidth = screenWidth;
        this.screenHeight = screenHeight;
        this.nearestCameraSpacePointZ = nearestCameraSpacePointZ;
        this.farthestCameraSpacePointZ = farthestCameraSpacePointZ;
        this.backgroundColor = backgroundColor;
        this.pointColors = pointColors;
        this.pointScaleFactors = pointScaleFactors;
        this.labels = labels;
        this.polylineColors = polylineColors;
        this.polylineOpacities = polylineOpacities;
        this.polylineWidths = polylineWidths;
    }
    return RenderContext;
}();
$480c19973a73a2be$exports.RenderContext = $480c19973a73a2be$var$RenderContext;


var $18e0ef071f720394$exports = {};
"use strict";
Object.defineProperty($18e0ef071f720394$exports, "__esModule", {
    value: true
});

var $eq1Fs = parcelRequire("eq1Fs");
function $18e0ef071f720394$var$vector3DToScreenCoords(cam, w, h, v) {
    var dpr = window.devicePixelRatio;
    var pv = new $eq1Fs.Vector3().copy(v).project(cam);
    var coords = [
        (pv.x + 1) / 2 * w * dpr,
        -((pv.y - 1) / 2 * h) * dpr
    ];
    return coords;
}
$18e0ef071f720394$exports.vector3DToScreenCoords = $18e0ef071f720394$var$vector3DToScreenCoords;
function $18e0ef071f720394$var$vector3FromPackedArray(a, pointIndex) {
    var offset = pointIndex * 3;
    return new $eq1Fs.Vector3(a[offset], a[offset + 1], a[offset + 2]);
}
$18e0ef071f720394$exports.vector3FromPackedArray = $18e0ef071f720394$var$vector3FromPackedArray;
function $18e0ef071f720394$var$getNearFarPoints(worldSpacePoints, cameraPos, cameraTarget) {
    var shortestDist = Infinity;
    var furthestDist = 0;
    var camToTarget = new $eq1Fs.Vector3().copy(cameraTarget).sub(cameraPos);
    var camPlaneNormal = new $eq1Fs.Vector3().copy(camToTarget).normalize();
    var n = worldSpacePoints.length / 3;
    var src = 0;
    var p = new $eq1Fs.Vector3();
    var camToPoint = new $eq1Fs.Vector3();
    for(var i = 0; i < n; i++){
        p.x = worldSpacePoints[src];
        p.y = worldSpacePoints[src + 1];
        p.z = worldSpacePoints[src + 2];
        src += 3;
        camToPoint.copy(p).sub(cameraPos);
        var dist = camPlaneNormal.dot(camToPoint);
        if (dist < 0) continue;
        furthestDist = dist > furthestDist ? dist : furthestDist;
        shortestDist = dist < shortestDist ? dist : shortestDist;
    }
    return [
        shortestDist,
        furthestDist
    ];
}
$18e0ef071f720394$exports.getNearFarPoints = $18e0ef071f720394$var$getNearFarPoints;
function $18e0ef071f720394$var$prepareTexture(texture, needsUpdate) {
    if (needsUpdate === void 0) needsUpdate = true;
    texture.needsUpdate = needsUpdate;
    texture.minFilter = $eq1Fs.LinearFilter;
    texture.generateMipmaps = false;
    texture.flipY = false;
    return texture;
}
function $18e0ef071f720394$var$createTextureFromCanvas(image) {
    var texture = new $eq1Fs.Texture(image);
    return $18e0ef071f720394$var$prepareTexture(texture);
}
$18e0ef071f720394$exports.createTextureFromCanvas = $18e0ef071f720394$var$createTextureFromCanvas;
function $18e0ef071f720394$var$createTextureFromImage(image, onImageLoad) {
    var texture = new $eq1Fs.Texture(image);
    if (image.complete) {
        texture.needsUpdate = true;
        onImageLoad();
    } else image.onload = function() {
        texture.needsUpdate = true;
        onImageLoad();
    };
    return $18e0ef071f720394$var$prepareTexture(texture, false);
}
$18e0ef071f720394$exports.createTextureFromImage = $18e0ef071f720394$var$createTextureFromImage;
function $18e0ef071f720394$var$hasWebGLSupport() {
    try {
        var c = document.createElement('canvas');
        var gl = c.getContext('webgl') || c.getContext('experimental-webgl');
        return gl != null;
    } catch (e) {
        return false;
    }
}
$18e0ef071f720394$exports.hasWebGLSupport = $18e0ef071f720394$var$hasWebGLSupport;
function $18e0ef071f720394$var$extent(data) {
    var minimum = Infinity;
    var maximum = -Infinity;
    for(var i = 0; i < data.length; i++){
        var item = data[i];
        if (item < minimum) minimum = item;
        if (item > maximum) maximum = item;
    }
    return [
        minimum,
        maximum
    ];
}
$18e0ef071f720394$exports.extent = $18e0ef071f720394$var$extent;
function $18e0ef071f720394$var$scaleLinear(value, domain, range) {
    var domainDifference = domain[1] - domain[0];
    var rangeDifference = range[1] - range[0];
    var percentDomain = (value - domain[0]) / domainDifference;
    return percentDomain * rangeDifference + range[0];
}
$18e0ef071f720394$exports.scaleLinear = $18e0ef071f720394$var$scaleLinear;
function $18e0ef071f720394$var$scaleExponential(value, domain, range) {
    var domainDifference = Math.pow(domain[1], Math.E) - Math.pow(domain[0], Math.E);
    var rangeDifference = range[1] - range[0];
    var percentDomain = (Math.pow(value, Math.E) - domain[0]) / domainDifference;
    return percentDomain * rangeDifference + range[0];
}
$18e0ef071f720394$exports.scaleExponential = $18e0ef071f720394$var$scaleExponential;
function $18e0ef071f720394$var$packRgbIntoUint8Array(rgbArray, labelIndex, r, g, b) {
    rgbArray[labelIndex * 3] = r;
    rgbArray[labelIndex * 3 + 1] = g;
    rgbArray[labelIndex * 3 + 2] = b;
}
$18e0ef071f720394$exports.packRgbIntoUint8Array = $18e0ef071f720394$var$packRgbIntoUint8Array;
function $18e0ef071f720394$var$styleRgbFromHexColor(hex) {
    var c = new $eq1Fs.Color(hex);
    return [
        c.r * 255 | 0,
        c.g * 255 | 0,
        c.b * 255 | 0
    ];
}
$18e0ef071f720394$exports.styleRgbFromHexColor = $18e0ef071f720394$var$styleRgbFromHexColor;
var $18e0ef071f720394$var$toPercent = function(percent) {
    return 100 * percent + "%";
};
function $18e0ef071f720394$var$getDefaultPointInPolylineColor(index, totalPoints, startHue, endHue, saturation, lightness) {
    var hue = startHue + (endHue - startHue) * index / totalPoints;
    var hsl = "hsl(" + hue + ", " + $18e0ef071f720394$var$toPercent(saturation) + ", " + $18e0ef071f720394$var$toPercent(lightness) + ")";
    return new $eq1Fs.Color(hsl);
}
$18e0ef071f720394$exports.getDefaultPointInPolylineColor = $18e0ef071f720394$var$getDefaultPointInPolylineColor;


var $c6cbaeb5baba58b4$exports = {};
"use strict";
Object.defineProperty($c6cbaeb5baba58b4$exports, "__esModule", {
    value: true
});
var $c6cbaeb5baba58b4$var$ScatterPlotRectangleSelector = function() {
    function ScatterPlotRectangleSelector(container, selectionCallback, styles) {
        this.startCoordinates = [
            0,
            0
        ];
        this.svgElement = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
        this.svgElement.style.display = 'none';
        this.svgElement.style.height = '100%';
        this.svgElement.style.width = '100%';
        this.svgElement.style.position = 'absolute';
        container.insertAdjacentElement('afterbegin', this.svgElement);
        this.rectElement = document.createElementNS('http://www.w3.org/2000/svg', 'rect');
        this.rectElement.style.stroke = styles.select.stroke;
        this.rectElement.style.strokeDasharray = styles.select.strokeDashArray;
        this.rectElement.style.strokeWidth = "" + styles.select.strokeWidth;
        this.rectElement.style.fill = styles.select.fill;
        this.rectElement.style.fillOpacity = "" + styles.select.fillOpacity;
        this.svgElement.appendChild(this.rectElement);
        this.selectionCallback = selectionCallback;
        this.isMouseDown = false;
    }
    ScatterPlotRectangleSelector.prototype.onMouseDown = function(offsetX, offsetY) {
        this.isMouseDown = true;
        this.rectElement.style.display = 'block';
        this.svgElement.style.display = 'block';
        this.startCoordinates = [
            offsetX,
            offsetY
        ];
        this.lastBoundingBox = {
            x: this.startCoordinates[0],
            y: this.startCoordinates[1],
            width: 1,
            height: 1
        };
    };
    ScatterPlotRectangleSelector.prototype.onMouseMove = function(offsetX, offsetY) {
        if (!this.isMouseDown) return;
        this.lastBoundingBox.x = Math.min(offsetX, this.startCoordinates[0]);
        this.lastBoundingBox.y = Math.max(offsetY, this.startCoordinates[1]);
        this.lastBoundingBox.width = Math.max(offsetX, this.startCoordinates[0]) - this.lastBoundingBox.x;
        this.lastBoundingBox.height = this.lastBoundingBox.y - Math.min(offsetY, this.startCoordinates[1]);
        this.rectElement.setAttribute('x', '' + this.lastBoundingBox.x);
        this.rectElement.setAttribute('y', '' + (this.lastBoundingBox.y - this.lastBoundingBox.height));
        this.rectElement.setAttribute('width', '' + this.lastBoundingBox.width);
        this.rectElement.setAttribute('height', '' + this.lastBoundingBox.height);
    };
    ScatterPlotRectangleSelector.prototype.onMouseUp = function() {
        this.isMouseDown = false;
        this.svgElement.style.display = 'none';
        this.rectElement.style.display = 'none';
        this.rectElement.setAttribute('width', '0');
        this.rectElement.setAttribute('height', '0');
        this.selectionCallback(this.lastBoundingBox);
    };
    return ScatterPlotRectangleSelector;
}();
$c6cbaeb5baba58b4$exports.ScatterPlotRectangleSelector = $c6cbaeb5baba58b4$var$ScatterPlotRectangleSelector;


var $31a6dfd76139c96e$var$CUBE_LENGTH = 2;
var $31a6dfd76139c96e$var$MAX_ZOOM = 5 * $31a6dfd76139c96e$var$CUBE_LENGTH;
var $31a6dfd76139c96e$var$MIN_ZOOM = 0.025 * $31a6dfd76139c96e$var$CUBE_LENGTH;
var $31a6dfd76139c96e$var$PERSP_CAMERA_FOV_VERTICAL = 70;
var $31a6dfd76139c96e$var$PERSP_CAMERA_NEAR_CLIP_PLANE = 0.01;
var $31a6dfd76139c96e$var$PERSP_CAMERA_FAR_CLIP_PLANE = 100;
var $31a6dfd76139c96e$var$ORTHO_CAMERA_FRUSTUM_HALF_EXTENT = 1.2;
var $31a6dfd76139c96e$var$SHIFT_KEY = 'Shift';
var $31a6dfd76139c96e$var$CTRL_KEY = 'Control';
var $31a6dfd76139c96e$var$START_CAMERA_POS_3D = new $eq1Fs.Vector3(0.45, 0.9, 1.6);
var $31a6dfd76139c96e$var$START_CAMERA_TARGET_3D = new $eq1Fs.Vector3(0, 0, 0);
var $31a6dfd76139c96e$var$START_CAMERA_POS_2D = new $eq1Fs.Vector3(0, 0, 4);
var $31a6dfd76139c96e$var$START_CAMERA_TARGET_2D = new $eq1Fs.Vector3(0, 0, 0);
var $31a6dfd76139c96e$var$DEFAULT_ORBIT_CONTROL_PARAMS = {
    mouseRotateSpeed: 1,
    autoRotateSpeed: 2,
    zoomSpeed: 0.125
};
var $31a6dfd76139c96e$var$ScatterPlot = function() {
    function ScatterPlot(containerElement, params) {
        var _this = this;
        this.clickCallback = function() {};
        this.hoverCallback = function() {};
        this.selectCallback = function() {};
        this.selectEnabled = true;
        this.visualizers = new Map();
        this.onCameraMoveListeners = [];
        this.height = 0;
        this.width = 0;
        this.dimensions = 3;
        this.interactionMode = "PAN";
        this.pickingTexture = new $eq1Fs.WebGLRenderTarget(0, 0);
        this.orbitAnimationOnNextCameraCreation = false;
        this.orbitAnimationId = null;
        this.worldSpacePointPositions = new Float32Array(0);
        this.pointColors = new Float32Array(0);
        this.pointScaleFactors = new Float32Array(0);
        this.polylineColors = {};
        this.polylineOpacities = new Float32Array(0);
        this.polylineWidths = new Float32Array(0);
        this.selecting = false;
        this.nearestPoint = null;
        this.mouseIsDown = false;
        this.isDragSequence = false;
        this.lastHovered = null;
        this.container = containerElement;
        this.styles = params.styles;
        this.setParameters(params);
        this.computeLayoutValues();
        this.scene = new $eq1Fs.Scene();
        this.renderer = new $eq1Fs.WebGLRenderer({
            alpha: true,
            premultipliedAlpha: false,
            antialias: false
        });
        this.renderer.setClearColor(this.styles.backgroundColor, 1);
        this.container.appendChild(this.renderer.domElement);
        this.light = new $eq1Fs.PointLight(0xffecbf, 1, 0);
        this.scene.add(this.light);
        this.orbitControlParams = $31a6dfd76139c96e$var$__assign($31a6dfd76139c96e$var$__assign({}, $31a6dfd76139c96e$var$DEFAULT_ORBIT_CONTROL_PARAMS), params.orbitControlParams);
        this.rectangleSelector = new $c6cbaeb5baba58b4$exports.ScatterPlotRectangleSelector(this.container, function(boundingBox) {
            _this.selectBoundingBox(boundingBox);
        }, this.styles);
        this.addInteractionListeners();
        this.setDimensions(3);
        this.makeCamera(params.camera);
        this.resize();
    }
    ScatterPlot.prototype.setParameters = function(p) {
        if (p.onClick !== undefined) this.clickCallback = p.onClick;
        if (p.onHover !== undefined) this.hoverCallback = p.onHover;
        if (p.onSelect !== undefined) this.selectCallback = p.onSelect;
        if (p.selectEnabled !== undefined) this.selectEnabled = p.selectEnabled;
    };
    ScatterPlot.prototype.addInteractionListeners = function() {
        this.container.addEventListener('pointermove', this.onMouseMove.bind(this));
        this.container.addEventListener('pointerdown', this.onMouseDown.bind(this));
        this.container.addEventListener('pointerup', this.onMouseUp.bind(this));
        this.container.addEventListener('click', this.onClick.bind(this));
        window.addEventListener('keydown', this.onKeyDown.bind(this), false);
        window.addEventListener('keyup', this.onKeyUp.bind(this), false);
    };
    ScatterPlot.prototype.addCameraControlsEventListeners = function(cameraControls) {
        var _this = this;
        cameraControls.addEventListener('start', function() {
            _this.stopOrbitAnimation();
            _this.onCameraMoveListeners.forEach(function(l) {
                return l(_this.camera.position, cameraControls.target);
            });
        });
        cameraControls.addEventListener('change', function() {
            _this.render();
        });
        cameraControls.addEventListener('end', function() {});
    };
    ScatterPlot.prototype.makeOrbitControls = function(camera, cameraIs3D) {
        if (this.orbitCameraControls != null) this.orbitCameraControls.dispose();
        var occ = new $ac97ba1014cae2cd$export$8ff7788029dfdf52(camera, this.renderer.domElement);
        occ.zoomSpeed = this.orbitControlParams.zoomSpeed;
        occ.enableRotate = cameraIs3D;
        occ.autoRotate = false;
        occ.enableKeys = false;
        occ.rotateSpeed = this.orbitControlParams.mouseRotateSpeed;
        if (cameraIs3D) {
            occ.mouseButtons.LEFT = $eq1Fs.MOUSE.LEFT;
            occ.mouseButtons.RIGHT = $eq1Fs.MOUSE.RIGHT;
        } else {
            occ.mouseButtons.LEFT = $eq1Fs.MOUSE.RIGHT;
            occ.mouseButtons.RIGHT = $eq1Fs.MOUSE.LEFT;
        }
        occ.reset();
        this.camera = camera;
        this.orbitCameraControls = occ;
        this.addCameraControlsEventListeners(this.orbitCameraControls);
    };
    ScatterPlot.prototype.makeCamera = function(cameraParams) {
        if (cameraParams === void 0) cameraParams = {};
        var def = this.makeDefaultCameraDef(this.dimensions, cameraParams);
        this.recreateCamera(def);
        if (this.dimensions === 3 && this.styles.axesVisible) this.add3dAxes();
        else this.remove3dAxesFromScene();
    };
    ScatterPlot.prototype.makeCamera3D = function(cameraDef, w, h) {
        var camera;
        var aspectRatio = w / h;
        camera = new $eq1Fs.PerspectiveCamera($31a6dfd76139c96e$var$PERSP_CAMERA_FOV_VERTICAL, aspectRatio, $31a6dfd76139c96e$var$PERSP_CAMERA_NEAR_CLIP_PLANE, $31a6dfd76139c96e$var$PERSP_CAMERA_FAR_CLIP_PLANE);
        camera.position.set(cameraDef.position[0], cameraDef.position[1], cameraDef.position[2]);
        var at = new $eq1Fs.Vector3(cameraDef.target[0], cameraDef.target[1], cameraDef.target[2]);
        camera.lookAt(at);
        camera.zoom = cameraDef.zoom;
        camera.updateProjectionMatrix();
        this.camera = camera;
        this.makeOrbitControls(camera, true);
    };
    ScatterPlot.prototype.makeCamera2D = function(cameraDef, w, h) {
        var camera;
        var target = new $eq1Fs.Vector3(cameraDef.target[0], cameraDef.target[1], cameraDef.target[2]);
        var aspectRatio = w / h;
        var left = -$31a6dfd76139c96e$var$ORTHO_CAMERA_FRUSTUM_HALF_EXTENT;
        var right = $31a6dfd76139c96e$var$ORTHO_CAMERA_FRUSTUM_HALF_EXTENT;
        var bottom = -$31a6dfd76139c96e$var$ORTHO_CAMERA_FRUSTUM_HALF_EXTENT;
        var top_1 = $31a6dfd76139c96e$var$ORTHO_CAMERA_FRUSTUM_HALF_EXTENT;
        if (aspectRatio > 1) {
            left *= aspectRatio;
            right *= aspectRatio;
        } else {
            top_1 /= aspectRatio;
            bottom /= aspectRatio;
        }
        camera = new $eq1Fs.OrthographicCamera(left, right, top_1, bottom, -1000, 1000);
        camera.position.set(cameraDef.position[0], cameraDef.position[1], cameraDef.position[2]);
        camera.up = new $eq1Fs.Vector3(0, 0, 1);
        camera.lookAt(target);
        camera.zoom = cameraDef.zoom;
        camera.updateProjectionMatrix();
        this.camera = camera;
        this.makeOrbitControls(camera, false);
    };
    ScatterPlot.prototype.makeDefaultCameraDef = function(dimensions, cameraParams) {
        if (cameraParams === void 0) cameraParams = {};
        var orthographic = dimensions === 2;
        var position = orthographic ? $31a6dfd76139c96e$var$START_CAMERA_POS_2D : $31a6dfd76139c96e$var$START_CAMERA_POS_3D;
        var target = orthographic ? $31a6dfd76139c96e$var$START_CAMERA_TARGET_2D : $31a6dfd76139c96e$var$START_CAMERA_TARGET_3D;
        var def = {
            orthographic: orthographic,
            zoom: 1.0,
            position: [
                position.x,
                position.y,
                position.z
            ],
            target: [
                target.x,
                target.y,
                target.z
            ]
        };
        if (cameraParams.zoom) def.zoom = cameraParams.zoom;
        if (cameraParams.position) def.position = cameraParams.position;
        if (cameraParams.target) def.target = cameraParams.target;
        return def;
    };
    ScatterPlot.prototype.recreateCamera = function(cameraDef) {
        if (cameraDef.orthographic) this.makeCamera2D(cameraDef, this.width, this.height);
        else this.makeCamera3D(cameraDef, this.width, this.height);
        this.orbitCameraControls.minDistance = $31a6dfd76139c96e$var$MIN_ZOOM;
        this.orbitCameraControls.maxDistance = $31a6dfd76139c96e$var$MAX_ZOOM;
        this.orbitCameraControls.update();
        if (this.orbitAnimationOnNextCameraCreation) this.startOrbitAnimation();
    };
    ScatterPlot.prototype.setInteractionMode = function(interactionMode) {
        this.interactionMode = interactionMode;
        if (interactionMode === "SELECT") {
            this.selecting = true;
            this.container.style.cursor = 'crosshair';
            this.orbitCameraControls.enabled = false;
        } else {
            this.selecting = false;
            this.container.style.cursor = 'default';
            this.orbitCameraControls.enabled = true;
        }
    };
    ScatterPlot.prototype.onClick = function(e, notify) {
        if (notify === void 0) notify = true;
        if (e && this.selecting) return;
        if (!this.isDragSequence && notify) {
            if (this.selectEnabled) {
                var selected = this.nearestPoint != null ? [
                    this.nearestPoint
                ] : [];
                this.selectCallback(selected);
            }
            this.clickCallback(this.nearestPoint);
        }
        this.isDragSequence = false;
        this.render();
    };
    ScatterPlot.prototype.onMouseDown = function(e) {
        this.isDragSequence = false;
        this.mouseIsDown = true;
        if (this.selecting) {
            this.rectangleSelector.onMouseDown(e.offsetX, e.offsetY);
            this.setNearestPointToMouse(e);
        } else if (!e.ctrlKey && this.sceneIs3D() && this.orbitCameraControls.mouseButtons.ORBIT === $eq1Fs.MOUSE.RIGHT) {
            this.orbitCameraControls.mouseButtons.ORBIT = $eq1Fs.MOUSE.LEFT;
            this.orbitCameraControls.mouseButtons.PAN = $eq1Fs.MOUSE.RIGHT;
        } else if (e.ctrlKey && this.sceneIs3D() && this.orbitCameraControls.mouseButtons.ORBIT === $eq1Fs.MOUSE.LEFT) {
            this.orbitCameraControls.mouseButtons.ORBIT = $eq1Fs.MOUSE.RIGHT;
            this.orbitCameraControls.mouseButtons.PAN = $eq1Fs.MOUSE.LEFT;
        }
    };
    ScatterPlot.prototype.onMouseUp = function(e) {
        if (this.selecting) {
            this.rectangleSelector.onMouseUp();
            this.render();
        }
        this.mouseIsDown = false;
    };
    ScatterPlot.prototype.onMouseMove = function(e) {
        this.isDragSequence = this.mouseIsDown;
        if (this.selecting && this.mouseIsDown) {
            this.rectangleSelector.onMouseMove(e.offsetX, e.offsetY);
            this.render();
        } else if (!this.mouseIsDown) {
            this.setNearestPointToMouse(e);
            if (this.nearestPoint != this.lastHovered) {
                this.lastHovered = this.nearestPoint;
                this.hoverCallback(this.nearestPoint);
            }
        }
    };
    ScatterPlot.prototype.onKeyDown = function(e) {
        if (e.key === $31a6dfd76139c96e$var$CTRL_KEY && this.sceneIs3D()) {
            this.orbitCameraControls.mouseButtons.ORBIT = $eq1Fs.MOUSE.RIGHT;
            this.orbitCameraControls.mouseButtons.PAN = $eq1Fs.MOUSE.LEFT;
        }
        if (e.key === $31a6dfd76139c96e$var$SHIFT_KEY && this.selectEnabled) {
            this.selecting = true;
            this.orbitCameraControls.enabled = false;
            this.container.style.cursor = 'crosshair';
        }
    };
    ScatterPlot.prototype.onKeyUp = function(e) {
        if (e.key === $31a6dfd76139c96e$var$CTRL_KEY && this.sceneIs3D()) {
            this.orbitCameraControls.mouseButtons.ORBIT = $eq1Fs.MOUSE.LEFT;
            this.orbitCameraControls.mouseButtons.PAN = $eq1Fs.MOUSE.RIGHT;
        }
        if (e.key === $31a6dfd76139c96e$var$SHIFT_KEY && this.selectEnabled) {
            this.selecting = false;
            this.orbitCameraControls.enabled = true;
            this.container.style.cursor = 'default';
            this.render();
        }
    };
    ScatterPlot.prototype.getPointIndicesFromBoundingBox = function(boundingBox) {
        if (this.worldSpacePointPositions == null) return [];
        this.camera.updateMatrixWorld();
        var dpr = window.devicePixelRatio || 1;
        var selectionX = Math.floor(boundingBox.x * dpr);
        var selectionY = Math.floor(boundingBox.y * dpr);
        var selectionWidth = Math.max(Math.floor(boundingBox.width * dpr), 1);
        var selectionHeight = Math.max(Math.floor(boundingBox.height * dpr), 1);
        if (selectionWidth <= 2 && selectionHeight <= 2) return this.getPointIndicesFromBoundingBoxPickingTexture(boundingBox);
        var canvas = this.renderer.domElement;
        var canvasWidth = canvas.width;
        var canvasHeight = canvas.height;
        var pointIndices = [];
        var vector3 = new $eq1Fs.Vector3();
        for(var i = 0; i < this.worldSpacePointPositions.length; i++){
            var start = i * 3;
            var _a = $31a6dfd76139c96e$var$__read(this.worldSpacePointPositions.slice(start, start + 3), 3), worldX = _a[0], worldY = _a[1], worldZ = _a[2];
            vector3.x = worldX;
            vector3.y = worldY;
            vector3.z = worldZ;
            var screenVector = vector3.project(this.camera);
            var x = (screenVector.x + 1) * canvasWidth / 2;
            var y = -(screenVector.y - 1) * canvasHeight / 2;
            if (x >= selectionX && x <= selectionX + selectionWidth) {
                if (y <= selectionY && y >= selectionY - selectionHeight) pointIndices.push(i);
            }
        }
        return pointIndices;
    };
    ScatterPlot.prototype.getPointIndicesFromBoundingBoxPickingTexture = function(boundingBox) {
        if (this.worldSpacePointPositions == null) return [];
        var pointCount = this.worldSpacePointPositions.length / 3;
        var dpr = window.devicePixelRatio || 1;
        var x = Math.floor(boundingBox.x * dpr);
        var y = Math.floor(boundingBox.y * dpr);
        var width = Math.max(Math.floor(boundingBox.width * dpr), 1);
        var height = Math.max(Math.floor(boundingBox.height * dpr), 1);
        var pixelBuffer = new Uint8Array(width * height * 4);
        this.renderer.readRenderTargetPixels(this.pickingTexture, x, this.pickingTexture.height - y, width, height, pixelBuffer);
        var pointIndicesSelection = new Uint8Array(this.worldSpacePointPositions.length);
        for(var i = 0; i < width * height; i++){
            var id = pixelBuffer[i * 4] << 16 | pixelBuffer[i * 4 + 1] << 8 | pixelBuffer[i * 4 + 2];
            if (id !== 0xffffff && id < pointCount) pointIndicesSelection[id] = 1;
        }
        var pointIndices = [];
        for(var i = 0; i < pointIndicesSelection.length; i++)if (pointIndicesSelection[i] === 1) pointIndices.push(i);
        return pointIndices;
    };
    ScatterPlot.prototype.selectBoundingBox = function(boundingBox) {
        var pointIndices = this.getPointIndicesFromBoundingBox(boundingBox);
        this.selectCallback(pointIndices);
    };
    ScatterPlot.prototype.setNearestPointToMouse = function(e) {
        if (this.pickingTexture == null) {
            this.nearestPoint = null;
            return;
        }
        var boundingBox = {
            x: e.offsetX,
            y: e.offsetY,
            width: 1,
            height: 1
        };
        var pointIndices = this.getPointIndicesFromBoundingBoxPickingTexture(boundingBox);
        this.nearestPoint = pointIndices.length ? pointIndices[0] : null;
    };
    ScatterPlot.prototype.computeLayoutValues = function() {
        this.width = this.container.offsetWidth;
        this.height = Math.max(1, this.container.offsetHeight);
        return [
            this.width,
            this.height
        ];
    };
    ScatterPlot.prototype.sceneIs3D = function() {
        return this.dimensions === 3;
    };
    ScatterPlot.prototype.remove3dAxesFromScene = function() {
        var axes = this.scene.getObjectByName('axes');
        if (axes != null) this.scene.remove(axes);
        return axes;
    };
    ScatterPlot.prototype.add3dAxes = function() {
        var axes = new $eq1Fs.AxesHelper();
        axes.name = 'axes';
        this.scene.add(axes);
    };
    ScatterPlot.prototype.setDimensions = function(dimensions) {
        if (dimensions !== 2 && dimensions !== 3) throw new RangeError('dimensions must be 2 or 3');
        if (this.dimensions !== dimensions) {
            this.dimensions = dimensions;
            this.makeCamera();
        }
    };
    ScatterPlot.prototype.getCameraPosition = function() {
        var currPos = this.camera.position;
        return [
            currPos.x,
            currPos.y,
            currPos.z
        ];
    };
    ScatterPlot.prototype.getCameraTarget = function() {
        var currTarget = this.orbitCameraControls.target;
        return [
            currTarget.x,
            currTarget.y,
            currTarget.z
        ];
    };
    ScatterPlot.prototype.setCameraPositionAndTarget = function(position, target) {
        this.stopOrbitAnimation();
        this.camera.position.set(position[0], position[1], position[2]);
        this.orbitCameraControls.target.set(target[0], target[1], target[2]);
        this.orbitCameraControls.update();
        this.render();
    };
    ScatterPlot.prototype.startOrbitAnimation = function() {
        if (!this.sceneIs3D()) return;
        if (this.orbitAnimationId != null) this.stopOrbitAnimation();
        this.orbitCameraControls.autoRotate = true;
        this.orbitCameraControls.autoRotateSpeed = this.orbitControlParams.autoRotateSpeed;
        this.updateOrbitAnimation();
    };
    ScatterPlot.prototype.orbitIsAnimating = function() {
        return this.orbitAnimationId != null;
    };
    ScatterPlot.prototype.updateOrbitAnimation = function() {
        var _this = this;
        this.orbitCameraControls.update();
        this.orbitAnimationId = requestAnimationFrame(function() {
            return _this.updateOrbitAnimation();
        });
    };
    ScatterPlot.prototype.stopOrbitAnimation = function() {
        this.orbitCameraControls.autoRotate = false;
        this.orbitCameraControls.rotateSpeed = this.orbitControlParams.mouseRotateSpeed;
        if (this.orbitAnimationId != null) {
            cancelAnimationFrame(this.orbitAnimationId);
            this.orbitAnimationId = null;
        }
    };
    ScatterPlot.prototype.setActiveVisualizers = function(visualizers) {
        var e_1, _a, e_2, _b;
        var nextVisualizerIds = new Set(visualizers.map(function(v) {
            return v.id;
        }));
        try {
            for(var _c = $31a6dfd76139c96e$var$__values(this.visualizers.values()), _d = _c.next(); !_d.done; _d = _c.next()){
                var visualizer = _d.value;
                if (!nextVisualizerIds.has(visualizer.id)) {
                    visualizer.dispose();
                    this.visualizers.delete(visualizer.id);
                }
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_d && !_d.done && (_a = _c.return)) _a.call(_c);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        try {
            for(var visualizers_1 = $31a6dfd76139c96e$var$__values(visualizers), visualizers_1_1 = visualizers_1.next(); !visualizers_1_1.done; visualizers_1_1 = visualizers_1.next()){
                var visualizer = visualizers_1_1.value;
                this.visualizers.set(visualizer.id, visualizer);
                visualizer.setScene(this.scene);
                visualizer.onResize(this.width, this.height);
                if (this.worldSpacePointPositions) visualizer.onPointPositionsChanged(this.worldSpacePointPositions);
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (visualizers_1_1 && !visualizers_1_1.done && (_b = visualizers_1.return)) _b.call(visualizers_1);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
    };
    ScatterPlot.prototype.disposeAllVisualizers = function() {
        this.visualizers.forEach(function(v) {
            return v.dispose();
        });
        this.visualizers.clear();
    };
    ScatterPlot.prototype.setPointPositions = function(worldSpacePointPositions) {
        this.worldSpacePointPositions = worldSpacePointPositions;
        this.visualizers.forEach(function(v) {
            return v.onPointPositionsChanged(worldSpacePointPositions);
        });
    };
    ScatterPlot.prototype.render = function() {
        var lightPos = this.camera.position.clone();
        lightPos.x += 1;
        lightPos.y += 1;
        this.light.position.set(lightPos.x, lightPos.y, lightPos.z);
        var cameraType = this.camera instanceof $eq1Fs.PerspectiveCamera ? $480c19973a73a2be$exports.CameraType.Perspective : $480c19973a73a2be$exports.CameraType.Orthographic;
        var cameraSpacePointExtents = [
            0,
            0
        ];
        if (this.worldSpacePointPositions != null) cameraSpacePointExtents = $18e0ef071f720394$exports.getNearFarPoints(this.worldSpacePointPositions, this.camera.position, this.orbitCameraControls.target);
        var rc = new $480c19973a73a2be$exports.RenderContext(this.camera, cameraType, this.orbitCameraControls.target, this.width, this.height, cameraSpacePointExtents[0], cameraSpacePointExtents[1], this.styles.backgroundColor, this.pointColors, this.pointScaleFactors, this.labels, this.polylineColors, this.polylineOpacities, this.polylineWidths);
        this.visualizers.forEach(function(v) {
            return v.onPickingRender(rc);
        });
        var axes = this.remove3dAxesFromScene();
        this.renderer.setRenderTarget(this.pickingTexture);
        this.renderer.render(this.scene, this.camera);
        if (axes != null) this.scene.add(axes);
        this.visualizers.forEach(function(v) {
            return v.onRender(rc);
        });
        this.renderer.setRenderTarget(null);
        this.renderer.render(this.scene, this.camera);
    };
    ScatterPlot.prototype.setPointColors = function(colors) {
        this.pointColors = colors;
    };
    ScatterPlot.prototype.setPointScaleFactors = function(scaleFactors) {
        this.pointScaleFactors = scaleFactors;
    };
    ScatterPlot.prototype.setLabels = function(labels) {
        this.labels = labels;
    };
    ScatterPlot.prototype.setPolylineColors = function(colors) {
        this.polylineColors = colors;
    };
    ScatterPlot.prototype.setPolylineOpacities = function(opacities) {
        this.polylineOpacities = opacities;
    };
    ScatterPlot.prototype.setPolylineWidths = function(widths) {
        this.polylineWidths = widths;
    };
    ScatterPlot.prototype.resetZoom = function() {
        this.recreateCamera(this.makeDefaultCameraDef(this.dimensions));
        this.render();
    };
    ScatterPlot.prototype.setDayNightMode = function(isNight) {
        var canvases = this.container.querySelectorAll('canvas');
        var filterValue = isNight ? 'invert(100%)' : '';
        for(var i = 0; i < canvases.length; i++)canvases[i].style.filter = filterValue;
    };
    ScatterPlot.prototype.resize = function(render) {
        if (render === void 0) render = true;
        var _a = $31a6dfd76139c96e$var$__read([
            this.width,
            this.height
        ], 2), oldW = _a[0], oldH = _a[1];
        var _b = $31a6dfd76139c96e$var$__read(this.computeLayoutValues(), 2), newW = _b[0], newH = _b[1];
        if (this.dimensions === 3) {
            var camera = this.camera;
            camera.aspect = newW / newH;
            camera.updateProjectionMatrix();
        } else {
            var camera = this.camera;
            var scaleW = newW / oldW;
            var scaleH = newH / oldH;
            var newCamHalfWidth = (camera.right - camera.left) * scaleW / 2;
            var newCamHalfHeight = (camera.top - camera.bottom) * scaleH / 2;
            camera.top = newCamHalfHeight;
            camera.bottom = -newCamHalfHeight;
            camera.left = -newCamHalfWidth;
            camera.right = newCamHalfWidth;
            camera.updateProjectionMatrix();
        }
        var dpr = window.devicePixelRatio || 1;
        this.renderer.setPixelRatio(dpr);
        this.renderer.setSize(newW, newH);
        var renderCanvasSize = new $eq1Fs.Vector2();
        this.renderer.getSize(renderCanvasSize);
        var pixelRatio = this.renderer.getPixelRatio();
        this.pickingTexture = new $eq1Fs.WebGLRenderTarget(renderCanvasSize.width * pixelRatio, renderCanvasSize.height * pixelRatio);
        this.pickingTexture.texture.minFilter = $eq1Fs.LinearFilter;
        this.visualizers.forEach(function(v) {
            return v.onResize(newW, newH);
        });
        if (render) this.render();
    };
    ScatterPlot.prototype.onCameraMove = function(listener) {
        this.onCameraMoveListeners.push(listener);
    };
    ScatterPlot.prototype.clickOnPoint = function(pointIndex) {
        this.nearestPoint = pointIndex;
        this.onClick(null, false);
    };
    return ScatterPlot;
}();
$31a6dfd76139c96e$exports.ScatterPlot = $31a6dfd76139c96e$var$ScatterPlot;


var $749a49c2dd17f2c1$exports = {};
"use strict";
var $749a49c2dd17f2c1$var$__read = $749a49c2dd17f2c1$exports && $749a49c2dd17f2c1$exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty($749a49c2dd17f2c1$exports, "__esModule", {
    value: true
});

var $eq1Fs = parcelRequire("eq1Fs");
var $749a49c2dd17f2c1$var$cache = new Map();
var $749a49c2dd17f2c1$var$regex = /^(rgba|hsla)\((\d+),\s*(\d+%?),\s*(\d+%?)(?:,\s*(\d+(?:\.\d+)?))?\)$/;
function $749a49c2dd17f2c1$var$parseOpacity(colorString) {
    var result = $749a49c2dd17f2c1$var$regex.exec(colorString);
    if (result) {
        var _a = $749a49c2dd17f2c1$var$__read(result, 6), _ = _a[0], rgbaOrHsla = _a[1], rh = _a[2], gs = _a[3], bl = _a[4], opacity = _a[5];
        var colorString_1 = rgbaOrHsla.replace('a', '') + "(" + rh + "," + gs + "," + bl + ")";
        return {
            colorString: colorString_1,
            opacity: parseFloat(opacity)
        };
    }
    return {
        colorString: colorString,
        opacity: 1
    };
}
function $749a49c2dd17f2c1$var$parseColor(inputColorString) {
    if ($749a49c2dd17f2c1$var$cache.has(inputColorString)) return $749a49c2dd17f2c1$var$cache.get(inputColorString);
    var _a = $749a49c2dd17f2c1$var$parseOpacity(inputColorString), colorString = _a.colorString, opacity = _a.opacity;
    var color = new $eq1Fs.Color(colorString);
    var r = color.r, g = color.g, b = color.b;
    var item = {
        r: r,
        g: g,
        b: b,
        opacity: opacity
    };
    $749a49c2dd17f2c1$var$cache.set(inputColorString, item);
    return item;
}
$749a49c2dd17f2c1$exports.parseColor = $749a49c2dd17f2c1$var$parseColor;


var $9e8f9a54f1e224ec$exports = {};
"use strict";
var $9e8f9a54f1e224ec$var$__values = $9e8f9a54f1e224ec$exports && $9e8f9a54f1e224ec$exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty($9e8f9a54f1e224ec$exports, "__esModule", {
    value: true
});
var $9e8f9a54f1e224ec$var$DIMENSIONALITY_ERROR_MESSAGE = 'Points must be an array of either 2 or 3 dimensional number arrays';
var $9e8f9a54f1e224ec$var$Dataset = function() {
    function Dataset(points, metadata) {
        var e_1, _a;
        if (metadata === void 0) metadata = [];
        this.points = points;
        this.metadata = metadata;
        var dimensions = points[0].length;
        if (!(dimensions === 2 || dimensions === 3)) throw new Error($9e8f9a54f1e224ec$var$DIMENSIONALITY_ERROR_MESSAGE);
        try {
            for(var points_1 = $9e8f9a54f1e224ec$var$__values(points), points_1_1 = points_1.next(); !points_1_1.done; points_1_1 = points_1.next()){
                var point = points_1_1.value;
                if (dimensions !== point.length) throw new Error($9e8f9a54f1e224ec$var$DIMENSIONALITY_ERROR_MESSAGE);
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (points_1_1 && !points_1_1.done && (_a = points_1.return)) _a.call(points_1);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.dimensions = dimensions;
    }
    Dataset.prototype.setSpriteMetadata = function(spriteMetadata) {
        this.spriteMetadata = spriteMetadata;
    };
    return Dataset;
}();
$9e8f9a54f1e224ec$exports.Dataset = $9e8f9a54f1e224ec$var$Dataset;



var $382a0cc339c3adec$exports = {};
"use strict";
Object.defineProperty($382a0cc339c3adec$exports, "__esModule", {
    value: true
});
var $382a0cc339c3adec$var$makeDefaultStyles = function() {
    var defaultStyles = {
        backgroundColor: '#ffffff',
        axesVisible: true,
        fog: {
            color: '#ffffff',
            enabled: true,
            threshold: 5000
        },
        label: {
            fontSize: 10,
            scaleDefault: 1,
            scaleLarge: 2,
            fillColorSelected: '#000000',
            fillColorHover: '#000000',
            strokeColorSelected: '#ffffff',
            strokeColorHover: '#ffffff',
            strokeWidth: 3,
            fillWidth: 6
        },
        label3D: {
            fontSize: 80,
            scale: 2.2,
            color: 'black',
            backgroundColor: '#ffffff',
            colorUnselected: '#ffffff',
            colorNoSelection: '#ffffff'
        },
        point: {
            colorUnselected: 'rgba(227, 227, 227, 0.7)',
            colorNoSelection: 'rgba(117, 117, 217, 0.7)',
            colorSelected: 'rgba(250, 102, 102, 0.7)',
            colorHover: 'rgba(118, 11, 79, 0.7)',
            scaleDefault: 1.0,
            scaleSelected: 1.2,
            scaleHover: 1.2
        },
        polyline: {
            startHue: 60,
            endHue: 360,
            saturation: 1,
            lightness: 0.3,
            defaultOpacity: 0.2,
            defaultLineWidth: 2,
            selectedOpacity: 0.9,
            selectedLineWidth: 3,
            deselectedOpacity: 0.05
        },
        select: {
            fill: '#dddddd',
            fillOpacity: 0.2,
            stroke: '#aaaaaa',
            strokeWidth: 2,
            strokeDashArray: '10 5'
        },
        sprites: {
            minPointSize: 5.0,
            imageSize: 30,
            colorUnselected: '#ffffff',
            colorNoSelection: '#ffffff'
        }
    };
    return defaultStyles;
};
function $382a0cc339c3adec$var$makeStyles(userStyles) {
    var defaultStyles = $382a0cc339c3adec$var$makeDefaultStyles();
    if (userStyles === undefined) return defaultStyles;
    for(var key in defaultStyles){
        var _key = key;
        if (typeof defaultStyles[_key] === 'object' && typeof userStyles[_key] === 'object') defaultStyles[_key] = Object.assign(defaultStyles[_key], userStyles[_key]);
        else if (userStyles[_key] !== undefined) defaultStyles[_key] = userStyles[_key];
    }
    return defaultStyles;
}
$382a0cc339c3adec$exports.makeStyles = $382a0cc339c3adec$var$makeStyles;



var $00b5687c084295e3$exports = {};
"use strict";
Object.defineProperty($00b5687c084295e3$exports, "__esModule", {
    value: true
});
$00b5687c084295e3$exports.RGB_NUM_ELEMENTS = 3;
$00b5687c084295e3$exports.RGBA_NUM_ELEMENTS = 4;
$00b5687c084295e3$exports.XYZ_NUM_ELEMENTS = 3;
$00b5687c084295e3$exports.UV_NUM_ELEMENTS = 2;
$00b5687c084295e3$exports.INDEX_NUM_ELEMENTS = 1;
$00b5687c084295e3$exports.SCATTER_PLOT_CUBE_LENGTH = 2;


var $7b3b9345c90293f3$exports = {};
"use strict";
Object.defineProperty($7b3b9345c90293f3$exports, "__esModule", {
    value: true
});

var $eq1Fs = parcelRequire("eq1Fs");


var $7b3b9345c90293f3$var$MAX_CANVAS_DIMENSION = 8192;
var $7b3b9345c90293f3$var$NUM_GLYPHS = 256;
var $7b3b9345c90293f3$var$VERTICES_PER_GLYPH = 6;
var $7b3b9345c90293f3$var$makeVertexShader = function(fontSize, scale) {
    return "\n      attribute vec2 posObj;\n      attribute vec4 color;\n      varying vec2 vUv;\n      varying vec4 vColor;\n\n      void main() {\n        vUv = uv;\n        vColor = color;\n\n        // Rotate label to face camera.\n\n        vec4 vRight = vec4(\n          modelViewMatrix[0][0], modelViewMatrix[1][0], modelViewMatrix[2][0], 0);\n\n        vec4 vUp = vec4(\n          modelViewMatrix[0][1], modelViewMatrix[1][1], modelViewMatrix[2][1], 0);\n\n        vec4 vAt = -vec4(\n          modelViewMatrix[0][2], modelViewMatrix[1][2], modelViewMatrix[2][2], 0);\n\n        mat4 pointToCamera = mat4(vRight, vUp, vAt, vec4(0, 0, 0, 1));\n\n        vec2 scaledPos = posObj * " + 1 / fontSize + " * " + scale + ";\n\n        vec4 posRotated = pointToCamera * vec4(scaledPos, 0, 1);\n        vec4 mvPosition = modelViewMatrix * (vec4(position, 0) + posRotated);\n        gl_Position = projectionMatrix * mvPosition;\n      }";
};
var $7b3b9345c90293f3$var$FRAGMENT_SHADER = "\n      uniform sampler2D glyphTexture;\n      uniform bool picking;\n      varying vec2 vUv;\n      varying vec4 vColor;\n\n      void main() {\n        if (picking) {\n          gl_FragColor = vColor;\n        } else {\n          vec4 fromTexture = texture(glyphTexture, vUv);\n          gl_FragColor = vColor * fromTexture;\n        }\n      }";
var $7b3b9345c90293f3$var$ScatterPlotVisualizer3DLabels = function() {
    function ScatterPlotVisualizer3DLabels(styles) {
        this.styles = styles;
        this.id = '3D_LABELS';
        this.labelStrings = [];
        this.worldSpacePointPositions = new Float32Array(0);
        this.pickingColors = new Float32Array(0);
        this.renderColors = new Float32Array(0);
        this.uniforms = {};
        this.totalVertexCount = 0;
        this.labelVertexMap = [];
    }
    ScatterPlotVisualizer3DLabels.prototype.createGlyphTexture = function() {
        var _a = this.styles.label3D, fontSize = _a.fontSize, backgroundColor = _a.backgroundColor, color = _a.color;
        var canvas = document.createElement('canvas');
        canvas.width = $7b3b9345c90293f3$var$MAX_CANVAS_DIMENSION;
        canvas.height = fontSize;
        var ctx = canvas.getContext('2d');
        ctx.font = 'bold ' + fontSize + 'px roboto';
        ctx.textBaseline = 'top';
        ctx.fillStyle = backgroundColor;
        ctx.rect(0, 0, canvas.width, canvas.height);
        ctx.fill();
        ctx.fillStyle = color;
        var spaceOffset = ctx.measureText(' ').width;
        var glyphLengths = new Float32Array($7b3b9345c90293f3$var$NUM_GLYPHS);
        var glyphOffset = new Float32Array($7b3b9345c90293f3$var$NUM_GLYPHS);
        var leftCoord = 0;
        for(var i = 0; i < $7b3b9345c90293f3$var$NUM_GLYPHS; i++){
            var text = ' ' + String.fromCharCode(i);
            var textLength = ctx.measureText(text).width;
            glyphLengths[i] = textLength - spaceOffset;
            glyphOffset[i] = leftCoord;
            ctx.fillText(text, leftCoord - spaceOffset, 0);
            leftCoord += textLength;
        }
        var tex = $18e0ef071f720394$exports.createTextureFromCanvas(canvas);
        return {
            texture: tex,
            lengths: glyphLengths,
            offsets: glyphOffset
        };
    };
    ScatterPlotVisualizer3DLabels.prototype.processLabelVerts = function(pointCount) {
        var numTotalLetters = 0;
        this.labelVertexMap = [];
        for(var i = 0; i < pointCount; i++){
            var label = this.labelStrings[i];
            var vertsArray = [];
            for(var j = 0; j < label.length; j++){
                for(var k = 0; k < $7b3b9345c90293f3$var$VERTICES_PER_GLYPH; k++)vertsArray.push(numTotalLetters * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + k);
                numTotalLetters++;
            }
            this.labelVertexMap.push(vertsArray);
        }
        this.totalVertexCount = numTotalLetters * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH;
    };
    ScatterPlotVisualizer3DLabels.prototype.createColorBuffers = function(pointCount) {
        var _this = this;
        this.pickingColors = new Float32Array(this.totalVertexCount * $00b5687c084295e3$exports.RGB_NUM_ELEMENTS);
        this.renderColors = new Float32Array(this.totalVertexCount * $00b5687c084295e3$exports.RGB_NUM_ELEMENTS);
        var _loop_1 = function(i) {
            var pickingColor = new $eq1Fs.Color(i);
            this_1.labelVertexMap[i].forEach(function(j) {
                _this.pickingColors[$00b5687c084295e3$exports.RGB_NUM_ELEMENTS * j] = pickingColor.r;
                _this.pickingColors[$00b5687c084295e3$exports.RGB_NUM_ELEMENTS * j + 1] = pickingColor.g;
                _this.pickingColors[$00b5687c084295e3$exports.RGB_NUM_ELEMENTS * j + 2] = pickingColor.b;
                _this.renderColors[$00b5687c084295e3$exports.RGB_NUM_ELEMENTS * j] = 1.0;
                _this.renderColors[$00b5687c084295e3$exports.RGB_NUM_ELEMENTS * j + 1] = 1.0;
                _this.renderColors[$00b5687c084295e3$exports.RGB_NUM_ELEMENTS * j + 2] = 1.0;
            });
        };
        var this_1 = this;
        for(var i = 0; i < pointCount; i++)_loop_1(i);
    };
    ScatterPlotVisualizer3DLabels.prototype.createLabels = function() {
        var _this = this;
        var _a = this.styles.label3D, fontSize = _a.fontSize, scale = _a.scale;
        if (this.labelStrings == null || this.worldSpacePointPositions == null) return;
        var pointCount = this.worldSpacePointPositions.length / $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS;
        if (pointCount !== this.labelStrings.length) return;
        this.glyphTexture = this.createGlyphTexture();
        this.uniforms = {
            glyphTexture: {
                value: null
            },
            picking: {
                value: false
            }
        };
        this.material = new $eq1Fs.ShaderMaterial({
            uniforms: this.uniforms,
            transparent: true,
            vertexShader: $7b3b9345c90293f3$var$makeVertexShader(fontSize, scale),
            fragmentShader: $7b3b9345c90293f3$var$FRAGMENT_SHADER
        });
        this.processLabelVerts(pointCount);
        this.createColorBuffers(pointCount);
        var positionArray = new Float32Array(this.totalVertexCount * $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS);
        this.positions = new $eq1Fs.BufferAttribute(positionArray, $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS);
        var posArray = new Float32Array(this.totalVertexCount * $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS);
        var uvArray = new Float32Array(this.totalVertexCount * $00b5687c084295e3$exports.UV_NUM_ELEMENTS);
        var colorsArray = new Float32Array(this.totalVertexCount * $00b5687c084295e3$exports.RGB_NUM_ELEMENTS);
        var positionObject = new $eq1Fs.BufferAttribute(posArray, 2);
        var uv = new $eq1Fs.BufferAttribute(uvArray, $00b5687c084295e3$exports.UV_NUM_ELEMENTS);
        var colors = new $eq1Fs.BufferAttribute(colorsArray, $00b5687c084295e3$exports.RGB_NUM_ELEMENTS);
        this.geometry = new $eq1Fs.BufferGeometry();
        this.geometry.setAttribute('posObj', positionObject);
        this.geometry.setAttribute('position', this.positions);
        this.geometry.setAttribute('uv', uv);
        this.geometry.setAttribute('color', colors);
        var lettersSoFar = 0;
        for(var i = 0; i < pointCount; i++){
            var label = this.labelStrings[i];
            var leftOffset = 0;
            for(var j = 0; j < label.length; j++){
                var letterCode = label.charCodeAt(j);
                leftOffset += this.glyphTexture.lengths[letterCode];
            }
            leftOffset /= -2;
            for(var j = 0; j < label.length; j++){
                var letterCode = label.charCodeAt(j);
                var letterWidth = this.glyphTexture.lengths[letterCode];
                var scale_1 = fontSize;
                var right = (leftOffset + letterWidth) / scale_1;
                var left = leftOffset / scale_1;
                var top_1 = fontSize / scale_1;
                positionObject.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 0, left, 0);
                positionObject.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 1, right, 0);
                positionObject.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 2, left, top_1);
                positionObject.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 3, left, top_1);
                positionObject.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 4, right, 0);
                positionObject.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 5, right, top_1);
                var uLeft = this.glyphTexture.offsets[letterCode];
                var uRight = this.glyphTexture.offsets[letterCode] + letterWidth;
                uLeft /= $7b3b9345c90293f3$var$MAX_CANVAS_DIMENSION;
                uRight /= $7b3b9345c90293f3$var$MAX_CANVAS_DIMENSION;
                var vTop = 1;
                var vBottom = 0;
                uv.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 0, uLeft, vTop);
                uv.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 1, uRight, vTop);
                uv.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 2, uLeft, vBottom);
                uv.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 3, uLeft, vBottom);
                uv.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 4, uRight, vTop);
                uv.setXY(lettersSoFar * $7b3b9345c90293f3$var$VERTICES_PER_GLYPH + 5, uRight, vBottom);
                lettersSoFar++;
                leftOffset += letterWidth;
            }
        }
        var _loop_2 = function(i) {
            var p = $18e0ef071f720394$exports.vector3FromPackedArray(this_2.worldSpacePointPositions, i);
            this_2.labelVertexMap[i].forEach(function(j) {
                _this.positions.setXYZ(j, p.x, p.y, p.z);
            });
        };
        var this_2 = this;
        for(var i = 0; i < pointCount; i++)_loop_2(i);
        this.labelsMesh = new $eq1Fs.Mesh(this.geometry, this.material);
        this.labelsMesh.frustumCulled = false;
        this.scene.add(this.labelsMesh);
    };
    ScatterPlotVisualizer3DLabels.prototype.colorLabels = function(pointColors) {
        if (this.labelStrings == null || this.geometry == null || pointColors == null) return;
        var colors = this.geometry.getAttribute('color');
        colors.array = this.renderColors;
        var n = pointColors.length / $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS;
        var src = 0;
        for(var i = 0; i < n; ++i){
            var c = new $eq1Fs.Color(pointColors[src], pointColors[src + 1], pointColors[src + 2]);
            var m = this.labelVertexMap[i].length;
            for(var j = 0; j < m; ++j)colors.setXYZ(this.labelVertexMap[i][j], c.r, c.g, c.b);
            src += $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS;
        }
        colors.needsUpdate = true;
    };
    ScatterPlotVisualizer3DLabels.prototype.setScene = function(scene) {
        this.scene = scene;
    };
    ScatterPlotVisualizer3DLabels.prototype.dispose = function() {
        if (this.labelsMesh) {
            if (this.scene) this.scene.remove(this.labelsMesh);
            this.labelsMesh = null;
        }
        if (this.geometry) {
            this.geometry.dispose();
            this.geometry = null;
        }
        if (this.glyphTexture != null && this.glyphTexture.texture != null) {
            this.glyphTexture.texture.dispose();
            this.glyphTexture.texture = null;
        }
    };
    ScatterPlotVisualizer3DLabels.prototype.onPickingRender = function(rc) {
        if (this.geometry == null) {
            this.createLabels();
            return;
        }
        this.material.uniforms.glyphTexture.value = this.glyphTexture.texture;
        this.material.uniforms.picking.value = true;
        var colors = this.geometry.getAttribute('color');
        colors.array = this.pickingColors;
        colors.needsUpdate = true;
    };
    ScatterPlotVisualizer3DLabels.prototype.onRender = function(rc) {
        if (this.geometry == null) {
            this.createLabels();
            return;
        }
        this.colorLabels(rc.pointColors);
        this.material.uniforms.glyphTexture.value = this.glyphTexture.texture;
        this.material.uniforms.picking.value = false;
        var colors = this.geometry.getAttribute('color');
        colors.array = this.renderColors;
        colors.needsUpdate = true;
    };
    ScatterPlotVisualizer3DLabels.prototype.onPointPositionsChanged = function(newPositions) {
        this.worldSpacePointPositions = newPositions;
        this.dispose();
    };
    ScatterPlotVisualizer3DLabels.prototype.setLabelStrings = function(labelStrings) {
        this.labelStrings = labelStrings;
        this.dispose();
    };
    ScatterPlotVisualizer3DLabels.prototype.onResize = function(newWidth, newHeight) {};
    return ScatterPlotVisualizer3DLabels;
}();
$7b3b9345c90293f3$exports.ScatterPlotVisualizer3DLabels = $7b3b9345c90293f3$var$ScatterPlotVisualizer3DLabels;


var $5d0295989f090b05$exports = {};
"use strict";
Object.defineProperty($5d0295989f090b05$exports, "__esModule", {
    value: true
});

var $eq1Fs = parcelRequire("eq1Fs");



var $5d0295989f090b05$var$makeVertexShader = function(minPointSize) {
    return "\n    // Index of the specific vertex (passed in as bufferAttribute), and the\n    // variable that will be used to pass it to the fragment shader.\n    attribute float spriteIndex;\n    attribute vec4 color;\n    attribute float scaleFactor;\n\n    varying vec2 xyIndex;\n    varying vec4 vColor;\n\n    uniform bool sizeAttenuation;\n    uniform float pointSize;\n    uniform float spritesPerRow;\n    uniform float spritesPerColumn;\n\n    varying float fogDepth;\n\n    void main() {\n      // Pass index and color values to fragment shader.\n      vColor = color;\n      xyIndex = vec2(mod(spriteIndex, spritesPerRow),\n                floor(spriteIndex / spritesPerColumn));\n\n      // Transform current vertex by modelViewMatrix (model world position and\n      // camera world position matrix).\n      vec4 cameraSpacePos = modelViewMatrix * vec4(position, 1.0);\n\n      // Project vertex in camera-space to screen coordinates using the camera's\n      // projection matrix.\n      gl_Position = projectionMatrix * cameraSpacePos;\n\n      // Create size attenuation (if we're in 3D mode) by making the size of\n      // each point inversly proportional to its distance to the camera.\n      float outputPointSize = pointSize;\n      if (sizeAttenuation) {\n        outputPointSize = -pointSize / cameraSpacePos.z;\n        fogDepth = pointSize / outputPointSize * 1.2;\n      } else {  // Create size attenuation (if we're in 2D mode)\n        const float PI = 3.1415926535897932384626433832795;\n        const float minScale = 0.1;  // minimum scaling factor\n        const float outSpeed = 2.0;  // shrink speed when zooming out\n        const float outNorm = (1. - minScale) / atan(outSpeed);\n        const float maxScale = 15.0;  // maximum scaling factor\n        const float inSpeed = 0.02;  // enlarge speed when zooming in\n        const float zoomOffset = 0.3;  // offset zoom pivot\n        float zoom = projectionMatrix[0][0] + zoomOffset;  // zoom pivot\n        float scale = zoom < 1. ? 1. + outNorm * atan(outSpeed * (zoom - 1.)) :\n                      1. + 2. / PI * (maxScale - 1.) * atan(inSpeed * (zoom - 1.));\n        outputPointSize = pointSize * scale;\n      }\n\n      gl_PointSize =\n        max(outputPointSize * scaleFactor, " + minPointSize.toFixed(1) + ");\n    }";
};
var $5d0295989f090b05$var$FRAGMENT_SHADER_POINT_TEST_CHUNK = "\n    bool point_in_unit_circle(vec2 spriteCoord) {\n      vec2 centerToP = spriteCoord - vec2(0.5, 0.5);\n      return dot(centerToP, centerToP) < (0.5 * 0.5);\n    }\n\n    bool point_in_unit_equilateral_triangle(vec2 spriteCoord) {\n      vec3 v0 = vec3(0, 1, 0);\n      vec3 v1 = vec3(0.5, 0, 0);\n      vec3 v2 = vec3(1, 1, 0);\n      vec3 p = vec3(spriteCoord, 0);\n      float p_in_v0_v1 = cross(v1 - v0, p - v0).z;\n      float p_in_v1_v2 = cross(v2 - v1, p - v1).z;\n      return (p_in_v0_v1 > 0.0) && (p_in_v1_v2 > 0.0);\n    }\n\n    bool point_in_unit_square(vec2 spriteCoord) {\n      return true;\n    }\n  ";
var $5d0295989f090b05$var$FRAGMENT_SHADER = "\n    varying vec2 xyIndex;\n    varying vec4 vColor;\n\n    uniform sampler2D spriteTexture;\n    uniform float spritesPerRow;\n    uniform float spritesPerColumn;\n    uniform bool isImage;\n\n    " + $eq1Fs.ShaderChunk['common'] + "\n    " + $5d0295989f090b05$var$FRAGMENT_SHADER_POINT_TEST_CHUNK + "\n    uniform vec3 fogColor;\n    varying float fogDepth;\n\t\tuniform float fogNear;\n    uniform float fogFar;\n\n    void main() {\n      if (isImage) {\n        // Coordinates of the vertex within the entire sprite image.\n        vec2 coords =\n          (gl_PointCoord + xyIndex) / vec2(spritesPerRow, spritesPerColumn);\n        gl_FragColor = vColor * texture(spriteTexture, coords);\n      } else {\n        bool inside = point_in_unit_circle(gl_PointCoord);\n        if (!inside) {\n          discard;\n        }\n        gl_FragColor = vColor;\n      }\n      float fogFactor = smoothstep( fogNear, fogFar, fogDepth );\n      gl_FragColor.rgb = mix( gl_FragColor.rgb, fogColor, fogFactor );\n    }";
var $5d0295989f090b05$var$FRAGMENT_SHADER_PICKING = "\n    varying vec2 xyIndex;\n    varying vec4 vColor;\n    uniform bool isImage;\n\n    " + $5d0295989f090b05$var$FRAGMENT_SHADER_POINT_TEST_CHUNK + "\n\n    varying float fogDepth;\n\n    void main() {\n      xyIndex; // Silence 'unused variable' warning.\n      fogDepth; // Silence 'unused variable' warning.\n      if (isImage) {\n        gl_FragColor = vColor;\n      } else {\n        bool inside = point_in_unit_circle(gl_PointCoord);\n        if (!inside) {\n          discard;\n        }\n        gl_FragColor = vColor;\n      }\n    }";
var $5d0295989f090b05$var$ScatterPlotVisualizerSprites = function() {
    function ScatterPlotVisualizerSprites(styles, spriteSheetParams) {
        this.styles = styles;
        this.id = 'SPRITES';
        this.isSpriteSheetMode = false;
        this.spritesPerRow = 0;
        this.spritesPerColumn = 0;
        this.spriteDimensions = [
            0,
            0
        ];
        this.worldSpacePointPositions = new Float32Array(0);
        this.pickingColors = new Float32Array(0);
        this.renderColors = new Float32Array(0);
        this.standinTextureForPoints = $18e0ef071f720394$exports.createTextureFromCanvas(document.createElement('canvas'));
        if (spriteSheetParams) {
            this.spriteSheetParams = spriteSheetParams;
            this.setSpriteSheet(spriteSheetParams);
            this.isSpriteSheetMode = true;
        }
        this.renderMaterial = this.createRenderMaterial();
        this.pickingMaterial = this.createPickingMaterial();
    }
    ScatterPlotVisualizerSprites.prototype.createUniforms = function() {
        return {
            spriteTexture: {
                type: 't'
            },
            spritesPerRow: {
                type: 'f'
            },
            spritesPerColumn: {
                type: 'f'
            },
            fogColor: {
                type: 'c'
            },
            fogNear: {
                type: 'f'
            },
            fogFar: {
                type: 'f'
            },
            isImage: {
                type: 'bool'
            },
            sizeAttenuation: {
                type: 'bool'
            },
            pointSize: {
                type: 'f'
            }
        };
    };
    ScatterPlotVisualizerSprites.prototype.createRenderMaterial = function() {
        var isSpriteSheetMode = this.isSpriteSheetMode;
        var uniforms = this.createUniforms();
        return new $eq1Fs.ShaderMaterial({
            uniforms: uniforms,
            vertexShader: $5d0295989f090b05$var$makeVertexShader(this.styles.sprites.minPointSize),
            fragmentShader: $5d0295989f090b05$var$FRAGMENT_SHADER,
            transparent: true,
            depthFunc: $eq1Fs.LessDepth,
            fog: this.styles.fog.enabled,
            blending: $eq1Fs.NormalBlending
        });
    };
    ScatterPlotVisualizerSprites.prototype.createPickingMaterial = function() {
        var uniforms = this.createUniforms();
        return new $eq1Fs.ShaderMaterial({
            uniforms: uniforms,
            vertexShader: $5d0295989f090b05$var$makeVertexShader(this.styles.sprites.minPointSize),
            fragmentShader: $5d0295989f090b05$var$FRAGMENT_SHADER_PICKING,
            transparent: true,
            depthTest: true,
            depthWrite: true,
            fog: false,
            blending: $eq1Fs.NormalBlending
        });
    };
    ScatterPlotVisualizerSprites.prototype.createPointSprites = function(scene, positions) {
        var pointCount = positions != null ? positions.length / $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS : 0;
        var geometry = this.createGeometry(pointCount);
        this.fog = new $eq1Fs.Fog(0xffffff);
        this.points = new $eq1Fs.Points(geometry, this.renderMaterial);
        this.points.frustumCulled = false;
        if (this.spriteIndexBufferAttribute != null) this.points.geometry.setAttribute('spriteIndex', this.spriteIndexBufferAttribute);
        scene.add(this.points);
    };
    ScatterPlotVisualizerSprites.prototype.calculatePointSize = function(sceneIs3D) {
        var imageSize = this.styles.sprites.imageSize;
        if (this.texture) return sceneIs3D ? imageSize : this.spriteDimensions[0];
        var n = this.worldSpacePointPositions != null ? this.worldSpacePointPositions.length / $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS : 1;
        var SCALE = 200;
        var LOG_BASE = 8;
        var DIVISOR = 1.5;
        var pointSize = SCALE / Math.log(n) / Math.log(LOG_BASE);
        return sceneIs3D ? pointSize : pointSize / DIVISOR;
    };
    ScatterPlotVisualizerSprites.prototype.createGeometry = function(pointCount) {
        var n = pointCount;
        this.pickingColors = new Float32Array(n * $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS);
        var dst = 0;
        for(var i = 0; i < n; i++){
            var c = new $eq1Fs.Color(i);
            this.pickingColors[dst++] = c.r;
            this.pickingColors[dst++] = c.g;
            this.pickingColors[dst++] = c.b;
            this.pickingColors[dst++] = 1;
        }
        var geometry = new $eq1Fs.BufferGeometry();
        geometry.setAttribute('position', new $eq1Fs.BufferAttribute(new Float32Array([]), $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS));
        geometry.setAttribute('color', new $eq1Fs.BufferAttribute(new Float32Array([]), $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS));
        geometry.setAttribute('scaleFactor', new $eq1Fs.BufferAttribute(new Float32Array([]), $00b5687c084295e3$exports.INDEX_NUM_ELEMENTS));
        geometry.computeVertexNormals();
        return geometry;
    };
    ScatterPlotVisualizerSprites.prototype.setFogDistances = function(sceneIs3D, nearestPointZ, farthestPointZ) {
        var _a = this.styles.fog, threshold = _a.threshold, enabled = _a.enabled;
        if (sceneIs3D && enabled) {
            this.fog.near = nearestPointZ;
            var delta = nearestPointZ - farthestPointZ;
            this.fog.far = nearestPointZ - threshold * delta;
        } else {
            this.fog.near = Infinity;
            this.fog.far = Infinity;
        }
    };
    ScatterPlotVisualizerSprites.prototype.dispose = function() {
        this.disposeGeometry();
        this.disposeSpriteSheet();
    };
    ScatterPlotVisualizerSprites.prototype.disposeGeometry = function() {
        if (this.points != null) {
            this.scene.remove(this.points);
            this.points.geometry.dispose();
            this.points = null;
            this.worldSpacePointPositions = null;
        }
    };
    ScatterPlotVisualizerSprites.prototype.disposeSpriteSheet = function() {
        if (this.texture) this.texture.dispose();
        this.texture = null;
        this.renderMaterial = null;
        this.pickingMaterial = null;
        this.spriteSheetImage = null;
    };
    ScatterPlotVisualizerSprites.prototype.setScene = function(scene) {
        this.scene = scene;
    };
    ScatterPlotVisualizerSprites.prototype.setSpriteSheet = function(spriteSheetParams) {
        var _this = this;
        var spriteDimensions = spriteSheetParams.spriteDimensions, onImageLoad = spriteSheetParams.onImageLoad;
        var spriteSheet = spriteSheetParams.spritesheetImage;
        if (typeof spriteSheet === 'string') {
            var spriteSheetUrl = spriteSheet;
            spriteSheet = new Image();
            spriteSheet.src = spriteSheetUrl;
        }
        this.spriteSheetImage = spriteSheet;
        this.texture = $18e0ef071f720394$exports.createTextureFromImage(this.spriteSheetImage, function() {
            _this.spritesPerRow = _this.spriteSheetImage.width / spriteDimensions[0];
            _this.spritesPerColumn = _this.spriteSheetImage.height / spriteDimensions[1];
            onImageLoad();
        });
        this.spriteDimensions = spriteDimensions;
        this.setSpriteIndexBuffer();
    };
    ScatterPlotVisualizerSprites.prototype.setSpriteIndexBuffer = function() {
        var spriteIndices = this.spriteSheetParams.spriteIndices;
        this.spriteIndexBufferAttribute = new $eq1Fs.BufferAttribute(spriteIndices, $00b5687c084295e3$exports.INDEX_NUM_ELEMENTS);
        if (this.points != null) this.points.geometry.setAttribute('spriteIndex', this.spriteIndexBufferAttribute);
    };
    ScatterPlotVisualizerSprites.prototype.onPointPositionsChanged = function(newPositions) {
        if (this.points != null) {
            if (this.worldSpacePointPositions.length !== newPositions.length) this.disposeGeometry();
        }
        this.worldSpacePointPositions = newPositions;
        if (this.points == null) this.createPointSprites(this.scene, newPositions);
        if (this.spriteSheetParams) this.setSpriteIndexBuffer();
        this.renderMaterial = this.createRenderMaterial();
        this.pickingMaterial = this.createPickingMaterial();
        var positions = this.points.geometry.getAttribute('position');
        positions.array = newPositions;
        positions.count = newPositions.length / $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS;
        positions.needsUpdate = true;
    };
    ScatterPlotVisualizerSprites.prototype.onPickingRender = function(rc) {
        var sceneIs3D = rc.cameraType === $480c19973a73a2be$exports.CameraType.Perspective;
        this.pickingMaterial.uniforms.spritesPerRow.value = this.spritesPerRow;
        this.pickingMaterial.uniforms.spritesPerRow.value = this.spritesPerColumn;
        this.pickingMaterial.uniforms.sizeAttenuation.value = sceneIs3D;
        this.pickingMaterial.uniforms.pointSize.value = this.calculatePointSize(sceneIs3D);
        this.points.material = this.pickingMaterial;
        var colors = this.points.geometry.getAttribute('color');
        colors.array = this.pickingColors;
        colors.count = this.pickingColors.length / $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS;
        colors.needsUpdate = true;
        var scaleFactors = this.points.geometry.getAttribute('scaleFactor');
        scaleFactors.array = rc.pointScaleFactors;
        scaleFactors.count = rc.pointScaleFactors.length;
        scaleFactors.count = rc.pointScaleFactors.length / $00b5687c084295e3$exports.INDEX_NUM_ELEMENTS;
        scaleFactors.needsUpdate = true;
    };
    ScatterPlotVisualizerSprites.prototype.onRender = function(rc) {
        var sceneIs3D = rc.camera instanceof $eq1Fs.PerspectiveCamera;
        this.setFogDistances(sceneIs3D, rc.nearestCameraSpacePointZ, rc.farthestCameraSpacePointZ);
        this.scene.fog = this.fog;
        this.scene.fog.color = new $eq1Fs.Color(rc.backgroundColor);
        this.renderMaterial.uniforms.fogColor.value = this.scene.fog.color;
        this.renderMaterial.uniforms.fogNear.value = this.fog.near;
        this.renderMaterial.uniforms.fogFar.value = this.fog.far;
        this.renderMaterial.uniforms.spritesPerRow.value = this.spritesPerRow;
        this.renderMaterial.uniforms.spritesPerColumn.value = this.spritesPerColumn;
        this.renderMaterial.uniforms.isImage.value = this.texture != null;
        this.renderMaterial.uniforms.spriteTexture.value = this.texture != null ? this.texture : this.standinTextureForPoints;
        this.renderMaterial.uniforms.sizeAttenuation.value = sceneIs3D;
        this.renderMaterial.uniforms.pointSize.value = this.calculatePointSize(sceneIs3D);
        this.points.material = this.renderMaterial;
        var colors = this.points.geometry.getAttribute('color');
        this.renderColors = rc.pointColors;
        colors.array = this.renderColors;
        colors.count = this.renderColors.length / $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS;
        colors.needsUpdate = true;
        var scaleFactors = this.points.geometry.getAttribute('scaleFactor');
        scaleFactors.array = rc.pointScaleFactors;
        scaleFactors.count = rc.pointScaleFactors.length / $00b5687c084295e3$exports.INDEX_NUM_ELEMENTS;
        scaleFactors.needsUpdate = true;
    };
    ScatterPlotVisualizerSprites.prototype.onResize = function(newWidth, newHeight) {};
    return ScatterPlotVisualizerSprites;
}();
$5d0295989f090b05$exports.ScatterPlotVisualizerSprites = $5d0295989f090b05$var$ScatterPlotVisualizerSprites;


var $40353bc42ddffc62$exports = {};
"use strict";
var $40353bc42ddffc62$var$__read = $40353bc42ddffc62$exports && $40353bc42ddffc62$exports.__read || function(o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while((n === void 0 || n-- > 0) && !(r = i.next()).done)ar.push(r.value);
    } catch (error) {
        e = {
            error: error
        };
    } finally{
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        } finally{
            if (e) throw e.error;
        }
    }
    return ar;
};
Object.defineProperty($40353bc42ddffc62$exports, "__esModule", {
    value: true
});

var $eq1Fs = parcelRequire("eq1Fs");

var $c97f935c30df7b24$exports = {};
"use strict";
Object.defineProperty($c97f935c30df7b24$exports, "__esModule", {
    value: true
});
var $c97f935c30df7b24$var$CollisionGrid = function() {
    function CollisionGrid(bound, cellWidth, cellHeight) {
        this.bound = bound;
        this.cellWidth = cellWidth;
        this.cellHeight = cellHeight;
        this.numHorizCells = Math.ceil(this.boundWidth(bound) / cellWidth);
        this.numVertCells = Math.ceil(this.boundHeight(bound) / cellHeight);
        this.grid = new Array(this.numHorizCells * this.numVertCells);
    }
    CollisionGrid.prototype.boundWidth = function(bound) {
        return bound.hiX - bound.loX;
    };
    CollisionGrid.prototype.boundHeight = function(bound) {
        return bound.hiY - bound.loY;
    };
    CollisionGrid.prototype.boundsIntersect = function(a, b) {
        return !(a.loX > b.hiX || a.loY > b.hiY || a.hiX < b.loX || a.hiY < b.loY);
    };
    CollisionGrid.prototype.insert = function(bound, justTest) {
        if (justTest === void 0) justTest = false;
        if (bound.hiX < this.bound.loX || bound.loX > this.bound.hiX || bound.hiY < this.bound.loY || bound.loY > this.bound.hiY) return false;
        var minCellX = this.getCellX(bound.loX);
        var maxCellX = this.getCellX(bound.hiX);
        var minCellY = this.getCellY(bound.loY);
        var maxCellY = this.getCellY(bound.hiY);
        var baseIdx = minCellY * this.numHorizCells + minCellX;
        var idx = baseIdx;
        for(var j = minCellY; j <= maxCellY; j++){
            for(var i = minCellX; i <= maxCellX; i++){
                var cell = this.grid[idx++];
                if (cell) for(var k = 0; k < cell.length; k++){
                    if (this.boundsIntersect(bound, cell[k])) return false;
                }
            }
            idx += this.numHorizCells - (maxCellX - minCellX + 1);
        }
        if (justTest) return true;
        idx = baseIdx;
        for(var j = minCellY; j <= maxCellY; j++){
            for(var i = minCellX; i <= maxCellX; i++){
                if (!this.grid[idx]) this.grid[idx] = [
                    bound
                ];
                else this.grid[idx].push(bound);
                idx++;
            }
            idx += this.numHorizCells - (maxCellX - minCellX + 1);
        }
        return true;
    };
    CollisionGrid.prototype.getCellX = function(x) {
        return Math.floor((x - this.bound.loX) / this.cellWidth);
    };
    CollisionGrid.prototype.getCellY = function(y) {
        return Math.floor((y - this.bound.loY) / this.cellHeight);
    };
    return CollisionGrid;
}();
$c97f935c30df7b24$exports.CollisionGrid = $c97f935c30df7b24$var$CollisionGrid;



var $40353bc42ddffc62$var$MAX_LABELS_ON_SCREEN = 10000;
var $40353bc42ddffc62$var$ScatterPlotVisualizerCanvasLabels = function() {
    function ScatterPlotVisualizerCanvasLabels(container, styles) {
        this.styles = styles;
        this.id = 'CANVAS_LABELS';
        this.worldSpacePointPositions = new Float32Array(0);
        this.labelsActive = true;
        this.canvas = document.createElement('canvas');
        container.appendChild(this.canvas);
        this.gc = this.canvas.getContext('2d');
        this.canvas.style.position = 'absolute';
        this.canvas.style.left = '0';
        this.canvas.style.top = '0';
        this.canvas.style.pointerEvents = 'none';
    }
    ScatterPlotVisualizerCanvasLabels.prototype.removeAllLabels = function() {
        var pixelWidth = this.canvas.width * window.devicePixelRatio;
        var pixelHeight = this.canvas.height * window.devicePixelRatio;
        this.gc.clearRect(0, 0, pixelWidth, pixelHeight);
    };
    ScatterPlotVisualizerCanvasLabels.prototype.makeLabels = function(rc) {
        if (rc.labels == null || rc.labels.pointIndices.length === 0) return;
        if (this.worldSpacePointPositions == null) return;
        var lrc = rc.labels;
        var sceneIs3D = rc.cameraType === $480c19973a73a2be$exports.CameraType.Perspective;
        var labelHeight = parseInt(this.gc.font, 10);
        var dpr = window.devicePixelRatio;
        var grid;
        var pixw = this.canvas.width * dpr;
        var pixh = this.canvas.height * dpr;
        var bb = {
            loX: 0,
            hiX: pixw,
            loY: 0,
            hiY: pixh
        };
        grid = new $c97f935c30df7b24$exports.CollisionGrid(bb, pixw / 25, pixh / 50);
        var cameraDomain = [
            rc.farthestCameraSpacePointZ,
            rc.nearestCameraSpacePointZ
        ];
        var opacityMap = function(x) {
            return $18e0ef071f720394$exports.scaleExponential(x, cameraDomain, [
                0.1,
                1
            ]);
        };
        var camPos = rc.camera.position;
        var camToTarget = camPos.clone().sub(rc.cameraTarget);
        var camToPoint = new $eq1Fs.Vector3();
        this.gc.textBaseline = 'middle';
        this.gc.miterLimit = 2;
        var labelMargin = 2;
        var xShift = 4;
        var n = Math.min($40353bc42ddffc62$var$MAX_LABELS_ON_SCREEN, lrc.pointIndices.length);
        for(var i = 0; i < n; ++i){
            var point = void 0;
            var pi = lrc.pointIndices[i];
            point = $18e0ef071f720394$exports.vector3FromPackedArray(this.worldSpacePointPositions, pi);
            camToPoint.copy(camPos).sub(point);
            if (camToTarget.dot(camToPoint) < 0) continue;
            var _a = $40353bc42ddffc62$var$__read($18e0ef071f720394$exports.vector3DToScreenCoords(rc.camera, rc.screenWidth, rc.screenHeight, point), 2), x = _a[0], y = _a[1];
            x += xShift;
            var textBoundingBox = {
                loX: x - labelMargin,
                hiX: x + 1 + labelMargin,
                loY: y - labelHeight / 2 - labelMargin,
                hiY: y + labelHeight / 2 + labelMargin
            };
            if (grid.insert(textBoundingBox, true)) {
                var text = lrc.labelStrings[i];
                var fontSize = lrc.defaultFontSize * lrc.scaleFactors[i] * dpr;
                this.gc.font = fontSize + 'px roboto';
                textBoundingBox.hiX += this.gc.measureText(text).width - 1;
                if (grid.insert(textBoundingBox)) {
                    var opacity = 1;
                    if (sceneIs3D && lrc.useSceneOpacityFlags[i] === 1) opacity = opacityMap(camToPoint.length());
                    this.gc.fillStyle = this.styleStringFromPackedRgba(lrc.fillColors, i, opacity);
                    this.gc.strokeStyle = this.styleStringFromPackedRgba(lrc.strokeColors, i, opacity);
                    this.gc.lineWidth = this.styles.label.strokeWidth;
                    this.gc.strokeText(text, x, y);
                    this.gc.lineWidth = this.styles.label.fillWidth;
                    this.gc.fillText(text, x, y);
                }
            }
        }
    };
    ScatterPlotVisualizerCanvasLabels.prototype.styleStringFromPackedRgba = function(packedRgbaArray, colorIndex, opacity) {
        var offset = colorIndex * 3;
        var r = packedRgbaArray[offset];
        var g = packedRgbaArray[offset + 1];
        var b = packedRgbaArray[offset + 2];
        return 'rgba(' + r + ',' + g + ',' + b + ',' + opacity + ')';
    };
    ScatterPlotVisualizerCanvasLabels.prototype.onResize = function(newWidth, newHeight) {
        var dpr = window.devicePixelRatio;
        this.canvas.width = newWidth * dpr;
        this.canvas.height = newHeight * dpr;
        this.canvas.style.width = newWidth + 'px';
        this.canvas.style.height = newHeight + 'px';
    };
    ScatterPlotVisualizerCanvasLabels.prototype.dispose = function() {
        this.removeAllLabels();
    };
    ScatterPlotVisualizerCanvasLabels.prototype.onPointPositionsChanged = function(newPositions) {
        this.worldSpacePointPositions = newPositions;
        this.removeAllLabels();
    };
    ScatterPlotVisualizerCanvasLabels.prototype.onRender = function(rc) {
        if (!this.labelsActive) return;
        this.removeAllLabels();
        this.makeLabels(rc);
    };
    ScatterPlotVisualizerCanvasLabels.prototype.setScene = function(scene) {};
    ScatterPlotVisualizerCanvasLabels.prototype.onPickingRender = function(renderContext) {};
    return ScatterPlotVisualizerCanvasLabels;
}();
$40353bc42ddffc62$exports.ScatterPlotVisualizerCanvasLabels = $40353bc42ddffc62$var$ScatterPlotVisualizerCanvasLabels;


var $6b8c0a9dd7ee1b6d$exports = {};
"use strict";
var $6b8c0a9dd7ee1b6d$var$__values = $6b8c0a9dd7ee1b6d$exports && $6b8c0a9dd7ee1b6d$exports.__values || function(o) {
    var s = typeof Symbol === "function" && Symbol.iterator, m = s && o[s], i = 0;
    if (m) return m.call(o);
    if (o && typeof o.length === "number") return {
        next: function() {
            if (o && i >= o.length) o = void 0;
            return {
                value: o && o[i++],
                done: !o
            };
        }
    };
    throw new TypeError(s ? "Object is not iterable." : "Symbol.iterator is not defined.");
};
Object.defineProperty($6b8c0a9dd7ee1b6d$exports, "__esModule", {
    value: true
});

var $eq1Fs = parcelRequire("eq1Fs");


var $6b8c0a9dd7ee1b6d$var$ScatterPlotVisualizerPolylines = function() {
    function ScatterPlotVisualizerPolylines() {
        this.id = 'POLYLINES';
        this.sequences = [];
        this.polylines = [];
        this.polylinePositionBuffer = {};
        this.polylineColorBuffer = {};
        this.pointSequenceIndices = new Map();
    }
    ScatterPlotVisualizerPolylines.prototype.getPointSequenceIndex = function(pointIndex) {
        return this.pointSequenceIndices.get(pointIndex);
    };
    ScatterPlotVisualizerPolylines.prototype.updateSequenceIndices = function() {
        for(var i = 0; i < this.sequences.length; i++){
            var sequence = this.sequences[i];
            for(var j = 0; j < sequence.indices.length - 1; j++){
                var pointIndex = sequence.indices[j];
                this.pointSequenceIndices.set(pointIndex, i);
                this.pointSequenceIndices.set(pointIndex + 1, i);
            }
        }
    };
    ScatterPlotVisualizerPolylines.prototype.createPolylines = function() {
        var e_1, _a;
        this.updateSequenceIndices();
        try {
            for(var _b = $6b8c0a9dd7ee1b6d$var$__values(this.polylines), _c = _b.next(); !_c.done; _c = _b.next()){
                var polyline = _c.value;
                this.scene.remove(polyline);
                polyline.geometry.dispose();
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        this.polylines = [];
        for(var i = 0; i < this.sequences.length; i++){
            var geometry = new $eq1Fs.BufferGeometry();
            geometry.addAttribute('position', this.polylinePositionBuffer[i]);
            geometry.addAttribute('color', this.polylineColorBuffer[i]);
            var material = new $eq1Fs.LineBasicMaterial({
                linewidth: 1,
                opacity: 1.0,
                transparent: true,
                vertexColors: true
            });
            var polyline = new $eq1Fs.LineSegments(geometry, material);
            polyline.frustumCulled = false;
            this.polylines.push(polyline);
            this.scene.add(polyline);
        }
    };
    ScatterPlotVisualizerPolylines.prototype.dispose = function() {
        var e_2, _a;
        try {
            for(var _b = $6b8c0a9dd7ee1b6d$var$__values(this.polylines), _c = _b.next(); !_c.done; _c = _b.next()){
                var polyline = _c.value;
                this.scene.remove(polyline);
                polyline.geometry.dispose();
            }
        } catch (e_2_1) {
            e_2 = {
                error: e_2_1
            };
        } finally{
            try {
                if (_c && !_c.done && (_a = _b.return)) _a.call(_b);
            } finally{
                if (e_2) throw e_2.error;
            }
        }
        this.polylines = [];
        this.polylinePositionBuffer = {};
        this.polylineColorBuffer = {};
    };
    ScatterPlotVisualizerPolylines.prototype.setScene = function(scene) {
        this.scene = scene;
    };
    ScatterPlotVisualizerPolylines.prototype.setSequences = function(sequences) {
        this.sequences = sequences;
    };
    ScatterPlotVisualizerPolylines.prototype.onPointPositionsChanged = function(newPositions) {
        if (newPositions == null) this.dispose();
        if (newPositions == null || this.sequences.length === 0) return;
        for(var i = 0; i < this.sequences.length; i++){
            var sequence = this.sequences[i];
            var vertexCount = 2 * (sequence.indices.length - 1);
            var polylines = new Float32Array(vertexCount * $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS);
            this.polylinePositionBuffer[i] = new $eq1Fs.BufferAttribute(polylines, $00b5687c084295e3$exports.XYZ_NUM_ELEMENTS);
            var colors = new Float32Array(vertexCount * $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS);
            this.polylineColorBuffer[i] = new $eq1Fs.BufferAttribute(colors, $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS);
        }
        for(var i = 0; i < this.sequences.length; i++){
            var sequence = this.sequences[i];
            var src = 0;
            for(var j = 0; j < sequence.indices.length - 1; j++){
                var p1Index = sequence.indices[j];
                var p2Index = sequence.indices[j + 1];
                var p1 = $18e0ef071f720394$exports.vector3FromPackedArray(newPositions, p1Index);
                var p2 = $18e0ef071f720394$exports.vector3FromPackedArray(newPositions, p2Index);
                this.polylinePositionBuffer[i].setXYZ(src, p1.x, p1.y, p1.z);
                this.polylinePositionBuffer[i].setXYZ(src + 1, p2.x, p2.y, p2.z);
                src += 2;
            }
            this.polylinePositionBuffer[i].needsUpdate = true;
        }
        this.createPolylines();
    };
    ScatterPlotVisualizerPolylines.prototype.onRender = function(renderContext) {
        for(var i = 0; i < this.polylines.length; i++){
            var material = this.polylines[i].material;
            material.opacity = renderContext.polylineOpacities[i];
            material.linewidth = renderContext.polylineWidths[i];
            this.polylineColorBuffer[i].array = renderContext.polylineColors[i];
            this.polylineColorBuffer[i].needsUpdate = true;
        }
    };
    ScatterPlotVisualizerPolylines.prototype.onPickingRender = function(renderContext) {};
    ScatterPlotVisualizerPolylines.prototype.onResize = function(newWidth, newHeight) {};
    return ScatterPlotVisualizerPolylines;
}();
$6b8c0a9dd7ee1b6d$exports.ScatterPlotVisualizerPolylines = $6b8c0a9dd7ee1b6d$var$ScatterPlotVisualizerPolylines;


var $7aca01f07175d0d8$var$ScatterGL = function() {
    function ScatterGL(containerElement, params) {
        var _this = this;
        if (params === void 0) params = {};
        this.pointColorer = null;
        this.sequences = [];
        this.renderMode = "POINT";
        this.rotateOnStart = true;
        this.selectEnabled = true;
        this.showLabelsOnHover = true;
        this.hoverPointIndex = null;
        this.selectedPointIndices = new Set();
        this.clickCallback = function() {};
        this.hoverCallback = function() {};
        this.selectCallback = function() {};
        this.cameraMoveCallback = function() {};
        this.onHover = function(pointIndex) {
            _this.hoverCallback(pointIndex);
            _this.hoverPointIndex = pointIndex;
            _this.updateScatterPlotAttributes();
            _this.renderScatterPlot();
        };
        this.onClick = function(pointIndex) {
            _this.clickCallback(pointIndex);
        };
        this.select = function(pointIndices) {
            if (!_this.selectEnabled) return;
            _this.selectedPointIndices = new Set(pointIndices);
            _this.updateScatterPlotAttributes();
            _this.renderScatterPlot();
        };
        this.onSelect = function(pointIndices) {
            if (!_this.selectEnabled) return;
            _this.selectCallback(pointIndices);
            _this.select(pointIndices);
        };
        this.containerElement = containerElement;
        this.styles = $382a0cc339c3adec$exports.makeStyles(params.styles);
        this.setParameters(params);
        this.scatterPlot = new $31a6dfd76139c96e$exports.ScatterPlot(containerElement, {
            camera: params.camera,
            onClick: this.onClick,
            onHover: this.onHover,
            onSelect: this.onSelect,
            selectEnabled: this.selectEnabled,
            styles: this.styles,
            orbitControlParams: params.orbitControls
        });
        this.scatterPlot.onCameraMove(this.cameraMoveCallback);
    }
    ScatterGL.prototype.setParameters = function(p) {
        if (p.onClick !== undefined) this.clickCallback = p.onClick;
        if (p.onHover !== undefined) this.hoverCallback = p.onHover;
        if (p.onSelect !== undefined) this.selectCallback = p.onSelect;
        if (p.onCameraMove !== undefined) this.cameraMoveCallback = p.onCameraMove;
        if (p.pointColorer !== undefined) this.pointColorer = p.pointColorer;
        if (p.renderMode !== undefined) this.renderMode = p.renderMode;
        if (p.rotateOnStart !== undefined) this.rotateOnStart = p.rotateOnStart;
        if (p.selectEnabled !== undefined) this.selectEnabled = p.selectEnabled;
        if (p.showLabelsOnHover !== undefined) this.showLabelsOnHover = p.showLabelsOnHover;
    };
    ScatterGL.prototype.render = function(dataset) {
        this.updateDataset(dataset);
        this.clearVisualizers();
        this.setVisualizers();
        if (this.rotateOnStart) this.scatterPlot.startOrbitAnimation();
    };
    ScatterGL.prototype.clearVisualizers = function() {
        this.canvasLabelsVisualizer = undefined;
        this.labels3DVisualizer = undefined;
        this.pointVisualizer = undefined;
        this.polylineVisualizer = undefined;
        this.spritesheetVisualizer = undefined;
        this.scatterPlot.disposeAllVisualizers();
    };
    ScatterGL.prototype.renderScatterPlot = function() {
        if (this.dataset) this.scatterPlot.render();
    };
    ScatterGL.prototype.resetZoom = function() {
        this.scatterPlot.resetZoom();
    };
    ScatterGL.prototype.setRenderMode = function(renderMode) {
        this.renderMode = renderMode;
        this.setVisualizers();
        this.updateScatterPlotAttributes();
        this.updateScatterPlotPositions();
    };
    ScatterGL.prototype.setTextRenderMode = function() {
        this.setRenderMode("TEXT");
        this.renderScatterPlot();
    };
    ScatterGL.prototype.setPointRenderMode = function() {
        this.setRenderMode("POINT");
        this.renderScatterPlot();
    };
    ScatterGL.prototype.setSpriteRenderMode = function() {
        if (this.dataset && this.dataset.spriteMetadata) {
            this.setRenderMode("SPRITE");
            this.renderScatterPlot();
        }
    };
    ScatterGL.prototype.setSequences = function(sequences) {
        this.sequences = sequences;
        this.updatePolylineAttributes();
        this.setVisualizers();
        this.renderScatterPlot();
    };
    ScatterGL.prototype.setPanMode = function() {
        this.scatterPlot.setInteractionMode("PAN");
    };
    ScatterGL.prototype.setSelectMode = function() {
        this.scatterPlot.setInteractionMode("SELECT");
    };
    ScatterGL.prototype.setDimensions = function(nDimensions) {
        var outsideRange = nDimensions < 2 || nDimensions > 3;
        var moreThanDataset = this.dataset && nDimensions > this.dataset.dimensions;
        if (outsideRange || moreThanDataset) throw new RangeError('Setting invalid dimensionality');
        else {
            this.scatterPlot.setDimensions(nDimensions);
            this.renderScatterPlot();
        }
    };
    ScatterGL.prototype.setPointColorer = function(pointColorer) {
        this.pointColorer = pointColorer;
        this.updateScatterPlotAttributes();
        this.renderScatterPlot();
    };
    ScatterGL.prototype.callPointColorer = function(pointColorer, index) {
        return pointColorer(index, this.selectedPointIndices, this.hoverPointIndex);
    };
    ScatterGL.prototype.setHoverPointIndex = function(index) {
        this.hoverPointIndex = index;
        this.updateScatterPlotAttributes();
        if (this.scatterPlot.orbitIsAnimating()) return;
        this.renderScatterPlot();
    };
    ScatterGL.prototype.resize = function() {
        this.scatterPlot.resize();
    };
    ScatterGL.prototype.updateDataset = function(dataset) {
        this.setDataset(dataset);
        this.scatterPlot.setDimensions(dataset.dimensions);
        this.updateScatterPlotAttributes();
        this.updateScatterPlotPositions();
        this.renderScatterPlot();
    };
    ScatterGL.prototype.isOrbiting = function() {
        return this.scatterPlot.orbitIsAnimating();
    };
    ScatterGL.prototype.startOrbitAnimation = function() {
        this.scatterPlot.startOrbitAnimation();
    };
    ScatterGL.prototype.stopOrbitAnimation = function() {
        this.scatterPlot.stopOrbitAnimation();
    };
    ScatterGL.prototype.setDataset = function(dataset) {
        this.dataset = dataset;
        if (this.labels3DVisualizer) this.labels3DVisualizer.setLabelStrings(this.generate3DLabelsArray());
    };
    ScatterGL.prototype.updateScatterPlotPositions = function() {
        var dataset = this.dataset;
        if (!dataset) return;
        var newPositions = this.generatePointPositionArray(dataset);
        this.scatterPlot.setPointPositions(newPositions);
    };
    ScatterGL.prototype.updateScatterPlotAttributes = function() {
        var dataset = this.dataset;
        if (!dataset) return;
        var pointColors = this.generatePointColorArray(dataset);
        var pointScaleFactors = this.generatePointScaleFactorArray(dataset);
        var labels = this.generateVisibleLabelRenderParams();
        this.scatterPlot.setPointColors(pointColors);
        this.scatterPlot.setPointScaleFactors(pointScaleFactors);
        this.scatterPlot.setLabels(labels);
    };
    ScatterGL.prototype.updatePolylineAttributes = function() {
        var dataset = this.dataset;
        if (!dataset) return;
        var polylineColors = this.generateLineSegmentColorMap(dataset);
        var polylineOpacities = this.generateLineSegmentOpacityArray(dataset);
        var polylineWidths = this.generateLineSegmentWidthArray(dataset);
        this.scatterPlot.setPolylineColors(polylineColors);
        this.scatterPlot.setPolylineOpacities(polylineOpacities);
        this.scatterPlot.setPolylineWidths(polylineWidths);
    };
    ScatterGL.prototype.generatePointPositionArray = function(dataset) {
        var xExtent = [
            0,
            0
        ];
        var yExtent = [
            0,
            0
        ];
        var zExtent = [
            0,
            0
        ];
        xExtent = $18e0ef071f720394$exports.extent(dataset.points.map(function(p) {
            return p[0];
        }));
        yExtent = $18e0ef071f720394$exports.extent(dataset.points.map(function(p) {
            return p[1];
        }));
        if (dataset.dimensions === 3) zExtent = $18e0ef071f720394$exports.extent(dataset.points.map(function(p) {
            return p[2];
        }));
        var getRange = function(extent) {
            return Math.abs(extent[1] - extent[0]);
        };
        var xRange = getRange(xExtent);
        var yRange = getRange(yExtent);
        var zRange = getRange(zExtent);
        var maxRange = Math.max(xRange, yRange, zRange);
        var halfCube = $00b5687c084295e3$exports.SCATTER_PLOT_CUBE_LENGTH / 2;
        var makeScaleRange = function(range, base) {
            return [
                -base * (range / maxRange),
                base * (range / maxRange)
            ];
        };
        var xScale = makeScaleRange(xRange, halfCube);
        var yScale = makeScaleRange(yRange, halfCube);
        var zScale = makeScaleRange(zRange, halfCube);
        var positions = new Float32Array(dataset.points.length * 3);
        var dst = 0;
        dataset.points.forEach(function(d, i) {
            var vector = dataset.points[i];
            positions[dst++] = $18e0ef071f720394$exports.scaleLinear(vector[0], xExtent, xScale);
            positions[dst++] = $18e0ef071f720394$exports.scaleLinear(vector[1], yExtent, yScale);
            if (dataset.dimensions === 3) positions[dst++] = $18e0ef071f720394$exports.scaleLinear(vector[2], zExtent, zScale);
            else positions[dst++] = 0.0;
        });
        return positions;
    };
    ScatterGL.prototype.generateVisibleLabelRenderParams = function() {
        var _a = this, hoverPointIndex = _a.hoverPointIndex, selectedPointIndices = _a.selectedPointIndices, styles = _a.styles;
        var n = hoverPointIndex !== null ? 1 : 0;
        var visibleLabels = new Uint32Array(n);
        var scale = new Float32Array(n);
        var opacityFlags = new Int8Array(n);
        var fillColors = new Uint8Array(n * 3);
        var strokeColors = new Uint8Array(n * 3);
        var labelStrings = [];
        scale.fill(styles.label.scaleDefault);
        opacityFlags.fill(1);
        var dst = 0;
        if (hoverPointIndex !== null) {
            labelStrings.push(this.getLabelText(hoverPointIndex));
            visibleLabels[dst] = hoverPointIndex;
            scale[dst] = styles.label.scaleLarge;
            opacityFlags[dst] = 0;
            var fillRgb = $18e0ef071f720394$exports.styleRgbFromHexColor(styles.label.fillColorHover);
            $18e0ef071f720394$exports.packRgbIntoUint8Array(fillColors, dst, fillRgb[0], fillRgb[1], fillRgb[2]);
            var strokeRgb = $18e0ef071f720394$exports.styleRgbFromHexColor(styles.label.strokeColorHover);
            $18e0ef071f720394$exports.packRgbIntoUint8Array(strokeColors, dst, strokeRgb[0], strokeRgb[1], strokeRgb[1]);
            ++dst;
        }
        var fillRgb = $18e0ef071f720394$exports.styleRgbFromHexColor(styles.label.fillColorSelected);
        var strokeRgb = $18e0ef071f720394$exports.styleRgbFromHexColor(styles.label.strokeColorSelected);
        if (selectedPointIndices.size === 1) {
            var labelIndex = $7aca01f07175d0d8$var$__spread(selectedPointIndices)[0];
            labelStrings.push(this.getLabelText(labelIndex));
            visibleLabels[dst] = labelIndex;
            scale[dst] = styles.label.scaleLarge;
            opacityFlags[dst] = 0;
            $18e0ef071f720394$exports.packRgbIntoUint8Array(fillColors, dst, fillRgb[0], fillRgb[1], fillRgb[2]);
            $18e0ef071f720394$exports.packRgbIntoUint8Array(strokeColors, dst, strokeRgb[0], strokeRgb[1], strokeRgb[2]);
        }
        return new $480c19973a73a2be$exports.LabelRenderParams(new Float32Array(visibleLabels), labelStrings, scale, opacityFlags, styles.label.fontSize, fillColors, strokeColors);
    };
    ScatterGL.prototype.generatePointScaleFactorArray = function(dataset) {
        var e_1, _a;
        var _b = this, hoverPointIndex = _b.hoverPointIndex, selectedPointIndices = _b.selectedPointIndices, styles = _b.styles;
        var _c = styles.point, scaleDefault = _c.scaleDefault, scaleSelected = _c.scaleSelected, scaleHover = _c.scaleHover;
        var scale = new Float32Array(dataset.points.length);
        scale.fill(scaleDefault);
        var selectedPointCount = selectedPointIndices.size;
        try {
            for(var _d = $7aca01f07175d0d8$var$__values(selectedPointIndices.values()), _e = _d.next(); !_e.done; _e = _d.next()){
                var p = _e.value;
                scale[p] = scaleSelected;
            }
        } catch (e_1_1) {
            e_1 = {
                error: e_1_1
            };
        } finally{
            try {
                if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
            } finally{
                if (e_1) throw e_1.error;
            }
        }
        if (hoverPointIndex != null) scale[hoverPointIndex] = scaleHover;
        return scale;
    };
    ScatterGL.prototype.generatePointColorArray = function(dataset) {
        var e_2, _a;
        var _b = this, hoverPointIndex = _b.hoverPointIndex, pointColorer = _b.pointColorer, selectedPointIndices = _b.selectedPointIndices, styles = _b.styles;
        var _c = styles.point, colorHover = _c.colorHover, colorNoSelection = _c.colorNoSelection, colorSelected = _c.colorSelected, colorUnselected = _c.colorUnselected;
        var colors = new Float32Array(dataset.points.length * $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS);
        var unselectedColor = colorUnselected;
        var noSelectionColor = colorNoSelection;
        if (this.renderMode === "TEXT") {
            unselectedColor = this.styles.label3D.colorUnselected;
            noSelectionColor = this.styles.label3D.colorNoSelection;
        }
        if (this.renderMode === "SPRITE") {
            unselectedColor = this.styles.sprites.colorUnselected;
            noSelectionColor = this.styles.sprites.colorNoSelection;
        }
        var n = dataset.points.length;
        var selectedPointCount = this.selectedPointIndices.size;
        if (pointColorer) {
            var dst = 0;
            for(var i = 0; i < n; ++i){
                var c = $749a49c2dd17f2c1$exports.parseColor(this.callPointColorer(pointColorer, i) || noSelectionColor);
                colors[dst++] = c.r;
                colors[dst++] = c.g;
                colors[dst++] = c.b;
                colors[dst++] = c.opacity;
            }
        } else {
            var dst = 0;
            var c = selectedPointCount > 0 ? $749a49c2dd17f2c1$exports.parseColor(unselectedColor) : $749a49c2dd17f2c1$exports.parseColor(noSelectionColor);
            for(var i = 0; i < n; ++i){
                colors[dst++] = c.r;
                colors[dst++] = c.g;
                colors[dst++] = c.b;
                colors[dst++] = c.opacity;
            }
            c = $749a49c2dd17f2c1$exports.parseColor(colorSelected);
            try {
                for(var _d = $7aca01f07175d0d8$var$__values(selectedPointIndices.values()), _e = _d.next(); !_e.done; _e = _d.next()){
                    var selectedPointIndex = _e.value;
                    var dst_1 = selectedPointIndex * $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS;
                    colors[dst_1++] = c.r;
                    colors[dst_1++] = c.g;
                    colors[dst_1++] = c.b;
                    colors[dst_1++] = c.opacity;
                }
            } catch (e_2_1) {
                e_2 = {
                    error: e_2_1
                };
            } finally{
                try {
                    if (_e && !_e.done && (_a = _d.return)) _a.call(_d);
                } finally{
                    if (e_2) throw e_2.error;
                }
            }
            if (hoverPointIndex != null) {
                var c_1 = $749a49c2dd17f2c1$exports.parseColor(colorHover);
                var dst_2 = hoverPointIndex * $00b5687c084295e3$exports.RGBA_NUM_ELEMENTS;
                colors[dst_2++] = c_1.r;
                colors[dst_2++] = c_1.g;
                colors[dst_2++] = c_1.b;
                colors[dst_2++] = c_1.opacity;
            }
        }
        return colors;
    };
    ScatterGL.prototype.generate3DLabelsArray = function() {
        var dataset = this.dataset;
        if (!dataset) return [];
        var labels = [];
        var n = dataset.points.length;
        for(var i = 0; i < n; ++i)labels.push(this.getLabelText(i));
        return labels;
    };
    ScatterGL.prototype.generateLineSegmentColorMap = function(dataset) {
        var _a = this, pointColorer = _a.pointColorer, styles = _a.styles;
        var polylineColorArrayMap = {};
        for(var i = 0; i < this.sequences.length; i++){
            var sequence = this.sequences[i];
            var colors = new Float32Array(2 * (sequence.indices.length - 1) * 3);
            var colorIndex = 0;
            if (pointColorer) for(var j = 0; j < sequence.indices.length - 1; j++){
                var c1 = $749a49c2dd17f2c1$exports.parseColor(this.callPointColorer(pointColorer, sequence.indices[j]));
                var c2 = $749a49c2dd17f2c1$exports.parseColor(this.callPointColorer(pointColorer, sequence.indices[j + 1]));
                colors[colorIndex++] = c1.r;
                colors[colorIndex++] = c1.g;
                colors[colorIndex++] = c1.b;
                colors[colorIndex++] = c2.r;
                colors[colorIndex++] = c2.g;
                colors[colorIndex++] = c2.b;
            }
            else for(var j = 0; j < sequence.indices.length - 1; j++){
                var c1 = $18e0ef071f720394$exports.getDefaultPointInPolylineColor(j, sequence.indices.length, styles.polyline.startHue, styles.polyline.endHue, styles.polyline.saturation, styles.polyline.lightness);
                var c2 = $18e0ef071f720394$exports.getDefaultPointInPolylineColor(j + 1, sequence.indices.length, styles.polyline.startHue, styles.polyline.endHue, styles.polyline.saturation, styles.polyline.lightness);
                colors[colorIndex++] = c1.r;
                colors[colorIndex++] = c1.g;
                colors[colorIndex++] = c1.b;
                colors[colorIndex++] = c2.r;
                colors[colorIndex++] = c2.g;
                colors[colorIndex++] = c2.b;
            }
            polylineColorArrayMap[i] = colors;
        }
        return polylineColorArrayMap;
    };
    ScatterGL.prototype.generateLineSegmentOpacityArray = function(dataset) {
        var _a = this, selectedPointIndices = _a.selectedPointIndices, styles = _a.styles;
        var opacities = new Float32Array(this.sequences.length);
        var selectedPointCount = selectedPointIndices.size;
        if (selectedPointCount > 0) {
            opacities.fill(styles.polyline.deselectedOpacity);
            var i = this.polylineVisualizer.getPointSequenceIndex($7aca01f07175d0d8$var$__spread(selectedPointIndices)[0]);
            if (i !== undefined) opacities[i] = styles.polyline.selectedOpacity;
        } else opacities.fill(styles.polyline.defaultOpacity);
        return opacities;
    };
    ScatterGL.prototype.generateLineSegmentWidthArray = function(dataset) {
        var _a = this, selectedPointIndices = _a.selectedPointIndices, styles = _a.styles;
        var widths = new Float32Array(this.sequences.length);
        widths.fill(styles.polyline.defaultLineWidth);
        var selectedPointCount = selectedPointIndices.size;
        if (selectedPointCount > 0) {
            var i = this.polylineVisualizer.getPointSequenceIndex($7aca01f07175d0d8$var$__spread(selectedPointIndices)[0]);
            if (i !== undefined) widths[i] = styles.polyline.selectedLineWidth;
        }
        return widths;
    };
    ScatterGL.prototype.getLabelText = function(i) {
        var dataset = this.dataset;
        if (!dataset) return '';
        var metadata = dataset.metadata[i];
        return metadata && metadata.label != null ? "" + metadata.label : '';
    };
    ScatterGL.prototype.initializeCanvasLabelsVisualizer = function() {
        if (!this.canvasLabelsVisualizer) this.canvasLabelsVisualizer = new $40353bc42ddffc62$exports.ScatterPlotVisualizerCanvasLabels(this.containerElement, this.styles);
        return this.canvasLabelsVisualizer;
    };
    ScatterGL.prototype.initialize3DLabelsVisualizer = function() {
        if (!this.labels3DVisualizer) this.labels3DVisualizer = new $7b3b9345c90293f3$exports.ScatterPlotVisualizer3DLabels(this.styles);
        this.labels3DVisualizer.setLabelStrings(this.generate3DLabelsArray());
        return this.labels3DVisualizer;
    };
    ScatterGL.prototype.initializePointVisualizer = function() {
        if (!this.pointVisualizer) this.pointVisualizer = new $5d0295989f090b05$exports.ScatterPlotVisualizerSprites(this.styles);
        return this.pointVisualizer;
    };
    ScatterGL.prototype.initializeSpritesheetVisualizer = function() {
        var _this = this;
        var styles = this.styles;
        var dataset = this.dataset;
        var spriteMetadata = dataset.spriteMetadata;
        if (!this.spritesheetVisualizer && spriteMetadata) {
            if (!spriteMetadata.spriteImage || !spriteMetadata.singleSpriteSize) return;
            var n = dataset.points.length;
            var spriteIndices = void 0;
            if (spriteMetadata.spriteIndices) spriteIndices = new Float32Array(spriteMetadata.spriteIndices);
            else {
                spriteIndices = new Float32Array(n);
                for(var i = 0; i < n; ++i)spriteIndices[i] = i;
            }
            var onImageLoad = function() {
                return _this.renderScatterPlot();
            };
            var spritesheetVisualizer = new $5d0295989f090b05$exports.ScatterPlotVisualizerSprites(styles, {
                spritesheetImage: spriteMetadata.spriteImage,
                spriteDimensions: spriteMetadata.singleSpriteSize,
                spriteIndices: spriteIndices,
                onImageLoad: onImageLoad
            });
            spritesheetVisualizer.id = 'SPRITE_SHEET_VISUALIZER';
            this.spritesheetVisualizer = spritesheetVisualizer;
        }
        return this.spritesheetVisualizer;
    };
    ScatterGL.prototype.initializePolylineVisualizer = function() {
        if (!this.polylineVisualizer) this.polylineVisualizer = new $6b8c0a9dd7ee1b6d$exports.ScatterPlotVisualizerPolylines();
        this.polylineVisualizer.setSequences(this.sequences);
        return this.polylineVisualizer;
    };
    ScatterGL.prototype.setVisualizers = function() {
        var _a = this, dataset = _a.dataset, renderMode = _a.renderMode;
        var activeVisualizers = [];
        if (renderMode === "TEXT") {
            var visualizer = this.initialize3DLabelsVisualizer();
            activeVisualizers.push(visualizer);
        } else if (renderMode === "POINT") {
            var visualizer = this.initializePointVisualizer();
            activeVisualizers.push(visualizer);
        } else if (renderMode === "SPRITE" && dataset.spriteMetadata) {
            var visualizer = this.initializeSpritesheetVisualizer();
            if (visualizer) activeVisualizers.push(visualizer);
        }
        if (this.sequences.length > 0) {
            var visualizer = this.initializePolylineVisualizer();
            activeVisualizers.push(visualizer);
        }
        var textLabelsRenderMode = renderMode === "POINT" || renderMode === "SPRITE";
        if (textLabelsRenderMode && this.showLabelsOnHover) {
            var visualizer = this.initializeCanvasLabelsVisualizer();
            activeVisualizers.push(visualizer);
        }
        this.scatterPlot.setActiveVisualizers(activeVisualizers);
    };
    ScatterGL.Dataset = $9e8f9a54f1e224ec$exports.Dataset;
    return ScatterGL;
}();
$7aca01f07175d0d8$exports.ScatterGL = $7aca01f07175d0d8$var$ScatterGL;


$abd2d8e70de93536$exports.ScatterGL = $7aca01f07175d0d8$exports.ScatterGL;

$abd2d8e70de93536$exports.Dataset = $9e8f9a54f1e224ec$exports.Dataset;



// These anchor points allow the pose pointcloud to resize according to its
// position in the input.
const $96f6625aee0e377e$var$ANCHOR_POINTS = [
    [
        0,
        0,
        0
    ],
    [
        0,
        1,
        0
    ],
    [
        -1,
        0,
        0
    ],
    [
        -1,
        -1,
        0
    ]
];
const $96f6625aee0e377e$var$LEFT_COLOR = "#00ff00";
const $96f6625aee0e377e$var$RIGHT_COLOR = "#ffa500";
const $96f6625aee0e377e$var$MIDDLE_COLOR = "#ff0000";
class $96f6625aee0e377e$export$8c0ff5fc83e0c92 {
    /**
   * @param options.mirror Whether the source image is mirrored, as a camera
   *   preview is and a recorded file is not. Mirroring is applied to the
   *   context once here rather than per draw, so everything drawn through it
   *   inherits the flip — see the note on Readout.
   */ constructor(canvas, { mirror: mirror = true } = {}){
        this.ctx = canvas.getContext("2d");
        this.scatterGLEl = document.querySelector("#scatter-gl-container");
        this.scatterGL = new $abd2d8e70de93536$exports.ScatterGL(this.scatterGLEl, {
            rotateOnStart: true,
            selectEnabled: false,
            styles: {
                polyline: {
                    defaultOpacity: 1,
                    deselectedOpacity: 1
                }
            }
        });
        this.scatterGLHasInitialized = false;
        this.videoWidth = canvas.width;
        this.videoHeight = canvas.height;
        // Precompute the side lookup so the per-frame path is a plain array read.
        this.sideByIndex = new Array($4765f54d936bfe63$export$8519f787e6064507.length).fill($96f6625aee0e377e$var$MIDDLE_COLOR);
        for (const i of $4765f54d936bfe63$export$17f063499ab4f36b.left)this.sideByIndex[i] = $96f6625aee0e377e$var$LEFT_COLOR;
        for (const i of $4765f54d936bfe63$export$17f063499ab4f36b.right)this.sideByIndex[i] = $96f6625aee0e377e$var$RIGHT_COLOR;
        this.mirror = mirror;
        this.flip(this.videoWidth, this.videoHeight);
    }
    flip(videoWidth, videoHeight) {
        // Because the image from camera is mirrored, need to flip horizontally.
        // A video file is already the right way round, so it is left alone.
        if (this.mirror) {
            this.ctx.translate(videoWidth, 0);
            this.ctx.scale(-1, 1);
        }
        this.scatterGLEl.style = `width: ${videoWidth}px; height: ${videoHeight}px;`;
        this.scatterGL.resize();
        this.scatterGLEl.style.display = $4765f54d936bfe63$export$63b4527a2777036f.render3D ? "inline-block" : "none";
    }
    /**
   * @param video The source video element.
   * @param result A PoseLandmarkerResult, already smoothed.
   */ draw(video, result) {
        this.drawCtx(video);
        if (result == null) return;
        for (const landmarks of result.landmarks){
            this.drawKeypoints(landmarks);
            this.drawSkeleton(landmarks);
        }
        if ($4765f54d936bfe63$export$63b4527a2777036f.render3D && result.worldLandmarks.length > 0) this.drawKeypoints3D(result.worldLandmarks[0]);
    }
    drawCtx(video) {
        this.ctx.drawImage(video, 0, 0, this.videoWidth, this.videoHeight);
    }
    clearCtx() {
        this.ctx.clearRect(0, 0, this.videoWidth, this.videoHeight);
    }
    /** Landmarks arrive normalized to 0..1; scale them into canvas pixels. */ toPixels(landmark) {
        return {
            x: landmark.x * this.videoWidth,
            y: landmark.y * this.videoHeight
        };
    }
    isVisible(landmark) {
        // Treat a missing visibility as visible, matching the model's own
        // behaviour for variants that do not emit the field.
        const visibility = landmark.visibility != null ? landmark.visibility : 1;
        return visibility >= $4765f54d936bfe63$export$63b4527a2777036f.visibilityThreshold;
    }
    /**
   * Draw the keypoints on the video, coloured by body side so that left and
   * right stay distinguishable in side-on views.
   */ drawKeypoints(landmarks) {
        this.ctx.strokeStyle = "White";
        this.ctx.lineWidth = $4765f54d936bfe63$export$fa5c98d8c8e603f1;
        landmarks.forEach((landmark, i)=>{
            if (!this.isVisible(landmark)) return;
            this.ctx.fillStyle = this.sideByIndex[i];
            const { x: x, y: y } = this.toPixels(landmark);
            const circle = new Path2D();
            circle.arc(x, y, $4765f54d936bfe63$export$63f2df7bd7371262, 0, 2 * Math.PI);
            this.ctx.fill(circle);
            this.ctx.stroke(circle);
        });
    }
    /**
   * Draw the skeleton of a body on the video. Each bone takes the colour of its
   * side, so an occluded limb crossing the body is still readable.
   */ drawSkeleton(landmarks) {
        this.ctx.lineWidth = $4765f54d936bfe63$export$fa5c98d8c8e603f1;
        for (const { start: start, end: end } of (0, $a2acea4f3420f1d8$export$fe95e48202120e29).POSE_CONNECTIONS){
            const from = landmarks[start];
            const to = landmarks[end];
            if (from == null || to == null) continue;
            if (!this.isVisible(from) || !this.isVisible(to)) continue;
            // A bone spanning the midline gets the colour of its far end.
            this.ctx.strokeStyle = this.sideByIndex[start] === $96f6625aee0e377e$var$MIDDLE_COLOR ? this.sideByIndex[end] : this.sideByIndex[start];
            const a = this.toPixels(from);
            const b = this.toPixels(to);
            this.ctx.beginPath();
            this.ctx.moveTo(a.x, a.y);
            this.ctx.lineTo(b.x, b.y);
            this.ctx.stroke();
        }
    }
    /**
   * Render the metric world landmarks as a rotatable point cloud. This is the
   * view that disambiguates depth, so it is the useful one for side-on work.
   */ drawKeypoints3D(landmarks) {
        const pointsData = landmarks.map((landmark)=>[
                -landmark.x,
                -landmark.y,
                -landmark.z
            ]);
        const dataset = new $abd2d8e70de93536$exports.ScatterGL.Dataset([
            ...pointsData,
            ...$96f6625aee0e377e$var$ANCHOR_POINTS
        ]);
        this.scatterGL.setPointColorer((i)=>{
            // Hide the anchor points and any landmark the model is unsure of.
            if (landmarks[i] == null || !this.isVisible(landmarks[i])) return "#ffffff";
            return this.sideByIndex[i];
        });
        if (!this.scatterGLHasInitialized) this.scatterGL.render(dataset);
        else this.scatterGL.updateDataset(dataset);
        const sequences = (0, $a2acea4f3420f1d8$export$fe95e48202120e29).POSE_CONNECTIONS.map(({ start: start, end: end })=>({
                indices: [
                    start,
                    end
                ]
            }));
        this.scatterGL.setSequences(sequences);
        this.scatterGLHasInitialized = true;
    }
}



/**
 * A fixed-capacity ring of per-frame samples.
 *
 * Every metric is a question about a span of time — a range, a peak, a
 * difference between two events — but the render loop only ever holds the
 * current frame. This is the history those questions are asked against.
 *
 * It stores derived scalars rather than raw landmarks: that is what the metrics
 * consume, and it keeps a few seconds of history to a few tens of kilobytes.
 * If a future metric needs the landmarks themselves, this is where they would
 * be added.
 */ class $ee1111b42ffa8532$export$50ba7b64cce2f44c {
    /** @param capacity Number of samples to retain. At 60fps, 600 is ten seconds. */ constructor(capacity = 600){
        if (!(capacity > 0)) throw new Error(`FrameBuffer capacity must be positive, got ${capacity}`);
        this.capacity = capacity;
        this.items = [];
        this.start = 0;
    }
    get size() {
        return this.items.length;
    }
    push(sample) {
        if (this.items.length < this.capacity) {
            this.items.push(sample);
            return;
        }
        // Full: overwrite the oldest slot and advance the start marker.
        this.items[this.start] = sample;
        this.start = (this.start + 1) % this.capacity;
    }
    clear() {
        this.items = [];
        this.start = 0;
    }
    /** Oldest to newest. */ toArray() {
        if (this.items.length < this.capacity) return this.items.slice();
        return this.items.slice(this.start).concat(this.items.slice(0, this.start));
    }
    last() {
        if (this.items.length === 0) return null;
        const index = this.items.length < this.capacity ? this.items.length - 1 : (this.start + this.capacity - 1) % this.capacity;
        return this.items[index];
    }
    /**
   * Samples from the last `ms` milliseconds, oldest to newest. Empty if there
   * is no history yet.
   */ window(ms) {
        const newest = this.last();
        if (newest == null) return [];
        const cutoff = newest.t - ms;
        return this.toArray().filter((s)=>s.t >= cutoff);
    }
}


/**
 * Reduces one frame of landmarks to the scalar signals the metrics are built
 * from. Kept separate from the metric definitions so that the per-frame cost is
 * paid once, no matter how many metrics read the result.
 */ /**
 * Geometric primitives for pose metrics.
 *
 * Everything here works on the **image-plane projection of `worldLandmarks`**:
 * the x and y components only, in metres, with the origin at the hip centre.
 * The z axis is deliberately dropped. MediaPipe's depth estimate is weakly
 * supervised and far noisier than x/y, and every metric in the MVP is a joint
 * angle whose error would be dominated by that noise. Working in the projection
 * keeps the numbers trustworthy; the declared camera view is what tells us
 * which anatomical plane the projection corresponds to.
 *
 * Verified coordinate conventions (measured, not assumed — see the axis probe
 * in the commit that introduced this file):
 *   - origin is the midpoint of the hips
 *   - up is NEGATIVE y (shoulders sit at y ≈ -0.49 on a standing adult)
 *   - positive x is the athlete's LEFT, which is the right-hand side of the
 *     image when they face the camera
 *   - units are metres
 */ 
const $cc0f2085491d6651$var$RAD_TO_DEG = 180 / Math.PI;
const $cc0f2085491d6651$export$b29f845fa4b57508 = {
    x: 0,
    y: -1
};
function $cc0f2085491d6651$export$f93b5905241a7cca(a, b) {
    return {
        x: a.x - b.x,
        y: a.y - b.y
    };
}
function $cc0f2085491d6651$export$f2e8a19be46147af(a, b) {
    return {
        x: (a.x + b.x) / 2,
        y: (a.y + b.y) / 2
    };
}
function $cc0f2085491d6651$export$f24224f1c91d8156(v) {
    return Math.hypot(v.x, v.y);
}
function $cc0f2085491d6651$export$a3295358bff77e(v) {
    const len = $cc0f2085491d6651$export$f24224f1c91d8156(v);
    return len === 0 ? {
        x: 0,
        y: 0
    } : {
        x: v.x / len,
        y: v.y / len
    };
}
function $cc0f2085491d6651$export$94132a0e348806d4(a, b) {
    return a.x * b.x + a.y * b.y;
}
function $cc0f2085491d6651$export$bb646b20bb93d339(a, b) {
    return a.x * b.y - a.y * b.x;
}
function $cc0f2085491d6651$export$2c039ab0034c6824(from, to) {
    return $cc0f2085491d6651$var$RAD_TO_DEG * Math.atan2($cc0f2085491d6651$export$bb646b20bb93d339(from, to), $cc0f2085491d6651$export$94132a0e348806d4(from, to));
}
function $cc0f2085491d6651$export$1e3beed969d52e9c(a, b, c) {
    const ba = $cc0f2085491d6651$export$f93b5905241a7cca(a, b);
    const bc = $cc0f2085491d6651$export$f93b5905241a7cca(c, b);
    // atan2 of |cross| against dot stays stable near 0 and 180 degrees, where
    // acos(dot / |a||b|) loses precision badly.
    return $cc0f2085491d6651$var$RAD_TO_DEG * Math.atan2(Math.abs($cc0f2085491d6651$export$bb646b20bb93d339(ba, bc)), $cc0f2085491d6651$export$94132a0e348806d4(ba, bc));
}
function $cc0f2085491d6651$export$8fb5883e7a138415(pose) {
    const hip = $cc0f2085491d6651$export$f2e8a19be46147af(pose[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HIP], pose[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HIP]);
    const shoulder = $cc0f2085491d6651$export$f2e8a19be46147af(pose[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER], pose[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER]);
    return {
        hip: hip,
        shoulder: shoulder,
        up: $cc0f2085491d6651$export$a3295358bff77e($cc0f2085491d6651$export$f93b5905241a7cca(shoulder, hip))
    };
}
function $cc0f2085491d6651$export$4f202c2986bb5540(pose) {
    return $cc0f2085491d6651$export$2c039ab0034c6824($cc0f2085491d6651$export$b29f845fa4b57508, $cc0f2085491d6651$export$8fb5883e7a138415(pose).up);
}
function $cc0f2085491d6651$export$73b01e5cb56afbbf(pose, side) {
    const { up: up } = $cc0f2085491d6651$export$8fb5883e7a138415(pose);
    const down = {
        x: -up.x,
        y: -up.y
    };
    const shoulder = pose[side === "left" ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER];
    const elbow = pose[side === "left" ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_ELBOW : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_ELBOW];
    // Negated so that positive means +x for both this and trunkTilt. Measuring
    // from `down` rather than from `UP` reverses the cross-product sign, and
    // without this the two signed angles would disagree about which way is which.
    return -$cc0f2085491d6651$export$2c039ab0034c6824(down, $cc0f2085491d6651$export$f93b5905241a7cca(elbow, shoulder));
}
function $cc0f2085491d6651$export$1226f403e94f0c91(pose, side) {
    const isLeft = side === "left";
    return $cc0f2085491d6651$export$1e3beed969d52e9c(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_ELBOW : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_ELBOW], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_WRIST : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_WRIST]);
}
function $cc0f2085491d6651$export$d64cf3abde4cdb36(pose, side) {
    const isLeft = side === "left";
    const chain = [
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER],
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_ELBOW : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_ELBOW],
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_WRIST : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_WRIST]
    ];
    let total = 0;
    for (const p of chain)total += p.visibility != null ? p.visibility : 1;
    return total / chain.length;
}
function $cc0f2085491d6651$export$18d4e3868b02b8fa(pose, side) {
    return Math.abs($cc0f2085491d6651$export$73b01e5cb56afbbf(pose, side));
}
function $cc0f2085491d6651$export$2dc95e612047cef1(pose, side) {
    const isLeft = side === "left";
    return $cc0f2085491d6651$export$1e3beed969d52e9c(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HIP : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HIP], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_KNEE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_KNEE], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_ANKLE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_ANKLE]);
}
function $cc0f2085491d6651$export$bb427f6d855d0ca7(pose, side) {
    const isLeft = side === "left";
    return $cc0f2085491d6651$export$1e3beed969d52e9c(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HIP : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HIP], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_KNEE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_KNEE]);
}
function $cc0f2085491d6651$export$b8104747b1440175(pose, side) {
    const isLeft = side === "left";
    return Math.min($cc0f2085491d6651$var$visibilityOf(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER]), $cc0f2085491d6651$var$visibilityOf(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HIP : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HIP]), $cc0f2085491d6651$var$visibilityOf(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_KNEE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_KNEE]));
}
function $cc0f2085491d6651$export$818fcf01ae577fc1(pose, side) {
    const isLeft = side === "left";
    const heel = pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HEEL : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HEEL];
    const toe = pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_FOOT_INDEX : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_FOOT_INDEX];
    // Up is negative y, so the toe being lower means a larger y.
    return toe.y - heel.y;
}
function $cc0f2085491d6651$export$6d1d6f374b7a903d(pose, side) {
    const isLeft = side === "left";
    return $cc0f2085491d6651$export$f24224f1c91d8156($cc0f2085491d6651$export$f93b5905241a7cca(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_FOOT_INDEX : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_FOOT_INDEX], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HEEL : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HEEL]));
}
function $cc0f2085491d6651$export$511e18f89c19057(pose, side) {
    const { up: up } = $cc0f2085491d6651$export$8fb5883e7a138415(pose);
    const ear = pose[side === "left" ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_EAR : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_EAR];
    const head = $cc0f2085491d6651$export$f93b5905241a7cca(pose[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).NOSE], ear);
    // The magnitude first: the signed angle's own sign flips with which way the
    // athlete faces, which is not what is being asked.
    return Math.abs($cc0f2085491d6651$export$2c039ab0034c6824(up, head)) - 90;
}
function $cc0f2085491d6651$export$46ccc94fcac5f66f(pose, side) {
    return pose[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).NOSE].x - pose[side === "left" ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_EAR : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_EAR].x;
}
function $cc0f2085491d6651$export$e3a5c5b59e7202c5(point, pose, side, facing) {
    return facing * (point.x - pose[side === "left" ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_KNEE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_KNEE].x);
}
function $cc0f2085491d6651$export$11c092ac8d4e295c(pose) {
    return $cc0f2085491d6651$export$f2e8a19be46147af(pose[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER], pose[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER]);
}
function $cc0f2085491d6651$export$971407c4402b061c(pose, side) {
    const isLeft = side === "left";
    return Math.min($cc0f2085491d6651$export$d64cf3abde4cdb36(pose, side), $cc0f2085491d6651$var$visibilityOf(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HIP : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HIP]), $cc0f2085491d6651$var$visibilityOf(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER]));
}
function $cc0f2085491d6651$var$visibilityOf(point) {
    return point.visibility != null ? point.visibility : 1;
}
function $cc0f2085491d6651$export$6e742c511f2b18e7(pose, side) {
    const isLeft = side === "left";
    const chain = [
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_KNEE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_KNEE],
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_ANKLE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_ANKLE],
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HEEL : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HEEL]
    ];
    let lowest = 1;
    for (const p of chain)lowest = Math.min(lowest, $cc0f2085491d6651$var$visibilityOf(p));
    // The lowest, not the mean: one guessed landmark is enough to invalidate a
    // knee angle or a heel height, and a mean lets two good ones hide it.
    return lowest;
}
function $cc0f2085491d6651$export$12e4782e65f1e530(pose, side) {
    const isLeft = side === "left";
    return $cc0f2085491d6651$export$1e3beed969d52e9c(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_KNEE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_KNEE], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_ANKLE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_ANKLE], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_FOOT_INDEX : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_FOOT_INDEX]);
}
function $cc0f2085491d6651$export$8671c91be085aa51(pose, side) {
    const isLeft = side === "left";
    return $cc0f2085491d6651$export$1e3beed969d52e9c(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_WRIST : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_WRIST], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER], pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HIP : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HIP]);
}
function $cc0f2085491d6651$export$ad18e54ad212c661(pose, side) {
    const isLeft = side === "left";
    const chain = [
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_WRIST : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_WRIST],
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_ELBOW : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_ELBOW],
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER],
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_HIP : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_HIP],
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_KNEE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_KNEE],
        pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_ANKLE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_ANKLE]
    ];
    let lowest = 1;
    for (const p of chain)lowest = Math.min(lowest, $cc0f2085491d6651$var$visibilityOf(p));
    return lowest;
}
function $cc0f2085491d6651$export$37fb96dde07e6d8c(pose, side) {
    const isLeft = side === "left";
    const wrist = pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_WRIST : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_WRIST];
    const ankle = pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_ANKLE : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_ANKLE];
    return ankle.x - wrist.x;
}
function $cc0f2085491d6651$export$a2ecadb1de46e762(pose, side) {
    const isLeft = side === "left";
    const shoulder = pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_SHOULDER : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_SHOULDER];
    const arm = $cc0f2085491d6651$export$f93b5905241a7cca(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_WRIST : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_WRIST], shoulder);
    const head = $cc0f2085491d6651$export$f93b5905241a7cca(pose[isLeft ? (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_EAR : (0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_EAR], shoulder);
    if ($cc0f2085491d6651$export$f24224f1c91d8156(arm) < 1e-6 || $cc0f2085491d6651$export$f24224f1c91d8156(head) < 1e-6) return null;
    return $cc0f2085491d6651$export$2c039ab0034c6824(arm, head);
}



function $4851c46e13ae947d$export$f77d0f9ead22ddee(world, t) {
    return {
        t: t,
        armAngle: {
            left: $cc0f2085491d6651$export$73b01e5cb56afbbf(world, "left"),
            right: $cc0f2085491d6651$export$73b01e5cb56afbbf(world, "right")
        },
        // Bounded 0..180, and what ranges are taken over; see armElevation.
        elevation: {
            left: $cc0f2085491d6651$export$18d4e3868b02b8fa(world, "left"),
            right: $cc0f2085491d6651$export$18d4e3868b02b8fa(world, "right")
        },
        elbow: {
            left: $cc0f2085491d6651$export$1226f403e94f0c91(world, "left"),
            right: $cc0f2085491d6651$export$1226f403e94f0c91(world, "right")
        },
        visibility: {
            left: $cc0f2085491d6651$export$d64cf3abde4cdb36(world, "left"),
            right: $cc0f2085491d6651$export$d64cf3abde4cdb36(world, "right")
        },
        trunkTilt: $cc0f2085491d6651$export$4f202c2986bb5540(world),
        knee: {
            left: $cc0f2085491d6651$export$2dc95e612047cef1(world, "left"),
            right: $cc0f2085491d6651$export$2dc95e612047cef1(world, "right")
        },
        // Shoulder-hip-knee: 180 lying flat, closing as the body folds. What a
        // V-sit is counted and scored on.
        hip: {
            left: $cc0f2085491d6651$export$bb427f6d855d0ca7(world, "left"),
            right: $cc0f2085491d6651$export$bb427f6d855d0ca7(world, "right")
        },
        // Metres. Divided by footLength at scoring time, not here, because the
        // scale wanted is the recording's median rather than this frame's — an
        // occluded foot measures as short as 3cm against a 13cm median, and a
        // per-frame ratio would spike for that reason rather than a raised heel.
        heelLift: {
            left: $cc0f2085491d6651$export$818fcf01ae577fc1(world, "left"),
            right: $cc0f2085491d6651$export$818fcf01ae577fc1(world, "right")
        },
        footLength: {
            left: $cc0f2085491d6651$export$6d1d6f374b7a903d(world, "left"),
            right: $cc0f2085491d6651$export$6d1d6f374b7a903d(world, "right")
        },
        headPitch: {
            left: $cc0f2085491d6651$export$511e18f89c19057(world, "left"),
            right: $cc0f2085491d6651$export$511e18f89c19057(world, "right")
        },
        // Signed along +x, with the facing sign applied at scoring time: which way
        // the athlete faces is a property of the take, not of one frame.
        aheadOfKneeRaw: {
            left: {
                head: $cc0f2085491d6651$export$e3a5c5b59e7202c5(world[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).LEFT_EAR], world, "left", 1),
                chest: $cc0f2085491d6651$export$e3a5c5b59e7202c5($cc0f2085491d6651$export$11c092ac8d4e295c(world), world, "left", 1)
            },
            right: {
                head: $cc0f2085491d6651$export$e3a5c5b59e7202c5(world[(0, $4765f54d936bfe63$export$93e1ca20ea9c5749).RIGHT_EAR], world, "right", 1),
                chest: $cc0f2085491d6651$export$e3a5c5b59e7202c5($cc0f2085491d6651$export$11c092ac8d4e295c(world), world, "right", 1)
            }
        },
        facingOffset: {
            left: $cc0f2085491d6651$export$46ccc94fcac5f66f(world, "left"),
            right: $cc0f2085491d6651$export$46ccc94fcac5f66f(world, "right")
        },
        legVisibility: {
            left: $cc0f2085491d6651$export$6e742c511f2b18e7(world, "left"),
            right: $cc0f2085491d6651$export$6e742c511f2b18e7(world, "right")
        },
        swingVisibility: {
            left: $cc0f2085491d6651$export$971407c4402b061c(world, "left"),
            right: $cc0f2085491d6651$export$971407c4402b061c(world, "right")
        },
        foldVisibility: {
            left: $cc0f2085491d6651$export$b8104747b1440175(world, "left"),
            right: $cc0f2085491d6651$export$b8104747b1440175(world, "right")
        },
        // The rest of the handstand's chain. The hip and the knee it already has;
        // what a line upside down adds is the shoulder, and a gate that spans the
        // whole body from the hand to the foot.
        shoulder: {
            left: $cc0f2085491d6651$export$8671c91be085aa51(world, "left"),
            right: $cc0f2085491d6651$export$8671c91be085aa51(world, "right")
        },
        ankle: {
            left: $cc0f2085491d6651$export$12e4782e65f1e530(world, "left"),
            right: $cc0f2085491d6651$export$12e4782e65f1e530(world, "right")
        },
        handstandVisibility: {
            left: $cc0f2085491d6651$export$ad18e54ad212c661(world, "left"),
            right: $cc0f2085491d6651$export$ad18e54ad212c661(world, "right")
        },
        wallLean: {
            left: $cc0f2085491d6651$export$37fb96dde07e6d8c(world, "left"),
            right: $cc0f2085491d6651$export$37fb96dde07e6d8c(world, "right")
        },
        // Signed by which side of the arm the ear is on, with the facing left to
        // the caller — the same arrangement as `aheadOfKneeRaw` and for the same
        // reason: which way the athlete faces belongs to the take, not the frame.
        earOffArmLineRaw: {
            left: $cc0f2085491d6651$export$a2ecadb1de46e762(world, "left"),
            right: $cc0f2085491d6651$export$a2ecadb1de46e762(world, "right")
        }
    };
}
function $4851c46e13ae947d$export$1cd850881aa38839(samples) {
    let left = 0;
    let right = 0;
    for (const s of samples){
        left += s.visibility.left;
        right += s.visibility.right;
    }
    return left >= right ? "left" : "right";
}


/**
 * Metric definitions, each declaring which camera views it is valid in.
 *
 * The view gate is the point of this file. Side-on, the far arm is occluded and
 * its landmarks are the model's best guess, so a left/right symmetry figure
 * still computes and still looks plausible while meaning nothing. Rather than
 * leave that to a caller to remember, each metric names the views it is honest
 * in, and the readout renders only those.
 *
 * Every `compute` takes a span of samples and returns a number, or null when
 * there is not enough history to answer.
 */ 
const $b2f3e77422e22e97$export$50bf86b71c5fd0d9 = [
    "side",
    "front"
];
function $b2f3e77422e22e97$var$range(values) {
    if (values.length === 0) return null;
    return Math.max(...values) - Math.min(...values);
}
/**
 * How much higher one arm is than the other, in degrees.
 *
 * Compares elevation MAGNITUDE, not the signed angle. The sign says which way
 * along x the arm went, so two arms held out symmetrically to either side carry
 * opposite signs and their raw difference is ~180 for what is in fact a
 * symmetric shape. Magnitude also sidesteps the sign flapping that happens when
 * an arm passes near vertical and its x component is close to zero.
 *
 * The tradeoff: this cannot see a fault where the arms are equally high but
 * travelling in opposite directions. Detecting that needs the swing direction
 * per arm, which is a rep-level question rather than a per-frame one.
 */ function $b2f3e77422e22e97$var$armElevationGap(sample) {
    return Math.abs(sample.elevation.left - sample.elevation.right);
}
function $b2f3e77422e22e97$var$rms(values) {
    if (values.length === 0) return null;
    const total = values.reduce((sum, v)=>sum + v * v, 0);
    return Math.sqrt(total / values.length);
}
const $b2f3e77422e22e97$export$3f0e99ae6e0ec541 = [
    {
        id: "swing_range",
        label: "Swing range",
        unit: "\xb0",
        views: [
            "side"
        ],
        precision: 0,
        help: "Peak-to-peak travel of the upper arm relative to the trunk.",
        compute: (samples)=>{
            const side = (0, $4851c46e13ae947d$export$1cd850881aa38839)(samples);
            // Elevation, not the signed angle: a shoulder cannot travel more than
            // 180 degrees from the trunk, so this is bounded by construction. The
            // signed angle wraps, and unwrapping it treats the joint as if it
            // revolved, which produced readings past 500 degrees on real footage.
            return $b2f3e77422e22e97$var$range(samples.map((s)=>s.elevation[side]));
        }
    },
    {
        id: "elbow_min",
        label: "Straightest elbow",
        unit: "\xb0",
        views: [
            "side"
        ],
        precision: 0,
        help: "Lowest elbow angle seen; divers want the swing arm near 180.",
        compute: (samples)=>{
            const side = (0, $4851c46e13ae947d$export$1cd850881aa38839)(samples);
            return Math.min(...samples.map((s)=>s.elbow[side]));
        }
    },
    {
        id: "elbow_min_both",
        label: "Straightest elbow",
        unit: "\xb0",
        views: [
            "front"
        ],
        precision: 0,
        help: "Lowest elbow angle across both arms.",
        compute: (samples)=>Math.min(...samples.map((s)=>Math.min(s.elbow.left, s.elbow.right)))
    },
    {
        id: "symmetry_peak",
        label: "Worst L/R gap",
        unit: "\xb0",
        views: [
            "front"
        ],
        precision: 0,
        help: "Largest instantaneous difference in how high the two arms are.",
        compute: (samples)=>Math.max(...samples.map($b2f3e77422e22e97$var$armElevationGap))
    },
    {
        id: "symmetry_rms",
        label: "Typical L/R gap",
        unit: "\xb0",
        views: [
            "front"
        ],
        precision: 1,
        help: "RMS difference in arm elevation across the window.",
        compute: (samples)=>$b2f3e77422e22e97$var$rms(samples.map($b2f3e77422e22e97$var$armElevationGap))
    },
    {
        id: "trunk_rock",
        label: "Trunk rock",
        unit: "\xb0",
        views: [
            "side"
        ],
        precision: 1,
        help: "Sagittal trunk movement; a swing drill wants this small.",
        compute: (samples)=>$b2f3e77422e22e97$var$range(samples.map((s)=>s.trunkTilt))
    },
    {
        id: "trunk_sway",
        label: "Trunk sway",
        unit: "\xb0",
        views: [
            "front"
        ],
        precision: 1,
        help: "Lateral trunk movement; a swing drill wants this small.",
        compute: (samples)=>$b2f3e77422e22e97$var$range(samples.map((s)=>s.trunkTilt))
    }
];
function $b2f3e77422e22e97$export$18ba04b5611ca1a6(view) {
    return $b2f3e77422e22e97$export$3f0e99ae6e0ec541.filter((m)=>m.views.includes(view));
}
function $b2f3e77422e22e97$export$fef61f332f2c0afc(view, samples) {
    return $b2f3e77422e22e97$export$83ff8900102eb45f($b2f3e77422e22e97$export$18ba04b5611ca1a6(view), samples);
}
function $b2f3e77422e22e97$export$83ff8900102eb45f(metrics, samples) {
    return metrics.map((metric)=>{
        let value = null;
        if (samples.length > 0) try {
            const computed = metric.compute(samples);
            value = Number.isFinite(computed) ? computed : null;
        } catch  {
            value = null;
        }
        return {
            ...metric,
            value: value
        };
    });
}


/**
 * Draws the metric panel over the video.
 *
 * The renderer permanently mirrors the 2D context so the camera image reads
 * correctly, which means anything drawn through it inherits that flip and comes
 * out backwards. Text especially. Every draw here happens inside a
 * save/setTransform/restore so the panel is laid out in ordinary screen
 * coordinates, and the mirror is put back untouched for the next frame.
 *
 * Set in the same bitmap face as the rest of the UI. A canvas never triggers a
 * font load of its own — it silently falls back — but the DOM is set in this face
 * too, so by the time the model has downloaded and this first draws, it is there.
 * The face is roughly twice as wide per character as a proportional one, which is
 * why every size here is smaller and the panel is wider than it looks like it
 * needs to be: "Straightest elbow" is seventeen characters.
 */ const $fc50d37955791958$var$FACE = '"Press Start 2P", ui-monospace, monospace';
const $fc50d37955791958$var$PADDING = 12;
const $fc50d37955791958$var$LINE_HEIGHT = 20;
const $fc50d37955791958$var$PANEL_WIDTH = 300;
/** The rep count has to be readable from across a gym, unlike the metrics. */ const $fc50d37955791958$var$COUNT_HEIGHT = 44;
/** The same without the progress bar, which a timed drill has no use for. */ const $fc50d37955791958$var$COUNT_HEIGHT_BARE = 28;
const $fc50d37955791958$var$PASS_COLOR = "#3ddc6b";
const $fc50d37955791958$var$FAIL_COLOR = "#e8384f";
const $fc50d37955791958$var$DIM_COLOR = "#8d9bd4";
class $fc50d37955791958$export$aaa04cbb2b170a34 {
    constructor(canvas){
        this.ctx = canvas.getContext("2d");
    }
    /**
   * @param view The declared camera view, shown so a mis-set view is obvious.
   * @param results Output of `evaluate()`.
   * @param note Optional status line, e.g. why values are missing.
   * @param counter Optional headline figure under the rows:
   *   `{ value, label, progress }`. `value` and `label` are already strings
   *   because what a drill counts is the drill's business — a hold's headline is
   *   a clock in seconds and labelling it REPS is simply wrong, which is what
   *   the handstand shipped. `progress` null draws no bar: a hold's bar fills in
   *   two seconds and then sits full for the rest of a forty-second hold.
   * @param posture Optional rows from `PostureTally.summary()`.
   */ draw(view, results, note, counter = null, posture = null) {
        const ctx = this.ctx;
        ctx.save();
        // Drop the renderer's mirror for the duration of the panel.
        ctx.setTransform(1, 0, 0, 1, 0, 0);
        const postureRows = posture || [];
        const rows = results.length + 1 + postureRows.length;
        const height = $fc50d37955791958$var$PADDING * 2 + rows * $fc50d37955791958$var$LINE_HEIGHT + (note ? $fc50d37955791958$var$LINE_HEIGHT : 0) + (counter ? counter.progress == null ? $fc50d37955791958$var$COUNT_HEIGHT_BARE : $fc50d37955791958$var$COUNT_HEIGHT : 0);
        // Flat fill and a hard edge, matching the bars: no blur anywhere in this UI.
        ctx.fillStyle = "rgba(5, 7, 15, 0.82)";
        ctx.fillRect(0, 0, $fc50d37955791958$var$PANEL_WIDTH, height);
        ctx.fillStyle = "#05070f";
        ctx.fillRect(0, height - 4, $fc50d37955791958$var$PANEL_WIDTH, 4);
        ctx.fillRect($fc50d37955791958$var$PANEL_WIDTH - 4, 0, 4, height);
        ctx.textBaseline = "top";
        ctx.font = `10px ${$fc50d37955791958$var$FACE}`;
        ctx.fillStyle = "#ffd23f";
        ctx.fillText(`${view} view`.toUpperCase(), $fc50d37955791958$var$PADDING, $fc50d37955791958$var$PADDING);
        ctx.font = `8px ${$fc50d37955791958$var$FACE}`;
        results.forEach((metric, i)=>{
            const y = $fc50d37955791958$var$PADDING + (i + 1) * $fc50d37955791958$var$LINE_HEIGHT;
            ctx.fillStyle = $fc50d37955791958$var$DIM_COLOR;
            ctx.fillText(metric.label.toUpperCase(), $fc50d37955791958$var$PADDING, y);
            const shown = metric.value == null ? "--" : `${metric.value.toFixed(metric.precision)}${metric.unit}`;
            ctx.fillStyle = metric.value == null ? "#5c6694" : "#e8f0ff";
            ctx.textAlign = "right";
            ctx.fillText(shown, $fc50d37955791958$var$PANEL_WIDTH - $fc50d37955791958$var$PADDING, y);
            ctx.textAlign = "left";
        });
        postureRows.forEach((row, i)=>{
            const y = $fc50d37955791958$var$PADDING + (results.length + 1 + i) * $fc50d37955791958$var$LINE_HEIGHT;
            ctx.fillStyle = $fc50d37955791958$var$DIM_COLOR;
            ctx.fillText(row.label.toUpperCase(), $fc50d37955791958$var$PADDING, y);
            // The tally, not just this rep: ten red marks on a ten-rep set is noise,
            // whereas "8/10" is something a coach can act on. An informational row has
            // no tally to show and must not be coloured as a pass or a fault — it gets
            // its own note in the neutral amber the other read-this-number uses.
            const shown = row.value == null ? "--" : row.informational ? `${row.value.toFixed(row.precision)}${row.unit}  ${row.note}` : `${row.value.toFixed(row.precision)}${row.unit}  ${row.passed}/${row.total}`;
            ctx.fillStyle = row.informational ? "#ffd23f" : row.pass == null ? "#5c6694" : row.pass ? $fc50d37955791958$var$PASS_COLOR : $fc50d37955791958$var$FAIL_COLOR;
            ctx.textAlign = "right";
            ctx.fillText(shown, $fc50d37955791958$var$PANEL_WIDTH - $fc50d37955791958$var$PADDING, y);
            ctx.textAlign = "left";
        });
        if (note) {
            ctx.fillStyle = "#5c6694";
            ctx.font = `8px ${$fc50d37955791958$var$FACE}`;
            ctx.fillText(note.toUpperCase(), $fc50d37955791958$var$PADDING, $fc50d37955791958$var$PADDING + rows * $fc50d37955791958$var$LINE_HEIGHT);
        }
        if (counter) {
            const y = $fc50d37955791958$var$PADDING + rows * $fc50d37955791958$var$LINE_HEIGHT + (note ? $fc50d37955791958$var$LINE_HEIGHT : 0);
            ctx.font = `24px ${$fc50d37955791958$var$FACE}`;
            // Amber, like the count in the bar: the same figure in the same colour in
            // both places, so there is nothing to reconcile.
            ctx.fillStyle = "#ffd23f";
            ctx.fillText(counter.value, $fc50d37955791958$var$PADDING, y);
            ctx.font = `8px ${$fc50d37955791958$var$FACE}`;
            ctx.fillStyle = "#5c6694";
            ctx.fillText(counter.label, $fc50d37955791958$var$PADDING + 20 + counter.value.length * 24, y + 16);
            if (counter.progress != null) {
                // A bar rather than a number: mid-rep progress is for reassuring the
                // athlete the counter is alive, not for reading a value off.
                // Drawn as cells rather than a sliver, matching the loading bar: a block
                // appearing reads as progress at a glance, a sliver growing does not.
                const barY = y + 34;
                const barWidth = $fc50d37955791958$var$PANEL_WIDTH - $fc50d37955791958$var$PADDING * 2;
                const cells = 20;
                const cell = Math.floor(barWidth / cells);
                const filled = Math.round(Math.min(counter.progress, 1) * cells);
                for(let i = 0; i < cells; i += 1){
                    ctx.fillStyle = i < filled ? "#ffd23f" : "rgba(141, 155, 212, 0.22)";
                    ctx.fillRect($fc50d37955791958$var$PADDING + i * cell, barY, cell - 2, 6);
                }
            }
        }
        ctx.restore();
    }
}


/**
 * Captures a drill session as a landmark time series for offline work.
 *
 * This exists so that rep detection can be tuned against real movement instead
 * of guessed thresholds. It deliberately records landmarks rather than video:
 * the file is a few hundred kilobytes instead of hundreds of megabytes, it is
 * directly what the detector consumes, and it contains no imagery of the
 * athlete — which matters when the athletes are junior divers.
 *
 * Landmarks are stored RAW, before smoothing. Smoothing can be reapplied
 * offline with any parameters; it cannot be undone. The filter settings that
 * were active are recorded alongside so a session can be reproduced exactly.
 *
 * A second person can tap a key once per rep while the athlete works. Those
 * marks are the ground truth the detector gets scored against — without them a
 * recording says how the athlete moved but not where a human saw one rep end
 * and the next begin.
 */ /**
 * The schema's name and version. The schema itself has never changed: takes
 * written before the app was renamed from RoboCoach carry
 * `robocoach-session/1` and are the same shape, so anything reading a fixture
 * must accept either name rather than treating the old one as unknown. The
 * version stays at 1 because nothing about the data moved.
 */ const $0f75d94e0701fa23$var$FORMAT = "spottr-session/1";
/** Rounds to millimetre precision; the extra digits are model noise, not signal. */ function $0f75d94e0701fa23$var$round(value) {
    return Math.round(value * 10000) / 10000;
}
class $0f75d94e0701fa23$export$fff78e3cee5381c8 {
    /**
   * @param maxSeconds Auto-stops after this long, so a forgotten recording
   *   cannot grow without bound.
   */ constructor({ maxSeconds: maxSeconds = 120 } = {}){
        this.maxSeconds = maxSeconds;
        this.reset();
    }
    reset() {
        this.recording = false;
        this.frames = [];
        this.marks = [];
        this.startedAt = null;
        this.meta = null;
    }
    start(meta) {
        this.reset();
        this.recording = true;
        this.startedAt = new Date().toISOString();
        this.meta = meta;
    }
    /** @return true if this frame was stored. */ capture(world, t) {
        if (!this.recording) return false;
        if (this.frames.length > 0 && t - this.frames[0].t > this.maxSeconds * 1000) {
            this.stop();
            return false;
        }
        this.frames.push({
            t: $0f75d94e0701fa23$var$round(t),
            world: world.map((p)=>[
                    $0f75d94e0701fa23$var$round(p.x),
                    $0f75d94e0701fa23$var$round(p.y),
                    $0f75d94e0701fa23$var$round(p.z),
                    $0f75d94e0701fa23$var$round(p.visibility != null ? p.visibility : 1)
                ])
        });
        return true;
    }
    /** Records a human-observed rep boundary at the latest frame time. */ mark() {
        if (!this.recording || this.frames.length === 0) return;
        this.marks.push(this.frames[this.frames.length - 1].t);
    }
    stop() {
        this.recording = false;
    }
    get durationSeconds() {
        if (this.frames.length < 2) return 0;
        return (this.frames[this.frames.length - 1].t - this.frames[0].t) / 1000;
    }
    /** Mean frames per second actually achieved, which caps velocity accuracy. */ get fps() {
        const seconds = this.durationSeconds;
        return seconds > 0 ? this.frames.length / seconds : 0;
    }
    toJSON(landmarkNames) {
        return {
            format: $0f75d94e0701fa23$var$FORMAT,
            recordedAt: this.startedAt,
            durationSeconds: +this.durationSeconds.toFixed(2),
            frameCount: this.frames.length,
            meanFps: +this.fps.toFixed(1),
            // Landmarks here are raw; this records what the live view was smoothing with.
            smoothingAtCapture: this.meta?.smoothing,
            // Which drill was filmed. A take is only meaningful against the drill it
            // was performed as, and nothing in the landmarks says which that was: a
            // squat and a V-sit both fold, and either one scored against the other's
            // thresholds produces a plausible number for a movement nobody did.
            exercise: this.meta?.exercise,
            view: this.meta?.view,
            model: this.meta?.model,
            camera: this.meta?.camera,
            landmarkNames: landmarkNames,
            markCount: this.marks.length,
            marks: this.marks,
            frames: this.frames
        };
    }
    /** Approximate size of the export in bytes, for a size hint in the UI. */ estimateBytes() {
        // Each landmark serialises to roughly 34 characters across four rounded
        // numbers plus punctuation; enough to warn before a file gets unwieldy.
        return this.frames.length * 1122;
    }
}
function $0f75d94e0701fa23$export$f9d4d06a96a4d34f(recorder, landmarkNames) {
    const payload = JSON.stringify(recorder.toJSON(landmarkNames));
    const blob = new Blob([
        payload
    ], {
        type: "application/json"
    });
    const url = URL.createObjectURL(blob);
    const stamp = (recorder.startedAt || new Date().toISOString()).replace(/[:.]/g, "-").slice(0, 19);
    // The drill goes in the name because the file arrives alone in a downloads
    // folder, where the directory it will be committed to cannot tell it apart.
    const parts = [
        recorder.meta?.exercise,
        recorder.meta?.view
    ].filter(Boolean);
    const name = `spottr-${parts.join("-") || "session"}-${stamp}.json`;
    const link = document.createElement("a");
    link.href = url;
    link.download = name;
    document.body.appendChild(link);
    link.click();
    link.remove();
    // Not in this tick. A blob download starts asynchronously, so revoking the
    // URL on the line after the click can pull the file out from under the
    // browser before it has read it — Safari in particular hands the take to a
    // share sheet rather than a downloads folder, and that happens well after
    // the click returns. The object is a few megabytes and the page is about to
    // keep running either way, so a minute of it costing nothing beats a take
    // the athlete performed and did not get.
    setTimeout(()=>URL.revokeObjectURL(url), 60000);
    return {
        name: name,
        bytes: payload.length
    };
}


/**
 * Short tones, so the athlete does not have to look at the screen.
 *
 * This matters more than it sounds. The drill is filmed side-on, which means the
 * athlete is standing at ninety degrees to the phone: reading a verdict off the
 * screen costs them a turn of the head on every rep, which is a change to the
 * movement being measured. A sound they can tell apart without looking is the
 * only feedback that does not interfere with the thing it is reporting on.
 *
 * Everything here is guarded and silent on failure. Audio is blocked outright on
 * some devices and in some settings, and a missing tone must never take the drill
 * down with it — the on-screen verdict is always there as well.
 */ /** One shared context. iOS will refuse to start more than a few. */ let $ae07fe683ada68ce$var$context = null;
function $ae07fe683ada68ce$var$acquire() {
    const Ctor = window.AudioContext || window.webkitAudioContext;
    if (!Ctor) return null;
    $ae07fe683ada68ce$var$context = $ae07fe683ada68ce$var$context || new Ctor();
    if ($ae07fe683ada68ce$var$context.state === "suspended") $ae07fe683ada68ce$var$context.resume();
    return $ae07fe683ada68ce$var$context;
}
function $ae07fe683ada68ce$export$3f66b274a2143589() {
    try {
        $ae07fe683ada68ce$var$acquire();
    } catch  {
    // Silence is acceptable; a thrown error during setup is not.
    }
}
/**
 * The lowest pitch a phone speaker actually reproduces.
 *
 * Measured the hard way: the first version of the fault tone fell to 190Hz, and
 * on a phone propped up across the room it was inaudible. A phone speaker is a
 * few millimetres across and rolls off steeply below roughly 500Hz, so a low
 * tone is not a quiet warning — it is no warning at all. Nothing here goes below
 * this, which costs the fault sound the obvious "low means bad" and is why it
 * carries its difference in timbre and length instead.
 */ const $ae07fe683ada68ce$var$SPEAKER_FLOOR = 440;
function $ae07fe683ada68ce$export$7297c25227171a1f(frequency, seconds, after = 0, type = "square") {
    try {
        const ctx = $ae07fe683ada68ce$var$acquire();
        if (ctx == null) return;
        const start = ctx.currentTime + after;
        const oscillator = ctx.createOscillator();
        const gain = ctx.createGain();
        oscillator.type = type;
        oscillator.frequency.value = Math.max(frequency, $ae07fe683ada68ce$var$SPEAKER_FLOOR);
        // A square wave carries far more energy than a sine at the same amplitude,
        // so it is turned down to sit at a comparable loudness rather than a harsh one.
        gain.gain.setValueAtTime(type === "square" ? 0.08 : 0.12, start);
        // Fade out, because an abruptly stopped oscillator clicks.
        gain.gain.exponentialRampToValueAtTime(0.0001, start + seconds);
        oscillator.connect(gain).connect(ctx.destination);
        oscillator.start(start);
        oscillator.stop(start + seconds);
    } catch  {
    // No audio available; the on-screen readout still carries it.
    }
}
function $ae07fe683ada68ce$export$8fe7916d8fd7015f() {
    $ae07fe683ada68ce$export$7297c25227171a1f(880, 0.09, 0, "triangle");
    $ae07fe683ada68ce$export$7297c25227171a1f(1320, 0.12, 0.1, "triangle");
}
function $ae07fe683ada68ce$export$4d50da2a305230d9() {
    $ae07fe683ada68ce$export$7297c25227171a1f(740, 0.13, 0, "square");
    $ae07fe683ada68ce$export$7297c25227171a1f(590, 0.13, 0.14, "square");
    $ae07fe683ada68ce$export$7297c25227171a1f(440, 0.22, 0.28, "square");
}
function $ae07fe683ada68ce$export$a1e358de886dcafc() {
    $ae07fe683ada68ce$export$8fe7916d8fd7015f();
    // After the good figure has finished, with a clear gap: they are being
    // compared, not blended.
    setTimeout($ae07fe683ada68ce$export$4d50da2a305230d9, 700);
}


class $a348886ba5f90808$export$c49181b1c9eea0fa {
    /**
   * @param recorder The SessionRecorder to drive.
   * @param handlers.onStart Must return the capture metadata for the session.
   * @param handlers.onStop Called after recording stops, to save the session.
   * @param handlers.countdownSeconds Delay before recording begins. 0 starts
   *   immediately.
   */ constructor(recorder, { onStart: onStart, onStop: onStop, countdownSeconds: countdownSeconds = 0 }){
        this.recorder = recorder;
        this.onStart = onStart;
        this.onStop = onStop;
        this.countdownSeconds = countdownSeconds;
        this.remaining = 0;
        this.ticker = null;
        this.countdown = document.getElementById("countdown");
        this.countdownNumber = document.getElementById("countdown-number");
        this.indicator = document.getElementById("rec-indicator");
        this.indicatorTime = document.getElementById("rec-time");
        this.toggleButton = document.getElementById("record-toggle");
        this.markButton = document.getElementById("mark-rep");
        this.status = document.getElementById("control-status");
        this.toggleButton.addEventListener("click", ()=>this.toggle());
        this.markButton.addEventListener("click", ()=>this.mark());
        window.addEventListener("keydown", (event)=>{
            if (event.repeat || $a348886ba5f90808$var$isTypingTarget(event.target)) return;
            if (event.key.toLowerCase() === "r") this.toggle();
            else if (event.code === "Space") {
                // Space would otherwise re-trigger whichever button has focus.
                event.preventDefault();
                this.mark();
            }
        });
        this.render();
    }
    get countingDown() {
        return this.ticker != null;
    }
    toggle() {
        if (this.recorder.recording) {
            this.recorder.stop();
            this.onStop();
        } else if (this.countingDown) this.cancelCountdown();
        else if (this.countdownSeconds > 0) this.startCountdown();
        else this.begin();
        this.render();
    }
    /**
   * Starts a recording if one is not already starting or running.
   *
   * Separate from `toggle()` because the two mean opposite things when a
   * countdown is in flight: toggling then is the Cancel the button offers,
   * while arming again is the caller repeating itself. `?record=1` arms from
   * the render loop, which runs sixty times a second, so a caller that could
   * only toggle took the countdown down and put it back up on alternating
   * frames.
   */ arm() {
        if (this.recorder.recording || this.countingDown) return;
        this.toggle();
    }
    /**
   * Counts down before recording, so the phone can be propped up and the
   * athlete can walk into frame. Each tick beeps: facing away from the screen,
   * sound is the only channel left.
   */ startCountdown() {
        this.remaining = this.countdownSeconds;
        (0, $ae07fe683ada68ce$export$7297c25227171a1f)(660, 0.08);
        this.ticker = setInterval(()=>{
            this.remaining -= 1;
            if (this.remaining > 0) {
                (0, $ae07fe683ada68ce$export$7297c25227171a1f)(660, 0.08);
                this.render();
                return;
            }
            this.clearTicker();
            this.begin();
            this.render();
        }, 1000);
    }
    cancelCountdown() {
        this.clearTicker();
        this.remaining = 0;
    }
    clearTicker() {
        if (this.ticker != null) {
            clearInterval(this.ticker);
            this.ticker = null;
        }
    }
    begin() {
        // Wall clock, deliberately not the recorder's frame span. Frames only
        // accumulate while a pose is detected, so a frame-derived timer sits at
        // 0:00 while the athlete walks into shot — which reads as "not recording"
        // at the exact moment the indicator most needs to be believable.
        this.startedAt = performance.now();
        this.recorder.start(this.onStart());
        // Distinct from the tick: a longer, higher tone means "now".
        (0, $ae07fe683ada68ce$export$7297c25227171a1f)(1040, 0.35);
    }
    mark() {
        if (!this.recorder.recording) return;
        this.recorder.mark();
        this.render();
    }
    /** Called every frame while recording so the counters stay live. */ render() {
        const recording = this.recorder.recording;
        const counting = this.countingDown;
        this.toggleButton.textContent = recording ? "Stop & save" : counting ? "Cancel" : "Start recording";
        this.toggleButton.setAttribute("aria-pressed", String(recording));
        this.markButton.disabled = !recording;
        this.countdown.hidden = !counting;
        if (counting) this.countdownNumber.textContent = String(this.remaining);
        this.indicator.hidden = !recording;
        document.body.classList.toggle("is-recording", recording);
        if (recording) {
            const total = Math.floor((performance.now() - this.startedAt) / 1000);
            const mins = Math.floor(total / 60);
            const secs = String(total % 60).padStart(2, "0");
            // Saying so is the honest version of a frozen counter: the clock proves
            // recording is live, and this says nothing is being captured into it yet.
            const waiting = this.recorder.frames.length === 0 ? " \xb7 no pose" : "";
            this.indicatorTime.textContent = `${mins}:${secs}${waiting}`;
        }
        if (recording) {
            const mb = (this.recorder.estimateBytes() / 1048576).toFixed(1);
            this.status.textContent = `\u{25CF} ${this.recorder.durationSeconds.toFixed(0)}s \xb7 ` + `${this.recorder.frames.length} frames \xb7 ` + `${this.recorder.marks.length} marks \xb7 ~${mb}MB`;
        } else if (counting) this.status.textContent = `Starting in ${this.remaining}\u2026 tap Cancel to stop`;
        else if (this.lastSaved) this.status.textContent = this.lastSaved;
        else this.status.textContent = "Ready \u2014 press Start, then Mark once per rep";
    }
    /** Shows what the finished session contained, so a bad take is obvious. */ reportSaved(filename, bytes, frameCount, markCount, fps) {
        this.lastSaved = `Saved ${filename} \xb7 ${frameCount} frames @ ${fps.toFixed(0)}fps \xb7 ` + `${markCount} marks \xb7 ${(bytes / 1048576).toFixed(1)}MB`;
        this.render();
    }
}
function $a348886ba5f90808$var$isTypingTarget(target) {
    if (target == null) return false;
    const tag = target.tagName;
    return tag === "INPUT" || tag === "TEXTAREA" || target.isContentEditable;
}


/**
 * The coaching flow: start a set, then a verdict on every rep as it happens.
 *
 * This is the app's main interface, and it is a different job from the capture
 * controls in `controls.js`. Capturing a fixture is an occasional errand for
 * whoever is tuning the detector; being told whether the rep you just did was
 * good is the thing the athlete opened the app for. So the recorder's buttons —
 * including "Mark rep", which only ever existed to label ground truth for
 * tuning — move behind `?capture=1`, and this takes the bottom bar.
 *
 * Why a verdict per rep and not only the running tally: a tally answers "how did
 * that set go", which is a question for afterwards. Mid-set the athlete needs to
 * know what to change on the next rep, and that is one short cue delivered
 * immediately. Both are shown; they answer different questions.
 *
 * DOM rather than canvas, for the reasons `controls.js` gives: the canvas context
 * is mirrored so text painted into it comes out backwards, and real buttons get
 * touch targets and screen-reader semantics for free.
 */ 
/**
 * How long a verdict stays up when no further rep replaces it.
 *
 * A verdict belongs on screen until the next one replaces it. This was 2500ms,
 * then briefly 1200ms with the banner also coming down partway into the next
 * rep, on the reasoning that a banner outliving its rep reads as a verdict on
 * the one being performed. The athlete tried it and the opposite was true: the
 * cues went by faster than he could read them from where he was standing, which
 * is the whole problem the banner exists to solve. A cue he cannot read is worth
 * nothing, and the sound is what tells him which rep it was about anyway.
 *
 * So the next rep is what takes it down, and this is only the fallback for the
 * last rep of a set — long enough to read, short enough that it is gone before
 * he comes back to the phone.
 */ const $4982aed1ac51f6d6$var$VERDICT_MS = 8000;
/** Steps in a bonus counter, and what one step is worth by default. */ const $4982aed1ac51f6d6$var$BONUS_STEPS = 10;
/** At most this many cues at once; more is not coaching, it is a list. */ const $4982aed1ac51f6d6$var$MAX_CUES = 2;
function $4982aed1ac51f6d6$export$81e4fbd518fcb891(scored, cues) {
    const labels = cues || {};
    const judged = scored.filter((row)=>!row.informational);
    const failed = judged.filter((row)=>row.pass === false);
    const unjudged = judged.filter((row)=>row.pass === null);
    if (failed.length > 0) return {
        good: false,
        text: failed.slice(0, $4982aed1ac51f6d6$var$MAX_CUES).map((row)=>labels[row.id] || row.label).join(" \xb7 "),
        partial: false
    };
    return {
        good: true,
        text: "Good",
        // Said plainly rather than passed off as a clean rep: if the feet were out
        // of frame, the athlete should know the verdict only covers part of it.
        partial: unjudged.length > 0
    };
}
class $4982aed1ac51f6d6$export$55b83b3b18aa54c4 {
    /**
   * @param handlers.onStart Called when the set begins, to reset the counters.
   * @param handlers.onStop Called when the set ends.
   * @param handlers.onMenu Back to the drill list. Mid-set there is no way
   *   back by design — Stop first — but before one has started, a drill picked
   *   by mistake must not need a reload to undo.
   * @param handlers.canStart Whether the bar may act at all. The menu and the
   *   receipt both sit over this bar and both own the keyboard while they are
   *   up: a `keydown` listener on `window` still fires for them, and Space
   *   choosing a drill must not also start a set behind it.
   * @param handlers.countdownSeconds Delay before the set begins, so the phone
   *   can be propped up and the athlete can walk into frame.
   */ constructor({ onStart: onStart, onStop: onStop, countdownSeconds: countdownSeconds = 0, sound: sound = true, soundcheck: soundcheck = false, canStart: canStart = ()=>true, onMenu: onMenu = null }){
        this.onStart = onStart;
        this.onStop = onStop;
        this.canStart = canStart;
        /** Set by `setExercise`; until then there is no drill to start. */ this.exercise = null;
        this.countdownSeconds = countdownSeconds;
        this.sound = sound;
        this.soundcheck = soundcheck;
        this.remaining = 0;
        this.ticker = null;
        /** Whether this drill is a hold rather than a set of reps. */ this.timed = false;
        /** The settled state of the hold under way, for a timed drill. */ this.holdState = null;
        /** Holds completed in this set, for the banner mid-hold. */ this.holdNumber = 0;
        /** When the countdown is due to end, on the wall clock. See startCountdown. */ this.deadline = null;
        this.verdictTimer = null;
        this.running = false;
        this.countdown = document.getElementById("countdown");
        this.countdownNumber = document.getElementById("countdown-number");
        this.countdownHint = document.getElementById("countdown-hint");
        this.verdict = document.getElementById("verdict");
        this.verdictRep = document.getElementById("verdict-rep");
        this.verdictText = document.getElementById("verdict-text");
        this.count = document.getElementById("coach-count");
        this.bonusNode = document.getElementById("coach-bonus");
        /**
     * Running totals for the drill's `aggregate: "sum"` rows, by id. Nothing
     * here is specific to the jump: an exercise that reports a figure worth
     * adding up gets a counter, and one that reports none has no counter. The
     * receipt totals the same rows at the end of the workout (see score.js).
     */ this.bonus = [];
        this.button = document.getElementById("coach-toggle");
        this.menuButton = document.getElementById("coach-menu");
        this.status = document.getElementById("coach-status");
        this.button.addEventListener("click", ()=>this.toggle());
        // The countdown covers the whole screen, the bar included, so the Cancel
        // the button is offering at that moment cannot be reached: it is behind an
        // overlay at a higher layer. Tapping the countdown itself is the way out,
        // and it is the whole screen rather than a target to find — which is the
        // right size for something tapped on the way back into frame.
        this.countdown.addEventListener("click", ()=>{
            if (this.countingDown) this.cancelCountdown();
        });
        if (this.menuButton) this.menuButton.addEventListener("click", ()=>{
            if (onMenu && !this.running && !this.countingDown) onMenu();
        });
        window.addEventListener("keydown", (event)=>{
            if (event.repeat || $4982aed1ac51f6d6$var$isTypingTarget(event.target)) return;
            // Enter and Space both, because whichever of them a given browser fires
            // on a focused button, the other should still work from anywhere.
            if (event.code === "Space" || event.key === "Enter") {
                event.preventDefault();
                this.toggle();
            }
        });
        this.render();
    }
    get countingDown() {
        return this.ticker != null;
    }
    /**
   * Points the bar at a drill. Called when one is chosen from the menu, and
   * again on returning to it, so the cues and the status line follow whichever
   * exercise is actually being scored.
   */ setExercise(exercise) {
        this.exercise = exercise;
        // A hold is not a set of reps: the headline number is the clock rather than
        // a tally, and the verdict is a change of state rather than something that
        // happened once. See exercises/hold.js.
        this.timed = exercise != null && exercise.timed === true;
        this.holdState = null;
        this.holdNumber = 0;
        this.setCount(this.timed ? "0.0s" : 0);
        this.resetBonus();
        this.clearVerdict();
        this.render();
    }
    /**
   * The state of a hold, every frame, for a drill that has one.
   *
   * The athlete is upside down and cannot read anything, so the sound is the
   * whole feature and the banner is for afterwards. The tones are the rep tones
   * on purpose: there are two of them, they already mean good and not good in
   * this app, and a third pair would be one more thing to learn mid-handstand
   * for no gain. The counter settles the state before it reaches here
   * (`settleMs`), so a reading flickering at the threshold is not a sound.
   *
   * @param state "good", "bad", or null when no hold is under way.
   * @param seconds Seconds in line so far, for the headline figure.
   */ showHoldState(state, seconds) {
        if (this.timed) this.setCount(`${seconds.toFixed(1)}s`);
        if (state === this.holdState) return;
        const previous = this.holdState;
        this.holdState = state;
        // The hold is over. Nothing is announced — its verdict arrives on its own as
        // a completed hold — but the banner has to come down, and for one build it
        // did not: it says what is true right now and has no timer, so coming out of
        // a handstand left a green IN LINE sitting over a body folded in half on the
        // floor. A hold that was too short to count banks no verdict to replace it
        // either, so clearing it here is the only thing that does. An accepted hold
        // overwrites this in the same frame, so there is nothing to see in between.
        if (state == null) {
            this.clearVerdict();
            return;
        }
        // And nothing is announced as one opens: the athlete is mid kick-up and is
        // not being told off for it, so the first change out of that is the first
        // thing heard.
        if (previous == null) return;
        const cues = this.exercise && this.exercise.stateCues || {};
        const good = state === "good";
        this.verdictRep.textContent = `Hold ${this.holdNumber + 1}`;
        this.verdictText.textContent = cues[state] || (good ? "Good" : "Fix it");
        this.verdict.className = good ? "good" : "bad";
        this.verdict.hidden = false;
        // No timer: unlike a rep's verdict this says what is true right now, so it
        // comes down when it stops being true rather than after a while.
        clearTimeout(this.verdictTimer);
        if (this.sound) {
            if (good) (0, $ae07fe683ada68ce$export$8fe7916d8fd7015f)();
            else (0, $ae07fe683ada68ce$export$4d50da2a305230d9)();
        }
    }
    toggle() {
        if (!this.canStart() || this.exercise == null) return;
        // Inside the gesture, which is the only moment the browser will let audio
        // start. Without this the rep tones — which fire on their own, long after any
        // tap — are silently dropped on iOS, where a context created outside a
        // gesture stays suspended for good.
        if (this.sound) (0, $ae07fe683ada68ce$export$3f66b274a2143589)();
        if (this.soundcheck) {
            // ?soundcheck=1 turns Start into a speaker test and nothing else: hearing
            // the fault sound otherwise means performing a bad rep on purpose, which
            // is how the first version shipped inaudible on a phone.
            (0, $ae07fe683ada68ce$export$a1e358de886dcafc)();
            return;
        }
        if (this.running) this.stop();
        else if (this.countingDown) this.cancelCountdown();
        else if (this.countdownSeconds > 0) this.startCountdown();
        else this.begin();
    }
    /**
   * Counts in from a deadline rather than by counting ticks.
   *
   * The ticks are not reliable on the one device this is used on. The athlete
   * presses Start and walks away, and a phone that locks or a tab iOS throttles
   * in the background stops firing timers — so a countdown that reaches zero by
   * subtracting one per tick does not reach zero at all, and the overlay sits
   * there over a bar it covers, with the set never starting and a reload the
   * only way out. Read off the clock, a tick that arrives late or never simply
   * finds the time already gone and starts the set.
   */ startCountdown() {
        this.deadline = Date.now() + this.countdownSeconds * 1000;
        this.remaining = this.countdownSeconds;
        this.countdownHint.textContent = "Get into position\u2026 tap to cancel";
        // Faster than the second it displays, so the first tick after the screen
        // comes back is at most a fifth of a second late rather than a whole one.
        this.ticker = setInterval(()=>this.tickCountdown(), 200);
        this.render();
    }
    tickCountdown() {
        const left = Math.max(0, Math.ceil((this.deadline - Date.now()) / 1000));
        if (left === this.remaining) return;
        this.remaining = left;
        if (left <= 0) {
            this.cancelCountdown();
            this.begin();
            return;
        }
        if (this.sound) // Audible, so the athlete can already be facing away while it runs.
        (0, $ae07fe683ada68ce$export$7297c25227171a1f)(660, 0.08);
        this.render();
    }
    cancelCountdown() {
        clearInterval(this.ticker);
        this.ticker = null;
        this.deadline = null;
        this.remaining = 0;
        this.render();
    }
    begin() {
        this.running = true;
        this.holdState = null;
        this.holdNumber = 0;
        this.setCount(this.timed ? "0.0s" : 0);
        this.clearVerdict();
        // A set starts the score at zero. Carrying it over would make the counter a
        // running total of the session, which the receipt already is.
        this.resetBonus();
        if (this.sound) // Longer and higher than the ticks: this one means "now".
        (0, $ae07fe683ada68ce$export$7297c25227171a1f)(1040, 0.35);
        this.onStart();
        this.render();
    }
    stop() {
        this.running = false;
        // The set is over and the receipt is about to cover the screen; a verdict
        // from the last rep hanging over it belongs to a set that has ended.
        this.clearVerdict();
        this.onStop();
        this.render();
    }
    /**
   * Shows the verdict for one rep.
   *
   * @param number Which rep this was.
   * @param scored Rows from `scoreRep()`.
   */ showRep(number, scored) {
        const verdict = $4982aed1ac51f6d6$export$81e4fbd518fcb891(scored, this.exercise && this.exercise.cues);
        const noun = this.timed ? "Hold" : "Rep";
        this.verdictRep.textContent = verdict.partial ? `${noun} ${number} \u{2014} partly seen` : `${noun} ${number}`;
        this.verdictText.textContent = verdict.text;
        this.verdict.className = verdict.good ? "good" : "bad";
        this.verdict.hidden = false;
        // The sound is the part that actually reaches the athlete. Filmed side-on
        // they stand at ninety degrees to the phone, so reading the screen costs a
        // turn of the head on every rep — a change to the movement being measured.
        // A hold has been sounding its changes of state as they happened, and the
        // one that ended it was the last of them. A second tone here would be the
        // same news twice.
        if (this.sound && !this.timed) {
            if (verdict.good) (0, $ae07fe683ada68ce$export$8fe7916d8fd7015f)();
            else (0, $ae07fe683ada68ce$export$4d50da2a305230d9)();
        }
        this.addBonus(scored);
        clearTimeout(this.verdictTimer);
        this.verdictTimer = setTimeout(()=>this.clearVerdict(), $4982aed1ac51f6d6$var$VERDICT_MS);
        // The clock keeps the headline on a timed drill. The tally of holds is on
        // the banner and on the ticket, which is where a count belongs when the
        // number worth watching is the seconds.
        this.holdNumber = number;
        if (!this.timed) this.setCount(number);
    }
    clearVerdict() {
        this.verdict.hidden = true;
    }
    setCount(value) {
        this.count.textContent = String(value);
    }
    resetBonus() {
        this.bonus = [];
        this.renderBonus();
    }
    /**
   * Adds this rep's aggregate figures to the counter.
   *
   * A rep the drill could not measure contributes nothing rather than resetting
   * the counter or showing a gap: the score only ever grows, which is the whole
   * appeal of one.
   */ addBonus(scored) {
        for (const row of scored){
            if (row.aggregate !== "sum" || !Number.isFinite(row.value)) continue;
            let entry = this.bonus.find((b)=>b.id === row.id);
            if (entry == null) {
                entry = {
                    id: row.id,
                    label: row.label,
                    unit: row.unit,
                    precision: row.precision,
                    // What one step of the counter costs, in the row's own unit. The
                    // drill knows; the bar only knows there are ten of them.
                    step: row.bonusStep,
                    total: 0
                };
                this.bonus.push(entry);
            }
            entry.total += row.value;
        }
        this.renderBonus();
    }
    renderBonus() {
        if (this.bonusNode == null) return;
        if (this.bonus.length === 0) {
            this.bonusNode.hidden = true;
            this.bonusNode.textContent = "";
            this.bonusNode.className = "";
            return;
        }
        // One counter, drawn as steps rather than as the raw figure: a number of
        // seconds climbing by fractions is something to read, and ten cells filling
        // one at a time is something to notice while moving. The drill says what one
        // step costs; the scale and the ten steps are the bar's own.
        const entry = this.bonus[0];
        const step = entry.step > 0 ? entry.step : 1;
        // Whole steps earned, and never less than one once anything has been
        // banked: a counter that appears reading zero is not a reward.
        const level = Math.min($4982aed1ac51f6d6$var$BONUS_STEPS, entry.total <= 0 ? 0 : Math.max(1, Math.floor(entry.total / step)));
        const maxed = level >= $4982aed1ac51f6d6$var$BONUS_STEPS;
        this.bonusNode.textContent = "";
        const label = document.createElement("span");
        label.className = "bonus-label";
        label.textContent = entry.label.toUpperCase();
        this.bonusNode.appendChild(label);
        const track = document.createElement("span");
        track.className = "bonus-track";
        for(let i = 0; i < $4982aed1ac51f6d6$var$BONUS_STEPS; i += 1){
            const cell = document.createElement("span");
            if (i < level) cell.className = "on";
            track.appendChild(cell);
        }
        this.bonusNode.appendChild(track);
        const number = document.createElement("span");
        number.className = "bonus-level";
        number.textContent = maxed ? "MAX" : String(level);
        this.bonusNode.appendChild(number);
        this.bonusNode.hidden = false;
        this.bonusNode.setAttribute("aria-label", `${entry.label} bonus ${level} of ${$4982aed1ac51f6d6$var$BONUS_STEPS}`);
        // Restarted rather than added: the classes are still on from the last rep.
        this.bonusNode.className = "";
        this.bonusNode.offsetWidth;
        this.bonusNode.className = maxed ? "tick max" : "tick";
    }
    render() {
        this.button.textContent = this.running ? "Stop" : this.countingDown ? "Cancel" : "Start";
        this.button.setAttribute("aria-pressed", String(this.running));
        if (this.menuButton) // Not while a set is running or counting in: leaving then would throw away
        // reps the athlete is in the middle of earning.
        this.menuButton.hidden = this.running || this.countingDown;
        this.countdown.hidden = !this.countingDown;
        if (this.countingDown) this.countdownNumber.textContent = String(this.remaining);
        if (this.soundcheck) {
            this.status.textContent = "Sound check: good, then fault";
            this.button.textContent = "Play both sounds";
            return;
        }
        const name = this.exercise ? this.exercise.name : "";
        if (this.running) this.status.textContent = `Counting ${name.toLowerCase()}\u{2026}`;
        else if (this.countingDown) this.status.textContent = "Starting\u2026";
        else if (this.exercise) this.status.textContent = `${name} \xb7 press Start, then do your reps`;
        else this.status.textContent = "Choose a drill";
    }
}
/** So the shortcut does not fire while someone is typing in a field. */ function $4982aed1ac51f6d6$var$isTypingTarget(target) {
    if (target == null) return false;
    const tag = target.tagName;
    return tag === "INPUT" || tag === "TEXTAREA" || target.isContentEditable;
}


/**
 * Scores one rep against the drill's posture criteria.
 *
 * The drill is not only an arm swing: it is performed on the toes, with the
 * knees flexed, the core engaged, the head and neck neutral, and the chest and
 * head not ahead of the knees. Each of those is checked here over the samples of
 * a single rep. See docs/arm-swing-posture.md for where every threshold came
 * from — all of them are measured off real footage, and all are settings.
 *
 * Side view only. Every criterion is a sagittal-plane measurement; from the
 * front they are either invisible or meaningless, so `POSTURE_VIEWS` gates them
 * the way `views:` gates the per-window metrics.
 *
 * One of the five is not what it claims. Core engagement is not observable:
 * no landmark reports muscle activation, and a lumbar arch barely moves the
 * hip-to-shoulder line the trunk axis is built from. What IS observable is its
 * failure mode — the trunk rocking as the arms pass overhead — so that is what
 * is measured, and it is labelled "Trunk steady" rather than "Core engaged".
 * Claiming otherwise would be a lie the athlete cannot check.
 */ 
const $351c2b07e0ef1e12$export$86b297e393d0a433 = [
    "side"
];
function $351c2b07e0ef1e12$var$median(values) {
    if (values.length === 0) return null;
    const sorted = [
        ...values
    ].sort((a, b)=>a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
}
function $351c2b07e0ef1e12$var$range(values) {
    return Math.max(...values) - Math.min(...values);
}
function $351c2b07e0ef1e12$export$e6b68ffc01162663(samples, side) {
    const offset = $351c2b07e0ef1e12$var$median(samples.map((s)=>s.facingOffset[side]));
    return offset != null && offset < 0 ? -1 : 1;
}
function $351c2b07e0ef1e12$export$f608706c6ebdbcc3(samples, side) {
    return $351c2b07e0ef1e12$var$median(samples.map((s)=>s.footLength[side]));
}
function $351c2b07e0ef1e12$export$d497432b8c9e33de(samples, thresholds, scale = null) {
    if (samples.length === 0) return [];
    const side = (0, $4851c46e13ae947d$export$1cd850881aa38839)(samples);
    const facing = $351c2b07e0ef1e12$export$e6b68ffc01162663(samples, side);
    const foot = scale || $351c2b07e0ef1e12$export$f608706c6ebdbcc3(samples, side);
    // Four of the six read the legs, and the knee is the reference the head and
    // chest are compared against. A take framed from the knees up still counts
    // reps — see RepCounter — so those four report as unjudged rather than
    // confidently wrong on landmarks the model is guessing at.
    const legsSeen = $351c2b07e0ef1e12$var$median(samples.map((s)=>s.legVisibility[side])) >= thresholds.minVisibility;
    const peakLift = Math.max(...samples.map((s)=>s.heelLift[side]));
    const tiptoe = legsSeen && foot > 0 ? peakLift / foot : null;
    const straightestKnee = legsSeen ? Math.min(...samples.map((s)=>s.knee[side])) : null;
    const trunkRock = $351c2b07e0ef1e12$var$range(samples.map((s)=>s.trunkTilt));
    // Centimetres: the athlete reads this, and metres to three decimals does not
    // communicate. Ahead is positive, so the worst frame is the largest.
    const headAhead = 100 * Math.max(...samples.map((s)=>facing * s.aheadOfKneeRaw[side].head));
    const chestAhead = 100 * Math.max(...samples.map((s)=>facing * s.aheadOfKneeRaw[side].chest));
    // Typical, not worst: the head moves through the swing and one frame of it
    // dipping is not a fault. Deviation from the athlete's own neutral offset,
    // which is anatomy rather than form, hence a setting.
    const neckDeviation = $351c2b07e0ef1e12$var$median(samples.map((s)=>s.headPitch[side])) - thresholds.neckOffset;
    return [
        {
            id: "tiptoe",
            label: "On the toes",
            value: tiptoe,
            unit: "\xd7foot",
            precision: 2,
            pass: tiptoe == null ? null : tiptoe >= thresholds.tiptoeMin
        },
        {
            id: "knee_flex",
            label: "Knees flexed",
            value: straightestKnee,
            unit: "\xb0",
            precision: 0,
            pass: straightestKnee == null ? null : straightestKnee <= thresholds.kneeFlexMax
        },
        {
            id: "trunk_steady",
            label: "Trunk steady",
            value: trunkRock,
            unit: "\xb0",
            precision: 1,
            pass: trunkRock <= thresholds.trunkRockMax
        },
        {
            id: "head_back",
            label: "Head behind knee",
            value: headAhead,
            unit: "cm",
            precision: 1,
            pass: headAhead == null ? null : headAhead <= thresholds.aheadOfKneeMax
        },
        {
            id: "chest_back",
            label: "Chest behind knee",
            value: chestAhead,
            unit: "cm",
            precision: 1,
            pass: chestAhead == null ? null : chestAhead <= thresholds.aheadOfKneeMax
        },
        {
            id: "neck_neutral",
            label: "Neck neutral",
            value: neckDeviation,
            unit: "\xb0",
            precision: 0,
            pass: Math.abs(neckDeviation) <= thresholds.neckTolerance
        }
    ];
}
class $351c2b07e0ef1e12$export$3677b0fddb922740 {
    constructor(){
        this.reps = 0;
        this.passes = new Map();
        this.rows = [];
    }
    add(scored) {
        this.reps += 1;
        this.rows = scored;
        for (const row of scored)if (row.pass === true) this.passes.set(row.id, (this.passes.get(row.id) || 0) + 1);
    }
    /** The latest rep's rows, each with how many reps have passed that criterion. */ summary() {
        return this.rows.map((row)=>({
                ...row,
                passed: this.passes.get(row.id) || 0,
                total: this.reps
            }));
    }
    reset() {
        this.reps = 0;
        this.passes.clear();
        this.rows = [];
    }
}


/**
 * What a set and a workout add up to.
 *
 * The per-rep verdict answers "what should I change on the next rep", which is
 * the only question worth answering mid-drill. Afterwards there is a different
 * question — "how did that go" — and it needs the set as a whole: how many reps,
 * how many clean, which fault came up most, how long it took.
 *
 * Score is the share of reps with no failed criterion, and nothing cleverer.
 * A weighted score would need to say that one criterion matters more than
 * another, and nothing in docs/arm-swing-posture.md supports that ordering: the
 * thresholds are one athlete's reps read by one person. Counting clean reps is a
 * claim the numbers can carry.
 *
 * Reps that could not be judged still count as reps and are not clean. They are
 * reported separately, because "6 of 10 clean, 2 not fully seen" tells the
 * athlete to move the phone, while a bare 60% tells them to train harder.
 *
 * No DOM here, and no formatting. The receipt renders this; a check can print it
 * from Node against a recording, which is how the arm swing's cues were
 * verified.
 */ 
class $c8248b0f107e3b94$export$a8b278985df8ab3 {
    /**
   * @param exercise The exercise definition this set was performed under.
   * @param startedAt Wall-clock ms, for the receipt's set time.
   */ constructor(exercise, startedAt = Date.now()){
        this.exercise = exercise;
        this.startedAt = startedAt;
        this.endedAt = null;
        this.reps = 0;
        this.good = 0;
        this.partial = 0;
        /** Per criterion: `{ id, label, passed, judged }`, in the rows' own order. */ this.criteria = [];
        /** Cue text to how many reps raised it, commonest first when read back. */ this.faults = new Map();
        /**
     * Per informational row marked `aggregate: "sum"`: `{ id, label, unit,
     * precision, total, best, reps }`. A figure that judges nothing can still be
     * worth adding up — the air time the athlete asked to see in seconds is the
     * first of them — and a sum belongs to the set rather than to the rep, since
     * a rep already showed its own number as it happened.
     */ this.totals = [];
    }
    /** @param scored Rows from the exercise's `scoreRep`. */ add(scored) {
        const verdict = (0, $4982aed1ac51f6d6$export$81e4fbd518fcb891)(scored, this.exercise && this.exercise.cues);
        this.reps += 1;
        if (verdict.good) this.good += 1;
        if (verdict.partial) this.partial += 1;
        for (const row of scored){
            if (row.informational && row.aggregate === "sum") {
                let total = this.totals.find((t)=>t.id === row.id);
                if (total == null) {
                    total = {
                        id: row.id,
                        label: row.label,
                        unit: row.unit,
                        precision: row.precision,
                        total: 0,
                        best: 0,
                        reps: 0
                    };
                    this.totals.push(total);
                }
                if (Number.isFinite(row.value)) {
                    total.total += row.value;
                    total.best = Math.max(total.best, row.value);
                    total.reps += 1;
                }
            }
            if (row.informational) continue;
            let entry = this.criteria.find((c)=>c.id === row.id);
            if (entry == null) {
                entry = {
                    id: row.id,
                    label: row.label,
                    passed: 0,
                    judged: 0
                };
                this.criteria.push(entry);
            }
            if (row.pass != null) {
                entry.judged += 1;
                if (row.pass) entry.passed += 1;
            }
            if (row.pass === false) {
                const cue = this.cueFor(row);
                this.faults.set(cue, (this.faults.get(cue) || 0) + 1);
            }
        }
    }
    cueFor(row) {
        const cues = this.exercise && this.exercise.cues || {};
        return cues[row.id] || row.label;
    }
    end(at = Date.now()) {
        this.endedAt = at;
        return this;
    }
    get seconds() {
        const end = this.endedAt == null ? Date.now() : this.endedAt;
        return Math.max(0, Math.round((end - this.startedAt) / 1000));
    }
    /** Share of reps with no failed criterion, 0-100, or null for an empty set. */ get percent() {
        return this.reps === 0 ? null : Math.round(100 * this.good / this.reps);
    }
    /**
   * The set as plain data, for storage and for the backend this is one day
   * going to be posted to.
   *
   * Deliberately not the whole object: `exercise` is a module, not data, so only
   * its id is kept and the definition is looked up again on the way back. What
   * is stored is the SUMMARY — counts and criterion tallies — never the samples
   * or the landmarks, which is the same line the rest of the app holds: nothing
   * derived from the video is kept beyond the figures the athlete was shown.
   */ toJSON() {
        return {
            exercise: this.exercise && this.exercise.id,
            startedAt: this.startedAt,
            endedAt: this.endedAt,
            reps: this.reps,
            good: this.good,
            partial: this.partial,
            criteria: this.criteria,
            totals: this.totals,
            faults: [
                ...this.faults.entries()
            ]
        };
    }
    /**
   * Rebuilds a set from `toJSON()`.
   *
   * Every field is checked rather than trusted: this comes back from storage,
   * where an older build, a half-written record or a hand edit all look the
   * same. A set that cannot be rebuilt is dropped by the caller rather than
   * printed as a line of NaN.
   *
   * @param exercise The definition for `data.exercise`, or null if that drill no
   *   longer exists — the line then still prints, under its stored id.
   */ static fromJSON(data, exercise) {
        if (data == null || typeof data !== "object") return null;
        const reps = $c8248b0f107e3b94$var$count(data.reps);
        if (reps === 0) return null;
        const set = new $c8248b0f107e3b94$export$a8b278985df8ab3(exercise || {
            id: data.exercise,
            name: data.exercise || "Drill"
        }, $c8248b0f107e3b94$var$count(data.startedAt));
        set.endedAt = $c8248b0f107e3b94$var$count(data.endedAt) || set.startedAt;
        set.reps = reps;
        set.good = Math.min(reps, $c8248b0f107e3b94$var$count(data.good));
        set.partial = Math.min(reps, $c8248b0f107e3b94$var$count(data.partial));
        set.criteria = Array.isArray(data.criteria) ? data.criteria.filter((c)=>c && typeof c.id === "string").map((c)=>({
                id: c.id,
                label: typeof c.label === "string" ? c.label : c.id,
                passed: $c8248b0f107e3b94$var$count(c.passed),
                judged: $c8248b0f107e3b94$var$count(c.judged)
            })) : [];
        set.totals = Array.isArray(data.totals) ? data.totals.filter((t)=>t && typeof t.id === "string" && Number.isFinite(t.total) && t.total >= 0).map((t)=>({
                id: t.id,
                label: typeof t.label === "string" ? t.label : t.id,
                unit: typeof t.unit === "string" ? t.unit : "",
                precision: $c8248b0f107e3b94$var$count(t.precision),
                total: t.total,
                best: Number.isFinite(t.best) && t.best > 0 ? t.best : 0,
                reps: $c8248b0f107e3b94$var$count(t.reps)
            })) : [];
        set.faults = new Map(Array.isArray(data.faults) ? data.faults.filter(([cue, n])=>typeof cue === "string" && $c8248b0f107e3b94$var$count(n) > 0) : []);
        return set;
    }
    /** Faults by how many reps raised them, commonest first. */ get topFaults() {
        return [
            ...this.faults.entries()
        ].map(([cue, count])=>({
                cue: cue,
                count: count
            })).sort((a, b)=>b.count - a.count);
    }
}
class $c8248b0f107e3b94$export$4a524c6720bdca36 {
    constructor(){
        this.sets = [];
    }
    /** @param set A finished `SetScore`. Empty sets are dropped. */ add(set) {
        if (set.reps > 0) this.sets.push(set);
        return this;
    }
    get reps() {
        return this.sets.reduce((total, set)=>total + set.reps, 0);
    }
    get good() {
        return this.sets.reduce((total, set)=>total + set.good, 0);
    }
    get partial() {
        return this.sets.reduce((total, set)=>total + set.partial, 0);
    }
    get seconds() {
        return this.sets.reduce((total, set)=>total + set.seconds, 0);
    }
    get percent() {
        return this.reps === 0 ? null : Math.round(100 * this.good / this.reps);
    }
    /** True when any set was scored against thresholds nobody has calibrated. */ get uncalibrated() {
        return this.sets.some((set)=>set.exercise && !set.exercise.calibrated);
    }
    /**
   * The aggregated informational figures across every set, by id, in the order
   * they first appeared. One line on the ticket rather than one per set.
   */ get totals() {
        const byId = new Map();
        for (const set of this.sets)for (const t of set.totals || []){
            const entry = byId.get(t.id);
            if (entry == null) byId.set(t.id, {
                ...t
            });
            else {
                entry.total += t.total;
                entry.best = Math.max(entry.best, t.best);
                entry.reps += t.reps;
            }
        }
        return [
            ...byId.values()
        ];
    }
    get topFaults() {
        const totals = new Map();
        for (const set of this.sets)for (const { cue: cue, count: count } of set.topFaults)totals.set(cue, (totals.get(cue) || 0) + count);
        return [
            ...totals.entries()
        ].map(([cue, count])=>({
                cue: cue,
                count: count
            })).sort((a, b)=>b.count - a.count);
    }
    reset() {
        this.sets = [];
    }
}
/**
 * A letter for the score, console-style.
 *
 * Bands rather than a curve, and deliberately coarse: the measurement's own
 * resolution is one rep, so on a ten-rep set every band edge is a whole rep
 * anyway. S is kept for a set with nothing wrong in it, because a rank that can
 * be reached with a fault in it is not worth reaching.
 */ function $c8248b0f107e3b94$var$count(value) {
    return Number.isFinite(value) && value > 0 ? Math.floor(value) : 0;
}
function $c8248b0f107e3b94$export$3b9c11a81d4bccbf(percent) {
    if (percent == null) return "-";
    if (percent >= 100) return "S";
    if (percent >= 90) return "A";
    if (percent >= 75) return "B";
    if (percent >= 50) return "C";
    return "D";
}


/**
 * Levels, as a video game's: what the athlete has banked on each drill across
 * every visit, not just this session.
 *
 * The honest version of a level. XP is **clean reps** — reps with no failed
 * criterion — and nothing else, so the number cannot be farmed by doing more
 * bad reps, which is the one thing a rep counter makes trivially easy and the
 * one thing a coaching app must not reward. A rep that was only partly seen
 * earns nothing either: it was not judged, so it is not evidence of anything.
 *
 * It is a motivator and not a measurement. A level says how much clean work has
 * gone in, not how good the athlete is, and on an uncalibrated drill the clean
 * reps were counted against thresholds nobody measured — the menu card and the
 * receipt both keep saying so, and the level does not override that.
 *
 * Stored in localStorage, per device. There is no backend and no account in this
 * app, which is the whole premise: no video and nothing derived from it leaves
 * the machine. So the levels live on the phone that recorded them, and clearing
 * the browser's data clears them. Every access is wrapped: Safari in private
 * mode throws on write rather than returning null, and a drill that cannot save
 * a level must still run.
 */ const $35939dc4a8d67d0d$var$KEY = "spottr.progress.v1";
/**
 * What the key was called before the app was renamed from RoboCoach.
 *
 * A rename must not cost the athlete their levels. The keys are read through
 * `readRenamed`, which copies the old record forward the first time it finds
 * one, so a phone that has been using the app keeps every clean rep it earned
 * and a new one never writes the old name at all.
 */ const $35939dc4a8d67d0d$var$OLD_KEY = "robocoach.progress.v1";
/**
 * Clean reps for the first level, and how much more each level asks.
 *
 * The curve is deliberately gentle at the start and never steepens much: the
 * point is that a first session ends with something visibly earned, and that a
 * drill done twice a week keeps moving. Ten clean reps is one honest set.
 */ const $35939dc4a8d67d0d$var$BASE = 10;
const $35939dc4a8d67d0d$var$STEP = 5;
function $35939dc4a8d67d0d$export$c932aceb7c67d0f4(level) {
    return $35939dc4a8d67d0d$var$BASE + $35939dc4a8d67d0d$var$STEP * (level - 1);
}
function $35939dc4a8d67d0d$export$a9ca2b63f7e2ae88(clean) {
    let level = 1;
    // A total read back from storage can be anything; a drill with a corrupt
    // total is level one, not a bar full of NaN.
    let left = Number.isFinite(clean) ? Math.max(0, Math.floor(clean)) : 0;
    while(left >= $35939dc4a8d67d0d$export$c932aceb7c67d0f4(level)){
        left -= $35939dc4a8d67d0d$export$c932aceb7c67d0f4(level);
        level += 1;
    }
    return {
        level: level,
        into: left,
        need: $35939dc4a8d67d0d$export$c932aceb7c67d0f4(level)
    };
}
class $35939dc4a8d67d0d$export$b25a304ec7d746bb {
    constructor(storage = $35939dc4a8d67d0d$export$41c9f13668e9c626()){
        this.storage = storage;
        /** Per exercise id: `{ reps, clean }`. */ this.totals = this.read();
    }
    read() {
        if (this.storage == null) return {};
        try {
            const raw = $35939dc4a8d67d0d$export$ce992fb8397a90f8(this.storage, $35939dc4a8d67d0d$var$KEY, $35939dc4a8d67d0d$var$OLD_KEY);
            const parsed = raw ? JSON.parse(raw) : {};
            // Anything in storage is from an older build or a hand edit, so each
            // field is taken only if it is a real number.
            const totals = {};
            for (const [id, entry] of Object.entries(parsed || {}))if (entry && typeof entry === "object") totals[id] = {
                reps: $35939dc4a8d67d0d$var$numberOr(entry.reps, 0),
                clean: $35939dc4a8d67d0d$var$numberOr(entry.clean, 0)
            };
            return totals;
        } catch  {
            return {};
        }
    }
    save() {
        if (this.storage == null) return;
        try {
            this.storage.setItem($35939dc4a8d67d0d$var$KEY, JSON.stringify(this.totals));
        } catch  {
        // Out of quota, or private mode. A level that cannot be saved is not a
        // reason to lose the set that earned it.
        }
    }
    forExercise(id) {
        return this.totals[id] || {
            reps: 0,
            clean: 0
        };
    }
    /** `{ level, into, need }` for one drill. */ levelOf(id) {
        return $35939dc4a8d67d0d$export$a9ca2b63f7e2ae88(this.forExercise(id).clean);
    }
    /**
   * Banks a finished set.
   *
   * @return `{ gained, from, to }` — clean reps earned and the levels either
   *   side, so the receipt can say when one was crossed.
   */ add(set) {
        const id = set.exercise && set.exercise.id;
        if (id == null || set.reps === 0) return {
            gained: 0,
            from: null,
            to: null
        };
        const before = this.levelOf(id);
        const totals = this.forExercise(id);
        this.totals[id] = {
            reps: totals.reps + set.reps,
            clean: totals.clean + set.good
        };
        this.save();
        return {
            gained: set.good,
            from: before.level,
            to: this.levelOf(id).level
        };
    }
    /** Wipes every level. Only ever called from an explicit reset. */ clear() {
        this.totals = {};
        this.save();
    }
}
function $35939dc4a8d67d0d$var$numberOr(value, fallback) {
    return Number.isFinite(value) && value >= 0 ? value : fallback;
}
function $35939dc4a8d67d0d$export$41c9f13668e9c626() {
    try {
        const storage = window.localStorage;
        const probe = "spottr.probe";
        storage.setItem(probe, "1");
        storage.removeItem(probe);
        return storage;
    } catch  {
        return null;
    }
}
function $35939dc4a8d67d0d$export$ce992fb8397a90f8(storage, key, oldKey) {
    if (storage == null) return null;
    try {
        const raw = storage.getItem(key);
        if (raw != null) return raw;
        const legacy = storage.getItem(oldKey);
        if (legacy == null) return null;
        try {
            storage.setItem(key, legacy);
        } catch  {
        // Out of quota or private mode. The record still reads fine from the old
        // key this time and every time, so nothing is lost by failing here.
        }
        return legacy;
    } catch  {
        return null;
    }
}


/**
 * The day's receipt, kept across reloads.
 *
 * A workout is not a page load. The athlete drops the phone, the screen locks,
 * the tab is reclaimed by iOS for memory, they come back after the rest between
 * sets and reload — and before this, that was a fresh ticket with the earlier
 * sets gone. So the sets are banked as they finish and the ticket is the day's,
 * not the session's.
 *
 * **The day boundary is local midnight**, taken from the device clock. Not a
 * rolling 24 hours, which would merge a late Monday into a Tuesday morning, and
 * not UTC, which would cut a European evening session in half. A workout that
 * genuinely crosses midnight is split, and that is the honest reading: it is two
 * dates.
 *
 * What is stored is the summary — counts and criterion tallies — and never the
 * samples or the landmarks. That line is the premise of the whole app: no video
 * and nothing derived from it leaves the machine, and keeping a day's figures
 * does not change that.
 *
 * The shape is versioned and plain, with the exercise referred to by id, so that
 * the planned backend can take the same records as a body without a migration:
 * what is written here is what would be posted.
 */ 

const $3f82ab3df4547366$var$KEY = "spottr.workout.v1";
/** The key before the rename from RoboCoach; see `readRenamed`. */ const $3f82ab3df4547366$var$OLD_KEY = "robocoach.workout.v1";
function $3f82ab3df4547366$export$f4a168a9e08afad3(at = new Date()) {
    const pad = (n)=>String(n).padStart(2, "0");
    return `${at.getFullYear()}-${pad(at.getMonth() + 1)}-${pad(at.getDate())}`;
}
class $3f82ab3df4547366$export$7c314e4f9c976dac {
    constructor(storage = (0, $35939dc4a8d67d0d$export$41c9f13668e9c626)()){
        this.storage = storage;
        this.day = $3f82ab3df4547366$export$f4a168a9e08afad3();
    }
    /**
   * Today's workout, or an empty one.
   *
   * @param exerciseById Resolves a stored id back to its definition.
   * @return `{ workout, earned }` — the second being the per-set XP rows the
   *   receipt prints, in the same order, from when those sets were banked.
   */ load(exerciseById) {
        const empty = {
            workout: new (0, $c8248b0f107e3b94$export$4a524c6720bdca36)(),
            earned: []
        };
        if (this.storage == null) return empty;
        let stored;
        try {
            const raw = (0, $35939dc4a8d67d0d$export$ce992fb8397a90f8)(this.storage, $3f82ab3df4547366$var$KEY, $3f82ab3df4547366$var$OLD_KEY);
            stored = raw ? JSON.parse(raw) : null;
        } catch  {
            return empty;
        }
        // A record from another day is yesterday's ticket, not this one's. It is
        // left in place rather than deleted: the next save overwrites it, and a
        // clock that has jumped backwards for an hour should not destroy a workout.
        if (stored == null || stored.day !== this.day) return empty;
        const sets = Array.isArray(stored.sets) ? stored.sets : [];
        const workout = new (0, $c8248b0f107e3b94$export$4a524c6720bdca36)();
        const earned = [];
        sets.forEach((record, i)=>{
            const set = (0, $c8248b0f107e3b94$export$a8b278985df8ab3).fromJSON(record, exerciseById(record && record.exercise));
            if (set == null) return;
            workout.add(set);
            const gain = Array.isArray(stored.earned) ? stored.earned[i] : null;
            earned.push(gain && typeof gain === "object" ? {
                gained: gain.gained || 0,
                from: gain.from,
                to: gain.to
            } : {
                gained: 0,
                from: null,
                to: null
            });
        });
        return {
            workout: workout,
            earned: earned
        };
    }
    /** Banks the day's sets. Called as each one finishes. */ save(workout, earned) {
        if (this.storage == null) return;
        try {
            this.storage.setItem($3f82ab3df4547366$var$KEY, JSON.stringify({
                version: 1,
                day: this.day,
                sets: workout.sets.map((set)=>set.toJSON()),
                earned: earned
            }));
        } catch  {
        // Out of quota, or private mode. The ticket on screen is still right for
        // this session; it just will not survive the reload.
        }
    }
    /**
   * Whether the day has turned over since this store was made.
   *
   * The app is left open on a phone for hours, so the day it started on is not
   * necessarily the day a set ends on.
   */ rolledOver() {
        return $3f82ab3df4547366$export$f4a168a9e08afad3() !== this.day;
    }
    /** Moves to today, so the next save starts a new day's ticket. */ startNewDay() {
        this.day = $3f82ab3df4547366$export$f4a168a9e08afad3();
    }
}


/**
 * The end-of-workout receipt.
 *
 * A till roll, because that is the one summary layout everybody can already
 * read: a quantity, a name, a figure per line, a rule, and a total at the
 * bottom. It also happens to suit this UI exactly — a receipt is monospaced,
 * left-aligned, has no colour and no rounded corners, and is printed in capitals
 * on paper. The whole aesthetic is already in the font.
 *
 * It is itemised by SET rather than by rep. A rep's verdict has already been
 * delivered, as a sound and a banner, at the moment it mattered; printing ten of
 * them afterwards is a log, not a summary. What the athlete did not yet have is
 * the shape of the whole thing, so each set is one line with its reps and its
 * score, and each of its criteria is a sub-line with how many reps passed it.
 *
 * Under the total is the one thing on the ticket that is coaching rather than
 * accounting: what to fix next time, in the drill's own cues, or PERFECT when
 * there is nothing. See `feedbackLines()` for why a partly seen rep never earns
 * that word.
 *
 * The lines are built as data, apart from the rendering, for the same reason
 * `verdictFor()` is: the layout can then be checked against a recording from
 * Node, with no browser and no camera. `src/metrics/receipt.js` printing a
 * sensible ticket for a ten-rep take is a thing a script can assert.
 */ 
function $6cd2e44443c6f786$var$minutes(seconds) {
    const mins = Math.floor(seconds / 60);
    const secs = seconds % 60;
    return `${mins}:${String(secs).padStart(2, "0")}`;
}
function $6cd2e44443c6f786$var$stamp(ms) {
    const date = new Date(ms);
    const pad = (n)=>String(n).padStart(2, "0");
    return `${date.getFullYear()}-${pad(date.getMonth() + 1)}-${pad(date.getDate())} ` + `${pad(date.getHours())}:${pad(date.getMinutes())}`;
}
function $6cd2e44443c6f786$export$ce5a0db87b5d5433(workout, earned = null) {
    const lines = [];
    const push = (kind, left = null, right = null, qty = null)=>lines.push({
            kind: kind,
            left: left,
            right: right,
            qty: qty
        });
    push("title", "Spottr");
    push("subtitle", "Training receipt");
    push("meta", $6cd2e44443c6f786$var$stamp(Date.now()), `${workout.sets.length} set${workout.sets.length === 1 ? "" : "s"}`);
    push("rule");
    push("head", "Item", "Clean", "Qty");
    workout.sets.forEach((set, index)=>{
        const exercise = set.exercise || {};
        const name = exercise.calibrated === false ? `${exercise.name} *` : exercise.name || "Drill";
        // The quantity is its own column rather than padding on the label: HTML
        // collapses runs of spaces, so a padded string that lines up in a terminal
        // does not line up on the page.
        push("item", name, `${set.good}/${set.reps}`, String(set.reps));
        for (const criterion of set.criteria){
            // Unjudged reps are left out of the denominator rather than counted as
            // failures: the criterion was not measured on them, which is a different
            // statement from the athlete missing it.
            const figure = criterion.judged === 0 ? "--" : `${criterion.passed}/${criterion.judged}`;
            push("sub", criterion.label, figure);
        }
        for (const total of set.totals || [])// The figures that judge nothing but add up: air time on the jump today.
        // Printed as the set's own total with its best rep beside it, which is
        // the form a score is read in.
        push("sub", total.label, `${total.total.toFixed(1)}${total.unit} \xb7 best ${total.best.toFixed(2)}${total.unit}`);
        if (set.partial > 0) push("sub", "Partly seen", `${set.partial}`);
        const gain = earned && earned[index];
        if (gain && gain.gained > 0) push("sub", `${exercise.name} XP`, `+${gain.gained}`);
        if (gain && gain.to > gain.from) push("levelup", `${exercise.name} reached Lv ${gain.to}`);
    });
    push("thin");
    push("total", "Reps", String(workout.reps));
    push("total", "Clean reps", String(workout.good));
    if (workout.partial > 0) push("total", "Partly seen", String(workout.partial));
    push("total", "Time", $6cd2e44443c6f786$var$minutes(workout.seconds));
    for (const total of workout.totals)push("total", total.label, `${total.total.toFixed(1)}${total.unit} \xb7 best ${total.best.toFixed(2)}${total.unit}`);
    push("thin");
    const percent = workout.percent;
    push("grand", "Total", percent == null ? "--" : `${percent}%`);
    push("rank", "Rank", (0, $c8248b0f107e3b94$export$3b9c11a81d4bccbf)(percent));
    push("thin");
    for (const line of $6cd2e44443c6f786$var$feedbackLines(workout))lines.push(line);
    push("rule");
    if (workout.uncalibrated) // Printed on the ticket rather than only shown in the menu: a score carries
    // the authority of the thresholds behind it, and the squat's are not
    // measured off footage the way the swing's are.
    push("note", "* Experimental \u2014 the count is sound, the score is a guess");
    push("barcode");
    push("footer", "Thank you \u2014 train again soon");
    return lines;
}
/** At most this many faults are printed as things to fix. */ const $6cd2e44443c6f786$var$MAX_FIXES = 3;
/**
 * What to change next time, or that there is nothing.
 *
 * The rep verdicts were delivered as they happened, so what this adds is the
 * one thing the athlete did wrong most often, said in the drill's own cue —
 * imperative and short, the same words that were on the banner mid-rep, rather
 * than a criterion name restated. Three at most: a list of eight faults is a log
 * again, and the point of the block is to leave the athlete with something they
 * can hold in their head on the way back to the mat.
 *
 * Two things it will not do. **A partly seen rep is not a perfect one**, even
 * though it counts as clean and can carry a 100% total: nothing failed because
 * the criteria were not measured, and telling someone they were perfect on reps
 * the model was guessing at is the one kind of praise this app must not give. So
 * framing is a line in the fix list, in plain words rather than as a drill cue,
 * since no exercise declares one for it. And **PERFECT says nothing about the
 * thresholds behind it** — on an uncalibrated drill it is a perfect score
 * against numbers nobody measured, which is what the experimental note under it
 * is for. The note is not softened and PERFECT is not withheld: the mark is the
 * athlete's performance against what the app claimed, and the asterisk is the
 * app's claim about itself.
 */ function $6cd2e44443c6f786$var$feedbackLines(workout) {
    const lines = [];
    const push = (kind, left = null, right = null)=>lines.push({
            kind: kind,
            left: left,
            right: right,
            qty: null
        });
    const faults = workout.topFaults;
    if (faults.length === 0 && workout.partial === 0) {
        push("perfect", "Perfect");
        push("note", "Nothing to fix - every rep clean and fully seen");
        return lines;
    }
    push("fixhead", "Fix next time");
    for (const fault of faults.slice(0, $6cd2e44443c6f786$var$MAX_FIXES))push("fix", fault.cue, `x${fault.count}`);
    const dropped = faults.length - $6cd2e44443c6f786$var$MAX_FIXES;
    if (dropped > 0) push("note", `+${dropped} more above`);
    if (workout.partial > 0) push("fix", "Get your whole body in shot", `x${workout.partial}`);
    return lines;
}
class $6cd2e44443c6f786$export$953430523d182974 {
    /**
   * @param handlers.onAgain Back to the drill to add another set.
   * @param handlers.onMenu Back to the exercise menu.
   */ constructor({ onAgain: onAgain, onMenu: onMenu }){
        this.panel = document.getElementById("receipt");
        this.paper = document.getElementById("receipt-paper");
        this.again = document.getElementById("receipt-again");
        this.menu = document.getElementById("receipt-menu");
        this.printButton = document.getElementById("receipt-print");
        this.again.addEventListener("click", ()=>{
            this.hide();
            onAgain();
        });
        this.menu.addEventListener("click", ()=>{
            this.hide();
            onMenu();
        });
        if (this.printButton) // The ticket stays open behind the print dialog: the athlete cancels or
        // prints and is still looking at the same workout. The page-sized version
        // is `@media print` in base.css, not a second rendering of the lines.
        this.printButton.addEventListener("click", ()=>window.print());
    }
    get visible() {
        return !this.panel.hidden;
    }
    show(workout, earned = null) {
        this.paper.textContent = "";
        for (const line of $6cd2e44443c6f786$export$ce5a0db87b5d5433(workout, earned))this.paper.appendChild($6cd2e44443c6f786$var$renderLine(line));
        this.panel.hidden = false;
        // So the pad's buttons are reachable by keyboard the moment it opens, and
        // because the drill's Space shortcut must not fall through to Start.
        this.again.focus();
    }
    hide() {
        this.panel.hidden = true;
    }
}
function $6cd2e44443c6f786$var$renderLine(line) {
    if (line.kind === "rule" || line.kind === "thin") {
        const rule = document.createElement("div");
        rule.className = `receipt-${line.kind}`;
        return rule;
    }
    if (line.kind === "barcode") return $6cd2e44443c6f786$var$renderBarcode();
    const row = document.createElement("div");
    row.className = `receipt-line receipt-${line.kind}`;
    if (line.qty != null) {
        const qty = document.createElement("span");
        qty.className = "receipt-qty";
        qty.textContent = line.qty;
        row.appendChild(qty);
    }
    const left = document.createElement("span");
    left.className = "receipt-left";
    left.textContent = line.left;
    row.appendChild(left);
    if (line.right != null) {
        const right = document.createElement("span");
        right.className = "receipt-right";
        right.textContent = line.right;
        row.appendChild(right);
    }
    return row;
}
/**
 * The barcode. It encodes nothing and is not pretending to: it is the one mark
 * that makes a block of monospaced text unmistakably a till receipt, and it is
 * built from hard-edged bars, which is the only kind of gradient this UI allows.
 */ function $6cd2e44443c6f786$var$renderBarcode() {
    const bars = document.createElement("div");
    bars.className = "receipt-barcode";
    bars.setAttribute("aria-hidden", "true");
    const widths = [
        3,
        1,
        2,
        1,
        1,
        4,
        1,
        2,
        3,
        1,
        1,
        2,
        4,
        1,
        3,
        1,
        2,
        1,
        1,
        3
    ];
    widths.forEach((width, i)=>{
        const bar = document.createElement("span");
        bar.style.width = `${width * 2}px`;
        // Alternating bar and gap, the way a real one reads.
        bar.style.background = i % 2 === 0 ? "var(--edge)" : "transparent";
        bars.appendChild(bar);
    });
    return bars;
}


/**
 * The exercise registry: which drills this app can score, and what each one
 * needs from the render loop.
 *
 * Why this exists. Everything under src/metrics/ splits cleanly into two halves
 * that used to be welded together in index.js. One half is generic — the pose
 * geometry, the sample, the frame buffer, the smoothing, the window metrics, the
 * readout, the sounds, the countdown, the receipt. The other half is one
 * exercise: that a rep is a full revolution of the arm, that six criteria are
 * worth checking, and what to say when one of them fails. Only the second half
 * changes between drills, so an exercise is a declaration of exactly that:
 *
 *   id            stable, used by `?exercise=` and written into the receipt
 *   name, blurb   what the menu shows
 *   view          which camera view its criteria are honest in
 *   calibrated    whether its thresholds were measured or guessed
 *   cues          what to say when a criterion fails, by criterion id
 *   createCounter a rep counter: `push(sample, side)`, `reset()`, `count`,
 *                 `progress`, `break()`
 *   scoreRep      one rep's samples in, criterion rows out
 *
 * A row is `{ id, label, value, unit, precision, pass }`, with `pass` null for
 * "could not judge this" and an optional `informational: true` for a figure that
 * reports without judging. Everything downstream — the verdict, the sounds, the
 * readout, the tally, the receipt — reads only that shape, so an exercise that
 * produces it needs no changes anywhere else.
 *
 * What an exercise may NOT do is claim to be calibrated. The swing's thresholds
 * came off real footage and are recorded in docs/arm-swing-posture.md; the
 * squat jump's counting was measured the same way in docs/squat-jump.md but its
 * criteria are anatomy and judgement, and the V-sit's are judgement throughout.
 * They all score reps and only one of them means what a score usually means, so
 * the flag is carried through to the menu and printed on the receipt rather than
 * left in a comment.
 */ /**
 * The dryland arm swing: the drill this app was built around, now expressed as
 * an exercise definition rather than wired straight into the render loop.
 *
 * Nothing about the measurement changed in being moved here. The counter is
 * still `RepCounter`, which accumulates the signed arm angle because this swing
 * genuinely revolves (see metrics/revolutions.js), and the criteria are still
 * the six in metrics/posture.js plus the two tempo rows. What the definition
 * adds is the declaration a second exercise needs: which view the criteria are
 * honest in, which thresholds they read, and what to say when one fails.
 *
 * This is the only calibrated exercise. Every threshold behind it was measured
 * off real footage and is recorded in docs/arm-swing-posture.md.
 */ /**
 * Counts reps as full revolutions of the upper arm.
 *
 * A standing arm swing circles: the arm goes down, forward, overhead, behind
 * and down again, so the upper-arm vector genuinely revolves rather than
 * oscillating. On a ten-rep recording the signed arm angle relative to the
 * trunk accumulates -3600 degrees — 10.00 revolutions against ten performed.
 *
 * This is why the counter reads the SIGNED angle and accumulates it, while the
 * amplitude metrics read `elevation` and must not. Elevation is bounded 0-180
 * by construction, which is what makes it right for a windowed peak-to-peak and
 * useless here: a full circle and a raise-and-lower both trace 0 to 180 and
 * back, and only the accumulated signal tells them apart. Accumulating is wrong
 * for amplitude and necessary for counting; see `armElevation()` for the other
 * half of that split.
 */ /** Smallest signed step between two angles, resolving the wrap at +/-180. */ function $1afed4526f0605fd$var$step(from, to) {
    let delta = to - from;
    while(delta > 180)delta -= 360;
    while(delta < -180)delta += 360;
    return delta;
}
class $1afed4526f0605fd$export$ab99ef5b8e65ee0c {
    /**
   * @param options.minVisibility Frames whose arm or trunk landmarks fall below
   *   this are refused outright. Without a gate, a take where the athlete walks
   *   into and out of shot counts 11 reps instead of 10, because the walks carry
   *   real arm movement the model is partly guessing at.
   *
   *   The gate reads arm and trunk, NOT legs: counting is a question about the
   *   arm, so a take framed from the knees up still counts — it simply cannot be
   *   scored for tiptoes or knee flexion. The legs are also the less reliable
   *   half of the pose. On the reference recordings 99 to 106 frames fall below
   *   this threshold on the legs against 83 to 88 on the arm and trunk, so a leg
   *   gate would break accumulation on frames where the arm is perfectly clear.
   * @param options.maxGapMs A longer gap between frames breaks the
   *   accumulation. Real recordings drop frames — one 490ms gap in 29 seconds,
   *   spanning about a quarter of a rep — and bridging one invents travel the
   *   arm may not have made.
   */ constructor({ minVisibility: minVisibility = 0.5, maxGapMs: maxGapMs = 250 } = {}){
        this.minVisibility = minVisibility;
        this.maxGapMs = maxGapMs;
        this.reset();
    }
    reset() {
        this.count = 0;
        this.travel = 0;
        this.last = null;
        /** Samples accumulated since the current rep began. */ this.current = [];
        /** The most recently completed rep's samples, for scoring. */ this.lastRep = null;
    }
    /**
   * Feeds one sample in. Returns the completed rep's samples when this sample
   * closed a revolution, otherwise null.
   *
   * @param sample From `buildSample()`.
   * @param side Which arm to follow, from `nearSide()`.
   */ push(sample, side) {
        if (sample.swingVisibility[side] < this.minVisibility) {
            // Not a failed rep, just an unusable frame. Drop the partial rep rather
            // than resuming across the gap with a stale angle.
            this.break();
            return null;
        }
        const angle = sample.armAngle[side];
        if (this.last == null || sample.t - this.last.t > this.maxGapMs) {
            this.last = {
                t: sample.t,
                angle: angle
            };
            this.current = [
                sample
            ];
            return null;
        }
        this.travel += $1afed4526f0605fd$var$step(this.last.angle, angle);
        this.last = {
            t: sample.t,
            angle: angle
        };
        this.current.push(sample);
        if (Math.abs(this.travel) < 360) return null;
        // One revolution closed. Carry the overshoot rather than discarding it, so
        // a slow drift in frame timing cannot shed a rep over a long set.
        this.travel -= Math.sign(this.travel) * 360;
        this.count += 1;
        this.lastRep = this.current;
        this.current = [
            sample
        ];
        return this.lastRep;
    }
    /** Abandons the rep in progress, keeping the count so far. */ break() {
        this.last = null;
        this.travel = 0;
        this.current = [];
    }
    /** How far through the current rep, 0 to 1. For a progress readout. */ get progress() {
        return Math.abs(this.travel) / 360;
    }
}



/**
 * How fast the arm travels on the way up against the way down.
 *
 * Both halves cover the same 360 degrees of travel, so the only thing that
 * separates them is the time each takes, and the ratio of the two speeds is the
 * whole measurement.
 *
 * It reports and never judges. Driving the arm up faster than it comes down was
 * the original ask, and it was dropped as a criterion on 2026-10-03 because the
 * athlete could not reach any ratio the measurement can resolve: the spread
 * between clean reps is about 0.09, so a target set anywhere near 1.0 passes and
 * fails the same rep on different days. What survives is the figure itself, said
 * as "Up faster", "Down faster" or "Even", which is useful to watch across a set
 * and dishonest to fail a rep on.
 *
 * **Never per frame.** This is the one thing that will bite anyone changing this
 * file. The signed arm angle does not advance evenly between frames even when the
 * arm is moving smoothly, so a per-frame speed is mostly noise: on the reference
 * ten-rep take the median per-frame speed came out at 63 degrees/second against a
 * true average of 225. Speed here is therefore degrees travelled over a whole
 * phase divided by the time that phase took, which is also the quantity the
 * athlete can actually control.
 *
 * The up and down halves are split on `elevation`, which is bounded 0-180 by
 * construction, so the direction it moves cuts each revolution into exactly two
 * halves. This is the same split the amplitude metrics rely on, and it leaves the
 * rep counter's accumulated signed angle alone — see `revolutions.js` for why
 * those two signals must not borrow from each other.
 *
 * One idea that sounds right and is not: excluding a dead band around the top and
 * bottom of the circle, where elevation barely changes and the phase a frame
 * belongs to looks like it should be decided by noise. Tried on the reference
 * take across bands from 5 to 40 degrees. The spread between reps does not
 * improve — a standard deviation of 0.09 at no dead band against 0.09 at 10
 * degrees and 0.11 at 20 — and past 25 degrees the measurement falls apart
 * entirely, because what is left is the middle of each phase rather than the
 * phase. The spread is the movement and the landmarks, not the turnarounds.
 */ /** Smallest signed step between two angles, resolving the wrap at +/-180. */ function $0a9253dfd716f087$var$step(from, to) {
    let delta = to - from;
    while(delta > 180)delta -= 360;
    while(delta < -180)delta += 360;
    return delta;
}
function $0a9253dfd716f087$export$25a961605a21d687(samples, side, maxGapMs = 250) {
    let upDegrees = 0;
    let upMs = 0;
    let downDegrees = 0;
    let downMs = 0;
    for(let i = 1; i < samples.length; i += 1){
        const elapsed = samples[i].t - samples[i - 1].t;
        if (elapsed <= 0 || elapsed > maxGapMs) continue;
        const degrees = Math.abs($0a9253dfd716f087$var$step(samples[i - 1].armAngle[side], samples[i].armAngle[side]));
        // Equal elevation counts as rising, so a frame is never discarded for being
        // exactly level; at this sample rate that is a handful of frames per rep.
        if (samples[i].elevation[side] >= samples[i - 1].elevation[side]) {
            upDegrees += degrees;
            upMs += elapsed;
        } else {
            downDegrees += degrees;
            downMs += elapsed;
        }
    }
    const up = upMs > 0 ? 1000 * upDegrees / upMs : null;
    const down = downMs > 0 ? 1000 * downDegrees / downMs : null;
    return {
        up: up,
        down: down,
        ratio: up != null && down != null && down > 0 ? up / down : null
    };
}
function $0a9253dfd716f087$export$6734e1fd2cbd894f(samples, side, maxGapMs = 250) {
    let net = 0;
    let elapsed = 0;
    for(let i = 1; i < samples.length; i += 1){
        const dt = samples[i].t - samples[i - 1].t;
        if (dt <= 0 || dt > maxGapMs) continue;
        net += $0a9253dfd716f087$var$step(samples[i - 1].armAngle[side], samples[i].armAngle[side]);
        elapsed += dt;
    }
    return elapsed > 0 ? 1000 * Math.abs(net) / elapsed : null;
}
function $0a9253dfd716f087$export$ac8ee1f4019d35eb(samples, side, thresholds) {
    const speed = $0a9253dfd716f087$export$6734e1fd2cbd894f(samples, side, thresholds.maxGapMs);
    return {
        id: "swing_speed",
        label: "Swing speed",
        value: speed,
        unit: "\xb0/s",
        precision: 0,
        pass: speed == null ? null : speed >= thresholds.swingSpeedMin
    };
}
function $0a9253dfd716f087$export$d65e673853f36884(samples, side, thresholds) {
    const { ratio: ratio } = $0a9253dfd716f087$export$25a961605a21d687(samples, side, thresholds.maxGapMs);
    return {
        id: "tempo",
        label: "Up vs down",
        value: ratio,
        unit: "\xd7",
        precision: 2,
        informational: true,
        note: $0a9253dfd716f087$export$76bfef5403468154(ratio, thresholds.tempoEvenBand),
        pass: null
    };
}
function $0a9253dfd716f087$export$76bfef5403468154(ratio, evenBand = 0.1) {
    if (ratio == null) return null;
    if (ratio >= 1 + evenBand) return "Up faster";
    if (ratio <= 1 - evenBand) return "Down faster";
    return "Even";
}


const $0a6425a5afc29eb8$export$f947eafee843b553 = {
    id: "arm_swing",
    name: "Arm swing",
    /** One line in the menu: what the body does, not what is measured. */ blurb: "Full circles, on the toes, knees bent",
    /**
   * Every criterion is a sagittal-plane measurement, so from the front they are
   * either invisible or meaningless. Picking the exercise sets the view.
   */ view: "side",
    /**
   * True only where the thresholds come from footage rather than judgement. It
   * is shown in the menu and printed on the receipt, because a number scored
   * against a guessed threshold looks exactly like one scored against a
   * measured threshold.
   */ calibrated: true,
    /** Thresholds the criteria read, by their key in `STATE.posture`. */ thresholdKeys: [
        "tiptoeMin",
        "kneeFlexMax",
        "trunkRockMax",
        "aheadOfKneeMax",
        "neckOffset",
        "neckTolerance",
        "tempoEvenBand",
        "swingSpeedMin"
    ],
    /**
   * Imperative and short, because it is read mid-rep from across a room — not a
   * restatement of the measurement. "Head level" rather than "eyes forward":
   * what is measured is head pitch, and where the athlete is looking is not
   * something the landmarks can report.
   */ cues: {
        tiptoe: "Up on your toes",
        knee_flex: "Bend your knees",
        trunk_steady: "Tighten your core",
        head_back: "Head back",
        chest_back: "Chest back",
        neck_neutral: "Head level",
        swing_speed: "Swing faster"
    },
    /**
   * The tiptoe criterion is normalised by foot length measured over the whole
   * session, so the loop has to keep that scale; see index.js.
   */ needsFootScale: true,
    createCounter: (thresholds)=>new (0, $1afed4526f0605fd$export$ab99ef5b8e65ee0c)(thresholds),
    scoreRep: (samples, { side: side, thresholds: thresholds, footScale: footScale })=>[
            ...(0, $351c2b07e0ef1e12$export$d497432b8c9e33de)(samples, thresholds, footScale),
            (0, $0a9253dfd716f087$export$ac8ee1f4019d35eb)(samples, side, thresholds),
            // Last because it is the only row that judges nothing: it reports which way
            // the swing leans and never fails a rep.
            (0, $0a9253dfd716f087$export$d65e673853f36884)(samples, side, thresholds)
        ]
};


/**
 * Squat jump. Counting is measured off real footage; the criteria are not.
 *
 * It counts with the generic oscillation counter rather than the revolution
 * accumulator — the knee leaves a standing value, closes into the
 * counter-movement and opens again — and its criteria read the legs that the
 * swing's counter deliberately ignores. If a second exercise could be expressed
 * without touching the geometry, the sample, the readout or the receipt, the
 * exercise layer would not be worth having.
 *
 * Three things this drill taught, all off the take in
 * `fixtures/squat_jump/`; `docs/squat-jump.md` records the numbers.
 *
 * **The knee does not lock out between jumps.** At a 1.5s cadence the athlete
 * came back to 154-162 degrees and no further, so a counter asking for 160 — a
 * reasonable figure for a squat, and what this file asked for when it was one —
 * merged five of the ten gaps and counted 6 reps against 11 performed. The
 * threshold is 145 for that reason, which still leaves 40 degrees between it and
 * the bottom of the movement, far outside the 1-3 degree noise floor.
 *
 * **Heels down is a squat's criterion, not a jump's.** It failed all 11 reps at
 * 0.82-0.92 foot lengths, which is the push-off doing exactly what it should.
 * A jump wants the opposite, so what is checked is that the ankle extended.
 *
 * **The foot in the air is not measurable either, and that one was tested.**
 * The athlete asked for pointed toes, so this file judged the ankle extension
 * and called the row "Toes". Three takes say it cannot: a take performed with
 * the feet deliberately pulled towards the shin — the caricature of the fault,
 * filmed to settle this — reads 132-137 degrees of ankle angle in the air where
 * the good take reads 126-133. It moves the WRONG way, and the same holds on
 * the raw landmarks, so smoothing is not the cause. Within any one take the
 * spread is about 5 degrees while takes differ by 10, which is a measurement
 * reporting the camera and the pose prior rather than the foot; MediaPipe
 * reports 0.97-0.98 visibility on those landmarks throughout, which is what a
 * guess looks like from here. The push-off is real and physical, and it is what
 * the airborne window is built from, so the row stays as `informational` and is
 * labelled "Push-off". No cue claims anything about the toes.
 *
 * **Jump height is not measurable here.** `worldLandmarks` are hip-centred, so
 * the origin rises with the athlete and a body leaving the floor is the one
 * thing the coordinates cannot show. Ankle extension at the push is a proxy for
 * the effort, not a height, and is labelled as such.
 *
 * Geometry note: both criteria are sagittal, so this is a side-on drill like the
 * swing. Depth read from the front is foreshortened by however the athlete is
 * turned, which measures the camera angle rather than the squat.
 *
 * `calibrated: true` as of the four takes above, which is what the protocol in
 * `fixtures/README.md` asks for: a clean set, a set of deliberate faults, and
 * every surviving criterion shown both to pass the first and to catch something
 * in the second. One criterion did not survive it, which is the protocol
 * working rather than a reason to hold the flag back. What the flag does NOT
 * claim is a coaching standard: these are one athlete on one day, the thinnest
 * margin is `jumpLegsMin` at 4 degrees under his weakest clean rep, and
 * `docs/squat-jump.md` records every one of them.
 */ /**
 * Counts reps of a movement that goes down and comes back, rather than one that
 * revolves.
 *
 * This is the other half of the rep-counting problem. `metrics/revolutions.js`
 * accumulates the signed arm angle, which is right for the swing and wrong for
 * everything else: a squat, a press, a hinge or a push-up never revolve, so
 * their accumulated angle sums to zero over a rep and the counter would never
 * fire. What they do instead is leave a resting value, reach an extreme, and
 * come back, so what counts them is a threshold crossed in both directions.
 *
 * Two thresholds rather than one, because a single one counts the noise. The
 * knee angle wanders a degree or two at the bottom of a squat, and a counter
 * watching one line would score every wobble across it as another rep. With a
 * gap between the two lines the signal has to travel the whole way back before
 * it can count again, which is the standard way out and costs nothing: the gap
 * is wider than the noise floor by construction.
 *
 * The rep boundary is the TOP, not the bottom. A rep that starts at the top
 * carries its whole descent, which is the half the posture criteria mostly read,
 * and it is also where the athlete is standing still, so the boundary does not
 * land in the middle of fast movement.
 *
 * `tailMs` exists because that boundary cuts an explosive movement in the wrong
 * place. `high` has to sit below a locked joint for a jump to count at all —
 * the athlete does not lock out between reps — so the rep closes partway up the
 * push, and the extension at the top of the jump, which is the part worth
 * judging, falls outside the window. With a tail the counter keeps collecting
 * past the crossing until the signal falls back below `high` or the tail runs
 * out, so the rep carries its own flight. The cap is what makes the last rep of
 * a set arrive: the athlete then stands there with the knee above `high`, and
 * without it the signal never comes back down and the rep never closes.
 */ class $d6c66893ba1d8e22$export$3468a5dd9b5297bf {
    /**
   * @param options.signal Reads the scalar being watched out of a sample, given
   *   the near side. Degrees, metres, anything monotonic in the movement.
   * @param options.low The signal has to go below this for the rep to be under
   *   way: the depth that makes it a rep rather than a twitch.
   * @param options.high And back above this to close it. Must sit clear of
   *   `low` by more than the signal's noise.
   * @param options.visibility Reads the visibility that gates the frame, the way
   *   `RepCounter` gates on arm and trunk: a landmark the model is guessing at
   *   can cross a threshold on its own.
   * @param options.minVisibility Frames below this are refused outright.
   * @param options.maxGapMs A longer gap between frames abandons the rep in
   *   progress rather than bridging it, since the movement may have completed
   *   unobserved.
   * @param options.tailMs Keep collecting for up to this long after the signal
   *   crosses `high`, so a rep carries what happens past the crossing. 0, the
   *   default, closes on the crossing itself.
   * @param options.accept Optional last word on whether a closed rep was really
   *   a rep, given its samples and the side. The signal alone cannot always
   *   tell: a knee bending on the floor traces the same curve as a knee bending
   *   to jump, so the squat jump asks for flight in the samples before counting
   *   one. A rejected rep is not counted, not scored and not reported — the
   *   athlete settling himself between reps should cost nothing — which is only
   *   safe because what it rejects is a movement the drill does not claim to
   *   judge, rather than a rep performed badly.
   */ constructor({ signal: signal, low: low, high: high, visibility: visibility, minVisibility: minVisibility = 0.5, maxGapMs: maxGapMs = 250, tailMs: tailMs = 0, accept: accept = null }){
        this.signal = signal;
        this.low = low;
        this.high = high;
        this.visibility = visibility;
        this.minVisibility = minVisibility;
        this.maxGapMs = maxGapMs;
        this.tailMs = tailMs;
        this.accept = accept;
        this.reset();
    }
    reset() {
        this.count = 0;
        /** The most recent usable reading, for the progress bar. */ this.value = null;
        /** "waiting" until the signal has been seen up top at least once, then
     *  "top" between reps, "down" once it has gone below `low`, and "tail"
     *  while a closed rep is still collecting its flight. */ this.phase = "waiting";
        this.last = null;
        this.current = [];
        this.lastRep = null;
        /** When the signal crossed `high`, while the tail is being collected. */ this.crossedAt = null;
        /** Movements that closed but `accept` turned down, for the record. */ this.rejected = 0;
    }
    /**
   * Feeds one sample in. Returns the completed rep's samples when this sample
   * closed one, otherwise null. Same contract as `RepCounter.push`, so the
   * caller does not care which counter an exercise uses.
   */ push(sample, side) {
        if (this.visibility(sample, side) < this.minVisibility) {
            this.break();
            return null;
        }
        const value = this.signal(sample, side);
        if (!Number.isFinite(value)) {
            this.break();
            return null;
        }
        if (this.last != null && sample.t - this.last > this.maxGapMs) this.break();
        this.last = sample.t;
        this.lastSide = side;
        this.value = value;
        this.current.push(sample);
        if (this.phase === "waiting") {
            // Only ever armed from the top, so a take that begins with the athlete
            // already at the bottom does not count the way up as a whole rep.
            if (value >= this.high) {
                this.phase = "top";
                this.current = [
                    sample
                ];
            }
            return null;
        }
        if (this.phase === "top") {
            if (value <= this.low) this.phase = "down";
            else // Still standing: hold the boundary at the last frame up top rather
            // than banking however long the athlete stood there.
            this.current = [
                sample
            ];
            return null;
        }
        if (this.phase === "tail") {
            // The extension is over once the signal falls back below the line it
            // crossed, and the cap ends a tail that never does — the last rep of a
            // set, where the athlete simply stands there above `high`.
            if (value >= this.high && sample.t - this.crossedAt < this.tailMs) return null;
            return this.closeRep(sample, value);
        }
        if (value < this.high) return null;
        if (this.tailMs > 0) {
            this.phase = "tail";
            this.crossedAt = sample.t;
            return null;
        }
        return this.closeRep(sample, value);
    }
    /**
   * Banks the rep in progress. The closing sample starts the next one, except
   * when a tail has already carried the signal back down past `high`: the
   * athlete is then on the way into the next rep rather than standing at the
   * top, and holding the boundary at this frame would drop the beginning of
   * that descent.
   */ closeRep(sample, value) {
        const closed = this.current;
        this.crossedAt = null;
        this.phase = value <= this.low ? "down" : "top";
        this.current = [
            sample
        ];
        if (this.accept != null && !this.accept(closed, this.lastSide)) {
            this.rejected += 1;
            return null;
        }
        this.count += 1;
        this.lastRep = closed;
        return this.lastRep;
    }
    /** The side the last sample was read on, for `flush`. */ get side() {
        return this.lastSide;
    }
    /**
   * Closes a rep that is still collecting its tail, and returns its samples.
   *
   * The tail waits either for the signal to come back down or for its cap to
   * run out, and both need frames that stop arriving the moment a set ends. The
   * athlete pressing Stop right after their last jump would otherwise lose that
   * rep from the count and from the ticket, which is the one thing a rep
   * counter must not do. Returns null when there is nothing waiting, so the
   * caller can flush unconditionally at the end of a set.
   */ flush() {
        if (this.phase !== "tail") return null;
        const last = this.current[this.current.length - 1];
        return this.closeRep(last, this.signal(last, this.side) ?? this.value);
    }
    /** Abandons the rep in progress, keeping the count so far. */ break() {
        this.phase = "waiting";
        this.value = null;
        this.last = null;
        this.current = [];
        this.crossedAt = null;
    }
    /**
   * How far through the current rep, 0 to 1.
   *
   * Half the bar for the way down and half for the way back, so it fills once
   * per rep rather than twice, and it is read off the current depth rather than
   * the deepest frame so that it tracks the athlete coming back up.
   */ get progress() {
        if (this.value == null || this.phase === "waiting") return 0;
        const span = this.high - this.low;
        if (span <= 0) return this.phase === "down" ? 0.5 : 0;
        const height = Math.min(1, Math.max(0, (this.value - this.low) / span));
        // A tail is the end of a rep, not the start of the next one, so the bar
        // stays full through it rather than snapping back to empty mid-flight.
        if (this.phase === "tail") return 1;
        return this.phase === "down" ? 0.5 + 0.5 * height : 0.5 * (1 - height);
    }
}



function $bcb64f06a285175f$var$median(values) {
    if (values.length === 0) return null;
    const sorted = [
        ...values
    ].sort((a, b)=>a - b);
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
}
function $bcb64f06a285175f$export$d1af52cc5b48d381(samples, side, thresholds, scale = null) {
    const foot = scale || (0, $351c2b07e0ef1e12$export$f608706c6ebdbcc3)(samples, side);
    const knees = samples.map((s)=>s.knee[side]);
    const deepest = Math.min(...knees);
    // The jump is everything after the bottom. Measuring over the whole rep would
    // read the extension criteria off the descent, where the body is folded on
    // purpose and every one of them would fail.
    const flight = samples.slice(knees.indexOf(deepest));
    const toeRatios = flight.map((s)=>foot > 0 ? s.heelLift[side] / foot : null);
    const takeOff = toeRatios.indexOf(Math.max(...toeRatios));
    const air = [];
    for(let i = takeOff; i < flight.length; i += 1){
        if (!(toeRatios[i] > thresholds.jumpAirToes)) break;
        air.push(flight[i]);
    }
    return {
        air: air,
        airMs: air.length > 0 ? air[air.length - 1].t - air[0].t : 0,
        flight: flight,
        knees: knees,
        deepest: deepest,
        foot: foot,
        peakToes: Math.max(...flight.map((s)=>s.heelLift[side]))
    };
}
const $bcb64f06a285175f$export$1cb722a15a243c7a = {
    id: "squat_jump",
    name: "Squat jump",
    blurb: "Load, then stretch out in the air",
    view: "side",
    calibrated: true,
    thresholdKeys: [
        "jumpKneeDown",
        "jumpKneeUp",
        "jumpFlightMs",
        "jumpDepthMax",
        "jumpLegsMin",
        "jumpHipsMin",
        "jumpAirToes",
        "jumpAirMinMs",
        "jumpTrunkMax",
        "jumpArmSwingMin",
        "neckOffset",
        "neckTolerance"
    ],
    cues: {
        jump_depth: "Load deeper",
        jump_legs: "Straighten your legs",
        jump_hips: "Open your hips",
        jump_trunk: "Stand tall in the air",
        jump_arms: "Swing your arms back",
        // "Head level" rather than anything about where to look: gaze is not
        // something the landmarks report.
        jump_head: "Head level"
    },
    needsFootScale: true,
    /**
   * Knee angle is the signal: near 180 standing, closing into the
   * counter-movement and opening through the jump. The two thresholds stay far
   * apart — below `jumpKneeDown`, then back above `jumpKneeUp` — so no wobble at
   * either end counts twice, but `jumpKneeUp` sits below a locked knee because
   * at speed the athlete never reaches one.
   *
   * The tail is what makes the flight part of the rep. `jumpKneeUp` has to sit
   * partway up the push for the rep to count at all, so without it the window
   * would close before the body finished extending and every criterion below
   * would be reading the push rather than the jump.
   */ createCounter: (thresholds, { footScale: sessionScale = ()=>null } = {})=>new (0, $d6c66893ba1d8e22$export$3468a5dd9b5297bf)({
            signal: (sample, side)=>sample.knee[side],
            low: thresholds.jumpKneeDown,
            high: thresholds.jumpKneeUp,
            tailMs: thresholds.jumpFlightMs,
            // The legs ARE the movement here, so unlike the swing the counter cannot
            // run on a take framed from the knees up: a knee the model is guessing at
            // crosses both thresholds on its own. On the reference take this is what
            // keeps the walk-in and the walk-out from counting as reps.
            visibility: (sample, side)=>sample.legVisibility[side],
            minVisibility: thresholds.minVisibility,
            maxGapMs: thresholds.maxGapMs,
            // A jump is the feet leaving the floor, and the knee alone cannot say
            // whether they did. Bending the knees on the floor traces the same curve,
            // so an athlete settling himself between jumps — stepping back into
            // position, shaking out a leg — was counted as an attempt and told it was
            // a bad one. What makes it a rep is that it had flight in it.
            //
            // This is also why resting mid-set now costs nothing: a set is the reps
            // performed in it, not the time between them, and a drill this heavy is
            // one people stop in the middle of.
            accept: (samples, side)=>$bcb64f06a285175f$export$d1af52cc5b48d381(samples, side, thresholds, sessionScale()).airMs >= thresholds.jumpAirMinMs
        }),
    scoreRep: (samples, { side: side, thresholds: thresholds, footScale: scale })=>{
        if (samples.length === 0) return [];
        const legsSeen = $bcb64f06a285175f$var$median(samples.map((s)=>s.legVisibility[side])) >= thresholds.minVisibility;
        const { air: air, airMs: airMs, flight: flight, knees: knees, deepest: lowest, foot: foot, peakToes: peakToes } = $bcb64f06a285175f$export$d1af52cc5b48d381(samples, side, thresholds, scale);
        const deepest = legsSeen ? lowest : null;
        // A rep the counter accepted always has flight in it, but `scoreRep` is
        // also called straight from a script against arbitrary samples, so the
        // criteria below still report unjudged rather than grading a body that
        // never left the floor.
        const airborne = legsSeen && foot > 0 && airMs >= thresholds.jumpAirMinMs ? air : null;
        // Each figure is taken at its own best moment within that window rather
        // than all at one frame. The three do not peak together in this data — the
        // ankle extends hardest at take-off and the knee reads its maximum a third
        // of a second later, which is mostly the smoothing filter's lag rather than
        // the athlete — and a single frame would charge each criterion for the
        // others' timing. What this does NOT check is that the shape happened all
        // at once, which is what a diver is actually after; see docs/squat-jump.md.
        const peakKnee = airborne == null ? null : Math.max(...airborne.map((s)=>s.knee[side]));
        // The hip is the other half of "not extended", and on that same take it is
        // the half that showed: 114-167 in the air against 163-178 clean, where the
        // knee overlapped. Measured separately from the knee so the cue can name
        // the joint that folded.
        const hips = airborne == null ? [] : airborne.map((s)=>s.hip[side]).filter((v)=>Number.isFinite(v));
        const peakHip = hips.length > 0 ? Math.max(...hips) : null;
        const tallest = airborne == null ? null : Math.min(...airborne.map((s)=>Math.abs(s.trunkTilt)));
        const toes = legsSeen && foot > 0 ? peakToes / foot : null;
        // Typical rather than worst, the way the swing reads it: the head moves
        // through a jump and one frame of it dipping is not a fault. Deviation from
        // the athlete's own neutral, so positive is chin down. Frames with no
        // reading are dropped rather than sorted among the numbers, and a flight
        // with none left reports unjudged instead of a fault.
        const pitches = flight.map((s)=>s.headPitch == null ? null : s.headPitch[side]).filter((v)=>Number.isFinite(v));
        const headPitch = $bcb64f06a285175f$var$median(pitches);
        const head = headPitch == null ? null : headPitch - thresholds.neckOffset;
        // The arms, which travel the opposite way to the body: forward and down
        // into the load, back and up through the jump. Measured as how far the arm
        // swings BACK between those two moments rather than as where it ends up,
        // because the movement is what the athlete was asked for and because an end
        // position would also depend on how he carries his arms at rest.
        //
        // Signed, so forward has to be known: `armAngle` is positive toward +x and
        // the athlete may face either way, hence the facing sign. On the good take
        // the arm sits 76-103 degrees forward at the bottom and reaches 65-73
        // behind in the air, a travel of 145-172. On the take where the arms were
        // left out of it, -99 to 144.
        const armsSeen = $bcb64f06a285175f$var$median(samples.map((s)=>s.visibility[side])) >= thresholds.minVisibility;
        const facing = (0, $351c2b07e0ef1e12$export$e6b68ffc01162663)(samples, side);
        const forwardArm = (sample)=>sample.armAngle == null ? null : facing * sample.armAngle[side];
        const armAtBottom = forwardArm(samples[knees.indexOf(Math.min(...knees))]);
        const airArms = airborne == null ? [] : airborne.map(forwardArm).filter((v)=>Number.isFinite(v));
        const armBackInAir = airArms.length > 0 ? Math.min(...airArms) : null;
        const armSwing = !armsSeen || armBackInAir == null || !Number.isFinite(armAtBottom) ? null : armAtBottom - armBackInAir;
        // How long the ankle stayed extended, which is the closest these landmarks
        // come to air time and is NOT the same measurement. The ankle extends before
        // the foot leaves the floor and relaxes after it lands, so the figure runs
        // long: 0.50-0.60s on the good take where a jump of that depth physically
        // produces nearer 0.40-0.50s. Informational for that reason — a threshold
        // would be judging the measurement's own bias — and never called a height,
        // which hip-centred landmarks cannot give at all.
        const airSeconds = airborne == null ? null : airMs / 1000;
        return [
            {
                id: "jump_depth",
                label: "Load",
                value: deepest,
                unit: "\xb0",
                precision: 0,
                pass: deepest == null ? null : deepest <= thresholds.jumpDepthMax
            },
            {
                id: "jump_legs",
                label: "Legs",
                value: peakKnee,
                unit: "\xb0",
                precision: 0,
                pass: peakKnee == null ? null : peakKnee >= thresholds.jumpLegsMin
            },
            {
                // Shoulder-hip-knee: 180 is a straight line from shoulder to knee, and
                // it closes as the athlete pikes. The separate trunk row below reads
                // the trunk against gravity, which is a different question — a body can
                // be upright and still folded at the waist.
                id: "jump_hips",
                label: "Hips",
                value: peakHip,
                unit: "\xb0",
                precision: 0,
                pass: peakHip == null ? null : peakHip >= thresholds.jumpHipsMin
            },
            {
                id: "jump_trunk",
                label: "Body",
                value: tallest,
                unit: "\xb0",
                precision: 1,
                pass: tallest == null ? null : tallest <= thresholds.jumpTrunkMax
            },
            {
                // The ankle at its most extended over the flight, in foot lengths. This
                // is the push-off and nothing else, so it reports and never judges: see
                // "The foot in the air is not measurable" above. Not a jump height
                // either.
                id: "jump_toes",
                label: "Push-off",
                value: toes,
                unit: "\u00d7foot",
                precision: 2,
                informational: true,
                note: "takeoff",
                pass: null
            },
            {
                // Forward at the bottom, back in the air. The arm is the one part of
                // this drill that is NOT asked to extend, so it gets its own row rather
                // than being folded into the body's shape.
                id: "jump_arms",
                label: "Arms",
                value: armSwing,
                unit: "\xb0",
                precision: 0,
                pass: armSwing == null ? null : armSwing >= thresholds.jumpArmSwingMin
            },
            {
                // Looking at the floor is a fault the athlete named, and this is the
                // signal the swing already judges, on the same athlete's own neutral.
                // It shares `neckOffset` and `neckTolerance` rather than taking a
                // parallel pair: a neck's anatomy does not change between drills, and
                // two knobs for one zero would drift apart.
                //
                // Read as a median over the flight, not a worst frame. Within a single
                // jump the raw figure moves through 40-57 degrees — the head travels,
                // and the face landmarks are a few pixels across at the resolution a
                // phone records — so a worst-frame reading would be noise. The medians
                // sit at -7 to +8 across the reference take against a 15-degree
                // tolerance, which is what makes it judgeable at all.
                id: "jump_head",
                label: "Head",
                value: head,
                unit: "\xb0",
                precision: 0,
                pass: head == null ? null : Math.abs(head) <= thresholds.neckTolerance
            },
            {
                // Reports without judging, the way the swing's up/down ratio does: the
                // figure is honest about the athlete's effort and dishonest as an
                // absolute, since it measures the ankle rather than the floor. `pass`
                // stays null and `informational` keeps it out of the cues and the
                // tally; `aggregate` is what puts the set's total on the receipt, which
                // is the form the athlete asked for it in.
                id: "jump_air",
                label: "Air",
                value: airSeconds,
                unit: "s",
                precision: 2,
                informational: true,
                aggregate: "sum",
                // Ten steps of the bar at 0.55s each, so a set of ten good jumps fills
                // it on the last one or two: the good take totals 5.8s over eleven reps.
                // A bar that fills on rep three is not a reward.
                bonusStep: 0.55,
                note: "approx",
                pass: null
            }
        ];
    },
    /** Only the window metrics that mean anything here; see exercises/index.js. */ metricIds: [
        "trunk_rock"
    ]
};


/**
 * V-sit. Its four thresholds were **measured** off the take of 2026-10-13 —
 * shallow folds, bent knees, clean reps and lying leg raises, five of each in
 * one recording — and all four moved because of it. It still ships
 * `calibrated: false`, and for something that is not a threshold: the counter
 * also counts the athlete settling into position and getting up again, two
 * folds in that take that nothing in this signal tells apart from a rep.
 * See docs/v-sit.md.
 *
 * Lying on the back, the trunk and the legs rise to meet in a V and come back
 * down. So the signal is the hip angle — shoulder-hip-knee, 180 flat, closing as
 * the body folds — counted with the oscillation counter the same way a squat's
 * knee is.
 *
 * **The hip angle is what counts a rep, and it is not enough to judge one.**
 * Shoulder-hip-knee closes exactly as well when the legs come up to a trunk that
 * stayed on the floor, so a lying leg raise scored a clean V-sit until the
 * athlete reported it. The two are kept apart the way the handstand keeps being
 * inverted apart from being in line: the hip says an attempt happened, and a
 * criterion of its own says the trunk came up too. The rep is still counted and
 * cued rather than rejected — a leg raise performed where a V-sit was asked for
 * is a rep done wrong, and the athlete has to be told which thing was wrong.
 *
 * Two things are specific to doing this on the floor with the phone propped up,
 * and both cost a rep if they are got wrong:
 *
 * - **The ankles are the landmarks most often lost.** Lying down they are the
 *   furthest from the camera, they leave the frame first, and on the floor they
 *   are often behind the near leg. So this gates on shoulder, hip and knee —
 *   `foldVisibility` — rather than on the leg chain the squat uses, which starts
 *   at the knee and runs down to the heel.
 * - **Coming back down is half the rep, and it is the counter that enforces it,
 *   not a criterion.** A rep closes only when the hip angle returns above
 *   `vSitHipUp`, which is set at a full extension, so a bounced rep that never
 *   unfolds is not counted at all rather than counted and failed. A "came back
 *   down" criterion was written first and removed: a rep's samples end at the
 *   frame that closed it, so the furthest the hip opened within the rep IS the
 *   threshold, and the criterion could only ever restate it. It passed by
 *   construction or failed by construction depending on where the number was put,
 *   which is worse than not measuring it.
 */ 
const $a7a5e1d03f929104$export$6a99a18a913cbcda = {
    id: "v_sit",
    name: "V-sit",
    blurb: "Lie flat, fold to a V, come all the way back",
    /**
   * Side-on, like the other two. The fold happens in the sagittal plane, and
   * from the front or from the feet it is along the axis the geometry drops —
   * the z MediaPipe is weakly supervised on, which is the whole reason the
   * metrics are a projection. Camera at the athlete's side, on the floor.
   */ view: "side",
    calibrated: false,
    thresholdKeys: [
        "vSitHipDown",
        "vSitHipUp",
        "vSitFoldMax",
        "vSitKneeMin",
        "vSitTrunkRise"
    ],
    cues: {
        v_sit_fold: "Fold tighter",
        v_sit_knees: "Straighten your legs",
        v_sit_trunk: "Lift your chest too"
    },
    needsFootScale: false,
    createCounter: (thresholds)=>new (0, $d6c66893ba1d8e22$export$3468a5dd9b5297bf)({
            signal: (sample, side)=>sample.hip[side],
            low: thresholds.vSitHipDown,
            high: thresholds.vSitHipUp,
            visibility: (sample, side)=>sample.foldVisibility[side],
            minVisibility: thresholds.minVisibility,
            maxGapMs: thresholds.maxGapMs
        }),
    scoreRep: (samples, { side: side, thresholds: thresholds })=>{
        if (samples.length === 0) return [];
        const seen = Math.min(...samples.map((s)=>s.foldVisibility[side])) >= thresholds.minVisibility;
        const tightest = Math.min(...samples.map((s)=>s.hip[side]));
        // The straightest the knee got while the body was folded, not over the whole
        // rep: the legs bend on the way down and that is not the fault being looked
        // for. Taken over the frames at or near the top of the fold.
        //
        // A shallow rep has no such frames, and that is NOT a reason to abstain. A
        // fold that passed `vSitHipDown` but never reached `vSitFoldMax` is a rep
        // the athlete performed badly, and a null knee on it would print "not fully
        // seen" — which tells them to move the phone when what was wrong was the
        // fold. So the window falls back to the frames that made it a rep at all,
        // which is non-empty by construction: the counter only closed a rep because
        // the hip went below `vSitHipDown`. Null here stays reserved for landmarks
        // the model was guessing at.
        const tight = samples.filter((s)=>s.hip[side] <= thresholds.vSitFoldMax);
        const folded = tight.length > 0 ? tight : samples.filter((s)=>s.hip[side] <= thresholds.vSitHipDown);
        const knee = seen && folded.length > 0 ? Math.max(...folded.map((s)=>s.knee[side])) : null;
        // How far the trunk came off the floor within this rep. `trunkTilt` is
        // signed off world vertical, so lying flat reads near 90 either way and
        // sitting up reads near 0; the magnitude subtracted from 90 is elevation off
        // the floor, 0 flat. Read as a rise from the rep's own flattest frame rather
        // than as an absolute angle, because the floor is not a landmark and the
        // phone is propped on it: a tilted phone shifts both ends equally and the
        // difference survives it.
        const elevation = samples.map((s)=>90 - Math.abs(s.trunkTilt));
        const rise = Math.max(...elevation) - Math.min(...elevation);
        return [
            {
                id: "v_sit_fold",
                label: "Fold",
                value: seen ? tightest : null,
                unit: "\xb0",
                precision: 0,
                pass: seen ? tightest <= thresholds.vSitFoldMax : null
            },
            {
                id: "v_sit_knees",
                label: "Legs straight",
                value: knee,
                unit: "\xb0",
                precision: 0,
                pass: knee == null ? null : knee >= thresholds.vSitKneeMin
            },
            {
                id: "v_sit_trunk",
                label: "Chest up",
                value: seen ? rise : null,
                unit: "\xb0",
                precision: 0,
                pass: seen ? rise >= thresholds.vSitTrunkRise : null
            }
        ];
    },
    metricIds: []
};


/**
 * Wall handstand hold. **Still uncalibrated**, but no longer blind: one take
 * exists and it answered the question this drill had that the others did not.
 *
 * MediaPipe's pose model is trained overwhelmingly on people the right way up,
 * so until there was footage, nothing here was known to measure anything at all.
 * There is now (`fixtures/wall_handstand/`), and the model tracks an inverted
 * body cleanly: 0.97-0.98 visibility along the whole chain through a 46-second
 * hold, the ankle above the shoulder in 3091 of 3098 inverted frames, and
 * `trunkTilt` reaching 172-180 as the drill assumes.
 *
 * What one take cannot do is calibrate seven thresholds. It calibrated two,
 * because it contained a fault performed on purpose: the head criterion below,
 * which that fault was, and the knee, which the take showed failing a straight
 * leg. The rest are still a diver's line written down as angles, the drill still
 * ships `calibrated: false`, and `docs/wall-handstand.md` records what each
 * number now rests on and what is still unanswered.
 *
 * What the drill is, as asked for: a hold against a wall, filmed side-on, in a
 * diver's line — hands, shoulders, hips and feet stacked, legs and arms
 * straight. Either way round, chest to the wall or back to it.
 *
 * **Two questions per frame, kept apart.** Being upside down is what opens and
 * closes the hold; being in line is what the athlete hears about. They are
 * deliberately not the same test, because a hold that could only exist while the
 * line was good would make every criterion below pass by construction — see
 * `exercises/hold.js` and the V-sit's note in `docs/exercises.md`.
 *
 * **The line is the hip and the knee judged apart, not one angle through the
 * whole body.** Shoulder-hip-ankle was written first and is worse: bending a
 * knee moves the ankle, so one fault failed two criteria and the athlete was
 * told to stack his hips about his knees. Shoulder-hip-knee isolates the fold at
 * the hip, the knee angle isolates the leg, and a body straight at both IS the
 * line — there is nothing left for a third angle to catch. What the projection
 * cannot tell is a pike from an arch: both leave the line on the same axis, so
 * the cue says "Stack your hips" rather than naming a direction it did not
 * measure.
 *
 * **The wall is found without being seen, because the feet are on it.** There is
 * no wall in the landmarks, but a wall handstand rests its feet against one, so
 * the horizontal gap between the wrist and the ankle IS how far the hands sit
 * out from the wall. That is the distance the athlete wants under 30cm, and the
 * same measurement read for its sign says which way round he is: the body leans
 * the way the wall is, and which way he faces (`facingOffset`) says whether that
 * side is his chest or his back. The distance is judged; the side is only a
 * label on the row, because a wrong guess at it costs a word and a straight line
 * is a straight line either way round.
 *
 * Two things to hold against that number. It is a projection, so it is the gap
 * along the camera's x rather than along the floor, which is the same thing only
 * while the camera is square to the wall. And `worldLandmarks` are metres by
 * estimate rather than by measurement, so 30cm here is 30cm as MediaPipe reckons
 * it. Both are reasons the row prints its figure rather than only a verdict, and
 * reasons to put a tape next to it on the first take.
 *
 * **The distance makes no sound.** It is set before the athlete goes up and
 * cannot be changed while he is inverted, so announcing it mid-hold would be
 * telling him about something he can only act on once he comes down. It is on
 * the readout and on the ticket, which is where a setup fault belongs.
 *
 * **The ankle angle does not track the foot, and the row no longer claims to.**
 * The athlete asked for pointed feet, so this started as a criterion — the
 * knee-ankle-toe angle, 180 being the foot continuing the shin, rather than the
 * squat jump's heel height, which means nothing with no floor under the foot. It
 * was never wired to the sound, because this app had already had one criterion
 * on exactly this joint turn out to be reading the camera rather than the body
 * (the jump's "Push-off"). A take then retired it here too, and by the cleanest
 * test available: the athlete flexed his feet deliberately and corrected them
 * **within one hold**, which removes between-take variability altogether. The
 * ankle angle does not step. Its one-second medians wander between 149 and 168
 * with no regime, and the best single split point anywhere in a 34 second hold
 * separates the two halves by 3.2 degrees — at the noise floor, and in the
 * direction that says correcting the feet made them worse. Identical on the raw
 * landmarks, with the foot landmarks reporting 0.93-0.97 visibility throughout.
 *
 * So the row is `informational` with `pass` permanently null, labelled `Ankle`
 * for the angle it computes and noted as not being toe point, and it has no cue.
 * That is the squat jump's resolution applied to the same joint a second time.
 * Two drills, one upright and one inverted, on the same phone at a similar
 * distance, both say MediaPipe's foot landmarks do not follow the foot here; see
 * AGENTS.md. Pointed toes are not currently measurable in this app, and a row
 * that said otherwise would be the one failure mode a coaching app cannot
 * afford — telling an athlete he is wrong about something nobody measured.
 *
 * **The head is judged on which side of the arm it is, not how far.** The
 * athlete asked for the ears between the arms, and `earOffArmLine` is an angle
 * at the shoulder between the arm and the ear whose SIGN is the whole signal.
 * The magnitude separates nothing: on the reference take a good hold reads 8
 * degrees off the arm line at one moment and 28 at another, and a deliberately
 * broken one reads 7. The sign flips exactly where the posture breaks — clean
 * -8 to -28, broken +10 to +47 — which is why this is the one criterion on the
 * drill with a fault take behind it and the one that is wired to the sound.
 *
 * **Positive is the ear BEHIND the arms**, away from the way the athlete faces,
 * which is the direction the fault actually went: on the reference take the
 * broken stretches put the ear 3.6-7.4cm to the back of where a clean hold put
 * it, and pulled it 2.6cm closer to the shoulder with it. That is a head thrown
 * back, which is what letting it out of the line looks like. It was worth
 * measuring rather than assuming, because the obvious guess — the head dropping
 * forward towards the chest — is the other sign entirely.
 *
 * Its sign is only meaningful once the facing is applied, and the facing is a
 * property of the take rather than of the frame — the same reason `aheadOfKnee`
 * takes it as an argument. Here it has to be read per frame anyway, because the
 * sound is per frame, so instead the facing gets a floor: below
 * `handstandFacingMin` of nose-to-ear offset the head is reported unjudged
 * rather than guessed, since a facing read backwards would invert the criterion
 * and tell an athlete he is wrong while he holds a good handstand. On the
 * reference take that offset never fell below 4.7cm and never changed sign
 * across 2777 frames, which is what makes reading it per frame defensible.
 *
 * **`headPitchFromTrunk` is still not used.** It is measured against
 * `neckOffset`, pinned from a still of this athlete standing up, and upside down
 * that offset is not known to mean anything. The ear against the arm needs no
 * constant.
 */ /**
 * Counts a position held, rather than a movement repeated.
 *
 * The third shape of drill in this app, and the first that is not a rep at all.
 * `metrics/revolutions.js` counts a signal that goes round;
 * `exercises/oscillation.js` counts one that leaves a resting value and comes
 * back. A handstand does neither: the athlete arrives somewhere and stays, and
 * what is worth counting is the time.
 *
 * Two different questions are being asked of each frame, and keeping them apart
 * is what makes this honest:
 *
 * - **`holding` — is the hold under way at all?** For the handstand that is
 *   simply being upside down. It is what opens and closes a hold, so it is the
 *   only thing the counter enforces.
 * - **`inLine` — is the posture right *now*?** That is what the athlete hears
 *   about and what the seconds are counted against, and it is deliberately NOT
 *   what opens the hold. If a hold could only exist while the posture was good,
 *   every criterion scored afterwards would pass by construction — the V-sit
 *   taught this app that lesson (see `docs/exercises.md`) and a hold is where it
 *   is easiest to get wrong, because the position and the quality of it look
 *   like the same measurement.
 *
 * **The state is settled before it is announced.** `inLine` is a threshold on a
 * continuous quantity, so at the edge it flickers from frame to frame, and every
 * flicker here is a sound in the athlete's ear. `settleMs` is the same idea as
 * the oscillation counter's two thresholds: a change has to persist before it
 * counts as a change.
 *
 * **The seconds counted are the seconds in line.** Not the time upside down: the
 * thing being trained is the shape, and a figure that grew while the athlete
 * sagged would pay for sagging, the same reason XP in this app is clean reps and
 * nothing else.
 */ class $039e2a4757468baf$export$6dfab0fa668706fb {
    /**
   * @param options.holding Whether this frame is part of a hold at all.
   * @param options.inLine Whether the posture is right on this frame.
   * @param options.visibility Reads the visibility that gates the frame.
   * @param options.minVisibility Frames below this are refused outright, and a
   *   hold in progress ends rather than bridging the gap: the athlete has gone
   *   out of frame or come down, and either way what happened is not observed.
   * @param options.maxGapMs A longer gap between frames ends the hold too.
   * @param options.minHoldMs Shorter than this was a kick-up and a fall, not a
   *   hold, and it is dropped rather than banked as a very bad one.
   * @param options.settleMs How long a change in the posture has to persist
   *   before it is announced as one.
   */ constructor({ holding: holding, inLine: inLine, visibility: visibility, minVisibility: minVisibility = 0.5, maxGapMs: maxGapMs = 250, minHoldMs: minHoldMs = 1000, settleMs: settleMs = 300 }){
        this.holding = holding;
        this.inLine = inLine;
        this.visibility = visibility;
        this.minVisibility = minVisibility;
        this.maxGapMs = maxGapMs;
        this.minHoldMs = minHoldMs;
        this.settleMs = settleMs;
        this.reset();
    }
    reset() {
        /** Holds completed and banked. */ this.count = 0;
        /** "good" or "bad" while a hold is under way, null when there is none. */ this.state = null;
        /** Seconds spent in line in the hold under way. The bar's headline figure. */ this.seconds = 0;
        this.current = [];
        this.last = null;
        this.lastSide = null;
        this.lastRep = null;
        /** Milliseconds in line in the hold under way. */ this.goodMs = 0;
        /** The previous frame's raw reading, which owns the interval after it. */ this.lastReading = null;
        /** The reading waiting to become the state, and since when. */ this.pending = null;
        this.pendingAt = null;
        /** Holds that ended before `minHoldMs`, for the record. */ this.rejected = 0;
    }
    /**
   * Feeds one sample in. Returns the samples of a hold that this frame ended,
   * otherwise null — the same contract as the other two counters, so nothing
   * downstream has to know which kind of drill it is looking at.
   */ push(sample, side) {
        this.lastSide = side;
        const gap = this.last != null && sample.t - this.last > this.maxGapMs;
        const seen = this.visibility(sample, side) >= this.minVisibility;
        this.last = sample.t;
        if (!seen || gap || !this.holding(sample, side)) return this.closeHold();
        const reading = this.inLine(sample, side) ? "good" : "bad";
        if (this.current.length === 0) this.startHold();
        else if (this.lastReading === "good") // The interval between two frames belongs to the reading the first of
        // them gave. Summed off the RAW reading rather than the settled state,
        // because `settleMs` exists to keep the sound from chattering and must
        // not also move the arithmetic: the figure the bar shows and the figure
        // the ticket prints are then the same sum over the same frames, and
        // `scoreRep` can recompute it from the samples alone.
        this.goodMs += sample.t - this.current[this.current.length - 1].t;
        this.lastReading = reading;
        this.current.push(sample);
        this.settle(reading, sample.t);
        this.seconds = this.goodMs / 1000;
        return null;
    }
    startHold() {
        this.goodMs = 0;
        this.seconds = 0;
        this.lastReading = null;
        this.pending = null;
        this.pendingAt = null;
        // A hold opens as "bad" rather than as nothing: the athlete has just kicked
        // up and is not in line yet, so the first settled reading being "good" is a
        // change, and a change is what makes the sound.
        this.state = "bad";
    }
    /** Applies `settleMs` of hysteresis to a raw reading. */ settle(reading, t) {
        if (reading === this.state) {
            this.pending = null;
            this.pendingAt = null;
            return;
        }
        if (reading !== this.pending) {
            this.pending = reading;
            this.pendingAt = t;
            return;
        }
        if (t - this.pendingAt >= this.settleMs) {
            this.state = reading;
            this.pending = null;
            this.pendingAt = null;
        }
    }
    /**
   * Banks the hold in progress, if there was one worth banking.
   *
   * A hold that never reached `minHoldMs` is dropped rather than scored: the
   * athlete kicked up and came straight back down, and calling that a bad hold
   * would put a line on the ticket for something nobody attempted to hold.
   */ closeHold() {
        if (this.current.length === 0) {
            this.state = null;
            return null;
        }
        const closed = this.current;
        const heldMs = closed[closed.length - 1].t - closed[0].t;
        this.current = [];
        this.state = null;
        this.seconds = 0;
        this.pending = null;
        this.pendingAt = null;
        if (heldMs < this.minHoldMs) {
            this.rejected += 1;
            this.goodMs = 0;
            return null;
        }
        this.count += 1;
        this.lastRep = closed;
        this.goodMs = 0;
        return closed;
    }
    /** The side the last sample was read on, to match the other counters. */ get side() {
        return this.lastSide;
    }
    /**
   * Closes a hold still under way at the end of a set.
   *
   * Unlike the other two counters this is the normal case rather than the edge
   * one: a hold ends because the athlete came down, and coming down and pressing
   * Stop are the same moment. Without this the only hold of a set would be the
   * one that never made it to the ticket.
   */ flush() {
        return this.closeHold();
    }
    /** Abandons the hold in progress without banking it. */ break() {
        this.current = [];
        this.state = null;
        this.seconds = 0;
        this.goodMs = 0;
        this.last = null;
        this.pending = null;
        this.pendingAt = null;
    }
    /**
   * How far through the hold, 0 to 1, against `minHoldMs`.
   *
   * A hold has no natural end to measure against the way a rep does, so the bar
   * fills to the point the hold counts at all and stays full after it. That is
   * the one moment in a hold worth marking.
   */ get progress() {
        if (this.current.length === 0 || this.minHoldMs <= 0) return 0;
        const heldMs = this.current[this.current.length - 1].t - this.current[0].t;
        return Math.min(1, heldMs / this.minHoldMs);
    }
}


function $cd1714f28c53368d$var$median(values) {
    const sorted = values.filter((v)=>Number.isFinite(v)).sort((a, b)=>a - b);
    if (sorted.length === 0) return null;
    const mid = Math.floor(sorted.length / 2);
    return sorted.length % 2 === 0 ? (sorted[mid - 1] + sorted[mid]) / 2 : sorted[mid];
}
function $cd1714f28c53368d$export$2585fe9e60d91058(sample, thresholds) {
    return Math.abs(sample.trunkTilt) >= thresholds.handstandInvertMin;
}
function $cd1714f28c53368d$export$5a86d721e5d87096(sample, side, thresholds) {
    const raw = sample.earOffArmLineRaw[side];
    const facing = sample.facingOffset[side];
    if (raw == null || !Number.isFinite(raw) || !Number.isFinite(facing) || Math.abs(facing) < thresholds.handstandFacingMin) return null;
    return Math.sign(facing) * raw;
}
function $cd1714f28c53368d$export$66dce4127571c185(sample, side, thresholds) {
    const line = sample.hip[side];
    const knee = sample.knee[side];
    const elbow = sample.elbow[side];
    const shoulder = sample.shoulder[side];
    const head = $cd1714f28c53368d$export$5a86d721e5d87096(sample, side, thresholds);
    return Number.isFinite(line) && Number.isFinite(knee) && Number.isFinite(elbow) && Number.isFinite(shoulder) && line >= thresholds.handstandLineMin && knee >= thresholds.handstandKneeMin && elbow >= thresholds.handstandElbowMin && shoulder >= thresholds.handstandShoulderMin && (head == null || $cd1714f28c53368d$export$fd183be5b7b89408(head, thresholds));
}
function $cd1714f28c53368d$export$fd183be5b7b89408(head, thresholds) {
    return head <= thresholds.handstandHeadMax && head >= thresholds.handstandHeadMin;
}
/**
 * Seconds of the hold spent in line, summed over the frames.
 *
 * The same sum the counter keeps live for the bar, recomputed here off the same
 * predicate so the figure on the ticket and the figure the athlete watched are
 * one number. Each interval belongs to the reading the frame before it gave.
 */ function $cd1714f28c53368d$var$secondsInLine(samples, side, thresholds) {
    let ms = 0;
    for(let i = 1; i < samples.length; i += 1)if ($cd1714f28c53368d$export$66dce4127571c185(samples[i - 1], side, thresholds)) ms += samples[i].t - samples[i - 1].t;
    return ms / 1000;
}
/**
 * Chest to the wall or back to it, from the lean and the facing. Null when the
 * body was too close to plumb to call it, which is the honest answer rather
 * than a coin toss.
 */ function $cd1714f28c53368d$var$wallSide(samples, side, thresholds) {
    const lean = $cd1714f28c53368d$var$median(samples.map((s)=>s.wallLean[side]));
    const facing = $cd1714f28c53368d$var$median(samples.map((s)=>s.facingOffset[side]));
    if (lean == null) return {
        lean: null,
        side: null
    };
    if (facing == null || facing === 0 || Math.abs(lean) < thresholds.handstandLeanMin) return {
        lean: lean,
        side: null
    };
    // The feet lean towards the wall. If that is the way the athlete's front
    // points, the chest is against it.
    return {
        lean: lean,
        side: Math.sign(lean) === Math.sign(facing) ? "front" : "back"
    };
}
const $cd1714f28c53368d$export$5b00b0dc9a6383ca = {
    id: "wall_handstand",
    name: "Wall handstand",
    blurb: "Hold the line upside down, either way round",
    /**
   * Side-on. Every angle here is sagittal — the line through the body, the
   * knee, the elbow, the shoulder — and from the front they all live along the
   * axis the geometry drops. It is also the only view from which the lean that
   * finds the wall is visible at all.
   */ view: "side",
    /**
   * Not calibrated, and further from it than the V-sit: the V-sit's numbers are
   * anatomy applied to a movement the model tracks. These are anatomy applied to
   * a body the model has never been checked against. See the module note.
   */ calibrated: false,
    timed: true,
    thresholdKeys: [
        "handstandInvertMin",
        "handstandLineMin",
        "handstandKneeMin",
        "handstandElbowMin",
        "handstandShoulderMin",
        "handstandMinHoldMs",
        "handstandSettleMs",
        "handstandLeanMin",
        "handstandWallMax",
        "handstandHeadMax",
        "handstandHeadMin",
        "handstandFacingMin"
    ],
    cues: {
        hs_line: "Stack your hips",
        hs_legs: "Straighten your legs",
        hs_elbows: "Lock your elbows",
        hs_shoulders: "Push the floor away",
        // No cue for the ankle: it reports and never judges, so nothing it says
        // could be acted on. Nothing claims anything about the toes.
        hs_head: "Ears between your arms",
        hs_wall: "Hands closer to the wall"
    },
    /** What the athlete hears mid-hold, as the state changes. */ stateCues: {
        good: "In line",
        bad: "Find the line"
    },
    needsFootScale: false,
    createCounter: (thresholds)=>new (0, $039e2a4757468baf$export$6dfab0fa668706fb)({
            holding: (sample)=>$cd1714f28c53368d$export$2585fe9e60d91058(sample, thresholds),
            inLine: (sample, side)=>$cd1714f28c53368d$export$66dce4127571c185(sample, side, thresholds),
            // The longest visibility gate in the app, because the measurement is a
            // line from the hand to the foot and a guess anywhere along it is a guess
            // about all of it.
            visibility: (sample, side)=>sample.handstandVisibility[side],
            minVisibility: thresholds.minVisibility,
            maxGapMs: thresholds.maxGapMs,
            minHoldMs: thresholds.handstandMinHoldMs,
            settleMs: thresholds.handstandSettleMs
        }),
    /**
   * One hold's samples in, criterion rows out.
   *
   * Each joint reports its TYPICAL reading over the hold rather than its best or
   * its worst. A hold is a sustained thing: the best frame says the shape
   * existed for a moment, the worst says the athlete blinked, and the middle is
   * the only one of the three that describes what was held.
   */ scoreRep: (samples, { side: side, thresholds: thresholds })=>{
        if (samples.length === 0) return [];
        const seen = $cd1714f28c53368d$var$median(samples.map((s)=>s.handstandVisibility[side])) >= thresholds.minVisibility;
        const typical = (read)=>seen ? $cd1714f28c53368d$var$median(samples.map(read)) : null;
        const line = typical((s)=>s.hip[side]);
        const knee = typical((s)=>s.knee[side]);
        const elbow = typical((s)=>s.elbow[side]);
        const shoulder = typical((s)=>s.shoulder[side]);
        const toes = typical((s)=>s.ankle[side]);
        // Read per frame, each with its own facing, and then taken over the hold
        // like every other reading here. Frames whose facing was too weak drop out
        // of the median rather than counting as good, and a hold with none left
        // reports unjudged.
        const head = seen ? $cd1714f28c53368d$var$median(samples.map((s)=>$cd1714f28c53368d$export$5a86d721e5d87096(s, side, thresholds))) : null;
        const held = $cd1714f28c53368d$var$secondsInLine(samples, side, thresholds);
        const wall = seen ? $cd1714f28c53368d$var$wallSide(samples, side, thresholds) : {
            lean: null,
            side: null
        };
        return [
            {
                id: "hs_line",
                label: "Body line",
                value: line,
                unit: "\xb0",
                precision: 0,
                pass: line == null ? null : line >= thresholds.handstandLineMin
            },
            {
                id: "hs_legs",
                label: "Legs straight",
                value: knee,
                unit: "\xb0",
                precision: 0,
                pass: knee == null ? null : knee >= thresholds.handstandKneeMin
            },
            {
                id: "hs_elbows",
                label: "Elbows locked",
                value: elbow,
                unit: "\xb0",
                precision: 0,
                pass: elbow == null ? null : elbow >= thresholds.handstandElbowMin
            },
            {
                id: "hs_shoulders",
                label: "Shoulders open",
                value: shoulder,
                unit: "\xb0",
                precision: 0,
                pass: shoulder == null ? null : shoulder >= thresholds.handstandShoulderMin
            },
            {
                // The ankle angle, which is a real angle and not a reading of what the
                // athlete does with his foot: see the module note. Reports and never
                // judges, like the squat jump's row on the same joint.
                id: "hs_toes",
                label: "Ankle",
                value: toes,
                unit: "\xb0",
                precision: 0,
                informational: true,
                note: "not toe point",
                pass: null
            },
            {
                // The criterion with performed faults behind it in both directions,
                // which is why it is also the one that reaches the sound. Positive is
                // the ear out behind the arms, which is the head thrown back; negative
                // is the head coming forward off the line, and far enough that way is
                // just as wrong. The band between them is where the ears belong. The
                // figure is printed signed for that reason — a magnitude would throw
                // away the only part of it that means anything, and would fold the two
                // faults onto each other.
                id: "hs_head",
                label: "Ears in line",
                value: head,
                unit: "\xb0",
                precision: 0,
                pass: head == null ? null : $cd1714f28c53368d$export$fd183be5b7b89408(head, thresholds)
            },
            {
                // The headline figure, and the one thing on this drill that is a
                // measurement rather than a judgement: a clock. It adds up over the set
                // the way the jump's air time does, so the bar carries a running total
                // and the ticket prints the set's seconds with the best hold beside it.
                id: "hs_held",
                label: "In line",
                value: held,
                unit: "s",
                precision: 1,
                informational: true,
                aggregate: "sum",
                bonusStep: 5,
                note: "seconds",
                pass: null
            },
            {
                // How far the hands sit out from the wall, which is the gap between the
                // wrist and the ankle because the feet are against it. Judged: the
                // athlete asked for under 30cm, and unlike the line it is set before he
                // goes up rather than held.
                id: "hs_wall",
                label: "Hands to wall",
                value: wall.lean == null ? null : Math.abs(wall.lean) * 100,
                unit: "cm",
                precision: 0,
                // Which way round he is rides along as the note rather than as a row of
                // its own: it is the same measurement read for its sign, and it is a
                // label rather than a judgement.
                note: wall.side == null ? "not sure" : wall.side === "front" ? "chest" : "back",
                pass: wall.lean == null ? null : Math.abs(wall.lean) <= thresholds.handstandWallMax
            }
        ];
    },
    metricIds: []
};



const $378d82c5860e548d$export$622f75fe8d421c2d = [
    (0, $0a6425a5afc29eb8$export$f947eafee843b553),
    (0, $a7a5e1d03f929104$export$6a99a18a913cbcda),
    (0, $bcb64f06a285175f$export$1cb722a15a243c7a),
    (0, $cd1714f28c53368d$export$5b00b0dc9a6383ca)
];
const $378d82c5860e548d$export$afb06daf2da6f031 = (0, $0a6425a5afc29eb8$export$f947eafee843b553).id;
function $378d82c5860e548d$export$5eda13eb340067d(id) {
    return $378d82c5860e548d$export$622f75fe8d421c2d.find((exercise)=>exercise.id === id) || null;
}
function $378d82c5860e548d$export$3b58c245a668d265(exercise, view) {
    const metrics = (0, $b2f3e77422e22e97$export$18ba04b5611ca1a6)(view);
    if (exercise == null || exercise.metricIds == null) return metrics;
    return metrics.filter((metric)=>exercise.metricIds.includes(metric.id));
}


/**
 * The exercise menu: a title screen that asks what is being trained today.
 *
 * It opens over the live camera rather than before it, which is deliberate. The
 * athlete has to frame the shot — side-on, head to floor, feet in — and the
 * menu's own hint says so, so it is the one moment where seeing yourself in the
 * frame while reading the list is useful. The panel is translucent over the
 * video for exactly that reason.
 *
 * A console's menu, so the arrow keys and Enter work as well as a tap: the phone
 * is on a tripod but this screen is also the one used from a laptop while
 * reviewing a recording.
 *
 * It doubles as the character screen: each drill carries a level and a bar
 * towards the next one, earned in clean reps and kept on the device (see
 * metrics/progress.js). That is a motivator rather than a measurement, and the
 * XP is clean reps for a reason — a bar that filled with any rep at all would
 * pay the athlete to do bad ones, which is the one thing a rep counter makes
 * easy and the one thing this app must not reward.
 *
 * Calibration is said on the card, not buried in a doc, and in the athlete's
 * words: a drill reads "ready" or "experimental". An experimental drill counts
 * reps honestly and scores them against numbers nobody measured, and the
 * difference between that and a ready one is not something to leave the athlete
 * to infer from a score that looks identical either way.
 */ /** Cells in the XP bar. Twenty is what the loading bar and the rep bar use. */ const $c3af07c42f72350a$var$XP_CELLS = 20;
class $c3af07c42f72350a$export$b88448d84eda42e2 {
    /**
   * @param exercises The registry, in menu order.
   * @param handlers.onPick Called with the chosen exercise.
   */ constructor(exercises, { onPick: onPick, progress: progress = null }){
        this.exercises = exercises;
        this.onPick = onPick;
        this.progress = progress;
        this.panel = document.getElementById("menu");
        this.list = document.getElementById("menu-list");
        this.buttons = [];
        /** Per exercise id, the nodes `refresh()` writes the level into. */ this.levels = new Map();
        exercises.forEach((exercise)=>{
            const button = document.createElement("button");
            button.type = "button";
            button.className = "control menu-item";
            button.dataset.exercise = exercise.id;
            const head = document.createElement("span");
            head.className = "menu-head";
            const name = document.createElement("span");
            name.className = "menu-name";
            name.textContent = exercise.name;
            head.appendChild(name);
            const level = document.createElement("span");
            level.className = "menu-level";
            head.appendChild(level);
            button.appendChild(head);
            const blurb = document.createElement("span");
            blurb.className = "menu-blurb";
            blurb.textContent = exercise.blurb;
            button.appendChild(blurb);
            const tag = document.createElement("span");
            tag.className = exercise.calibrated ? "menu-tag menu-tag-ready" : "menu-tag menu-tag-raw";
            // "Ready" and "Experimental" rather than "calibrated" and "not
            // calibrated": the athlete is picking a drill, not auditing the
            // thresholds, and the word that matters to him is whether this one is
            // finished. The field behind it is still `calibrated` and still means
            // the protocol in `fixtures/README.md`.
            tag.textContent = exercise.calibrated ? `${exercise.view} view \xb7 ready` : `${exercise.view} view \xb7 experimental`;
            button.appendChild(tag);
            // The bar is cells rather than a fill, like the loading bar: a block
            // appearing reads as progress at a glance where a sliver growing does not.
            const track = document.createElement("span");
            track.className = "menu-xp";
            const cells = [];
            for(let i = 0; i < $c3af07c42f72350a$var$XP_CELLS; i += 1){
                const cell = document.createElement("span");
                track.appendChild(cell);
                cells.push(cell);
            }
            button.appendChild(track);
            const earned = document.createElement("span");
            earned.className = "menu-xp-label";
            button.appendChild(earned);
            this.levels.set(exercise.id, {
                level: level,
                cells: cells,
                earned: earned,
                track: track
            });
            button.addEventListener("click", ()=>this.pick(exercise));
            this.list.appendChild(button);
            this.buttons.push(button);
        });
        this.onKey = (event)=>this.handleKey(event);
        window.addEventListener("keydown", this.onKey);
    }
    get visible() {
        return !this.panel.hidden;
    }
    /**
   * Writes the levels in. Called on every show, because a set banked since the
   * last one is exactly what the athlete came back to this screen to see.
   */ refresh() {
        if (this.progress == null) return;
        for (const exercise of this.exercises){
            const nodes = this.levels.get(exercise.id);
            const { level: level, into: into, need: need } = this.progress.levelOf(exercise.id);
            nodes.level.textContent = `Lv ${level}`;
            nodes.earned.textContent = `${into}/${need} clean reps to Lv ${level + 1}`;
            const filled = Math.round(into / need * $c3af07c42f72350a$var$XP_CELLS);
            nodes.cells.forEach((cell, i)=>{
                cell.className = i < filled ? "on" : "";
            });
            nodes.track.setAttribute("aria-label", `Level ${level}, ${into} of ${need} clean reps to level ${level + 1}`);
        }
    }
    show() {
        this.refresh();
        this.panel.hidden = false;
        if (this.buttons.length > 0) this.buttons[0].focus();
    }
    hide() {
        this.panel.hidden = true;
    }
    pick(exercise) {
        this.hide();
        this.onPick(exercise);
    }
    handleKey(event) {
        if (!this.visible || event.repeat) return;
        const index = this.buttons.indexOf(document.activeElement);
        if (event.key === "ArrowDown" || event.key === "ArrowUp") {
            event.preventDefault();
            const step = event.key === "ArrowDown" ? 1 : -1;
            const next = (Math.max(0, index) + step + this.buttons.length) % this.buttons.length;
            this.buttons[next].focus();
        } else if (event.code === "Space" && index >= 0) {
            // The drill bar listens for Space too, and until a drill is chosen there
            // is nothing for it to start.
            event.preventDefault();
            this.buttons[index].click();
        }
    }
}


/**
 * A recorded video file standing in for the camera.
 *
 * Reviewing form live is awkward: the athlete is the one holding the phone, the
 * numbers go past at 60fps, and a rep you want to look at twice is gone. Running
 * the same pipeline over a file fixes all three — and because `detectForVideo`
 * takes any `ImageSource`, nothing about the detection path has to change.
 *
 * Two things differ from the camera and both matter:
 *
 * - **No mirror.** The camera image is mirrored so the athlete sees themselves
 *   as in a mirror, and the renderer bakes that into the 2D context. A recording
 *   is already the right way round, so the renderer is built unmirrored here.
 * - **Media time, not wall-clock time.** Timestamps come from `currentTime`, so
 *   the analysis is in the video's own clock. That makes it independent of
 *   playback rate and of how long inference takes, which wall-clock timestamps
 *   would smear.
 *
 * It also means the whole app runs with no camera at all, which is the only way
 * to exercise this pipeline in a sandbox or in CI.
 */ /** Long enough for a slow decode of a large file, short enough to fail visibly. */ const $dc8dd92b16f52584$var$METADATA_TIMEOUT_MS = 20000;
/**
 * Why a file can be selectable and still not play.
 *
 * The input accepts `video/*`, which is about the container, while playing is
 * about the codec inside it. A phone recording is the common case: an iPhone
 * writes `.mov`, which Safari plays natively on every device, and which Chrome
 * plays only when the track inside is H.264 — a clip recorded in "High
 * Efficiency" mode is HEVC and Chrome may refuse it on the same machine where
 * Safari is fine. Nothing can be done about that in a page, so the message says
 * which browser to open instead rather than blaming the file.
 */ function $dc8dd92b16f52584$var$decodeHint(file) {
    const name = file && file.name || "";
    const type = file && file.type || "";
    const quicktime = /\.mov$/i.test(name) || type === "video/quicktime";
    if (quicktime) return "Could not decode that video. A .mov from an iPhone plays in Safari but not always in Chrome, which needs H.264 rather than HEVC.";
    return "Could not decode that video. Try an MP4 the browser can play natively.";
}
function $dc8dd92b16f52584$var$waitForMetadata(video, timeoutMs, file) {
    if (video.videoWidth > 0 && video.videoHeight > 0) return Promise.resolve();
    return new Promise((resolve, reject)=>{
        const cleanup = ()=>{
            clearTimeout(deadline);
            video.removeEventListener("loadedmetadata", onReady);
            video.removeEventListener("error", onError);
        };
        const onReady = ()=>{
            cleanup();
            resolve();
        };
        const onError = ()=>{
            cleanup();
            reject(new Error($dc8dd92b16f52584$var$decodeHint(file)));
        };
        const deadline = setTimeout(()=>{
            cleanup();
            reject(new Error("Timed out reading the video."));
        }, timeoutMs);
        video.addEventListener("loadedmetadata", onReady);
        video.addEventListener("error", onError);
    });
}
class $dc8dd92b16f52584$export$a630243e2c957ead {
    constructor(){
        this.video = document.getElementById("video");
        this.objectUrl = null;
    }
    /** True for a source whose image is already the right way round. */ get mirrored() {
        return false;
    }
    /**
   * Timestamps in milliseconds on the video's own clock, which is what makes
   * the analysis independent of playback rate and of inference speed.
   */ timestamp() {
        return this.video.currentTime * 1000;
    }
    static async setup(file) {
        const source = new $dc8dd92b16f52584$export$a630243e2c957ead();
        const video = source.video;
        // A camera stream may still be attached if the mode was switched at runtime.
        if (video.srcObject) {
            for (const track of video.srcObject.getTracks())track.stop();
            video.srcObject = null;
        }
        source.objectUrl = URL.createObjectURL(file);
        video.src = source.objectUrl;
        video.muted = true;
        video.playsInline = true;
        video.loop = false;
        // The camera path sets this; a file must not inherit it, or scrubbing back
        // to look at a rep again would restart the whole analysis.
        video.autoplay = false;
        video.load();
        await $dc8dd92b16f52584$var$waitForMetadata(video, $dc8dd92b16f52584$var$METADATA_TIMEOUT_MS, file);
        video.width = video.videoWidth;
        video.height = video.videoHeight;
        const wrapper = document.querySelector(".canvas-wrapper");
        wrapper.style.aspectRatio = `${video.videoWidth} / ${video.videoHeight}`;
        return source;
    }
    play() {
        const playing = this.video.play();
        if (playing && typeof playing.catch === "function") playing.catch(()=>{});
    }
    release() {
        if (this.objectUrl) {
            URL.revokeObjectURL(this.objectUrl);
            this.objectUrl = null;
        }
    }
}


/**
 * The startup panel: what the app shows before it can draw anything.
 *
 * Nothing appears on screen until the camera is live and the pose model has
 * downloaded, which on a phone is several seconds and several megabytes. With
 * no indicator that wait is a blank screen, and — worse — a failure is
 * indistinguishable from a slow load. This makes both legible, and reports the
 * actual reason when it fails rather than leaving someone guessing.
 */ class $f89871a1926c8f6b$export$b2d771f28e95281b {
    constructor(){
        this.root = document.getElementById("startup");
        this.message = document.getElementById("startup-message");
        this.detail = document.getElementById("startup-detail");
        this.track = document.getElementById("startup-track");
        this.bar = document.getElementById("startup-bar");
        this.retry = document.getElementById("startup-retry");
        this.track.hidden = true;
    }
    /** Names the step in progress. Clears any bar left over from a prior step. */ stage(message, detail = "") {
        this.root.hidden = false;
        this.root.classList.remove("failed");
        this.retry.hidden = true;
        this.message.textContent = message;
        this.detail.textContent = detail;
        this.track.hidden = true;
        this.bar.style.width = "0%";
    }
    /**
   * @param fraction 0..1, or null when the server sends no content-length and
   *   the total is therefore unknown.
   */ progress(fraction, detail = "") {
        if (fraction == null) this.track.hidden = true;
        else {
            this.track.hidden = false;
            this.bar.style.width = `${Math.round(fraction * 100)}%`;
        }
        if (detail) this.detail.textContent = detail;
    }
    fail(error) {
        this.root.hidden = false;
        this.root.classList.add("failed");
        this.track.hidden = true;
        const { message: message, detail: detail } = $f89871a1926c8f6b$var$describe(error);
        this.message.textContent = message;
        this.detail.textContent = detail;
        this.retry.hidden = false;
        // The underlying error still goes to the console for anyone debugging.
        console.error("startup failed:", error);
    }
    done() {
        this.root.hidden = true;
    }
    onRetry(handler) {
        this.retry.addEventListener("click", handler);
    }
}
/**
 * Turns a thrown error into something worth reading. A raw "Failed to fetch"
 * tells the person nothing they can act on.
 */ function $f89871a1926c8f6b$var$describe(error) {
    const raw = String(error && error.message || error);
    if (error && error.name === "NotAllowedError") return {
        message: "Camera permission denied",
        detail: "Allow camera access for this site in your browser settings, then try again."
    };
    if (error && error.name === "NotFoundError") return {
        message: "No camera found",
        detail: "This device reported no usable camera."
    };
    if (raw.includes("getUserMedia not available")) return {
        message: "Camera unavailable",
        detail: "The camera needs a secure context. Open the app over HTTPS or on localhost."
    };
    if (raw.includes("model") || raw.includes("wasm") || raw.includes("404")) return {
        message: "Could not load the pose model",
        detail: `${raw}. The model and Wasm runtime are staged into dist/ at build ` + "time; if this is a deployment, check that the build ran the asset step."
    };
    return {
        message: "Something went wrong starting up",
        detail: raw
    };
}
async function $f89871a1926c8f6b$export$11d57964f93cdb7d(url, onProgress) {
    const response = await fetch(url);
    if (!response.ok) throw new Error(`${url} returned ${response.status}`);
    const total = Number(response.headers.get("content-length")) || 0;
    // No streaming body (or no length): fall back to an opaque wait rather than
    // reporting a percentage that would be a guess.
    if (!response.body) {
        onProgress(null, 0, total);
        return new Uint8Array(await response.arrayBuffer());
    }
    const reader = response.body.getReader();
    const chunks = [];
    let received = 0;
    for(;;){
        const { done: done, value: value } = await reader.read();
        if (done) break;
        chunks.push(value);
        received += value.length;
        onProgress(total ? received / total : null, received, total);
    }
    const bytes = new Uint8Array(received);
    let offset = 0;
    for (const chunk of chunks){
        bytes.set(chunk, offset);
        offset += chunk.length;
    }
    return bytes;
}
function $f89871a1926c8f6b$export$7b2eccf27de336d2(urlFragment, onProgress) {
    const original = window.fetch;
    if (typeof original !== "function") return ()=>{};
    window.fetch = async (input, init)=>{
        const url = typeof input === "string" ? input : input && input.url;
        const response = await original(input, init);
        if (!url || !url.includes(urlFragment) || !response.body) return response;
        const total = Number(response.headers.get("content-length")) || 0;
        const reader = response.body.getReader();
        let received = 0;
        const counted = new ReadableStream({
            async pull (controller) {
                const { done: done, value: value } = await reader.read();
                if (done) {
                    controller.close();
                    return;
                }
                received += value.length;
                onProgress(total ? received / total : null, received, total);
                controller.enqueue(value);
            },
            cancel (reason) {
                return reader.cancel(reason);
            }
        });
        // Headers are carried over so the content type still says application/wasm
        // and streaming compilation is not lost.
        return new Response(counted, {
            headers: response.headers,
            status: response.status,
            statusText: response.statusText
        });
    };
    return ()=>{
        window.fetch = original;
    };
}
function $f89871a1926c8f6b$export$2f8990f0737862ee(bytes) {
    return `${(bytes / 1048576).toFixed(1)}MB`;
}


let $1f0dc3b9307be026$var$source, $1f0dc3b9307be026$var$landmarker, $1f0dc3b9307be026$var$renderer, $1f0dc3b9307be026$var$rafId;
/** Whether a frame has already thrown, so the loop reports it once. */ let $1f0dc3b9307be026$var$loopFailed = false;
/** Whether a `play()` is already in flight, so the loop does not stack them. */ let $1f0dc3b9307be026$var$resuming = false;
/**
 * The camera watchdog.
 *
 * `resumeIfPaused` covers the element being paused, which is one of the two
 * ways iOS takes the picture away. The other leaves the element playing and
 * stops the frames: the track is interrupted — by the download sheet a saved
 * recording opens, by the lock button, by another app taking the camera — and
 * comes back muted or ended. `paused` is false, `readyState` is 4, and
 * `currentTime` simply never advances again, so the loop never re-infers and
 * goes on drawing the last frame it had. That is the freeze the athlete kept
 * reporting after the pause fix shipped.
 *
 * Nothing recovers a dead track but asking for a new one, so a camera that has
 * produced no frame for `STALL_RESTART_MS` while the page is on screen is torn
 * down and set up again. The backoff doubles the wait after each restart that
 * does not produce frames, up to `STALL_RESTART_MAX_MS`: a phone that has
 * genuinely lost the camera — permission revoked, another app holding it — must
 * not be asked for it twice a second for as long as the tab is open.
 */ const $1f0dc3b9307be026$var$STALL_RESTART_MS = 2000;
const $1f0dc3b9307be026$var$STALL_RESTART_MAX_MS = 30000;
let $1f0dc3b9307be026$var$lastFrameAt = 0;
let $1f0dc3b9307be026$var$restarting = false;
let $1f0dc3b9307be026$var$restarts = 0;
let $1f0dc3b9307be026$var$normalizedSmoother, $1f0dc3b9307be026$var$worldSmoother;
let $1f0dc3b9307be026$var$frames, $1f0dc3b9307be026$var$readout, $1f0dc3b9307be026$var$recorder, $1f0dc3b9307be026$var$controls, $1f0dc3b9307be026$var$coach, $1f0dc3b9307be026$var$startup;
/** Set the first time ?record=1 arms the recorder, so it arms exactly once. */ let $1f0dc3b9307be026$var$autoRecordArmed = false;
let $1f0dc3b9307be026$var$reps, $1f0dc3b9307be026$var$posture;
/**
 * The drill being scored, from the menu or `?exercise=`. Everything that is
 * specific to one movement — how a rep is counted, which criteria are checked,
 * what to say when one fails — hangs off this; see exercises/index.js.
 */ let $1f0dc3b9307be026$var$exercise = null;
let $1f0dc3b9307be026$var$menu, $1f0dc3b9307be026$var$receipt, $1f0dc3b9307be026$var$workout, $1f0dc3b9307be026$var$set, $1f0dc3b9307be026$var$progress, $1f0dc3b9307be026$var$history;
/**
 * What each banked set earned, in the order the workout holds them, so the
 * ticket can print the XP and any level crossed beside the set that did it.
 */ let $1f0dc3b9307be026$var$earned;
// detectForVideo requires strictly increasing timestamps, and re-running
// inference on a frame the source has not replaced yet is wasted work.
let $1f0dc3b9307be026$var$lastVideoTime = -1;
let $1f0dc3b9307be026$var$lastTimestamp = -1;
let $1f0dc3b9307be026$var$inferenceTime = 0;
let $1f0dc3b9307be026$var$lastResult = null;
/**
 * Foot length for the tiptoe criterion, measured over the session rather than
 * per rep. An occluded foot measures a third of its real length, and a per-rep
 * scale would read that as a raised heel.
 */ let $1f0dc3b9307be026$var$sessionFootScale = null;
/**
 * Wraps a Camera in the same shape VideoFile has, so the render loop does not
 * branch on which it has. The two differ in exactly two ways: a camera preview
 * is mirrored and a file is not, and a camera runs on wall-clock time while a
 * file runs on its own.
 */ function $1f0dc3b9307be026$var$cameraSource(camera) {
    return {
        video: camera.video,
        mirrored: true,
        timestamp: ()=>performance.now(),
        // A paused camera is always an accident; a paused file is the review
        // control doing its job. See `resumeIfPaused`.
        keepPlaying: true
    };
}
async function $1f0dc3b9307be026$var$createLandmarker() {
    // Resolving the fileset only computes paths; the ~11MB runtime binary is
    // fetched later, inside createFromOptions.
    const vision = await (0, $a2acea4f3420f1d8$export$f97946dfe503e8d3).forVisionTasks((0, $4765f54d936bfe63$export$46af0713ef1f3295));
    // Fetched here rather than handed to MediaPipe as a path, so the download —
    // by far the longest part of startup, and megabytes on a phone — can report
    // real progress instead of an opaque wait.
    $1f0dc3b9307be026$var$startup.stage("Loading pose model\u2026", `${(0, $4765f54d936bfe63$export$63b4527a2777036f).model} model, cached after the first visit`);
    const modelBytes = await (0, $f89871a1926c8f6b$export$11d57964f93cdb7d)((0, $4765f54d936bfe63$export$66d3b9df51b4fadf)[(0, $4765f54d936bfe63$export$63b4527a2777036f).model], (fraction, received, total)=>{
        $1f0dc3b9307be026$var$startup.progress(fraction, total ? `${(0, $f89871a1926c8f6b$export$2f8990f0737862ee)(received)} of ${(0, $f89871a1926c8f6b$export$2f8990f0737862ee)(total)}` : `${(0, $f89871a1926c8f6b$export$2f8990f0737862ee)(received)} downloaded`);
    });
    // The runtime download happens inside createFromOptions, so its progress has
    // to be observed rather than driven.
    $1f0dc3b9307be026$var$startup.stage("Loading pose runtime\u2026", "about 11MB, cached after the first visit");
    const untrack = (0, $f89871a1926c8f6b$export$7b2eccf27de336d2)("vision_wasm", (fraction, received, total)=>{
        $1f0dc3b9307be026$var$startup.progress(fraction, total ? `${(0, $f89871a1926c8f6b$export$2f8990f0737862ee)(received)} of ${(0, $f89871a1926c8f6b$export$2f8990f0737862ee)(total)}` : `${(0, $f89871a1926c8f6b$export$2f8990f0737862ee)(received)} downloaded`);
    });
    try {
        return await (0, $a2acea4f3420f1d8$export$fe95e48202120e29).createFromOptions(vision, {
            baseOptions: {
                modelAssetBuffer: modelBytes,
                // GPU keeps a heavier model real-time; MediaPipe falls back to CPU on
                // its own if the delegate is unavailable.
                delegate: "GPU"
            },
            // VIDEO mode carries tracking state between frames, which both steadies
            // the landmarks and avoids re-running whole-frame detection every time.
            runningMode: "VIDEO",
            ...(0, $4765f54d936bfe63$export$63b4527a2777036f).landmarker
        });
    } finally{
        untrack();
    }
}
/**
 * Smoothing must be applied per pose, and the filters hold per-landmark state,
 * so this only supports a single tracked athlete. numPoses > 1 would need a
 * smoother bank keyed by a stable track id, which the task does not expose.
 */ function $1f0dc3b9307be026$var$smooth(result, timestamp) {
    if (result.landmarks.length === 0) {
        $1f0dc3b9307be026$var$normalizedSmoother.reset();
        $1f0dc3b9307be026$var$worldSmoother.reset();
        return result;
    }
    if (!(0, $4765f54d936bfe63$export$63b4527a2777036f).smoothing.enabled) return result;
    return {
        ...result,
        landmarks: [
            $1f0dc3b9307be026$var$normalizedSmoother.smooth(result.landmarks[0], timestamp)
        ],
        worldLandmarks: result.worldLandmarks.length > 0 ? [
            $1f0dc3b9307be026$var$worldSmoother.smooth(result.worldLandmarks[0], timestamp)
        ] : result.worldLandmarks
    };
}
/**
 * Monotonic timestamps for `detectForVideo`, which rejects one it has already
 * seen, from a source clock that is not guaranteed to only move forwards.
 *
 * Scrubbing a file back to watch a rep again rewinds `currentTime`, and feeding
 * that in would make the detector refuse every frame until playback passed the
 * furthest point already reached — the overlay would freeze for exactly the
 * stretch being reviewed. So inference gets its own ever-increasing clock, while
 * the metrics and the recorder keep the source's real timestamp, which for a
 * file is media time and is the honest one to record.
 */ function $1f0dc3b9307be026$var$inferenceClock(timestamp) {
    const step = timestamp > $1f0dc3b9307be026$var$lastTimestamp ? timestamp - $1f0dc3b9307be026$var$lastTimestamp : 1;
    $1f0dc3b9307be026$var$lastTimestamp = timestamp;
    $1f0dc3b9307be026$var$inferenceTime += step;
    return $1f0dc3b9307be026$var$inferenceTime;
}
/**
 * Keeps the camera's own `<video>` playing.
 *
 * Nothing in this app ever started it: a stream assigned to `srcObject`
 * autoplays, so there is no `play()` call to repeat. iOS pauses that element
 * whenever the system takes the screen — a download or share sheet, the lock
 * button, a tab switch — and when the page comes back nothing resumes it. The
 * loop then sees `currentTime` standing still, never re-infers, and goes on
 * drawing the last frame it had: a camera frozen for good while every button
 * still works. Saving a recording is the reliable way to produce it, because
 * the download sheet is exactly that kind of interruption, which is why this
 * was reported as "it freezes when I finish the set and save the take".
 *
 * A file is the opposite case — pausing it is the review control doing its job
 * — so only a source that asks for this gets it.
 *
 * `play()` rejects if it is called again while the element is still recovering,
 * so the rejection is swallowed and the next frame simply tries again.
 */ function $1f0dc3b9307be026$var$resumeIfPaused(video) {
    if (!$1f0dc3b9307be026$var$source.keepPlaying || !video.paused || $1f0dc3b9307be026$var$resuming) return;
    $1f0dc3b9307be026$var$resuming = true;
    const done = ()=>{
        $1f0dc3b9307be026$var$resuming = false;
    };
    const attempt = video.play();
    if (attempt && typeof attempt.then === "function") attempt.then(done, done);
    else done();
}
/**
 * Lets go of the camera and asks for it again.
 *
 * The old tracks are stopped first and deliberately: a track that is muted
 * rather than ended still holds the device, and iOS will hand back the same
 * dead track rather than a fresh one while it does. `Camera.setup` reuses the
 * same `<video>` element, re-plays it and re-waits for real frames, so what
 * comes back is a working source or an error.
 */ async function $1f0dc3b9307be026$var$restartCamera() {
    if ($1f0dc3b9307be026$var$restarting || !$1f0dc3b9307be026$var$source.keepPlaying) return;
    $1f0dc3b9307be026$var$restarting = true;
    $1f0dc3b9307be026$var$restarts += 1;
    try {
        const stream = $1f0dc3b9307be026$var$source.video.srcObject;
        if (stream && typeof stream.getTracks === "function") for (const track of stream.getTracks())track.stop();
        $1f0dc3b9307be026$var$source.video.srcObject = null;
        $1f0dc3b9307be026$var$source = $1f0dc3b9307be026$var$cameraSource(await (0, $99e47839c965209f$export$79f141de891a5fed).setup((0, $4765f54d936bfe63$export$63b4527a2777036f).camera));
        // The new stream starts its own clock, so the guard must not compare
        // against the dead one's last time.
        $1f0dc3b9307be026$var$lastVideoTime = -1;
    } catch (error) {
        console.error("camera restart failed", error);
    } finally{
        $1f0dc3b9307be026$var$restarting = false;
        // Whether it worked or not, the next window starts now: a failed restart
        // backs off rather than retrying on the very next frame.
        $1f0dc3b9307be026$var$lastFrameAt = performance.now();
    }
}
/**
 * Restarts the camera if it has stopped producing frames.
 *
 * Only while the page is on screen. A backgrounded tab stops delivering frames
 * for perfectly good reasons, and `visibilitychange` resets the window on the
 * way back so a return from the lock screen gets its two seconds to resume by
 * itself before the camera is torn down.
 */ function $1f0dc3b9307be026$var$watchForStall(now) {
    if (!$1f0dc3b9307be026$var$source.keepPlaying || $1f0dc3b9307be026$var$restarting) return;
    if (typeof document !== "undefined" && document.visibilityState === "hidden") {
        $1f0dc3b9307be026$var$lastFrameAt = now;
        return;
    }
    const wait = Math.min($1f0dc3b9307be026$var$STALL_RESTART_MS * Math.pow(2, $1f0dc3b9307be026$var$restarts), $1f0dc3b9307be026$var$STALL_RESTART_MAX_MS);
    if (now - $1f0dc3b9307be026$var$lastFrameAt > wait) $1f0dc3b9307be026$var$restartCamera();
}
function $1f0dc3b9307be026$var$renderResult() {
    const video = $1f0dc3b9307be026$var$source.video;
    $1f0dc3b9307be026$var$resumeIfPaused(video);
    const now = performance.now();
    if ($1f0dc3b9307be026$var$lastFrameAt === 0) $1f0dc3b9307be026$var$lastFrameAt = now;
    if (video.readyState < 2) {
        $1f0dc3b9307be026$var$watchForStall(now);
        return;
    }
    if (video.currentTime !== $1f0dc3b9307be026$var$lastVideoTime) {
        $1f0dc3b9307be026$var$lastVideoTime = video.currentTime;
        // A frame the source actually replaced, which is the only evidence that the
        // camera is alive: `paused` and `readyState` both lie about a dead track.
        $1f0dc3b9307be026$var$lastFrameAt = now;
        $1f0dc3b9307be026$var$restarts = 0;
        const timestamp = $1f0dc3b9307be026$var$source.timestamp();
        const detected = $1f0dc3b9307be026$var$landmarker.detectForVideo(video, $1f0dc3b9307be026$var$inferenceClock(timestamp));
        // Recorded before smoothing: filtering can be reapplied offline with any
        // parameters, but it cannot be removed after the fact.
        if (detected.worldLandmarks.length > 0) {
            if ((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.autoRecord && !$1f0dc3b9307be026$var$autoRecordArmed) {
                // Armed by ?record=1: begin at the first detected pose rather than on
                // load, so a tripod setup does not bank seconds of an empty gym. Armed
                // once and tracked here rather than read back off the recorder: during
                // the countdown the recorder has not started, so a recorder-derived
                // guard fires again on the next frame and the second call reads as the
                // Cancel it is, tearing the countdown down and starting it again sixty
                // times a second.
                $1f0dc3b9307be026$var$autoRecordArmed = true;
                $1f0dc3b9307be026$var$controls.arm();
            }
            $1f0dc3b9307be026$var$recorder.capture(detected.worldLandmarks[0], timestamp);
        }
        $1f0dc3b9307be026$var$lastResult = $1f0dc3b9307be026$var$smooth(detected, timestamp);
        $1f0dc3b9307be026$var$recordSample($1f0dc3b9307be026$var$lastResult, timestamp);
    } else $1f0dc3b9307be026$var$watchForStall(now);
    $1f0dc3b9307be026$var$renderer.draw(video, $1f0dc3b9307be026$var$lastResult);
    $1f0dc3b9307be026$var$drawMetrics();
}
/**
 * Metrics run off the smoothed world landmarks, so they inherit the same
 * filtering the overlay shows. Losing the pose clears the history rather than
 * letting a stale window blend across a gap.
 */ function $1f0dc3b9307be026$var$recordSample(result, timestamp) {
    if (!(0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.enabled) return;
    if (result.worldLandmarks.length === 0) {
        $1f0dc3b9307be026$var$frames.clear();
        return;
    }
    const sample = (0, $4851c46e13ae947d$export$f77d0f9ead22ddee)(result.worldLandmarks[0], timestamp);
    $1f0dc3b9307be026$var$frames.push(sample);
    $1f0dc3b9307be026$var$countRep(sample);
}
/**
 * Feeds the counter and scores each rep as it closes.
 *
 * The near side is taken from the recent window rather than from this frame: it
 * is a property of where the athlete stands relative to the camera, and letting
 * it flip mid-rep would swap which arm is being followed partway through a
 * revolution.
 */ function $1f0dc3b9307be026$var$countRep(sample) {
    if (!$1f0dc3b9307be026$var$scoringEnabled()) return;
    // Only during a set. Counting from page load would have the athlete walking
    // back from the phone on rep 1, and would make Start mean nothing.
    if ($1f0dc3b9307be026$var$coach && !$1f0dc3b9307be026$var$coach.running) return;
    const window1 = $1f0dc3b9307be026$var$frames.window((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.windowMs);
    const side = window1.length > 0 ? (0, $4851c46e13ae947d$export$1cd850881aa38839)(window1) : "left";
    const completed = $1f0dc3b9307be026$var$reps.push(sample, side);
    // A hold reports every frame, not only when one ends: the seconds on the bar
    // and the sound that says the line went are both live, and by the time a hold
    // closes the athlete is already on the floor. A rep drill has no state and
    // this does nothing for it.
    if ($1f0dc3b9307be026$var$coach && $1f0dc3b9307be026$var$exercise.timed) $1f0dc3b9307be026$var$coach.showHoldState($1f0dc3b9307be026$var$reps.state, $1f0dc3b9307be026$var$reps.seconds);
    if (completed == null) return;
    $1f0dc3b9307be026$var$scoreCompletedRep(completed, side, window1);
}
/**
 * Delivers one completed rep: the verdict, the sound, the tally, the ticket.
 *
 * Separate from `countRep` because a rep can also arrive at the end of a set
 * rather than on a frame — see `flushRep`.
 */ function $1f0dc3b9307be026$var$scoreCompletedRep(completed, side, window1) {
    if ($1f0dc3b9307be026$var$sessionFootScale == null && $1f0dc3b9307be026$var$exercise.needsFootScale) $1f0dc3b9307be026$var$sessionFootScale = (0, $351c2b07e0ef1e12$export$f608706c6ebdbcc3)(window1, side);
    // The exercise decides what a rep is judged on. Everything from here down —
    // the verdict, the sounds, the live tally, the receipt — reads only the row
    // shape, so a new drill needs no changes to any of it.
    const scored = $1f0dc3b9307be026$var$exercise.scoreRep(completed, {
        side: side,
        thresholds: (0, $4765f54d936bfe63$export$63b4527a2777036f).posture,
        footScale: $1f0dc3b9307be026$var$sessionFootScale
    });
    $1f0dc3b9307be026$var$posture.add(scored);
    if ($1f0dc3b9307be026$var$set) $1f0dc3b9307be026$var$set.add(scored);
    if ($1f0dc3b9307be026$var$coach) $1f0dc3b9307be026$var$coach.showRep($1f0dc3b9307be026$var$reps.count, scored);
}
/**
 * Closes a rep whose counter is still waiting on frames, at the end of a set.
 *
 * A jump's rep window runs past the point the knee re-extends, so the counter
 * holds the last one open waiting either for the knee to come back down or for
 * its cap to run out. Both need frames, and frames stop mattering the moment
 * the athlete presses Stop. Without this the last jump of every set would be
 * missing from the count and from the ticket.
 */ function $1f0dc3b9307be026$var$flushRep() {
    if (!$1f0dc3b9307be026$var$scoringEnabled() || $1f0dc3b9307be026$var$reps == null || typeof $1f0dc3b9307be026$var$reps.flush !== "function") return;
    const completed = $1f0dc3b9307be026$var$reps.flush();
    if (completed == null) return;
    const window1 = $1f0dc3b9307be026$var$frames.window((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.windowMs);
    $1f0dc3b9307be026$var$scoreCompletedRep(completed, window1.length > 0 ? (0, $4851c46e13ae947d$export$1cd850881aa38839)(window1) : "left", window1);
}
/**
 * Scoring needs a drill AND the camera view its criteria are honest in. The
 * menu sets both at once, so a mismatch only happens with `?view=` and
 * `?exercise=` set against each other, which is worth refusing rather than
 * answering with numbers measured in the wrong plane.
 */ function $1f0dc3b9307be026$var$scoringEnabled() {
    return (0, $4765f54d936bfe63$export$63b4527a2777036f).posture.enabled && $1f0dc3b9307be026$var$exercise != null && $1f0dc3b9307be026$var$exercise.view === (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.view;
}
/**
 * Points the app at a drill: the counter it needs, the view its criteria are
 * measured in, and the cues its bar says.
 */ function $1f0dc3b9307be026$var$selectExercise(chosen) {
    $1f0dc3b9307be026$var$exercise = chosen;
    (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.view = chosen.view;
    // The counter gets the session's foot scale the same way `scoreRep` does, as
    // a getter rather than a value: it is not known until the first rep has been
    // seen, and a counter that measured it per rep would judge the same movement
    // differently from the criteria that score it.
    $1f0dc3b9307be026$var$reps = chosen.createCounter((0, $4765f54d936bfe63$export$63b4527a2777036f).posture, {
        footScale: ()=>$1f0dc3b9307be026$var$sessionFootScale
    });
    $1f0dc3b9307be026$var$posture.reset();
    $1f0dc3b9307be026$var$sessionFootScale = null;
    document.getElementById("coach").hidden = false;
    if ($1f0dc3b9307be026$var$coach) $1f0dc3b9307be026$var$coach.setExercise(chosen);
    $1f0dc3b9307be026$var$renderReceiptButton();
}
/** A set starts from zero: the tally is about this set, not the page's lifetime. */ function $1f0dc3b9307be026$var$startSet() {
    $1f0dc3b9307be026$var$reps.reset();
    $1f0dc3b9307be026$var$posture.reset();
    $1f0dc3b9307be026$var$sessionFootScale = null;
    $1f0dc3b9307be026$var$set = new (0, $c8248b0f107e3b94$export$a8b278985df8ab3)($1f0dc3b9307be026$var$exercise);
}
/**
 * Ends the set and shows the ticket for the workout so far.
 *
 * The receipt comes up on its own rather than behind a second button, because
 * stopping the set IS the athlete saying they are done with it, and a summary
 * nobody opens is not a summary. A set with no reps in it was a false start and
 * is dropped: it would otherwise print a line scored 0 of 0 and drag the total
 * down with it.
 */ function $1f0dc3b9307be026$var$endSet() {
    if ($1f0dc3b9307be026$var$set == null) return;
    // Before the set is closed, so the last rep is in it.
    $1f0dc3b9307be026$var$flushRep();
    const finished = $1f0dc3b9307be026$var$set.end();
    $1f0dc3b9307be026$var$set = null;
    if (finished.reps === 0) return;
    // A set finished after midnight belongs to the new day, and starts its ticket.
    if ($1f0dc3b9307be026$var$history.rolledOver()) {
        $1f0dc3b9307be026$var$history.startNewDay();
        $1f0dc3b9307be026$var$workout.reset();
        $1f0dc3b9307be026$var$earned.length = 0;
    }
    $1f0dc3b9307be026$var$workout.add(finished);
    // Banked before the ticket is drawn, so the line that says a level was
    // crossed and the bar on the menu behind it cannot disagree.
    $1f0dc3b9307be026$var$earned.push($1f0dc3b9307be026$var$progress.add(finished));
    $1f0dc3b9307be026$var$history.save($1f0dc3b9307be026$var$workout, $1f0dc3b9307be026$var$earned);
    $1f0dc3b9307be026$var$renderReceiptButton();
    $1f0dc3b9307be026$var$receipt.show($1f0dc3b9307be026$var$workout, $1f0dc3b9307be026$var$earned);
}
/** Back to the drill list, from the bar or from the ticket. */ function $1f0dc3b9307be026$var$showMenu() {
    document.getElementById("coach").hidden = true;
    $1f0dc3b9307be026$var$menu.show();
}
function $1f0dc3b9307be026$var$renderReceiptButton() {
    const button = document.getElementById("coach-receipt");
    if (button) button.hidden = $1f0dc3b9307be026$var$workout == null || $1f0dc3b9307be026$var$workout.sets.length === 0;
}
function $1f0dc3b9307be026$var$drawMetrics() {
    if (!(0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.enabled) return;
    const samples = $1f0dc3b9307be026$var$frames.window((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.windowMs);
    let note;
    if ($1f0dc3b9307be026$var$recorder.recording) {
        const mb = ($1f0dc3b9307be026$var$recorder.estimateBytes() / 1048576).toFixed(1);
        note = `\u{25CF} REC ${$1f0dc3b9307be026$var$recorder.durationSeconds.toFixed(0)}s \xb7 ${$1f0dc3b9307be026$var$recorder.frames.length} frames \xb7 ${$1f0dc3b9307be026$var$recorder.marks.length} marks \xb7 ~${mb}MB`;
    } else if (samples.length === 0) note = "no pose \u2014 stand in frame";
    else if ((0, $4765f54d936bfe63$export$63b4527a2777036f).sourceKind === "file") {
        const video = $1f0dc3b9307be026$var$source.video;
        const at = video.currentTime.toFixed(1);
        const of = Number.isFinite(video.duration) ? video.duration.toFixed(1) : "?";
        note = `${at}s of ${of}s \xb7 click to ${video.paused ? "play" : "pause"} \xb7 arrows to step`;
    } else if ((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.capture) note = `${((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.windowMs / 1000).toFixed(0)}s window \xb7 ${samples.length} frames \xb7 R to record`;
    else if ($1f0dc3b9307be026$var$menu && $1f0dc3b9307be026$var$menu.visible) note = "choose a drill";
    else if ($1f0dc3b9307be026$var$coach && !$1f0dc3b9307be026$var$coach.running) note = `${((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.windowMs / 1000).toFixed(0)}s window \xb7 press Start to count`;
    else note = `${((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.windowMs / 1000).toFixed(0)}s window \xb7 ${samples.length} frames`;
    const scoring = $1f0dc3b9307be026$var$scoringEnabled();
    $1f0dc3b9307be026$var$readout.draw((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.view, (0, $b2f3e77422e22e97$export$83ff8900102eb45f)((0, $378d82c5860e548d$export$3b58c245a668d265)($1f0dc3b9307be026$var$exercise, (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.view), samples), note, scoring ? $1f0dc3b9307be026$var$counterReadout() : null, scoring && $1f0dc3b9307be026$var$posture.reps > 0 ? $1f0dc3b9307be026$var$posture.summary() : null);
    if ($1f0dc3b9307be026$var$controls && ($1f0dc3b9307be026$var$recorder.recording || $1f0dc3b9307be026$var$controls.countingDown)) $1f0dc3b9307be026$var$controls.render();
}
/**
 * The headline figure under the metric rows, and what it is called.
 *
 * A hold is not a set of reps and must not be labelled as one. The handstand
 * shipped with a big amber `0` under the word REPS through a forty-second hold,
 * with the drill bar beside it correctly reading the clock — two numbers
 * disagreeing about what the drill even measures. The bar had the same problem:
 * a hold's progress is measured against `handstandMinHoldMs`, so it filled in
 * two seconds and then sat full, which is a bar saying nothing for the rest of
 * the hold. A timed drill gets the clock and no bar; see exercises/hold.js.
 */ function $1f0dc3b9307be026$var$counterReadout() {
    if ($1f0dc3b9307be026$var$exercise.timed) return {
        value: `${$1f0dc3b9307be026$var$reps.seconds.toFixed(1)}s`,
        label: "SECONDS",
        progress: null
    };
    return {
        value: String($1f0dc3b9307be026$var$reps.count),
        label: "REPS",
        progress: $1f0dc3b9307be026$var$reps.progress
    };
}
/**
 * The loop, and the one place in the app that must not be allowed to end.
 *
 * `requestAnimationFrame` is only scheduled from inside the callback, so a
 * single frame that throws — one malformed landmark, one metric reading a joint
 * that was not there — does not drop a frame, it stops the app for good: the
 * overlay freezes on the last picture it drew, the counters stop, and nothing
 * recovers short of a reload. That is far too much to lose to one bad frame, so
 * the next frame is booked whatever this one did. The error is reported once
 * rather than every frame at 60Hz, because a loop that keeps running is only an
 * improvement if it does not also fill the console.
 */ function $1f0dc3b9307be026$var$renderPrediction() {
    try {
        $1f0dc3b9307be026$var$renderResult();
    } catch (error) {
        if (!$1f0dc3b9307be026$var$loopFailed) {
            $1f0dc3b9307be026$var$loopFailed = true;
            console.error("frame failed; the loop continues", error);
        }
    }
    $1f0dc3b9307be026$var$rafId = requestAnimationFrame($1f0dc3b9307be026$var$renderPrediction);
}
function $1f0dc3b9307be026$var$captureMeta() {
    return {
        // The drill the person named, not the one the readout fell back to. An
        // unlabelled take is better than a wrong label: the landmarks are the same
        // either way, so leaving it out says "sort this by hand" where `arm_swing`
        // would have said "measured as an arm swing" about a squat.
        exercise: (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.exercise || undefined,
        view: (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.view,
        model: (0, $4765f54d936bfe63$export$63b4527a2777036f).model,
        smoothing: (0, $4765f54d936bfe63$export$63b4527a2777036f).smoothing,
        camera: {
            width: $1f0dc3b9307be026$var$source.video.width,
            height: $1f0dc3b9307be026$var$source.video.height
        }
    };
}
function $1f0dc3b9307be026$var$saveSession() {
    const filename = (0, $0f75d94e0701fa23$export$f9d4d06a96a4d34f)($1f0dc3b9307be026$var$recorder, (0, $4765f54d936bfe63$export$8519f787e6064507));
    $1f0dc3b9307be026$var$controls.reportSaved(filename.name, filename.bytes, $1f0dc3b9307be026$var$recorder.frames.length, $1f0dc3b9307be026$var$recorder.marks.length, $1f0dc3b9307be026$var$recorder.fps);
}
function $1f0dc3b9307be026$var$applyUrlParams() {
    const urlParams = new URLSearchParams(window.location.search);
    // A phone pays for the bigger model twice: once downloading it over mobile
    // data, then again on every frame. Default to `lite` there; ?model= below
    // still wins for anyone who wants the accuracy.
    if ((0, $99e47839c965209f$export$d0a8044dce8ff2fc)()) (0, $4765f54d936bfe63$export$63b4527a2777036f).model = "lite";
    const model = urlParams.get("model");
    if (model != null && model in (0, $4765f54d936bfe63$export$66d3b9df51b4fadf)) (0, $4765f54d936bfe63$export$63b4527a2777036f).model = model;
    if (urlParams.has("render3d")) (0, $4765f54d936bfe63$export$63b4527a2777036f).render3D = urlParams.get("render3d") !== "0";
    if (urlParams.has("smoothing")) (0, $4765f54d936bfe63$export$63b4527a2777036f).smoothing.enabled = urlParams.get("smoothing") !== "0";
    const view = urlParams.get("view");
    if (view != null && (0, $b2f3e77422e22e97$export$50bf86b71c5fd0d9).includes(view)) (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.view = view;
    if (urlParams.has("metrics")) (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.enabled = urlParams.get("metrics") !== "0";
    if (urlParams.has("record")) (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.autoRecord = urlParams.get("record") !== "0";
    // ?source=file reviews a recording instead of opening the camera, which also
    // means the app runs where there is no camera at all.
    const sourceKind = urlParams.get("source");
    if (sourceKind === "file" || sourceKind === "camera") (0, $4765f54d936bfe63$export$63b4527a2777036f).sourceKind = sourceKind;
    // ?exercise= picks a drill and skips the menu, which is how a recording is
    // reviewed and the only way to drive the whole flow with nobody to tap.
    const exerciseId = urlParams.get("exercise");
    if (exerciseId != null && (0, $378d82c5860e548d$export$5eda13eb340067d)(exerciseId) != null) (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.exercise = exerciseId;
    // ?capture=1 swaps the drill bar for the recording bar, which is the tool for
    // capturing fixtures rather than for coaching.
    if (urlParams.has("capture")) (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.capture = urlParams.get("capture") !== "0";
    // ?record=1 arms the recorder, and only the recording bar owns one, so it
    // means capture mode whether it was asked for as well or not. Without this
    // the drill bar comes up, nothing there can start a recording, and the first
    // detected pose reaches a toggle on controls that were never built. The two
    // can still be set against each other, and then the explicit one wins: with
    // ?capture=0 the recorder is disarmed rather than the bar swapped back in.
    if ((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.autoRecord) {
        if (urlParams.has("capture") && !(0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.capture) (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.autoRecord = false;
        else (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.capture = true;
    }
    if (urlParams.has("sound")) (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.sound = urlParams.get("sound") !== "0";
    if (urlParams.has("soundcheck")) (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.soundcheck = urlParams.get("soundcheck") !== "0";
    if (urlParams.has("posture")) (0, $4765f54d936bfe63$export$63b4527a2777036f).posture.enabled = urlParams.get("posture") !== "0";
    // ?camsize=640x480 asks the camera for more pixels than a phone gets by
    // default. More pixels is a better head angle and a slower frame rate, and
    // which of those matters is a question for the phone rather than for here.
    const camSize = urlParams.get("camsize");
    if (camSize != null) {
        const wanted = camSize.toLowerCase().replace(/[^0-9x]/g, "");
        const option = Object.keys((0, $4765f54d936bfe63$export$b9792696e3661529)).find((key)=>key.toLowerCase().replace(/[^0-9x]/g, "") === wanted);
        if (option != null) {
            (0, $4765f54d936bfe63$export$63b4527a2777036f).camera.sizeOption = option;
            (0, $4765f54d936bfe63$export$63b4527a2777036f).camera.mobileSizeOption = option;
        }
    }
    // Every posture threshold is overridable, because they are one athlete's reps
    // read by one person and a coach will want to move them without a rebuild.
    for (const key of [
        "tiptoeMin",
        "kneeFlexMax",
        "trunkRockMax",
        "aheadOfKneeMax",
        "neckOffset",
        "neckTolerance",
        "tempoEvenBand",
        "swingSpeedMin",
        "jumpKneeDown",
        "jumpKneeUp",
        "jumpFlightMs",
        "jumpDepthMax",
        "jumpLegsMin",
        "jumpHipsMin",
        "jumpTrunkMax",
        "jumpAirToes",
        "jumpAirMinMs",
        "jumpArmSwingMin",
        "vSitHipDown",
        "vSitHipUp",
        "vSitFoldMax",
        "vSitKneeMin",
        "vSitTrunkRise",
        "handstandInvertMin",
        "handstandLineMin",
        "handstandKneeMin",
        "handstandElbowMin",
        "handstandShoulderMin",
        "handstandMinHoldMs",
        "handstandSettleMs",
        "handstandLeanMin",
        "handstandWallMax",
        // The head band and its facing gate were left out of this list when they
        // were added, so the one criterion on this drill with performed faults
        // behind it was the one that could not be swept from a URL.
        "handstandHeadMax",
        "handstandHeadMin",
        "handstandFacingMin"
    ]){
        const value = Number(urlParams.get(key.toLowerCase()));
        if (urlParams.has(key.toLowerCase()) && Number.isFinite(value)) (0, $4765f54d936bfe63$export$63b4527a2777036f).posture[key] = value;
    }
    const countdown = Number(urlParams.get("countdown"));
    if (Number.isFinite(countdown) && countdown >= 0 && urlParams.has("countdown")) (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.countdownSeconds = Math.min(countdown, 60);
}
/**
 * Without this a failure anywhere in startup is a silent blank page, which is
 * indistinguishable from a slow load and was exactly what made the iOS camera
 * hang so hard to pin down.
 */ /**
 * Last-resort error display. Not a duplicate of the startup panel: `app()`
 * already catches into `startup.fail()`, which is the richer path. This covers
 * the case where the panel itself cannot be built — a missing element, a bad
 * bundle — where the alternative is a silent blank page.
 */ function $1f0dc3b9307be026$var$showFatal(error) {
    console.error("startup failed:", error);
    const panel = document.createElement("div");
    panel.setAttribute("role", "alert");
    panel.style.cssText = "position:fixed;inset:0;display:flex;align-items:center;justify-content:center;padding:24px;text-align:center;background:#111;color:#ff8a80;font:15px system-ui,sans-serif;z-index:20";
    panel.textContent = String(error && error.message || error);
    document.body.appendChild(panel);
}
async function $1f0dc3b9307be026$var$app() {
    $1f0dc3b9307be026$var$startup = new (0, $f89871a1926c8f6b$export$b2d771f28e95281b)();
    $1f0dc3b9307be026$var$startup.onRetry(()=>window.location.reload());
    try {
        await $1f0dc3b9307be026$var$start();
    } catch (error) {
        $1f0dc3b9307be026$var$startup.fail(error);
    }
}
async function $1f0dc3b9307be026$var$start() {
    $1f0dc3b9307be026$var$applyUrlParams();
    if ((0, $4765f54d936bfe63$export$63b4527a2777036f).sourceKind === "file") $1f0dc3b9307be026$var$source = await $1f0dc3b9307be026$var$pickVideoFile();
    else {
        $1f0dc3b9307be026$var$startup.stage("Starting camera\u2026", "Allow camera access when prompted.");
        $1f0dc3b9307be026$var$source = $1f0dc3b9307be026$var$cameraSource(await (0, $99e47839c965209f$export$79f141de891a5fed).setup((0, $4765f54d936bfe63$export$63b4527a2777036f).camera));
    }
    $1f0dc3b9307be026$var$landmarker = await $1f0dc3b9307be026$var$createLandmarker();
    $1f0dc3b9307be026$var$normalizedSmoother = new (0, $a75a0c604ecdd6ea$export$b49a7690c1441d8a)((0, $4765f54d936bfe63$export$63b4527a2777036f).smoothing.normalized);
    $1f0dc3b9307be026$var$worldSmoother = new (0, $a75a0c604ecdd6ea$export$b49a7690c1441d8a)((0, $4765f54d936bfe63$export$63b4527a2777036f).smoothing.world);
    const canvas = document.getElementById("output");
    canvas.width = $1f0dc3b9307be026$var$source.video.width;
    canvas.height = $1f0dc3b9307be026$var$source.video.height;
    $1f0dc3b9307be026$var$renderer = new (0, $96f6625aee0e377e$export$8c0ff5fc83e0c92)(canvas, {
        mirror: $1f0dc3b9307be026$var$source.mirrored
    });
    $1f0dc3b9307be026$var$readout = new (0, $fc50d37955791958$export$aaa04cbb2b170a34)(canvas);
    $1f0dc3b9307be026$var$frames = new (0, $ee1111b42ffa8532$export$50ba7b64cce2f44c)((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.bufferFrames);
    $1f0dc3b9307be026$var$recorder = new (0, $0f75d94e0701fa23$export$fff78e3cee5381c8)();
    $1f0dc3b9307be026$var$posture = new (0, $351c2b07e0ef1e12$export$3677b0fddb922740)();
    // The ticket is the day's, not the page's: a phone that locked between sets
    // and came back is the same workout. See metrics/history.js.
    $1f0dc3b9307be026$var$history = new (0, $3f82ab3df4547366$export$7c314e4f9c976dac)();
    const restored = $1f0dc3b9307be026$var$history.load((0, $378d82c5860e548d$export$5eda13eb340067d));
    $1f0dc3b9307be026$var$workout = restored.workout;
    $1f0dc3b9307be026$var$earned = restored.earned;
    // Levels survive the page, so they are read before anything is drawn. On a
    // device where storage is blocked this is simply empty and the drills still
    // run; see metrics/progress.js.
    $1f0dc3b9307be026$var$progress = new (0, $35939dc4a8d67d0d$export$b25a304ec7d746bb)();
    // Two different jobs, so two different bars, and only one at a time. The
    // recorder's controls — "Mark rep" above all, which exists only to label
    // ground truth for tuning — are a tool for whoever is working on the detector,
    // not something to hand an athlete mid-drill.
    if ((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.capture) {
        document.getElementById("coach").hidden = true;
        document.getElementById("controls").hidden = false;
        $1f0dc3b9307be026$var$controls = new (0, $a348886ba5f90808$export$c49181b1c9eea0fa)($1f0dc3b9307be026$var$recorder, {
            onStart: $1f0dc3b9307be026$var$captureMeta,
            onStop: $1f0dc3b9307be026$var$saveSession,
            countdownSeconds: (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.countdownSeconds
        });
        // Capture skips the menu — it is a tuning errand, not a drill — but it is
        // not the arm swing's errand any more: `?capture=1&exercise=squat` frames
        // the readout for the drill being filmed, and names the drill in the file
        // and in its filename. The landmarks written are the same either way — they
        // are raw and belong to no exercise — but a take scored against the wrong
        // drill's thresholds reads as a plausible number for a movement nobody did,
        // so which drill it was has to travel with it.
        $1f0dc3b9307be026$var$selectExercise((0, $378d82c5860e548d$export$5eda13eb340067d)((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.exercise) || (0, $378d82c5860e548d$export$5eda13eb340067d)((0, $378d82c5860e548d$export$afb06daf2da6f031)));
        document.getElementById("coach").hidden = true;
    } else {
        $1f0dc3b9307be026$var$coach = new (0, $4982aed1ac51f6d6$export$55b83b3b18aa54c4)({
            onStart: $1f0dc3b9307be026$var$startSet,
            onStop: $1f0dc3b9307be026$var$endSet,
            countdownSeconds: (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.countdownSeconds,
            sound: (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.sound,
            soundcheck: (0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.soundcheck,
            // Both the menu and the receipt sit over this bar and own the keyboard
            // while they are up; a window keydown listener still fires underneath.
            canStart: ()=>!$1f0dc3b9307be026$var$menu.visible && !$1f0dc3b9307be026$var$receipt.visible,
            onMenu: $1f0dc3b9307be026$var$showMenu
        });
        $1f0dc3b9307be026$var$menu = new (0, $c3af07c42f72350a$export$b88448d84eda42e2)((0, $378d82c5860e548d$export$622f75fe8d421c2d), {
            onPick: $1f0dc3b9307be026$var$selectExercise,
            progress: $1f0dc3b9307be026$var$progress
        });
        $1f0dc3b9307be026$var$receipt = new (0, $6cd2e44443c6f786$export$953430523d182974)({
            onAgain: ()=>$1f0dc3b9307be026$var$coach.setExercise($1f0dc3b9307be026$var$exercise),
            onMenu: $1f0dc3b9307be026$var$showMenu
        });
        document.getElementById("coach-receipt").addEventListener("click", ()=>{
            if ($1f0dc3b9307be026$var$workout.sets.length > 0) $1f0dc3b9307be026$var$receipt.show($1f0dc3b9307be026$var$workout, $1f0dc3b9307be026$var$earned);
        });
        const chosen = (0, $378d82c5860e548d$export$5eda13eb340067d)((0, $4765f54d936bfe63$export$63b4527a2777036f).metrics.exercise);
        if (chosen) // `?exercise=` goes straight to a drill, which is how a recording is
        // reviewed and how the pipeline is driven with no one to tap the menu.
        $1f0dc3b9307be026$var$selectExercise(chosen);
        else $1f0dc3b9307be026$var$menu.show();
    }
    $1f0dc3b9307be026$var$startup.done();
    if (typeof $1f0dc3b9307be026$var$source.play === "function") {
        $1f0dc3b9307be026$var$bindReviewControls($1f0dc3b9307be026$var$source);
        $1f0dc3b9307be026$var$source.play();
    }
    $1f0dc3b9307be026$var$renderPrediction();
}
/**
 * Click to pause, arrow keys to step. Reviewing is the point of file mode, and
 * it is not reviewing if the only thing it can do is play once from the start.
 *
 * Left alone: Space and R, which the recorder controls already own.
 */ function $1f0dc3b9307be026$var$bindReviewControls(file) {
    const canvas = document.getElementById("output");
    canvas.style.cursor = "pointer";
    canvas.addEventListener("click", ()=>{
        if (file.video.paused) file.play();
        else file.video.pause();
    });
    window.addEventListener("keydown", (event)=>{
        const step = event.shiftKey ? 0.1 : 1;
        if (event.key === "ArrowLeft") {
            event.preventDefault();
            file.video.currentTime = Math.max(0, file.video.currentTime - step);
        } else if (event.key === "ArrowRight") {
            event.preventDefault();
            file.video.currentTime = Math.min(file.video.duration || 0, file.video.currentTime + step);
        }
    });
}
/**
 * Waits for the athlete to choose a file. A file cannot be opened without a
 * gesture, so this is a prompt rather than a load, and the startup panel is
 * where it belongs: it is the one thing standing between here and a running app.
 */ function $1f0dc3b9307be026$var$pickVideoFile() {
    const input = document.getElementById("video-file");
    $1f0dc3b9307be026$var$startup.stage("Choose a video\u2026", "Nothing is uploaded; it is read on this device.");
    input.hidden = false;
    return new Promise((resolve, reject)=>{
        input.addEventListener("change", ()=>{
            const file = input.files && input.files[0];
            input.hidden = true;
            if (!file) {
                reject(new Error("No video chosen."));
                return;
            }
            $1f0dc3b9307be026$var$startup.stage("Reading the video\u2026", file.name);
            (0, $dc8dd92b16f52584$export$a630243e2c957ead).setup(file).then(resolve, reject);
        }, {
            once: true
        });
    });
}
$1f0dc3b9307be026$var$app().catch($1f0dc3b9307be026$var$showFatal);


//# sourceMappingURL=repo.3199fd8d.js.map
